var gJ = Object.defineProperty;
var yJ = (t, e, n) => e in t ? gJ(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var Vt = (t, e, n) => (yJ(t, typeof e != "symbol" ? e + "" : e, n), n), ZR = (t, e, n) => {
  if (!e.has(t))
    throw TypeError("Cannot " + n);
};
var K = (t, e, n) => (ZR(t, e, "read from private field"), n ? n.call(t) : e.get(t)), Fe = (t, e, n) => {
  if (e.has(t))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(t) : e.set(t, n);
}, Ue = (t, e, n, r) => (ZR(t, e, "write to private field"), r ? r.call(t, n) : e.set(t, n), n);
var Ym = (t, e, n, r) => ({
  set _(i) {
    Ue(t, e, i, n);
  },
  get _() {
    return K(t, e, r);
  }
}), Yt = (t, e, n) => (ZR(t, e, "access private method"), n);
import "./index.css";
import * as H from "react";
import rr, { useCallback as De, createContext as Wt, useMemo as vt, createElement as ye, useContext as lt, forwardRef as Ge, Children as Zo, isValidElement as _l, cloneElement as Tc, Fragment as tu, useEffect as Ee, useRef as Ve, useState as nt, useLayoutEffect as xp, useReducer as bE, useInsertionEffect as Nw, useId as nu, memo as ZJ, useSyncExternalStore as bJ } from "react";
import * as EJ from "react-dom";
import SJ, { flushSync as Mw, createPortal as EE } from "react-dom";
const $i = typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {};
function pw() {
  throw new Error("setTimeout has not been defined");
}
function mw() {
  throw new Error("clearTimeout has not been defined");
}
var dl = pw, ul = mw;
typeof $i.setTimeout == "function" && (dl = setTimeout);
typeof $i.clearTimeout == "function" && (ul = clearTimeout);
function Tw(t) {
  if (dl === setTimeout)
    return setTimeout(t, 0);
  if ((dl === pw || !dl) && setTimeout)
    return dl = setTimeout, setTimeout(t, 0);
  try {
    return dl(t, 0);
  } catch {
    try {
      return dl.call(null, t, 0);
    } catch {
      return dl.call(this, t, 0);
    }
  }
}
function xJ(t) {
  if (ul === clearTimeout)
    return clearTimeout(t);
  if ((ul === mw || !ul) && clearTimeout)
    return ul = clearTimeout, clearTimeout(t);
  try {
    return ul(t);
  } catch {
    try {
      return ul.call(null, t);
    } catch {
      return ul.call(this, t);
    }
  }
}
var Ms = [], l0 = !1, nd, WT = -1;
function WJ() {
  !l0 || !nd || (l0 = !1, nd.length ? Ms = nd.concat(Ms) : WT = -1, Ms.length && fw());
}
function fw() {
  if (!l0) {
    var t = Tw(WJ);
    l0 = !0;
    for (var e = Ms.length; e; ) {
      for (nd = Ms, Ms = []; ++WT < e; )
        nd && nd[WT].run();
      WT = -1, e = Ms.length;
    }
    nd = null, l0 = !1, xJ(t);
  }
}
function jJ(t) {
  var e = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var n = 1; n < arguments.length; n++)
      e[n - 1] = arguments[n];
  Ms.push(new Vw(t, e)), Ms.length === 1 && !l0 && Tw(fw);
}
function Vw(t, e) {
  this.fun = t, this.array = e;
}
Vw.prototype.run = function() {
  this.fun.apply(null, this.array);
};
var DJ = "browser", zJ = "browser", kJ = !0, wJ = {}, FJ = [], vJ = "", IJ = {}, OJ = {}, YJ = {};
function ru() {
}
var QJ = ru, GJ = ru, CJ = ru, LJ = ru, JJ = ru, BJ = ru, AJ = ru;
function HJ(t) {
  throw new Error("process.binding is not supported");
}
function XJ() {
  return "/";
}
function _J(t) {
  throw new Error("process.chdir is not supported");
}
function PJ() {
  return 0;
}
var Cu = $i.performance || {}, KJ = Cu.now || Cu.mozNow || Cu.msNow || Cu.oNow || Cu.webkitNow || function() {
  return (/* @__PURE__ */ new Date()).getTime();
};
function $J(t) {
  var e = KJ.call(Cu) * 1e-3, n = Math.floor(e), r = Math.floor(e % 1 * 1e9);
  return t && (n = n - t[0], r = r - t[1], r < 0 && (n--, r += 1e9)), [n, r];
}
var qJ = /* @__PURE__ */ new Date();
function eB() {
  var t = /* @__PURE__ */ new Date(), e = t - qJ;
  return e / 1e3;
}
var ue = {
  nextTick: jJ,
  title: DJ,
  browser: kJ,
  env: wJ,
  argv: FJ,
  version: vJ,
  versions: IJ,
  on: QJ,
  addListener: GJ,
  once: CJ,
  off: LJ,
  removeListener: JJ,
  removeAllListeners: BJ,
  emit: AJ,
  binding: HJ,
  cwd: XJ,
  chdir: _J,
  umask: PJ,
  hrtime: $J,
  platform: zJ,
  release: OJ,
  config: YJ,
  uptime: eB
}, ya = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function fc(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function Uw(t) {
  if (t.__esModule)
    return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(t, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return t[r];
      }
    });
  }), n;
}
var my = { exports: {} }, TN = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var aW;
function tB() {
  if (aW)
    return TN;
  aW = 1;
  var t = rr, e = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, l, c) {
    var d, u = {}, h = null, N = null;
    c !== void 0 && (h = "" + c), l.key !== void 0 && (h = "" + l.key), l.ref !== void 0 && (N = l.ref);
    for (d in l)
      r.call(l, d) && !a.hasOwnProperty(d) && (u[d] = l[d]);
    if (s && s.defaultProps)
      for (d in l = s.defaultProps, l)
        u[d] === void 0 && (u[d] = l[d]);
    return { $$typeof: e, type: s, key: h, ref: N, props: u, _owner: i.current };
  }
  return TN.Fragment = n, TN.jsx = o, TN.jsxs = o, TN;
}
var fN = {}, oW;
function nB() {
  return oW || (oW = 1, ue.env.NODE_ENV !== "production" && function() {
    var t = rr, e = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), u = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), N = Symbol.for("react.offscreen"), M = Symbol.iterator, p = "@@iterator";
    function m(X) {
      if (X === null || typeof X != "object")
        return null;
      var he = M && X[M] || X[p];
      return typeof he == "function" ? he : null;
    }
    var R = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function V(X) {
      {
        for (var he = arguments.length, pe = new Array(he > 1 ? he - 1 : 0), we = 1; we < he; we++)
          pe[we - 1] = arguments[we];
        U("error", X, pe);
      }
    }
    function U(X, he, pe) {
      {
        var we = R.ReactDebugCurrentFrame, It = we.getStackAddendum();
        It !== "" && (he += "%s", pe = pe.concat([It]));
        var _e = pe.map(function(qe) {
          return String(qe);
        });
        _e.unshift("Warning: " + he), Function.prototype.apply.call(console[X], console, _e);
      }
    }
    var g = !1, y = !1, x = !1, f = !1, D = !1, Y;
    Y = Symbol.for("react.module.reference");
    function Q(X) {
      return !!(typeof X == "string" || typeof X == "function" || X === r || X === a || D || X === i || X === c || X === d || f || X === N || g || y || x || typeof X == "object" && X !== null && (X.$$typeof === h || X.$$typeof === u || X.$$typeof === o || X.$$typeof === s || X.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      X.$$typeof === Y || X.getModuleId !== void 0));
    }
    function G(X, he, pe) {
      var we = X.displayName;
      if (we)
        return we;
      var It = he.displayName || he.name || "";
      return It !== "" ? pe + "(" + It + ")" : pe;
    }
    function ne(X) {
      return X.displayName || "Context";
    }
    function O(X) {
      if (X == null)
        return null;
      if (typeof X.tag == "number" && V("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof X == "function")
        return X.displayName || X.name || null;
      if (typeof X == "string")
        return X;
      switch (X) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case a:
          return "Profiler";
        case i:
          return "StrictMode";
        case c:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof X == "object")
        switch (X.$$typeof) {
          case s:
            var he = X;
            return ne(he) + ".Consumer";
          case o:
            var pe = X;
            return ne(pe._context) + ".Provider";
          case l:
            return G(X, X.render, "ForwardRef");
          case u:
            var we = X.displayName || null;
            return we !== null ? we : O(X.type) || "Memo";
          case h: {
            var It = X, _e = It._payload, qe = It._init;
            try {
              return O(qe(_e));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var T = Object.assign, Z = 0, z, j, w, C, J, I, b;
    function k() {
    }
    k.__reactDisabledLog = !0;
    function ae() {
      {
        if (Z === 0) {
          z = console.log, j = console.info, w = console.warn, C = console.error, J = console.group, I = console.groupCollapsed, b = console.groupEnd;
          var X = {
            configurable: !0,
            enumerable: !0,
            value: k,
            writable: !0
          };
          Object.defineProperties(console, {
            info: X,
            log: X,
            warn: X,
            error: X,
            group: X,
            groupCollapsed: X,
            groupEnd: X
          });
        }
        Z++;
      }
    }
    function oe() {
      {
        if (Z--, Z === 0) {
          var X = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: T({}, X, {
              value: z
            }),
            info: T({}, X, {
              value: j
            }),
            warn: T({}, X, {
              value: w
            }),
            error: T({}, X, {
              value: C
            }),
            group: T({}, X, {
              value: J
            }),
            groupCollapsed: T({}, X, {
              value: I
            }),
            groupEnd: T({}, X, {
              value: b
            })
          });
        }
        Z < 0 && V("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var le = R.ReactCurrentDispatcher, fe;
    function de(X, he, pe) {
      {
        if (fe === void 0)
          try {
            throw Error();
          } catch (It) {
            var we = It.stack.trim().match(/\n( *(at )?)/);
            fe = we && we[1] || "";
          }
        return `
` + fe + X;
      }
    }
    var Me = !1, je;
    {
      var Se = typeof WeakMap == "function" ? WeakMap : Map;
      je = new Se();
    }
    function se(X, he) {
      if (!X || Me)
        return "";
      {
        var pe = je.get(X);
        if (pe !== void 0)
          return pe;
      }
      var we;
      Me = !0;
      var It = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var _e;
      _e = le.current, le.current = null, ae();
      try {
        if (he) {
          var qe = function() {
            throw Error();
          };
          if (Object.defineProperty(qe.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(qe, []);
            } catch (An) {
              we = An;
            }
            Reflect.construct(X, [], qe);
          } else {
            try {
              qe.call();
            } catch (An) {
              we = An;
            }
            X.call(qe.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (An) {
            we = An;
          }
          X();
        }
      } catch (An) {
        if (An && we && typeof An.stack == "string") {
          for (var gt = An.stack.split(`
`), Bn = we.stack.split(`
`), Mn = gt.length - 1, fn = Bn.length - 1; Mn >= 1 && fn >= 0 && gt[Mn] !== Bn[fn]; )
            fn--;
          for (; Mn >= 1 && fn >= 0; Mn--, fn--)
            if (gt[Mn] !== Bn[fn]) {
              if (Mn !== 1 || fn !== 1)
                do
                  if (Mn--, fn--, fn < 0 || gt[Mn] !== Bn[fn]) {
                    var lr = `
` + gt[Mn].replace(" at new ", " at ");
                    return X.displayName && lr.includes("<anonymous>") && (lr = lr.replace("<anonymous>", X.displayName)), typeof X == "function" && je.set(X, lr), lr;
                  }
                while (Mn >= 1 && fn >= 0);
              break;
            }
        }
      } finally {
        Me = !1, le.current = _e, oe(), Error.prepareStackTrace = It;
      }
      var Zr = X ? X.displayName || X.name : "", ro = Zr ? de(Zr) : "";
      return typeof X == "function" && je.set(X, ro), ro;
    }
    function Ce(X, he, pe) {
      return se(X, !1);
    }
    function et(X) {
      var he = X.prototype;
      return !!(he && he.isReactComponent);
    }
    function at(X, he, pe) {
      if (X == null)
        return "";
      if (typeof X == "function")
        return se(X, et(X));
      if (typeof X == "string")
        return de(X);
      switch (X) {
        case c:
          return de("Suspense");
        case d:
          return de("SuspenseList");
      }
      if (typeof X == "object")
        switch (X.$$typeof) {
          case l:
            return Ce(X.render);
          case u:
            return at(X.type, he, pe);
          case h: {
            var we = X, It = we._payload, _e = we._init;
            try {
              return at(_e(It), he, pe);
            } catch {
            }
          }
        }
      return "";
    }
    var Rn = Object.prototype.hasOwnProperty, Zt = {}, kt = R.ReactDebugCurrentFrame;
    function Pn(X) {
      if (X) {
        var he = X._owner, pe = at(X.type, X._source, he ? he.type : null);
        kt.setExtraStackFrame(pe);
      } else
        kt.setExtraStackFrame(null);
    }
    function Oe(X, he, pe, we, It) {
      {
        var _e = Function.call.bind(Rn);
        for (var qe in X)
          if (_e(X, qe)) {
            var gt = void 0;
            try {
              if (typeof X[qe] != "function") {
                var Bn = Error((we || "React class") + ": " + pe + " type `" + qe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof X[qe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Bn.name = "Invariant Violation", Bn;
              }
              gt = X[qe](he, qe, we, pe, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Mn) {
              gt = Mn;
            }
            gt && !(gt instanceof Error) && (Pn(It), V("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", we || "React class", pe, qe, typeof gt), Pn(null)), gt instanceof Error && !(gt.message in Zt) && (Zt[gt.message] = !0, Pn(It), V("Failed %s type: %s", pe, gt.message), Pn(null));
          }
      }
    }
    var Xe = Array.isArray;
    function ft(X) {
      return Xe(X);
    }
    function Le(X) {
      {
        var he = typeof Symbol == "function" && Symbol.toStringTag, pe = he && X[Symbol.toStringTag] || X.constructor.name || "Object";
        return pe;
      }
    }
    function dt(X) {
      try {
        return Dt(X), !1;
      } catch {
        return !0;
      }
    }
    function Dt(X) {
      return "" + X;
    }
    function ut(X) {
      if (dt(X))
        return V("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Le(X)), Dt(X);
    }
    var v = R.ReactCurrentOwner, S = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, W, L, P;
    P = {};
    function q(X) {
      if (Rn.call(X, "ref")) {
        var he = Object.getOwnPropertyDescriptor(X, "ref").get;
        if (he && he.isReactWarning)
          return !1;
      }
      return X.ref !== void 0;
    }
    function ie(X) {
      if (Rn.call(X, "key")) {
        var he = Object.getOwnPropertyDescriptor(X, "key").get;
        if (he && he.isReactWarning)
          return !1;
      }
      return X.key !== void 0;
    }
    function Be(X, he) {
      if (typeof X.ref == "string" && v.current && he && v.current.stateNode !== he) {
        var pe = O(v.current.type);
        P[pe] || (V('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', O(v.current.type), X.ref), P[pe] = !0);
      }
    }
    function Je(X, he) {
      {
        var pe = function() {
          W || (W = !0, V("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", he));
        };
        pe.isReactWarning = !0, Object.defineProperty(X, "key", {
          get: pe,
          configurable: !0
        });
      }
    }
    function He(X, he) {
      {
        var pe = function() {
          L || (L = !0, V("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", he));
        };
        pe.isReactWarning = !0, Object.defineProperty(X, "ref", {
          get: pe,
          configurable: !0
        });
      }
    }
    var Qt = function(X, he, pe, we, It, _e, qe) {
      var gt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: X,
        key: he,
        ref: pe,
        props: qe,
        // Record the component responsible for creating this element.
        _owner: _e
      };
      return gt._store = {}, Object.defineProperty(gt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(gt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: we
      }), Object.defineProperty(gt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: It
      }), Object.freeze && (Object.freeze(gt.props), Object.freeze(gt)), gt;
    };
    function it(X, he, pe, we, It) {
      {
        var _e, qe = {}, gt = null, Bn = null;
        pe !== void 0 && (ut(pe), gt = "" + pe), ie(he) && (ut(he.key), gt = "" + he.key), q(he) && (Bn = he.ref, Be(he, It));
        for (_e in he)
          Rn.call(he, _e) && !S.hasOwnProperty(_e) && (qe[_e] = he[_e]);
        if (X && X.defaultProps) {
          var Mn = X.defaultProps;
          for (_e in Mn)
            qe[_e] === void 0 && (qe[_e] = Mn[_e]);
        }
        if (gt || Bn) {
          var fn = typeof X == "function" ? X.displayName || X.name || "Unknown" : X;
          gt && Je(qe, fn), Bn && He(qe, fn);
        }
        return Qt(X, gt, Bn, It, we, v.current, qe);
      }
    }
    var sn = R.ReactCurrentOwner, Ao = R.ReactDebugCurrentFrame;
    function Pt(X) {
      if (X) {
        var he = X._owner, pe = at(X.type, X._source, he ? he.type : null);
        Ao.setExtraStackFrame(pe);
      } else
        Ao.setExtraStackFrame(null);
    }
    var Ct;
    Ct = !1;
    function no(X) {
      return typeof X == "object" && X !== null && X.$$typeof === e;
    }
    function wt() {
      {
        if (sn.current) {
          var X = O(sn.current.type);
          if (X)
            return `

Check the render method of \`` + X + "`.";
        }
        return "";
      }
    }
    function xn(X) {
      {
        if (X !== void 0) {
          var he = X.fileName.replace(/^.*[\\\/]/, ""), pe = X.lineNumber;
          return `

Check your code at ` + he + ":" + pe + ".";
        }
        return "";
      }
    }
    var Ho = {};
    function Wn(X) {
      {
        var he = wt();
        if (!he) {
          var pe = typeof X == "string" ? X : X.displayName || X.name;
          pe && (he = `

Check the top-level render call using <` + pe + ">.");
        }
        return he;
      }
    }
    function gn(X, he) {
      {
        if (!X._store || X._store.validated || X.key != null)
          return;
        X._store.validated = !0;
        var pe = Wn(he);
        if (Ho[pe])
          return;
        Ho[pe] = !0;
        var we = "";
        X && X._owner && X._owner !== sn.current && (we = " It was passed a child from " + O(X._owner.type) + "."), Pt(X), V('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', pe, we), Pt(null);
      }
    }
    function Xo(X, he) {
      {
        if (typeof X != "object")
          return;
        if (ft(X))
          for (var pe = 0; pe < X.length; pe++) {
            var we = X[pe];
            no(we) && gn(we, he);
          }
        else if (no(X))
          X._store && (X._store.validated = !0);
        else if (X) {
          var It = m(X);
          if (typeof It == "function" && It !== X.entries)
            for (var _e = It.call(X), qe; !(qe = _e.next()).done; )
              no(qe.value) && gn(qe.value, he);
        }
      }
    }
    function bt(X) {
      {
        var he = X.type;
        if (he == null || typeof he == "string")
          return;
        var pe;
        if (typeof he == "function")
          pe = he.propTypes;
        else if (typeof he == "object" && (he.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        he.$$typeof === u))
          pe = he.propTypes;
        else
          return;
        if (pe) {
          var we = O(he);
          Oe(pe, X.props, "prop", we, X);
        } else if (he.PropTypes !== void 0 && !Ct) {
          Ct = !0;
          var It = O(he);
          V("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", It || "Unknown");
        }
        typeof he.getDefaultProps == "function" && !he.getDefaultProps.isReactClassApproved && V("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function jn(X) {
      {
        for (var he = Object.keys(X.props), pe = 0; pe < he.length; pe++) {
          var we = he[pe];
          if (we !== "children" && we !== "key") {
            Pt(X), V("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", we), Pt(null);
            break;
          }
        }
        X.ref !== null && (Pt(X), V("Invalid attribute `ref` supplied to `React.Fragment`."), Pt(null));
      }
    }
    function _o(X, he, pe, we, It, _e) {
      {
        var qe = Q(X);
        if (!qe) {
          var gt = "";
          (X === void 0 || typeof X == "object" && X !== null && Object.keys(X).length === 0) && (gt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Bn = xn(It);
          Bn ? gt += Bn : gt += wt();
          var Mn;
          X === null ? Mn = "null" : ft(X) ? Mn = "array" : X !== void 0 && X.$$typeof === e ? (Mn = "<" + (O(X.type) || "Unknown") + " />", gt = " Did you accidentally export a JSX literal instead of a component?") : Mn = typeof X, V("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Mn, gt);
        }
        var fn = it(X, he, pe, It, _e);
        if (fn == null)
          return fn;
        if (qe) {
          var lr = he.children;
          if (lr !== void 0)
            if (we)
              if (ft(lr)) {
                for (var Zr = 0; Zr < lr.length; Zr++)
                  Xo(lr[Zr], X);
                Object.freeze && Object.freeze(lr);
              } else
                V("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Xo(lr, X);
        }
        return X === r ? jn(fn) : bt(fn), fn;
      }
    }
    function Dn(X, he, pe) {
      return _o(X, he, pe, !0);
    }
    function zn(X, he, pe) {
      return _o(X, he, pe, !1);
    }
    var el = zn, Lt = Dn;
    fN.Fragment = r, fN.jsx = el, fN.jsxs = Lt;
  }()), fN;
}
ue.env.NODE_ENV === "production" ? my.exports = tB() : my.exports = nB();
var E = my.exports;
function Rw(t) {
  var e, n, r = "";
  if (typeof t == "string" || typeof t == "number")
    r += t;
  else if (typeof t == "object")
    if (Array.isArray(t))
      for (e = 0; e < t.length; e++)
        t[e] && (n = Rw(t[e])) && (r && (r += " "), r += n);
    else
      for (e in t)
        t[e] && (r && (r += " "), r += e);
  return r;
}
function Tf() {
  for (var t, e, n = 0, r = ""; n < arguments.length; )
    (t = arguments[n++]) && (e = Rw(t)) && (r && (r += " "), r += e);
  return r;
}
const Cke = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clsx: Tf,
  default: Tf
}, Symbol.toStringTag, { value: "Module" }));
function rB() {
  for (var t = 0, e, n, r = ""; t < arguments.length; )
    (e = arguments[t++]) && (n = gw(e)) && (r && (r += " "), r += n);
  return r;
}
function gw(t) {
  if (typeof t == "string")
    return t;
  for (var e, n = "", r = 0; r < t.length; r++)
    t[r] && (e = gw(t[r])) && (n && (n += " "), n += e);
  return n;
}
var SE = "-";
function iB(t) {
  var e = oB(t), n = t.conflictingClassGroups, r = t.conflictingClassGroupModifiers, i = r === void 0 ? {} : r;
  function a(s) {
    var l = s.split(SE);
    return l[0] === "" && l.length !== 1 && l.shift(), yw(l, e) || aB(s);
  }
  function o(s, l) {
    var c = n[s] || [];
    return l && i[s] ? [].concat(c, i[s]) : c;
  }
  return {
    getClassGroupId: a,
    getConflictingClassGroupIds: o
  };
}
function yw(t, e) {
  var o;
  if (t.length === 0)
    return e.classGroupId;
  var n = t[0], r = e.nextPart.get(n), i = r ? yw(t.slice(1), r) : void 0;
  if (i)
    return i;
  if (e.validators.length !== 0) {
    var a = t.join(SE);
    return (o = e.validators.find(function(s) {
      var l = s.validator;
      return l(a);
    })) == null ? void 0 : o.classGroupId;
  }
}
var sW = /^\[(.+)\]$/;
function aB(t) {
  if (sW.test(t)) {
    var e = sW.exec(t)[1], n = e == null ? void 0 : e.substring(0, e.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function oB(t) {
  var e = t.theme, n = t.prefix, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, i = lB(Object.entries(t.classGroups), n);
  return i.forEach(function(a) {
    var o = a[0], s = a[1];
    Ty(s, r, o, e);
  }), r;
}
function Ty(t, e, n, r) {
  t.forEach(function(i) {
    if (typeof i == "string") {
      var a = i === "" ? e : lW(e, i);
      a.classGroupId = n;
      return;
    }
    if (typeof i == "function") {
      if (sB(i)) {
        Ty(i(r), e, n, r);
        return;
      }
      e.validators.push({
        validator: i,
        classGroupId: n
      });
      return;
    }
    Object.entries(i).forEach(function(o) {
      var s = o[0], l = o[1];
      Ty(l, lW(e, s), n, r);
    });
  });
}
function lW(t, e) {
  var n = t;
  return e.split(SE).forEach(function(r) {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function sB(t) {
  return t.isThemeGetter;
}
function lB(t, e) {
  return e ? t.map(function(n) {
    var r = n[0], i = n[1], a = i.map(function(o) {
      return typeof o == "string" ? e + o : typeof o == "object" ? Object.fromEntries(Object.entries(o).map(function(s) {
        var l = s[0], c = s[1];
        return [e + l, c];
      })) : o;
    });
    return [r, a];
  }) : t;
}
function cB(t) {
  if (t < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var e = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function i(a, o) {
    n.set(a, o), e++, e > t && (e = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get: function(o) {
      var s = n.get(o);
      if (s !== void 0)
        return s;
      if ((s = r.get(o)) !== void 0)
        return i(o, s), s;
    },
    set: function(o, s) {
      n.has(o) ? n.set(o, s) : i(o, s);
    }
  };
}
var Zw = "!";
function dB(t) {
  var e = t.separator || ":", n = e.length === 1, r = e[0], i = e.length;
  return function(o) {
    for (var s = [], l = 0, c = 0, d, u = 0; u < o.length; u++) {
      var h = o[u];
      if (l === 0) {
        if (h === r && (n || o.slice(u, u + i) === e)) {
          s.push(o.slice(c, u)), c = u + i;
          continue;
        }
        if (h === "/") {
          d = u;
          continue;
        }
      }
      h === "[" ? l++ : h === "]" && l--;
    }
    var N = s.length === 0 ? o : o.substring(c), M = N.startsWith(Zw), p = M ? N.substring(1) : N, m = d && d > c ? d - c : void 0;
    return {
      modifiers: s,
      hasImportantModifier: M,
      baseClassName: p,
      maybePostfixModifierPosition: m
    };
  };
}
function uB(t) {
  if (t.length <= 1)
    return t;
  var e = [], n = [];
  return t.forEach(function(r) {
    var i = r[0] === "[";
    i ? (e.push.apply(e, n.sort().concat([r])), n = []) : n.push(r);
  }), e.push.apply(e, n.sort()), e;
}
function hB(t) {
  return {
    cache: cB(t.cacheSize),
    splitModifiers: dB(t),
    ...iB(t)
  };
}
var NB = /\s+/;
function MB(t, e) {
  var n = e.splitModifiers, r = e.getClassGroupId, i = e.getConflictingClassGroupIds, a = /* @__PURE__ */ new Set();
  return t.trim().split(NB).map(function(o) {
    var s = n(o), l = s.modifiers, c = s.hasImportantModifier, d = s.baseClassName, u = s.maybePostfixModifierPosition, h = r(u ? d.substring(0, u) : d), N = !!u;
    if (!h) {
      if (!u)
        return {
          isTailwindClass: !1,
          originalClassName: o
        };
      if (h = r(d), !h)
        return {
          isTailwindClass: !1,
          originalClassName: o
        };
      N = !1;
    }
    var M = uB(l).join(":"), p = c ? M + Zw : M;
    return {
      isTailwindClass: !0,
      modifierId: p,
      classGroupId: h,
      originalClassName: o,
      hasPostfixModifier: N
    };
  }).reverse().filter(function(o) {
    if (!o.isTailwindClass)
      return !0;
    var s = o.modifierId, l = o.classGroupId, c = o.hasPostfixModifier, d = s + l;
    return a.has(d) ? !1 : (a.add(d), i(l, c).forEach(function(u) {
      return a.add(s + u);
    }), !0);
  }).reverse().map(function(o) {
    return o.originalClassName;
  }).join(" ");
}
function pB() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  var r, i, a, o = s;
  function s(c) {
    var d = e[0], u = e.slice(1), h = u.reduce(function(N, M) {
      return M(N);
    }, d());
    return r = hB(h), i = r.cache.get, a = r.cache.set, o = l, l(c);
  }
  function l(c) {
    var d = i(c);
    if (d)
      return d;
    var u = MB(c, r);
    return a(c, u), u;
  }
  return function() {
    return o(rB.apply(null, arguments));
  };
}
function Fn(t) {
  var e = function(r) {
    return r[t] || [];
  };
  return e.isThemeGetter = !0, e;
}
var bw = /^\[(?:([a-z-]+):)?(.+)\]$/i, mB = /^\d+\/\d+$/, TB = /* @__PURE__ */ new Set(["px", "full", "screen"]), fB = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, VB = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|^0$/, UB = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function Fa(t) {
  return rd(t) || TB.has(t) || mB.test(t) || hl(t);
}
function hl(t) {
  return iu(t, "length", EB);
}
function RB(t) {
  return iu(t, "size", Ew);
}
function gB(t) {
  return iu(t, "position", Ew);
}
function yB(t) {
  return iu(t, "url", SB);
}
function Qm(t) {
  return iu(t, "number", rd);
}
function rd(t) {
  return !Number.isNaN(Number(t));
}
function ZB(t) {
  return t.endsWith("%") && rd(t.slice(0, -1));
}
function VN(t) {
  return cW(t) || iu(t, "number", cW);
}
function nr(t) {
  return bw.test(t);
}
function UN() {
  return !0;
}
function il(t) {
  return fB.test(t);
}
function bB(t) {
  return iu(t, "", xB);
}
function iu(t, e, n) {
  var r = bw.exec(t);
  return r ? r[1] ? r[1] === e : n(r[2]) : !1;
}
function EB(t) {
  return VB.test(t);
}
function Ew() {
  return !1;
}
function SB(t) {
  return t.startsWith("url(");
}
function cW(t) {
  return Number.isInteger(Number(t));
}
function xB(t) {
  return UB.test(t);
}
function WB() {
  var t = Fn("colors"), e = Fn("spacing"), n = Fn("blur"), r = Fn("brightness"), i = Fn("borderColor"), a = Fn("borderRadius"), o = Fn("borderSpacing"), s = Fn("borderWidth"), l = Fn("contrast"), c = Fn("grayscale"), d = Fn("hueRotate"), u = Fn("invert"), h = Fn("gap"), N = Fn("gradientColorStops"), M = Fn("gradientColorStopPositions"), p = Fn("inset"), m = Fn("margin"), R = Fn("opacity"), V = Fn("padding"), U = Fn("saturate"), g = Fn("scale"), y = Fn("sepia"), x = Fn("skew"), f = Fn("space"), D = Fn("translate"), Y = function() {
    return ["auto", "contain", "none"];
  }, Q = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, G = function() {
    return ["auto", e];
  }, ne = function() {
    return ["", Fa];
  }, O = function() {
    return ["auto", rd, nr];
  }, T = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, Z = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, z = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, j = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, w = function() {
    return ["", "0", nr];
  }, C = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, J = function() {
    return [rd, Qm];
  }, I = function() {
    return [rd, nr];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [UN],
      spacing: [Fa],
      blur: ["none", "", il, hl],
      brightness: J(),
      borderColor: [t],
      borderRadius: ["none", "", "full", il, hl],
      borderSpacing: [e],
      borderWidth: ne(),
      contrast: J(),
      grayscale: w(),
      hueRotate: I(),
      invert: w(),
      gap: [e],
      gradientColorStops: [t],
      gradientColorStopPositions: [ZB, hl],
      inset: G(),
      margin: G(),
      opacity: J(),
      padding: [e],
      saturate: J(),
      scale: J(),
      sepia: w(),
      skew: I(),
      space: [e],
      translate: [e]
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", nr]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [il]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": C()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": C()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(T(), [nr])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: Q()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": Q()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": Q()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: Y()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": Y()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": Y()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [p]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [p]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [p]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [p]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [p]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [p]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [p]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [p]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [p]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", VN]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: G()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", nr]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: w()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: w()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", VN]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [UN]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: [VN]
        }, nr]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": O()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": O()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [UN]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [VN]
        }, nr]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": O()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": O()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", nr]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", nr]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [h]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [h]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [h]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(j())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(j(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(j(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [V]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [V]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [V]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [V]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [V]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [V]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [V]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [V]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [V]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [m]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [m]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [m]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [m]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [m]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [m]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [m]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [m]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [m]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [f]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [f]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", e]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", Fa]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [il]
        }, il, hl]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [e, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", Fa]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [e, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", il, hl]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Qm]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [UN]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", hl]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", rd, Qm]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Fa]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", nr]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", nr]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [t]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [R]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [t]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [R]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(Z(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Fa]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Fa]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [t]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: [e]
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", hl]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", nr]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [R]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(T(), [gB])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", RB]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, yB]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [t]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [M]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [M]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [M]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [N]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [N]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [N]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [a]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [a]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [a]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [a]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [a]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [a]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [a]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [a]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [a]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [a]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [a]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [a]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [a]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [a]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [a]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [R]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(Z(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [R]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: Z()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(Z())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Fa]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Fa]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [t]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: ne()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [t]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [R]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Fa]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [t]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", il, bB]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [UN]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [R]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": z()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": z()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", il, nr]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [d]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [u]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [U]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [y]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [d]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [u]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [R]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [U]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [y]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [o]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [o]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [o]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", nr]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: I()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", nr]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: I()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", nr]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [g]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [g]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [g]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [VN, nr]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [D]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [D]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [x]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [x]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", nr]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", t]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", nr]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [t]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": [e]
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": [e]
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": [e]
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": [e]
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": [e]
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": [e]
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": [e]
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": [e]
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": [e]
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": [e]
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": [e]
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": [e]
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": [e]
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": [e]
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": [e]
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": [e]
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": [e]
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": [e]
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", nr]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [t, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Fa, Qm]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [t, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var jB = /* @__PURE__ */ pB(WB);
function ni(...t) {
  return jB(Tf(t));
}
function At() {
  return At = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, At.apply(this, arguments);
}
function Gn(t, e, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (t == null || t(i), n === !1 || !i.defaultPrevented)
      return e == null ? void 0 : e(i);
  };
}
function DB(t, e) {
  typeof t == "function" ? t(e) : t != null && (t.current = e);
}
function Sw(...t) {
  return (e) => t.forEach(
    (n) => DB(n, e)
  );
}
function ri(...t) {
  return De(Sw(...t), t);
}
function au(t, e = []) {
  let n = [];
  function r(a, o) {
    const s = /* @__PURE__ */ Wt(o), l = n.length;
    n = [
      ...n,
      o
    ];
    function c(u) {
      const { scope: h, children: N, ...M } = u, p = (h == null ? void 0 : h[t][l]) || s, m = vt(
        () => M,
        Object.values(M)
      );
      return /* @__PURE__ */ ye(p.Provider, {
        value: m
      }, N);
    }
    function d(u, h) {
      const N = (h == null ? void 0 : h[t][l]) || s, M = lt(N);
      if (M)
        return M;
      if (o !== void 0)
        return o;
      throw new Error(`\`${u}\` must be used within \`${a}\``);
    }
    return c.displayName = a + "Provider", [
      c,
      d
    ];
  }
  const i = () => {
    const a = n.map((o) => /* @__PURE__ */ Wt(o));
    return function(s) {
      const l = (s == null ? void 0 : s[t]) || a;
      return vt(
        () => ({
          [`__scope${t}`]: {
            ...s,
            [t]: l
          }
        }),
        [
          s,
          l
        ]
      );
    };
  };
  return i.scopeName = t, [
    r,
    zB(i, ...e)
  ];
}
function zB(...t) {
  const e = t[0];
  if (t.length === 1)
    return e;
  const n = () => {
    const r = t.map(
      (i) => ({
        useScope: i(),
        scopeName: i.scopeName
      })
    );
    return function(a) {
      const o = r.reduce((s, { useScope: l, scopeName: c }) => {
        const u = l(a)[`__scope${c}`];
        return {
          ...s,
          ...u
        };
      }, {});
      return vt(
        () => ({
          [`__scope${e.scopeName}`]: o
        }),
        [
          o
        ]
      );
    };
  };
  return n.scopeName = e.scopeName, n;
}
const x1 = /* @__PURE__ */ Ge((t, e) => {
  const { children: n, ...r } = t, i = Zo.toArray(n), a = i.find(kB);
  if (a) {
    const o = a.props.children, s = i.map((l) => l === a ? Zo.count(o) > 1 ? Zo.only(null) : /* @__PURE__ */ _l(o) ? o.props.children : null : l);
    return /* @__PURE__ */ ye(fy, At({}, r, {
      ref: e
    }), /* @__PURE__ */ _l(o) ? /* @__PURE__ */ Tc(o, void 0, s) : null);
  }
  return /* @__PURE__ */ ye(fy, At({}, r, {
    ref: e
  }), n);
});
x1.displayName = "Slot";
const fy = /* @__PURE__ */ Ge((t, e) => {
  const { children: n, ...r } = t;
  return /* @__PURE__ */ _l(n) ? /* @__PURE__ */ Tc(n, {
    ...wB(r, n.props),
    ref: e ? Sw(e, n.ref) : n.ref
  }) : Zo.count(n) > 1 ? Zo.only(null) : null;
});
fy.displayName = "SlotClone";
const xw = ({ children: t }) => /* @__PURE__ */ ye(tu, null, t);
function kB(t) {
  return /* @__PURE__ */ _l(t) && t.type === xw;
}
function wB(t, e) {
  const n = {
    ...e
  };
  for (const r in e) {
    const i = t[r], a = e[r];
    /^on[A-Z]/.test(r) ? i && a ? n[r] = (...s) => {
      a(...s), i(...s);
    } : i && (n[r] = i) : r === "style" ? n[r] = {
      ...i,
      ...a
    } : r === "className" && (n[r] = [
      i,
      a
    ].filter(Boolean).join(" "));
  }
  return {
    ...t,
    ...n
  };
}
const FB = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Vi = FB.reduce((t, e) => {
  const n = /* @__PURE__ */ Ge((r, i) => {
    const { asChild: a, ...o } = r, s = a ? x1 : e;
    return Ee(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ ye(s, At({}, o, {
      ref: i
    }));
  });
  return n.displayName = `Primitive.${e}`, {
    ...t,
    [e]: n
  };
}, {});
function xE(t, e) {
  t && Mw(
    () => t.dispatchEvent(e)
  );
}
function mi(t) {
  const e = Ve(t);
  return Ee(() => {
    e.current = t;
  }), vt(
    () => (...n) => {
      var r;
      return (r = e.current) === null || r === void 0 ? void 0 : r.call(e, ...n);
    },
    []
  );
}
function Ww(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = mi(t);
  Ee(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return e.addEventListener("keydown", r), () => e.removeEventListener("keydown", r);
  }, [
    n,
    e
  ]);
}
const Vy = "dismissableLayer.update", vB = "dismissableLayer.pointerDownOutside", IB = "dismissableLayer.focusOutside";
let dW;
const OB = /* @__PURE__ */ Wt({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), YB = /* @__PURE__ */ Ge((t, e) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: i, onPointerDownOutside: a, onFocusOutside: o, onInteractOutside: s, onDismiss: l, ...c } = t, d = lt(OB), [u, h] = nt(null), N = (n = u == null ? void 0 : u.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, M] = nt({}), p = ri(
    e,
    (D) => h(D)
  ), m = Array.from(d.layers), [R] = [
    ...d.layersWithOutsidePointerEventsDisabled
  ].slice(-1), V = m.indexOf(R), U = u ? m.indexOf(u) : -1, g = d.layersWithOutsidePointerEventsDisabled.size > 0, y = U >= V, x = QB((D) => {
    const Y = D.target, Q = [
      ...d.branches
    ].some(
      (G) => G.contains(Y)
    );
    !y || Q || (a == null || a(D), s == null || s(D), D.defaultPrevented || l == null || l());
  }, N), f = GB((D) => {
    const Y = D.target;
    [
      ...d.branches
    ].some(
      (G) => G.contains(Y)
    ) || (o == null || o(D), s == null || s(D), D.defaultPrevented || l == null || l());
  }, N);
  return Ww((D) => {
    U === d.layers.size - 1 && (i == null || i(D), !D.defaultPrevented && l && (D.preventDefault(), l()));
  }, N), Ee(() => {
    if (u)
      return r && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (dW = N.body.style.pointerEvents, N.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(u)), d.layers.add(u), uW(), () => {
        r && d.layersWithOutsidePointerEventsDisabled.size === 1 && (N.body.style.pointerEvents = dW);
      };
  }, [
    u,
    N,
    r,
    d
  ]), Ee(() => () => {
    u && (d.layers.delete(u), d.layersWithOutsidePointerEventsDisabled.delete(u), uW());
  }, [
    u,
    d
  ]), Ee(() => {
    const D = () => M({});
    return document.addEventListener(Vy, D), () => document.removeEventListener(Vy, D);
  }, []), /* @__PURE__ */ ye(Vi.div, At({}, c, {
    ref: p,
    style: {
      pointerEvents: g ? y ? "auto" : "none" : void 0,
      ...t.style
    },
    onFocusCapture: Gn(t.onFocusCapture, f.onFocusCapture),
    onBlurCapture: Gn(t.onBlurCapture, f.onBlurCapture),
    onPointerDownCapture: Gn(t.onPointerDownCapture, x.onPointerDownCapture)
  }));
});
function QB(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = mi(t), r = Ve(!1), i = Ve(() => {
  });
  return Ee(() => {
    const a = (s) => {
      if (s.target && !r.current) {
        let c = function() {
          jw(vB, n, l, {
            discrete: !0
          });
        };
        const l = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (e.removeEventListener("click", i.current), i.current = c, e.addEventListener("click", i.current, {
          once: !0
        })) : c();
      }
      r.current = !1;
    }, o = window.setTimeout(() => {
      e.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(o), e.removeEventListener("pointerdown", a), e.removeEventListener("click", i.current);
    };
  }, [
    e,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function GB(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = mi(t), r = Ve(!1);
  return Ee(() => {
    const i = (a) => {
      a.target && !r.current && jw(IB, n, {
        originalEvent: a
      }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", i), () => e.removeEventListener("focusin", i);
  }, [
    e,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function uW() {
  const t = new CustomEvent(Vy);
  document.dispatchEvent(t);
}
function jw(t, e, n, { discrete: r }) {
  const i = n.originalEvent.target, a = new CustomEvent(t, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  e && i.addEventListener(t, e, {
    once: !0
  }), r ? xE(i, a) : i.dispatchEvent(a);
}
const Pl = globalThis != null && globalThis.document ? xp : () => {
};
function Jh(t) {
  return t.split("-")[1];
}
function WE(t) {
  return t === "y" ? "height" : "width";
}
function Rs(t) {
  return t.split("-")[0];
}
function ou(t) {
  return ["top", "bottom"].includes(Rs(t)) ? "x" : "y";
}
function hW(t, e, n) {
  let { reference: r, floating: i } = t;
  const a = r.x + r.width / 2 - i.width / 2, o = r.y + r.height / 2 - i.height / 2, s = ou(e), l = WE(s), c = r[l] / 2 - i[l] / 2, d = s === "x";
  let u;
  switch (Rs(e)) {
    case "top":
      u = { x: a, y: r.y - i.height };
      break;
    case "bottom":
      u = { x: a, y: r.y + r.height };
      break;
    case "right":
      u = { x: r.x + r.width, y: o };
      break;
    case "left":
      u = { x: r.x - i.width, y: o };
      break;
    default:
      u = { x: r.x, y: r.y };
  }
  switch (Jh(e)) {
    case "start":
      u[s] -= c * (n && d ? -1 : 1);
      break;
    case "end":
      u[s] += c * (n && d ? -1 : 1);
  }
  return u;
}
const CB = async (t, e, n) => {
  const { placement: r = "bottom", strategy: i = "absolute", middleware: a = [], platform: o } = n, s = a.filter(Boolean), l = await (o.isRTL == null ? void 0 : o.isRTL(e));
  let c = await o.getElementRects({ reference: t, floating: e, strategy: i }), { x: d, y: u } = hW(c, r, l), h = r, N = {}, M = 0;
  for (let p = 0; p < s.length; p++) {
    const { name: m, fn: R } = s[p], { x: V, y: U, data: g, reset: y } = await R({ x: d, y: u, initialPlacement: r, placement: h, strategy: i, middlewareData: N, rects: c, platform: o, elements: { reference: t, floating: e } });
    d = V ?? d, u = U ?? u, N = { ...N, [m]: { ...N[m], ...g } }, y && M <= 50 && (M++, typeof y == "object" && (y.placement && (h = y.placement), y.rects && (c = y.rects === !0 ? await o.getElementRects({ reference: t, floating: e, strategy: i }) : y.rects), { x: d, y: u } = hW(c, h, l)), p = -1);
  }
  return { x: d, y: u, placement: h, strategy: i, middlewareData: N };
};
function Ds(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Dw(t) {
  return typeof t != "number" ? function(e) {
    return { top: 0, right: 0, bottom: 0, left: 0, ...e };
  }(t) : { top: t, right: t, bottom: t, left: t };
}
function ff(t) {
  return { ...t, top: t.y, left: t.x, right: t.x + t.width, bottom: t.y + t.height };
}
async function W1(t, e) {
  var n;
  e === void 0 && (e = {});
  const { x: r, y: i, platform: a, rects: o, elements: s, strategy: l } = t, { boundary: c = "clippingAncestors", rootBoundary: d = "viewport", elementContext: u = "floating", altBoundary: h = !1, padding: N = 0 } = Ds(e, t), M = Dw(N), p = s[h ? u === "floating" ? "reference" : "floating" : u], m = ff(await a.getClippingRect({ element: (n = await (a.isElement == null ? void 0 : a.isElement(p))) == null || n ? p : p.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)), boundary: c, rootBoundary: d, strategy: l })), R = u === "floating" ? { ...o.floating, x: r, y: i } : o.reference, V = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), U = await (a.isElement == null ? void 0 : a.isElement(V)) && await (a.getScale == null ? void 0 : a.getScale(V)) || { x: 1, y: 1 }, g = ff(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({ rect: R, offsetParent: V, strategy: l }) : R);
  return { top: (m.top - g.top + M.top) / U.y, bottom: (g.bottom - m.bottom + M.bottom) / U.y, left: (m.left - g.left + M.left) / U.x, right: (g.right - m.right + M.right) / U.x };
}
const j1 = Math.min, _c = Math.max;
function Uy(t, e, n) {
  return _c(t, j1(e, n));
}
const NW = (t) => ({ name: "arrow", options: t, async fn(e) {
  const { x: n, y: r, placement: i, rects: a, platform: o, elements: s } = e, { element: l, padding: c = 0 } = Ds(t, e) || {};
  if (l == null)
    return {};
  const d = Dw(c), u = { x: n, y: r }, h = ou(i), N = WE(h), M = await o.getDimensions(l), p = h === "y", m = p ? "top" : "left", R = p ? "bottom" : "right", V = p ? "clientHeight" : "clientWidth", U = a.reference[N] + a.reference[h] - u[h] - a.floating[N], g = u[h] - a.reference[h], y = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(l));
  let x = y ? y[V] : 0;
  x && await (o.isElement == null ? void 0 : o.isElement(y)) || (x = s.floating[V] || a.floating[N]);
  const f = U / 2 - g / 2, D = x / 2 - M[N] / 2 - 1, Y = j1(d[m], D), Q = j1(d[R], D), G = Y, ne = x - M[N] - Q, O = x / 2 - M[N] / 2 + f, T = Uy(G, O, ne), Z = Jh(i) != null && O != T && a.reference[N] / 2 - (O < G ? Y : Q) - M[N] / 2 < 0 ? O < G ? G - O : ne - O : 0;
  return { [h]: u[h] - Z, data: { [h]: T, centerOffset: O - T + Z } };
} }), zw = ["top", "right", "bottom", "left"];
zw.reduce((t, e) => t.concat(e, e + "-start", e + "-end"), []);
const LB = { left: "right", right: "left", bottom: "top", top: "bottom" };
function Vf(t) {
  return t.replace(/left|right|bottom|top/g, (e) => LB[e]);
}
function JB(t, e, n) {
  n === void 0 && (n = !1);
  const r = Jh(t), i = ou(t), a = WE(i);
  let o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return e.reference[a] > e.floating[a] && (o = Vf(o)), { main: o, cross: Vf(o) };
}
const BB = { start: "end", end: "start" };
function bR(t) {
  return t.replace(/start|end/g, (e) => BB[e]);
}
const kw = function(t) {
  return t === void 0 && (t = {}), { name: "flip", options: t, async fn(e) {
    var n;
    const { placement: r, middlewareData: i, rects: a, initialPlacement: o, platform: s, elements: l } = e, { mainAxis: c = !0, crossAxis: d = !0, fallbackPlacements: u, fallbackStrategy: h = "bestFit", fallbackAxisSideDirection: N = "none", flipAlignment: M = !0, ...p } = Ds(t, e), m = Rs(r), R = Rs(o) === o, V = await (s.isRTL == null ? void 0 : s.isRTL(l.floating)), U = u || (R || !M ? [Vf(o)] : function(G) {
      const ne = Vf(G);
      return [bR(G), ne, bR(ne)];
    }(o));
    u || N === "none" || U.push(...function(G, ne, O, T) {
      const Z = Jh(G);
      let z = function(j, w, C) {
        const J = ["left", "right"], I = ["right", "left"], b = ["top", "bottom"], k = ["bottom", "top"];
        switch (j) {
          case "top":
          case "bottom":
            return C ? w ? I : J : w ? J : I;
          case "left":
          case "right":
            return w ? b : k;
          default:
            return [];
        }
      }(Rs(G), O === "start", T);
      return Z && (z = z.map((j) => j + "-" + Z), ne && (z = z.concat(z.map(bR)))), z;
    }(o, M, N, V));
    const g = [o, ...U], y = await W1(e, p), x = [];
    let f = ((n = i.flip) == null ? void 0 : n.overflows) || [];
    if (c && x.push(y[m]), d) {
      const { main: G, cross: ne } = JB(r, a, V);
      x.push(y[G], y[ne]);
    }
    if (f = [...f, { placement: r, overflows: x }], !x.every((G) => G <= 0)) {
      var D, Y;
      const G = (((D = i.flip) == null ? void 0 : D.index) || 0) + 1, ne = g[G];
      if (ne)
        return { data: { index: G, overflows: f }, reset: { placement: ne } };
      let O = (Y = f.filter((T) => T.overflows[0] <= 0).sort((T, Z) => T.overflows[1] - Z.overflows[1])[0]) == null ? void 0 : Y.placement;
      if (!O)
        switch (h) {
          case "bestFit": {
            var Q;
            const T = (Q = f.map((Z) => [Z.placement, Z.overflows.filter((z) => z > 0).reduce((z, j) => z + j, 0)]).sort((Z, z) => Z[1] - z[1])[0]) == null ? void 0 : Q[0];
            T && (O = T);
            break;
          }
          case "initialPlacement":
            O = o;
        }
      if (r !== O)
        return { reset: { placement: O } };
    }
    return {};
  } };
};
function MW(t, e) {
  return { top: t.top - e.height, right: t.right - e.width, bottom: t.bottom - e.height, left: t.left - e.width };
}
function pW(t) {
  return zw.some((e) => t[e] >= 0);
}
const ww = function(t) {
  return t === void 0 && (t = {}), { name: "hide", options: t, async fn(e) {
    const { rects: n } = e, { strategy: r = "referenceHidden", ...i } = Ds(t, e);
    switch (r) {
      case "referenceHidden": {
        const a = MW(await W1(e, { ...i, elementContext: "reference" }), n.reference);
        return { data: { referenceHiddenOffsets: a, referenceHidden: pW(a) } };
      }
      case "escaped": {
        const a = MW(await W1(e, { ...i, altBoundary: !0 }), n.floating);
        return { data: { escapedOffsets: a, escaped: pW(a) } };
      }
      default:
        return {};
    }
  } };
}, Fw = function(t) {
  return t === void 0 && (t = 0), { name: "offset", options: t, async fn(e) {
    const { x: n, y: r } = e, i = await async function(a, o) {
      const { placement: s, platform: l, elements: c } = a, d = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), u = Rs(s), h = Jh(s), N = ou(s) === "x", M = ["left", "top"].includes(u) ? -1 : 1, p = d && N ? -1 : 1, m = Ds(o, a);
      let { mainAxis: R, crossAxis: V, alignmentAxis: U } = typeof m == "number" ? { mainAxis: m, crossAxis: 0, alignmentAxis: null } : { mainAxis: 0, crossAxis: 0, alignmentAxis: null, ...m };
      return h && typeof U == "number" && (V = h === "end" ? -1 * U : U), N ? { x: V * p, y: R * M } : { x: R * M, y: V * p };
    }(e, t);
    return { x: n + i.x, y: r + i.y, data: i };
  } };
};
function vw(t) {
  return t === "x" ? "y" : "x";
}
const Iw = function(t) {
  return t === void 0 && (t = {}), { name: "shift", options: t, async fn(e) {
    const { x: n, y: r, placement: i } = e, { mainAxis: a = !0, crossAxis: o = !1, limiter: s = { fn: (m) => {
      let { x: R, y: V } = m;
      return { x: R, y: V };
    } }, ...l } = Ds(t, e), c = { x: n, y: r }, d = await W1(e, l), u = ou(Rs(i)), h = vw(u);
    let N = c[u], M = c[h];
    if (a) {
      const m = u === "y" ? "bottom" : "right";
      N = Uy(N + d[u === "y" ? "top" : "left"], N, N - d[m]);
    }
    if (o) {
      const m = h === "y" ? "bottom" : "right";
      M = Uy(M + d[h === "y" ? "top" : "left"], M, M - d[m]);
    }
    const p = s.fn({ ...e, [u]: N, [h]: M });
    return { ...p, data: { x: p.x - n, y: p.y - r } };
  } };
}, Ow = function(t) {
  return t === void 0 && (t = {}), { options: t, fn(e) {
    const { x: n, y: r, placement: i, rects: a, middlewareData: o } = e, { offset: s = 0, mainAxis: l = !0, crossAxis: c = !0 } = Ds(t, e), d = { x: n, y: r }, u = ou(i), h = vw(u);
    let N = d[u], M = d[h];
    const p = Ds(s, e), m = typeof p == "number" ? { mainAxis: p, crossAxis: 0 } : { mainAxis: 0, crossAxis: 0, ...p };
    if (l) {
      const U = u === "y" ? "height" : "width", g = a.reference[u] - a.floating[U] + m.mainAxis, y = a.reference[u] + a.reference[U] - m.mainAxis;
      N < g ? N = g : N > y && (N = y);
    }
    if (c) {
      var R, V;
      const U = u === "y" ? "width" : "height", g = ["top", "left"].includes(Rs(i)), y = a.reference[h] - a.floating[U] + (g && ((R = o.offset) == null ? void 0 : R[h]) || 0) + (g ? 0 : m.crossAxis), x = a.reference[h] + a.reference[U] + (g ? 0 : ((V = o.offset) == null ? void 0 : V[h]) || 0) - (g ? m.crossAxis : 0);
      M < y ? M = y : M > x && (M = x);
    }
    return { [u]: N, [h]: M };
  } };
}, Yw = function(t) {
  return t === void 0 && (t = {}), { name: "size", options: t, async fn(e) {
    const { placement: n, rects: r, platform: i, elements: a } = e, { apply: o = () => {
    }, ...s } = Ds(t, e), l = await W1(e, s), c = Rs(n), d = Jh(n), u = ou(n) === "x", { width: h, height: N } = r.floating;
    let M, p;
    c === "top" || c === "bottom" ? (M = c, p = d === (await (i.isRTL == null ? void 0 : i.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (p = c, M = d === "end" ? "top" : "bottom");
    const m = N - l[M], R = h - l[p], V = !e.middlewareData.shift;
    let U = m, g = R;
    if (u) {
      const x = h - l.left - l.right;
      g = d || V ? j1(R, x) : x;
    } else {
      const x = N - l.top - l.bottom;
      U = d || V ? j1(m, x) : x;
    }
    if (V && !d) {
      const x = _c(l.left, 0), f = _c(l.right, 0), D = _c(l.top, 0), Y = _c(l.bottom, 0);
      u ? g = h - 2 * (x !== 0 || f !== 0 ? x + f : _c(l.left, l.right)) : U = N - 2 * (D !== 0 || Y !== 0 ? D + Y : _c(l.top, l.bottom));
    }
    await o({ ...e, availableWidth: g, availableHeight: U });
    const y = await i.getDimensions(a.floating);
    return h !== y.width || N !== y.height ? { reset: { rects: !0 } } : {};
  } };
};
function ba(t) {
  var e;
  return ((e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function Ba(t) {
  return ba(t).getComputedStyle(t);
}
function Qw(t) {
  return t instanceof ba(t).Node;
}
function Kl(t) {
  return Qw(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function _a(t) {
  return t instanceof ba(t).HTMLElement;
}
function gs(t) {
  return t instanceof ba(t).Element;
}
function mW(t) {
  return typeof ShadowRoot < "u" && (t instanceof ba(t).ShadowRoot || t instanceof ShadowRoot);
}
function D1(t) {
  const { overflow: e, overflowX: n, overflowY: r, display: i } = Ba(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + r + n) && !["inline", "contents"].includes(i);
}
function AB(t) {
  return ["table", "td", "th"].includes(Kl(t));
}
function Ry(t) {
  const e = jE(), n = Ba(t);
  return n.transform !== "none" || n.perspective !== "none" || !e && !!n.backdropFilter && n.backdropFilter !== "none" || !e && !!n.filter && n.filter !== "none" || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function jE() {
  return !(typeof CSS > "u" || !CSS.supports) && CSS.supports("-webkit-backdrop-filter", "none");
}
function p2(t) {
  return ["html", "body", "#document"].includes(Kl(t));
}
const gy = Math.min, c0 = Math.max, Uf = Math.round, Gm = Math.floor, zd = (t) => ({ x: t, y: t });
function Gw(t) {
  const e = Ba(t);
  let n = parseFloat(e.width) || 0, r = parseFloat(e.height) || 0;
  const i = _a(t), a = i ? t.offsetWidth : n, o = i ? t.offsetHeight : r, s = Uf(n) !== a || Uf(r) !== o;
  return s && (n = a, r = o), { width: n, height: r, $: s };
}
function DE(t) {
  return gs(t) ? t : t.contextElement;
}
function d0(t) {
  const e = DE(t);
  if (!_a(e))
    return zd(1);
  const n = e.getBoundingClientRect(), { width: r, height: i, $: a } = Gw(e);
  let o = (a ? Uf(n.width) : n.width) / r, s = (a ? Uf(n.height) : n.height) / i;
  return o && Number.isFinite(o) || (o = 1), s && Number.isFinite(s) || (s = 1), { x: o, y: s };
}
const TW = zd(0);
function Cw(t, e, n) {
  var r, i;
  if (e === void 0 && (e = !0), !jE())
    return TW;
  const a = t ? ba(t) : window;
  return !n || e && n !== a ? TW : { x: ((r = a.visualViewport) == null ? void 0 : r.offsetLeft) || 0, y: ((i = a.visualViewport) == null ? void 0 : i.offsetTop) || 0 };
}
function kd(t, e, n, r) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const i = t.getBoundingClientRect(), a = DE(t);
  let o = zd(1);
  e && (r ? gs(r) && (o = d0(r)) : o = d0(t));
  const s = Cw(a, n, r);
  let l = (i.left + s.x) / o.x, c = (i.top + s.y) / o.y, d = i.width / o.x, u = i.height / o.y;
  if (a) {
    const h = ba(a), N = r && gs(r) ? ba(r) : r;
    let M = h.frameElement;
    for (; M && r && N !== h; ) {
      const p = d0(M), m = M.getBoundingClientRect(), R = getComputedStyle(M), V = m.left + (M.clientLeft + parseFloat(R.paddingLeft)) * p.x, U = m.top + (M.clientTop + parseFloat(R.paddingTop)) * p.y;
      l *= p.x, c *= p.y, d *= p.x, u *= p.y, l += V, c += U, M = ba(M).frameElement;
    }
  }
  return ff({ width: d, height: u, x: l, y: c });
}
function ys(t) {
  return ((Qw(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function m2(t) {
  return gs(t) ? { scrollLeft: t.scrollLeft, scrollTop: t.scrollTop } : { scrollLeft: t.pageXOffset, scrollTop: t.pageYOffset };
}
function Lw(t) {
  return kd(ys(t)).left + m2(t).scrollLeft;
}
function _0(t) {
  if (Kl(t) === "html")
    return t;
  const e = t.assignedSlot || t.parentNode || mW(t) && t.host || ys(t);
  return mW(e) ? e.host : e;
}
function Jw(t) {
  const e = _0(t);
  return p2(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : _a(e) && D1(e) ? e : Jw(e);
}
function Rf(t, e) {
  var n;
  e === void 0 && (e = []);
  const r = Jw(t), i = r === ((n = t.ownerDocument) == null ? void 0 : n.body), a = ba(r);
  return i ? e.concat(a, a.visualViewport || [], D1(r) ? r : []) : e.concat(r, Rf(r));
}
function fW(t, e, n) {
  let r;
  if (e === "viewport")
    r = function(i, a) {
      const o = ba(i), s = ys(i), l = o.visualViewport;
      let c = s.clientWidth, d = s.clientHeight, u = 0, h = 0;
      if (l) {
        c = l.width, d = l.height;
        const N = jE();
        (!N || N && a === "fixed") && (u = l.offsetLeft, h = l.offsetTop);
      }
      return { width: c, height: d, x: u, y: h };
    }(t, n);
  else if (e === "document")
    r = function(i) {
      const a = ys(i), o = m2(i), s = i.ownerDocument.body, l = c0(a.scrollWidth, a.clientWidth, s.scrollWidth, s.clientWidth), c = c0(a.scrollHeight, a.clientHeight, s.scrollHeight, s.clientHeight);
      let d = -o.scrollLeft + Lw(i);
      const u = -o.scrollTop;
      return Ba(s).direction === "rtl" && (d += c0(a.clientWidth, s.clientWidth) - l), { width: l, height: c, x: d, y: u };
    }(ys(t));
  else if (gs(e))
    r = function(i, a) {
      const o = kd(i, !0, a === "fixed"), s = o.top + i.clientTop, l = o.left + i.clientLeft, c = _a(i) ? d0(i) : zd(1);
      return { width: i.clientWidth * c.x, height: i.clientHeight * c.y, x: l * c.x, y: s * c.y };
    }(e, n);
  else {
    const i = Cw(t);
    r = { ...e, x: e.x - i.x, y: e.y - i.y };
  }
  return ff(r);
}
function Bw(t, e) {
  const n = _0(t);
  return !(n === e || !gs(n) || p2(n)) && (Ba(n).position === "fixed" || Bw(n, e));
}
function VW(t, e) {
  return _a(t) && Ba(t).position !== "fixed" ? e ? e(t) : t.offsetParent : null;
}
function UW(t, e) {
  const n = ba(t);
  if (!_a(t))
    return n;
  let r = VW(t, e);
  for (; r && AB(r) && Ba(r).position === "static"; )
    r = VW(r, e);
  return r && (Kl(r) === "html" || Kl(r) === "body" && Ba(r).position === "static" && !Ry(r)) ? n : r || function(i) {
    let a = _0(i);
    for (; _a(a) && !p2(a); ) {
      if (Ry(a))
        return a;
      a = _0(a);
    }
    return null;
  }(t) || n;
}
function HB(t, e, n) {
  const r = _a(e), i = ys(e), a = n === "fixed", o = kd(t, !0, a, e);
  let s = { scrollLeft: 0, scrollTop: 0 };
  const l = zd(0);
  if (r || !r && !a)
    if ((Kl(e) !== "body" || D1(i)) && (s = m2(e)), _a(e)) {
      const c = kd(e, !0, a, e);
      l.x = c.x + e.clientLeft, l.y = c.y + e.clientTop;
    } else
      i && (l.x = Lw(i));
  return { x: o.left + s.scrollLeft - l.x, y: o.top + s.scrollTop - l.y, width: o.width, height: o.height };
}
const XB = { getClippingRect: function(t) {
  let { element: e, boundary: n, rootBoundary: r, strategy: i } = t;
  const a = n === "clippingAncestors" ? function(c, d) {
    const u = d.get(c);
    if (u)
      return u;
    let h = Rf(c).filter((m) => gs(m) && Kl(m) !== "body"), N = null;
    const M = Ba(c).position === "fixed";
    let p = M ? _0(c) : c;
    for (; gs(p) && !p2(p); ) {
      const m = Ba(p), R = Ry(p);
      R || m.position !== "fixed" || (N = null), (M ? !R && !N : !R && m.position === "static" && N && ["absolute", "fixed"].includes(N.position) || D1(p) && !R && Bw(c, p)) ? h = h.filter((V) => V !== p) : N = m, p = _0(p);
    }
    return d.set(c, h), h;
  }(e, this._c) : [].concat(n), o = [...a, r], s = o[0], l = o.reduce((c, d) => {
    const u = fW(e, d, i);
    return c.top = c0(u.top, c.top), c.right = gy(u.right, c.right), c.bottom = gy(u.bottom, c.bottom), c.left = c0(u.left, c.left), c;
  }, fW(e, s, i));
  return { width: l.right - l.left, height: l.bottom - l.top, x: l.left, y: l.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
  let { rect: e, offsetParent: n, strategy: r } = t;
  const i = _a(n), a = ys(n);
  if (n === a)
    return e;
  let o = { scrollLeft: 0, scrollTop: 0 }, s = zd(1);
  const l = zd(0);
  if ((i || !i && r !== "fixed") && ((Kl(n) !== "body" || D1(a)) && (o = m2(n)), _a(n))) {
    const c = kd(n);
    s = d0(n), l.x = c.x + n.clientLeft, l.y = c.y + n.clientTop;
  }
  return { width: e.width * s.x, height: e.height * s.y, x: e.x * s.x - o.scrollLeft * s.x + l.x, y: e.y * s.y - o.scrollTop * s.y + l.y };
}, isElement: gs, getDimensions: function(t) {
  return Gw(t);
}, getOffsetParent: UW, getDocumentElement: ys, getScale: d0, async getElementRects(t) {
  let { reference: e, floating: n, strategy: r } = t;
  const i = this.getOffsetParent || UW, a = this.getDimensions;
  return { reference: HB(e, await i(n), r), floating: { x: 0, y: 0, ...await a(n) } };
}, getClientRects: (t) => Array.from(t.getClientRects()), isRTL: (t) => Ba(t).direction === "rtl" };
function Aw(t, e, n, r) {
  r === void 0 && (r = {});
  const { ancestorScroll: i = !0, ancestorResize: a = !0, elementResize: o = !0, layoutShift: s = typeof IntersectionObserver == "function", animationFrame: l = !1 } = r, c = DE(t), d = i || a ? [...c ? Rf(c) : [], ...Rf(e)] : [];
  d.forEach((p) => {
    i && p.addEventListener("scroll", n, { passive: !0 }), a && p.addEventListener("resize", n);
  });
  const u = c && s ? function(p, m) {
    let R, V = null;
    const U = ys(p);
    function g() {
      clearTimeout(R), V && V.disconnect(), V = null;
    }
    return function y(x, f) {
      x === void 0 && (x = !1), f === void 0 && (f = 1), g();
      const { left: D, top: Y, width: Q, height: G } = p.getBoundingClientRect();
      if (x || m(), !Q || !G)
        return;
      const ne = Gm(Y), O = Gm(U.clientWidth - (D + Q)), T = Gm(U.clientHeight - (Y + G)), Z = Gm(D);
      let z = !0;
      V = new IntersectionObserver((j) => {
        const w = j[0].intersectionRatio;
        if (w !== f) {
          if (!z)
            return y();
          w ? y(!1, w) : R = setTimeout(() => {
            y(!1, 1e-7);
          }, 100);
        }
        z = !1;
      }, { rootMargin: -ne + "px " + -O + "px " + -T + "px " + -Z + "px", threshold: c0(0, gy(1, f)) || 1 }), V.observe(p);
    }(!0), g;
  }(c, n) : null;
  let h, N = null;
  o && (N = new ResizeObserver(n), c && !l && N.observe(c), N.observe(e));
  let M = l ? kd(t) : null;
  return l && function p() {
    const m = kd(t);
    !M || m.x === M.x && m.y === M.y && m.width === M.width && m.height === M.height || n(), M = m, h = requestAnimationFrame(p);
  }(), n(), () => {
    d.forEach((p) => {
      i && p.removeEventListener("scroll", n), a && p.removeEventListener("resize", n);
    }), u && u(), N && N.disconnect(), N = null, l && cancelAnimationFrame(h);
  };
}
const _B = (t, e, n) => {
  const r = /* @__PURE__ */ new Map(), i = { platform: XB, ...n }, a = { ...i.platform, _c: r };
  return CB(t, e, { ...i, platform: a });
}, Hw = (t) => {
  function e(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: t,
    fn(n) {
      const {
        element: r,
        padding: i
      } = typeof t == "function" ? t(n) : t;
      return r && e(r) ? r.current != null ? NW({
        element: r.current,
        padding: i
      }).fn(n) : {} : r ? NW({
        element: r,
        padding: i
      }).fn(n) : {};
    }
  };
};
var jT = typeof document < "u" ? xp : Ee;
function gf(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let n, r, i;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n != e.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!gf(t[r], e[r]))
          return !1;
      return !0;
    }
    if (i = Object.keys(t), n = i.length, n !== Object.keys(e).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(e, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const a = i[r];
      if (!(a === "_owner" && t.$$typeof) && !gf(t[a], e[a]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function Xw(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function RW(t, e) {
  const n = Xw(t);
  return Math.round(e * n) / n;
}
function gW(t) {
  const e = H.useRef(t);
  return jT(() => {
    e.current = t;
  }), e;
}
function _w(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: i,
    elements: {
      reference: a,
      floating: o
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = t, [d, u] = H.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [h, N] = H.useState(r);
  gf(h, r) || N(r);
  const [M, p] = H.useState(null), [m, R] = H.useState(null), V = H.useCallback((z) => {
    z != x.current && (x.current = z, p(z));
  }, [p]), U = H.useCallback((z) => {
    z !== f.current && (f.current = z, R(z));
  }, [R]), g = a || M, y = o || m, x = H.useRef(null), f = H.useRef(null), D = H.useRef(d), Y = gW(l), Q = gW(i), G = H.useCallback(() => {
    if (!x.current || !f.current)
      return;
    const z = {
      placement: e,
      strategy: n,
      middleware: h
    };
    Q.current && (z.platform = Q.current), _B(x.current, f.current, z).then((j) => {
      const w = {
        ...j,
        isPositioned: !0
      };
      ne.current && !gf(D.current, w) && (D.current = w, EJ.flushSync(() => {
        u(w);
      }));
    });
  }, [h, e, n, Q]);
  jT(() => {
    c === !1 && D.current.isPositioned && (D.current.isPositioned = !1, u((z) => ({
      ...z,
      isPositioned: !1
    })));
  }, [c]);
  const ne = H.useRef(!1);
  jT(() => (ne.current = !0, () => {
    ne.current = !1;
  }), []), jT(() => {
    if (g && (x.current = g), y && (f.current = y), g && y) {
      if (Y.current)
        return Y.current(g, y, G);
      G();
    }
  }, [g, y, G, Y]);
  const O = H.useMemo(() => ({
    reference: x,
    floating: f,
    setReference: V,
    setFloating: U
  }), [V, U]), T = H.useMemo(() => ({
    reference: g,
    floating: y
  }), [g, y]), Z = H.useMemo(() => {
    const z = {
      position: n,
      left: 0,
      top: 0
    };
    if (!T.floating)
      return z;
    const j = RW(T.floating, d.x), w = RW(T.floating, d.y);
    return s ? {
      ...z,
      transform: "translate(" + j + "px, " + w + "px)",
      ...Xw(T.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: j,
      top: w
    };
  }, [n, s, T.floating, d.x, d.y]);
  return H.useMemo(() => ({
    ...d,
    update: G,
    refs: O,
    elements: T,
    floatingStyles: Z
  }), [d, G, O, T, Z]);
}
function Pw(t) {
  const [e, n] = nt(void 0);
  return Pl(() => {
    if (t) {
      n({
        width: t.offsetWidth,
        height: t.offsetHeight
      });
      const r = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const a = i[0];
        let o, s;
        if ("borderBoxSize" in a) {
          const l = a.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          o = c.inlineSize, s = c.blockSize;
        } else
          o = t.offsetWidth, s = t.offsetHeight;
        n({
          width: o,
          height: s
        });
      });
      return r.observe(t, {
        box: "border-box"
      }), () => r.unobserve(t);
    } else
      n(void 0);
  }, [
    t
  ]), e;
}
const Kw = "Popper", [$w, qw] = au(Kw), [Lke, PB] = $w(Kw), eF = "PopperContent", [KB, Jke] = $w(eF), $B = /* @__PURE__ */ Ge((t, e) => {
  var n, r, i, a, o, s, l, c;
  const { __scopePopper: d, side: u = "bottom", sideOffset: h = 0, align: N = "center", alignOffset: M = 0, arrowPadding: p = 0, collisionBoundary: m = [], collisionPadding: R = 0, sticky: V = "partial", hideWhenDetached: U = !1, avoidCollisions: g = !0, onPlaced: y, ...x } = t, f = PB(eF, d), [D, Y] = nt(null), Q = ri(
    e,
    (et) => Y(et)
  ), [G, ne] = nt(null), O = Pw(G), T = (n = O == null ? void 0 : O.width) !== null && n !== void 0 ? n : 0, Z = (r = O == null ? void 0 : O.height) !== null && r !== void 0 ? r : 0, z = u + (N !== "center" ? "-" + N : ""), j = typeof R == "number" ? R : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...R
  }, w = Array.isArray(m) ? m : [
    m
  ], C = w.length > 0, J = {
    padding: j,
    boundary: w.filter(qB),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: C
  }, { refs: I, floatingStyles: b, placement: k, isPositioned: ae, middlewareData: oe } = _w({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: z,
    whileElementsMounted: Aw,
    elements: {
      reference: f.anchor
    },
    middleware: [
      Fw({
        mainAxis: h + Z,
        alignmentAxis: M
      }),
      g && Iw({
        mainAxis: !0,
        crossAxis: !1,
        limiter: V === "partial" ? Ow() : void 0,
        ...J
      }),
      g && kw({
        ...J
      }),
      Yw({
        ...J,
        apply: ({ elements: et, rects: at, availableWidth: Rn, availableHeight: Zt }) => {
          const { width: kt, height: Pn } = at.reference, Oe = et.floating.style;
          Oe.setProperty("--radix-popper-available-width", `${Rn}px`), Oe.setProperty("--radix-popper-available-height", `${Zt}px`), Oe.setProperty("--radix-popper-anchor-width", `${kt}px`), Oe.setProperty("--radix-popper-anchor-height", `${Pn}px`);
        }
      }),
      G && Hw({
        element: G,
        padding: p
      }),
      eA({
        arrowWidth: T,
        arrowHeight: Z
      }),
      U && ww({
        strategy: "referenceHidden"
      })
    ]
  }), [le, fe] = tF(k), de = mi(y);
  Pl(() => {
    ae && (de == null || de());
  }, [
    ae,
    de
  ]);
  const Me = (i = oe.arrow) === null || i === void 0 ? void 0 : i.x, je = (a = oe.arrow) === null || a === void 0 ? void 0 : a.y, Se = ((o = oe.arrow) === null || o === void 0 ? void 0 : o.centerOffset) !== 0, [se, Ce] = nt();
  return Pl(() => {
    D && Ce(window.getComputedStyle(D).zIndex);
  }, [
    D
  ]), /* @__PURE__ */ ye("div", {
    ref: I.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...b,
      transform: ae ? b.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: se,
      "--radix-popper-transform-origin": [
        (s = oe.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (l = oe.transformOrigin) === null || l === void 0 ? void 0 : l.y
      ].join(" ")
    },
    dir: t.dir
  }, /* @__PURE__ */ ye(KB, {
    scope: d,
    placedSide: le,
    onArrowChange: ne,
    arrowX: Me,
    arrowY: je,
    shouldHideArrow: Se
  }, /* @__PURE__ */ ye(Vi.div, At({
    "data-side": le,
    "data-align": fe
  }, x, {
    ref: Q,
    style: {
      ...x.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: ae ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (c = oe.hide) !== null && c !== void 0 && c.referenceHidden ? 0 : void 0
    }
  }))));
});
function qB(t) {
  return t !== null;
}
const eA = (t) => ({
  name: "transformOrigin",
  options: t,
  fn(e) {
    var n, r, i, a, o;
    const { placement: s, rects: l, middlewareData: c } = e, u = ((n = c.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, h = u ? 0 : t.arrowWidth, N = u ? 0 : t.arrowHeight, [M, p] = tF(s), m = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[p], R = ((r = (i = c.arrow) === null || i === void 0 ? void 0 : i.x) !== null && r !== void 0 ? r : 0) + h / 2, V = ((a = (o = c.arrow) === null || o === void 0 ? void 0 : o.y) !== null && a !== void 0 ? a : 0) + N / 2;
    let U = "", g = "";
    return M === "bottom" ? (U = u ? m : `${R}px`, g = `${-N}px`) : M === "top" ? (U = u ? m : `${R}px`, g = `${l.floating.height + N}px`) : M === "right" ? (U = `${-N}px`, g = u ? m : `${V}px`) : M === "left" && (U = `${l.floating.width + N}px`, g = u ? m : `${V}px`), {
      data: {
        x: U,
        y: g
      }
    };
  }
});
function tF(t) {
  const [e, n = "center"] = t.split("-");
  return [
    e,
    n
  ];
}
const tA = $B;
function nA(t, e) {
  return bE((n, r) => {
    const i = e[n][r];
    return i ?? n;
  }, t);
}
const Wp = (t) => {
  const { present: e, children: n } = t, r = rA(e), i = typeof n == "function" ? n({
    present: r.isPresent
  }) : Zo.only(n), a = ri(r.ref, i.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ Tc(i, {
    ref: a
  }) : null;
};
Wp.displayName = "Presence";
function rA(t) {
  const [e, n] = nt(), r = Ve({}), i = Ve(t), a = Ve("none"), o = t ? "mounted" : "unmounted", [s, l] = nA(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Ee(() => {
    const c = Cm(r.current);
    a.current = s === "mounted" ? c : "none";
  }, [
    s
  ]), Pl(() => {
    const c = r.current, d = i.current;
    if (d !== t) {
      const h = a.current, N = Cm(c);
      t ? l("MOUNT") : N === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(d && h !== N ? "ANIMATION_OUT" : "UNMOUNT"), i.current = t;
    }
  }, [
    t,
    l
  ]), Pl(() => {
    if (e) {
      const c = (u) => {
        const N = Cm(r.current).includes(u.animationName);
        u.target === e && N && Mw(
          () => l("ANIMATION_END")
        );
      }, d = (u) => {
        u.target === e && (a.current = Cm(r.current));
      };
      return e.addEventListener("animationstart", d), e.addEventListener("animationcancel", c), e.addEventListener("animationend", c), () => {
        e.removeEventListener("animationstart", d), e.removeEventListener("animationcancel", c), e.removeEventListener("animationend", c);
      };
    } else
      l("ANIMATION_END");
  }, [
    e,
    l
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: De((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function Cm(t) {
  return (t == null ? void 0 : t.animationName) || "none";
}
function nF({ prop: t, defaultProp: e, onChange: n = () => {
} }) {
  const [r, i] = iA({
    defaultProp: e,
    onChange: n
  }), a = t !== void 0, o = a ? t : r, s = mi(n), l = De((c) => {
    if (a) {
      const u = typeof c == "function" ? c(t) : c;
      u !== t && s(u);
    } else
      i(c);
  }, [
    a,
    t,
    i,
    s
  ]);
  return [
    o,
    l
  ];
}
function iA({ defaultProp: t, onChange: e }) {
  const n = nt(t), [r] = n, i = Ve(r), a = mi(e);
  return Ee(() => {
    i.current !== r && (a(r), i.current = r);
  }, [
    r,
    i,
    a
  ]), n;
}
const zE = /* @__PURE__ */ Ge((t, e) => /* @__PURE__ */ ye(Vi.span, At({}, t, {
  ref: e,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...t.style
  }
}))), aA = zE, [T2, Bke] = au("Tooltip", [
  qw
]), oA = qw(), sA = "TooltipProvider", yW = "tooltip.open", [Ake, lA] = T2(sA), rF = "Tooltip", [Hke, kE] = T2(rF), cA = "TooltipPortal", [Xke, dA] = T2(cA, {
  forceMount: void 0
}), z1 = "TooltipContent", uA = /* @__PURE__ */ Ge((t, e) => {
  const n = dA(z1, t.__scopeTooltip), { forceMount: r = n.forceMount, side: i = "top", ...a } = t, o = kE(z1, t.__scopeTooltip);
  return /* @__PURE__ */ ye(Wp, {
    present: r || o.open
  }, o.disableHoverableContent ? /* @__PURE__ */ ye(iF, At({
    side: i
  }, a, {
    ref: e
  })) : /* @__PURE__ */ ye(hA, At({
    side: i
  }, a, {
    ref: e
  })));
}), hA = /* @__PURE__ */ Ge((t, e) => {
  const n = kE(z1, t.__scopeTooltip), r = lA(z1, t.__scopeTooltip), i = Ve(null), a = ri(e, i), [o, s] = nt(null), { trigger: l, onClose: c } = n, d = i.current, { onPointerInTransitChange: u } = r, h = De(() => {
    s(null), u(!1);
  }, [
    u
  ]), N = De((M, p) => {
    const m = M.currentTarget, R = {
      x: M.clientX,
      y: M.clientY
    }, V = MA(R, m.getBoundingClientRect()), U = pA(R, V), g = mA(p.getBoundingClientRect()), y = fA([
      ...U,
      ...g
    ]);
    s(y), u(!0);
  }, [
    u
  ]);
  return Ee(() => () => h(), [
    h
  ]), Ee(() => {
    if (l && d) {
      const M = (m) => N(m, d), p = (m) => N(m, l);
      return l.addEventListener("pointerleave", M), d.addEventListener("pointerleave", p), () => {
        l.removeEventListener("pointerleave", M), d.removeEventListener("pointerleave", p);
      };
    }
  }, [
    l,
    d,
    N,
    h
  ]), Ee(() => {
    if (o) {
      const M = (p) => {
        const m = p.target, R = {
          x: p.clientX,
          y: p.clientY
        }, V = (l == null ? void 0 : l.contains(m)) || (d == null ? void 0 : d.contains(m)), U = !TA(R, o);
        V ? h() : U && (h(), c());
      };
      return document.addEventListener("pointermove", M), () => document.removeEventListener("pointermove", M);
    }
  }, [
    l,
    d,
    o,
    c,
    h
  ]), /* @__PURE__ */ ye(iF, At({}, t, {
    ref: a
  }));
}), [NA, _ke] = T2(rF, {
  isInside: !1
}), iF = /* @__PURE__ */ Ge((t, e) => {
  const { __scopeTooltip: n, children: r, "aria-label": i, onEscapeKeyDown: a, onPointerDownOutside: o, ...s } = t, l = kE(z1, n), c = oA(n), { onClose: d } = l;
  return Ee(() => (document.addEventListener(yW, d), () => document.removeEventListener(yW, d)), [
    d
  ]), Ee(() => {
    if (l.trigger) {
      const u = (h) => {
        const N = h.target;
        N != null && N.contains(l.trigger) && d();
      };
      return window.addEventListener("scroll", u, {
        capture: !0
      }), () => window.removeEventListener("scroll", u, {
        capture: !0
      });
    }
  }, [
    l.trigger,
    d
  ]), /* @__PURE__ */ ye(YB, {
    asChild: !0,
    disableOutsidePointerEvents: !1,
    onEscapeKeyDown: a,
    onPointerDownOutside: o,
    onFocusOutside: (u) => u.preventDefault(),
    onDismiss: d
  }, /* @__PURE__ */ ye(tA, At({
    "data-state": l.stateAttribute
  }, c, s, {
    ref: e,
    style: {
      ...s.style,
      "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
      "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
      "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }), /* @__PURE__ */ ye(xw, null, r), /* @__PURE__ */ ye(NA, {
    scope: n,
    isInside: !0
  }, /* @__PURE__ */ ye(aA, {
    id: l.contentId,
    role: "tooltip"
  }, i || r))));
});
function MA(t, e) {
  const n = Math.abs(e.top - t.y), r = Math.abs(e.bottom - t.y), i = Math.abs(e.right - t.x), a = Math.abs(e.left - t.x);
  switch (Math.min(n, r, i, a)) {
    case a:
      return "left";
    case i:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function pA(t, e, n = 5) {
  const r = [];
  switch (e) {
    case "top":
      r.push({
        x: t.x - n,
        y: t.y + n
      }, {
        x: t.x + n,
        y: t.y + n
      });
      break;
    case "bottom":
      r.push({
        x: t.x - n,
        y: t.y - n
      }, {
        x: t.x + n,
        y: t.y - n
      });
      break;
    case "left":
      r.push({
        x: t.x + n,
        y: t.y - n
      }, {
        x: t.x + n,
        y: t.y + n
      });
      break;
    case "right":
      r.push({
        x: t.x - n,
        y: t.y - n
      }, {
        x: t.x - n,
        y: t.y + n
      });
      break;
  }
  return r;
}
function mA(t) {
  const { top: e, right: n, bottom: r, left: i } = t;
  return [
    {
      x: i,
      y: e
    },
    {
      x: n,
      y: e
    },
    {
      x: n,
      y: r
    },
    {
      x: i,
      y: r
    }
  ];
}
function TA(t, e) {
  const { x: n, y: r } = t;
  let i = !1;
  for (let a = 0, o = e.length - 1; a < e.length; o = a++) {
    const s = e[a].x, l = e[a].y, c = e[o].x, d = e[o].y;
    l > r != d > r && n < (c - s) * (r - l) / (d - l) + s && (i = !i);
  }
  return i;
}
function fA(t) {
  const e = t.slice();
  return e.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), VA(e);
}
function VA(t) {
  if (t.length <= 1)
    return t.slice();
  const e = [];
  for (let r = 0; r < t.length; r++) {
    const i = t[r];
    for (; e.length >= 2; ) {
      const a = e[e.length - 1], o = e[e.length - 2];
      if ((a.x - o.x) * (i.y - o.y) >= (a.y - o.y) * (i.x - o.x))
        e.pop();
      else
        break;
    }
    e.push(i);
  }
  e.pop();
  const n = [];
  for (let r = t.length - 1; r >= 0; r--) {
    const i = t[r];
    for (; n.length >= 2; ) {
      const a = n[n.length - 1], o = n[n.length - 2];
      if ((a.x - o.x) * (i.y - o.y) >= (a.y - o.y) * (i.x - o.x))
        n.pop();
      else
        break;
    }
    n.push(i);
  }
  return n.pop(), e.length === 1 && n.length === 1 && e[0].x === n[0].x && e[0].y === n[0].y ? e : e.concat(n);
}
const aF = uA, UA = H.forwardRef(({ className: t, sideOffset: e = 4, ...n }, r) => /* @__PURE__ */ E.jsx(
  aF,
  {
    ref: r,
    sideOffset: e,
    className: t,
    ...n
  }
));
UA.displayName = aF.displayName;
function RA(t, [e, n]) {
  return Math.min(n, Math.max(e, t));
}
const gA = /* @__PURE__ */ Wt(void 0);
function yA(t) {
  const e = lt(gA);
  return t || e || "ltr";
}
function ZA(t) {
  const e = Ve({
    value: t,
    previous: t
  });
  return vt(() => (e.current.value !== t && (e.current.previous = e.current.value, e.current.value = t), e.current.previous), [
    t
  ]);
}
function oF(t) {
  const e = t + "CollectionProvider", [n, r] = au(e), [i, a] = n(e, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), o = (N) => {
    const { scope: M, children: p } = N, m = rr.useRef(null), R = rr.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ rr.createElement(i, {
      scope: M,
      itemMap: R,
      collectionRef: m
    }, p);
  }, s = t + "CollectionSlot", l = /* @__PURE__ */ rr.forwardRef((N, M) => {
    const { scope: p, children: m } = N, R = a(s, p), V = ri(M, R.collectionRef);
    return /* @__PURE__ */ rr.createElement(x1, {
      ref: V
    }, m);
  }), c = t + "CollectionItemSlot", d = "data-radix-collection-item", u = /* @__PURE__ */ rr.forwardRef((N, M) => {
    const { scope: p, children: m, ...R } = N, V = rr.useRef(null), U = ri(M, V), g = a(c, p);
    return rr.useEffect(() => (g.itemMap.set(V, {
      ref: V,
      ...R
    }), () => void g.itemMap.delete(V))), /* @__PURE__ */ rr.createElement(x1, {
      [d]: "",
      ref: U
    }, m);
  });
  function h(N) {
    const M = a(t + "CollectionConsumer", N);
    return rr.useCallback(() => {
      const m = M.collectionRef.current;
      if (!m)
        return [];
      const R = Array.from(m.querySelectorAll(`[${d}]`));
      return Array.from(M.itemMap.values()).sort(
        (g, y) => R.indexOf(g.ref.current) - R.indexOf(y.ref.current)
      );
    }, [
      M.collectionRef,
      M.itemMap
    ]);
  }
  return [
    {
      Provider: o,
      Slot: l,
      ItemSlot: u
    },
    h,
    r
  ];
}
const sF = [
  "PageUp",
  "PageDown"
], lF = [
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight"
], cF = {
  "from-left": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowLeft"
  ],
  "from-right": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowRight"
  ],
  "from-bottom": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowLeft"
  ],
  "from-top": [
    "Home",
    "PageDown",
    "ArrowUp",
    "ArrowLeft"
  ]
}, jp = "Slider", [ZW, Pke, bA] = oF(jp), [dF, Kke] = au(jp, [
  bA
]), [EA, SA] = dF(jp), xA = /* @__PURE__ */ Ge((t, e) => {
  const { name: n, min: r = 0, max: i = 100, step: a = 1, orientation: o = "horizontal", disabled: s = !1, minStepsBetweenThumbs: l = 0, defaultValue: c = [
    r
  ], value: d, onValueChange: u = () => {
  }, onValueCommit: h = () => {
  }, inverted: N = !1, ...M } = t, [p, m] = nt(null), R = ri(
    e,
    (T) => m(T)
  ), V = Ve(/* @__PURE__ */ new Set()), U = Ve(0), g = o === "horizontal", y = p ? !!p.closest("form") : !0, x = g ? WA : jA, [f = [], D] = nF({
    prop: d,
    defaultProp: c,
    onChange: (T) => {
      var Z;
      (Z = [
        ...V.current
      ][U.current]) === null || Z === void 0 || Z.focus(), u(T);
    }
  }), Y = Ve(f);
  function Q(T) {
    const Z = kA(f, T);
    O(T, Z);
  }
  function G(T) {
    O(T, U.current);
  }
  function ne() {
    const T = Y.current[U.current];
    f[U.current] !== T && h(f);
  }
  function O(T, Z, { commit: z } = {
    commit: !1
  }) {
    const j = vA(a), w = IA(Math.round((T - r) / a) * a + r, j), C = RA(w, [
      r,
      i
    ]);
    D((J = []) => {
      const I = zA(J, C, Z);
      if (FA(I, l * a)) {
        U.current = I.indexOf(C);
        const b = String(I) !== String(J);
        return b && z && h(I), b ? I : J;
      } else
        return J;
    });
  }
  return /* @__PURE__ */ ye(EA, {
    scope: t.__scopeSlider,
    disabled: s,
    min: r,
    max: i,
    valueIndexToChangeRef: U,
    thumbs: V.current,
    values: f,
    orientation: o
  }, /* @__PURE__ */ ye(ZW.Provider, {
    scope: t.__scopeSlider
  }, /* @__PURE__ */ ye(ZW.Slot, {
    scope: t.__scopeSlider
  }, /* @__PURE__ */ ye(x, At({
    "aria-disabled": s,
    "data-disabled": s ? "" : void 0
  }, M, {
    ref: R,
    onPointerDown: Gn(M.onPointerDown, () => {
      s || (Y.current = f);
    }),
    min: r,
    max: i,
    inverted: N,
    onSlideStart: s ? void 0 : Q,
    onSlideMove: s ? void 0 : G,
    onSlideEnd: s ? void 0 : ne,
    onHomeKeyDown: () => !s && O(r, 0, {
      commit: !0
    }),
    onEndKeyDown: () => !s && O(i, f.length - 1, {
      commit: !0
    }),
    onStepKeyDown: ({ event: T, direction: Z }) => {
      if (!s) {
        const w = sF.includes(T.key) || T.shiftKey && lF.includes(T.key) ? 10 : 1, C = U.current, J = f[C], I = a * w * Z;
        O(J + I, C, {
          commit: !0
        });
      }
    }
  })))), y && f.map(
    (T, Z) => /* @__PURE__ */ ye(DA, {
      key: Z,
      name: n ? n + (f.length > 1 ? "[]" : "") : void 0,
      value: T
    })
  ));
}), [uF, $ke] = dF(jp, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), WA = /* @__PURE__ */ Ge((t, e) => {
  const { min: n, max: r, dir: i, inverted: a, onSlideStart: o, onSlideMove: s, onSlideEnd: l, onStepKeyDown: c, ...d } = t, [u, h] = nt(null), N = ri(
    e,
    (U) => h(U)
  ), M = Ve(), p = yA(i), m = p === "ltr", R = m && !a || !m && a;
  function V(U) {
    const g = M.current || u.getBoundingClientRect(), y = [
      0,
      g.width
    ], f = NF(y, R ? [
      n,
      r
    ] : [
      r,
      n
    ]);
    return M.current = g, f(U - g.left);
  }
  return /* @__PURE__ */ ye(uF, {
    scope: t.__scopeSlider,
    startEdge: R ? "left" : "right",
    endEdge: R ? "right" : "left",
    direction: R ? 1 : -1,
    size: "width"
  }, /* @__PURE__ */ ye(hF, At({
    dir: p,
    "data-orientation": "horizontal"
  }, d, {
    ref: N,
    style: {
      ...d.style,
      "--radix-slider-thumb-transform": "translateX(-50%)"
    },
    onSlideStart: (U) => {
      const g = V(U.clientX);
      o == null || o(g);
    },
    onSlideMove: (U) => {
      const g = V(U.clientX);
      s == null || s(g);
    },
    onSlideEnd: () => {
      M.current = void 0, l == null || l();
    },
    onStepKeyDown: (U) => {
      const y = cF[R ? "from-left" : "from-right"].includes(U.key);
      c == null || c({
        event: U,
        direction: y ? -1 : 1
      });
    }
  })));
}), jA = /* @__PURE__ */ Ge((t, e) => {
  const { min: n, max: r, inverted: i, onSlideStart: a, onSlideMove: o, onSlideEnd: s, onStepKeyDown: l, ...c } = t, d = Ve(null), u = ri(e, d), h = Ve(), N = !i;
  function M(p) {
    const m = h.current || d.current.getBoundingClientRect(), R = [
      0,
      m.height
    ], U = NF(R, N ? [
      r,
      n
    ] : [
      n,
      r
    ]);
    return h.current = m, U(p - m.top);
  }
  return /* @__PURE__ */ ye(uF, {
    scope: t.__scopeSlider,
    startEdge: N ? "bottom" : "top",
    endEdge: N ? "top" : "bottom",
    size: "height",
    direction: N ? 1 : -1
  }, /* @__PURE__ */ ye(hF, At({
    "data-orientation": "vertical"
  }, c, {
    ref: u,
    style: {
      ...c.style,
      "--radix-slider-thumb-transform": "translateY(50%)"
    },
    onSlideStart: (p) => {
      const m = M(p.clientY);
      a == null || a(m);
    },
    onSlideMove: (p) => {
      const m = M(p.clientY);
      o == null || o(m);
    },
    onSlideEnd: () => {
      h.current = void 0, s == null || s();
    },
    onStepKeyDown: (p) => {
      const R = cF[N ? "from-bottom" : "from-top"].includes(p.key);
      l == null || l({
        event: p,
        direction: R ? -1 : 1
      });
    }
  })));
}), hF = /* @__PURE__ */ Ge((t, e) => {
  const { __scopeSlider: n, onSlideStart: r, onSlideMove: i, onSlideEnd: a, onHomeKeyDown: o, onEndKeyDown: s, onStepKeyDown: l, ...c } = t, d = SA(jp, n);
  return /* @__PURE__ */ ye(Vi.span, At({}, c, {
    ref: e,
    onKeyDown: Gn(t.onKeyDown, (u) => {
      u.key === "Home" ? (o(u), u.preventDefault()) : u.key === "End" ? (s(u), u.preventDefault()) : sF.concat(lF).includes(u.key) && (l(u), u.preventDefault());
    }),
    onPointerDown: Gn(t.onPointerDown, (u) => {
      const h = u.target;
      h.setPointerCapture(u.pointerId), u.preventDefault(), d.thumbs.has(h) ? h.focus() : r(u);
    }),
    onPointerMove: Gn(t.onPointerMove, (u) => {
      u.target.hasPointerCapture(u.pointerId) && i(u);
    }),
    onPointerUp: Gn(t.onPointerUp, (u) => {
      const h = u.target;
      h.hasPointerCapture(u.pointerId) && (h.releasePointerCapture(u.pointerId), a(u));
    })
  }));
}), DA = (t) => {
  const { value: e, ...n } = t, r = Ve(null), i = ZA(e);
  return Ee(() => {
    const a = r.current, o = window.HTMLInputElement.prototype, l = Object.getOwnPropertyDescriptor(o, "value").set;
    if (i !== e && l) {
      const c = new Event("input", {
        bubbles: !0
      });
      l.call(a, e), a.dispatchEvent(c);
    }
  }, [
    i,
    e
  ]), /* @__PURE__ */ ye("input", At({
    style: {
      display: "none"
    }
  }, n, {
    ref: r,
    defaultValue: e
  }));
};
function zA(t = [], e, n) {
  const r = [
    ...t
  ];
  return r[n] = e, r.sort(
    (i, a) => i - a
  );
}
function kA(t, e) {
  if (t.length === 1)
    return 0;
  const n = t.map(
    (i) => Math.abs(i - e)
  ), r = Math.min(...n);
  return n.indexOf(r);
}
function wA(t) {
  return t.slice(0, -1).map(
    (e, n) => t[n + 1] - e
  );
}
function FA(t, e) {
  if (e > 0) {
    const n = wA(t);
    return Math.min(...n) >= e;
  }
  return !0;
}
function NF(t, e) {
  return (n) => {
    if (t[0] === t[1] || e[0] === e[1])
      return e[0];
    const r = (e[1] - e[0]) / (t[1] - t[0]);
    return e[0] + r * (n - t[0]);
  };
}
function vA(t) {
  return (String(t).split(".")[1] || "").length;
}
function IA(t, e) {
  const n = Math.pow(10, e);
  return Math.round(t * n) / n;
}
const MF = xA, OA = H.forwardRef(({ className: t, children: e, ...n }, r) => /* @__PURE__ */ E.jsx(
  MF,
  {
    ref: r,
    className: ni(
      "relative flex w-full touch-none select-none items-center",
      t
    ),
    ...n,
    children: e
  }
));
OA.displayName = MF.displayName;
const yy = "dismissableLayer.update", YA = "dismissableLayer.pointerDownOutside", QA = "dismissableLayer.focusOutside";
let bW;
const pF = /* @__PURE__ */ Wt({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), mF = /* @__PURE__ */ Ge((t, e) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: i, onPointerDownOutside: a, onFocusOutside: o, onInteractOutside: s, onDismiss: l, ...c } = t, d = lt(pF), [u, h] = nt(null), N = (n = u == null ? void 0 : u.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, M] = nt({}), p = ri(
    e,
    (D) => h(D)
  ), m = Array.from(d.layers), [R] = [
    ...d.layersWithOutsidePointerEventsDisabled
  ].slice(-1), V = m.indexOf(R), U = u ? m.indexOf(u) : -1, g = d.layersWithOutsidePointerEventsDisabled.size > 0, y = U >= V, x = CA((D) => {
    const Y = D.target, Q = [
      ...d.branches
    ].some(
      (G) => G.contains(Y)
    );
    !y || Q || (a == null || a(D), s == null || s(D), D.defaultPrevented || l == null || l());
  }, N), f = LA((D) => {
    const Y = D.target;
    [
      ...d.branches
    ].some(
      (G) => G.contains(Y)
    ) || (o == null || o(D), s == null || s(D), D.defaultPrevented || l == null || l());
  }, N);
  return Ww((D) => {
    U === d.layers.size - 1 && (i == null || i(D), !D.defaultPrevented && l && (D.preventDefault(), l()));
  }, N), Ee(() => {
    if (u)
      return r && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (bW = N.body.style.pointerEvents, N.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(u)), d.layers.add(u), EW(), () => {
        r && d.layersWithOutsidePointerEventsDisabled.size === 1 && (N.body.style.pointerEvents = bW);
      };
  }, [
    u,
    N,
    r,
    d
  ]), Ee(() => () => {
    u && (d.layers.delete(u), d.layersWithOutsidePointerEventsDisabled.delete(u), EW());
  }, [
    u,
    d
  ]), Ee(() => {
    const D = () => M({});
    return document.addEventListener(yy, D), () => document.removeEventListener(yy, D);
  }, []), /* @__PURE__ */ ye(Vi.div, At({}, c, {
    ref: p,
    style: {
      pointerEvents: g ? y ? "auto" : "none" : void 0,
      ...t.style
    },
    onFocusCapture: Gn(t.onFocusCapture, f.onFocusCapture),
    onBlurCapture: Gn(t.onBlurCapture, f.onBlurCapture),
    onPointerDownCapture: Gn(t.onPointerDownCapture, x.onPointerDownCapture)
  }));
}), GA = /* @__PURE__ */ Ge((t, e) => {
  const n = lt(pF), r = Ve(null), i = ri(e, r);
  return Ee(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [
    n.branches
  ]), /* @__PURE__ */ ye(Vi.div, At({}, t, {
    ref: i
  }));
});
function CA(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = mi(t), r = Ve(!1), i = Ve(() => {
  });
  return Ee(() => {
    const a = (s) => {
      if (s.target && !r.current) {
        let c = function() {
          TF(YA, n, l, {
            discrete: !0
          });
        };
        const l = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (e.removeEventListener("click", i.current), i.current = c, e.addEventListener("click", i.current, {
          once: !0
        })) : c();
      } else
        e.removeEventListener("click", i.current);
      r.current = !1;
    }, o = window.setTimeout(() => {
      e.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(o), e.removeEventListener("pointerdown", a), e.removeEventListener("click", i.current);
    };
  }, [
    e,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function LA(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = mi(t), r = Ve(!1);
  return Ee(() => {
    const i = (a) => {
      a.target && !r.current && TF(QA, n, {
        originalEvent: a
      }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", i), () => e.removeEventListener("focusin", i);
  }, [
    e,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function EW() {
  const t = new CustomEvent(yy);
  document.dispatchEvent(t);
}
function TF(t, e, n, { discrete: r }) {
  const i = n.originalEvent.target, a = new CustomEvent(t, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  e && i.addEventListener(t, e, {
    once: !0
  }), r ? xE(i, a) : i.dispatchEvent(a);
}
const JA = mF, BA = GA, fF = /* @__PURE__ */ Ge((t, e) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...i } = t;
  return r ? /* @__PURE__ */ SJ.createPortal(/* @__PURE__ */ ye(Vi.div, At({}, i, {
    ref: e
  })), r) : null;
}), VF = "ToastProvider", [wE, AA, HA] = oF("Toast"), [UF, qke] = au("Toast", [
  HA
]), [XA, f2] = UF(VF), _A = (t) => {
  const { __scopeToast: e, label: n = "Notification", duration: r = 5e3, swipeDirection: i = "right", swipeThreshold: a = 50, children: o } = t, [s, l] = nt(null), [c, d] = nt(0), u = Ve(!1), h = Ve(!1);
  return /* @__PURE__ */ ye(wE.Provider, {
    scope: e
  }, /* @__PURE__ */ ye(XA, {
    scope: e,
    label: n,
    duration: r,
    swipeDirection: i,
    swipeThreshold: a,
    toastCount: c,
    viewport: s,
    onViewportChange: l,
    onToastAdd: De(
      () => d(
        (N) => N + 1
      ),
      []
    ),
    onToastRemove: De(
      () => d(
        (N) => N - 1
      ),
      []
    ),
    isFocusedToastEscapeKeyDownRef: u,
    isClosePausedRef: h
  }, o));
};
_A.propTypes = {
  label(t) {
    if (t.label && typeof t.label == "string" && !t.label.trim()) {
      const e = `Invalid prop \`label\` supplied to \`${VF}\`. Expected non-empty \`string\`.`;
      return new Error(e);
    }
    return null;
  }
};
const PA = "ToastViewport", KA = [
  "F8"
], Zy = "toast.viewportPause", by = "toast.viewportResume", $A = /* @__PURE__ */ Ge((t, e) => {
  const { __scopeToast: n, hotkey: r = KA, label: i = "Notifications ({hotkey})", ...a } = t, o = f2(PA, n), s = AA(n), l = Ve(null), c = Ve(null), d = Ve(null), u = Ve(null), h = ri(e, u, o.onViewportChange), N = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), M = o.toastCount > 0;
  Ee(() => {
    const m = (R) => {
      var V;
      r.every(
        (g) => R[g] || R.code === g
      ) && ((V = u.current) === null || V === void 0 || V.focus());
    };
    return document.addEventListener("keydown", m), () => document.removeEventListener("keydown", m);
  }, [
    r
  ]), Ee(() => {
    const m = l.current, R = u.current;
    if (M && m && R) {
      const V = () => {
        if (!o.isClosePausedRef.current) {
          const x = new CustomEvent(Zy);
          R.dispatchEvent(x), o.isClosePausedRef.current = !0;
        }
      }, U = () => {
        if (o.isClosePausedRef.current) {
          const x = new CustomEvent(by);
          R.dispatchEvent(x), o.isClosePausedRef.current = !1;
        }
      }, g = (x) => {
        !m.contains(x.relatedTarget) && U();
      }, y = () => {
        m.contains(document.activeElement) || U();
      };
      return m.addEventListener("focusin", V), m.addEventListener("focusout", g), m.addEventListener("pointermove", V), m.addEventListener("pointerleave", y), window.addEventListener("blur", V), window.addEventListener("focus", U), () => {
        m.removeEventListener("focusin", V), m.removeEventListener("focusout", g), m.removeEventListener("pointermove", V), m.removeEventListener("pointerleave", y), window.removeEventListener("blur", V), window.removeEventListener("focus", U);
      };
    }
  }, [
    M,
    o.isClosePausedRef
  ]);
  const p = De(({ tabbingDirection: m }) => {
    const V = s().map((U) => {
      const g = U.ref.current, y = [
        g,
        ...MH(g)
      ];
      return m === "forwards" ? y : y.reverse();
    });
    return (m === "forwards" ? V.reverse() : V).flat();
  }, [
    s
  ]);
  return Ee(() => {
    const m = u.current;
    if (m) {
      const R = (V) => {
        const U = V.altKey || V.ctrlKey || V.metaKey;
        if (V.key === "Tab" && !U) {
          const D = document.activeElement, Y = V.shiftKey;
          if (V.target === m && Y) {
            var y;
            (y = c.current) === null || y === void 0 || y.focus();
            return;
          }
          const ne = p({
            tabbingDirection: Y ? "backwards" : "forwards"
          }), O = ne.findIndex(
            (T) => T === D
          );
          if (ER(ne.slice(O + 1)))
            V.preventDefault();
          else {
            var x, f;
            Y ? (x = c.current) === null || x === void 0 || x.focus() : (f = d.current) === null || f === void 0 || f.focus();
          }
        }
      };
      return m.addEventListener("keydown", R), () => m.removeEventListener("keydown", R);
    }
  }, [
    s,
    p
  ]), /* @__PURE__ */ ye(BA, {
    ref: l,
    role: "region",
    "aria-label": i.replace("{hotkey}", N),
    tabIndex: -1,
    style: {
      pointerEvents: M ? void 0 : "none"
    }
  }, M && /* @__PURE__ */ ye(SW, {
    ref: c,
    onFocusFromOutsideViewport: () => {
      const m = p({
        tabbingDirection: "forwards"
      });
      ER(m);
    }
  }), /* @__PURE__ */ ye(wE.Slot, {
    scope: n
  }, /* @__PURE__ */ ye(Vi.ol, At({
    tabIndex: -1
  }, a, {
    ref: h
  }))), M && /* @__PURE__ */ ye(SW, {
    ref: d,
    onFocusFromOutsideViewport: () => {
      const m = p({
        tabbingDirection: "backwards"
      });
      ER(m);
    }
  }));
}), qA = "ToastFocusProxy", SW = /* @__PURE__ */ Ge((t, e) => {
  const { __scopeToast: n, onFocusFromOutsideViewport: r, ...i } = t, a = f2(qA, n);
  return /* @__PURE__ */ ye(zE, At({
    "aria-hidden": !0,
    tabIndex: 0
  }, i, {
    ref: e,
    style: {
      position: "fixed"
    },
    onFocus: (o) => {
      var s;
      const l = o.relatedTarget;
      !((s = a.viewport) !== null && s !== void 0 && s.contains(l)) && r();
    }
  }));
}), V2 = "Toast", eH = "toast.swipeStart", tH = "toast.swipeMove", nH = "toast.swipeCancel", rH = "toast.swipeEnd", iH = /* @__PURE__ */ Ge((t, e) => {
  const { forceMount: n, open: r, defaultOpen: i, onOpenChange: a, ...o } = t, [s = !0, l] = nF({
    prop: r,
    defaultProp: i,
    onChange: a
  });
  return /* @__PURE__ */ ye(Wp, {
    present: n || s
  }, /* @__PURE__ */ ye(RF, At({
    open: s
  }, o, {
    ref: e,
    onClose: () => l(!1),
    onPause: mi(t.onPause),
    onResume: mi(t.onResume),
    onSwipeStart: Gn(t.onSwipeStart, (c) => {
      c.currentTarget.setAttribute("data-swipe", "start");
    }),
    onSwipeMove: Gn(t.onSwipeMove, (c) => {
      const { x: d, y: u } = c.detail.delta;
      c.currentTarget.setAttribute("data-swipe", "move"), c.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${d}px`), c.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${u}px`);
    }),
    onSwipeCancel: Gn(t.onSwipeCancel, (c) => {
      c.currentTarget.setAttribute("data-swipe", "cancel"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), c.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
    }),
    onSwipeEnd: Gn(t.onSwipeEnd, (c) => {
      const { x: d, y: u } = c.detail.delta;
      c.currentTarget.setAttribute("data-swipe", "end"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), c.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${d}px`), c.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${u}px`), l(!1);
    })
  })));
}), [aH, oH] = UF(V2, {
  onClose() {
  }
}), RF = /* @__PURE__ */ Ge((t, e) => {
  const { __scopeToast: n, type: r = "foreground", duration: i, open: a, onClose: o, onEscapeKeyDown: s, onPause: l, onResume: c, onSwipeStart: d, onSwipeMove: u, onSwipeCancel: h, onSwipeEnd: N, ...M } = t, p = f2(V2, n), [m, R] = nt(null), V = ri(
    e,
    (T) => R(T)
  ), U = Ve(null), g = Ve(null), y = i || p.duration, x = Ve(0), f = Ve(y), D = Ve(0), { onToastAdd: Y, onToastRemove: Q } = p, G = mi(() => {
    var T;
    (m == null ? void 0 : m.contains(document.activeElement)) && ((T = p.viewport) === null || T === void 0 || T.focus()), o();
  }), ne = De((T) => {
    !T || T === 1 / 0 || (window.clearTimeout(D.current), x.current = (/* @__PURE__ */ new Date()).getTime(), D.current = window.setTimeout(G, T));
  }, [
    G
  ]);
  Ee(() => {
    const T = p.viewport;
    if (T) {
      const Z = () => {
        ne(f.current), c == null || c();
      }, z = () => {
        const j = (/* @__PURE__ */ new Date()).getTime() - x.current;
        f.current = f.current - j, window.clearTimeout(D.current), l == null || l();
      };
      return T.addEventListener(Zy, z), T.addEventListener(by, Z), () => {
        T.removeEventListener(Zy, z), T.removeEventListener(by, Z);
      };
    }
  }, [
    p.viewport,
    y,
    l,
    c,
    ne
  ]), Ee(() => {
    a && !p.isClosePausedRef.current && ne(y);
  }, [
    a,
    y,
    p.isClosePausedRef,
    ne
  ]), Ee(() => (Y(), () => Q()), [
    Y,
    Q
  ]);
  const O = vt(() => m ? bF(m) : null, [
    m
  ]);
  return p.viewport ? /* @__PURE__ */ ye(tu, null, O && /* @__PURE__ */ ye(sH, {
    __scopeToast: n,
    role: "status",
    "aria-live": r === "foreground" ? "assertive" : "polite",
    "aria-atomic": !0
  }, O), /* @__PURE__ */ ye(aH, {
    scope: n,
    onClose: G
  }, /* @__PURE__ */ EE(/* @__PURE__ */ ye(wE.ItemSlot, {
    scope: n
  }, /* @__PURE__ */ ye(JA, {
    asChild: !0,
    onEscapeKeyDown: Gn(s, () => {
      p.isFocusedToastEscapeKeyDownRef.current || G(), p.isFocusedToastEscapeKeyDownRef.current = !1;
    })
  }, /* @__PURE__ */ ye(Vi.li, At({
    // Ensure toasts are announced as status list or status when focused
    role: "status",
    "aria-live": "off",
    "aria-atomic": !0,
    tabIndex: 0,
    "data-state": a ? "open" : "closed",
    "data-swipe-direction": p.swipeDirection
  }, M, {
    ref: V,
    style: {
      userSelect: "none",
      touchAction: "none",
      ...t.style
    },
    onKeyDown: Gn(t.onKeyDown, (T) => {
      T.key === "Escape" && (s == null || s(T.nativeEvent), T.nativeEvent.defaultPrevented || (p.isFocusedToastEscapeKeyDownRef.current = !0, G()));
    }),
    onPointerDown: Gn(t.onPointerDown, (T) => {
      T.button === 0 && (U.current = {
        x: T.clientX,
        y: T.clientY
      });
    }),
    onPointerMove: Gn(t.onPointerMove, (T) => {
      if (!U.current)
        return;
      const Z = T.clientX - U.current.x, z = T.clientY - U.current.y, j = !!g.current, w = [
        "left",
        "right"
      ].includes(p.swipeDirection), C = [
        "left",
        "up"
      ].includes(p.swipeDirection) ? Math.min : Math.max, J = w ? C(0, Z) : 0, I = w ? 0 : C(0, z), b = T.pointerType === "touch" ? 10 : 2, k = {
        x: J,
        y: I
      }, ae = {
        originalEvent: T,
        delta: k
      };
      j ? (g.current = k, Lm(tH, u, ae, {
        discrete: !1
      })) : xW(k, p.swipeDirection, b) ? (g.current = k, Lm(eH, d, ae, {
        discrete: !1
      }), T.target.setPointerCapture(T.pointerId)) : (Math.abs(Z) > b || Math.abs(z) > b) && (U.current = null);
    }),
    onPointerUp: Gn(t.onPointerUp, (T) => {
      const Z = g.current, z = T.target;
      if (z.hasPointerCapture(T.pointerId) && z.releasePointerCapture(T.pointerId), g.current = null, U.current = null, Z) {
        const j = T.currentTarget, w = {
          originalEvent: T,
          delta: Z
        };
        xW(Z, p.swipeDirection, p.swipeThreshold) ? Lm(rH, N, w, {
          discrete: !0
        }) : Lm(nH, h, w, {
          discrete: !0
        }), j.addEventListener(
          "click",
          (C) => C.preventDefault(),
          {
            once: !0
          }
        );
      }
    })
  })))), p.viewport))) : null;
});
RF.propTypes = {
  type(t) {
    if (t.type && ![
      "foreground",
      "background"
    ].includes(t.type)) {
      const e = `Invalid prop \`type\` supplied to \`${V2}\`. Expected \`foreground | background\`.`;
      return new Error(e);
    }
    return null;
  }
};
const sH = (t) => {
  const { __scopeToast: e, children: n, ...r } = t, i = f2(V2, e), [a, o] = nt(!1), [s, l] = nt(!1);
  return hH(
    () => o(!0)
  ), Ee(() => {
    const c = window.setTimeout(
      () => l(!0),
      1e3
    );
    return () => window.clearTimeout(c);
  }, []), s ? null : /* @__PURE__ */ ye(fF, {
    asChild: !0
  }, /* @__PURE__ */ ye(zE, r, a && /* @__PURE__ */ ye(tu, null, i.label, " ", n)));
}, lH = /* @__PURE__ */ Ge((t, e) => {
  const { __scopeToast: n, ...r } = t;
  return /* @__PURE__ */ ye(Vi.div, At({}, r, {
    ref: e
  }));
}), cH = /* @__PURE__ */ Ge((t, e) => {
  const { __scopeToast: n, ...r } = t;
  return /* @__PURE__ */ ye(Vi.div, At({}, r, {
    ref: e
  }));
}), dH = "ToastAction", gF = /* @__PURE__ */ Ge((t, e) => {
  const { altText: n, ...r } = t;
  return n ? /* @__PURE__ */ ye(ZF, {
    altText: n,
    asChild: !0
  }, /* @__PURE__ */ ye(yF, At({}, r, {
    ref: e
  }))) : null;
});
gF.propTypes = {
  altText(t) {
    return t.altText ? null : new Error(`Missing prop \`altText\` expected on \`${dH}\``);
  }
};
const uH = "ToastClose", yF = /* @__PURE__ */ Ge((t, e) => {
  const { __scopeToast: n, ...r } = t, i = oH(uH, n);
  return /* @__PURE__ */ ye(ZF, {
    asChild: !0
  }, /* @__PURE__ */ ye(Vi.button, At({
    type: "button"
  }, r, {
    ref: e,
    onClick: Gn(t.onClick, i.onClose)
  })));
}), ZF = /* @__PURE__ */ Ge((t, e) => {
  const { __scopeToast: n, altText: r, ...i } = t;
  return /* @__PURE__ */ ye(Vi.div, At({
    "data-radix-toast-announce-exclude": "",
    "data-radix-toast-announce-alt": r || void 0
  }, i, {
    ref: e
  }));
});
function bF(t) {
  const e = [];
  return Array.from(t.childNodes).forEach((r) => {
    if (r.nodeType === r.TEXT_NODE && r.textContent && e.push(r.textContent), NH(r)) {
      const i = r.ariaHidden || r.hidden || r.style.display === "none", a = r.dataset.radixToastAnnounceExclude === "";
      if (!i)
        if (a) {
          const o = r.dataset.radixToastAnnounceAlt;
          o && e.push(o);
        } else
          e.push(...bF(r));
    }
  }), e;
}
function Lm(t, e, n, { discrete: r }) {
  const i = n.originalEvent.currentTarget, a = new CustomEvent(t, {
    bubbles: !0,
    cancelable: !0,
    detail: n
  });
  e && i.addEventListener(t, e, {
    once: !0
  }), r ? xE(i, a) : i.dispatchEvent(a);
}
const xW = (t, e, n = 0) => {
  const r = Math.abs(t.x), i = Math.abs(t.y), a = r > i;
  return e === "left" || e === "right" ? a && r > n : !a && i > n;
};
function hH(t = () => {
}) {
  const e = mi(t);
  Pl(() => {
    let n = 0, r = 0;
    return n = window.requestAnimationFrame(
      () => r = window.requestAnimationFrame(e)
    ), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(r);
    };
  }, [
    e
  ]);
}
function NH(t) {
  return t.nodeType === t.ELEMENT_NODE;
}
function MH(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    e.push(n.currentNode);
  return e;
}
function ER(t) {
  const e = document.activeElement;
  return t.some((n) => n === e ? !0 : (n.focus(), document.activeElement !== e));
}
const EF = $A, SF = iH, xF = lH, WF = cH, jF = gF, DF = yF, WW = (t) => typeof t == "boolean" ? "".concat(t) : t === 0 ? "0" : t, jW = Tf, pH = (t, e) => (n) => {
  var r;
  if ((e == null ? void 0 : e.variants) == null)
    return jW(t, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: i, defaultVariants: a } = e, o = Object.keys(i).map((c) => {
    const d = n == null ? void 0 : n[c], u = a == null ? void 0 : a[c];
    if (d === null)
      return null;
    const h = WW(d) || WW(u);
    return i[c][h];
  }), s = n && Object.entries(n).reduce((c, d) => {
    let [u, h] = d;
    return h === void 0 || (c[u] = h), c;
  }, {}), l = e == null || (r = e.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((c, d) => {
    let { class: u, className: h, ...N } = d;
    return Object.entries(N).every((M) => {
      let [p, m] = M;
      return Array.isArray(m) ? m.includes({
        ...a,
        ...s
      }[p]) : {
        ...a,
        ...s
      }[p] === m;
    }) ? [
      ...c,
      u,
      h
    ] : c;
  }, []);
  return jW(t, o, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
};
var mH = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
const TH = (t) => t.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), fH = (t, e) => {
  const n = Ge(
    ({ color: r = "currentColor", size: i = 24, strokeWidth: a = 2, absoluteStrokeWidth: o, children: s, ...l }, c) => ye(
      "svg",
      {
        ref: c,
        ...mH,
        width: i,
        height: i,
        stroke: r,
        strokeWidth: o ? Number(a) * 24 / Number(i) : a,
        className: `lucide lucide-${TH(t)}`,
        ...l
      },
      [
        ...e.map(([d, u]) => ye(d, u)),
        ...(Array.isArray(s) ? s : [s]) || []
      ]
    )
  );
  return n.displayName = `${t}`, n;
}, VH = fH("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]), UH = H.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ E.jsx(
  EF,
  {
    ref: n,
    className: ni(
      "z-toast fixed right-[16px] top-[16px] flex max-h-screen max-w-[320px] flex-col sm:right-[32px] sm:top-[32px]",
      t
    ),
    ...e
  }
));
UH.displayName = EF.displayName;
const RH = pH(
  "group pointer-events-auto backdrop-blur-[10px] relative flex w-full space-x-[8px] outline outline-[1px] rounded-[8px] py-[20px] px-[24px]",
  {
    variants: {
      variant: {
        default: "bg-background-mask outline-line text-foreground",
        destructive: "destructive group border-destructive bg-destructive text-destructive-foreground"
      },
      animation: {
        default: "transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-right-full"
      }
    },
    defaultVariants: {
      variant: "default",
      animation: "default"
    }
  }
), gH = H.forwardRef(({ className: t, variant: e, ...n }, r) => /* @__PURE__ */ E.jsx(
  SF,
  {
    ref: r,
    className: ni(RH({ variant: e }), t),
    ...n
  }
));
gH.displayName = SF.displayName;
const yH = H.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ E.jsx(
  jF,
  {
    ref: n,
    className: ni(
      "ring-offset-background hover:bg-secondary focus:ring-ring group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
      t
    ),
    ...e
  }
));
yH.displayName = jF.displayName;
const ZH = H.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ E.jsx(
  DF,
  {
    ref: n,
    className: ni(
      "text-text-tertiary hover:text-text-primary absolute right-[8px] top-[8px]",
      t
    ),
    "toast-close": "",
    ...e,
    children: /* @__PURE__ */ E.jsx(VH, { className: "h-[16px] w-[16px]" })
  }
));
ZH.displayName = DF.displayName;
const bH = H.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ E.jsx(
  xF,
  {
    ref: n,
    className: ni(
      "text-text-primary text-[18px]/[22px] font-semibold",
      t
    ),
    ...e
  }
));
bH.displayName = xF.displayName;
const EH = H.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ E.jsx(
  WF,
  {
    ref: n,
    className: ni(
      "text-text-secondary line-clamp-6 text-[12px]/[16px]",
      t
    ),
    ...e
  }
));
EH.displayName = WF.displayName;
let SR = 0;
function SH() {
  Ee(() => {
    var t, e;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (t = n[0]) !== null && t !== void 0 ? t : DW()), document.body.insertAdjacentElement("beforeend", (e = n[1]) !== null && e !== void 0 ? e : DW()), SR++, () => {
      SR === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), SR--;
    };
  }, []);
}
function DW() {
  const t = document.createElement("span");
  return t.setAttribute("data-radix-focus-guard", ""), t.tabIndex = 0, t.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", t;
}
const xR = "focusScope.autoFocusOnMount", WR = "focusScope.autoFocusOnUnmount", zW = {
  bubbles: !1,
  cancelable: !0
}, xH = /* @__PURE__ */ Ge((t, e) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: i, onUnmountAutoFocus: a, ...o } = t, [s, l] = nt(null), c = mi(i), d = mi(a), u = Ve(null), h = ri(
    e,
    (p) => l(p)
  ), N = Ve({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  Ee(() => {
    if (r) {
      let p = function(U) {
        if (N.paused || !s)
          return;
        const g = U.target;
        s.contains(g) ? u.current = g : Nl(u.current, {
          select: !0
        });
      }, m = function(U) {
        if (N.paused || !s)
          return;
        const g = U.relatedTarget;
        g !== null && (s.contains(g) || Nl(u.current, {
          select: !0
        }));
      }, R = function(U) {
        if (document.activeElement === document.body)
          for (const y of U)
            y.removedNodes.length > 0 && Nl(s);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", m);
      const V = new MutationObserver(R);
      return s && V.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", m), V.disconnect();
      };
    }
  }, [
    r,
    s,
    N.paused
  ]), Ee(() => {
    if (s) {
      wW.add(N);
      const p = document.activeElement;
      if (!s.contains(p)) {
        const R = new CustomEvent(xR, zW);
        s.addEventListener(xR, c), s.dispatchEvent(R), R.defaultPrevented || (WH(wH(zF(s)), {
          select: !0
        }), document.activeElement === p && Nl(s));
      }
      return () => {
        s.removeEventListener(xR, c), setTimeout(() => {
          const R = new CustomEvent(WR, zW);
          s.addEventListener(WR, d), s.dispatchEvent(R), R.defaultPrevented || Nl(p ?? document.body, {
            select: !0
          }), s.removeEventListener(WR, d), wW.remove(N);
        }, 0);
      };
    }
  }, [
    s,
    c,
    d,
    N
  ]);
  const M = De((p) => {
    if (!n && !r || N.paused)
      return;
    const m = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, R = document.activeElement;
    if (m && R) {
      const V = p.currentTarget, [U, g] = jH(V);
      U && g ? !p.shiftKey && R === g ? (p.preventDefault(), n && Nl(U, {
        select: !0
      })) : p.shiftKey && R === U && (p.preventDefault(), n && Nl(g, {
        select: !0
      })) : R === V && p.preventDefault();
    }
  }, [
    n,
    r,
    N.paused
  ]);
  return /* @__PURE__ */ ye(Vi.div, At({
    tabIndex: -1
  }, o, {
    ref: h,
    onKeyDown: M
  }));
});
function WH(t, { select: e = !1 } = {}) {
  const n = document.activeElement;
  for (const r of t)
    if (Nl(r, {
      select: e
    }), document.activeElement !== n)
      return;
}
function jH(t) {
  const e = zF(t), n = kW(e, t), r = kW(e.reverse(), t);
  return [
    n,
    r
  ];
}
function zF(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    e.push(n.currentNode);
  return e;
}
function kW(t, e) {
  for (const n of t)
    if (!DH(n, {
      upTo: e
    }))
      return n;
}
function DH(t, { upTo: e }) {
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  for (; t; ) {
    if (e !== void 0 && t === e)
      return !1;
    if (getComputedStyle(t).display === "none")
      return !0;
    t = t.parentElement;
  }
  return !1;
}
function zH(t) {
  return t instanceof HTMLInputElement && "select" in t;
}
function Nl(t, { select: e = !1 } = {}) {
  if (t && t.focus) {
    const n = document.activeElement;
    t.focus({
      preventScroll: !0
    }), t !== n && zH(t) && e && t.select();
  }
}
const wW = kH();
function kH() {
  let t = [];
  return {
    add(e) {
      const n = t[0];
      e !== n && (n == null || n.pause()), t = FW(t, e), t.unshift(e);
    },
    remove(e) {
      var n;
      t = FW(t, e), (n = t[0]) === null || n === void 0 || n.resume();
    }
  };
}
function FW(t, e) {
  const n = [
    ...t
  ], r = n.indexOf(e);
  return r !== -1 && n.splice(r, 1), n;
}
function wH(t) {
  return t.filter(
    (e) => e.tagName !== "A"
  );
}
const kF = "Popper", [wF, FF] = au(kF), [ewe, FH] = wF(kF), vF = "PopperContent", [vH, twe] = wF(vF), IH = /* @__PURE__ */ Ge((t, e) => {
  var n, r, i, a, o, s, l, c;
  const { __scopePopper: d, side: u = "bottom", sideOffset: h = 0, align: N = "center", alignOffset: M = 0, arrowPadding: p = 0, avoidCollisions: m = !0, collisionBoundary: R = [], collisionPadding: V = 0, sticky: U = "partial", hideWhenDetached: g = !1, updatePositionStrategy: y = "optimized", onPlaced: x, ...f } = t, D = FH(vF, d), [Y, Q] = nt(null), G = ri(
    e,
    (at) => Q(at)
  ), [ne, O] = nt(null), T = Pw(ne), Z = (n = T == null ? void 0 : T.width) !== null && n !== void 0 ? n : 0, z = (r = T == null ? void 0 : T.height) !== null && r !== void 0 ? r : 0, j = u + (N !== "center" ? "-" + N : ""), w = typeof V == "number" ? V : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...V
  }, C = Array.isArray(R) ? R : [
    R
  ], J = C.length > 0, I = {
    padding: w,
    boundary: C.filter(OH),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: J
  }, { refs: b, floatingStyles: k, placement: ae, isPositioned: oe, middlewareData: le } = _w({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: j,
    whileElementsMounted: (...at) => Aw(...at, {
      animationFrame: y === "always"
    }),
    elements: {
      reference: D.anchor
    },
    middleware: [
      Fw({
        mainAxis: h + z,
        alignmentAxis: M
      }),
      m && Iw({
        mainAxis: !0,
        crossAxis: !1,
        limiter: U === "partial" ? Ow() : void 0,
        ...I
      }),
      m && kw({
        ...I
      }),
      Yw({
        ...I,
        apply: ({ elements: at, rects: Rn, availableWidth: Zt, availableHeight: kt }) => {
          const { width: Pn, height: Oe } = Rn.reference, Xe = at.floating.style;
          Xe.setProperty("--radix-popper-available-width", `${Zt}px`), Xe.setProperty("--radix-popper-available-height", `${kt}px`), Xe.setProperty("--radix-popper-anchor-width", `${Pn}px`), Xe.setProperty("--radix-popper-anchor-height", `${Oe}px`);
        }
      }),
      ne && Hw({
        element: ne,
        padding: p
      }),
      YH({
        arrowWidth: Z,
        arrowHeight: z
      }),
      g && ww({
        strategy: "referenceHidden",
        ...I
      })
    ]
  }), [fe, de] = IF(ae), Me = mi(x);
  Pl(() => {
    oe && (Me == null || Me());
  }, [
    oe,
    Me
  ]);
  const je = (i = le.arrow) === null || i === void 0 ? void 0 : i.x, Se = (a = le.arrow) === null || a === void 0 ? void 0 : a.y, se = ((o = le.arrow) === null || o === void 0 ? void 0 : o.centerOffset) !== 0, [Ce, et] = nt();
  return Pl(() => {
    Y && et(window.getComputedStyle(Y).zIndex);
  }, [
    Y
  ]), /* @__PURE__ */ ye("div", {
    ref: b.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...k,
      transform: oe ? k.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: Ce,
      "--radix-popper-transform-origin": [
        (s = le.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (l = le.transformOrigin) === null || l === void 0 ? void 0 : l.y
      ].join(" ")
    },
    dir: t.dir
  }, /* @__PURE__ */ ye(vH, {
    scope: d,
    placedSide: fe,
    onArrowChange: O,
    arrowX: je,
    arrowY: Se,
    shouldHideArrow: se
  }, /* @__PURE__ */ ye(Vi.div, At({
    "data-side": fe,
    "data-align": de
  }, f, {
    ref: G,
    style: {
      ...f.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: oe ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (c = le.hide) !== null && c !== void 0 && c.referenceHidden ? 0 : void 0
    }
  }))));
});
function OH(t) {
  return t !== null;
}
const YH = (t) => ({
  name: "transformOrigin",
  options: t,
  fn(e) {
    var n, r, i, a, o;
    const { placement: s, rects: l, middlewareData: c } = e, u = ((n = c.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, h = u ? 0 : t.arrowWidth, N = u ? 0 : t.arrowHeight, [M, p] = IF(s), m = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[p], R = ((r = (i = c.arrow) === null || i === void 0 ? void 0 : i.x) !== null && r !== void 0 ? r : 0) + h / 2, V = ((a = (o = c.arrow) === null || o === void 0 ? void 0 : o.y) !== null && a !== void 0 ? a : 0) + N / 2;
    let U = "", g = "";
    return M === "bottom" ? (U = u ? m : `${R}px`, g = `${-N}px`) : M === "top" ? (U = u ? m : `${R}px`, g = `${l.floating.height + N}px`) : M === "right" ? (U = `${-N}px`, g = u ? m : `${V}px`) : M === "left" && (U = `${l.floating.width + N}px`, g = u ? m : `${V}px`), {
      data: {
        x: U,
        y: g
      }
    };
  }
});
function IF(t) {
  const [e, n = "center"] = t.split("-");
  return [
    e,
    n
  ];
}
const QH = IH;
var GH = function(t) {
  if (typeof document > "u")
    return null;
  var e = Array.isArray(t) ? t[0] : t;
  return e.ownerDocument.body;
}, Wu = /* @__PURE__ */ new WeakMap(), Jm = /* @__PURE__ */ new WeakMap(), Bm = {}, jR = 0, OF = function(t) {
  return t && (t.host || OF(t.parentNode));
}, CH = function(t, e) {
  return e.map(function(n) {
    if (t.contains(n))
      return n;
    var r = OF(n);
    return r && t.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", t, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, LH = function(t, e, n, r) {
  var i = CH(e, Array.isArray(t) ? t : [t]);
  Bm[n] || (Bm[n] = /* @__PURE__ */ new WeakMap());
  var a = Bm[n], o = [], s = /* @__PURE__ */ new Set(), l = new Set(i), c = function(u) {
    !u || s.has(u) || (s.add(u), c(u.parentNode));
  };
  i.forEach(c);
  var d = function(u) {
    !u || l.has(u) || Array.prototype.forEach.call(u.children, function(h) {
      if (s.has(h))
        d(h);
      else {
        var N = h.getAttribute(r), M = N !== null && N !== "false", p = (Wu.get(h) || 0) + 1, m = (a.get(h) || 0) + 1;
        Wu.set(h, p), a.set(h, m), o.push(h), p === 1 && M && Jm.set(h, !0), m === 1 && h.setAttribute(n, "true"), M || h.setAttribute(r, "true");
      }
    });
  };
  return d(e), s.clear(), jR++, function() {
    o.forEach(function(u) {
      var h = Wu.get(u) - 1, N = a.get(u) - 1;
      Wu.set(u, h), a.set(u, N), h || (Jm.has(u) || u.removeAttribute(r), Jm.delete(u)), N || u.removeAttribute(n);
    }), jR--, jR || (Wu = /* @__PURE__ */ new WeakMap(), Wu = /* @__PURE__ */ new WeakMap(), Jm = /* @__PURE__ */ new WeakMap(), Bm = {});
  };
}, JH = function(t, e, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(t) ? t : [t]), i = e || GH(t);
  return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live]"))), LH(r, i, n, "aria-hidden")) : function() {
    return null;
  };
}, Ey = function(t, e) {
  return Ey = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r)
      Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, Ey(t, e);
};
function YF(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  Ey(t, e);
  function n() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
}
var ga = function() {
  return ga = Object.assign || function(e) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  }, ga.apply(this, arguments);
};
function U2(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}
function QF(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
}
function GF(t, e) {
  return function(n, r) {
    e(n, r, t);
  };
}
function BH(t, e, n, r, i, a) {
  function o(R) {
    if (R !== void 0 && typeof R != "function")
      throw new TypeError("Function expected");
    return R;
  }
  for (var s = r.kind, l = s === "getter" ? "get" : s === "setter" ? "set" : "value", c = !e && t ? r.static ? t : t.prototype : null, d = e || (c ? Object.getOwnPropertyDescriptor(c, r.name) : {}), u, h = !1, N = n.length - 1; N >= 0; N--) {
    var M = {};
    for (var p in r)
      M[p] = p === "access" ? {} : r[p];
    for (var p in r.access)
      M.access[p] = r.access[p];
    M.addInitializer = function(R) {
      if (h)
        throw new TypeError("Cannot add initializers after decoration has completed");
      a.push(o(R || null));
    };
    var m = (0, n[N])(s === "accessor" ? { get: d.get, set: d.set } : d[l], M);
    if (s === "accessor") {
      if (m === void 0)
        continue;
      if (m === null || typeof m != "object")
        throw new TypeError("Object expected");
      (u = o(m.get)) && (d.get = u), (u = o(m.set)) && (d.set = u), (u = o(m.init)) && i.unshift(u);
    } else
      (u = o(m)) && (s === "field" ? i.unshift(u) : d[l] = u);
  }
  c && Object.defineProperty(c, r.name, d), h = !0;
}
function AH(t, e, n) {
  for (var r = arguments.length > 2, i = 0; i < e.length; i++)
    n = r ? e[i].call(t, n) : e[i].call(t);
  return r ? n : void 0;
}
function HH(t) {
  return typeof t == "symbol" ? t : "".concat(t);
}
function XH(t, e, n) {
  return typeof e == "symbol" && (e = e.description ? "[".concat(e.description, "]") : ""), Object.defineProperty(t, "name", { configurable: !0, value: n ? "".concat(n, " ", e) : e });
}
function CF(t, e) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(t, e);
}
function LF(t, e, n, r) {
  function i(a) {
    return a instanceof n ? a : new n(function(o) {
      o(a);
    });
  }
  return new (n || (n = Promise))(function(a, o) {
    function s(d) {
      try {
        c(r.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(r.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? a(d.value) : i(d.value).then(s, l);
    }
    c((r = r.apply(t, e || [])).next());
  });
}
function JF(t, e) {
  var n = { label: 0, sent: function() {
    if (a[0] & 1)
      throw a[1];
    return a[1];
  }, trys: [], ops: [] }, r, i, a, o;
  return o = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(c) {
    return function(d) {
      return l([c, d]);
    };
  }
  function l(c) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, c[0] && (n = 0)), n; )
      try {
        if (r = 1, i && (a = c[0] & 2 ? i.return : c[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, c[1])).done)
          return a;
        switch (i = 0, a && (c = [c[0] & 2, a.value]), c[0]) {
          case 0:
          case 1:
            a = c;
            break;
          case 4:
            return n.label++, { value: c[1], done: !1 };
          case 5:
            n.label++, i = c[1], c = [0];
            continue;
          case 7:
            c = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (a = n.trys, !(a = a.length > 0 && a[a.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              n = 0;
              continue;
            }
            if (c[0] === 3 && (!a || c[1] > a[0] && c[1] < a[3])) {
              n.label = c[1];
              break;
            }
            if (c[0] === 6 && n.label < a[1]) {
              n.label = a[1], a = c;
              break;
            }
            if (a && n.label < a[2]) {
              n.label = a[2], n.ops.push(c);
              break;
            }
            a[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        c = e.call(t, n);
      } catch (d) {
        c = [6, d], i = 0;
      } finally {
        r = a = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
var R2 = Object.create ? function(t, e, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(e, n);
  (!i || ("get" in i ? !e.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return e[n];
  } }), Object.defineProperty(t, r, i);
} : function(t, e, n, r) {
  r === void 0 && (r = n), t[r] = e[n];
};
function BF(t, e) {
  for (var n in t)
    n !== "default" && !Object.prototype.hasOwnProperty.call(e, n) && R2(e, t, n);
}
function yf(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function FE(t, e) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n)
    return t;
  var r = n.call(t), i, a = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = r.next()).done; )
      a.push(i.value);
  } catch (s) {
    o = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return a;
}
function AF() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t = t.concat(FE(arguments[e]));
  return t;
}
function HF() {
  for (var t = 0, e = 0, n = arguments.length; e < n; e++)
    t += arguments[e].length;
  for (var r = Array(t), i = 0, e = 0; e < n; e++)
    for (var a = arguments[e], o = 0, s = a.length; o < s; o++, i++)
      r[i] = a[o];
  return r;
}
function vE(t, e, n) {
  if (n || arguments.length === 2)
    for (var r = 0, i = e.length, a; r < i; r++)
      (a || !(r in e)) && (a || (a = Array.prototype.slice.call(e, 0, r)), a[r] = e[r]);
  return t.concat(a || Array.prototype.slice.call(e));
}
function P0(t) {
  return this instanceof P0 ? (this.v = t, this) : new P0(t);
}
function XF(t, e, n) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = n.apply(t, e || []), i, a = [];
  return i = {}, o("next"), o("throw"), o("return"), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function o(h) {
    r[h] && (i[h] = function(N) {
      return new Promise(function(M, p) {
        a.push([h, N, M, p]) > 1 || s(h, N);
      });
    });
  }
  function s(h, N) {
    try {
      l(r[h](N));
    } catch (M) {
      u(a[0][3], M);
    }
  }
  function l(h) {
    h.value instanceof P0 ? Promise.resolve(h.value.v).then(c, d) : u(a[0][2], h);
  }
  function c(h) {
    s("next", h);
  }
  function d(h) {
    s("throw", h);
  }
  function u(h, N) {
    h(N), a.shift(), a.length && s(a[0][0], a[0][1]);
  }
}
function _F(t) {
  var e, n;
  return e = {}, r("next"), r("throw", function(i) {
    throw i;
  }), r("return"), e[Symbol.iterator] = function() {
    return this;
  }, e;
  function r(i, a) {
    e[i] = t[i] ? function(o) {
      return (n = !n) ? { value: P0(t[i](o)), done: !1 } : a ? a(o) : o;
    } : a;
  }
}
function PF(t) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = t[Symbol.asyncIterator], n;
  return e ? e.call(t) : (t = typeof yf == "function" ? yf(t) : t[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function r(a) {
    n[a] = t[a] && function(o) {
      return new Promise(function(s, l) {
        o = t[a](o), i(s, l, o.done, o.value);
      });
    };
  }
  function i(a, o, s, l) {
    Promise.resolve(l).then(function(c) {
      a({ value: c, done: s });
    }, o);
  }
}
function KF(t, e) {
  return Object.defineProperty ? Object.defineProperty(t, "raw", { value: e }) : t.raw = e, t;
}
var _H = Object.create ? function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
} : function(t, e) {
  t.default = e;
};
function $F(t) {
  if (t && t.__esModule)
    return t;
  var e = {};
  if (t != null)
    for (var n in t)
      n !== "default" && Object.prototype.hasOwnProperty.call(t, n) && R2(e, t, n);
  return _H(e, t), e;
}
function qF(t) {
  return t && t.__esModule ? t : { default: t };
}
function ev(t, e, n, r) {
  if (n === "a" && !r)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? t !== e || !r : !e.has(t))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return n === "m" ? r : n === "a" ? r.call(t) : r ? r.value : e.get(t);
}
function tv(t, e, n, r, i) {
  if (r === "m")
    throw new TypeError("Private method is not writable");
  if (r === "a" && !i)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? t !== e || !i : !e.has(t))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return r === "a" ? i.call(t, n) : i ? i.value = n : e.set(t, n), n;
}
function nv(t, e) {
  if (e === null || typeof e != "object" && typeof e != "function")
    throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof t == "function" ? e === t : t.has(e);
}
const PH = {
  __extends: YF,
  __assign: ga,
  __rest: U2,
  __decorate: QF,
  __param: GF,
  __metadata: CF,
  __awaiter: LF,
  __generator: JF,
  __createBinding: R2,
  __exportStar: BF,
  __values: yf,
  __read: FE,
  __spread: AF,
  __spreadArrays: HF,
  __spreadArray: vE,
  __await: P0,
  __asyncGenerator: XF,
  __asyncDelegator: _F,
  __asyncValues: PF,
  __makeTemplateObject: KF,
  __importStar: $F,
  __importDefault: qF,
  __classPrivateFieldGet: ev,
  __classPrivateFieldSet: tv,
  __classPrivateFieldIn: nv
}, nwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get __assign() {
    return ga;
  },
  __asyncDelegator: _F,
  __asyncGenerator: XF,
  __asyncValues: PF,
  __await: P0,
  __awaiter: LF,
  __classPrivateFieldGet: ev,
  __classPrivateFieldIn: nv,
  __classPrivateFieldSet: tv,
  __createBinding: R2,
  __decorate: QF,
  __esDecorate: BH,
  __exportStar: BF,
  __extends: YF,
  __generator: JF,
  __importDefault: qF,
  __importStar: $F,
  __makeTemplateObject: KF,
  __metadata: CF,
  __param: GF,
  __propKey: HH,
  __read: FE,
  __rest: U2,
  __runInitializers: AH,
  __setFunctionName: XH,
  __spread: AF,
  __spreadArray: vE,
  __spreadArrays: HF,
  __values: yf,
  default: PH
}, Symbol.toStringTag, { value: "Module" }));
var DT = "right-scroll-bar-position", zT = "width-before-scroll-bar", KH = "with-scroll-bars-hidden", $H = "--removed-body-scroll-bar-size";
function qH(t, e) {
  return typeof t == "function" ? t(e) : t && (t.current = e), t;
}
function e6(t, e) {
  var n = nt(function() {
    return {
      // value
      value: t,
      // last callback
      callback: e,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var i = n.value;
          i !== r && (n.value = r, n.callback(r, i));
        }
      }
    };
  })[0];
  return n.callback = e, n.facade;
}
function t6(t, e) {
  return e6(e || null, function(n) {
    return t.forEach(function(r) {
      return qH(r, n);
    });
  });
}
function n6(t) {
  return t;
}
function r6(t, e) {
  e === void 0 && (e = n6);
  var n = [], r = !1, i = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : t;
    },
    useMedium: function(a) {
      var o = e(a, r);
      return n.push(o), function() {
        n = n.filter(function(s) {
          return s !== o;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (r = !0; n.length; ) {
        var o = n;
        n = [], o.forEach(a);
      }
      n = {
        push: function(s) {
          return a(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      r = !0;
      var o = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(a), o = n;
      }
      var l = function() {
        var d = o;
        o = [], d.forEach(a);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(d) {
          o.push(d), c();
        },
        filter: function(d) {
          return o = o.filter(d), n;
        }
      };
    }
  };
  return i;
}
function i6(t) {
  t === void 0 && (t = {});
  var e = r6(null);
  return e.options = ga({ async: !0, ssr: !1 }, t), e;
}
var rv = function(t) {
  var e = t.sideCar, n = U2(t, ["sideCar"]);
  if (!e)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = e.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return H.createElement(r, ga({}, n));
};
rv.isSideCarExport = !0;
function a6(t, e) {
  return t.useMedium(e), rv;
}
var iv = i6(), DR = function() {
}, g2 = H.forwardRef(function(t, e) {
  var n = H.useRef(null), r = H.useState({
    onScrollCapture: DR,
    onWheelCapture: DR,
    onTouchMoveCapture: DR
  }), i = r[0], a = r[1], o = t.forwardProps, s = t.children, l = t.className, c = t.removeScrollBar, d = t.enabled, u = t.shards, h = t.sideCar, N = t.noIsolation, M = t.inert, p = t.allowPinchZoom, m = t.as, R = m === void 0 ? "div" : m, V = U2(t, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), U = h, g = t6([n, e]), y = ga(ga({}, V), i);
  return H.createElement(
    H.Fragment,
    null,
    d && H.createElement(U, { sideCar: iv, removeScrollBar: c, shards: u, noIsolation: N, inert: M, setCallbacks: a, allowPinchZoom: !!p, lockRef: n }),
    o ? H.cloneElement(H.Children.only(s), ga(ga({}, y), { ref: g })) : H.createElement(R, ga({}, y, { className: l, ref: g }), s)
  );
});
g2.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
g2.classNames = {
  fullWidth: zT,
  zeroRight: DT
};
var vW, o6 = function() {
  if (vW)
    return vW;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function s6() {
  if (!document)
    return null;
  var t = document.createElement("style");
  t.type = "text/css";
  var e = o6();
  return e && t.setAttribute("nonce", e), t;
}
function l6(t, e) {
  t.styleSheet ? t.styleSheet.cssText = e : t.appendChild(document.createTextNode(e));
}
function c6(t) {
  var e = document.head || document.getElementsByTagName("head")[0];
  e.appendChild(t);
}
var d6 = function() {
  var t = 0, e = null;
  return {
    add: function(n) {
      t == 0 && (e = s6()) && (l6(e, n), c6(e)), t++;
    },
    remove: function() {
      t--, !t && e && (e.parentNode && e.parentNode.removeChild(e), e = null);
    }
  };
}, u6 = function() {
  var t = d6();
  return function(e, n) {
    H.useEffect(function() {
      return t.add(e), function() {
        t.remove();
      };
    }, [e && n]);
  };
}, av = function() {
  var t = u6(), e = function(n) {
    var r = n.styles, i = n.dynamic;
    return t(r, i), null;
  };
  return e;
}, h6 = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, zR = function(t) {
  return parseInt(t || "", 10) || 0;
}, N6 = function(t) {
  var e = window.getComputedStyle(document.body), n = e[t === "padding" ? "paddingLeft" : "marginLeft"], r = e[t === "padding" ? "paddingTop" : "marginTop"], i = e[t === "padding" ? "paddingRight" : "marginRight"];
  return [zR(n), zR(r), zR(i)];
}, M6 = function(t) {
  if (t === void 0 && (t = "margin"), typeof window > "u")
    return h6;
  var e = N6(t), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: e[0],
    top: e[1],
    right: e[2],
    gap: Math.max(0, r - n + e[2] - e[0])
  };
}, p6 = av(), m6 = function(t, e, n, r) {
  var i = t.left, a = t.top, o = t.right, s = t.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(KH, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    e && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(o, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(DT, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(zT, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(DT, " .").concat(DT, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(zT, " .").concat(zT, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body {
    `).concat($H, ": ").concat(s, `px;
  }
`);
}, T6 = function(t) {
  var e = t.noRelative, n = t.noImportant, r = t.gapMode, i = r === void 0 ? "margin" : r, a = H.useMemo(function() {
    return M6(i);
  }, [i]);
  return H.createElement(p6, { styles: m6(a, !e, i, n ? "" : "!important") });
}, Sy = !1;
if (typeof window < "u")
  try {
    var Am = Object.defineProperty({}, "passive", {
      get: function() {
        return Sy = !0, !0;
      }
    });
    window.addEventListener("test", Am, Am), window.removeEventListener("test", Am, Am);
  } catch {
    Sy = !1;
  }
var ju = Sy ? { passive: !1 } : !1, f6 = function(t) {
  return t.tagName === "TEXTAREA";
}, ov = function(t, e) {
  var n = window.getComputedStyle(t);
  return (
    // not-not-scrollable
    n[e] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !f6(t) && n[e] === "visible")
  );
}, V6 = function(t) {
  return ov(t, "overflowY");
}, U6 = function(t) {
  return ov(t, "overflowX");
}, IW = function(t, e) {
  var n = e;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = sv(t, n);
    if (r) {
      var i = lv(t, n), a = i[1], o = i[2];
      if (a > o)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, R6 = function(t) {
  var e = t.scrollTop, n = t.scrollHeight, r = t.clientHeight;
  return [
    e,
    n,
    r
  ];
}, g6 = function(t) {
  var e = t.scrollLeft, n = t.scrollWidth, r = t.clientWidth;
  return [
    e,
    n,
    r
  ];
}, sv = function(t, e) {
  return t === "v" ? V6(e) : U6(e);
}, lv = function(t, e) {
  return t === "v" ? R6(e) : g6(e);
}, y6 = function(t, e) {
  return t === "h" && e === "rtl" ? -1 : 1;
}, Z6 = function(t, e, n, r, i) {
  var a = y6(t, window.getComputedStyle(e).direction), o = a * r, s = n.target, l = e.contains(s), c = !1, d = o > 0, u = 0, h = 0;
  do {
    var N = lv(t, s), M = N[0], p = N[1], m = N[2], R = p - m - a * M;
    (M || R) && sv(t, s) && (u += R, h += M), s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (e.contains(s) || e === s)
  );
  return (d && (i && u === 0 || !i && o > u) || !d && (i && h === 0 || !i && -o > h)) && (c = !0), c;
}, Hm = function(t) {
  return "changedTouches" in t ? [t.changedTouches[0].clientX, t.changedTouches[0].clientY] : [0, 0];
}, OW = function(t) {
  return [t.deltaX, t.deltaY];
}, YW = function(t) {
  return t && "current" in t ? t.current : t;
}, b6 = function(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}, E6 = function(t) {
  return `
  .block-interactivity-`.concat(t, ` {pointer-events: none;}
  .allow-interactivity-`).concat(t, ` {pointer-events: all;}
`);
}, S6 = 0, Du = [];
function x6(t) {
  var e = H.useRef([]), n = H.useRef([0, 0]), r = H.useRef(), i = H.useState(S6++)[0], a = H.useState(function() {
    return av();
  })[0], o = H.useRef(t);
  H.useEffect(function() {
    o.current = t;
  }, [t]), H.useEffect(function() {
    if (t.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var p = vE([t.lockRef.current], (t.shards || []).map(YW), !0).filter(Boolean);
      return p.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), p.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [t.inert, t.lockRef.current, t.shards]);
  var s = H.useCallback(function(p, m) {
    if ("touches" in p && p.touches.length === 2)
      return !o.current.allowPinchZoom;
    var R = Hm(p), V = n.current, U = "deltaX" in p ? p.deltaX : V[0] - R[0], g = "deltaY" in p ? p.deltaY : V[1] - R[1], y, x = p.target, f = Math.abs(U) > Math.abs(g) ? "h" : "v";
    if ("touches" in p && f === "h" && x.type === "range")
      return !1;
    var D = IW(f, x);
    if (!D)
      return !0;
    if (D ? y = f : (y = f === "v" ? "h" : "v", D = IW(f, x)), !D)
      return !1;
    if (!r.current && "changedTouches" in p && (U || g) && (r.current = y), !y)
      return !0;
    var Y = r.current || y;
    return Z6(Y, m, p, Y === "h" ? U : g, !0);
  }, []), l = H.useCallback(function(p) {
    var m = p;
    if (!(!Du.length || Du[Du.length - 1] !== a)) {
      var R = "deltaY" in m ? OW(m) : Hm(m), V = e.current.filter(function(y) {
        return y.name === m.type && y.target === m.target && b6(y.delta, R);
      })[0];
      if (V && V.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!V) {
        var U = (o.current.shards || []).map(YW).filter(Boolean).filter(function(y) {
          return y.contains(m.target);
        }), g = U.length > 0 ? s(m, U[0]) : !o.current.noIsolation;
        g && m.cancelable && m.preventDefault();
      }
    }
  }, []), c = H.useCallback(function(p, m, R, V) {
    var U = { name: p, delta: m, target: R, should: V };
    e.current.push(U), setTimeout(function() {
      e.current = e.current.filter(function(g) {
        return g !== U;
      });
    }, 1);
  }, []), d = H.useCallback(function(p) {
    n.current = Hm(p), r.current = void 0;
  }, []), u = H.useCallback(function(p) {
    c(p.type, OW(p), p.target, s(p, t.lockRef.current));
  }, []), h = H.useCallback(function(p) {
    c(p.type, Hm(p), p.target, s(p, t.lockRef.current));
  }, []);
  H.useEffect(function() {
    return Du.push(a), t.setCallbacks({
      onScrollCapture: u,
      onWheelCapture: u,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", l, ju), document.addEventListener("touchmove", l, ju), document.addEventListener("touchstart", d, ju), function() {
      Du = Du.filter(function(p) {
        return p !== a;
      }), document.removeEventListener("wheel", l, ju), document.removeEventListener("touchmove", l, ju), document.removeEventListener("touchstart", d, ju);
    };
  }, []);
  var N = t.removeScrollBar, M = t.inert;
  return H.createElement(
    H.Fragment,
    null,
    M ? H.createElement(a, { styles: E6(i) }) : null,
    N ? H.createElement(T6, { gapMode: "margin" }) : null
  );
}
const W6 = a6(iv, x6);
var cv = H.forwardRef(function(t, e) {
  return H.createElement(g2, ga({}, t, { ref: e, sideCar: W6 }));
});
cv.classNames = g2.classNames;
const j6 = cv, dv = "Popover", [uv, rwe] = au(dv, [
  FF
]), D6 = FF(), [iwe, Dp] = uv(dv), hv = "PopoverPortal", [z6, k6] = uv(hv, {
  forceMount: void 0
}), w6 = (t) => {
  const { __scopePopover: e, forceMount: n, children: r, container: i } = t, a = Dp(hv, e);
  return /* @__PURE__ */ ye(z6, {
    scope: e,
    forceMount: n
  }, /* @__PURE__ */ ye(Wp, {
    present: n || a.open
  }, /* @__PURE__ */ ye(fF, {
    asChild: !0,
    container: i
  }, r)));
}, k1 = "PopoverContent", F6 = /* @__PURE__ */ Ge((t, e) => {
  const n = k6(k1, t.__scopePopover), { forceMount: r = n.forceMount, ...i } = t, a = Dp(k1, t.__scopePopover);
  return /* @__PURE__ */ ye(Wp, {
    present: r || a.open
  }, a.modal ? /* @__PURE__ */ ye(v6, At({}, i, {
    ref: e
  })) : /* @__PURE__ */ ye(I6, At({}, i, {
    ref: e
  })));
}), v6 = /* @__PURE__ */ Ge((t, e) => {
  const n = Dp(k1, t.__scopePopover), r = Ve(null), i = ri(e, r), a = Ve(!1);
  return Ee(() => {
    const o = r.current;
    if (o)
      return JH(o);
  }, []), /* @__PURE__ */ ye(j6, {
    as: x1,
    allowPinchZoom: !0
  }, /* @__PURE__ */ ye(Nv, At({}, t, {
    ref: i,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: Gn(t.onCloseAutoFocus, (o) => {
      var s;
      o.preventDefault(), a.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus();
    }),
    onPointerDownOutside: Gn(t.onPointerDownOutside, (o) => {
      const s = o.detail.originalEvent, l = s.button === 0 && s.ctrlKey === !0, c = s.button === 2 || l;
      a.current = c;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: Gn(
      t.onFocusOutside,
      (o) => o.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), I6 = /* @__PURE__ */ Ge((t, e) => {
  const n = Dp(k1, t.__scopePopover), r = Ve(!1), i = Ve(!1);
  return /* @__PURE__ */ ye(Nv, At({}, t, {
    ref: e,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (a) => {
      var o;
      if ((o = t.onCloseAutoFocus) === null || o === void 0 || o.call(t, a), !a.defaultPrevented) {
        var s;
        r.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), a.preventDefault();
      }
      r.current = !1, i.current = !1;
    },
    onInteractOutside: (a) => {
      var o, s;
      (o = t.onInteractOutside) === null || o === void 0 || o.call(t, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (i.current = !0));
      const l = a.target;
      ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(l)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && i.current && a.preventDefault();
    }
  }));
}), Nv = /* @__PURE__ */ Ge((t, e) => {
  const { __scopePopover: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: a, disableOutsidePointerEvents: o, onEscapeKeyDown: s, onPointerDownOutside: l, onFocusOutside: c, onInteractOutside: d, ...u } = t, h = Dp(k1, n), N = D6(n);
  return SH(), /* @__PURE__ */ ye(xH, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: i,
    onUnmountAutoFocus: a
  }, /* @__PURE__ */ ye(mF, {
    asChild: !0,
    disableOutsidePointerEvents: o,
    onInteractOutside: d,
    onEscapeKeyDown: s,
    onPointerDownOutside: l,
    onFocusOutside: c,
    onDismiss: () => h.onOpenChange(!1)
  }, /* @__PURE__ */ ye(QH, At({
    "data-state": O6(h.open),
    role: "dialog",
    id: h.contentId
  }, N, u, {
    ref: e,
    style: {
      ...u.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
});
function O6(t) {
  return t ? "open" : "closed";
}
const Y6 = w6, Mv = F6, Q6 = H.forwardRef(({ className: t, align: e = "center", sideOffset: n = 4, ...r }, i) => /* @__PURE__ */ E.jsx(Y6, { children: /* @__PURE__ */ E.jsx(
  Mv,
  {
    ref: i,
    align: e,
    sideOffset: n,
    className: ni(
      "bg-surface-3 animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 ml-[16px] max-w-[280px] overflow-hidden rounded-[4px] px-[10px] py-[8px] text-[12px] leading-[16px] text-white",
      t
    ),
    ...r
  }
) }));
Q6.displayName = Mv.displayName;
var Zf = { exports: {} };
Zf.exports;
(function(t, e) {
  var n = 200, r = "__lodash_hash_undefined__", i = 800, a = 16, o = 9007199254740991, s = "[object Arguments]", l = "[object Array]", c = "[object AsyncFunction]", d = "[object Boolean]", u = "[object Date]", h = "[object Error]", N = "[object Function]", M = "[object GeneratorFunction]", p = "[object Map]", m = "[object Number]", R = "[object Null]", V = "[object Object]", U = "[object Proxy]", g = "[object RegExp]", y = "[object Set]", x = "[object String]", f = "[object Undefined]", D = "[object WeakMap]", Y = "[object ArrayBuffer]", Q = "[object DataView]", G = "[object Float32Array]", ne = "[object Float64Array]", O = "[object Int8Array]", T = "[object Int16Array]", Z = "[object Int32Array]", z = "[object Uint8Array]", j = "[object Uint8ClampedArray]", w = "[object Uint16Array]", C = "[object Uint32Array]", J = /[\\^$.*+?()[\]{}|]/g, I = /^\[object .+?Constructor\]$/, b = /^(?:0|[1-9]\d*)$/, k = {};
  k[G] = k[ne] = k[O] = k[T] = k[Z] = k[z] = k[j] = k[w] = k[C] = !0, k[s] = k[l] = k[Y] = k[d] = k[Q] = k[u] = k[h] = k[N] = k[p] = k[m] = k[V] = k[g] = k[y] = k[x] = k[D] = !1;
  var ae = typeof ya == "object" && ya && ya.Object === Object && ya, oe = typeof self == "object" && self && self.Object === Object && self, le = ae || oe || Function("return this")(), fe = e && !e.nodeType && e, de = fe && !0 && t && !t.nodeType && t, Me = de && de.exports === fe, je = Me && ae.process, Se = function() {
    try {
      var F = de && de.require && de.require("util").types;
      return F || je && je.binding && je.binding("util");
    } catch {
    }
  }(), se = Se && Se.isTypedArray;
  function Ce(F, A, re) {
    switch (re.length) {
      case 0:
        return F.call(A);
      case 1:
        return F.call(A, re[0]);
      case 2:
        return F.call(A, re[0], re[1]);
      case 3:
        return F.call(A, re[0], re[1], re[2]);
    }
    return F.apply(A, re);
  }
  function et(F, A) {
    for (var re = -1, me = Array(F); ++re < F; )
      me[re] = A(re);
    return me;
  }
  function at(F) {
    return function(A) {
      return F(A);
    };
  }
  function Rn(F, A) {
    return F == null ? void 0 : F[A];
  }
  function Zt(F, A) {
    return function(re) {
      return F(A(re));
    };
  }
  var kt = Array.prototype, Pn = Function.prototype, Oe = Object.prototype, Xe = le["__core-js_shared__"], ft = Pn.toString, Le = Oe.hasOwnProperty, dt = function() {
    var F = /[^.]+$/.exec(Xe && Xe.keys && Xe.keys.IE_PROTO || "");
    return F ? "Symbol(src)_1." + F : "";
  }(), Dt = Oe.toString, ut = ft.call(Object), v = RegExp(
    "^" + ft.call(Le).replace(J, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), S = Me ? le.Buffer : void 0, W = le.Symbol, L = le.Uint8Array, P = S ? S.allocUnsafe : void 0, q = Zt(Object.getPrototypeOf, Object), ie = Object.create, Be = Oe.propertyIsEnumerable, Je = kt.splice, He = W ? W.toStringTag : void 0, Qt = function() {
    try {
      var F = NN(Object, "defineProperty");
      return F({}, "", {}), F;
    } catch {
    }
  }(), it = S ? S.isBuffer : void 0, sn = Math.max, Ao = Date.now, Pt = NN(le, "Map"), Ct = NN(Object, "create"), no = function() {
    function F() {
    }
    return function(A) {
      if (!ai(A))
        return {};
      if (ie)
        return ie(A);
      F.prototype = A;
      var re = new F();
      return F.prototype = void 0, re;
    };
  }();
  function wt(F) {
    var A = -1, re = F == null ? 0 : F.length;
    for (this.clear(); ++A < re; ) {
      var me = F[A];
      this.set(me[0], me[1]);
    }
  }
  function xn() {
    this.__data__ = Ct ? Ct(null) : {}, this.size = 0;
  }
  function Ho(F) {
    var A = this.has(F) && delete this.__data__[F];
    return this.size -= A ? 1 : 0, A;
  }
  function Wn(F) {
    var A = this.__data__;
    if (Ct) {
      var re = A[F];
      return re === r ? void 0 : re;
    }
    return Le.call(A, F) ? A[F] : void 0;
  }
  function gn(F) {
    var A = this.__data__;
    return Ct ? A[F] !== void 0 : Le.call(A, F);
  }
  function Xo(F, A) {
    var re = this.__data__;
    return this.size += this.has(F) ? 0 : 1, re[F] = Ct && A === void 0 ? r : A, this;
  }
  wt.prototype.clear = xn, wt.prototype.delete = Ho, wt.prototype.get = Wn, wt.prototype.has = gn, wt.prototype.set = Xo;
  function bt(F) {
    var A = -1, re = F == null ? 0 : F.length;
    for (this.clear(); ++A < re; ) {
      var me = F[A];
      this.set(me[0], me[1]);
    }
  }
  function jn() {
    this.__data__ = [], this.size = 0;
  }
  function _o(F) {
    var A = this.__data__, re = An(A, F);
    if (re < 0)
      return !1;
    var me = A.length - 1;
    return re == me ? A.pop() : Je.call(A, re, 1), --this.size, !0;
  }
  function Dn(F) {
    var A = this.__data__, re = An(A, F);
    return re < 0 ? void 0 : A[re][1];
  }
  function zn(F) {
    return An(this.__data__, F) > -1;
  }
  function el(F, A) {
    var re = this.__data__, me = An(re, F);
    return me < 0 ? (++this.size, re.push([F, A])) : re[me][1] = A, this;
  }
  bt.prototype.clear = jn, bt.prototype.delete = _o, bt.prototype.get = Dn, bt.prototype.has = zn, bt.prototype.set = el;
  function Lt(F) {
    var A = -1, re = F == null ? 0 : F.length;
    for (this.clear(); ++A < re; ) {
      var me = F[A];
      this.set(me[0], me[1]);
    }
  }
  function X() {
    this.size = 0, this.__data__ = {
      hash: new wt(),
      map: new (Pt || bt)(),
      string: new wt()
    };
  }
  function he(F) {
    var A = nl(this, F).delete(F);
    return this.size -= A ? 1 : 0, A;
  }
  function pe(F) {
    return nl(this, F).get(F);
  }
  function we(F) {
    return nl(this, F).has(F);
  }
  function It(F, A) {
    var re = nl(this, F), me = re.size;
    return re.set(F, A), this.size += re.size == me ? 0 : 1, this;
  }
  Lt.prototype.clear = X, Lt.prototype.delete = he, Lt.prototype.get = pe, Lt.prototype.has = we, Lt.prototype.set = It;
  function _e(F) {
    var A = this.__data__ = new bt(F);
    this.size = A.size;
  }
  function qe() {
    this.__data__ = new bt(), this.size = 0;
  }
  function gt(F) {
    var A = this.__data__, re = A.delete(F);
    return this.size = A.size, re;
  }
  function Bn(F) {
    return this.__data__.get(F);
  }
  function Mn(F) {
    return this.__data__.has(F);
  }
  function fn(F, A) {
    var re = this.__data__;
    if (re instanceof bt) {
      var me = re.__data__;
      if (!Pt || me.length < n - 1)
        return me.push([F, A]), this.size = ++re.size, this;
      re = this.__data__ = new Lt(me);
    }
    return re.set(F, A), this.size = re.size, this;
  }
  _e.prototype.clear = qe, _e.prototype.delete = gt, _e.prototype.get = Bn, _e.prototype.has = Mn, _e.prototype.set = fn;
  function lr(F, A) {
    var re = Gc(F), me = !re && Qc(F), $e = !re && !me && Eu(F), Ye = !re && !me && !$e && Fm(F), ht = re || me || $e || Ye, mt = ht ? et(F.length, String) : [], Ot = mt.length;
    for (var br in F)
      (A || Le.call(F, br)) && !(ht && // Safari 9 has enumerable `arguments.length` in strict mode.
      (br == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      $e && (br == "offset" || br == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      Ye && (br == "buffer" || br == "byteLength" || br == "byteOffset") || // Skip index properties.
      jm(br, Ot))) && mt.push(br);
    return mt;
  }
  function Zr(F, A, re) {
    (re !== void 0 && !rl(F[A], re) || re === void 0 && !(A in F)) && wa(F, A, re);
  }
  function ro(F, A, re) {
    var me = F[A];
    (!(Le.call(F, A) && rl(me, re)) || re === void 0 && !(A in F)) && wa(F, A, re);
  }
  function An(F, A) {
    for (var re = F.length; re--; )
      if (rl(F[re][0], A))
        return re;
    return -1;
  }
  function wa(F, A, re) {
    A == "__proto__" && Qt ? Qt(F, A, {
      configurable: !0,
      enumerable: !0,
      value: re,
      writable: !0
    }) : F[A] = re;
  }
  var kc = NR();
  function Ci(F) {
    return F == null ? F === void 0 ? f : R : He && He in Object(F) ? MR(F) : fR(F);
  }
  function Po(F) {
    return Cc(F) && Ci(F) == s;
  }
  function wc(F) {
    if (!ai(F) || Dm(F))
      return !1;
    var A = Su(F) ? v : I;
    return A.test(bu(F));
  }
  function Fc(F) {
    return Cc(F) && ao(F.length) && !!k[Ci(F)];
  }
  function vc(F) {
    if (!ai(F))
      return TR(F);
    var A = zm(F), re = [];
    for (var me in F)
      me == "constructor" && (A || !Le.call(F, me)) || re.push(me);
    return re;
  }
  function io(F, A, re, me, $e) {
    F !== A && kc(A, function(Ye, ht) {
      if ($e || ($e = new _e()), ai(Ye))
        Ic(F, A, ht, re, io, me, $e);
      else {
        var mt = me ? me(pN(F, ht), Ye, ht + "", F, A, $e) : void 0;
        mt === void 0 && (mt = Ye), Zr(F, ht, mt);
      }
    }, Im);
  }
  function Ic(F, A, re, me, $e, Ye, ht) {
    var mt = pN(F, re), Ot = pN(A, re), br = ht.get(Ot);
    if (br) {
      Zr(F, re, br);
      return;
    }
    var kr = Ye ? Ye(mt, Ot, re + "", F, A, ht) : void 0, Ko = kr === void 0;
    if (Ko) {
      var xu = Gc(Ot), yR = !xu && Eu(Ot), iW = !xu && !yR && Fm(Ot);
      kr = Ot, xu || yR || iW ? Gc(mt) ? kr = mt : km(mt) ? kr = dR(mt) : yR ? (Ko = !1, kr = sR(Ot, !0)) : iW ? (Ko = !1, kr = cR(Ot, !0)) : kr = [] : wm(Ot) || Qc(Ot) ? (kr = mt, Qc(mt) ? kr = vm(mt) : (!ai(mt) || Su(mt)) && (kr = Wm(Ot))) : Ko = !1;
    }
    Ko && (ht.set(Ot, kr), $e(kr, Ot, me, Ye, ht), ht.delete(Ot)), Zr(F, re, kr);
  }
  function tl(F, A) {
    return VR(MN(F, A, B), F + "");
  }
  var Oc = Qt ? function(F, A) {
    return Qt(F, "toString", {
      configurable: !0,
      enumerable: !1,
      value: gR(A),
      writable: !0
    });
  } : B;
  function sR(F, A) {
    if (A)
      return F.slice();
    var re = F.length, me = P ? P(re) : new F.constructor(re);
    return F.copy(me), me;
  }
  function lR(F) {
    var A = new F.constructor(F.byteLength);
    return new L(A).set(new L(F)), A;
  }
  function cR(F, A) {
    var re = A ? lR(F.buffer) : F.buffer;
    return new F.constructor(re, F.byteOffset, F.length);
  }
  function dR(F, A) {
    var re = -1, me = F.length;
    for (A || (A = Array(me)); ++re < me; )
      A[re] = F[re];
    return A;
  }
  function uR(F, A, re, me) {
    var $e = !re;
    re || (re = {});
    for (var Ye = -1, ht = A.length; ++Ye < ht; ) {
      var mt = A[Ye], Ot = me ? me(re[mt], F[mt], mt, re, F) : void 0;
      Ot === void 0 && (Ot = F[mt]), $e ? wa(re, mt, Ot) : ro(re, mt, Ot);
    }
    return re;
  }
  function hR(F) {
    return tl(function(A, re) {
      var me = -1, $e = re.length, Ye = $e > 1 ? re[$e - 1] : void 0, ht = $e > 2 ? re[2] : void 0;
      for (Ye = F.length > 3 && typeof Ye == "function" ? ($e--, Ye) : void 0, ht && pR(re[0], re[1], ht) && (Ye = $e < 3 ? void 0 : Ye, $e = 1), A = Object(A); ++me < $e; ) {
        var mt = re[me];
        mt && F(A, mt, me, Ye);
      }
      return A;
    });
  }
  function NR(F) {
    return function(A, re, me) {
      for (var $e = -1, Ye = Object(A), ht = me(A), mt = ht.length; mt--; ) {
        var Ot = ht[F ? mt : ++$e];
        if (re(Ye[Ot], Ot, Ye) === !1)
          break;
      }
      return A;
    };
  }
  function Yc(F, A, re, me, $e, Ye) {
    return ai(F) && ai(A) && (Ye.set(A, F), io(F, A, void 0, Yc, Ye), Ye.delete(A)), F;
  }
  function nl(F, A) {
    var re = F.__data__;
    return mR(A) ? re[typeof A == "string" ? "string" : "hash"] : re.map;
  }
  function NN(F, A) {
    var re = Rn(F, A);
    return wc(re) ? re : void 0;
  }
  function MR(F) {
    var A = Le.call(F, He), re = F[He];
    try {
      F[He] = void 0;
      var me = !0;
    } catch {
    }
    var $e = Dt.call(F);
    return me && (A ? F[He] = re : delete F[He]), $e;
  }
  function Wm(F) {
    return typeof F.constructor == "function" && !zm(F) ? no(q(F)) : {};
  }
  function jm(F, A) {
    var re = typeof F;
    return A = A ?? o, !!A && (re == "number" || re != "symbol" && b.test(F)) && F > -1 && F % 1 == 0 && F < A;
  }
  function pR(F, A, re) {
    if (!ai(re))
      return !1;
    var me = typeof A;
    return (me == "number" ? mN(re) && jm(A, re.length) : me == "string" && A in re) ? rl(re[A], F) : !1;
  }
  function mR(F) {
    var A = typeof F;
    return A == "string" || A == "number" || A == "symbol" || A == "boolean" ? F !== "__proto__" : F === null;
  }
  function Dm(F) {
    return !!dt && dt in F;
  }
  function zm(F) {
    var A = F && F.constructor, re = typeof A == "function" && A.prototype || Oe;
    return F === re;
  }
  function TR(F) {
    var A = [];
    if (F != null)
      for (var re in Object(F))
        A.push(re);
    return A;
  }
  function fR(F) {
    return Dt.call(F);
  }
  function MN(F, A, re) {
    return A = sn(A === void 0 ? F.length - 1 : A, 0), function() {
      for (var me = arguments, $e = -1, Ye = sn(me.length - A, 0), ht = Array(Ye); ++$e < Ye; )
        ht[$e] = me[A + $e];
      $e = -1;
      for (var mt = Array(A + 1); ++$e < A; )
        mt[$e] = me[$e];
      return mt[A] = re(ht), Ce(F, this, mt);
    };
  }
  function pN(F, A) {
    if (!(A === "constructor" && typeof F[A] == "function") && A != "__proto__")
      return F[A];
  }
  var VR = UR(Oc);
  function UR(F) {
    var A = 0, re = 0;
    return function() {
      var me = Ao(), $e = a - (me - re);
      if (re = me, $e > 0) {
        if (++A >= i)
          return arguments[0];
      } else
        A = 0;
      return F.apply(void 0, arguments);
    };
  }
  function bu(F) {
    if (F != null) {
      try {
        return ft.call(F);
      } catch {
      }
      try {
        return F + "";
      } catch {
      }
    }
    return "";
  }
  function rl(F, A) {
    return F === A || F !== F && A !== A;
  }
  var Qc = Po(function() {
    return arguments;
  }()) ? Po : function(F) {
    return Cc(F) && Le.call(F, "callee") && !Be.call(F, "callee");
  }, Gc = Array.isArray;
  function mN(F) {
    return F != null && ao(F.length) && !Su(F);
  }
  function km(F) {
    return Cc(F) && mN(F);
  }
  var Eu = it || $;
  function Su(F) {
    if (!ai(F))
      return !1;
    var A = Ci(F);
    return A == N || A == M || A == c || A == U;
  }
  function ao(F) {
    return typeof F == "number" && F > -1 && F % 1 == 0 && F <= o;
  }
  function ai(F) {
    var A = typeof F;
    return F != null && (A == "object" || A == "function");
  }
  function Cc(F) {
    return F != null && typeof F == "object";
  }
  function wm(F) {
    if (!Cc(F) || Ci(F) != V)
      return !1;
    var A = q(F);
    if (A === null)
      return !0;
    var re = Le.call(A, "constructor") && A.constructor;
    return typeof re == "function" && re instanceof re && ft.call(re) == ut;
  }
  var Fm = se ? at(se) : Fc;
  function vm(F) {
    return uR(F, Im(F));
  }
  var RR = tl(function(F) {
    return F.push(void 0, Yc), Ce(Om, void 0, F);
  });
  function Im(F) {
    return mN(F) ? lr(F, !0) : vc(F);
  }
  var Om = hR(function(F, A, re, me) {
    io(F, A, re, me);
  });
  function gR(F) {
    return function() {
      return F;
    };
  }
  function B(F) {
    return F;
  }
  function $() {
    return !1;
  }
  t.exports = RR;
})(Zf, Zf.exports);
var G6 = Zf.exports;
const IE = /* @__PURE__ */ fc(G6);
function pv(t, e = {}) {
  const { fees: n = t.fees, formatters: r = t.formatters, serializers: i = t.serializers } = e;
  return {
    ...t,
    fees: n,
    formatters: r,
    serializers: i
  };
}
const C6 = "1.19.10", L6 = (t) => t, y2 = (t) => t, J6 = () => `viem@${C6}`;
class xe extends Error {
  constructor(e, n = {}) {
    var a;
    super(), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ViemError"
    }), Object.defineProperty(this, "version", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: J6()
    });
    const r = n.cause instanceof xe ? n.cause.details : (a = n.cause) != null && a.message ? n.cause.message : n.details, i = n.cause instanceof xe && n.cause.docsPath || n.docsPath;
    this.message = [
      e || "An error occurred.",
      "",
      ...n.metaMessages ? [...n.metaMessages, ""] : [],
      ...i ? [
        `Docs: https://viem.sh${i}.html${n.docsSlug ? `#${n.docsSlug}` : ""}`
      ] : [],
      ...r ? [`Details: ${r}`] : [],
      `Version: ${this.version}`
    ].join(`
`), n.cause && (this.cause = n.cause), this.details = r, this.docsPath = i, this.metaMessages = n.metaMessages, this.shortMessage = e;
  }
  walk(e) {
    return mv(this, e);
  }
}
function mv(t, e) {
  return e != null && e(t) ? t : t && typeof t == "object" && "cause" in t ? mv(t.cause, e) : e ? null : t;
}
class B6 extends xe {
  constructor({ max: e, min: n, signed: r, size: i, value: a }) {
    super(`Number "${a}" is not in safe ${i ? `${i * 8}-bit ${r ? "signed" : "unsigned"} ` : ""}integer range ${e ? `(${n} to ${e})` : `(above ${n})`}`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "IntegerOutOfRangeError"
    });
  }
}
class A6 extends xe {
  constructor(e) {
    super(`Hex value "${e}" is not a valid boolean. The hex value must be "0x0" (false) or "0x1" (true).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidHexBooleanError"
    });
  }
}
class H6 extends xe {
  constructor({ givenSize: e, maxSize: n }) {
    super(`Size cannot exceed ${n} bytes. Given size: ${e} bytes.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SizeOverflowError"
    });
  }
}
function Do(t, { strict: e = !0 } = {}) {
  return !t || typeof t != "string" ? !1 : e ? /^0x[0-9a-fA-F]*$/.test(t) : t.startsWith("0x");
}
function Ur(t) {
  return Do(t, { strict: !1 }) ? Math.ceil((t.length - 2) / 2) : t.length;
}
function gd(t, { dir: e = "left" } = {}) {
  let n = typeof t == "string" ? t.replace("0x", "") : t, r = 0;
  for (let i = 0; i < n.length - 1 && n[e === "left" ? i : n.length - i - 1].toString() === "0"; i++)
    r++;
  return n = e === "left" ? n.slice(r) : n.slice(0, n.length - r), typeof t == "string" ? (n.length === 1 && e === "right" && (n = `${n}0`), `0x${n.length % 2 === 1 ? `0${n}` : n}`) : n;
}
class Tv extends xe {
  constructor({ offset: e, position: n, size: r }) {
    super(`Slice ${n === "start" ? "starting" : "ending"} at offset "${e}" is out-of-bounds (size: ${r}).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SliceOffsetOutOfBoundsError"
    });
  }
}
class fv extends xe {
  constructor({ size: e, targetSize: n, type: r }) {
    super(`${r.charAt(0).toUpperCase()}${r.slice(1).toLowerCase()} size (${e}) exceeds padding size (${n}).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SizeExceedsPaddingSizeError"
    });
  }
}
function Bh(t, { dir: e, size: n = 32 } = {}) {
  return typeof t == "string" ? Ol(t, { dir: e, size: n }) : X6(t, { dir: e, size: n });
}
function Ol(t, { dir: e, size: n = 32 } = {}) {
  if (n === null)
    return t;
  const r = t.replace("0x", "");
  if (r.length > n * 2)
    throw new fv({
      size: Math.ceil(r.length / 2),
      targetSize: n,
      type: "hex"
    });
  return `0x${r[e === "right" ? "padEnd" : "padStart"](n * 2, "0")}`;
}
function X6(t, { dir: e, size: n = 32 } = {}) {
  if (n === null)
    return t;
  if (t.length > n)
    throw new fv({
      size: t.length,
      targetSize: n,
      type: "bytes"
    });
  const r = new Uint8Array(n);
  for (let i = 0; i < n; i++) {
    const a = e === "right";
    r[a ? i : n - i - 1] = t[a ? i : t.length - i - 1];
  }
  return r;
}
const _6 = /* @__PURE__ */ Array.from({ length: 256 }, (t, e) => e.toString(16).padStart(2, "0"));
function Bs(t, e = {}) {
  return typeof t == "number" || typeof t == "bigint" ? St(t, e) : typeof t == "string" ? OE(t, e) : typeof t == "boolean" ? Vv(t, e) : w1(t, e);
}
function Vv(t, e = {}) {
  const n = `0x${Number(t)}`;
  return typeof e.size == "number" ? (Vc(n, { size: e.size }), Bh(n, { size: e.size })) : n;
}
function w1(t, e = {}) {
  let n = "";
  for (let i = 0; i < t.length; i++)
    n += _6[t[i]];
  const r = `0x${n}`;
  return typeof e.size == "number" ? (Vc(r, { size: e.size }), Bh(r, { dir: "right", size: e.size })) : r;
}
function St(t, e = {}) {
  const { signed: n, size: r } = e, i = BigInt(t);
  let a;
  r ? n ? a = (1n << BigInt(r) * 8n - 1n) - 1n : a = 2n ** (BigInt(r) * 8n) - 1n : typeof t == "number" && (a = BigInt(Number.MAX_SAFE_INTEGER));
  const o = typeof a == "bigint" && n ? -a - 1n : 0;
  if (a && i > a || i < o) {
    const l = typeof t == "bigint" ? "n" : "";
    throw new B6({
      max: a ? `${a}${l}` : void 0,
      min: `${o}${l}`,
      signed: n,
      size: r,
      value: `${t}${l}`
    });
  }
  const s = `0x${(n && i < 0 ? (1n << BigInt(r * 8)) + BigInt(i) : i).toString(16)}`;
  return r ? Bh(s, { size: r }) : s;
}
const P6 = /* @__PURE__ */ new TextEncoder();
function OE(t, e = {}) {
  const n = P6.encode(t);
  return w1(n, e);
}
const K6 = /* @__PURE__ */ new TextEncoder();
function $l(t, e = {}) {
  return typeof t == "number" || typeof t == "bigint" ? q6(t, e) : typeof t == "boolean" ? $6(t, e) : Do(t) ? YE(t, e) : Zs(t, e);
}
function $6(t, e = {}) {
  const n = new Uint8Array(1);
  return n[0] = Number(t), typeof e.size == "number" ? (Vc(n, { size: e.size }), Bh(n, { size: e.size })) : n;
}
const $o = {
  zero: 48,
  nine: 57,
  A: 65,
  F: 70,
  a: 97,
  f: 102
};
function QW(t) {
  if (t >= $o.zero && t <= $o.nine)
    return t - $o.zero;
  if (t >= $o.A && t <= $o.F)
    return t - ($o.A - 10);
  if (t >= $o.a && t <= $o.f)
    return t - ($o.a - 10);
}
function YE(t, e = {}) {
  let n = t;
  e.size && (Vc(n, { size: e.size }), n = Bh(n, { dir: "right", size: e.size }));
  let r = n.slice(2);
  r.length % 2 && (r = `0${r}`);
  const i = r.length / 2, a = new Uint8Array(i);
  for (let o = 0, s = 0; o < i; o++) {
    const l = QW(r.charCodeAt(s++)), c = QW(r.charCodeAt(s++));
    if (l === void 0 || c === void 0)
      throw new xe(`Invalid byte sequence ("${r[s - 2]}${r[s - 1]}" in "${r}").`);
    a[o] = l * 16 + c;
  }
  return a;
}
function q6(t, e) {
  const n = St(t, e);
  return YE(n);
}
function Zs(t, e = {}) {
  const n = K6.encode(t);
  return typeof e.size == "number" ? (Vc(n, { size: e.size }), Bh(n, { dir: "right", size: e.size })) : n;
}
function Vc(t, { size: e }) {
  if (Ur(t) > e)
    throw new H6({
      givenSize: Ur(t),
      maxSize: e
    });
}
function Z2(t, e = {}) {
  const { signed: n } = e;
  e.size && Vc(t, { size: e.size });
  const r = BigInt(t);
  if (!n)
    return r;
  const i = (t.length - 2) / 2, a = (1n << BigInt(i) * 8n - 1n) - 1n;
  return r <= a ? r : r - BigInt(`0x${"f".padStart(i * 2, "f")}`) - 1n;
}
function eX(t, e = {}) {
  let n = t;
  if (e.size && (Vc(n, { size: e.size }), n = gd(n)), gd(n) === "0x00")
    return !1;
  if (gd(n) === "0x01")
    return !0;
  throw new A6(n);
}
function ei(t, e = {}) {
  return Number(Z2(t, e));
}
function QE(t, e = {}) {
  let n = YE(t);
  return e.size && (Vc(n, { size: e.size }), n = gd(n, { dir: "right" })), new TextDecoder().decode(n);
}
const Uv = {
  "0x0": "legacy",
  "0x1": "eip2930",
  "0x2": "eip1559"
};
function Rv(t) {
  const e = {
    ...t,
    blockHash: t.blockHash ? t.blockHash : null,
    blockNumber: t.blockNumber ? BigInt(t.blockNumber) : null,
    chainId: t.chainId ? ei(t.chainId) : void 0,
    gas: t.gas ? BigInt(t.gas) : void 0,
    gasPrice: t.gasPrice ? BigInt(t.gasPrice) : void 0,
    maxFeePerGas: t.maxFeePerGas ? BigInt(t.maxFeePerGas) : void 0,
    maxPriorityFeePerGas: t.maxPriorityFeePerGas ? BigInt(t.maxPriorityFeePerGas) : void 0,
    nonce: t.nonce ? ei(t.nonce) : void 0,
    to: t.to ? t.to : null,
    transactionIndex: t.transactionIndex ? Number(t.transactionIndex) : null,
    type: t.type ? Uv[t.type] : void 0,
    typeHex: t.type ? t.type : void 0,
    value: t.value ? BigInt(t.value) : void 0,
    v: t.v ? BigInt(t.v) : void 0
  };
  return e.yParity = (() => {
    if (t.yParity)
      return Number(t.yParity);
    if (typeof e.v == "bigint") {
      if (e.v === 0n || e.v === 27n)
        return 0;
      if (e.v === 1n || e.v === 28n)
        return 1;
      if (e.v >= 35n)
        return e.v % 2n === 0n ? 1 : 0;
    }
  })(), e.type === "legacy" && (delete e.accessList, delete e.maxFeePerGas, delete e.maxPriorityFeePerGas, delete e.yParity), e.type === "eip2930" && (delete e.maxFeePerGas, delete e.maxPriorityFeePerGas), e;
}
function gv(t) {
  var n;
  const e = (n = t.transactions) == null ? void 0 : n.map((r) => typeof r == "string" ? r : Rv(r));
  return {
    ...t,
    baseFeePerGas: t.baseFeePerGas ? BigInt(t.baseFeePerGas) : null,
    difficulty: t.difficulty ? BigInt(t.difficulty) : void 0,
    gasLimit: t.gasLimit ? BigInt(t.gasLimit) : void 0,
    gasUsed: t.gasUsed ? BigInt(t.gasUsed) : void 0,
    hash: t.hash ? t.hash : null,
    logsBloom: t.logsBloom ? t.logsBloom : null,
    nonce: t.nonce ? t.nonce : null,
    number: t.number ? BigInt(t.number) : null,
    size: t.size ? BigInt(t.size) : void 0,
    timestamp: t.timestamp ? BigInt(t.timestamp) : void 0,
    transactions: e,
    totalDifficulty: t.totalDifficulty ? BigInt(t.totalDifficulty) : null
  };
}
function Pa(t, { args: e, eventName: n } = {}) {
  return {
    ...t,
    blockHash: t.blockHash ? t.blockHash : null,
    blockNumber: t.blockNumber ? BigInt(t.blockNumber) : null,
    logIndex: t.logIndex ? Number(t.logIndex) : null,
    transactionHash: t.transactionHash ? t.transactionHash : null,
    transactionIndex: t.transactionIndex ? Number(t.transactionIndex) : null,
    ...n ? { args: e, eventName: n } : {}
  };
}
const tX = {
  "0x0": "reverted",
  "0x1": "success"
};
function nX(t) {
  return {
    ...t,
    blockNumber: t.blockNumber ? BigInt(t.blockNumber) : null,
    contractAddress: t.contractAddress ? t.contractAddress : null,
    cumulativeGasUsed: t.cumulativeGasUsed ? BigInt(t.cumulativeGasUsed) : null,
    effectiveGasPrice: t.effectiveGasPrice ? BigInt(t.effectiveGasPrice) : null,
    gasUsed: t.gasUsed ? BigInt(t.gasUsed) : null,
    logs: t.logs ? t.logs.map((e) => Pa(e)) : null,
    to: t.to ? t.to : null,
    transactionIndex: t.transactionIndex ? ei(t.transactionIndex) : null,
    status: t.status ? tX[t.status] : null,
    type: t.type ? Uv[t.type] || t.type : null
  };
}
const rX = {
  legacy: "0x0",
  eip2930: "0x1",
  eip1559: "0x2"
};
function b2(t) {
  return {
    ...t,
    gas: typeof t.gas < "u" ? St(t.gas) : void 0,
    gasPrice: typeof t.gasPrice < "u" ? St(t.gasPrice) : void 0,
    maxFeePerGas: typeof t.maxFeePerGas < "u" ? St(t.maxFeePerGas) : void 0,
    maxPriorityFeePerGas: typeof t.maxPriorityFeePerGas < "u" ? St(t.maxPriorityFeePerGas) : void 0,
    nonce: typeof t.nonce < "u" ? St(t.nonce) : void 0,
    type: typeof t.type < "u" ? rX[t.type] : void 0,
    value: typeof t.value < "u" ? St(t.value) : void 0
  };
}
class F1 extends xe {
  constructor({ address: e }) {
    super(`Address "${e}" is invalid.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidAddressError"
    });
  }
}
class xy extends xe {
  constructor({ blockNumber: e, chain: n, contract: r }) {
    super(`Chain "${n.name}" does not support contract "${r.name}".`, {
      metaMessages: [
        "This could be due to any of the following:",
        ...e && r.blockCreated && r.blockCreated > e ? [
          `- The contract "${r.name}" was not deployed until block ${r.blockCreated} (current block ${e}).`
        ] : [
          `- The chain does not have the contract "${r.name}" configured.`
        ]
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ChainDoesNotSupportContract"
    });
  }
}
let iX = class extends xe {
  constructor({ chain: e, currentChainId: n }) {
    super(`The current chain of the wallet (id: ${n}) does not match the target chain for the transaction (id: ${e.id} – ${e.name}).`, {
      metaMessages: [
        `Current Chain ID:  ${n}`,
        `Expected Chain ID: ${e.id} – ${e.name}`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ChainMismatchError"
    });
  }
};
class aX extends xe {
  constructor() {
    super([
      "No chain was provided to the request.",
      "Please provide a chain with the `chain` argument on the Action, or by supplying a `chain` to WalletClient."
    ].join(`
`)), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ChainNotFoundError"
    });
  }
}
class yv extends xe {
  constructor() {
    super("No chain was provided to the Client."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ClientChainNotConfiguredError"
    });
  }
}
const oX = {
  gwei: 9,
  wei: 18
}, sX = {
  ether: -9,
  wei: 9
}, lX = {
  ether: -18,
  gwei: -9
};
function qi(t, e) {
  let n = t.toString();
  const r = n.startsWith("-");
  r && (n = n.slice(1)), n = n.padStart(e, "0");
  let [i, a] = [
    n.slice(0, n.length - e),
    n.slice(n.length - e)
  ];
  return a = a.replace(/(0+)$/, ""), `${r ? "-" : ""}${i || "0"}${a ? `.${a}` : ""}`;
}
function xi(t, e = "wei") {
  return qi(t, sX[e]);
}
class _u extends xe {
  constructor({ cause: e, message: n } = {}) {
    var i;
    const r = (i = n == null ? void 0 : n.replace("execution reverted: ", "")) == null ? void 0 : i.replace("execution reverted", "");
    super(`Execution reverted ${r ? `with reason: ${r}` : "for an unknown reason"}.`, {
      cause: e
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ExecutionRevertedError"
    });
  }
}
Object.defineProperty(_u, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 3
});
Object.defineProperty(_u, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /execution reverted/
});
class bf extends xe {
  constructor({ cause: e, maxFeePerGas: n } = {}) {
    super(`The fee cap (\`maxFeePerGas\`${n ? ` = ${xi(n)} gwei` : ""}) cannot be higher than the maximum allowed value (2^256-1).`, {
      cause: e
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "FeeCapTooHigh"
    });
  }
}
Object.defineProperty(bf, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max fee per gas higher than 2\^256-1|fee cap higher than 2\^256-1/
});
class Wy extends xe {
  constructor({ cause: e, maxFeePerGas: n } = {}) {
    super(`The fee cap (\`maxFeePerGas\`${n ? ` = ${xi(n)}` : ""} gwei) cannot be lower than the block base fee.`, {
      cause: e
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "FeeCapTooLow"
    });
  }
}
Object.defineProperty(Wy, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max fee per gas less than block base fee|fee cap less than block base fee|transaction is outdated/
});
class jy extends xe {
  constructor({ cause: e, nonce: n } = {}) {
    super(`Nonce provided for the transaction ${n ? `(${n}) ` : ""}is higher than the next one expected.`, { cause: e }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "NonceTooHighError"
    });
  }
}
Object.defineProperty(jy, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce too high/
});
class Dy extends xe {
  constructor({ cause: e, nonce: n } = {}) {
    super([
      `Nonce provided for the transaction ${n ? `(${n}) ` : ""}is lower than the current nonce of the account.`,
      "Try increasing the nonce or find the latest nonce with `getTransactionCount`."
    ].join(`
`), { cause: e }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "NonceTooLowError"
    });
  }
}
Object.defineProperty(Dy, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce too low|transaction already imported|already known/
});
class zy extends xe {
  constructor({ cause: e, nonce: n } = {}) {
    super(`Nonce provided for the transaction ${n ? `(${n}) ` : ""}exceeds the maximum allowed nonce.`, { cause: e }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "NonceMaxValueError"
    });
  }
}
Object.defineProperty(zy, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce has max value/
});
class ky extends xe {
  constructor({ cause: e } = {}) {
    super([
      "The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account."
    ].join(`
`), {
      cause: e,
      metaMessages: [
        "This error could arise when the account does not have enough funds to:",
        " - pay for the total gas fee,",
        " - pay for the value to send.",
        " ",
        "The cost of the transaction is calculated as `gas * gas fee + value`, where:",
        " - `gas` is the amount of gas needed for transaction to execute,",
        " - `gas fee` is the gas fee,",
        " - `value` is the amount of ether to send to the recipient."
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InsufficientFundsError"
    });
  }
}
Object.defineProperty(ky, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /insufficient funds/
});
class wy extends xe {
  constructor({ cause: e, gas: n } = {}) {
    super(`The amount of gas ${n ? `(${n}) ` : ""}provided for the transaction exceeds the limit allowed for the block.`, {
      cause: e
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "IntrinsicGasTooHighError"
    });
  }
}
Object.defineProperty(wy, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /intrinsic gas too high|gas limit reached/
});
class Fy extends xe {
  constructor({ cause: e, gas: n } = {}) {
    super(`The amount of gas ${n ? `(${n}) ` : ""}provided for the transaction is too low.`, {
      cause: e
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "IntrinsicGasTooLowError"
    });
  }
}
Object.defineProperty(Fy, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /intrinsic gas too low/
});
class vy extends xe {
  constructor({ cause: e }) {
    super("The transaction type is not supported for this chain.", {
      cause: e
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "TransactionTypeNotSupportedError"
    });
  }
}
Object.defineProperty(vy, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /transaction type not valid/
});
class Ef extends xe {
  constructor({ cause: e, maxPriorityFeePerGas: n, maxFeePerGas: r } = {}) {
    super([
      `The provided tip (\`maxPriorityFeePerGas\`${n ? ` = ${xi(n)} gwei` : ""}) cannot be higher than the fee cap (\`maxFeePerGas\`${r ? ` = ${xi(r)} gwei` : ""}).`
    ].join(`
`), {
      cause: e
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "TipAboveFeeCapError"
    });
  }
}
Object.defineProperty(Ef, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max priority fee per gas higher than max fee per gas|tip higher than fee cap/
});
class E2 extends xe {
  constructor({ cause: e }) {
    super(`An error occurred while executing: ${e == null ? void 0 : e.shortMessage}`, {
      cause: e
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnknownNodeError"
    });
  }
}
const cX = /^0x[a-fA-F0-9]{40}$/;
function Ni(t) {
  return cX.test(t);
}
function zs(t) {
  return typeof t[0] == "string" ? GE(t) : dX(t);
}
function dX(t) {
  let e = 0;
  for (const i of t)
    e += i.length;
  const n = new Uint8Array(e);
  let r = 0;
  for (const i of t)
    n.set(i, r), r += i.length;
  return n;
}
function GE(t) {
  return `0x${t.reduce((e, n) => e + n.replace("0x", ""), "")}`;
}
function uX(t, e) {
  const n = t.exec(e);
  return n == null ? void 0 : n.groups;
}
const GW = /^tuple(?<array>(\[(\d*)\])*)$/;
function Iy(t) {
  let e = t.type;
  if (GW.test(t.type) && "components" in t) {
    e = "(";
    const n = t.components.length;
    for (let i = 0; i < n; i++) {
      const a = t.components[i];
      e += Iy(a), i < n - 1 && (e += ", ");
    }
    const r = uX(GW, t.type);
    return e += `)${(r == null ? void 0 : r.array) ?? ""}`, Iy({
      ...t,
      type: e
    });
  }
  return "indexed" in t && t.indexed && (e = `${e} indexed`), t.name ? `${e} ${t.name}` : e;
}
function RN(t) {
  let e = "";
  const n = t.length;
  for (let r = 0; r < n; r++) {
    const i = t[r];
    e += Iy(i), r !== n - 1 && (e += ", ");
  }
  return e;
}
function hX(t) {
  return t.type === "function" ? `function ${t.name}(${RN(t.inputs)})${t.stateMutability && t.stateMutability !== "nonpayable" ? ` ${t.stateMutability}` : ""}${t.outputs.length ? ` returns (${RN(t.outputs)})` : ""}` : t.type === "event" ? `event ${t.name}(${RN(t.inputs)})` : t.type === "error" ? `error ${t.name}(${RN(t.inputs)})` : t.type === "constructor" ? `constructor(${RN(t.inputs)})${t.stateMutability === "payable" ? " payable" : ""}` : t.type === "fallback" ? "fallback()" : "receive() external payable";
}
function Tt(t, e, n) {
  return (r) => {
    var i;
    return ((i = t[e.name || n]) == null ? void 0 : i.call(t, r)) ?? e(t, r);
  };
}
function su(t, { includeName: e = !1 } = {}) {
  if (t.type !== "function" && t.type !== "event" && t.type !== "error")
    throw new bX(t.type);
  return `${t.name}(${S2(t.inputs, { includeName: e })})`;
}
function S2(t, { includeName: e = !1 } = {}) {
  return t ? t.map((n) => NX(n, { includeName: e })).join(e ? ", " : ",") : "";
}
function NX(t, { includeName: e }) {
  return t.type.startsWith("tuple") ? `(${S2(t.components, { includeName: e })})${t.type.slice(5)}` : t.type + (e && t.name ? ` ${t.name}` : "");
}
class MX extends xe {
  constructor({ docsPath: e }) {
    super([
      "A constructor was not found on the ABI.",
      "Make sure you are using the correct ABI and that the constructor exists on it."
    ].join(`
`), {
      docsPath: e
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiConstructorNotFoundError"
    });
  }
}
class CW extends xe {
  constructor({ docsPath: e }) {
    super([
      "Constructor arguments were provided (`args`), but a constructor parameters (`inputs`) were not found on the ABI.",
      "Make sure you are using the correct ABI, and that the `inputs` attribute on the constructor exists."
    ].join(`
`), {
      docsPath: e
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiConstructorParamsNotFoundError"
    });
  }
}
class CE extends xe {
  constructor({ data: e, params: n, size: r }) {
    super([`Data size of ${r} bytes is too small for given parameters.`].join(`
`), {
      metaMessages: [
        `Params: (${S2(n, { includeName: !0 })})`,
        `Data:   ${e} (${r} bytes)`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiDecodingDataSizeTooSmallError"
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "params", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "size", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = e, this.params = n, this.size = r;
  }
}
class x2 extends xe {
  constructor() {
    super('Cannot decode zero data ("0x") with ABI parameters.'), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiDecodingZeroDataError"
    });
  }
}
class pX extends xe {
  constructor({ expectedLength: e, givenLength: n, type: r }) {
    super([
      `ABI encoding array length mismatch for type ${r}.`,
      `Expected length: ${e}`,
      `Given length: ${n}`
    ].join(`
`)), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiEncodingArrayLengthMismatchError"
    });
  }
}
class mX extends xe {
  constructor({ expectedSize: e, value: n }) {
    super(`Size of bytes "${n}" (bytes${Ur(n)}) does not match expected size (bytes${e}).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiEncodingBytesSizeMismatchError"
    });
  }
}
class TX extends xe {
  constructor({ expectedLength: e, givenLength: n }) {
    super([
      "ABI encoding params/values length mismatch.",
      `Expected length (params): ${e}`,
      `Given length (values): ${n}`
    ].join(`
`)), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiEncodingLengthMismatchError"
    });
  }
}
class Zv extends xe {
  constructor(e, { docsPath: n }) {
    super([
      `Encoded error signature "${e}" not found on ABI.`,
      "Make sure you are using the correct ABI and that the error exists on it.",
      `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${e}.`
    ].join(`
`), {
      docsPath: n
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiErrorSignatureNotFoundError"
    }), Object.defineProperty(this, "signature", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.signature = e;
  }
}
class fX extends xe {
  constructor({ docsPath: e }) {
    super("Cannot extract event signature from empty topics.", {
      docsPath: e
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiEventSignatureEmptyTopicsError"
    });
  }
}
class VX extends xe {
  constructor(e, { docsPath: n }) {
    super([
      `Encoded event signature "${e}" not found on ABI.`,
      "Make sure you are using the correct ABI and that the event exists on it.",
      `You can look up the signature here: https://openchain.xyz/signatures?query=${e}.`
    ].join(`
`), {
      docsPath: n
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiEventSignatureNotFoundError"
    });
  }
}
class LW extends xe {
  constructor(e, { docsPath: n } = {}) {
    super([
      `Event ${e ? `"${e}" ` : ""}not found on ABI.`,
      "Make sure you are using the correct ABI and that the event exists on it."
    ].join(`
`), {
      docsPath: n
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiEventNotFoundError"
    });
  }
}
class Sf extends xe {
  constructor(e, { docsPath: n } = {}) {
    super([
      `Function ${e ? `"${e}" ` : ""}not found on ABI.`,
      "Make sure you are using the correct ABI and that the function exists on it."
    ].join(`
`), {
      docsPath: n
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiFunctionNotFoundError"
    });
  }
}
class UX extends xe {
  constructor(e, { docsPath: n }) {
    super([
      `Function "${e}" does not contain any \`outputs\` on ABI.`,
      "Cannot decode function result without knowing what the parameter types are.",
      "Make sure you are using the correct ABI and that the function exists on it."
    ].join(`
`), {
      docsPath: n
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiFunctionOutputsNotFoundError"
    });
  }
}
class RX extends xe {
  constructor({ expectedSize: e, givenSize: n }) {
    super(`Expected bytes${e}, got bytes${n}.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BytesSizeMismatchError"
    });
  }
}
class wd extends xe {
  constructor({ abiItem: e, data: n, params: r, size: i }) {
    super([
      `Data size of ${i} bytes is too small for non-indexed event parameters.`
    ].join(`
`), {
      metaMessages: [
        `Params: (${S2(r, { includeName: !0 })})`,
        `Data:   ${n} (${i} bytes)`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "DecodeLogDataMismatch"
    }), Object.defineProperty(this, "abiItem", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "params", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "size", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.abiItem = e, this.data = n, this.params = r, this.size = i;
  }
}
class Ah extends xe {
  constructor({ abiItem: e, param: n }) {
    super([
      `Expected a topic for indexed event parameter${n.name ? ` "${n.name}"` : ""} on event "${su(e, { includeName: !0 })}".`
    ].join(`
`)), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "DecodeLogTopicsMismatch"
    }), Object.defineProperty(this, "abiItem", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.abiItem = e;
  }
}
class gX extends xe {
  constructor(e, { docsPath: n }) {
    super([
      `Type "${e}" is not a valid encoding type.`,
      "Please provide a valid ABI type."
    ].join(`
`), { docsPath: n }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidAbiEncodingType"
    });
  }
}
class yX extends xe {
  constructor(e, { docsPath: n }) {
    super([
      `Type "${e}" is not a valid decoding type.`,
      "Please provide a valid ABI type."
    ].join(`
`), { docsPath: n }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidAbiDecodingType"
    });
  }
}
class ZX extends xe {
  constructor(e) {
    super([`Value "${e}" is not a valid array.`].join(`
`)), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidArrayError"
    });
  }
}
class bX extends xe {
  constructor(e) {
    super([
      `"${e}" is not a valid definition type.`,
      'Valid types: "function", "event", "error"'
    ].join(`
`)), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidDefinitionTypeError"
    });
  }
}
class EX extends xe {
  constructor(e) {
    super(`Filter type "${e}" is not supported.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "FilterTypeNotSupportedError"
    });
  }
}
function SX(t) {
  let e = !0, n = "", r = 0, i = "", a = !1;
  for (let o = 0; o < t.length; o++) {
    const s = t[o];
    if (["(", ")", ","].includes(s) && (e = !0), s === "(" && r++, s === ")" && r--, !!e) {
      if (r === 0) {
        if (s === " " && ["event", "function", ""].includes(i))
          i = "";
        else if (i += s, s === ")") {
          a = !0;
          break;
        }
        continue;
      }
      if (s === " ") {
        t[o - 1] !== "," && n !== "," && n !== ",(" && (n = "", e = !1);
        continue;
      }
      i += s, n += s;
    }
  }
  if (!a)
    throw new xe("Unable to normalize signature.");
  return i;
}
const bv = (t) => {
  const e = (() => typeof t == "string" ? t : hX(t))();
  return SX(e);
}, xX = (t) => bv(t);
function JW(t) {
  if (!Number.isSafeInteger(t) || t < 0)
    throw new Error(`Wrong positive integer: ${t}`);
}
function Ev(t, ...e) {
  if (!(t instanceof Uint8Array))
    throw new Error("Expected Uint8Array");
  if (e.length > 0 && !e.includes(t.length))
    throw new Error(`Expected Uint8Array of length ${e}, not of length=${t.length}`);
}
function BW(t, e = !0) {
  if (t.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (e && t.finished)
    throw new Error("Hash#digest() has already been called");
}
function WX(t, e) {
  Ev(t);
  const n = e.outputLen;
  if (t.length < n)
    throw new Error(`digestInto() expects output buffer of length at least ${n}`);
}
const Xm = /* @__PURE__ */ BigInt(2 ** 32 - 1), AW = /* @__PURE__ */ BigInt(32);
function jX(t, e = !1) {
  return e ? { h: Number(t & Xm), l: Number(t >> AW & Xm) } : { h: Number(t >> AW & Xm) | 0, l: Number(t & Xm) | 0 };
}
function DX(t, e = !1) {
  let n = new Uint32Array(t.length), r = new Uint32Array(t.length);
  for (let i = 0; i < t.length; i++) {
    const { h: a, l: o } = jX(t[i], e);
    [n[i], r[i]] = [a, o];
  }
  return [n, r];
}
const zX = (t, e, n) => t << n | e >>> 32 - n, kX = (t, e, n) => e << n | t >>> 32 - n, wX = (t, e, n) => e << n - 32 | t >>> 64 - n, FX = (t, e, n) => t << n - 32 | e >>> 64 - n;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const vX = (t) => t instanceof Uint8Array, IX = (t) => new Uint32Array(t.buffer, t.byteOffset, Math.floor(t.byteLength / 4)), OX = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!OX)
  throw new Error("Non little-endian hardware is not supported");
function YX(t) {
  if (typeof t != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof t}`);
  return new Uint8Array(new TextEncoder().encode(t));
}
function Sv(t) {
  if (typeof t == "string" && (t = YX(t)), !vX(t))
    throw new Error(`expected Uint8Array, got ${typeof t}`);
  return t;
}
class QX {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function GX(t) {
  const e = (r) => t().update(Sv(r)).digest(), n = t();
  return e.outputLen = n.outputLen, e.blockLen = n.blockLen, e.create = () => t(), e;
}
const [xv, Wv, jv] = [[], [], []], CX = /* @__PURE__ */ BigInt(0), gN = /* @__PURE__ */ BigInt(1), LX = /* @__PURE__ */ BigInt(2), JX = /* @__PURE__ */ BigInt(7), BX = /* @__PURE__ */ BigInt(256), AX = /* @__PURE__ */ BigInt(113);
for (let t = 0, e = gN, n = 1, r = 0; t < 24; t++) {
  [n, r] = [r, (2 * n + 3 * r) % 5], xv.push(2 * (5 * r + n)), Wv.push((t + 1) * (t + 2) / 2 % 64);
  let i = CX;
  for (let a = 0; a < 7; a++)
    e = (e << gN ^ (e >> JX) * AX) % BX, e & LX && (i ^= gN << (gN << /* @__PURE__ */ BigInt(a)) - gN);
  jv.push(i);
}
const [HX, XX] = /* @__PURE__ */ DX(jv, !0), HW = (t, e, n) => n > 32 ? wX(t, e, n) : zX(t, e, n), XW = (t, e, n) => n > 32 ? FX(t, e, n) : kX(t, e, n);
function _X(t, e = 24) {
  const n = new Uint32Array(10);
  for (let r = 24 - e; r < 24; r++) {
    for (let o = 0; o < 10; o++)
      n[o] = t[o] ^ t[o + 10] ^ t[o + 20] ^ t[o + 30] ^ t[o + 40];
    for (let o = 0; o < 10; o += 2) {
      const s = (o + 8) % 10, l = (o + 2) % 10, c = n[l], d = n[l + 1], u = HW(c, d, 1) ^ n[s], h = XW(c, d, 1) ^ n[s + 1];
      for (let N = 0; N < 50; N += 10)
        t[o + N] ^= u, t[o + N + 1] ^= h;
    }
    let i = t[2], a = t[3];
    for (let o = 0; o < 24; o++) {
      const s = Wv[o], l = HW(i, a, s), c = XW(i, a, s), d = xv[o];
      i = t[d], a = t[d + 1], t[d] = l, t[d + 1] = c;
    }
    for (let o = 0; o < 50; o += 10) {
      for (let s = 0; s < 10; s++)
        n[s] = t[o + s];
      for (let s = 0; s < 10; s++)
        t[o + s] ^= ~n[(s + 2) % 10] & n[(s + 4) % 10];
    }
    t[0] ^= HX[r], t[1] ^= XX[r];
  }
  n.fill(0);
}
class LE extends QX {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(e, n, r, i = !1, a = 24) {
    if (super(), this.blockLen = e, this.suffix = n, this.outputLen = r, this.enableXOF = i, this.rounds = a, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, JW(r), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = IX(this.state);
  }
  keccak() {
    _X(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
  }
  update(e) {
    BW(this);
    const { blockLen: n, state: r } = this;
    e = Sv(e);
    const i = e.length;
    for (let a = 0; a < i; ) {
      const o = Math.min(n - this.pos, i - a);
      for (let s = 0; s < o; s++)
        r[this.pos++] ^= e[a++];
      this.pos === n && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: e, suffix: n, pos: r, blockLen: i } = this;
    e[r] ^= n, n & 128 && r === i - 1 && this.keccak(), e[i - 1] ^= 128, this.keccak();
  }
  writeInto(e) {
    BW(this, !1), Ev(e), this.finish();
    const n = this.state, { blockLen: r } = this;
    for (let i = 0, a = e.length; i < a; ) {
      this.posOut >= r && this.keccak();
      const o = Math.min(r - this.posOut, a - i);
      e.set(n.subarray(this.posOut, this.posOut + o), i), this.posOut += o, i += o;
    }
    return e;
  }
  xofInto(e) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(e);
  }
  xof(e) {
    return JW(e), this.xofInto(new Uint8Array(e));
  }
  digestInto(e) {
    if (WX(e, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(e), this.destroy(), e;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(e) {
    const { blockLen: n, suffix: r, outputLen: i, rounds: a, enableXOF: o } = this;
    return e || (e = new LE(n, r, i, o, a)), e.state32.set(this.state32), e.pos = this.pos, e.posOut = this.posOut, e.finished = this.finished, e.rounds = a, e.suffix = r, e.outputLen = i, e.enableXOF = o, e.destroyed = this.destroyed, e;
  }
}
const PX = (t, e, n) => GX(() => new LE(e, t, n)), KX = /* @__PURE__ */ PX(1, 136, 256 / 8);
function ui(t, e) {
  const n = e || "hex", r = KX(Do(t, { strict: !1 }) ? $l(t) : t);
  return n === "bytes" ? r : Bs(r);
}
const $X = (t) => ui($l(t)), JE = (t) => $X(xX(t));
function Nr(t, e, n, { strict: r } = {}) {
  return Do(t, { strict: !1 }) ? e8(t, e, n, {
    strict: r
  }) : qX(t, e, n, {
    strict: r
  });
}
function Dv(t, e) {
  if (typeof e == "number" && e > 0 && e > Ur(t) - 1)
    throw new Tv({
      offset: e,
      position: "start",
      size: Ur(t)
    });
}
function zv(t, e, n) {
  if (typeof e == "number" && typeof n == "number" && Ur(t) !== n - e)
    throw new Tv({
      offset: n,
      position: "end",
      size: Ur(t)
    });
}
function qX(t, e, n, { strict: r } = {}) {
  Dv(t, e);
  const i = t.slice(e, n);
  return r && zv(i, e, n), i;
}
function e8(t, e, n, { strict: r } = {}) {
  Dv(t, e);
  const i = `0x${t.replace("0x", "").slice((e ?? 0) * 2, (n ?? t.length) * 2)}`;
  return r && zv(i, e, n), i;
}
function zp(t, e) {
  if (t.length !== e.length)
    throw new TX({
      expectedLength: t.length,
      givenLength: e.length
    });
  const n = t8({
    params: t,
    values: e
  }), r = AE(n);
  return r.length === 0 ? "0x" : r;
}
function t8({ params: t, values: e }) {
  const n = [];
  for (let r = 0; r < t.length; r++)
    n.push(BE({ param: t[r], value: e[r] }));
  return n;
}
function BE({ param: t, value: e }) {
  const n = W2(t.type);
  if (n) {
    const [r, i] = n;
    return r8(e, { length: r, param: { ...t, type: i } });
  }
  if (t.type === "tuple")
    return l8(e, {
      param: t
    });
  if (t.type === "address")
    return n8(e);
  if (t.type === "bool")
    return a8(e);
  if (t.type.startsWith("uint") || t.type.startsWith("int")) {
    const r = t.type.startsWith("int");
    return o8(e, { signed: r });
  }
  if (t.type.startsWith("bytes"))
    return i8(e, { param: t });
  if (t.type === "string")
    return s8(e);
  throw new gX(t.type, {
    docsPath: "/docs/contract/encodeAbiParameters"
  });
}
function AE(t) {
  let e = 0;
  for (let a = 0; a < t.length; a++) {
    const { dynamic: o, encoded: s } = t[a];
    o ? e += 32 : e += Ur(s);
  }
  const n = [], r = [];
  let i = 0;
  for (let a = 0; a < t.length; a++) {
    const { dynamic: o, encoded: s } = t[a];
    o ? (n.push(St(e + i, { size: 32 })), r.push(s), i += Ur(s)) : n.push(s);
  }
  return zs([...n, ...r]);
}
function n8(t) {
  if (!Ni(t))
    throw new F1({ address: t });
  return { dynamic: !1, encoded: Ol(t.toLowerCase()) };
}
function r8(t, { length: e, param: n }) {
  const r = e === null;
  if (!Array.isArray(t))
    throw new ZX(t);
  if (!r && t.length !== e)
    throw new pX({
      expectedLength: e,
      givenLength: t.length,
      type: `${n.type}[${e}]`
    });
  let i = !1;
  const a = [];
  for (let o = 0; o < t.length; o++) {
    const s = BE({ param: n, value: t[o] });
    s.dynamic && (i = !0), a.push(s);
  }
  if (r || i) {
    const o = AE(a);
    if (r) {
      const s = St(a.length, { size: 32 });
      return {
        dynamic: !0,
        encoded: a.length > 0 ? zs([s, o]) : s
      };
    }
    if (i)
      return { dynamic: !0, encoded: o };
  }
  return {
    dynamic: !1,
    encoded: zs(a.map(({ encoded: o }) => o))
  };
}
function i8(t, { param: e }) {
  const [, n] = e.type.split("bytes"), r = Ur(t);
  if (!n) {
    let i = t;
    return r % 32 !== 0 && (i = Ol(i, {
      dir: "right",
      size: Math.ceil((t.length - 2) / 2 / 32) * 32
    })), {
      dynamic: !0,
      encoded: zs([Ol(St(r, { size: 32 })), i])
    };
  }
  if (r !== parseInt(n))
    throw new mX({
      expectedSize: parseInt(n),
      value: t
    });
  return { dynamic: !1, encoded: Ol(t, { dir: "right" }) };
}
function a8(t) {
  return { dynamic: !1, encoded: Ol(Vv(t)) };
}
function o8(t, { signed: e }) {
  return {
    dynamic: !1,
    encoded: St(t, {
      size: 32,
      signed: e
    })
  };
}
function s8(t) {
  const e = OE(t), n = Math.ceil(Ur(e) / 32), r = [];
  for (let i = 0; i < n; i++)
    r.push(Ol(Nr(e, i * 32, (i + 1) * 32), {
      dir: "right"
    }));
  return {
    dynamic: !0,
    encoded: zs([
      Ol(St(Ur(e), { size: 32 })),
      ...r
    ])
  };
}
function l8(t, { param: e }) {
  let n = !1;
  const r = [];
  for (let i = 0; i < e.components.length; i++) {
    const a = e.components[i], o = Array.isArray(t) ? i : a.name, s = BE({
      param: a,
      value: t[o]
    });
    r.push(s), s.dynamic && (n = !0);
  }
  return {
    dynamic: n,
    encoded: n ? AE(r) : zs(r.map(({ encoded: i }) => i))
  };
}
function W2(t) {
  const e = t.match(/^(.*)\[(\d+)?\]$/);
  return e ? (
    // Return `null` if the array is dynamic.
    [e[2] ? Number(e[2]) : null, e[1]]
  ) : void 0;
}
const c8 = (t) => ui($l(t)), HE = (t) => Nr(c8(bv(t)), 0, 4);
function kp({ abi: t, args: e = [], name: n }) {
  const r = Do(n, { strict: !1 }), i = t.filter((a) => r ? a.type === "function" ? HE(a) === n : a.type === "event" ? JE(a) === n : !1 : "name" in a && a.name === n);
  if (i.length !== 0) {
    if (i.length === 1)
      return i[0];
    for (const a of i) {
      if (!("inputs" in a))
        continue;
      if (!e || e.length === 0) {
        if (!a.inputs || a.inputs.length === 0)
          return a;
        continue;
      }
      if (!a.inputs || a.inputs.length === 0 || a.inputs.length !== e.length)
        continue;
      if (e.every((s, l) => {
        const c = "inputs" in a && a.inputs[l];
        return c ? Oy(s, c) : !1;
      }))
        return a;
    }
    return i[0];
  }
}
function Oy(t, e) {
  const n = typeof t, r = e.type;
  switch (r) {
    case "address":
      return Ni(t);
    case "bool":
      return n === "boolean";
    case "function":
      return n === "string";
    case "string":
      return n === "string";
    default:
      return r === "tuple" && "components" in e ? Object.values(e.components).every((i, a) => Oy(Object.values(t)[a], i)) : /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/.test(r) ? n === "number" || n === "bigint" : /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/.test(r) ? n === "string" || t instanceof Uint8Array : /[a-z]+[1-9]{0,3}(\[[0-9]{0,}\])+$/.test(r) ? Array.isArray(t) && t.every((i) => Oy(i, {
        ...e,
        // Pop off `[]` or `[M]` from end of type
        type: r.replace(/(\[[0-9]{0,}\])$/, "")
      })) : !1;
  }
}
function wp({ abi: t, eventName: e, args: n }) {
  var s;
  let r = t[0];
  if (e && (r = kp({
    abi: t,
    args: n,
    name: e
  }), !r))
    throw new LW(e, {
      docsPath: "/docs/contract/encodeEventTopics"
    });
  if (r.type !== "event")
    throw new LW(void 0, {
      docsPath: "/docs/contract/encodeEventTopics"
    });
  const i = su(r), a = JE(i);
  let o = [];
  if (n && "inputs" in r) {
    const l = (s = r.inputs) == null ? void 0 : s.filter((d) => "indexed" in d && d.indexed), c = Array.isArray(n) ? n : Object.values(n).length > 0 ? (l == null ? void 0 : l.map((d) => n[d.name])) ?? [] : [];
    c.length > 0 && (o = (l == null ? void 0 : l.map((d, u) => Array.isArray(c[u]) ? c[u].map((h, N) => _W({ param: d, value: c[u][N] })) : c[u] ? _W({ param: d, value: c[u] }) : null)) ?? []);
  }
  return [a, ...o];
}
function _W({ param: t, value: e }) {
  if (t.type === "string" || t.type === "bytes")
    return ui($l(e));
  if (t.type === "tuple" || t.type.match(/^(.*)\[(\d+)?\]$/))
    throw new EX(t.type);
  return zp([t], [e]);
}
function j2(t, { method: e }) {
  var r, i;
  const n = {};
  return t.transport.type === "fallback" && ((i = (r = t.transport).onResponse) == null || i.call(r, ({ method: a, response: o, status: s, transport: l }) => {
    s === "success" && e === a && (n[o] = l.request);
  })), (a) => n[a] || t.request;
}
async function kv(t, { address: e, abi: n, args: r, eventName: i, fromBlock: a, strict: o, toBlock: s }) {
  const l = j2(t, {
    method: "eth_newFilter"
  }), c = i ? wp({
    abi: n,
    args: r,
    eventName: i
  }) : void 0, d = await t.request({
    method: "eth_newFilter",
    params: [
      {
        address: e,
        fromBlock: typeof a == "bigint" ? St(a) : a,
        toBlock: typeof s == "bigint" ? St(s) : s,
        topics: c
      }
    ]
  });
  return {
    abi: n,
    args: r,
    eventName: i,
    id: d,
    request: l(d),
    strict: o,
    type: "event"
  };
}
function za(t) {
  return typeof t == "string" ? { address: t, type: "json-rpc" } : t;
}
function Uc({ abi: t, args: e, functionName: n }) {
  let r = t[0];
  if (n && (r = kp({
    abi: t,
    args: e,
    name: n
  }), !r))
    throw new Sf(n, {
      docsPath: "/docs/contract/encodeFunctionData"
    });
  if (r.type !== "function")
    throw new Sf(void 0, {
      docsPath: "/docs/contract/encodeFunctionData"
    });
  const i = su(r), a = HE(i), o = "inputs" in r && r.inputs ? zp(r.inputs, e ?? []) : void 0;
  return GE([a, o ?? "0x"]);
}
const wv = {
  1: "An `assert` condition failed.",
  17: "Arithmic operation resulted in underflow or overflow.",
  18: "Division or modulo by zero (e.g. `5 / 0` or `23 % 0`).",
  33: "Attempted to convert to an invalid type.",
  34: "Attempted to access a storage byte array that is incorrectly encoded.",
  49: "Performed `.pop()` on an empty array",
  50: "Array index is out of bounds.",
  65: "Allocated too much memory or created an array which is too large.",
  81: "Attempted to call a zero-initialized variable of internal function type."
}, d8 = {
  inputs: [
    {
      name: "message",
      type: "string"
    }
  ],
  name: "Error",
  type: "error"
}, u8 = {
  inputs: [
    {
      name: "reason",
      type: "uint256"
    }
  ],
  name: "Panic",
  type: "error"
};
function XE(t, e) {
  const n = e ? `${e}${t.toLowerCase()}` : t.substring(2).toLowerCase(), r = ui(Zs(n), "bytes"), i = (e ? n.substring(`${e}0x`.length) : n).split("");
  for (let a = 0; a < 40; a += 2)
    r[a >> 1] >> 4 >= 8 && i[a] && (i[a] = i[a].toUpperCase()), (r[a >> 1] & 15) >= 8 && i[a + 1] && (i[a + 1] = i[a + 1].toUpperCase());
  return `0x${i.join("")}`;
}
function un(t, e) {
  if (!Ni(t))
    throw new F1({ address: t });
  return XE(t, e);
}
function D2(t, e) {
  if (e === "0x" && t.length > 0)
    throw new x2();
  if (Ur(e) && Ur(e) < 32)
    throw new CE({
      data: e,
      params: t,
      size: Ur(e)
    });
  return h8({
    data: e,
    params: t
  });
}
function h8({ data: t, params: e }) {
  const n = [];
  let r = 0;
  for (let i = 0; i < e.length; i++) {
    if (r >= Ur(t))
      throw new CE({
        data: t,
        params: e,
        size: Ur(t)
      });
    const a = e[i], { consumed: o, value: s } = u0({ data: t, param: a, position: r });
    n.push(s), r += o;
  }
  return n;
}
function u0({ data: t, param: e, position: n }) {
  const r = W2(e.type);
  if (r) {
    const [a, o] = r;
    return M8(t, {
      length: a,
      param: { ...e, type: o },
      position: n
    });
  }
  if (e.type === "tuple")
    return V8(t, { param: e, position: n });
  if (e.type === "string")
    return f8(t, { position: n });
  if (e.type.startsWith("bytes"))
    return m8(t, { param: e, position: n });
  const i = Nr(t, n, n + 32, { strict: !0 });
  if (e.type.startsWith("uint") || e.type.startsWith("int"))
    return T8(i, { param: e });
  if (e.type === "address")
    return N8(i);
  if (e.type === "bool")
    return p8(i);
  throw new yX(e.type, {
    docsPath: "/docs/contract/decodeAbiParameters"
  });
}
function N8(t) {
  return { consumed: 32, value: XE(Nr(t, -20)) };
}
function M8(t, { param: e, length: n, position: r }) {
  if (!n) {
    const o = ei(Nr(t, r, r + 32, { strict: !0 })), s = ei(Nr(t, o, o + 32, { strict: !0 }));
    let l = 0;
    const c = [];
    for (let d = 0; d < s; ++d) {
      const u = u0({
        data: Nr(t, o + 32),
        param: e,
        position: l
      });
      l += u.consumed, c.push(u.value);
    }
    return { value: c, consumed: 32 };
  }
  if (xf(e)) {
    const o = W2(e.type), s = !(o != null && o[0]);
    let l = 0;
    const c = [];
    for (let d = 0; d < n; ++d) {
      const u = ei(Nr(t, r, r + 32, { strict: !0 })), h = u0({
        data: Nr(t, u),
        param: e,
        position: s ? l : d * 32
      });
      l += h.consumed, c.push(h.value);
    }
    return { value: c, consumed: 32 };
  }
  let i = 0;
  const a = [];
  for (let o = 0; o < n; ++o) {
    const s = u0({
      data: t,
      param: e,
      position: r + i
    });
    i += s.consumed, a.push(s.value);
  }
  return { value: a, consumed: i };
}
function p8(t) {
  return { consumed: 32, value: eX(t) };
}
function m8(t, { param: e, position: n }) {
  const [r, i] = e.type.split("bytes");
  if (!i) {
    const o = ei(Nr(t, n, n + 32, { strict: !0 })), s = ei(Nr(t, o, o + 32, { strict: !0 }));
    return s === 0 ? { consumed: 32, value: "0x" } : { consumed: 32, value: Nr(t, o + 32, o + 32 + s, {
      strict: !0
    }) };
  }
  return { consumed: 32, value: Nr(t, n, n + parseInt(i), {
    strict: !0
  }) };
}
function T8(t, { param: e }) {
  const n = e.type.startsWith("int");
  return {
    consumed: 32,
    value: parseInt(e.type.split("int")[1] || "256") > 48 ? Z2(t, { signed: n }) : ei(t, { signed: n })
  };
}
function f8(t, { position: e }) {
  const n = ei(Nr(t, e, e + 32, { strict: !0 })), r = ei(Nr(t, n, n + 32, { strict: !0 }));
  return r === 0 ? { consumed: 32, value: "" } : { consumed: 32, value: QE(gd(Nr(t, n + 32, n + 32 + r, { strict: !0 }))) };
}
function V8(t, { param: e, position: n }) {
  const r = e.components.length === 0 || e.components.some(({ name: o }) => !o), i = r ? [] : {};
  let a = 0;
  if (xf(e)) {
    const o = ei(Nr(t, n, n + 32, { strict: !0 }));
    for (let s = 0; s < e.components.length; ++s) {
      const l = e.components[s], c = u0({
        data: Nr(t, o),
        param: l,
        position: a
      });
      a += c.consumed, i[r ? s : l == null ? void 0 : l.name] = c.value;
    }
    return { consumed: 32, value: i };
  }
  for (let o = 0; o < e.components.length; ++o) {
    const s = e.components[o], l = u0({
      data: t,
      param: s,
      position: n + a
    });
    a += l.consumed, i[r ? o : s == null ? void 0 : s.name] = l.value;
  }
  return { consumed: a, value: i };
}
function xf(t) {
  var r;
  const { type: e } = t;
  if (e === "string" || e === "bytes" || e.endsWith("[]"))
    return !0;
  if (e === "tuple")
    return (r = t.components) == null ? void 0 : r.some(xf);
  const n = W2(t.type);
  return !!(n && xf({ ...t, type: n[1] }));
}
function U8({ abi: t, data: e }) {
  const n = Nr(e, 0, 4);
  if (n === "0x")
    throw new x2();
  const i = [...t || [], d8, u8].find((a) => a.type === "error" && n === HE(su(a)));
  if (!i)
    throw new Zv(n, {
      docsPath: "/docs/contract/decodeErrorResult"
    });
  return {
    abiItem: i,
    args: "inputs" in i && i.inputs && i.inputs.length > 0 ? D2(i.inputs, Nr(e, 4)) : void 0,
    errorName: i.name
  };
}
const Mi = (t, e, n) => JSON.stringify(t, (r, i) => {
  const a = typeof i == "bigint" ? i.toString() : i;
  return typeof e == "function" ? e(r, a) : a;
}, n);
function Fv({ abiItem: t, args: e, includeFunctionName: n = !0, includeName: r = !1 }) {
  if ("name" in t && "inputs" in t && t.inputs)
    return `${n ? t.name : ""}(${t.inputs.map((i, a) => `${r && i.name ? `${i.name}: ` : ""}${typeof e[a] == "object" ? Mi(e[a]) : e[a]}`).join(", ")})`;
}
function _E(t, e = "wei") {
  return qi(t, oX[e]);
}
function Fp(t) {
  const e = Object.entries(t).map(([r, i]) => i === void 0 || i === !1 ? null : [r, i]).filter(Boolean), n = e.reduce((r, [i]) => Math.max(r, i.length), 0);
  return e.map(([r, i]) => `  ${`${r}:`.padEnd(n + 1)}  ${i}`).join(`
`);
}
class R8 extends xe {
  constructor() {
    super([
      "Cannot specify both a `gasPrice` and a `maxFeePerGas`/`maxPriorityFeePerGas`.",
      "Use `maxFeePerGas`/`maxPriorityFeePerGas` for EIP-1559 compatible networks, and `gasPrice` for others."
    ].join(`
`)), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "FeeConflictError"
    });
  }
}
class g8 extends xe {
  constructor({ transaction: e }) {
    super("Cannot infer a transaction type from provided transaction.", {
      metaMessages: [
        "Provided Transaction:",
        "{",
        Fp(e),
        "}",
        "",
        "To infer the type, either provide:",
        "- a `type` to the Transaction, or",
        "- an EIP-1559 Transaction with `maxFeePerGas`, or",
        "- an EIP-2930 Transaction with `gasPrice` & `accessList`, or",
        "- a Legacy Transaction with `gasPrice`"
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidSerializableTransactionError"
    });
  }
}
class y8 extends xe {
  constructor(e, { account: n, docsPath: r, chain: i, data: a, gas: o, gasPrice: s, maxFeePerGas: l, maxPriorityFeePerGas: c, nonce: d, to: u, value: h }) {
    var M;
    const N = Fp({
      chain: i && `${i == null ? void 0 : i.name} (id: ${i == null ? void 0 : i.id})`,
      from: n == null ? void 0 : n.address,
      to: u,
      value: typeof h < "u" && `${_E(h)} ${((M = i == null ? void 0 : i.nativeCurrency) == null ? void 0 : M.symbol) || "ETH"}`,
      data: a,
      gas: o,
      gasPrice: typeof s < "u" && `${xi(s)} gwei`,
      maxFeePerGas: typeof l < "u" && `${xi(l)} gwei`,
      maxPriorityFeePerGas: typeof c < "u" && `${xi(c)} gwei`,
      nonce: d
    });
    super(e.shortMessage, {
      cause: e,
      docsPath: r,
      metaMessages: [
        ...e.metaMessages ? [...e.metaMessages, " "] : [],
        "Request Arguments:",
        N
      ].filter(Boolean)
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "TransactionExecutionError"
    }), this.cause = e;
  }
}
class vv extends xe {
  constructor({ blockHash: e, blockNumber: n, blockTag: r, hash: i, index: a }) {
    let o = "Transaction";
    r && a !== void 0 && (o = `Transaction at block time "${r}" at index "${a}"`), e && a !== void 0 && (o = `Transaction at block hash "${e}" at index "${a}"`), n && a !== void 0 && (o = `Transaction at block number "${n}" at index "${a}"`), i && (o = `Transaction with hash "${i}"`), super(`${o} could not be found.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "TransactionNotFoundError"
    });
  }
}
class Iv extends xe {
  constructor({ hash: e }) {
    super(`Transaction receipt with hash "${e}" could not be found. The Transaction may not be processed on a block yet.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "TransactionReceiptNotFoundError"
    });
  }
}
class Z8 extends xe {
  constructor({ hash: e }) {
    super(`Timed out while waiting for transaction with hash "${e}" to be confirmed.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "WaitForTransactionReceiptTimeoutError"
    });
  }
}
class Ov extends xe {
  constructor(e, { account: n, docsPath: r, chain: i, data: a, gas: o, gasPrice: s, maxFeePerGas: l, maxPriorityFeePerGas: c, nonce: d, to: u, value: h }) {
    var p;
    const N = n ? za(n) : void 0, M = Fp({
      from: N == null ? void 0 : N.address,
      to: u,
      value: typeof h < "u" && `${_E(h)} ${((p = i == null ? void 0 : i.nativeCurrency) == null ? void 0 : p.symbol) || "ETH"}`,
      data: a,
      gas: o,
      gasPrice: typeof s < "u" && `${xi(s)} gwei`,
      maxFeePerGas: typeof l < "u" && `${xi(l)} gwei`,
      maxPriorityFeePerGas: typeof c < "u" && `${xi(c)} gwei`,
      nonce: d
    });
    super(e.shortMessage, {
      cause: e,
      docsPath: r,
      metaMessages: [
        ...e.metaMessages ? [...e.metaMessages, " "] : [],
        "Raw Call Arguments:",
        M
      ].filter(Boolean)
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "CallExecutionError"
    }), this.cause = e;
  }
}
class PE extends xe {
  constructor(e, { abi: n, args: r, contractAddress: i, docsPath: a, functionName: o, sender: s }) {
    const l = kp({ abi: n, args: r, name: o }), c = l ? Fv({
      abiItem: l,
      args: r,
      includeFunctionName: !1,
      includeName: !1
    }) : void 0, d = l ? su(l, { includeName: !0 }) : void 0, u = Fp({
      address: i && L6(i),
      function: d,
      args: c && c !== "()" && `${[...Array((o == null ? void 0 : o.length) ?? 0).keys()].map(() => " ").join("")}${c}`,
      sender: s
    });
    super(e.shortMessage || `An unknown error occurred while executing the contract function "${o}".`, {
      cause: e,
      docsPath: a,
      metaMessages: [
        ...e.metaMessages ? [...e.metaMessages, " "] : [],
        "Contract Call:",
        u
      ].filter(Boolean)
    }), Object.defineProperty(this, "abi", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "args", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "contractAddress", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "formattedArgs", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "functionName", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "sender", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ContractFunctionExecutionError"
    }), this.abi = n, this.args = r, this.cause = e, this.contractAddress = i, this.functionName = o, this.sender = s;
  }
}
class Yy extends xe {
  constructor({ abi: e, data: n, functionName: r, message: i }) {
    let a, o, s, l;
    if (n && n !== "0x")
      try {
        o = U8({ abi: e, data: n });
        const { abiItem: d, errorName: u, args: h } = o;
        if (u === "Error")
          l = h[0];
        else if (u === "Panic") {
          const [N] = h;
          l = wv[N];
        } else {
          const N = d ? su(d, { includeName: !0 }) : void 0, M = d && h ? Fv({
            abiItem: d,
            args: h,
            includeFunctionName: !1,
            includeName: !1
          }) : void 0;
          s = [
            N ? `Error: ${N}` : "",
            M && M !== "()" ? `       ${[...Array((u == null ? void 0 : u.length) ?? 0).keys()].map(() => " ").join("")}${M}` : ""
          ];
        }
      } catch (d) {
        a = d;
      }
    else
      i && (l = i);
    let c;
    a instanceof Zv && (c = a.signature, s = [
      `Unable to decode signature "${c}" as it was not found on the provided ABI.`,
      "Make sure you are using the correct ABI and that the error exists on it.",
      `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${c}.`
    ]), super(l && l !== "execution reverted" || c ? [
      `The contract function "${r}" reverted with the following ${c ? "signature" : "reason"}:`,
      l || c
    ].join(`
`) : `The contract function "${r}" reverted.`, {
      cause: a,
      metaMessages: s
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ContractFunctionRevertedError"
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "reason", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "signature", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = o, this.reason = l, this.signature = c;
  }
}
class b8 extends xe {
  constructor({ functionName: e }) {
    super(`The contract function "${e}" returned no data ("0x").`, {
      metaMessages: [
        "This could be due to any of the following:",
        `  - The contract does not have the function "${e}",`,
        "  - The parameters passed to the contract function may be invalid, or",
        "  - The address is not a contract."
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ContractFunctionZeroDataError"
    });
  }
}
class KE extends xe {
  constructor({ data: e, message: n }) {
    super(n || ""), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 3
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RawContractError"
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = e;
  }
}
class qN extends xe {
  constructor({ body: e, details: n, headers: r, status: i, url: a }) {
    super("HTTP request failed.", {
      details: n,
      metaMessages: [
        i && `Status: ${i}`,
        `URL: ${y2(a)}`,
        e && `Request body: ${Mi(e)}`
      ].filter(Boolean)
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "HttpRequestError"
    }), Object.defineProperty(this, "body", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "headers", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "status", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "url", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.body = e, this.headers = r, this.status = i, this.url = a;
  }
}
class E8 extends xe {
  constructor({ body: e, details: n, url: r }) {
    super("WebSocket request failed.", {
      details: n,
      metaMessages: [`URL: ${y2(r)}`, `Request body: ${Mi(e)}`]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "WebSocketRequestError"
    });
  }
}
class $E extends xe {
  constructor({ body: e, error: n, url: r }) {
    super("RPC Request failed.", {
      cause: n,
      details: n.message,
      metaMessages: [`URL: ${y2(r)}`, `Request body: ${Mi(e)}`]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RpcRequestError"
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.code = n.code;
  }
}
class Qy extends xe {
  constructor({ body: e, url: n }) {
    super("The request took too long to respond.", {
      details: "The request timed out.",
      metaMessages: [`URL: ${y2(n)}`, `Request body: ${Mi(e)}`]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "TimeoutError"
    });
  }
}
const S8 = -1;
class Yi extends xe {
  constructor(e, { code: n, docsPath: r, metaMessages: i, shortMessage: a }) {
    super(a, {
      cause: e,
      docsPath: r,
      metaMessages: i || (e == null ? void 0 : e.metaMessages)
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RpcError"
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = e.name, this.code = e instanceof $E ? e.code : n ?? S8;
  }
}
class Hh extends Yi {
  constructor(e, n) {
    super(e, n), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ProviderRpcError"
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = n.data;
  }
}
class v1 extends Yi {
  constructor(e) {
    super(e, {
      code: v1.code,
      shortMessage: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ParseRpcError"
    });
  }
}
Object.defineProperty(v1, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32700
});
class I1 extends Yi {
  constructor(e) {
    super(e, {
      code: I1.code,
      shortMessage: "JSON is not a valid request object."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidRequestRpcError"
    });
  }
}
Object.defineProperty(I1, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32600
});
class O1 extends Yi {
  constructor(e) {
    super(e, {
      code: O1.code,
      shortMessage: "The method does not exist / is not available."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "MethodNotFoundRpcError"
    });
  }
}
Object.defineProperty(O1, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32601
});
class Y1 extends Yi {
  constructor(e) {
    super(e, {
      code: Y1.code,
      shortMessage: [
        "Invalid parameters were provided to the RPC method.",
        "Double check you have provided the correct parameters."
      ].join(`
`)
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidParamsRpcError"
    });
  }
}
Object.defineProperty(Y1, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32602
});
class K0 extends Yi {
  constructor(e) {
    super(e, {
      code: K0.code,
      shortMessage: "An internal error was received."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InternalRpcError"
    });
  }
}
Object.defineProperty(K0, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32603
});
class Fd extends Yi {
  constructor(e) {
    super(e, {
      code: Fd.code,
      shortMessage: [
        "Missing or invalid parameters.",
        "Double check you have provided the correct parameters."
      ].join(`
`)
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidInputRpcError"
    });
  }
}
Object.defineProperty(Fd, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32e3
});
class Lr extends Yi {
  constructor(e) {
    super(e, {
      code: Lr.code,
      shortMessage: "Requested resource not found."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ResourceNotFoundRpcError"
    });
  }
}
Object.defineProperty(Lr, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32001
});
class ql extends Yi {
  constructor(e) {
    super(e, {
      code: ql.code,
      shortMessage: "Requested resource not available."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ResourceUnavailableRpcError"
    });
  }
}
Object.defineProperty(ql, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32002
});
class Q1 extends Yi {
  constructor(e) {
    super(e, {
      code: Q1.code,
      shortMessage: "Transaction creation failed."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "TransactionRejectedRpcError"
    });
  }
}
Object.defineProperty(Q1, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32003
});
class G1 extends Yi {
  constructor(e) {
    super(e, {
      code: G1.code,
      shortMessage: "Method is not implemented."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "MethodNotSupportedRpcError"
    });
  }
}
Object.defineProperty(G1, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32004
});
class C1 extends Yi {
  constructor(e) {
    super(e, {
      code: C1.code,
      shortMessage: "Request exceeds defined limit."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "LimitExceededRpcError"
    });
  }
}
Object.defineProperty(C1, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32005
});
class L1 extends Yi {
  constructor(e) {
    super(e, {
      code: L1.code,
      shortMessage: "Version of JSON-RPC protocol is not supported."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "JsonRpcVersionUnsupportedError"
    });
  }
}
Object.defineProperty(L1, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32006
});
class Un extends Hh {
  constructor(e) {
    super(e, {
      code: Un.code,
      shortMessage: "User rejected the request."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UserRejectedRequestError"
    });
  }
}
Object.defineProperty(Un, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4001
});
class J1 extends Hh {
  constructor(e) {
    super(e, {
      code: J1.code,
      shortMessage: "The requested method and/or account has not been authorized by the user."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnauthorizedProviderError"
    });
  }
}
Object.defineProperty(J1, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4100
});
class B1 extends Hh {
  constructor(e) {
    super(e, {
      code: B1.code,
      shortMessage: "The Provider does not support the requested method."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnsupportedProviderMethodError"
    });
  }
}
Object.defineProperty(B1, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4200
});
class A1 extends Hh {
  constructor(e) {
    super(e, {
      code: A1.code,
      shortMessage: "The Provider is disconnected from all chains."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ProviderDisconnectedError"
    });
  }
}
Object.defineProperty(A1, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4900
});
class H1 extends Hh {
  constructor(e) {
    super(e, {
      code: H1.code,
      shortMessage: "The Provider is not connected to the requested chain."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ChainDisconnectedError"
    });
  }
}
Object.defineProperty(H1, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4901
});
class ks extends Hh {
  constructor(e) {
    super(e, {
      code: ks.code,
      shortMessage: "An error occurred when attempting to switch chain."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SwitchChainError"
    });
  }
}
Object.defineProperty(ks, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4902
});
class x8 extends Yi {
  constructor(e) {
    super(e, {
      shortMessage: "An unknown RPC error occurred."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnknownRpcError"
    });
  }
}
const W8 = 3;
function X1(t, { abi: e, address: n, args: r, docsPath: i, functionName: a, sender: o }) {
  const { code: s, data: l, message: c, shortMessage: d } = t instanceof KE ? t : t instanceof xe ? t.walk((h) => "data" in h) || t.walk() : {}, u = (() => t instanceof x2 ? new b8({ functionName: a }) : [W8, K0.code].includes(s) && (l || c || d) ? new Yy({
    abi: e,
    data: typeof l == "object" ? l.data : l,
    functionName: a,
    message: d ?? c
  }) : t)();
  return new PE(u, {
    abi: e,
    args: r,
    contractAddress: n,
    docsPath: i,
    functionName: a,
    sender: o
  });
}
class Xh extends xe {
  constructor({ docsPath: e } = {}) {
    super([
      "Could not find an Account to execute with this Action.",
      "Please provide an Account with the `account` argument on the Action, or by supplying an `account` to the WalletClient."
    ].join(`
`), {
      docsPath: e,
      docsSlug: "account"
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AccountNotFoundError"
    });
  }
}
class j8 extends xe {
  constructor(e, { account: n, docsPath: r, chain: i, data: a, gas: o, gasPrice: s, maxFeePerGas: l, maxPriorityFeePerGas: c, nonce: d, to: u, value: h }) {
    var M;
    const N = Fp({
      from: n == null ? void 0 : n.address,
      to: u,
      value: typeof h < "u" && `${_E(h)} ${((M = i == null ? void 0 : i.nativeCurrency) == null ? void 0 : M.symbol) || "ETH"}`,
      data: a,
      gas: o,
      gasPrice: typeof s < "u" && `${xi(s)} gwei`,
      maxFeePerGas: typeof l < "u" && `${xi(l)} gwei`,
      maxPriorityFeePerGas: typeof c < "u" && `${xi(c)} gwei`,
      nonce: d
    });
    super(e.shortMessage, {
      cause: e,
      docsPath: r,
      metaMessages: [
        ...e.metaMessages ? [...e.metaMessages, " "] : [],
        "Estimate Gas Arguments:",
        N
      ].filter(Boolean)
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "EstimateGasExecutionError"
    }), this.cause = e;
  }
}
function qE(t, e) {
  const n = (t.details || "").toLowerCase(), r = t.walk((i) => i.code === _u.code);
  return r instanceof xe ? new _u({
    cause: t,
    message: r.details
  }) : _u.nodeMessage.test(n) ? new _u({
    cause: t,
    message: t.details
  }) : bf.nodeMessage.test(n) ? new bf({
    cause: t,
    maxFeePerGas: e == null ? void 0 : e.maxFeePerGas
  }) : Wy.nodeMessage.test(n) ? new Wy({
    cause: t,
    maxFeePerGas: e == null ? void 0 : e.maxFeePerGas
  }) : jy.nodeMessage.test(n) ? new jy({ cause: t, nonce: e == null ? void 0 : e.nonce }) : Dy.nodeMessage.test(n) ? new Dy({ cause: t, nonce: e == null ? void 0 : e.nonce }) : zy.nodeMessage.test(n) ? new zy({ cause: t, nonce: e == null ? void 0 : e.nonce }) : ky.nodeMessage.test(n) ? new ky({ cause: t }) : wy.nodeMessage.test(n) ? new wy({ cause: t, gas: e == null ? void 0 : e.gas }) : Fy.nodeMessage.test(n) ? new Fy({ cause: t, gas: e == null ? void 0 : e.gas }) : vy.nodeMessage.test(n) ? new vy({ cause: t }) : Ef.nodeMessage.test(n) ? new Ef({
    cause: t,
    maxFeePerGas: e == null ? void 0 : e.maxFeePerGas,
    maxPriorityFeePerGas: e == null ? void 0 : e.maxPriorityFeePerGas
  }) : new E2({
    cause: t
  });
}
function D8(t, { docsPath: e, ...n }) {
  const r = (() => {
    const i = qE(t, n);
    return i instanceof E2 ? t : i;
  })();
  return new j8(r, {
    docsPath: e,
    ...n
  });
}
function e3(t, { format: e }) {
  if (!e)
    return {};
  const n = {};
  function r(a) {
    const o = Object.keys(a);
    for (const s of o)
      s in t && (n[s] = t[s]), a[s] && typeof a[s] == "object" && !Array.isArray(a[s]) && r(a[s]);
  }
  const i = e(t || {});
  return r(i), n;
}
function vp(t) {
  const { account: e, gasPrice: n, maxFeePerGas: r, maxPriorityFeePerGas: i, to: a } = t, o = e ? za(e) : void 0;
  if (o && !Ni(o.address))
    throw new F1({ address: o.address });
  if (a && !Ni(a))
    throw new F1({ address: a });
  if (typeof n < "u" && (typeof r < "u" || typeof i < "u"))
    throw new R8();
  if (r && r > 2n ** 256n - 1n)
    throw new bf({ maxFeePerGas: r });
  if (i && r && i > r)
    throw new Ef({ maxFeePerGas: r, maxPriorityFeePerGas: i });
}
class z8 extends xe {
  constructor() {
    super("`baseFeeMultiplier` must be greater than 1."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BaseFeeScalarError"
    });
  }
}
class t3 extends xe {
  constructor() {
    super("Chain does not support EIP-1559 fees."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "Eip1559FeesNotSupportedError"
    });
  }
}
class k8 extends xe {
  constructor({ maxPriorityFeePerGas: e }) {
    super(`\`maxFeePerGas\` cannot be less than the \`maxPriorityFeePerGas\` (${xi(e)} gwei).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "MaxFeePerGasTooLowError"
    });
  }
}
class Yv extends xe {
  constructor({ blockHash: e, blockNumber: n }) {
    let r = "Block";
    e && (r = `Block at hash "${e}"`), n && (r = `Block at number "${n}"`), super(`${r} could not be found.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BlockNotFoundError"
    });
  }
}
async function ec(t, { blockHash: e, blockNumber: n, blockTag: r, includeTransactions: i } = {}) {
  var d, u, h;
  const a = r ?? "latest", o = i ?? !1, s = n !== void 0 ? St(n) : void 0;
  let l = null;
  if (e ? l = await t.request({
    method: "eth_getBlockByHash",
    params: [e, o]
  }) : l = await t.request({
    method: "eth_getBlockByNumber",
    params: [s || a, o]
  }), !l)
    throw new Yv({ blockHash: e, blockNumber: n });
  return (((h = (u = (d = t.chain) == null ? void 0 : d.formatters) == null ? void 0 : u.block) == null ? void 0 : h.format) || gv)(l);
}
async function n3(t) {
  const e = await t.request({
    method: "eth_gasPrice"
  });
  return BigInt(e);
}
async function w8(t, e) {
  return Qv(t, e);
}
async function Qv(t, e) {
  var a, o, s;
  const { block: n, chain: r = t.chain, request: i } = e || {};
  if (typeof ((a = r == null ? void 0 : r.fees) == null ? void 0 : a.defaultPriorityFee) == "function") {
    const l = n || await Tt(t, ec, "getBlock")({});
    return r.fees.defaultPriorityFee({
      block: l,
      client: t,
      request: i
    });
  }
  if (typeof ((o = r == null ? void 0 : r.fees) == null ? void 0 : o.defaultPriorityFee) < "u")
    return (s = r == null ? void 0 : r.fees) == null ? void 0 : s.defaultPriorityFee;
  try {
    const l = await t.request({
      method: "eth_maxPriorityFeePerGas"
    });
    return Z2(l);
  } catch {
    const [l, c] = await Promise.all([
      n ? Promise.resolve(n) : Tt(t, ec, "getBlock")({}),
      Tt(t, n3, "getGasPrice")({})
    ]);
    if (typeof l.baseFeePerGas != "bigint")
      throw new t3();
    const d = c - l.baseFeePerGas;
    return d < 0n ? 0n : d;
  }
}
async function F8(t, e) {
  return Gy(t, e);
}
async function Gy(t, e) {
  var h, N;
  const { block: n, chain: r = t.chain, request: i, type: a = "eip1559" } = e || {}, o = await (async () => {
    var M, p;
    return typeof ((M = r == null ? void 0 : r.fees) == null ? void 0 : M.baseFeeMultiplier) == "function" ? r.fees.baseFeeMultiplier({
      block: n,
      client: t,
      request: i
    }) : ((p = r == null ? void 0 : r.fees) == null ? void 0 : p.baseFeeMultiplier) ?? 1.2;
  })();
  if (o < 1)
    throw new z8();
  const l = 10 ** (((h = o.toString().split(".")[1]) == null ? void 0 : h.length) ?? 0), c = (M) => M * BigInt(Math.ceil(o * l)) / BigInt(l), d = n || await Tt(t, ec, "getBlock")({});
  if (typeof ((N = r == null ? void 0 : r.fees) == null ? void 0 : N.estimateFeesPerGas) == "function")
    return r.fees.estimateFeesPerGas({
      block: n,
      client: t,
      multiply: c,
      request: i,
      type: a
    });
  if (a === "eip1559") {
    if (typeof d.baseFeePerGas != "bigint")
      throw new t3();
    const M = i != null && i.maxPriorityFeePerGas ? i.maxPriorityFeePerGas : await Qv(t, {
      block: d,
      chain: r,
      request: i
    }), p = c(d.baseFeePerGas);
    return {
      maxFeePerGas: (i == null ? void 0 : i.maxFeePerGas) ?? p + M,
      maxPriorityFeePerGas: M
    };
  }
  return {
    gasPrice: (i == null ? void 0 : i.gasPrice) ?? c(await Tt(t, n3, "getGasPrice")({}))
  };
}
async function Gv(t, { address: e, blockTag: n = "latest", blockNumber: r }) {
  const i = await t.request({
    method: "eth_getTransactionCount",
    params: [e, r ? St(r) : n]
  });
  return ei(i);
}
function v8(t) {
  if (t.type)
    return t.type;
  if (typeof t.maxFeePerGas < "u" || typeof t.maxPriorityFeePerGas < "u")
    return "eip1559";
  if (typeof t.gasPrice < "u")
    return typeof t.accessList < "u" ? "eip2930" : "legacy";
  throw new g8({ transaction: t });
}
async function z2(t, e) {
  const { account: n = t.account, chain: r, gas: i, nonce: a, type: o } = e;
  if (!n)
    throw new Xh();
  const s = za(n), l = await Tt(t, ec, "getBlock")({ blockTag: "latest" }), c = { ...e, from: s.address };
  if (typeof a > "u" && (c.nonce = await Tt(t, Gv, "getTransactionCount")({
    address: s.address,
    blockTag: "pending"
  })), typeof o > "u")
    try {
      c.type = v8(c);
    } catch {
      c.type = typeof l.baseFeePerGas == "bigint" ? "eip1559" : "legacy";
    }
  if (c.type === "eip1559") {
    const { maxFeePerGas: d, maxPriorityFeePerGas: u } = await Gy(t, {
      block: l,
      chain: r,
      request: c
    });
    if (typeof e.maxPriorityFeePerGas > "u" && e.maxFeePerGas && e.maxFeePerGas < u)
      throw new k8({
        maxPriorityFeePerGas: u
      });
    c.maxPriorityFeePerGas = u, c.maxFeePerGas = d;
  } else {
    if (typeof e.maxFeePerGas < "u" || typeof e.maxPriorityFeePerGas < "u")
      throw new t3();
    const { gasPrice: d } = await Gy(t, {
      block: l,
      chain: r,
      request: c,
      type: "legacy"
    });
    c.gasPrice = d;
  }
  return typeof i > "u" && (c.gas = await Tt(t, r3, "estimateGas")({
    ...c,
    account: { address: s.address, type: "json-rpc" }
  })), vp(c), c;
}
async function r3(t, e) {
  var i, a, o;
  const n = e.account ?? t.account;
  if (!n)
    throw new Xh({
      docsPath: "/docs/actions/public/estimateGas"
    });
  const r = za(n);
  try {
    const { accessList: s, blockNumber: l, blockTag: c, data: d, gas: u, gasPrice: h, maxFeePerGas: N, maxPriorityFeePerGas: M, nonce: p, to: m, value: R, ...V } = r.type === "local" ? await z2(t, e) : e, g = (l ? St(l) : void 0) || c;
    vp(e);
    const y = (o = (a = (i = t.chain) == null ? void 0 : i.formatters) == null ? void 0 : a.transactionRequest) == null ? void 0 : o.format, f = (y || b2)({
      // Pick out extra data that might exist on the chain's transaction request type.
      ...e3(V, { format: y }),
      from: r.address,
      accessList: s,
      data: d,
      gas: u,
      gasPrice: h,
      maxFeePerGas: N,
      maxPriorityFeePerGas: M,
      nonce: p,
      to: m,
      value: R
    }), D = await t.request({
      method: "eth_estimateGas",
      params: g ? [f, g] : [f]
    });
    return BigInt(D);
  } catch (s) {
    throw D8(s, {
      ...e,
      account: r,
      chain: t.chain
    });
  }
}
async function I8(t, { abi: e, address: n, args: r, functionName: i, ...a }) {
  const o = Uc({
    abi: e,
    args: r,
    functionName: i
  });
  try {
    return await Tt(t, r3, "estimateGas")({
      data: o,
      to: n,
      ...a
    });
  } catch (s) {
    const l = a.account ? za(a.account) : void 0;
    throw X1(s, {
      abi: e,
      address: n,
      args: r,
      docsPath: "/docs/contract/estimateContractGas",
      functionName: i,
      sender: l == null ? void 0 : l.address
    });
  }
}
const PW = "/docs/contract/decodeEventLog";
function Ip({ abi: t, data: e, strict: n, topics: r }) {
  const i = n ?? !0, [a, ...o] = r;
  if (!a)
    throw new fX({
      docsPath: PW
    });
  const s = t.find((M) => M.type === "event" && a === JE(su(M)));
  if (!(s && "name" in s) || s.type !== "event")
    throw new VX(a, {
      docsPath: PW
    });
  const { name: l, inputs: c } = s, d = c == null ? void 0 : c.some((M) => !("name" in M && M.name));
  let u = d ? [] : {};
  const h = c.filter((M) => "indexed" in M && M.indexed);
  for (let M = 0; M < h.length; M++) {
    const p = h[M], m = o[M];
    if (!m)
      throw new Ah({
        abiItem: s,
        param: p
      });
    u[p.name || M] = O8({ param: p, value: m });
  }
  const N = c.filter((M) => !("indexed" in M && M.indexed));
  if (N.length > 0) {
    if (e && e !== "0x")
      try {
        const M = D2(N, e);
        if (M)
          if (d)
            u = [...u, ...M];
          else
            for (let p = 0; p < N.length; p++)
              u[N[p].name] = M[p];
      } catch (M) {
        if (i)
          throw M instanceof CE ? new wd({
            abiItem: s,
            data: M.data,
            params: M.params,
            size: M.size
          }) : M;
      }
    else if (i)
      throw new wd({
        abiItem: s,
        data: "0x",
        params: N,
        size: 0
      });
  }
  return {
    eventName: l,
    args: Object.values(u).length > 0 ? u : void 0
  };
}
function O8({ param: t, value: e }) {
  return t.type === "string" || t.type === "bytes" || t.type === "tuple" || t.type.match(/^(.*)\[(\d+)?\]$/) ? e : (D2([t], e) || [])[0];
}
async function i3(t, { address: e, blockHash: n, fromBlock: r, toBlock: i, event: a, events: o, args: s, strict: l } = {}) {
  const c = l ?? !1, d = o ?? (a ? [a] : void 0);
  let u = [];
  d && (u = [
    d.flatMap((N) => wp({
      abi: [N],
      eventName: N.name,
      args: s
    }))
  ], a && (u = u[0]));
  let h;
  return n ? h = await t.request({
    method: "eth_getLogs",
    params: [{ address: e, topics: u, blockHash: n }]
  }) : h = await t.request({
    method: "eth_getLogs",
    params: [
      {
        address: e,
        topics: u,
        fromBlock: typeof r == "bigint" ? St(r) : r,
        toBlock: typeof i == "bigint" ? St(i) : i
      }
    ]
  }), h.map((N) => {
    var M;
    try {
      const { eventName: p, args: m } = d ? Ip({
        abi: d,
        data: N.data,
        topics: N.topics,
        strict: c
      }) : { eventName: void 0, args: void 0 };
      return Pa(N, { args: m, eventName: p });
    } catch (p) {
      let m, R;
      if (p instanceof wd || p instanceof Ah) {
        if (c)
          return;
        m = p.abiItem.name, R = (M = p.abiItem.inputs) == null ? void 0 : M.some((V) => !("name" in V && V.name));
      }
      return Pa(N, { args: R ? [] : {}, eventName: m });
    }
  }).filter(Boolean);
}
async function Cv(t, { abi: e, address: n, args: r, blockHash: i, eventName: a, fromBlock: o, toBlock: s, strict: l }) {
  const c = a ? kp({ abi: e, name: a }) : void 0, d = c ? void 0 : e.filter((u) => u.type === "event");
  return Tt(t, i3, "getLogs")({
    address: n,
    args: r,
    blockHash: i,
    event: c,
    events: d,
    fromBlock: o,
    toBlock: s,
    strict: l
  });
}
const kR = "/docs/contract/decodeFunctionResult";
function _h({ abi: t, args: e, functionName: n, data: r }) {
  let i = t[0];
  if (n && (i = kp({
    abi: t,
    args: e,
    name: n
  }), !i))
    throw new Sf(n, { docsPath: kR });
  if (i.type !== "function")
    throw new Sf(void 0, { docsPath: kR });
  if (!i.outputs)
    throw new UX(i.name, { docsPath: kR });
  const a = D2(i.outputs, r);
  if (a && a.length > 1)
    return a;
  if (a && a.length === 1)
    return a[0];
}
const Cy = [
  {
    inputs: [
      {
        components: [
          {
            name: "target",
            type: "address"
          },
          {
            name: "allowFailure",
            type: "bool"
          },
          {
            name: "callData",
            type: "bytes"
          }
        ],
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "aggregate3",
    outputs: [
      {
        components: [
          {
            name: "success",
            type: "bool"
          },
          {
            name: "returnData",
            type: "bytes"
          }
        ],
        name: "returnData",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
], Lv = [
  {
    inputs: [],
    name: "ResolverNotFound",
    type: "error"
  },
  {
    inputs: [],
    name: "ResolverWildcardNotSupported",
    type: "error"
  }
], Jv = [
  ...Lv,
  {
    name: "resolve",
    type: "function",
    stateMutability: "view",
    inputs: [
      { name: "name", type: "bytes" },
      { name: "data", type: "bytes" }
    ],
    outputs: [
      { name: "", type: "bytes" },
      { name: "address", type: "address" }
    ]
  }
], Y8 = [
  ...Lv,
  {
    name: "reverse",
    type: "function",
    stateMutability: "view",
    inputs: [{ type: "bytes", name: "reverseName" }],
    outputs: [
      { type: "string", name: "resolvedName" },
      { type: "address", name: "resolvedAddress" },
      { type: "address", name: "reverseResolver" },
      { type: "address", name: "resolver" }
    ]
  }
], KW = [
  {
    name: "text",
    type: "function",
    stateMutability: "view",
    inputs: [
      { name: "name", type: "bytes32" },
      { name: "key", type: "string" }
    ],
    outputs: [{ name: "", type: "string" }]
  }
], $W = [
  {
    name: "addr",
    type: "function",
    stateMutability: "view",
    inputs: [{ name: "name", type: "bytes32" }],
    outputs: [{ name: "", type: "address" }]
  },
  {
    name: "addr",
    type: "function",
    stateMutability: "view",
    inputs: [
      { name: "name", type: "bytes32" },
      { name: "coinType", type: "uint256" }
    ],
    outputs: [{ name: "", type: "bytes" }]
  }
], Q8 = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_signer",
        type: "address"
      },
      {
        internalType: "bytes32",
        name: "_hash",
        type: "bytes32"
      },
      {
        internalType: "bytes",
        name: "_signature",
        type: "bytes"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  }
], G8 = "0x82ad56cb";
function Ph({ blockNumber: t, chain: e, contract: n }) {
  var i;
  const r = (i = e == null ? void 0 : e.contracts) == null ? void 0 : i[n];
  if (!r)
    throw new xy({
      chain: e,
      contract: { name: n }
    });
  if (t && r.blockCreated && r.blockCreated > t)
    throw new xy({
      blockNumber: t,
      chain: e,
      contract: {
        name: n,
        blockCreated: r.blockCreated
      }
    });
  return r.address;
}
function C8(t, { docsPath: e, ...n }) {
  const r = (() => {
    const i = qE(t, n);
    return i instanceof E2 ? t : i;
  })();
  return new Ov(r, {
    docsPath: e,
    ...n
  });
}
const wR = /* @__PURE__ */ new Map();
function a3({ fn: t, id: e, shouldSplitBatch: n, wait: r = 0, sort: i }) {
  const a = async () => {
    const d = l();
    o();
    const u = d.map(({ args: h }) => h);
    u.length !== 0 && t(u).then((h) => {
      var N;
      i && Array.isArray(h) && h.sort(i);
      for (let M = 0; M < d.length; M++) {
        const { pendingPromise: p } = d[M];
        (N = p.resolve) == null || N.call(p, [h[M], h]);
      }
    }).catch((h) => {
      var N;
      for (let M = 0; M < d.length; M++) {
        const { pendingPromise: p } = d[M];
        (N = p.reject) == null || N.call(p, h);
      }
    });
  }, o = () => wR.delete(e), s = () => l().map(({ args: d }) => d), l = () => wR.get(e) || [], c = (d) => wR.set(e, [...l(), d]);
  return {
    flush: o,
    async schedule(d) {
      const u = {}, h = new Promise((p, m) => {
        u.resolve = p, u.reject = m;
      });
      return (n == null ? void 0 : n([...s(), d])) && a(), l().length > 0 ? (c({ args: d, pendingPromise: u }), h) : (c({ args: d, pendingPromise: u }), setTimeout(a, r), h);
    }
  };
}
async function k2(t, e) {
  var R, V, U, g;
  const { account: n = t.account, batch: r = !!((R = t.batch) != null && R.multicall), blockNumber: i, blockTag: a = "latest", accessList: o, data: s, gas: l, gasPrice: c, maxFeePerGas: d, maxPriorityFeePerGas: u, nonce: h, to: N, value: M, ...p } = e, m = n ? za(n) : void 0;
  try {
    vp(e);
    const x = (i ? St(i) : void 0) || a, f = (g = (U = (V = t.chain) == null ? void 0 : V.formatters) == null ? void 0 : U.transactionRequest) == null ? void 0 : g.format, Y = (f || b2)({
      // Pick out extra data that might exist on the chain's transaction request type.
      ...e3(p, { format: f }),
      from: m == null ? void 0 : m.address,
      accessList: o,
      data: s,
      gas: l,
      gasPrice: c,
      maxFeePerGas: d,
      maxPriorityFeePerGas: u,
      nonce: h,
      to: N,
      value: M
    });
    if (r && L8({ request: Y }))
      try {
        return await J8(t, {
          ...Y,
          blockNumber: i,
          blockTag: a
        });
      } catch (G) {
        if (!(G instanceof yv) && !(G instanceof xy))
          throw G;
      }
    const Q = await t.request({
      method: "eth_call",
      params: x ? [Y, x] : [Y]
    });
    return Q === "0x" ? { data: void 0 } : { data: Q };
  } catch (y) {
    const x = B8(y), { offchainLookup: f, offchainLookupSignature: D } = await import("./ccip-72770d16.js");
    if ((x == null ? void 0 : x.slice(0, 10)) === D && N)
      return { data: await f(t, { data: x, to: N }) };
    throw C8(y, {
      ...e,
      account: m,
      chain: t.chain
    });
  }
}
function L8({ request: t }) {
  const { data: e, to: n, ...r } = t;
  return !(!e || e.startsWith(G8) || !n || Object.values(r).filter((i) => typeof i < "u").length > 0);
}
async function J8(t, e) {
  var p;
  const { batchSize: n = 1024, wait: r = 0 } = typeof ((p = t.batch) == null ? void 0 : p.multicall) == "object" ? t.batch.multicall : {}, { blockNumber: i, blockTag: a = "latest", data: o, multicallAddress: s, to: l } = e;
  let c = s;
  if (!c) {
    if (!t.chain)
      throw new yv();
    c = Ph({
      blockNumber: i,
      chain: t.chain,
      contract: "multicall3"
    });
  }
  const u = (i ? St(i) : void 0) || a, { schedule: h } = a3({
    id: `${t.uid}.${u}`,
    wait: r,
    shouldSplitBatch(m) {
      return m.reduce((V, { data: U }) => V + (U.length - 2), 0) > n * 2;
    },
    fn: async (m) => {
      const R = m.map((g) => ({
        allowFailure: !0,
        callData: g.data,
        target: g.to
      })), V = Uc({
        abi: Cy,
        args: [R],
        functionName: "aggregate3"
      }), U = await t.request({
        method: "eth_call",
        params: [
          {
            data: V,
            to: c
          },
          u
        ]
      });
      return _h({
        abi: Cy,
        args: [R],
        functionName: "aggregate3",
        data: U || "0x"
      });
    }
  }), [{ returnData: N, success: M }] = await h({ data: o, to: l });
  if (!M)
    throw new KE({ data: N });
  return N === "0x" ? { data: void 0 } : { data: N };
}
function B8(t) {
  if (!(t instanceof xe))
    return;
  const e = t.walk();
  return typeof e.data == "object" ? e.data.data : e.data;
}
async function tc(t, { abi: e, address: n, args: r, functionName: i, ...a }) {
  const o = Uc({
    abi: e,
    args: r,
    functionName: i
  });
  try {
    const { data: s } = await Tt(t, k2, "call")({
      data: o,
      to: n,
      ...a
    });
    return _h({
      abi: e,
      args: r,
      functionName: i,
      data: s || "0x"
    });
  } catch (s) {
    throw X1(s, {
      abi: e,
      address: n,
      args: r,
      docsPath: "/docs/contract/readContract",
      functionName: i
    });
  }
}
async function A8(t, { abi: e, address: n, args: r, dataSuffix: i, functionName: a, ...o }) {
  const s = o.account ? za(o.account) : void 0, l = Uc({
    abi: e,
    args: r,
    functionName: a
  });
  try {
    const { data: c } = await Tt(t, k2, "call")({
      batch: !1,
      data: `${l}${i ? i.replace("0x", "") : ""}`,
      to: n,
      ...o
    });
    return {
      result: _h({
        abi: e,
        args: r,
        functionName: a,
        data: c || "0x"
      }),
      request: {
        abi: e,
        address: n,
        args: r,
        dataSuffix: i,
        functionName: a,
        ...o
      }
    };
  } catch (c) {
    throw X1(c, {
      abi: e,
      address: n,
      args: r,
      docsPath: "/docs/contract/simulateContract",
      functionName: a,
      sender: s == null ? void 0 : s.address
    });
  }
}
const FR = /* @__PURE__ */ new Map(), qW = /* @__PURE__ */ new Map();
let H8 = 0;
function Kh(t, e, n) {
  const r = ++H8, i = () => FR.get(t) || [], a = () => {
    const d = i();
    FR.set(t, d.filter((u) => u.id !== r));
  }, o = () => {
    const d = qW.get(t);
    i().length === 1 && d && d(), a();
  }, s = i();
  if (FR.set(t, [
    ...s,
    { id: r, fns: e }
  ]), s && s.length > 0)
    return o;
  const l = {};
  for (const d in e)
    l[d] = (...u) => {
      var N, M;
      const h = i();
      if (h.length !== 0)
        for (const p of h)
          (M = (N = p.fns)[d]) == null || M.call(N, ...u);
    };
  const c = n(l);
  return typeof c == "function" && qW.set(t, c), o;
}
async function Wf(t) {
  return new Promise((e) => setTimeout(e, t));
}
function Op(t, { emitOnBegin: e, initialWaitTime: n, interval: r }) {
  let i = !0;
  const a = () => i = !1;
  return (async () => {
    let s;
    e && (s = await t({ unpoll: a }));
    const l = await (n == null ? void 0 : n(s)) ?? r;
    await Wf(l);
    const c = async () => {
      i && (await t({ unpoll: a }), await Wf(r), c());
    };
    c();
  })(), a;
}
const X8 = /* @__PURE__ */ new Map(), _8 = /* @__PURE__ */ new Map();
function P8(t) {
  const e = (i, a) => ({
    clear: () => a.delete(i),
    get: () => a.get(i),
    set: (o) => a.set(i, o)
  }), n = e(t, X8), r = e(t, _8);
  return {
    clear: () => {
      n.clear(), r.clear();
    },
    promise: n,
    response: r
  };
}
async function K8(t, { cacheKey: e, cacheTime: n = 1 / 0 }) {
  const r = P8(e), i = r.response.get();
  if (i && n > 0 && (/* @__PURE__ */ new Date()).getTime() - i.created.getTime() < n)
    return i.data;
  let a = r.promise.get();
  a || (a = t(), r.promise.set(a));
  try {
    const o = await a;
    return r.response.set({ created: /* @__PURE__ */ new Date(), data: o }), o;
  } finally {
    r.promise.clear();
  }
}
const $8 = (t) => `blockNumber.${t}`;
async function Yp(t, { cacheTime: e = t.cacheTime, maxAge: n } = {}) {
  const r = await K8(() => t.request({
    method: "eth_blockNumber"
  }), { cacheKey: $8(t.uid), cacheTime: n ?? e });
  return BigInt(r);
}
async function w2(t, { filter: e }) {
  const n = "strict" in e && e.strict;
  return (await e.request({
    method: "eth_getFilterChanges",
    params: [e.id]
  })).map((i) => {
    var a;
    if (typeof i == "string")
      return i;
    try {
      const { eventName: o, args: s } = "abi" in e && e.abi ? Ip({
        abi: e.abi,
        data: i.data,
        topics: i.topics,
        strict: n
      }) : { eventName: void 0, args: void 0 };
      return Pa(i, { args: s, eventName: o });
    } catch (o) {
      let s, l;
      if (o instanceof wd || o instanceof Ah) {
        if ("strict" in e && e.strict)
          return;
        s = o.abiItem.name, l = (a = o.abiItem.inputs) == null ? void 0 : a.some((c) => !("name" in c && c.name));
      }
      return Pa(i, { args: l ? [] : {}, eventName: s });
    }
  }).filter(Boolean);
}
async function F2(t, { filter: e }) {
  return e.request({
    method: "eth_uninstallFilter",
    params: [e.id]
  });
}
function q8(t, { abi: e, address: n, args: r, batch: i = !0, eventName: a, onError: o, onLogs: s, poll: l, pollingInterval: c = t.pollingInterval, strict: d }) {
  return (typeof l < "u" ? l : t.transport.type !== "webSocket") ? (() => {
    const M = Mi([
      "watchContractEvent",
      n,
      r,
      i,
      t.uid,
      a,
      c
    ]), p = d ?? !1;
    return Kh(M, { onLogs: s, onError: o }, (m) => {
      let R, V, U = !1;
      const g = Op(async () => {
        var y;
        if (!U) {
          try {
            V = await Tt(t, kv, "createContractEventFilter")({
              abi: e,
              address: n,
              args: r,
              eventName: a,
              strict: p
            });
          } catch {
          }
          U = !0;
          return;
        }
        try {
          let x;
          if (V)
            x = await Tt(t, w2, "getFilterChanges")({ filter: V });
          else {
            const f = await Tt(t, Yp, "getBlockNumber")({});
            R && R !== f ? x = await Tt(t, Cv, "getContractEvents")({
              abi: e,
              address: n,
              args: r,
              eventName: a,
              fromBlock: R + 1n,
              toBlock: f,
              strict: p
            }) : x = [], R = f;
          }
          if (x.length === 0)
            return;
          if (i)
            m.onLogs(x);
          else
            for (const f of x)
              m.onLogs([f]);
        } catch (x) {
          V && x instanceof Fd && (U = !1), (y = m.onError) == null || y.call(m, x);
        }
      }, {
        emitOnBegin: !0,
        interval: c
      });
      return async () => {
        V && await Tt(t, F2, "uninstallFilter")({ filter: V }), g();
      };
    });
  })() : (() => {
    let M = !0, p = () => M = !1;
    return (async () => {
      try {
        const m = a ? wp({
          abi: e,
          eventName: a,
          args: r
        }) : [], { unsubscribe: R } = await t.transport.subscribe({
          params: ["logs", { address: n, topics: m }],
          onData(V) {
            var g;
            if (!M)
              return;
            const U = V.result;
            try {
              const { eventName: y, args: x } = Ip({
                abi: e,
                data: U.data,
                topics: U.topics,
                strict: d
              }), f = Pa(U, {
                args: x,
                eventName: y
              });
              s([f]);
            } catch (y) {
              let x, f;
              if (y instanceof wd || y instanceof Ah) {
                if (d)
                  return;
                x = y.abiItem.name, f = (g = y.abiItem.inputs) == null ? void 0 : g.some((Y) => !("name" in Y && Y.name));
              }
              const D = Pa(U, {
                args: f ? [] : {},
                eventName: x
              });
              s([D]);
            }
          },
          onError(V) {
            o == null || o(V);
          }
        });
        p = R, M || p();
      } catch (m) {
        o == null || o(m);
      }
    })(), p;
  })();
}
function Bv({ chain: t, currentChainId: e }) {
  if (!t)
    throw new aX();
  if (e !== t.id)
    throw new iX({ chain: t, currentChainId: e });
}
function e_(t, { docsPath: e, ...n }) {
  const r = (() => {
    const i = qE(t, n);
    return i instanceof E2 ? t : i;
  })();
  return new y8(r, {
    docsPath: e,
    ...n
  });
}
async function _1(t) {
  const e = await t.request({
    method: "eth_chainId"
  });
  return ei(e);
}
async function o3(t, { serializedTransaction: e }) {
  return t.request({
    method: "eth_sendRawTransaction",
    params: [e]
  });
}
async function s3(t, e) {
  var p, m, R, V;
  const { account: n = t.account, chain: r = t.chain, accessList: i, data: a, gas: o, gasPrice: s, maxFeePerGas: l, maxPriorityFeePerGas: c, nonce: d, to: u, value: h, ...N } = e;
  if (!n)
    throw new Xh({
      docsPath: "/docs/actions/wallet/sendTransaction"
    });
  const M = za(n);
  try {
    vp(e);
    let U;
    if (r !== null && (U = await Tt(t, _1, "getChainId")({}), Bv({
      currentChainId: U,
      chain: r
    })), M.type === "local") {
      const f = await Tt(t, z2, "prepareTransactionRequest")({
        account: M,
        accessList: i,
        chain: r,
        data: a,
        gas: o,
        gasPrice: s,
        maxFeePerGas: l,
        maxPriorityFeePerGas: c,
        nonce: d,
        to: u,
        value: h,
        ...N
      });
      U || (U = await Tt(t, _1, "getChainId")({}));
      const D = (p = r == null ? void 0 : r.serializers) == null ? void 0 : p.transaction, Y = await M.signTransaction({
        ...f,
        chainId: U
      }, { serializer: D });
      return await Tt(t, o3, "sendRawTransaction")({
        serializedTransaction: Y
      });
    }
    const g = (V = (R = (m = t.chain) == null ? void 0 : m.formatters) == null ? void 0 : R.transactionRequest) == null ? void 0 : V.format, x = (g || b2)({
      // Pick out extra data that might exist on the chain's transaction request type.
      ...e3(N, { format: g }),
      accessList: i,
      data: a,
      from: M.address,
      gas: o,
      gasPrice: s,
      maxFeePerGas: l,
      maxPriorityFeePerGas: c,
      nonce: d,
      to: u,
      value: h
    });
    return await t.request({
      method: "eth_sendTransaction",
      params: [x]
    });
  } catch (U) {
    throw e_(U, {
      ...e,
      account: M,
      chain: e.chain || void 0
    });
  }
}
async function t_(t, { abi: e, address: n, args: r, dataSuffix: i, functionName: a, ...o }) {
  const s = Uc({
    abi: e,
    args: r,
    functionName: a
  });
  return await Tt(t, s3, "sendTransaction")({
    data: `${s}${i ? i.replace("0x", "") : ""}`,
    to: n,
    ...o
  });
}
async function n_(t, { chain: e }) {
  const { id: n, name: r, nativeCurrency: i, rpcUrls: a, blockExplorers: o } = e;
  await t.request({
    method: "wallet_addEthereumChain",
    params: [
      {
        chainId: St(n),
        chainName: r,
        nativeCurrency: i,
        rpcUrls: a.default.http,
        blockExplorerUrls: o ? Object.values(o).map(({ url: s }) => s) : void 0
      }
    ]
  });
}
const Ly = 256;
let _m = Ly, Pm;
function r_(t = 11) {
  if (!Pm || _m + t > Ly * 2) {
    Pm = "", _m = 0;
    for (let e = 0; e < Ly; e++)
      Pm += (256 + Math.random() * 256 | 0).toString(16).substring(1);
  }
  return Pm.substring(_m, _m++ + t);
}
function Av(t) {
  const { batch: e, cacheTime: n = t.pollingInterval ?? 4e3, key: r = "base", name: i = "Base Client", pollingInterval: a = 4e3, type: o = "base" } = t, s = t.chain, l = t.account ? za(t.account) : void 0, { config: c, request: d, value: u } = t.transport({
    chain: s,
    pollingInterval: a
  }), h = { ...c, ...u }, N = {
    account: l,
    batch: e,
    cacheTime: n,
    chain: s,
    key: r,
    name: i,
    pollingInterval: a,
    request: d,
    transport: h,
    type: o,
    uid: r_()
  };
  function M(p) {
    return (m) => {
      const R = m(p);
      for (const U in N)
        delete R[U];
      const V = { ...p, ...R };
      return Object.assign(V, { extend: M(V) });
    };
  }
  return Object.assign(N, { extend: M(N) });
}
function Jy(t, { delay: e = 100, retryCount: n = 2, shouldRetry: r = () => !0 } = {}) {
  return new Promise((i, a) => {
    const o = async ({ count: s = 0 } = {}) => {
      const l = async ({ error: c }) => {
        const d = typeof e == "function" ? e({ count: s, error: c }) : e;
        d && await Wf(d), o({ count: s + 1 });
      };
      try {
        const c = await t();
        i(c);
      } catch (c) {
        if (s < n && await r({ count: s, error: c }))
          return l({ error: c });
        a(c);
      }
    };
    o();
  });
}
const Hv = (t) => "code" in t ? t.code !== -1 && t.code !== -32004 && t.code !== -32005 && t.code !== -32042 && t.code !== -32603 : t instanceof qN && t.status ? t.status !== 403 && t.status !== 408 && t.status !== 413 && t.status !== 429 && t.status !== 500 && t.status !== 502 && t.status !== 503 && t.status !== 504 : !1;
function i_(t, { retryDelay: e = 150, retryCount: n = 3 } = {}) {
  return async (r) => Jy(async () => {
    try {
      return await t(r);
    } catch (i) {
      const a = i;
      switch (a.code) {
        case v1.code:
          throw new v1(a);
        case I1.code:
          throw new I1(a);
        case O1.code:
          throw new O1(a);
        case Y1.code:
          throw new Y1(a);
        case K0.code:
          throw new K0(a);
        case Fd.code:
          throw new Fd(a);
        case Lr.code:
          throw new Lr(a);
        case ql.code:
          throw new ql(a);
        case Q1.code:
          throw new Q1(a);
        case G1.code:
          throw new G1(a);
        case C1.code:
          throw new C1(a);
        case L1.code:
          throw new L1(a);
        case Un.code:
          throw new Un(a);
        case J1.code:
          throw new J1(a);
        case B1.code:
          throw new B1(a);
        case A1.code:
          throw new A1(a);
        case H1.code:
          throw new H1(a);
        case ks.code:
          throw new ks(a);
        case 5e3:
          throw new Un(a);
        default:
          throw i instanceof xe ? i : new x8(a);
      }
    }
  }, {
    delay: ({ count: i, error: a }) => {
      var o;
      if (a && a instanceof qN) {
        const s = (o = a == null ? void 0 : a.headers) == null ? void 0 : o.get("Retry-After");
        if (s != null && s.match(/\d/))
          return parseInt(s) * 1e3;
      }
      return ~~(1 << i) * e;
    },
    retryCount: n,
    shouldRetry: ({ error: i }) => !Hv(i)
  });
}
function v2({ key: t, name: e, request: n, retryCount: r = 3, retryDelay: i = 150, timeout: a, type: o }, s) {
  return {
    config: { key: t, name: e, request: n, retryCount: r, retryDelay: i, timeout: a, type: o },
    request: i_(n, { retryCount: r, retryDelay: i }),
    value: s
  };
}
function l3(t, e = {}) {
  const { key: n = "custom", name: r = "Custom Provider", retryDelay: i } = e;
  return ({ retryCount: a }) => v2({
    key: n,
    name: r,
    request: t.request.bind(t),
    retryCount: e.retryCount ?? a,
    retryDelay: i,
    type: "custom"
  });
}
function jf(t, e = {}) {
  const { key: n = "fallback", name: r = "Fallback", rank: i = !1, retryCount: a, retryDelay: o } = e;
  return ({ chain: s, pollingInterval: l = 4e3, timeout: c }) => {
    let d = t, u = () => {
    };
    const h = v2({
      key: n,
      name: r,
      async request({ method: N, params: M }) {
        const p = async (m = 0) => {
          const R = d[m]({ chain: s, retryCount: 0, timeout: c });
          try {
            const V = await R.request({
              method: N,
              params: M
            });
            return u({
              method: N,
              params: M,
              response: V,
              transport: R,
              status: "success"
            }), V;
          } catch (V) {
            if (u({
              error: V,
              method: N,
              params: M,
              transport: R,
              status: "error"
            }), Hv(V) || m === d.length - 1)
              throw V;
            return p(m + 1);
          }
        };
        return p();
      },
      retryCount: a,
      retryDelay: o,
      type: "fallback"
    }, {
      onResponse: (N) => u = N,
      transports: d.map((N) => N({ chain: s, retryCount: 0 }))
    });
    if (i) {
      const N = typeof i == "object" ? i : {};
      a_({
        chain: s,
        interval: N.interval ?? l,
        onTransports: (M) => d = M,
        sampleCount: N.sampleCount,
        timeout: N.timeout,
        transports: d,
        weights: N.weights
      });
    }
    return h;
  };
}
function a_({ chain: t, interval: e = 4e3, onTransports: n, sampleCount: r = 10, timeout: i = 1e3, transports: a, weights: o = {} }) {
  const { stability: s = 0.7, latency: l = 0.3 } = o, c = [], d = async () => {
    const u = await Promise.all(a.map(async (M) => {
      const p = M({ chain: t, retryCount: 0, timeout: i }), m = Date.now();
      let R, V;
      try {
        await p.request({ method: "net_listening" }), V = 1;
      } catch {
        V = 0;
      } finally {
        R = Date.now();
      }
      return { latency: R - m, success: V };
    }));
    c.push(u), c.length > r && c.shift();
    const h = Math.max(...c.map((M) => Math.max(...M.map(({ latency: p }) => p)))), N = a.map((M, p) => {
      const m = c.map((y) => y[p].latency), V = 1 - m.reduce((y, x) => y + x, 0) / m.length / h, U = c.map((y) => y[p].success), g = U.reduce((y, x) => y + x, 0) / U.length;
      return g === 0 ? [0, p] : [
        l * V + s * g,
        p
      ];
    }).sort((M, p) => p[0] - M[0]);
    n(N.map(([, M]) => a[M])), await Wf(e), d();
  };
  d();
}
class Xv extends xe {
  constructor() {
    super("No URL was provided to the Transport. Please provide a valid RPC URL to the Transport.", {
      docsPath: "/docs/clients/intro"
    });
  }
}
function o_() {
  if (typeof WebSocket < "u")
    return WebSocket;
  if (typeof $i.WebSocket < "u")
    return $i.WebSocket;
  if (typeof window.WebSocket < "u")
    return window.WebSocket;
  if (typeof self.WebSocket < "u")
    return self.WebSocket;
  throw new Error("`WebSocket` is not supported in this environment");
}
const ej = o_();
function _v(t, { errorInstance: e = new Error("timed out"), timeout: n, signal: r }) {
  return new Promise((i, a) => {
    (async () => {
      let o;
      try {
        const s = new AbortController();
        n > 0 && (o = setTimeout(() => {
          r ? s.abort() : a(e);
        }, n)), i(await t({ signal: s == null ? void 0 : s.signal }));
      } catch (s) {
        s.name === "AbortError" && a(e), a(s);
      } finally {
        clearTimeout(o);
      }
    })();
  });
}
let By = 0;
async function s_(t, { body: e, fetchOptions: n = {}, timeout: r = 1e4 }) {
  var s;
  const { headers: i, method: a, signal: o } = n;
  try {
    const l = await _v(async ({ signal: d }) => await fetch(t, {
      ...n,
      body: Array.isArray(e) ? Mi(e.map((h) => ({
        jsonrpc: "2.0",
        id: h.id ?? By++,
        ...h
      }))) : Mi({ jsonrpc: "2.0", id: e.id ?? By++, ...e }),
      headers: {
        ...i,
        "Content-Type": "application/json"
      },
      method: a || "POST",
      signal: o || (r > 0 ? d : void 0)
    }), {
      errorInstance: new Qy({ body: e, url: t }),
      timeout: r,
      signal: !0
    });
    let c;
    if ((s = l.headers.get("Content-Type")) != null && s.startsWith("application/json") ? c = await l.json() : c = await l.text(), !l.ok)
      throw new qN({
        body: e,
        details: Mi(c.error) || l.statusText,
        headers: l.headers,
        status: l.status,
        url: t
      });
    return c;
  } catch (l) {
    throw l instanceof qN || l instanceof Qy ? l : new qN({
      body: e,
      details: l.message,
      url: t
    });
  }
}
const vR = /* @__PURE__ */ new Map();
async function IR(t) {
  let e = vR.get(t);
  if (e)
    return e;
  const { schedule: n } = a3({
    id: t,
    fn: async () => {
      const a = new ej(t), o = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), l = ({ data: d }) => {
        const u = JSON.parse(d), h = u.method === "eth_subscription", N = h ? u.params.subscription : u.id, M = h ? s : o, p = M.get(N);
        p && p({ data: d }), h || M.delete(N);
      }, c = () => {
        vR.delete(t), a.removeEventListener("close", c), a.removeEventListener("message", l);
      };
      return a.addEventListener("close", c), a.addEventListener("message", l), a.readyState === ej.CONNECTING && await new Promise((d, u) => {
        a && (a.onopen = d, a.onerror = u);
      }), e = Object.assign(a, {
        requests: o,
        subscriptions: s
      }), vR.set(t, e), [e];
    }
  }), [r, [i]] = await n();
  return i;
}
function l_(t, { body: e, onResponse: n }) {
  if (t.readyState === t.CLOSED || t.readyState === t.CLOSING)
    throw new E8({
      body: e,
      url: t.url,
      details: "Socket is closed."
    });
  const r = By++, i = ({ data: a }) => {
    var s;
    const o = JSON.parse(a);
    typeof o.id == "number" && r !== o.id || (n == null || n(o), e.method === "eth_subscribe" && typeof o.result == "string" && t.subscriptions.set(o.result, i), e.method === "eth_unsubscribe" && t.subscriptions.delete((s = e.params) == null ? void 0 : s[0]));
  };
  return t.requests.set(r, i), t.send(JSON.stringify({ jsonrpc: "2.0", ...e, id: r })), t;
}
async function c_(t, { body: e, timeout: n = 1e4 }) {
  return _v(() => new Promise((r) => h0.webSocket(t, {
    body: e,
    onResponse: r
  })), {
    errorInstance: new Qy({ body: e, url: t.url }),
    timeout: n
  });
}
const h0 = {
  http: s_,
  webSocket: l_,
  webSocketAsync: c_
};
function Qp(t, e = {}) {
  const { batch: n, fetchOptions: r, key: i = "http", name: a = "HTTP JSON-RPC", retryDelay: o } = e;
  return ({ chain: s, retryCount: l, timeout: c }) => {
    const { batchSize: d = 1e3, wait: u = 0 } = typeof n == "object" ? n : {}, h = e.retryCount ?? l, N = c ?? e.timeout ?? 1e4, M = t || (s == null ? void 0 : s.rpcUrls.default.http[0]);
    if (!M)
      throw new Xv();
    return v2({
      key: i,
      name: a,
      async request({ method: p, params: m }) {
        const R = { method: p, params: m }, { schedule: V } = a3({
          id: `${t}`,
          wait: u,
          shouldSplitBatch(x) {
            return x.length > d;
          },
          fn: (x) => h0.http(M, {
            body: x,
            fetchOptions: r,
            timeout: N
          }),
          sort: (x, f) => x.id - f.id
        }), U = async (x) => n ? V(x) : [await h0.http(M, { body: x, fetchOptions: r, timeout: N })], [{ error: g, result: y }] = await U(R);
        if (g)
          throw new $E({
            body: R,
            error: g,
            url: M
          });
        return y;
      },
      retryCount: h,
      retryDelay: o,
      timeout: N,
      type: "http"
    }, {
      fetchOptions: r,
      url: t
    });
  };
}
function c3(t, e) {
  var r, i, a;
  if (!(t instanceof xe))
    return !1;
  const n = t.walk((o) => o instanceof Yy);
  return n instanceof Yy ? !!(((r = n.data) == null ? void 0 : r.errorName) === "ResolverNotFound" || ((i = n.data) == null ? void 0 : i.errorName) === "ResolverWildcardNotSupported" || (a = n.reason) != null && a.includes("Wildcard on non-extended resolvers is not supported") || e === "reverse" && n.reason === wv[50]) : !1;
}
function Pv(t) {
  if (t.length !== 66 || t.indexOf("[") !== 0 || t.indexOf("]") !== 65)
    return null;
  const e = `0x${t.slice(1, 65)}`;
  return Do(e) ? e : null;
}
function kT(t) {
  let e = new Uint8Array(32).fill(0);
  if (!t)
    return w1(e);
  const n = t.split(".");
  for (let r = n.length - 1; r >= 0; r -= 1) {
    const i = Pv(n[r]), a = i ? $l(i) : ui(Zs(n[r]), "bytes");
    e = ui(zs([e, a]), "bytes");
  }
  return w1(e);
}
function d_(t) {
  return `[${t.slice(2)}]`;
}
function u_(t) {
  const e = new Uint8Array(32).fill(0);
  return t ? Pv(t) || ui(Zs(t)) : w1(e);
}
function I2(t) {
  const e = t.replace(/^\.|\.$/gm, "");
  if (e.length === 0)
    return new Uint8Array(1);
  const n = new Uint8Array(Zs(e).byteLength + 2);
  let r = 0;
  const i = e.split(".");
  for (let a = 0; a < i.length; a++) {
    let o = Zs(i[a]);
    o.byteLength > 255 && (o = Zs(d_(u_(i[a])))), n[r] = o.length, n.set(o, r + 1), r += o.length + 1;
  }
  return n.byteLength !== r + 1 ? n.slice(0, r + 1) : n;
}
async function h_(t, { blockNumber: e, blockTag: n, coinType: r, name: i, universalResolverAddress: a }) {
  let o = a;
  if (!o) {
    if (!t.chain)
      throw new Error("client chain not configured. universalResolverAddress is required.");
    o = Ph({
      blockNumber: e,
      chain: t.chain,
      contract: "ensUniversalResolver"
    });
  }
  try {
    const s = Uc({
      abi: $W,
      functionName: "addr",
      ...r != null ? { args: [kT(i), BigInt(r)] } : { args: [kT(i)] }
    }), l = await Tt(t, tc, "readContract")({
      address: o,
      abi: Jv,
      functionName: "resolve",
      args: [Bs(I2(i)), s],
      blockNumber: e,
      blockTag: n
    });
    if (l[0] === "0x")
      return null;
    const c = _h({
      abi: $W,
      args: r != null ? [kT(i), BigInt(r)] : void 0,
      functionName: "addr",
      data: l[0]
    });
    return c === "0x" || gd(c) === "0x00" ? null : c;
  } catch (s) {
    if (c3(s, "resolve"))
      return null;
    throw s;
  }
}
class N_ extends xe {
  constructor({ data: e }) {
    super("Unable to extract image from metadata. The metadata may be malformed or invalid.", {
      metaMessages: [
        "- Metadata must be a JSON object with at least an `image`, `image_url` or `image_data` property.",
        "",
        `Provided data: ${JSON.stringify(e)}`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "EnsAvatarInvalidMetadataError"
    });
  }
}
class yN extends xe {
  constructor({ reason: e }) {
    super(`ENS NFT avatar URI is invalid. ${e}`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "EnsAvatarInvalidNftUriError"
    });
  }
}
class d3 extends xe {
  constructor({ uri: e }) {
    super(`Unable to resolve ENS avatar URI "${e}". The URI may be malformed, invalid, or does not respond with a valid image.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "EnsAvatarUriResolutionError"
    });
  }
}
class M_ extends xe {
  constructor({ namespace: e }) {
    super(`ENS NFT avatar namespace "${e}" is not supported. Must be "erc721" or "erc1155".`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "EnsAvatarUnsupportedNamespaceError"
    });
  }
}
const p_ = /(?<protocol>https?:\/\/[^\/]*|ipfs:\/|ipns:\/|ar:\/)?(?<root>\/)?(?<subpath>ipfs\/|ipns\/)?(?<target>[\w\-.]+)(?<subtarget>\/.*)?/, m_ = /^(Qm[1-9A-HJ-NP-Za-km-z]{44,}|b[A-Za-z2-7]{58,}|B[A-Z2-7]{58,}|z[1-9A-HJ-NP-Za-km-z]{48,}|F[0-9A-F]{50,})(\/(?<target>[\w\-.]+))?(?<subtarget>\/.*)?$/, T_ = /^data:([a-zA-Z\-/+]*);base64,([^"].*)/, f_ = /^data:([a-zA-Z\-/+]*)?(;[a-zA-Z0-9].*?)?(,)/;
async function V_(t) {
  try {
    const e = await fetch(t, { method: "HEAD" });
    if (e.status === 200) {
      const n = e.headers.get("content-type");
      return n == null ? void 0 : n.startsWith("image/");
    }
    return !1;
  } catch (e) {
    return typeof e == "object" && typeof e.response < "u" || !globalThis.hasOwnProperty("Image") ? !1 : new Promise((n) => {
      const r = new Image();
      r.onload = () => {
        n(!0);
      }, r.onerror = () => {
        n(!1);
      }, r.src = t;
    });
  }
}
function tj(t, e) {
  return t ? t.endsWith("/") ? t.slice(0, -1) : t : e;
}
function Kv({ uri: t, gatewayUrls: e }) {
  const n = T_.test(t);
  if (n)
    return { uri: t, isOnChain: !0, isEncoded: n };
  const r = tj(e == null ? void 0 : e.ipfs, "https://ipfs.io"), i = tj(e == null ? void 0 : e.arweave, "https://arweave.net"), a = t.match(p_), { protocol: o, subpath: s, target: l, subtarget: c = "" } = (a == null ? void 0 : a.groups) || {}, d = o === "ipns:/" || s === "ipns/", u = o === "ipfs:/" || s === "ipfs/" || m_.test(t);
  if (t.startsWith("http") && !d && !u) {
    let N = t;
    return e != null && e.arweave && (N = t.replace(/https:\/\/arweave.net/g, e == null ? void 0 : e.arweave)), { uri: N, isOnChain: !1, isEncoded: !1 };
  }
  if ((d || u) && l)
    return {
      uri: `${r}/${d ? "ipns" : "ipfs"}/${l}${c}`,
      isOnChain: !1,
      isEncoded: !1
    };
  if (o === "ar:/" && l)
    return {
      uri: `${i}/${l}${c || ""}`,
      isOnChain: !1,
      isEncoded: !1
    };
  let h = t.replace(f_, "");
  if (h.startsWith("<svg") && (h = `data:image/svg+xml;base64,${btoa(h)}`), h.startsWith("data:") || h.startsWith("{"))
    return {
      uri: h,
      isOnChain: !0,
      isEncoded: !1
    };
  throw new d3({ uri: t });
}
function $v(t) {
  if (typeof t != "object" || !("image" in t) && !("image_url" in t) && !("image_data" in t))
    throw new N_({ data: t });
  return t.image || t.image_url || t.image_data;
}
async function U_({ gatewayUrls: t, uri: e }) {
  try {
    const n = await fetch(e).then((i) => i.json());
    return await u3({
      gatewayUrls: t,
      uri: $v(n)
    });
  } catch {
    throw new d3({ uri: e });
  }
}
async function u3({ gatewayUrls: t, uri: e }) {
  const { uri: n, isOnChain: r } = Kv({ uri: e, gatewayUrls: t });
  if (r || await V_(n))
    return n;
  throw new d3({ uri: e });
}
function R_(t) {
  let e = t;
  e.startsWith("did:nft:") && (e = e.replace("did:nft:", "").replace(/_/g, "/"));
  const [n, r, i] = e.split("/"), [a, o] = n.split(":"), [s, l] = r.split(":");
  if (!a || a.toLowerCase() !== "eip155")
    throw new yN({ reason: "Only EIP-155 supported" });
  if (!o)
    throw new yN({ reason: "Chain ID not found" });
  if (!l)
    throw new yN({
      reason: "Contract address not found"
    });
  if (!i)
    throw new yN({ reason: "Token ID not found" });
  if (!s)
    throw new yN({ reason: "ERC namespace not found" });
  return {
    chainID: parseInt(o),
    namespace: s.toLowerCase(),
    contractAddress: l,
    tokenID: i
  };
}
async function g_(t, { nft: e }) {
  if (e.namespace === "erc721")
    return tc(t, {
      address: e.contractAddress,
      abi: [
        {
          name: "tokenURI",
          type: "function",
          stateMutability: "view",
          inputs: [{ name: "tokenId", type: "uint256" }],
          outputs: [{ name: "", type: "string" }]
        }
      ],
      functionName: "tokenURI",
      args: [BigInt(e.tokenID)]
    });
  if (e.namespace === "erc1155")
    return tc(t, {
      address: e.contractAddress,
      abi: [
        {
          name: "uri",
          type: "function",
          stateMutability: "view",
          inputs: [{ name: "_id", type: "uint256" }],
          outputs: [{ name: "", type: "string" }]
        }
      ],
      functionName: "uri",
      args: [BigInt(e.tokenID)]
    });
  throw new M_({ namespace: e.namespace });
}
async function y_(t, { gatewayUrls: e, record: n }) {
  return /eip155:/i.test(n) ? Z_(t, { gatewayUrls: e, record: n }) : u3({ uri: n, gatewayUrls: e });
}
async function Z_(t, { gatewayUrls: e, record: n }) {
  const r = R_(n), i = await g_(t, { nft: r }), { uri: a, isOnChain: o, isEncoded: s } = Kv({ uri: i, gatewayUrls: e });
  if (o && (a.includes("data:application/json;base64,") || a.startsWith("{"))) {
    const c = s ? (
      // if it is encoded, decode it
      atob(a.replace("data:application/json;base64,", ""))
    ) : (
      // if it isn't encoded assume it is a JSON string, but it could be anything (it will error if it is)
      a
    ), d = JSON.parse(c);
    return u3({ uri: $v(d), gatewayUrls: e });
  }
  let l = r.tokenID;
  return r.namespace === "erc1155" && (l = l.replace("0x", "").padStart(64, "0")), U_({
    gatewayUrls: e,
    uri: a.replace(/(?:0x)?{id}/, l)
  });
}
async function qv(t, { blockNumber: e, blockTag: n, name: r, key: i, universalResolverAddress: a }) {
  let o = a;
  if (!o) {
    if (!t.chain)
      throw new Error("client chain not configured. universalResolverAddress is required.");
    o = Ph({
      blockNumber: e,
      chain: t.chain,
      contract: "ensUniversalResolver"
    });
  }
  try {
    const s = await Tt(t, tc, "readContract")({
      address: o,
      abi: Jv,
      functionName: "resolve",
      args: [
        Bs(I2(r)),
        Uc({
          abi: KW,
          functionName: "text",
          args: [kT(r), i]
        })
      ],
      blockNumber: e,
      blockTag: n
    });
    if (s[0] === "0x")
      return null;
    const l = _h({
      abi: KW,
      functionName: "text",
      data: s[0]
    });
    return l === "" ? null : l;
  } catch (s) {
    if (c3(s, "resolve"))
      return null;
    throw s;
  }
}
async function b_(t, { blockNumber: e, blockTag: n, gatewayUrls: r, name: i, universalResolverAddress: a }) {
  const o = await Tt(t, qv, "getEnsText")({
    blockNumber: e,
    blockTag: n,
    key: "avatar",
    name: i,
    universalResolverAddress: a
  });
  if (!o)
    return null;
  try {
    return await y_(t, { record: o, gatewayUrls: r });
  } catch {
    return null;
  }
}
async function E_(t, { address: e, blockNumber: n, blockTag: r, universalResolverAddress: i }) {
  let a = i;
  if (!a) {
    if (!t.chain)
      throw new Error("client chain not configured. universalResolverAddress is required.");
    a = Ph({
      blockNumber: n,
      chain: t.chain,
      contract: "ensUniversalResolver"
    });
  }
  const o = `${e.toLowerCase().substring(2)}.addr.reverse`;
  try {
    return (await Tt(t, tc, "readContract")({
      address: a,
      abi: Y8,
      functionName: "reverse",
      args: [Bs(I2(o))],
      blockNumber: n,
      blockTag: r
    }))[0];
  } catch (s) {
    if (c3(s, "reverse"))
      return null;
    throw s;
  }
}
async function S_(t, { blockNumber: e, blockTag: n, name: r, universalResolverAddress: i }) {
  let a = i;
  if (!a) {
    if (!t.chain)
      throw new Error("client chain not configured. universalResolverAddress is required.");
    a = Ph({
      blockNumber: e,
      chain: t.chain,
      contract: "ensUniversalResolver"
    });
  }
  const [o] = await Tt(t, tc, "readContract")({
    address: a,
    abi: [
      {
        inputs: [{ type: "bytes" }],
        name: "findResolver",
        outputs: [{ type: "address" }, { type: "bytes32" }],
        stateMutability: "view",
        type: "function"
      }
    ],
    functionName: "findResolver",
    args: [Bs(I2(r))],
    blockNumber: e,
    blockTag: n
  });
  return o;
}
async function x_(t) {
  const e = j2(t, {
    method: "eth_newBlockFilter"
  }), n = await t.request({
    method: "eth_newBlockFilter"
  });
  return { id: n, request: e(n), type: "block" };
}
async function eI(t, { address: e, args: n, event: r, events: i, fromBlock: a, strict: o, toBlock: s } = {}) {
  const l = i ?? (r ? [r] : void 0), c = j2(t, {
    method: "eth_newFilter"
  });
  let d = [];
  l && (d = [
    l.flatMap((h) => wp({
      abi: [h],
      eventName: h.name,
      args: n
    }))
  ], r && (d = d[0]));
  const u = await t.request({
    method: "eth_newFilter",
    params: [
      {
        address: e,
        fromBlock: typeof a == "bigint" ? St(a) : a,
        toBlock: typeof s == "bigint" ? St(s) : s,
        ...d.length ? { topics: d } : {}
      }
    ]
  });
  return {
    abi: l,
    args: n,
    eventName: r ? r.name : void 0,
    fromBlock: a,
    id: u,
    request: c(u),
    strict: o,
    toBlock: s,
    type: "event"
  };
}
async function tI(t) {
  const e = j2(t, {
    method: "eth_newPendingTransactionFilter"
  }), n = await t.request({
    method: "eth_newPendingTransactionFilter"
  });
  return { id: n, request: e(n), type: "transaction" };
}
async function W_(t, { address: e, blockNumber: n, blockTag: r = "latest" }) {
  const i = n ? St(n) : void 0, a = await t.request({
    method: "eth_getBalance",
    params: [e, i || r]
  });
  return BigInt(a);
}
async function j_(t, { blockHash: e, blockNumber: n, blockTag: r = "latest" } = {}) {
  const i = n !== void 0 ? St(n) : void 0;
  let a;
  return e ? a = await t.request({
    method: "eth_getBlockTransactionCountByHash",
    params: [e]
  }) : a = await t.request({
    method: "eth_getBlockTransactionCountByNumber",
    params: [i || r]
  }), ei(a);
}
async function D_(t, { address: e, blockNumber: n, blockTag: r = "latest" }) {
  const i = n !== void 0 ? St(n) : void 0, a = await t.request({
    method: "eth_getCode",
    params: [e, i || r]
  });
  if (a !== "0x")
    return a;
}
function z_(t) {
  var e;
  return {
    baseFeePerGas: t.baseFeePerGas.map((n) => BigInt(n)),
    gasUsedRatio: t.gasUsedRatio,
    oldestBlock: BigInt(t.oldestBlock),
    reward: (e = t.reward) == null ? void 0 : e.map((n) => n.map((r) => BigInt(r)))
  };
}
async function k_(t, { blockCount: e, blockNumber: n, blockTag: r = "latest", rewardPercentiles: i }) {
  const a = n ? St(n) : void 0, o = await t.request({
    method: "eth_feeHistory",
    params: [
      St(e),
      a || r,
      i
    ]
  });
  return z_(o);
}
async function w_(t, { filter: e }) {
  const n = e.strict ?? !1;
  return (await e.request({
    method: "eth_getFilterLogs",
    params: [e.id]
  })).map((i) => {
    var a;
    try {
      const { eventName: o, args: s } = "abi" in e && e.abi ? Ip({
        abi: e.abi,
        data: i.data,
        topics: i.topics,
        strict: n
      }) : { eventName: void 0, args: void 0 };
      return Pa(i, { args: s, eventName: o });
    } catch (o) {
      let s, l;
      if (o instanceof wd || o instanceof Ah) {
        if ("strict" in e && e.strict)
          return;
        s = o.abiItem.name, l = (a = o.abiItem.inputs) == null ? void 0 : a.some((c) => !("name" in c && c.name));
      }
      return Pa(i, { args: l ? [] : {}, eventName: s });
    }
  }).filter(Boolean);
}
const F_ = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/, v_ = /^(u?int)(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;
function I_({ domain: t, message: e, primaryType: n, types: r }) {
  const i = typeof t > "u" ? {} : t, a = {
    EIP712Domain: sI({ domain: i }),
    ...r
  };
  oI({
    domain: i,
    message: e,
    primaryType: n,
    types: a
  });
  const o = ["0x1901"];
  return i && o.push(O_({
    domain: i,
    types: a
  })), n !== "EIP712Domain" && o.push(nI({
    data: e,
    primaryType: n,
    types: a
  })), ui(zs(o));
}
function O_({ domain: t, types: e }) {
  return nI({
    data: t,
    primaryType: "EIP712Domain",
    types: e
  });
}
function nI({ data: t, primaryType: e, types: n }) {
  const r = rI({
    data: t,
    primaryType: e,
    types: n
  });
  return ui(r);
}
function rI({ data: t, primaryType: e, types: n }) {
  const r = [{ type: "bytes32" }], i = [Y_({ primaryType: e, types: n })];
  for (const a of n[e]) {
    const [o, s] = aI({
      types: n,
      name: a.name,
      type: a.type,
      value: t[a.name]
    });
    r.push(o), i.push(s);
  }
  return zp(r, i);
}
function Y_({ primaryType: t, types: e }) {
  const n = Bs(Q_({ primaryType: t, types: e }));
  return ui(n);
}
function Q_({ primaryType: t, types: e }) {
  let n = "";
  const r = iI({ primaryType: t, types: e });
  r.delete(t);
  const i = [t, ...Array.from(r).sort()];
  for (const a of i)
    n += `${a}(${e[a].map(({ name: o, type: s }) => `${s} ${o}`).join(",")})`;
  return n;
}
function iI({ primaryType: t, types: e }, n = /* @__PURE__ */ new Set()) {
  const r = t.match(/^\w*/u), i = r == null ? void 0 : r[0];
  if (n.has(i) || e[i] === void 0)
    return n;
  n.add(i);
  for (const a of e[i])
    iI({ primaryType: a.type, types: e }, n);
  return n;
}
function aI({ types: t, name: e, type: n, value: r }) {
  if (t[n] !== void 0)
    return [
      { type: "bytes32" },
      ui(rI({ data: r, primaryType: n, types: t }))
    ];
  if (n === "bytes")
    return r = `0x${(r.length % 2 ? "0" : "") + r.slice(2)}`, [{ type: "bytes32" }, ui(r)];
  if (n === "string")
    return [{ type: "bytes32" }, ui(Bs(r))];
  if (n.lastIndexOf("]") === n.length - 1) {
    const i = n.slice(0, n.lastIndexOf("[")), a = r.map((o) => aI({
      name: e,
      type: i,
      types: t,
      value: o
    }));
    return [
      { type: "bytes32" },
      ui(zp(a.map(([o]) => o), a.map(([, o]) => o)))
    ];
  }
  return [{ type: n }, r];
}
function oI({ domain: t, message: e, primaryType: n, types: r }) {
  const i = r, a = (o, s) => {
    for (const l of o) {
      const { name: c, type: d } = l, u = d, h = s[c], N = u.match(v_);
      if (N && (typeof h == "number" || typeof h == "bigint")) {
        const [m, R, V] = N;
        St(h, {
          signed: R === "int",
          size: parseInt(V) / 8
        });
      }
      if (u === "address" && typeof h == "string" && !Ni(h))
        throw new F1({ address: h });
      const M = u.match(F_);
      if (M) {
        const [m, R] = M;
        if (R && Ur(h) !== parseInt(R))
          throw new RX({
            expectedSize: parseInt(R),
            givenSize: Ur(h)
          });
      }
      const p = i[u];
      p && a(p, h);
    }
  };
  if (i.EIP712Domain && t && a(i.EIP712Domain, t), n !== "EIP712Domain") {
    const o = i[n];
    a(o, e);
  }
}
function sI({ domain: t }) {
  return [
    typeof (t == null ? void 0 : t.name) == "string" && { name: "name", type: "string" },
    (t == null ? void 0 : t.version) && { name: "version", type: "string" },
    typeof (t == null ? void 0 : t.chainId) == "number" && {
      name: "chainId",
      type: "uint256"
    },
    (t == null ? void 0 : t.verifyingContract) && {
      name: "verifyingContract",
      type: "address"
    },
    (t == null ? void 0 : t.salt) && { name: "salt", type: "bytes32" }
  ].filter(Boolean);
}
const OR = "/docs/contract/encodeDeployData";
function lI({ abi: t, args: e, bytecode: n }) {
  if (!e || e.length === 0)
    return n;
  const r = t.find((a) => "type" in a && a.type === "constructor");
  if (!r)
    throw new MX({ docsPath: OR });
  if (!("inputs" in r))
    throw new CW({ docsPath: OR });
  if (!r.inputs || r.inputs.length === 0)
    throw new CW({ docsPath: OR });
  const i = zp(r.inputs, e);
  return GE([n, i]);
}
const G_ = `Ethereum Signed Message:
`;
function C_(t, e) {
  const n = (() => typeof t == "string" ? Zs(t) : t.raw instanceof Uint8Array ? t.raw : $l(t.raw))(), r = Zs(`${G_}${n.length}`);
  return ui(zs([r, n]), e);
}
function L_(t) {
  return t.map((e) => ({
    ...e,
    value: BigInt(e.value)
  }));
}
function J_(t) {
  return {
    ...t,
    balance: t.balance ? BigInt(t.balance) : void 0,
    nonce: t.nonce ? ei(t.nonce) : void 0,
    storageProof: t.storageProof ? L_(t.storageProof) : void 0
  };
}
async function B_(t, { address: e, blockNumber: n, blockTag: r, storageKeys: i }) {
  const a = r ?? "latest", o = n !== void 0 ? St(n) : void 0, s = await t.request({
    method: "eth_getProof",
    params: [e, i, o || a]
  });
  return J_(s);
}
async function A_(t, { address: e, blockNumber: n, blockTag: r = "latest", slot: i }) {
  const a = n !== void 0 ? St(n) : void 0;
  return await t.request({
    method: "eth_getStorageAt",
    params: [e, i, a || r]
  });
}
async function h3(t, { blockHash: e, blockNumber: n, blockTag: r, hash: i, index: a }) {
  var d, u, h;
  const o = r || "latest", s = n !== void 0 ? St(n) : void 0;
  let l = null;
  if (i ? l = await t.request({
    method: "eth_getTransactionByHash",
    params: [i]
  }) : e ? l = await t.request({
    method: "eth_getTransactionByBlockHashAndIndex",
    params: [e, St(a)]
  }) : (s || o) && (l = await t.request({
    method: "eth_getTransactionByBlockNumberAndIndex",
    params: [s || o, St(a)]
  })), !l)
    throw new vv({
      blockHash: e,
      blockNumber: n,
      blockTag: o,
      hash: i,
      index: a
    });
  return (((h = (u = (d = t.chain) == null ? void 0 : d.formatters) == null ? void 0 : u.transaction) == null ? void 0 : h.format) || Rv)(l);
}
async function H_(t, { hash: e, transactionReceipt: n }) {
  const [r, i] = await Promise.all([
    Tt(t, Yp, "getBlockNumber")({}),
    e ? Tt(t, h3, "getBlockNumber")({ hash: e }) : void 0
  ]), a = (n == null ? void 0 : n.blockNumber) || (i == null ? void 0 : i.blockNumber);
  return a ? r - a + 1n : 0n;
}
async function Ay(t, { hash: e }) {
  var i, a, o;
  const n = await t.request({
    method: "eth_getTransactionReceipt",
    params: [e]
  });
  if (!n)
    throw new Iv({ hash: e });
  return (((o = (a = (i = t.chain) == null ? void 0 : i.formatters) == null ? void 0 : a.transactionReceipt) == null ? void 0 : o.format) || nX)(n);
}
async function X_(t, e) {
  var p;
  const { allowFailure: n = !0, batchSize: r, blockNumber: i, blockTag: a, contracts: o, multicallAddress: s } = e, l = r ?? (typeof ((p = t.batch) == null ? void 0 : p.multicall) == "object" && t.batch.multicall.batchSize || 1024);
  let c = s;
  if (!c) {
    if (!t.chain)
      throw new Error("client chain not configured. multicallAddress is required.");
    c = Ph({
      blockNumber: i,
      chain: t.chain,
      contract: "multicall3"
    });
  }
  const d = [[]];
  let u = 0, h = 0;
  for (let m = 0; m < o.length; m++) {
    const { abi: R, address: V, args: U, functionName: g } = o[m];
    try {
      const y = Uc({
        abi: R,
        args: U,
        functionName: g
      });
      h += (y.length - 2) / 2, // Check if batching is enabled.
      l > 0 && // Check if the current size of the batch exceeds the size limit.
      h > l && // Check if the current chunk is not already empty.
      d[u].length > 0 && (u++, h = (y.length - 2) / 2, d[u] = []), d[u] = [
        ...d[u],
        {
          allowFailure: !0,
          callData: y,
          target: V
        }
      ];
    } catch (y) {
      const x = X1(y, {
        abi: R,
        address: V,
        args: U,
        docsPath: "/docs/contract/multicall",
        functionName: g
      });
      if (!n)
        throw x;
      d[u] = [
        ...d[u],
        {
          allowFailure: !0,
          callData: "0x",
          target: V
        }
      ];
    }
  }
  const N = await Promise.allSettled(d.map((m) => Tt(t, tc, "readContract")({
    abi: Cy,
    address: c,
    args: [m],
    blockNumber: i,
    blockTag: a,
    functionName: "aggregate3"
  }))), M = [];
  for (let m = 0; m < N.length; m++) {
    const R = N[m];
    if (R.status === "rejected") {
      if (!n)
        throw R.reason;
      for (let U = 0; U < d[m].length; U++)
        M.push({
          status: "failure",
          error: R.reason,
          result: void 0
        });
      continue;
    }
    const V = R.value;
    for (let U = 0; U < V.length; U++) {
      const { returnData: g, success: y } = V[U], { callData: x } = d[m][U], { abi: f, address: D, functionName: Y, args: Q } = o[M.length];
      try {
        if (x === "0x")
          throw new x2();
        if (!y)
          throw new KE({ data: g });
        const G = _h({
          abi: f,
          args: Q,
          data: g,
          functionName: Y
        });
        M.push(n ? { result: G, status: "success" } : G);
      } catch (G) {
        const ne = X1(G, {
          abi: f,
          address: D,
          args: Q,
          docsPath: "/docs/contract/multicall",
          functionName: Y
        });
        if (!n)
          throw ne;
        M.push({ error: ne, result: void 0, status: "failure" });
      }
    }
  }
  if (M.length !== o.length)
    throw new xe("multicall results mismatch");
  return M;
}
const __ = "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";
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
BigInt(0);
BigInt(1);
BigInt(2);
function P_(t, e) {
  if (t.length !== e.length)
    return !1;
  for (let n = 0; n < t.length; n++)
    if (t[n] !== e[n])
      return !1;
  return !0;
}
function K_(t, e) {
  const n = Do(t) ? $l(t) : t, r = Do(e) ? $l(e) : e;
  return P_(n, r);
}
async function cI(t, { address: e, hash: n, signature: r, ...i }) {
  const a = Do(r) ? r : Bs(r);
  try {
    const { data: o } = await Tt(t, k2, "call")({
      data: lI({
        abi: Q8,
        args: [e, n, a],
        bytecode: __
      }),
      ...i
    });
    return K_(o ?? "0x0", "0x1");
  } catch (o) {
    if (o instanceof Ov)
      return !1;
    throw o;
  }
}
async function $_(t, { address: e, message: n, signature: r, ...i }) {
  const a = C_(n);
  return cI(t, {
    address: e,
    hash: a,
    signature: r,
    ...i
  });
}
async function q_(t, { address: e, signature: n, message: r, primaryType: i, types: a, domain: o, ...s }) {
  const l = I_({ message: r, primaryType: i, types: a, domain: o });
  return cI(t, {
    address: e,
    hash: l,
    signature: n,
    ...s
  });
}
function dI(t, { emitOnBegin: e = !1, emitMissed: n = !1, onBlockNumber: r, onError: i, poll: a, pollingInterval: o = t.pollingInterval }) {
  const s = typeof a < "u" ? a : t.transport.type !== "webSocket";
  let l;
  return s ? (() => {
    const u = Mi([
      "watchBlockNumber",
      t.uid,
      e,
      n,
      o
    ]);
    return Kh(u, { onBlockNumber: r, onError: i }, (h) => Op(async () => {
      var N;
      try {
        const M = await Tt(t, Yp, "getBlockNumber")({ cacheTime: 0 });
        if (l) {
          if (M === l)
            return;
          if (M - l > 1 && n)
            for (let p = l + 1n; p < M; p++)
              h.onBlockNumber(p, l), l = p;
        }
        (!l || M > l) && (h.onBlockNumber(M, l), l = M);
      } catch (M) {
        (N = h.onError) == null || N.call(h, M);
      }
    }, {
      emitOnBegin: e,
      interval: o
    }));
  })() : (() => {
    let u = !0, h = () => u = !1;
    return (async () => {
      try {
        const { unsubscribe: N } = await t.transport.subscribe({
          params: ["newHeads"],
          onData(M) {
            var m;
            if (!u)
              return;
            const p = Z2((m = M.result) == null ? void 0 : m.number);
            r(p, l), l = p;
          },
          onError(M) {
            i == null || i(M);
          }
        });
        h = N, u || h();
      } catch (N) {
        i == null || i(N);
      }
    })(), h;
  })();
}
async function eP(t, { confirmations: e = 1, hash: n, onReplaced: r, pollingInterval: i = t.pollingInterval, timeout: a }) {
  const o = Mi(["waitForTransactionReceipt", t.uid, n]);
  let s, l, c, d = !1;
  return new Promise((u, h) => {
    a && setTimeout(() => h(new Z8({ hash: n })), a);
    const N = Kh(o, { onReplaced: r, resolve: u, reject: h }, (M) => {
      const p = Tt(t, dI, "watchBlockNumber")({
        emitMissed: !0,
        emitOnBegin: !0,
        poll: !0,
        pollingInterval: i,
        async onBlockNumber(m) {
          if (d)
            return;
          let R = m;
          const V = (U) => {
            p(), U(), N();
          };
          try {
            if (c) {
              if (e > 1 && (!c.blockNumber || R - c.blockNumber + 1n < e))
                return;
              V(() => M.resolve(c));
              return;
            }
            if (s || (d = !0, await Jy(async () => {
              s = await Tt(t, h3, "getTransaction")({ hash: n }), s.blockNumber && (R = s.blockNumber);
            }, {
              // exponential backoff
              delay: ({ count: U }) => ~~(1 << U) * 200,
              retryCount: 6
            }), d = !1), c = await Tt(t, Ay, "getTransactionReceipt")({ hash: n }), e > 1 && (!c.blockNumber || R - c.blockNumber + 1n < e))
              return;
            V(() => M.resolve(c));
          } catch (U) {
            if (s && (U instanceof vv || U instanceof Iv))
              try {
                l = s, d = !0;
                const g = await Jy(() => Tt(t, ec, "getBlock")({
                  blockNumber: R,
                  includeTransactions: !0
                }), {
                  // exponential backoff
                  delay: ({ count: f }) => ~~(1 << f) * 200,
                  retryCount: 6,
                  shouldRetry: ({ error: f }) => f instanceof Yv
                });
                d = !1;
                const y = g.transactions.find(({ from: f, nonce: D }) => f === l.from && D === l.nonce);
                if (!y || (c = await Tt(t, Ay, "getTransactionReceipt")({
                  hash: y.hash
                }), e > 1 && (!c.blockNumber || R - c.blockNumber + 1n < e)))
                  return;
                let x = "replaced";
                y.to === l.to && y.value === l.value ? x = "repriced" : y.from === y.to && y.value === 0n && (x = "cancelled"), V(() => {
                  var f;
                  (f = M.onReplaced) == null || f.call(M, {
                    reason: x,
                    replacedTransaction: l,
                    transaction: y,
                    transactionReceipt: c
                  }), M.resolve(c);
                });
              } catch (g) {
                V(() => M.reject(g));
              }
            else
              V(() => M.reject(U));
          }
        }
      });
    });
  });
}
function tP(t, { blockTag: e = "latest", emitMissed: n = !1, emitOnBegin: r = !1, onBlock: i, onError: a, includeTransactions: o, poll: s, pollingInterval: l = t.pollingInterval }) {
  const c = typeof s < "u" ? s : t.transport.type !== "webSocket", d = o ?? !1;
  let u;
  return c ? (() => {
    const M = Mi([
      "watchBlocks",
      t.uid,
      n,
      r,
      d,
      l
    ]);
    return Kh(M, { onBlock: i, onError: a }, (p) => Op(async () => {
      var m;
      try {
        const R = await Tt(t, ec, "getBlock")({
          blockTag: e,
          includeTransactions: d
        });
        if (R.number && (u != null && u.number)) {
          if (R.number === u.number)
            return;
          if (R.number - u.number > 1 && n)
            for (let V = (u == null ? void 0 : u.number) + 1n; V < R.number; V++) {
              const U = await Tt(t, ec, "getBlock")({
                blockNumber: V,
                includeTransactions: d
              });
              p.onBlock(U, u), u = U;
            }
        }
        // If no previous block exists, emit.
        (!(u != null && u.number) || // If the block tag is "pending" with no block number, emit.
        e === "pending" && !(R != null && R.number) || // If the next block number is greater than the previous block number, emit.
        // We don't want to emit blocks in the past.
        R.number && R.number > u.number) && (p.onBlock(R, u), u = R);
      } catch (R) {
        (m = p.onError) == null || m.call(p, R);
      }
    }, {
      emitOnBegin: r,
      interval: l
    }));
  })() : (() => {
    let M = !0, p = () => M = !1;
    return (async () => {
      try {
        const { unsubscribe: m } = await t.transport.subscribe({
          params: ["newHeads"],
          onData(R) {
            var g, y, x;
            if (!M)
              return;
            const U = (((x = (y = (g = t.chain) == null ? void 0 : g.formatters) == null ? void 0 : y.block) == null ? void 0 : x.format) || gv)(R.result);
            i(U, u), u = U;
          },
          onError(R) {
            a == null || a(R);
          }
        });
        p = m, M || p();
      } catch (m) {
        a == null || a(m);
      }
    })(), p;
  })();
}
function nP(t, { address: e, args: n, batch: r = !0, event: i, events: a, onError: o, onLogs: s, poll: l, pollingInterval: c = t.pollingInterval, strict: d }) {
  const u = typeof l < "u" ? l : t.transport.type !== "webSocket", h = d ?? !1;
  return u ? (() => {
    const p = Mi([
      "watchEvent",
      e,
      n,
      r,
      t.uid,
      i,
      c
    ]);
    return Kh(p, { onLogs: s, onError: o }, (m) => {
      let R, V, U = !1;
      const g = Op(async () => {
        var y;
        if (!U) {
          try {
            V = await Tt(t, eI, "createEventFilter")({
              address: e,
              args: n,
              event: i,
              events: a,
              strict: h
            });
          } catch {
          }
          U = !0;
          return;
        }
        try {
          let x;
          if (V)
            x = await Tt(t, w2, "getFilterChanges")({ filter: V });
          else {
            const f = await Tt(t, Yp, "getBlockNumber")({});
            R && R !== f ? x = await Tt(t, i3, "getLogs")({
              address: e,
              args: n,
              event: i,
              events: a,
              fromBlock: R + 1n,
              toBlock: f
            }) : x = [], R = f;
          }
          if (x.length === 0)
            return;
          if (r)
            m.onLogs(x);
          else
            for (const f of x)
              m.onLogs([f]);
        } catch (x) {
          V && x instanceof Fd && (U = !1), (y = m.onError) == null || y.call(m, x);
        }
      }, {
        emitOnBegin: !0,
        interval: c
      });
      return async () => {
        V && await Tt(t, F2, "uninstallFilter")({ filter: V }), g();
      };
    });
  })() : (() => {
    let p = !0, m = () => p = !1;
    return (async () => {
      try {
        const R = a ?? (i ? [i] : void 0);
        let V = [];
        R && (V = [
          R.flatMap((g) => wp({
            abi: [g],
            eventName: g.name,
            args: n
          }))
        ], i && (V = V[0]));
        const { unsubscribe: U } = await t.transport.subscribe({
          params: ["logs", { address: e, topics: V }],
          onData(g) {
            var x;
            if (!p)
              return;
            const y = g.result;
            try {
              const { eventName: f, args: D } = Ip({
                abi: R,
                data: y.data,
                topics: y.topics,
                strict: h
              }), Y = Pa(y, {
                args: D,
                eventName: f
              });
              s([Y]);
            } catch (f) {
              let D, Y;
              if (f instanceof wd || f instanceof Ah) {
                if (d)
                  return;
                D = f.abiItem.name, Y = (x = f.abiItem.inputs) == null ? void 0 : x.some((G) => !("name" in G && G.name));
              }
              const Q = Pa(y, {
                args: Y ? [] : {},
                eventName: D
              });
              s([Q]);
            }
          },
          onError(g) {
            o == null || o(g);
          }
        });
        m = U, p || m();
      } catch (R) {
        o == null || o(R);
      }
    })(), m;
  })();
}
function rP(t, { batch: e = !0, onError: n, onTransactions: r, poll: i, pollingInterval: a = t.pollingInterval }) {
  return (typeof i < "u" ? i : t.transport.type !== "webSocket") ? (() => {
    const c = Mi([
      "watchPendingTransactions",
      t.uid,
      e,
      a
    ]);
    return Kh(c, { onTransactions: r, onError: n }, (d) => {
      let u;
      const h = Op(async () => {
        var N;
        try {
          if (!u)
            try {
              u = await Tt(t, tI, "createPendingTransactionFilter")({});
              return;
            } catch (p) {
              throw h(), p;
            }
          const M = await Tt(t, w2, "getFilterChanges")({ filter: u });
          if (M.length === 0)
            return;
          if (e)
            d.onTransactions(M);
          else
            for (const p of M)
              d.onTransactions([p]);
        } catch (M) {
          (N = d.onError) == null || N.call(d, M);
        }
      }, {
        emitOnBegin: !0,
        interval: a
      });
      return async () => {
        u && await Tt(t, F2, "uninstallFilter")({ filter: u }), h();
      };
    });
  })() : (() => {
    let c = !0, d = () => c = !1;
    return (async () => {
      try {
        const { unsubscribe: u } = await t.transport.subscribe({
          params: ["newPendingTransactions"],
          onData(h) {
            if (!c)
              return;
            const N = h.result;
            r([N]);
          },
          onError(h) {
            n == null || n(h);
          }
        });
        d = u, c || d();
      } catch (u) {
        n == null || n(u);
      }
    })(), d;
  })();
}
function iP(t) {
  return {
    call: (e) => k2(t, e),
    createBlockFilter: () => x_(t),
    createContractEventFilter: (e) => kv(t, e),
    createEventFilter: (e) => eI(t, e),
    createPendingTransactionFilter: () => tI(t),
    estimateContractGas: (e) => I8(t, e),
    estimateGas: (e) => r3(t, e),
    getBalance: (e) => W_(t, e),
    getBlock: (e) => ec(t, e),
    getBlockNumber: (e) => Yp(t, e),
    getBlockTransactionCount: (e) => j_(t, e),
    getBytecode: (e) => D_(t, e),
    getChainId: () => _1(t),
    getContractEvents: (e) => Cv(t, e),
    getEnsAddress: (e) => h_(t, e),
    getEnsAvatar: (e) => b_(t, e),
    getEnsName: (e) => E_(t, e),
    getEnsResolver: (e) => S_(t, e),
    getEnsText: (e) => qv(t, e),
    getFeeHistory: (e) => k_(t, e),
    estimateFeesPerGas: (e) => F8(t, e),
    getFilterChanges: (e) => w2(t, e),
    getFilterLogs: (e) => w_(t, e),
    getGasPrice: () => n3(t),
    getLogs: (e) => i3(t, e),
    getProof: (e) => B_(t, e),
    estimateMaxPriorityFeePerGas: (e) => w8(t, e),
    getStorageAt: (e) => A_(t, e),
    getTransaction: (e) => h3(t, e),
    getTransactionConfirmations: (e) => H_(t, e),
    getTransactionCount: (e) => Gv(t, e),
    getTransactionReceipt: (e) => Ay(t, e),
    multicall: (e) => X_(t, e),
    prepareTransactionRequest: (e) => z2(t, e),
    readContract: (e) => tc(t, e),
    sendRawTransaction: (e) => o3(t, e),
    simulateContract: (e) => A8(t, e),
    verifyMessage: (e) => $_(t, e),
    verifyTypedData: (e) => q_(t, e),
    uninstallFilter: (e) => F2(t, e),
    waitForTransactionReceipt: (e) => eP(t, e),
    watchBlocks: (e) => tP(t, e),
    watchBlockNumber: (e) => dI(t, e),
    watchContractEvent: (e) => q8(t, e),
    watchEvent: (e) => nP(t, e),
    watchPendingTransactions: (e) => rP(t, e)
  };
}
function Df(t) {
  const { key: e = "public", name: n = "Public Client" } = t;
  return Av({
    ...t,
    key: e,
    name: n,
    type: "publicClient"
  }).extend(iP);
}
function aP(t, { abi: e, args: n, bytecode: r, ...i }) {
  const a = lI({
    abi: e,
    args: n,
    bytecode: r
  });
  return s3(t, {
    ...i,
    data: a
  });
}
async function oP(t) {
  var n;
  return ((n = t.account) == null ? void 0 : n.type) === "local" ? [t.account.address] : (await t.request({ method: "eth_accounts" })).map((r) => XE(r));
}
async function sP(t) {
  return await t.request({ method: "wallet_getPermissions" });
}
async function lP(t) {
  return (await t.request({ method: "eth_requestAccounts" })).map((n) => un(n));
}
async function cP(t, e) {
  return t.request({
    method: "wallet_requestPermissions",
    params: [e]
  });
}
async function dP(t, { account: e = t.account, message: n }) {
  if (!e)
    throw new Xh({
      docsPath: "/docs/actions/wallet/signMessage"
    });
  const r = za(e);
  if (r.type === "local")
    return r.signMessage({ message: n });
  const i = (() => typeof n == "string" ? OE(n) : n.raw instanceof Uint8Array ? Bs(n.raw) : n.raw)();
  return t.request({
    method: "personal_sign",
    params: [i, r.address]
  });
}
async function uP(t, e) {
  var c, d, u, h;
  const { account: n = t.account, chain: r = t.chain, ...i } = e;
  if (!n)
    throw new Xh({
      docsPath: "/docs/actions/wallet/signTransaction"
    });
  const a = za(n);
  vp({
    account: a,
    ...e
  });
  const o = await Tt(t, _1, "getChainId")({});
  r !== null && Bv({
    currentChainId: o,
    chain: r
  });
  const s = (r == null ? void 0 : r.formatters) || ((c = t.chain) == null ? void 0 : c.formatters), l = ((d = s == null ? void 0 : s.transactionRequest) == null ? void 0 : d.format) || b2;
  return a.type === "local" ? a.signTransaction({
    ...i,
    chainId: o
  }, { serializer: (h = (u = t.chain) == null ? void 0 : u.serializers) == null ? void 0 : h.transaction }) : await t.request({
    method: "eth_signTransaction",
    params: [
      {
        ...l(i),
        chainId: St(o),
        from: a.address
      }
    ]
  });
}
async function hP(t, { account: e = t.account, domain: n, message: r, primaryType: i, types: a }) {
  if (!e)
    throw new Xh({
      docsPath: "/docs/actions/wallet/signTypedData"
    });
  const o = za(e), s = {
    EIP712Domain: sI({ domain: n }),
    ...a
  };
  if (oI({
    domain: n,
    message: r,
    primaryType: i,
    types: s
  }), o.type === "local")
    return o.signTypedData({
      domain: n,
      primaryType: i,
      types: s,
      message: r
    });
  const l = Mi({ domain: n ?? {}, primaryType: i, types: s, message: r }, (c, d) => Do(d) ? d.toLowerCase() : d);
  return t.request({
    method: "eth_signTypedData_v4",
    params: [o.address, l]
  });
}
async function NP(t, { id: e }) {
  await t.request({
    method: "wallet_switchEthereumChain",
    params: [
      {
        chainId: St(e)
      }
    ]
  });
}
async function MP(t, e) {
  return await t.request({
    method: "wallet_watchAsset",
    params: e
  });
}
function pP(t) {
  return {
    addChain: (e) => n_(t, e),
    deployContract: (e) => aP(t, e),
    getAddresses: () => oP(t),
    getChainId: () => _1(t),
    getPermissions: () => sP(t),
    prepareTransactionRequest: (e) => z2(t, e),
    requestAddresses: () => lP(t),
    requestPermissions: (e) => cP(t, e),
    sendRawTransaction: (e) => o3(t, e),
    sendTransaction: (e) => s3(t, e),
    signMessage: (e) => dP(t, e),
    signTransaction: (e) => uP(t, e),
    signTypedData: (e) => hP(t, e),
    switchChain: (e) => NP(t, e),
    watchAsset: (e) => MP(t, e),
    writeContract: (e) => t_(t, e)
  };
}
function N3(t) {
  const { key: e = "wallet", name: n = "Wallet Client", transport: r } = t;
  return Av({
    ...t,
    key: e,
    name: n,
    transport: (a) => r({ ...a, retryCount: 0 }),
    type: "walletClient"
  }).extend(pP);
}
function mP(t, e = {}) {
  const { key: n = "webSocket", name: r = "WebSocket JSON-RPC", retryDelay: i } = e;
  return ({ chain: a, retryCount: o, timeout: s }) => {
    var u;
    const l = e.retryCount ?? o, c = s ?? e.timeout ?? 1e4, d = t || ((u = a == null ? void 0 : a.rpcUrls.default.webSocket) == null ? void 0 : u[0]);
    if (!d)
      throw new Xv();
    return v2({
      key: n,
      name: r,
      async request({ method: h, params: N }) {
        const M = { method: h, params: N }, p = await IR(d), { error: m, result: R } = await h0.webSocketAsync(p, {
          body: M,
          timeout: c
        });
        if (m)
          throw new $E({
            body: M,
            error: m,
            url: d
          });
        return R;
      },
      retryCount: l,
      retryDelay: i,
      timeout: c,
      type: "webSocket"
    }, {
      getSocket() {
        return IR(d);
      },
      async subscribe({ params: h, onData: N, onError: M }) {
        const p = await IR(d), { result: m } = await new Promise((R, V) => h0.webSocket(p, {
          body: {
            method: "eth_subscribe",
            params: h
          },
          onResponse(U) {
            if (U.error) {
              V(U.error), M == null || M(U.error);
              return;
            }
            if (typeof U.id == "number") {
              R(U);
              return;
            }
            U.method === "eth_subscription" && N(U.params);
          }
        }));
        return {
          subscriptionId: m,
          async unsubscribe() {
            return new Promise((R) => h0.webSocket(p, {
              body: {
                method: "eth_unsubscribe",
                params: [m]
              },
              onResponse: R
            }));
          }
        };
      }
    });
  };
}
const TP = /* @__PURE__ */ pv({
  id: 5,
  network: "goerli",
  name: "Goerli",
  nativeCurrency: { name: "Goerli Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    alchemy: {
      http: ["https://eth-goerli.g.alchemy.com/v2"],
      webSocket: ["wss://eth-goerli.g.alchemy.com/v2"]
    },
    infura: {
      http: ["https://goerli.infura.io/v3"],
      webSocket: ["wss://goerli.infura.io/ws/v3"]
    },
    default: {
      http: ["https://rpc.ankr.com/eth_goerli"]
    },
    public: {
      http: ["https://rpc.ankr.com/eth_goerli"]
    }
  },
  blockExplorers: {
    etherscan: {
      name: "Etherscan",
      url: "https://goerli.etherscan.io"
    },
    default: {
      name: "Etherscan",
      url: "https://goerli.etherscan.io"
    }
  },
  contracts: {
    ensRegistry: {
      address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
    },
    ensUniversalResolver: {
      address: "0x56522D00C410a43BFfDF00a9A569489297385790",
      blockCreated: 8765204
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 6507670
    }
  },
  testnet: !0
}), uI = /* @__PURE__ */ pv({
  id: 1,
  network: "homestead",
  name: "Ethereum",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    alchemy: {
      http: ["https://eth-mainnet.g.alchemy.com/v2"],
      webSocket: ["wss://eth-mainnet.g.alchemy.com/v2"]
    },
    infura: {
      http: ["https://mainnet.infura.io/v3"],
      webSocket: ["wss://mainnet.infura.io/ws/v3"]
    },
    default: {
      http: ["https://cloudflare-eth.com"]
    },
    public: {
      http: ["https://cloudflare-eth.com"]
    }
  },
  blockExplorers: {
    etherscan: {
      name: "Etherscan",
      url: "https://etherscan.io"
    },
    default: {
      name: "Etherscan",
      url: "https://etherscan.io"
    }
  },
  contracts: {
    ensRegistry: {
      address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
    },
    ensUniversalResolver: {
      address: "0xc0497E381f536Be9ce14B0dD3817cBcAe57d2F62",
      blockCreated: 16966585
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 14353601
    }
  }
});
var hI = { exports: {} };
(function(t) {
  var e = Object.prototype.hasOwnProperty, n = "~";
  function r() {
  }
  Object.create && (r.prototype = /* @__PURE__ */ Object.create(null), new r().__proto__ || (n = !1));
  function i(l, c, d) {
    this.fn = l, this.context = c, this.once = d || !1;
  }
  function a(l, c, d, u, h) {
    if (typeof d != "function")
      throw new TypeError("The listener must be a function");
    var N = new i(d, u || l, h), M = n ? n + c : c;
    return l._events[M] ? l._events[M].fn ? l._events[M] = [l._events[M], N] : l._events[M].push(N) : (l._events[M] = N, l._eventsCount++), l;
  }
  function o(l, c) {
    --l._eventsCount === 0 ? l._events = new r() : delete l._events[c];
  }
  function s() {
    this._events = new r(), this._eventsCount = 0;
  }
  s.prototype.eventNames = function() {
    var c = [], d, u;
    if (this._eventsCount === 0)
      return c;
    for (u in d = this._events)
      e.call(d, u) && c.push(n ? u.slice(1) : u);
    return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(d)) : c;
  }, s.prototype.listeners = function(c) {
    var d = n ? n + c : c, u = this._events[d];
    if (!u)
      return [];
    if (u.fn)
      return [u.fn];
    for (var h = 0, N = u.length, M = new Array(N); h < N; h++)
      M[h] = u[h].fn;
    return M;
  }, s.prototype.listenerCount = function(c) {
    var d = n ? n + c : c, u = this._events[d];
    return u ? u.fn ? 1 : u.length : 0;
  }, s.prototype.emit = function(c, d, u, h, N, M) {
    var p = n ? n + c : c;
    if (!this._events[p])
      return !1;
    var m = this._events[p], R = arguments.length, V, U;
    if (m.fn) {
      switch (m.once && this.removeListener(c, m.fn, void 0, !0), R) {
        case 1:
          return m.fn.call(m.context), !0;
        case 2:
          return m.fn.call(m.context, d), !0;
        case 3:
          return m.fn.call(m.context, d, u), !0;
        case 4:
          return m.fn.call(m.context, d, u, h), !0;
        case 5:
          return m.fn.call(m.context, d, u, h, N), !0;
        case 6:
          return m.fn.call(m.context, d, u, h, N, M), !0;
      }
      for (U = 1, V = new Array(R - 1); U < R; U++)
        V[U - 1] = arguments[U];
      m.fn.apply(m.context, V);
    } else {
      var g = m.length, y;
      for (U = 0; U < g; U++)
        switch (m[U].once && this.removeListener(c, m[U].fn, void 0, !0), R) {
          case 1:
            m[U].fn.call(m[U].context);
            break;
          case 2:
            m[U].fn.call(m[U].context, d);
            break;
          case 3:
            m[U].fn.call(m[U].context, d, u);
            break;
          case 4:
            m[U].fn.call(m[U].context, d, u, h);
            break;
          default:
            if (!V)
              for (y = 1, V = new Array(R - 1); y < R; y++)
                V[y - 1] = arguments[y];
            m[U].fn.apply(m[U].context, V);
        }
    }
    return !0;
  }, s.prototype.on = function(c, d, u) {
    return a(this, c, d, u, !1);
  }, s.prototype.once = function(c, d, u) {
    return a(this, c, d, u, !0);
  }, s.prototype.removeListener = function(c, d, u, h) {
    var N = n ? n + c : c;
    if (!this._events[N])
      return this;
    if (!d)
      return o(this, N), this;
    var M = this._events[N];
    if (M.fn)
      M.fn === d && (!h || M.once) && (!u || M.context === u) && o(this, N);
    else {
      for (var p = 0, m = [], R = M.length; p < R; p++)
        (M[p].fn !== d || h && !M[p].once || u && M[p].context !== u) && m.push(M[p]);
      m.length ? this._events[N] = m.length === 1 ? m[0] : m : o(this, N);
    }
    return this;
  }, s.prototype.removeAllListeners = function(c) {
    var d;
    return c ? (d = n ? n + c : c, this._events[d] && o(this, d)) : (this._events = new r(), this._eventsCount = 0), this;
  }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = n, s.EventEmitter = s, t.exports = s;
})(hI);
var fP = hI.exports;
const VP = /* @__PURE__ */ fc(fP), UP = (t) => (e, n, r) => {
  const i = r.subscribe;
  return r.subscribe = (o, s, l) => {
    let c = o;
    if (s) {
      const d = (l == null ? void 0 : l.equalityFn) || Object.is;
      let u = o(r.getState());
      c = (h) => {
        const N = o(h);
        if (!d(u, N)) {
          const M = u;
          s(u = N, M);
        }
      }, l != null && l.fireImmediately && s(u, u);
    }
    return i(c);
  }, t(e, n, r);
}, RP = UP;
function gP(t, e) {
  let n;
  try {
    n = t();
  } catch {
    return;
  }
  return {
    getItem: (i) => {
      var a;
      const o = (l) => l === null ? null : JSON.parse(l, e == null ? void 0 : e.reviver), s = (a = n.getItem(i)) != null ? a : null;
      return s instanceof Promise ? s.then(o) : o(s);
    },
    setItem: (i, a) => n.setItem(
      i,
      JSON.stringify(a, e == null ? void 0 : e.replacer)
    ),
    removeItem: (i) => n.removeItem(i)
  };
}
const P1 = (t) => (e) => {
  try {
    const n = t(e);
    return n instanceof Promise ? n : {
      then(r) {
        return P1(r)(n);
      },
      catch(r) {
        return this;
      }
    };
  } catch (n) {
    return {
      then(r) {
        return this;
      },
      catch(r) {
        return P1(r)(n);
      }
    };
  }
}, yP = (t, e) => (n, r, i) => {
  let a = {
    getStorage: () => localStorage,
    serialize: JSON.stringify,
    deserialize: JSON.parse,
    partialize: (m) => m,
    version: 0,
    merge: (m, R) => ({
      ...R,
      ...m
    }),
    ...e
  }, o = !1;
  const s = /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Set();
  let c;
  try {
    c = a.getStorage();
  } catch {
  }
  if (!c)
    return t(
      (...m) => {
        console.warn(
          `[zustand persist middleware] Unable to update item '${a.name}', the given storage is currently unavailable.`
        ), n(...m);
      },
      r,
      i
    );
  const d = P1(a.serialize), u = () => {
    const m = a.partialize({ ...r() });
    let R;
    const V = d({ state: m, version: a.version }).then(
      (U) => c.setItem(a.name, U)
    ).catch((U) => {
      R = U;
    });
    if (R)
      throw R;
    return V;
  }, h = i.setState;
  i.setState = (m, R) => {
    h(m, R), u();
  };
  const N = t(
    (...m) => {
      n(...m), u();
    },
    r,
    i
  );
  let M;
  const p = () => {
    var m;
    if (!c)
      return;
    o = !1, s.forEach((V) => V(r()));
    const R = ((m = a.onRehydrateStorage) == null ? void 0 : m.call(a, r())) || void 0;
    return P1(c.getItem.bind(c))(a.name).then((V) => {
      if (V)
        return a.deserialize(V);
    }).then((V) => {
      if (V)
        if (typeof V.version == "number" && V.version !== a.version) {
          if (a.migrate)
            return a.migrate(
              V.state,
              V.version
            );
          console.error(
            "State loaded from storage couldn't be migrated since no migrate function was provided"
          );
        } else
          return V.state;
    }).then((V) => {
      var U;
      return M = a.merge(
        V,
        (U = r()) != null ? U : N
      ), n(M, !0), u();
    }).then(() => {
      R == null || R(M, void 0), o = !0, l.forEach((V) => V(M));
    }).catch((V) => {
      R == null || R(void 0, V);
    });
  };
  return i.persist = {
    setOptions: (m) => {
      a = {
        ...a,
        ...m
      }, m.getStorage && (c = m.getStorage());
    },
    clearStorage: () => {
      c == null || c.removeItem(a.name);
    },
    getOptions: () => a,
    rehydrate: () => p(),
    hasHydrated: () => o,
    onHydrate: (m) => (s.add(m), () => {
      s.delete(m);
    }),
    onFinishHydration: (m) => (l.add(m), () => {
      l.delete(m);
    })
  }, p(), M || N;
}, ZP = (t, e) => (n, r, i) => {
  let a = {
    storage: gP(() => localStorage),
    partialize: (p) => p,
    version: 0,
    merge: (p, m) => ({
      ...m,
      ...p
    }),
    ...e
  }, o = !1;
  const s = /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Set();
  let c = a.storage;
  if (!c)
    return t(
      (...p) => {
        console.warn(
          `[zustand persist middleware] Unable to update item '${a.name}', the given storage is currently unavailable.`
        ), n(...p);
      },
      r,
      i
    );
  const d = () => {
    const p = a.partialize({ ...r() });
    return c.setItem(a.name, {
      state: p,
      version: a.version
    });
  }, u = i.setState;
  i.setState = (p, m) => {
    u(p, m), d();
  };
  const h = t(
    (...p) => {
      n(...p), d();
    },
    r,
    i
  );
  let N;
  const M = () => {
    var p, m;
    if (!c)
      return;
    o = !1, s.forEach((V) => {
      var U;
      return V((U = r()) != null ? U : h);
    });
    const R = ((m = a.onRehydrateStorage) == null ? void 0 : m.call(a, (p = r()) != null ? p : h)) || void 0;
    return P1(c.getItem.bind(c))(a.name).then((V) => {
      if (V)
        if (typeof V.version == "number" && V.version !== a.version) {
          if (a.migrate)
            return a.migrate(
              V.state,
              V.version
            );
          console.error(
            "State loaded from storage couldn't be migrated since no migrate function was provided"
          );
        } else
          return V.state;
    }).then((V) => {
      var U;
      return N = a.merge(
        V,
        (U = r()) != null ? U : h
      ), n(N, !0), d();
    }).then(() => {
      R == null || R(N, void 0), N = r(), o = !0, l.forEach((V) => V(N));
    }).catch((V) => {
      R == null || R(void 0, V);
    });
  };
  return i.persist = {
    setOptions: (p) => {
      a = {
        ...a,
        ...p
      }, p.storage && (c = p.storage);
    },
    clearStorage: () => {
      c == null || c.removeItem(a.name);
    },
    getOptions: () => a,
    rehydrate: () => M(),
    hasHydrated: () => o,
    onHydrate: (p) => (s.add(p), () => {
      s.delete(p);
    }),
    onFinishHydration: (p) => (l.add(p), () => {
      l.delete(p);
    })
  }, a.skipHydration || M(), N || h;
}, bP = (t, e) => "getStorage" in e || "serialize" in e || "deserialize" in e ? (console.warn(
  "[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead."
), yP(t, e)) : ZP(t, e), EP = bP, nj = (t) => {
  let e;
  const n = /* @__PURE__ */ new Set(), r = (l, c) => {
    const d = typeof l == "function" ? l(e) : l;
    if (!Object.is(d, e)) {
      const u = e;
      e = c ?? typeof d != "object" ? d : Object.assign({}, e, d), n.forEach((h) => h(e, u));
    }
  }, i = () => e, s = { setState: r, getState: i, subscribe: (l) => (n.add(l), () => n.delete(l)), destroy: () => {
    console.warn(
      "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
    ), n.clear();
  } };
  return e = t(r, i, s), s;
}, SP = (t) => t ? nj(t) : nj;
function NI(t, e) {
  if (Object.is(t, e))
    return !0;
  if (typeof t != "object" || t === null || typeof e != "object" || e === null)
    return !1;
  if (t instanceof Map && e instanceof Map) {
    if (t.size !== e.size)
      return !1;
    for (const [r, i] of t)
      if (!Object.is(i, e.get(r)))
        return !1;
    return !0;
  }
  if (t instanceof Set && e instanceof Set) {
    if (t.size !== e.size)
      return !1;
    for (const r of t)
      if (!e.has(r))
        return !1;
    return !0;
  }
  const n = Object.keys(t);
  if (n.length !== Object.keys(e).length)
    return !1;
  for (let r = 0; r < n.length; r++)
    if (!Object.prototype.hasOwnProperty.call(e, n[r]) || !Object.is(t[n[r]], e[n[r]]))
      return !1;
  return !0;
}
var Hy = [
  {
    type: "event",
    name: "Approval",
    inputs: [
      {
        indexed: !0,
        name: "owner",
        type: "address"
      },
      {
        indexed: !0,
        name: "spender",
        type: "address"
      },
      {
        indexed: !1,
        name: "value",
        type: "uint256"
      }
    ]
  },
  {
    type: "event",
    name: "Transfer",
    inputs: [
      {
        indexed: !0,
        name: "from",
        type: "address"
      },
      {
        indexed: !0,
        name: "to",
        type: "address"
      },
      {
        indexed: !1,
        name: "value",
        type: "uint256"
      }
    ]
  },
  {
    type: "function",
    name: "allowance",
    stateMutability: "view",
    inputs: [
      {
        name: "owner",
        type: "address"
      },
      {
        name: "spender",
        type: "address"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ]
  },
  {
    type: "function",
    name: "approve",
    stateMutability: "nonpayable",
    inputs: [
      {
        name: "spender",
        type: "address"
      },
      {
        name: "amount",
        type: "uint256"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ]
  },
  {
    type: "function",
    name: "balanceOf",
    stateMutability: "view",
    inputs: [
      {
        name: "account",
        type: "address"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ]
  },
  {
    type: "function",
    name: "decimals",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint8"
      }
    ]
  },
  {
    type: "function",
    name: "name",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "string"
      }
    ]
  },
  {
    type: "function",
    name: "symbol",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "string"
      }
    ]
  },
  {
    type: "function",
    name: "totalSupply",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ]
  },
  {
    type: "function",
    name: "transfer",
    stateMutability: "nonpayable",
    inputs: [
      {
        name: "recipient",
        type: "address"
      },
      {
        name: "amount",
        type: "uint256"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ]
  },
  {
    type: "function",
    name: "transferFrom",
    stateMutability: "nonpayable",
    inputs: [
      {
        name: "sender",
        type: "address"
      },
      {
        name: "recipient",
        type: "address"
      },
      {
        name: "amount",
        type: "uint256"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ]
  }
], ve = /* @__PURE__ */ ((t) => (t.MAINNET = "1", t.ETH_TESTNET = "5", t.BSC_MAINNET = "56", t.BSC_TESTNET = "97", t.POLYGON_MAINNET = "137", t.POLYGON_TESTNET = "80001", t.FANTOM_MAINNET = "250", t.FANTOM_TESTNET = "4002", t.CRONOS_MAINNET = "25", t.CRONOS_TESTNET = "338", t.THUNDERCORE_MAINNET = "108", t.THUNDERCORE_TESTNET = "18", t.AVALANCHE_MAINNET = "43114", t.AVALANCHE_TESTNET = "43113", t.KCC_TESTNET = "322", t.KCC_MAINNET = "321", t.ARBITRUM_MAINNET = "42161", t.ARBITRUM_TESTNET = "421611", t.OPTIMISM_MAINNET = "10", t.OPTIMISM_TESTNET = "420", t.ASTAR_MAINNET = "592", t.ASTAR_TESTNET = "81", t.MOONRIVER_MAINNET = "1285", t.MOONRIVER_TESTNET = "1287", t.KLAYTN_MAINNET = "8217", t.KLAYTN_TESTNET = "1001", t.NUMBERS_MAINNET = "10507", t.NUMBERS_TESTNET = "10508", t.WEMIX_MAINNET = "1111", t.WEMIX_TESTNET = "1112", t.ZKSYNC_ERA_MAINNET = "324", t.ZKSYNC_ERA_TESTNET = "280", t.POLYGON_ZKEVM_MAINNET = "1101", t.POLYGON_ZKEVM_TESTNET = "1442", t.LINEA_MAINNET = "59144", t.LINEA_TESTNET = "59140", t.BASE_MAINNET = "8453", t.BASE_TESTNET = "84531", t.MANTLE_MAINNET = "5000", t.MANTLE_TESTNET = "5001", t.SCROLL_MAINNET = "534352", t.SCROLL_TESTNET = "534351", t.X1_MAINNET = "196", t.X1_TESTNET = "195", t))(ve || {}), M3 = { exports: {} };
const xP = {}, WP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: xP
}, Symbol.toStringTag, { value: "Module" })), MI = /* @__PURE__ */ Uw(WP);
M3.exports;
(function(t) {
  (function(e, n) {
    function r(O, T) {
      if (!O)
        throw new Error(T || "Assertion failed");
    }
    function i(O, T) {
      O.super_ = T;
      var Z = function() {
      };
      Z.prototype = T.prototype, O.prototype = new Z(), O.prototype.constructor = O;
    }
    function a(O, T, Z) {
      if (a.isBN(O))
        return O;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, O !== null && ((T === "le" || T === "be") && (Z = T, T = 10), this._init(O || 0, T || 10, Z || "be"));
    }
    typeof e == "object" ? e.exports = a : n.BN = a, a.BN = a, a.wordSize = 26;
    var o;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? o = window.Buffer : o = MI.Buffer;
    } catch {
    }
    a.isBN = function(T) {
      return T instanceof a ? !0 : T !== null && typeof T == "object" && T.constructor.wordSize === a.wordSize && Array.isArray(T.words);
    }, a.max = function(T, Z) {
      return T.cmp(Z) > 0 ? T : Z;
    }, a.min = function(T, Z) {
      return T.cmp(Z) < 0 ? T : Z;
    }, a.prototype._init = function(T, Z, z) {
      if (typeof T == "number")
        return this._initNumber(T, Z, z);
      if (typeof T == "object")
        return this._initArray(T, Z, z);
      Z === "hex" && (Z = 16), r(Z === (Z | 0) && Z >= 2 && Z <= 36), T = T.toString().replace(/\s+/g, "");
      var j = 0;
      T[0] === "-" && (j++, this.negative = 1), j < T.length && (Z === 16 ? this._parseHex(T, j, z) : (this._parseBase(T, Z, j), z === "le" && this._initArray(this.toArray(), Z, z)));
    }, a.prototype._initNumber = function(T, Z, z) {
      T < 0 && (this.negative = 1, T = -T), T < 67108864 ? (this.words = [T & 67108863], this.length = 1) : T < 4503599627370496 ? (this.words = [
        T & 67108863,
        T / 67108864 & 67108863
      ], this.length = 2) : (r(T < 9007199254740992), this.words = [
        T & 67108863,
        T / 67108864 & 67108863,
        1
      ], this.length = 3), z === "le" && this._initArray(this.toArray(), Z, z);
    }, a.prototype._initArray = function(T, Z, z) {
      if (r(typeof T.length == "number"), T.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(T.length / 3), this.words = new Array(this.length);
      for (var j = 0; j < this.length; j++)
        this.words[j] = 0;
      var w, C, J = 0;
      if (z === "be")
        for (j = T.length - 1, w = 0; j >= 0; j -= 3)
          C = T[j] | T[j - 1] << 8 | T[j - 2] << 16, this.words[w] |= C << J & 67108863, this.words[w + 1] = C >>> 26 - J & 67108863, J += 24, J >= 26 && (J -= 26, w++);
      else if (z === "le")
        for (j = 0, w = 0; j < T.length; j += 3)
          C = T[j] | T[j + 1] << 8 | T[j + 2] << 16, this.words[w] |= C << J & 67108863, this.words[w + 1] = C >>> 26 - J & 67108863, J += 24, J >= 26 && (J -= 26, w++);
      return this._strip();
    };
    function s(O, T) {
      var Z = O.charCodeAt(T);
      if (Z >= 48 && Z <= 57)
        return Z - 48;
      if (Z >= 65 && Z <= 70)
        return Z - 55;
      if (Z >= 97 && Z <= 102)
        return Z - 87;
      r(!1, "Invalid character in " + O);
    }
    function l(O, T, Z) {
      var z = s(O, Z);
      return Z - 1 >= T && (z |= s(O, Z - 1) << 4), z;
    }
    a.prototype._parseHex = function(T, Z, z) {
      this.length = Math.ceil((T.length - Z) / 6), this.words = new Array(this.length);
      for (var j = 0; j < this.length; j++)
        this.words[j] = 0;
      var w = 0, C = 0, J;
      if (z === "be")
        for (j = T.length - 1; j >= Z; j -= 2)
          J = l(T, Z, j) << w, this.words[C] |= J & 67108863, w >= 18 ? (w -= 18, C += 1, this.words[C] |= J >>> 26) : w += 8;
      else {
        var I = T.length - Z;
        for (j = I % 2 === 0 ? Z + 1 : Z; j < T.length; j += 2)
          J = l(T, Z, j) << w, this.words[C] |= J & 67108863, w >= 18 ? (w -= 18, C += 1, this.words[C] |= J >>> 26) : w += 8;
      }
      this._strip();
    };
    function c(O, T, Z, z) {
      for (var j = 0, w = 0, C = Math.min(O.length, Z), J = T; J < C; J++) {
        var I = O.charCodeAt(J) - 48;
        j *= z, I >= 49 ? w = I - 49 + 10 : I >= 17 ? w = I - 17 + 10 : w = I, r(I >= 0 && w < z, "Invalid character"), j += w;
      }
      return j;
    }
    a.prototype._parseBase = function(T, Z, z) {
      this.words = [0], this.length = 1;
      for (var j = 0, w = 1; w <= 67108863; w *= Z)
        j++;
      j--, w = w / Z | 0;
      for (var C = T.length - z, J = C % j, I = Math.min(C, C - J) + z, b = 0, k = z; k < I; k += j)
        b = c(T, k, k + j, Z), this.imuln(w), this.words[0] + b < 67108864 ? this.words[0] += b : this._iaddn(b);
      if (J !== 0) {
        var ae = 1;
        for (b = c(T, k, T.length, Z), k = 0; k < J; k++)
          ae *= Z;
        this.imuln(ae), this.words[0] + b < 67108864 ? this.words[0] += b : this._iaddn(b);
      }
      this._strip();
    }, a.prototype.copy = function(T) {
      T.words = new Array(this.length);
      for (var Z = 0; Z < this.length; Z++)
        T.words[Z] = this.words[Z];
      T.length = this.length, T.negative = this.negative, T.red = this.red;
    };
    function d(O, T) {
      O.words = T.words, O.length = T.length, O.negative = T.negative, O.red = T.red;
    }
    if (a.prototype._move = function(T) {
      d(T, this);
    }, a.prototype.clone = function() {
      var T = new a(null);
      return this.copy(T), T;
    }, a.prototype._expand = function(T) {
      for (; this.length < T; )
        this.words[this.length++] = 0;
      return this;
    }, a.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, a.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        a.prototype[Symbol.for("nodejs.util.inspect.custom")] = u;
      } catch {
        a.prototype.inspect = u;
      }
    else
      a.prototype.inspect = u;
    function u() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var h = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], N = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], M = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    a.prototype.toString = function(T, Z) {
      T = T || 10, Z = Z | 0 || 1;
      var z;
      if (T === 16 || T === "hex") {
        z = "";
        for (var j = 0, w = 0, C = 0; C < this.length; C++) {
          var J = this.words[C], I = ((J << j | w) & 16777215).toString(16);
          w = J >>> 24 - j & 16777215, j += 2, j >= 26 && (j -= 26, C--), w !== 0 || C !== this.length - 1 ? z = h[6 - I.length] + I + z : z = I + z;
        }
        for (w !== 0 && (z = w.toString(16) + z); z.length % Z !== 0; )
          z = "0" + z;
        return this.negative !== 0 && (z = "-" + z), z;
      }
      if (T === (T | 0) && T >= 2 && T <= 36) {
        var b = N[T], k = M[T];
        z = "";
        var ae = this.clone();
        for (ae.negative = 0; !ae.isZero(); ) {
          var oe = ae.modrn(k).toString(T);
          ae = ae.idivn(k), ae.isZero() ? z = oe + z : z = h[b - oe.length] + oe + z;
        }
        for (this.isZero() && (z = "0" + z); z.length % Z !== 0; )
          z = "0" + z;
        return this.negative !== 0 && (z = "-" + z), z;
      }
      r(!1, "Base should be between 2 and 36");
    }, a.prototype.toNumber = function() {
      var T = this.words[0];
      return this.length === 2 ? T += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? T += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && r(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -T : T;
    }, a.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, o && (a.prototype.toBuffer = function(T, Z) {
      return this.toArrayLike(o, T, Z);
    }), a.prototype.toArray = function(T, Z) {
      return this.toArrayLike(Array, T, Z);
    };
    var p = function(T, Z) {
      return T.allocUnsafe ? T.allocUnsafe(Z) : new T(Z);
    };
    a.prototype.toArrayLike = function(T, Z, z) {
      this._strip();
      var j = this.byteLength(), w = z || Math.max(1, j);
      r(j <= w, "byte array longer than desired length"), r(w > 0, "Requested array length <= 0");
      var C = p(T, w), J = Z === "le" ? "LE" : "BE";
      return this["_toArrayLike" + J](C, j), C;
    }, a.prototype._toArrayLikeLE = function(T, Z) {
      for (var z = 0, j = 0, w = 0, C = 0; w < this.length; w++) {
        var J = this.words[w] << C | j;
        T[z++] = J & 255, z < T.length && (T[z++] = J >> 8 & 255), z < T.length && (T[z++] = J >> 16 & 255), C === 6 ? (z < T.length && (T[z++] = J >> 24 & 255), j = 0, C = 0) : (j = J >>> 24, C += 2);
      }
      if (z < T.length)
        for (T[z++] = j; z < T.length; )
          T[z++] = 0;
    }, a.prototype._toArrayLikeBE = function(T, Z) {
      for (var z = T.length - 1, j = 0, w = 0, C = 0; w < this.length; w++) {
        var J = this.words[w] << C | j;
        T[z--] = J & 255, z >= 0 && (T[z--] = J >> 8 & 255), z >= 0 && (T[z--] = J >> 16 & 255), C === 6 ? (z >= 0 && (T[z--] = J >> 24 & 255), j = 0, C = 0) : (j = J >>> 24, C += 2);
      }
      if (z >= 0)
        for (T[z--] = j; z >= 0; )
          T[z--] = 0;
    }, Math.clz32 ? a.prototype._countBits = function(T) {
      return 32 - Math.clz32(T);
    } : a.prototype._countBits = function(T) {
      var Z = T, z = 0;
      return Z >= 4096 && (z += 13, Z >>>= 13), Z >= 64 && (z += 7, Z >>>= 7), Z >= 8 && (z += 4, Z >>>= 4), Z >= 2 && (z += 2, Z >>>= 2), z + Z;
    }, a.prototype._zeroBits = function(T) {
      if (T === 0)
        return 26;
      var Z = T, z = 0;
      return Z & 8191 || (z += 13, Z >>>= 13), Z & 127 || (z += 7, Z >>>= 7), Z & 15 || (z += 4, Z >>>= 4), Z & 3 || (z += 2, Z >>>= 2), Z & 1 || z++, z;
    }, a.prototype.bitLength = function() {
      var T = this.words[this.length - 1], Z = this._countBits(T);
      return (this.length - 1) * 26 + Z;
    };
    function m(O) {
      for (var T = new Array(O.bitLength()), Z = 0; Z < T.length; Z++) {
        var z = Z / 26 | 0, j = Z % 26;
        T[Z] = O.words[z] >>> j & 1;
      }
      return T;
    }
    a.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var T = 0, Z = 0; Z < this.length; Z++) {
        var z = this._zeroBits(this.words[Z]);
        if (T += z, z !== 26)
          break;
      }
      return T;
    }, a.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, a.prototype.toTwos = function(T) {
      return this.negative !== 0 ? this.abs().inotn(T).iaddn(1) : this.clone();
    }, a.prototype.fromTwos = function(T) {
      return this.testn(T - 1) ? this.notn(T).iaddn(1).ineg() : this.clone();
    }, a.prototype.isNeg = function() {
      return this.negative !== 0;
    }, a.prototype.neg = function() {
      return this.clone().ineg();
    }, a.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, a.prototype.iuor = function(T) {
      for (; this.length < T.length; )
        this.words[this.length++] = 0;
      for (var Z = 0; Z < T.length; Z++)
        this.words[Z] = this.words[Z] | T.words[Z];
      return this._strip();
    }, a.prototype.ior = function(T) {
      return r((this.negative | T.negative) === 0), this.iuor(T);
    }, a.prototype.or = function(T) {
      return this.length > T.length ? this.clone().ior(T) : T.clone().ior(this);
    }, a.prototype.uor = function(T) {
      return this.length > T.length ? this.clone().iuor(T) : T.clone().iuor(this);
    }, a.prototype.iuand = function(T) {
      var Z;
      this.length > T.length ? Z = T : Z = this;
      for (var z = 0; z < Z.length; z++)
        this.words[z] = this.words[z] & T.words[z];
      return this.length = Z.length, this._strip();
    }, a.prototype.iand = function(T) {
      return r((this.negative | T.negative) === 0), this.iuand(T);
    }, a.prototype.and = function(T) {
      return this.length > T.length ? this.clone().iand(T) : T.clone().iand(this);
    }, a.prototype.uand = function(T) {
      return this.length > T.length ? this.clone().iuand(T) : T.clone().iuand(this);
    }, a.prototype.iuxor = function(T) {
      var Z, z;
      this.length > T.length ? (Z = this, z = T) : (Z = T, z = this);
      for (var j = 0; j < z.length; j++)
        this.words[j] = Z.words[j] ^ z.words[j];
      if (this !== Z)
        for (; j < Z.length; j++)
          this.words[j] = Z.words[j];
      return this.length = Z.length, this._strip();
    }, a.prototype.ixor = function(T) {
      return r((this.negative | T.negative) === 0), this.iuxor(T);
    }, a.prototype.xor = function(T) {
      return this.length > T.length ? this.clone().ixor(T) : T.clone().ixor(this);
    }, a.prototype.uxor = function(T) {
      return this.length > T.length ? this.clone().iuxor(T) : T.clone().iuxor(this);
    }, a.prototype.inotn = function(T) {
      r(typeof T == "number" && T >= 0);
      var Z = Math.ceil(T / 26) | 0, z = T % 26;
      this._expand(Z), z > 0 && Z--;
      for (var j = 0; j < Z; j++)
        this.words[j] = ~this.words[j] & 67108863;
      return z > 0 && (this.words[j] = ~this.words[j] & 67108863 >> 26 - z), this._strip();
    }, a.prototype.notn = function(T) {
      return this.clone().inotn(T);
    }, a.prototype.setn = function(T, Z) {
      r(typeof T == "number" && T >= 0);
      var z = T / 26 | 0, j = T % 26;
      return this._expand(z + 1), Z ? this.words[z] = this.words[z] | 1 << j : this.words[z] = this.words[z] & ~(1 << j), this._strip();
    }, a.prototype.iadd = function(T) {
      var Z;
      if (this.negative !== 0 && T.negative === 0)
        return this.negative = 0, Z = this.isub(T), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && T.negative !== 0)
        return T.negative = 0, Z = this.isub(T), T.negative = 1, Z._normSign();
      var z, j;
      this.length > T.length ? (z = this, j = T) : (z = T, j = this);
      for (var w = 0, C = 0; C < j.length; C++)
        Z = (z.words[C] | 0) + (j.words[C] | 0) + w, this.words[C] = Z & 67108863, w = Z >>> 26;
      for (; w !== 0 && C < z.length; C++)
        Z = (z.words[C] | 0) + w, this.words[C] = Z & 67108863, w = Z >>> 26;
      if (this.length = z.length, w !== 0)
        this.words[this.length] = w, this.length++;
      else if (z !== this)
        for (; C < z.length; C++)
          this.words[C] = z.words[C];
      return this;
    }, a.prototype.add = function(T) {
      var Z;
      return T.negative !== 0 && this.negative === 0 ? (T.negative = 0, Z = this.sub(T), T.negative ^= 1, Z) : T.negative === 0 && this.negative !== 0 ? (this.negative = 0, Z = T.sub(this), this.negative = 1, Z) : this.length > T.length ? this.clone().iadd(T) : T.clone().iadd(this);
    }, a.prototype.isub = function(T) {
      if (T.negative !== 0) {
        T.negative = 0;
        var Z = this.iadd(T);
        return T.negative = 1, Z._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(T), this.negative = 1, this._normSign();
      var z = this.cmp(T);
      if (z === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var j, w;
      z > 0 ? (j = this, w = T) : (j = T, w = this);
      for (var C = 0, J = 0; J < w.length; J++)
        Z = (j.words[J] | 0) - (w.words[J] | 0) + C, C = Z >> 26, this.words[J] = Z & 67108863;
      for (; C !== 0 && J < j.length; J++)
        Z = (j.words[J] | 0) + C, C = Z >> 26, this.words[J] = Z & 67108863;
      if (C === 0 && J < j.length && j !== this)
        for (; J < j.length; J++)
          this.words[J] = j.words[J];
      return this.length = Math.max(this.length, J), j !== this && (this.negative = 1), this._strip();
    }, a.prototype.sub = function(T) {
      return this.clone().isub(T);
    };
    function R(O, T, Z) {
      Z.negative = T.negative ^ O.negative;
      var z = O.length + T.length | 0;
      Z.length = z, z = z - 1 | 0;
      var j = O.words[0] | 0, w = T.words[0] | 0, C = j * w, J = C & 67108863, I = C / 67108864 | 0;
      Z.words[0] = J;
      for (var b = 1; b < z; b++) {
        for (var k = I >>> 26, ae = I & 67108863, oe = Math.min(b, T.length - 1), le = Math.max(0, b - O.length + 1); le <= oe; le++) {
          var fe = b - le | 0;
          j = O.words[fe] | 0, w = T.words[le] | 0, C = j * w + ae, k += C / 67108864 | 0, ae = C & 67108863;
        }
        Z.words[b] = ae | 0, I = k | 0;
      }
      return I !== 0 ? Z.words[b] = I | 0 : Z.length--, Z._strip();
    }
    var V = function(T, Z, z) {
      var j = T.words, w = Z.words, C = z.words, J = 0, I, b, k, ae = j[0] | 0, oe = ae & 8191, le = ae >>> 13, fe = j[1] | 0, de = fe & 8191, Me = fe >>> 13, je = j[2] | 0, Se = je & 8191, se = je >>> 13, Ce = j[3] | 0, et = Ce & 8191, at = Ce >>> 13, Rn = j[4] | 0, Zt = Rn & 8191, kt = Rn >>> 13, Pn = j[5] | 0, Oe = Pn & 8191, Xe = Pn >>> 13, ft = j[6] | 0, Le = ft & 8191, dt = ft >>> 13, Dt = j[7] | 0, ut = Dt & 8191, v = Dt >>> 13, S = j[8] | 0, W = S & 8191, L = S >>> 13, P = j[9] | 0, q = P & 8191, ie = P >>> 13, Be = w[0] | 0, Je = Be & 8191, He = Be >>> 13, Qt = w[1] | 0, it = Qt & 8191, sn = Qt >>> 13, Ao = w[2] | 0, Pt = Ao & 8191, Ct = Ao >>> 13, no = w[3] | 0, wt = no & 8191, xn = no >>> 13, Ho = w[4] | 0, Wn = Ho & 8191, gn = Ho >>> 13, Xo = w[5] | 0, bt = Xo & 8191, jn = Xo >>> 13, _o = w[6] | 0, Dn = _o & 8191, zn = _o >>> 13, el = w[7] | 0, Lt = el & 8191, X = el >>> 13, he = w[8] | 0, pe = he & 8191, we = he >>> 13, It = w[9] | 0, _e = It & 8191, qe = It >>> 13;
      z.negative = T.negative ^ Z.negative, z.length = 19, I = Math.imul(oe, Je), b = Math.imul(oe, He), b = b + Math.imul(le, Je) | 0, k = Math.imul(le, He);
      var gt = (J + I | 0) + ((b & 8191) << 13) | 0;
      J = (k + (b >>> 13) | 0) + (gt >>> 26) | 0, gt &= 67108863, I = Math.imul(de, Je), b = Math.imul(de, He), b = b + Math.imul(Me, Je) | 0, k = Math.imul(Me, He), I = I + Math.imul(oe, it) | 0, b = b + Math.imul(oe, sn) | 0, b = b + Math.imul(le, it) | 0, k = k + Math.imul(le, sn) | 0;
      var Bn = (J + I | 0) + ((b & 8191) << 13) | 0;
      J = (k + (b >>> 13) | 0) + (Bn >>> 26) | 0, Bn &= 67108863, I = Math.imul(Se, Je), b = Math.imul(Se, He), b = b + Math.imul(se, Je) | 0, k = Math.imul(se, He), I = I + Math.imul(de, it) | 0, b = b + Math.imul(de, sn) | 0, b = b + Math.imul(Me, it) | 0, k = k + Math.imul(Me, sn) | 0, I = I + Math.imul(oe, Pt) | 0, b = b + Math.imul(oe, Ct) | 0, b = b + Math.imul(le, Pt) | 0, k = k + Math.imul(le, Ct) | 0;
      var Mn = (J + I | 0) + ((b & 8191) << 13) | 0;
      J = (k + (b >>> 13) | 0) + (Mn >>> 26) | 0, Mn &= 67108863, I = Math.imul(et, Je), b = Math.imul(et, He), b = b + Math.imul(at, Je) | 0, k = Math.imul(at, He), I = I + Math.imul(Se, it) | 0, b = b + Math.imul(Se, sn) | 0, b = b + Math.imul(se, it) | 0, k = k + Math.imul(se, sn) | 0, I = I + Math.imul(de, Pt) | 0, b = b + Math.imul(de, Ct) | 0, b = b + Math.imul(Me, Pt) | 0, k = k + Math.imul(Me, Ct) | 0, I = I + Math.imul(oe, wt) | 0, b = b + Math.imul(oe, xn) | 0, b = b + Math.imul(le, wt) | 0, k = k + Math.imul(le, xn) | 0;
      var fn = (J + I | 0) + ((b & 8191) << 13) | 0;
      J = (k + (b >>> 13) | 0) + (fn >>> 26) | 0, fn &= 67108863, I = Math.imul(Zt, Je), b = Math.imul(Zt, He), b = b + Math.imul(kt, Je) | 0, k = Math.imul(kt, He), I = I + Math.imul(et, it) | 0, b = b + Math.imul(et, sn) | 0, b = b + Math.imul(at, it) | 0, k = k + Math.imul(at, sn) | 0, I = I + Math.imul(Se, Pt) | 0, b = b + Math.imul(Se, Ct) | 0, b = b + Math.imul(se, Pt) | 0, k = k + Math.imul(se, Ct) | 0, I = I + Math.imul(de, wt) | 0, b = b + Math.imul(de, xn) | 0, b = b + Math.imul(Me, wt) | 0, k = k + Math.imul(Me, xn) | 0, I = I + Math.imul(oe, Wn) | 0, b = b + Math.imul(oe, gn) | 0, b = b + Math.imul(le, Wn) | 0, k = k + Math.imul(le, gn) | 0;
      var lr = (J + I | 0) + ((b & 8191) << 13) | 0;
      J = (k + (b >>> 13) | 0) + (lr >>> 26) | 0, lr &= 67108863, I = Math.imul(Oe, Je), b = Math.imul(Oe, He), b = b + Math.imul(Xe, Je) | 0, k = Math.imul(Xe, He), I = I + Math.imul(Zt, it) | 0, b = b + Math.imul(Zt, sn) | 0, b = b + Math.imul(kt, it) | 0, k = k + Math.imul(kt, sn) | 0, I = I + Math.imul(et, Pt) | 0, b = b + Math.imul(et, Ct) | 0, b = b + Math.imul(at, Pt) | 0, k = k + Math.imul(at, Ct) | 0, I = I + Math.imul(Se, wt) | 0, b = b + Math.imul(Se, xn) | 0, b = b + Math.imul(se, wt) | 0, k = k + Math.imul(se, xn) | 0, I = I + Math.imul(de, Wn) | 0, b = b + Math.imul(de, gn) | 0, b = b + Math.imul(Me, Wn) | 0, k = k + Math.imul(Me, gn) | 0, I = I + Math.imul(oe, bt) | 0, b = b + Math.imul(oe, jn) | 0, b = b + Math.imul(le, bt) | 0, k = k + Math.imul(le, jn) | 0;
      var Zr = (J + I | 0) + ((b & 8191) << 13) | 0;
      J = (k + (b >>> 13) | 0) + (Zr >>> 26) | 0, Zr &= 67108863, I = Math.imul(Le, Je), b = Math.imul(Le, He), b = b + Math.imul(dt, Je) | 0, k = Math.imul(dt, He), I = I + Math.imul(Oe, it) | 0, b = b + Math.imul(Oe, sn) | 0, b = b + Math.imul(Xe, it) | 0, k = k + Math.imul(Xe, sn) | 0, I = I + Math.imul(Zt, Pt) | 0, b = b + Math.imul(Zt, Ct) | 0, b = b + Math.imul(kt, Pt) | 0, k = k + Math.imul(kt, Ct) | 0, I = I + Math.imul(et, wt) | 0, b = b + Math.imul(et, xn) | 0, b = b + Math.imul(at, wt) | 0, k = k + Math.imul(at, xn) | 0, I = I + Math.imul(Se, Wn) | 0, b = b + Math.imul(Se, gn) | 0, b = b + Math.imul(se, Wn) | 0, k = k + Math.imul(se, gn) | 0, I = I + Math.imul(de, bt) | 0, b = b + Math.imul(de, jn) | 0, b = b + Math.imul(Me, bt) | 0, k = k + Math.imul(Me, jn) | 0, I = I + Math.imul(oe, Dn) | 0, b = b + Math.imul(oe, zn) | 0, b = b + Math.imul(le, Dn) | 0, k = k + Math.imul(le, zn) | 0;
      var ro = (J + I | 0) + ((b & 8191) << 13) | 0;
      J = (k + (b >>> 13) | 0) + (ro >>> 26) | 0, ro &= 67108863, I = Math.imul(ut, Je), b = Math.imul(ut, He), b = b + Math.imul(v, Je) | 0, k = Math.imul(v, He), I = I + Math.imul(Le, it) | 0, b = b + Math.imul(Le, sn) | 0, b = b + Math.imul(dt, it) | 0, k = k + Math.imul(dt, sn) | 0, I = I + Math.imul(Oe, Pt) | 0, b = b + Math.imul(Oe, Ct) | 0, b = b + Math.imul(Xe, Pt) | 0, k = k + Math.imul(Xe, Ct) | 0, I = I + Math.imul(Zt, wt) | 0, b = b + Math.imul(Zt, xn) | 0, b = b + Math.imul(kt, wt) | 0, k = k + Math.imul(kt, xn) | 0, I = I + Math.imul(et, Wn) | 0, b = b + Math.imul(et, gn) | 0, b = b + Math.imul(at, Wn) | 0, k = k + Math.imul(at, gn) | 0, I = I + Math.imul(Se, bt) | 0, b = b + Math.imul(Se, jn) | 0, b = b + Math.imul(se, bt) | 0, k = k + Math.imul(se, jn) | 0, I = I + Math.imul(de, Dn) | 0, b = b + Math.imul(de, zn) | 0, b = b + Math.imul(Me, Dn) | 0, k = k + Math.imul(Me, zn) | 0, I = I + Math.imul(oe, Lt) | 0, b = b + Math.imul(oe, X) | 0, b = b + Math.imul(le, Lt) | 0, k = k + Math.imul(le, X) | 0;
      var An = (J + I | 0) + ((b & 8191) << 13) | 0;
      J = (k + (b >>> 13) | 0) + (An >>> 26) | 0, An &= 67108863, I = Math.imul(W, Je), b = Math.imul(W, He), b = b + Math.imul(L, Je) | 0, k = Math.imul(L, He), I = I + Math.imul(ut, it) | 0, b = b + Math.imul(ut, sn) | 0, b = b + Math.imul(v, it) | 0, k = k + Math.imul(v, sn) | 0, I = I + Math.imul(Le, Pt) | 0, b = b + Math.imul(Le, Ct) | 0, b = b + Math.imul(dt, Pt) | 0, k = k + Math.imul(dt, Ct) | 0, I = I + Math.imul(Oe, wt) | 0, b = b + Math.imul(Oe, xn) | 0, b = b + Math.imul(Xe, wt) | 0, k = k + Math.imul(Xe, xn) | 0, I = I + Math.imul(Zt, Wn) | 0, b = b + Math.imul(Zt, gn) | 0, b = b + Math.imul(kt, Wn) | 0, k = k + Math.imul(kt, gn) | 0, I = I + Math.imul(et, bt) | 0, b = b + Math.imul(et, jn) | 0, b = b + Math.imul(at, bt) | 0, k = k + Math.imul(at, jn) | 0, I = I + Math.imul(Se, Dn) | 0, b = b + Math.imul(Se, zn) | 0, b = b + Math.imul(se, Dn) | 0, k = k + Math.imul(se, zn) | 0, I = I + Math.imul(de, Lt) | 0, b = b + Math.imul(de, X) | 0, b = b + Math.imul(Me, Lt) | 0, k = k + Math.imul(Me, X) | 0, I = I + Math.imul(oe, pe) | 0, b = b + Math.imul(oe, we) | 0, b = b + Math.imul(le, pe) | 0, k = k + Math.imul(le, we) | 0;
      var wa = (J + I | 0) + ((b & 8191) << 13) | 0;
      J = (k + (b >>> 13) | 0) + (wa >>> 26) | 0, wa &= 67108863, I = Math.imul(q, Je), b = Math.imul(q, He), b = b + Math.imul(ie, Je) | 0, k = Math.imul(ie, He), I = I + Math.imul(W, it) | 0, b = b + Math.imul(W, sn) | 0, b = b + Math.imul(L, it) | 0, k = k + Math.imul(L, sn) | 0, I = I + Math.imul(ut, Pt) | 0, b = b + Math.imul(ut, Ct) | 0, b = b + Math.imul(v, Pt) | 0, k = k + Math.imul(v, Ct) | 0, I = I + Math.imul(Le, wt) | 0, b = b + Math.imul(Le, xn) | 0, b = b + Math.imul(dt, wt) | 0, k = k + Math.imul(dt, xn) | 0, I = I + Math.imul(Oe, Wn) | 0, b = b + Math.imul(Oe, gn) | 0, b = b + Math.imul(Xe, Wn) | 0, k = k + Math.imul(Xe, gn) | 0, I = I + Math.imul(Zt, bt) | 0, b = b + Math.imul(Zt, jn) | 0, b = b + Math.imul(kt, bt) | 0, k = k + Math.imul(kt, jn) | 0, I = I + Math.imul(et, Dn) | 0, b = b + Math.imul(et, zn) | 0, b = b + Math.imul(at, Dn) | 0, k = k + Math.imul(at, zn) | 0, I = I + Math.imul(Se, Lt) | 0, b = b + Math.imul(Se, X) | 0, b = b + Math.imul(se, Lt) | 0, k = k + Math.imul(se, X) | 0, I = I + Math.imul(de, pe) | 0, b = b + Math.imul(de, we) | 0, b = b + Math.imul(Me, pe) | 0, k = k + Math.imul(Me, we) | 0, I = I + Math.imul(oe, _e) | 0, b = b + Math.imul(oe, qe) | 0, b = b + Math.imul(le, _e) | 0, k = k + Math.imul(le, qe) | 0;
      var kc = (J + I | 0) + ((b & 8191) << 13) | 0;
      J = (k + (b >>> 13) | 0) + (kc >>> 26) | 0, kc &= 67108863, I = Math.imul(q, it), b = Math.imul(q, sn), b = b + Math.imul(ie, it) | 0, k = Math.imul(ie, sn), I = I + Math.imul(W, Pt) | 0, b = b + Math.imul(W, Ct) | 0, b = b + Math.imul(L, Pt) | 0, k = k + Math.imul(L, Ct) | 0, I = I + Math.imul(ut, wt) | 0, b = b + Math.imul(ut, xn) | 0, b = b + Math.imul(v, wt) | 0, k = k + Math.imul(v, xn) | 0, I = I + Math.imul(Le, Wn) | 0, b = b + Math.imul(Le, gn) | 0, b = b + Math.imul(dt, Wn) | 0, k = k + Math.imul(dt, gn) | 0, I = I + Math.imul(Oe, bt) | 0, b = b + Math.imul(Oe, jn) | 0, b = b + Math.imul(Xe, bt) | 0, k = k + Math.imul(Xe, jn) | 0, I = I + Math.imul(Zt, Dn) | 0, b = b + Math.imul(Zt, zn) | 0, b = b + Math.imul(kt, Dn) | 0, k = k + Math.imul(kt, zn) | 0, I = I + Math.imul(et, Lt) | 0, b = b + Math.imul(et, X) | 0, b = b + Math.imul(at, Lt) | 0, k = k + Math.imul(at, X) | 0, I = I + Math.imul(Se, pe) | 0, b = b + Math.imul(Se, we) | 0, b = b + Math.imul(se, pe) | 0, k = k + Math.imul(se, we) | 0, I = I + Math.imul(de, _e) | 0, b = b + Math.imul(de, qe) | 0, b = b + Math.imul(Me, _e) | 0, k = k + Math.imul(Me, qe) | 0;
      var Ci = (J + I | 0) + ((b & 8191) << 13) | 0;
      J = (k + (b >>> 13) | 0) + (Ci >>> 26) | 0, Ci &= 67108863, I = Math.imul(q, Pt), b = Math.imul(q, Ct), b = b + Math.imul(ie, Pt) | 0, k = Math.imul(ie, Ct), I = I + Math.imul(W, wt) | 0, b = b + Math.imul(W, xn) | 0, b = b + Math.imul(L, wt) | 0, k = k + Math.imul(L, xn) | 0, I = I + Math.imul(ut, Wn) | 0, b = b + Math.imul(ut, gn) | 0, b = b + Math.imul(v, Wn) | 0, k = k + Math.imul(v, gn) | 0, I = I + Math.imul(Le, bt) | 0, b = b + Math.imul(Le, jn) | 0, b = b + Math.imul(dt, bt) | 0, k = k + Math.imul(dt, jn) | 0, I = I + Math.imul(Oe, Dn) | 0, b = b + Math.imul(Oe, zn) | 0, b = b + Math.imul(Xe, Dn) | 0, k = k + Math.imul(Xe, zn) | 0, I = I + Math.imul(Zt, Lt) | 0, b = b + Math.imul(Zt, X) | 0, b = b + Math.imul(kt, Lt) | 0, k = k + Math.imul(kt, X) | 0, I = I + Math.imul(et, pe) | 0, b = b + Math.imul(et, we) | 0, b = b + Math.imul(at, pe) | 0, k = k + Math.imul(at, we) | 0, I = I + Math.imul(Se, _e) | 0, b = b + Math.imul(Se, qe) | 0, b = b + Math.imul(se, _e) | 0, k = k + Math.imul(se, qe) | 0;
      var Po = (J + I | 0) + ((b & 8191) << 13) | 0;
      J = (k + (b >>> 13) | 0) + (Po >>> 26) | 0, Po &= 67108863, I = Math.imul(q, wt), b = Math.imul(q, xn), b = b + Math.imul(ie, wt) | 0, k = Math.imul(ie, xn), I = I + Math.imul(W, Wn) | 0, b = b + Math.imul(W, gn) | 0, b = b + Math.imul(L, Wn) | 0, k = k + Math.imul(L, gn) | 0, I = I + Math.imul(ut, bt) | 0, b = b + Math.imul(ut, jn) | 0, b = b + Math.imul(v, bt) | 0, k = k + Math.imul(v, jn) | 0, I = I + Math.imul(Le, Dn) | 0, b = b + Math.imul(Le, zn) | 0, b = b + Math.imul(dt, Dn) | 0, k = k + Math.imul(dt, zn) | 0, I = I + Math.imul(Oe, Lt) | 0, b = b + Math.imul(Oe, X) | 0, b = b + Math.imul(Xe, Lt) | 0, k = k + Math.imul(Xe, X) | 0, I = I + Math.imul(Zt, pe) | 0, b = b + Math.imul(Zt, we) | 0, b = b + Math.imul(kt, pe) | 0, k = k + Math.imul(kt, we) | 0, I = I + Math.imul(et, _e) | 0, b = b + Math.imul(et, qe) | 0, b = b + Math.imul(at, _e) | 0, k = k + Math.imul(at, qe) | 0;
      var wc = (J + I | 0) + ((b & 8191) << 13) | 0;
      J = (k + (b >>> 13) | 0) + (wc >>> 26) | 0, wc &= 67108863, I = Math.imul(q, Wn), b = Math.imul(q, gn), b = b + Math.imul(ie, Wn) | 0, k = Math.imul(ie, gn), I = I + Math.imul(W, bt) | 0, b = b + Math.imul(W, jn) | 0, b = b + Math.imul(L, bt) | 0, k = k + Math.imul(L, jn) | 0, I = I + Math.imul(ut, Dn) | 0, b = b + Math.imul(ut, zn) | 0, b = b + Math.imul(v, Dn) | 0, k = k + Math.imul(v, zn) | 0, I = I + Math.imul(Le, Lt) | 0, b = b + Math.imul(Le, X) | 0, b = b + Math.imul(dt, Lt) | 0, k = k + Math.imul(dt, X) | 0, I = I + Math.imul(Oe, pe) | 0, b = b + Math.imul(Oe, we) | 0, b = b + Math.imul(Xe, pe) | 0, k = k + Math.imul(Xe, we) | 0, I = I + Math.imul(Zt, _e) | 0, b = b + Math.imul(Zt, qe) | 0, b = b + Math.imul(kt, _e) | 0, k = k + Math.imul(kt, qe) | 0;
      var Fc = (J + I | 0) + ((b & 8191) << 13) | 0;
      J = (k + (b >>> 13) | 0) + (Fc >>> 26) | 0, Fc &= 67108863, I = Math.imul(q, bt), b = Math.imul(q, jn), b = b + Math.imul(ie, bt) | 0, k = Math.imul(ie, jn), I = I + Math.imul(W, Dn) | 0, b = b + Math.imul(W, zn) | 0, b = b + Math.imul(L, Dn) | 0, k = k + Math.imul(L, zn) | 0, I = I + Math.imul(ut, Lt) | 0, b = b + Math.imul(ut, X) | 0, b = b + Math.imul(v, Lt) | 0, k = k + Math.imul(v, X) | 0, I = I + Math.imul(Le, pe) | 0, b = b + Math.imul(Le, we) | 0, b = b + Math.imul(dt, pe) | 0, k = k + Math.imul(dt, we) | 0, I = I + Math.imul(Oe, _e) | 0, b = b + Math.imul(Oe, qe) | 0, b = b + Math.imul(Xe, _e) | 0, k = k + Math.imul(Xe, qe) | 0;
      var vc = (J + I | 0) + ((b & 8191) << 13) | 0;
      J = (k + (b >>> 13) | 0) + (vc >>> 26) | 0, vc &= 67108863, I = Math.imul(q, Dn), b = Math.imul(q, zn), b = b + Math.imul(ie, Dn) | 0, k = Math.imul(ie, zn), I = I + Math.imul(W, Lt) | 0, b = b + Math.imul(W, X) | 0, b = b + Math.imul(L, Lt) | 0, k = k + Math.imul(L, X) | 0, I = I + Math.imul(ut, pe) | 0, b = b + Math.imul(ut, we) | 0, b = b + Math.imul(v, pe) | 0, k = k + Math.imul(v, we) | 0, I = I + Math.imul(Le, _e) | 0, b = b + Math.imul(Le, qe) | 0, b = b + Math.imul(dt, _e) | 0, k = k + Math.imul(dt, qe) | 0;
      var io = (J + I | 0) + ((b & 8191) << 13) | 0;
      J = (k + (b >>> 13) | 0) + (io >>> 26) | 0, io &= 67108863, I = Math.imul(q, Lt), b = Math.imul(q, X), b = b + Math.imul(ie, Lt) | 0, k = Math.imul(ie, X), I = I + Math.imul(W, pe) | 0, b = b + Math.imul(W, we) | 0, b = b + Math.imul(L, pe) | 0, k = k + Math.imul(L, we) | 0, I = I + Math.imul(ut, _e) | 0, b = b + Math.imul(ut, qe) | 0, b = b + Math.imul(v, _e) | 0, k = k + Math.imul(v, qe) | 0;
      var Ic = (J + I | 0) + ((b & 8191) << 13) | 0;
      J = (k + (b >>> 13) | 0) + (Ic >>> 26) | 0, Ic &= 67108863, I = Math.imul(q, pe), b = Math.imul(q, we), b = b + Math.imul(ie, pe) | 0, k = Math.imul(ie, we), I = I + Math.imul(W, _e) | 0, b = b + Math.imul(W, qe) | 0, b = b + Math.imul(L, _e) | 0, k = k + Math.imul(L, qe) | 0;
      var tl = (J + I | 0) + ((b & 8191) << 13) | 0;
      J = (k + (b >>> 13) | 0) + (tl >>> 26) | 0, tl &= 67108863, I = Math.imul(q, _e), b = Math.imul(q, qe), b = b + Math.imul(ie, _e) | 0, k = Math.imul(ie, qe);
      var Oc = (J + I | 0) + ((b & 8191) << 13) | 0;
      return J = (k + (b >>> 13) | 0) + (Oc >>> 26) | 0, Oc &= 67108863, C[0] = gt, C[1] = Bn, C[2] = Mn, C[3] = fn, C[4] = lr, C[5] = Zr, C[6] = ro, C[7] = An, C[8] = wa, C[9] = kc, C[10] = Ci, C[11] = Po, C[12] = wc, C[13] = Fc, C[14] = vc, C[15] = io, C[16] = Ic, C[17] = tl, C[18] = Oc, J !== 0 && (C[19] = J, z.length++), z;
    };
    Math.imul || (V = R);
    function U(O, T, Z) {
      Z.negative = T.negative ^ O.negative, Z.length = O.length + T.length;
      for (var z = 0, j = 0, w = 0; w < Z.length - 1; w++) {
        var C = j;
        j = 0;
        for (var J = z & 67108863, I = Math.min(w, T.length - 1), b = Math.max(0, w - O.length + 1); b <= I; b++) {
          var k = w - b, ae = O.words[k] | 0, oe = T.words[b] | 0, le = ae * oe, fe = le & 67108863;
          C = C + (le / 67108864 | 0) | 0, fe = fe + J | 0, J = fe & 67108863, C = C + (fe >>> 26) | 0, j += C >>> 26, C &= 67108863;
        }
        Z.words[w] = J, z = C, C = j;
      }
      return z !== 0 ? Z.words[w] = z : Z.length--, Z._strip();
    }
    function g(O, T, Z) {
      return U(O, T, Z);
    }
    a.prototype.mulTo = function(T, Z) {
      var z, j = this.length + T.length;
      return this.length === 10 && T.length === 10 ? z = V(this, T, Z) : j < 63 ? z = R(this, T, Z) : j < 1024 ? z = U(this, T, Z) : z = g(this, T, Z), z;
    }, a.prototype.mul = function(T) {
      var Z = new a(null);
      return Z.words = new Array(this.length + T.length), this.mulTo(T, Z);
    }, a.prototype.mulf = function(T) {
      var Z = new a(null);
      return Z.words = new Array(this.length + T.length), g(this, T, Z);
    }, a.prototype.imul = function(T) {
      return this.clone().mulTo(T, this);
    }, a.prototype.imuln = function(T) {
      var Z = T < 0;
      Z && (T = -T), r(typeof T == "number"), r(T < 67108864);
      for (var z = 0, j = 0; j < this.length; j++) {
        var w = (this.words[j] | 0) * T, C = (w & 67108863) + (z & 67108863);
        z >>= 26, z += w / 67108864 | 0, z += C >>> 26, this.words[j] = C & 67108863;
      }
      return z !== 0 && (this.words[j] = z, this.length++), Z ? this.ineg() : this;
    }, a.prototype.muln = function(T) {
      return this.clone().imuln(T);
    }, a.prototype.sqr = function() {
      return this.mul(this);
    }, a.prototype.isqr = function() {
      return this.imul(this.clone());
    }, a.prototype.pow = function(T) {
      var Z = m(T);
      if (Z.length === 0)
        return new a(1);
      for (var z = this, j = 0; j < Z.length && Z[j] === 0; j++, z = z.sqr())
        ;
      if (++j < Z.length)
        for (var w = z.sqr(); j < Z.length; j++, w = w.sqr())
          Z[j] !== 0 && (z = z.mul(w));
      return z;
    }, a.prototype.iushln = function(T) {
      r(typeof T == "number" && T >= 0);
      var Z = T % 26, z = (T - Z) / 26, j = 67108863 >>> 26 - Z << 26 - Z, w;
      if (Z !== 0) {
        var C = 0;
        for (w = 0; w < this.length; w++) {
          var J = this.words[w] & j, I = (this.words[w] | 0) - J << Z;
          this.words[w] = I | C, C = J >>> 26 - Z;
        }
        C && (this.words[w] = C, this.length++);
      }
      if (z !== 0) {
        for (w = this.length - 1; w >= 0; w--)
          this.words[w + z] = this.words[w];
        for (w = 0; w < z; w++)
          this.words[w] = 0;
        this.length += z;
      }
      return this._strip();
    }, a.prototype.ishln = function(T) {
      return r(this.negative === 0), this.iushln(T);
    }, a.prototype.iushrn = function(T, Z, z) {
      r(typeof T == "number" && T >= 0);
      var j;
      Z ? j = (Z - Z % 26) / 26 : j = 0;
      var w = T % 26, C = Math.min((T - w) / 26, this.length), J = 67108863 ^ 67108863 >>> w << w, I = z;
      if (j -= C, j = Math.max(0, j), I) {
        for (var b = 0; b < C; b++)
          I.words[b] = this.words[b];
        I.length = C;
      }
      if (C !== 0)
        if (this.length > C)
          for (this.length -= C, b = 0; b < this.length; b++)
            this.words[b] = this.words[b + C];
        else
          this.words[0] = 0, this.length = 1;
      var k = 0;
      for (b = this.length - 1; b >= 0 && (k !== 0 || b >= j); b--) {
        var ae = this.words[b] | 0;
        this.words[b] = k << 26 - w | ae >>> w, k = ae & J;
      }
      return I && k !== 0 && (I.words[I.length++] = k), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, a.prototype.ishrn = function(T, Z, z) {
      return r(this.negative === 0), this.iushrn(T, Z, z);
    }, a.prototype.shln = function(T) {
      return this.clone().ishln(T);
    }, a.prototype.ushln = function(T) {
      return this.clone().iushln(T);
    }, a.prototype.shrn = function(T) {
      return this.clone().ishrn(T);
    }, a.prototype.ushrn = function(T) {
      return this.clone().iushrn(T);
    }, a.prototype.testn = function(T) {
      r(typeof T == "number" && T >= 0);
      var Z = T % 26, z = (T - Z) / 26, j = 1 << Z;
      if (this.length <= z)
        return !1;
      var w = this.words[z];
      return !!(w & j);
    }, a.prototype.imaskn = function(T) {
      r(typeof T == "number" && T >= 0);
      var Z = T % 26, z = (T - Z) / 26;
      if (r(this.negative === 0, "imaskn works only with positive numbers"), this.length <= z)
        return this;
      if (Z !== 0 && z++, this.length = Math.min(z, this.length), Z !== 0) {
        var j = 67108863 ^ 67108863 >>> Z << Z;
        this.words[this.length - 1] &= j;
      }
      return this._strip();
    }, a.prototype.maskn = function(T) {
      return this.clone().imaskn(T);
    }, a.prototype.iaddn = function(T) {
      return r(typeof T == "number"), r(T < 67108864), T < 0 ? this.isubn(-T) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= T ? (this.words[0] = T - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(T), this.negative = 1, this) : this._iaddn(T);
    }, a.prototype._iaddn = function(T) {
      this.words[0] += T;
      for (var Z = 0; Z < this.length && this.words[Z] >= 67108864; Z++)
        this.words[Z] -= 67108864, Z === this.length - 1 ? this.words[Z + 1] = 1 : this.words[Z + 1]++;
      return this.length = Math.max(this.length, Z + 1), this;
    }, a.prototype.isubn = function(T) {
      if (r(typeof T == "number"), r(T < 67108864), T < 0)
        return this.iaddn(-T);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(T), this.negative = 1, this;
      if (this.words[0] -= T, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var Z = 0; Z < this.length && this.words[Z] < 0; Z++)
          this.words[Z] += 67108864, this.words[Z + 1] -= 1;
      return this._strip();
    }, a.prototype.addn = function(T) {
      return this.clone().iaddn(T);
    }, a.prototype.subn = function(T) {
      return this.clone().isubn(T);
    }, a.prototype.iabs = function() {
      return this.negative = 0, this;
    }, a.prototype.abs = function() {
      return this.clone().iabs();
    }, a.prototype._ishlnsubmul = function(T, Z, z) {
      var j = T.length + z, w;
      this._expand(j);
      var C, J = 0;
      for (w = 0; w < T.length; w++) {
        C = (this.words[w + z] | 0) + J;
        var I = (T.words[w] | 0) * Z;
        C -= I & 67108863, J = (C >> 26) - (I / 67108864 | 0), this.words[w + z] = C & 67108863;
      }
      for (; w < this.length - z; w++)
        C = (this.words[w + z] | 0) + J, J = C >> 26, this.words[w + z] = C & 67108863;
      if (J === 0)
        return this._strip();
      for (r(J === -1), J = 0, w = 0; w < this.length; w++)
        C = -(this.words[w] | 0) + J, J = C >> 26, this.words[w] = C & 67108863;
      return this.negative = 1, this._strip();
    }, a.prototype._wordDiv = function(T, Z) {
      var z = this.length - T.length, j = this.clone(), w = T, C = w.words[w.length - 1] | 0, J = this._countBits(C);
      z = 26 - J, z !== 0 && (w = w.ushln(z), j.iushln(z), C = w.words[w.length - 1] | 0);
      var I = j.length - w.length, b;
      if (Z !== "mod") {
        b = new a(null), b.length = I + 1, b.words = new Array(b.length);
        for (var k = 0; k < b.length; k++)
          b.words[k] = 0;
      }
      var ae = j.clone()._ishlnsubmul(w, 1, I);
      ae.negative === 0 && (j = ae, b && (b.words[I] = 1));
      for (var oe = I - 1; oe >= 0; oe--) {
        var le = (j.words[w.length + oe] | 0) * 67108864 + (j.words[w.length + oe - 1] | 0);
        for (le = Math.min(le / C | 0, 67108863), j._ishlnsubmul(w, le, oe); j.negative !== 0; )
          le--, j.negative = 0, j._ishlnsubmul(w, 1, oe), j.isZero() || (j.negative ^= 1);
        b && (b.words[oe] = le);
      }
      return b && b._strip(), j._strip(), Z !== "div" && z !== 0 && j.iushrn(z), {
        div: b || null,
        mod: j
      };
    }, a.prototype.divmod = function(T, Z, z) {
      if (r(!T.isZero()), this.isZero())
        return {
          div: new a(0),
          mod: new a(0)
        };
      var j, w, C;
      return this.negative !== 0 && T.negative === 0 ? (C = this.neg().divmod(T, Z), Z !== "mod" && (j = C.div.neg()), Z !== "div" && (w = C.mod.neg(), z && w.negative !== 0 && w.iadd(T)), {
        div: j,
        mod: w
      }) : this.negative === 0 && T.negative !== 0 ? (C = this.divmod(T.neg(), Z), Z !== "mod" && (j = C.div.neg()), {
        div: j,
        mod: C.mod
      }) : this.negative & T.negative ? (C = this.neg().divmod(T.neg(), Z), Z !== "div" && (w = C.mod.neg(), z && w.negative !== 0 && w.isub(T)), {
        div: C.div,
        mod: w
      }) : T.length > this.length || this.cmp(T) < 0 ? {
        div: new a(0),
        mod: this
      } : T.length === 1 ? Z === "div" ? {
        div: this.divn(T.words[0]),
        mod: null
      } : Z === "mod" ? {
        div: null,
        mod: new a(this.modrn(T.words[0]))
      } : {
        div: this.divn(T.words[0]),
        mod: new a(this.modrn(T.words[0]))
      } : this._wordDiv(T, Z);
    }, a.prototype.div = function(T) {
      return this.divmod(T, "div", !1).div;
    }, a.prototype.mod = function(T) {
      return this.divmod(T, "mod", !1).mod;
    }, a.prototype.umod = function(T) {
      return this.divmod(T, "mod", !0).mod;
    }, a.prototype.divRound = function(T) {
      var Z = this.divmod(T);
      if (Z.mod.isZero())
        return Z.div;
      var z = Z.div.negative !== 0 ? Z.mod.isub(T) : Z.mod, j = T.ushrn(1), w = T.andln(1), C = z.cmp(j);
      return C < 0 || w === 1 && C === 0 ? Z.div : Z.div.negative !== 0 ? Z.div.isubn(1) : Z.div.iaddn(1);
    }, a.prototype.modrn = function(T) {
      var Z = T < 0;
      Z && (T = -T), r(T <= 67108863);
      for (var z = (1 << 26) % T, j = 0, w = this.length - 1; w >= 0; w--)
        j = (z * j + (this.words[w] | 0)) % T;
      return Z ? -j : j;
    }, a.prototype.modn = function(T) {
      return this.modrn(T);
    }, a.prototype.idivn = function(T) {
      var Z = T < 0;
      Z && (T = -T), r(T <= 67108863);
      for (var z = 0, j = this.length - 1; j >= 0; j--) {
        var w = (this.words[j] | 0) + z * 67108864;
        this.words[j] = w / T | 0, z = w % T;
      }
      return this._strip(), Z ? this.ineg() : this;
    }, a.prototype.divn = function(T) {
      return this.clone().idivn(T);
    }, a.prototype.egcd = function(T) {
      r(T.negative === 0), r(!T.isZero());
      var Z = this, z = T.clone();
      Z.negative !== 0 ? Z = Z.umod(T) : Z = Z.clone();
      for (var j = new a(1), w = new a(0), C = new a(0), J = new a(1), I = 0; Z.isEven() && z.isEven(); )
        Z.iushrn(1), z.iushrn(1), ++I;
      for (var b = z.clone(), k = Z.clone(); !Z.isZero(); ) {
        for (var ae = 0, oe = 1; !(Z.words[0] & oe) && ae < 26; ++ae, oe <<= 1)
          ;
        if (ae > 0)
          for (Z.iushrn(ae); ae-- > 0; )
            (j.isOdd() || w.isOdd()) && (j.iadd(b), w.isub(k)), j.iushrn(1), w.iushrn(1);
        for (var le = 0, fe = 1; !(z.words[0] & fe) && le < 26; ++le, fe <<= 1)
          ;
        if (le > 0)
          for (z.iushrn(le); le-- > 0; )
            (C.isOdd() || J.isOdd()) && (C.iadd(b), J.isub(k)), C.iushrn(1), J.iushrn(1);
        Z.cmp(z) >= 0 ? (Z.isub(z), j.isub(C), w.isub(J)) : (z.isub(Z), C.isub(j), J.isub(w));
      }
      return {
        a: C,
        b: J,
        gcd: z.iushln(I)
      };
    }, a.prototype._invmp = function(T) {
      r(T.negative === 0), r(!T.isZero());
      var Z = this, z = T.clone();
      Z.negative !== 0 ? Z = Z.umod(T) : Z = Z.clone();
      for (var j = new a(1), w = new a(0), C = z.clone(); Z.cmpn(1) > 0 && z.cmpn(1) > 0; ) {
        for (var J = 0, I = 1; !(Z.words[0] & I) && J < 26; ++J, I <<= 1)
          ;
        if (J > 0)
          for (Z.iushrn(J); J-- > 0; )
            j.isOdd() && j.iadd(C), j.iushrn(1);
        for (var b = 0, k = 1; !(z.words[0] & k) && b < 26; ++b, k <<= 1)
          ;
        if (b > 0)
          for (z.iushrn(b); b-- > 0; )
            w.isOdd() && w.iadd(C), w.iushrn(1);
        Z.cmp(z) >= 0 ? (Z.isub(z), j.isub(w)) : (z.isub(Z), w.isub(j));
      }
      var ae;
      return Z.cmpn(1) === 0 ? ae = j : ae = w, ae.cmpn(0) < 0 && ae.iadd(T), ae;
    }, a.prototype.gcd = function(T) {
      if (this.isZero())
        return T.abs();
      if (T.isZero())
        return this.abs();
      var Z = this.clone(), z = T.clone();
      Z.negative = 0, z.negative = 0;
      for (var j = 0; Z.isEven() && z.isEven(); j++)
        Z.iushrn(1), z.iushrn(1);
      do {
        for (; Z.isEven(); )
          Z.iushrn(1);
        for (; z.isEven(); )
          z.iushrn(1);
        var w = Z.cmp(z);
        if (w < 0) {
          var C = Z;
          Z = z, z = C;
        } else if (w === 0 || z.cmpn(1) === 0)
          break;
        Z.isub(z);
      } while (!0);
      return z.iushln(j);
    }, a.prototype.invm = function(T) {
      return this.egcd(T).a.umod(T);
    }, a.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, a.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, a.prototype.andln = function(T) {
      return this.words[0] & T;
    }, a.prototype.bincn = function(T) {
      r(typeof T == "number");
      var Z = T % 26, z = (T - Z) / 26, j = 1 << Z;
      if (this.length <= z)
        return this._expand(z + 1), this.words[z] |= j, this;
      for (var w = j, C = z; w !== 0 && C < this.length; C++) {
        var J = this.words[C] | 0;
        J += w, w = J >>> 26, J &= 67108863, this.words[C] = J;
      }
      return w !== 0 && (this.words[C] = w, this.length++), this;
    }, a.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, a.prototype.cmpn = function(T) {
      var Z = T < 0;
      if (this.negative !== 0 && !Z)
        return -1;
      if (this.negative === 0 && Z)
        return 1;
      this._strip();
      var z;
      if (this.length > 1)
        z = 1;
      else {
        Z && (T = -T), r(T <= 67108863, "Number is too big");
        var j = this.words[0] | 0;
        z = j === T ? 0 : j < T ? -1 : 1;
      }
      return this.negative !== 0 ? -z | 0 : z;
    }, a.prototype.cmp = function(T) {
      if (this.negative !== 0 && T.negative === 0)
        return -1;
      if (this.negative === 0 && T.negative !== 0)
        return 1;
      var Z = this.ucmp(T);
      return this.negative !== 0 ? -Z | 0 : Z;
    }, a.prototype.ucmp = function(T) {
      if (this.length > T.length)
        return 1;
      if (this.length < T.length)
        return -1;
      for (var Z = 0, z = this.length - 1; z >= 0; z--) {
        var j = this.words[z] | 0, w = T.words[z] | 0;
        if (j !== w) {
          j < w ? Z = -1 : j > w && (Z = 1);
          break;
        }
      }
      return Z;
    }, a.prototype.gtn = function(T) {
      return this.cmpn(T) === 1;
    }, a.prototype.gt = function(T) {
      return this.cmp(T) === 1;
    }, a.prototype.gten = function(T) {
      return this.cmpn(T) >= 0;
    }, a.prototype.gte = function(T) {
      return this.cmp(T) >= 0;
    }, a.prototype.ltn = function(T) {
      return this.cmpn(T) === -1;
    }, a.prototype.lt = function(T) {
      return this.cmp(T) === -1;
    }, a.prototype.lten = function(T) {
      return this.cmpn(T) <= 0;
    }, a.prototype.lte = function(T) {
      return this.cmp(T) <= 0;
    }, a.prototype.eqn = function(T) {
      return this.cmpn(T) === 0;
    }, a.prototype.eq = function(T) {
      return this.cmp(T) === 0;
    }, a.red = function(T) {
      return new G(T);
    }, a.prototype.toRed = function(T) {
      return r(!this.red, "Already a number in reduction context"), r(this.negative === 0, "red works only with positives"), T.convertTo(this)._forceRed(T);
    }, a.prototype.fromRed = function() {
      return r(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, a.prototype._forceRed = function(T) {
      return this.red = T, this;
    }, a.prototype.forceRed = function(T) {
      return r(!this.red, "Already a number in reduction context"), this._forceRed(T);
    }, a.prototype.redAdd = function(T) {
      return r(this.red, "redAdd works only with red numbers"), this.red.add(this, T);
    }, a.prototype.redIAdd = function(T) {
      return r(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, T);
    }, a.prototype.redSub = function(T) {
      return r(this.red, "redSub works only with red numbers"), this.red.sub(this, T);
    }, a.prototype.redISub = function(T) {
      return r(this.red, "redISub works only with red numbers"), this.red.isub(this, T);
    }, a.prototype.redShl = function(T) {
      return r(this.red, "redShl works only with red numbers"), this.red.shl(this, T);
    }, a.prototype.redMul = function(T) {
      return r(this.red, "redMul works only with red numbers"), this.red._verify2(this, T), this.red.mul(this, T);
    }, a.prototype.redIMul = function(T) {
      return r(this.red, "redMul works only with red numbers"), this.red._verify2(this, T), this.red.imul(this, T);
    }, a.prototype.redSqr = function() {
      return r(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, a.prototype.redISqr = function() {
      return r(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, a.prototype.redSqrt = function() {
      return r(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, a.prototype.redInvm = function() {
      return r(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, a.prototype.redNeg = function() {
      return r(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, a.prototype.redPow = function(T) {
      return r(this.red && !T.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, T);
    };
    var y = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function x(O, T) {
      this.name = O, this.p = new a(T, 16), this.n = this.p.bitLength(), this.k = new a(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    x.prototype._tmp = function() {
      var T = new a(null);
      return T.words = new Array(Math.ceil(this.n / 13)), T;
    }, x.prototype.ireduce = function(T) {
      var Z = T, z;
      do
        this.split(Z, this.tmp), Z = this.imulK(Z), Z = Z.iadd(this.tmp), z = Z.bitLength();
      while (z > this.n);
      var j = z < this.n ? -1 : Z.ucmp(this.p);
      return j === 0 ? (Z.words[0] = 0, Z.length = 1) : j > 0 ? Z.isub(this.p) : Z.strip !== void 0 ? Z.strip() : Z._strip(), Z;
    }, x.prototype.split = function(T, Z) {
      T.iushrn(this.n, 0, Z);
    }, x.prototype.imulK = function(T) {
      return T.imul(this.k);
    };
    function f() {
      x.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    i(f, x), f.prototype.split = function(T, Z) {
      for (var z = 4194303, j = Math.min(T.length, 9), w = 0; w < j; w++)
        Z.words[w] = T.words[w];
      if (Z.length = j, T.length <= 9) {
        T.words[0] = 0, T.length = 1;
        return;
      }
      var C = T.words[9];
      for (Z.words[Z.length++] = C & z, w = 10; w < T.length; w++) {
        var J = T.words[w] | 0;
        T.words[w - 10] = (J & z) << 4 | C >>> 22, C = J;
      }
      C >>>= 22, T.words[w - 10] = C, C === 0 && T.length > 10 ? T.length -= 10 : T.length -= 9;
    }, f.prototype.imulK = function(T) {
      T.words[T.length] = 0, T.words[T.length + 1] = 0, T.length += 2;
      for (var Z = 0, z = 0; z < T.length; z++) {
        var j = T.words[z] | 0;
        Z += j * 977, T.words[z] = Z & 67108863, Z = j * 64 + (Z / 67108864 | 0);
      }
      return T.words[T.length - 1] === 0 && (T.length--, T.words[T.length - 1] === 0 && T.length--), T;
    };
    function D() {
      x.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    i(D, x);
    function Y() {
      x.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    i(Y, x);
    function Q() {
      x.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    i(Q, x), Q.prototype.imulK = function(T) {
      for (var Z = 0, z = 0; z < T.length; z++) {
        var j = (T.words[z] | 0) * 19 + Z, w = j & 67108863;
        j >>>= 26, T.words[z] = w, Z = j;
      }
      return Z !== 0 && (T.words[T.length++] = Z), T;
    }, a._prime = function(T) {
      if (y[T])
        return y[T];
      var Z;
      if (T === "k256")
        Z = new f();
      else if (T === "p224")
        Z = new D();
      else if (T === "p192")
        Z = new Y();
      else if (T === "p25519")
        Z = new Q();
      else
        throw new Error("Unknown prime " + T);
      return y[T] = Z, Z;
    };
    function G(O) {
      if (typeof O == "string") {
        var T = a._prime(O);
        this.m = T.p, this.prime = T;
      } else
        r(O.gtn(1), "modulus must be greater than 1"), this.m = O, this.prime = null;
    }
    G.prototype._verify1 = function(T) {
      r(T.negative === 0, "red works only with positives"), r(T.red, "red works only with red numbers");
    }, G.prototype._verify2 = function(T, Z) {
      r((T.negative | Z.negative) === 0, "red works only with positives"), r(
        T.red && T.red === Z.red,
        "red works only with red numbers"
      );
    }, G.prototype.imod = function(T) {
      return this.prime ? this.prime.ireduce(T)._forceRed(this) : (d(T, T.umod(this.m)._forceRed(this)), T);
    }, G.prototype.neg = function(T) {
      return T.isZero() ? T.clone() : this.m.sub(T)._forceRed(this);
    }, G.prototype.add = function(T, Z) {
      this._verify2(T, Z);
      var z = T.add(Z);
      return z.cmp(this.m) >= 0 && z.isub(this.m), z._forceRed(this);
    }, G.prototype.iadd = function(T, Z) {
      this._verify2(T, Z);
      var z = T.iadd(Z);
      return z.cmp(this.m) >= 0 && z.isub(this.m), z;
    }, G.prototype.sub = function(T, Z) {
      this._verify2(T, Z);
      var z = T.sub(Z);
      return z.cmpn(0) < 0 && z.iadd(this.m), z._forceRed(this);
    }, G.prototype.isub = function(T, Z) {
      this._verify2(T, Z);
      var z = T.isub(Z);
      return z.cmpn(0) < 0 && z.iadd(this.m), z;
    }, G.prototype.shl = function(T, Z) {
      return this._verify1(T), this.imod(T.ushln(Z));
    }, G.prototype.imul = function(T, Z) {
      return this._verify2(T, Z), this.imod(T.imul(Z));
    }, G.prototype.mul = function(T, Z) {
      return this._verify2(T, Z), this.imod(T.mul(Z));
    }, G.prototype.isqr = function(T) {
      return this.imul(T, T.clone());
    }, G.prototype.sqr = function(T) {
      return this.mul(T, T);
    }, G.prototype.sqrt = function(T) {
      if (T.isZero())
        return T.clone();
      var Z = this.m.andln(3);
      if (r(Z % 2 === 1), Z === 3) {
        var z = this.m.add(new a(1)).iushrn(2);
        return this.pow(T, z);
      }
      for (var j = this.m.subn(1), w = 0; !j.isZero() && j.andln(1) === 0; )
        w++, j.iushrn(1);
      r(!j.isZero());
      var C = new a(1).toRed(this), J = C.redNeg(), I = this.m.subn(1).iushrn(1), b = this.m.bitLength();
      for (b = new a(2 * b * b).toRed(this); this.pow(b, I).cmp(J) !== 0; )
        b.redIAdd(J);
      for (var k = this.pow(b, j), ae = this.pow(T, j.addn(1).iushrn(1)), oe = this.pow(T, j), le = w; oe.cmp(C) !== 0; ) {
        for (var fe = oe, de = 0; fe.cmp(C) !== 0; de++)
          fe = fe.redSqr();
        r(de < le);
        var Me = this.pow(k, new a(1).iushln(le - de - 1));
        ae = ae.redMul(Me), k = Me.redSqr(), oe = oe.redMul(k), le = de;
      }
      return ae;
    }, G.prototype.invm = function(T) {
      var Z = T._invmp(this.m);
      return Z.negative !== 0 ? (Z.negative = 0, this.imod(Z).redNeg()) : this.imod(Z);
    }, G.prototype.pow = function(T, Z) {
      if (Z.isZero())
        return new a(1).toRed(this);
      if (Z.cmpn(1) === 0)
        return T.clone();
      var z = 4, j = new Array(1 << z);
      j[0] = new a(1).toRed(this), j[1] = T;
      for (var w = 2; w < j.length; w++)
        j[w] = this.mul(j[w - 1], T);
      var C = j[0], J = 0, I = 0, b = Z.bitLength() % 26;
      for (b === 0 && (b = 26), w = Z.length - 1; w >= 0; w--) {
        for (var k = Z.words[w], ae = b - 1; ae >= 0; ae--) {
          var oe = k >> ae & 1;
          if (C !== j[0] && (C = this.sqr(C)), oe === 0 && J === 0) {
            I = 0;
            continue;
          }
          J <<= 1, J |= oe, I++, !(I !== z && (w !== 0 || ae !== 0)) && (C = this.mul(C, j[J]), I = 0, J = 0);
        }
        b = 26;
      }
      return C;
    }, G.prototype.convertTo = function(T) {
      var Z = T.umod(this.m);
      return Z === T ? Z.clone() : Z;
    }, G.prototype.convertFrom = function(T) {
      var Z = T.clone();
      return Z.red = null, Z;
    }, a.mont = function(T) {
      return new ne(T);
    };
    function ne(O) {
      G.call(this, O), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new a(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    i(ne, G), ne.prototype.convertTo = function(T) {
      return this.imod(T.ushln(this.shift));
    }, ne.prototype.convertFrom = function(T) {
      var Z = this.imod(T.mul(this.rinv));
      return Z.red = null, Z;
    }, ne.prototype.imul = function(T, Z) {
      if (T.isZero() || Z.isZero())
        return T.words[0] = 0, T.length = 1, T;
      var z = T.imul(Z), j = z.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), w = z.isub(j).iushrn(this.shift), C = w;
      return w.cmp(this.m) >= 0 ? C = w.isub(this.m) : w.cmpn(0) < 0 && (C = w.iadd(this.m)), C._forceRed(this);
    }, ne.prototype.mul = function(T, Z) {
      if (T.isZero() || Z.isZero())
        return new a(0)._forceRed(this);
      var z = T.mul(Z), j = z.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), w = z.isub(j).iushrn(this.shift), C = w;
      return w.cmp(this.m) >= 0 ? C = w.isub(this.m) : w.cmpn(0) < 0 && (C = w.iadd(this.m)), C._forceRed(this);
    }, ne.prototype.invm = function(T) {
      var Z = this.imod(T._invmp(this.m).mul(this.r2));
      return Z._forceRed(this);
    };
  })(t, ya);
})(M3);
var jP = M3.exports;
const DP = /* @__PURE__ */ fc(jP), zP = "logger/5.7.0";
let rj = !1, ij = !1;
const wT = { debug: 1, default: 2, info: 2, warning: 3, error: 4, off: 5 };
let aj = wT.default, YR = null;
function kP() {
  try {
    const t = [];
    if (["NFD", "NFC", "NFKD", "NFKC"].forEach((e) => {
      try {
        if ("test".normalize(e) !== "test")
          throw new Error("bad normalize");
      } catch {
        t.push(e);
      }
    }), t.length)
      throw new Error("missing " + t.join(", "));
    if (String.fromCharCode(233).normalize("NFD") !== String.fromCharCode(101, 769))
      throw new Error("broken implementation");
  } catch (t) {
    return t.message;
  }
  return null;
}
const oj = kP();
var Xy;
(function(t) {
  t.DEBUG = "DEBUG", t.INFO = "INFO", t.WARNING = "WARNING", t.ERROR = "ERROR", t.OFF = "OFF";
})(Xy || (Xy = {}));
var Ya;
(function(t) {
  t.UNKNOWN_ERROR = "UNKNOWN_ERROR", t.NOT_IMPLEMENTED = "NOT_IMPLEMENTED", t.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION", t.NETWORK_ERROR = "NETWORK_ERROR", t.SERVER_ERROR = "SERVER_ERROR", t.TIMEOUT = "TIMEOUT", t.BUFFER_OVERRUN = "BUFFER_OVERRUN", t.NUMERIC_FAULT = "NUMERIC_FAULT", t.MISSING_NEW = "MISSING_NEW", t.INVALID_ARGUMENT = "INVALID_ARGUMENT", t.MISSING_ARGUMENT = "MISSING_ARGUMENT", t.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT", t.CALL_EXCEPTION = "CALL_EXCEPTION", t.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", t.NONCE_EXPIRED = "NONCE_EXPIRED", t.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED", t.UNPREDICTABLE_GAS_LIMIT = "UNPREDICTABLE_GAS_LIMIT", t.TRANSACTION_REPLACED = "TRANSACTION_REPLACED", t.ACTION_REJECTED = "ACTION_REJECTED";
})(Ya || (Ya = {}));
const sj = "0123456789abcdef";
class Xt {
  constructor(e) {
    Object.defineProperty(this, "version", {
      enumerable: !0,
      value: e,
      writable: !1
    });
  }
  _log(e, n) {
    const r = e.toLowerCase();
    wT[r] == null && this.throwArgumentError("invalid log level name", "logLevel", e), !(aj > wT[r]) && console.log.apply(console, n);
  }
  debug(...e) {
    this._log(Xt.levels.DEBUG, e);
  }
  info(...e) {
    this._log(Xt.levels.INFO, e);
  }
  warn(...e) {
    this._log(Xt.levels.WARNING, e);
  }
  makeError(e, n, r) {
    if (ij)
      return this.makeError("censored error", n, {});
    n || (n = Xt.errors.UNKNOWN_ERROR), r || (r = {});
    const i = [];
    Object.keys(r).forEach((l) => {
      const c = r[l];
      try {
        if (c instanceof Uint8Array) {
          let d = "";
          for (let u = 0; u < c.length; u++)
            d += sj[c[u] >> 4], d += sj[c[u] & 15];
          i.push(l + "=Uint8Array(0x" + d + ")");
        } else
          i.push(l + "=" + JSON.stringify(c));
      } catch {
        i.push(l + "=" + JSON.stringify(r[l].toString()));
      }
    }), i.push(`code=${n}`), i.push(`version=${this.version}`);
    const a = e;
    let o = "";
    switch (n) {
      case Ya.NUMERIC_FAULT: {
        o = "NUMERIC_FAULT";
        const l = e;
        switch (l) {
          case "overflow":
          case "underflow":
          case "division-by-zero":
            o += "-" + l;
            break;
          case "negative-power":
          case "negative-width":
            o += "-unsupported";
            break;
          case "unbound-bitwise-result":
            o += "-unbound-result";
            break;
        }
        break;
      }
      case Ya.CALL_EXCEPTION:
      case Ya.INSUFFICIENT_FUNDS:
      case Ya.MISSING_NEW:
      case Ya.NONCE_EXPIRED:
      case Ya.REPLACEMENT_UNDERPRICED:
      case Ya.TRANSACTION_REPLACED:
      case Ya.UNPREDICTABLE_GAS_LIMIT:
        o = n;
        break;
    }
    o && (e += " [ See: https://links.ethers.org/v5-errors-" + o + " ]"), i.length && (e += " (" + i.join(", ") + ")");
    const s = new Error(e);
    return s.reason = a, s.code = n, Object.keys(r).forEach(function(l) {
      s[l] = r[l];
    }), s;
  }
  throwError(e, n, r) {
    throw this.makeError(e, n, r);
  }
  throwArgumentError(e, n, r) {
    return this.throwError(e, Xt.errors.INVALID_ARGUMENT, {
      argument: n,
      value: r
    });
  }
  assert(e, n, r, i) {
    e || this.throwError(n, r, i);
  }
  assertArgument(e, n, r, i) {
    e || this.throwArgumentError(n, r, i);
  }
  checkNormalize(e) {
    oj && this.throwError("platform missing String.prototype.normalize", Xt.errors.UNSUPPORTED_OPERATION, {
      operation: "String.prototype.normalize",
      form: oj
    });
  }
  checkSafeUint53(e, n) {
    typeof e == "number" && (n == null && (n = "value not safe"), (e < 0 || e >= 9007199254740991) && this.throwError(n, Xt.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "out-of-safe-range",
      value: e
    }), e % 1 && this.throwError(n, Xt.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "non-integer",
      value: e
    }));
  }
  checkArgumentCount(e, n, r) {
    r ? r = ": " + r : r = "", e < n && this.throwError("missing argument" + r, Xt.errors.MISSING_ARGUMENT, {
      count: e,
      expectedCount: n
    }), e > n && this.throwError("too many arguments" + r, Xt.errors.UNEXPECTED_ARGUMENT, {
      count: e,
      expectedCount: n
    });
  }
  checkNew(e, n) {
    (e === Object || e == null) && this.throwError("missing new", Xt.errors.MISSING_NEW, { name: n.name });
  }
  checkAbstract(e, n) {
    e === n ? this.throwError("cannot instantiate abstract class " + JSON.stringify(n.name) + " directly; use a sub-class", Xt.errors.UNSUPPORTED_OPERATION, { name: e.name, operation: "new" }) : (e === Object || e == null) && this.throwError("missing new", Xt.errors.MISSING_NEW, { name: n.name });
  }
  static globalLogger() {
    return YR || (YR = new Xt(zP)), YR;
  }
  static setCensorship(e, n) {
    if (!e && n && this.globalLogger().throwError("cannot permanently disable censorship", Xt.errors.UNSUPPORTED_OPERATION, {
      operation: "setCensorship"
    }), rj) {
      if (!e)
        return;
      this.globalLogger().throwError("error censorship permanent", Xt.errors.UNSUPPORTED_OPERATION, {
        operation: "setCensorship"
      });
    }
    ij = !!e, rj = !!n;
  }
  static setLogLevel(e) {
    const n = wT[e.toLowerCase()];
    if (n == null) {
      Xt.globalLogger().warn("invalid log level - " + e);
      return;
    }
    aj = n;
  }
  static from(e) {
    return new Xt(e);
  }
}
Xt.errors = Ya;
Xt.levels = Xy;
const wP = "bytes/5.7.0", Yl = new Xt(wP);
function pI(t) {
  return !!t.toHexString;
}
function FT(t) {
  return t.slice || (t.slice = function() {
    const e = Array.prototype.slice.call(arguments);
    return FT(new Uint8Array(Array.prototype.slice.apply(t, e)));
  }), t;
}
function lj(t) {
  return typeof t == "number" && t == t && t % 1 === 0;
}
function Gp(t) {
  if (t == null)
    return !1;
  if (t.constructor === Uint8Array)
    return !0;
  if (typeof t == "string" || !lj(t.length) || t.length < 0)
    return !1;
  for (let e = 0; e < t.length; e++) {
    const n = t[e];
    if (!lj(n) || n < 0 || n >= 256)
      return !1;
  }
  return !0;
}
function FP(t, e) {
  if (e || (e = {}), typeof t == "number") {
    Yl.checkSafeUint53(t, "invalid arrayify value");
    const n = [];
    for (; t; )
      n.unshift(t & 255), t = parseInt(String(t / 256));
    return n.length === 0 && n.push(0), FT(new Uint8Array(n));
  }
  if (e.allowMissingPrefix && typeof t == "string" && t.substring(0, 2) !== "0x" && (t = "0x" + t), pI(t) && (t = t.toHexString()), $0(t)) {
    let n = t.substring(2);
    n.length % 2 && (e.hexPad === "left" ? n = "0" + n : e.hexPad === "right" ? n += "0" : Yl.throwArgumentError("hex data is odd-length", "value", t));
    const r = [];
    for (let i = 0; i < n.length; i += 2)
      r.push(parseInt(n.substring(i, i + 2), 16));
    return FT(new Uint8Array(r));
  }
  return Gp(t) ? FT(new Uint8Array(t)) : Yl.throwArgumentError("invalid arrayify value", "value", t);
}
function $0(t, e) {
  return !(typeof t != "string" || !t.match(/^0x[0-9A-Fa-f]*$/) || e && t.length !== 2 + 2 * e);
}
const QR = "0123456789abcdef";
function mI(t, e) {
  if (e || (e = {}), typeof t == "number") {
    Yl.checkSafeUint53(t, "invalid hexlify value");
    let n = "";
    for (; t; )
      n = QR[t & 15] + n, t = Math.floor(t / 16);
    return n.length ? (n.length % 2 && (n = "0" + n), "0x" + n) : "0x00";
  }
  if (typeof t == "bigint")
    return t = t.toString(16), t.length % 2 ? "0x0" + t : "0x" + t;
  if (e.allowMissingPrefix && typeof t == "string" && t.substring(0, 2) !== "0x" && (t = "0x" + t), pI(t))
    return t.toHexString();
  if ($0(t))
    return t.length % 2 && (e.hexPad === "left" ? t = "0x0" + t.substring(2) : e.hexPad === "right" ? t += "0" : Yl.throwArgumentError("hex data is odd-length", "value", t)), t.toLowerCase();
  if (Gp(t)) {
    let n = "0x";
    for (let r = 0; r < t.length; r++) {
      let i = t[r];
      n += QR[(i & 240) >> 4] + QR[i & 15];
    }
    return n;
  }
  return Yl.throwArgumentError("invalid hexlify value", "value", t);
}
function cj(t, e) {
  for (typeof t != "string" ? t = mI(t) : $0(t) || Yl.throwArgumentError("invalid hex string", "value", t), t.length > 2 * e + 2 && Yl.throwArgumentError("value out of range", "value", arguments[1]); t.length < 2 * e + 2; )
    t = "0x0" + t.substring(2);
  return t;
}
const TI = "bignumber/5.7.0";
var _y = DP.BN;
const as = new Xt(TI), GR = {}, dj = 9007199254740991;
function vP(t) {
  return t != null && (pn.isBigNumber(t) || typeof t == "number" && t % 1 === 0 || typeof t == "string" && !!t.match(/^-?[0-9]+$/) || $0(t) || typeof t == "bigint" || Gp(t));
}
let uj = !1;
class pn {
  constructor(e, n) {
    e !== GR && as.throwError("cannot call constructor directly; use BigNumber.from", Xt.errors.UNSUPPORTED_OPERATION, {
      operation: "new (BigNumber)"
    }), this._hex = n, this._isBigNumber = !0, Object.freeze(this);
  }
  fromTwos(e) {
    return gi(Jt(this).fromTwos(e));
  }
  toTwos(e) {
    return gi(Jt(this).toTwos(e));
  }
  abs() {
    return this._hex[0] === "-" ? pn.from(this._hex.substring(1)) : this;
  }
  add(e) {
    return gi(Jt(this).add(Jt(e)));
  }
  sub(e) {
    return gi(Jt(this).sub(Jt(e)));
  }
  div(e) {
    return pn.from(e).isZero() && da("division-by-zero", "div"), gi(Jt(this).div(Jt(e)));
  }
  mul(e) {
    return gi(Jt(this).mul(Jt(e)));
  }
  mod(e) {
    const n = Jt(e);
    return n.isNeg() && da("division-by-zero", "mod"), gi(Jt(this).umod(n));
  }
  pow(e) {
    const n = Jt(e);
    return n.isNeg() && da("negative-power", "pow"), gi(Jt(this).pow(n));
  }
  and(e) {
    const n = Jt(e);
    return (this.isNegative() || n.isNeg()) && da("unbound-bitwise-result", "and"), gi(Jt(this).and(n));
  }
  or(e) {
    const n = Jt(e);
    return (this.isNegative() || n.isNeg()) && da("unbound-bitwise-result", "or"), gi(Jt(this).or(n));
  }
  xor(e) {
    const n = Jt(e);
    return (this.isNegative() || n.isNeg()) && da("unbound-bitwise-result", "xor"), gi(Jt(this).xor(n));
  }
  mask(e) {
    return (this.isNegative() || e < 0) && da("negative-width", "mask"), gi(Jt(this).maskn(e));
  }
  shl(e) {
    return (this.isNegative() || e < 0) && da("negative-width", "shl"), gi(Jt(this).shln(e));
  }
  shr(e) {
    return (this.isNegative() || e < 0) && da("negative-width", "shr"), gi(Jt(this).shrn(e));
  }
  eq(e) {
    return Jt(this).eq(Jt(e));
  }
  lt(e) {
    return Jt(this).lt(Jt(e));
  }
  lte(e) {
    return Jt(this).lte(Jt(e));
  }
  gt(e) {
    return Jt(this).gt(Jt(e));
  }
  gte(e) {
    return Jt(this).gte(Jt(e));
  }
  isNegative() {
    return this._hex[0] === "-";
  }
  isZero() {
    return Jt(this).isZero();
  }
  toNumber() {
    try {
      return Jt(this).toNumber();
    } catch {
      da("overflow", "toNumber", this.toString());
    }
    return null;
  }
  toBigInt() {
    try {
      return BigInt(this.toString());
    } catch {
    }
    return as.throwError("this platform does not support BigInt", Xt.errors.UNSUPPORTED_OPERATION, {
      value: this.toString()
    });
  }
  toString() {
    return arguments.length > 0 && (arguments[0] === 10 ? uj || (uj = !0, as.warn("BigNumber.toString does not accept any parameters; base-10 is assumed")) : arguments[0] === 16 ? as.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", Xt.errors.UNEXPECTED_ARGUMENT, {}) : as.throwError("BigNumber.toString does not accept parameters", Xt.errors.UNEXPECTED_ARGUMENT, {})), Jt(this).toString(10);
  }
  toHexString() {
    return this._hex;
  }
  toJSON(e) {
    return { type: "BigNumber", hex: this.toHexString() };
  }
  static from(e) {
    if (e instanceof pn)
      return e;
    if (typeof e == "string")
      return e.match(/^-?0x[0-9a-f]+$/i) ? new pn(GR, K1(e)) : e.match(/^-?[0-9]+$/) ? new pn(GR, K1(new _y(e))) : as.throwArgumentError("invalid BigNumber string", "value", e);
    if (typeof e == "number")
      return e % 1 && da("underflow", "BigNumber.from", e), (e >= dj || e <= -dj) && da("overflow", "BigNumber.from", e), pn.from(String(e));
    const n = e;
    if (typeof n == "bigint")
      return pn.from(n.toString());
    if (Gp(n))
      return pn.from(mI(n));
    if (n)
      if (n.toHexString) {
        const r = n.toHexString();
        if (typeof r == "string")
          return pn.from(r);
      } else {
        let r = n._hex;
        if (r == null && n.type === "BigNumber" && (r = n.hex), typeof r == "string" && ($0(r) || r[0] === "-" && $0(r.substring(1))))
          return pn.from(r);
      }
    return as.throwArgumentError("invalid BigNumber value", "value", e);
  }
  static isBigNumber(e) {
    return !!(e && e._isBigNumber);
  }
}
function K1(t) {
  if (typeof t != "string")
    return K1(t.toString(16));
  if (t[0] === "-")
    return t = t.substring(1), t[0] === "-" && as.throwArgumentError("invalid hex", "value", t), t = K1(t), t === "0x00" ? t : "-" + t;
  if (t.substring(0, 2) !== "0x" && (t = "0x" + t), t === "0x")
    return "0x00";
  for (t.length % 2 && (t = "0x0" + t.substring(2)); t.length > 4 && t.substring(0, 4) === "0x00"; )
    t = "0x" + t.substring(4);
  return t;
}
function gi(t) {
  return pn.from(K1(t));
}
function Jt(t) {
  const e = pn.from(t).toHexString();
  return e[0] === "-" ? new _y("-" + e.substring(3), 16) : new _y(e.substring(2), 16);
}
function da(t, e, n) {
  const r = { fault: t, operation: e };
  return n != null && (r.value = n), as.throwError(t, Xt.errors.NUMERIC_FAULT, r);
}
const di = new Xt(TI), e1 = {}, fI = pn.from(0), VI = pn.from(-1);
function UI(t, e, n, r) {
  const i = { fault: e, operation: n };
  return r !== void 0 && (i.value = r), di.throwError(t, Xt.errors.NUMERIC_FAULT, i);
}
let t1 = "0";
for (; t1.length < 256; )
  t1 += t1;
function p3(t) {
  if (typeof t != "number")
    try {
      t = pn.from(t).toNumber();
    } catch {
    }
  return typeof t == "number" && t >= 0 && t <= 256 && !(t % 1) ? "1" + t1.substring(0, t) : di.throwArgumentError("invalid decimal size", "decimals", t);
}
function vT(t, e) {
  e == null && (e = 0);
  const n = p3(e);
  t = pn.from(t);
  const r = t.lt(fI);
  r && (t = t.mul(VI));
  let i = t.mod(n).toString();
  for (; i.length < n.length - 1; )
    i = "0" + i;
  i = i.match(/^([0-9]*[1-9]|0)(0*)/)[1];
  const a = t.div(n).toString();
  return n.length === 1 ? t = a : t = a + "." + i, r && (t = "-" + t), t;
}
function co(t, e) {
  e == null && (e = 0);
  const n = p3(e);
  (typeof t != "string" || !t.match(/^-?[0-9.]+$/)) && di.throwArgumentError("invalid decimal value", "value", t);
  const r = t.substring(0, 1) === "-";
  r && (t = t.substring(1)), t === "." && di.throwArgumentError("missing value", "value", t);
  const i = t.split(".");
  i.length > 2 && di.throwArgumentError("too many decimal points", "value", t);
  let a = i[0], o = i[1];
  for (a || (a = "0"), o || (o = "0"); o[o.length - 1] === "0"; )
    o = o.substring(0, o.length - 1);
  for (o.length > n.length - 1 && UI("fractional component exceeds decimals", "underflow", "parseFixed"), o === "" && (o = "0"); o.length < n.length - 1; )
    o += "0";
  const s = pn.from(a), l = pn.from(o);
  let c = s.mul(n).add(l);
  return r && (c = c.mul(VI)), c;
}
class N0 {
  constructor(e, n, r, i) {
    e !== e1 && di.throwError("cannot use FixedFormat constructor; use FixedFormat.from", Xt.errors.UNSUPPORTED_OPERATION, {
      operation: "new FixedFormat"
    }), this.signed = n, this.width = r, this.decimals = i, this.name = (n ? "" : "u") + "fixed" + String(r) + "x" + String(i), this._multiplier = p3(i), Object.freeze(this);
  }
  static from(e) {
    if (e instanceof N0)
      return e;
    typeof e == "number" && (e = `fixed128x${e}`);
    let n = !0, r = 128, i = 18;
    if (typeof e == "string") {
      if (e !== "fixed")
        if (e === "ufixed")
          n = !1;
        else {
          const a = e.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
          a || di.throwArgumentError("invalid fixed format", "format", e), n = a[1] !== "u", r = parseInt(a[2]), i = parseInt(a[3]);
        }
    } else if (e) {
      const a = (o, s, l) => e[o] == null ? l : (typeof e[o] !== s && di.throwArgumentError("invalid fixed format (" + o + " not " + s + ")", "format." + o, e[o]), e[o]);
      n = a("signed", "boolean", n), r = a("width", "number", r), i = a("decimals", "number", i);
    }
    return r % 8 && di.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", r), i > 80 && di.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", i), new N0(e1, n, r, i);
  }
}
class vr {
  constructor(e, n, r, i) {
    e !== e1 && di.throwError("cannot use FixedNumber constructor; use FixedNumber.from", Xt.errors.UNSUPPORTED_OPERATION, {
      operation: "new FixedFormat"
    }), this.format = i, this._hex = n, this._value = r, this._isFixedNumber = !0, Object.freeze(this);
  }
  _checkFormat(e) {
    this.format.name !== e.format.name && di.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", e);
  }
  addUnsafe(e) {
    this._checkFormat(e);
    const n = co(this._value, this.format.decimals), r = co(e._value, e.format.decimals);
    return vr.fromValue(n.add(r), this.format.decimals, this.format);
  }
  subUnsafe(e) {
    this._checkFormat(e);
    const n = co(this._value, this.format.decimals), r = co(e._value, e.format.decimals);
    return vr.fromValue(n.sub(r), this.format.decimals, this.format);
  }
  mulUnsafe(e) {
    this._checkFormat(e);
    const n = co(this._value, this.format.decimals), r = co(e._value, e.format.decimals);
    return vr.fromValue(n.mul(r).div(this.format._multiplier), this.format.decimals, this.format);
  }
  divUnsafe(e) {
    this._checkFormat(e);
    const n = co(this._value, this.format.decimals), r = co(e._value, e.format.decimals);
    return vr.fromValue(n.mul(this.format._multiplier).div(r), this.format.decimals, this.format);
  }
  floor() {
    const e = this.toString().split(".");
    e.length === 1 && e.push("0");
    let n = vr.from(e[0], this.format);
    const r = !e[1].match(/^(0*)$/);
    return this.isNegative() && r && (n = n.subUnsafe(hj.toFormat(n.format))), n;
  }
  ceiling() {
    const e = this.toString().split(".");
    e.length === 1 && e.push("0");
    let n = vr.from(e[0], this.format);
    const r = !e[1].match(/^(0*)$/);
    return !this.isNegative() && r && (n = n.addUnsafe(hj.toFormat(n.format))), n;
  }
  // @TODO: Support other rounding algorithms
  round(e) {
    e == null && (e = 0);
    const n = this.toString().split(".");
    if (n.length === 1 && n.push("0"), (e < 0 || e > 80 || e % 1) && di.throwArgumentError("invalid decimal count", "decimals", e), n[1].length <= e)
      return this;
    const r = vr.from("1" + t1.substring(0, e), this.format), i = IP.toFormat(this.format);
    return this.mulUnsafe(r).addUnsafe(i).floor().divUnsafe(r);
  }
  isZero() {
    return this._value === "0.0" || this._value === "0";
  }
  isNegative() {
    return this._value[0] === "-";
  }
  toString() {
    return this._value;
  }
  toHexString(e) {
    if (e == null)
      return this._hex;
    e % 8 && di.throwArgumentError("invalid byte width", "width", e);
    const n = pn.from(this._hex).fromTwos(this.format.width).toTwos(e).toHexString();
    return cj(n, e / 8);
  }
  toUnsafeFloat() {
    return parseFloat(this.toString());
  }
  toFormat(e) {
    return vr.fromString(this._value, e);
  }
  static fromValue(e, n, r) {
    return r == null && n != null && !vP(n) && (r = n, n = null), n == null && (n = 0), r == null && (r = "fixed"), vr.fromString(vT(e, n), N0.from(r));
  }
  static fromString(e, n) {
    n == null && (n = "fixed");
    const r = N0.from(n), i = co(e, r.decimals);
    !r.signed && i.lt(fI) && UI("unsigned value cannot be negative", "overflow", "value", e);
    let a = null;
    r.signed ? a = i.toTwos(r.width).toHexString() : (a = i.toHexString(), a = cj(a, r.width / 8));
    const o = vT(i, r.decimals);
    return new vr(e1, a, o, r);
  }
  static fromBytes(e, n) {
    n == null && (n = "fixed");
    const r = N0.from(n);
    if (FP(e).length > r.width / 8)
      throw new Error("overflow");
    let i = pn.from(e);
    r.signed && (i = i.fromTwos(r.width));
    const a = i.toTwos((r.signed ? 0 : 1) + r.width).toHexString(), o = vT(i, r.decimals);
    return new vr(e1, a, o, r);
  }
  static from(e, n) {
    if (typeof e == "string")
      return vr.fromString(e, n);
    if (Gp(e))
      return vr.fromBytes(e, n);
    try {
      return vr.fromValue(e, 0, n);
    } catch (r) {
      if (r.code !== Xt.errors.INVALID_ARGUMENT)
        throw r;
    }
    return di.throwArgumentError("invalid FixedNumber value", "value", e);
  }
  static isFixedNumber(e) {
    return !!(e && e._isFixedNumber);
  }
}
const hj = vr.from(1), IP = vr.from("0.5");
class Ei {
  constructor() {
    Vt(this, "address", "");
    Vt(this, "symbol", "");
    Vt(this, "name", "");
    Vt(this, "chainId", "");
    Vt(this, "decimals", 18);
    Vt(this, "logoURI", "");
    Vt(this, "balance", pn.from(0));
    Vt(this, "isFakeToken", !0);
    Vt(this, "reedamable", !1);
  }
}
var ps = /* @__PURE__ */ ((t) => (t.GREATER_THAN_EQUAL_SECOND_BOUND = "3", t.BETWEEN_OR_EQUAL_FIRST_AND_SECOND_BOUND = "2", t.LESS_THAN_FIRST_BOUND = "1", t.NO_NEED_TO_CHECK_BOUND = "0", t))(ps || {}), os = /* @__PURE__ */ ((t) => (t.CANNOT_ESTIMATE_GAS_FEE = "2", t.GAS_FEE_NOT_ENOUGH = "1", t.GAS_FEE_ENOUGH = "0", t))(os || {}), Bt = /* @__PURE__ */ ((t) => (t[t.Unknown_Error = 1e4] = "Unknown_Error", t[t.System_Maintenance = 10001] = "System_Maintenance", t[t.Invalid_Affiliate_Address = 20001] = "Invalid_Affiliate_Address", t[t.Invalid_Receiver_Address = 20002] = "Invalid_Receiver_Address", t[t.Invalid_Slippage = 20003] = "Invalid_Slippage", t[t.Required_Swap_Provider = 20004] = "Required_Swap_Provider", t[t.Required_Bridge_Provider = 20005] = "Required_Bridge_Provider", t[t.Address_Invalid = 20006] = "Address_Invalid", t[t.Cannot_Apply_Swap_Provider = 20007] = "Cannot_Apply_Swap_Provider", t[t.Cannot_Apply_Bridge_Provider = 20008] = "Cannot_Apply_Bridge_Provider", t[t.Not_Supported_Network = 30001] = "Not_Supported_Network", t[t.No_Available_Route = 30002] = "No_Available_Route", t[t.Not_Supported_Bridge_Provider = 30003] = "Not_Supported_Bridge_Provider", t[t.Invalid_Commision_Rate = 30004] = "Invalid_Commision_Rate", t[t.Not_Supported_Swap_Provider = 30005] = "Not_Supported_Swap_Provider", t[t.Service_Temporary_Down = 30006] = "Service_Temporary_Down", t[t.Y_Pool_Amount_Too_Big = 31001] = "Y_Pool_Amount_Too_Big", t[t.Y_Pool_Liquidity_Insufficient = 31002] = "Y_Pool_Liquidity_Insufficient", t[t.Y_Pool_Not_Supported_Bridge_Token = 31003] = "Y_Pool_Not_Supported_Bridge_Token", t[t.Y_Pool_Amount_Too_Small = 31004] = "Y_Pool_Amount_Too_Small", t[t.C_Bridge_Amount_Too_Small = 32001] = "C_Bridge_Amount_Too_Small", t[t.C_Bridge_Amount_Too_Big = 32002] = "C_Bridge_Amount_Too_Big", t[t.C_Bridge_Fee_Too_High = 32003] = "C_Bridge_Fee_Too_High", t[t.C_Bridge_API_Failed = 32004] = "C_Bridge_API_Failed", t[t.Multichain_Not_Supported_Bridge_Token = 33001] = "Multichain_Not_Supported_Bridge_Token", t[t.Multichain_Amount_Too_Small = 33002] = "Multichain_Amount_Too_Small", t[t.Multichain_Amount_Too_Big = 33003] = "Multichain_Amount_Too_Big", t[t.Multichain_Amount_Too_High = 33004] = "Multichain_Amount_Too_High", t[t.Xasset_Liquidity_Insufficient = 34001] = "Xasset_Liquidity_Insufficient", t[t.Xasset_Fee_Too_High = 34002] = "Xasset_Fee_Too_High", t[t.Celer_CCTP_Fee_Too_High = 35001] = "Celer_CCTP_Fee_Too_High", t[t.Synapse_Fee_Too_High = 36001] = "Synapse_Fee_Too_High", t[t.Synapse_Liquidity_Not_Enough = 36002] = "Synapse_Liquidity_Not_Enough", t[t.Build_Tx_Rate_Limit = 40002] = "Build_Tx_Rate_Limit", t))(Bt || {}), ci = /* @__PURE__ */ ((t) => (t.SYNAPSE = "Synapse", t.Y_BRIDGE = "yBridge", t.TOKEN_BRIDGE = "TokenBridge", t.C_BRIDGE = "CBridge", t.MULTICHAIN = "Multichain", t.XASSET_BRIDGE = "XassetBridge", t.CELER_CCTP = "CelerCCTP", t))(ci || {}), Lu = /* @__PURE__ */ ((t) => (t.XY_DEX_AGGREGATOR = "XY DexAggregator", t.ONE_INCH_V5 = "OneInch V5 DexAggregator", t.ONE_INCH_V4 = "OneInch V4 DexAggregator", t.OPEN_OCEAN = "OpenOcean V3 DexAggregator", t.OKX = "OKX DEX", t))(Lu || {}), Rc = /* @__PURE__ */ ((t) => (t.Metamask = "MetaMask", t.WalletConnect = "WalletConnect", t.CoinbaseWallet = "Coinbase Wallet", t.OKXWallet = "OKX Wallet", t.HaloWallet = "Halo Wallet", t.ImToken = "imToken", t.TrustWallet = "Trust Wallet", t.Brave = "Brave Wallet", t.Bitget = "Bitget Wallet", t))(Rc || {}), Kr = /* @__PURE__ */ ((t) => (t.Metamask = "metaMask", t.WalletConnect = "walletConnect", t.CoinbaseWallet = "coinbaseWallet", t.OKXWallet = "okxWallet", t.HaloWallet = "haloWallet", t.ImToken = "imToken", t.TrustWallet = "trustWallet", t.Brave = "brave", t.Bitget = "bitget", t))(Kr || {});
const OP = "https://xy.finance", YP = "https://widget.xy.finance", QP = "https://api.coingecko.com/api/v3", zi = "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE", GP = 15e3, Py = 6e4, CP = 15e3, Nj = 5e3, RI = "0xFD19727868A8197F42e7a52d024374598F62953B", LP = "e9a4e561b8cd7ef77a4539b779e43f2c", JP = "https://bc24bfbe550c460090812db2ac7f85af@o4505005974290432.ingest.sentry.io/4505005975994368", BP = [ve.THUNDERCORE_MAINNET], Mj = ["60", "100"], AP = [], HP = "0xdAC17F958D2ee523a2206206994597C13D831ec7", XP = [ve.X1_TESTNET], _P = [
  ve.X1_MAINNET,
  ve.X1_TESTNET,
  ve.KCC_MAINNET,
  ve.KCC_TESTNET,
  ve.MANTLE_MAINNET,
  ve.MANTLE_TESTNET,
  ve.POLYGON_ZKEVM_MAINNET,
  ve.POLYGON_ZKEVM_TESTNET,
  ve.SCROLL_MAINNET,
  ve.SCROLL_TESTNET
];
ve.MAINNET, ve.MAINNET;
const gI = {
  disabledChains: [],
  fromToken: {
    chainId: ve.MAINNET,
    address: zi
  },
  toToken: {
    chainId: ve.BSC_MAINNET,
    address: zi
  },
  fromInput: "",
  slippage: "1",
  referrer: RI,
  featuredTokens: [],
  disabledTokens: [],
  disableTokenSelection: "none",
  enableReport: !0
}, yI = {
  mode: "light",
  fontFamily: "ui-sans-serif, system-ui, -apple-system",
  borderRadius: {
    container: "12px",
    inner: "8px",
    button: "8px"
  },
  colors: {
    primary: "#277EEC",
    gradient: ["#277EEC", "#1499E4"]
  },
  components: {
    button: {
      variant: "gradient"
    }
  }
}, ZI = {}, PP = [
  {
    constant: !0,
    inputs: [],
    name: "name",
    outputs: [{ name: "", type: "string" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [{ name: "_upgradedAddress", type: "address" }],
    name: "deprecate",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      { name: "_spender", type: "address" },
      { name: "_value", type: "uint256" }
    ],
    name: "approve",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "deprecated",
    outputs: [{ name: "", type: "bool" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [{ name: "_evilUser", type: "address" }],
    name: "addBlackList",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "totalSupply",
    outputs: [{ name: "", type: "uint256" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      { name: "_from", type: "address" },
      { name: "_to", type: "address" },
      { name: "_value", type: "uint256" }
    ],
    name: "transferFrom",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "upgradedAddress",
    outputs: [{ name: "", type: "address" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [{ name: "", type: "address" }],
    name: "balances",
    outputs: [{ name: "", type: "uint256" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "decimals",
    outputs: [{ name: "", type: "uint256" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "maximumFee",
    outputs: [{ name: "", type: "uint256" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "_totalSupply",
    outputs: [{ name: "", type: "uint256" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [],
    name: "unpause",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [{ name: "_maker", type: "address" }],
    name: "getBlackListStatus",
    outputs: [{ name: "", type: "bool" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      { name: "", type: "address" },
      { name: "", type: "address" }
    ],
    name: "allowed",
    outputs: [{ name: "", type: "uint256" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "paused",
    outputs: [{ name: "", type: "bool" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [{ name: "who", type: "address" }],
    name: "balanceOf",
    outputs: [{ name: "", type: "uint256" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [],
    name: "pause",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "getOwner",
    outputs: [{ name: "", type: "address" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "owner",
    outputs: [{ name: "", type: "address" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "symbol",
    outputs: [{ name: "", type: "string" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      { name: "_to", type: "address" },
      { name: "_value", type: "uint256" }
    ],
    name: "transfer",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      { name: "newBasisPoints", type: "uint256" },
      { name: "newMaxFee", type: "uint256" }
    ],
    name: "setParams",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [{ name: "amount", type: "uint256" }],
    name: "issue",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [{ name: "amount", type: "uint256" }],
    name: "redeem",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      { name: "_owner", type: "address" },
      { name: "_spender", type: "address" }
    ],
    name: "allowance",
    outputs: [{ name: "remaining", type: "uint256" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "basisPointsRate",
    outputs: [{ name: "", type: "uint256" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [{ name: "", type: "address" }],
    name: "isBlackListed",
    outputs: [{ name: "", type: "bool" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [{ name: "_clearedUser", type: "address" }],
    name: "removeBlackList",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "MAX_UINT",
    outputs: [{ name: "", type: "uint256" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [{ name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [{ name: "_blackListedUser", type: "address" }],
    name: "destroyBlackFunds",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "_initialSupply", type: "uint256" },
      { name: "_name", type: "string" },
      { name: "_symbol", type: "string" },
      { name: "_decimals", type: "uint256" }
    ],
    payable: !1,
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: !1,
    inputs: [{ indexed: !1, name: "amount", type: "uint256" }],
    name: "Issue",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [{ indexed: !1, name: "amount", type: "uint256" }],
    name: "Redeem",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [{ indexed: !1, name: "newAddress", type: "address" }],
    name: "Deprecate",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !1, name: "feeBasisPoints", type: "uint256" },
      { indexed: !1, name: "maxFee", type: "uint256" }
    ],
    name: "Params",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !1, name: "_blackListedUser", type: "address" },
      { indexed: !1, name: "_balance", type: "uint256" }
    ],
    name: "DestroyedBlackFunds",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [{ indexed: !1, name: "_user", type: "address" }],
    name: "AddedBlackList",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [{ indexed: !1, name: "_user", type: "address" }],
    name: "RemovedBlackList",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !0, name: "owner", type: "address" },
      { indexed: !0, name: "spender", type: "address" },
      { indexed: !1, name: "value", type: "uint256" }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !0, name: "from", type: "address" },
      { indexed: !0, name: "to", type: "address" },
      { indexed: !1, name: "value", type: "uint256" }
    ],
    name: "Transfer",
    type: "event"
  },
  { anonymous: !1, inputs: [], name: "Pause", type: "event" },
  { anonymous: !1, inputs: [], name: "Unpause", type: "event" }
], bI = {
  id: 1,
  network: "homestead",
  name: "Ethereum",
  nativeCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    public: {
      http: [
        "https://rpc.ankr.com/eth",
        "https://eth.meowrpc.com",
        "https://1rpc.io/eth",
        "https://endpoints.omniatech.io/v1/eth/mainnet/public",
        "https://eth.llamarpc.com",
        "https://ethereum.publicnode.com",
        "https://eth-rpc.gateway.pokt.network",
        "https://eth.drpc.org"
      ]
    },
    default: { http: ["https://rpc.ankr.com1/eth"] }
  },
  blockExplorers: {
    etherscan: { name: "Etherscan", url: "https://etherscan.io" },
    default: { name: "Etherscan", url: "https://etherscan.io" }
  },
  contracts: {
    ensRegistry: {
      address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
    },
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    }
  }
}, KP = {
  id: 56,
  name: "BNB",
  network: "bsc",
  nativeCurrency: {
    decimals: 18,
    name: "BNB",
    symbol: "BNB"
  },
  rpcUrls: {
    public: {
      http: [
        "https://rpc.ankr.com/bsc",
        "https://1rpc.io/bnb",
        "https://binance.llamarpc.com",
        "https://bsc-rpc.gateway.pokt.network",
        "https://endpoints.omniatech.io/v1/bsc/mainnet/public",
        "https://bsc-rpc.gateway.pokt.network",
        "https://bsc.publicnode.com",
        "https://bsc-mainnet.public.blastapi.io",
        "https://bsc.meowrpc.com",
        "https://bsc.drpc.org"
      ]
    },
    default: { http: ["https://rpc.ankr.com/bsc"] }
  },
  blockExplorers: {
    etherscan: { name: "BscScan", url: "https://bscscan.com" },
    default: { name: "BscScan", url: "https://bscscan.com" }
  },
  contracts: {
    ensRegistry: {
      address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
    },
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    }
  }
}, $P = {
  id: 137,
  name: "Polygon",
  network: "matic",
  nativeCurrency: {
    name: "MATIC",
    symbol: "MATIC",
    decimals: 18
  },
  rpcUrls: {
    public: {
      http: [
        "https://rpc.ankr.com/polygon",
        "https://1rpc.io/matic",
        "https://polygon.llamarpc.com",
        "https://poly-rpc.gateway.pokt.network",
        "https://endpoints.omniatech.io/v1/matic/mainnet/public",
        "https://polygon-mainnet.public.blastapi.io",
        "https://polygon-bor.publicnode.com",
        "https://polygon.meowrpc.com"
      ]
    },
    default: { http: ["https://rpc.ankr.com/polygon"] }
  },
  blockExplorers: {
    etherscan: { name: "PolygonScan", url: "https://polygonscan.com" },
    default: { name: "PolygonScan", url: "https://polygonscan.com" }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 25770160
    }
  }
}, qP = {
  id: 250,
  name: "Fantom",
  network: "fantom",
  nativeCurrency: {
    name: "Fantom",
    symbol: "FTM",
    decimals: 18
  },
  rpcUrls: {
    public: {
      http: [
        "https://rpc.ankr.com/fantom",
        "https://rpc.ftm.tools",
        "https://1rpc.io/ftm",
        "https://endpoints.omniatech.io/v1/fantom/mainnet/public",
        "https://fantom-mainnet.public.blastapi.io",
        "https://fantom.blockpi.network/v1/rpc/public",
        "https://fantom.publicnode.com",
        "https://fantom.drpc.org"
      ]
    },
    default: { http: ["https://rpc.ankr.com/fantom"] }
  },
  blockExplorers: {
    etherscan: { name: "FTMScan", url: "https://ftmscan.com" },
    default: { name: "FTMScan", url: "https://ftmscan.com" }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    }
  }
}, eK = {
  id: 25,
  name: "Cronos",
  network: "cronos",
  nativeCurrency: {
    name: "CRO",
    symbol: "CRO",
    decimals: 18
  },
  rpcUrls: {
    public: {
      http: [
        "https://rpc.vvs.finance",
        "https://1rpc.io/cro",
        "https://cronos.blockpi.network/v1/rpc/public",
        "https://evm.cronos.org"
      ]
    },
    default: { http: ["https://rpc.vvs.finance"] }
  },
  blockExplorers: {
    etherscan: { name: "Cronoscan", url: "https://cronoscan.com" },
    default: { name: "Cronoscan", url: "https://cronoscan.com" }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    }
  }
}, tK = {
  id: 108,
  name: "ThunderCore",
  network: "thundercore",
  nativeCurrency: {
    name: "Thunder Token",
    symbol: "TT",
    decimals: 18
  },
  rpcUrls: {
    public: {
      http: [
        "https://mainnet-rpc.thundercore.com",
        "https://mainnet-rpc.thundertoken.net",
        "https://mainnet-rpc.thundercore.io"
      ]
    },
    default: { http: ["https://mainnet-rpc.thundercore.com"] }
  },
  blockExplorers: {
    etherscan: {
      name: "ThunderCorescan",
      url: "https://viewblock.io/thundercore"
    },
    default: {
      name: "ThunderCorescan",
      url: "https://viewblock.io/thundercore"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    }
  }
}, nK = {
  id: 43114,
  name: "Avalanche",
  network: "avalanche",
  nativeCurrency: {
    name: "Avalanche",
    symbol: "AVAX",
    decimals: 18
  },
  rpcUrls: {
    public: {
      http: [
        "https://api.avax.network/ext/bc/C/rpc",
        "https://1rpc.io/avax/c",
        "https://rpc.ankr.com/avalanche",
        "https://avalanche-c-chain.publicnode.com",
        "https://avalanche.blockpi.network/v1/rpc/public",
        "https://avalanche.drpc.org"
      ]
    },
    default: { http: ["https://rpc.ankr.com/avalanche"] }
  },
  blockExplorers: {
    etherscan: {
      name: "SnowTrace",
      url: "https://www.oklink.com/avax"
    },
    default: {
      name: "SnowTrace",
      url: "https://www.oklink.com/avax"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    }
  }
}, rK = {
  id: 321,
  name: "KCC",
  network: "kcc",
  nativeCurrency: {
    name: "KuCoin Token",
    symbol: "KCS",
    decimals: 18
  },
  rpcUrls: {
    public: {
      http: [
        "https://rpc-mainnet.kcc.network",
        "https://kcc.mytokenpocket.vip",
        "https://kcc-rpc.com"
      ]
    },
    default: { http: ["https://rpc-mainnet.kcc.network"] }
  },
  blockExplorers: {
    etherscan: {
      name: "KCCExplorer",
      url: "https://scan.kcc.io"
    },
    default: {
      name: "KCCExplorer",
      url: "https://scan.kcc.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    }
  }
}, iK = {
  id: 42161,
  name: "Arbitrum",
  network: "arbitrum",
  nativeCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    public: {
      http: [
        "https://arb1.arbitrum.io/rpc",
        "https://1rpc.io/arb",
        "https://rpc.ankr.com/arbitrum",
        "https://arbitrum.llamarpc.com",
        "https://arbitrum.blockpi.network/v1/rpc/public",
        "https://arbitrum-one.public.blastapi.io",
        "https://arbitrum-one.publicnode.com",
        "https://arbitrum.meowrpc.com",
        "https://arbitrum.drpc.org"
      ]
    },
    default: { http: ["https://arb1.arbitrum.io/rpc"] }
  },
  blockExplorers: {
    etherscan: {
      name: "Arbiscan",
      url: "https://arbiscan.io"
    },
    default: {
      name: "Arbiscan",
      url: "https://arbiscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 7654707
    }
  }
}, aK = {
  id: 10,
  name: "Optimism",
  network: "optimism",
  nativeCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    public: {
      http: [
        "https://rpc.ankr.com/optimism",
        "https://1rpc.io/op",
        "https://optimism.llamarpc.com",
        "https://optimism.publicnode.com",
        "https://optimism.blockpi.network/v1/rpc/public",
        "https://optimism.api.onfinality.io/public",
        "https://optimism.meowrpc.com",
        "https://optimism.drpc.org"
      ]
    },
    default: { http: ["https://rpc.ankr.com/optimism"] }
  },
  blockExplorers: {
    etherscan: {
      name: "Etherscan",
      url: "https://optimistic.etherscan.io"
    },
    default: {
      name: "Optimism Explorer",
      url: "https://explorer.optimism.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 4286263
    }
  }
}, oK = {
  id: 592,
  name: "Astar",
  network: "astar",
  nativeCurrency: {
    name: "ASTR",
    symbol: "ASTR",
    decimals: 18
  },
  rpcUrls: {
    public: {
      http: [
        "https://evm.astar.network",
        "https://1rpc.io/astr",
        "https://astar-rpc.dwellir.com",
        "https://astar.public.blastapi.io",
        "https://astar.api.onfinality.io/public"
      ]
    },
    default: { http: ["https://evm.astar.network"] }
  },
  blockExplorers: {
    default: {
      name: "Blockscout Astar",
      url: "https://blockscout.com/astar"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 761794
    }
  }
}, sK = {
  id: 1285,
  name: "Moonriver",
  network: "moonriver",
  nativeCurrency: {
    name: "MOVR",
    symbol: "MOVR",
    decimals: 18
  },
  rpcUrls: {
    public: {
      http: [
        "https://rpc.api.moonriver.moonbeam.network",
        "https://moonriver.public.blastapi.io"
      ]
    },
    default: { http: ["https://rpc.api.moonriver.moonbeam.network"] }
  },
  blockExplorers: {
    etherscan: {
      name: "Moonscan",
      url: "https://moonriver.moonscan.io"
    },
    default: {
      name: "Moonscan",
      url: "https://moonriver.moonscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 1597904
    }
  }
}, lK = {
  id: 8217,
  name: "Klaytn",
  network: "klaytn",
  nativeCurrency: {
    name: "Klaytn",
    symbol: "KLAY",
    decimals: 18
  },
  rpcUrls: {
    public: {
      http: [
        "https://rpc.ankr.com/klaytn",
        "https://klaytn.blockpi.network/v1/rpc/public",
        "https://klaytn.api.onfinality.io/public",
        "https://klaytn.drpc.org",
        "https://1rpc.io/klay"
      ]
    },
    default: { http: ["https://rpc.ankr.com/klaytn"] }
  },
  blockExplorers: {
    default: {
      name: "Klaytn Explorer",
      url: "https://scope.klaytn.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    }
  }
}, cK = {
  id: 10507,
  name: "Numbers",
  network: "numbers",
  nativeCurrency: {
    name: "Numbers",
    symbol: "NUM",
    decimals: 18
  },
  rpcUrls: {
    public: { http: ["https://mainnetrpc.num.network"] },
    default: { http: ["https://mainnetrpc.num.network"] }
  },
  blockExplorers: {
    default: {
      name: "Numbers Explorer",
      url: "https://mainnet.num.network"
    }
  },
  contracts: {
    multicall3: {
      address: "0xEE1Dc36185c460f8078E149F61E37f23A2120048"
    }
  }
}, dK = {
  id: 324,
  name: "zkSync Era",
  network: "zksync-era",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    public: {
      http: [
        "https://zksync2-mainnet.zksync.io",
        "https://rpc.ankr.com/zksync_era",
        "https://1rpc.io/zksync2-era",
        "https://zksync.meowrpc.com",
        "https://zksync.drpc.org",
        "https://zksync-era.blockpi.network/v1/rpc/public",
        "https://mainnet.era.zksync.io"
      ]
    },
    default: { http: ["https://zksync2-mainnet.zksync.io"] }
  },
  blockExplorers: {
    etherscan: {
      name: "zkSync Era Explorer",
      url: "https://www.oklink.com/zksync"
    },
    default: {
      name: "zkSync Era Explorer",
      url: "https://www.oklink.com/zksync"
    }
  },
  contracts: {
    multicall3: {
      address: "0xF9cda624FBC7e059355ce98a31693d299FACd963"
    }
  }
}, uK = {
  id: 1101,
  name: "Polygon zkEVM",
  network: "polygon-zkevm",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    public: {
      http: [
        "https://zkevm-rpc.com",
        "https://1rpc.io/polygon/zkevm",
        "https://rpc.ankr.com/polygon_zkevm",
        "https://polygon-zkevm.blockpi.network/v1/rpc/public",
        "https://polygon-zkevm-mainnet.public.blastapi.io",
        "https://polygon-zkevm.drpc.org"
      ]
    },
    default: { http: ["https://zkevm-rpc.com"] }
  },
  blockExplorers: {
    etherscan: {
      name: "Polygon zkEVM Explorer",
      url: "https://zkevm.polygonscan.com"
    },
    default: {
      name: "Polygon zkEVM Explorer",
      url: "https://zkevm.polygonscan.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    }
  }
}, hK = {
  id: 59144,
  name: "Linea",
  network: "linea",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    public: {
      http: [
        "https://rpc.linea.build",
        "https://1rpc.io/linea",
        "https://linea.blockpi.network/v1/rpc/public",
        "https://linea.drpc.org"
      ]
    },
    default: { http: ["https://rpc.linea.build"] }
  },
  blockExplorers: {
    etherscan: {
      name: "Linea Explorer",
      url: "https://lineascan.build"
    },
    default: {
      name: "Linea Explorer",
      url: "https://lineascan.build"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    }
  }
}, NK = {
  id: 8453,
  name: "Base",
  network: "base",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    public: {
      http: [
        "https://base.blockpi.network/v1/rpc/public",
        "https://1rpc.io/base",
        "https://rpc.ankr.com/base",
        "https://base-mainnet.diamondswap.org/rpc",
        "https://base-mainnet.public.blastapi.io",
        "https://base.publicnode.com",
        "https://base.meowrpc.com",
        "https://mainnet.base.org"
      ]
    },
    default: { http: ["https://base.blockpi.network/v1/rpc/public"] }
  },
  blockExplorers: {
    etherscan: {
      name: "Base Explorer",
      url: "https://basescan.org"
    },
    default: {
      name: "Base Explorer",
      url: "https://basescan.org"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    }
  }
}, MK = {
  id: 5e3,
  name: "Mantle",
  network: "mantle",
  nativeCurrency: {
    decimals: 18,
    name: "MNT",
    symbol: "MNT"
  },
  rpcUrls: {
    public: {
      http: [
        "https://rpc.ankr.com/mantle",
        "https://mantle-mainnet.public.blastapi.io",
        "https://rpc.mantle.xyz",
        "https://mantle.drpc.org"
      ]
    },
    default: { http: ["https://rpc.mantle.xyz"] }
  },
  blockExplorers: {
    etherscan: {
      name: "Mantle Explorer",
      url: "https://explorer.mantle.xyz"
    },
    default: {
      name: "Mantle Explorer",
      url: "https://explorer.mantle.xyz"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    }
  }
}, pK = {
  id: 534352,
  name: "Scroll",
  network: "scroll",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    public: {
      http: [
        "https://rpc.scroll.io",
        "https://1rpc.io/scroll",
        "https://scroll.blockpi.network/v1/rpc/public"
      ]
    },
    default: { http: ["https://rpc.scroll.io"] }
  },
  blockExplorers: {
    etherscan: {
      name: "Scroll Explorer",
      url: "https://scrollscan.com"
    },
    default: {
      name: "Scroll Explorer",
      url: "https://scrollscan.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    }
  }
}, mK = {
  id: 5,
  network: "goerli",
  name: "Goerli",
  nativeCurrency: {
    name: "Goerli Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    public: { http: ["https://rpc.ankr.com/eth_goerli"] },
    default: { http: ["https://rpc.ankr.com/eth_goerli"] }
  },
  blockExplorers: {
    default: { name: "Etherscan", url: "https://goerli.etherscan.io" }
  },
  contracts: {
    ensRegistry: {
      address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 6507670
    }
  },
  testnet: !0
}, TK = {
  id: 97,
  name: "BNB",
  network: "bsc-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "BNB",
    symbol: "BNB"
  },
  rpcUrls: {
    public: { http: ["https://rpc.ankr.com/bsc_testnet_chapel"] },
    default: { http: ["https://rpc.ankr.com/bsc_testnet_chapel"] }
  },
  blockExplorers: {
    etherscan: { name: "BscScan", url: "https://testnet.bscscan.com" },
    default: { name: "BscScan", url: "https://testnet.bscscan.com" }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 17422483
    }
  },
  testnet: !0
}, fK = {
  id: 80001,
  name: "Mumbai",
  network: "maticmum",
  nativeCurrency: {
    decimals: 18,
    name: "MATIC",
    symbol: "MATIC"
  },
  rpcUrls: {
    public: { http: ["https://rpc.ankr.com/polygon_mumbai"] },
    default: { http: ["https://rpc.ankr.com/polygon_mumbai"] }
  },
  blockExplorers: {
    etherscan: { name: "PolygonScan", url: "https://mumbai.polygonscan.com" },
    default: { name: "PolygonScan", url: "https://mumbai.polygonscan.com" }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 25770160
    }
  },
  testnet: !0
}, VK = {
  id: 4002,
  name: "Fantom",
  network: "fantom-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Fantom",
    symbol: "FTM"
  },
  rpcUrls: {
    public: { http: ["https://rpc.testnet.fantom.network"] },
    default: { http: ["https://rpc.testnet.fantom.network"] }
  },
  blockExplorers: {
    etherscan: { name: "FTMScan", url: "https://testnet.ftmscan.com" },
    default: { name: "FTMScan", url: "https://testnet.ftmscan.com" }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 8328688
    }
  },
  testnet: !0
}, UK = {
  id: 338,
  name: "Cronos",
  network: "cronos-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "TCRO",
    symbol: "TCRO"
  },
  rpcUrls: {
    public: { http: ["https://cronos-testnet-3.crypto.org:8545"] },
    default: { http: ["https://cronos-testnet-3.crypto.org:8545"] }
  },
  blockExplorers: {
    etherscan: {
      name: "CronosScan",
      url: "https://cronos.crypto.org/explorer/testnet3"
    },
    default: {
      name: "CronosScan",
      url: "https://cronos.crypto.org/explorer/testnet3"
    }
  },
  contracts: {
    // TODO: Deploy a real multicall3 contract
    multicall3: {
      address: "0xF853dC76229fc930B3b4271380a5b551cE8e3364",
      blockCreated: 7653008
    }
  },
  testnet: !0
}, RK = {
  id: 18,
  name: "ThunderCore",
  network: "thundercore-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "TT",
    symbol: "TT"
  },
  rpcUrls: {
    public: { http: ["https://testnet-rpc.thundercore.com"] },
    default: { http: ["https://testnet-rpc.thundercore.com"] }
  },
  blockExplorers: {
    etherscan: {
      name: "ThunderCoreScan",
      url: "https://explorer-testnet.thundercore.com"
    },
    default: {
      name: "ThunderCoreScan",
      url: "https://explorer-testnet.thundercore.com"
    }
  },
  contracts: {
    // TODO: Deploy a real multicall3 contract
    multicall3: {
      address: "0x06b076ac7A4252343bF6Dbc78da76b9DC653c736",
      blockCreated: 99763319
    }
  },
  testnet: !0
}, gK = {
  id: 43113,
  name: "Fuji",
  network: "avalanche-fuji",
  nativeCurrency: {
    decimals: 18,
    name: "Avalanche Fuji",
    symbol: "AVAX"
  },
  rpcUrls: {
    public: { http: ["https://rpc.ankr.com/avalanche_fuji"] },
    default: { http: ["https://rpc.ankr.com/avalanche_fuji"] }
  },
  blockExplorers: {
    etherscan: {
      name: "SnowTrace",
      url: "https://subnets-test.avax.network"
    },
    default: {
      name: "SnowTrace",
      url: "https://subnets-test.avax.network"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 7096959
    }
  },
  testnet: !0
}, yK = {
  id: 322,
  name: "KCC",
  network: "kcc-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "KCS",
    symbol: "KCS"
  },
  rpcUrls: {
    public: { http: ["https://rpc-testnet.kcc.network"] },
    default: { http: ["https://rpc-testnet.kcc.network"] }
  },
  blockExplorers: {
    etherscan: {
      name: "KCC Explorer",
      url: "https://scan-testnet.kcc.network"
    },
    default: {
      name: "KCC Explorer",
      url: "https://scan-testnet.kcc.network"
    }
  },
  contracts: {
    // TODO: Deploy a real multicall3 contract
    multicall3: {
      address: "0x5ad18149804f181f0F13A8C26ebC3D4aD9Fa48a6",
      blockCreated: 9881167
    }
  },
  testnet: !0
}, ZK = {
  id: 421611,
  name: "Arbitrum",
  network: "arbitrum-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Ethereum",
    symbol: "ETH"
  },
  rpcUrls: {
    public: { http: ["https://rinkeby.arbitrum.io/rpc"] },
    default: { http: ["https://rinkeby.arbitrum.io/rpc"] }
  },
  blockExplorers: {
    etherscan: {
      name: "Arbitrum Explorer",
      url: "https://testnet.arbiscan.io"
    },
    default: {
      name: "Arbitrum Explorer",
      url: "https://testnet.arbiscan.io"
    }
  },
  contracts: {
    // TODO: Deploy a real multicall3 contract
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 88114
    }
  },
  testnet: !0
}, bK = {
  id: 420,
  name: "Optimism",
  network: "optimism-goerli",
  nativeCurrency: {
    decimals: 18,
    name: "Goerli Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    public: { http: ["https://rpc.ankr.com/optimism_testnet"] },
    default: { http: ["https://rpc.ankr.com/optimism_testnet"] }
  },
  blockExplorers: {
    etherscan: {
      name: "Etherscan",
      url: "https://goerli-optimism.etherscan.io"
    },
    default: {
      name: "Blockscout optimism goerli",
      url: "https://blockscout.com/optimism/goerli"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 49461
    }
  },
  testnet: !0
}, EK = {
  id: 81,
  name: "Astar",
  network: "astar-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "SBY",
    symbol: "SBY"
  },
  rpcUrls: {
    public: { http: ["https://evm.shibuya.astar.network"] },
    default: { http: ["https://evm.shibuya.astar.network"] }
  },
  blockExplorers: {
    etherscan: {
      name: "Blocksout shibuya",
      url: "https://blockscout.com/shibuya"
    },
    default: {
      name: "Blocksout shibuya",
      url: "https://blockscout.com/shibuya"
    }
  },
  contracts: {
    // TODO: Deploy a real multicall3 contract
    multicall3: {
      address: "0x0d8bbc46011D4fc5110dCb241810C9d2967497e0",
      blockCreated: 1546215
    }
  },
  testnet: !0
}, SK = {
  id: 1287,
  name: "Alpha",
  network: "moonbase-alpha",
  nativeCurrency: {
    decimals: 18,
    name: "DEV",
    symbol: "DEV"
  },
  rpcUrls: {
    public: { http: ["https://rpc.api.moonbase.moonbeam.network"] },
    default: { http: ["https://rpc.api.moonbase.moonbeam.network"] }
  },
  blockExplorers: {
    etherscan: {
      name: "Moonscan",
      url: "https://moonbase.moonscan.io"
    },
    default: {
      name: "Moonscan",
      url: "https://moonbase.moonscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 1850686
    }
  },
  testnet: !0
}, xK = {
  id: 1001,
  name: "Klaytn",
  network: "klaytn-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Klaytn",
    symbol: "KLAY"
  },
  rpcUrls: {
    public: { http: ["https://rpc.ankr.com/klaytn_testnet"] },
    default: { http: ["https://rpc.ankr.com/klaytn_testnet"] }
  },
  blockExplorers: {
    etherscan: {
      name: "Klaytn Explorer",
      url: "https://baobab.scope.klaytn.com"
    },
    default: {
      name: "Klaytn Explorer",
      url: "https://baobab.scope.klaytn.com"
    }
  },
  contracts: {
    // TODO: Deploy a real multicall3 contract
    multicall3: {
      address: "0x0d8bbc46011D4fc5110dCb241810C9d2967497e0",
      blockCreated: 95414688
    }
  },
  testnet: !0
}, WK = {
  id: 10508,
  name: "Numbers",
  network: "numbers-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Numbers",
    symbol: "NUM"
  },
  rpcUrls: {
    public: { http: ["https://testnetrpc.num.network"] },
    default: { http: ["https://testnetrpc.num.network"] }
  },
  blockExplorers: {
    etherscan: {
      name: "Numbers Explorer",
      url: "https://testnet.num.network"
    },
    default: {
      name: "Numbers Explorer",
      url: "https://testnet.num.network"
    }
  },
  contracts: {
    // TODO: Deploy a real multicall3 contract
    multicall3: {
      address: "0x44A63889fbc4e82aAEFffC2905B9c570a76873fe",
      blockCreated: 39563
    }
  },
  testnet: !0
}, jK = {
  id: 280,
  name: "zkSyncEra",
  network: "zksync-era-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    public: { http: ["https://zksync2-testnet.zksync.dev"] },
    default: { http: ["https://zksync2-testnet.zksync.dev"] }
  },
  blockExplorers: {
    etherscan: {
      name: "zkSync Era Explorer",
      url: "https://goerli.explorer.zksync.io"
    },
    default: {
      name: "zkSync Era Explorer",
      url: "https://goerli.explorer.zksync.io"
    }
  },
  contracts: {
    // TODO: Deploy a real multicall3 contract
    multicall3: {
      address: "0x1751eECaDe35F26fc5C4A48A6Fe8aBE0c615739A"
    }
  },
  testnet: !0
}, DK = {
  id: 280,
  name: "Polygon zkEVM",
  network: "polygon-zkevm-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    public: { http: ["https://rpc.public.zkevm-test.net"] },
    default: { http: ["https://rpc.public.zkevm-test.net"] }
  },
  blockExplorers: {
    etherscan: {
      name: "Polygon zkEVM Explorer",
      url: "https://testnet-zkevm.polygonscan.com"
    },
    default: {
      name: "Polygon zkEVM Explorer",
      url: "https://testnet-zkevm.polygonscan.com"
    }
  },
  contracts: {
    // TODO: Deploy a real multicall3 contract
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    }
  },
  testnet: !0
}, zK = {
  id: 59140,
  name: "Linea Goerli",
  network: "linea-goerli",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    public: { http: ["https://rpc.goerli.linea.build"] },
    default: { http: ["https://rpc.goerli.linea.build"] }
  },
  blockExplorers: {
    etherscan: {
      name: "Linea Explorer",
      url: "https://explorer.goerli.linea.build"
    },
    default: {
      name: "Linea Explorer",
      url: "https://explorer.goerli.linea.build"
    }
  },
  contracts: {
    // TODO: Deploy a real multicall3 contract
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    }
  }
}, kK = {
  id: 84531,
  name: "Base Testnet",
  network: "base-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    public: { http: ["https://goerli.base.org"] },
    default: { http: ["https://goerli.base.org"] }
  },
  blockExplorers: {
    etherscan: {
      name: "Base Explorer",
      url: "https://goerli.basescan.org"
    },
    default: {
      name: "Base Explorer",
      url: "https://goerli.basescan.org"
    }
  },
  contracts: {
    // TODO: Deploy a real multicall3 contract
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    }
  }
}, wK = {
  id: 5001,
  name: "Mantle Testnet",
  network: "mantle-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "MNT",
    symbol: "MNT"
  },
  rpcUrls: {
    public: { http: ["https://rpc.testnet.mantle.xyz"] },
    default: { http: ["https://rpc.testnet.mantle.xyz"] }
  },
  blockExplorers: {
    etherscan: {
      name: "Mantle Explorer",
      url: "https://explorer.testnet.mantle.xyz"
    },
    default: {
      name: "Mantle Explorer",
      url: "https://explorer.testnet.mantle.xyz"
    }
  },
  contracts: {
    // TODO: Deploy a real multicall3 contract
    multicall3: {
      address: "0xA70bD0f369C776B2774FD3C0949DCb5251fC3b79"
    }
  }
}, FK = {
  id: 534351,
  name: "Scroll",
  network: "scroll-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    public: {
      http: ["https://sepolia-rpc.scroll.io"]
    },
    default: { http: ["https://sepolia-rpc.scroll.io"] }
  },
  blockExplorers: {
    etherscan: {
      name: "Scroll Explorer",
      url: "https://sepolia.scrollscan.com"
    },
    default: {
      name: "Scroll Explorer",
      url: "https://sepolia.scrollscan.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    }
  }
}, vK = {
  id: 195,
  name: "X1",
  network: "x1-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "OKB",
    symbol: "OKB"
  },
  rpcUrls: {
    public: {
      http: [
        /**
         * @todo
         * replace this with real X1 mainnet rpc
         */
        "https://x1testrpc.okx.com",
        "https://testrpc.x1.tech"
      ]
    },
    default: { http: ["https://x1testrpc.okx.com"] }
  },
  blockExplorers: {
    default: {
      name: "X1 scan",
      url: "https://www.oklink.com/x1-test"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    }
  }
}, m3 = [
  /**
   * @todo 等 x1 上線後，改掉
   */
  bI,
  vK,
  pK,
  MK,
  hK,
  NK,
  iK,
  dK,
  KP,
  $P,
  lK,
  uK,
  nK,
  aK,
  eK,
  qP,
  oK,
  rK,
  sK,
  tK,
  cK
], T3 = [
  mK,
  TK,
  fK,
  VK,
  UK,
  RK,
  gK,
  yK,
  ZK,
  bK,
  EK,
  SK,
  xK,
  WK,
  jK,
  DK,
  zK,
  kK,
  wK,
  FK
], vN = [
  ...m3,
  ...T3
];
class bo {
  static getRpcUrl(e) {
    const n = typeof e == "string" ? parseInt(e) : e, r = vN.find(
      (i) => i.id === n
    );
    return r ? r.rpcUrls.default.http[0] : null;
  }
  static getNetworkName(e) {
    const n = typeof e == "string" ? parseInt(e) : e, r = vN.find(
      (i) => i.id === n
    );
    if (!r)
      return "Unknown Network";
    switch (String(r.id)) {
      case ve.POLYGON_ZKEVM_MAINNET:
      case ve.POLYGON_ZKEVM_TESTNET:
        return "zkEVM";
      default:
        return r.name;
    }
  }
  static getMulticallAddress(e) {
    var i, a;
    const n = typeof e == "string" ? parseInt(e) : e, r = vN.find(
      (o) => o.id === n
    );
    return r ? (a = (i = r.contracts) == null ? void 0 : i.multicall3) == null ? void 0 : a.address : null;
  }
  static getExplorerUrl(e) {
    var i;
    const n = typeof e == "string" ? parseInt(e) : e, r = vN.find(
      (a) => a.id === n
    );
    return r ? (i = r.blockExplorers) == null ? void 0 : i.default.url : null;
  }
  static getTxExplorerUrl(e, n, r) {
    switch (n = String(n), n) {
      default:
        return e + "/tx/" + r;
    }
  }
  static getAddressExplorerUrl(e, n, r) {
    switch (n) {
      default:
        return `${e}/address/${r}`;
    }
  }
}
Vt(bo, "getBridgeName", (e, n) => {
  switch (e) {
    case ci.Y_BRIDGE:
      return "yBridge";
    case ci.C_BRIDGE:
      return "cBridge";
    case ci.MULTICHAIN:
      return "Multichain";
    case ci.TOKEN_BRIDGE:
      return "Token Bridge";
    case ci.SYNAPSE:
      return "Synapase";
    case ci.XASSET_BRIDGE:
      return n ? `${n} Bridge` : "Xasset Bridge";
    case ci.CELER_CCTP:
      return "Circle CCTP";
    default:
      return e || "Unknown Bridge";
  }
}), Vt(bo, "getDexAggregatorName", (e) => {
  switch (e) {
    case Lu.ONE_INCH_V5:
    case Lu.ONE_INCH_V4:
      return "1inch";
    case Lu.OPEN_OCEAN:
      return "OpenOcean";
    case Lu.XY_DEX_AGGREGATOR:
      return "XY Aggregator";
    case Lu.OKX:
      return "OKX DEX";
    default:
      return e || "Unknown DexAggregator";
  }
}), /**
 *
 * @deprecated
 * 這邊並不是因為 ETH USDT 的 allowance 有問題
 * 而是你在不同的鏈上，卻去查看 Ethereum 的 USDT 的 allowance，才會導致出現錯誤
 */
// USDT on Ethereum mainnet is not ERC20 compliant
// Therefore, we need to use a different ABI for USDT on Ethereum mainnet
Vt(bo, "getERC20ABI", ({
  tokenAddress: e,
  chainId: n
}) => e === HP && n === parseInt(ve.MAINNET) ? PP : Hy);
const pj = {
  [ve.ARBITRUM_MAINNET]: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
  [ve.OPTIMISM_MAINNET]: "0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85",
  [ve.POLYGON_MAINNET]: "0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359",
  [ve.AVALANCHE_MAINNET]: "0xA7D7079b0FEaD91F3e65f86E8915Cb59c1a4C664",
  [ve.BASE_MAINNET]: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913"
};
class Ky {
  static isXYToken(e, n) {
    return !!Object.values(n).find((i) => e.address === i);
  }
  static isUSDT(e, n) {
    return !!Object.values(n).find(
      (i) => {
        var a;
        return e.address === ((a = i.USDT) == null ? void 0 : a.tokenAddress);
      }
    );
  }
  static isCircleUSDC(e) {
    return e.chainId in pj ? e.address === pj[e.chainId] : !1;
  }
  static isUSDC(e, n) {
    return !!Object.values(n).find(
      (i) => {
        var a;
        return e.address === ((a = i.USDC) == null ? void 0 : a.tokenAddress);
      }
    );
  }
  static getTokensSortedByPopularity(e, n) {
    const r = [...e];
    if (!n)
      return r;
    const { xyTokenContract: i, yPoolDepositContract: a } = n;
    return r.sort((o, s) => this.isXYToken(o, i) ? -1 : this.isXYToken(s, i) ? 1 : 0).sort((o, s) => this.isUSDC(o, a) ? -1 : this.isUSDC(s, a) ? 1 : 0).sort((o, s) => this.isCircleUSDC(o) ? -1 : this.isCircleUSDC(s) ? 1 : 0).sort((o, s) => this.isUSDT(o, a) ? -1 : this.isUSDT(s, a) ? 1 : 0).sort((o, s) => o.address === zi ? -1 : s.address === zi ? 1 : 0);
  }
  static getTokensSortedByBalance(e) {
    const n = e.filter((i) => i.balance.gt(0)), r = e.filter((i) => i.balance.eq(0));
    return [...n, ...r];
  }
}
class EI {
  static getErrorMessageDisplayFromErrorCode(e) {
    switch (e) {
      case Bt.Unknown_Error:
        return "Unknown error.";
      case Bt.System_Maintenance:
        return "System maintenance.";
      case Bt.Invalid_Affiliate_Address:
        return "Invalid affiliate address.";
      case Bt.Invalid_Receiver_Address:
        return "Invalid reciever address.";
      case Bt.Invalid_Slippage:
        return "Invalid slippage.";
      case Bt.Required_Swap_Provider:
        return "SwapProvider is required.";
      case Bt.Required_Bridge_Provider:
        return "BridgeProvider, srcBridgeTokenAddress and dstBridgeTokenAddress are required.";
      case Bt.Address_Invalid:
        return "Address_Invalid.";
      case Bt.Cannot_Apply_Swap_Provider:
        return "Cannot apply swap provider.";
      case Bt.Cannot_Apply_Bridge_Provider:
        return "Cannot apply bridge provider.";
      case Bt.Not_Supported_Network:
        return "Not supported network.";
      case Bt.No_Available_Route:
        return "No available route found. Please try again later or attempt another bridge request.";
      case Bt.Not_Supported_Bridge_Provider:
        return "Not supported bridge provider.";
      case Bt.Invalid_Commision_Rate:
        return "Invalid commision rate.";
      case Bt.Not_Supported_Swap_Provider:
        return "Not supported swap provider.";
      case Bt.Service_Temporary_Down:
        return "The network is under maintenance, please follow our update.";
      case Bt.Y_Pool_Amount_Too_Big:
        return "[yBridge] Given amount not supported, please try a smaller amount.";
      case Bt.Y_Pool_Liquidity_Insufficient:
        return "[yBridge] Liquidity insufficient.";
      case Bt.Y_Pool_Not_Supported_Bridge_Token:
        return "[yBridge] Not supported bridge token.";
      case Bt.Y_Pool_Amount_Too_Small:
        return "[yBridge] Given amount not supported, please try a larger amount.";
      case Bt.C_Bridge_Amount_Too_Small:
        return "[cBridge] Given amount not supported, please try a larger amount.";
      case Bt.C_Bridge_Amount_Too_Big:
        return "[cBridge] Given amount not supported, please try a smaller amount.";
      case Bt.C_Bridge_Fee_Too_High:
        return "[cBridge] Given amount not supported, please try a larger amount.";
      case Bt.C_Bridge_API_Failed:
        return "[cBridge] Api fail to information, please try again later.";
      case Bt.Multichain_Not_Supported_Bridge_Token:
        return "[Multichain] Not supported bridge token.";
      case Bt.Multichain_Amount_Too_Small:
        return "[Multichain] Given amount not supported, please try a larger amount.";
      case Bt.Multichain_Amount_Too_Big:
        return "[Multichain] Given amount not supported, please try a smaller amount.";
      case Bt.Multichain_Amount_Too_High:
        return "[Multichain] Given amount not supported, please try a larger amount.";
      case Bt.Xasset_Liquidity_Insufficient:
        return "[Xasset] Liquidity insufficient.";
      case Bt.Xasset_Fee_Too_High:
        return "[Xasset] Given amount not supported, please try a larger amount.";
      case Bt.Celer_CCTP_Fee_Too_High:
        return "[CCTP] Api fail to information, please try again later.";
      case Bt.Synapse_Fee_Too_High:
        return "[Synapse] Given amount not supported, please try a larger amount.";
      case Bt.Synapse_Liquidity_Not_Enough:
        return "[Synapse] Liquidity insufficient.";
      case Bt.Build_Tx_Rate_Limit:
        return "There was a temporary issue retrieving the quote. Please refresh the quote to try again.";
      default:
        return `errorCode: ${e}`;
    }
  }
}
const ds = class ds {
  /**
   * @Instance
   * The ClientSideEVMServer's constructor should always be private to prevent direct
   * construction calls with the `new` operator.
   */
  constructor(e) {
    this.viemClientMap = e;
  }
  // init
  static init(e) {
    if (ds.inited)
      throw new Error("ClientSideEVMServer is already init");
    const { viemClientMap: n } = e;
    ds.clientSideEVMServer = new ds(
      n
    ), ds.inited = !0;
  }
  // The static method that controls the access to the singleton instance.
  static getInstance() {
    return ds.clientSideEVMServer;
  }
  /**
   * @BussinesssLogic
   * Finally, any singleton should define some business logic, which can be
   * executed on its instance.
   */
  async getUserTokenMap(e, n, r) {
    try {
      if (Object.keys(n).length === 0)
        throw new Error("tokenMap is empty");
      const i = Object.entries(n).map(
        ([c, d]) => {
          const u = this.viemClientMap[c];
          return this.getBalanceTokens({
            address: e,
            chainId: c,
            publicClient: u,
            tokens: d,
            signal: r
          });
        }
      );
      return (await Promise.allSettled(i)).filter(
        (c) => c.status === "fulfilled"
      ).map(
        (c) => c.value
      ).flat().reduce((c, d) => {
        const u = d.chainId;
        return typeof c[u] > "u" ? c[u] = [d] : c[u].push(d), c;
      }, {});
    } catch (i) {
      throw console.error("GET_USER_TOKEN_MAP_ERROR", i), i;
    }
  }
  async getBalanceTokens(e) {
    const { address: n, chainId: r, publicClient: i, tokens: a, onError: o } = e;
    if (!bo.getRpcUrl(r))
      return [];
    try {
      const l = a.find(
        (m) => m.address === zi
      );
      if (!l)
        throw Error("Native token not found.");
      const c = a.filter(
        (m) => m.address !== zi
      ), d = i.getBalance({
        address: n
      }), u = i.multicall({
        allowFailure: !1,
        contracts: c.map((m) => ({
          address: m.address,
          abi: Hy,
          functionName: "balanceOf",
          args: [n]
        }))
      }), [h, N] = await Promise.all([
        d,
        u
      ]), M = {
        ...l,
        balance: pn.from(h)
      }, p = c.map((m, R) => ({
        ...m,
        balance: pn.from(N[R])
      }));
      return [M, ...p];
    } catch (l) {
      throw console.error(`GET_BALANCE_TOKENS_ERROR | chainId: ${r}`, l), o && o(l), l;
    }
  }
  async checkContractExistence(e, n) {
    const r = await n.getBytecode({ address: e });
    return r ? r.startsWith("0x") : !1;
  }
  async getRawToken(e, n) {
    const r = bo.getRpcUrl(n), i = this.viemClientMap[n], a = await this.checkContractExistence(
      e,
      i
    );
    if (!r || !a)
      return null;
    const o = {
      address: e,
      abi: Hy
    };
    try {
      const [s, l, c] = (await i.multicall({
        contracts: [
          {
            ...o,
            functionName: "name"
          },
          {
            ...o,
            functionName: "symbol"
          },
          {
            ...o,
            functionName: "decimals"
          }
        ]
      })).map((d) => d.result);
      return {
        address: un(e),
        symbol: l,
        name: s,
        chainId: n,
        decimals: c,
        logoURI: ""
      };
    } catch (s) {
      throw console.error(`GET_CUSTOM_TOKEN_ERROR | chainId: ${n}`, s), s;
    }
  }
  async getCustomRawTokenList(e, n) {
    if (e === "" || !Ni(e))
      return [];
    const r = n.map((i) => this.getRawToken(e, String(i.id)));
    try {
      return (await Promise.all(r)).filter(
        (a) => a !== null
      );
    } catch (i) {
      throw console.error("GET_CUSTOM_RAW_TOKENS_ERROR", i), i;
    }
  }
  async getFeeValue(e) {
    const n = this.viemClientMap[e];
    try {
      if (this.isNotSupportEIP1559(e)) {
        const { gasPrice: a } = await n.estimateFeesPerGas({
          chain: n.chain,
          type: "legacy"
        });
        return { gasPrice: a };
      }
      const { maxFeePerGas: r, maxPriorityFeePerGas: i } = await n.estimateFeesPerGas();
      return {
        maxFeePerGas: r,
        maxPriorityFeePerGas: i
      };
    } catch (r) {
      throw console.error(`GET_FEE_VALUE_ERROR | chainId:${e}`, r), r;
    }
  }
  isNotSupportEIP1559(e) {
    return _P.includes(e);
  }
};
/**
 * @Static
 */
Vt(ds, "clientSideEVMServer"), Vt(ds, "inited", !1);
let nc = ds;
function IK() {
  return vN.reduce((t, e) => (typeof t[e.id] > "u" && (t[e.id] = OK(e)), t), {});
}
function OK(t) {
  return Df({
    chain: t,
    transport: YK(t),
    batch: {
      multicall: {
        wait: 0
      }
    }
  });
}
function YK(t) {
  switch (String(t.id)) {
    default:
      return jf([...t.rpcUrls.public.http.map((e) => Qp(e))]);
  }
}
async function QK(t) {
  try {
    return (await t.get("/")).data;
  } catch (e) {
    return console.error("FETCH_TOKEN_LIST_ERROR", e), Promise.reject(e);
  }
}
const GK = async ({
  routerApi: t,
  src_chain_id: e,
  src_quote_token_address: n,
  src_quote_token_amount: r,
  dst_chain_id: i,
  dst_quote_token_address: a,
  slippage: o,
  receiver: s,
  bridge_provider: l,
  src_bridge_token_address: c,
  dst_bridge_token_address: d,
  affiliate: u,
  commission_rate: h,
  src_swap_provider: N,
  dst_swap_provider: M,
  tip_to: p,
  dst_xapp_address: m
}) => {
  try {
    return (await t.get("/build_tx", {
      params: {
        src_chain_id: e,
        src_quote_token_address: n,
        src_quote_token_amount: r,
        dst_chain_id: i,
        dst_quote_token_address: a,
        slippage: o,
        receiver: s,
        bridge_provider: l,
        src_bridge_token_address: c,
        dst_bridge_token_address: d,
        affiliate: u,
        commission_rate: h,
        src_swap_provider: N,
        dst_swap_provider: M,
        tip_to: p,
        dst_xapp_address: m
      }
    })).data;
  } catch (R) {
    return console.error("FETCH_ROUTER_BUILD_ERROR", R), Promise.reject(R);
  }
}, CK = async ({
  routerApi: t,
  src_chain_id: e,
  src_quote_token_address: n,
  src_quote_token_amount: r,
  dst_chain_id: i,
  dst_quote_token_address: a,
  slippage: o,
  affiliate: s,
  commission_rate: l
}) => {
  try {
    return (await t.get("/quote", {
      params: {
        src_chain_id: e,
        src_quote_token_address: n,
        src_quote_token_amount: r,
        dst_chain_id: i,
        dst_quote_token_address: a,
        slippage: o,
        affiliate: s,
        commission_rate: l
      }
    })).data;
  } catch (c) {
    return console.error("FETCH_ROUTER_QUOTE_ERROR", c), Promise.reject(c);
  }
}, LK = async ({
  src_chain_id: t,
  src_tx_hash: e,
  routerApi: n
}) => {
  try {
    return (await n.get(
      "/cross_chain_status",
      {
        params: {
          src_chain_id: t,
          src_tx_hash: e
        }
      }
    )).data;
  } catch (r) {
    return console.error("FETCH_ROUTER_CROSS_CHAIN_STATUS_ERROR", r), Promise.reject(r);
  }
};
async function JK(t) {
  try {
    return (await t.get(
      "/contractAddresses",
      {
        timeout: 1e4
      }
    )).data;
  } catch (e) {
    return console.error("FETCH_CONTRACT_ADDRESSES_ERROR", e), Promise.reject(e);
  }
}
function $y(t, e) {
  const n = { ...t, address: un(t.address) };
  return e.find(
    (r) => r.address === n.address && r.chainId === n.chainId
  );
}
const BK = "units/5.7.0", AK = new Xt(BK), SI = [
  "wei",
  "kwei",
  "mwei",
  "gwei",
  "szabo",
  "finney",
  "ether"
];
function ws(t, e) {
  if (typeof e == "string") {
    const n = SI.indexOf(e);
    n !== -1 && (e = 3 * n);
  }
  return vT(t, e ?? 18);
}
function HK(t, e) {
  if (typeof t != "string" && AK.throwArgumentError("value must be a string", "value", t), typeof e == "string") {
    const n = SI.indexOf(e);
    n !== -1 && (e = 3 * n);
  }
  return co(t, e ?? 18);
}
function yd(t = "", e = 6) {
  return t ? `${t.slice(0, e)}...${t.slice(t.length - 4)}` : "";
}
const XK = new RegExp(/^\d*\.?\d*$/), _K = /^(?:\d|[1-9]\d|[1-9]\d{0,1}\.\d{0,2}|0\.\d{0,2}|100|100\.0{0,2})$/;
function fr(t, e = 6, n = "Token") {
  const r = () => n === "Token" && i < 1e4 ? 6 : i < 1e-6 ? e : 2, i = typeof t == "number" ? t : parseFloat(t), a = r(), o = parseFloat(i.toFixed(a)).toString(), [s, l] = o.split("."), c = s.replace(/\B(?=(\d{3})+(?!\d))/g, ","), d = l ? `${c}.${l}` : c;
  return d === "0" ? String(t) : d;
}
function PK(t, e) {
  try {
    if (e === 0)
      return null;
    const n = new RegExp(`^(-?\\d*(?:\\.\\d{1,${e}})?)`), r = t.match(n);
    return r ? r[1].startsWith(".") ? `0${r[1]}` : r[1] : null;
  } catch (n) {
    return console.error("ROUND_TO_MAX_DECIMAL_ERROR", n), null;
  }
}
function qy(t, e) {
  const n = BigInt(1e18), [r, i = "0"] = t.split("."), [a, o = "0"] = e.split("."), s = BigInt(r) * n + BigInt(i.padEnd(18, "0")), l = BigInt(a) * n + BigInt(o.padEnd(18, "0"));
  return s > l ? 1 : s < l ? -1 : 0;
}
function KK(t) {
  const e = new Date(t), n = e.getUTCMonth() + 1, r = e.getUTCDate(), i = e.getUTCHours(), a = e.getUTCMinutes(), o = String(n).padStart(2, "0"), s = String(r).padStart(2, "0"), l = String(i).padStart(2, "0"), c = String(a).padStart(2, "0");
  return `${o}/${s} ${l}:${c}`;
}
function zf(t) {
  "@babel/helpers - typeof";
  return zf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, zf(t);
}
var $K = /^\s+/, qK = /\s+$/;
function Pe(t, e) {
  if (t = t || "", e = e || {}, t instanceof Pe)
    return t;
  if (!(this instanceof Pe))
    return new Pe(t, e);
  var n = e7(t);
  this._originalInput = t, this._r = n.r, this._g = n.g, this._b = n.b, this._a = n.a, this._roundA = Math.round(100 * this._a) / 100, this._format = e.format || n.format, this._gradientType = e.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = n.ok;
}
Pe.prototype = {
  isDark: function() {
    return this.getBrightness() < 128;
  },
  isLight: function() {
    return !this.isDark();
  },
  isValid: function() {
    return this._ok;
  },
  getOriginalInput: function() {
    return this._originalInput;
  },
  getFormat: function() {
    return this._format;
  },
  getAlpha: function() {
    return this._a;
  },
  getBrightness: function() {
    var e = this.toRgb();
    return (e.r * 299 + e.g * 587 + e.b * 114) / 1e3;
  },
  getLuminance: function() {
    var e = this.toRgb(), n, r, i, a, o, s;
    return n = e.r / 255, r = e.g / 255, i = e.b / 255, n <= 0.03928 ? a = n / 12.92 : a = Math.pow((n + 0.055) / 1.055, 2.4), r <= 0.03928 ? o = r / 12.92 : o = Math.pow((r + 0.055) / 1.055, 2.4), i <= 0.03928 ? s = i / 12.92 : s = Math.pow((i + 0.055) / 1.055, 2.4), 0.2126 * a + 0.7152 * o + 0.0722 * s;
  },
  setAlpha: function(e) {
    return this._a = xI(e), this._roundA = Math.round(100 * this._a) / 100, this;
  },
  toHsv: function() {
    var e = Tj(this._r, this._g, this._b);
    return {
      h: e.h * 360,
      s: e.s,
      v: e.v,
      a: this._a
    };
  },
  toHsvString: function() {
    var e = Tj(this._r, this._g, this._b), n = Math.round(e.h * 360), r = Math.round(e.s * 100), i = Math.round(e.v * 100);
    return this._a == 1 ? "hsv(" + n + ", " + r + "%, " + i + "%)" : "hsva(" + n + ", " + r + "%, " + i + "%, " + this._roundA + ")";
  },
  toHsl: function() {
    var e = mj(this._r, this._g, this._b);
    return {
      h: e.h * 360,
      s: e.s,
      l: e.l,
      a: this._a
    };
  },
  toHslString: function() {
    var e = mj(this._r, this._g, this._b), n = Math.round(e.h * 360), r = Math.round(e.s * 100), i = Math.round(e.l * 100);
    return this._a == 1 ? "hsl(" + n + ", " + r + "%, " + i + "%)" : "hsla(" + n + ", " + r + "%, " + i + "%, " + this._roundA + ")";
  },
  toHex: function(e) {
    return fj(this._r, this._g, this._b, e);
  },
  toHexString: function(e) {
    return "#" + this.toHex(e);
  },
  toHex8: function(e) {
    return i7(this._r, this._g, this._b, this._a, e);
  },
  toHex8String: function(e) {
    return "#" + this.toHex8(e);
  },
  toRgb: function() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function() {
    return {
      r: Math.round(Yn(this._r, 255) * 100) + "%",
      g: Math.round(Yn(this._g, 255) * 100) + "%",
      b: Math.round(Yn(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(Yn(this._r, 255) * 100) + "%, " + Math.round(Yn(this._g, 255) * 100) + "%, " + Math.round(Yn(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(Yn(this._r, 255) * 100) + "%, " + Math.round(Yn(this._g, 255) * 100) + "%, " + Math.round(Yn(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function() {
    return this._a === 0 ? "transparent" : this._a < 1 ? !1 : m7[fj(this._r, this._g, this._b, !0)] || !1;
  },
  toFilter: function(e) {
    var n = "#" + Vj(this._r, this._g, this._b, this._a), r = n, i = this._gradientType ? "GradientType = 1, " : "";
    if (e) {
      var a = Pe(e);
      r = "#" + Vj(a._r, a._g, a._b, a._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + i + "startColorstr=" + n + ",endColorstr=" + r + ")";
  },
  toString: function(e) {
    var n = !!e;
    e = e || this._format;
    var r = !1, i = this._a < 1 && this._a >= 0, a = !n && i && (e === "hex" || e === "hex6" || e === "hex3" || e === "hex4" || e === "hex8" || e === "name");
    return a ? e === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (e === "rgb" && (r = this.toRgbString()), e === "prgb" && (r = this.toPercentageRgbString()), (e === "hex" || e === "hex6") && (r = this.toHexString()), e === "hex3" && (r = this.toHexString(!0)), e === "hex4" && (r = this.toHex8String(!0)), e === "hex8" && (r = this.toHex8String()), e === "name" && (r = this.toName()), e === "hsl" && (r = this.toHslString()), e === "hsv" && (r = this.toHsvString()), r || this.toHexString());
  },
  clone: function() {
    return Pe(this.toString());
  },
  _applyModification: function(e, n) {
    var r = e.apply(null, [this].concat([].slice.call(n)));
    return this._r = r._r, this._g = r._g, this._b = r._b, this.setAlpha(r._a), this;
  },
  lighten: function() {
    return this._applyModification(l7, arguments);
  },
  brighten: function() {
    return this._applyModification(c7, arguments);
  },
  darken: function() {
    return this._applyModification(d7, arguments);
  },
  desaturate: function() {
    return this._applyModification(a7, arguments);
  },
  saturate: function() {
    return this._applyModification(o7, arguments);
  },
  greyscale: function() {
    return this._applyModification(s7, arguments);
  },
  spin: function() {
    return this._applyModification(u7, arguments);
  },
  _applyCombination: function(e, n) {
    return e.apply(null, [this].concat([].slice.call(n)));
  },
  analogous: function() {
    return this._applyCombination(M7, arguments);
  },
  complement: function() {
    return this._applyCombination(h7, arguments);
  },
  monochromatic: function() {
    return this._applyCombination(p7, arguments);
  },
  splitcomplement: function() {
    return this._applyCombination(N7, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function() {
    return this._applyCombination(Uj, [3]);
  },
  tetrad: function() {
    return this._applyCombination(Uj, [4]);
  }
};
Pe.fromRatio = function(t, e) {
  if (zf(t) == "object") {
    var n = {};
    for (var r in t)
      t.hasOwnProperty(r) && (r === "a" ? n[r] = t[r] : n[r] = IN(t[r]));
    t = n;
  }
  return Pe(t, e);
};
function e7(t) {
  var e = {
    r: 0,
    g: 0,
    b: 0
  }, n = 1, r = null, i = null, a = null, o = !1, s = !1;
  return typeof t == "string" && (t = U7(t)), zf(t) == "object" && (qo(t.r) && qo(t.g) && qo(t.b) ? (e = t7(t.r, t.g, t.b), o = !0, s = String(t.r).substr(-1) === "%" ? "prgb" : "rgb") : qo(t.h) && qo(t.s) && qo(t.v) ? (r = IN(t.s), i = IN(t.v), e = r7(t.h, r, i), o = !0, s = "hsv") : qo(t.h) && qo(t.s) && qo(t.l) && (r = IN(t.s), a = IN(t.l), e = n7(t.h, r, a), o = !0, s = "hsl"), t.hasOwnProperty("a") && (n = t.a)), n = xI(n), {
    ok: o,
    format: t.format || s,
    r: Math.min(255, Math.max(e.r, 0)),
    g: Math.min(255, Math.max(e.g, 0)),
    b: Math.min(255, Math.max(e.b, 0)),
    a: n
  };
}
function t7(t, e, n) {
  return {
    r: Yn(t, 255) * 255,
    g: Yn(e, 255) * 255,
    b: Yn(n, 255) * 255
  };
}
function mj(t, e, n) {
  t = Yn(t, 255), e = Yn(e, 255), n = Yn(n, 255);
  var r = Math.max(t, e, n), i = Math.min(t, e, n), a, o, s = (r + i) / 2;
  if (r == i)
    a = o = 0;
  else {
    var l = r - i;
    switch (o = s > 0.5 ? l / (2 - r - i) : l / (r + i), r) {
      case t:
        a = (e - n) / l + (e < n ? 6 : 0);
        break;
      case e:
        a = (n - t) / l + 2;
        break;
      case n:
        a = (t - e) / l + 4;
        break;
    }
    a /= 6;
  }
  return {
    h: a,
    s: o,
    l: s
  };
}
function n7(t, e, n) {
  var r, i, a;
  t = Yn(t, 360), e = Yn(e, 100), n = Yn(n, 100);
  function o(c, d, u) {
    return u < 0 && (u += 1), u > 1 && (u -= 1), u < 1 / 6 ? c + (d - c) * 6 * u : u < 1 / 2 ? d : u < 2 / 3 ? c + (d - c) * (2 / 3 - u) * 6 : c;
  }
  if (e === 0)
    r = i = a = n;
  else {
    var s = n < 0.5 ? n * (1 + e) : n + e - n * e, l = 2 * n - s;
    r = o(l, s, t + 1 / 3), i = o(l, s, t), a = o(l, s, t - 1 / 3);
  }
  return {
    r: r * 255,
    g: i * 255,
    b: a * 255
  };
}
function Tj(t, e, n) {
  t = Yn(t, 255), e = Yn(e, 255), n = Yn(n, 255);
  var r = Math.max(t, e, n), i = Math.min(t, e, n), a, o, s = r, l = r - i;
  if (o = r === 0 ? 0 : l / r, r == i)
    a = 0;
  else {
    switch (r) {
      case t:
        a = (e - n) / l + (e < n ? 6 : 0);
        break;
      case e:
        a = (n - t) / l + 2;
        break;
      case n:
        a = (t - e) / l + 4;
        break;
    }
    a /= 6;
  }
  return {
    h: a,
    s: o,
    v: s
  };
}
function r7(t, e, n) {
  t = Yn(t, 360) * 6, e = Yn(e, 100), n = Yn(n, 100);
  var r = Math.floor(t), i = t - r, a = n * (1 - e), o = n * (1 - i * e), s = n * (1 - (1 - i) * e), l = r % 6, c = [n, o, a, a, s, n][l], d = [s, n, n, o, a, a][l], u = [a, a, s, n, n, o][l];
  return {
    r: c * 255,
    g: d * 255,
    b: u * 255
  };
}
function fj(t, e, n, r) {
  var i = [La(Math.round(t).toString(16)), La(Math.round(e).toString(16)), La(Math.round(n).toString(16))];
  return r && i[0].charAt(0) == i[0].charAt(1) && i[1].charAt(0) == i[1].charAt(1) && i[2].charAt(0) == i[2].charAt(1) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
}
function i7(t, e, n, r, i) {
  var a = [La(Math.round(t).toString(16)), La(Math.round(e).toString(16)), La(Math.round(n).toString(16)), La(WI(r))];
  return i && a[0].charAt(0) == a[0].charAt(1) && a[1].charAt(0) == a[1].charAt(1) && a[2].charAt(0) == a[2].charAt(1) && a[3].charAt(0) == a[3].charAt(1) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) + a[3].charAt(0) : a.join("");
}
function Vj(t, e, n, r) {
  var i = [La(WI(r)), La(Math.round(t).toString(16)), La(Math.round(e).toString(16)), La(Math.round(n).toString(16))];
  return i.join("");
}
Pe.equals = function(t, e) {
  return !t || !e ? !1 : Pe(t).toRgbString() == Pe(e).toRgbString();
};
Pe.random = function() {
  return Pe.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function a7(t, e) {
  e = e === 0 ? 0 : e || 10;
  var n = Pe(t).toHsl();
  return n.s -= e / 100, n.s = O2(n.s), Pe(n);
}
function o7(t, e) {
  e = e === 0 ? 0 : e || 10;
  var n = Pe(t).toHsl();
  return n.s += e / 100, n.s = O2(n.s), Pe(n);
}
function s7(t) {
  return Pe(t).desaturate(100);
}
function l7(t, e) {
  e = e === 0 ? 0 : e || 10;
  var n = Pe(t).toHsl();
  return n.l += e / 100, n.l = O2(n.l), Pe(n);
}
function c7(t, e) {
  e = e === 0 ? 0 : e || 10;
  var n = Pe(t).toRgb();
  return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(e / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(e / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(e / 100)))), Pe(n);
}
function d7(t, e) {
  e = e === 0 ? 0 : e || 10;
  var n = Pe(t).toHsl();
  return n.l -= e / 100, n.l = O2(n.l), Pe(n);
}
function u7(t, e) {
  var n = Pe(t).toHsl(), r = (n.h + e) % 360;
  return n.h = r < 0 ? 360 + r : r, Pe(n);
}
function h7(t) {
  var e = Pe(t).toHsl();
  return e.h = (e.h + 180) % 360, Pe(e);
}
function Uj(t, e) {
  if (isNaN(e) || e <= 0)
    throw new Error("Argument to polyad must be a positive number");
  for (var n = Pe(t).toHsl(), r = [Pe(t)], i = 360 / e, a = 1; a < e; a++)
    r.push(Pe({
      h: (n.h + a * i) % 360,
      s: n.s,
      l: n.l
    }));
  return r;
}
function N7(t) {
  var e = Pe(t).toHsl(), n = e.h;
  return [Pe(t), Pe({
    h: (n + 72) % 360,
    s: e.s,
    l: e.l
  }), Pe({
    h: (n + 216) % 360,
    s: e.s,
    l: e.l
  })];
}
function M7(t, e, n) {
  e = e || 6, n = n || 30;
  var r = Pe(t).toHsl(), i = 360 / n, a = [Pe(t)];
  for (r.h = (r.h - (i * e >> 1) + 720) % 360; --e; )
    r.h = (r.h + i) % 360, a.push(Pe(r));
  return a;
}
function p7(t, e) {
  e = e || 6;
  for (var n = Pe(t).toHsv(), r = n.h, i = n.s, a = n.v, o = [], s = 1 / e; e--; )
    o.push(Pe({
      h: r,
      s: i,
      v: a
    })), a = (a + s) % 1;
  return o;
}
Pe.mix = function(t, e, n) {
  n = n === 0 ? 0 : n || 50;
  var r = Pe(t).toRgb(), i = Pe(e).toRgb(), a = n / 100, o = {
    r: (i.r - r.r) * a + r.r,
    g: (i.g - r.g) * a + r.g,
    b: (i.b - r.b) * a + r.b,
    a: (i.a - r.a) * a + r.a
  };
  return Pe(o);
};
Pe.readability = function(t, e) {
  var n = Pe(t), r = Pe(e);
  return (Math.max(n.getLuminance(), r.getLuminance()) + 0.05) / (Math.min(n.getLuminance(), r.getLuminance()) + 0.05);
};
Pe.isReadable = function(t, e, n) {
  var r = Pe.readability(t, e), i, a;
  switch (a = !1, i = R7(n), i.level + i.size) {
    case "AAsmall":
    case "AAAlarge":
      a = r >= 4.5;
      break;
    case "AAlarge":
      a = r >= 3;
      break;
    case "AAAsmall":
      a = r >= 7;
      break;
  }
  return a;
};
Pe.mostReadable = function(t, e, n) {
  var r = null, i = 0, a, o, s, l;
  n = n || {}, o = n.includeFallbackColors, s = n.level, l = n.size;
  for (var c = 0; c < e.length; c++)
    a = Pe.readability(t, e[c]), a > i && (i = a, r = Pe(e[c]));
  return Pe.isReadable(t, r, {
    level: s,
    size: l
  }) || !o ? r : (n.includeFallbackColors = !1, Pe.mostReadable(t, ["#fff", "#000"], n));
};
var eZ = Pe.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
}, m7 = Pe.hexNames = T7(eZ);
function T7(t) {
  var e = {};
  for (var n in t)
    t.hasOwnProperty(n) && (e[t[n]] = n);
  return e;
}
function xI(t) {
  return t = parseFloat(t), (isNaN(t) || t < 0 || t > 1) && (t = 1), t;
}
function Yn(t, e) {
  f7(t) && (t = "100%");
  var n = V7(t);
  return t = Math.min(e, Math.max(0, parseFloat(t))), n && (t = parseInt(t * e, 10) / 100), Math.abs(t - e) < 1e-6 ? 1 : t % e / parseFloat(e);
}
function O2(t) {
  return Math.min(1, Math.max(0, t));
}
function Bi(t) {
  return parseInt(t, 16);
}
function f7(t) {
  return typeof t == "string" && t.indexOf(".") != -1 && parseFloat(t) === 1;
}
function V7(t) {
  return typeof t == "string" && t.indexOf("%") != -1;
}
function La(t) {
  return t.length == 1 ? "0" + t : "" + t;
}
function IN(t) {
  return t <= 1 && (t = t * 100 + "%"), t;
}
function WI(t) {
  return Math.round(parseFloat(t) * 255).toString(16);
}
function Rj(t) {
  return Bi(t) / 255;
}
var Ia = function() {
  var t = "[-\\+]?\\d+%?", e = "[-\\+]?\\d*\\.\\d+%?", n = "(?:" + e + ")|(?:" + t + ")", r = "[\\s|\\(]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")\\s*\\)?", i = "[\\s|\\(]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(n),
    rgb: new RegExp("rgb" + r),
    rgba: new RegExp("rgba" + i),
    hsl: new RegExp("hsl" + r),
    hsla: new RegExp("hsla" + i),
    hsv: new RegExp("hsv" + r),
    hsva: new RegExp("hsva" + i),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();
function qo(t) {
  return !!Ia.CSS_UNIT.exec(t);
}
function U7(t) {
  t = t.replace($K, "").replace(qK, "").toLowerCase();
  var e = !1;
  if (eZ[t])
    t = eZ[t], e = !0;
  else if (t == "transparent")
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  var n;
  return (n = Ia.rgb.exec(t)) ? {
    r: n[1],
    g: n[2],
    b: n[3]
  } : (n = Ia.rgba.exec(t)) ? {
    r: n[1],
    g: n[2],
    b: n[3],
    a: n[4]
  } : (n = Ia.hsl.exec(t)) ? {
    h: n[1],
    s: n[2],
    l: n[3]
  } : (n = Ia.hsla.exec(t)) ? {
    h: n[1],
    s: n[2],
    l: n[3],
    a: n[4]
  } : (n = Ia.hsv.exec(t)) ? {
    h: n[1],
    s: n[2],
    v: n[3]
  } : (n = Ia.hsva.exec(t)) ? {
    h: n[1],
    s: n[2],
    v: n[3],
    a: n[4]
  } : (n = Ia.hex8.exec(t)) ? {
    r: Bi(n[1]),
    g: Bi(n[2]),
    b: Bi(n[3]),
    a: Rj(n[4]),
    format: e ? "name" : "hex8"
  } : (n = Ia.hex6.exec(t)) ? {
    r: Bi(n[1]),
    g: Bi(n[2]),
    b: Bi(n[3]),
    format: e ? "name" : "hex"
  } : (n = Ia.hex4.exec(t)) ? {
    r: Bi(n[1] + "" + n[1]),
    g: Bi(n[2] + "" + n[2]),
    b: Bi(n[3] + "" + n[3]),
    a: Rj(n[4] + "" + n[4]),
    format: e ? "name" : "hex8"
  } : (n = Ia.hex3.exec(t)) ? {
    r: Bi(n[1] + "" + n[1]),
    g: Bi(n[2] + "" + n[2]),
    b: Bi(n[3] + "" + n[3]),
    format: e ? "name" : "hex"
  } : !1;
}
function R7(t) {
  var e, n;
  return t = t || {
    level: "AA",
    size: "small"
  }, e = (t.level || "AA").toUpperCase(), n = (t.size || "small").toLowerCase(), e !== "AA" && e !== "AAA" && (e = "AA"), n !== "small" && n !== "large" && (n = "small"), {
    level: e,
    size: n
  };
}
function Lc(t, e) {
  return Pe(t).setAlpha(e).toRgbString();
}
var Ro = [], Ma = [], g7 = typeof Uint8Array < "u" ? Uint8Array : Array, f3 = !1;
function jI() {
  f3 = !0;
  for (var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", e = 0, n = t.length; e < n; ++e)
    Ro[e] = t[e], Ma[t.charCodeAt(e)] = e;
  Ma["-".charCodeAt(0)] = 62, Ma["_".charCodeAt(0)] = 63;
}
function y7(t) {
  f3 || jI();
  var e, n, r, i, a, o, s = t.length;
  if (s % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  a = t[s - 2] === "=" ? 2 : t[s - 1] === "=" ? 1 : 0, o = new g7(s * 3 / 4 - a), r = a > 0 ? s - 4 : s;
  var l = 0;
  for (e = 0, n = 0; e < r; e += 4, n += 3)
    i = Ma[t.charCodeAt(e)] << 18 | Ma[t.charCodeAt(e + 1)] << 12 | Ma[t.charCodeAt(e + 2)] << 6 | Ma[t.charCodeAt(e + 3)], o[l++] = i >> 16 & 255, o[l++] = i >> 8 & 255, o[l++] = i & 255;
  return a === 2 ? (i = Ma[t.charCodeAt(e)] << 2 | Ma[t.charCodeAt(e + 1)] >> 4, o[l++] = i & 255) : a === 1 && (i = Ma[t.charCodeAt(e)] << 10 | Ma[t.charCodeAt(e + 1)] << 4 | Ma[t.charCodeAt(e + 2)] >> 2, o[l++] = i >> 8 & 255, o[l++] = i & 255), o;
}
function Z7(t) {
  return Ro[t >> 18 & 63] + Ro[t >> 12 & 63] + Ro[t >> 6 & 63] + Ro[t & 63];
}
function b7(t, e, n) {
  for (var r, i = [], a = e; a < n; a += 3)
    r = (t[a] << 16) + (t[a + 1] << 8) + t[a + 2], i.push(Z7(r));
  return i.join("");
}
function gj(t) {
  f3 || jI();
  for (var e, n = t.length, r = n % 3, i = "", a = [], o = 16383, s = 0, l = n - r; s < l; s += o)
    a.push(b7(t, s, s + o > l ? l : s + o));
  return r === 1 ? (e = t[n - 1], i += Ro[e >> 2], i += Ro[e << 4 & 63], i += "==") : r === 2 && (e = (t[n - 2] << 8) + t[n - 1], i += Ro[e >> 10], i += Ro[e >> 4 & 63], i += Ro[e << 2 & 63], i += "="), a.push(i), a.join("");
}
function Y2(t, e, n, r, i) {
  var a, o, s = i * 8 - r - 1, l = (1 << s) - 1, c = l >> 1, d = -7, u = n ? i - 1 : 0, h = n ? -1 : 1, N = t[e + u];
  for (u += h, a = N & (1 << -d) - 1, N >>= -d, d += s; d > 0; a = a * 256 + t[e + u], u += h, d -= 8)
    ;
  for (o = a & (1 << -d) - 1, a >>= -d, d += r; d > 0; o = o * 256 + t[e + u], u += h, d -= 8)
    ;
  if (a === 0)
    a = 1 - c;
  else {
    if (a === l)
      return o ? NaN : (N ? -1 : 1) * (1 / 0);
    o = o + Math.pow(2, r), a = a - c;
  }
  return (N ? -1 : 1) * o * Math.pow(2, a - r);
}
function DI(t, e, n, r, i, a) {
  var o, s, l, c = a * 8 - i - 1, d = (1 << c) - 1, u = d >> 1, h = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, N = r ? 0 : a - 1, M = r ? 1 : -1, p = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, o = d) : (o = Math.floor(Math.log(e) / Math.LN2), e * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), o + u >= 1 ? e += h / l : e += h * Math.pow(2, 1 - u), e * l >= 2 && (o++, l /= 2), o + u >= d ? (s = 0, o = d) : o + u >= 1 ? (s = (e * l - 1) * Math.pow(2, i), o = o + u) : (s = e * Math.pow(2, u - 1) * Math.pow(2, i), o = 0)); i >= 8; t[n + N] = s & 255, N += M, s /= 256, i -= 8)
    ;
  for (o = o << i | s, c += i; c > 0; t[n + N] = o & 255, N += M, o /= 256, c -= 8)
    ;
  t[n + N - M] |= p * 128;
}
var E7 = {}.toString, zI = Array.isArray || function(t) {
  return E7.call(t) == "[object Array]";
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
var S7 = 50;
Ne.TYPED_ARRAY_SUPPORT = $i.TYPED_ARRAY_SUPPORT !== void 0 ? $i.TYPED_ARRAY_SUPPORT : !0;
kf();
function kf() {
  return Ne.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
}
function ms(t, e) {
  if (kf() < e)
    throw new RangeError("Invalid typed array length");
  return Ne.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e), t.__proto__ = Ne.prototype) : (t === null && (t = new Ne(e)), t.length = e), t;
}
function Ne(t, e, n) {
  if (!Ne.TYPED_ARRAY_SUPPORT && !(this instanceof Ne))
    return new Ne(t, e, n);
  if (typeof t == "number") {
    if (typeof e == "string")
      throw new Error(
        "If encoding is specified then the first argument must be a string"
      );
    return V3(this, t);
  }
  return kI(this, t, e, n);
}
Ne.poolSize = 8192;
Ne._augment = function(t) {
  return t.__proto__ = Ne.prototype, t;
};
function kI(t, e, n, r) {
  if (typeof e == "number")
    throw new TypeError('"value" argument must not be a number');
  return typeof ArrayBuffer < "u" && e instanceof ArrayBuffer ? j7(t, e, n, r) : typeof e == "string" ? W7(t, e, n) : D7(t, e);
}
Ne.from = function(t, e, n) {
  return kI(null, t, e, n);
};
Ne.TYPED_ARRAY_SUPPORT && (Ne.prototype.__proto__ = Uint8Array.prototype, Ne.__proto__ = Uint8Array, typeof Symbol < "u" && Symbol.species && Ne[Symbol.species]);
function wI(t) {
  if (typeof t != "number")
    throw new TypeError('"size" argument must be a number');
  if (t < 0)
    throw new RangeError('"size" argument must not be negative');
}
function x7(t, e, n, r) {
  return wI(e), e <= 0 ? ms(t, e) : n !== void 0 ? typeof r == "string" ? ms(t, e).fill(n, r) : ms(t, e).fill(n) : ms(t, e);
}
Ne.alloc = function(t, e, n) {
  return x7(null, t, e, n);
};
function V3(t, e) {
  if (wI(e), t = ms(t, e < 0 ? 0 : U3(e) | 0), !Ne.TYPED_ARRAY_SUPPORT)
    for (var n = 0; n < e; ++n)
      t[n] = 0;
  return t;
}
Ne.allocUnsafe = function(t) {
  return V3(null, t);
};
Ne.allocUnsafeSlow = function(t) {
  return V3(null, t);
};
function W7(t, e, n) {
  if ((typeof n != "string" || n === "") && (n = "utf8"), !Ne.isEncoding(n))
    throw new TypeError('"encoding" must be a valid string encoding');
  var r = FI(e, n) | 0;
  t = ms(t, r);
  var i = t.write(e, n);
  return i !== r && (t = t.slice(0, i)), t;
}
function tZ(t, e) {
  var n = e.length < 0 ? 0 : U3(e.length) | 0;
  t = ms(t, n);
  for (var r = 0; r < n; r += 1)
    t[r] = e[r] & 255;
  return t;
}
function j7(t, e, n, r) {
  if (e.byteLength, n < 0 || e.byteLength < n)
    throw new RangeError("'offset' is out of bounds");
  if (e.byteLength < n + (r || 0))
    throw new RangeError("'length' is out of bounds");
  return n === void 0 && r === void 0 ? e = new Uint8Array(e) : r === void 0 ? e = new Uint8Array(e, n) : e = new Uint8Array(e, n, r), Ne.TYPED_ARRAY_SUPPORT ? (t = e, t.__proto__ = Ne.prototype) : t = tZ(t, e), t;
}
function D7(t, e) {
  if (zo(e)) {
    var n = U3(e.length) | 0;
    return t = ms(t, n), t.length === 0 || e.copy(t, 0, 0, n), t;
  }
  if (e) {
    if (typeof ArrayBuffer < "u" && e.buffer instanceof ArrayBuffer || "length" in e)
      return typeof e.length != "number" || P7(e.length) ? ms(t, 0) : tZ(t, e);
    if (e.type === "Buffer" && zI(e.data))
      return tZ(t, e.data);
  }
  throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function U3(t) {
  if (t >= kf())
    throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kf().toString(16) + " bytes");
  return t | 0;
}
Ne.isBuffer = K7;
function zo(t) {
  return !!(t != null && t._isBuffer);
}
Ne.compare = function(e, n) {
  if (!zo(e) || !zo(n))
    throw new TypeError("Arguments must be Buffers");
  if (e === n)
    return 0;
  for (var r = e.length, i = n.length, a = 0, o = Math.min(r, i); a < o; ++a)
    if (e[a] !== n[a]) {
      r = e[a], i = n[a];
      break;
    }
  return r < i ? -1 : i < r ? 1 : 0;
};
Ne.isEncoding = function(e) {
  switch (String(e).toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "latin1":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return !0;
    default:
      return !1;
  }
};
Ne.concat = function(e, n) {
  if (!zI(e))
    throw new TypeError('"list" argument must be an Array of Buffers');
  if (e.length === 0)
    return Ne.alloc(0);
  var r;
  if (n === void 0)
    for (n = 0, r = 0; r < e.length; ++r)
      n += e[r].length;
  var i = Ne.allocUnsafe(n), a = 0;
  for (r = 0; r < e.length; ++r) {
    var o = e[r];
    if (!zo(o))
      throw new TypeError('"list" argument must be an Array of Buffers');
    o.copy(i, a), a += o.length;
  }
  return i;
};
function FI(t, e) {
  if (zo(t))
    return t.length;
  if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer))
    return t.byteLength;
  typeof t != "string" && (t = "" + t);
  var n = t.length;
  if (n === 0)
    return 0;
  for (var r = !1; ; )
    switch (e) {
      case "ascii":
      case "latin1":
      case "binary":
        return n;
      case "utf8":
      case "utf-8":
      case void 0:
        return wf(t).length;
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return n * 2;
      case "hex":
        return n >>> 1;
      case "base64":
        return CI(t).length;
      default:
        if (r)
          return wf(t).length;
        e = ("" + e).toLowerCase(), r = !0;
    }
}
Ne.byteLength = FI;
function z7(t, e, n) {
  var r = !1;
  if ((e === void 0 || e < 0) && (e = 0), e > this.length || ((n === void 0 || n > this.length) && (n = this.length), n <= 0) || (n >>>= 0, e >>>= 0, n <= e))
    return "";
  for (t || (t = "utf8"); ; )
    switch (t) {
      case "hex":
        return C7(this, e, n);
      case "utf8":
      case "utf-8":
        return OI(this, e, n);
      case "ascii":
        return Q7(this, e, n);
      case "latin1":
      case "binary":
        return G7(this, e, n);
      case "base64":
        return O7(this, e, n);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return L7(this, e, n);
      default:
        if (r)
          throw new TypeError("Unknown encoding: " + t);
        t = (t + "").toLowerCase(), r = !0;
    }
}
Ne.prototype._isBuffer = !0;
function id(t, e, n) {
  var r = t[e];
  t[e] = t[n], t[n] = r;
}
Ne.prototype.swap16 = function() {
  var e = this.length;
  if (e % 2 !== 0)
    throw new RangeError("Buffer size must be a multiple of 16-bits");
  for (var n = 0; n < e; n += 2)
    id(this, n, n + 1);
  return this;
};
Ne.prototype.swap32 = function() {
  var e = this.length;
  if (e % 4 !== 0)
    throw new RangeError("Buffer size must be a multiple of 32-bits");
  for (var n = 0; n < e; n += 4)
    id(this, n, n + 3), id(this, n + 1, n + 2);
  return this;
};
Ne.prototype.swap64 = function() {
  var e = this.length;
  if (e % 8 !== 0)
    throw new RangeError("Buffer size must be a multiple of 64-bits");
  for (var n = 0; n < e; n += 8)
    id(this, n, n + 7), id(this, n + 1, n + 6), id(this, n + 2, n + 5), id(this, n + 3, n + 4);
  return this;
};
Ne.prototype.toString = function() {
  var e = this.length | 0;
  return e === 0 ? "" : arguments.length === 0 ? OI(this, 0, e) : z7.apply(this, arguments);
};
Ne.prototype.equals = function(e) {
  if (!zo(e))
    throw new TypeError("Argument must be a Buffer");
  return this === e ? !0 : Ne.compare(this, e) === 0;
};
Ne.prototype.inspect = function() {
  var e = "", n = S7;
  return this.length > 0 && (e = this.toString("hex", 0, n).match(/.{2}/g).join(" "), this.length > n && (e += " ... ")), "<Buffer " + e + ">";
};
Ne.prototype.compare = function(e, n, r, i, a) {
  if (!zo(e))
    throw new TypeError("Argument must be a Buffer");
  if (n === void 0 && (n = 0), r === void 0 && (r = e ? e.length : 0), i === void 0 && (i = 0), a === void 0 && (a = this.length), n < 0 || r > e.length || i < 0 || a > this.length)
    throw new RangeError("out of range index");
  if (i >= a && n >= r)
    return 0;
  if (i >= a)
    return -1;
  if (n >= r)
    return 1;
  if (n >>>= 0, r >>>= 0, i >>>= 0, a >>>= 0, this === e)
    return 0;
  for (var o = a - i, s = r - n, l = Math.min(o, s), c = this.slice(i, a), d = e.slice(n, r), u = 0; u < l; ++u)
    if (c[u] !== d[u]) {
      o = c[u], s = d[u];
      break;
    }
  return o < s ? -1 : s < o ? 1 : 0;
};
function vI(t, e, n, r, i) {
  if (t.length === 0)
    return -1;
  if (typeof n == "string" ? (r = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), n = +n, isNaN(n) && (n = i ? 0 : t.length - 1), n < 0 && (n = t.length + n), n >= t.length) {
    if (i)
      return -1;
    n = t.length - 1;
  } else if (n < 0)
    if (i)
      n = 0;
    else
      return -1;
  if (typeof e == "string" && (e = Ne.from(e, r)), zo(e))
    return e.length === 0 ? -1 : yj(t, e, n, r, i);
  if (typeof e == "number")
    return e = e & 255, Ne.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? i ? Uint8Array.prototype.indexOf.call(t, e, n) : Uint8Array.prototype.lastIndexOf.call(t, e, n) : yj(t, [e], n, r, i);
  throw new TypeError("val must be string, number or Buffer");
}
function yj(t, e, n, r, i) {
  var a = 1, o = t.length, s = e.length;
  if (r !== void 0 && (r = String(r).toLowerCase(), r === "ucs2" || r === "ucs-2" || r === "utf16le" || r === "utf-16le")) {
    if (t.length < 2 || e.length < 2)
      return -1;
    a = 2, o /= 2, s /= 2, n /= 2;
  }
  function l(N, M) {
    return a === 1 ? N[M] : N.readUInt16BE(M * a);
  }
  var c;
  if (i) {
    var d = -1;
    for (c = n; c < o; c++)
      if (l(t, c) === l(e, d === -1 ? 0 : c - d)) {
        if (d === -1 && (d = c), c - d + 1 === s)
          return d * a;
      } else
        d !== -1 && (c -= c - d), d = -1;
  } else
    for (n + s > o && (n = o - s), c = n; c >= 0; c--) {
      for (var u = !0, h = 0; h < s; h++)
        if (l(t, c + h) !== l(e, h)) {
          u = !1;
          break;
        }
      if (u)
        return c;
    }
  return -1;
}
Ne.prototype.includes = function(e, n, r) {
  return this.indexOf(e, n, r) !== -1;
};
Ne.prototype.indexOf = function(e, n, r) {
  return vI(this, e, n, r, !0);
};
Ne.prototype.lastIndexOf = function(e, n, r) {
  return vI(this, e, n, r, !1);
};
function k7(t, e, n, r) {
  n = Number(n) || 0;
  var i = t.length - n;
  r ? (r = Number(r), r > i && (r = i)) : r = i;
  var a = e.length;
  if (a % 2 !== 0)
    throw new TypeError("Invalid hex string");
  r > a / 2 && (r = a / 2);
  for (var o = 0; o < r; ++o) {
    var s = parseInt(e.substr(o * 2, 2), 16);
    if (isNaN(s))
      return o;
    t[n + o] = s;
  }
  return o;
}
function w7(t, e, n, r) {
  return C2(wf(e, t.length - n), t, n, r);
}
function II(t, e, n, r) {
  return C2(X7(e), t, n, r);
}
function F7(t, e, n, r) {
  return II(t, e, n, r);
}
function v7(t, e, n, r) {
  return C2(CI(e), t, n, r);
}
function I7(t, e, n, r) {
  return C2(_7(e, t.length - n), t, n, r);
}
Ne.prototype.write = function(e, n, r, i) {
  if (n === void 0)
    i = "utf8", r = this.length, n = 0;
  else if (r === void 0 && typeof n == "string")
    i = n, r = this.length, n = 0;
  else if (isFinite(n))
    n = n | 0, isFinite(r) ? (r = r | 0, i === void 0 && (i = "utf8")) : (i = r, r = void 0);
  else
    throw new Error(
      "Buffer.write(string, encoding, offset[, length]) is no longer supported"
    );
  var a = this.length - n;
  if ((r === void 0 || r > a) && (r = a), e.length > 0 && (r < 0 || n < 0) || n > this.length)
    throw new RangeError("Attempt to write outside buffer bounds");
  i || (i = "utf8");
  for (var o = !1; ; )
    switch (i) {
      case "hex":
        return k7(this, e, n, r);
      case "utf8":
      case "utf-8":
        return w7(this, e, n, r);
      case "ascii":
        return II(this, e, n, r);
      case "latin1":
      case "binary":
        return F7(this, e, n, r);
      case "base64":
        return v7(this, e, n, r);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return I7(this, e, n, r);
      default:
        if (o)
          throw new TypeError("Unknown encoding: " + i);
        i = ("" + i).toLowerCase(), o = !0;
    }
};
Ne.prototype.toJSON = function() {
  return {
    type: "Buffer",
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
function O7(t, e, n) {
  return e === 0 && n === t.length ? gj(t) : gj(t.slice(e, n));
}
function OI(t, e, n) {
  n = Math.min(t.length, n);
  for (var r = [], i = e; i < n; ) {
    var a = t[i], o = null, s = a > 239 ? 4 : a > 223 ? 3 : a > 191 ? 2 : 1;
    if (i + s <= n) {
      var l, c, d, u;
      switch (s) {
        case 1:
          a < 128 && (o = a);
          break;
        case 2:
          l = t[i + 1], (l & 192) === 128 && (u = (a & 31) << 6 | l & 63, u > 127 && (o = u));
          break;
        case 3:
          l = t[i + 1], c = t[i + 2], (l & 192) === 128 && (c & 192) === 128 && (u = (a & 15) << 12 | (l & 63) << 6 | c & 63, u > 2047 && (u < 55296 || u > 57343) && (o = u));
          break;
        case 4:
          l = t[i + 1], c = t[i + 2], d = t[i + 3], (l & 192) === 128 && (c & 192) === 128 && (d & 192) === 128 && (u = (a & 15) << 18 | (l & 63) << 12 | (c & 63) << 6 | d & 63, u > 65535 && u < 1114112 && (o = u));
      }
    }
    o === null ? (o = 65533, s = 1) : o > 65535 && (o -= 65536, r.push(o >>> 10 & 1023 | 55296), o = 56320 | o & 1023), r.push(o), i += s;
  }
  return Y7(r);
}
var Zj = 4096;
function Y7(t) {
  var e = t.length;
  if (e <= Zj)
    return String.fromCharCode.apply(String, t);
  for (var n = "", r = 0; r < e; )
    n += String.fromCharCode.apply(
      String,
      t.slice(r, r += Zj)
    );
  return n;
}
function Q7(t, e, n) {
  var r = "";
  n = Math.min(t.length, n);
  for (var i = e; i < n; ++i)
    r += String.fromCharCode(t[i] & 127);
  return r;
}
function G7(t, e, n) {
  var r = "";
  n = Math.min(t.length, n);
  for (var i = e; i < n; ++i)
    r += String.fromCharCode(t[i]);
  return r;
}
function C7(t, e, n) {
  var r = t.length;
  (!e || e < 0) && (e = 0), (!n || n < 0 || n > r) && (n = r);
  for (var i = "", a = e; a < n; ++a)
    i += H7(t[a]);
  return i;
}
function L7(t, e, n) {
  for (var r = t.slice(e, n), i = "", a = 0; a < r.length; a += 2)
    i += String.fromCharCode(r[a] + r[a + 1] * 256);
  return i;
}
Ne.prototype.slice = function(e, n) {
  var r = this.length;
  e = ~~e, n = n === void 0 ? r : ~~n, e < 0 ? (e += r, e < 0 && (e = 0)) : e > r && (e = r), n < 0 ? (n += r, n < 0 && (n = 0)) : n > r && (n = r), n < e && (n = e);
  var i;
  if (Ne.TYPED_ARRAY_SUPPORT)
    i = this.subarray(e, n), i.__proto__ = Ne.prototype;
  else {
    var a = n - e;
    i = new Ne(a, void 0);
    for (var o = 0; o < a; ++o)
      i[o] = this[o + e];
  }
  return i;
};
function zr(t, e, n) {
  if (t % 1 !== 0 || t < 0)
    throw new RangeError("offset is not uint");
  if (t + e > n)
    throw new RangeError("Trying to access beyond buffer length");
}
Ne.prototype.readUIntLE = function(e, n, r) {
  e = e | 0, n = n | 0, r || zr(e, n, this.length);
  for (var i = this[e], a = 1, o = 0; ++o < n && (a *= 256); )
    i += this[e + o] * a;
  return i;
};
Ne.prototype.readUIntBE = function(e, n, r) {
  e = e | 0, n = n | 0, r || zr(e, n, this.length);
  for (var i = this[e + --n], a = 1; n > 0 && (a *= 256); )
    i += this[e + --n] * a;
  return i;
};
Ne.prototype.readUInt8 = function(e, n) {
  return n || zr(e, 1, this.length), this[e];
};
Ne.prototype.readUInt16LE = function(e, n) {
  return n || zr(e, 2, this.length), this[e] | this[e + 1] << 8;
};
Ne.prototype.readUInt16BE = function(e, n) {
  return n || zr(e, 2, this.length), this[e] << 8 | this[e + 1];
};
Ne.prototype.readUInt32LE = function(e, n) {
  return n || zr(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + this[e + 3] * 16777216;
};
Ne.prototype.readUInt32BE = function(e, n) {
  return n || zr(e, 4, this.length), this[e] * 16777216 + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
};
Ne.prototype.readIntLE = function(e, n, r) {
  e = e | 0, n = n | 0, r || zr(e, n, this.length);
  for (var i = this[e], a = 1, o = 0; ++o < n && (a *= 256); )
    i += this[e + o] * a;
  return a *= 128, i >= a && (i -= Math.pow(2, 8 * n)), i;
};
Ne.prototype.readIntBE = function(e, n, r) {
  e = e | 0, n = n | 0, r || zr(e, n, this.length);
  for (var i = n, a = 1, o = this[e + --i]; i > 0 && (a *= 256); )
    o += this[e + --i] * a;
  return a *= 128, o >= a && (o -= Math.pow(2, 8 * n)), o;
};
Ne.prototype.readInt8 = function(e, n) {
  return n || zr(e, 1, this.length), this[e] & 128 ? (255 - this[e] + 1) * -1 : this[e];
};
Ne.prototype.readInt16LE = function(e, n) {
  n || zr(e, 2, this.length);
  var r = this[e] | this[e + 1] << 8;
  return r & 32768 ? r | 4294901760 : r;
};
Ne.prototype.readInt16BE = function(e, n) {
  n || zr(e, 2, this.length);
  var r = this[e + 1] | this[e] << 8;
  return r & 32768 ? r | 4294901760 : r;
};
Ne.prototype.readInt32LE = function(e, n) {
  return n || zr(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
};
Ne.prototype.readInt32BE = function(e, n) {
  return n || zr(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
};
Ne.prototype.readFloatLE = function(e, n) {
  return n || zr(e, 4, this.length), Y2(this, e, !0, 23, 4);
};
Ne.prototype.readFloatBE = function(e, n) {
  return n || zr(e, 4, this.length), Y2(this, e, !1, 23, 4);
};
Ne.prototype.readDoubleLE = function(e, n) {
  return n || zr(e, 8, this.length), Y2(this, e, !0, 52, 8);
};
Ne.prototype.readDoubleBE = function(e, n) {
  return n || zr(e, 8, this.length), Y2(this, e, !1, 52, 8);
};
function Qi(t, e, n, r, i, a) {
  if (!zo(t))
    throw new TypeError('"buffer" argument must be a Buffer instance');
  if (e > i || e < a)
    throw new RangeError('"value" argument is out of bounds');
  if (n + r > t.length)
    throw new RangeError("Index out of range");
}
Ne.prototype.writeUIntLE = function(e, n, r, i) {
  if (e = +e, n = n | 0, r = r | 0, !i) {
    var a = Math.pow(2, 8 * r) - 1;
    Qi(this, e, n, r, a, 0);
  }
  var o = 1, s = 0;
  for (this[n] = e & 255; ++s < r && (o *= 256); )
    this[n + s] = e / o & 255;
  return n + r;
};
Ne.prototype.writeUIntBE = function(e, n, r, i) {
  if (e = +e, n = n | 0, r = r | 0, !i) {
    var a = Math.pow(2, 8 * r) - 1;
    Qi(this, e, n, r, a, 0);
  }
  var o = r - 1, s = 1;
  for (this[n + o] = e & 255; --o >= 0 && (s *= 256); )
    this[n + o] = e / s & 255;
  return n + r;
};
Ne.prototype.writeUInt8 = function(e, n, r) {
  return e = +e, n = n | 0, r || Qi(this, e, n, 1, 255, 0), Ne.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[n] = e & 255, n + 1;
};
function Q2(t, e, n, r) {
  e < 0 && (e = 65535 + e + 1);
  for (var i = 0, a = Math.min(t.length - n, 2); i < a; ++i)
    t[n + i] = (e & 255 << 8 * (r ? i : 1 - i)) >>> (r ? i : 1 - i) * 8;
}
Ne.prototype.writeUInt16LE = function(e, n, r) {
  return e = +e, n = n | 0, r || Qi(this, e, n, 2, 65535, 0), Ne.TYPED_ARRAY_SUPPORT ? (this[n] = e & 255, this[n + 1] = e >>> 8) : Q2(this, e, n, !0), n + 2;
};
Ne.prototype.writeUInt16BE = function(e, n, r) {
  return e = +e, n = n | 0, r || Qi(this, e, n, 2, 65535, 0), Ne.TYPED_ARRAY_SUPPORT ? (this[n] = e >>> 8, this[n + 1] = e & 255) : Q2(this, e, n, !1), n + 2;
};
function G2(t, e, n, r) {
  e < 0 && (e = 4294967295 + e + 1);
  for (var i = 0, a = Math.min(t.length - n, 4); i < a; ++i)
    t[n + i] = e >>> (r ? i : 3 - i) * 8 & 255;
}
Ne.prototype.writeUInt32LE = function(e, n, r) {
  return e = +e, n = n | 0, r || Qi(this, e, n, 4, 4294967295, 0), Ne.TYPED_ARRAY_SUPPORT ? (this[n + 3] = e >>> 24, this[n + 2] = e >>> 16, this[n + 1] = e >>> 8, this[n] = e & 255) : G2(this, e, n, !0), n + 4;
};
Ne.prototype.writeUInt32BE = function(e, n, r) {
  return e = +e, n = n | 0, r || Qi(this, e, n, 4, 4294967295, 0), Ne.TYPED_ARRAY_SUPPORT ? (this[n] = e >>> 24, this[n + 1] = e >>> 16, this[n + 2] = e >>> 8, this[n + 3] = e & 255) : G2(this, e, n, !1), n + 4;
};
Ne.prototype.writeIntLE = function(e, n, r, i) {
  if (e = +e, n = n | 0, !i) {
    var a = Math.pow(2, 8 * r - 1);
    Qi(this, e, n, r, a - 1, -a);
  }
  var o = 0, s = 1, l = 0;
  for (this[n] = e & 255; ++o < r && (s *= 256); )
    e < 0 && l === 0 && this[n + o - 1] !== 0 && (l = 1), this[n + o] = (e / s >> 0) - l & 255;
  return n + r;
};
Ne.prototype.writeIntBE = function(e, n, r, i) {
  if (e = +e, n = n | 0, !i) {
    var a = Math.pow(2, 8 * r - 1);
    Qi(this, e, n, r, a - 1, -a);
  }
  var o = r - 1, s = 1, l = 0;
  for (this[n + o] = e & 255; --o >= 0 && (s *= 256); )
    e < 0 && l === 0 && this[n + o + 1] !== 0 && (l = 1), this[n + o] = (e / s >> 0) - l & 255;
  return n + r;
};
Ne.prototype.writeInt8 = function(e, n, r) {
  return e = +e, n = n | 0, r || Qi(this, e, n, 1, 127, -128), Ne.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[n] = e & 255, n + 1;
};
Ne.prototype.writeInt16LE = function(e, n, r) {
  return e = +e, n = n | 0, r || Qi(this, e, n, 2, 32767, -32768), Ne.TYPED_ARRAY_SUPPORT ? (this[n] = e & 255, this[n + 1] = e >>> 8) : Q2(this, e, n, !0), n + 2;
};
Ne.prototype.writeInt16BE = function(e, n, r) {
  return e = +e, n = n | 0, r || Qi(this, e, n, 2, 32767, -32768), Ne.TYPED_ARRAY_SUPPORT ? (this[n] = e >>> 8, this[n + 1] = e & 255) : Q2(this, e, n, !1), n + 2;
};
Ne.prototype.writeInt32LE = function(e, n, r) {
  return e = +e, n = n | 0, r || Qi(this, e, n, 4, 2147483647, -2147483648), Ne.TYPED_ARRAY_SUPPORT ? (this[n] = e & 255, this[n + 1] = e >>> 8, this[n + 2] = e >>> 16, this[n + 3] = e >>> 24) : G2(this, e, n, !0), n + 4;
};
Ne.prototype.writeInt32BE = function(e, n, r) {
  return e = +e, n = n | 0, r || Qi(this, e, n, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), Ne.TYPED_ARRAY_SUPPORT ? (this[n] = e >>> 24, this[n + 1] = e >>> 16, this[n + 2] = e >>> 8, this[n + 3] = e & 255) : G2(this, e, n, !1), n + 4;
};
function YI(t, e, n, r, i, a) {
  if (n + r > t.length)
    throw new RangeError("Index out of range");
  if (n < 0)
    throw new RangeError("Index out of range");
}
function QI(t, e, n, r, i) {
  return i || YI(t, e, n, 4), DI(t, e, n, r, 23, 4), n + 4;
}
Ne.prototype.writeFloatLE = function(e, n, r) {
  return QI(this, e, n, !0, r);
};
Ne.prototype.writeFloatBE = function(e, n, r) {
  return QI(this, e, n, !1, r);
};
function GI(t, e, n, r, i) {
  return i || YI(t, e, n, 8), DI(t, e, n, r, 52, 8), n + 8;
}
Ne.prototype.writeDoubleLE = function(e, n, r) {
  return GI(this, e, n, !0, r);
};
Ne.prototype.writeDoubleBE = function(e, n, r) {
  return GI(this, e, n, !1, r);
};
Ne.prototype.copy = function(e, n, r, i) {
  if (r || (r = 0), !i && i !== 0 && (i = this.length), n >= e.length && (n = e.length), n || (n = 0), i > 0 && i < r && (i = r), i === r || e.length === 0 || this.length === 0)
    return 0;
  if (n < 0)
    throw new RangeError("targetStart out of bounds");
  if (r < 0 || r >= this.length)
    throw new RangeError("sourceStart out of bounds");
  if (i < 0)
    throw new RangeError("sourceEnd out of bounds");
  i > this.length && (i = this.length), e.length - n < i - r && (i = e.length - n + r);
  var a = i - r, o;
  if (this === e && r < n && n < i)
    for (o = a - 1; o >= 0; --o)
      e[o + n] = this[o + r];
  else if (a < 1e3 || !Ne.TYPED_ARRAY_SUPPORT)
    for (o = 0; o < a; ++o)
      e[o + n] = this[o + r];
  else
    Uint8Array.prototype.set.call(
      e,
      this.subarray(r, r + a),
      n
    );
  return a;
};
Ne.prototype.fill = function(e, n, r, i) {
  if (typeof e == "string") {
    if (typeof n == "string" ? (i = n, n = 0, r = this.length) : typeof r == "string" && (i = r, r = this.length), e.length === 1) {
      var a = e.charCodeAt(0);
      a < 256 && (e = a);
    }
    if (i !== void 0 && typeof i != "string")
      throw new TypeError("encoding must be a string");
    if (typeof i == "string" && !Ne.isEncoding(i))
      throw new TypeError("Unknown encoding: " + i);
  } else
    typeof e == "number" && (e = e & 255);
  if (n < 0 || this.length < n || this.length < r)
    throw new RangeError("Out of range index");
  if (r <= n)
    return this;
  n = n >>> 0, r = r === void 0 ? this.length : r >>> 0, e || (e = 0);
  var o;
  if (typeof e == "number")
    for (o = n; o < r; ++o)
      this[o] = e;
  else {
    var s = zo(e) ? e : wf(new Ne(e, i).toString()), l = s.length;
    for (o = 0; o < r - n; ++o)
      this[o + n] = s[o % l];
  }
  return this;
};
var J7 = /[^+\/0-9A-Za-z-_]/g;
function B7(t) {
  if (t = A7(t).replace(J7, ""), t.length < 2)
    return "";
  for (; t.length % 4 !== 0; )
    t = t + "=";
  return t;
}
function A7(t) {
  return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
}
function H7(t) {
  return t < 16 ? "0" + t.toString(16) : t.toString(16);
}
function wf(t, e) {
  e = e || 1 / 0;
  for (var n, r = t.length, i = null, a = [], o = 0; o < r; ++o) {
    if (n = t.charCodeAt(o), n > 55295 && n < 57344) {
      if (!i) {
        if (n > 56319) {
          (e -= 3) > -1 && a.push(239, 191, 189);
          continue;
        } else if (o + 1 === r) {
          (e -= 3) > -1 && a.push(239, 191, 189);
          continue;
        }
        i = n;
        continue;
      }
      if (n < 56320) {
        (e -= 3) > -1 && a.push(239, 191, 189), i = n;
        continue;
      }
      n = (i - 55296 << 10 | n - 56320) + 65536;
    } else
      i && (e -= 3) > -1 && a.push(239, 191, 189);
    if (i = null, n < 128) {
      if ((e -= 1) < 0)
        break;
      a.push(n);
    } else if (n < 2048) {
      if ((e -= 2) < 0)
        break;
      a.push(
        n >> 6 | 192,
        n & 63 | 128
      );
    } else if (n < 65536) {
      if ((e -= 3) < 0)
        break;
      a.push(
        n >> 12 | 224,
        n >> 6 & 63 | 128,
        n & 63 | 128
      );
    } else if (n < 1114112) {
      if ((e -= 4) < 0)
        break;
      a.push(
        n >> 18 | 240,
        n >> 12 & 63 | 128,
        n >> 6 & 63 | 128,
        n & 63 | 128
      );
    } else
      throw new Error("Invalid code point");
  }
  return a;
}
function X7(t) {
  for (var e = [], n = 0; n < t.length; ++n)
    e.push(t.charCodeAt(n) & 255);
  return e;
}
function _7(t, e) {
  for (var n, r, i, a = [], o = 0; o < t.length && !((e -= 2) < 0); ++o)
    n = t.charCodeAt(o), r = n >> 8, i = n % 256, a.push(i), a.push(r);
  return a;
}
function CI(t) {
  return y7(B7(t));
}
function C2(t, e, n, r) {
  for (var i = 0; i < r && !(i + n >= e.length || i >= t.length); ++i)
    e[i + n] = t[i];
  return i;
}
function P7(t) {
  return t !== t;
}
function K7(t) {
  return t != null && (!!t._isBuffer || LI(t) || $7(t));
}
function LI(t) {
  return !!t.constructor && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t);
}
function $7(t) {
  return typeof t.readFloatLE == "function" && typeof t.slice == "function" && LI(t.slice(0, 0));
}
function q7(t, e) {
  if (!t)
    return null;
  if (e != null && e.maxFeePerGas) {
    const n = pn.from(e.maxFeePerGas).mul(t);
    return ws(n);
  } else if (e != null && e.gasPrice) {
    const n = pn.from(e.gasPrice).mul(t);
    return ws(n);
  }
  return null;
}
function e$(t, e, n, r) {
  if (!e || !r || !n)
    return os.CANNOT_ESTIMATE_GAS_FEE;
  if (t.address === zi) {
    const i = pn.from(e), a = r.balance.sub(i);
    switch (qy(
      n,
      ws(
        a,
        r.decimals
      )
    )) {
      case 1:
        return os.GAS_FEE_NOT_ENOUGH;
      case -1:
        return os.GAS_FEE_ENOUGH;
      case 0:
        return os.GAS_FEE_ENOUGH;
    }
  } else
    switch (qy(
      n,
      ws(
        r.balance,
        r.decimals
      )
    )) {
      case 1:
        return os.GAS_FEE_NOT_ENOUGH;
      case -1:
        return os.GAS_FEE_ENOUGH;
      case 0:
        return os.GAS_FEE_ENOUGH;
    }
}
const t$ = Qp("https://mainnet.infura.io/v3/"), n$ = Qp("https://rpc.ankr.com/eth"), r$ = Qp("https://cloudflare-eth.com"), i$ = Df({
  chain: bI,
  transport: jf(
    [t$, n$, r$],
    {
      retryCount: 5
    }
  )
});
ve.MAINNET + "";
function a$() {
  const t = IK();
  nc.init({
    viemClientMap: t
  });
}
a$();
function o$({ data: t = [], pageSize: e = 5 }) {
  const [n, r] = nt(1), i = t.length, a = Math.ceil(i / e), o = n === a, s = e * (n - 1), l = o ? t.length - 1 : s + e - 1, c = n <= 1, d = n >= a, u = () => {
    d || r(n + 1);
  }, h = () => {
    c || r(n - 1);
  }, N = s + 1, M = l + 1, p = `${N} - ${M} of ${i}`, m = t.slice(s, M);
  return {
    data: t,
    currentItemIndex: N,
    endItemIndex: M,
    total: i,
    currentPage: n,
    pageSize: e,
    startIndex: s,
    endIndex: l,
    totalPages: a,
    nextPage: u,
    previousPage: h,
    disabledPreviousPage: c,
    disabledNextPage: d,
    paginationStr: p,
    isLastPage: o,
    currentPageData: m
  };
}
function s$(t) {
  const e = document.createElement("textarea");
  e.value = t, document.body.appendChild(e), e.select(), document.execCommand("copy"), document.body.removeChild(e);
}
function l$() {
  const [t, e] = H.useState(null), n = H.useCallback((r) => {
    (async () => {
      var a;
      try {
        if ((a = navigator == null ? void 0 : navigator.clipboard) != null && a.writeText)
          await navigator.clipboard.writeText(r), e(r);
        else
          throw new Error("writeText not supported");
      } catch {
        s$(r), e(r);
      }
    })();
  }, []);
  return [t, n];
}
function c$(t = 3e3) {
  const [e, n] = l$(), [r, i] = nt(!1);
  return Ee(() => {
    const a = setTimeout(() => {
      i(!1);
    }, t);
    return () => {
      clearTimeout(a);
    };
  }, [r]), {
    copiedText: e,
    copyToClipboard: n,
    isCopiedSuccess: r,
    setIsCopiedSuccess: i
  };
}
var Cp = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    return this.listeners.add(e), this.onSubscribe(), () => {
      this.listeners.delete(e), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, q0 = typeof window > "u" || "Deno" in window;
function Ua() {
}
function d$(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function nZ(t) {
  return typeof t == "number" && t >= 0 && t !== 1 / 0;
}
function JI(t, e) {
  return Math.max(t + (e || 0) - Date.now(), 0);
}
function bj(t, e) {
  const {
    type: n = "all",
    exact: r,
    fetchStatus: i,
    predicate: a,
    queryKey: o,
    stale: s
  } = t;
  if (o) {
    if (r) {
      if (e.queryHash !== R3(o, e.options))
        return !1;
    } else if (!q1(e.queryKey, o))
      return !1;
  }
  if (n !== "all") {
    const l = e.isActive();
    if (n === "active" && !l || n === "inactive" && l)
      return !1;
  }
  return !(typeof s == "boolean" && e.isStale() !== s || typeof i < "u" && i !== e.state.fetchStatus || a && !a(e));
}
function Ej(t, e) {
  const { exact: n, status: r, predicate: i, mutationKey: a } = t;
  if (a) {
    if (!e.options.mutationKey)
      return !1;
    if (n) {
      if ($1(e.options.mutationKey) !== $1(a))
        return !1;
    } else if (!q1(e.options.mutationKey, a))
      return !1;
  }
  return !(r && e.state.status !== r || i && !i(e));
}
function R3(t, e) {
  return ((e == null ? void 0 : e.queryKeyHashFn) || $1)(t);
}
function $1(t) {
  return JSON.stringify(
    t,
    (e, n) => iZ(n) ? Object.keys(n).sort().reduce((r, i) => (r[i] = n[i], r), {}) : n
  );
}
function q1(t, e) {
  return t === e ? !0 : typeof t != typeof e ? !1 : t && e && typeof t == "object" && typeof e == "object" ? !Object.keys(e).some((n) => !q1(t[n], e[n])) : !1;
}
function BI(t, e) {
  if (t === e)
    return t;
  const n = Sj(t) && Sj(e);
  if (n || iZ(t) && iZ(e)) {
    const r = n ? t.length : Object.keys(t).length, i = n ? e : Object.keys(e), a = i.length, o = n ? [] : {};
    let s = 0;
    for (let l = 0; l < a; l++) {
      const c = n ? l : i[l];
      o[c] = BI(t[c], e[c]), o[c] === t[c] && s++;
    }
    return r === a && s === r ? t : o;
  }
  return e;
}
function rZ(t, e) {
  if (t && !e || e && !t)
    return !1;
  for (const n in t)
    if (t[n] !== e[n])
      return !1;
  return !0;
}
function Sj(t) {
  return Array.isArray(t) && t.length === Object.keys(t).length;
}
function iZ(t) {
  if (!xj(t))
    return !1;
  const e = t.constructor;
  if (typeof e > "u")
    return !0;
  const n = e.prototype;
  return !(!xj(n) || !n.hasOwnProperty("isPrototypeOf"));
}
function xj(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function AI(t) {
  return new Promise((e) => {
    setTimeout(e, t);
  });
}
function Wj(t) {
  AI(0).then(t);
}
function aZ(t, e, n) {
  return typeof n.structuralSharing == "function" ? n.structuralSharing(t, e) : n.structuralSharing !== !1 ? BI(t, e) : e;
}
function u$(t, e, n = 0) {
  const r = [...t, e];
  return n && r.length > n ? r.slice(1) : r;
}
function h$(t, e, n = 0) {
  const r = [e, ...t];
  return n && r.length > n ? r.slice(0, -1) : r;
}
var ud, Wl, S0, tw, N$ = (tw = class extends Cp {
  constructor() {
    super();
    Fe(this, ud, void 0);
    Fe(this, Wl, void 0);
    Fe(this, S0, void 0);
    Ue(this, S0, (n) => {
      if (!q0 && window.addEventListener) {
        const r = () => n();
        return window.addEventListener("visibilitychange", r, !1), () => {
          window.removeEventListener("visibilitychange", r);
        };
      }
    });
  }
  onSubscribe() {
    K(this, Wl) || this.setEventListener(K(this, S0));
  }
  onUnsubscribe() {
    var n;
    this.hasListeners() || ((n = K(this, Wl)) == null || n.call(this), Ue(this, Wl, void 0));
  }
  setEventListener(n) {
    var r;
    Ue(this, S0, n), (r = K(this, Wl)) == null || r.call(this), Ue(this, Wl, n((i) => {
      typeof i == "boolean" ? this.setFocused(i) : this.onFocus();
    }));
  }
  setFocused(n) {
    K(this, ud) !== n && (Ue(this, ud, n), this.onFocus());
  }
  onFocus() {
    this.listeners.forEach((n) => {
      n();
    });
  }
  isFocused() {
    var n;
    return typeof K(this, ud) == "boolean" ? K(this, ud) : ((n = globalThis.document) == null ? void 0 : n.visibilityState) !== "hidden";
  }
}, ud = new WeakMap(), Wl = new WeakMap(), S0 = new WeakMap(), tw), eM = new N$(), x0, jl, W0, nw, M$ = (nw = class extends Cp {
  constructor() {
    super();
    Fe(this, x0, !0);
    Fe(this, jl, void 0);
    Fe(this, W0, void 0);
    Ue(this, W0, (n) => {
      if (!q0 && window.addEventListener) {
        const r = () => n(!0), i = () => n(!1);
        return window.addEventListener("online", r, !1), window.addEventListener("offline", i, !1), () => {
          window.removeEventListener("online", r), window.removeEventListener("offline", i);
        };
      }
    });
  }
  onSubscribe() {
    K(this, jl) || this.setEventListener(K(this, W0));
  }
  onUnsubscribe() {
    var n;
    this.hasListeners() || ((n = K(this, jl)) == null || n.call(this), Ue(this, jl, void 0));
  }
  setEventListener(n) {
    var r;
    Ue(this, W0, n), (r = K(this, jl)) == null || r.call(this), Ue(this, jl, n(this.setOnline.bind(this)));
  }
  setOnline(n) {
    K(this, x0) !== n && (Ue(this, x0, n), this.listeners.forEach((i) => {
      i(n);
    }));
  }
  isOnline() {
    return K(this, x0);
  }
}, x0 = new WeakMap(), jl = new WeakMap(), W0 = new WeakMap(), nw), tM = new M$();
function p$(t) {
  return Math.min(1e3 * 2 ** t, 3e4);
}
function L2(t) {
  return (t ?? "online") === "online" ? tM.isOnline() : !0;
}
var HI = class {
  constructor(e) {
    this.revert = e == null ? void 0 : e.revert, this.silent = e == null ? void 0 : e.silent;
  }
};
function CR(t) {
  return t instanceof HI;
}
function XI(t) {
  let e = !1, n = 0, r = !1, i, a, o;
  const s = new Promise((m, R) => {
    a = m, o = R;
  }), l = (m) => {
    var R;
    r || (N(new HI(m)), (R = t.abort) == null || R.call(t));
  }, c = () => {
    e = !0;
  }, d = () => {
    e = !1;
  }, u = () => !eM.isFocused() || t.networkMode !== "always" && !tM.isOnline(), h = (m) => {
    var R;
    r || (r = !0, (R = t.onSuccess) == null || R.call(t, m), i == null || i(), a(m));
  }, N = (m) => {
    var R;
    r || (r = !0, (R = t.onError) == null || R.call(t, m), i == null || i(), o(m));
  }, M = () => new Promise((m) => {
    var R;
    i = (V) => {
      const U = r || !u();
      return U && m(V), U;
    }, (R = t.onPause) == null || R.call(t);
  }).then(() => {
    var m;
    i = void 0, r || (m = t.onContinue) == null || m.call(t);
  }), p = () => {
    if (r)
      return;
    let m;
    try {
      m = t.fn();
    } catch (R) {
      m = Promise.reject(R);
    }
    Promise.resolve(m).then(h).catch((R) => {
      var x;
      if (r)
        return;
      const V = t.retry ?? (q0 ? 0 : 3), U = t.retryDelay ?? p$, g = typeof U == "function" ? U(n, R) : U, y = V === !0 || typeof V == "number" && n < V || typeof V == "function" && V(n, R);
      if (e || !y) {
        N(R);
        return;
      }
      n++, (x = t.onFail) == null || x.call(t, n, R), AI(g).then(() => {
        if (u())
          return M();
      }).then(() => {
        e ? N(R) : p();
      });
    });
  };
  return L2(t.networkMode) ? p() : M().then(p), {
    promise: s,
    cancel: l,
    continue: () => (i == null ? void 0 : i()) ? s : Promise.resolve(),
    cancelRetry: c,
    continueRetry: d
  };
}
function m$() {
  let t = [], e = 0, n = (d) => {
    d();
  }, r = (d) => {
    d();
  };
  const i = (d) => {
    let u;
    e++;
    try {
      u = d();
    } finally {
      e--, e || s();
    }
    return u;
  }, a = (d) => {
    e ? t.push(d) : Wj(() => {
      n(d);
    });
  }, o = (d) => (...u) => {
    a(() => {
      d(...u);
    });
  }, s = () => {
    const d = t;
    t = [], d.length && Wj(() => {
      r(() => {
        d.forEach((u) => {
          n(u);
        });
      });
    });
  };
  return {
    batch: i,
    batchCalls: o,
    schedule: a,
    setNotifyFunction: (d) => {
      n = d;
    },
    setBatchNotifyFunction: (d) => {
      r = d;
    }
  };
}
var Yr = m$(), hd, rw, _I = (rw = class {
  constructor() {
    Fe(this, hd, void 0);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), nZ(this.gcTime) && Ue(this, hd, setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(e) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      e ?? (q0 ? 1 / 0 : 5 * 60 * 1e3)
    );
  }
  clearGcTimeout() {
    K(this, hd) && (clearTimeout(K(this, hd)), Ue(this, hd, void 0));
  }
}, hd = new WeakMap(), rw), j0, D0, Ta, Dl, fa, xr, Np, Nd, z0, IT, Qa, is, iw, T$ = (iw = class extends _I {
  constructor(n) {
    super();
    Fe(this, z0);
    Fe(this, Qa);
    Fe(this, j0, void 0);
    Fe(this, D0, void 0);
    Fe(this, Ta, void 0);
    Fe(this, Dl, void 0);
    Fe(this, fa, void 0);
    Fe(this, xr, void 0);
    Fe(this, Np, void 0);
    Fe(this, Nd, void 0);
    Ue(this, Nd, !1), Ue(this, Np, n.defaultOptions), Yt(this, z0, IT).call(this, n.options), Ue(this, xr, []), Ue(this, Ta, n.cache), this.queryKey = n.queryKey, this.queryHash = n.queryHash, Ue(this, j0, n.state || f$(this.options)), this.state = K(this, j0), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  optionalRemove() {
    !K(this, xr).length && this.state.fetchStatus === "idle" && K(this, Ta).remove(this);
  }
  setData(n, r) {
    const i = aZ(this.state.data, n, this.options);
    return Yt(this, Qa, is).call(this, {
      data: i,
      type: "success",
      dataUpdatedAt: r == null ? void 0 : r.updatedAt,
      manual: r == null ? void 0 : r.manual
    }), i;
  }
  setState(n, r) {
    Yt(this, Qa, is).call(this, { type: "setState", state: n, setStateOptions: r });
  }
  cancel(n) {
    var i;
    const r = K(this, Dl);
    return (i = K(this, fa)) == null || i.cancel(n), r ? r.then(Ua).catch(Ua) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(K(this, j0));
  }
  isActive() {
    return K(this, xr).some(
      (n) => n.options.enabled !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || K(this, xr).some((n) => n.getCurrentResult().isStale);
  }
  isStaleByTime(n = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !JI(this.state.dataUpdatedAt, n);
  }
  onFocus() {
    var r;
    const n = K(this, xr).find((i) => i.shouldFetchOnWindowFocus());
    n == null || n.refetch({ cancelRefetch: !1 }), (r = K(this, fa)) == null || r.continue();
  }
  onOnline() {
    var r;
    const n = K(this, xr).find((i) => i.shouldFetchOnReconnect());
    n == null || n.refetch({ cancelRefetch: !1 }), (r = K(this, fa)) == null || r.continue();
  }
  addObserver(n) {
    K(this, xr).includes(n) || (K(this, xr).push(n), this.clearGcTimeout(), K(this, Ta).notify({ type: "observerAdded", query: this, observer: n }));
  }
  removeObserver(n) {
    K(this, xr).includes(n) && (Ue(this, xr, K(this, xr).filter((r) => r !== n)), K(this, xr).length || (K(this, fa) && (K(this, Nd) ? K(this, fa).cancel({ revert: !0 }) : K(this, fa).cancelRetry()), this.scheduleGc()), K(this, Ta).notify({ type: "observerRemoved", query: this, observer: n }));
  }
  getObserversCount() {
    return K(this, xr).length;
  }
  invalidate() {
    this.state.isInvalidated || Yt(this, Qa, is).call(this, { type: "invalidate" });
  }
  fetch(n, r) {
    var d, u, h, N;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.dataUpdatedAt && (r != null && r.cancelRefetch))
        this.cancel({ silent: !0 });
      else if (K(this, Dl))
        return (d = K(this, fa)) == null || d.continueRetry(), K(this, Dl);
    }
    if (n && Yt(this, z0, IT).call(this, n), !this.options.queryFn) {
      const M = K(this, xr).find((p) => p.options.queryFn);
      M && Yt(this, z0, IT).call(this, M.options);
    }
    ue.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || console.error(
      "As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"
    ));
    const i = new AbortController(), a = {
      queryKey: this.queryKey,
      meta: this.meta
    }, o = (M) => {
      Object.defineProperty(M, "signal", {
        enumerable: !0,
        get: () => (Ue(this, Nd, !0), i.signal)
      });
    };
    o(a);
    const s = () => this.options.queryFn ? (Ue(this, Nd, !1), this.options.persister ? this.options.persister(
      this.options.queryFn,
      a,
      this
    ) : this.options.queryFn(
      a
    )) : Promise.reject(
      new Error(`Missing queryFn: '${this.options.queryHash}'`)
    ), l = {
      fetchOptions: r,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: s
    };
    o(l), (u = this.options.behavior) == null || u.onFetch(
      l,
      this
    ), Ue(this, D0, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((h = l.fetchOptions) == null ? void 0 : h.meta)) && Yt(this, Qa, is).call(this, { type: "fetch", meta: (N = l.fetchOptions) == null ? void 0 : N.meta });
    const c = (M) => {
      var p, m, R, V;
      CR(M) && M.silent || Yt(this, Qa, is).call(this, {
        type: "error",
        error: M
      }), CR(M) || ((m = (p = K(this, Ta).config).onError) == null || m.call(
        p,
        M,
        this
      ), (V = (R = K(this, Ta).config).onSettled) == null || V.call(
        R,
        this.state.data,
        M,
        this
      )), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return Ue(this, fa, XI({
      fn: l.fetchFn,
      abort: i.abort.bind(i),
      onSuccess: (M) => {
        var p, m, R, V;
        if (typeof M > "u") {
          ue.env.NODE_ENV !== "production" && console.error(
            `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
          ), c(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        this.setData(M), (m = (p = K(this, Ta).config).onSuccess) == null || m.call(p, M, this), (V = (R = K(this, Ta).config).onSettled) == null || V.call(
          R,
          M,
          this.state.error,
          this
        ), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: c,
      onFail: (M, p) => {
        Yt(this, Qa, is).call(this, { type: "failed", failureCount: M, error: p });
      },
      onPause: () => {
        Yt(this, Qa, is).call(this, { type: "pause" });
      },
      onContinue: () => {
        Yt(this, Qa, is).call(this, { type: "continue" });
      },
      retry: l.options.retry,
      retryDelay: l.options.retryDelay,
      networkMode: l.options.networkMode
    })), Ue(this, Dl, K(this, fa).promise), K(this, Dl);
  }
}, j0 = new WeakMap(), D0 = new WeakMap(), Ta = new WeakMap(), Dl = new WeakMap(), fa = new WeakMap(), xr = new WeakMap(), Np = new WeakMap(), Nd = new WeakMap(), z0 = new WeakSet(), IT = function(n) {
  this.options = { ...K(this, Np), ...n }, this.updateGcTime(this.options.gcTime);
}, Qa = new WeakSet(), is = function(n) {
  const r = (i) => {
    switch (n.type) {
      case "failed":
        return {
          ...i,
          fetchFailureCount: n.failureCount,
          fetchFailureReason: n.error
        };
      case "pause":
        return {
          ...i,
          fetchStatus: "paused"
        };
      case "continue":
        return {
          ...i,
          fetchStatus: "fetching"
        };
      case "fetch":
        return {
          ...i,
          fetchFailureCount: 0,
          fetchFailureReason: null,
          fetchMeta: n.meta ?? null,
          fetchStatus: L2(this.options.networkMode) ? "fetching" : "paused",
          ...!i.dataUpdatedAt && {
            error: null,
            status: "pending"
          }
        };
      case "success":
        return {
          ...i,
          data: n.data,
          dataUpdateCount: i.dataUpdateCount + 1,
          dataUpdatedAt: n.dataUpdatedAt ?? Date.now(),
          error: null,
          isInvalidated: !1,
          status: "success",
          ...!n.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          }
        };
      case "error":
        const a = n.error;
        return CR(a) && a.revert && K(this, D0) ? { ...K(this, D0), fetchStatus: "idle" } : {
          ...i,
          error: a,
          errorUpdateCount: i.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: i.fetchFailureCount + 1,
          fetchFailureReason: a,
          fetchStatus: "idle",
          status: "error"
        };
      case "invalidate":
        return {
          ...i,
          isInvalidated: !0
        };
      case "setState":
        return {
          ...i,
          ...n.state
        };
    }
  };
  this.state = r(this.state), Yr.batch(() => {
    K(this, xr).forEach((i) => {
      i.onQueryUpdate();
    }), K(this, Ta).notify({ query: this, type: "updated", action: n });
  });
}, iw);
function f$(t) {
  const e = typeof t.initialData == "function" ? t.initialData() : t.initialData, n = typeof e < "u", r = n ? typeof t.initialDataUpdatedAt == "function" ? t.initialDataUpdatedAt() : t.initialDataUpdatedAt : 0;
  return {
    data: e,
    dataUpdateCount: 0,
    dataUpdatedAt: n ? r ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: n ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var mo, aw, V$ = (aw = class extends Cp {
  constructor(n = {}) {
    super();
    Fe(this, mo, void 0);
    this.config = n, Ue(this, mo, /* @__PURE__ */ new Map());
  }
  build(n, r, i) {
    const a = r.queryKey, o = r.queryHash ?? R3(a, r);
    let s = this.get(o);
    return s || (s = new T$({
      cache: this,
      queryKey: a,
      queryHash: o,
      options: n.defaultQueryOptions(r),
      state: i,
      defaultOptions: n.getQueryDefaults(a)
    }), this.add(s)), s;
  }
  add(n) {
    K(this, mo).has(n.queryHash) || (K(this, mo).set(n.queryHash, n), this.notify({
      type: "added",
      query: n
    }));
  }
  remove(n) {
    const r = K(this, mo).get(n.queryHash);
    r && (n.destroy(), r === n && K(this, mo).delete(n.queryHash), this.notify({ type: "removed", query: n }));
  }
  clear() {
    Yr.batch(() => {
      this.getAll().forEach((n) => {
        this.remove(n);
      });
    });
  }
  get(n) {
    return K(this, mo).get(n);
  }
  getAll() {
    return [...K(this, mo).values()];
  }
  find(n) {
    const r = { exact: !0, ...n };
    return this.getAll().find(
      (i) => bj(r, i)
    );
  }
  findAll(n = {}) {
    const r = this.getAll();
    return Object.keys(n).length > 0 ? r.filter((i) => bj(n, i)) : r;
  }
  notify(n) {
    Yr.batch(() => {
      this.listeners.forEach((r) => {
        r(n);
      });
    });
  }
  onFocus() {
    Yr.batch(() => {
      this.getAll().forEach((n) => {
        n.onFocus();
      });
    });
  }
  onOnline() {
    Yr.batch(() => {
      this.getAll().forEach((n) => {
        n.onOnline();
      });
    });
  }
}, mo = new WeakMap(), aw), To, Mp, Hi, k0, fo, Ml, ow, U$ = (ow = class extends _I {
  constructor(n) {
    super();
    Fe(this, fo);
    Fe(this, To, void 0);
    Fe(this, Mp, void 0);
    Fe(this, Hi, void 0);
    Fe(this, k0, void 0);
    this.mutationId = n.mutationId, Ue(this, Mp, n.defaultOptions), Ue(this, Hi, n.mutationCache), Ue(this, To, []), this.state = n.state || R$(), this.setOptions(n.options), this.scheduleGc();
  }
  setOptions(n) {
    this.options = { ...K(this, Mp), ...n }, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(n) {
    K(this, To).includes(n) || (K(this, To).push(n), this.clearGcTimeout(), K(this, Hi).notify({
      type: "observerAdded",
      mutation: this,
      observer: n
    }));
  }
  removeObserver(n) {
    Ue(this, To, K(this, To).filter((r) => r !== n)), this.scheduleGc(), K(this, Hi).notify({
      type: "observerRemoved",
      mutation: this,
      observer: n
    });
  }
  optionalRemove() {
    K(this, To).length || (this.state.status === "pending" ? this.scheduleGc() : K(this, Hi).remove(this));
  }
  continue() {
    var n;
    return ((n = K(this, k0)) == null ? void 0 : n.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(n) {
    var a, o, s, l, c, d, u, h, N, M, p, m, R, V, U, g, y, x, f, D;
    const r = () => (Ue(this, k0, XI({
      fn: () => this.options.mutationFn ? this.options.mutationFn(n) : Promise.reject(new Error("No mutationFn found")),
      onFail: (Y, Q) => {
        Yt(this, fo, Ml).call(this, { type: "failed", failureCount: Y, error: Q });
      },
      onPause: () => {
        Yt(this, fo, Ml).call(this, { type: "pause" });
      },
      onContinue: () => {
        Yt(this, fo, Ml).call(this, { type: "continue" });
      },
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode
    })), K(this, k0).promise), i = this.state.status === "pending";
    try {
      if (!i) {
        Yt(this, fo, Ml).call(this, { type: "pending", variables: n }), await ((o = (a = K(this, Hi).config).onMutate) == null ? void 0 : o.call(
          a,
          n,
          this
        ));
        const Q = await ((l = (s = this.options).onMutate) == null ? void 0 : l.call(s, n));
        Q !== this.state.context && Yt(this, fo, Ml).call(this, {
          type: "pending",
          context: Q,
          variables: n
        });
      }
      const Y = await r();
      return await ((d = (c = K(this, Hi).config).onSuccess) == null ? void 0 : d.call(
        c,
        Y,
        n,
        this.state.context,
        this
      )), await ((h = (u = this.options).onSuccess) == null ? void 0 : h.call(u, Y, n, this.state.context)), await ((M = (N = K(this, Hi).config).onSettled) == null ? void 0 : M.call(
        N,
        Y,
        null,
        this.state.variables,
        this.state.context,
        this
      )), await ((m = (p = this.options).onSettled) == null ? void 0 : m.call(p, Y, null, n, this.state.context)), Yt(this, fo, Ml).call(this, { type: "success", data: Y }), Y;
    } catch (Y) {
      try {
        throw await ((V = (R = K(this, Hi).config).onError) == null ? void 0 : V.call(
          R,
          Y,
          n,
          this.state.context,
          this
        )), await ((g = (U = this.options).onError) == null ? void 0 : g.call(
          U,
          Y,
          n,
          this.state.context
        )), await ((x = (y = K(this, Hi).config).onSettled) == null ? void 0 : x.call(
          y,
          void 0,
          Y,
          this.state.variables,
          this.state.context,
          this
        )), await ((D = (f = this.options).onSettled) == null ? void 0 : D.call(
          f,
          void 0,
          Y,
          n,
          this.state.context
        )), Y;
      } finally {
        Yt(this, fo, Ml).call(this, { type: "error", error: Y });
      }
    }
  }
}, To = new WeakMap(), Mp = new WeakMap(), Hi = new WeakMap(), k0 = new WeakMap(), fo = new WeakSet(), Ml = function(n) {
  const r = (i) => {
    switch (n.type) {
      case "failed":
        return {
          ...i,
          failureCount: n.failureCount,
          failureReason: n.error
        };
      case "pause":
        return {
          ...i,
          isPaused: !0
        };
      case "continue":
        return {
          ...i,
          isPaused: !1
        };
      case "pending":
        return {
          ...i,
          context: n.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: !L2(this.options.networkMode),
          status: "pending",
          variables: n.variables,
          submittedAt: Date.now()
        };
      case "success":
        return {
          ...i,
          data: n.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: !1
        };
      case "error":
        return {
          ...i,
          data: void 0,
          error: n.error,
          failureCount: i.failureCount + 1,
          failureReason: n.error,
          isPaused: !1,
          status: "error"
        };
    }
  };
  this.state = r(this.state), Yr.batch(() => {
    K(this, To).forEach((i) => {
      i.onMutationUpdate(n);
    }), K(this, Hi).notify({
      mutation: this,
      type: "updated",
      action: n
    });
  });
}, ow);
function R$() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var Va, pp, Md, sw, g$ = (sw = class extends Cp {
  constructor(n = {}) {
    super();
    Fe(this, Va, void 0);
    Fe(this, pp, void 0);
    Fe(this, Md, void 0);
    this.config = n, Ue(this, Va, []), Ue(this, pp, 0);
  }
  build(n, r, i) {
    const a = new U$({
      mutationCache: this,
      mutationId: ++Ym(this, pp)._,
      options: n.defaultMutationOptions(r),
      state: i
    });
    return this.add(a), a;
  }
  add(n) {
    K(this, Va).push(n), this.notify({ type: "added", mutation: n });
  }
  remove(n) {
    Ue(this, Va, K(this, Va).filter((r) => r !== n)), this.notify({ type: "removed", mutation: n });
  }
  clear() {
    Yr.batch(() => {
      K(this, Va).forEach((n) => {
        this.remove(n);
      });
    });
  }
  getAll() {
    return K(this, Va);
  }
  find(n) {
    const r = { exact: !0, ...n };
    return K(this, Va).find(
      (i) => Ej(r, i)
    );
  }
  findAll(n = {}) {
    return K(this, Va).filter(
      (r) => Ej(n, r)
    );
  }
  notify(n) {
    Yr.batch(() => {
      this.listeners.forEach((r) => {
        r(n);
      });
    });
  }
  resumePausedMutations() {
    return Ue(this, Md, (K(this, Md) ?? Promise.resolve()).then(() => {
      const n = K(this, Va).filter((r) => r.state.isPaused);
      return Yr.batch(
        () => n.reduce(
          (r, i) => r.then(() => i.continue().catch(Ua)),
          Promise.resolve()
        )
      );
    }).then(() => {
      Ue(this, Md, void 0);
    })), K(this, Md);
  }
}, Va = new WeakMap(), pp = new WeakMap(), Md = new WeakMap(), sw);
function y$(t) {
  return {
    onFetch: (e, n) => {
      const r = async () => {
        var M, p, m, R, V;
        const i = e.options, a = (m = (p = (M = e.fetchOptions) == null ? void 0 : M.meta) == null ? void 0 : p.fetchMore) == null ? void 0 : m.direction, o = ((R = e.state.data) == null ? void 0 : R.pages) || [], s = ((V = e.state.data) == null ? void 0 : V.pageParams) || [], l = { pages: [], pageParams: [] };
        let c = !1;
        const d = (U) => {
          Object.defineProperty(U, "signal", {
            enumerable: !0,
            get: () => (e.signal.aborted ? c = !0 : e.signal.addEventListener("abort", () => {
              c = !0;
            }), e.signal)
          });
        }, u = e.options.queryFn || (() => Promise.reject(
          new Error(`Missing queryFn: '${e.options.queryHash}'`)
        )), h = async (U, g, y) => {
          if (c)
            return Promise.reject();
          if (g == null && U.pages.length)
            return Promise.resolve(U);
          const x = {
            queryKey: e.queryKey,
            pageParam: g,
            direction: y ? "backward" : "forward",
            meta: e.options.meta
          };
          d(x);
          const f = await u(
            x
          ), { maxPages: D } = e.options, Y = y ? h$ : u$;
          return {
            pages: Y(U.pages, f, D),
            pageParams: Y(U.pageParams, g, D)
          };
        };
        let N;
        if (a && o.length) {
          const U = a === "backward", g = U ? Z$ : jj, y = {
            pages: o,
            pageParams: s
          }, x = g(i, y);
          N = await h(y, x, U);
        } else {
          N = await h(
            l,
            s[0] ?? i.initialPageParam
          );
          const U = t ?? o.length;
          for (let g = 1; g < U; g++) {
            const y = jj(i, N);
            N = await h(N, y);
          }
        }
        return N;
      };
      e.options.persister ? e.fetchFn = () => {
        var i, a;
        return (a = (i = e.options).persister) == null ? void 0 : a.call(
          i,
          r,
          {
            queryKey: e.queryKey,
            meta: e.options.meta,
            signal: e.signal
          },
          n
        );
      } : e.fetchFn = r;
    }
  };
}
function jj(t, { pages: e, pageParams: n }) {
  const r = e.length - 1;
  return t.getNextPageParam(
    e[r],
    e,
    n[r],
    n
  );
}
function Z$(t, { pages: e, pageParams: n }) {
  var r;
  return (r = t.getPreviousPageParam) == null ? void 0 : r.call(
    t,
    e[0],
    e,
    n[0],
    n
  );
}
var mr, zl, kl, w0, F0, wl, v0, I0, lw, b$ = (lw = class {
  constructor(e = {}) {
    Fe(this, mr, void 0);
    Fe(this, zl, void 0);
    Fe(this, kl, void 0);
    Fe(this, w0, void 0);
    Fe(this, F0, void 0);
    Fe(this, wl, void 0);
    Fe(this, v0, void 0);
    Fe(this, I0, void 0);
    Ue(this, mr, e.queryCache || new V$()), Ue(this, zl, e.mutationCache || new g$()), Ue(this, kl, e.defaultOptions || {}), Ue(this, w0, /* @__PURE__ */ new Map()), Ue(this, F0, /* @__PURE__ */ new Map()), Ue(this, wl, 0);
  }
  mount() {
    Ym(this, wl)._++, K(this, wl) === 1 && (Ue(this, v0, eM.subscribe(() => {
      eM.isFocused() && (this.resumePausedMutations(), K(this, mr).onFocus());
    })), Ue(this, I0, tM.subscribe(() => {
      tM.isOnline() && (this.resumePausedMutations(), K(this, mr).onOnline());
    })));
  }
  unmount() {
    var e, n;
    Ym(this, wl)._--, K(this, wl) === 0 && ((e = K(this, v0)) == null || e.call(this), Ue(this, v0, void 0), (n = K(this, I0)) == null || n.call(this), Ue(this, I0, void 0));
  }
  isFetching(e) {
    return K(this, mr).findAll({ ...e, fetchStatus: "fetching" }).length;
  }
  isMutating(e) {
    return K(this, zl).findAll({ ...e, status: "pending" }).length;
  }
  getQueryData(e) {
    var n;
    return (n = K(this, mr).find({ queryKey: e })) == null ? void 0 : n.state.data;
  }
  ensureQueryData(e) {
    const n = this.getQueryData(e.queryKey);
    return n !== void 0 ? Promise.resolve(n) : this.fetchQuery(e);
  }
  getQueriesData(e) {
    return this.getQueryCache().findAll(e).map(({ queryKey: n, state: r }) => {
      const i = r.data;
      return [n, i];
    });
  }
  setQueryData(e, n, r) {
    const i = K(this, mr).find({ queryKey: e }), a = i == null ? void 0 : i.state.data, o = d$(n, a);
    if (typeof o > "u")
      return;
    const s = this.defaultQueryOptions({ queryKey: e });
    return K(this, mr).build(this, s).setData(o, { ...r, manual: !0 });
  }
  setQueriesData(e, n, r) {
    return Yr.batch(
      () => this.getQueryCache().findAll(e).map(({ queryKey: i }) => [
        i,
        this.setQueryData(i, n, r)
      ])
    );
  }
  getQueryState(e) {
    var n;
    return (n = K(this, mr).find({ queryKey: e })) == null ? void 0 : n.state;
  }
  removeQueries(e) {
    const n = K(this, mr);
    Yr.batch(() => {
      n.findAll(e).forEach((r) => {
        n.remove(r);
      });
    });
  }
  resetQueries(e, n) {
    const r = K(this, mr), i = {
      type: "active",
      ...e
    };
    return Yr.batch(() => (r.findAll(e).forEach((a) => {
      a.reset();
    }), this.refetchQueries(i, n)));
  }
  cancelQueries(e = {}, n = {}) {
    const r = { revert: !0, ...n }, i = Yr.batch(
      () => K(this, mr).findAll(e).map((a) => a.cancel(r))
    );
    return Promise.all(i).then(Ua).catch(Ua);
  }
  invalidateQueries(e = {}, n = {}) {
    return Yr.batch(() => {
      if (K(this, mr).findAll(e).forEach((i) => {
        i.invalidate();
      }), e.refetchType === "none")
        return Promise.resolve();
      const r = {
        ...e,
        type: e.refetchType ?? e.type ?? "active"
      };
      return this.refetchQueries(r, n);
    });
  }
  refetchQueries(e = {}, n) {
    const r = {
      ...n,
      cancelRefetch: (n == null ? void 0 : n.cancelRefetch) ?? !0
    }, i = Yr.batch(
      () => K(this, mr).findAll(e).filter((a) => !a.isDisabled()).map((a) => {
        let o = a.fetch(void 0, r);
        return r.throwOnError || (o = o.catch(Ua)), a.state.fetchStatus === "paused" ? Promise.resolve() : o;
      })
    );
    return Promise.all(i).then(Ua);
  }
  fetchQuery(e) {
    const n = this.defaultQueryOptions(e);
    typeof n.retry > "u" && (n.retry = !1);
    const r = K(this, mr).build(this, n);
    return r.isStaleByTime(n.staleTime) ? r.fetch(n) : Promise.resolve(r.state.data);
  }
  prefetchQuery(e) {
    return this.fetchQuery(e).then(Ua).catch(Ua);
  }
  fetchInfiniteQuery(e) {
    return e.behavior = y$(e.pages), this.fetchQuery(e);
  }
  prefetchInfiniteQuery(e) {
    return this.fetchInfiniteQuery(e).then(Ua).catch(Ua);
  }
  resumePausedMutations() {
    return K(this, zl).resumePausedMutations();
  }
  getQueryCache() {
    return K(this, mr);
  }
  getMutationCache() {
    return K(this, zl);
  }
  getDefaultOptions() {
    return K(this, kl);
  }
  setDefaultOptions(e) {
    Ue(this, kl, e);
  }
  setQueryDefaults(e, n) {
    K(this, w0).set($1(e), {
      queryKey: e,
      defaultOptions: n
    });
  }
  getQueryDefaults(e) {
    const n = [...K(this, w0).values()];
    let r = {};
    return n.forEach((i) => {
      q1(e, i.queryKey) && (r = { ...r, ...i.defaultOptions });
    }), r;
  }
  setMutationDefaults(e, n) {
    K(this, F0).set($1(e), {
      mutationKey: e,
      defaultOptions: n
    });
  }
  getMutationDefaults(e) {
    const n = [...K(this, F0).values()];
    let r = {};
    return n.forEach((i) => {
      q1(e, i.mutationKey) && (r = { ...r, ...i.defaultOptions });
    }), r;
  }
  defaultQueryOptions(e) {
    if (e != null && e._defaulted)
      return e;
    const n = {
      ...K(this, kl).queries,
      ...(e == null ? void 0 : e.queryKey) && this.getQueryDefaults(e.queryKey),
      ...e,
      _defaulted: !0
    };
    return n.queryHash || (n.queryHash = R3(
      n.queryKey,
      n
    )), typeof n.refetchOnReconnect > "u" && (n.refetchOnReconnect = n.networkMode !== "always"), typeof n.throwOnError > "u" && (n.throwOnError = !!n.suspense), typeof n.networkMode > "u" && n.persister && (n.networkMode = "offlineFirst"), n;
  }
  defaultMutationOptions(e) {
    return e != null && e._defaulted ? e : {
      ...K(this, kl).mutations,
      ...(e == null ? void 0 : e.mutationKey) && this.getMutationDefaults(e.mutationKey),
      ...e,
      _defaulted: !0
    };
  }
  clear() {
    K(this, mr).clear(), K(this, zl).clear();
  }
}, mr = new WeakMap(), zl = new WeakMap(), kl = new WeakMap(), w0 = new WeakMap(), F0 = new WeakMap(), wl = new WeakMap(), v0 = new WeakMap(), I0 = new WeakMap(), lw), yi, kn, O0, Pr, pd, Y0, Vo, mp, Q0, G0, md, Td, Fl, fd, Vd, ON, Tp, oZ, fp, sZ, Vp, lZ, Up, cZ, Rp, dZ, gp, uZ, yp, hZ, M2, PI, cw, E$ = (cw = class extends Cp {
  constructor(n, r) {
    super();
    Fe(this, Vd);
    Fe(this, Tp);
    Fe(this, fp);
    Fe(this, Vp);
    Fe(this, Up);
    Fe(this, Rp);
    Fe(this, gp);
    Fe(this, yp);
    Fe(this, M2);
    Fe(this, yi, void 0);
    Fe(this, kn, void 0);
    Fe(this, O0, void 0);
    Fe(this, Pr, void 0);
    Fe(this, pd, void 0);
    Fe(this, Y0, void 0);
    Fe(this, Vo, void 0);
    Fe(this, mp, void 0);
    Fe(this, Q0, void 0);
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    Fe(this, G0, void 0);
    Fe(this, md, void 0);
    Fe(this, Td, void 0);
    Fe(this, Fl, void 0);
    Fe(this, fd, void 0);
    Ue(this, kn, void 0), Ue(this, O0, void 0), Ue(this, Pr, void 0), Ue(this, fd, /* @__PURE__ */ new Set()), Ue(this, yi, n), this.options = r, Ue(this, Vo, null), this.bindMethods(), this.setOptions(r);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (K(this, kn).addObserver(this), Dj(K(this, kn), this.options) && Yt(this, Vd, ON).call(this), Yt(this, Up, cZ).call(this));
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return NZ(
      K(this, kn),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return NZ(
      K(this, kn),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), Yt(this, Rp, dZ).call(this), Yt(this, gp, uZ).call(this), K(this, kn).removeObserver(this);
  }
  setOptions(n, r) {
    const i = this.options, a = K(this, kn);
    if (this.options = K(this, yi).defaultQueryOptions(n), rZ(i, this.options) || K(this, yi).getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: K(this, kn),
      observer: this
    }), typeof this.options.enabled < "u" && typeof this.options.enabled != "boolean")
      throw new Error("Expected enabled to be a boolean");
    this.options.queryKey || (this.options.queryKey = i.queryKey), Yt(this, yp, hZ).call(this);
    const o = this.hasListeners();
    o && zj(
      K(this, kn),
      a,
      this.options,
      i
    ) && Yt(this, Vd, ON).call(this), this.updateResult(r), o && (K(this, kn) !== a || this.options.enabled !== i.enabled || this.options.staleTime !== i.staleTime) && Yt(this, Tp, oZ).call(this);
    const s = Yt(this, fp, sZ).call(this);
    o && (K(this, kn) !== a || this.options.enabled !== i.enabled || s !== K(this, Fl)) && Yt(this, Vp, lZ).call(this, s);
  }
  getOptimisticResult(n) {
    const r = K(this, yi).getQueryCache().build(K(this, yi), n), i = this.createResult(r, n);
    return x$(this, i) && (Ue(this, Pr, i), Ue(this, Y0, this.options), Ue(this, pd, K(this, kn).state)), i;
  }
  getCurrentResult() {
    return K(this, Pr);
  }
  trackResult(n) {
    const r = {};
    return Object.keys(n).forEach((i) => {
      Object.defineProperty(r, i, {
        configurable: !1,
        enumerable: !0,
        get: () => (K(this, fd).add(i), n[i])
      });
    }), r;
  }
  getCurrentQuery() {
    return K(this, kn);
  }
  refetch({ ...n } = {}) {
    return this.fetch({
      ...n
    });
  }
  fetchOptimistic(n) {
    const r = K(this, yi).defaultQueryOptions(n), i = K(this, yi).getQueryCache().build(K(this, yi), r);
    return i.isFetchingOptimistic = !0, i.fetch().then(() => this.createResult(i, r));
  }
  fetch(n) {
    return Yt(this, Vd, ON).call(this, {
      ...n,
      cancelRefetch: n.cancelRefetch ?? !0
    }).then(() => (this.updateResult(), K(this, Pr)));
  }
  createResult(n, r) {
    var f;
    const i = K(this, kn), a = this.options, o = K(this, Pr), s = K(this, pd), l = K(this, Y0), d = n !== i ? n.state : K(this, O0), { state: u } = n;
    let { error: h, errorUpdatedAt: N, fetchStatus: M, status: p } = u, m = !1, R;
    if (r._optimisticResults) {
      const D = this.hasListeners(), Y = !D && Dj(n, r), Q = D && zj(n, i, r, a);
      (Y || Q) && (M = L2(n.options.networkMode) ? "fetching" : "paused", u.dataUpdatedAt || (p = "pending")), r._optimisticResults === "isRestoring" && (M = "idle");
    }
    if (r.select && typeof u.data < "u")
      if (o && u.data === (s == null ? void 0 : s.data) && r.select === K(this, mp))
        R = K(this, Q0);
      else
        try {
          Ue(this, mp, r.select), R = r.select(u.data), R = aZ(o == null ? void 0 : o.data, R, r), Ue(this, Q0, R), Ue(this, Vo, null);
        } catch (D) {
          Ue(this, Vo, D);
        }
    else
      R = u.data;
    if (typeof r.placeholderData < "u" && typeof R > "u" && p === "pending") {
      let D;
      if (o != null && o.isPlaceholderData && r.placeholderData === (l == null ? void 0 : l.placeholderData))
        D = o.data;
      else if (D = typeof r.placeholderData == "function" ? r.placeholderData(
        (f = K(this, G0)) == null ? void 0 : f.state.data,
        K(this, G0)
      ) : r.placeholderData, r.select && typeof D < "u")
        try {
          D = r.select(D), Ue(this, Vo, null);
        } catch (Y) {
          Ue(this, Vo, Y);
        }
      typeof D < "u" && (p = "success", R = aZ(
        o == null ? void 0 : o.data,
        D,
        r
      ), m = !0);
    }
    K(this, Vo) && (h = K(this, Vo), R = K(this, Q0), N = Date.now(), p = "error");
    const V = M === "fetching", U = p === "pending", g = p === "error", y = U && V;
    return {
      status: p,
      fetchStatus: M,
      isPending: U,
      isSuccess: p === "success",
      isError: g,
      isInitialLoading: y,
      isLoading: y,
      data: R,
      dataUpdatedAt: u.dataUpdatedAt,
      error: h,
      errorUpdatedAt: N,
      failureCount: u.fetchFailureCount,
      failureReason: u.fetchFailureReason,
      errorUpdateCount: u.errorUpdateCount,
      isFetched: u.dataUpdateCount > 0 || u.errorUpdateCount > 0,
      isFetchedAfterMount: u.dataUpdateCount > d.dataUpdateCount || u.errorUpdateCount > d.errorUpdateCount,
      isFetching: V,
      isRefetching: V && !U,
      isLoadingError: g && u.dataUpdatedAt === 0,
      isPaused: M === "paused",
      isPlaceholderData: m,
      isRefetchError: g && u.dataUpdatedAt !== 0,
      isStale: g3(n, r),
      refetch: this.refetch
    };
  }
  updateResult(n) {
    const r = K(this, Pr), i = this.createResult(K(this, kn), this.options);
    if (Ue(this, pd, K(this, kn).state), Ue(this, Y0, this.options), rZ(i, r))
      return;
    K(this, pd).data !== void 0 && Ue(this, G0, K(this, kn)), Ue(this, Pr, i);
    const a = {}, o = () => {
      if (!r)
        return !0;
      const { notifyOnChangeProps: s } = this.options, l = typeof s == "function" ? s() : s;
      if (l === "all" || !l && !K(this, fd).size)
        return !0;
      const c = new Set(
        l ?? K(this, fd)
      );
      return this.options.throwOnError && c.add("error"), Object.keys(K(this, Pr)).some((d) => {
        const u = d;
        return K(this, Pr)[u] !== r[u] && c.has(u);
      });
    };
    (n == null ? void 0 : n.listeners) !== !1 && o() && (a.listeners = !0), Yt(this, M2, PI).call(this, { ...a, ...n });
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && Yt(this, Up, cZ).call(this);
  }
}, yi = new WeakMap(), kn = new WeakMap(), O0 = new WeakMap(), Pr = new WeakMap(), pd = new WeakMap(), Y0 = new WeakMap(), Vo = new WeakMap(), mp = new WeakMap(), Q0 = new WeakMap(), G0 = new WeakMap(), md = new WeakMap(), Td = new WeakMap(), Fl = new WeakMap(), fd = new WeakMap(), Vd = new WeakSet(), ON = function(n) {
  Yt(this, yp, hZ).call(this);
  let r = K(this, kn).fetch(
    this.options,
    n
  );
  return n != null && n.throwOnError || (r = r.catch(Ua)), r;
}, Tp = new WeakSet(), oZ = function() {
  if (Yt(this, Rp, dZ).call(this), q0 || K(this, Pr).isStale || !nZ(this.options.staleTime))
    return;
  const r = JI(
    K(this, Pr).dataUpdatedAt,
    this.options.staleTime
  ) + 1;
  Ue(this, md, setTimeout(() => {
    K(this, Pr).isStale || this.updateResult();
  }, r));
}, fp = new WeakSet(), sZ = function() {
  return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(K(this, kn)) : this.options.refetchInterval) ?? !1;
}, Vp = new WeakSet(), lZ = function(n) {
  Yt(this, gp, uZ).call(this), Ue(this, Fl, n), !(q0 || this.options.enabled === !1 || !nZ(K(this, Fl)) || K(this, Fl) === 0) && Ue(this, Td, setInterval(() => {
    (this.options.refetchIntervalInBackground || eM.isFocused()) && Yt(this, Vd, ON).call(this);
  }, K(this, Fl)));
}, Up = new WeakSet(), cZ = function() {
  Yt(this, Tp, oZ).call(this), Yt(this, Vp, lZ).call(this, Yt(this, fp, sZ).call(this));
}, Rp = new WeakSet(), dZ = function() {
  K(this, md) && (clearTimeout(K(this, md)), Ue(this, md, void 0));
}, gp = new WeakSet(), uZ = function() {
  K(this, Td) && (clearInterval(K(this, Td)), Ue(this, Td, void 0));
}, yp = new WeakSet(), hZ = function() {
  const n = K(this, yi).getQueryCache().build(K(this, yi), this.options);
  if (n === K(this, kn))
    return;
  const r = K(this, kn);
  Ue(this, kn, n), Ue(this, O0, n.state), this.hasListeners() && (r == null || r.removeObserver(this), n.addObserver(this));
}, M2 = new WeakSet(), PI = function(n) {
  Yr.batch(() => {
    n.listeners && this.listeners.forEach((r) => {
      r(K(this, Pr));
    }), K(this, yi).getQueryCache().notify({
      query: K(this, kn),
      type: "observerResultsUpdated"
    });
  });
}, cw);
function S$(t, e) {
  return e.enabled !== !1 && !t.state.dataUpdatedAt && !(t.state.status === "error" && e.retryOnMount === !1);
}
function Dj(t, e) {
  return S$(t, e) || t.state.dataUpdatedAt > 0 && NZ(t, e, e.refetchOnMount);
}
function NZ(t, e, n) {
  if (e.enabled !== !1) {
    const r = typeof n == "function" ? n(t) : n;
    return r === "always" || r !== !1 && g3(t, e);
  }
  return !1;
}
function zj(t, e, n, r) {
  return n.enabled !== !1 && (t !== e || r.enabled === !1) && (!n.suspense || t.state.status !== "error") && g3(t, n);
}
function g3(t, e) {
  return t.isStaleByTime(e.staleTime);
}
function x$(t, e) {
  return !rZ(t.getCurrentResult(), e);
}
var KI = H.createContext(
  void 0
), $I = (t) => {
  const e = H.useContext(KI);
  if (t)
    return t;
  if (!e)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return e;
}, W$ = ({
  client: t,
  children: e
}) => (H.useEffect(() => (t.mount(), () => {
  t.unmount();
}), [t]), /* @__PURE__ */ H.createElement(KI.Provider, { value: t }, e)), qI = H.createContext(!1), j$ = () => H.useContext(qI);
qI.Provider;
function D$() {
  let t = !1;
  return {
    clearReset: () => {
      t = !1;
    },
    reset: () => {
      t = !0;
    },
    isReset: () => t
  };
}
var z$ = H.createContext(D$()), k$ = () => H.useContext(z$);
function w$(t, e) {
  return typeof t == "function" ? t(...e) : !!t;
}
var F$ = (t, e) => {
  (t.suspense || t.throwOnError) && (e.isReset() || (t.retryOnMount = !1));
}, v$ = (t) => {
  H.useEffect(() => {
    t.clearReset();
  }, [t]);
}, I$ = ({
  result: t,
  errorResetBoundary: e,
  throwOnError: n,
  query: r
}) => t.isError && !e.isReset() && !t.isFetching && w$(n, [t.error, r]), O$ = (t) => {
  t.suspense && typeof t.staleTime != "number" && (t.staleTime = 1e3);
}, Y$ = (t, e) => t.isLoading && t.isFetching && !e, Q$ = (t, e, n) => (t == null ? void 0 : t.suspense) && Y$(e, n), G$ = (t, e, n) => e.fetchOptimistic(t).catch(() => {
  n.clearReset();
});
function C$(t, e, n) {
  const r = $I(n), i = j$(), a = k$(), o = r.defaultQueryOptions(t);
  o._optimisticResults = i ? "isRestoring" : "optimistic", O$(o), F$(o, a), v$(a);
  const [s] = H.useState(
    () => new e(
      r,
      o
    )
  ), l = s.getOptimisticResult(o);
  if (H.useSyncExternalStore(
    H.useCallback(
      (c) => {
        const d = i ? () => {
        } : s.subscribe(Yr.batchCalls(c));
        return s.updateResult(), d;
      },
      [s, i]
    ),
    () => s.getCurrentResult(),
    () => s.getCurrentResult()
  ), H.useEffect(() => {
    s.setOptions(o, { listeners: !1 });
  }, [o, s]), Q$(o, l, i))
    throw G$(o, s, a);
  if (I$({
    result: l,
    errorResetBoundary: a,
    throwOnError: o.throwOnError,
    query: s.getCurrentQuery()
  }))
    throw l.error;
  return o.notifyOnChangeProps ? l : s.trackResult(l);
}
function Ff(t, e) {
  return C$(t, E$, e);
}
const eO = Wt({});
function L$({ children: t }) {
  const n = {
    routerQuoteQuery: J$()
  };
  return /* @__PURE__ */ E.jsx(eO.Provider, { value: n, children: t });
}
function J$() {
  const { routerApi: t, defaultAffiliate: e } = Xp(), { referrer: n, commissionRate: r } = Lo(), {
    debounceFromAmount: i,
    inputToken: a,
    outputToken: o,
    slippage: s,
    slippageError: l
  } = Br(), c = i === "" || !!l || a.isFakeToken || o.isFakeToken;
  return Ff({
    queryKey: [
      "router-quote",
      a,
      o,
      i,
      s
    ],
    queryFn: () => CK({
      routerApi: t,
      src_chain_id: parseInt(a.chainId),
      src_quote_token_address: a.address,
      src_quote_token_amount: i,
      dst_chain_id: parseInt(o.chainId),
      dst_quote_token_address: o.address,
      slippage: parseInt(s),
      affiliate: n ?? e,
      commission_rate: r
    }),
    refetchInterval: Py,
    enabled: !c
  });
}
function aa() {
  var x;
  const { routerQuoteQuery: t } = lt(eO), {
    data: e,
    dataUpdatedAt: n,
    isLoading: r,
    isError: i,
    isFetching: a,
    isStale: o,
    refetch: s,
    error: l
  } = t || {}, c = s, { selectedRouteIdx: d } = Br(), u = e == null ? void 0 : e.routes, h = (x = e == null ? void 0 : e.routes) != null && x[d] ? e.routes[d] : null, N = !!(e && e.success), M = e == null ? void 0 : e.error_code, p = e == null ? void 0 : e.error_msg, m = M ? EI.getErrorMessageDisplayFromErrorCode(M) : null, R = h ? qi(
    BigInt(h.dst_quote_token_amount),
    h.dst_quote_token.decimals
  ) : null, V = h ? h.src_chain_id === h.dst_chain_id : !1, U = h ? h.src_chain_id !== h.dst_chain_id : !1, g = m ? new Error(m) : null;
  return {
    data: e,
    dataUpdatedAt: n,
    isLoading: r,
    isError: i,
    isFetching: a,
    isStale: o,
    refetch: c,
    isSuccess: N,
    errorMessage: p,
    error: l,
    errors: [l, g],
    selectedRoute: h,
    formatedSelectedRouteTokenNumber: R,
    isSingleChain: V,
    isCrossChain: U,
    errorCode: M,
    routes: u
  };
}
function B$({
  storage: t,
  key: e = "REACT_QUERY_OFFLINE_CACHE",
  throttleTime: n = 1e3,
  serialize: r = JSON.stringify,
  deserialize: i = JSON.parse,
  retry: a
}) {
  if (t) {
    const o = (s) => {
      try {
        t.setItem(e, r(s));
        return;
      } catch (l) {
        return l;
      }
    };
    return {
      persistClient: A$((s) => {
        let l = s, c = o(l), d = 0;
        for (; c && l; )
          d++, l = a == null ? void 0 : a({
            persistedClient: l,
            error: c,
            errorCount: d
          }), l && (c = o(l));
      }, n),
      restoreClient: () => {
        const s = t.getItem(e);
        if (s)
          return i(s);
      },
      removeClient: () => {
        t.removeItem(e);
      }
    };
  }
  return {
    persistClient: kj,
    restoreClient: () => {
    },
    removeClient: kj
  };
}
function A$(t, e = 100) {
  let n = null, r;
  return function(...i) {
    r = i, n === null && (n = setTimeout(() => {
      t(...r), n = null;
    }, e));
  };
}
function kj() {
}
class $h {
  constructor() {
    this.listeners = [], this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    return this.listeners.push(e), this.onSubscribe(), () => {
      this.listeners = this.listeners.filter((n) => n !== e), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.length > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}
const nM = typeof window > "u" || "Deno" in window;
function Ra() {
}
function H$(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function MZ(t) {
  return typeof t == "number" && t >= 0 && t !== 1 / 0;
}
function tO(t, e) {
  return Math.max(t + (e || 0) - Date.now(), 0);
}
function Km(t, e, n) {
  return Lp(t) ? typeof e == "function" ? {
    ...n,
    queryKey: t,
    queryFn: e
  } : {
    ...e,
    queryKey: t
  } : t;
}
function nO(t, e, n) {
  return Lp(t) ? typeof e == "function" ? {
    ...n,
    mutationKey: t,
    mutationFn: e
  } : {
    ...e,
    mutationKey: t
  } : typeof t == "function" ? {
    ...e,
    mutationFn: t
  } : {
    ...t
  };
}
function Tl(t, e, n) {
  return Lp(t) ? [{
    ...e,
    queryKey: t
  }, n] : [t || {}, e];
}
function wj(t, e) {
  const {
    type: n = "all",
    exact: r,
    fetchStatus: i,
    predicate: a,
    queryKey: o,
    stale: s
  } = t;
  if (Lp(o)) {
    if (r) {
      if (e.queryHash !== y3(o, e.options))
        return !1;
    } else if (!Pu(e.queryKey, o))
      return !1;
  }
  if (n !== "all") {
    const l = e.isActive();
    if (n === "active" && !l || n === "inactive" && l)
      return !1;
  }
  return !(typeof s == "boolean" && e.isStale() !== s || typeof i < "u" && i !== e.state.fetchStatus || a && !a(e));
}
function Fj(t, e) {
  const {
    exact: n,
    fetching: r,
    predicate: i,
    mutationKey: a
  } = t;
  if (Lp(a)) {
    if (!e.options.mutationKey)
      return !1;
    if (n) {
      if (ad(e.options.mutationKey) !== ad(a))
        return !1;
    } else if (!Pu(e.options.mutationKey, a))
      return !1;
  }
  return !(typeof r == "boolean" && e.state.status === "loading" !== r || i && !i(e));
}
function y3(t, e) {
  return ((e == null ? void 0 : e.queryKeyHashFn) || ad)(t);
}
function ad(t) {
  return JSON.stringify(t, (e, n) => mZ(n) ? Object.keys(n).sort().reduce((r, i) => (r[i] = n[i], r), {}) : n);
}
function Pu(t, e) {
  return rO(t, e);
}
function rO(t, e) {
  return t === e ? !0 : typeof t != typeof e ? !1 : t && e && typeof t == "object" && typeof e == "object" ? !Object.keys(e).some((n) => !rO(t[n], e[n])) : !1;
}
function Z3(t, e) {
  if (t === e)
    return t;
  const n = vj(t) && vj(e);
  if (n || mZ(t) && mZ(e)) {
    const r = n ? t.length : Object.keys(t).length, i = n ? e : Object.keys(e), a = i.length, o = n ? [] : {};
    let s = 0;
    for (let l = 0; l < a; l++) {
      const c = n ? l : i[l];
      o[c] = Z3(t[c], e[c]), o[c] === t[c] && s++;
    }
    return r === a && s === r ? t : o;
  }
  return e;
}
function pZ(t, e) {
  if (t && !e || e && !t)
    return !1;
  for (const n in t)
    if (t[n] !== e[n])
      return !1;
  return !0;
}
function vj(t) {
  return Array.isArray(t) && t.length === Object.keys(t).length;
}
function mZ(t) {
  if (!Ij(t))
    return !1;
  const e = t.constructor;
  if (typeof e > "u")
    return !0;
  const n = e.prototype;
  return !(!Ij(n) || !n.hasOwnProperty("isPrototypeOf"));
}
function Ij(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function Lp(t) {
  return Array.isArray(t);
}
function iO(t) {
  return new Promise((e) => {
    setTimeout(e, t);
  });
}
function Oj(t) {
  iO(0).then(t);
}
function X$() {
  if (typeof AbortController == "function")
    return new AbortController();
}
function TZ(t, e, n) {
  return n.isDataEqual != null && n.isDataEqual(t, e) ? t : typeof n.structuralSharing == "function" ? n.structuralSharing(t, e) : n.structuralSharing !== !1 ? Z3(t, e) : e;
}
class _$ extends $h {
  constructor() {
    super(), this.setup = (e) => {
      if (!nM && window.addEventListener) {
        const n = () => e();
        return window.addEventListener("visibilitychange", n, !1), window.addEventListener("focus", n, !1), () => {
          window.removeEventListener("visibilitychange", n), window.removeEventListener("focus", n);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var e;
      (e = this.cleanup) == null || e.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(e) {
    var n;
    this.setup = e, (n = this.cleanup) == null || n.call(this), this.cleanup = e((r) => {
      typeof r == "boolean" ? this.setFocused(r) : this.onFocus();
    });
  }
  setFocused(e) {
    this.focused = e, e && this.onFocus();
  }
  onFocus() {
    this.listeners.forEach((e) => {
      e();
    });
  }
  isFocused() {
    return typeof this.focused == "boolean" ? this.focused : typeof document > "u" ? !0 : [void 0, "visible", "prerender"].includes(document.visibilityState);
  }
}
const vf = new _$();
class P$ extends $h {
  constructor() {
    super(), this.setup = (e) => {
      if (!nM && window.addEventListener) {
        const n = () => e();
        return window.addEventListener("online", n, !1), window.addEventListener("offline", n, !1), () => {
          window.removeEventListener("online", n), window.removeEventListener("offline", n);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var e;
      (e = this.cleanup) == null || e.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(e) {
    var n;
    this.setup = e, (n = this.cleanup) == null || n.call(this), this.cleanup = e((r) => {
      typeof r == "boolean" ? this.setOnline(r) : this.onOnline();
    });
  }
  setOnline(e) {
    this.online = e, e && this.onOnline();
  }
  onOnline() {
    this.listeners.forEach((e) => {
      e();
    });
  }
  isOnline() {
    return typeof this.online == "boolean" ? this.online : typeof navigator > "u" || typeof navigator.onLine > "u" ? !0 : navigator.onLine;
  }
}
const If = new P$();
function K$(t) {
  return Math.min(1e3 * 2 ** t, 3e4);
}
function J2(t) {
  return (t ?? "online") === "online" ? If.isOnline() : !0;
}
class aO {
  constructor(e) {
    this.revert = e == null ? void 0 : e.revert, this.silent = e == null ? void 0 : e.silent;
  }
}
function OT(t) {
  return t instanceof aO;
}
function oO(t) {
  let e = !1, n = 0, r = !1, i, a, o;
  const s = new Promise((m, R) => {
    a = m, o = R;
  }), l = (m) => {
    r || (N(new aO(m)), t.abort == null || t.abort());
  }, c = () => {
    e = !0;
  }, d = () => {
    e = !1;
  }, u = () => !vf.isFocused() || t.networkMode !== "always" && !If.isOnline(), h = (m) => {
    r || (r = !0, t.onSuccess == null || t.onSuccess(m), i == null || i(), a(m));
  }, N = (m) => {
    r || (r = !0, t.onError == null || t.onError(m), i == null || i(), o(m));
  }, M = () => new Promise((m) => {
    i = (R) => {
      const V = r || !u();
      return V && m(R), V;
    }, t.onPause == null || t.onPause();
  }).then(() => {
    i = void 0, r || t.onContinue == null || t.onContinue();
  }), p = () => {
    if (r)
      return;
    let m;
    try {
      m = t.fn();
    } catch (R) {
      m = Promise.reject(R);
    }
    Promise.resolve(m).then(h).catch((R) => {
      var V, U;
      if (r)
        return;
      const g = (V = t.retry) != null ? V : 3, y = (U = t.retryDelay) != null ? U : K$, x = typeof y == "function" ? y(n, R) : y, f = g === !0 || typeof g == "number" && n < g || typeof g == "function" && g(n, R);
      if (e || !f) {
        N(R);
        return;
      }
      n++, t.onFail == null || t.onFail(n, R), iO(x).then(() => {
        if (u())
          return M();
      }).then(() => {
        e ? N(R) : p();
      });
    });
  };
  return J2(t.networkMode) ? p() : M().then(p), {
    promise: s,
    cancel: l,
    continue: () => (i == null ? void 0 : i()) ? s : Promise.resolve(),
    cancelRetry: c,
    continueRetry: d
  };
}
const b3 = console;
function $$() {
  let t = [], e = 0, n = (d) => {
    d();
  }, r = (d) => {
    d();
  };
  const i = (d) => {
    let u;
    e++;
    try {
      u = d();
    } finally {
      e--, e || s();
    }
    return u;
  }, a = (d) => {
    e ? t.push(d) : Oj(() => {
      n(d);
    });
  }, o = (d) => (...u) => {
    a(() => {
      d(...u);
    });
  }, s = () => {
    const d = t;
    t = [], d.length && Oj(() => {
      r(() => {
        d.forEach((u) => {
          n(u);
        });
      });
    });
  };
  return {
    batch: i,
    batchCalls: o,
    schedule: a,
    setNotifyFunction: (d) => {
      n = d;
    },
    setBatchNotifyFunction: (d) => {
      r = d;
    }
  };
}
const tr = $$();
class sO {
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), MZ(this.cacheTime) && (this.gcTimeout = setTimeout(() => {
      this.optionalRemove();
    }, this.cacheTime));
  }
  updateCacheTime(e) {
    this.cacheTime = Math.max(this.cacheTime || 0, e ?? (nM ? 1 / 0 : 5 * 60 * 1e3));
  }
  clearGcTimeout() {
    this.gcTimeout && (clearTimeout(this.gcTimeout), this.gcTimeout = void 0);
  }
}
class q$ extends sO {
  constructor(e) {
    super(), this.abortSignalConsumed = !1, this.defaultOptions = e.defaultOptions, this.setOptions(e.options), this.observers = [], this.cache = e.cache, this.logger = e.logger || b3, this.queryKey = e.queryKey, this.queryHash = e.queryHash, this.initialState = e.state || eq(this.options), this.state = this.initialState, this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  setOptions(e) {
    this.options = {
      ...this.defaultOptions,
      ...e
    }, this.updateCacheTime(this.options.cacheTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && this.cache.remove(this);
  }
  setData(e, n) {
    const r = TZ(this.state.data, e, this.options);
    return this.dispatch({
      data: r,
      type: "success",
      dataUpdatedAt: n == null ? void 0 : n.updatedAt,
      manual: n == null ? void 0 : n.manual
    }), r;
  }
  setState(e, n) {
    this.dispatch({
      type: "setState",
      state: e,
      setStateOptions: n
    });
  }
  cancel(e) {
    var n;
    const r = this.promise;
    return (n = this.retryer) == null || n.cancel(e), r ? r.then(Ra).catch(Ra) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({
      silent: !0
    });
  }
  reset() {
    this.destroy(), this.setState(this.initialState);
  }
  isActive() {
    return this.observers.some((e) => e.options.enabled !== !1);
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((e) => e.getCurrentResult().isStale);
  }
  isStaleByTime(e = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !tO(this.state.dataUpdatedAt, e);
  }
  onFocus() {
    var e;
    const n = this.observers.find((r) => r.shouldFetchOnWindowFocus());
    n && n.refetch({
      cancelRefetch: !1
    }), (e = this.retryer) == null || e.continue();
  }
  onOnline() {
    var e;
    const n = this.observers.find((r) => r.shouldFetchOnReconnect());
    n && n.refetch({
      cancelRefetch: !1
    }), (e = this.retryer) == null || e.continue();
  }
  addObserver(e) {
    this.observers.indexOf(e) === -1 && (this.observers.push(e), this.clearGcTimeout(), this.cache.notify({
      type: "observerAdded",
      query: this,
      observer: e
    }));
  }
  removeObserver(e) {
    this.observers.indexOf(e) !== -1 && (this.observers = this.observers.filter((n) => n !== e), this.observers.length || (this.retryer && (this.abortSignalConsumed ? this.retryer.cancel({
      revert: !0
    }) : this.retryer.cancelRetry()), this.scheduleGc()), this.cache.notify({
      type: "observerRemoved",
      query: this,
      observer: e
    }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || this.dispatch({
      type: "invalidate"
    });
  }
  fetch(e, n) {
    var r, i;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.dataUpdatedAt && n != null && n.cancelRefetch)
        this.cancel({
          silent: !0
        });
      else if (this.promise) {
        var a;
        return (a = this.retryer) == null || a.continueRetry(), this.promise;
      }
    }
    if (e && this.setOptions(e), !this.options.queryFn) {
      const N = this.observers.find((M) => M.options.queryFn);
      N && this.setOptions(N.options);
    }
    Array.isArray(this.options.queryKey) || ue.env.NODE_ENV !== "production" && this.logger.error("As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']");
    const o = X$(), s = {
      queryKey: this.queryKey,
      pageParam: void 0,
      meta: this.meta
    }, l = (N) => {
      Object.defineProperty(N, "signal", {
        enumerable: !0,
        get: () => {
          if (o)
            return this.abortSignalConsumed = !0, o.signal;
        }
      });
    };
    l(s);
    const c = () => this.options.queryFn ? (this.abortSignalConsumed = !1, this.options.queryFn(s)) : Promise.reject("Missing queryFn"), d = {
      fetchOptions: n,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: c
    };
    if (l(d), (r = this.options.behavior) == null || r.onFetch(d), this.revertState = this.state, this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((i = d.fetchOptions) == null ? void 0 : i.meta)) {
      var u;
      this.dispatch({
        type: "fetch",
        meta: (u = d.fetchOptions) == null ? void 0 : u.meta
      });
    }
    const h = (N) => {
      if (OT(N) && N.silent || this.dispatch({
        type: "error",
        error: N
      }), !OT(N)) {
        var M, p, m, R;
        (M = (p = this.cache.config).onError) == null || M.call(p, N, this), (m = (R = this.cache.config).onSettled) == null || m.call(R, this.state.data, N, this), ue.env.NODE_ENV !== "production" && this.logger.error(N);
      }
      this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return this.retryer = oO({
      fn: d.fetchFn,
      abort: o == null ? void 0 : o.abort.bind(o),
      onSuccess: (N) => {
        var M, p, m, R;
        if (typeof N > "u") {
          ue.env.NODE_ENV !== "production" && this.logger.error("Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: " + this.queryHash), h(new Error("undefined"));
          return;
        }
        this.setData(N), (M = (p = this.cache.config).onSuccess) == null || M.call(p, N, this), (m = (R = this.cache.config).onSettled) == null || m.call(R, N, this.state.error, this), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: h,
      onFail: (N, M) => {
        this.dispatch({
          type: "failed",
          failureCount: N,
          error: M
        });
      },
      onPause: () => {
        this.dispatch({
          type: "pause"
        });
      },
      onContinue: () => {
        this.dispatch({
          type: "continue"
        });
      },
      retry: d.options.retry,
      retryDelay: d.options.retryDelay,
      networkMode: d.options.networkMode
    }), this.promise = this.retryer.promise, this.promise;
  }
  dispatch(e) {
    const n = (r) => {
      var i, a;
      switch (e.type) {
        case "failed":
          return {
            ...r,
            fetchFailureCount: e.failureCount,
            fetchFailureReason: e.error
          };
        case "pause":
          return {
            ...r,
            fetchStatus: "paused"
          };
        case "continue":
          return {
            ...r,
            fetchStatus: "fetching"
          };
        case "fetch":
          return {
            ...r,
            fetchFailureCount: 0,
            fetchFailureReason: null,
            fetchMeta: (i = e.meta) != null ? i : null,
            fetchStatus: J2(this.options.networkMode) ? "fetching" : "paused",
            ...!r.dataUpdatedAt && {
              error: null,
              status: "loading"
            }
          };
        case "success":
          return {
            ...r,
            data: e.data,
            dataUpdateCount: r.dataUpdateCount + 1,
            dataUpdatedAt: (a = e.dataUpdatedAt) != null ? a : Date.now(),
            error: null,
            isInvalidated: !1,
            status: "success",
            ...!e.manual && {
              fetchStatus: "idle",
              fetchFailureCount: 0,
              fetchFailureReason: null
            }
          };
        case "error":
          const o = e.error;
          return OT(o) && o.revert && this.revertState ? {
            ...this.revertState
          } : {
            ...r,
            error: o,
            errorUpdateCount: r.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: r.fetchFailureCount + 1,
            fetchFailureReason: o,
            fetchStatus: "idle",
            status: "error"
          };
        case "invalidate":
          return {
            ...r,
            isInvalidated: !0
          };
        case "setState":
          return {
            ...r,
            ...e.state
          };
      }
    };
    this.state = n(this.state), tr.batch(() => {
      this.observers.forEach((r) => {
        r.onQueryUpdate(e);
      }), this.cache.notify({
        query: this,
        type: "updated",
        action: e
      });
    });
  }
}
function eq(t) {
  const e = typeof t.initialData == "function" ? t.initialData() : t.initialData, n = typeof e < "u", r = n ? typeof t.initialDataUpdatedAt == "function" ? t.initialDataUpdatedAt() : t.initialDataUpdatedAt : 0;
  return {
    data: e,
    dataUpdateCount: 0,
    dataUpdatedAt: n ? r ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: n ? "success" : "loading",
    fetchStatus: "idle"
  };
}
class tq extends $h {
  constructor(e) {
    super(), this.config = e || {}, this.queries = [], this.queriesMap = {};
  }
  build(e, n, r) {
    var i;
    const a = n.queryKey, o = (i = n.queryHash) != null ? i : y3(a, n);
    let s = this.get(o);
    return s || (s = new q$({
      cache: this,
      logger: e.getLogger(),
      queryKey: a,
      queryHash: o,
      options: e.defaultQueryOptions(n),
      state: r,
      defaultOptions: e.getQueryDefaults(a)
    }), this.add(s)), s;
  }
  add(e) {
    this.queriesMap[e.queryHash] || (this.queriesMap[e.queryHash] = e, this.queries.push(e), this.notify({
      type: "added",
      query: e
    }));
  }
  remove(e) {
    const n = this.queriesMap[e.queryHash];
    n && (e.destroy(), this.queries = this.queries.filter((r) => r !== e), n === e && delete this.queriesMap[e.queryHash], this.notify({
      type: "removed",
      query: e
    }));
  }
  clear() {
    tr.batch(() => {
      this.queries.forEach((e) => {
        this.remove(e);
      });
    });
  }
  get(e) {
    return this.queriesMap[e];
  }
  getAll() {
    return this.queries;
  }
  find(e, n) {
    const [r] = Tl(e, n);
    return typeof r.exact > "u" && (r.exact = !0), this.queries.find((i) => wj(r, i));
  }
  findAll(e, n) {
    const [r] = Tl(e, n);
    return Object.keys(r).length > 0 ? this.queries.filter((i) => wj(r, i)) : this.queries;
  }
  notify(e) {
    tr.batch(() => {
      this.listeners.forEach((n) => {
        n(e);
      });
    });
  }
  onFocus() {
    tr.batch(() => {
      this.queries.forEach((e) => {
        e.onFocus();
      });
    });
  }
  onOnline() {
    tr.batch(() => {
      this.queries.forEach((e) => {
        e.onOnline();
      });
    });
  }
}
class nq extends sO {
  constructor(e) {
    super(), this.defaultOptions = e.defaultOptions, this.mutationId = e.mutationId, this.mutationCache = e.mutationCache, this.logger = e.logger || b3, this.observers = [], this.state = e.state || lO(), this.setOptions(e.options), this.scheduleGc();
  }
  setOptions(e) {
    this.options = {
      ...this.defaultOptions,
      ...e
    }, this.updateCacheTime(this.options.cacheTime);
  }
  get meta() {
    return this.options.meta;
  }
  setState(e) {
    this.dispatch({
      type: "setState",
      state: e
    });
  }
  addObserver(e) {
    this.observers.indexOf(e) === -1 && (this.observers.push(e), this.clearGcTimeout(), this.mutationCache.notify({
      type: "observerAdded",
      mutation: this,
      observer: e
    }));
  }
  removeObserver(e) {
    this.observers = this.observers.filter((n) => n !== e), this.scheduleGc(), this.mutationCache.notify({
      type: "observerRemoved",
      mutation: this,
      observer: e
    });
  }
  optionalRemove() {
    this.observers.length || (this.state.status === "loading" ? this.scheduleGc() : this.mutationCache.remove(this));
  }
  continue() {
    var e, n;
    return (e = (n = this.retryer) == null ? void 0 : n.continue()) != null ? e : this.execute();
  }
  async execute() {
    const e = () => {
      var f;
      return this.retryer = oO({
        fn: () => this.options.mutationFn ? this.options.mutationFn(this.state.variables) : Promise.reject("No mutationFn found"),
        onFail: (D, Y) => {
          this.dispatch({
            type: "failed",
            failureCount: D,
            error: Y
          });
        },
        onPause: () => {
          this.dispatch({
            type: "pause"
          });
        },
        onContinue: () => {
          this.dispatch({
            type: "continue"
          });
        },
        retry: (f = this.options.retry) != null ? f : 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode
      }), this.retryer.promise;
    }, n = this.state.status === "loading";
    try {
      var r, i, a, o, s, l, c, d;
      if (!n) {
        var u, h, N, M;
        this.dispatch({
          type: "loading",
          variables: this.options.variables
        }), await ((u = (h = this.mutationCache.config).onMutate) == null ? void 0 : u.call(h, this.state.variables, this));
        const D = await ((N = (M = this.options).onMutate) == null ? void 0 : N.call(M, this.state.variables));
        D !== this.state.context && this.dispatch({
          type: "loading",
          context: D,
          variables: this.state.variables
        });
      }
      const f = await e();
      return await ((r = (i = this.mutationCache.config).onSuccess) == null ? void 0 : r.call(i, f, this.state.variables, this.state.context, this)), await ((a = (o = this.options).onSuccess) == null ? void 0 : a.call(o, f, this.state.variables, this.state.context)), await ((s = (l = this.mutationCache.config).onSettled) == null ? void 0 : s.call(l, f, null, this.state.variables, this.state.context, this)), await ((c = (d = this.options).onSettled) == null ? void 0 : c.call(d, f, null, this.state.variables, this.state.context)), this.dispatch({
        type: "success",
        data: f
      }), f;
    } catch (f) {
      try {
        var p, m, R, V, U, g, y, x;
        throw await ((p = (m = this.mutationCache.config).onError) == null ? void 0 : p.call(m, f, this.state.variables, this.state.context, this)), ue.env.NODE_ENV !== "production" && this.logger.error(f), await ((R = (V = this.options).onError) == null ? void 0 : R.call(V, f, this.state.variables, this.state.context)), await ((U = (g = this.mutationCache.config).onSettled) == null ? void 0 : U.call(g, void 0, f, this.state.variables, this.state.context, this)), await ((y = (x = this.options).onSettled) == null ? void 0 : y.call(x, void 0, f, this.state.variables, this.state.context)), f;
      } finally {
        this.dispatch({
          type: "error",
          error: f
        });
      }
    }
  }
  dispatch(e) {
    const n = (r) => {
      switch (e.type) {
        case "failed":
          return {
            ...r,
            failureCount: e.failureCount,
            failureReason: e.error
          };
        case "pause":
          return {
            ...r,
            isPaused: !0
          };
        case "continue":
          return {
            ...r,
            isPaused: !1
          };
        case "loading":
          return {
            ...r,
            context: e.context,
            data: void 0,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: !J2(this.options.networkMode),
            status: "loading",
            variables: e.variables
          };
        case "success":
          return {
            ...r,
            data: e.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: "success",
            isPaused: !1
          };
        case "error":
          return {
            ...r,
            data: void 0,
            error: e.error,
            failureCount: r.failureCount + 1,
            failureReason: e.error,
            isPaused: !1,
            status: "error"
          };
        case "setState":
          return {
            ...r,
            ...e.state
          };
      }
    };
    this.state = n(this.state), tr.batch(() => {
      this.observers.forEach((r) => {
        r.onMutationUpdate(e);
      }), this.mutationCache.notify({
        mutation: this,
        type: "updated",
        action: e
      });
    });
  }
}
function lO() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0
  };
}
class rq extends $h {
  constructor(e) {
    super(), this.config = e || {}, this.mutations = [], this.mutationId = 0;
  }
  build(e, n, r) {
    const i = new nq({
      mutationCache: this,
      logger: e.getLogger(),
      mutationId: ++this.mutationId,
      options: e.defaultMutationOptions(n),
      state: r,
      defaultOptions: n.mutationKey ? e.getMutationDefaults(n.mutationKey) : void 0
    });
    return this.add(i), i;
  }
  add(e) {
    this.mutations.push(e), this.notify({
      type: "added",
      mutation: e
    });
  }
  remove(e) {
    this.mutations = this.mutations.filter((n) => n !== e), this.notify({
      type: "removed",
      mutation: e
    });
  }
  clear() {
    tr.batch(() => {
      this.mutations.forEach((e) => {
        this.remove(e);
      });
    });
  }
  getAll() {
    return this.mutations;
  }
  find(e) {
    return typeof e.exact > "u" && (e.exact = !0), this.mutations.find((n) => Fj(e, n));
  }
  findAll(e) {
    return this.mutations.filter((n) => Fj(e, n));
  }
  notify(e) {
    tr.batch(() => {
      this.listeners.forEach((n) => {
        n(e);
      });
    });
  }
  resumePausedMutations() {
    var e;
    return this.resuming = ((e = this.resuming) != null ? e : Promise.resolve()).then(() => {
      const n = this.mutations.filter((r) => r.state.isPaused);
      return tr.batch(() => n.reduce((r, i) => r.then(() => i.continue().catch(Ra)), Promise.resolve()));
    }).then(() => {
      this.resuming = void 0;
    }), this.resuming;
  }
}
function iq() {
  return {
    onFetch: (t) => {
      t.fetchFn = () => {
        var e, n, r, i, a, o;
        const s = (e = t.fetchOptions) == null || (n = e.meta) == null ? void 0 : n.refetchPage, l = (r = t.fetchOptions) == null || (i = r.meta) == null ? void 0 : i.fetchMore, c = l == null ? void 0 : l.pageParam, d = (l == null ? void 0 : l.direction) === "forward", u = (l == null ? void 0 : l.direction) === "backward", h = ((a = t.state.data) == null ? void 0 : a.pages) || [], N = ((o = t.state.data) == null ? void 0 : o.pageParams) || [];
        let M = N, p = !1;
        const m = (x) => {
          Object.defineProperty(x, "signal", {
            enumerable: !0,
            get: () => {
              var f;
              if ((f = t.signal) != null && f.aborted)
                p = !0;
              else {
                var D;
                (D = t.signal) == null || D.addEventListener("abort", () => {
                  p = !0;
                });
              }
              return t.signal;
            }
          });
        }, R = t.options.queryFn || (() => Promise.reject("Missing queryFn")), V = (x, f, D, Y) => (M = Y ? [f, ...M] : [...M, f], Y ? [D, ...x] : [...x, D]), U = (x, f, D, Y) => {
          if (p)
            return Promise.reject("Cancelled");
          if (typeof D > "u" && !f && x.length)
            return Promise.resolve(x);
          const Q = {
            queryKey: t.queryKey,
            pageParam: D,
            meta: t.options.meta
          };
          m(Q);
          const G = R(Q);
          return Promise.resolve(G).then((O) => V(x, D, O, Y));
        };
        let g;
        if (!h.length)
          g = U([]);
        else if (d) {
          const x = typeof c < "u", f = x ? c : Yj(t.options, h);
          g = U(h, x, f);
        } else if (u) {
          const x = typeof c < "u", f = x ? c : aq(t.options, h);
          g = U(h, x, f, !0);
        } else {
          M = [];
          const x = typeof t.options.getNextPageParam > "u";
          g = (s && h[0] ? s(h[0], 0, h) : !0) ? U([], x, N[0]) : Promise.resolve(V([], N[0], h[0]));
          for (let D = 1; D < h.length; D++)
            g = g.then((Y) => {
              if (s && h[D] ? s(h[D], D, h) : !0) {
                const G = x ? N[D] : Yj(t.options, Y);
                return U(Y, x, G);
              }
              return Promise.resolve(V(Y, N[D], h[D]));
            });
        }
        return g.then((x) => ({
          pages: x,
          pageParams: M
        }));
      };
    }
  };
}
function Yj(t, e) {
  return t.getNextPageParam == null ? void 0 : t.getNextPageParam(e[e.length - 1], e);
}
function aq(t, e) {
  return t.getPreviousPageParam == null ? void 0 : t.getPreviousPageParam(e[0], e);
}
class oq {
  constructor(e = {}) {
    this.queryCache = e.queryCache || new tq(), this.mutationCache = e.mutationCache || new rq(), this.logger = e.logger || b3, this.defaultOptions = e.defaultOptions || {}, this.queryDefaults = [], this.mutationDefaults = [], this.mountCount = 0, ue.env.NODE_ENV !== "production" && e.logger && this.logger.error("Passing a custom logger has been deprecated and will be removed in the next major version.");
  }
  mount() {
    this.mountCount++, this.mountCount === 1 && (this.unsubscribeFocus = vf.subscribe(() => {
      vf.isFocused() && (this.resumePausedMutations(), this.queryCache.onFocus());
    }), this.unsubscribeOnline = If.subscribe(() => {
      If.isOnline() && (this.resumePausedMutations(), this.queryCache.onOnline());
    }));
  }
  unmount() {
    var e, n;
    this.mountCount--, this.mountCount === 0 && ((e = this.unsubscribeFocus) == null || e.call(this), this.unsubscribeFocus = void 0, (n = this.unsubscribeOnline) == null || n.call(this), this.unsubscribeOnline = void 0);
  }
  isFetching(e, n) {
    const [r] = Tl(e, n);
    return r.fetchStatus = "fetching", this.queryCache.findAll(r).length;
  }
  isMutating(e) {
    return this.mutationCache.findAll({
      ...e,
      fetching: !0
    }).length;
  }
  getQueryData(e, n) {
    var r;
    return (r = this.queryCache.find(e, n)) == null ? void 0 : r.state.data;
  }
  ensureQueryData(e, n, r) {
    const i = Km(e, n, r), a = this.getQueryData(i.queryKey);
    return a ? Promise.resolve(a) : this.fetchQuery(i);
  }
  getQueriesData(e) {
    return this.getQueryCache().findAll(e).map(({
      queryKey: n,
      state: r
    }) => {
      const i = r.data;
      return [n, i];
    });
  }
  setQueryData(e, n, r) {
    const i = this.queryCache.find(e), a = i == null ? void 0 : i.state.data, o = H$(n, a);
    if (typeof o > "u")
      return;
    const s = Km(e), l = this.defaultQueryOptions(s);
    return this.queryCache.build(this, l).setData(o, {
      ...r,
      manual: !0
    });
  }
  setQueriesData(e, n, r) {
    return tr.batch(() => this.getQueryCache().findAll(e).map(({
      queryKey: i
    }) => [i, this.setQueryData(i, n, r)]));
  }
  getQueryState(e, n) {
    var r;
    return (r = this.queryCache.find(e, n)) == null ? void 0 : r.state;
  }
  removeQueries(e, n) {
    const [r] = Tl(e, n), i = this.queryCache;
    tr.batch(() => {
      i.findAll(r).forEach((a) => {
        i.remove(a);
      });
    });
  }
  resetQueries(e, n, r) {
    const [i, a] = Tl(e, n, r), o = this.queryCache, s = {
      type: "active",
      ...i
    };
    return tr.batch(() => (o.findAll(i).forEach((l) => {
      l.reset();
    }), this.refetchQueries(s, a)));
  }
  cancelQueries(e, n, r) {
    const [i, a = {}] = Tl(e, n, r);
    typeof a.revert > "u" && (a.revert = !0);
    const o = tr.batch(() => this.queryCache.findAll(i).map((s) => s.cancel(a)));
    return Promise.all(o).then(Ra).catch(Ra);
  }
  invalidateQueries(e, n, r) {
    const [i, a] = Tl(e, n, r);
    return tr.batch(() => {
      var o, s;
      if (this.queryCache.findAll(i).forEach((c) => {
        c.invalidate();
      }), i.refetchType === "none")
        return Promise.resolve();
      const l = {
        ...i,
        type: (o = (s = i.refetchType) != null ? s : i.type) != null ? o : "active"
      };
      return this.refetchQueries(l, a);
    });
  }
  refetchQueries(e, n, r) {
    const [i, a] = Tl(e, n, r), o = tr.batch(() => this.queryCache.findAll(i).filter((l) => !l.isDisabled()).map((l) => {
      var c;
      return l.fetch(void 0, {
        ...a,
        cancelRefetch: (c = a == null ? void 0 : a.cancelRefetch) != null ? c : !0,
        meta: {
          refetchPage: i.refetchPage
        }
      });
    }));
    let s = Promise.all(o).then(Ra);
    return a != null && a.throwOnError || (s = s.catch(Ra)), s;
  }
  fetchQuery(e, n, r) {
    const i = Km(e, n, r), a = this.defaultQueryOptions(i);
    typeof a.retry > "u" && (a.retry = !1);
    const o = this.queryCache.build(this, a);
    return o.isStaleByTime(a.staleTime) ? o.fetch(a) : Promise.resolve(o.state.data);
  }
  prefetchQuery(e, n, r) {
    return this.fetchQuery(e, n, r).then(Ra).catch(Ra);
  }
  fetchInfiniteQuery(e, n, r) {
    const i = Km(e, n, r);
    return i.behavior = iq(), this.fetchQuery(i);
  }
  prefetchInfiniteQuery(e, n, r) {
    return this.fetchInfiniteQuery(e, n, r).then(Ra).catch(Ra);
  }
  resumePausedMutations() {
    return this.mutationCache.resumePausedMutations();
  }
  getQueryCache() {
    return this.queryCache;
  }
  getMutationCache() {
    return this.mutationCache;
  }
  getLogger() {
    return this.logger;
  }
  getDefaultOptions() {
    return this.defaultOptions;
  }
  setDefaultOptions(e) {
    this.defaultOptions = e;
  }
  setQueryDefaults(e, n) {
    const r = this.queryDefaults.find((i) => ad(e) === ad(i.queryKey));
    r ? r.defaultOptions = n : this.queryDefaults.push({
      queryKey: e,
      defaultOptions: n
    });
  }
  getQueryDefaults(e) {
    if (!e)
      return;
    const n = this.queryDefaults.find((r) => Pu(e, r.queryKey));
    return ue.env.NODE_ENV !== "production" && this.queryDefaults.filter((i) => Pu(e, i.queryKey)).length > 1 && this.logger.error("[QueryClient] Several query defaults match with key '" + JSON.stringify(e) + "'. The first matching query defaults are used. Please check how query defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetquerydefaults."), n == null ? void 0 : n.defaultOptions;
  }
  setMutationDefaults(e, n) {
    const r = this.mutationDefaults.find((i) => ad(e) === ad(i.mutationKey));
    r ? r.defaultOptions = n : this.mutationDefaults.push({
      mutationKey: e,
      defaultOptions: n
    });
  }
  getMutationDefaults(e) {
    if (!e)
      return;
    const n = this.mutationDefaults.find((r) => Pu(e, r.mutationKey));
    return ue.env.NODE_ENV !== "production" && this.mutationDefaults.filter((i) => Pu(e, i.mutationKey)).length > 1 && this.logger.error("[QueryClient] Several mutation defaults match with key '" + JSON.stringify(e) + "'. The first matching mutation defaults are used. Please check how mutation defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetmutationdefaults."), n == null ? void 0 : n.defaultOptions;
  }
  defaultQueryOptions(e) {
    if (e != null && e._defaulted)
      return e;
    const n = {
      ...this.defaultOptions.queries,
      ...this.getQueryDefaults(e == null ? void 0 : e.queryKey),
      ...e,
      _defaulted: !0
    };
    return !n.queryHash && n.queryKey && (n.queryHash = y3(n.queryKey, n)), typeof n.refetchOnReconnect > "u" && (n.refetchOnReconnect = n.networkMode !== "always"), typeof n.useErrorBoundary > "u" && (n.useErrorBoundary = !!n.suspense), n;
  }
  defaultMutationOptions(e) {
    return e != null && e._defaulted ? e : {
      ...this.defaultOptions.mutations,
      ...this.getMutationDefaults(e == null ? void 0 : e.mutationKey),
      ...e,
      _defaulted: !0
    };
  }
  clear() {
    this.queryCache.clear(), this.mutationCache.clear();
  }
}
class sq extends $h {
  constructor(e, n) {
    super(), this.client = e, this.options = n, this.trackedProps = /* @__PURE__ */ new Set(), this.selectError = null, this.bindMethods(), this.setOptions(n);
  }
  bindMethods() {
    this.remove = this.remove.bind(this), this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.length === 1 && (this.currentQuery.addObserver(this), Qj(this.currentQuery, this.options) && this.executeFetch(), this.updateTimers());
  }
  onUnsubscribe() {
    this.listeners.length || this.destroy();
  }
  shouldFetchOnReconnect() {
    return fZ(this.currentQuery, this.options, this.options.refetchOnReconnect);
  }
  shouldFetchOnWindowFocus() {
    return fZ(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  }
  destroy() {
    this.listeners = [], this.clearStaleTimeout(), this.clearRefetchInterval(), this.currentQuery.removeObserver(this);
  }
  setOptions(e, n) {
    const r = this.options, i = this.currentQuery;
    if (this.options = this.client.defaultQueryOptions(e), ue.env.NODE_ENV !== "production" && typeof (e == null ? void 0 : e.isDataEqual) < "u" && this.client.getLogger().error("The isDataEqual option has been deprecated and will be removed in the next major version. You can achieve the same functionality by passing a function as the structuralSharing option"), pZ(r, this.options) || this.client.getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: this.currentQuery,
      observer: this
    }), typeof this.options.enabled < "u" && typeof this.options.enabled != "boolean")
      throw new Error("Expected enabled to be a boolean");
    this.options.queryKey || (this.options.queryKey = r.queryKey), this.updateQuery();
    const a = this.hasListeners();
    a && Gj(this.currentQuery, i, this.options, r) && this.executeFetch(), this.updateResult(n), a && (this.currentQuery !== i || this.options.enabled !== r.enabled || this.options.staleTime !== r.staleTime) && this.updateStaleTimeout();
    const o = this.computeRefetchInterval();
    a && (this.currentQuery !== i || this.options.enabled !== r.enabled || o !== this.currentRefetchInterval) && this.updateRefetchInterval(o);
  }
  getOptimisticResult(e) {
    const n = this.client.getQueryCache().build(this.client, e);
    return this.createResult(n, e);
  }
  getCurrentResult() {
    return this.currentResult;
  }
  trackResult(e) {
    const n = {};
    return Object.keys(e).forEach((r) => {
      Object.defineProperty(n, r, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackedProps.add(r), e[r])
      });
    }), n;
  }
  getCurrentQuery() {
    return this.currentQuery;
  }
  remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  }
  refetch({
    refetchPage: e,
    ...n
  } = {}) {
    return this.fetch({
      ...n,
      meta: {
        refetchPage: e
      }
    });
  }
  fetchOptimistic(e) {
    const n = this.client.defaultQueryOptions(e), r = this.client.getQueryCache().build(this.client, n);
    return r.isFetchingOptimistic = !0, r.fetch().then(() => this.createResult(r, n));
  }
  fetch(e) {
    var n;
    return this.executeFetch({
      ...e,
      cancelRefetch: (n = e.cancelRefetch) != null ? n : !0
    }).then(() => (this.updateResult(), this.currentResult));
  }
  executeFetch(e) {
    this.updateQuery();
    let n = this.currentQuery.fetch(this.options, e);
    return e != null && e.throwOnError || (n = n.catch(Ra)), n;
  }
  updateStaleTimeout() {
    if (this.clearStaleTimeout(), nM || this.currentResult.isStale || !MZ(this.options.staleTime))
      return;
    const n = tO(this.currentResult.dataUpdatedAt, this.options.staleTime) + 1;
    this.staleTimeoutId = setTimeout(() => {
      this.currentResult.isStale || this.updateResult();
    }, n);
  }
  computeRefetchInterval() {
    var e;
    return typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (e = this.options.refetchInterval) != null ? e : !1;
  }
  updateRefetchInterval(e) {
    this.clearRefetchInterval(), this.currentRefetchInterval = e, !(nM || this.options.enabled === !1 || !MZ(this.currentRefetchInterval) || this.currentRefetchInterval === 0) && (this.refetchIntervalId = setInterval(() => {
      (this.options.refetchIntervalInBackground || vf.isFocused()) && this.executeFetch();
    }, this.currentRefetchInterval));
  }
  updateTimers() {
    this.updateStaleTimeout(), this.updateRefetchInterval(this.computeRefetchInterval());
  }
  clearStaleTimeout() {
    this.staleTimeoutId && (clearTimeout(this.staleTimeoutId), this.staleTimeoutId = void 0);
  }
  clearRefetchInterval() {
    this.refetchIntervalId && (clearInterval(this.refetchIntervalId), this.refetchIntervalId = void 0);
  }
  createResult(e, n) {
    const r = this.currentQuery, i = this.options, a = this.currentResult, o = this.currentResultState, s = this.currentResultOptions, l = e !== r, c = l ? e.state : this.currentQueryInitialState, d = l ? this.currentResult : this.previousQueryResult, {
      state: u
    } = e;
    let {
      dataUpdatedAt: h,
      error: N,
      errorUpdatedAt: M,
      fetchStatus: p,
      status: m
    } = u, R = !1, V = !1, U;
    if (n._optimisticResults) {
      const D = this.hasListeners(), Y = !D && Qj(e, n), Q = D && Gj(e, r, n, i);
      (Y || Q) && (p = J2(e.options.networkMode) ? "fetching" : "paused", h || (m = "loading")), n._optimisticResults === "isRestoring" && (p = "idle");
    }
    if (n.keepPreviousData && !u.dataUpdatedAt && d != null && d.isSuccess && m !== "error")
      U = d.data, h = d.dataUpdatedAt, m = d.status, R = !0;
    else if (n.select && typeof u.data < "u")
      if (a && u.data === (o == null ? void 0 : o.data) && n.select === this.selectFn)
        U = this.selectResult;
      else
        try {
          this.selectFn = n.select, U = n.select(u.data), U = TZ(a == null ? void 0 : a.data, U, n), this.selectResult = U, this.selectError = null;
        } catch (D) {
          ue.env.NODE_ENV !== "production" && this.client.getLogger().error(D), this.selectError = D;
        }
    else
      U = u.data;
    if (typeof n.placeholderData < "u" && typeof U > "u" && m === "loading") {
      let D;
      if (a != null && a.isPlaceholderData && n.placeholderData === (s == null ? void 0 : s.placeholderData))
        D = a.data;
      else if (D = typeof n.placeholderData == "function" ? n.placeholderData() : n.placeholderData, n.select && typeof D < "u")
        try {
          D = n.select(D), this.selectError = null;
        } catch (Y) {
          ue.env.NODE_ENV !== "production" && this.client.getLogger().error(Y), this.selectError = Y;
        }
      typeof D < "u" && (m = "success", U = TZ(a == null ? void 0 : a.data, D, n), V = !0);
    }
    this.selectError && (N = this.selectError, U = this.selectResult, M = Date.now(), m = "error");
    const g = p === "fetching", y = m === "loading", x = m === "error";
    return {
      status: m,
      fetchStatus: p,
      isLoading: y,
      isSuccess: m === "success",
      isError: x,
      isInitialLoading: y && g,
      data: U,
      dataUpdatedAt: h,
      error: N,
      errorUpdatedAt: M,
      failureCount: u.fetchFailureCount,
      failureReason: u.fetchFailureReason,
      errorUpdateCount: u.errorUpdateCount,
      isFetched: u.dataUpdateCount > 0 || u.errorUpdateCount > 0,
      isFetchedAfterMount: u.dataUpdateCount > c.dataUpdateCount || u.errorUpdateCount > c.errorUpdateCount,
      isFetching: g,
      isRefetching: g && !y,
      isLoadingError: x && u.dataUpdatedAt === 0,
      isPaused: p === "paused",
      isPlaceholderData: V,
      isPreviousData: R,
      isRefetchError: x && u.dataUpdatedAt !== 0,
      isStale: E3(e, n),
      refetch: this.refetch,
      remove: this.remove
    };
  }
  updateResult(e) {
    const n = this.currentResult, r = this.createResult(this.currentQuery, this.options);
    if (this.currentResultState = this.currentQuery.state, this.currentResultOptions = this.options, pZ(r, n))
      return;
    this.currentResult = r;
    const i = {
      cache: !0
    }, a = () => {
      if (!n)
        return !0;
      const {
        notifyOnChangeProps: o
      } = this.options;
      if (o === "all" || !o && !this.trackedProps.size)
        return !0;
      const s = new Set(o ?? this.trackedProps);
      return this.options.useErrorBoundary && s.add("error"), Object.keys(this.currentResult).some((l) => {
        const c = l;
        return this.currentResult[c] !== n[c] && s.has(c);
      });
    };
    (e == null ? void 0 : e.listeners) !== !1 && a() && (i.listeners = !0), this.notify({
      ...i,
      ...e
    });
  }
  updateQuery() {
    const e = this.client.getQueryCache().build(this.client, this.options);
    if (e === this.currentQuery)
      return;
    const n = this.currentQuery;
    this.currentQuery = e, this.currentQueryInitialState = e.state, this.previousQueryResult = this.currentResult, this.hasListeners() && (n == null || n.removeObserver(this), e.addObserver(this));
  }
  onQueryUpdate(e) {
    const n = {};
    e.type === "success" ? n.onSuccess = !e.manual : e.type === "error" && !OT(e.error) && (n.onError = !0), this.updateResult(n), this.hasListeners() && this.updateTimers();
  }
  notify(e) {
    tr.batch(() => {
      if (e.onSuccess) {
        var n, r, i, a;
        (n = (r = this.options).onSuccess) == null || n.call(r, this.currentResult.data), (i = (a = this.options).onSettled) == null || i.call(a, this.currentResult.data, null);
      } else if (e.onError) {
        var o, s, l, c;
        (o = (s = this.options).onError) == null || o.call(s, this.currentResult.error), (l = (c = this.options).onSettled) == null || l.call(c, void 0, this.currentResult.error);
      }
      e.listeners && this.listeners.forEach((d) => {
        d(this.currentResult);
      }), e.cache && this.client.getQueryCache().notify({
        query: this.currentQuery,
        type: "observerResultsUpdated"
      });
    });
  }
}
function lq(t, e) {
  return e.enabled !== !1 && !t.state.dataUpdatedAt && !(t.state.status === "error" && e.retryOnMount === !1);
}
function Qj(t, e) {
  return lq(t, e) || t.state.dataUpdatedAt > 0 && fZ(t, e, e.refetchOnMount);
}
function fZ(t, e, n) {
  if (e.enabled !== !1) {
    const r = typeof n == "function" ? n(t) : n;
    return r === "always" || r !== !1 && E3(t, e);
  }
  return !1;
}
function Gj(t, e, n, r) {
  return n.enabled !== !1 && (t !== e || r.enabled === !1) && (!n.suspense || t.state.status !== "error") && E3(t, n);
}
function E3(t, e) {
  return t.isStaleByTime(e.staleTime);
}
let cq = class extends $h {
  constructor(e, n) {
    super(), this.client = e, this.setOptions(n), this.bindMethods(), this.updateResult();
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this), this.reset = this.reset.bind(this);
  }
  setOptions(e) {
    var n;
    const r = this.options;
    this.options = this.client.defaultMutationOptions(e), pZ(r, this.options) || this.client.getMutationCache().notify({
      type: "observerOptionsUpdated",
      mutation: this.currentMutation,
      observer: this
    }), (n = this.currentMutation) == null || n.setOptions(this.options);
  }
  onUnsubscribe() {
    if (!this.listeners.length) {
      var e;
      (e = this.currentMutation) == null || e.removeObserver(this);
    }
  }
  onMutationUpdate(e) {
    this.updateResult();
    const n = {
      listeners: !0
    };
    e.type === "success" ? n.onSuccess = !0 : e.type === "error" && (n.onError = !0), this.notify(n);
  }
  getCurrentResult() {
    return this.currentResult;
  }
  reset() {
    this.currentMutation = void 0, this.updateResult(), this.notify({
      listeners: !0
    });
  }
  mutate(e, n) {
    return this.mutateOptions = n, this.currentMutation && this.currentMutation.removeObserver(this), this.currentMutation = this.client.getMutationCache().build(this.client, {
      ...this.options,
      variables: typeof e < "u" ? e : this.options.variables
    }), this.currentMutation.addObserver(this), this.currentMutation.execute();
  }
  updateResult() {
    const e = this.currentMutation ? this.currentMutation.state : lO(), n = {
      ...e,
      isLoading: e.status === "loading",
      isSuccess: e.status === "success",
      isError: e.status === "error",
      isIdle: e.status === "idle",
      mutate: this.mutate,
      reset: this.reset
    };
    this.currentResult = n;
  }
  notify(e) {
    tr.batch(() => {
      if (this.mutateOptions && this.hasListeners()) {
        if (e.onSuccess) {
          var n, r, i, a;
          (n = (r = this.mutateOptions).onSuccess) == null || n.call(r, this.currentResult.data, this.currentResult.variables, this.currentResult.context), (i = (a = this.mutateOptions).onSettled) == null || i.call(a, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
        } else if (e.onError) {
          var o, s, l, c;
          (o = (s = this.mutateOptions).onError) == null || o.call(s, this.currentResult.error, this.currentResult.variables, this.currentResult.context), (l = (c = this.mutateOptions).onSettled) == null || l.call(c, void 0, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
        }
      }
      e.listeners && this.listeners.forEach((d) => {
        d(this.currentResult);
      });
    });
  }
};
var VZ = { exports: {} }, LR = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Cj;
function dq() {
  if (Cj)
    return LR;
  Cj = 1;
  var t = rr;
  function e(u, h) {
    return u === h && (u !== 0 || 1 / u === 1 / h) || u !== u && h !== h;
  }
  var n = typeof Object.is == "function" ? Object.is : e, r = t.useState, i = t.useEffect, a = t.useLayoutEffect, o = t.useDebugValue;
  function s(u, h) {
    var N = h(), M = r({ inst: { value: N, getSnapshot: h } }), p = M[0].inst, m = M[1];
    return a(function() {
      p.value = N, p.getSnapshot = h, l(p) && m({ inst: p });
    }, [u, N, h]), i(function() {
      return l(p) && m({ inst: p }), u(function() {
        l(p) && m({ inst: p });
      });
    }, [u]), o(N), N;
  }
  function l(u) {
    var h = u.getSnapshot;
    u = u.value;
    try {
      var N = h();
      return !n(u, N);
    } catch {
      return !0;
    }
  }
  function c(u, h) {
    return h();
  }
  var d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : s;
  return LR.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : d, LR;
}
var JR = {}, Lj;
function uq() {
  return Lj || (Lj = 1, ue.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = rr, e = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(U) {
      {
        for (var g = arguments.length, y = new Array(g > 1 ? g - 1 : 0), x = 1; x < g; x++)
          y[x - 1] = arguments[x];
        r("error", U, y);
      }
    }
    function r(U, g, y) {
      {
        var x = e.ReactDebugCurrentFrame, f = x.getStackAddendum();
        f !== "" && (g += "%s", y = y.concat([f]));
        var D = y.map(function(Y) {
          return String(Y);
        });
        D.unshift("Warning: " + g), Function.prototype.apply.call(console[U], console, D);
      }
    }
    function i(U, g) {
      return U === g && (U !== 0 || 1 / U === 1 / g) || U !== U && g !== g;
    }
    var a = typeof Object.is == "function" ? Object.is : i, o = t.useState, s = t.useEffect, l = t.useLayoutEffect, c = t.useDebugValue, d = !1, u = !1;
    function h(U, g, y) {
      d || t.startTransition !== void 0 && (d = !0, n("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var x = g();
      if (!u) {
        var f = g();
        a(x, f) || (n("The result of getSnapshot should be cached to avoid an infinite loop"), u = !0);
      }
      var D = o({
        inst: {
          value: x,
          getSnapshot: g
        }
      }), Y = D[0].inst, Q = D[1];
      return l(function() {
        Y.value = x, Y.getSnapshot = g, N(Y) && Q({
          inst: Y
        });
      }, [U, x, g]), s(function() {
        N(Y) && Q({
          inst: Y
        });
        var G = function() {
          N(Y) && Q({
            inst: Y
          });
        };
        return U(G);
      }, [U]), c(x), x;
    }
    function N(U) {
      var g = U.getSnapshot, y = U.value;
      try {
        var x = g();
        return !a(y, x);
      } catch {
        return !0;
      }
    }
    function M(U, g, y) {
      return g();
    }
    var p = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", m = !p, R = m ? M : h, V = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : R;
    JR.useSyncExternalStore = V, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), JR;
}
ue.env.NODE_ENV === "production" ? VZ.exports = dq() : VZ.exports = uq();
var B2 = VZ.exports;
const hq = B2.useSyncExternalStore, Jj = /* @__PURE__ */ H.createContext(void 0), cO = /* @__PURE__ */ H.createContext(!1);
function dO(t, e) {
  return t || (e && typeof window < "u" ? (window.ReactQueryClientContext || (window.ReactQueryClientContext = Jj), window.ReactQueryClientContext) : Jj);
}
const S3 = ({
  context: t
} = {}) => {
  const e = H.useContext(dO(t, H.useContext(cO)));
  if (!e)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return e;
}, Nq = ({
  client: t,
  children: e,
  context: n,
  contextSharing: r = !1
}) => {
  H.useEffect(() => (t.mount(), () => {
    t.unmount();
  }), [t]), ue.env.NODE_ENV !== "production" && r && t.getLogger().error("The contextSharing option has been deprecated and will be removed in the next major version");
  const i = dO(n, r);
  return /* @__PURE__ */ H.createElement(cO.Provider, {
    value: !n && r
  }, /* @__PURE__ */ H.createElement(i.Provider, {
    value: t
  }, e));
}, uO = /* @__PURE__ */ H.createContext(!1), Mq = () => H.useContext(uO);
uO.Provider;
function pq() {
  let t = !1;
  return {
    clearReset: () => {
      t = !1;
    },
    reset: () => {
      t = !0;
    },
    isReset: () => t
  };
}
const mq = /* @__PURE__ */ H.createContext(pq()), Tq = () => H.useContext(mq);
function fq(t, e) {
  return typeof t == "function" ? t(...e) : !!t;
}
function Vq(t, e, n) {
  const r = nO(t, e, n), i = S3({
    context: r.context
  }), [a] = H.useState(() => new cq(i, r));
  H.useEffect(() => {
    a.setOptions(r);
  }, [a, r]);
  const o = hq(H.useCallback((l) => a.subscribe(tr.batchCalls(l)), [a]), () => a.getCurrentResult(), () => a.getCurrentResult()), s = H.useCallback((l, c) => {
    a.mutate(l, c).catch(Uq);
  }, [a]);
  if (o.error && fq(a.options.useErrorBoundary, [o.error]))
    throw o.error;
  return {
    ...o,
    mutate: s,
    mutateAsync: o.mutate
  };
}
function Uq() {
}
function Rq(t) {
  return {
    mutationKey: t.options.mutationKey,
    state: t.state
  };
}
function gq(t) {
  return {
    state: t.state,
    queryKey: t.queryKey,
    queryHash: t.queryHash
  };
}
function yq(t) {
  return t.state.isPaused;
}
function Zq(t) {
  return t.state.status === "success";
}
function bq(t, e = {}) {
  const n = [], r = [];
  if (e.dehydrateMutations !== !1) {
    const i = e.shouldDehydrateMutation || yq;
    t.getMutationCache().getAll().forEach((a) => {
      i(a) && n.push(Rq(a));
    });
  }
  if (e.dehydrateQueries !== !1) {
    const i = e.shouldDehydrateQuery || Zq;
    t.getQueryCache().getAll().forEach((a) => {
      i(a) && r.push(gq(a));
    });
  }
  return {
    mutations: n,
    queries: r
  };
}
function Eq(t, e, n) {
  if (typeof e != "object" || e === null)
    return;
  const r = t.getMutationCache(), i = t.getQueryCache(), a = e.mutations || [], o = e.queries || [];
  a.forEach((s) => {
    var l;
    r.build(t, {
      ...n == null || (l = n.defaultOptions) == null ? void 0 : l.mutations,
      mutationKey: s.mutationKey
    }, s.state);
  }), o.forEach((s) => {
    var l;
    const c = i.get(s.queryHash), d = {
      ...s.state,
      fetchStatus: "idle"
    };
    if (c) {
      c.state.dataUpdatedAt < d.dataUpdatedAt && c.setState(d);
      return;
    }
    i.build(t, {
      ...n == null || (l = n.defaultOptions) == null ? void 0 : l.queries,
      queryKey: s.queryKey,
      queryHash: s.queryHash
    }, d);
  });
}
const Sq = ["added", "removed", "updated"];
function Bj(t) {
  return Sq.includes(t);
}
async function xq({
  queryClient: t,
  persister: e,
  maxAge: n = 1e3 * 60 * 60 * 24,
  buster: r = "",
  hydrateOptions: i
}) {
  try {
    const a = await e.restoreClient();
    if (a)
      if (a.timestamp) {
        const o = Date.now() - a.timestamp > n, s = a.buster !== r;
        o || s ? e.removeClient() : Eq(t, a.clientState, i);
      } else
        e.removeClient();
  } catch (a) {
    ue.env.NODE_ENV !== "production" && (t.getLogger().error(a), t.getLogger().warn("Encountered an error attempting to restore client cache from persisted location. As a precaution, the persisted cache will be discarded.")), e.removeClient();
  }
}
async function Aj({
  queryClient: t,
  persister: e,
  buster: n = "",
  dehydrateOptions: r
}) {
  const i = {
    buster: n,
    timestamp: Date.now(),
    clientState: bq(t, r)
  };
  await e.persistClient(i);
}
function Wq(t) {
  const e = t.queryClient.getQueryCache().subscribe((r) => {
    Bj(r.type) && Aj(t);
  }), n = t.queryClient.getMutationCache().subscribe((r) => {
    Bj(r.type) && Aj(t);
  });
  return () => {
    e(), n();
  };
}
function jq(t) {
  let e = !1, n;
  const r = () => {
    e = !0, n == null || n();
  }, i = xq(t).then(() => {
    e || (n = Wq(t));
  });
  return [r, i];
}
var Dq = class extends Error {
  constructor({
    chainId: e,
    connectorId: n
  }) {
    super(`Chain "${e}" not configured for connector "${n}".`), this.name = "ChainNotConfiguredForConnectorError";
  }
}, Xi = class extends Error {
  constructor() {
    super(...arguments), this.name = "ConnectorNotFoundError", this.message = "Connector not found";
  }
};
function Hj(t) {
  return typeof t == "string" ? Number.parseInt(
    t,
    t.trim().substring(0, 2) === "0x" ? 16 : 10
  ) : typeof t == "bigint" ? Number(t) : t;
}
var x3 = (t, e, n) => {
  if (!e.has(t))
    throw TypeError("Cannot " + n);
}, Qn = (t, e, n) => (x3(t, e, "read from private field"), n ? n.call(t) : e.get(t)), Ai = (t, e, n) => {
  if (e.has(t))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(t) : e.set(t, n);
}, A2 = (t, e, n, r) => (x3(t, e, "write to private field"), r ? r.call(t, n) : e.set(t, n), n), Wr = (t, e, n) => (x3(t, e, "access private method"), n), W3 = class extends VP {
  constructor({
    chains: t = [uI, TP],
    options: e
  }) {
    super(), this.chains = t, this.options = e;
  }
  getBlockExplorerUrls(t) {
    const { default: e, ...n } = t.blockExplorers ?? {};
    if (e)
      return [
        e.url,
        ...Object.values(n).map((r) => r.url)
      ];
  }
  isChainUnsupported(t) {
    return !this.chains.some((e) => e.id === t);
  }
  setStorage(t) {
    this.storage = t;
  }
};
function zq(t) {
  var n;
  if (!t)
    return "Injected";
  const e = (r) => {
    if (r.isApexWallet)
      return "Apex Wallet";
    if (r.isAvalanche)
      return "Core Wallet";
    if (r.isBackpack)
      return "Backpack";
    if (r.isBifrost)
      return "Bifrost Wallet";
    if (r.isBitKeep)
      return "BitKeep";
    if (r.isBitski)
      return "Bitski";
    if (r.isBlockWallet)
      return "BlockWallet";
    if (r.isBraveWallet)
      return "Brave Wallet";
    if (r.isCoin98)
      return "Coin98 Wallet";
    if (r.isCoinbaseWallet)
      return "Coinbase Wallet";
    if (r.isDawn)
      return "Dawn Wallet";
    if (r.isDefiant)
      return "Defiant";
    if (r.isDesig)
      return "Desig Wallet";
    if (r.isEnkrypt)
      return "Enkrypt";
    if (r.isExodus)
      return "Exodus";
    if (r.isFordefi)
      return "Fordefi";
    if (r.isFrame)
      return "Frame";
    if (r.isFrontier)
      return "Frontier Wallet";
    if (r.isGamestop)
      return "GameStop Wallet";
    if (r.isHaqqWallet)
      return "HAQQ Wallet";
    if (r.isHyperPay)
      return "HyperPay Wallet";
    if (r.isImToken)
      return "ImToken";
    if (r.isHaloWallet)
      return "Halo Wallet";
    if (r.isKuCoinWallet)
      return "KuCoin Wallet";
    if (r.isMathWallet)
      return "MathWallet";
    if (r.isNovaWallet)
      return "Nova Wallet";
    if (r.isOkxWallet || r.isOKExWallet)
      return "OKX Wallet";
    if (r.isOktoWallet)
      return "Okto Wallet";
    if (r.isOneInchIOSWallet || r.isOneInchAndroidWallet)
      return "1inch Wallet";
    if (r.isOneKey)
      return "OneKey Wallet";
    if (r.isOpera)
      return "Opera";
    if (r.isPhantom)
      return "Phantom";
    if (r.isPortal)
      return "Ripio Portal";
    if (r.isRabby)
      return "Rabby Wallet";
    if (r.isRainbow)
      return "Rainbow";
    if (r.isSafePal)
      return "SafePal Wallet";
    if (r.isStatus)
      return "Status";
    if (r.isSubWallet)
      return "SubWallet";
    if (r.isTalisman)
      return "Talisman";
    if (r.isTally)
      return "Taho";
    if (r.isTokenPocket)
      return "TokenPocket";
    if (r.isTokenary)
      return "Tokenary";
    if (r.isTrust || r.isTrustWallet)
      return "Trust Wallet";
    if (r.isTTWallet)
      return "TTWallet";
    if (r.isXDEFI)
      return "XDEFI Wallet";
    if (r.isZeal)
      return "Zeal";
    if (r.isZerion)
      return "Zerion";
    if (r.isMetaMask)
      return "MetaMask";
  };
  if ((n = t.providers) != null && n.length) {
    const r = /* @__PURE__ */ new Set();
    let i = 1;
    for (const o of t.providers) {
      let s = e(o);
      s || (s = `Unknown Wallet #${i}`, i += 1), r.add(s);
    }
    const a = [...r];
    return a.length ? a : a[0] ?? "Injected";
  }
  return e(t) ?? "Injected";
}
var YT, gc = class extends W3 {
  constructor({
    chains: t,
    options: e
  } = {}) {
    const n = {
      shimDisconnect: !0,
      getProvider() {
        if (typeof window > "u")
          return;
        const i = window.ethereum;
        return i != null && i.providers && i.providers.length > 0 ? i.providers[0] : i;
      },
      ...e
    };
    super({ chains: t, options: n }), this.id = "injected", Ai(this, YT, void 0), this.shimDisconnectKey = `${this.id}.shimDisconnect`, this.onAccountsChanged = (i) => {
      i.length === 0 ? this.emit("disconnect") : this.emit("change", {
        account: un(i[0])
      });
    }, this.onChainChanged = (i) => {
      const a = Hj(i), o = this.isChainUnsupported(a);
      this.emit("change", { chain: { id: a, unsupported: o } });
    }, this.onDisconnect = async (i) => {
      var a;
      i.code === 1013 && await this.getProvider() && await this.getAccount() || (this.emit("disconnect"), this.options.shimDisconnect && ((a = this.storage) == null || a.removeItem(this.shimDisconnectKey)));
    };
    const r = n.getProvider();
    if (typeof n.name == "string")
      this.name = n.name;
    else if (r) {
      const i = zq(r);
      n.name ? this.name = n.name(i) : typeof i == "string" ? this.name = i : this.name = i[0];
    } else
      this.name = "Injected";
    this.ready = !!r;
  }
  async connect({ chainId: t } = {}) {
    var e;
    try {
      const n = await this.getProvider();
      if (!n)
        throw new Xi();
      n.on && (n.on("accountsChanged", this.onAccountsChanged), n.on("chainChanged", this.onChainChanged), n.on("disconnect", this.onDisconnect)), this.emit("message", { type: "connecting" });
      const r = await n.request({
        method: "eth_requestAccounts"
      }), i = un(r[0]);
      let a = await this.getChainId(), o = this.isChainUnsupported(a);
      return t && a !== t && (a = (await this.switchChain(t)).id, o = this.isChainUnsupported(a)), this.options.shimDisconnect && ((e = this.storage) == null || e.setItem(this.shimDisconnectKey, !0)), { account: i, chain: { id: a, unsupported: o } };
    } catch (n) {
      throw this.isUserRejectedRequestError(n) ? new Un(n) : n.code === -32002 ? new ql(n) : n;
    }
  }
  async disconnect() {
    var e;
    const t = await this.getProvider();
    t != null && t.removeListener && (t.removeListener("accountsChanged", this.onAccountsChanged), t.removeListener("chainChanged", this.onChainChanged), t.removeListener("disconnect", this.onDisconnect), this.options.shimDisconnect && ((e = this.storage) == null || e.removeItem(this.shimDisconnectKey)));
  }
  async getAccount() {
    const t = await this.getProvider();
    if (!t)
      throw new Xi();
    const e = await t.request({
      method: "eth_accounts"
    });
    return un(e[0]);
  }
  async getChainId() {
    const t = await this.getProvider();
    if (!t)
      throw new Xi();
    return t.request({ method: "eth_chainId" }).then(Hj);
  }
  async getProvider() {
    const t = this.options.getProvider();
    return t && A2(this, YT, t), Qn(this, YT);
  }
  async getWalletClient({
    chainId: t
  } = {}) {
    const [e, n] = await Promise.all([
      this.getProvider(),
      this.getAccount()
    ]), r = this.chains.find((i) => i.id === t);
    if (!e)
      throw new Error("provider is required.");
    return N3({
      account: n,
      chain: r,
      transport: l3(e)
    });
  }
  async isAuthorized() {
    var t;
    try {
      if (this.options.shimDisconnect && !((t = this.storage) != null && t.getItem(this.shimDisconnectKey)))
        return !1;
      if (!await this.getProvider())
        throw new Xi();
      return !!await this.getAccount();
    } catch {
      return !1;
    }
  }
  async switchChain(t) {
    var r, i, a;
    const e = await this.getProvider();
    if (!e)
      throw new Xi();
    const n = St(t);
    try {
      return await Promise.all([
        e.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: n }]
        }),
        new Promise(
          (o) => this.on("change", ({ chain: s }) => {
            (s == null ? void 0 : s.id) === t && o();
          })
        )
      ]), this.chains.find((o) => o.id === t) ?? {
        id: t,
        name: `Chain ${n}`,
        network: `${n}`,
        nativeCurrency: { name: "Ether", decimals: 18, symbol: "ETH" },
        rpcUrls: { default: { http: [""] }, public: { http: [""] } }
      };
    } catch (o) {
      const s = this.chains.find((l) => l.id === t);
      if (!s)
        throw new Dq({
          chainId: t,
          connectorId: this.id
        });
      if (o.code === 4902 || ((i = (r = o == null ? void 0 : o.data) == null ? void 0 : r.originalError) == null ? void 0 : i.code) === 4902)
        try {
          if (await e.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainId: n,
                chainName: s.name,
                nativeCurrency: s.nativeCurrency,
                rpcUrls: [((a = s.rpcUrls.public) == null ? void 0 : a.http[0]) ?? ""],
                blockExplorerUrls: this.getBlockExplorerUrls(s)
              }
            ]
          }), await this.getChainId() !== t)
            throw new Un(
              new Error("User rejected switch after adding network.")
            );
          return s;
        } catch (l) {
          throw new Un(l);
        }
      throw this.isUserRejectedRequestError(o) ? new Un(o) : new ks(o);
    }
  }
  async watchAsset({
    address: t,
    decimals: e = 18,
    image: n,
    symbol: r
  }) {
    const i = await this.getProvider();
    if (!i)
      throw new Xi();
    return i.request({
      method: "wallet_watchAsset",
      params: {
        type: "ERC20",
        options: {
          address: t,
          decimals: e,
          image: n,
          symbol: r
        }
      }
    });
  }
  isUserRejectedRequestError(t) {
    return t.code === 4001;
  }
};
YT = /* @__PURE__ */ new WeakMap();
var j3 = (t, e, n) => {
  if (!e.has(t))
    throw TypeError("Cannot " + n);
}, BR = (t, e, n) => (j3(t, e, "read from private field"), n ? n.call(t) : e.get(t)), AR = (t, e, n) => {
  if (e.has(t))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(t) : e.set(t, n);
}, $m = (t, e, n, r) => (j3(t, e, "write to private field"), r ? r.call(t, n) : e.set(t, n), n), kq = (t, e, n) => (j3(t, e, "access private method"), n);
function wq(t, e, {
  batch: n = { multicall: { wait: 32 } },
  pollingInterval: r = 4e3,
  rank: i,
  retryCount: a,
  retryDelay: o,
  stallTimeout: s
} = {}) {
  if (!t.length)
    throw new Error("must have at least one chain");
  let l = [];
  const c = {}, d = {};
  for (const u of t) {
    let h = !1;
    for (const N of e) {
      const M = N(u);
      M && (h = !0, l.some(({ id: p }) => p === u.id) || (l = [...l, M.chain]), c[u.id] = [
        ...c[u.id] || [],
        ...M.rpcUrls.http
      ], M.rpcUrls.webSocket && (d[u.id] = [
        ...d[u.id] || [],
        ...M.rpcUrls.webSocket
      ]));
    }
    if (!h)
      throw new Error(
        [
          `Could not find valid provider configuration for chain "${u.name}".
`,
          "You may need to add `jsonRpcProvider` to `configureChains` with the chain's RPC URLs.",
          "Read more: https://wagmi.sh/core/providers/jsonRpc"
        ].join(`
`)
      );
  }
  return {
    chains: l,
    publicClient: ({ chainId: u }) => {
      const h = l.find((p) => p.id === u) ?? t[0], N = c[h.id];
      if (!N || !N[0])
        throw new Error(`No providers configured for chain "${h.id}"`);
      const M = Df({
        batch: n,
        chain: h,
        transport: jf(
          N.map((p) => Qp(p, { timeout: s })),
          { rank: i, retryCount: a, retryDelay: o }
        ),
        pollingInterval: r
      });
      return Object.assign(M, {
        chains: l
      });
    },
    webSocketPublicClient: ({ chainId: u }) => {
      const h = l.find((p) => p.id === u) ?? t[0], N = d[h.id];
      if (!N || !N[0])
        return;
      const M = Df({
        batch: n,
        chain: h,
        transport: jf(
          N.map((p) => mP(p, { timeout: s })),
          { rank: i, retryCount: a, retryDelay: o }
        ),
        pollingInterval: r
      });
      return Object.assign(M, {
        chains: l
      });
    }
  };
}
var Fq = class extends Error {
  constructor({
    activeChain: t,
    targetChain: e
  }) {
    super(
      `Chain mismatch: Expected "${e}", received "${t}".`
    ), this.name = "ChainMismatchError";
  }
}, vq = class extends Error {
  constructor({
    chainId: t,
    connectorId: e
  }) {
    super(
      `Chain "${t}" not configured${e ? ` for connector "${e}"` : ""}.`
    ), this.name = "ChainNotConfigured";
  }
}, Iq = class extends Error {
  constructor() {
    super(...arguments), this.name = "ConnectorAlreadyConnectedError", this.message = "Connector already connected";
  }
}, Oq = class extends Error {
  constructor() {
    super(...arguments), this.name = "ConfigChainsNotFound", this.message = "No chains were found on the wagmi config. Some functions that require a chain may not work.";
  }
}, Yq = class extends Error {
  constructor({ connector: t }) {
    super(`"${t.name}" does not support programmatic chain switching.`), this.name = "SwitchChainNotSupportedError";
  }
};
function Of(t, e) {
  if (t === e)
    return !0;
  if (t && e && typeof t == "object" && typeof e == "object") {
    if (t.constructor !== e.constructor)
      return !1;
    let n, r;
    if (Array.isArray(t) && Array.isArray(e)) {
      if (n = t.length, n != e.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!Of(t[r], e[r]))
          return !1;
      return !0;
    }
    if (t.valueOf !== Object.prototype.valueOf)
      return t.valueOf() === e.valueOf();
    if (t.toString !== Object.prototype.toString)
      return t.toString() === e.toString();
    const i = Object.keys(t);
    if (n = i.length, n !== Object.keys(e).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(e, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const a = i[r];
      if (a && !Of(t[a], e[a]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
var UZ = (t, {
  find: e,
  replace: n
}) => t && e(t) ? n(t) : typeof t != "object" ? t : Array.isArray(t) ? t.map((r) => UZ(r, { find: e, replace: n })) : t instanceof Object ? Object.entries(t).reduce(
  (r, [i, a]) => ({
    ...r,
    [i]: UZ(a, { find: e, replace: n })
  }),
  {}
) : t;
function Qq(t) {
  const e = JSON.parse(t);
  return UZ(e, {
    find: (r) => typeof r == "string" && r.startsWith("#bigint."),
    replace: (r) => BigInt(r.replace("#bigint.", ""))
  });
}
function Gq(t) {
  return {
    accessList: t.accessList,
    account: t.account,
    blockNumber: t.blockNumber,
    blockTag: t.blockTag,
    data: t.data,
    gas: t.gas,
    gasPrice: t.gasPrice,
    maxFeePerGas: t.maxFeePerGas,
    maxPriorityFeePerGas: t.maxPriorityFeePerGas,
    nonce: t.nonce,
    to: t.to,
    value: t.value
  };
}
function Xj(t) {
  return typeof t == "number" ? t : t === "wei" ? 0 : Math.abs(lX[t]);
}
function _j(t, e) {
  return t.slice(0, e).join(".") || ".";
}
function Pj(t, e) {
  const { length: n } = t;
  for (let r = 0; r < n; ++r)
    if (t[r] === e)
      return r + 1;
  return 0;
}
function Cq(t, e) {
  const n = typeof t == "function", r = typeof e == "function", i = [], a = [];
  return function(s, l) {
    if (typeof l == "object")
      if (i.length) {
        const c = Pj(i, this);
        c === 0 ? i[i.length] = this : (i.splice(c), a.splice(c)), a[a.length] = s;
        const d = Pj(i, l);
        if (d !== 0)
          return r ? e.call(
            this,
            s,
            l,
            _j(a, d)
          ) : `[ref=${_j(a, d)}]`;
      } else
        i[0] = l, a[0] = s;
    return n ? t.call(this, s, l) : l;
  };
}
function Lq(t, e, n, r) {
  return JSON.stringify(
    t,
    Cq((i, a) => {
      const o = typeof a == "bigint" ? `#bigint.${a.toString()}` : a;
      return (e == null ? void 0 : e(i, o)) || o;
    }, r),
    n ?? void 0
  );
}
var hO = {
  getItem: (t) => "",
  setItem: (t, e) => null,
  removeItem: (t) => null
};
function D3({
  deserialize: t = Qq,
  key: e = "wagmi",
  serialize: n = Lq,
  storage: r
}) {
  return {
    ...r,
    getItem: (i, a = null) => {
      const o = r.getItem(`${e}.${i}`);
      try {
        return o ? t(o) : a;
      } catch (s) {
        return console.warn(s), a;
      }
    },
    setItem: (i, a) => {
      if (a === null)
        r.removeItem(`${e}.${i}`);
      else
        try {
          r.setItem(`${e}.${i}`, n(a));
        } catch (o) {
          console.error(o);
        }
    },
    removeItem: (i) => r.removeItem(`${e}.${i}`)
  };
}
var Kj = "store", Ju, YN, RZ, NO, Jq = class {
  constructor({
    autoConnect: t = !1,
    connectors: e = [new gc()],
    publicClient: n,
    storage: r = D3({
      storage: typeof window < "u" ? window.localStorage : hO
    }),
    logger: i = {
      warn: console.warn
    },
    webSocketPublicClient: a
  }) {
    var c, d;
    AR(this, RZ), this.publicClients = /* @__PURE__ */ new Map(), this.webSocketPublicClients = /* @__PURE__ */ new Map(), AR(this, Ju, void 0), AR(this, YN, void 0), this.args = {
      autoConnect: t,
      connectors: e,
      logger: i,
      publicClient: n,
      storage: r,
      webSocketPublicClient: a
    };
    let o = "disconnected", s;
    if (t)
      try {
        const u = r.getItem(Kj), h = (c = u == null ? void 0 : u.state) == null ? void 0 : c.data;
        o = h != null && h.account ? "reconnecting" : "connecting", s = (d = h == null ? void 0 : h.chain) == null ? void 0 : d.id;
      } catch {
      }
    const l = typeof e == "function" ? e() : e;
    l.forEach((u) => u.setStorage(r)), this.store = SP(
      RP(
        EP(
          () => ({
            connectors: l,
            publicClient: this.getPublicClient({ chainId: s }),
            status: o,
            webSocketPublicClient: this.getWebSocketPublicClient({ chainId: s })
          }),
          {
            name: Kj,
            storage: r,
            partialize: (u) => {
              var h, N;
              return {
                ...t && {
                  data: {
                    account: (h = u == null ? void 0 : u.data) == null ? void 0 : h.account,
                    chain: (N = u == null ? void 0 : u.data) == null ? void 0 : N.chain
                  }
                },
                chains: u == null ? void 0 : u.chains
              };
            },
            version: 2
          }
        )
      )
    ), this.storage = r, $m(this, YN, r == null ? void 0 : r.getItem("wallet")), kq(this, RZ, NO).call(this), t && typeof window < "u" && setTimeout(async () => await this.autoConnect(), 0);
  }
  get chains() {
    return this.store.getState().chains;
  }
  get connectors() {
    return this.store.getState().connectors;
  }
  get connector() {
    return this.store.getState().connector;
  }
  get data() {
    return this.store.getState().data;
  }
  get error() {
    return this.store.getState().error;
  }
  get lastUsedChainId() {
    var t, e;
    return (e = (t = this.data) == null ? void 0 : t.chain) == null ? void 0 : e.id;
  }
  get publicClient() {
    return this.store.getState().publicClient;
  }
  get status() {
    return this.store.getState().status;
  }
  get subscribe() {
    return this.store.subscribe;
  }
  get webSocketPublicClient() {
    return this.store.getState().webSocketPublicClient;
  }
  setState(t) {
    const e = typeof t == "function" ? t(this.store.getState()) : t;
    this.store.setState(e, !0);
  }
  clearState() {
    this.setState((t) => ({
      ...t,
      chains: void 0,
      connector: void 0,
      data: void 0,
      error: void 0,
      status: "disconnected"
    }));
  }
  async destroy() {
    var t, e;
    this.connector && await ((e = (t = this.connector).disconnect) == null ? void 0 : e.call(t)), $m(this, Ju, !1), this.clearState(), this.store.destroy();
  }
  async autoConnect() {
    if (BR(this, Ju))
      return;
    $m(this, Ju, !0), this.setState((n) => {
      var r;
      return {
        ...n,
        status: (r = n.data) != null && r.account ? "reconnecting" : "connecting"
      };
    });
    const t = BR(this, YN) ? [...this.connectors].sort(
      (n) => n.id === BR(this, YN) ? -1 : 1
    ) : this.connectors;
    let e = !1;
    for (const n of t) {
      if (!n.ready || !n.isAuthorized || !await n.isAuthorized())
        continue;
      const i = await n.connect();
      this.setState((a) => ({
        ...a,
        connector: n,
        chains: n == null ? void 0 : n.chains,
        data: i,
        status: "connected"
      })), e = !0;
      break;
    }
    return e || this.setState((n) => ({
      ...n,
      data: void 0,
      status: "disconnected"
    })), $m(this, Ju, !1), this.data;
  }
  setConnectors(t) {
    this.args = {
      ...this.args,
      connectors: t
    };
    const e = typeof t == "function" ? t() : t;
    e.forEach((n) => n.setStorage(this.args.storage)), this.setState((n) => ({
      ...n,
      connectors: e
    }));
  }
  getPublicClient({ chainId: t } = {}) {
    let e = this.publicClients.get(-1);
    if (e && (e == null ? void 0 : e.chain.id) === t || (e = this.publicClients.get(t ?? -1), e))
      return e;
    const { publicClient: n } = this.args;
    return e = typeof n == "function" ? n({ chainId: t }) : n, this.publicClients.set(t ?? -1, e), e;
  }
  setPublicClient(t) {
    var n, r;
    const e = (r = (n = this.data) == null ? void 0 : n.chain) == null ? void 0 : r.id;
    this.args = {
      ...this.args,
      publicClient: t
    }, this.publicClients.clear(), this.setState((i) => ({
      ...i,
      publicClient: this.getPublicClient({ chainId: e })
    }));
  }
  getWebSocketPublicClient({ chainId: t } = {}) {
    let e = this.webSocketPublicClients.get(-1);
    if (e && (e == null ? void 0 : e.chain.id) === t || (e = this.webSocketPublicClients.get(t ?? -1), e))
      return e;
    const { webSocketPublicClient: n } = this.args;
    return e = typeof n == "function" ? n({ chainId: t }) : n, e && this.webSocketPublicClients.set(t ?? -1, e), e;
  }
  setWebSocketPublicClient(t) {
    var n, r;
    const e = (r = (n = this.data) == null ? void 0 : n.chain) == null ? void 0 : r.id;
    this.args = {
      ...this.args,
      webSocketPublicClient: t
    }, this.webSocketPublicClients.clear(), this.setState((i) => ({
      ...i,
      webSocketPublicClient: this.getWebSocketPublicClient({
        chainId: e
      })
    }));
  }
  setLastUsedConnector(t = null) {
    var e;
    (e = this.storage) == null || e.setItem("wallet", t);
  }
};
Ju = /* @__PURE__ */ new WeakMap();
YN = /* @__PURE__ */ new WeakMap();
RZ = /* @__PURE__ */ new WeakSet();
NO = function() {
  const t = (s) => {
    this.setState((l) => ({
      ...l,
      data: { ...l.data, ...s }
    }));
  }, e = () => {
    this.clearState();
  }, n = (s) => {
    this.setState((l) => ({ ...l, error: s }));
  };
  this.store.subscribe(
    ({ connector: s }) => s,
    (s, l) => {
      var c, d, u, h, N, M;
      (c = l == null ? void 0 : l.off) == null || c.call(l, "change", t), (d = l == null ? void 0 : l.off) == null || d.call(l, "disconnect", e), (u = l == null ? void 0 : l.off) == null || u.call(l, "error", n), s && ((h = s.on) == null || h.call(s, "change", t), (N = s.on) == null || N.call(s, "disconnect", e), (M = s.on) == null || M.call(s, "error", n));
    }
  );
  const { publicClient: r, webSocketPublicClient: i } = this.args;
  (typeof r == "function" || typeof i == "function") && this.store.subscribe(
    ({ data: s }) => {
      var l;
      return (l = s == null ? void 0 : s.chain) == null ? void 0 : l.id;
    },
    (s) => {
      this.setState((l) => ({
        ...l,
        publicClient: this.getPublicClient({ chainId: s }),
        webSocketPublicClient: this.getWebSocketPublicClient({
          chainId: s
        })
      }));
    }
  );
};
var gZ;
function Bq(t) {
  const e = new Jq(t);
  return gZ = e, e;
}
function oa() {
  if (!gZ)
    throw new Error(
      "No wagmi config found. Ensure you have set up a config: https://wagmi.sh/react/config"
    );
  return gZ;
}
async function yZ({ chainId: t, connector: e }) {
  const n = oa(), r = n.connector;
  if (r && e.id === r.id)
    throw new Iq();
  try {
    n.setState((a) => ({ ...a, status: "connecting" }));
    const i = await e.connect({ chainId: t });
    return n.setLastUsedConnector(e.id), n.setState((a) => ({
      ...a,
      connector: e,
      chains: e == null ? void 0 : e.chains,
      data: i,
      status: "connected"
    })), n.storage.setItem("connected", !0), { ...i, connector: e };
  } catch (i) {
    throw n.setState((a) => ({
      ...a,
      status: a.connector ? "connected" : "disconnected"
    })), i;
  }
}
async function MO() {
  const t = oa();
  t.connector && await t.connector.disconnect(), t.clearState(), t.storage.removeItem("connected");
}
var z3 = [
  {
    type: "event",
    name: "Approval",
    inputs: [
      {
        indexed: !0,
        name: "owner",
        type: "address"
      },
      {
        indexed: !0,
        name: "spender",
        type: "address"
      },
      {
        indexed: !1,
        name: "value",
        type: "uint256"
      }
    ]
  },
  {
    type: "event",
    name: "Transfer",
    inputs: [
      {
        indexed: !0,
        name: "from",
        type: "address"
      },
      {
        indexed: !0,
        name: "to",
        type: "address"
      },
      {
        indexed: !1,
        name: "value",
        type: "uint256"
      }
    ]
  },
  {
    type: "function",
    name: "allowance",
    stateMutability: "view",
    inputs: [
      {
        name: "owner",
        type: "address"
      },
      {
        name: "spender",
        type: "address"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ]
  },
  {
    type: "function",
    name: "approve",
    stateMutability: "nonpayable",
    inputs: [
      {
        name: "spender",
        type: "address"
      },
      {
        name: "amount",
        type: "uint256"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ]
  },
  {
    type: "function",
    name: "balanceOf",
    stateMutability: "view",
    inputs: [
      {
        name: "account",
        type: "address"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ]
  },
  {
    type: "function",
    name: "decimals",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint8"
      }
    ]
  },
  {
    type: "function",
    name: "name",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "string"
      }
    ]
  },
  {
    type: "function",
    name: "symbol",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "string"
      }
    ]
  },
  {
    type: "function",
    name: "totalSupply",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ]
  },
  {
    type: "function",
    name: "transfer",
    stateMutability: "nonpayable",
    inputs: [
      {
        name: "recipient",
        type: "address"
      },
      {
        name: "amount",
        type: "uint256"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ]
  },
  {
    type: "function",
    name: "transferFrom",
    stateMutability: "nonpayable",
    inputs: [
      {
        name: "sender",
        type: "address"
      },
      {
        name: "recipient",
        type: "address"
      },
      {
        name: "amount",
        type: "uint256"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ]
  }
], Aq = [
  {
    type: "event",
    name: "Approval",
    inputs: [
      {
        indexed: !0,
        name: "owner",
        type: "address"
      },
      {
        indexed: !0,
        name: "spender",
        type: "address"
      },
      {
        indexed: !1,
        name: "value",
        type: "uint256"
      }
    ]
  },
  {
    type: "event",
    name: "Transfer",
    inputs: [
      {
        indexed: !0,
        name: "from",
        type: "address"
      },
      {
        indexed: !0,
        name: "to",
        type: "address"
      },
      {
        indexed: !1,
        name: "value",
        type: "uint256"
      }
    ]
  },
  {
    type: "function",
    name: "allowance",
    stateMutability: "view",
    inputs: [
      {
        name: "owner",
        type: "address"
      },
      {
        name: "spender",
        type: "address"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ]
  },
  {
    type: "function",
    name: "approve",
    stateMutability: "nonpayable",
    inputs: [
      {
        name: "spender",
        type: "address"
      },
      {
        name: "amount",
        type: "uint256"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ]
  },
  {
    type: "function",
    name: "balanceOf",
    stateMutability: "view",
    inputs: [
      {
        name: "account",
        type: "address"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ]
  },
  {
    type: "function",
    name: "decimals",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint8"
      }
    ]
  },
  {
    type: "function",
    name: "name",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bytes32"
      }
    ]
  },
  {
    type: "function",
    name: "symbol",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bytes32"
      }
    ]
  },
  {
    type: "function",
    name: "totalSupply",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ]
  },
  {
    type: "function",
    name: "transfer",
    stateMutability: "nonpayable",
    inputs: [
      {
        name: "recipient",
        type: "address"
      },
      {
        name: "amount",
        type: "uint256"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ]
  },
  {
    type: "function",
    name: "transferFrom",
    stateMutability: "nonpayable",
    inputs: [
      {
        name: "sender",
        type: "address"
      },
      {
        name: "recipient",
        type: "address"
      },
      {
        name: "amount",
        type: "uint256"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ]
  }
];
function ki({ chainId: t } = {}) {
  const e = oa();
  return t && e.getPublicClient({ chainId: t }) || e.publicClient;
}
async function Jp({
  chainId: t
} = {}) {
  var r, i;
  return await ((i = (r = oa().connector) == null ? void 0 : r.getWalletClient) == null ? void 0 : i.call(r, { chainId: t })) || null;
}
function ZZ({
  chainId: t
} = {}) {
  const e = oa();
  return t && e.getWebSocketPublicClient({ chainId: t }) || e.webSocketPublicClient;
}
function Hq(t, e) {
  const n = oa(), r = async () => e(ki(t));
  return n.subscribe(
    ({ publicClient: a }) => a,
    r
  );
}
function Xq(t, e) {
  const n = oa(), r = async () => e(ZZ(t));
  return n.subscribe(
    ({ webSocketPublicClient: a }) => a,
    r
  );
}
async function pO({
  abi: t,
  address: e,
  args: n,
  chainId: r,
  dataSuffix: i,
  functionName: a,
  walletClient: o,
  ...s
}) {
  const l = ki({ chainId: r }), c = o ?? await Jp({ chainId: r });
  if (!c)
    throw new Xi();
  r && H2({ chainId: r });
  const {
    account: d,
    accessList: u,
    blockNumber: h,
    blockTag: N,
    gas: M,
    gasPrice: p,
    maxFeePerGas: m,
    maxPriorityFeePerGas: R,
    nonce: V,
    value: U
  } = Gq(s), { result: g, request: y } = await l.simulateContract({
    abi: t,
    address: e,
    functionName: a,
    args: n,
    account: d || c.account,
    accessList: u,
    blockNumber: h,
    blockTag: N,
    dataSuffix: i,
    gas: M,
    gasPrice: p,
    maxFeePerGas: m,
    maxPriorityFeePerGas: R,
    nonce: V,
    value: U
  }), x = t.filter(
    (f) => "name" in f && f.name === a
  );
  return {
    mode: "prepared",
    request: {
      ...y,
      abi: x,
      chainId: r
    },
    result: g
  };
}
async function _q({
  chainId: t,
  contracts: e,
  blockNumber: n,
  blockTag: r,
  ...i
}) {
  const a = ki({ chainId: t });
  if (!a.chains)
    throw new Oq();
  if (t && a.chain.id !== t)
    throw new vq({ chainId: t });
  return a.multicall({
    allowFailure: i.allowFailure ?? !0,
    blockNumber: n,
    blockTag: r,
    contracts: e
  });
}
async function mO({
  address: t,
  account: e,
  chainId: n,
  abi: r,
  args: i,
  functionName: a,
  blockNumber: o,
  blockTag: s
}) {
  return ki({ chainId: n }).readContract({
    abi: r,
    address: t,
    account: e,
    functionName: a,
    args: i,
    blockNumber: o,
    blockTag: s
  });
}
async function Pq({
  contracts: t,
  blockNumber: e,
  blockTag: n,
  ...r
}) {
  const { allowFailure: i = !0 } = r;
  try {
    const a = ki(), o = t.reduce((d, u, h) => {
      const N = u.chainId ?? a.chain.id;
      return {
        ...d,
        [N]: [...d[N] || [], { contract: u, index: h }]
      };
    }, {}), s = () => Object.entries(o).map(
      ([d, u]) => _q({
        allowFailure: i,
        chainId: parseInt(d),
        contracts: u.map(
          ({ contract: h }) => h
        ),
        blockNumber: e,
        blockTag: n
      })
    ), l = (await Promise.all(s())).flat(), c = Object.values(o).flatMap(
      (d) => d.map(({ index: u }) => u)
    );
    return l.reduce((d, u, h) => (d && (d[c[h]] = u), d), []);
  } catch (a) {
    if (a instanceof PE)
      throw a;
    const o = () => t.map(
      (s) => mO({ ...s, blockNumber: e, blockTag: n })
    );
    return i ? (await Promise.allSettled(o())).map((s) => s.status === "fulfilled" ? { result: s.value, status: "success" } : { error: s.reason, result: void 0, status: "failure" }) : await Promise.all(o());
  }
}
async function Kq(t) {
  const e = await Jp({ chainId: t.chainId });
  if (!e)
    throw new Xi();
  t.chainId && H2({ chainId: t.chainId });
  let n;
  if (t.mode === "prepared")
    n = t.request;
  else {
    const { chainId: i, mode: a, ...o } = t;
    n = (await pO(o)).request;
  }
  return { hash: await e.writeContract({
    ...n,
    chain: t.chainId ? { id: t.chainId } : null
  }) };
}
async function $q({
  address: t,
  chainId: e,
  formatUnits: n,
  token: r
}) {
  const i = oa(), a = ki({ chainId: e });
  if (r) {
    const c = async ({ abi: d }) => {
      const u = { abi: d, address: r, chainId: e }, [h, N, M] = await Pq({
        allowFailure: !1,
        contracts: [
          {
            ...u,
            functionName: "balanceOf",
            args: [t]
          },
          { ...u, functionName: "decimals" },
          { ...u, functionName: "symbol" }
        ]
      });
      return {
        decimals: N,
        formatted: qi(h ?? "0", Xj(n ?? N)),
        symbol: M,
        value: h
      };
    };
    try {
      return await c({ abi: z3 });
    } catch (d) {
      if (d instanceof PE) {
        const { symbol: u, ...h } = await c({
          abi: Aq
        });
        return {
          symbol: QE(gd(u, { dir: "right" })),
          ...h
        };
      }
      throw d;
    }
  }
  const o = [
    ...i.publicClient.chains || [],
    ...i.chains ?? []
  ], s = await a.getBalance({ address: t }), l = o.find((c) => c.id === a.chain.id);
  return {
    decimals: (l == null ? void 0 : l.nativeCurrency.decimals) ?? 18,
    formatted: qi(s ?? "0", Xj(n ?? 18)),
    symbol: (l == null ? void 0 : l.nativeCurrency.symbol) ?? "ETH",
    value: s
  };
}
function Yf() {
  const { data: t, connector: e, status: n } = oa();
  switch (n) {
    case "connected":
      return {
        address: t == null ? void 0 : t.account,
        connector: e,
        isConnected: !0,
        isConnecting: !1,
        isDisconnected: !1,
        isReconnecting: !1,
        status: n
      };
    case "reconnecting":
      return {
        address: t == null ? void 0 : t.account,
        connector: e,
        isConnected: !!(t != null && t.account),
        isConnecting: !1,
        isDisconnected: !1,
        isReconnecting: !0,
        status: n
      };
    case "connecting":
      return {
        address: t == null ? void 0 : t.account,
        connector: e,
        isConnected: !1,
        isConnecting: !0,
        isDisconnected: !1,
        isReconnecting: !1,
        status: n
      };
    case "disconnected":
      return {
        address: void 0,
        connector: void 0,
        isConnected: !1,
        isConnecting: !1,
        isDisconnected: !0,
        isReconnecting: !1,
        status: n
      };
  }
}
function rM() {
  var i, a, o, s;
  const t = oa(), e = (a = (i = t.data) == null ? void 0 : i.chain) == null ? void 0 : a.id, n = t.chains ?? [], r = [
    ...((o = t.publicClient) == null ? void 0 : o.chains) || [],
    ...n
  ].find((l) => l.id === e) ?? {
    id: e,
    name: `Chain ${e}`,
    network: `${e}`,
    nativeCurrency: { name: "Ether", decimals: 18, symbol: "ETH" },
    rpcUrls: {
      default: { http: [""] },
      public: { http: [""] }
    }
  };
  return {
    chain: e ? {
      ...r,
      ...(s = t.data) == null ? void 0 : s.chain,
      id: e
    } : void 0,
    chains: n
  };
}
async function qq(t) {
  const e = await Jp();
  if (!e)
    throw new Xi();
  return await e.signMessage({
    message: t.message
  });
}
async function TO({
  chainId: t
}) {
  const { connector: e } = oa();
  if (!e)
    throw new Xi();
  if (!e.switchChain)
    throw new Yq({
      connector: e
    });
  return e.switchChain(t);
}
function fO(t, { selector: e = (n) => n } = {}) {
  const n = oa(), r = () => t(Yf());
  return n.subscribe(
    ({ data: a, connector: o, status: s }) => e({
      address: a == null ? void 0 : a.account,
      connector: o,
      status: s
    }),
    r,
    {
      equalityFn: NI
    }
  );
}
function VO(t, { selector: e = (n) => n } = {}) {
  const n = oa(), r = () => t(rM());
  return n.subscribe(
    ({ data: a, chains: o }) => {
      var s;
      return e({ chainId: (s = a == null ? void 0 : a.chain) == null ? void 0 : s.id, chains: o });
    },
    r,
    {
      equalityFn: NI
    }
  );
}
async function eee({
  chainId: t,
  name: e
}) {
  const { normalize: n } = await import("./index-239fa8b6.js"), i = await ki({ chainId: t }).getEnsAddress({
    name: n(e)
  });
  try {
    return i === "0x0000000000000000000000000000000000000000" ? null : i ? un(i) : null;
  } catch {
    return null;
  }
}
async function tee({
  name: t,
  chainId: e
}) {
  const { normalize: n } = await import("./index-239fa8b6.js");
  return await ki({ chainId: e }).getEnsAvatar({ name: n(t) });
}
async function nee({
  address: t,
  chainId: e
}) {
  return ki({ chainId: e }).getEnsName({
    address: un(t)
  });
}
async function ree({
  chainId: t
} = {}) {
  return await ki({ chainId: t }).getBlockNumber();
}
async function UO({
  accessList: t,
  account: e,
  chainId: n,
  data: r,
  gas: i,
  gasPrice: a,
  maxFeePerGas: o,
  maxPriorityFeePerGas: s,
  nonce: l,
  to: c,
  value: d,
  walletClient: u
}) {
  const h = ki({ chainId: n }), N = u ?? await Jp({ chainId: n });
  if (!N)
    throw new Xi();
  n && H2({ chainId: n });
  const M = (c && !Ni(c) ? await eee({ name: c }) : c) || void 0;
  if (M && !Ni(M))
    throw new Error("Invalid address");
  const p = typeof i > "u" ? await h.estimateGas({
    accessList: t,
    account: N.account,
    data: r,
    gas: i ?? void 0,
    gasPrice: a,
    maxFeePerGas: o,
    maxPriorityFeePerGas: s,
    nonce: l,
    to: M,
    value: d
  }) : i || void 0;
  return {
    accessList: t,
    account: e,
    data: r,
    gas: p,
    gasPrice: a,
    maxFeePerGas: o,
    maxPriorityFeePerGas: s,
    mode: "prepared",
    nonce: l,
    to: M,
    value: d,
    ...n ? { chainId: n } : {}
  };
}
async function iee({
  accessList: t,
  account: e,
  chainId: n,
  data: r,
  gas: i,
  gasPrice: a,
  maxFeePerGas: o,
  maxPriorityFeePerGas: s,
  mode: l,
  nonce: c,
  to: d,
  value: u
}) {
  const h = await Jp({ chainId: n });
  if (!h)
    throw new Xi();
  n && H2({ chainId: n });
  let N;
  return l === "prepared" ? N = {
    account: e,
    accessList: t,
    chain: null,
    data: r,
    gas: i,
    gasPrice: a,
    maxFeePerGas: o,
    maxPriorityFeePerGas: s,
    nonce: c,
    to: d,
    value: u
  } : N = await UO({
    accessList: t,
    account: e,
    chainId: n,
    data: r,
    gas: i || null,
    gasPrice: a,
    maxFeePerGas: o,
    maxPriorityFeePerGas: s,
    nonce: c,
    to: d,
    value: u
  }), { hash: await h.sendTransaction({
    ...N,
    chain: n ? { id: n } : null
  }) };
}
async function aee({
  chainId: t,
  confirmations: e = 1,
  hash: n,
  onReplaced: r,
  timeout: i = 0
}) {
  const a = ki({ chainId: t }), o = await a.waitForTransactionReceipt({
    hash: n,
    confirmations: e,
    onReplaced: r,
    timeout: i
  });
  if (o.status === "reverted") {
    const s = await a.getTransaction({
      hash: o.transactionHash
    }), l = await a.call({
      ...s,
      gasPrice: s.type !== "eip1559" ? s.gasPrice : void 0,
      maxFeePerGas: s.type === "eip1559" ? s.maxFeePerGas : void 0,
      maxPriorityFeePerGas: s.type === "eip1559" ? s.maxPriorityFeePerGas : void 0
    }), c = QE(`0x${l.substring(138)}`);
    throw new Error(c);
  }
  return o;
}
function H2({ chainId: t }) {
  var i, a;
  const { chain: e, chains: n } = rM(), r = e == null ? void 0 : e.id;
  if (r && t !== r)
    throw new Fq({
      activeChain: ((i = n.find((o) => o.id === r)) == null ? void 0 : i.name) ?? `Chain ${r}`,
      targetChain: ((a = n.find((o) => o.id === t)) == null ? void 0 : a.name) ?? `Chain ${t}`
    });
}
var bZ = { exports: {} }, HR = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $j;
function oee() {
  if ($j)
    return HR;
  $j = 1;
  var t = rr, e = B2;
  function n(c, d) {
    return c === d && (c !== 0 || 1 / c === 1 / d) || c !== c && d !== d;
  }
  var r = typeof Object.is == "function" ? Object.is : n, i = e.useSyncExternalStore, a = t.useRef, o = t.useEffect, s = t.useMemo, l = t.useDebugValue;
  return HR.useSyncExternalStoreWithSelector = function(c, d, u, h, N) {
    var M = a(null);
    if (M.current === null) {
      var p = { hasValue: !1, value: null };
      M.current = p;
    } else
      p = M.current;
    M = s(function() {
      function R(x) {
        if (!V) {
          if (V = !0, U = x, x = h(x), N !== void 0 && p.hasValue) {
            var f = p.value;
            if (N(f, x))
              return g = f;
          }
          return g = x;
        }
        if (f = g, r(U, x))
          return f;
        var D = h(x);
        return N !== void 0 && N(f, D) ? f : (U = x, g = D);
      }
      var V = !1, U, g, y = u === void 0 ? null : u;
      return [function() {
        return R(d());
      }, y === null ? void 0 : function() {
        return R(y());
      }];
    }, [d, u, h, N]);
    var m = i(c, M[0], M[1]);
    return o(function() {
      p.hasValue = !0, p.value = m;
    }, [m]), l(m), m;
  }, HR;
}
var XR = {}, qj;
function see() {
  return qj || (qj = 1, ue.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = rr, e = B2;
    function n(d, u) {
      return d === u && (d !== 0 || 1 / d === 1 / u) || d !== d && u !== u;
    }
    var r = typeof Object.is == "function" ? Object.is : n, i = e.useSyncExternalStore, a = t.useRef, o = t.useEffect, s = t.useMemo, l = t.useDebugValue;
    function c(d, u, h, N, M) {
      var p = a(null), m;
      p.current === null ? (m = {
        hasValue: !1,
        value: null
      }, p.current = m) : m = p.current;
      var R = s(function() {
        var y = !1, x, f, D = function(ne) {
          if (!y) {
            y = !0, x = ne;
            var O = N(ne);
            if (M !== void 0 && m.hasValue) {
              var T = m.value;
              if (M(T, O))
                return f = T, T;
            }
            return f = O, O;
          }
          var Z = x, z = f;
          if (r(Z, ne))
            return z;
          var j = N(ne);
          return M !== void 0 && M(z, j) ? z : (x = ne, f = j, j);
        }, Y = h === void 0 ? null : h, Q = function() {
          return D(u());
        }, G = Y === null ? void 0 : function() {
          return D(Y());
        };
        return [Q, G];
      }, [u, h, N, M]), V = R[0], U = R[1], g = i(d, V, U);
      return o(function() {
        m.hasValue = !0, m.value = g;
      }, [g]), l(g), g;
    }
    XR.useSyncExternalStoreWithSelector = c, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), XR;
}
ue.env.NODE_ENV === "production" ? bZ.exports = oee() : bZ.exports = see();
var k3 = bZ.exports;
function lee({
  queryClient: t = new oq({
    defaultOptions: {
      queries: {
        cacheTime: 1e3 * 60 * 60 * 24,
        networkMode: "offlineFirst",
        refetchOnWindowFocus: !1,
        retry: 0
      },
      mutations: {
        networkMode: "offlineFirst"
      }
    }
  }),
  storage: e = D3({
    storage: typeof window < "u" && window.localStorage ? window.localStorage : hO
  }),
  persister: n = typeof window < "u" ? B$({
    key: "cache",
    storage: e,
    serialize: (i) => i,
    deserialize: (i) => i
  }) : void 0,
  ...r
}) {
  const i = Bq({
    ...r,
    storage: e
  });
  return n && jq({
    queryClient: t,
    persister: n,
    dehydrateOptions: {
      shouldDehydrateQuery: (a) => a.cacheTime !== 0 && a.queryKey[0].persist !== !1
    }
  }), Object.assign(i, { queryClient: t });
}
var RO = H.createContext(void 0), X2 = H.createContext(
  void 0
);
function cee({
  children: t,
  config: e
}) {
  return H.createElement(RO.Provider, {
    children: H.createElement(Nq, {
      children: t,
      client: e.queryClient,
      context: X2
    }),
    value: e
  });
}
function _2() {
  const t = H.useContext(RO);
  if (!t)
    throw new Error(
      [
        "`useConfig` must be used within `WagmiConfig`.\n",
        "Read more: https://wagmi.sh/react/WagmiConfig"
      ].join(`
`)
    );
  return t;
}
var dee = B2.useSyncExternalStore;
function uee(t) {
  return Array.isArray(t);
}
function hee(t) {
  if (!eD(t))
    return !1;
  const e = t.constructor;
  if (typeof e > "u")
    return !0;
  const n = e.prototype;
  return !(!eD(n) || !n.hasOwnProperty("isPrototypeOf"));
}
function eD(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function Nee(t, e, n) {
  return uee(t) ? typeof e == "function" ? { ...n, queryKey: t, queryFn: e } : { ...e, queryKey: t } : t;
}
function Mee(t) {
  return JSON.stringify(
    t,
    (e, n) => hee(n) ? Object.keys(n).sort().reduce((r, i) => (r[i] = n[i], r), {}) : typeof n == "bigint" ? n.toString() : n
  );
}
function pee(t, e) {
  return typeof t == "function" ? t(...e) : !!t;
}
function mee(t, e) {
  const n = {};
  return Object.keys(t).forEach((r) => {
    Object.defineProperty(n, r, {
      configurable: !1,
      enumerable: !0,
      get: () => (e.trackedProps.add(r), t[r])
    });
  }), n;
}
function Tee(t, e) {
  const n = S3({ context: t.context }), r = Mq(), i = Tq(), a = n.defaultQueryOptions({
    ...t,
    queryKeyHashFn: Mee
  });
  a._optimisticResults = r ? "isRestoring" : "optimistic", a.onError && (a.onError = tr.batchCalls(
    a.onError
  )), a.onSuccess && (a.onSuccess = tr.batchCalls(
    a.onSuccess
  )), a.onSettled && (a.onSettled = tr.batchCalls(
    a.onSettled
  )), a.suspense && typeof a.staleTime != "number" && (a.staleTime = 1e3), (a.suspense || a.useErrorBoundary) && (i.isReset() || (a.retryOnMount = !1));
  const [o] = H.useState(
    () => new e(
      n,
      a
    )
  ), s = o.getOptimisticResult(a);
  if (dee(
    H.useCallback(
      (u) => r ? () => {
      } : o.subscribe(tr.batchCalls(u)),
      [o, r]
    ),
    () => o.getCurrentResult(),
    () => o.getCurrentResult()
  ), H.useEffect(() => {
    i.clearReset();
  }, [i]), H.useEffect(() => {
    o.setOptions(a, { listeners: !1 });
  }, [a, o]), a.suspense && s.isLoading && s.isFetching && !r)
    throw o.fetchOptimistic(a).then(({ data: u }) => {
      var h, N;
      (h = a.onSuccess) == null || h.call(a, u), (N = a.onSettled) == null || N.call(a, u, null);
    }).catch((u) => {
      var h, N;
      i.clearReset(), (h = a.onError) == null || h.call(a, u), (N = a.onSettled) == null || N.call(a, void 0, u);
    });
  if (s.isError && !i.isReset() && !s.isFetching && pee(a.useErrorBoundary, [
    s.error,
    o.getCurrentQuery()
  ]))
    throw s.error;
  const l = s.status === "loading" && s.fetchStatus === "idle" ? "idle" : s.status, c = l === "idle", d = l === "loading" && s.fetchStatus === "fetching";
  return {
    ...s,
    defaultedOptions: a,
    isIdle: c,
    isLoading: d,
    observer: o,
    status: l
  };
}
function w3(t, e, n) {
  const r = nO(t, e, n);
  return Vq({ context: X2, ...r });
}
function gO(t, e, n) {
  const r = Nee(t, e, n), i = Tee({ context: X2, ...r }, sq), a = {
    data: i.data,
    error: i.error,
    fetchStatus: i.fetchStatus,
    isError: i.isError,
    isFetched: i.isFetched,
    isFetchedAfterMount: i.isFetchedAfterMount,
    isFetching: i.isFetching,
    isIdle: i.isIdle,
    isLoading: i.isLoading,
    isRefetching: i.isRefetching,
    isSuccess: i.isSuccess,
    refetch: i.refetch,
    status: i.status,
    internal: {
      dataUpdatedAt: i.dataUpdatedAt,
      errorUpdatedAt: i.errorUpdatedAt,
      failureCount: i.failureCount,
      isFetchedAfterMount: i.isFetchedAfterMount,
      isLoadingError: i.isLoadingError,
      isPaused: i.isPaused,
      isPlaceholderData: i.isPlaceholderData,
      isPreviousData: i.isPreviousData,
      isRefetchError: i.isRefetchError,
      isStale: i.isStale,
      remove: i.remove
    }
  };
  return i.defaultedOptions.notifyOnChangeProps ? a : mee(a, i.observer);
}
var yO = () => S3({ context: X2 });
function ZO({
  chainId: t
} = {}) {
  return k3.useSyncExternalStoreWithSelector(
    (e) => Hq({ chainId: t }, e),
    () => ki({ chainId: t }),
    () => ki({ chainId: t }),
    (e) => e,
    (e, n) => e.uid === n.uid
  );
}
function fee({ chainId: t } = {}) {
  return k3.useSyncExternalStoreWithSelector(
    (e) => Xq({ chainId: t }, e),
    () => ZZ({ chainId: t }),
    () => ZZ({ chainId: t }),
    (e) => e,
    (e, n) => (e == null ? void 0 : e.uid) === (n == null ? void 0 : n.uid)
  );
}
function bO({ chainId: t } = {}) {
  return ZO({ chainId: t }).chain.id;
}
function Vee() {
  const [, t] = H.useReducer((e) => e + 1, 0);
  return t;
}
function tD({ chainId: t, scopeKey: e }) {
  return [{ entity: "blockNumber", chainId: t, scopeKey: e }];
}
function Uee({
  queryKey: [{ chainId: t }]
}) {
  return ree({ chainId: t });
}
function EO({
  cacheTime: t = 0,
  chainId: e,
  enabled: n = !0,
  scopeKey: r,
  staleTime: i,
  suspense: a,
  watch: o = !1,
  onBlock: s,
  onError: l,
  onSettled: c,
  onSuccess: d
} = {}) {
  const u = bO({ chainId: e }), h = ZO({ chainId: u }), N = fee({ chainId: u }), M = yO();
  return H.useEffect(() => !n || !o && !s ? void 0 : (N ?? h).watchBlockNumber({
    onBlockNumber: (R) => {
      o && M.setQueryData(tD({ chainId: u, scopeKey: r }), R), s && s(R);
    },
    emitOnBegin: !0
  }), [
    u,
    r,
    s,
    h,
    M,
    o,
    N,
    n
  ]), gO(tD({ scopeKey: r, chainId: u }), Uee, {
    cacheTime: t,
    enabled: n,
    staleTime: i,
    suspense: a,
    onError: l,
    onSettled: c,
    onSuccess: d
  });
}
function Ree({
  chainId: t,
  enabled: e,
  queryKey: n
}) {
  const r = yO(), i = H.useCallback(
    () => r.invalidateQueries({ queryKey: n }, { cancelRefetch: !1 }),
    [r, n]
  );
  EO({
    chainId: t,
    enabled: e,
    onBlock: e ? i : void 0,
    scopeKey: e ? void 0 : "idle"
  });
}
var _R = (t) => typeof t == "object" && !Array.isArray(t);
function SO(t, e, n = e, r = Of) {
  const i = H.useRef([]), a = k3.useSyncExternalStoreWithSelector(
    t,
    e,
    n,
    (o) => o,
    (o, s) => {
      if (_R(o) && _R(s) && i.current.length) {
        for (const l of i.current)
          if (!r(
            o[l],
            s[l]
          ))
            return !1;
        return !0;
      }
      return r(o, s);
    }
  );
  if (_R(a)) {
    const o = { ...a };
    return Object.defineProperties(
      o,
      Object.entries(o).reduce(
        (s, [l, c]) => ({
          ...s,
          [l]: {
            configurable: !1,
            enumerable: !0,
            get: () => (i.current.includes(l) || i.current.push(l), c)
          }
        }),
        {}
      )
    ), o;
  }
  return a;
}
function Ui({ onConnect: t, onDisconnect: e } = {}) {
  const n = _2(), r = H.useCallback(
    (s) => fO(s),
    [n]
  ), i = SO(r, Yf), a = H.useRef(), o = a.current;
  return H.useEffect(() => {
    (o == null ? void 0 : o.status) !== "connected" && i.status === "connected" && (t == null || t({
      address: i.address,
      connector: i.connector,
      isReconnected: (o == null ? void 0 : o.status) === "reconnecting" || (o == null ? void 0 : o.status) === void 0
    })), (o == null ? void 0 : o.status) === "connected" && i.status === "disconnected" && (e == null || e()), a.current = i;
  }, [t, e, o, i]), i;
}
var gee = (t) => [{ entity: "connect", ...t }], yee = (t) => {
  const { connector: e, chainId: n } = t;
  if (!e)
    throw new Error("connector is required");
  return yZ({ connector: e, chainId: n });
};
function Zee({
  chainId: t,
  connector: e,
  onError: n,
  onMutate: r,
  onSettled: i,
  onSuccess: a
} = {}) {
  const o = _2(), {
    data: s,
    error: l,
    isError: c,
    isIdle: d,
    isLoading: u,
    isSuccess: h,
    mutate: N,
    mutateAsync: M,
    reset: p,
    status: m,
    variables: R
  } = w3(gee({ connector: e, chainId: t }), yee, {
    onError: n,
    onMutate: r,
    onSettled: i,
    onSuccess: a
  }), V = H.useCallback(
    (g) => N({
      chainId: (g == null ? void 0 : g.chainId) ?? t,
      connector: (g == null ? void 0 : g.connector) ?? e
    }),
    [t, e, N]
  ), U = H.useCallback(
    (g) => M({
      chainId: (g == null ? void 0 : g.chainId) ?? t,
      connector: (g == null ? void 0 : g.connector) ?? e
    }),
    [t, e, M]
  );
  return {
    connect: V,
    connectAsync: U,
    connectors: o.connectors,
    data: s,
    error: l,
    isError: c,
    isIdle: d,
    isLoading: u,
    isSuccess: h,
    pendingConnector: R == null ? void 0 : R.connector,
    reset: p,
    status: m,
    variables: R
  };
}
var bee = [{ entity: "disconnect" }], Eee = () => MO();
function See({
  onError: t,
  onMutate: e,
  onSettled: n,
  onSuccess: r
} = {}) {
  const {
    error: i,
    isError: a,
    isIdle: o,
    isLoading: s,
    isSuccess: l,
    mutate: c,
    mutateAsync: d,
    reset: u,
    status: h
  } = w3(bee, Eee, {
    ...t ? {
      onError(N, M, p) {
        t(N, p);
      }
    } : {},
    onMutate: e,
    ...n ? {
      onSettled(N, M, p, m) {
        n(M, m);
      }
    } : {},
    ...r ? {
      onSuccess(N, M, p) {
        r(p);
      }
    } : {}
  });
  return {
    disconnect: c,
    disconnectAsync: d,
    error: i,
    isError: a,
    isIdle: o,
    isLoading: s,
    isSuccess: l,
    reset: u,
    status: h
  };
}
function lu() {
  const t = _2(), e = De(
    (n) => VO(n),
    [t]
  );
  return SO(e, rM);
}
var xee = (t) => [{ entity: "switchNetwork", ...t }], Wee = (t) => {
  const { chainId: e } = t;
  if (!e)
    throw new Error("chainId is required");
  return TO({ chainId: e });
};
function jee({
  chainId: t,
  throwForSwitchChainNotSupported: e,
  onError: n,
  onMutate: r,
  onSettled: i,
  onSuccess: a
} = {}) {
  var D;
  const o = _2(), s = Vee(), {
    data: l,
    error: c,
    isError: d,
    isIdle: u,
    isLoading: h,
    isSuccess: N,
    mutate: M,
    mutateAsync: p,
    reset: m,
    status: R,
    variables: V
  } = w3(xee({ chainId: t }), Wee, {
    onError: n,
    onMutate: r,
    onSettled: i,
    onSuccess: a
  }), U = H.useCallback(
    (Y) => M({ chainId: Y ?? t }),
    [t, M]
  ), g = H.useCallback(
    (Y) => p({ chainId: Y ?? t }),
    [t, p]
  );
  H.useEffect(() => o.subscribe(
    ({ chains: Q, connector: G }) => ({
      chains: Q,
      connector: G
    }),
    s
  ), [o, s]);
  let y, x;
  const f = !!((D = o.connector) != null && D.switchChain);
  return (e || f) && (y = U, x = g), {
    chains: o.chains ?? [],
    data: l,
    error: c,
    isError: d,
    isIdle: u,
    isLoading: h,
    isSuccess: N,
    pendingChainId: V == null ? void 0 : V.chainId,
    reset: m,
    status: R,
    switchNetwork: y,
    switchNetworkAsync: x,
    variables: V
  };
}
function Dee({
  account: t,
  address: e,
  args: n,
  blockNumber: r,
  blockTag: i,
  chainId: a,
  functionName: o,
  scopeKey: s
}) {
  return [
    {
      entity: "readContract",
      account: t,
      address: e,
      args: n,
      blockNumber: r,
      blockTag: i,
      chainId: a,
      functionName: o,
      scopeKey: s
    }
  ];
}
function zee({ abi: t }) {
  return async ({
    queryKey: [
      { account: e, address: n, args: r, blockNumber: i, blockTag: a, chainId: o, functionName: s }
    ]
  }) => {
    if (!t)
      throw new Error("abi is required");
    if (!n)
      throw new Error("address is required");
    return await mO({
      account: e,
      address: n,
      args: r,
      blockNumber: i,
      blockTag: a,
      chainId: o,
      abi: t,
      functionName: s
    }) ?? null;
  };
}
function kee({
  abi: t,
  address: e,
  account: n,
  args: r,
  blockNumber: i,
  blockTag: a,
  cacheOnBlock: o = !1,
  cacheTime: s,
  chainId: l,
  enabled: c = !0,
  functionName: d,
  isDataEqual: u,
  keepPreviousData: h,
  onError: N,
  onSettled: M,
  onSuccess: p,
  scopeKey: m,
  select: R,
  staleTime: V,
  structuralSharing: U = (x, f) => Of(x, f) ? x : Z3(x, f),
  suspense: g,
  watch: y
} = {}) {
  const x = bO({ chainId: l }), { data: f } = EO({
    chainId: x,
    enabled: y || o,
    scopeKey: y || o ? void 0 : "idle",
    watch: y
  }), D = i ?? f, Y = H.useMemo(
    () => Dee({
      account: n,
      address: e,
      args: r,
      blockNumber: o ? D : void 0,
      blockTag: a,
      chainId: x,
      functionName: d,
      scopeKey: m
    }),
    [
      n,
      e,
      r,
      D,
      a,
      o,
      x,
      d,
      m
    ]
  ), Q = H.useMemo(() => {
    let G = !!(c && t && e && d);
    return o && (G = !!(G && D)), G;
  }, [t, e, D, o, c, d]);
  return Ree({
    chainId: x,
    enabled: !!(Q && y && !o),
    queryKey: Y
  }), gO(
    Y,
    zee({
      abi: t
    }),
    {
      cacheTime: s,
      enabled: Q,
      isDataEqual: u,
      keepPreviousData: h,
      select: R,
      staleTime: V,
      structuralSharing: U,
      suspense: g,
      onError: N,
      onSettled: M,
      onSuccess: p
    }
  );
}
function xO(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: WO } = Object.prototype, { getPrototypeOf: F3 } = Object, v3 = ((t) => (e) => {
  const n = WO.call(e);
  return t[n] || (t[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), As = (t) => (t = t.toLowerCase(), (e) => v3(e) === t), P2 = (t) => (e) => typeof e === t, { isArray: qh } = Array, iM = P2("undefined");
function wee(t) {
  return t !== null && !iM(t) && t.constructor !== null && !iM(t.constructor) && rc(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const jO = As("ArrayBuffer");
function Fee(t) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && jO(t.buffer), e;
}
const vee = P2("string"), rc = P2("function"), DO = P2("number"), I3 = (t) => t !== null && typeof t == "object", Iee = (t) => t === !0 || t === !1, QT = (t) => {
  if (v3(t) !== "object")
    return !1;
  const e = F3(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}, Oee = As("Date"), Yee = As("File"), Qee = As("Blob"), Gee = As("FileList"), Cee = (t) => I3(t) && rc(t.pipe), Lee = (t) => {
  const e = "[object FormData]";
  return t && (typeof FormData == "function" && t instanceof FormData || WO.call(t) === e || rc(t.toString) && t.toString() === e);
}, Jee = As("URLSearchParams"), Bee = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Bp(t, e, { allOwnKeys: n = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let r, i;
  if (typeof t != "object" && (t = [t]), qh(t))
    for (r = 0, i = t.length; r < i; r++)
      e.call(null, t[r], r, t);
  else {
    const a = n ? Object.getOwnPropertyNames(t) : Object.keys(t), o = a.length;
    let s;
    for (r = 0; r < o; r++)
      s = a[r], e.call(null, t[s], s, t);
  }
}
function zO(t, e) {
  e = e.toLowerCase();
  const n = Object.keys(t);
  let r = n.length, i;
  for (; r-- > 0; )
    if (i = n[r], e === i.toLowerCase())
      return i;
  return null;
}
const kO = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : $i)(), wO = (t) => !iM(t) && t !== kO;
function EZ() {
  const { caseless: t } = wO(this) && this || {}, e = {}, n = (r, i) => {
    const a = t && zO(e, i) || i;
    QT(e[a]) && QT(r) ? e[a] = EZ(e[a], r) : QT(r) ? e[a] = EZ({}, r) : qh(r) ? e[a] = r.slice() : e[a] = r;
  };
  for (let r = 0, i = arguments.length; r < i; r++)
    arguments[r] && Bp(arguments[r], n);
  return e;
}
const Aee = (t, e, n, { allOwnKeys: r } = {}) => (Bp(e, (i, a) => {
  n && rc(i) ? t[a] = xO(i, n) : t[a] = i;
}, { allOwnKeys: r }), t), Hee = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), Xee = (t, e, n, r) => {
  t.prototype = Object.create(e.prototype, r), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: e.prototype
  }), n && Object.assign(t.prototype, n);
}, _ee = (t, e, n, r) => {
  let i, a, o;
  const s = {};
  if (e = e || {}, t == null)
    return e;
  do {
    for (i = Object.getOwnPropertyNames(t), a = i.length; a-- > 0; )
      o = i[a], (!r || r(o, t, e)) && !s[o] && (e[o] = t[o], s[o] = !0);
    t = n !== !1 && F3(t);
  } while (t && (!n || n(t, e)) && t !== Object.prototype);
  return e;
}, Pee = (t, e, n) => {
  t = String(t), (n === void 0 || n > t.length) && (n = t.length), n -= e.length;
  const r = t.indexOf(e, n);
  return r !== -1 && r === n;
}, Kee = (t) => {
  if (!t)
    return null;
  if (qh(t))
    return t;
  let e = t.length;
  if (!DO(e))
    return null;
  const n = new Array(e);
  for (; e-- > 0; )
    n[e] = t[e];
  return n;
}, $ee = ((t) => (e) => t && e instanceof t)(typeof Uint8Array < "u" && F3(Uint8Array)), qee = (t, e) => {
  const r = (t && t[Symbol.iterator]).call(t);
  let i;
  for (; (i = r.next()) && !i.done; ) {
    const a = i.value;
    e.call(t, a[0], a[1]);
  }
}, ete = (t, e) => {
  let n;
  const r = [];
  for (; (n = t.exec(e)) !== null; )
    r.push(n);
  return r;
}, tte = As("HTMLFormElement"), nte = (t) => t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, i) {
    return r.toUpperCase() + i;
  }
), nD = (({ hasOwnProperty: t }) => (e, n) => t.call(e, n))(Object.prototype), rte = As("RegExp"), FO = (t, e) => {
  const n = Object.getOwnPropertyDescriptors(t), r = {};
  Bp(n, (i, a) => {
    e(i, a, t) !== !1 && (r[a] = i);
  }), Object.defineProperties(t, r);
}, ite = (t) => {
  FO(t, (e, n) => {
    if (rc(t) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = t[n];
    if (rc(r)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, ate = (t, e) => {
  const n = {}, r = (i) => {
    i.forEach((a) => {
      n[a] = !0;
    });
  };
  return qh(t) ? r(t) : r(String(t).split(e)), n;
}, ote = () => {
}, ste = (t, e) => (t = +t, Number.isFinite(t) ? t : e), PR = "abcdefghijklmnopqrstuvwxyz", rD = "0123456789", vO = {
  DIGIT: rD,
  ALPHA: PR,
  ALPHA_DIGIT: PR + PR.toUpperCase() + rD
}, lte = (t = 16, e = vO.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = e;
  for (; t--; )
    n += e[Math.random() * r | 0];
  return n;
};
function cte(t) {
  return !!(t && rc(t.append) && t[Symbol.toStringTag] === "FormData" && t[Symbol.iterator]);
}
const dte = (t) => {
  const e = new Array(10), n = (r, i) => {
    if (I3(r)) {
      if (e.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        e[i] = r;
        const a = qh(r) ? [] : {};
        return Bp(r, (o, s) => {
          const l = n(o, i + 1);
          !iM(l) && (a[s] = l);
        }), e[i] = void 0, a;
      }
    }
    return r;
  };
  return n(t, 0);
}, ce = {
  isArray: qh,
  isArrayBuffer: jO,
  isBuffer: wee,
  isFormData: Lee,
  isArrayBufferView: Fee,
  isString: vee,
  isNumber: DO,
  isBoolean: Iee,
  isObject: I3,
  isPlainObject: QT,
  isUndefined: iM,
  isDate: Oee,
  isFile: Yee,
  isBlob: Qee,
  isRegExp: rte,
  isFunction: rc,
  isStream: Cee,
  isURLSearchParams: Jee,
  isTypedArray: $ee,
  isFileList: Gee,
  forEach: Bp,
  merge: EZ,
  extend: Aee,
  trim: Bee,
  stripBOM: Hee,
  inherits: Xee,
  toFlatObject: _ee,
  kindOf: v3,
  kindOfTest: As,
  endsWith: Pee,
  toArray: Kee,
  forEachEntry: qee,
  matchAll: ete,
  isHTMLForm: tte,
  hasOwnProperty: nD,
  hasOwnProp: nD,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: FO,
  freezeMethods: ite,
  toObjectSet: ate,
  toCamelCase: nte,
  noop: ote,
  toFiniteNumber: ste,
  findKey: zO,
  global: kO,
  isContextDefined: wO,
  ALPHABET: vO,
  generateString: lte,
  isSpecCompliantForm: cte,
  toJSONObject: dte
};
function Kt(t, e, n, r, i) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), n && (this.config = n), r && (this.request = r), i && (this.response = i);
}
ce.inherits(Kt, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: ce.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const IO = Kt.prototype, OO = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((t) => {
  OO[t] = { value: t };
});
Object.defineProperties(Kt, OO);
Object.defineProperty(IO, "isAxiosError", { value: !0 });
Kt.from = (t, e, n, r, i, a) => {
  const o = Object.create(IO);
  return ce.toFlatObject(t, o, function(l) {
    return l !== Error.prototype;
  }, (s) => s !== "isAxiosError"), Kt.call(o, t.message, e, n, r, i), o.cause = t, o.name = t.name, a && Object.assign(o, a), o;
};
const ute = null;
function SZ(t) {
  return ce.isPlainObject(t) || ce.isArray(t);
}
function YO(t) {
  return ce.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function iD(t, e, n) {
  return t ? t.concat(e).map(function(i, a) {
    return i = YO(i), !n && a ? "[" + i + "]" : i;
  }).join(n ? "." : "") : e;
}
function hte(t) {
  return ce.isArray(t) && !t.some(SZ);
}
const Nte = ce.toFlatObject(ce, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function K2(t, e, n) {
  if (!ce.isObject(t))
    throw new TypeError("target must be an object");
  e = e || new FormData(), n = ce.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(p, m) {
    return !ce.isUndefined(m[p]);
  });
  const r = n.metaTokens, i = n.visitor || d, a = n.dots, o = n.indexes, l = (n.Blob || typeof Blob < "u" && Blob) && ce.isSpecCompliantForm(e);
  if (!ce.isFunction(i))
    throw new TypeError("visitor must be a function");
  function c(M) {
    if (M === null)
      return "";
    if (ce.isDate(M))
      return M.toISOString();
    if (!l && ce.isBlob(M))
      throw new Kt("Blob is not supported. Use a Buffer instead.");
    return ce.isArrayBuffer(M) || ce.isTypedArray(M) ? l && typeof Blob == "function" ? new Blob([M]) : Ne.from(M) : M;
  }
  function d(M, p, m) {
    let R = M;
    if (M && !m && typeof M == "object") {
      if (ce.endsWith(p, "{}"))
        p = r ? p : p.slice(0, -2), M = JSON.stringify(M);
      else if (ce.isArray(M) && hte(M) || (ce.isFileList(M) || ce.endsWith(p, "[]")) && (R = ce.toArray(M)))
        return p = YO(p), R.forEach(function(U, g) {
          !(ce.isUndefined(U) || U === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? iD([p], g, a) : o === null ? p : p + "[]",
            c(U)
          );
        }), !1;
    }
    return SZ(M) ? !0 : (e.append(iD(m, p, a), c(M)), !1);
  }
  const u = [], h = Object.assign(Nte, {
    defaultVisitor: d,
    convertValue: c,
    isVisitable: SZ
  });
  function N(M, p) {
    if (!ce.isUndefined(M)) {
      if (u.indexOf(M) !== -1)
        throw Error("Circular reference detected in " + p.join("."));
      u.push(M), ce.forEach(M, function(R, V) {
        (!(ce.isUndefined(R) || R === null) && i.call(
          e,
          R,
          ce.isString(V) ? V.trim() : V,
          p,
          h
        )) === !0 && N(R, p ? p.concat(V) : [V]);
      }), u.pop();
    }
  }
  if (!ce.isObject(t))
    throw new TypeError("data must be an object");
  return N(t), e;
}
function aD(t) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(r) {
    return e[r];
  });
}
function O3(t, e) {
  this._pairs = [], t && K2(t, this, e);
}
const QO = O3.prototype;
QO.append = function(e, n) {
  this._pairs.push([e, n]);
};
QO.toString = function(e) {
  const n = e ? function(r) {
    return e.call(this, r, aD);
  } : aD;
  return this._pairs.map(function(i) {
    return n(i[0]) + "=" + n(i[1]);
  }, "").join("&");
};
function Mte(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function GO(t, e, n) {
  if (!e)
    return t;
  const r = n && n.encode || Mte, i = n && n.serialize;
  let a;
  if (i ? a = i(e, n) : a = ce.isURLSearchParams(e) ? e.toString() : new O3(e, n).toString(r), a) {
    const o = t.indexOf("#");
    o !== -1 && (t = t.slice(0, o)), t += (t.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return t;
}
class pte {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, n, r) {
    return this.handlers.push({
      fulfilled: e,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    ce.forEach(this.handlers, function(r) {
      r !== null && e(r);
    });
  }
}
const oD = pte, CO = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, mte = typeof URLSearchParams < "u" ? URLSearchParams : O3, Tte = typeof FormData < "u" ? FormData : null, fte = (() => {
  let t;
  return typeof navigator < "u" && ((t = navigator.product) === "ReactNative" || t === "NativeScript" || t === "NS") ? !1 : typeof window < "u" && typeof document < "u";
})(), Vte = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), yo = {
  isBrowser: !0,
  classes: {
    URLSearchParams: mte,
    FormData: Tte,
    Blob
  },
  isStandardBrowserEnv: fte,
  isStandardBrowserWebWorkerEnv: Vte,
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
function Ute(t, e) {
  return K2(t, new yo.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, i, a) {
      return yo.isNode && ce.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : a.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function Rte(t) {
  return ce.matchAll(/\w+|\[(\w*)]/g, t).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function gte(t) {
  const e = {}, n = Object.keys(t);
  let r;
  const i = n.length;
  let a;
  for (r = 0; r < i; r++)
    a = n[r], e[a] = t[a];
  return e;
}
function LO(t) {
  function e(n, r, i, a) {
    let o = n[a++];
    const s = Number.isFinite(+o), l = a >= n.length;
    return o = !o && ce.isArray(i) ? i.length : o, l ? (ce.hasOwnProp(i, o) ? i[o] = [i[o], r] : i[o] = r, !s) : ((!i[o] || !ce.isObject(i[o])) && (i[o] = []), e(n, r, i[o], a) && ce.isArray(i[o]) && (i[o] = gte(i[o])), !s);
  }
  if (ce.isFormData(t) && ce.isFunction(t.entries)) {
    const n = {};
    return ce.forEachEntry(t, (r, i) => {
      e(Rte(r), i, n, 0);
    }), n;
  }
  return null;
}
const yte = {
  "Content-Type": void 0
};
function Zte(t, e, n) {
  if (ce.isString(t))
    try {
      return (e || JSON.parse)(t), ce.trim(t);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(t);
}
const $2 = {
  transitional: CO,
  adapter: ["xhr", "http"],
  transformRequest: [function(e, n) {
    const r = n.getContentType() || "", i = r.indexOf("application/json") > -1, a = ce.isObject(e);
    if (a && ce.isHTMLForm(e) && (e = new FormData(e)), ce.isFormData(e))
      return i && i ? JSON.stringify(LO(e)) : e;
    if (ce.isArrayBuffer(e) || ce.isBuffer(e) || ce.isStream(e) || ce.isFile(e) || ce.isBlob(e))
      return e;
    if (ce.isArrayBufferView(e))
      return e.buffer;
    if (ce.isURLSearchParams(e))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let s;
    if (a) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return Ute(e, this.formSerializer).toString();
      if ((s = ce.isFileList(e)) || r.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return K2(
          s ? { "files[]": e } : e,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return a || i ? (n.setContentType("application/json", !1), Zte(e)) : e;
  }],
  transformResponse: [function(e) {
    const n = this.transitional || $2.transitional, r = n && n.forcedJSONParsing, i = this.responseType === "json";
    if (e && ce.isString(e) && (r && !this.responseType || i)) {
      const o = !(n && n.silentJSONParsing) && i;
      try {
        return JSON.parse(e);
      } catch (s) {
        if (o)
          throw s.name === "SyntaxError" ? Kt.from(s, Kt.ERR_BAD_RESPONSE, this, null, this.response) : s;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: yo.classes.FormData,
    Blob: yo.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
ce.forEach(["delete", "get", "head"], function(e) {
  $2.headers[e] = {};
});
ce.forEach(["post", "put", "patch"], function(e) {
  $2.headers[e] = ce.merge(yte);
});
const Y3 = $2, bte = ce.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Ete = (t) => {
  const e = {};
  let n, r, i;
  return t && t.split(`
`).forEach(function(o) {
    i = o.indexOf(":"), n = o.substring(0, i).trim().toLowerCase(), r = o.substring(i + 1).trim(), !(!n || e[n] && bte[n]) && (n === "set-cookie" ? e[n] ? e[n].push(r) : e[n] = [r] : e[n] = e[n] ? e[n] + ", " + r : r);
  }), e;
}, sD = Symbol("internals");
function ZN(t) {
  return t && String(t).trim().toLowerCase();
}
function GT(t) {
  return t === !1 || t == null ? t : ce.isArray(t) ? t.map(GT) : String(t);
}
function Ste(t) {
  const e = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(t); )
    e[r[1]] = r[2];
  return e;
}
function xte(t) {
  return /^[-_a-zA-Z]+$/.test(t.trim());
}
function KR(t, e, n, r, i) {
  if (ce.isFunction(r))
    return r.call(this, e, n);
  if (i && (e = n), !!ce.isString(e)) {
    if (ce.isString(r))
      return e.indexOf(r) !== -1;
    if (ce.isRegExp(r))
      return r.test(e);
  }
}
function Wte(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, n, r) => n.toUpperCase() + r);
}
function jte(t, e) {
  const n = ce.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(t, r + n, {
      value: function(i, a, o) {
        return this[r].call(this, e, i, a, o);
      },
      configurable: !0
    });
  });
}
class q2 {
  constructor(e) {
    e && this.set(e);
  }
  set(e, n, r) {
    const i = this;
    function a(s, l, c) {
      const d = ZN(l);
      if (!d)
        throw new Error("header name must be a non-empty string");
      const u = ce.findKey(i, d);
      (!u || i[u] === void 0 || c === !0 || c === void 0 && i[u] !== !1) && (i[u || l] = GT(s));
    }
    const o = (s, l) => ce.forEach(s, (c, d) => a(c, d, l));
    return ce.isPlainObject(e) || e instanceof this.constructor ? o(e, n) : ce.isString(e) && (e = e.trim()) && !xte(e) ? o(Ete(e), n) : e != null && a(n, e, r), this;
  }
  get(e, n) {
    if (e = ZN(e), e) {
      const r = ce.findKey(this, e);
      if (r) {
        const i = this[r];
        if (!n)
          return i;
        if (n === !0)
          return Ste(i);
        if (ce.isFunction(n))
          return n.call(this, i, r);
        if (ce.isRegExp(n))
          return n.exec(i);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, n) {
    if (e = ZN(e), e) {
      const r = ce.findKey(this, e);
      return !!(r && this[r] !== void 0 && (!n || KR(this, this[r], r, n)));
    }
    return !1;
  }
  delete(e, n) {
    const r = this;
    let i = !1;
    function a(o) {
      if (o = ZN(o), o) {
        const s = ce.findKey(r, o);
        s && (!n || KR(r, r[s], s, n)) && (delete r[s], i = !0);
      }
    }
    return ce.isArray(e) ? e.forEach(a) : a(e), i;
  }
  clear(e) {
    const n = Object.keys(this);
    let r = n.length, i = !1;
    for (; r--; ) {
      const a = n[r];
      (!e || KR(this, this[a], a, e, !0)) && (delete this[a], i = !0);
    }
    return i;
  }
  normalize(e) {
    const n = this, r = {};
    return ce.forEach(this, (i, a) => {
      const o = ce.findKey(r, a);
      if (o) {
        n[o] = GT(i), delete n[a];
        return;
      }
      const s = e ? Wte(a) : String(a).trim();
      s !== a && delete n[a], n[s] = GT(i), r[s] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const n = /* @__PURE__ */ Object.create(null);
    return ce.forEach(this, (r, i) => {
      r != null && r !== !1 && (n[i] = e && ce.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, n]) => e + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...n) {
    const r = new this(e);
    return n.forEach((i) => r.set(i)), r;
  }
  static accessor(e) {
    const r = (this[sD] = this[sD] = {
      accessors: {}
    }).accessors, i = this.prototype;
    function a(o) {
      const s = ZN(o);
      r[s] || (jte(i, o), r[s] = !0);
    }
    return ce.isArray(e) ? e.forEach(a) : a(e), this;
  }
}
q2.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
ce.freezeMethods(q2.prototype);
ce.freezeMethods(q2);
const bs = q2;
function $R(t, e) {
  const n = this || Y3, r = e || n, i = bs.from(r.headers);
  let a = r.data;
  return ce.forEach(t, function(s) {
    a = s.call(n, a, i.normalize(), e ? e.status : void 0);
  }), i.normalize(), a;
}
function JO(t) {
  return !!(t && t.__CANCEL__);
}
function Ap(t, e, n) {
  Kt.call(this, t ?? "canceled", Kt.ERR_CANCELED, e, n), this.name = "CanceledError";
}
ce.inherits(Ap, Kt, {
  __CANCEL__: !0
});
function Dte(t, e, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? t(n) : e(new Kt(
    "Request failed with status code " + n.status,
    [Kt.ERR_BAD_REQUEST, Kt.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
const zte = yo.isStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  function() {
    return {
      write: function(n, r, i, a, o, s) {
        const l = [];
        l.push(n + "=" + encodeURIComponent(r)), ce.isNumber(i) && l.push("expires=" + new Date(i).toGMTString()), ce.isString(a) && l.push("path=" + a), ce.isString(o) && l.push("domain=" + o), s === !0 && l.push("secure"), document.cookie = l.join("; ");
      },
      read: function(n) {
        const r = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
        return r ? decodeURIComponent(r[3]) : null;
      },
      remove: function(n) {
        this.write(n, "", Date.now() - 864e5);
      }
    };
  }()
) : (
  // Non standard browser env (web workers, react-native) lack needed support.
  function() {
    return {
      write: function() {
      },
      read: function() {
        return null;
      },
      remove: function() {
      }
    };
  }()
);
function kte(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function wte(t, e) {
  return e ? t.replace(/\/+$/, "") + "/" + e.replace(/^\/+/, "") : t;
}
function BO(t, e) {
  return t && !kte(e) ? wte(t, e) : e;
}
const Fte = yo.isStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const e = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a");
    let r;
    function i(a) {
      let o = a;
      return e && (n.setAttribute("href", o), o = n.href), n.setAttribute("href", o), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return r = i(window.location.href), function(o) {
      const s = ce.isString(o) ? i(o) : o;
      return s.protocol === r.protocol && s.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function() {
    return function() {
      return !0;
    };
  }()
);
function vte(t) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return e && e[1] || "";
}
function Ite(t, e) {
  t = t || 10;
  const n = new Array(t), r = new Array(t);
  let i = 0, a = 0, o;
  return e = e !== void 0 ? e : 1e3, function(l) {
    const c = Date.now(), d = r[a];
    o || (o = c), n[i] = l, r[i] = c;
    let u = a, h = 0;
    for (; u !== i; )
      h += n[u++], u = u % t;
    if (i = (i + 1) % t, i === a && (a = (a + 1) % t), c - o < e)
      return;
    const N = d && c - d;
    return N ? Math.round(h * 1e3 / N) : void 0;
  };
}
function lD(t, e) {
  let n = 0;
  const r = Ite(50, 250);
  return (i) => {
    const a = i.loaded, o = i.lengthComputable ? i.total : void 0, s = a - n, l = r(s), c = a <= o;
    n = a;
    const d = {
      loaded: a,
      total: o,
      progress: o ? a / o : void 0,
      bytes: s,
      rate: l || void 0,
      estimated: l && o && c ? (o - a) / l : void 0,
      event: i
    };
    d[e ? "download" : "upload"] = !0, t(d);
  };
}
const Ote = typeof XMLHttpRequest < "u", Yte = Ote && function(t) {
  return new Promise(function(n, r) {
    let i = t.data;
    const a = bs.from(t.headers).normalize(), o = t.responseType;
    let s;
    function l() {
      t.cancelToken && t.cancelToken.unsubscribe(s), t.signal && t.signal.removeEventListener("abort", s);
    }
    ce.isFormData(i) && (yo.isStandardBrowserEnv || yo.isStandardBrowserWebWorkerEnv) && a.setContentType(!1);
    let c = new XMLHttpRequest();
    if (t.auth) {
      const N = t.auth.username || "", M = t.auth.password ? unescape(encodeURIComponent(t.auth.password)) : "";
      a.set("Authorization", "Basic " + btoa(N + ":" + M));
    }
    const d = BO(t.baseURL, t.url);
    c.open(t.method.toUpperCase(), GO(d, t.params, t.paramsSerializer), !0), c.timeout = t.timeout;
    function u() {
      if (!c)
        return;
      const N = bs.from(
        "getAllResponseHeaders" in c && c.getAllResponseHeaders()
      ), p = {
        data: !o || o === "text" || o === "json" ? c.responseText : c.response,
        status: c.status,
        statusText: c.statusText,
        headers: N,
        config: t,
        request: c
      };
      Dte(function(R) {
        n(R), l();
      }, function(R) {
        r(R), l();
      }, p), c = null;
    }
    if ("onloadend" in c ? c.onloadend = u : c.onreadystatechange = function() {
      !c || c.readyState !== 4 || c.status === 0 && !(c.responseURL && c.responseURL.indexOf("file:") === 0) || setTimeout(u);
    }, c.onabort = function() {
      c && (r(new Kt("Request aborted", Kt.ECONNABORTED, t, c)), c = null);
    }, c.onerror = function() {
      r(new Kt("Network Error", Kt.ERR_NETWORK, t, c)), c = null;
    }, c.ontimeout = function() {
      let M = t.timeout ? "timeout of " + t.timeout + "ms exceeded" : "timeout exceeded";
      const p = t.transitional || CO;
      t.timeoutErrorMessage && (M = t.timeoutErrorMessage), r(new Kt(
        M,
        p.clarifyTimeoutError ? Kt.ETIMEDOUT : Kt.ECONNABORTED,
        t,
        c
      )), c = null;
    }, yo.isStandardBrowserEnv) {
      const N = (t.withCredentials || Fte(d)) && t.xsrfCookieName && zte.read(t.xsrfCookieName);
      N && a.set(t.xsrfHeaderName, N);
    }
    i === void 0 && a.setContentType(null), "setRequestHeader" in c && ce.forEach(a.toJSON(), function(M, p) {
      c.setRequestHeader(p, M);
    }), ce.isUndefined(t.withCredentials) || (c.withCredentials = !!t.withCredentials), o && o !== "json" && (c.responseType = t.responseType), typeof t.onDownloadProgress == "function" && c.addEventListener("progress", lD(t.onDownloadProgress, !0)), typeof t.onUploadProgress == "function" && c.upload && c.upload.addEventListener("progress", lD(t.onUploadProgress)), (t.cancelToken || t.signal) && (s = (N) => {
      c && (r(!N || N.type ? new Ap(null, t, c) : N), c.abort(), c = null);
    }, t.cancelToken && t.cancelToken.subscribe(s), t.signal && (t.signal.aborted ? s() : t.signal.addEventListener("abort", s)));
    const h = vte(d);
    if (h && yo.protocols.indexOf(h) === -1) {
      r(new Kt("Unsupported protocol " + h + ":", Kt.ERR_BAD_REQUEST, t));
      return;
    }
    c.send(i || null);
  });
}, CT = {
  http: ute,
  xhr: Yte
};
ce.forEach(CT, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const Qte = {
  getAdapter: (t) => {
    t = ce.isArray(t) ? t : [t];
    const { length: e } = t;
    let n, r;
    for (let i = 0; i < e && (n = t[i], !(r = ce.isString(n) ? CT[n.toLowerCase()] : n)); i++)
      ;
    if (!r)
      throw r === !1 ? new Kt(
        `Adapter ${n} is not supported by the environment`,
        "ERR_NOT_SUPPORT"
      ) : new Error(
        ce.hasOwnProp(CT, n) ? `Adapter '${n}' is not available in the build` : `Unknown adapter '${n}'`
      );
    if (!ce.isFunction(r))
      throw new TypeError("adapter is not a function");
    return r;
  },
  adapters: CT
};
function qR(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new Ap(null, t);
}
function cD(t) {
  return qR(t), t.headers = bs.from(t.headers), t.data = $R.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), Qte.getAdapter(t.adapter || Y3.adapter)(t).then(function(r) {
    return qR(t), r.data = $R.call(
      t,
      t.transformResponse,
      r
    ), r.headers = bs.from(r.headers), r;
  }, function(r) {
    return JO(r) || (qR(t), r && r.response && (r.response.data = $R.call(
      t,
      t.transformResponse,
      r.response
    ), r.response.headers = bs.from(r.response.headers))), Promise.reject(r);
  });
}
const dD = (t) => t instanceof bs ? t.toJSON() : t;
function eh(t, e) {
  e = e || {};
  const n = {};
  function r(c, d, u) {
    return ce.isPlainObject(c) && ce.isPlainObject(d) ? ce.merge.call({ caseless: u }, c, d) : ce.isPlainObject(d) ? ce.merge({}, d) : ce.isArray(d) ? d.slice() : d;
  }
  function i(c, d, u) {
    if (ce.isUndefined(d)) {
      if (!ce.isUndefined(c))
        return r(void 0, c, u);
    } else
      return r(c, d, u);
  }
  function a(c, d) {
    if (!ce.isUndefined(d))
      return r(void 0, d);
  }
  function o(c, d) {
    if (ce.isUndefined(d)) {
      if (!ce.isUndefined(c))
        return r(void 0, c);
    } else
      return r(void 0, d);
  }
  function s(c, d, u) {
    if (u in e)
      return r(c, d);
    if (u in t)
      return r(void 0, c);
  }
  const l = {
    url: a,
    method: a,
    data: a,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: s,
    headers: (c, d) => i(dD(c), dD(d), !0)
  };
  return ce.forEach(Object.keys(t).concat(Object.keys(e)), function(d) {
    const u = l[d] || i, h = u(t[d], e[d], d);
    ce.isUndefined(h) && u !== s || (n[d] = h);
  }), n;
}
const AO = "1.3.3", Q3 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  Q3[t] = function(r) {
    return typeof r === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const uD = {};
Q3.transitional = function(e, n, r) {
  function i(a, o) {
    return "[Axios v" + AO + "] Transitional option '" + a + "'" + o + (r ? ". " + r : "");
  }
  return (a, o, s) => {
    if (e === !1)
      throw new Kt(
        i(o, " has been removed" + (n ? " in " + n : "")),
        Kt.ERR_DEPRECATED
      );
    return n && !uD[o] && (uD[o] = !0, console.warn(
      i(
        o,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), e ? e(a, o, s) : !0;
  };
};
function Gte(t, e, n) {
  if (typeof t != "object")
    throw new Kt("options must be an object", Kt.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(t);
  let i = r.length;
  for (; i-- > 0; ) {
    const a = r[i], o = e[a];
    if (o) {
      const s = t[a], l = s === void 0 || o(s, a, t);
      if (l !== !0)
        throw new Kt("option " + a + " must be " + l, Kt.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new Kt("Unknown option " + a, Kt.ERR_BAD_OPTION);
  }
}
const xZ = {
  assertOptions: Gte,
  validators: Q3
}, al = xZ.validators;
class Qf {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new oD(),
      response: new oD()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(e, n) {
    typeof e == "string" ? (n = n || {}, n.url = e) : n = e || {}, n = eh(this.defaults, n);
    const { transitional: r, paramsSerializer: i, headers: a } = n;
    r !== void 0 && xZ.assertOptions(r, {
      silentJSONParsing: al.transitional(al.boolean),
      forcedJSONParsing: al.transitional(al.boolean),
      clarifyTimeoutError: al.transitional(al.boolean)
    }, !1), i !== void 0 && xZ.assertOptions(i, {
      encode: al.function,
      serialize: al.function
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o;
    o = a && ce.merge(
      a.common,
      a[n.method]
    ), o && ce.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (M) => {
        delete a[M];
      }
    ), n.headers = bs.concat(o, a);
    const s = [];
    let l = !0;
    this.interceptors.request.forEach(function(p) {
      typeof p.runWhen == "function" && p.runWhen(n) === !1 || (l = l && p.synchronous, s.unshift(p.fulfilled, p.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(p) {
      c.push(p.fulfilled, p.rejected);
    });
    let d, u = 0, h;
    if (!l) {
      const M = [cD.bind(this), void 0];
      for (M.unshift.apply(M, s), M.push.apply(M, c), h = M.length, d = Promise.resolve(n); u < h; )
        d = d.then(M[u++], M[u++]);
      return d;
    }
    h = s.length;
    let N = n;
    for (u = 0; u < h; ) {
      const M = s[u++], p = s[u++];
      try {
        N = M(N);
      } catch (m) {
        p.call(this, m);
        break;
      }
    }
    try {
      d = cD.call(this, N);
    } catch (M) {
      return Promise.reject(M);
    }
    for (u = 0, h = c.length; u < h; )
      d = d.then(c[u++], c[u++]);
    return d;
  }
  getUri(e) {
    e = eh(this.defaults, e);
    const n = BO(e.baseURL, e.url);
    return GO(n, e.params, e.paramsSerializer);
  }
}
ce.forEach(["delete", "get", "head", "options"], function(e) {
  Qf.prototype[e] = function(n, r) {
    return this.request(eh(r || {}, {
      method: e,
      url: n,
      data: (r || {}).data
    }));
  };
});
ce.forEach(["post", "put", "patch"], function(e) {
  function n(r) {
    return function(a, o, s) {
      return this.request(eh(s || {}, {
        method: e,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: o
      }));
    };
  }
  Qf.prototype[e] = n(), Qf.prototype[e + "Form"] = n(!0);
});
const LT = Qf;
class G3 {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(a) {
      n = a;
    });
    const r = this;
    this.promise.then((i) => {
      if (!r._listeners)
        return;
      let a = r._listeners.length;
      for (; a-- > 0; )
        r._listeners[a](i);
      r._listeners = null;
    }), this.promise.then = (i) => {
      let a;
      const o = new Promise((s) => {
        r.subscribe(s), a = s;
      }).then(i);
      return o.cancel = function() {
        r.unsubscribe(a);
      }, o;
    }, e(function(a, o, s) {
      r.reason || (r.reason = new Ap(a, o, s), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(e);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new G3(function(i) {
        e = i;
      }),
      cancel: e
    };
  }
}
const Cte = G3;
function Lte(t) {
  return function(n) {
    return t.apply(null, n);
  };
}
function Jte(t) {
  return ce.isObject(t) && t.isAxiosError === !0;
}
const WZ = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(WZ).forEach(([t, e]) => {
  WZ[e] = t;
});
const Bte = WZ;
function HO(t) {
  const e = new LT(t), n = xO(LT.prototype.request, e);
  return ce.extend(n, LT.prototype, e, { allOwnKeys: !0 }), ce.extend(n, e, null, { allOwnKeys: !0 }), n.create = function(i) {
    return HO(eh(t, i));
  }, n;
}
const Rr = HO(Y3);
Rr.Axios = LT;
Rr.CanceledError = Ap;
Rr.CancelToken = Cte;
Rr.isCancel = JO;
Rr.VERSION = AO;
Rr.toFormData = K2;
Rr.AxiosError = Kt;
Rr.Cancel = Rr.CanceledError;
Rr.all = function(e) {
  return Promise.all(e);
};
Rr.spread = Lte;
Rr.isAxiosError = Jte;
Rr.mergeConfig = eh;
Rr.AxiosHeaders = bs;
Rr.formToJSON = (t) => LO(ce.isHTMLForm(t) ? new FormData(t) : t);
Rr.HttpStatusCode = Bte;
Rr.default = Rr;
const us = Rr;
var Et = {
  context: void 0,
  registry: void 0
};
function QN(t) {
  Et.context = t;
}
var Ate = (t, e) => t === e, Gf = Symbol("solid-proxy"), XO = Symbol("solid-track"), Cf = {
  equals: Ate
}, _O = tY, Hs = 1, Lf = 2, PO = {
  owned: null,
  cleanups: null,
  context: null,
  owner: null
}, eg = {}, qt = null, tg = null, mn = null, ti = null, Es = null, eU = 0, [Hte, Uwe] = /* @__PURE__ */ Zi(!1);
function Zd(t, e) {
  const n = mn, r = qt, i = t.length === 0, a = e === void 0 ? r : e, o = i ? PO : {
    owned: null,
    cleanups: null,
    context: a ? a.context : null,
    owner: a
  }, s = i ? t : () => t(() => Dr(() => nU(o)));
  qt = o, mn = null;
  try {
    return ko(s, !0);
  } finally {
    mn = n, qt = r;
  }
}
function Zi(t, e) {
  e = e ? Object.assign({}, Cf, e) : Cf;
  const n = {
    value: t,
    observers: null,
    observerSlots: null,
    comparator: e.equals || void 0
  }, r = (i) => (typeof i == "function" && (i = i(n.value)), eY(n, i));
  return [qO.bind(n), r];
}
function hD(t, e, n) {
  const r = tU(t, e, !0, Hs);
  eN(r);
}
function bd(t, e, n) {
  const r = tU(t, e, !1, Hs);
  eN(r);
}
function KO(t, e, n) {
  _O = ene;
  const r = tU(t, e, !1, Hs);
  (!n || !n.render) && (r.user = !0), Es ? Es.push(r) : eN(r);
}
function wi(t, e, n) {
  n = n ? Object.assign({}, Cf, n) : Cf;
  const r = tU(t, e, !0, 0);
  return r.observers = null, r.observerSlots = null, r.comparator = n.equals || void 0, eN(r), qO.bind(r);
}
function ND(t) {
  return t && typeof t == "object" && "then" in t;
}
function Xte(t, e, n) {
  let r, i, a;
  arguments.length === 2 && typeof e == "object" || arguments.length === 1 ? (r = !0, i = t, a = e || {}) : (r = t, i = e, a = n || {});
  let o = null, s = eg, l = null, c = !1, d = "initialValue" in a, u = typeof r == "function" && wi(r);
  const h = /* @__PURE__ */ new Set(), [N, M] = (a.storage || Zi)(a.initialValue), [p, m] = Zi(void 0), [R, V] = Zi(void 0, {
    equals: !1
  }), [U, g] = Zi(d ? "ready" : "unresolved");
  if (Et.context) {
    l = `${Et.context.id}${Et.context.count++}`;
    let Y;
    a.ssrLoadFrom === "initial" ? s = a.initialValue : Et.load && (Y = Et.load(l)) && (s = ND(Y) && "value" in Y ? Y.value : Y);
  }
  function y(Y, Q, G, ne) {
    return o === Y && (o = null, ne !== void 0 && (d = !0), (Y === s || Q === s) && a.onHydrated && queueMicrotask(
      () => a.onHydrated(ne, {
        value: Q
      })
    ), s = eg, x(Q, G)), Q;
  }
  function x(Y, Q) {
    ko(() => {
      Q === void 0 && M(() => Y), g(Q !== void 0 ? "errored" : d ? "ready" : "unresolved"), m(Q);
      for (const G of h.keys())
        G.decrement();
      h.clear();
    }, !1);
  }
  function f() {
    const Y = Kte, Q = N(), G = p();
    if (G !== void 0 && !o)
      throw G;
    return mn && !mn.user && Y && hD(() => {
      R(), o && (Y.resolved || h.has(Y) || (Y.increment(), h.add(Y)));
    }), Q;
  }
  function D(Y = !0) {
    if (Y !== !1 && c)
      return;
    c = !1;
    const Q = u ? u() : r;
    if (Q == null || Q === !1) {
      y(o, Dr(N));
      return;
    }
    const G = s !== eg ? s : Dr(
      () => i(Q, {
        value: N(),
        refetching: Y
      })
    );
    return ND(G) ? (o = G, c = !0, queueMicrotask(() => c = !1), ko(() => {
      g(d ? "refreshing" : "pending"), V();
    }, !1), G.then(
      (ne) => y(G, ne, void 0, Q),
      (ne) => y(G, void 0, rY(ne), Q)
    )) : (y(o, G, void 0, Q), G);
  }
  return Object.defineProperties(f, {
    state: {
      get: () => U()
    },
    error: {
      get: () => p()
    },
    loading: {
      get() {
        const Y = U();
        return Y === "pending" || Y === "refreshing";
      }
    },
    latest: {
      get() {
        if (!d)
          return f();
        const Y = p();
        if (Y && !o)
          throw Y;
        return N();
      }
    }
  }), u ? hD(() => D(!1)) : D(!1), [
    f,
    {
      refetch: D,
      mutate: M
    }
  ];
}
function Rwe(t) {
  return ko(t, !1);
}
function Dr(t) {
  if (mn === null)
    return t();
  const e = mn;
  mn = null;
  try {
    return t();
  } finally {
    mn = e;
  }
}
function gwe(t, e, n) {
  const r = Array.isArray(t);
  let i, a = n && n.defer;
  return (o) => {
    let s;
    if (r) {
      s = Array(t.length);
      for (let c = 0; c < t.length; c++)
        s[c] = t[c]();
    } else
      s = t();
    if (a) {
      a = !1;
      return;
    }
    const l = Dr(() => e(s, i, o));
    return i = s, l;
  };
}
function ywe(t) {
  KO(() => Dr(t));
}
function Jf(t) {
  return qt === null || (qt.cleanups === null ? qt.cleanups = [t] : qt.cleanups.push(t)), t;
}
function Zwe() {
  return mn;
}
function MD() {
  return qt;
}
function _te(t, e) {
  const n = qt, r = mn;
  qt = t, mn = null;
  try {
    return ko(e, !0);
  } catch (i) {
    C3(i);
  } finally {
    qt = n, mn = r;
  }
}
function Pte(t) {
  const e = mn, n = qt;
  return Promise.resolve().then(() => {
    mn = e, qt = n;
    let r;
    return ko(t, !1), mn = qt = null, r ? r.done : void 0;
  });
}
function bwe() {
  return [Hte, Pte];
}
function Ewe(t, e) {
  const n = Symbol("context");
  return {
    id: n,
    Provider: tne(n),
    defaultValue: t
  };
}
function Swe(t) {
  return qt && qt.context && qt.context[t.id] !== void 0 ? qt.context[t.id] : t.defaultValue;
}
function $O(t) {
  const e = wi(t), n = wi(() => jZ(e()));
  return n.toArray = () => {
    const r = n();
    return Array.isArray(r) ? r : r != null ? [r] : [];
  }, n;
}
var Kte;
function qO() {
  if (this.sources && this.state)
    if (this.state === Hs)
      eN(this);
    else {
      const t = ti;
      ti = null, ko(() => Af(this), !1), ti = t;
    }
  if (mn) {
    const t = this.observers ? this.observers.length : 0;
    mn.sources ? (mn.sources.push(this), mn.sourceSlots.push(t)) : (mn.sources = [this], mn.sourceSlots = [t]), this.observers ? (this.observers.push(mn), this.observerSlots.push(mn.sources.length - 1)) : (this.observers = [mn], this.observerSlots = [mn.sources.length - 1]);
  }
  return this.value;
}
function eY(t, e, n) {
  let r = t.value;
  return (!t.comparator || !t.comparator(r, e)) && (t.value = e, t.observers && t.observers.length && ko(() => {
    for (let i = 0; i < t.observers.length; i += 1) {
      const a = t.observers[i], o = tg && tg.running;
      o && tg.disposed.has(a), (o ? !a.tState : !a.state) && (a.pure ? ti.push(a) : Es.push(a), a.observers && nY(a)), o || (a.state = Hs);
    }
    if (ti.length > 1e6)
      throw ti = [], new Error();
  }, !1)), e;
}
function eN(t) {
  if (!t.fn)
    return;
  nU(t);
  const e = qt, n = mn, r = eU;
  mn = qt = t, $te(
    t,
    t.value,
    r
  ), mn = n, qt = e;
}
function $te(t, e, n) {
  let r;
  try {
    r = t.fn(e);
  } catch (i) {
    return t.pure && (t.state = Hs, t.owned && t.owned.forEach(nU), t.owned = null), t.updatedAt = n + 1, C3(i);
  }
  (!t.updatedAt || t.updatedAt <= n) && (t.updatedAt != null && "observers" in t ? eY(t, r) : t.value = r, t.updatedAt = n);
}
function tU(t, e, n, r = Hs, i) {
  const a = {
    fn: t,
    state: r,
    updatedAt: null,
    owned: null,
    sources: null,
    sourceSlots: null,
    cleanups: null,
    value: e,
    owner: qt,
    context: qt ? qt.context : null,
    pure: n
  };
  return qt === null || qt !== PO && (qt.owned ? qt.owned.push(a) : qt.owned = [a]), a;
}
function Bf(t) {
  if (t.state === 0)
    return;
  if (t.state === Lf)
    return Af(t);
  if (t.suspense && Dr(t.suspense.inFallback))
    return t.suspense.effects.push(t);
  const e = [t];
  for (; (t = t.owner) && (!t.updatedAt || t.updatedAt < eU); )
    t.state && e.push(t);
  for (let n = e.length - 1; n >= 0; n--)
    if (t = e[n], t.state === Hs)
      eN(t);
    else if (t.state === Lf) {
      const r = ti;
      ti = null, ko(() => Af(t, e[0]), !1), ti = r;
    }
}
function ko(t, e) {
  if (ti)
    return t();
  let n = !1;
  e || (ti = []), Es ? n = !0 : Es = [], eU++;
  try {
    const r = t();
    return qte(n), r;
  } catch (r) {
    n || (Es = null), ti = null, C3(r);
  }
}
function qte(t) {
  if (ti && (tY(ti), ti = null), t)
    return;
  const e = Es;
  Es = null, e.length && ko(() => _O(e), !1);
}
function tY(t) {
  for (let e = 0; e < t.length; e++)
    Bf(t[e]);
}
function ene(t) {
  let e, n = 0;
  for (e = 0; e < t.length; e++) {
    const r = t[e];
    r.user ? t[n++] = r : Bf(r);
  }
  if (Et.context) {
    if (Et.count) {
      Et.effects || (Et.effects = []), Et.effects.push(...t.slice(0, n));
      return;
    } else
      Et.effects && (t = [...Et.effects, ...t], n += Et.effects.length, delete Et.effects);
    QN();
  }
  for (e = 0; e < n; e++)
    Bf(t[e]);
}
function Af(t, e) {
  t.state = 0;
  for (let n = 0; n < t.sources.length; n += 1) {
    const r = t.sources[n];
    if (r.sources) {
      const i = r.state;
      i === Hs ? r !== e && (!r.updatedAt || r.updatedAt < eU) && Bf(r) : i === Lf && Af(r, e);
    }
  }
}
function nY(t) {
  for (let e = 0; e < t.observers.length; e += 1) {
    const n = t.observers[e];
    n.state || (n.state = Lf, n.pure ? ti.push(n) : Es.push(n), n.observers && nY(n));
  }
}
function nU(t) {
  let e;
  if (t.sources)
    for (; t.sources.length; ) {
      const n = t.sources.pop(), r = t.sourceSlots.pop(), i = n.observers;
      if (i && i.length) {
        const a = i.pop(), o = n.observerSlots.pop();
        r < i.length && (a.sourceSlots[o] = r, i[r] = a, n.observerSlots[r] = o);
      }
    }
  if (t.owned) {
    for (e = t.owned.length - 1; e >= 0; e--)
      nU(t.owned[e]);
    t.owned = null;
  }
  if (t.cleanups) {
    for (e = t.cleanups.length - 1; e >= 0; e--)
      t.cleanups[e]();
    t.cleanups = null;
  }
  t.state = 0;
}
function rY(t) {
  return t instanceof Error ? t : new Error(typeof t == "string" ? t : "Unknown error", {
    cause: t
  });
}
function C3(t, e = qt) {
  throw rY(t);
}
function jZ(t) {
  if (typeof t == "function" && !t.length)
    return jZ(t());
  if (Array.isArray(t)) {
    const e = [];
    for (let n = 0; n < t.length; n++) {
      const r = jZ(t[n]);
      Array.isArray(r) ? e.push.apply(e, r) : e.push(r);
    }
    return e;
  }
  return t;
}
function tne(t, e) {
  return function(r) {
    let i;
    return bd(
      () => i = Dr(() => (qt.context = {
        ...qt.context,
        [t]: r.value
      }, $O(() => r.children))),
      void 0
    ), i;
  };
}
var DZ = Symbol("fallback");
function Hf(t) {
  for (let e = 0; e < t.length; e++)
    t[e]();
}
function nne(t, e, n = {}) {
  let r = [], i = [], a = [], o = 0, s = e.length > 1 ? [] : null;
  return Jf(() => Hf(a)), () => {
    let l = t() || [], c, d;
    return l[XO], Dr(() => {
      let h = l.length, N, M, p, m, R, V, U, g, y;
      if (h === 0)
        o !== 0 && (Hf(a), a = [], r = [], i = [], o = 0, s && (s = [])), n.fallback && (r = [DZ], i[0] = Zd((x) => (a[0] = x, n.fallback())), o = 1);
      else if (o === 0) {
        for (i = new Array(h), d = 0; d < h; d++)
          r[d] = l[d], i[d] = Zd(u);
        o = h;
      } else {
        for (p = new Array(h), m = new Array(h), s && (R = new Array(h)), V = 0, U = Math.min(o, h); V < U && r[V] === l[V]; V++)
          ;
        for (U = o - 1, g = h - 1; U >= V && g >= V && r[U] === l[g]; U--, g--)
          p[g] = i[U], m[g] = a[U], s && (R[g] = s[U]);
        for (N = /* @__PURE__ */ new Map(), M = new Array(g + 1), d = g; d >= V; d--)
          y = l[d], c = N.get(y), M[d] = c === void 0 ? -1 : c, N.set(y, d);
        for (c = V; c <= U; c++)
          y = r[c], d = N.get(y), d !== void 0 && d !== -1 ? (p[d] = i[c], m[d] = a[c], s && (R[d] = s[c]), d = M[d], N.set(y, d)) : a[c]();
        for (d = V; d < h; d++)
          d in p ? (i[d] = p[d], a[d] = m[d], s && (s[d] = R[d], s[d](d))) : i[d] = Zd(u);
        i = i.slice(0, o = h), r = l.slice(0);
      }
      return i;
    });
    function u(h) {
      if (a[d] = h, s) {
        const [N, M] = Zi(d);
        return s[d] = M, e(l[d], N);
      }
      return e(l[d]);
    }
  };
}
function rne(t, e, n = {}) {
  let r = [], i = [], a = [], o = [], s = 0, l;
  return Jf(() => Hf(a)), () => {
    const c = t() || [];
    return c[XO], Dr(() => {
      if (c.length === 0)
        return s !== 0 && (Hf(a), a = [], r = [], i = [], s = 0, o = []), n.fallback && (r = [DZ], i[0] = Zd((u) => (a[0] = u, n.fallback())), s = 1), i;
      for (r[0] === DZ && (a[0](), a = [], r = [], i = [], s = 0), l = 0; l < c.length; l++)
        l < r.length && r[l] !== c[l] ? o[l](() => c[l]) : l >= r.length && (i[l] = Zd(d));
      for (; l < r.length; l++)
        a[l]();
      return s = o.length = a.length = c.length, r = c.slice(0), i = i.slice(0, s);
    });
    function d(u) {
      a[l] = u;
      const [h, N] = Zi(c[l]);
      return o[l] = N, e(h, l);
    }
  };
}
function ine(t, e) {
  return Dr(() => t(e || {}));
}
function qm() {
  return !0;
}
var zZ = {
  get(t, e, n) {
    return e === Gf ? n : t.get(e);
  },
  has(t, e) {
    return e === Gf ? !0 : t.has(e);
  },
  set: qm,
  deleteProperty: qm,
  getOwnPropertyDescriptor(t, e) {
    return {
      configurable: !0,
      enumerable: !0,
      get() {
        return t.get(e);
      },
      set: qm,
      deleteProperty: qm
    };
  },
  ownKeys(t) {
    return t.keys();
  }
};
function ng(t) {
  return (t = typeof t == "function" ? t() : t) ? t : {};
}
function ane() {
  for (let t = 0, e = this.length; t < e; ++t) {
    const n = this[t]();
    if (n !== void 0)
      return n;
  }
}
function one(...t) {
  let e = !1;
  for (let a = 0; a < t.length; a++) {
    const o = t[a];
    e = e || !!o && Gf in o, t[a] = typeof o == "function" ? (e = !0, wi(o)) : o;
  }
  if (e)
    return new Proxy(
      {
        get(a) {
          for (let o = t.length - 1; o >= 0; o--) {
            const s = ng(t[o])[a];
            if (s !== void 0)
              return s;
          }
        },
        has(a) {
          for (let o = t.length - 1; o >= 0; o--)
            if (a in ng(t[o]))
              return !0;
          return !1;
        },
        keys() {
          const a = [];
          for (let o = 0; o < t.length; o++)
            a.push(...Object.keys(ng(t[o])));
          return [...new Set(a)];
        }
      },
      zZ
    );
  const n = {}, r = {}, i = /* @__PURE__ */ new Set();
  for (let a = t.length - 1; a >= 0; a--) {
    const o = t[a];
    if (!o)
      continue;
    const s = Object.getOwnPropertyNames(o);
    for (let l = 0, c = s.length; l < c; l++) {
      const d = s[l];
      if (d === "__proto__" || d === "constructor")
        continue;
      const u = Object.getOwnPropertyDescriptor(o, d);
      if (!i.has(d))
        u.get ? (i.add(d), Object.defineProperty(n, d, {
          enumerable: !0,
          configurable: !0,
          get: ane.bind(r[d] = [u.get.bind(o)])
        })) : (u.value !== void 0 && i.add(d), n[d] = u.value);
      else {
        const h = r[d];
        h ? u.get ? h.push(u.get.bind(o)) : u.value !== void 0 && h.push(() => u.value) : n[d] === void 0 && (n[d] = u.value);
      }
    }
  }
  return n;
}
function sne(t, ...e) {
  if (Gf in t) {
    const i = new Set(e.length > 1 ? e.flat() : e[0]), a = e.map((o) => new Proxy(
      {
        get(s) {
          return o.includes(s) ? t[s] : void 0;
        },
        has(s) {
          return o.includes(s) && s in t;
        },
        keys() {
          return o.filter((s) => s in t);
        }
      },
      zZ
    ));
    return a.push(
      new Proxy(
        {
          get(o) {
            return i.has(o) ? void 0 : t[o];
          },
          has(o) {
            return i.has(o) ? !1 : o in t;
          },
          keys() {
            return Object.keys(t).filter((o) => !i.has(o));
          }
        },
        zZ
      )
    ), a;
  }
  const n = {}, r = e.map(() => ({}));
  for (const i of Object.getOwnPropertyNames(t)) {
    const a = Object.getOwnPropertyDescriptor(t, i), o = !a.get && !a.set && a.enumerable && a.writable && a.configurable;
    let s = !1, l = 0;
    for (const c of e)
      c.includes(i) && (s = !0, o ? r[l][i] = a.value : Object.defineProperty(r[l], i, a)), ++l;
    s || (o ? n[i] = a.value : Object.defineProperty(n, i, a));
  }
  return [...r, n];
}
function lne(t) {
  let e, n;
  const r = (i) => {
    const a = Et.context;
    if (a) {
      const [s, l] = Zi();
      Et.count || (Et.count = 0), Et.count++, (n || (n = t())).then((c) => {
        QN(a), Et.count--, l(() => c.default), QN();
      }), e = s;
    } else if (!e) {
      const [s] = Xte(() => (n || (n = t())).then((l) => l.default));
      e = s;
    }
    let o;
    return wi(
      () => (o = e()) && Dr(() => {
        if (!a)
          return o(i);
        const s = Et.context;
        QN(a);
        const l = o(i);
        return QN(s), l;
      })
    );
  };
  return r.preload = () => n || ((n = t()).then((i) => e = () => i.default), n), r;
}
var cne = 0;
function xwe() {
  const t = Et.context;
  return t ? `${t.id}${t.count++}` : `cl-${cne++}`;
}
var iY = (t) => `Stale read from <${t}>.`;
function Wwe(t) {
  const e = "fallback" in t && {
    fallback: () => t.fallback
  };
  return wi(nne(() => t.each, t.children, e || void 0));
}
function jwe(t) {
  const e = "fallback" in t && {
    fallback: () => t.fallback
  };
  return wi(rne(() => t.each, t.children, e || void 0));
}
function Dwe(t) {
  const e = t.keyed, n = wi(() => t.when, void 0, {
    equals: (r, i) => e ? r === i : !r == !i
  });
  return wi(
    () => {
      const r = n();
      if (r) {
        const i = t.children;
        return typeof i == "function" && i.length > 0 ? Dr(
          () => i(
            e ? r : () => {
              if (!Dr(n))
                throw iY("Show");
              return t.when;
            }
          )
        ) : i;
      }
      return t.fallback;
    },
    void 0,
    void 0
  );
}
function zwe(t) {
  let e = !1;
  const n = (a, o) => a[0] === o[0] && (e ? a[1] === o[1] : !a[1] == !o[1]) && a[2] === o[2], r = $O(() => t.children), i = wi(
    () => {
      let a = r();
      Array.isArray(a) || (a = [a]);
      for (let o = 0; o < a.length; o++) {
        const s = a[o].when;
        if (s)
          return e = !!a[o].keyed, [o, s, a[o]];
      }
      return [-1];
    },
    void 0,
    {
      equals: n
    }
  );
  return wi(
    () => {
      const [a, o, s] = i();
      if (a < 0)
        return t.fallback;
      const l = s.children;
      return typeof l == "function" && l.length > 0 ? Dr(
        () => l(
          e ? o : () => {
            if (Dr(i)[0] !== a)
              throw iY("Match");
            return s.when;
          }
        )
      ) : l;
    },
    void 0,
    void 0
  );
}
function kwe(t) {
  return t;
}
var dne = [
  "allowfullscreen",
  "async",
  "autofocus",
  "autoplay",
  "checked",
  "controls",
  "default",
  "disabled",
  "formnovalidate",
  "hidden",
  "indeterminate",
  "ismap",
  "loop",
  "multiple",
  "muted",
  "nomodule",
  "novalidate",
  "open",
  "playsinline",
  "readonly",
  "required",
  "reversed",
  "seamless",
  "selected"
], une = /* @__PURE__ */ new Set([
  "className",
  "value",
  "readOnly",
  "formNoValidate",
  "isMap",
  "noModule",
  "playsInline",
  ...dne
]), hne = /* @__PURE__ */ new Set([
  "innerHTML",
  "textContent",
  "innerText",
  "children"
]), Nne = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(null), {
  className: "class",
  htmlFor: "for"
}), Mne = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(null), {
  class: "className",
  formnovalidate: {
    $: "formNoValidate",
    BUTTON: 1,
    INPUT: 1
  },
  ismap: {
    $: "isMap",
    IMG: 1
  },
  nomodule: {
    $: "noModule",
    SCRIPT: 1
  },
  playsinline: {
    $: "playsInline",
    VIDEO: 1
  },
  readonly: {
    $: "readOnly",
    INPUT: 1,
    TEXTAREA: 1
  }
});
function pne(t, e) {
  const n = Mne[t];
  return typeof n == "object" ? n[e] ? n.$ : void 0 : n;
}
var mne = /* @__PURE__ */ new Set([
  "beforeinput",
  "click",
  "dblclick",
  "contextmenu",
  "focusin",
  "focusout",
  "input",
  "keydown",
  "keyup",
  "mousedown",
  "mousemove",
  "mouseout",
  "mouseover",
  "mouseup",
  "pointerdown",
  "pointermove",
  "pointerout",
  "pointerover",
  "pointerup",
  "touchend",
  "touchmove",
  "touchstart"
]), Tne = /* @__PURE__ */ new Set([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animate",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "circle",
  "clipPath",
  "color-profile",
  "cursor",
  "defs",
  "desc",
  "ellipse",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "filter",
  "font",
  "font-face",
  "font-face-format",
  "font-face-name",
  "font-face-src",
  "font-face-uri",
  "foreignObject",
  "g",
  "glyph",
  "glyphRef",
  "hkern",
  "image",
  "line",
  "linearGradient",
  "marker",
  "mask",
  "metadata",
  "missing-glyph",
  "mpath",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "set",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "textPath",
  "tref",
  "tspan",
  "use",
  "view",
  "vkern"
]), fne = {
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace"
};
function Vne(t, e, n) {
  let r = n.length, i = e.length, a = r, o = 0, s = 0, l = e[i - 1].nextSibling, c = null;
  for (; o < i || s < a; ) {
    if (e[o] === n[s]) {
      o++, s++;
      continue;
    }
    for (; e[i - 1] === n[a - 1]; )
      i--, a--;
    if (i === o) {
      const d = a < r ? s ? n[s - 1].nextSibling : n[a - s] : l;
      for (; s < a; )
        t.insertBefore(n[s++], d);
    } else if (a === s)
      for (; o < i; )
        (!c || !c.has(e[o])) && e[o].remove(), o++;
    else if (e[o] === n[a - 1] && n[s] === e[i - 1]) {
      const d = e[--i].nextSibling;
      t.insertBefore(n[s++], e[o++].nextSibling), t.insertBefore(n[--a], d), e[i] = n[a];
    } else {
      if (!c) {
        c = /* @__PURE__ */ new Map();
        let u = s;
        for (; u < a; )
          c.set(n[u], u++);
      }
      const d = c.get(e[o]);
      if (d != null)
        if (s < d && d < a) {
          let u = o, h = 1, N;
          for (; ++u < i && u < a && !((N = c.get(e[u])) == null || N !== d + h); )
            h++;
          if (h > d - s) {
            const M = e[o];
            for (; s < d; )
              t.insertBefore(n[s++], M);
          } else
            t.replaceChild(n[s++], e[o++]);
        } else
          o++;
      else
        e[o++].remove();
    }
  }
}
var pD = "_$DX_DELEGATE";
function Une(t, e, n, r = {}) {
  let i;
  return Zd((a) => {
    i = a, e === document ? t() : wZ(e, t(), e.firstChild ? null : void 0, n);
  }, r.owner), () => {
    i(), e.textContent = "";
  };
}
function wwe(t, e, n) {
  let r;
  const i = () => {
    const o = document.createElement("template");
    return o.innerHTML = t, n ? o.content.firstChild.firstChild : o.content.firstChild;
  }, a = e ? () => Dr(() => document.importNode(r || (r = i()), !0)) : () => (r || (r = i())).cloneNode(!0);
  return a.cloneNode = a, a;
}
function Rne(t, e = window.document) {
  const n = e[pD] || (e[pD] = /* @__PURE__ */ new Set());
  for (let r = 0, i = t.length; r < i; r++) {
    const a = t[r];
    n.has(a) || (n.add(a), e.addEventListener(a, Dne));
  }
}
function kZ(t, e, n) {
  Et.context || (n == null ? t.removeAttribute(e) : t.setAttribute(e, n));
}
function gne(t, e, n, r) {
  Et.context || (r == null ? t.removeAttributeNS(e, n) : t.setAttributeNS(e, n, r));
}
function yne(t, e) {
  Et.context || (e == null ? t.removeAttribute("class") : t.className = e);
}
function Zne(t, e, n, r) {
  if (r)
    Array.isArray(n) ? (t[`$$${e}`] = n[0], t[`$$${e}Data`] = n[1]) : t[`$$${e}`] = n;
  else if (Array.isArray(n)) {
    const i = n[0];
    t.addEventListener(e, n[0] = (a) => i.call(t, n[1], a));
  } else
    t.addEventListener(e, n);
}
function bne(t, e, n = {}) {
  const r = Object.keys(e || {}), i = Object.keys(n);
  let a, o;
  for (a = 0, o = i.length; a < o; a++) {
    const s = i[a];
    !s || s === "undefined" || e[s] || (mD(t, s, !1), delete n[s]);
  }
  for (a = 0, o = r.length; a < o; a++) {
    const s = r[a], l = !!e[s];
    !s || s === "undefined" || n[s] === l || !l || (mD(t, s, !0), n[s] = l);
  }
  return n;
}
function Ene(t, e, n) {
  if (!e)
    return n ? kZ(t, "style") : e;
  const r = t.style;
  if (typeof e == "string")
    return r.cssText = e;
  typeof n == "string" && (r.cssText = n = void 0), n || (n = {}), e || (e = {});
  let i, a;
  for (a in n)
    e[a] == null && r.removeProperty(a), delete n[a];
  for (a in e)
    i = e[a], i !== n[a] && (r.setProperty(a, i), n[a] = i);
  return n;
}
function Sne(t, e = {}, n, r) {
  const i = {};
  return r || bd(
    () => i.children = th(t, e.children, i.children)
  ), bd(() => e.ref && e.ref(t)), bd(() => xne(t, e, n, !0, i, !0)), i;
}
function Fwe(t, e, n) {
  return Dr(() => t(e, n));
}
function wZ(t, e, n, r) {
  if (n !== void 0 && !r && (r = []), typeof e != "function")
    return th(t, e, r, n);
  bd((i) => th(t, e(), i, n), r);
}
function xne(t, e, n, r, i = {}, a = !1) {
  e || (e = {});
  for (const o in i)
    if (!(o in e)) {
      if (o === "children")
        continue;
      i[o] = TD(t, o, null, i[o], n, a);
    }
  for (const o in e) {
    if (o === "children") {
      r || th(t, e.children);
      continue;
    }
    const s = e[o];
    i[o] = TD(t, o, s, i[o], n, a);
  }
}
function Wne(t) {
  let e, n;
  return !Et.context || !(e = Et.registry.get(n = zne())) ? t() : (Et.completed && Et.completed.add(e), Et.registry.delete(n), e);
}
function jne(t) {
  return t.toLowerCase().replace(/-([a-z])/g, (e, n) => n.toUpperCase());
}
function mD(t, e, n) {
  const r = e.trim().split(/\s+/);
  for (let i = 0, a = r.length; i < a; i++)
    t.classList.toggle(r[i], n);
}
function TD(t, e, n, r, i, a) {
  let o, s, l, c, d;
  if (e === "style")
    return Ene(t, n, r);
  if (e === "classList")
    return bne(t, n, r);
  if (n === r)
    return r;
  if (e === "ref")
    a || n(t);
  else if (e.slice(0, 3) === "on:") {
    const u = e.slice(3);
    r && t.removeEventListener(u, r), n && t.addEventListener(u, n);
  } else if (e.slice(0, 10) === "oncapture:") {
    const u = e.slice(10);
    r && t.removeEventListener(u, r, !0), n && t.addEventListener(u, n, !0);
  } else if (e.slice(0, 2) === "on") {
    const u = e.slice(2).toLowerCase(), h = mne.has(u);
    if (!h && r) {
      const N = Array.isArray(r) ? r[0] : r;
      t.removeEventListener(u, N);
    }
    (h || n) && (Zne(t, u, n, h), h && Rne([u]));
  } else if (e.slice(0, 5) === "attr:")
    kZ(t, e.slice(5), n);
  else if ((d = e.slice(0, 5) === "prop:") || (l = hne.has(e)) || !i && ((c = pne(e, t.tagName)) || (s = une.has(e))) || (o = t.nodeName.includes("-"))) {
    if (d)
      e = e.slice(5), s = !0;
    else if (Et.context)
      return n;
    e === "class" || e === "className" ? yne(t, n) : o && !s && !l ? t[jne(e)] = n : t[c || e] = n;
  } else {
    const u = i && e.indexOf(":") > -1 && fne[e.split(":")[0]];
    u ? gne(t, u, e, n) : kZ(t, Nne[e] || e, n);
  }
  return n;
}
function Dne(t) {
  const e = `$$${t.type}`;
  let n = t.composedPath && t.composedPath()[0] || t.target;
  for (t.target !== n && Object.defineProperty(t, "target", {
    configurable: !0,
    value: n
  }), Object.defineProperty(t, "currentTarget", {
    configurable: !0,
    get() {
      return n || document;
    }
  }), Et.registry && !Et.done && (Et.done = _$HY.done = !0); n; ) {
    const r = n[e];
    if (r && !n.disabled) {
      const i = n[`${e}Data`];
      if (i !== void 0 ? r.call(n, i, t) : r.call(n, t), t.cancelBubble)
        return;
    }
    n = n._$host || n.parentNode || n.host;
  }
}
function th(t, e, n, r, i) {
  if (Et.context) {
    !n && (n = [...t.childNodes]);
    let s = [];
    for (let l = 0; l < n.length; l++) {
      const c = n[l];
      c.nodeType === 8 && c.data.slice(0, 2) === "!$" ? c.remove() : s.push(c);
    }
    n = s;
  }
  for (; typeof n == "function"; )
    n = n();
  if (e === n)
    return n;
  const a = typeof e, o = r !== void 0;
  if (t = o && n[0] && n[0].parentNode || t, a === "string" || a === "number") {
    if (Et.context)
      return n;
    if (a === "number" && (e = e.toString()), o) {
      let s = n[0];
      s && s.nodeType === 3 ? s.data = e : s = document.createTextNode(e), n = zu(t, n, r, s);
    } else
      n !== "" && typeof n == "string" ? n = t.firstChild.data = e : n = t.textContent = e;
  } else if (e == null || a === "boolean") {
    if (Et.context)
      return n;
    n = zu(t, n, r);
  } else {
    if (a === "function")
      return bd(() => {
        let s = e();
        for (; typeof s == "function"; )
          s = s();
        n = th(t, s, n, r);
      }), () => n;
    if (Array.isArray(e)) {
      const s = [], l = n && Array.isArray(n);
      if (FZ(s, e, n, i))
        return bd(() => n = th(t, s, n, r, !0)), () => n;
      if (Et.context) {
        if (!s.length)
          return n;
        if (r === void 0)
          return [...t.childNodes];
        let c = s[0], d = [c];
        for (; (c = c.nextSibling) !== r; )
          d.push(c);
        return n = d;
      }
      if (s.length === 0) {
        if (n = zu(t, n, r), o)
          return n;
      } else
        l ? n.length === 0 ? fD(t, s, r) : Vne(t, n, s) : (n && zu(t), fD(t, s));
      n = s;
    } else if (e.nodeType) {
      if (Et.context && e.parentNode)
        return n = o ? [e] : e;
      if (Array.isArray(n)) {
        if (o)
          return n = zu(t, n, r, e);
        zu(t, n, null, e);
      } else
        n == null || n === "" || !t.firstChild ? t.appendChild(e) : t.replaceChild(e, t.firstChild);
      n = e;
    }
  }
  return n;
}
function FZ(t, e, n, r) {
  let i = !1;
  for (let a = 0, o = e.length; a < o; a++) {
    let s = e[a], l = n && n[a], c;
    if (!(s == null || s === !0 || s === !1))
      if ((c = typeof s) == "object" && s.nodeType)
        t.push(s);
      else if (Array.isArray(s))
        i = FZ(t, s, l) || i;
      else if (c === "function")
        if (r) {
          for (; typeof s == "function"; )
            s = s();
          i = FZ(
            t,
            Array.isArray(s) ? s : [s],
            Array.isArray(l) ? l : [l]
          ) || i;
        } else
          t.push(s), i = !0;
      else {
        const d = String(s);
        l && l.nodeType === 3 && l.data === d ? t.push(l) : t.push(document.createTextNode(d));
      }
  }
  return i;
}
function fD(t, e, n = null) {
  for (let r = 0, i = e.length; r < i; r++)
    t.insertBefore(e[r], n);
}
function zu(t, e, n, r) {
  if (n === void 0)
    return t.textContent = "";
  const i = r || document.createTextNode("");
  if (e.length) {
    let a = !1;
    for (let o = e.length - 1; o >= 0; o--) {
      const s = e[o];
      if (i !== s) {
        const l = s.parentNode === t;
        !a && !o ? l ? t.replaceChild(i, s) : t.insertBefore(i, n) : l && s.remove();
      } else
        a = !0;
    }
  } else
    t.insertBefore(i, n);
  return [i];
}
function zne() {
  const t = Et.context;
  return `${t.id}${t.count++}`;
}
var kne = "http://www.w3.org/2000/svg";
function aY(t, e = !1) {
  return e ? document.createElementNS(kne, t) : document.createElement(t);
}
function vwe(t) {
  const { useShadow: e } = t, n = document.createTextNode(""), r = () => t.mount || document.body, i = MD();
  let a, o = !!Et.context;
  return KO(
    () => {
      o && (MD().user = o = !1), a || (a = _te(i, () => wi(() => t.children)));
      const s = r();
      if (s instanceof HTMLHeadElement) {
        const [l, c] = Zi(!1), d = () => c(!0);
        Zd((u) => wZ(s, () => l() ? u() : a(), null)), Jf(d);
      } else {
        const l = aY(t.isSVG ? "g" : "div", t.isSVG), c = e && l.attachShadow ? l.attachShadow({
          mode: "open"
        }) : l;
        Object.defineProperty(l, "_$host", {
          get() {
            return n.parentNode;
          },
          configurable: !0
        }), wZ(c, a), s.appendChild(l), t.ref && t.ref(l), Jf(() => s.removeChild(l));
      }
    },
    void 0,
    {
      render: !o
    }
  ), n;
}
function Iwe(t) {
  const [e, n] = sne(t, ["component"]), r = wi(() => e.component);
  return wi(() => {
    const i = r();
    switch (typeof i) {
      case "function":
        return Dr(() => i(n));
      case "string":
        const a = Tne.has(i), o = Et.context ? Wne() : aY(i, a);
        return Sne(o, n, a), o;
    }
  });
}
var C0, Zp, bp, Ep, Ud, L0, J0, B0, A0, H0, Sp, dw, wne = (dw = class {
  constructor(t) {
    Fe(this, C0, void 0);
    Fe(this, Zp, void 0);
    Fe(this, bp, void 0);
    Fe(this, Ep, void 0);
    Fe(this, Ud, !1);
    Fe(this, L0, void 0);
    Fe(this, J0, void 0);
    Fe(this, B0, void 0);
    Fe(this, A0, void 0);
    Fe(this, H0, void 0);
    Fe(this, Sp, void 0);
    const {
      client: e,
      queryFlavor: n,
      version: r,
      onlineManager: i,
      buttonPosition: a,
      position: o,
      initialIsOpen: s,
      errorTypes: l
    } = t;
    Ue(this, C0, Zi(e)), Ue(this, bp, n), Ue(this, Ep, r), Ue(this, Zp, i), Ue(this, L0, Zi(a)), Ue(this, J0, Zi(o)), Ue(this, B0, Zi(s)), Ue(this, A0, Zi(l));
  }
  setButtonPosition(t) {
    K(this, L0)[1](t);
  }
  setPosition(t) {
    K(this, J0)[1](t);
  }
  setInitialIsOpen(t) {
    K(this, B0)[1](t);
  }
  setErrorTypes(t) {
    K(this, A0)[1](t);
  }
  setClient(t) {
    K(this, C0)[1](t);
  }
  mount(t) {
    if (K(this, Ud))
      throw new Error("Devtools is already mounted");
    const e = Une(() => {
      const [n] = K(this, L0), [r] = K(this, J0), [i] = K(this, B0), [a] = K(this, A0), [o] = K(this, C0);
      let s;
      K(this, H0) ? s = K(this, H0) : (s = lne(() => import("./HESZYUBG-e288d8ce.js")), Ue(this, H0, s));
      const l = this;
      return ine(s, one({
        get queryFlavor() {
          return K(l, bp);
        },
        get version() {
          return K(l, Ep);
        },
        get onlineManager() {
          return K(l, Zp);
        }
      }, {
        get client() {
          return o();
        },
        get buttonPosition() {
          return n();
        },
        get position() {
          return r();
        },
        get initialIsOpen() {
          return i();
        },
        get errorTypes() {
          return a();
        }
      }));
    }, t);
    Ue(this, Ud, !0), Ue(this, Sp, e);
  }
  unmount() {
    var t;
    if (!K(this, Ud))
      throw new Error("Devtools is not mounted");
    (t = K(this, Sp)) == null || t.call(this), Ue(this, Ud, !1);
  }
}, C0 = new WeakMap(), Zp = new WeakMap(), bp = new WeakMap(), Ep = new WeakMap(), Ud = new WeakMap(), L0 = new WeakMap(), J0 = new WeakMap(), B0 = new WeakMap(), A0 = new WeakMap(), H0 = new WeakMap(), Sp = new WeakMap(), dw);
function Fne(t) {
  const e = $I(), n = t.client || e, r = Ve(null), { buttonPosition: i, position: a, initialIsOpen: o, errorTypes: s } = t, [l] = nt(
    new wne({
      client: n,
      queryFlavor: "React Query",
      version: "5",
      onlineManager: tM,
      buttonPosition: i,
      position: a,
      initialIsOpen: o,
      errorTypes: s
    })
  );
  return Ee(() => {
    l.setClient(n);
  }, [n, l]), Ee(() => {
    i && l.setButtonPosition(i);
  }, [i, l]), Ee(() => {
    a && l.setPosition(a);
  }, [a, l]), Ee(() => {
    l.setInitialIsOpen(o || !1);
  }, [o, l]), Ee(() => {
    l.setErrorTypes(s || []);
  }, [s, l]), Ee(() => (r.current && l.mount(r.current), () => {
    l.unmount();
  }), [l]), /* @__PURE__ */ rr.createElement("div", { className: "tsqd-parent-container", ref: r });
}
var vne = ue.env.NODE_ENV !== "development" ? function() {
  return null;
} : Fne;
function Ine({
  devtool: t = !1,
  client: e,
  children: n
}) {
  return /* @__PURE__ */ E.jsxs(W$, { client: e, children: [
    t && /* @__PURE__ */ E.jsx(vne, { initialIsOpen: !1 }),
    n
  ] });
}
const oY = Wt(gI);
function One({
  children: t,
  config: e
}) {
  return /* @__PURE__ */ E.jsx(oY.Provider, { value: e, children: t });
}
function Ir(t) {
  for (var e = arguments.length, n = Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
    n[r - 1] = arguments[r];
  if (ue.env.NODE_ENV !== "production") {
    var i = Ane[t], a = i ? typeof i == "function" ? i.apply(null, n) : i : "unknown error nr: " + t;
    throw Error("[Immer] " + a);
  }
  throw Error("[Immer] minified error nr: " + t + (n.length ? " " + n.map(function(o) {
    return "'" + o + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function nh(t) {
  return !!t && !!t[ea];
}
function vd(t) {
  var e;
  return !!t && (function(n) {
    if (!n || typeof n != "object")
      return !1;
    var r = Object.getPrototypeOf(n);
    if (r === null)
      return !0;
    var i = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
    return i === Object || typeof i == "function" && Function.toString.call(i) === Hne;
  }(t) || Array.isArray(t) || !!t[ED] || !!(!((e = t.constructor) === null || e === void 0) && e[ED]) || L3(t) || J3(t));
}
function aM(t, e, n) {
  n === void 0 && (n = !1), tN(t) === 0 ? (n ? Object.keys : X3)(t).forEach(function(r) {
    n && typeof r == "symbol" || e(r, t[r], t);
  }) : t.forEach(function(r, i) {
    return e(i, r, t);
  });
}
function tN(t) {
  var e = t[ea];
  return e ? e.i > 3 ? e.i - 4 : e.i : Array.isArray(t) ? 1 : L3(t) ? 2 : J3(t) ? 3 : 0;
}
function vZ(t, e) {
  return tN(t) === 2 ? t.has(e) : Object.prototype.hasOwnProperty.call(t, e);
}
function Yne(t, e) {
  return tN(t) === 2 ? t.get(e) : t[e];
}
function sY(t, e, n) {
  var r = tN(t);
  r === 2 ? t.set(e, n) : r === 3 ? t.add(n) : t[e] = n;
}
function Qne(t, e) {
  return t === e ? t !== 0 || 1 / t == 1 / e : t != t && e != e;
}
function L3(t) {
  return Jne && t instanceof Map;
}
function J3(t) {
  return Bne && t instanceof Set;
}
function Pc(t) {
  return t.o || t.t;
}
function B3(t) {
  if (Array.isArray(t))
    return Array.prototype.slice.call(t);
  var e = Xne(t);
  delete e[ea];
  for (var n = X3(e), r = 0; r < n.length; r++) {
    var i = n[r], a = e[i];
    a.writable === !1 && (a.writable = !0, a.configurable = !0), (a.get || a.set) && (e[i] = { configurable: !0, writable: !0, enumerable: a.enumerable, value: t[i] });
  }
  return Object.create(Object.getPrototypeOf(t), e);
}
function oM(t, e) {
  return e === void 0 && (e = !1), A3(t) || nh(t) || !vd(t) || (tN(t) > 1 && (t.set = t.add = t.clear = t.delete = Gne), Object.freeze(t), e && aM(t, function(n, r) {
    return oM(r, !0);
  }, !0)), t;
}
function Gne() {
  Ir(2);
}
function A3(t) {
  return t == null || typeof t != "object" || Object.isFrozen(t);
}
function Eo(t) {
  var e = _ne[t];
  return e || Ir(18, t), e;
}
function VD() {
  return ue.env.NODE_ENV === "production" || rh || Ir(0), rh;
}
function rg(t, e) {
  e && (Eo("Patches"), t.u = [], t.s = [], t.v = e);
}
function Xf(t) {
  IZ(t), t.p.forEach(Cne), t.p = null;
}
function IZ(t) {
  t === rh && (rh = t.l);
}
function UD(t) {
  return rh = { p: [], l: rh, h: t, m: !0, _: 0 };
}
function Cne(t) {
  var e = t[ea];
  e.i === 0 || e.i === 1 ? e.j() : e.O = !0;
}
function ig(t, e) {
  e._ = e.p.length;
  var n = e.p[0], r = t !== void 0 && t !== n;
  return e.h.g || Eo("ES5").S(e, t, r), r ? (n[ea].P && (Xf(e), Ir(4)), vd(t) && (t = _f(e, t), e.l || Pf(e, t)), e.u && Eo("Patches").M(n[ea].t, t, e.u, e.s)) : t = _f(e, n, []), Xf(e), e.u && e.v(e.u, e.s), t !== lY ? t : void 0;
}
function _f(t, e, n) {
  if (A3(e))
    return e;
  var r = e[ea];
  if (!r)
    return aM(e, function(s, l) {
      return RD(t, r, e, s, l, n);
    }, !0), e;
  if (r.A !== t)
    return e;
  if (!r.P)
    return Pf(t, r.t, !0), r.t;
  if (!r.I) {
    r.I = !0, r.A._--;
    var i = r.i === 4 || r.i === 5 ? r.o = B3(r.k) : r.o, a = i, o = !1;
    r.i === 3 && (a = new Set(i), i.clear(), o = !0), aM(a, function(s, l) {
      return RD(t, r, i, s, l, n, o);
    }), Pf(t, i, !1), n && t.u && Eo("Patches").N(r, n, t.u, t.s);
  }
  return r.o;
}
function RD(t, e, n, r, i, a, o) {
  if (ue.env.NODE_ENV !== "production" && i === n && Ir(5), nh(i)) {
    var s = _f(t, i, a && e && e.i !== 3 && !vZ(e.R, r) ? a.concat(r) : void 0);
    if (sY(n, r, s), !nh(s))
      return;
    t.m = !1;
  } else
    o && n.add(i);
  if (vd(i) && !A3(i)) {
    if (!t.h.D && t._ < 1)
      return;
    _f(t, i), e && e.A.l || Pf(t, i);
  }
}
function Pf(t, e, n) {
  n === void 0 && (n = !1), !t.l && t.h.D && t.m && oM(e, n);
}
function ag(t, e) {
  var n = t[ea];
  return (n ? Pc(n) : t)[e];
}
function gD(t, e) {
  if (e in t)
    for (var n = Object.getPrototypeOf(t); n; ) {
      var r = Object.getOwnPropertyDescriptor(n, e);
      if (r)
        return r;
      n = Object.getPrototypeOf(n);
    }
}
function OZ(t) {
  t.P || (t.P = !0, t.l && OZ(t.l));
}
function og(t) {
  t.o || (t.o = B3(t.t));
}
function YZ(t, e, n) {
  var r = L3(e) ? Eo("MapSet").F(e, n) : J3(e) ? Eo("MapSet").T(e, n) : t.g ? function(i, a) {
    var o = Array.isArray(i), s = { i: o ? 1 : 0, A: a ? a.A : VD(), P: !1, I: !1, R: {}, l: a, t: i, k: null, o: null, j: null, C: !1 }, l = s, c = QZ;
    o && (l = [s], c = GN);
    var d = Proxy.revocable(l, c), u = d.revoke, h = d.proxy;
    return s.k = h, s.j = u, h;
  }(e, n) : Eo("ES5").J(e, n);
  return (n ? n.A : VD()).p.push(r), r;
}
function Lne(t) {
  return nh(t) || Ir(22, t), function e(n) {
    if (!vd(n))
      return n;
    var r, i = n[ea], a = tN(n);
    if (i) {
      if (!i.P && (i.i < 4 || !Eo("ES5").K(i)))
        return i.t;
      i.I = !0, r = yD(n, a), i.I = !1;
    } else
      r = yD(n, a);
    return aM(r, function(o, s) {
      i && Yne(i.t, o) === s || sY(r, o, e(s));
    }), a === 3 ? new Set(r) : r;
  }(t);
}
function yD(t, e) {
  switch (e) {
    case 2:
      return new Map(t);
    case 3:
      return Array.from(t);
  }
  return B3(t);
}
var ZD, rh, H3 = typeof Symbol < "u" && typeof Symbol("x") == "symbol", Jne = typeof Map < "u", Bne = typeof Set < "u", bD = typeof Proxy < "u" && Proxy.revocable !== void 0 && typeof Reflect < "u", lY = H3 ? Symbol.for("immer-nothing") : ((ZD = {})["immer-nothing"] = !0, ZD), ED = H3 ? Symbol.for("immer-draftable") : "__$immer_draftable", ea = H3 ? Symbol.for("immer-state") : "__$immer_state", Ane = { 0: "Illegal state", 1: "Immer drafts cannot have computed properties", 2: "This object has been frozen and should not be mutated", 3: function(t) {
  return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + t;
}, 4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.", 5: "Immer forbids circular references", 6: "The first or second argument to `produce` must be a function", 7: "The third argument to `produce` must be a function or undefined", 8: "First argument to `createDraft` must be a plain object, an array, or an immerable object", 9: "First argument to `finishDraft` must be a draft returned by `createDraft`", 10: "The given draft is already finalized", 11: "Object.defineProperty() cannot be used on an Immer draft", 12: "Object.setPrototypeOf() cannot be used on an Immer draft", 13: "Immer only supports deleting array indices", 14: "Immer only supports setting array indices and the 'length' property", 15: function(t) {
  return "Cannot apply patch, path doesn't resolve: " + t;
}, 16: 'Sets cannot have "replace" patches.', 17: function(t) {
  return "Unsupported patch operation: " + t;
}, 18: function(t) {
  return "The plugin for '" + t + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + t + "()` when initializing your application.";
}, 20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available", 21: function(t) {
  return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + t + "'";
}, 22: function(t) {
  return "'current' expects a draft, got: " + t;
}, 23: function(t) {
  return "'original' expects a draft, got: " + t;
}, 24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed" }, Hne = "" + Object.prototype.constructor, X3 = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols !== void 0 ? function(t) {
  return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
} : Object.getOwnPropertyNames, Xne = Object.getOwnPropertyDescriptors || function(t) {
  var e = {};
  return X3(t).forEach(function(n) {
    e[n] = Object.getOwnPropertyDescriptor(t, n);
  }), e;
}, _ne = {}, QZ = { get: function(t, e) {
  if (e === ea)
    return t;
  var n = Pc(t);
  if (!vZ(n, e))
    return function(i, a, o) {
      var s, l = gD(a, o);
      return l ? "value" in l ? l.value : (s = l.get) === null || s === void 0 ? void 0 : s.call(i.k) : void 0;
    }(t, n, e);
  var r = n[e];
  return t.I || !vd(r) ? r : r === ag(t.t, e) ? (og(t), t.o[e] = YZ(t.A.h, r, t)) : r;
}, has: function(t, e) {
  return e in Pc(t);
}, ownKeys: function(t) {
  return Reflect.ownKeys(Pc(t));
}, set: function(t, e, n) {
  var r = gD(Pc(t), e);
  if (r != null && r.set)
    return r.set.call(t.k, n), !0;
  if (!t.P) {
    var i = ag(Pc(t), e), a = i == null ? void 0 : i[ea];
    if (a && a.t === n)
      return t.o[e] = n, t.R[e] = !1, !0;
    if (Qne(n, i) && (n !== void 0 || vZ(t.t, e)))
      return !0;
    og(t), OZ(t);
  }
  return t.o[e] === n && (n !== void 0 || e in t.o) || Number.isNaN(n) && Number.isNaN(t.o[e]) || (t.o[e] = n, t.R[e] = !0), !0;
}, deleteProperty: function(t, e) {
  return ag(t.t, e) !== void 0 || e in t.t ? (t.R[e] = !1, og(t), OZ(t)) : delete t.R[e], t.o && delete t.o[e], !0;
}, getOwnPropertyDescriptor: function(t, e) {
  var n = Pc(t), r = Reflect.getOwnPropertyDescriptor(n, e);
  return r && { writable: !0, configurable: t.i !== 1 || e !== "length", enumerable: r.enumerable, value: n[e] };
}, defineProperty: function() {
  Ir(11);
}, getPrototypeOf: function(t) {
  return Object.getPrototypeOf(t.t);
}, setPrototypeOf: function() {
  Ir(12);
} }, GN = {};
aM(QZ, function(t, e) {
  GN[t] = function() {
    return arguments[0] = arguments[0][0], e.apply(this, arguments);
  };
}), GN.deleteProperty = function(t, e) {
  return ue.env.NODE_ENV !== "production" && isNaN(parseInt(e)) && Ir(13), GN.set.call(this, t, e, void 0);
}, GN.set = function(t, e, n) {
  return ue.env.NODE_ENV !== "production" && e !== "length" && isNaN(parseInt(e)) && Ir(14), QZ.set.call(this, t[0], e, n, t[0]);
};
var Pne = function() {
  function t(n) {
    var r = this;
    this.g = bD, this.D = !0, this.produce = function(i, a, o) {
      if (typeof i == "function" && typeof a != "function") {
        var s = a;
        a = i;
        var l = r;
        return function(p) {
          var m = this;
          p === void 0 && (p = s);
          for (var R = arguments.length, V = Array(R > 1 ? R - 1 : 0), U = 1; U < R; U++)
            V[U - 1] = arguments[U];
          return l.produce(p, function(g) {
            var y;
            return (y = a).call.apply(y, [m, g].concat(V));
          });
        };
      }
      var c;
      if (typeof a != "function" && Ir(6), o !== void 0 && typeof o != "function" && Ir(7), vd(i)) {
        var d = UD(r), u = YZ(r, i, void 0), h = !0;
        try {
          c = a(u), h = !1;
        } finally {
          h ? Xf(d) : IZ(d);
        }
        return typeof Promise < "u" && c instanceof Promise ? c.then(function(p) {
          return rg(d, o), ig(p, d);
        }, function(p) {
          throw Xf(d), p;
        }) : (rg(d, o), ig(c, d));
      }
      if (!i || typeof i != "object") {
        if ((c = a(i)) === void 0 && (c = i), c === lY && (c = void 0), r.D && oM(c, !0), o) {
          var N = [], M = [];
          Eo("Patches").M(i, c, N, M), o(N, M);
        }
        return c;
      }
      Ir(21, i);
    }, this.produceWithPatches = function(i, a) {
      if (typeof i == "function")
        return function(c) {
          for (var d = arguments.length, u = Array(d > 1 ? d - 1 : 0), h = 1; h < d; h++)
            u[h - 1] = arguments[h];
          return r.produceWithPatches(c, function(N) {
            return i.apply(void 0, [N].concat(u));
          });
        };
      var o, s, l = r.produce(i, a, function(c, d) {
        o = c, s = d;
      });
      return typeof Promise < "u" && l instanceof Promise ? l.then(function(c) {
        return [c, o, s];
      }) : [l, o, s];
    }, typeof (n == null ? void 0 : n.useProxies) == "boolean" && this.setUseProxies(n.useProxies), typeof (n == null ? void 0 : n.autoFreeze) == "boolean" && this.setAutoFreeze(n.autoFreeze);
  }
  var e = t.prototype;
  return e.createDraft = function(n) {
    vd(n) || Ir(8), nh(n) && (n = Lne(n));
    var r = UD(this), i = YZ(this, n, void 0);
    return i[ea].C = !0, IZ(r), i;
  }, e.finishDraft = function(n, r) {
    var i = n && n[ea];
    ue.env.NODE_ENV !== "production" && (i && i.C || Ir(9), i.I && Ir(10));
    var a = i.A;
    return rg(a, r), ig(void 0, a);
  }, e.setAutoFreeze = function(n) {
    this.D = n;
  }, e.setUseProxies = function(n) {
    n && !bD && Ir(20), this.g = n;
  }, e.applyPatches = function(n, r) {
    var i;
    for (i = r.length - 1; i >= 0; i--) {
      var a = r[i];
      if (a.path.length === 0 && a.op === "replace") {
        n = a.value;
        break;
      }
    }
    i > -1 && (r = r.slice(i + 1));
    var o = Eo("Patches").$;
    return nh(n) ? o(n, r) : this.produce(n, function(s) {
      return o(s, r);
    });
  }, t;
}(), ta = new Pne(), Kne = ta.produce;
ta.produceWithPatches.bind(ta);
ta.setAutoFreeze.bind(ta);
ta.setUseProxies.bind(ta);
ta.applyPatches.bind(ta);
ta.createDraft.bind(ta);
ta.finishDraft.bind(ta);
const cY = Kne;
function dY(t) {
  var e = nt(function() {
    return oM(typeof t == "function" ? t() : t, !0);
  }), n = e[1];
  return [e[0], De(function(r) {
    n(typeof r == "function" ? cY(r) : oM(r));
  }, [])];
}
function yc(t, e, n) {
  var r = vt(function() {
    return cY(t);
  }, [t]);
  return bE(r, e, n);
}
const $ne = {
  fromToken: null,
  toToken: null,
  fromInput: "",
  slippage: "1",
  isSwapping: !1,
  isApproving: !1,
  selectedRouteIdx: 0
}, uY = Wt($ne), hY = Wt(
  () => {
  }
);
function qne({ children: t }) {
  const { fromToken: e, fromInput: n, toToken: r, slippage: i } = Lo(), [a, o] = yc(ere, {
    fromToken: e,
    fromInput: n,
    toToken: r,
    slippage: i,
    isSwapping: !1,
    isApproving: !1,
    selectedRouteIdx: 0
  });
  return /* @__PURE__ */ E.jsx(uY.Provider, { value: a, children: /* @__PURE__ */ E.jsx(hY.Provider, { value: o, children: t }) });
}
function ere(t, e) {
  const { type: n, payload: r } = e;
  switch (n) {
    case "SET_FROM_INPUT":
      t.fromInput = r;
      return;
    case "SET_SLIPPAGE":
      t.slippage = r;
      return;
    case "SET_FROM_TOKEN":
      const { address: i, chainId: a } = r;
      t.fromToken = { address: i, chainId: a };
      return;
    case "SET_TO_TOKEN":
      const { address: o, chainId: s } = r;
      t.toToken = { address: o, chainId: s };
      return;
    case "SWITCH_TOKENS":
      const l = t.fromToken === null ? null : { ...t.fromToken }, c = t.toToken === null ? null : { ...t.toToken };
      t.fromToken = c, t.toToken = l, t.fromInput = r;
      return;
    case "SET_IS_APPROVING":
      t.isApproving = r;
      return;
    case "SET_IS_SWAPPING":
      t.isSwapping = r;
      return;
    case "SET_SELECTED_ROUTE_IDX":
      t.selectedRouteIdx = r;
      return;
  }
}
const tre = {
  chainDataList: []
}, NY = Wt(
  tre
), MY = Wt(() => {
});
function nre({ children: t }) {
  const { chains: e } = Vre(), n = e.map((a) => ({
    chainId: String(a.id)
  })), [r, i] = yc(rre, {
    chainDataList: n
  });
  return /* @__PURE__ */ E.jsx(NY.Provider, { value: r, children: /* @__PURE__ */ E.jsx(MY.Provider, { value: i, children: t }) });
}
function rre(t, e) {
  const { type: n, payload: r } = e;
  switch (n) {
    case "SET_CHAIN_DATA_LIST":
      t.chainDataList = r;
      return;
  }
}
const pY = Wt({
  initTokenList: [],
  unsortedInitTokenList: []
});
function ire({ children: t }) {
  var N;
  const { xyApi: e, tokenListApi: n } = Xp(), { disabledChains: r, disabledTokens: i } = Lo(), { customRawTokenList: a } = sM(), o = Ff({
    queryKey: ["tokenList"],
    queryFn: () => QK(n)
  }), s = Ff({
    queryKey: ["contractAddresses"],
    queryFn: () => JK(e)
  }), l = (N = s == null ? void 0 : s.data) == null ? void 0 : N.data, d = vt(() => o != null && o.data ? [...o.data, ...a].filter((p) => Ni(p.address)).map((p) => ({
    ...p,
    address: un(p.address)
  })).filter((p, m, R) => m === R.findIndex((V) => V.address === p.address && V.chainId === p.chainId)).filter((p) => !(r != null && r.includes(p.chainId))).filter((p) => !i.some(
    (m) => m.chainId === p.chainId && m.address === p.address
  )) : [], [o, a]).map((M) => ({
    ...M,
    balance: pn.from(0)
  })), u = Ky.getTokensSortedByPopularity(
    d,
    l
  ), h = {
    tokenListQuery: o,
    contractAddressesQuery: s,
    initTokenList: u,
    unsortedInitTokenList: d
  };
  return /* @__PURE__ */ E.jsx(pY.Provider, { value: h, children: /* @__PURE__ */ E.jsx(nre, { children: /* @__PURE__ */ E.jsx(L$, { children: t }) }) });
}
const mY = Wt({
  input: "",
  loading: !1,
  customRawTokenList: []
}), TY = Wt(
  () => {
  }
);
function are({ children: t }) {
  const [e, n] = yc(ore, {
    input: "",
    loading: !1,
    customRawTokenList: []
  });
  return /* @__PURE__ */ E.jsx(mY.Provider, { value: e, children: /* @__PURE__ */ E.jsx(TY.Provider, { value: n, children: t }) });
}
function ore(t, e) {
  const { type: n, payload: r } = e;
  switch (n) {
    case "SET_INPUT":
      t.input = r;
      return;
    case "SET_LOADING":
      t.loading = r;
      return;
    case "SET_CUSTOM_RAW_TOKEN_LIST":
      t.customRawTokenList = r;
      return;
  }
}
const sre = {
  allChains: [],
  xyApi: us.create({
    baseURL: ""
  }),
  tokenListApi: us.create({
    baseURL: ""
  }),
  nestApi: us.create({
    baseURL: ""
  }),
  routerApi: us.create({
    baseURL: ""
  }),
  defaultAffiliate: "0x"
}, fY = Wt(sre);
function lre({
  allChains: t,
  apiUrlMap: e,
  widgetConfig: n,
  wagmiConfig: r,
  queryClient: i,
  defaultAffiliate: a,
  children: o
}) {
  const {
    xyApiBaseUrl: s,
    tokenListApiBaseUrl: l,
    routerApiBaseUrl: c,
    nestApiBaseUrl: d,
    coingeckoApiBaseUrl: u = QP
  } = e, h = us.create({
    baseURL: s
  }), N = us.create({
    baseURL: l
  }), M = us.create({
    baseURL: c
  }), p = us.create({
    baseURL: u
  }), m = us.create({
    baseURL: d
  }), R = {
    allChains: t,
    xyApi: h,
    tokenListApi: N,
    coingeckoApi: p,
    routerApi: M,
    nestApi: m,
    defaultAffiliate: a
  };
  return /* @__PURE__ */ E.jsx(fY.Provider, { value: R, children: /* @__PURE__ */ E.jsx(One, { config: n, children: /* @__PURE__ */ E.jsx(Ine, { client: i, children: /* @__PURE__ */ E.jsx(cee, { config: r, children: /* @__PURE__ */ E.jsx(qne, { children: /* @__PURE__ */ E.jsx(are, { children: /* @__PURE__ */ E.jsx(ire, { children: o }) }) }) }) }) }) });
}
const cre = {
  receiverAddress: ""
}, VY = Wt(
  cre
), UY = Wt(() => {
});
function dre({ children: t }) {
  const { address: e } = Ui(), [n, r] = yc(ure, {
    receiverAddress: e
  });
  return /* @__PURE__ */ E.jsx(VY.Provider, { value: n, children: /* @__PURE__ */ E.jsx(UY.Provider, { value: r, children: t }) });
}
function ure(t, e) {
  const { type: n, payload: r } = e;
  switch (n) {
    case "SET_RECEIVER_ADDRESS":
      t.receiverAddress = r;
      return;
  }
}
function hre(t, e) {
  e === void 0 && (e = 0);
  var n = Ve(!1), r = Ve(), i = Ve(t), a = De(function() {
    return n.current;
  }, []), o = De(function() {
    n.current = !1, r.current && clearTimeout(r.current), r.current = setTimeout(function() {
      n.current = !0, i.current();
    }, e);
  }, [e]), s = De(function() {
    n.current = null, r.current && clearTimeout(r.current);
  }, []);
  return Ee(function() {
    i.current = t;
  }, [t]), Ee(function() {
    return o(), s;
  }, [e]), [a, s, o];
}
function Nre(t, e, n) {
  e === void 0 && (e = 0), n === void 0 && (n = []);
  var r = hre(t, e), i = r[0], a = r[1], o = r[2];
  return Ee(o, n), [i, a];
}
var Mre = function(t, e) {
  var n = Ve(function() {
  });
  Ee(function() {
    n.current = t;
  }), Ee(function() {
    if (e !== null) {
      var r = setInterval(function() {
        return n.current();
      }, e || 0);
      return function() {
        return clearInterval(r);
      };
    }
  }, [e]);
};
const n1 = Mre, RY = Wt({
  userTokenList: []
});
function pre({ children: t }) {
  const { unsortedInitTokenMap: e, initTokenMap: n, tokenListQuery: r, allContractMap: i } = rU(), { address: a } = Ui(), [o, s] = nt(e), l = Ky.getTokensSortedByPopularity(
    Object.values(o).flat(),
    i
  ), c = Ky.getTokensSortedByBalance(l), { customRawTokenList: d } = sM();
  xre(), Ee(() => {
    if (!a || !(r != null && r.dataUpdatedAt) || Object.keys(n).length === 0)
      return;
    const h = new AbortController();
    return nc.getInstance().getUserTokenMap(a, n, h.signal).then((N) => {
      s(N);
    }), () => {
      h.abort();
    };
  }, [a, r == null ? void 0 : r.dataUpdatedAt, d]), n1(() => {
    !a || !r || Object.keys(n).length !== 0 && nc.getInstance().getUserTokenMap(a, n).then((h) => {
      s(h);
    });
  }, GP);
  const u = {
    userTokenList: c
  };
  return /* @__PURE__ */ E.jsx(RY.Provider, { value: u, children: t });
}
function mre({ children: t }) {
  const { address: e } = Ui();
  return /* @__PURE__ */ E.jsx(dre, { children: /* @__PURE__ */ E.jsx(pre, { children: t }) }, e || "default");
}
function Hp() {
  const { userTokenList: t } = lt(RY), { initTokenList: e, allContractMap: n } = rU(), { chain: r } = lu(), { enabledChains: i } = Lo(), a = t.length === 0 ? e : t, { noLPTokenList: o, LPTokenList: s } = vt(() => a.reduce(
    (M, p) => {
      const m = p.symbol === "xyUSDT" || p.symbol === "xyUSDC" || p.symbol === "xyETH";
      return M[m ? "LPTokenList" : "noLPTokenList"].push(p), M;
    },
    { noLPTokenList: [], LPTokenList: [] }
  ), [a]), l = vt(() => a.reduce((M, p) => {
    const m = p.chainId;
    return typeof M[m] > "u" ? M[m] = [p] : M[m].push(p), M;
  }, {}), [a]), c = vt(() => o.reduce((M, p) => {
    const m = p.chainId;
    return typeof M[m] > "u" ? M[m] = [p] : M[m].push(p), M;
  }, {}), [o]), d = vt(() => i.map((M) => String(M.id)).filter((M) => !Object.keys(l).includes(M)), [i, l]), u = vt(() => r ? a.find(
    (M) => parseInt(M.chainId) === r.id && M.address === zi
  ) : null, [r, a]), h = vt(() => a.reduce((M, p) => {
    const m = p.chainId;
    return typeof M[m] > "u" && p.address === zi && (M[m] = p), M;
  }, {}), [a]), N = vt(() => {
    const { xyTokenContract: M } = n || {};
    return r && a && M && M[r.id] ? $y(
      {
        address: M[r.id],
        chainId: String(r.id)
      },
      a
    ) || new Ei() : new Ei();
  }, [n, r, a]);
  return {
    tokenList: a,
    tokenMap: l,
    LPTokenList: s,
    noLPTokenList: o,
    noLPTokenMap: c,
    nativeTokens: h,
    currentNativeToken: u,
    rpcErrorChains: d,
    xyToken: N
  };
}
function _3() {
  const { chainDataList: t } = lt(NY), e = t.map((r) => {
    var i, a;
    return {
      ...r,
      gasPrice: (i = r.feeValue) != null && i.gasPrice ? ws((a = r.feeValue) == null ? void 0 : a.gasPrice, "gwei") : null
    };
  }), n = e.reduce(
    (r, i) => (r[i.chainId] = i, r),
    {}
  );
  return {
    chainDataList: t,
    gweiChainDataList: e,
    gweiChainDataMap: n
  };
}
function Tre() {
  return lt(MY);
}
function Br() {
  var z;
  const {
    fromToken: t,
    toToken: e,
    fromInput: n,
    slippage: r,
    isSwapping: i,
    isApproving: a,
    selectedRouteIdx: o
  } = lt(uY), { gweiChainDataMap: s } = _3(), { tokenList: l, tokenMap: c } = Hp(), d = t === null ? new Ei() : l.find(
    (j) => t.address === j.address && t.chainId === j.chainId
  ) ?? new Ei(), u = e === null ? new Ei() : l.find(
    (j) => e.address === j.address && e.chainId === j.chainId
  ) ?? new Ei(), h = bo.getNetworkName(d.chainId), N = (z = c[d.chainId]) == null ? void 0 : z.find(
    (j) => j.address === zi
  ), M = bo.getNetworkName(u.chainId), p = PK(n, d.decimals), m = p ? HK(p, d.decimals).toString() : null, R = m === null || m === "0" || m === "", [V, U] = nt("");
  Nre(
    () => {
      U(m ?? "");
    },
    500,
    [m]
  );
  const g = fre(
    d,
    p
  ), y = s[d.chainId], x = s[u.chainId], f = (() => {
    if (x != null && x.gasPrice) {
      const j = parseFloat(x.gasPrice), w = parseFloat(Mj[0]), C = parseFloat(Mj[1]);
      return j < w ? ps.LESS_THAN_FIRST_BOUND : j > C ? ps.GREATER_THAN_EQUAL_SECOND_BOUND : ps.BETWEEN_OR_EQUAL_FIRST_AND_SECOND_BOUND;
    }
    return ps.NO_NEED_TO_CHECK_BOUND;
  })(), D = Number(r) > 5, Y = Number(r) < 0.5, Q = Number(r) < 50 ? null : new Error("Slippage must less than 50%"), G = Number(r) === 0 ? new Error("Slippage cannot be empty or 0.") : null, ne = Q || G, O = [ne], T = d.chainId !== u.chainId, Z = d.isFakeToken || u.isFakeToken;
  return {
    slippage: r,
    fromInput: n,
    fromAmount: m,
    debounceFromAmount: V,
    fromToken: t,
    toToken: e,
    inputToken: d,
    outputToken: u,
    isInsufficientBalance: g,
    isSwapping: i,
    isApproving: a,
    isInvalidFromAmount: R,
    errors: O,
    slippageError: ne,
    isSlippageWarning: D,
    isSlippageRemind: Y,
    isCrossChain: T,
    isInvalidTokenPair: Z,
    sourceChainName: h,
    destinationChainName: M,
    destinationGweiChainData: x,
    boundStatusCode: f,
    sourceChainNativeToken: N,
    inputTokenFeeData: y,
    selectedRouteIdx: o
  };
}
function nN() {
  return lt(hY);
}
function fre(t, e) {
  if (!e)
    return !0;
  switch (qy(
    e,
    ws(t.balance, t.decimals)
  )) {
    case 1:
      return !0;
    case -1:
      return !1;
    case 0:
      return !1;
  }
}
function Vre() {
  const { chain: t, chains: e } = lu(), { inputToken: n } = Br(), r = t, i = e, a = r && r.unsupported ? new Error(
    `The currently connected network is not supported. Switch to ${bo.getNetworkName(
      n.chainId
    )}`
  ) : null;
  return { chain: r, chains: i, unsupportedChainError: a, errors: [a] };
}
function rN() {
  const { receiverAddress: t } = lt(VY), { isConnected: e, address: n } = Ui(), r = Ni(t), i = r ? un(t) : t, a = e && !r ? new Error("Receiver Invalid") : null;
  return {
    receiverError: a,
    errors: [a],
    receiverAddress: t,
    isValidReceiverAddress: r,
    maybeCheckSumReceiverAddress: i,
    isReceiverAddressChanged: n !== t
  };
}
function Ure() {
  return lt(UY);
}
function Rre({
  chainId: t,
  owner: e,
  spender: n,
  tokenContractAddress: r
}) {
  const i = (() => {
    if (r !== zi)
      return r;
  })(), a = (() => {
    if (!(!e || !n))
      return [e, n];
  })(), { chain: o } = lu(), s = !!(t && o && t === o.id), l = !!(i && a) && s, {
    data: c,
    isError: d,
    isLoading: u,
    isFetching: h,
    refetch: N
  } = kee({
    address: i,
    abi: z3,
    functionName: "allowance",
    args: a,
    enabled: l,
    watch: !0
  });
  return { data: c, isError: d, isLoading: u, isFetching: h, refetch: N, enabled: l };
}
function rU() {
  var l;
  const {
    tokenListQuery: t,
    contractAddressesQuery: e,
    initTokenList: n,
    unsortedInitTokenList: r
  } = lt(pY), i = (l = e == null ? void 0 : e.data) == null ? void 0 : l.data, a = !!(t != null && t.isFetching) || !!(e != null && e.isFetching), o = vt(() => n.reduce((c, d) => {
    const u = d.chainId;
    return typeof c[u] > "u" ? c[u] = [d] : c[u].push(d), c;
  }, {}), [n]), s = vt(() => n.reduce((c, d) => {
    const u = d.chainId;
    return typeof c[u] > "u" ? c[u] = [d] : c[u].push(d), c;
  }, {}), [r]);
  return {
    tokenListQuery: t,
    contractAddressesQuery: e,
    isShowLoader: a,
    initTokenList: n,
    initTokenMap: o,
    allContractMap: i,
    unsortedInitTokenMap: s
  };
}
function Xp() {
  return lt(fY);
}
const gre = 2e4;
function Lo() {
  const {
    disabledChains: t,
    fromToken: e,
    toToken: n,
    fromInput: r,
    slippage: i,
    referrer: a = "",
    commissionRate: o = 0,
    featuredTokens: s,
    disabledTokens: l,
    disableTokenSelection: c,
    enableReport: d
  } = lt(oY), { allChains: u } = Xp(), h = e === null ? e : { ...e, address: un(e.address) }, N = n === null ? n : { ...n, address: un(n.address) }, M = s.filter((g) => Ni(g.address)).map((g) => ({
    ...g,
    address: un(g.address)
  })), p = t.filter(
    (g) => g !== ve.MAINNET
  ), m = l.filter((g) => Ni(g.address)).map((g) => ({
    ...g,
    address: un(g.address)
  })).filter((g) => g.address !== zi), R = u.filter(
    (g) => !(p != null && p.map((y) => parseInt(y)).includes(g.id))
  ), V = (() => {
    if (a && Ni(a))
      return un(a);
  })(), U = Math.max(0, Math.min(o, gre));
  return {
    featuredTokens: M,
    enabledChains: R,
    disabledChains: p,
    fromToken: h,
    toToken: N,
    fromInput: r,
    slippage: i,
    referrer: V,
    commissionRate: U,
    disabledTokens: m,
    disableTokenSelection: c,
    enableReport: d
  };
}
function yre(t, e, n) {
  var r = this, i = Ve(null), a = Ve(0), o = Ve(null), s = Ve([]), l = Ve(), c = Ve(), d = Ve(t), u = Ve(!0);
  d.current = t;
  var h = typeof window < "u", N = !e && e !== 0 && h;
  if (typeof t != "function")
    throw new TypeError("Expected a function");
  e = +e || 0;
  var M = !!(n = n || {}).leading, p = !("trailing" in n) || !!n.trailing, m = "maxWait" in n, R = "debounceOnServer" in n && !!n.debounceOnServer, V = m ? Math.max(+n.maxWait || 0, e) : null;
  Ee(function() {
    return u.current = !0, function() {
      u.current = !1;
    };
  }, []);
  var U = vt(function() {
    var g = function(Q) {
      var G = s.current, ne = l.current;
      return s.current = l.current = null, a.current = Q, c.current = d.current.apply(ne, G);
    }, y = function(Q, G) {
      N && cancelAnimationFrame(o.current), o.current = N ? requestAnimationFrame(Q) : setTimeout(Q, G);
    }, x = function(Q) {
      if (!u.current)
        return !1;
      var G = Q - i.current;
      return !i.current || G >= e || G < 0 || m && Q - a.current >= V;
    }, f = function(Q) {
      return o.current = null, p && s.current ? g(Q) : (s.current = l.current = null, c.current);
    }, D = function Q() {
      var G = Date.now();
      if (x(G))
        return f(G);
      if (u.current) {
        var ne = e - (G - i.current), O = m ? Math.min(ne, V - (G - a.current)) : ne;
        y(Q, O);
      }
    }, Y = function() {
      if (h || R) {
        var Q = Date.now(), G = x(Q);
        if (s.current = [].slice.call(arguments), l.current = r, i.current = Q, G) {
          if (!o.current && u.current)
            return a.current = i.current, y(D, e), M ? g(i.current) : c.current;
          if (m)
            return y(D, e), g(i.current);
        }
        return o.current || y(D, e), c.current;
      }
    };
    return Y.cancel = function() {
      o.current && (N ? cancelAnimationFrame(o.current) : clearTimeout(o.current)), a.current = 0, s.current = i.current = l.current = o.current = null;
    }, Y.isPending = function() {
      return !!o.current;
    }, Y.flush = function() {
      return o.current ? f(Date.now()) : c.current;
    }, Y;
  }, [M, m, e, V, p, N, h, R]);
  return U;
}
function Zre(t, e) {
  return t === e;
}
function bre(t, e) {
  return e;
}
function Ere(t, e, n) {
  var r = n && n.equalityFn || Zre, i = bE(bre, t), a = i[0], o = i[1], s = yre(De(function(c) {
    return o(c);
  }, [o]), e, n), l = Ve(t);
  return r(l.current, t) || (s(t), l.current = t), [a, s];
}
function sM() {
  const { input: t, loading: e, customRawTokenList: n } = lt(mY), [r] = Ere(t, 300);
  return { input: t, debounceInput: r, loading: e, customRawTokenList: n };
}
function gY() {
  return lt(TY);
}
function Sre() {
  const { selectedRoute: t } = aa(), { inputToken: e, fromAmount: n, sourceChainNativeToken: r } = Br(), { gweiChainDataMap: i } = _3(), a = i[e.chainId], o = t ? String(t.estimated_gas) : null, s = q7(
    o,
    a == null ? void 0 : a.feeValue
  ), l = e$(
    e,
    n,
    s,
    r
  );
  return {
    estimatedGas: o,
    gasFeeStatusCode: l,
    estimatedGasFee: s
  };
}
function xre() {
  const { initTokenList: t } = rU(), { debounceInput: e, customRawTokenList: n } = sM(), r = gY(), { enabledChains: i } = Lo();
  Ee(() => {
    if (e === "" || !Ni(e) || !!t.find(
      (s) => un(s.address) === un(e)
    ))
      return;
    (async () => {
      try {
        r({ type: "SET_LOADING", payload: !0 });
        const s = await nc.getInstance().getCustomRawTokenList(
          e,
          i
        );
        if (s.length === 0)
          return;
        r({
          type: "SET_CUSTOM_RAW_TOKEN_LIST",
          payload: [...n, ...s]
        });
      } catch (s) {
        console.error("UPDATE_XY_TOKEN_LIST_ERROR", s);
      } finally {
        r({ type: "SET_LOADING", payload: !1 });
      }
    })();
  }, [e]);
}
function Wre({
  owner: t,
  spender: e,
  tokenContractAddress: n,
  chainId: r,
  amount: i
}) {
  const {
    data: a,
    isError: o,
    isLoading: s,
    isFetching: l,
    refetch: c
  } = Rre({
    owner: t,
    spender: e,
    tokenContractAddress: n,
    chainId: r
  }), d = (() => typeof a > "u" || !i ? !1 : a === BigInt(0) ? !0 : a < BigInt(i))(), u = a == null ? void 0 : a.toString();
  return {
    allowance: a,
    allowanceAmount: u,
    isError: o,
    isLoading: s,
    isFetching: l,
    isNeedApproved: d,
    refetch: c
  };
}
var JT, jre = class extends gc {
  constructor({
    chains: t,
    options: e
  } = {}) {
    const n = {
      name: "MetaMask",
      shimDisconnect: !0,
      getProvider() {
        function r(a) {
          if (a != null && a.isMetaMask && !(a.isBraveWallet && !a._events && !a._state) && !a.isApexWallet && !a.isAvalanche && !a.isBitKeep && !a.isBlockWallet && !a.isCoin98 && !a.isFordefi && !a.isMathWallet && !(a.isOkxWallet || a.isOKExWallet) && !(a.isOneInchIOSWallet || a.isOneInchAndroidWallet) && !a.isOpera && !a.isPortal && !a.isRabby && !a.isDefiant && !a.isTokenPocket && !a.isTokenary && !a.isZeal && !a.isZerion)
            return a;
        }
        if (typeof window > "u")
          return;
        const i = window.ethereum;
        return i != null && i.providers ? i.providers.find(r) : r(i);
      },
      ...e
    };
    super({ chains: t, options: n }), this.id = "metaMask", this.shimDisconnectKey = `${this.id}.shimDisconnect`, Ai(this, JT, void 0), A2(this, JT, n.UNSTABLE_shimOnConnectSelectAccount);
  }
  async connect({ chainId: t } = {}) {
    var e, n, r, i;
    try {
      const a = await this.getProvider();
      if (!a)
        throw new Xi();
      a.on && (a.on("accountsChanged", this.onAccountsChanged), a.on("chainChanged", this.onChainChanged), a.on("disconnect", this.onDisconnect)), this.emit("message", { type: "connecting" });
      let o = null;
      if (Qn(this, JT) && ((e = this.options) != null && e.shimDisconnect) && !((n = this.storage) != null && n.getItem(this.shimDisconnectKey)) && (o = await this.getAccount().catch(() => null), !!o))
        try {
          await a.request({
            method: "wallet_requestPermissions",
            params: [{ eth_accounts: {} }]
          }), o = await this.getAccount();
        } catch (d) {
          if (this.isUserRejectedRequestError(d))
            throw new Un(d);
          if (d.code === new ql(d).code)
            throw d;
        }
      if (!o) {
        const c = await a.request({
          method: "eth_requestAccounts"
        });
        o = un(c[0]);
      }
      let s = await this.getChainId(), l = this.isChainUnsupported(s);
      return t && s !== t && (s = (await this.switchChain(t)).id, l = this.isChainUnsupported(s)), (r = this.options) != null && r.shimDisconnect && ((i = this.storage) == null || i.setItem(this.shimDisconnectKey, !0)), { account: o, chain: { id: s, unsupported: l }, provider: a };
    } catch (a) {
      throw this.isUserRejectedRequestError(a) ? new Un(a) : a.code === -32002 ? new ql(a) : a;
    }
  }
};
JT = /* @__PURE__ */ new WeakMap();
var Dre = {}, iU = {}, jt = {}, yY = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  function e(s, l) {
    var c = s >>> 16 & 65535, d = s & 65535, u = l >>> 16 & 65535, h = l & 65535;
    return d * h + (c * h + d * u << 16 >>> 0) | 0;
  }
  t.mul = Math.imul || e;
  function n(s, l) {
    return s + l | 0;
  }
  t.add = n;
  function r(s, l) {
    return s - l | 0;
  }
  t.sub = r;
  function i(s, l) {
    return s << l | s >>> 32 - l;
  }
  t.rotl = i;
  function a(s, l) {
    return s << 32 - l | s >>> l;
  }
  t.rotr = a;
  function o(s) {
    return typeof s == "number" && isFinite(s) && Math.floor(s) === s;
  }
  t.isInteger = Number.isInteger || o, t.MAX_SAFE_INTEGER = 9007199254740991, t.isSafeInteger = function(s) {
    return t.isInteger(s) && s >= -t.MAX_SAFE_INTEGER && s <= t.MAX_SAFE_INTEGER;
  };
})(yY);
Object.defineProperty(jt, "__esModule", { value: !0 });
var ZY = yY;
function zre(t, e) {
  return e === void 0 && (e = 0), (t[e + 0] << 8 | t[e + 1]) << 16 >> 16;
}
jt.readInt16BE = zre;
function kre(t, e) {
  return e === void 0 && (e = 0), (t[e + 0] << 8 | t[e + 1]) >>> 0;
}
jt.readUint16BE = kre;
function wre(t, e) {
  return e === void 0 && (e = 0), (t[e + 1] << 8 | t[e]) << 16 >> 16;
}
jt.readInt16LE = wre;
function Fre(t, e) {
  return e === void 0 && (e = 0), (t[e + 1] << 8 | t[e]) >>> 0;
}
jt.readUint16LE = Fre;
function bY(t, e, n) {
  return e === void 0 && (e = new Uint8Array(2)), n === void 0 && (n = 0), e[n + 0] = t >>> 8, e[n + 1] = t >>> 0, e;
}
jt.writeUint16BE = bY;
jt.writeInt16BE = bY;
function EY(t, e, n) {
  return e === void 0 && (e = new Uint8Array(2)), n === void 0 && (n = 0), e[n + 0] = t >>> 0, e[n + 1] = t >>> 8, e;
}
jt.writeUint16LE = EY;
jt.writeInt16LE = EY;
function GZ(t, e) {
  return e === void 0 && (e = 0), t[e] << 24 | t[e + 1] << 16 | t[e + 2] << 8 | t[e + 3];
}
jt.readInt32BE = GZ;
function CZ(t, e) {
  return e === void 0 && (e = 0), (t[e] << 24 | t[e + 1] << 16 | t[e + 2] << 8 | t[e + 3]) >>> 0;
}
jt.readUint32BE = CZ;
function LZ(t, e) {
  return e === void 0 && (e = 0), t[e + 3] << 24 | t[e + 2] << 16 | t[e + 1] << 8 | t[e];
}
jt.readInt32LE = LZ;
function JZ(t, e) {
  return e === void 0 && (e = 0), (t[e + 3] << 24 | t[e + 2] << 16 | t[e + 1] << 8 | t[e]) >>> 0;
}
jt.readUint32LE = JZ;
function Kf(t, e, n) {
  return e === void 0 && (e = new Uint8Array(4)), n === void 0 && (n = 0), e[n + 0] = t >>> 24, e[n + 1] = t >>> 16, e[n + 2] = t >>> 8, e[n + 3] = t >>> 0, e;
}
jt.writeUint32BE = Kf;
jt.writeInt32BE = Kf;
function $f(t, e, n) {
  return e === void 0 && (e = new Uint8Array(4)), n === void 0 && (n = 0), e[n + 0] = t >>> 0, e[n + 1] = t >>> 8, e[n + 2] = t >>> 16, e[n + 3] = t >>> 24, e;
}
jt.writeUint32LE = $f;
jt.writeInt32LE = $f;
function vre(t, e) {
  e === void 0 && (e = 0);
  var n = GZ(t, e), r = GZ(t, e + 4);
  return n * 4294967296 + r - (r >> 31) * 4294967296;
}
jt.readInt64BE = vre;
function Ire(t, e) {
  e === void 0 && (e = 0);
  var n = CZ(t, e), r = CZ(t, e + 4);
  return n * 4294967296 + r;
}
jt.readUint64BE = Ire;
function Ore(t, e) {
  e === void 0 && (e = 0);
  var n = LZ(t, e), r = LZ(t, e + 4);
  return r * 4294967296 + n - (n >> 31) * 4294967296;
}
jt.readInt64LE = Ore;
function Yre(t, e) {
  e === void 0 && (e = 0);
  var n = JZ(t, e), r = JZ(t, e + 4);
  return r * 4294967296 + n;
}
jt.readUint64LE = Yre;
function SY(t, e, n) {
  return e === void 0 && (e = new Uint8Array(8)), n === void 0 && (n = 0), Kf(t / 4294967296 >>> 0, e, n), Kf(t >>> 0, e, n + 4), e;
}
jt.writeUint64BE = SY;
jt.writeInt64BE = SY;
function xY(t, e, n) {
  return e === void 0 && (e = new Uint8Array(8)), n === void 0 && (n = 0), $f(t >>> 0, e, n), $f(t / 4294967296 >>> 0, e, n + 4), e;
}
jt.writeUint64LE = xY;
jt.writeInt64LE = xY;
function Qre(t, e, n) {
  if (n === void 0 && (n = 0), t % 8 !== 0)
    throw new Error("readUintBE supports only bitLengths divisible by 8");
  if (t / 8 > e.length - n)
    throw new Error("readUintBE: array is too short for the given bitLength");
  for (var r = 0, i = 1, a = t / 8 + n - 1; a >= n; a--)
    r += e[a] * i, i *= 256;
  return r;
}
jt.readUintBE = Qre;
function Gre(t, e, n) {
  if (n === void 0 && (n = 0), t % 8 !== 0)
    throw new Error("readUintLE supports only bitLengths divisible by 8");
  if (t / 8 > e.length - n)
    throw new Error("readUintLE: array is too short for the given bitLength");
  for (var r = 0, i = 1, a = n; a < n + t / 8; a++)
    r += e[a] * i, i *= 256;
  return r;
}
jt.readUintLE = Gre;
function Cre(t, e, n, r) {
  if (n === void 0 && (n = new Uint8Array(t / 8)), r === void 0 && (r = 0), t % 8 !== 0)
    throw new Error("writeUintBE supports only bitLengths divisible by 8");
  if (!ZY.isSafeInteger(e))
    throw new Error("writeUintBE value must be an integer");
  for (var i = 1, a = t / 8 + r - 1; a >= r; a--)
    n[a] = e / i & 255, i *= 256;
  return n;
}
jt.writeUintBE = Cre;
function Lre(t, e, n, r) {
  if (n === void 0 && (n = new Uint8Array(t / 8)), r === void 0 && (r = 0), t % 8 !== 0)
    throw new Error("writeUintLE supports only bitLengths divisible by 8");
  if (!ZY.isSafeInteger(e))
    throw new Error("writeUintLE value must be an integer");
  for (var i = 1, a = r; a < r + t / 8; a++)
    n[a] = e / i & 255, i *= 256;
  return n;
}
jt.writeUintLE = Lre;
function Jre(t, e) {
  e === void 0 && (e = 0);
  var n = new DataView(t.buffer, t.byteOffset, t.byteLength);
  return n.getFloat32(e);
}
jt.readFloat32BE = Jre;
function Bre(t, e) {
  e === void 0 && (e = 0);
  var n = new DataView(t.buffer, t.byteOffset, t.byteLength);
  return n.getFloat32(e, !0);
}
jt.readFloat32LE = Bre;
function Are(t, e) {
  e === void 0 && (e = 0);
  var n = new DataView(t.buffer, t.byteOffset, t.byteLength);
  return n.getFloat64(e);
}
jt.readFloat64BE = Are;
function Hre(t, e) {
  e === void 0 && (e = 0);
  var n = new DataView(t.buffer, t.byteOffset, t.byteLength);
  return n.getFloat64(e, !0);
}
jt.readFloat64LE = Hre;
function Xre(t, e, n) {
  e === void 0 && (e = new Uint8Array(4)), n === void 0 && (n = 0);
  var r = new DataView(e.buffer, e.byteOffset, e.byteLength);
  return r.setFloat32(n, t), e;
}
jt.writeFloat32BE = Xre;
function _re(t, e, n) {
  e === void 0 && (e = new Uint8Array(4)), n === void 0 && (n = 0);
  var r = new DataView(e.buffer, e.byteOffset, e.byteLength);
  return r.setFloat32(n, t, !0), e;
}
jt.writeFloat32LE = _re;
function Pre(t, e, n) {
  e === void 0 && (e = new Uint8Array(8)), n === void 0 && (n = 0);
  var r = new DataView(e.buffer, e.byteOffset, e.byteLength);
  return r.setFloat64(n, t), e;
}
jt.writeFloat64BE = Pre;
function Kre(t, e, n) {
  e === void 0 && (e = new Uint8Array(8)), n === void 0 && (n = 0);
  var r = new DataView(e.buffer, e.byteOffset, e.byteLength);
  return r.setFloat64(n, t, !0), e;
}
jt.writeFloat64LE = Kre;
var qa = {};
Object.defineProperty(qa, "__esModule", { value: !0 });
function $re(t) {
  for (var e = 0; e < t.length; e++)
    t[e] = 0;
  return t;
}
qa.wipe = $re;
Object.defineProperty(iU, "__esModule", { value: !0 });
var Hr = jt, BZ = qa, qre = 20;
function eie(t, e, n) {
  for (var r = 1634760805, i = 857760878, a = 2036477234, o = 1797285236, s = n[3] << 24 | n[2] << 16 | n[1] << 8 | n[0], l = n[7] << 24 | n[6] << 16 | n[5] << 8 | n[4], c = n[11] << 24 | n[10] << 16 | n[9] << 8 | n[8], d = n[15] << 24 | n[14] << 16 | n[13] << 8 | n[12], u = n[19] << 24 | n[18] << 16 | n[17] << 8 | n[16], h = n[23] << 24 | n[22] << 16 | n[21] << 8 | n[20], N = n[27] << 24 | n[26] << 16 | n[25] << 8 | n[24], M = n[31] << 24 | n[30] << 16 | n[29] << 8 | n[28], p = e[3] << 24 | e[2] << 16 | e[1] << 8 | e[0], m = e[7] << 24 | e[6] << 16 | e[5] << 8 | e[4], R = e[11] << 24 | e[10] << 16 | e[9] << 8 | e[8], V = e[15] << 24 | e[14] << 16 | e[13] << 8 | e[12], U = r, g = i, y = a, x = o, f = s, D = l, Y = c, Q = d, G = u, ne = h, O = N, T = M, Z = p, z = m, j = R, w = V, C = 0; C < qre; C += 2)
    U = U + f | 0, Z ^= U, Z = Z >>> 32 - 16 | Z << 16, G = G + Z | 0, f ^= G, f = f >>> 32 - 12 | f << 12, g = g + D | 0, z ^= g, z = z >>> 32 - 16 | z << 16, ne = ne + z | 0, D ^= ne, D = D >>> 32 - 12 | D << 12, y = y + Y | 0, j ^= y, j = j >>> 32 - 16 | j << 16, O = O + j | 0, Y ^= O, Y = Y >>> 32 - 12 | Y << 12, x = x + Q | 0, w ^= x, w = w >>> 32 - 16 | w << 16, T = T + w | 0, Q ^= T, Q = Q >>> 32 - 12 | Q << 12, y = y + Y | 0, j ^= y, j = j >>> 32 - 8 | j << 8, O = O + j | 0, Y ^= O, Y = Y >>> 32 - 7 | Y << 7, x = x + Q | 0, w ^= x, w = w >>> 32 - 8 | w << 8, T = T + w | 0, Q ^= T, Q = Q >>> 32 - 7 | Q << 7, g = g + D | 0, z ^= g, z = z >>> 32 - 8 | z << 8, ne = ne + z | 0, D ^= ne, D = D >>> 32 - 7 | D << 7, U = U + f | 0, Z ^= U, Z = Z >>> 32 - 8 | Z << 8, G = G + Z | 0, f ^= G, f = f >>> 32 - 7 | f << 7, U = U + D | 0, w ^= U, w = w >>> 32 - 16 | w << 16, O = O + w | 0, D ^= O, D = D >>> 32 - 12 | D << 12, g = g + Y | 0, Z ^= g, Z = Z >>> 32 - 16 | Z << 16, T = T + Z | 0, Y ^= T, Y = Y >>> 32 - 12 | Y << 12, y = y + Q | 0, z ^= y, z = z >>> 32 - 16 | z << 16, G = G + z | 0, Q ^= G, Q = Q >>> 32 - 12 | Q << 12, x = x + f | 0, j ^= x, j = j >>> 32 - 16 | j << 16, ne = ne + j | 0, f ^= ne, f = f >>> 32 - 12 | f << 12, y = y + Q | 0, z ^= y, z = z >>> 32 - 8 | z << 8, G = G + z | 0, Q ^= G, Q = Q >>> 32 - 7 | Q << 7, x = x + f | 0, j ^= x, j = j >>> 32 - 8 | j << 8, ne = ne + j | 0, f ^= ne, f = f >>> 32 - 7 | f << 7, g = g + Y | 0, Z ^= g, Z = Z >>> 32 - 8 | Z << 8, T = T + Z | 0, Y ^= T, Y = Y >>> 32 - 7 | Y << 7, U = U + D | 0, w ^= U, w = w >>> 32 - 8 | w << 8, O = O + w | 0, D ^= O, D = D >>> 32 - 7 | D << 7;
  Hr.writeUint32LE(U + r | 0, t, 0), Hr.writeUint32LE(g + i | 0, t, 4), Hr.writeUint32LE(y + a | 0, t, 8), Hr.writeUint32LE(x + o | 0, t, 12), Hr.writeUint32LE(f + s | 0, t, 16), Hr.writeUint32LE(D + l | 0, t, 20), Hr.writeUint32LE(Y + c | 0, t, 24), Hr.writeUint32LE(Q + d | 0, t, 28), Hr.writeUint32LE(G + u | 0, t, 32), Hr.writeUint32LE(ne + h | 0, t, 36), Hr.writeUint32LE(O + N | 0, t, 40), Hr.writeUint32LE(T + M | 0, t, 44), Hr.writeUint32LE(Z + p | 0, t, 48), Hr.writeUint32LE(z + m | 0, t, 52), Hr.writeUint32LE(j + R | 0, t, 56), Hr.writeUint32LE(w + V | 0, t, 60);
}
function WY(t, e, n, r, i) {
  if (i === void 0 && (i = 0), t.length !== 32)
    throw new Error("ChaCha: key size must be 32 bytes");
  if (r.length < n.length)
    throw new Error("ChaCha: destination is shorter than source");
  var a, o;
  if (i === 0) {
    if (e.length !== 8 && e.length !== 12)
      throw new Error("ChaCha nonce must be 8 or 12 bytes");
    a = new Uint8Array(16), o = a.length - e.length, a.set(e, o);
  } else {
    if (e.length !== 16)
      throw new Error("ChaCha nonce with counter must be 16 bytes");
    a = e, o = i;
  }
  for (var s = new Uint8Array(64), l = 0; l < n.length; l += 64) {
    eie(s, a, t);
    for (var c = l; c < l + 64 && c < n.length; c++)
      r[c] = n[c] ^ s[c - l];
    nie(a, 0, o);
  }
  return BZ.wipe(s), i === 0 && BZ.wipe(a), r;
}
iU.streamXOR = WY;
function tie(t, e, n, r) {
  return r === void 0 && (r = 0), BZ.wipe(n), WY(t, e, n, n, r);
}
iU.stream = tie;
function nie(t, e, n) {
  for (var r = 1; n--; )
    r = r + (t[e] & 255) | 0, t[e] = r & 255, r >>>= 8, e++;
  if (r > 0)
    throw new Error("ChaCha: counter overflow");
}
var jY = {}, Zc = {};
Object.defineProperty(Zc, "__esModule", { value: !0 });
function rie(t, e, n) {
  return ~(t - 1) & e | t - 1 & n;
}
Zc.select = rie;
function iie(t, e) {
  return (t | 0) - (e | 0) - 1 >>> 31 & 1;
}
Zc.lessOrEqual = iie;
function DY(t, e) {
  if (t.length !== e.length)
    return 0;
  for (var n = 0, r = 0; r < t.length; r++)
    n |= t[r] ^ e[r];
  return 1 & n - 1 >>> 8;
}
Zc.compare = DY;
function aie(t, e) {
  return t.length === 0 || e.length === 0 ? !1 : DY(t, e) !== 0;
}
Zc.equal = aie;
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = Zc, n = qa;
  t.DIGEST_LENGTH = 16;
  var r = (
    /** @class */
    function() {
      function o(s) {
        this.digestLength = t.DIGEST_LENGTH, this._buffer = new Uint8Array(16), this._r = new Uint16Array(10), this._h = new Uint16Array(10), this._pad = new Uint16Array(8), this._leftover = 0, this._fin = 0, this._finished = !1;
        var l = s[0] | s[1] << 8;
        this._r[0] = l & 8191;
        var c = s[2] | s[3] << 8;
        this._r[1] = (l >>> 13 | c << 3) & 8191;
        var d = s[4] | s[5] << 8;
        this._r[2] = (c >>> 10 | d << 6) & 7939;
        var u = s[6] | s[7] << 8;
        this._r[3] = (d >>> 7 | u << 9) & 8191;
        var h = s[8] | s[9] << 8;
        this._r[4] = (u >>> 4 | h << 12) & 255, this._r[5] = h >>> 1 & 8190;
        var N = s[10] | s[11] << 8;
        this._r[6] = (h >>> 14 | N << 2) & 8191;
        var M = s[12] | s[13] << 8;
        this._r[7] = (N >>> 11 | M << 5) & 8065;
        var p = s[14] | s[15] << 8;
        this._r[8] = (M >>> 8 | p << 8) & 8191, this._r[9] = p >>> 5 & 127, this._pad[0] = s[16] | s[17] << 8, this._pad[1] = s[18] | s[19] << 8, this._pad[2] = s[20] | s[21] << 8, this._pad[3] = s[22] | s[23] << 8, this._pad[4] = s[24] | s[25] << 8, this._pad[5] = s[26] | s[27] << 8, this._pad[6] = s[28] | s[29] << 8, this._pad[7] = s[30] | s[31] << 8;
      }
      return o.prototype._blocks = function(s, l, c) {
        for (var d = this._fin ? 0 : 2048, u = this._h[0], h = this._h[1], N = this._h[2], M = this._h[3], p = this._h[4], m = this._h[5], R = this._h[6], V = this._h[7], U = this._h[8], g = this._h[9], y = this._r[0], x = this._r[1], f = this._r[2], D = this._r[3], Y = this._r[4], Q = this._r[5], G = this._r[6], ne = this._r[7], O = this._r[8], T = this._r[9]; c >= 16; ) {
          var Z = s[l + 0] | s[l + 1] << 8;
          u += Z & 8191;
          var z = s[l + 2] | s[l + 3] << 8;
          h += (Z >>> 13 | z << 3) & 8191;
          var j = s[l + 4] | s[l + 5] << 8;
          N += (z >>> 10 | j << 6) & 8191;
          var w = s[l + 6] | s[l + 7] << 8;
          M += (j >>> 7 | w << 9) & 8191;
          var C = s[l + 8] | s[l + 9] << 8;
          p += (w >>> 4 | C << 12) & 8191, m += C >>> 1 & 8191;
          var J = s[l + 10] | s[l + 11] << 8;
          R += (C >>> 14 | J << 2) & 8191;
          var I = s[l + 12] | s[l + 13] << 8;
          V += (J >>> 11 | I << 5) & 8191;
          var b = s[l + 14] | s[l + 15] << 8;
          U += (I >>> 8 | b << 8) & 8191, g += b >>> 5 | d;
          var k = 0, ae = k;
          ae += u * y, ae += h * (5 * T), ae += N * (5 * O), ae += M * (5 * ne), ae += p * (5 * G), k = ae >>> 13, ae &= 8191, ae += m * (5 * Q), ae += R * (5 * Y), ae += V * (5 * D), ae += U * (5 * f), ae += g * (5 * x), k += ae >>> 13, ae &= 8191;
          var oe = k;
          oe += u * x, oe += h * y, oe += N * (5 * T), oe += M * (5 * O), oe += p * (5 * ne), k = oe >>> 13, oe &= 8191, oe += m * (5 * G), oe += R * (5 * Q), oe += V * (5 * Y), oe += U * (5 * D), oe += g * (5 * f), k += oe >>> 13, oe &= 8191;
          var le = k;
          le += u * f, le += h * x, le += N * y, le += M * (5 * T), le += p * (5 * O), k = le >>> 13, le &= 8191, le += m * (5 * ne), le += R * (5 * G), le += V * (5 * Q), le += U * (5 * Y), le += g * (5 * D), k += le >>> 13, le &= 8191;
          var fe = k;
          fe += u * D, fe += h * f, fe += N * x, fe += M * y, fe += p * (5 * T), k = fe >>> 13, fe &= 8191, fe += m * (5 * O), fe += R * (5 * ne), fe += V * (5 * G), fe += U * (5 * Q), fe += g * (5 * Y), k += fe >>> 13, fe &= 8191;
          var de = k;
          de += u * Y, de += h * D, de += N * f, de += M * x, de += p * y, k = de >>> 13, de &= 8191, de += m * (5 * T), de += R * (5 * O), de += V * (5 * ne), de += U * (5 * G), de += g * (5 * Q), k += de >>> 13, de &= 8191;
          var Me = k;
          Me += u * Q, Me += h * Y, Me += N * D, Me += M * f, Me += p * x, k = Me >>> 13, Me &= 8191, Me += m * y, Me += R * (5 * T), Me += V * (5 * O), Me += U * (5 * ne), Me += g * (5 * G), k += Me >>> 13, Me &= 8191;
          var je = k;
          je += u * G, je += h * Q, je += N * Y, je += M * D, je += p * f, k = je >>> 13, je &= 8191, je += m * x, je += R * y, je += V * (5 * T), je += U * (5 * O), je += g * (5 * ne), k += je >>> 13, je &= 8191;
          var Se = k;
          Se += u * ne, Se += h * G, Se += N * Q, Se += M * Y, Se += p * D, k = Se >>> 13, Se &= 8191, Se += m * f, Se += R * x, Se += V * y, Se += U * (5 * T), Se += g * (5 * O), k += Se >>> 13, Se &= 8191;
          var se = k;
          se += u * O, se += h * ne, se += N * G, se += M * Q, se += p * Y, k = se >>> 13, se &= 8191, se += m * D, se += R * f, se += V * x, se += U * y, se += g * (5 * T), k += se >>> 13, se &= 8191;
          var Ce = k;
          Ce += u * T, Ce += h * O, Ce += N * ne, Ce += M * G, Ce += p * Q, k = Ce >>> 13, Ce &= 8191, Ce += m * Y, Ce += R * D, Ce += V * f, Ce += U * x, Ce += g * y, k += Ce >>> 13, Ce &= 8191, k = (k << 2) + k | 0, k = k + ae | 0, ae = k & 8191, k = k >>> 13, oe += k, u = ae, h = oe, N = le, M = fe, p = de, m = Me, R = je, V = Se, U = se, g = Ce, l += 16, c -= 16;
        }
        this._h[0] = u, this._h[1] = h, this._h[2] = N, this._h[3] = M, this._h[4] = p, this._h[5] = m, this._h[6] = R, this._h[7] = V, this._h[8] = U, this._h[9] = g;
      }, o.prototype.finish = function(s, l) {
        l === void 0 && (l = 0);
        var c = new Uint16Array(10), d, u, h, N;
        if (this._leftover) {
          for (N = this._leftover, this._buffer[N++] = 1; N < 16; N++)
            this._buffer[N] = 0;
          this._fin = 1, this._blocks(this._buffer, 0, 16);
        }
        for (d = this._h[1] >>> 13, this._h[1] &= 8191, N = 2; N < 10; N++)
          this._h[N] += d, d = this._h[N] >>> 13, this._h[N] &= 8191;
        for (this._h[0] += d * 5, d = this._h[0] >>> 13, this._h[0] &= 8191, this._h[1] += d, d = this._h[1] >>> 13, this._h[1] &= 8191, this._h[2] += d, c[0] = this._h[0] + 5, d = c[0] >>> 13, c[0] &= 8191, N = 1; N < 10; N++)
          c[N] = this._h[N] + d, d = c[N] >>> 13, c[N] &= 8191;
        for (c[9] -= 8192, u = (d ^ 1) - 1, N = 0; N < 10; N++)
          c[N] &= u;
        for (u = ~u, N = 0; N < 10; N++)
          this._h[N] = this._h[N] & u | c[N];
        for (this._h[0] = (this._h[0] | this._h[1] << 13) & 65535, this._h[1] = (this._h[1] >>> 3 | this._h[2] << 10) & 65535, this._h[2] = (this._h[2] >>> 6 | this._h[3] << 7) & 65535, this._h[3] = (this._h[3] >>> 9 | this._h[4] << 4) & 65535, this._h[4] = (this._h[4] >>> 12 | this._h[5] << 1 | this._h[6] << 14) & 65535, this._h[5] = (this._h[6] >>> 2 | this._h[7] << 11) & 65535, this._h[6] = (this._h[7] >>> 5 | this._h[8] << 8) & 65535, this._h[7] = (this._h[8] >>> 8 | this._h[9] << 5) & 65535, h = this._h[0] + this._pad[0], this._h[0] = h & 65535, N = 1; N < 8; N++)
          h = (this._h[N] + this._pad[N] | 0) + (h >>> 16) | 0, this._h[N] = h & 65535;
        return s[l + 0] = this._h[0] >>> 0, s[l + 1] = this._h[0] >>> 8, s[l + 2] = this._h[1] >>> 0, s[l + 3] = this._h[1] >>> 8, s[l + 4] = this._h[2] >>> 0, s[l + 5] = this._h[2] >>> 8, s[l + 6] = this._h[3] >>> 0, s[l + 7] = this._h[3] >>> 8, s[l + 8] = this._h[4] >>> 0, s[l + 9] = this._h[4] >>> 8, s[l + 10] = this._h[5] >>> 0, s[l + 11] = this._h[5] >>> 8, s[l + 12] = this._h[6] >>> 0, s[l + 13] = this._h[6] >>> 8, s[l + 14] = this._h[7] >>> 0, s[l + 15] = this._h[7] >>> 8, this._finished = !0, this;
      }, o.prototype.update = function(s) {
        var l = 0, c = s.length, d;
        if (this._leftover) {
          d = 16 - this._leftover, d > c && (d = c);
          for (var u = 0; u < d; u++)
            this._buffer[this._leftover + u] = s[l + u];
          if (c -= d, l += d, this._leftover += d, this._leftover < 16)
            return this;
          this._blocks(this._buffer, 0, 16), this._leftover = 0;
        }
        if (c >= 16 && (d = c - c % 16, this._blocks(s, l, d), l += d, c -= d), c) {
          for (var u = 0; u < c; u++)
            this._buffer[this._leftover + u] = s[l + u];
          this._leftover += c;
        }
        return this;
      }, o.prototype.digest = function() {
        if (this._finished)
          throw new Error("Poly1305 was finished");
        var s = new Uint8Array(16);
        return this.finish(s), s;
      }, o.prototype.clean = function() {
        return n.wipe(this._buffer), n.wipe(this._r), n.wipe(this._h), n.wipe(this._pad), this._leftover = 0, this._fin = 0, this._finished = !0, this;
      }, o;
    }()
  );
  t.Poly1305 = r;
  function i(o, s) {
    var l = new r(o);
    l.update(s);
    var c = l.digest();
    return l.clean(), c;
  }
  t.oneTimeAuth = i;
  function a(o, s) {
    return o.length !== t.DIGEST_LENGTH || s.length !== t.DIGEST_LENGTH ? !1 : e.equal(o, s);
  }
  t.equal = a;
})(jY);
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = iU, n = jY, r = qa, i = jt, a = Zc;
  t.KEY_LENGTH = 32, t.NONCE_LENGTH = 12, t.TAG_LENGTH = 16;
  var o = new Uint8Array(16), s = (
    /** @class */
    function() {
      function l(c) {
        if (this.nonceLength = t.NONCE_LENGTH, this.tagLength = t.TAG_LENGTH, c.length !== t.KEY_LENGTH)
          throw new Error("ChaCha20Poly1305 needs 32-byte key");
        this._key = new Uint8Array(c);
      }
      return l.prototype.seal = function(c, d, u, h) {
        if (c.length > 16)
          throw new Error("ChaCha20Poly1305: incorrect nonce length");
        var N = new Uint8Array(16);
        N.set(c, N.length - c.length);
        var M = new Uint8Array(32);
        e.stream(this._key, N, M, 4);
        var p = d.length + this.tagLength, m;
        if (h) {
          if (h.length !== p)
            throw new Error("ChaCha20Poly1305: incorrect destination length");
          m = h;
        } else
          m = new Uint8Array(p);
        return e.streamXOR(this._key, N, d, m, 4), this._authenticate(m.subarray(m.length - this.tagLength, m.length), M, m.subarray(0, m.length - this.tagLength), u), r.wipe(N), m;
      }, l.prototype.open = function(c, d, u, h) {
        if (c.length > 16)
          throw new Error("ChaCha20Poly1305: incorrect nonce length");
        if (d.length < this.tagLength)
          return null;
        var N = new Uint8Array(16);
        N.set(c, N.length - c.length);
        var M = new Uint8Array(32);
        e.stream(this._key, N, M, 4);
        var p = new Uint8Array(this.tagLength);
        if (this._authenticate(p, M, d.subarray(0, d.length - this.tagLength), u), !a.equal(p, d.subarray(d.length - this.tagLength, d.length)))
          return null;
        var m = d.length - this.tagLength, R;
        if (h) {
          if (h.length !== m)
            throw new Error("ChaCha20Poly1305: incorrect destination length");
          R = h;
        } else
          R = new Uint8Array(m);
        return e.streamXOR(this._key, N, d.subarray(0, d.length - this.tagLength), R, 4), r.wipe(N), R;
      }, l.prototype.clean = function() {
        return r.wipe(this._key), this;
      }, l.prototype._authenticate = function(c, d, u, h) {
        var N = new n.Poly1305(d);
        h && (N.update(h), h.length % 16 > 0 && N.update(o.subarray(h.length % 16))), N.update(u), u.length % 16 > 0 && N.update(o.subarray(u.length % 16));
        var M = new Uint8Array(8);
        h && i.writeUint64LE(h.length, M), N.update(M), i.writeUint64LE(u.length, M), N.update(M);
        for (var p = N.digest(), m = 0; m < p.length; m++)
          c[m] = p[m];
        N.clean(), r.wipe(p), r.wipe(M);
      }, l;
    }()
  );
  t.ChaCha20Poly1305 = s;
})(Dre);
var zY = {}, _p = {}, P3 = {};
Object.defineProperty(P3, "__esModule", { value: !0 });
function oie(t) {
  return typeof t.saveState < "u" && typeof t.restoreState < "u" && typeof t.cleanSavedState < "u";
}
P3.isSerializableHash = oie;
Object.defineProperty(_p, "__esModule", { value: !0 });
var oo = P3, sie = Zc, lie = qa, kY = (
  /** @class */
  function() {
    function t(e, n) {
      this._finished = !1, this._inner = new e(), this._outer = new e(), this.blockSize = this._outer.blockSize, this.digestLength = this._outer.digestLength;
      var r = new Uint8Array(this.blockSize);
      n.length > this.blockSize ? this._inner.update(n).finish(r).clean() : r.set(n);
      for (var i = 0; i < r.length; i++)
        r[i] ^= 54;
      this._inner.update(r);
      for (var i = 0; i < r.length; i++)
        r[i] ^= 106;
      this._outer.update(r), oo.isSerializableHash(this._inner) && oo.isSerializableHash(this._outer) && (this._innerKeyedState = this._inner.saveState(), this._outerKeyedState = this._outer.saveState()), lie.wipe(r);
    }
    return t.prototype.reset = function() {
      if (!oo.isSerializableHash(this._inner) || !oo.isSerializableHash(this._outer))
        throw new Error("hmac: can't reset() because hash doesn't implement restoreState()");
      return this._inner.restoreState(this._innerKeyedState), this._outer.restoreState(this._outerKeyedState), this._finished = !1, this;
    }, t.prototype.clean = function() {
      oo.isSerializableHash(this._inner) && this._inner.cleanSavedState(this._innerKeyedState), oo.isSerializableHash(this._outer) && this._outer.cleanSavedState(this._outerKeyedState), this._inner.clean(), this._outer.clean();
    }, t.prototype.update = function(e) {
      return this._inner.update(e), this;
    }, t.prototype.finish = function(e) {
      return this._finished ? (this._outer.finish(e), this) : (this._inner.finish(e), this._outer.update(e.subarray(0, this.digestLength)).finish(e), this._finished = !0, this);
    }, t.prototype.digest = function() {
      var e = new Uint8Array(this.digestLength);
      return this.finish(e), e;
    }, t.prototype.saveState = function() {
      if (!oo.isSerializableHash(this._inner))
        throw new Error("hmac: can't saveState() because hash doesn't implement it");
      return this._inner.saveState();
    }, t.prototype.restoreState = function(e) {
      if (!oo.isSerializableHash(this._inner) || !oo.isSerializableHash(this._outer))
        throw new Error("hmac: can't restoreState() because hash doesn't implement it");
      return this._inner.restoreState(e), this._outer.restoreState(this._outerKeyedState), this._finished = !1, this;
    }, t.prototype.cleanSavedState = function(e) {
      if (!oo.isSerializableHash(this._inner))
        throw new Error("hmac: can't cleanSavedState() because hash doesn't implement it");
      this._inner.cleanSavedState(e);
    }, t;
  }()
);
_p.HMAC = kY;
function cie(t, e, n) {
  var r = new kY(t, e);
  r.update(n);
  var i = r.digest();
  return r.clean(), i;
}
_p.hmac = cie;
_p.equal = sie.equal;
Object.defineProperty(zY, "__esModule", { value: !0 });
var SD = _p, xD = qa, die = (
  /** @class */
  function() {
    function t(e, n, r, i) {
      r === void 0 && (r = new Uint8Array(0)), this._counter = new Uint8Array(1), this._hash = e, this._info = i;
      var a = SD.hmac(this._hash, r, n);
      this._hmac = new SD.HMAC(e, a), this._buffer = new Uint8Array(this._hmac.digestLength), this._bufpos = this._buffer.length;
    }
    return t.prototype._fillBuffer = function() {
      this._counter[0]++;
      var e = this._counter[0];
      if (e === 0)
        throw new Error("hkdf: cannot expand more");
      this._hmac.reset(), e > 1 && this._hmac.update(this._buffer), this._info && this._hmac.update(this._info), this._hmac.update(this._counter), this._hmac.finish(this._buffer), this._bufpos = 0;
    }, t.prototype.expand = function(e) {
      for (var n = new Uint8Array(e), r = 0; r < n.length; r++)
        this._bufpos === this._buffer.length && this._fillBuffer(), n[r] = this._buffer[this._bufpos++];
      return n;
    }, t.prototype.clean = function() {
      this._hmac.clean(), xD.wipe(this._buffer), xD.wipe(this._counter), this._bufpos = 0;
    }, t;
  }()
), Owe = zY.HKDF = die, wY = {}, aU = {}, oU = {};
Object.defineProperty(oU, "__esModule", { value: !0 });
oU.BrowserRandomSource = void 0;
const WD = 65536;
class uie {
  constructor() {
    this.isAvailable = !1, this.isInstantiated = !1;
    const e = typeof self < "u" ? self.crypto || self.msCrypto : null;
    e && e.getRandomValues !== void 0 && (this._crypto = e, this.isAvailable = !0, this.isInstantiated = !0);
  }
  randomBytes(e) {
    if (!this.isAvailable || !this._crypto)
      throw new Error("Browser random byte generator is not available.");
    const n = new Uint8Array(e);
    for (let r = 0; r < n.length; r += WD)
      this._crypto.getRandomValues(n.subarray(r, r + Math.min(n.length - r, WD)));
    return n;
  }
}
oU.BrowserRandomSource = uie;
function hie(t) {
  throw new Error('Could not dynamically require "' + t + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var sU = {};
Object.defineProperty(sU, "__esModule", { value: !0 });
sU.NodeRandomSource = void 0;
const Nie = qa;
class Mie {
  constructor() {
    if (this.isAvailable = !1, this.isInstantiated = !1, typeof hie < "u") {
      const e = MI;
      e && e.randomBytes && (this._crypto = e, this.isAvailable = !0, this.isInstantiated = !0);
    }
  }
  randomBytes(e) {
    if (!this.isAvailable || !this._crypto)
      throw new Error("Node.js random byte generator is not available.");
    let n = this._crypto.randomBytes(e);
    if (n.length !== e)
      throw new Error("NodeRandomSource: got fewer bytes than requested");
    const r = new Uint8Array(e);
    for (let i = 0; i < r.length; i++)
      r[i] = n[i];
    return (0, Nie.wipe)(n), r;
  }
}
sU.NodeRandomSource = Mie;
Object.defineProperty(aU, "__esModule", { value: !0 });
aU.SystemRandomSource = void 0;
const pie = oU, mie = sU;
class Tie {
  constructor() {
    if (this.isAvailable = !1, this.name = "", this._source = new pie.BrowserRandomSource(), this._source.isAvailable) {
      this.isAvailable = !0, this.name = "Browser";
      return;
    }
    if (this._source = new mie.NodeRandomSource(), this._source.isAvailable) {
      this.isAvailable = !0, this.name = "Node";
      return;
    }
  }
  randomBytes(e) {
    if (!this.isAvailable)
      throw new Error("System random byte generator is not available.");
    return this._source.randomBytes(e);
  }
}
aU.SystemRandomSource = Tie;
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.randomStringForEntropy = t.randomString = t.randomUint32 = t.randomBytes = t.defaultRandomSource = void 0;
  const e = aU, n = jt, r = qa;
  t.defaultRandomSource = new e.SystemRandomSource();
  function i(c, d = t.defaultRandomSource) {
    return d.randomBytes(c);
  }
  t.randomBytes = i;
  function a(c = t.defaultRandomSource) {
    const d = i(4, c), u = (0, n.readUint32LE)(d);
    return (0, r.wipe)(d), u;
  }
  t.randomUint32 = a;
  const o = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  function s(c, d = o, u = t.defaultRandomSource) {
    if (d.length < 2)
      throw new Error("randomString charset is too short");
    if (d.length > 256)
      throw new Error("randomString charset is too long");
    let h = "";
    const N = d.length, M = 256 - 256 % N;
    for (; c > 0; ) {
      const p = i(Math.ceil(c * 256 / M), u);
      for (let m = 0; m < p.length && c > 0; m++) {
        const R = p[m];
        R < M && (h += d.charAt(R % N), c--);
      }
      (0, r.wipe)(p);
    }
    return h;
  }
  t.randomString = s;
  function l(c, d = o, u = t.defaultRandomSource) {
    const h = Math.ceil(c / (Math.log(d.length) / Math.LN2));
    return s(h, d, u);
  }
  t.randomStringForEntropy = l;
})(wY);
var fie = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = jt, n = qa;
  t.DIGEST_LENGTH = 32, t.BLOCK_SIZE = 64;
  var r = (
    /** @class */
    function() {
      function s() {
        this.digestLength = t.DIGEST_LENGTH, this.blockSize = t.BLOCK_SIZE, this._state = new Int32Array(8), this._temp = new Int32Array(64), this._buffer = new Uint8Array(128), this._bufferLength = 0, this._bytesHashed = 0, this._finished = !1, this.reset();
      }
      return s.prototype._initState = function() {
        this._state[0] = 1779033703, this._state[1] = 3144134277, this._state[2] = 1013904242, this._state[3] = 2773480762, this._state[4] = 1359893119, this._state[5] = 2600822924, this._state[6] = 528734635, this._state[7] = 1541459225;
      }, s.prototype.reset = function() {
        return this._initState(), this._bufferLength = 0, this._bytesHashed = 0, this._finished = !1, this;
      }, s.prototype.clean = function() {
        n.wipe(this._buffer), n.wipe(this._temp), this.reset();
      }, s.prototype.update = function(l, c) {
        if (c === void 0 && (c = l.length), this._finished)
          throw new Error("SHA256: can't update because hash was finished.");
        var d = 0;
        if (this._bytesHashed += c, this._bufferLength > 0) {
          for (; this._bufferLength < this.blockSize && c > 0; )
            this._buffer[this._bufferLength++] = l[d++], c--;
          this._bufferLength === this.blockSize && (a(this._temp, this._state, this._buffer, 0, this.blockSize), this._bufferLength = 0);
        }
        for (c >= this.blockSize && (d = a(this._temp, this._state, l, d, c), c %= this.blockSize); c > 0; )
          this._buffer[this._bufferLength++] = l[d++], c--;
        return this;
      }, s.prototype.finish = function(l) {
        if (!this._finished) {
          var c = this._bytesHashed, d = this._bufferLength, u = c / 536870912 | 0, h = c << 3, N = c % 64 < 56 ? 64 : 128;
          this._buffer[d] = 128;
          for (var M = d + 1; M < N - 8; M++)
            this._buffer[M] = 0;
          e.writeUint32BE(u, this._buffer, N - 8), e.writeUint32BE(h, this._buffer, N - 4), a(this._temp, this._state, this._buffer, 0, N), this._finished = !0;
        }
        for (var M = 0; M < this.digestLength / 4; M++)
          e.writeUint32BE(this._state[M], l, M * 4);
        return this;
      }, s.prototype.digest = function() {
        var l = new Uint8Array(this.digestLength);
        return this.finish(l), l;
      }, s.prototype.saveState = function() {
        if (this._finished)
          throw new Error("SHA256: cannot save finished state");
        return {
          state: new Int32Array(this._state),
          buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : void 0,
          bufferLength: this._bufferLength,
          bytesHashed: this._bytesHashed
        };
      }, s.prototype.restoreState = function(l) {
        return this._state.set(l.state), this._bufferLength = l.bufferLength, l.buffer && this._buffer.set(l.buffer), this._bytesHashed = l.bytesHashed, this._finished = !1, this;
      }, s.prototype.cleanSavedState = function(l) {
        n.wipe(l.state), l.buffer && n.wipe(l.buffer), l.bufferLength = 0, l.bytesHashed = 0;
      }, s;
    }()
  );
  t.SHA256 = r;
  var i = new Int32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ]);
  function a(s, l, c, d, u) {
    for (; u >= 64; ) {
      for (var h = l[0], N = l[1], M = l[2], p = l[3], m = l[4], R = l[5], V = l[6], U = l[7], g = 0; g < 16; g++) {
        var y = d + g * 4;
        s[g] = e.readUint32BE(c, y);
      }
      for (var g = 16; g < 64; g++) {
        var x = s[g - 2], f = (x >>> 17 | x << 32 - 17) ^ (x >>> 19 | x << 32 - 19) ^ x >>> 10;
        x = s[g - 15];
        var D = (x >>> 7 | x << 32 - 7) ^ (x >>> 18 | x << 32 - 18) ^ x >>> 3;
        s[g] = (f + s[g - 7] | 0) + (D + s[g - 16] | 0);
      }
      for (var g = 0; g < 64; g++) {
        var f = (((m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7)) + (m & R ^ ~m & V) | 0) + (U + (i[g] + s[g] | 0) | 0) | 0, D = ((h >>> 2 | h << 32 - 2) ^ (h >>> 13 | h << 32 - 13) ^ (h >>> 22 | h << 32 - 22)) + (h & N ^ h & M ^ N & M) | 0;
        U = V, V = R, R = m, m = p + f | 0, p = M, M = N, N = h, h = f + D | 0;
      }
      l[0] += h, l[1] += N, l[2] += M, l[3] += p, l[4] += m, l[5] += R, l[6] += V, l[7] += U, d += 64, u -= 64;
    }
    return d;
  }
  function o(s) {
    var l = new r();
    l.update(s);
    var c = l.digest();
    return l.clean(), c;
  }
  t.hash = o;
})(fie);
var Vie = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.sharedKey = t.generateKeyPair = t.generateKeyPairFromSeed = t.scalarMultBase = t.scalarMult = t.SHARED_KEY_LENGTH = t.SECRET_KEY_LENGTH = t.PUBLIC_KEY_LENGTH = void 0;
  const e = wY, n = qa;
  t.PUBLIC_KEY_LENGTH = 32, t.SECRET_KEY_LENGTH = 32, t.SHARED_KEY_LENGTH = 32;
  function r(g) {
    const y = new Float64Array(16);
    if (g)
      for (let x = 0; x < g.length; x++)
        y[x] = g[x];
    return y;
  }
  const i = new Uint8Array(32);
  i[0] = 9;
  const a = r([56129, 1]);
  function o(g) {
    let y = 1;
    for (let x = 0; x < 16; x++) {
      let f = g[x] + y + 65535;
      y = Math.floor(f / 65536), g[x] = f - y * 65536;
    }
    g[0] += y - 1 + 37 * (y - 1);
  }
  function s(g, y, x) {
    const f = ~(x - 1);
    for (let D = 0; D < 16; D++) {
      const Y = f & (g[D] ^ y[D]);
      g[D] ^= Y, y[D] ^= Y;
    }
  }
  function l(g, y) {
    const x = r(), f = r();
    for (let D = 0; D < 16; D++)
      f[D] = y[D];
    o(f), o(f), o(f);
    for (let D = 0; D < 2; D++) {
      x[0] = f[0] - 65517;
      for (let Q = 1; Q < 15; Q++)
        x[Q] = f[Q] - 65535 - (x[Q - 1] >> 16 & 1), x[Q - 1] &= 65535;
      x[15] = f[15] - 32767 - (x[14] >> 16 & 1);
      const Y = x[15] >> 16 & 1;
      x[14] &= 65535, s(f, x, 1 - Y);
    }
    for (let D = 0; D < 16; D++)
      g[2 * D] = f[D] & 255, g[2 * D + 1] = f[D] >> 8;
  }
  function c(g, y) {
    for (let x = 0; x < 16; x++)
      g[x] = y[2 * x] + (y[2 * x + 1] << 8);
    g[15] &= 32767;
  }
  function d(g, y, x) {
    for (let f = 0; f < 16; f++)
      g[f] = y[f] + x[f];
  }
  function u(g, y, x) {
    for (let f = 0; f < 16; f++)
      g[f] = y[f] - x[f];
  }
  function h(g, y, x) {
    let f, D, Y = 0, Q = 0, G = 0, ne = 0, O = 0, T = 0, Z = 0, z = 0, j = 0, w = 0, C = 0, J = 0, I = 0, b = 0, k = 0, ae = 0, oe = 0, le = 0, fe = 0, de = 0, Me = 0, je = 0, Se = 0, se = 0, Ce = 0, et = 0, at = 0, Rn = 0, Zt = 0, kt = 0, Pn = 0, Oe = x[0], Xe = x[1], ft = x[2], Le = x[3], dt = x[4], Dt = x[5], ut = x[6], v = x[7], S = x[8], W = x[9], L = x[10], P = x[11], q = x[12], ie = x[13], Be = x[14], Je = x[15];
    f = y[0], Y += f * Oe, Q += f * Xe, G += f * ft, ne += f * Le, O += f * dt, T += f * Dt, Z += f * ut, z += f * v, j += f * S, w += f * W, C += f * L, J += f * P, I += f * q, b += f * ie, k += f * Be, ae += f * Je, f = y[1], Q += f * Oe, G += f * Xe, ne += f * ft, O += f * Le, T += f * dt, Z += f * Dt, z += f * ut, j += f * v, w += f * S, C += f * W, J += f * L, I += f * P, b += f * q, k += f * ie, ae += f * Be, oe += f * Je, f = y[2], G += f * Oe, ne += f * Xe, O += f * ft, T += f * Le, Z += f * dt, z += f * Dt, j += f * ut, w += f * v, C += f * S, J += f * W, I += f * L, b += f * P, k += f * q, ae += f * ie, oe += f * Be, le += f * Je, f = y[3], ne += f * Oe, O += f * Xe, T += f * ft, Z += f * Le, z += f * dt, j += f * Dt, w += f * ut, C += f * v, J += f * S, I += f * W, b += f * L, k += f * P, ae += f * q, oe += f * ie, le += f * Be, fe += f * Je, f = y[4], O += f * Oe, T += f * Xe, Z += f * ft, z += f * Le, j += f * dt, w += f * Dt, C += f * ut, J += f * v, I += f * S, b += f * W, k += f * L, ae += f * P, oe += f * q, le += f * ie, fe += f * Be, de += f * Je, f = y[5], T += f * Oe, Z += f * Xe, z += f * ft, j += f * Le, w += f * dt, C += f * Dt, J += f * ut, I += f * v, b += f * S, k += f * W, ae += f * L, oe += f * P, le += f * q, fe += f * ie, de += f * Be, Me += f * Je, f = y[6], Z += f * Oe, z += f * Xe, j += f * ft, w += f * Le, C += f * dt, J += f * Dt, I += f * ut, b += f * v, k += f * S, ae += f * W, oe += f * L, le += f * P, fe += f * q, de += f * ie, Me += f * Be, je += f * Je, f = y[7], z += f * Oe, j += f * Xe, w += f * ft, C += f * Le, J += f * dt, I += f * Dt, b += f * ut, k += f * v, ae += f * S, oe += f * W, le += f * L, fe += f * P, de += f * q, Me += f * ie, je += f * Be, Se += f * Je, f = y[8], j += f * Oe, w += f * Xe, C += f * ft, J += f * Le, I += f * dt, b += f * Dt, k += f * ut, ae += f * v, oe += f * S, le += f * W, fe += f * L, de += f * P, Me += f * q, je += f * ie, Se += f * Be, se += f * Je, f = y[9], w += f * Oe, C += f * Xe, J += f * ft, I += f * Le, b += f * dt, k += f * Dt, ae += f * ut, oe += f * v, le += f * S, fe += f * W, de += f * L, Me += f * P, je += f * q, Se += f * ie, se += f * Be, Ce += f * Je, f = y[10], C += f * Oe, J += f * Xe, I += f * ft, b += f * Le, k += f * dt, ae += f * Dt, oe += f * ut, le += f * v, fe += f * S, de += f * W, Me += f * L, je += f * P, Se += f * q, se += f * ie, Ce += f * Be, et += f * Je, f = y[11], J += f * Oe, I += f * Xe, b += f * ft, k += f * Le, ae += f * dt, oe += f * Dt, le += f * ut, fe += f * v, de += f * S, Me += f * W, je += f * L, Se += f * P, se += f * q, Ce += f * ie, et += f * Be, at += f * Je, f = y[12], I += f * Oe, b += f * Xe, k += f * ft, ae += f * Le, oe += f * dt, le += f * Dt, fe += f * ut, de += f * v, Me += f * S, je += f * W, Se += f * L, se += f * P, Ce += f * q, et += f * ie, at += f * Be, Rn += f * Je, f = y[13], b += f * Oe, k += f * Xe, ae += f * ft, oe += f * Le, le += f * dt, fe += f * Dt, de += f * ut, Me += f * v, je += f * S, Se += f * W, se += f * L, Ce += f * P, et += f * q, at += f * ie, Rn += f * Be, Zt += f * Je, f = y[14], k += f * Oe, ae += f * Xe, oe += f * ft, le += f * Le, fe += f * dt, de += f * Dt, Me += f * ut, je += f * v, Se += f * S, se += f * W, Ce += f * L, et += f * P, at += f * q, Rn += f * ie, Zt += f * Be, kt += f * Je, f = y[15], ae += f * Oe, oe += f * Xe, le += f * ft, fe += f * Le, de += f * dt, Me += f * Dt, je += f * ut, Se += f * v, se += f * S, Ce += f * W, et += f * L, at += f * P, Rn += f * q, Zt += f * ie, kt += f * Be, Pn += f * Je, Y += 38 * oe, Q += 38 * le, G += 38 * fe, ne += 38 * de, O += 38 * Me, T += 38 * je, Z += 38 * Se, z += 38 * se, j += 38 * Ce, w += 38 * et, C += 38 * at, J += 38 * Rn, I += 38 * Zt, b += 38 * kt, k += 38 * Pn, D = 1, f = Y + D + 65535, D = Math.floor(f / 65536), Y = f - D * 65536, f = Q + D + 65535, D = Math.floor(f / 65536), Q = f - D * 65536, f = G + D + 65535, D = Math.floor(f / 65536), G = f - D * 65536, f = ne + D + 65535, D = Math.floor(f / 65536), ne = f - D * 65536, f = O + D + 65535, D = Math.floor(f / 65536), O = f - D * 65536, f = T + D + 65535, D = Math.floor(f / 65536), T = f - D * 65536, f = Z + D + 65535, D = Math.floor(f / 65536), Z = f - D * 65536, f = z + D + 65535, D = Math.floor(f / 65536), z = f - D * 65536, f = j + D + 65535, D = Math.floor(f / 65536), j = f - D * 65536, f = w + D + 65535, D = Math.floor(f / 65536), w = f - D * 65536, f = C + D + 65535, D = Math.floor(f / 65536), C = f - D * 65536, f = J + D + 65535, D = Math.floor(f / 65536), J = f - D * 65536, f = I + D + 65535, D = Math.floor(f / 65536), I = f - D * 65536, f = b + D + 65535, D = Math.floor(f / 65536), b = f - D * 65536, f = k + D + 65535, D = Math.floor(f / 65536), k = f - D * 65536, f = ae + D + 65535, D = Math.floor(f / 65536), ae = f - D * 65536, Y += D - 1 + 37 * (D - 1), D = 1, f = Y + D + 65535, D = Math.floor(f / 65536), Y = f - D * 65536, f = Q + D + 65535, D = Math.floor(f / 65536), Q = f - D * 65536, f = G + D + 65535, D = Math.floor(f / 65536), G = f - D * 65536, f = ne + D + 65535, D = Math.floor(f / 65536), ne = f - D * 65536, f = O + D + 65535, D = Math.floor(f / 65536), O = f - D * 65536, f = T + D + 65535, D = Math.floor(f / 65536), T = f - D * 65536, f = Z + D + 65535, D = Math.floor(f / 65536), Z = f - D * 65536, f = z + D + 65535, D = Math.floor(f / 65536), z = f - D * 65536, f = j + D + 65535, D = Math.floor(f / 65536), j = f - D * 65536, f = w + D + 65535, D = Math.floor(f / 65536), w = f - D * 65536, f = C + D + 65535, D = Math.floor(f / 65536), C = f - D * 65536, f = J + D + 65535, D = Math.floor(f / 65536), J = f - D * 65536, f = I + D + 65535, D = Math.floor(f / 65536), I = f - D * 65536, f = b + D + 65535, D = Math.floor(f / 65536), b = f - D * 65536, f = k + D + 65535, D = Math.floor(f / 65536), k = f - D * 65536, f = ae + D + 65535, D = Math.floor(f / 65536), ae = f - D * 65536, Y += D - 1 + 37 * (D - 1), g[0] = Y, g[1] = Q, g[2] = G, g[3] = ne, g[4] = O, g[5] = T, g[6] = Z, g[7] = z, g[8] = j, g[9] = w, g[10] = C, g[11] = J, g[12] = I, g[13] = b, g[14] = k, g[15] = ae;
  }
  function N(g, y) {
    h(g, y, y);
  }
  function M(g, y) {
    const x = r();
    for (let f = 0; f < 16; f++)
      x[f] = y[f];
    for (let f = 253; f >= 0; f--)
      N(x, x), f !== 2 && f !== 4 && h(x, x, y);
    for (let f = 0; f < 16; f++)
      g[f] = x[f];
  }
  function p(g, y) {
    const x = new Uint8Array(32), f = new Float64Array(80), D = r(), Y = r(), Q = r(), G = r(), ne = r(), O = r();
    for (let j = 0; j < 31; j++)
      x[j] = g[j];
    x[31] = g[31] & 127 | 64, x[0] &= 248, c(f, y);
    for (let j = 0; j < 16; j++)
      Y[j] = f[j];
    D[0] = G[0] = 1;
    for (let j = 254; j >= 0; --j) {
      const w = x[j >>> 3] >>> (j & 7) & 1;
      s(D, Y, w), s(Q, G, w), d(ne, D, Q), u(D, D, Q), d(Q, Y, G), u(Y, Y, G), N(G, ne), N(O, D), h(D, Q, D), h(Q, Y, ne), d(ne, D, Q), u(D, D, Q), N(Y, D), u(Q, G, O), h(D, Q, a), d(D, D, G), h(Q, Q, D), h(D, G, O), h(G, Y, f), N(Y, ne), s(D, Y, w), s(Q, G, w);
    }
    for (let j = 0; j < 16; j++)
      f[j + 16] = D[j], f[j + 32] = Q[j], f[j + 48] = Y[j], f[j + 64] = G[j];
    const T = f.subarray(32), Z = f.subarray(16);
    M(T, T), h(Z, Z, T);
    const z = new Uint8Array(32);
    return l(z, Z), z;
  }
  t.scalarMult = p;
  function m(g) {
    return p(g, i);
  }
  t.scalarMultBase = m;
  function R(g) {
    if (g.length !== t.SECRET_KEY_LENGTH)
      throw new Error(`x25519: seed must be ${t.SECRET_KEY_LENGTH} bytes`);
    const y = new Uint8Array(g);
    return {
      publicKey: m(y),
      secretKey: y
    };
  }
  t.generateKeyPairFromSeed = R;
  function V(g) {
    const y = (0, e.randomBytes)(32, g), x = R(y);
    return (0, n.wipe)(y), x;
  }
  t.generateKeyPair = V;
  function U(g, y, x = !1) {
    if (g.length !== t.PUBLIC_KEY_LENGTH)
      throw new Error("X25519: incorrect secret key length");
    if (y.length !== t.PUBLIC_KEY_LENGTH)
      throw new Error("X25519: incorrect public key length");
    const f = p(g, y);
    if (x) {
      let D = 0;
      for (let Y = 0; Y < f.length; Y++)
        D |= f[Y];
      if (D === 0)
        throw new Error("X25519: invalid shared key");
    }
    return f;
  }
  t.sharedKey = U;
})(Vie);
function Uie(t, e) {
  if (t.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var n = new Uint8Array(256), r = 0; r < n.length; r++)
    n[r] = 255;
  for (var i = 0; i < t.length; i++) {
    var a = t.charAt(i), o = a.charCodeAt(0);
    if (n[o] !== 255)
      throw new TypeError(a + " is ambiguous");
    n[o] = i;
  }
  var s = t.length, l = t.charAt(0), c = Math.log(s) / Math.log(256), d = Math.log(256) / Math.log(s);
  function u(M) {
    if (M instanceof Uint8Array || (ArrayBuffer.isView(M) ? M = new Uint8Array(M.buffer, M.byteOffset, M.byteLength) : Array.isArray(M) && (M = Uint8Array.from(M))), !(M instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (M.length === 0)
      return "";
    for (var p = 0, m = 0, R = 0, V = M.length; R !== V && M[R] === 0; )
      R++, p++;
    for (var U = (V - R) * d + 1 >>> 0, g = new Uint8Array(U); R !== V; ) {
      for (var y = M[R], x = 0, f = U - 1; (y !== 0 || x < m) && f !== -1; f--, x++)
        y += 256 * g[f] >>> 0, g[f] = y % s >>> 0, y = y / s >>> 0;
      if (y !== 0)
        throw new Error("Non-zero carry");
      m = x, R++;
    }
    for (var D = U - m; D !== U && g[D] === 0; )
      D++;
    for (var Y = l.repeat(p); D < U; ++D)
      Y += t.charAt(g[D]);
    return Y;
  }
  function h(M) {
    if (typeof M != "string")
      throw new TypeError("Expected String");
    if (M.length === 0)
      return new Uint8Array();
    var p = 0;
    if (M[p] !== " ") {
      for (var m = 0, R = 0; M[p] === l; )
        m++, p++;
      for (var V = (M.length - p) * c + 1 >>> 0, U = new Uint8Array(V); M[p]; ) {
        var g = n[M.charCodeAt(p)];
        if (g === 255)
          return;
        for (var y = 0, x = V - 1; (g !== 0 || y < R) && x !== -1; x--, y++)
          g += s * U[x] >>> 0, U[x] = g % 256 >>> 0, g = g / 256 >>> 0;
        if (g !== 0)
          throw new Error("Non-zero carry");
        R = y, p++;
      }
      if (M[p] !== " ") {
        for (var f = V - R; f !== V && U[f] === 0; )
          f++;
        for (var D = new Uint8Array(m + (V - f)), Y = m; f !== V; )
          D[Y++] = U[f++];
        return D;
      }
    }
  }
  function N(M) {
    var p = h(M);
    if (p)
      return p;
    throw new Error(`Non-${e} character`);
  }
  return {
    encode: u,
    decodeUnsafe: h,
    decode: N
  };
}
var Rie = Uie, gie = Rie;
const yie = (t) => {
  if (t instanceof Uint8Array && t.constructor.name === "Uint8Array")
    return t;
  if (t instanceof ArrayBuffer)
    return new Uint8Array(t);
  if (ArrayBuffer.isView(t))
    return new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
  throw new Error("Unknown type, must be binary type");
}, Zie = (t) => new TextEncoder().encode(t), bie = (t) => new TextDecoder().decode(t);
class Eie {
  constructor(e, n, r) {
    this.name = e, this.prefix = n, this.baseEncode = r;
  }
  encode(e) {
    if (e instanceof Uint8Array)
      return `${this.prefix}${this.baseEncode(e)}`;
    throw Error("Unknown type, must be binary type");
  }
}
class Sie {
  constructor(e, n, r) {
    if (this.name = e, this.prefix = n, n.codePointAt(0) === void 0)
      throw new Error("Invalid prefix character");
    this.prefixCodePoint = n.codePointAt(0), this.baseDecode = r;
  }
  decode(e) {
    if (typeof e == "string") {
      if (e.codePointAt(0) !== this.prefixCodePoint)
        throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
      return this.baseDecode(e.slice(this.prefix.length));
    } else
      throw Error("Can only multibase decode strings");
  }
  or(e) {
    return FY(this, e);
  }
}
class xie {
  constructor(e) {
    this.decoders = e;
  }
  or(e) {
    return FY(this, e);
  }
  decode(e) {
    const n = e[0], r = this.decoders[n];
    if (r)
      return r.decode(e);
    throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
  }
}
const FY = (t, e) => new xie({
  ...t.decoders || { [t.prefix]: t },
  ...e.decoders || { [e.prefix]: e }
});
class Wie {
  constructor(e, n, r, i) {
    this.name = e, this.prefix = n, this.baseEncode = r, this.baseDecode = i, this.encoder = new Eie(e, n, r), this.decoder = new Sie(e, n, i);
  }
  encode(e) {
    return this.encoder.encode(e);
  }
  decode(e) {
    return this.decoder.decode(e);
  }
}
const lU = ({ name: t, prefix: e, encode: n, decode: r }) => new Wie(t, e, n, r), Pp = ({ prefix: t, name: e, alphabet: n }) => {
  const { encode: r, decode: i } = gie(n, e);
  return lU({
    prefix: t,
    name: e,
    encode: r,
    decode: (a) => yie(i(a))
  });
}, jie = (t, e, n, r) => {
  const i = {};
  for (let d = 0; d < e.length; ++d)
    i[e[d]] = d;
  let a = t.length;
  for (; t[a - 1] === "="; )
    --a;
  const o = new Uint8Array(a * n / 8 | 0);
  let s = 0, l = 0, c = 0;
  for (let d = 0; d < a; ++d) {
    const u = i[t[d]];
    if (u === void 0)
      throw new SyntaxError(`Non-${r} character`);
    l = l << n | u, s += n, s >= 8 && (s -= 8, o[c++] = 255 & l >> s);
  }
  if (s >= n || 255 & l << 8 - s)
    throw new SyntaxError("Unexpected end of data");
  return o;
}, Die = (t, e, n) => {
  const r = e[e.length - 1] === "=", i = (1 << n) - 1;
  let a = "", o = 0, s = 0;
  for (let l = 0; l < t.length; ++l)
    for (s = s << 8 | t[l], o += 8; o > n; )
      o -= n, a += e[i & s >> o];
  if (o && (a += e[i & s << n - o]), r)
    for (; a.length * n & 7; )
      a += "=";
  return a;
}, Ar = ({ name: t, prefix: e, bitsPerChar: n, alphabet: r }) => lU({
  prefix: e,
  name: t,
  encode(i) {
    return Die(i, r, n);
  },
  decode(i) {
    return jie(i, r, n, t);
  }
}), zie = lU({
  prefix: "\0",
  name: "identity",
  encode: (t) => bie(t),
  decode: (t) => Zie(t)
}), Ywe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  identity: zie
}, Symbol.toStringTag, { value: "Module" })), kie = Ar({
  prefix: "0",
  name: "base2",
  alphabet: "01",
  bitsPerChar: 1
}), Qwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base2: kie
}, Symbol.toStringTag, { value: "Module" })), wie = Ar({
  prefix: "7",
  name: "base8",
  alphabet: "01234567",
  bitsPerChar: 3
}), Gwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base8: wie
}, Symbol.toStringTag, { value: "Module" })), Fie = Pp({
  prefix: "9",
  name: "base10",
  alphabet: "0123456789"
}), Cwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base10: Fie
}, Symbol.toStringTag, { value: "Module" })), vie = Ar({
  prefix: "f",
  name: "base16",
  alphabet: "0123456789abcdef",
  bitsPerChar: 4
}), Iie = Ar({
  prefix: "F",
  name: "base16upper",
  alphabet: "0123456789ABCDEF",
  bitsPerChar: 4
}), Lwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base16: vie,
  base16upper: Iie
}, Symbol.toStringTag, { value: "Module" })), Oie = Ar({
  prefix: "b",
  name: "base32",
  alphabet: "abcdefghijklmnopqrstuvwxyz234567",
  bitsPerChar: 5
}), Yie = Ar({
  prefix: "B",
  name: "base32upper",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
  bitsPerChar: 5
}), Qie = Ar({
  prefix: "c",
  name: "base32pad",
  alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
  bitsPerChar: 5
}), Gie = Ar({
  prefix: "C",
  name: "base32padupper",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
  bitsPerChar: 5
}), Cie = Ar({
  prefix: "v",
  name: "base32hex",
  alphabet: "0123456789abcdefghijklmnopqrstuv",
  bitsPerChar: 5
}), Lie = Ar({
  prefix: "V",
  name: "base32hexupper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
  bitsPerChar: 5
}), Jie = Ar({
  prefix: "t",
  name: "base32hexpad",
  alphabet: "0123456789abcdefghijklmnopqrstuv=",
  bitsPerChar: 5
}), Bie = Ar({
  prefix: "T",
  name: "base32hexpadupper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
  bitsPerChar: 5
}), Aie = Ar({
  prefix: "h",
  name: "base32z",
  alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
  bitsPerChar: 5
}), Jwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base32: Oie,
  base32hex: Cie,
  base32hexpad: Jie,
  base32hexpadupper: Bie,
  base32hexupper: Lie,
  base32pad: Qie,
  base32padupper: Gie,
  base32upper: Yie,
  base32z: Aie
}, Symbol.toStringTag, { value: "Module" })), Hie = Pp({
  prefix: "k",
  name: "base36",
  alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}), Xie = Pp({
  prefix: "K",
  name: "base36upper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
}), Bwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base36: Hie,
  base36upper: Xie
}, Symbol.toStringTag, { value: "Module" })), _ie = Pp({
  name: "base58btc",
  prefix: "z",
  alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}), Pie = Pp({
  name: "base58flickr",
  prefix: "Z",
  alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
}), Awe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base58btc: _ie,
  base58flickr: Pie
}, Symbol.toStringTag, { value: "Module" })), Kie = Ar({
  prefix: "m",
  name: "base64",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
  bitsPerChar: 6
}), $ie = Ar({
  prefix: "M",
  name: "base64pad",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  bitsPerChar: 6
}), qie = Ar({
  prefix: "u",
  name: "base64url",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
  bitsPerChar: 6
}), eae = Ar({
  prefix: "U",
  name: "base64urlpad",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
  bitsPerChar: 6
}), Hwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base64: Kie,
  base64pad: $ie,
  base64url: qie,
  base64urlpad: eae
}, Symbol.toStringTag, { value: "Module" })), vY = Array.from("🚀🪐☄🛰🌌🌑🌒🌓🌔🌕🌖🌗🌘🌍🌏🌎🐉☀💻🖥💾💿😂❤😍🤣😊🙏💕😭😘👍😅👏😁🔥🥰💔💖💙😢🤔😆🙄💪😉☺👌🤗💜😔😎😇🌹🤦🎉💞✌✨🤷😱😌🌸🙌😋💗💚😏💛🙂💓🤩😄😀🖤😃💯🙈👇🎶😒🤭❣😜💋👀😪😑💥🙋😞😩😡🤪👊🥳😥🤤👉💃😳✋😚😝😴🌟😬🙃🍀🌷😻😓⭐✅🥺🌈😈🤘💦✔😣🏃💐☹🎊💘😠☝😕🌺🎂🌻😐🖕💝🙊😹🗣💫💀👑🎵🤞😛🔴😤🌼😫⚽🤙☕🏆🤫👈😮🙆🍻🍃🐶💁😲🌿🧡🎁⚡🌞🎈❌✊👋😰🤨😶🤝🚶💰🍓💢🤟🙁🚨💨🤬✈🎀🍺🤓😙💟🌱😖👶🥴▶➡❓💎💸⬇😨🌚🦋😷🕺⚠🙅😟😵👎🤲🤠🤧📌🔵💅🧐🐾🍒😗🤑🌊🤯🐷☎💧😯💆👆🎤🙇🍑❄🌴💣🐸💌📍🥀🤢👅💡💩👐📸👻🤐🤮🎼🥵🚩🍎🍊👼💍📣🥂"), tae = vY.reduce((t, e, n) => (t[n] = e, t), []), nae = vY.reduce((t, e, n) => (t[e.codePointAt(0)] = n, t), []);
function rae(t) {
  return t.reduce((e, n) => (e += tae[n], e), "");
}
function iae(t) {
  const e = [];
  for (const n of t) {
    const r = nae[n.codePointAt(0)];
    if (r === void 0)
      throw new Error(`Non-base256emoji character: ${n}`);
    e.push(r);
  }
  return new Uint8Array(e);
}
const aae = lU({
  prefix: "🚀",
  name: "base256emoji",
  encode: rae,
  decode: iae
}), Xwe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base256emoji: aae
}, Symbol.toStringTag, { value: "Module" }));
new TextEncoder();
new TextDecoder();
var oae = {};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var AZ = function(t, e) {
  return AZ = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r)
      r.hasOwnProperty(i) && (n[i] = r[i]);
  }, AZ(t, e);
};
function sae(t, e) {
  AZ(t, e);
  function n() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
}
var HZ = function() {
  return HZ = Object.assign || function(e) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  }, HZ.apply(this, arguments);
};
function lae(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}
function cae(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
}
function dae(t, e) {
  return function(n, r) {
    e(n, r, t);
  };
}
function uae(t, e) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(t, e);
}
function hae(t, e, n, r) {
  function i(a) {
    return a instanceof n ? a : new n(function(o) {
      o(a);
    });
  }
  return new (n || (n = Promise))(function(a, o) {
    function s(d) {
      try {
        c(r.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(r.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? a(d.value) : i(d.value).then(s, l);
    }
    c((r = r.apply(t, e || [])).next());
  });
}
function Nae(t, e) {
  var n = { label: 0, sent: function() {
    if (a[0] & 1)
      throw a[1];
    return a[1];
  }, trys: [], ops: [] }, r, i, a, o;
  return o = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(c) {
    return function(d) {
      return l([c, d]);
    };
  }
  function l(c) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; n; )
      try {
        if (r = 1, i && (a = c[0] & 2 ? i.return : c[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, c[1])).done)
          return a;
        switch (i = 0, a && (c = [c[0] & 2, a.value]), c[0]) {
          case 0:
          case 1:
            a = c;
            break;
          case 4:
            return n.label++, { value: c[1], done: !1 };
          case 5:
            n.label++, i = c[1], c = [0];
            continue;
          case 7:
            c = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (a = n.trys, !(a = a.length > 0 && a[a.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              n = 0;
              continue;
            }
            if (c[0] === 3 && (!a || c[1] > a[0] && c[1] < a[3])) {
              n.label = c[1];
              break;
            }
            if (c[0] === 6 && n.label < a[1]) {
              n.label = a[1], a = c;
              break;
            }
            if (a && n.label < a[2]) {
              n.label = a[2], n.ops.push(c);
              break;
            }
            a[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        c = e.call(t, n);
      } catch (d) {
        c = [6, d], i = 0;
      } finally {
        r = a = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function Mae(t, e, n, r) {
  r === void 0 && (r = n), t[r] = e[n];
}
function pae(t, e) {
  for (var n in t)
    n !== "default" && !e.hasOwnProperty(n) && (e[n] = t[n]);
}
function XZ(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function IY(t, e) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n)
    return t;
  var r = n.call(t), i, a = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = r.next()).done; )
      a.push(i.value);
  } catch (s) {
    o = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return a;
}
function mae() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t = t.concat(IY(arguments[e]));
  return t;
}
function Tae() {
  for (var t = 0, e = 0, n = arguments.length; e < n; e++)
    t += arguments[e].length;
  for (var r = Array(t), i = 0, e = 0; e < n; e++)
    for (var a = arguments[e], o = 0, s = a.length; o < s; o++, i++)
      r[i] = a[o];
  return r;
}
function lM(t) {
  return this instanceof lM ? (this.v = t, this) : new lM(t);
}
function fae(t, e, n) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = n.apply(t, e || []), i, a = [];
  return i = {}, o("next"), o("throw"), o("return"), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function o(h) {
    r[h] && (i[h] = function(N) {
      return new Promise(function(M, p) {
        a.push([h, N, M, p]) > 1 || s(h, N);
      });
    });
  }
  function s(h, N) {
    try {
      l(r[h](N));
    } catch (M) {
      u(a[0][3], M);
    }
  }
  function l(h) {
    h.value instanceof lM ? Promise.resolve(h.value.v).then(c, d) : u(a[0][2], h);
  }
  function c(h) {
    s("next", h);
  }
  function d(h) {
    s("throw", h);
  }
  function u(h, N) {
    h(N), a.shift(), a.length && s(a[0][0], a[0][1]);
  }
}
function Vae(t) {
  var e, n;
  return e = {}, r("next"), r("throw", function(i) {
    throw i;
  }), r("return"), e[Symbol.iterator] = function() {
    return this;
  }, e;
  function r(i, a) {
    e[i] = t[i] ? function(o) {
      return (n = !n) ? { value: lM(t[i](o)), done: i === "return" } : a ? a(o) : o;
    } : a;
  }
}
function Uae(t) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = t[Symbol.asyncIterator], n;
  return e ? e.call(t) : (t = typeof XZ == "function" ? XZ(t) : t[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function r(a) {
    n[a] = t[a] && function(o) {
      return new Promise(function(s, l) {
        o = t[a](o), i(s, l, o.done, o.value);
      });
    };
  }
  function i(a, o, s, l) {
    Promise.resolve(l).then(function(c) {
      a({ value: c, done: s });
    }, o);
  }
}
function Rae(t, e) {
  return Object.defineProperty ? Object.defineProperty(t, "raw", { value: e }) : t.raw = e, t;
}
function gae(t) {
  if (t && t.__esModule)
    return t;
  var e = {};
  if (t != null)
    for (var n in t)
      Object.hasOwnProperty.call(t, n) && (e[n] = t[n]);
  return e.default = t, e;
}
function yae(t) {
  return t && t.__esModule ? t : { default: t };
}
function Zae(t, e) {
  if (!e.has(t))
    throw new TypeError("attempted to get private field on non-instance");
  return e.get(t);
}
function bae(t, e, n) {
  if (!e.has(t))
    throw new TypeError("attempted to set private field on non-instance");
  return e.set(t, n), n;
}
const Eae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get __assign() {
    return HZ;
  },
  __asyncDelegator: Vae,
  __asyncGenerator: fae,
  __asyncValues: Uae,
  __await: lM,
  __awaiter: hae,
  __classPrivateFieldGet: Zae,
  __classPrivateFieldSet: bae,
  __createBinding: Mae,
  __decorate: cae,
  __exportStar: pae,
  __extends: sae,
  __generator: Nae,
  __importDefault: yae,
  __importStar: gae,
  __makeTemplateObject: Rae,
  __metadata: uae,
  __param: dae,
  __read: IY,
  __rest: lae,
  __spread: mae,
  __spreadArrays: Tae,
  __values: XZ
}, Symbol.toStringTag, { value: "Module" })), cU = /* @__PURE__ */ Uw(Eae);
var sg = {}, bN = {}, jD;
function Sae() {
  if (jD)
    return bN;
  jD = 1, Object.defineProperty(bN, "__esModule", { value: !0 }), bN.delay = void 0;
  function t(e) {
    return new Promise((n) => {
      setTimeout(() => {
        n(!0);
      }, e);
    });
  }
  return bN.delay = t, bN;
}
var Jc = {}, lg = {}, Bc = {}, DD;
function xae() {
  return DD || (DD = 1, Object.defineProperty(Bc, "__esModule", { value: !0 }), Bc.ONE_THOUSAND = Bc.ONE_HUNDRED = void 0, Bc.ONE_HUNDRED = 100, Bc.ONE_THOUSAND = 1e3), Bc;
}
var cg = {}, zD;
function Wae() {
  return zD || (zD = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.ONE_YEAR = t.FOUR_WEEKS = t.THREE_WEEKS = t.TWO_WEEKS = t.ONE_WEEK = t.THIRTY_DAYS = t.SEVEN_DAYS = t.FIVE_DAYS = t.THREE_DAYS = t.ONE_DAY = t.TWENTY_FOUR_HOURS = t.TWELVE_HOURS = t.SIX_HOURS = t.THREE_HOURS = t.ONE_HOUR = t.SIXTY_MINUTES = t.THIRTY_MINUTES = t.TEN_MINUTES = t.FIVE_MINUTES = t.ONE_MINUTE = t.SIXTY_SECONDS = t.THIRTY_SECONDS = t.TEN_SECONDS = t.FIVE_SECONDS = t.ONE_SECOND = void 0, t.ONE_SECOND = 1, t.FIVE_SECONDS = 5, t.TEN_SECONDS = 10, t.THIRTY_SECONDS = 30, t.SIXTY_SECONDS = 60, t.ONE_MINUTE = t.SIXTY_SECONDS, t.FIVE_MINUTES = t.ONE_MINUTE * 5, t.TEN_MINUTES = t.ONE_MINUTE * 10, t.THIRTY_MINUTES = t.ONE_MINUTE * 30, t.SIXTY_MINUTES = t.ONE_MINUTE * 60, t.ONE_HOUR = t.SIXTY_MINUTES, t.THREE_HOURS = t.ONE_HOUR * 3, t.SIX_HOURS = t.ONE_HOUR * 6, t.TWELVE_HOURS = t.ONE_HOUR * 12, t.TWENTY_FOUR_HOURS = t.ONE_HOUR * 24, t.ONE_DAY = t.TWENTY_FOUR_HOURS, t.THREE_DAYS = t.ONE_DAY * 3, t.FIVE_DAYS = t.ONE_DAY * 5, t.SEVEN_DAYS = t.ONE_DAY * 7, t.THIRTY_DAYS = t.ONE_DAY * 30, t.ONE_WEEK = t.SEVEN_DAYS, t.TWO_WEEKS = t.ONE_WEEK * 2, t.THREE_WEEKS = t.ONE_WEEK * 3, t.FOUR_WEEKS = t.ONE_WEEK * 4, t.ONE_YEAR = t.ONE_DAY * 365;
  }(cg)), cg;
}
var kD;
function OY() {
  return kD || (kD = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    const e = cU;
    e.__exportStar(xae(), t), e.__exportStar(Wae(), t);
  }(lg)), lg;
}
var wD;
function jae() {
  if (wD)
    return Jc;
  wD = 1, Object.defineProperty(Jc, "__esModule", { value: !0 }), Jc.fromMiliseconds = Jc.toMiliseconds = void 0;
  const t = OY();
  function e(r) {
    return r * t.ONE_THOUSAND;
  }
  Jc.toMiliseconds = e;
  function n(r) {
    return Math.floor(r / t.ONE_THOUSAND);
  }
  return Jc.fromMiliseconds = n, Jc;
}
var FD;
function Dae() {
  return FD || (FD = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    const e = cU;
    e.__exportStar(Sae(), t), e.__exportStar(jae(), t);
  }(sg)), sg;
}
var ku = {}, vD;
function zae() {
  if (vD)
    return ku;
  vD = 1, Object.defineProperty(ku, "__esModule", { value: !0 }), ku.Watch = void 0;
  class t {
    constructor() {
      this.timestamps = /* @__PURE__ */ new Map();
    }
    start(n) {
      if (this.timestamps.has(n))
        throw new Error(`Watch already started for label: ${n}`);
      this.timestamps.set(n, { started: Date.now() });
    }
    stop(n) {
      const r = this.get(n);
      if (typeof r.elapsed < "u")
        throw new Error(`Watch already stopped for label: ${n}`);
      const i = Date.now() - r.started;
      this.timestamps.set(n, { started: r.started, elapsed: i });
    }
    get(n) {
      const r = this.timestamps.get(n);
      if (typeof r > "u")
        throw new Error(`No timestamp found for label: ${n}`);
      return r;
    }
    elapsed(n) {
      const r = this.get(n);
      return r.elapsed || Date.now() - r.started;
    }
  }
  return ku.Watch = t, ku.default = t, ku;
}
var dg = {}, EN = {}, ID;
function kae() {
  if (ID)
    return EN;
  ID = 1, Object.defineProperty(EN, "__esModule", { value: !0 }), EN.IWatch = void 0;
  class t {
  }
  return EN.IWatch = t, EN;
}
var OD;
function wae() {
  return OD || (OD = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), cU.__exportStar(kae(), t);
  }(dg)), dg;
}
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  const e = cU;
  e.__exportStar(Dae(), t), e.__exportStar(zae(), t), e.__exportStar(wae(), t), e.__exportStar(OY(), t);
})(oae);
var wn = {};
Object.defineProperty(wn, "__esModule", { value: !0 });
wn.getLocalStorage = wn.getLocalStorageOrThrow = wn.getCrypto = wn.getCryptoOrThrow = Lae = wn.getLocation = wn.getLocationOrThrow = Qae = wn.getNavigator = wn.getNavigatorOrThrow = Iae = wn.getDocument = wn.getDocumentOrThrow = wn.getFromWindowOrThrow = wn.getFromWindow = void 0;
function cu(t) {
  let e;
  return typeof window < "u" && typeof window[t] < "u" && (e = window[t]), e;
}
wn.getFromWindow = cu;
function iN(t) {
  const e = cu(t);
  if (!e)
    throw new Error(`${t} is not defined in Window`);
  return e;
}
wn.getFromWindowOrThrow = iN;
function Fae() {
  return iN("document");
}
wn.getDocumentOrThrow = Fae;
function vae() {
  return cu("document");
}
var Iae = wn.getDocument = vae;
function Oae() {
  return iN("navigator");
}
wn.getNavigatorOrThrow = Oae;
function Yae() {
  return cu("navigator");
}
var Qae = wn.getNavigator = Yae;
function Gae() {
  return iN("location");
}
wn.getLocationOrThrow = Gae;
function Cae() {
  return cu("location");
}
var Lae = wn.getLocation = Cae;
function Jae() {
  return iN("crypto");
}
wn.getCryptoOrThrow = Jae;
function Bae() {
  return cu("crypto");
}
wn.getCrypto = Bae;
function Aae() {
  return iN("localStorage");
}
wn.getLocalStorageOrThrow = Aae;
function Hae() {
  return cu("localStorage");
}
wn.getLocalStorage = Hae;
var K3 = {};
Object.defineProperty(K3, "__esModule", { value: !0 });
var Xae = K3.getWindowMetadata = void 0;
const YD = wn;
function _ae() {
  let t, e;
  try {
    t = YD.getDocumentOrThrow(), e = YD.getLocationOrThrow();
  } catch {
    return null;
  }
  function n() {
    const u = t.getElementsByTagName("link"), h = [];
    for (let N = 0; N < u.length; N++) {
      const M = u[N], p = M.getAttribute("rel");
      if (p && p.toLowerCase().indexOf("icon") > -1) {
        const m = M.getAttribute("href");
        if (m)
          if (m.toLowerCase().indexOf("https:") === -1 && m.toLowerCase().indexOf("http:") === -1 && m.indexOf("//") !== 0) {
            let R = e.protocol + "//" + e.host;
            if (m.indexOf("/") === 0)
              R += m;
            else {
              const V = e.pathname.split("/");
              V.pop();
              const U = V.join("/");
              R += U + "/" + m;
            }
            h.push(R);
          } else if (m.indexOf("//") === 0) {
            const R = e.protocol + m;
            h.push(R);
          } else
            h.push(m);
      }
    }
    return h;
  }
  function r(...u) {
    const h = t.getElementsByTagName("meta");
    for (let N = 0; N < h.length; N++) {
      const M = h[N], p = ["itemprop", "property", "name"].map((m) => M.getAttribute(m)).filter((m) => m ? u.includes(m) : !1);
      if (p.length && p) {
        const m = M.getAttribute("content");
        if (m)
          return m;
      }
    }
    return "";
  }
  function i() {
    let u = r("name", "og:site_name", "og:title", "twitter:title");
    return u || (u = t.title), u;
  }
  function a() {
    return r("description", "og:description", "twitter:description", "keywords");
  }
  const o = i(), s = a(), l = e.origin, c = n();
  return {
    description: s,
    url: l,
    icons: c,
    name: o
  };
}
Xae = K3.getWindowMetadata = _ae;
var Pae = {}, Kae = (t) => encodeURIComponent(t).replace(/[!'()*]/g, (e) => `%${e.charCodeAt(0).toString(16).toUpperCase()}`), YY = "%[a-f0-9]{2}", QD = new RegExp("(" + YY + ")|([^%]+?)", "gi"), GD = new RegExp("(" + YY + ")+", "gi");
function _Z(t, e) {
  try {
    return [decodeURIComponent(t.join(""))];
  } catch {
  }
  if (t.length === 1)
    return t;
  e = e || 1;
  var n = t.slice(0, e), r = t.slice(e);
  return Array.prototype.concat.call([], _Z(n), _Z(r));
}
function $ae(t) {
  try {
    return decodeURIComponent(t);
  } catch {
    for (var e = t.match(QD) || [], n = 1; n < e.length; n++)
      t = _Z(e, n).join(""), e = t.match(QD) || [];
    return t;
  }
}
function qae(t) {
  for (var e = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  }, n = GD.exec(t); n; ) {
    try {
      e[n[0]] = decodeURIComponent(n[0]);
    } catch {
      var r = $ae(n[0]);
      r !== n[0] && (e[n[0]] = r);
    }
    n = GD.exec(t);
  }
  e["%C2"] = "�";
  for (var i = Object.keys(e), a = 0; a < i.length; a++) {
    var o = i[a];
    t = t.replace(new RegExp(o, "g"), e[o]);
  }
  return t;
}
var eoe = function(t) {
  if (typeof t != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof t + "`");
  try {
    return t = t.replace(/\+/g, " "), decodeURIComponent(t);
  } catch {
    return qae(t);
  }
}, toe = (t, e) => {
  if (!(typeof t == "string" && typeof e == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (e === "")
    return [t];
  const n = t.indexOf(e);
  return n === -1 ? [t] : [
    t.slice(0, n),
    t.slice(n + e.length)
  ];
}, noe = function(t, e) {
  for (var n = {}, r = Object.keys(t), i = Array.isArray(e), a = 0; a < r.length; a++) {
    var o = r[a], s = t[o];
    (i ? e.indexOf(o) !== -1 : e(o, s, t)) && (n[o] = s);
  }
  return n;
};
(function(t) {
  const e = Kae, n = eoe, r = toe, i = noe, a = (V) => V == null, o = Symbol("encodeFragmentIdentifier");
  function s(V) {
    switch (V.arrayFormat) {
      case "index":
        return (U) => (g, y) => {
          const x = g.length;
          return y === void 0 || V.skipNull && y === null || V.skipEmptyString && y === "" ? g : y === null ? [...g, [d(U, V), "[", x, "]"].join("")] : [
            ...g,
            [d(U, V), "[", d(x, V), "]=", d(y, V)].join("")
          ];
        };
      case "bracket":
        return (U) => (g, y) => y === void 0 || V.skipNull && y === null || V.skipEmptyString && y === "" ? g : y === null ? [...g, [d(U, V), "[]"].join("")] : [...g, [d(U, V), "[]=", d(y, V)].join("")];
      case "colon-list-separator":
        return (U) => (g, y) => y === void 0 || V.skipNull && y === null || V.skipEmptyString && y === "" ? g : y === null ? [...g, [d(U, V), ":list="].join("")] : [...g, [d(U, V), ":list=", d(y, V)].join("")];
      case "comma":
      case "separator":
      case "bracket-separator": {
        const U = V.arrayFormat === "bracket-separator" ? "[]=" : "=";
        return (g) => (y, x) => x === void 0 || V.skipNull && x === null || V.skipEmptyString && x === "" ? y : (x = x === null ? "" : x, y.length === 0 ? [[d(g, V), U, d(x, V)].join("")] : [[y, d(x, V)].join(V.arrayFormatSeparator)]);
      }
      default:
        return (U) => (g, y) => y === void 0 || V.skipNull && y === null || V.skipEmptyString && y === "" ? g : y === null ? [...g, d(U, V)] : [...g, [d(U, V), "=", d(y, V)].join("")];
    }
  }
  function l(V) {
    let U;
    switch (V.arrayFormat) {
      case "index":
        return (g, y, x) => {
          if (U = /\[(\d*)\]$/.exec(g), g = g.replace(/\[\d*\]$/, ""), !U) {
            x[g] = y;
            return;
          }
          x[g] === void 0 && (x[g] = {}), x[g][U[1]] = y;
        };
      case "bracket":
        return (g, y, x) => {
          if (U = /(\[\])$/.exec(g), g = g.replace(/\[\]$/, ""), !U) {
            x[g] = y;
            return;
          }
          if (x[g] === void 0) {
            x[g] = [y];
            return;
          }
          x[g] = [].concat(x[g], y);
        };
      case "colon-list-separator":
        return (g, y, x) => {
          if (U = /(:list)$/.exec(g), g = g.replace(/:list$/, ""), !U) {
            x[g] = y;
            return;
          }
          if (x[g] === void 0) {
            x[g] = [y];
            return;
          }
          x[g] = [].concat(x[g], y);
        };
      case "comma":
      case "separator":
        return (g, y, x) => {
          const f = typeof y == "string" && y.includes(V.arrayFormatSeparator), D = typeof y == "string" && !f && u(y, V).includes(V.arrayFormatSeparator);
          y = D ? u(y, V) : y;
          const Y = f || D ? y.split(V.arrayFormatSeparator).map((Q) => u(Q, V)) : y === null ? y : u(y, V);
          x[g] = Y;
        };
      case "bracket-separator":
        return (g, y, x) => {
          const f = /(\[\])$/.test(g);
          if (g = g.replace(/\[\]$/, ""), !f) {
            x[g] = y && u(y, V);
            return;
          }
          const D = y === null ? [] : y.split(V.arrayFormatSeparator).map((Y) => u(Y, V));
          if (x[g] === void 0) {
            x[g] = D;
            return;
          }
          x[g] = [].concat(x[g], D);
        };
      default:
        return (g, y, x) => {
          if (x[g] === void 0) {
            x[g] = y;
            return;
          }
          x[g] = [].concat(x[g], y);
        };
    }
  }
  function c(V) {
    if (typeof V != "string" || V.length !== 1)
      throw new TypeError("arrayFormatSeparator must be single character string");
  }
  function d(V, U) {
    return U.encode ? U.strict ? e(V) : encodeURIComponent(V) : V;
  }
  function u(V, U) {
    return U.decode ? n(V) : V;
  }
  function h(V) {
    return Array.isArray(V) ? V.sort() : typeof V == "object" ? h(Object.keys(V)).sort((U, g) => Number(U) - Number(g)).map((U) => V[U]) : V;
  }
  function N(V) {
    const U = V.indexOf("#");
    return U !== -1 && (V = V.slice(0, U)), V;
  }
  function M(V) {
    let U = "";
    const g = V.indexOf("#");
    return g !== -1 && (U = V.slice(g)), U;
  }
  function p(V) {
    V = N(V);
    const U = V.indexOf("?");
    return U === -1 ? "" : V.slice(U + 1);
  }
  function m(V, U) {
    return U.parseNumbers && !Number.isNaN(Number(V)) && typeof V == "string" && V.trim() !== "" ? V = Number(V) : U.parseBooleans && V !== null && (V.toLowerCase() === "true" || V.toLowerCase() === "false") && (V = V.toLowerCase() === "true"), V;
  }
  function R(V, U) {
    U = Object.assign({
      decode: !0,
      sort: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ",",
      parseNumbers: !1,
      parseBooleans: !1
    }, U), c(U.arrayFormatSeparator);
    const g = l(U), y = /* @__PURE__ */ Object.create(null);
    if (typeof V != "string" || (V = V.trim().replace(/^[?#&]/, ""), !V))
      return y;
    for (const x of V.split("&")) {
      if (x === "")
        continue;
      let [f, D] = r(U.decode ? x.replace(/\+/g, " ") : x, "=");
      D = D === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(U.arrayFormat) ? D : u(D, U), g(u(f, U), D, y);
    }
    for (const x of Object.keys(y)) {
      const f = y[x];
      if (typeof f == "object" && f !== null)
        for (const D of Object.keys(f))
          f[D] = m(f[D], U);
      else
        y[x] = m(f, U);
    }
    return U.sort === !1 ? y : (U.sort === !0 ? Object.keys(y).sort() : Object.keys(y).sort(U.sort)).reduce((x, f) => {
      const D = y[f];
      return D && typeof D == "object" && !Array.isArray(D) ? x[f] = h(D) : x[f] = D, x;
    }, /* @__PURE__ */ Object.create(null));
  }
  t.extract = p, t.parse = R, t.stringify = (V, U) => {
    if (!V)
      return "";
    U = Object.assign({
      encode: !0,
      strict: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ","
    }, U), c(U.arrayFormatSeparator);
    const g = (D) => U.skipNull && a(V[D]) || U.skipEmptyString && V[D] === "", y = s(U), x = {};
    for (const D of Object.keys(V))
      g(D) || (x[D] = V[D]);
    const f = Object.keys(x);
    return U.sort !== !1 && f.sort(U.sort), f.map((D) => {
      const Y = V[D];
      return Y === void 0 ? "" : Y === null ? d(D, U) : Array.isArray(Y) ? Y.length === 0 && U.arrayFormat === "bracket-separator" ? d(D, U) + "[]" : Y.reduce(y(D), []).join("&") : d(D, U) + "=" + d(Y, U);
    }).filter((D) => D.length > 0).join("&");
  }, t.parseUrl = (V, U) => {
    U = Object.assign({
      decode: !0
    }, U);
    const [g, y] = r(V, "#");
    return Object.assign(
      {
        url: g.split("?")[0] || "",
        query: R(p(V), U)
      },
      U && U.parseFragmentIdentifier && y ? { fragmentIdentifier: u(y, U) } : {}
    );
  }, t.stringifyUrl = (V, U) => {
    U = Object.assign({
      encode: !0,
      strict: !0,
      [o]: !0
    }, U);
    const g = N(V.url).split("?")[0] || "", y = t.extract(V.url), x = t.parse(y, { sort: !1 }), f = Object.assign(x, V.query);
    let D = t.stringify(f, U);
    D && (D = `?${D}`);
    let Y = M(V.url);
    return V.fragmentIdentifier && (Y = `#${U[o] ? d(V.fragmentIdentifier, U) : V.fragmentIdentifier}`), `${g}${D}${Y}`;
  }, t.pick = (V, U, g) => {
    g = Object.assign({
      parseFragmentIdentifier: !0,
      [o]: !1
    }, g);
    const { url: y, query: x, fragmentIdentifier: f } = t.parseUrl(V, g);
    return t.stringifyUrl({
      url: y,
      query: i(x, U),
      fragmentIdentifier: f
    }, g);
  }, t.exclude = (V, U, g) => {
    const y = Array.isArray(U) ? (x) => !U.includes(x) : (x, f) => !U(x, f);
    return t.pick(V, y, g);
  };
})(Pae);
function ug(t = [], e = []) {
  return [.../* @__PURE__ */ new Set([...t, ...e])];
}
var roe = Object.defineProperty, ioe = Object.defineProperties, aoe = Object.getOwnPropertyDescriptors, CD = Object.getOwnPropertySymbols, ooe = Object.prototype.hasOwnProperty, soe = Object.prototype.propertyIsEnumerable, LD = (t, e, n) => e in t ? roe(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, loe = (t, e) => {
  for (var n in e || (e = {}))
    ooe.call(e, n) && LD(t, n, e[n]);
  if (CD)
    for (var n of CD(e))
      soe.call(e, n) && LD(t, n, e[n]);
  return t;
}, coe = (t, e) => ioe(t, aoe(e));
function QY(t) {
  return t.includes(":");
}
function doe(t) {
  return QY(t) ? t.split(":")[0] : t;
}
function GY(t) {
  var e, n, r;
  const i = {};
  if (!uoe(t))
    return i;
  for (const [a, o] of Object.entries(t)) {
    const s = QY(a) ? [a] : o.chains, l = o.methods || [], c = o.events || [], d = doe(a);
    i[d] = coe(loe({}, i[d]), { chains: ug(s, (e = i[d]) == null ? void 0 : e.chains), methods: ug(l, (n = i[d]) == null ? void 0 : n.methods), events: ug(c, (r = i[d]) == null ? void 0 : r.events) });
  }
  return i;
}
function uoe(t) {
  return Object.getPrototypeOf(t) === Object.prototype && Object.keys(t).length;
}
var CY = "eip155", hoe = "store", LY = "requestedChains", PZ = "wallet_addEthereumChain", Xn, r1, BT, KZ, $3, JY, AT, $Z, qZ, BY, qf, q3, Bu, CN, eV, eS, tV, tS, nV, nS, Noe = class extends W3 {
  constructor(t) {
    super({
      ...t,
      options: { isNewChainsStale: !0, ...t.options }
    }), Ai(this, BT), Ai(this, $3), Ai(this, AT), Ai(this, qZ), Ai(this, qf), Ai(this, Bu), Ai(this, eV), Ai(this, tV), Ai(this, nV), this.id = "walletConnect", this.name = "WalletConnect", this.ready = !0, Ai(this, Xn, void 0), Ai(this, r1, void 0), this.onAccountsChanged = (e) => {
      e.length === 0 ? this.emit("disconnect") : this.emit("change", { account: un(e[0]) });
    }, this.onChainChanged = (e) => {
      const n = Number(e), r = this.isChainUnsupported(n);
      this.emit("change", { chain: { id: n, unsupported: r } });
    }, this.onDisconnect = () => {
      Wr(this, Bu, CN).call(this, []), this.emit("disconnect");
    }, this.onDisplayUri = (e) => {
      this.emit("message", { type: "display_uri", data: e });
    }, this.onConnect = () => {
      this.emit("connect", {});
    }, Wr(this, BT, KZ).call(this);
  }
  async connect({ chainId: t, pairingTopic: e } = {}) {
    var n, r, i, a, o;
    try {
      let s = t;
      if (!s) {
        const M = (n = this.storage) == null ? void 0 : n.getItem(hoe), p = (a = (i = (r = M == null ? void 0 : M.state) == null ? void 0 : r.data) == null ? void 0 : i.chain) == null ? void 0 : a.id;
        p && !this.isChainUnsupported(p) ? s = p : s = (o = this.chains[0]) == null ? void 0 : o.id;
      }
      if (!s)
        throw new Error("No chains found on connector.");
      const l = await this.getProvider();
      Wr(this, qZ, BY).call(this);
      const c = Wr(this, AT, $Z).call(this);
      if (l.session && c && await l.disconnect(), !l.session || c) {
        const M = this.chains.filter((p) => p.id !== s).map((p) => p.id);
        this.emit("message", { type: "connecting" }), await l.connect({
          pairingTopic: e,
          optionalChains: [s, ...M]
        }), Wr(this, Bu, CN).call(this, this.chains.map(({ id: p }) => p));
      }
      const d = await l.enable(), u = un(d[0]), h = await this.getChainId(), N = this.isChainUnsupported(h);
      return {
        account: u,
        chain: { id: h, unsupported: N }
      };
    } catch (s) {
      throw /user rejected/i.test(s == null ? void 0 : s.message) ? new Un(s) : s;
    }
  }
  async disconnect() {
    const t = await this.getProvider();
    try {
      await t.disconnect();
    } catch (e) {
      if (!/No matching key/i.test(e.message))
        throw e;
    } finally {
      Wr(this, qf, q3).call(this), Wr(this, Bu, CN).call(this, []);
    }
  }
  async getAccount() {
    const { accounts: t } = await this.getProvider();
    return un(t[0]);
  }
  async getChainId() {
    const { chainId: t } = await this.getProvider();
    return t;
  }
  async getProvider({ chainId: t } = {}) {
    return Qn(this, Xn) || await Wr(this, BT, KZ).call(this), t && await this.switchChain(t), Qn(this, Xn);
  }
  async getWalletClient({
    chainId: t
  } = {}) {
    const [e, n] = await Promise.all([
      this.getProvider({ chainId: t }),
      this.getAccount()
    ]), r = this.chains.find((i) => i.id === t);
    if (!e)
      throw new Error("provider is required.");
    return N3({
      account: n,
      chain: r,
      transport: l3(e)
    });
  }
  async isAuthorized() {
    try {
      const [t, e] = await Promise.all([
        this.getAccount(),
        this.getProvider()
      ]), n = Wr(this, AT, $Z).call(this);
      if (!t)
        return !1;
      if (n && e.session) {
        try {
          await e.disconnect();
        } catch {
        }
        return !1;
      }
      return !0;
    } catch {
      return !1;
    }
  }
  async switchChain(t) {
    var n, r;
    const e = this.chains.find((i) => i.id === t);
    if (!e)
      throw new ks(new Error("chain not found on connector."));
    try {
      const i = await this.getProvider(), a = Wr(this, tV, tS).call(this), o = Wr(this, nV, nS).call(this);
      if (!a.includes(t) && o.includes(PZ)) {
        await i.request({
          method: PZ,
          params: [
            {
              chainId: St(e.id),
              blockExplorerUrls: [(r = (n = e.blockExplorers) == null ? void 0 : n.default) == null ? void 0 : r.url],
              chainName: e.name,
              nativeCurrency: e.nativeCurrency,
              rpcUrls: [...e.rpcUrls.default.http]
            }
          ]
        });
        const l = Wr(this, eV, eS).call(this);
        l.push(t), Wr(this, Bu, CN).call(this, l);
      }
      return await i.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: St(t) }]
      }), e;
    } catch (i) {
      const a = typeof i == "string" ? i : i == null ? void 0 : i.message;
      throw /user rejected request/i.test(a) ? new Un(i) : new ks(i);
    }
  }
};
Xn = /* @__PURE__ */ new WeakMap();
r1 = /* @__PURE__ */ new WeakMap();
BT = /* @__PURE__ */ new WeakSet();
KZ = async function() {
  return !Qn(this, r1) && typeof window < "u" && A2(this, r1, Wr(this, $3, JY).call(this)), Qn(this, r1);
};
$3 = /* @__PURE__ */ new WeakSet();
JY = async function() {
  const { EthereumProvider: t } = await import("./index.es-712f1db1.js"), e = this.chains.map(({ id: n }) => n);
  if (e.length) {
    const {
      projectId: n,
      showQrModal: r = !0,
      qrModalOptions: i,
      metadata: a,
      relayUrl: o
    } = this.options;
    A2(this, Xn, await t.init({
      showQrModal: r,
      qrModalOptions: i,
      projectId: n,
      optionalChains: e,
      rpcMap: Object.fromEntries(
        this.chains.map((s) => [
          s.id,
          s.rpcUrls.default.http[0]
        ])
      ),
      metadata: a,
      relayUrl: o
    }));
  }
};
AT = /* @__PURE__ */ new WeakSet();
$Z = function() {
  if (Wr(this, nV, nS).call(this).includes(PZ) || !this.options.isNewChainsStale)
    return !1;
  const e = Wr(this, eV, eS).call(this), n = this.chains.map(({ id: i }) => i), r = Wr(this, tV, tS).call(this);
  return r.length && !r.some((i) => n.includes(i)) ? !1 : !n.every((i) => e.includes(i));
};
qZ = /* @__PURE__ */ new WeakSet();
BY = function() {
  Qn(this, Xn) && (Wr(this, qf, q3).call(this), Qn(this, Xn).on("accountsChanged", this.onAccountsChanged), Qn(this, Xn).on("chainChanged", this.onChainChanged), Qn(this, Xn).on("disconnect", this.onDisconnect), Qn(this, Xn).on("session_delete", this.onDisconnect), Qn(this, Xn).on("display_uri", this.onDisplayUri), Qn(this, Xn).on("connect", this.onConnect));
};
qf = /* @__PURE__ */ new WeakSet();
q3 = function() {
  Qn(this, Xn) && (Qn(this, Xn).removeListener("accountsChanged", this.onAccountsChanged), Qn(this, Xn).removeListener("chainChanged", this.onChainChanged), Qn(this, Xn).removeListener("disconnect", this.onDisconnect), Qn(this, Xn).removeListener("session_delete", this.onDisconnect), Qn(this, Xn).removeListener("display_uri", this.onDisplayUri), Qn(this, Xn).removeListener("connect", this.onConnect));
};
Bu = /* @__PURE__ */ new WeakSet();
CN = function(t) {
  var e;
  (e = this.storage) == null || e.setItem(LY, t);
};
eV = /* @__PURE__ */ new WeakSet();
eS = function() {
  var t;
  return ((t = this.storage) == null ? void 0 : t.getItem(LY)) ?? [];
};
tV = /* @__PURE__ */ new WeakSet();
tS = function() {
  var r, i, a;
  if (!Qn(this, Xn))
    return [];
  const t = (r = Qn(this, Xn).session) == null ? void 0 : r.namespaces;
  return t ? ((a = (i = GY(t)[CY]) == null ? void 0 : i.chains) == null ? void 0 : a.map(
    (o) => parseInt(o.split(":")[1] || "")
  )) ?? [] : [];
};
nV = /* @__PURE__ */ new WeakSet();
nS = function() {
  var r, i;
  if (!Qn(this, Xn))
    return [];
  const t = (r = Qn(this, Xn).session) == null ? void 0 : r.namespaces;
  return t ? ((i = GY(t)[CY]) == null ? void 0 : i.methods) ?? [] : [];
};
class Moe extends Error {
  constructor({
    chainId: n,
    connectorId: r
  }) {
    super(`Chain "${n}" not configured for connector "${r}".`);
    Vt(this, "name", "ChainNotConfiguredForConnectorError");
  }
}
class aN extends Error {
  constructor() {
    super(...arguments);
    Vt(this, "name", "ConnectorNotFoundError");
    Vt(this, "message", "Connector not found");
  }
}
function JD(t) {
  return typeof t == "string" ? Number.parseInt(
    t,
    t.trim().substring(0, 2) === "0x" ? 16 : 10
  ) : typeof t == "bigint" ? Number(t) : t;
}
const poe = () => {
  if (typeof window < "u")
    return window == null ? void 0 : window.okxwallet;
};
class moe extends gc {
  constructor({
    chains: n,
    options: r
  } = {}) {
    const i = {
      name: Rc.OKXWallet,
      shimDisconnect: !0,
      getProvider: poe,
      ...r
    };
    super({ chains: n, options: i });
    Vt(this, "id", Kr.OKXWallet);
    Vt(this, "shimDisconnectKey", `${this.id}.shimDisconnect`);
    Vt(this, "UNSTABLE_shimOnConnectSelectAccount");
    this.UNSTABLE_shimOnConnectSelectAccount = i.UNSTABLE_shimOnConnectSelectAccount;
  }
  async connect({ chainId: n } = {}) {
    var r, i, a, o;
    try {
      const s = await this.getProvider();
      if (!s)
        throw new aN();
      s.on && (s.on("accountsChanged", this.onAccountsChanged), s.on("chainChanged", this.onChainChanged), s.on("disconnect", this.onDisconnect)), this.emit("message", { type: "connecting" });
      let l = null;
      if (this.UNSTABLE_shimOnConnectSelectAccount && ((r = this.options) != null && r.shimDisconnect) && !((i = this.storage) != null && i.getItem(this.shimDisconnectKey)) && (l = await this.getAccount().catch(() => null), !!l))
        try {
          await s.request({
            method: "wallet_requestPermissions",
            params: [{ eth_accounts: {} }]
          }), l = await this.getAccount();
        } catch (h) {
          if (this.isUserRejectedRequestError(h))
            throw new Un(h);
          if (h.code === new Lr(h).code)
            throw h;
        }
      if (!l) {
        const u = await s.request({
          method: "eth_requestAccounts"
        });
        l = un(u[0]);
      }
      let c = await this.getChainId(), d = this.isChainUnsupported(c);
      return n && c !== n && (c = (await this.switchChain(n)).id, d = this.isChainUnsupported(c)), (a = this.options) != null && a.shimDisconnect && ((o = this.storage) == null || o.setItem(this.shimDisconnectKey, !0)), { account: l, chain: { id: c, unsupported: d }, provider: s };
    } catch (s) {
      throw this.isUserRejectedRequestError(s) ? new Un(s) : s.code === -32002 ? new Lr(s) : s;
    }
  }
}
const Toe = () => {
  var n;
  const t = (r) => r ? !!r.isTrust : !1;
  return typeof window < "u" && typeof window.ethereum < "u" ? t(window.ethereum) ? window.ethereum : (n = window.ethereum) != null && n.providers ? window.ethereum.providers.find(t) ?? null : (window == null ? void 0 : window.trustwallet) ?? null : null;
};
class foe extends gc {
  constructor({
    chains: n,
    options: r
  } = {}) {
    const i = {
      name: Rc.TrustWallet,
      shimDisconnect: !0,
      getProvider: Toe,
      ...r
    };
    super({ chains: n, options: i });
    Vt(this, "id", Kr.TrustWallet);
    Vt(this, "shimDisconnectKey", `${this.id}.shimDisconnect`);
    Vt(this, "UNSTABLE_shimOnConnectSelectAccount");
    this.UNSTABLE_shimOnConnectSelectAccount = i.UNSTABLE_shimOnConnectSelectAccount;
  }
  async connect({ chainId: n } = {}) {
    var r, i, a, o;
    try {
      const s = await this.getProvider();
      if (!s)
        throw new aN();
      s.on && (s.on("accountsChanged", this.onAccountsChanged), s.on("chainChanged", this.onChainChanged), s.on("disconnect", this.onDisconnect)), this.emit("message", { type: "connecting" });
      let l = null;
      if (this.UNSTABLE_shimOnConnectSelectAccount && ((r = this.options) != null && r.shimDisconnect) && !((i = this.storage) != null && i.getItem(this.shimDisconnectKey)) && (l = await this.getAccount().catch(() => null), !!l))
        try {
          await s.request({
            method: "wallet_requestPermissions",
            params: [{ eth_accounts: {} }]
          }), l = await this.getAccount();
        } catch (h) {
          if (this.isUserRejectedRequestError(h))
            throw new Un(h);
          if (h.code === new Lr(h).code)
            throw h;
        }
      if (!l) {
        const u = await s.request({
          method: "eth_requestAccounts"
        });
        l = un(u[0]);
      }
      let c = await this.getChainId(), d = this.isChainUnsupported(c);
      return n && c !== n && (c = (await this.switchChain(n)).id, d = this.isChainUnsupported(c)), (a = this.options) != null && a.shimDisconnect && ((o = this.storage) == null || o.setItem(this.shimDisconnectKey, !0)), { account: l, chain: { id: c, unsupported: d }, provider: s };
    } catch (s) {
      throw this.isUserRejectedRequestError(s) ? new Un(s) : s.code === -32002 ? new Lr(s) : s;
    }
  }
}
const Voe = () => {
  var t;
  if ((t = window == null ? void 0 : window.ethereum) != null && t.isImToken)
    return window.ethereum;
};
class Uoe extends gc {
  constructor({
    chains: n,
    options: r
  } = {}) {
    const i = {
      name: Rc.ImToken,
      shimDisconnect: !0,
      getProvider: Voe,
      ...r
    };
    super({ chains: n, options: i });
    Vt(this, "id", "imToken");
    Vt(this, "shimDisconnectKey", `${this.id}.shimDisconnect`);
    Vt(this, "UNSTABLE_shimOnConnectSelectAccount");
    this.UNSTABLE_shimOnConnectSelectAccount = i.UNSTABLE_shimOnConnectSelectAccount;
  }
  async connect({ chainId: n } = {}) {
    var r, i, a, o;
    try {
      const s = await this.getProvider();
      if (!s)
        throw new aN();
      s.on && (s.on("accountsChanged", this.onAccountsChanged), s.on("chainChanged", this.onChainChanged), s.on("disconnect", this.onDisconnect)), this.emit("message", { type: "connecting" });
      let l = null;
      if (this.UNSTABLE_shimOnConnectSelectAccount && ((r = this.options) != null && r.shimDisconnect) && !((i = this.storage) != null && i.getItem(this.shimDisconnectKey)) && (l = await this.getAccount().catch(() => null), !!l))
        try {
          await s.request({
            method: "wallet_requestPermissions",
            params: [{ eth_accounts: {} }]
          }), l = await this.getAccount();
        } catch (h) {
          if (this.isUserRejectedRequestError(h))
            throw new Un(h);
          if (h.code === new Lr(h).code)
            throw h;
        }
      if (!l) {
        const u = await s.request({
          method: "eth_requestAccounts"
        });
        l = un(u[0]);
      }
      let c = await this.getChainId(), d = this.isChainUnsupported(c);
      return n && c !== n && (c = (await this.switchChain(n)).id, d = this.isChainUnsupported(c)), (a = this.options) != null && a.shimDisconnect && ((o = this.storage) == null || o.setItem(this.shimDisconnectKey, !0)), { account: l, chain: { id: c, unsupported: d }, provider: s };
    } catch (s) {
      throw this.isUserRejectedRequestError(s) ? new Un(s) : s.code === -32002 ? new Lr(s) : s;
    }
  }
}
const Roe = () => {
  var t;
  if (typeof window < "u")
    return (t = window == null ? void 0 : window.bitkeep) == null ? void 0 : t.ethereum;
};
class goe extends gc {
  constructor({
    chains: n,
    options: r
  } = {}) {
    const i = {
      name: Rc.Bitget,
      shimDisconnect: !0,
      getProvider: Roe,
      ...r
    };
    super({ chains: n, options: i });
    Vt(this, "id", Kr.Bitget);
    Vt(this, "shimDisconnectKey", `${this.id}.shimDisconnect`);
    Vt(this, "UNSTABLE_shimOnConnectSelectAccount");
    this.UNSTABLE_shimOnConnectSelectAccount = i.UNSTABLE_shimOnConnectSelectAccount;
  }
  async connect({ chainId: n } = {}) {
    var r, i, a, o;
    try {
      const s = await this.getProvider();
      if (!s)
        throw new aN();
      s.on && (s.on("accountsChanged", this.onAccountsChanged), s.on("chainChanged", this.onChainChanged), s.on("disconnect", this.onDisconnect)), this.emit("message", { type: "connecting" });
      let l = null;
      if (this.UNSTABLE_shimOnConnectSelectAccount && ((r = this.options) != null && r.shimDisconnect) && !((i = this.storage) != null && i.getItem(this.shimDisconnectKey)) && (l = await this.getAccount().catch(() => null), !!l))
        try {
          await s.request({
            method: "wallet_requestPermissions",
            params: [{ eth_accounts: {} }]
          }), l = await this.getAccount();
        } catch (h) {
          if (this.isUserRejectedRequestError(h))
            throw new Un(h);
          if (h.code === new Lr(h).code)
            throw h;
        }
      if (!l) {
        const u = await s.request({
          method: "eth_requestAccounts"
        });
        l = un(u[0]);
      }
      let c = await this.getChainId(), d = this.isChainUnsupported(c);
      return n && c !== n && (c = (await this.switchChain(n)).id, d = this.isChainUnsupported(c)), (a = this.options) != null && a.shimDisconnect && ((o = this.storage) == null || o.setItem(this.shimDisconnectKey, !0)), { account: l, chain: { id: c, unsupported: d }, provider: s };
    } catch (s) {
      throw this.isUserRejectedRequestError(s) ? new Un(s) : s.code === -32002 ? new Lr(s) : s;
    }
  }
}
const yoe = () => {
  if (typeof window < "u")
    return window == null ? void 0 : window.haloEthereum;
};
class Zoe extends gc {
  constructor({
    chains: n,
    options: r
  } = {}) {
    const i = {
      name: Rc.HaloWallet,
      shimDisconnect: !0,
      getProvider: yoe,
      ...r
    };
    super({ chains: n, options: i });
    Vt(this, "id", Kr.HaloWallet);
    Vt(this, "shimDisconnectKey", `${this.id}.shimDisconnect`);
    Vt(this, "UNSTABLE_shimOnConnectSelectAccount");
    this.UNSTABLE_shimOnConnectSelectAccount = i.UNSTABLE_shimOnConnectSelectAccount;
  }
  async connect({ chainId: n } = {}) {
    var r, i, a, o;
    try {
      const s = await this.getProvider();
      if (!s)
        throw new aN();
      s.on && (s.on("accountsChanged", this.onAccountsChanged), s.on("chainChanged", this.onChainChanged), s.on("disconnect", this.onDisconnect)), this.emit("message", { type: "connecting" });
      let l = null;
      if (this.UNSTABLE_shimOnConnectSelectAccount && ((r = this.options) != null && r.shimDisconnect) && !((i = this.storage) != null && i.getItem(this.shimDisconnectKey)) && (l = await this.getAccount().catch(() => null), !!l))
        try {
          await s.request({
            method: "wallet_requestPermissions",
            params: [{ eth_accounts: {} }]
          }), l = await this.getAccount();
        } catch (h) {
          if (this.isUserRejectedRequestError(h))
            throw new Un(h);
          if (h.code === new Lr(h).code)
            throw h;
        }
      if (!l) {
        const u = await s.request({
          method: "eth_requestAccounts"
        });
        l = un(u[0]);
      }
      let c = await this.getChainId(), d = this.isChainUnsupported(c);
      return n && c !== n && (c = (await this.switchChain(n)).id, d = this.isChainUnsupported(c)), (a = this.options) != null && a.shimDisconnect && ((o = this.storage) == null || o.setItem(this.shimDisconnectKey, !0)), { account: l, chain: { id: c, unsupported: d }, provider: s };
    } catch (s) {
      throw this.isUserRejectedRequestError(s) ? new Un(s) : s.code === -32002 ? new Lr(s) : s;
    }
  }
}
const boe = () => {
  var t;
  if (typeof window < "u" && window.isSecureContext && ((t = window.ethereum) == null ? void 0 : t.isBraveWallet))
    return window.ethereum;
};
class Eoe extends gc {
  constructor({
    chains: n,
    options: r
  } = {}) {
    const i = {
      name: Rc.Brave,
      shimDisconnect: !0,
      getProvider: boe,
      ...r
    };
    super({ chains: n, options: i });
    Vt(this, "id", Kr.Brave);
    Vt(this, "shimDisconnectKey", `${this.id}.shimDisconnect`);
    Vt(this, "UNSTABLE_shimOnConnectSelectAccount");
    this.UNSTABLE_shimOnConnectSelectAccount = i.UNSTABLE_shimOnConnectSelectAccount;
  }
  async connect({ chainId: n } = {}) {
    var r, i, a, o;
    try {
      const s = await this.getProvider();
      if (!s)
        throw new aN();
      s.on && (s.on("accountsChanged", this.onAccountsChanged), s.on("chainChanged", this.onChainChanged), s.on("disconnect", this.onDisconnect)), this.emit("message", { type: "connecting" });
      let l = null;
      if (this.UNSTABLE_shimOnConnectSelectAccount && ((r = this.options) != null && r.shimDisconnect) && !((i = this.storage) != null && i.getItem(this.shimDisconnectKey)) && (l = await this.getAccount().catch(() => null), !!l))
        try {
          await s.request({
            method: "wallet_requestPermissions",
            params: [{ eth_accounts: {} }]
          }), l = await this.getAccount();
        } catch (h) {
          if (this.isUserRejectedRequestError(h))
            throw new Un(h);
          if (h.code === new Lr(h).code)
            throw h;
        }
      if (!l) {
        const u = await s.request({
          method: "eth_requestAccounts"
        });
        l = un(u[0]);
      }
      let c = await this.getChainId(), d = this.isChainUnsupported(c);
      return n && c !== n && (c = (await this.switchChain(n)).id, d = this.isChainUnsupported(c)), (a = this.options) != null && a.shimDisconnect && ((o = this.storage) == null || o.setItem(this.shimDisconnectKey, !0)), { account: l, chain: { id: c, unsupported: d }, provider: s };
    } catch (s) {
      throw this.isUserRejectedRequestError(s) ? new Un(s) : s.code === -32002 ? new Lr(s) : s;
    }
  }
}
var X0, Rd;
class Soe extends W3 {
  constructor({ chains: n, options: r }) {
    super({
      chains: n,
      options: {
        reloadOnDisconnect: !1,
        ...r
      }
    });
    Vt(this, "id", Kr.CoinbaseWallet);
    Vt(this, "name", Rc.CoinbaseWallet);
    Vt(this, "ready", !0);
    Fe(this, X0, void 0);
    Fe(this, Rd, void 0);
    Vt(this, "onAccountsChanged", (n) => {
      n.length === 0 ? this.emit("disconnect") : this.emit("change", { account: un(n[0]) });
    });
    Vt(this, "onChainChanged", (n) => {
      const r = JD(n), i = this.isChainUnsupported(r);
      this.emit("change", { chain: { id: r, unsupported: i } });
    });
    Vt(this, "onDisconnect", () => {
      this.emit("disconnect");
    });
  }
  async connect({ chainId: n } = {}) {
    try {
      const r = await this.getProvider();
      r.on("accountsChanged", this.onAccountsChanged), r.on("chainChanged", this.onChainChanged), r.on("disconnect", this.onDisconnect), this.emit("message", { type: "connecting" });
      const i = await r.enable(), a = un(i[0]);
      let o = await this.getChainId(), s = this.isChainUnsupported(o);
      return n && o !== n && (o = (await this.switchChain(n)).id, s = this.isChainUnsupported(o)), {
        account: a,
        chain: { id: o, unsupported: s }
      };
    } catch (r) {
      throw /(user closed modal|accounts received is empty)/i.test(
        r.message
      ) ? new Un(r) : r;
    }
  }
  async disconnect() {
    if (!K(this, Rd))
      return;
    const n = await this.getProvider();
    n.removeListener("accountsChanged", this.onAccountsChanged), n.removeListener("chainChanged", this.onChainChanged), n.removeListener("disconnect", this.onDisconnect), n.disconnect(), n.close();
  }
  async getAccount() {
    const r = await (await this.getProvider()).request({
      method: "eth_accounts"
    });
    return un(r[0]);
  }
  async getChainId() {
    const n = await this.getProvider();
    return JD(n.chainId);
  }
  async getProvider() {
    var n;
    if (!K(this, Rd)) {
      let r = (await import("./index-936c55c4.js").then((l) => l.i)).default;
      typeof r != "function" && // @ts-expect-error This import error is not visible to TypeScript
      typeof r.default == "function" && (r = r.default), Ue(this, X0, new r(this.options));
      const i = (n = K(this, X0).walletExtension) == null ? void 0 : n.getChainId(), a = this.chains.find(
        (l) => this.options.chainId ? l.id === this.options.chainId : l.id === i
      ) || this.chains[0], o = this.options.chainId || (a == null ? void 0 : a.id), s = this.options.jsonRpcUrl || (a == null ? void 0 : a.rpcUrls.default.http[0]);
      Ue(this, Rd, K(this, X0).makeWeb3Provider(s, o));
    }
    return K(this, Rd);
  }
  async getWalletClient({ chainId: n } = {}) {
    const [r, i] = await Promise.all([
      this.getProvider(),
      this.getAccount()
    ]), a = this.chains.find((o) => o.id === n);
    if (!r)
      throw new Error("provider is required.");
    return N3({
      account: i,
      chain: a,
      transport: l3(r)
    });
  }
  async isAuthorized() {
    try {
      return !!await this.getAccount();
    } catch {
      return !1;
    }
  }
  async switchChain(n) {
    var a, o, s;
    const r = await this.getProvider(), i = St(n);
    try {
      return await r.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: i }]
      }), this.chains.find((l) => l.id === n) ?? {
        id: n,
        name: `Chain ${i}`,
        network: `${i}`,
        nativeCurrency: { name: "Ether", decimals: 18, symbol: "ETH" },
        rpcUrls: { default: { http: [""] }, public: { http: [""] } }
      };
    } catch (l) {
      const c = this.chains.find((d) => d.id === n);
      if (!c)
        throw new Moe({
          chainId: n,
          connectorId: this.id
        });
      if (((o = (a = l == null ? void 0 : l.data) == null ? void 0 : a.originalError) == null ? void 0 : o.code) === 4902)
        try {
          return await r.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainId: i,
                chainName: c.name,
                nativeCurrency: c.nativeCurrency,
                rpcUrls: [((s = c.rpcUrls.public) == null ? void 0 : s.http[0]) ?? ""],
                blockExplorerUrls: this.getBlockExplorerUrls(c)
              }
            ]
          }), c;
        } catch (d) {
          throw new Un(d);
        }
      throw new ks(l);
    }
  }
  async watchAsset({
    address: n,
    decimals: r = 18,
    image: i,
    symbol: a
  }) {
    return (await this.getProvider()).request({
      method: "wallet_watchAsset",
      params: {
        type: "ERC20",
        options: {
          address: n,
          decimals: r,
          image: i,
          symbol: a
        }
      }
    });
  }
}
X0 = new WeakMap(), Rd = new WeakMap();
function xoe() {
  return function(t) {
    return t.rpcUrls.public.http[0] ? {
      chain: t,
      rpcUrls: t.rpcUrls.public
    } : null;
  };
}
let pl;
function Woe(t) {
  t && (pl = t);
}
function joe() {
  if (!pl)
    throw new Error('Please call "createWeb3Modal" before using "useWeb3Modal" hook');
  async function t(n) {
    await (pl == null ? void 0 : pl.open(n));
  }
  async function e() {
    await (pl == null ? void 0 : pl.close());
  }
  return { open: t, close: e };
}
const Doe = Symbol(), BD = Object.getPrototypeOf, eb = /* @__PURE__ */ new WeakMap(), zoe = (t) => t && (eb.has(t) ? eb.get(t) : BD(t) === Object.prototype || BD(t) === Array.prototype), koe = (t) => zoe(t) && t[Doe] || null, AD = (t, e = !0) => {
  eb.set(t, e);
}, hg = (t) => typeof t == "object" && t !== null, fl = /* @__PURE__ */ new WeakMap(), LN = /* @__PURE__ */ new WeakSet(), woe = (t = Object.is, e = (c, d) => new Proxy(c, d), n = (c) => hg(c) && !LN.has(c) && (Array.isArray(c) || !(Symbol.iterator in c)) && !(c instanceof WeakMap) && !(c instanceof WeakSet) && !(c instanceof Error) && !(c instanceof Number) && !(c instanceof Date) && !(c instanceof String) && !(c instanceof RegExp) && !(c instanceof ArrayBuffer), r = (c) => {
  switch (c.status) {
    case "fulfilled":
      return c.value;
    case "rejected":
      throw c.reason;
    default:
      throw c;
  }
}, i = /* @__PURE__ */ new WeakMap(), a = (c, d, u = r) => {
  const h = i.get(c);
  if ((h == null ? void 0 : h[0]) === d)
    return h[1];
  const N = Array.isArray(c) ? [] : Object.create(Object.getPrototypeOf(c));
  return AD(N, !0), i.set(c, [d, N]), Reflect.ownKeys(c).forEach((M) => {
    if (Object.getOwnPropertyDescriptor(N, M))
      return;
    const p = Reflect.get(c, M), m = {
      value: p,
      enumerable: !0,
      // This is intentional to avoid copying with proxy-compare.
      // It's still non-writable, so it avoids assigning a value.
      configurable: !0
    };
    if (LN.has(p))
      AD(p, !1);
    else if (p instanceof Promise)
      delete m.value, m.get = () => u(p);
    else if (fl.has(p)) {
      const [R, V] = fl.get(
        p
      );
      m.value = a(
        R,
        V(),
        u
      );
    }
    Object.defineProperty(N, M, m);
  }), Object.preventExtensions(N);
}, o = /* @__PURE__ */ new WeakMap(), s = [1, 1], l = (c) => {
  if (!hg(c))
    throw new Error("object required");
  const d = o.get(c);
  if (d)
    return d;
  let u = s[0];
  const h = /* @__PURE__ */ new Set(), N = (Y, Q = ++s[0]) => {
    u !== Q && (u = Q, h.forEach((G) => G(Y, Q)));
  };
  let M = s[1];
  const p = (Y = ++s[1]) => (M !== Y && !h.size && (M = Y, R.forEach(([Q]) => {
    const G = Q[1](Y);
    G > u && (u = G);
  })), u), m = (Y) => (Q, G) => {
    const ne = [...Q];
    ne[1] = [Y, ...ne[1]], N(ne, G);
  }, R = /* @__PURE__ */ new Map(), V = (Y, Q) => {
    if (R.has(Y))
      throw new Error("prop listener already exists");
    if (h.size) {
      const G = Q[3](m(Y));
      R.set(Y, [Q, G]);
    } else
      R.set(Y, [Q]);
  }, U = (Y) => {
    var Q;
    const G = R.get(Y);
    G && (R.delete(Y), (Q = G[1]) == null || Q.call(G));
  }, g = (Y) => (h.add(Y), h.size === 1 && R.forEach(([G, ne], O) => {
    if (ne)
      throw new Error("remove already exists");
    const T = G[3](m(O));
    R.set(O, [G, T]);
  }), () => {
    h.delete(Y), h.size === 0 && R.forEach(([G, ne], O) => {
      ne && (ne(), R.set(O, [G]));
    });
  }), y = Array.isArray(c) ? [] : Object.create(Object.getPrototypeOf(c)), f = e(y, {
    deleteProperty(Y, Q) {
      const G = Reflect.get(Y, Q);
      U(Q);
      const ne = Reflect.deleteProperty(Y, Q);
      return ne && N(["delete", [Q], G]), ne;
    },
    set(Y, Q, G, ne) {
      const O = Reflect.has(Y, Q), T = Reflect.get(Y, Q, ne);
      if (O && (t(T, G) || o.has(G) && t(T, o.get(G))))
        return !0;
      U(Q), hg(G) && (G = koe(G) || G);
      let Z = G;
      if (G instanceof Promise)
        G.then((z) => {
          G.status = "fulfilled", G.value = z, N(["resolve", [Q], z]);
        }).catch((z) => {
          G.status = "rejected", G.reason = z, N(["reject", [Q], z]);
        });
      else {
        !fl.has(G) && n(G) && (Z = l(G));
        const z = !LN.has(Z) && fl.get(Z);
        z && V(Q, z);
      }
      return Reflect.set(Y, Q, Z, ne), N(["set", [Q], G, T]), !0;
    }
  });
  o.set(c, f);
  const D = [
    y,
    p,
    a,
    g
  ];
  return fl.set(f, D), Reflect.ownKeys(c).forEach((Y) => {
    const Q = Object.getOwnPropertyDescriptor(
      c,
      Y
    );
    "value" in Q && (f[Y] = c[Y], delete Q.value, delete Q.writable), Object.defineProperty(y, Y, Q);
  }), f;
}) => [
  // public functions
  l,
  // shared state
  fl,
  LN,
  // internal things
  t,
  e,
  n,
  r,
  i,
  a,
  o,
  s
], [Foe] = woe();
function Ri(t = {}) {
  return Foe(t);
}
function Xs(t, e, n) {
  const r = fl.get(t);
  r || console.warn("Please use proxy object");
  let i;
  const a = [], o = r[3];
  let s = !1;
  const c = o((d) => {
    if (a.push(d), n) {
      e(a.splice(0));
      return;
    }
    i || (i = Promise.resolve().then(() => {
      i = void 0, s && e(a.splice(0));
    }));
  });
  return s = !0, () => {
    s = !1, c();
  };
}
function _we(t, e) {
  const n = fl.get(t);
  n || console.warn("Please use proxy object");
  const [r, i, a] = n;
  return a(r, i(), e);
}
function cM(t) {
  return LN.add(t), t;
}
function eo(t, e, n, r) {
  let i = t[e];
  return Xs(
    t,
    () => {
      const a = t[e];
      Object.is(i, a) || n(i = a);
    },
    r
  );
}
const od = {
  FOUR_MINUTES_MS: 24e4,
  TEN_SEC_MS: 1e4,
  ONE_SEC_MS: 1e3,
  SECURE_SITE_DASHBOARD: "https://secure.web3modal.com/dashboard",
  SECURE_SITE_FAVICON: "https://secure.web3modal.com/images/favicon.png",
  RESTRICTED_TIMEZONES: [
    "ASIA/SHANGHAI",
    "ASIA/URUMQI",
    "ASIA/CHONGQING",
    "ASIA/HARBIN",
    "ASIA/KASHGAR",
    "ASIA/MACAU",
    "ASIA/HONG_KONG",
    "ASIA/MACAO",
    "ASIA/BEIJING",
    "ASIA/HARBIN"
  ]
}, st = {
  isMobile() {
    return typeof window < "u" ? !!(window.matchMedia("(pointer:coarse)").matches || /Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini/u.test(navigator.userAgent)) : !1;
  },
  isAndroid() {
    const t = window.navigator.userAgent.toLowerCase();
    return st.isMobile() && t.includes("android");
  },
  isIos() {
    const t = window.navigator.userAgent.toLowerCase();
    return st.isMobile() && (t.includes("iphone") || t.includes("ipad"));
  },
  isClient() {
    return typeof window < "u";
  },
  isPairingExpired(t) {
    return t ? t - Date.now() <= od.TEN_SEC_MS : !0;
  },
  isAllowedRetry(t) {
    return Date.now() - t >= od.ONE_SEC_MS;
  },
  copyToClopboard(t) {
    navigator.clipboard.writeText(t);
  },
  getPairingExpiry() {
    return Date.now() + od.FOUR_MINUTES_MS;
  },
  getPlainAddress(t) {
    return t.split(":")[2];
  },
  async wait(t) {
    return new Promise((e) => {
      setTimeout(e, t);
    });
  },
  debounce(t, e = 500) {
    let n;
    return (...r) => {
      function i() {
        t(...r);
      }
      n && clearTimeout(n), n = setTimeout(i, e);
    };
  },
  isHttpUrl(t) {
    return t.startsWith("http://") || t.startsWith("https://");
  },
  formatNativeUrl(t, e) {
    if (st.isHttpUrl(t))
      return this.formatUniversalUrl(t, e);
    let n = t;
    n.includes("://") || (n = t.replaceAll("/", "").replaceAll(":", ""), n = `${n}://`), n.endsWith("/") || (n = `${n}/`);
    const r = encodeURIComponent(e);
    return {
      redirect: `${n}wc?uri=${r}`,
      href: n
    };
  },
  formatUniversalUrl(t, e) {
    if (!st.isHttpUrl(t))
      return this.formatNativeUrl(t, e);
    let n = t;
    n.endsWith("/") || (n = `${n}/`);
    const r = encodeURIComponent(e);
    return {
      redirect: `${n}wc?uri=${r}`,
      href: n
    };
  },
  openHref(t, e) {
    window.open(t, e, "noreferrer noopener");
  },
  async preloadImage(t) {
    const e = new Promise((n, r) => {
      const i = new Image();
      i.onload = n, i.onerror = r, i.crossOrigin = "anonymous", i.src = t;
    });
    return Promise.race([e, st.wait(2e3)]);
  },
  formatBalance(t, e) {
    var r;
    let n;
    if (t === "0")
      n = "0.000";
    else if (typeof t == "string") {
      const i = Number(t);
      i && (n = (r = i.toString().match(/^-?\d+(?:\.\d{0,3})?/u)) == null ? void 0 : r[0]);
    }
    return n ? `${n} ${e}` : `0.000 ${e}`;
  },
  isRestrictedRegion() {
    try {
      const { timeZone: t } = new Intl.DateTimeFormat().resolvedOptions(), e = t.toUpperCase();
      return od.RESTRICTED_TIMEZONES.includes(e);
    } catch {
      return !1;
    }
  },
  getApiUrl() {
    return st.isRestrictedRegion() ? "https://api.web3modal.org" : "https://api.web3modal.com";
  },
  getBlockchainApiUrl() {
    return st.isRestrictedRegion() ? "https://rpc.walletconnect.org" : "https://rpc.walletconnect.com";
  },
  getAnalyticsUrl() {
    return st.isRestrictedRegion() ? "https://pulse.walletconnect.org" : "https://pulse.walletconnect.com";
  },
  getUUID() {
    return crypto != null && crypto.randomUUID ? crypto.randomUUID() : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/gu, (t) => {
      const e = Math.random() * 16 | 0;
      return (t === "x" ? e : e & 3 | 8).toString(16);
    });
  },
  parseError(t) {
    var e, n;
    return typeof t == "string" ? t : typeof ((n = (e = t == null ? void 0 : t.issues) == null ? void 0 : e[0]) == null ? void 0 : n.message) == "string" ? t.issues[0].message : t instanceof Error ? t.message : "Unknown error";
  }
}, cr = Ri({
  isConnected: !1
}), en = {
  state: cr,
  subscribe(t) {
    return Xs(cr, () => t(cr));
  },
  subscribeKey(t, e) {
    return eo(cr, t, e);
  },
  setIsConnected(t) {
    cr.isConnected = t;
  },
  setCaipAddress(t) {
    cr.caipAddress = t, cr.address = t ? st.getPlainAddress(t) : void 0;
  },
  setBalance(t, e) {
    cr.balance = t, cr.balanceSymbol = e;
  },
  setProfileName(t) {
    cr.profileName = t;
  },
  setProfileImage(t) {
    cr.profileImage = t;
  },
  setAddressExplorerUrl(t) {
    cr.addressExplorerUrl = t;
  },
  resetAccount() {
    cr.isConnected = !1, cr.caipAddress = void 0, cr.address = void 0, cr.balance = void 0, cr.balanceSymbol = void 0, cr.profileName = void 0, cr.profileImage = void 0, cr.addressExplorerUrl = void 0;
  }
};
class rS {
  constructor({ baseUrl: e }) {
    this.baseUrl = e;
  }
  async get({ headers: e, ...n }) {
    const r = this.createUrl(n);
    return (await fetch(r, { method: "GET", headers: e })).json();
  }
  async getBlob({ headers: e, ...n }) {
    const r = this.createUrl(n);
    return (await fetch(r, { method: "GET", headers: e })).blob();
  }
  async post({ body: e, headers: n, ...r }) {
    const i = this.createUrl(r);
    return (await fetch(i, {
      method: "POST",
      headers: n,
      body: e ? JSON.stringify(e) : void 0
    })).json();
  }
  async put({ body: e, headers: n, ...r }) {
    const i = this.createUrl(r);
    return (await fetch(i, {
      method: "PUT",
      headers: n,
      body: e ? JSON.stringify(e) : void 0
    })).json();
  }
  async delete({ body: e, headers: n, ...r }) {
    const i = this.createUrl(r);
    return (await fetch(i, {
      method: "DELETE",
      headers: n,
      body: e ? JSON.stringify(e) : void 0
    })).json();
  }
  createUrl({ path: e, params: n }) {
    const r = new URL(e, this.baseUrl);
    return n && Object.entries(n).forEach(([i, a]) => {
      a && r.searchParams.append(i, a);
    }), r;
  }
}
const Ng = "WALLETCONNECT_DEEPLINK_CHOICE", HD = "@w3m/recent", XD = "@w3m/connected_wallet_image_url", _D = "@w3m/connected_connector", Si = {
  setWalletConnectDeepLink({ href: t, name: e }) {
    try {
      localStorage.setItem(Ng, JSON.stringify({ href: t, name: e }));
    } catch {
      console.info("Unable to set WalletConnect deep link");
    }
  },
  getWalletConnectDeepLink() {
    try {
      const t = localStorage.getItem(Ng);
      if (t)
        return JSON.parse(t);
    } catch {
      console.info("Unable to get WalletConnect deep link");
    }
  },
  deleteWalletConnectDeepLink() {
    try {
      localStorage.removeItem(Ng);
    } catch {
      console.info("Unable to delete WalletConnect deep link");
    }
  },
  setWeb3ModalRecent(t) {
    try {
      const e = Si.getRecentWallets();
      e.find((r) => r.id === t.id) || (e.unshift(t), e.length > 2 && e.pop(), localStorage.setItem(HD, JSON.stringify(e)));
    } catch {
      console.info("Unable to set Web3Modal recent");
    }
  },
  getRecentWallets() {
    try {
      const t = localStorage.getItem(HD);
      return t ? JSON.parse(t) : [];
    } catch {
      console.info("Unable to get Web3Modal recent");
    }
    return [];
  },
  setConnectedWalletImageUrl(t) {
    try {
      localStorage.setItem(XD, t);
    } catch {
      console.info("Unable to set Connected Wallet Image Url");
    }
  },
  getConnectedWalletImageUrl() {
    try {
      return localStorage.getItem(XD);
    } catch {
      console.info("Unable to set Connected Wallet Image Url");
    }
  },
  setConnectedConnector(t) {
    try {
      localStorage.setItem(_D, t);
    } catch {
      console.info("Unable to set Connected Connector");
    }
  },
  getConnectedConnector() {
    try {
      return localStorage.getItem(_D);
    } catch {
      console.info("Unable to get Connected Connector");
    }
  }
}, ol = Ri({
  walletImages: {},
  networkImages: {},
  connectorImages: {},
  tokenImages: {}
}), M0 = {
  state: ol,
  subscribeNetworkImages(t) {
    return Xs(ol.networkImages, () => t(ol.networkImages));
  },
  subscribeKey(t, e) {
    return eo(ol, t, e);
  },
  setWalletImage(t, e) {
    ol.walletImages[t] = e;
  },
  setNetworkImage(t, e) {
    ol.networkImages[t] = e;
  },
  setConnectorImage(t, e) {
    ol.connectorImages[t] = e;
  },
  setTokenImage(t, e) {
    ol.tokenImages[t] = e;
  }
}, wu = Ri({
  connectors: []
}), or = {
  state: wu,
  subscribeKey(t, e) {
    return eo(wu, t, e);
  },
  setConnectors(t) {
    wu.connectors = t.map((e) => cM(e));
  },
  addConnector(t) {
    wu.connectors.push(cM(t));
  },
  getEmailConnector() {
    return wu.connectors.find((t) => t.type === "EMAIL");
  },
  getConnectors() {
    return wu.connectors;
  }
}, SN = Ri({
  open: !1,
  selectedNetworkId: void 0
}), ih = {
  state: SN,
  subscribe(t) {
    return Xs(SN, () => t(SN));
  },
  set(t) {
    Object.assign(SN, { ...SN, ...t });
  }
}, Xr = Ri({
  supportsAllNetworks: !0,
  isDefaultCaipNetwork: !1
}), er = {
  state: Xr,
  subscribeKey(t, e) {
    return eo(Xr, t, e);
  },
  _getClient() {
    if (!Xr._client)
      throw new Error("NetworkController client not set");
    return Xr._client;
  },
  setClient(t) {
    Xr._client = cM(t);
  },
  setCaipNetwork(t) {
    Xr.caipNetwork = t, ih.set({ selectedNetworkId: t == null ? void 0 : t.id });
  },
  setDefaultCaipNetwork(t) {
    Xr.caipNetwork = t, ih.set({ selectedNetworkId: t == null ? void 0 : t.id }), Xr.isDefaultCaipNetwork = !0;
  },
  setRequestedCaipNetworks(t) {
    Xr.requestedCaipNetworks = t;
  },
  async getApprovedCaipNetworksData() {
    const t = await this._getClient().getApprovedCaipNetworksData();
    Xr.supportsAllNetworks = t.supportsAllNetworks, Xr.approvedCaipNetworkIds = t.approvedCaipNetworkIds;
  },
  async switchActiveNetwork(t) {
    await this._getClient().switchCaipNetwork(t), Xr.caipNetwork = t;
  },
  resetNetwork() {
    Xr.isDefaultCaipNetwork || (Xr.caipNetwork = void 0), Xr.approvedCaipNetworkIds = void 0, Xr.supportsAllNetworks = !0;
  }
}, Li = Ri({
  projectId: "",
  sdkType: "w3m",
  sdkVersion: "html-wagmi-undefined"
}), dn = {
  state: Li,
  subscribeKey(t, e) {
    return eo(Li, t, e);
  },
  setProjectId(t) {
    Li.projectId = t;
  },
  setIncludeWalletIds(t) {
    Li.includeWalletIds = t;
  },
  setExcludeWalletIds(t) {
    Li.excludeWalletIds = t;
  },
  setFeaturedWalletIds(t) {
    Li.featuredWalletIds = t;
  },
  setTokens(t) {
    Li.tokens = t;
  },
  setTermsConditionsUrl(t) {
    Li.termsConditionsUrl = t;
  },
  setPrivacyPolicyUrl(t) {
    Li.privacyPolicyUrl = t;
  },
  setCustomWallets(t) {
    Li.customWallets = t;
  },
  setEnableAnalytics(t) {
    Li.enableAnalytics = t;
  },
  setSdkVersion(t) {
    Li.sdkVersion = t;
  },
  setMetadata(t) {
    Li.metadata = t;
  }
}, voe = st.getApiUrl(), so = new rS({ baseUrl: voe }), Ioe = "40", PD = "4", oi = Ri({
  page: 1,
  count: 0,
  featured: [],
  recommended: [],
  wallets: [],
  search: []
}), Gt = {
  state: oi,
  subscribeKey(t, e) {
    return eo(oi, t, e);
  },
  _getApiHeaders() {
    const { projectId: t, sdkType: e, sdkVersion: n } = dn.state;
    return {
      "x-project-id": t,
      "x-sdk-type": e,
      "x-sdk-version": n
    };
  },
  async _fetchWalletImage(t) {
    const e = `${so.baseUrl}/getWalletImage/${t}`, n = await so.getBlob({ path: e, headers: Gt._getApiHeaders() });
    M0.setWalletImage(t, URL.createObjectURL(n));
  },
  async _fetchNetworkImage(t) {
    const e = `${so.baseUrl}/public/getAssetImage/${t}`, n = await so.getBlob({ path: e, headers: Gt._getApiHeaders() });
    M0.setNetworkImage(t, URL.createObjectURL(n));
  },
  async _fetchConnectorImage(t) {
    const e = `${so.baseUrl}/public/getAssetImage/${t}`, n = await so.getBlob({ path: e, headers: Gt._getApiHeaders() });
    M0.setConnectorImage(t, URL.createObjectURL(n));
  },
  async fetchNetworkImages() {
    const { requestedCaipNetworks: t } = er.state, e = t == null ? void 0 : t.map(({ imageId: n }) => n).filter(Boolean);
    e && await Promise.allSettled(e.map((n) => Gt._fetchNetworkImage(n)));
  },
  async fetchConnectorImages() {
    const { connectors: t } = or.state, e = t.map(({ imageId: n }) => n).filter(Boolean);
    await Promise.allSettled(e.map((n) => Gt._fetchConnectorImage(n)));
  },
  async fetchFeaturedWallets() {
    const { featuredWalletIds: t } = dn.state;
    if (t != null && t.length) {
      const { data: e } = await so.get({
        path: "/getWallets",
        headers: Gt._getApiHeaders(),
        params: {
          page: "1",
          entries: t != null && t.length ? String(t.length) : PD,
          include: t == null ? void 0 : t.join(",")
        }
      });
      e.sort((r, i) => t.indexOf(r.id) - t.indexOf(i.id));
      const n = e.map((r) => r.image_id).filter(Boolean);
      await Promise.allSettled(n.map((r) => Gt._fetchWalletImage(r))), oi.featured = e;
    }
  },
  async fetchRecommendedWallets() {
    const { includeWalletIds: t, excludeWalletIds: e, featuredWalletIds: n } = dn.state, r = [...e ?? [], ...n ?? []].filter(Boolean), { data: i, count: a } = await so.get({
      path: "/getWallets",
      headers: Gt._getApiHeaders(),
      params: {
        page: "1",
        entries: PD,
        include: t == null ? void 0 : t.join(","),
        exclude: r == null ? void 0 : r.join(",")
      }
    }), o = Si.getRecentWallets(), s = i.map((c) => c.image_id).filter(Boolean), l = o.map((c) => c.image_id).filter(Boolean);
    await Promise.allSettled([...s, ...l].map((c) => Gt._fetchWalletImage(c))), oi.recommended = i, oi.count = a ?? 0;
  },
  async fetchWallets({ page: t }) {
    const { includeWalletIds: e, excludeWalletIds: n, featuredWalletIds: r } = dn.state, i = [
      ...oi.recommended.map(({ id: l }) => l),
      ...n ?? [],
      ...r ?? []
    ].filter(Boolean), { data: a, count: o } = await so.get({
      path: "/getWallets",
      headers: Gt._getApiHeaders(),
      params: {
        page: String(t),
        entries: Ioe,
        include: e == null ? void 0 : e.join(","),
        exclude: i.join(",")
      }
    }), s = a.map((l) => l.image_id).filter(Boolean);
    await Promise.allSettled([
      ...s.map((l) => Gt._fetchWalletImage(l)),
      st.wait(300)
    ]), oi.wallets = [...oi.wallets, ...a], oi.count = o > oi.count ? o : oi.count, oi.page = t;
  },
  async searchWallet({ search: t }) {
    const { includeWalletIds: e, excludeWalletIds: n } = dn.state;
    oi.search = [];
    const { data: r } = await so.get({
      path: "/getWallets",
      headers: Gt._getApiHeaders(),
      params: {
        page: "1",
        entries: "100",
        search: t,
        include: e == null ? void 0 : e.join(","),
        exclude: n == null ? void 0 : n.join(",")
      }
    }), i = r.map((a) => a.image_id).filter(Boolean);
    await Promise.allSettled([
      ...i.map((a) => Gt._fetchWalletImage(a)),
      st.wait(300)
    ]), oi.search = r;
  },
  prefetch() {
    oi.prefetchPromise = Promise.race([
      Promise.allSettled([
        Gt.fetchFeaturedWallets(),
        Gt.fetchRecommendedWallets(),
        Gt.fetchNetworkImages(),
        Gt.fetchConnectorImages()
      ]),
      st.wait(3e3)
    ]);
  }
}, Ooe = st.getAnalyticsUrl(), Yoe = new rS({ baseUrl: Ooe }), Qoe = ["MODAL_CREATED"], Fu = Ri({
  timestamp: Date.now(),
  data: {
    type: "track",
    event: "MODAL_CREATED"
  }
}), _t = {
  state: Fu,
  subscribe(t) {
    return Xs(Fu, () => t(Fu));
  },
  _getApiHeaders() {
    const { projectId: t, sdkType: e, sdkVersion: n } = dn.state;
    return {
      "x-project-id": t,
      "x-sdk-type": e,
      "x-sdk-version": n
    };
  },
  async _sendAnalyticsEvent(t) {
    try {
      if (Qoe.includes(t.data.event) || typeof window > "u")
        return;
      await Yoe.post({
        path: "/e",
        headers: _t._getApiHeaders(),
        body: {
          eventId: st.getUUID(),
          url: window.location.href,
          domain: window.location.hostname,
          timestamp: t.timestamp,
          props: t.data
        }
      });
    } catch {
    }
  },
  sendEvent(t) {
    Fu.timestamp = Date.now(), Fu.data = t, dn.state.enableAnalytics && _t._sendAnalyticsEvent(Fu);
  }
}, Er = Ri({
  view: "Connect",
  history: ["Connect"]
}), tt = {
  state: Er,
  subscribeKey(t, e) {
    return eo(Er, t, e);
  },
  push(t, e) {
    t !== Er.view && (Er.view = t, Er.history.push(t), Er.data = e);
  },
  reset(t) {
    Er.view = t, Er.history = [t];
  },
  replace(t, e) {
    Er.history.length > 1 && Er.history.at(-1) !== t && (Er.view = t, Er.history[Er.history.length - 1] = t, Er.data = e);
  },
  goBack() {
    if (Er.history.length > 1) {
      Er.history.pop();
      const [t] = Er.history.slice(-1);
      t && (Er.view = t);
    }
  }
}, Ac = Ri({
  loading: !1,
  open: !1
}), bn = {
  state: Ac,
  subscribe(t) {
    return Xs(Ac, () => t(Ac));
  },
  subscribeKey(t, e) {
    return eo(Ac, t, e);
  },
  async open(t) {
    await Gt.state.prefetchPromise, t != null && t.view ? tt.reset(t.view) : en.state.isConnected ? tt.reset("Account") : tt.reset("Connect"), Ac.open = !0, ih.set({ open: !0 }), _t.sendEvent({ type: "track", event: "MODAL_OPEN" });
  },
  close() {
    Ac.open = !1, ih.set({ open: !1 }), _t.sendEvent({ type: "track", event: "MODAL_CLOSE" });
  },
  setLoading(t) {
    Ac.loading = t;
  }
}, Goe = st.getBlockchainApiUrl(), KD = new rS({ baseUrl: Goe }), AY = {
  fetchIdentity({ caipChainId: t, address: e }) {
    return KD.get({
      path: `/v1/identity/${e}`,
      params: {
        chainId: t,
        projectId: dn.state.projectId
      }
    });
  },
  fetchTransactions({ account: t, projectId: e, cursor: n }) {
    const r = n ? { cursor: n } : {};
    return KD.get({
      path: `/v1/account/${t}/history?projectId=${e}`,
      params: r
    });
  }
}, es = Ri({
  message: "",
  variant: "success",
  open: !1
}), Vr = {
  state: es,
  subscribeKey(t, e) {
    return eo(es, t, e);
  },
  showSuccess(t) {
    es.message = t, es.variant = "success", es.open = !0;
  },
  showError(t) {
    const e = st.parseError(t);
    es.message = e, es.variant = "error", es.open = !0;
  },
  hide() {
    es.open = !1;
  }
}, dr = Ri({
  transactions: [],
  transactionsByYear: {},
  loading: !1,
  empty: !1,
  next: void 0
}), Oa = {
  state: dr,
  subscribe(t) {
    return Xs(dr, () => t(dr));
  },
  async fetchTransactions(t) {
    const { projectId: e } = dn.state;
    if (!e || !t)
      throw new Error("Transactions can't be fetched without a projectId and an accountAddress");
    dr.loading = !0;
    try {
      const n = await AY.fetchTransactions({
        account: t,
        projectId: e,
        cursor: dr.next
      }), r = this.filterSpamTransactions(n.data), i = [...dr.transactions, ...r];
      dr.loading = !1, dr.transactions = i, dr.transactionsByYear = this.groupTransactionsByYear(dr.transactionsByYear, r), dr.empty = i.length === 0, dr.next = n.next ? n.next : void 0;
    } catch {
      _t.sendEvent({
        type: "track",
        event: "ERROR_FETCH_TRANSACTIONS",
        properties: {
          address: t,
          projectId: e,
          cursor: dr.next
        }
      }), Vr.showError("Failed to fetch transactions"), dr.loading = !1, dr.empty = !0;
    }
  },
  groupTransactionsByYear(t = {}, e = []) {
    const n = t;
    return e.forEach((r) => {
      var a;
      const i = new Date(r.metadata.minedAt).getFullYear();
      n[i] || (n[i] = []), (a = n[i]) == null || a.push(r);
    }), n;
  },
  filterSpamTransactions(t) {
    return t.filter((e) => !e.transfers.every((r) => {
      var i;
      return ((i = r.nft_info) == null ? void 0 : i.flags.is_spam) === !0;
    }));
  },
  resetTransactions() {
    dr.transactions = [], dr.transactionsByYear = {}, dr.loading = !1, dr.empty = !1, dr.next = void 0;
  }
}, Sr = Ri({
  wcError: !1,
  buffering: !1
}), Ht = {
  state: Sr,
  subscribeKey(t, e) {
    return eo(Sr, t, e);
  },
  _getClient() {
    if (!Sr._client)
      throw new Error("ConnectionController client not set");
    return Sr._client;
  },
  setClient(t) {
    Sr._client = cM(t);
  },
  connectWalletConnect() {
    Sr.wcPromise = this._getClient().connectWalletConnect((t) => {
      Sr.wcUri = t, Sr.wcPairingExpiry = st.getPairingExpiry();
    });
  },
  async connectExternal(t) {
    var e, n;
    await ((n = (e = this._getClient()).connectExternal) == null ? void 0 : n.call(e, t)), Si.setConnectedConnector(t.type);
  },
  async signMessage(t) {
    return this._getClient().signMessage(t);
  },
  checkInstalled(t) {
    var e, n;
    return (n = (e = this._getClient()).checkInstalled) == null ? void 0 : n.call(e, t);
  },
  resetWcConnection() {
    Sr.wcUri = void 0, Sr.wcPairingExpiry = void 0, Sr.wcPromise = void 0, Sr.wcLinking = void 0, Sr.recentWallet = void 0, Oa.resetTransactions(), Si.deleteWalletConnectDeepLink();
  },
  setWcLinking(t) {
    Sr.wcLinking = t;
  },
  setWcError(t) {
    Sr.wcError = t, Sr.buffering = !1;
  },
  setRecentWallet(t) {
    Sr.recentWallet = t;
  },
  setBuffering(t) {
    Sr.buffering = t;
  },
  async disconnect() {
    await this._getClient().disconnect(), this.resetWcConnection();
  }
}, Ji = Ri({
  status: "uninitialized",
  isSiweEnabled: !1
}), ir = {
  state: Ji,
  subscribeKey(t, e) {
    return eo(Ji, t, e);
  },
  subscribe(t) {
    return Xs(Ji, () => t(Ji));
  },
  _getClient() {
    if (!Ji._client)
      throw new Error("SIWEController client not set");
    return Ji._client;
  },
  async getNonce() {
    const e = await this._getClient().getNonce();
    return this.setNonce(e), e;
  },
  async getSession() {
    const e = await this._getClient().getSession();
    return e && (this.setSession(e), this.setStatus("success")), e;
  },
  createMessage(t) {
    const n = this._getClient().createMessage(t);
    return this.setMessage(n), n;
  },
  async verifyMessage(t) {
    return await this._getClient().verifyMessage(t);
  },
  async signIn() {
    return await this._getClient().signIn();
  },
  async signOut() {
    var e;
    const t = this._getClient();
    await t.signOut(), this.setStatus("ready"), (e = t.onSignOut) == null || e.call(t);
  },
  onSignIn(t) {
    var n;
    const e = this._getClient();
    (n = e.onSignIn) == null || n.call(e, t);
  },
  onSignOut() {
    var e;
    const t = this._getClient();
    (e = t.onSignOut) == null || e.call(t);
  },
  setSIWEClient(t) {
    Ji._client = cM(t), Ji.status = "ready", Ji.isSiweEnabled = t.options.enabled;
  },
  setNonce(t) {
    Ji.nonce = t;
  },
  setStatus(t) {
    Ji.status = t;
  },
  setMessage(t) {
    Ji.message = t;
  },
  setSession(t) {
    Ji.session = t;
  }
}, vu = Ri({
  themeMode: "dark",
  themeVariables: {}
}), pa = {
  state: vu,
  subscribe(t) {
    return Xs(vu, () => t(vu));
  },
  setThemeMode(t) {
    vu.themeMode = t;
  },
  setThemeVariables(t) {
    vu.themeVariables = { ...vu.themeVariables, ...t };
  }
}, qn = {
  getWalletImage(t) {
    if (t != null && t.image_url)
      return t == null ? void 0 : t.image_url;
    if (t != null && t.image_id)
      return M0.state.walletImages[t.image_id];
  },
  getNetworkImage(t) {
    if (t != null && t.imageUrl)
      return t == null ? void 0 : t.imageUrl;
    if (t != null && t.imageId)
      return M0.state.networkImages[t.imageId];
  },
  getConnectorImage(t) {
    if (t != null && t.imageUrl)
      return t.imageUrl;
    if (t != null && t.imageId)
      return M0.state.connectorImages[t.imageId];
  }
}, HY = {
  goBackOrCloseModal() {
    tt.state.history.length > 1 ? tt.goBack() : bn.close();
  },
  navigateAfterNetworkSwitch() {
    const { history: t } = tt.state, e = t.findIndex((r) => r === "Networks"), n = t[e - 1];
    n ? tt.replace(n) : bn.close();
  }
};
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const HT = globalThis, iS = HT.ShadowRoot && (HT.ShadyCSS === void 0 || HT.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, aS = Symbol(), $D = /* @__PURE__ */ new WeakMap();
let XY = class {
  constructor(e, n, r) {
    if (this._$cssResult$ = !0, r !== aS)
      throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = e, this.t = n;
  }
  get styleSheet() {
    let e = this.o;
    const n = this.t;
    if (iS && e === void 0) {
      const r = n !== void 0 && n.length === 1;
      r && (e = $D.get(n)), e === void 0 && ((this.o = e = new CSSStyleSheet()).replaceSync(this.cssText), r && $D.set(n, e));
    }
    return e;
  }
  toString() {
    return this.cssText;
  }
};
const uo = (t) => new XY(typeof t == "string" ? t : t + "", void 0, aS), ze = (t, ...e) => {
  const n = t.length === 1 ? t[0] : e.reduce((r, i, a) => r + ((o) => {
    if (o._$cssResult$ === !0)
      return o.cssText;
    if (typeof o == "number")
      return o;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + o + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(i) + t[a + 1], t[0]);
  return new XY(n, t, aS);
}, Coe = (t, e) => {
  if (iS)
    t.adoptedStyleSheets = e.map((n) => n instanceof CSSStyleSheet ? n : n.styleSheet);
  else
    for (const n of e) {
      const r = document.createElement("style"), i = HT.litNonce;
      i !== void 0 && r.setAttribute("nonce", i), r.textContent = n.cssText, t.appendChild(r);
    }
}, qD = iS ? (t) => t : (t) => t instanceof CSSStyleSheet ? ((e) => {
  let n = "";
  for (const r of e.cssRules)
    n += r.cssText;
  return uo(n);
})(t) : t;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { is: Loe, defineProperty: Joe, getOwnPropertyDescriptor: Boe, getOwnPropertyNames: Aoe, getOwnPropertySymbols: Hoe, getPrototypeOf: Xoe } = Object, Ql = globalThis, e4 = Ql.trustedTypes, _oe = e4 ? e4.emptyScript : "", Mg = Ql.reactiveElementPolyfillSupport, i1 = (t, e) => t, rV = { toAttribute(t, e) {
  switch (e) {
    case Boolean:
      t = t ? _oe : null;
      break;
    case Object:
    case Array:
      t = t == null ? t : JSON.stringify(t);
  }
  return t;
}, fromAttribute(t, e) {
  let n = t;
  switch (e) {
    case Boolean:
      n = t !== null;
      break;
    case Number:
      n = t === null ? null : Number(t);
      break;
    case Object:
    case Array:
      try {
        n = JSON.parse(t);
      } catch {
        n = null;
      }
  }
  return n;
} }, oS = (t, e) => !Loe(t, e), t4 = { attribute: !0, type: String, converter: rV, reflect: !1, hasChanged: oS };
Symbol.metadata ?? (Symbol.metadata = Symbol("metadata")), Ql.litPropertyMetadata ?? (Ql.litPropertyMetadata = /* @__PURE__ */ new WeakMap());
let Au = class extends HTMLElement {
  static addInitializer(e) {
    this._$Ei(), (this.l ?? (this.l = [])).push(e);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(e, n = t4) {
    if (n.state && (n.attribute = !1), this._$Ei(), this.elementProperties.set(e, n), !n.noAccessor) {
      const r = Symbol(), i = this.getPropertyDescriptor(e, r, n);
      i !== void 0 && Joe(this.prototype, e, i);
    }
  }
  static getPropertyDescriptor(e, n, r) {
    const { get: i, set: a } = Boe(this.prototype, e) ?? { get() {
      return this[n];
    }, set(o) {
      this[n] = o;
    } };
    return { get() {
      return i == null ? void 0 : i.call(this);
    }, set(o) {
      const s = i == null ? void 0 : i.call(this);
      a.call(this, o), this.requestUpdate(e, s, r);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(e) {
    return this.elementProperties.get(e) ?? t4;
  }
  static _$Ei() {
    if (this.hasOwnProperty(i1("elementProperties")))
      return;
    const e = Xoe(this);
    e.finalize(), e.l !== void 0 && (this.l = [...e.l]), this.elementProperties = new Map(e.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(i1("finalized")))
      return;
    if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(i1("properties"))) {
      const n = this.properties, r = [...Aoe(n), ...Hoe(n)];
      for (const i of r)
        this.createProperty(i, n[i]);
    }
    const e = this[Symbol.metadata];
    if (e !== null) {
      const n = litPropertyMetadata.get(e);
      if (n !== void 0)
        for (const [r, i] of n)
          this.elementProperties.set(r, i);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [n, r] of this.elementProperties) {
      const i = this._$Eu(n, r);
      i !== void 0 && this._$Eh.set(i, n);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(e) {
    const n = [];
    if (Array.isArray(e)) {
      const r = new Set(e.flat(1 / 0).reverse());
      for (const i of r)
        n.unshift(qD(i));
    } else
      e !== void 0 && n.push(qD(e));
    return n;
  }
  static _$Eu(e, n) {
    const r = n.attribute;
    return r === !1 ? void 0 : typeof r == "string" ? r : typeof e == "string" ? e.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    var e;
    this._$Eg = new Promise((n) => this.enableUpdating = n), this._$AL = /* @__PURE__ */ new Map(), this._$ES(), this.requestUpdate(), (e = this.constructor.l) == null || e.forEach((n) => n(this));
  }
  addController(e) {
    var n;
    (this._$E_ ?? (this._$E_ = /* @__PURE__ */ new Set())).add(e), this.renderRoot !== void 0 && this.isConnected && ((n = e.hostConnected) == null || n.call(e));
  }
  removeController(e) {
    var n;
    (n = this._$E_) == null || n.delete(e);
  }
  _$ES() {
    const e = /* @__PURE__ */ new Map(), n = this.constructor.elementProperties;
    for (const r of n.keys())
      this.hasOwnProperty(r) && (e.set(r, this[r]), delete this[r]);
    e.size > 0 && (this._$Ep = e);
  }
  createRenderRoot() {
    const e = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
    return Coe(e, this.constructor.elementStyles), e;
  }
  connectedCallback() {
    var e;
    this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), (e = this._$E_) == null || e.forEach((n) => {
      var r;
      return (r = n.hostConnected) == null ? void 0 : r.call(n);
    });
  }
  enableUpdating(e) {
  }
  disconnectedCallback() {
    var e;
    (e = this._$E_) == null || e.forEach((n) => {
      var r;
      return (r = n.hostDisconnected) == null ? void 0 : r.call(n);
    });
  }
  attributeChangedCallback(e, n, r) {
    this._$AK(e, r);
  }
  _$EO(e, n) {
    var a;
    const r = this.constructor.elementProperties.get(e), i = this.constructor._$Eu(e, r);
    if (i !== void 0 && r.reflect === !0) {
      const o = (((a = r.converter) == null ? void 0 : a.toAttribute) !== void 0 ? r.converter : rV).toAttribute(n, r.type);
      this._$Em = e, o == null ? this.removeAttribute(i) : this.setAttribute(i, o), this._$Em = null;
    }
  }
  _$AK(e, n) {
    var a;
    const r = this.constructor, i = r._$Eh.get(e);
    if (i !== void 0 && this._$Em !== i) {
      const o = r.getPropertyOptions(i), s = typeof o.converter == "function" ? { fromAttribute: o.converter } : ((a = o.converter) == null ? void 0 : a.fromAttribute) !== void 0 ? o.converter : rV;
      this._$Em = i, this[i] = s.fromAttribute(n, o.type), this._$Em = null;
    }
  }
  requestUpdate(e, n, r, i = !1, a) {
    if (e !== void 0) {
      if (r ?? (r = this.constructor.getPropertyOptions(e)), !(r.hasChanged ?? oS)(i ? a : this[e], n))
        return;
      this.C(e, n, r);
    }
    this.isUpdatePending === !1 && (this._$Eg = this._$EP());
  }
  C(e, n, r) {
    this._$AL.has(e) || this._$AL.set(e, n), r.reflect === !0 && this._$Em !== e && (this._$Ej ?? (this._$Ej = /* @__PURE__ */ new Set())).add(e);
  }
  async _$EP() {
    this.isUpdatePending = !0;
    try {
      await this._$Eg;
    } catch (n) {
      Promise.reject(n);
    }
    const e = this.scheduleUpdate();
    return e != null && await e, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var r;
    if (!this.isUpdatePending)
      return;
    if (!this.hasUpdated) {
      if (this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this._$Ep) {
        for (const [a, o] of this._$Ep)
          this[a] = o;
        this._$Ep = void 0;
      }
      const i = this.constructor.elementProperties;
      if (i.size > 0)
        for (const [a, o] of i)
          o.wrapped !== !0 || this._$AL.has(a) || this[a] === void 0 || this.C(a, this[a], o);
    }
    let e = !1;
    const n = this._$AL;
    try {
      e = this.shouldUpdate(n), e ? (this.willUpdate(n), (r = this._$E_) == null || r.forEach((i) => {
        var a;
        return (a = i.hostUpdate) == null ? void 0 : a.call(i);
      }), this.update(n)) : this._$ET();
    } catch (i) {
      throw e = !1, this._$ET(), i;
    }
    e && this._$AE(n);
  }
  willUpdate(e) {
  }
  _$AE(e) {
    var n;
    (n = this._$E_) == null || n.forEach((r) => {
      var i;
      return (i = r.hostUpdated) == null ? void 0 : i.call(r);
    }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(e)), this.updated(e);
  }
  _$ET() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$Eg;
  }
  shouldUpdate(e) {
    return !0;
  }
  update(e) {
    this._$Ej && (this._$Ej = this._$Ej.forEach((n) => this._$EO(n, this[n]))), this._$ET();
  }
  updated(e) {
  }
  firstUpdated(e) {
  }
};
Au.elementStyles = [], Au.shadowRootOptions = { mode: "open" }, Au[i1("elementProperties")] = /* @__PURE__ */ new Map(), Au[i1("finalized")] = /* @__PURE__ */ new Map(), Mg == null || Mg({ ReactiveElement: Au }), (Ql.reactiveElementVersions ?? (Ql.reactiveElementVersions = [])).push("2.0.2");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const a1 = globalThis, iV = a1.trustedTypes, n4 = iV ? iV.createPolicy("lit-html", { createHTML: (t) => t }) : void 0, _Y = "$lit$", gl = `lit$${(Math.random() + "").slice(9)}$`, PY = "?" + gl, Poe = `<${PY}>`, Id = document, dM = () => Id.createComment(""), uM = (t) => t === null || typeof t != "object" && typeof t != "function", KY = Array.isArray, Koe = (t) => KY(t) || typeof (t == null ? void 0 : t[Symbol.iterator]) == "function", pg = `[ 	
\f\r]`, xN = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, r4 = /-->/g, i4 = />/g, Hc = RegExp(`>|${pg}(?:([^\\s"'>=/]+)(${pg}*=${pg}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), a4 = /'/g, o4 = /"/g, $Y = /^(?:script|style|textarea|title)$/i, qY = (t) => (e, ...n) => ({ _$litType$: t, strings: e, values: n }), _ = qY(1), ke = qY(2), Od = Symbol.for("lit-noChange"), ar = Symbol.for("lit-nothing"), s4 = /* @__PURE__ */ new WeakMap(), sd = Id.createTreeWalker(Id, 129);
function eQ(t, e) {
  if (!Array.isArray(t) || !t.hasOwnProperty("raw"))
    throw Error("invalid template strings array");
  return n4 !== void 0 ? n4.createHTML(e) : e;
}
const $oe = (t, e) => {
  const n = t.length - 1, r = [];
  let i, a = e === 2 ? "<svg>" : "", o = xN;
  for (let s = 0; s < n; s++) {
    const l = t[s];
    let c, d, u = -1, h = 0;
    for (; h < l.length && (o.lastIndex = h, d = o.exec(l), d !== null); )
      h = o.lastIndex, o === xN ? d[1] === "!--" ? o = r4 : d[1] !== void 0 ? o = i4 : d[2] !== void 0 ? ($Y.test(d[2]) && (i = RegExp("</" + d[2], "g")), o = Hc) : d[3] !== void 0 && (o = Hc) : o === Hc ? d[0] === ">" ? (o = i ?? xN, u = -1) : d[1] === void 0 ? u = -2 : (u = o.lastIndex - d[2].length, c = d[1], o = d[3] === void 0 ? Hc : d[3] === '"' ? o4 : a4) : o === o4 || o === a4 ? o = Hc : o === r4 || o === i4 ? o = xN : (o = Hc, i = void 0);
    const N = o === Hc && t[s + 1].startsWith("/>") ? " " : "";
    a += o === xN ? l + Poe : u >= 0 ? (r.push(c), l.slice(0, u) + _Y + l.slice(u) + gl + N) : l + gl + (u === -2 ? s : N);
  }
  return [eQ(t, a + (t[n] || "<?>") + (e === 2 ? "</svg>" : "")), r];
};
class hM {
  constructor({ strings: e, _$litType$: n }, r) {
    let i;
    this.parts = [];
    let a = 0, o = 0;
    const s = e.length - 1, l = this.parts, [c, d] = $oe(e, n);
    if (this.el = hM.createElement(c, r), sd.currentNode = this.el.content, n === 2) {
      const u = this.el.content.firstChild;
      u.replaceWith(...u.childNodes);
    }
    for (; (i = sd.nextNode()) !== null && l.length < s; ) {
      if (i.nodeType === 1) {
        if (i.hasAttributes())
          for (const u of i.getAttributeNames())
            if (u.endsWith(_Y)) {
              const h = d[o++], N = i.getAttribute(u).split(gl), M = /([.?@])?(.*)/.exec(h);
              l.push({ type: 1, index: a, name: M[2], strings: N, ctor: M[1] === "." ? ese : M[1] === "?" ? tse : M[1] === "@" ? nse : dU }), i.removeAttribute(u);
            } else
              u.startsWith(gl) && (l.push({ type: 6, index: a }), i.removeAttribute(u));
        if ($Y.test(i.tagName)) {
          const u = i.textContent.split(gl), h = u.length - 1;
          if (h > 0) {
            i.textContent = iV ? iV.emptyScript : "";
            for (let N = 0; N < h; N++)
              i.append(u[N], dM()), sd.nextNode(), l.push({ type: 2, index: ++a });
            i.append(u[h], dM());
          }
        }
      } else if (i.nodeType === 8)
        if (i.data === PY)
          l.push({ type: 2, index: a });
        else {
          let u = -1;
          for (; (u = i.data.indexOf(gl, u + 1)) !== -1; )
            l.push({ type: 7, index: a }), u += gl.length - 1;
        }
      a++;
    }
  }
  static createElement(e, n) {
    const r = Id.createElement("template");
    return r.innerHTML = e, r;
  }
}
function ah(t, e, n = t, r) {
  var o, s;
  if (e === Od)
    return e;
  let i = r !== void 0 ? (o = n._$Co) == null ? void 0 : o[r] : n._$Cl;
  const a = uM(e) ? void 0 : e._$litDirective$;
  return (i == null ? void 0 : i.constructor) !== a && ((s = i == null ? void 0 : i._$AO) == null || s.call(i, !1), a === void 0 ? i = void 0 : (i = new a(t), i._$AT(t, n, r)), r !== void 0 ? (n._$Co ?? (n._$Co = []))[r] = i : n._$Cl = i), i !== void 0 && (e = ah(t, i._$AS(t, e.values), i, r)), e;
}
class qoe {
  constructor(e, n) {
    this._$AV = [], this._$AN = void 0, this._$AD = e, this._$AM = n;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(e) {
    const { el: { content: n }, parts: r } = this._$AD, i = ((e == null ? void 0 : e.creationScope) ?? Id).importNode(n, !0);
    sd.currentNode = i;
    let a = sd.nextNode(), o = 0, s = 0, l = r[0];
    for (; l !== void 0; ) {
      if (o === l.index) {
        let c;
        l.type === 2 ? c = new Kp(a, a.nextSibling, this, e) : l.type === 1 ? c = new l.ctor(a, l.name, l.strings, this, e) : l.type === 6 && (c = new rse(a, this, e)), this._$AV.push(c), l = r[++s];
      }
      o !== (l == null ? void 0 : l.index) && (a = sd.nextNode(), o++);
    }
    return sd.currentNode = Id, i;
  }
  p(e) {
    let n = 0;
    for (const r of this._$AV)
      r !== void 0 && (r.strings !== void 0 ? (r._$AI(e, r, n), n += r.strings.length - 2) : r._$AI(e[n])), n++;
  }
}
class Kp {
  get _$AU() {
    var e;
    return ((e = this._$AM) == null ? void 0 : e._$AU) ?? this._$Cv;
  }
  constructor(e, n, r, i) {
    this.type = 2, this._$AH = ar, this._$AN = void 0, this._$AA = e, this._$AB = n, this._$AM = r, this.options = i, this._$Cv = (i == null ? void 0 : i.isConnected) ?? !0;
  }
  get parentNode() {
    let e = this._$AA.parentNode;
    const n = this._$AM;
    return n !== void 0 && (e == null ? void 0 : e.nodeType) === 11 && (e = n.parentNode), e;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(e, n = this) {
    e = ah(this, e, n), uM(e) ? e === ar || e == null || e === "" ? (this._$AH !== ar && this._$AR(), this._$AH = ar) : e !== this._$AH && e !== Od && this._(e) : e._$litType$ !== void 0 ? this.g(e) : e.nodeType !== void 0 ? this.$(e) : Koe(e) ? this.T(e) : this._(e);
  }
  k(e) {
    return this._$AA.parentNode.insertBefore(e, this._$AB);
  }
  $(e) {
    this._$AH !== e && (this._$AR(), this._$AH = this.k(e));
  }
  _(e) {
    this._$AH !== ar && uM(this._$AH) ? this._$AA.nextSibling.data = e : this.$(Id.createTextNode(e)), this._$AH = e;
  }
  g(e) {
    var a;
    const { values: n, _$litType$: r } = e, i = typeof r == "number" ? this._$AC(e) : (r.el === void 0 && (r.el = hM.createElement(eQ(r.h, r.h[0]), this.options)), r);
    if (((a = this._$AH) == null ? void 0 : a._$AD) === i)
      this._$AH.p(n);
    else {
      const o = new qoe(i, this), s = o.u(this.options);
      o.p(n), this.$(s), this._$AH = o;
    }
  }
  _$AC(e) {
    let n = s4.get(e.strings);
    return n === void 0 && s4.set(e.strings, n = new hM(e)), n;
  }
  T(e) {
    KY(this._$AH) || (this._$AH = [], this._$AR());
    const n = this._$AH;
    let r, i = 0;
    for (const a of e)
      i === n.length ? n.push(r = new Kp(this.k(dM()), this.k(dM()), this, this.options)) : r = n[i], r._$AI(a), i++;
    i < n.length && (this._$AR(r && r._$AB.nextSibling, i), n.length = i);
  }
  _$AR(e = this._$AA.nextSibling, n) {
    var r;
    for ((r = this._$AP) == null ? void 0 : r.call(this, !1, !0, n); e && e !== this._$AB; ) {
      const i = e.nextSibling;
      e.remove(), e = i;
    }
  }
  setConnected(e) {
    var n;
    this._$AM === void 0 && (this._$Cv = e, (n = this._$AP) == null || n.call(this, e));
  }
}
class dU {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(e, n, r, i, a) {
    this.type = 1, this._$AH = ar, this._$AN = void 0, this.element = e, this.name = n, this._$AM = i, this.options = a, r.length > 2 || r[0] !== "" || r[1] !== "" ? (this._$AH = Array(r.length - 1).fill(new String()), this.strings = r) : this._$AH = ar;
  }
  _$AI(e, n = this, r, i) {
    const a = this.strings;
    let o = !1;
    if (a === void 0)
      e = ah(this, e, n, 0), o = !uM(e) || e !== this._$AH && e !== Od, o && (this._$AH = e);
    else {
      const s = e;
      let l, c;
      for (e = a[0], l = 0; l < a.length - 1; l++)
        c = ah(this, s[r + l], n, l), c === Od && (c = this._$AH[l]), o || (o = !uM(c) || c !== this._$AH[l]), c === ar ? e = ar : e !== ar && (e += (c ?? "") + a[l + 1]), this._$AH[l] = c;
    }
    o && !i && this.O(e);
  }
  O(e) {
    e === ar ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, e ?? "");
  }
}
class ese extends dU {
  constructor() {
    super(...arguments), this.type = 3;
  }
  O(e) {
    this.element[this.name] = e === ar ? void 0 : e;
  }
}
class tse extends dU {
  constructor() {
    super(...arguments), this.type = 4;
  }
  O(e) {
    this.element.toggleAttribute(this.name, !!e && e !== ar);
  }
}
class nse extends dU {
  constructor(e, n, r, i, a) {
    super(e, n, r, i, a), this.type = 5;
  }
  _$AI(e, n = this) {
    if ((e = ah(this, e, n, 0) ?? ar) === Od)
      return;
    const r = this._$AH, i = e === ar && r !== ar || e.capture !== r.capture || e.once !== r.once || e.passive !== r.passive, a = e !== ar && (r === ar || i);
    i && this.element.removeEventListener(this.name, this, r), a && this.element.addEventListener(this.name, this, e), this._$AH = e;
  }
  handleEvent(e) {
    var n;
    typeof this._$AH == "function" ? this._$AH.call(((n = this.options) == null ? void 0 : n.host) ?? this.element, e) : this._$AH.handleEvent(e);
  }
}
class rse {
  constructor(e, n, r) {
    this.element = e, this.type = 6, this._$AN = void 0, this._$AM = n, this.options = r;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(e) {
    ah(this, e);
  }
}
const mg = a1.litHtmlPolyfillSupport;
mg == null || mg(hM, Kp), (a1.litHtmlVersions ?? (a1.litHtmlVersions = [])).push("3.1.0");
const ise = (t, e, n) => {
  const r = (n == null ? void 0 : n.renderBefore) ?? e;
  let i = r._$litPart$;
  if (i === void 0) {
    const a = (n == null ? void 0 : n.renderBefore) ?? null;
    r._$litPart$ = i = new Kp(e.insertBefore(dM(), a), a, void 0, n ?? {});
  }
  return i._$AI(t), i;
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let be = class extends Au {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    var n;
    const e = super.createRenderRoot();
    return (n = this.renderOptions).renderBefore ?? (n.renderBefore = e.firstChild), e;
  }
  update(e) {
    const n = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(e), this._$Do = ise(n, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var e;
    super.connectedCallback(), (e = this._$Do) == null || e.setConnected(!0);
  }
  disconnectedCallback() {
    var e;
    super.disconnectedCallback(), (e = this._$Do) == null || e.setConnected(!1);
  }
  render() {
    return Od;
  }
};
var uw;
be._$litElement$ = !0, be.finalized = !0, (uw = globalThis.litElementHydrateSupport) == null || uw.call(globalThis, { LitElement: be });
const Tg = globalThis.litElementPolyfillSupport;
Tg == null || Tg({ LitElement: be });
(globalThis.litElementVersions ?? (globalThis.litElementVersions = [])).push("4.0.2");
let o1, Gl, Cl;
function ase(t, e) {
  o1 = document.createElement("style"), Gl = document.createElement("style"), Cl = document.createElement("style"), o1.textContent = p0(t).core.cssText, Gl.textContent = p0(t).dark.cssText, Cl.textContent = p0(t).light.cssText, document.head.appendChild(o1), document.head.appendChild(Gl), document.head.appendChild(Cl), tQ(e);
}
function tQ(t) {
  Gl && Cl && (t === "light" ? (Gl.removeAttribute("media"), Cl.media = "enabled") : (Cl.removeAttribute("media"), Gl.media = "enabled"));
}
function ose(t) {
  o1 && Gl && Cl && (o1.textContent = p0(t).core.cssText, Gl.textContent = p0(t).dark.cssText, Cl.textContent = p0(t).light.cssText);
}
function p0(t) {
  return {
    core: ze`
      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
      :root {
        --w3m-color-mix-strength: ${uo(t != null && t["--w3m-color-mix-strength"] ? `${t["--w3m-color-mix-strength"]}%` : "0%")};
        --w3m-font-family: ${uo((t == null ? void 0 : t["--w3m-font-family"]) || "Inter, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;")};
        --w3m-font-size-master: ${uo((t == null ? void 0 : t["--w3m-font-size-master"]) || "10px")};
        --w3m-border-radius-master: ${uo((t == null ? void 0 : t["--w3m-border-radius-master"]) || "4px")};
        --w3m-z-index: ${uo((t == null ? void 0 : t["--w3m-z-index"]) || 100)};

        --wui-font-family: var(--w3m-font-family);

        --wui-font-size-micro: var(--w3m-font-size-master);
        --wui-font-size-tiny: calc(var(--w3m-font-size-master) * 1.2);
        --wui-font-size-small: calc(var(--w3m-font-size-master) * 1.4);
        --wui-font-size-paragraph: calc(var(--w3m-font-size-master) * 1.6);
        --wui-font-size-large: calc(var(--w3m-font-size-master) * 2);

        --wui-border-radius-5xs: var(--w3m-border-radius-master);
        --wui-border-radius-4xs: calc(var(--w3m-border-radius-master) * 1.5);
        --wui-border-radius-3xs: calc(var(--w3m-border-radius-master) * 2);
        --wui-border-radius-xxs: calc(var(--w3m-border-radius-master) * 3);
        --wui-border-radius-xs: calc(var(--w3m-border-radius-master) * 4);
        --wui-border-radius-s: calc(var(--w3m-border-radius-master) * 5);
        --wui-border-radius-m: calc(var(--w3m-border-radius-master) * 7);
        --wui-border-radius-l: calc(var(--w3m-border-radius-master) * 9);
        --wui-border-radius-3xl: calc(var(--w3m-border-radius-master) * 20);

        --wui-font-weight-light: 400;
        --wui-font-weight-regular: 500;
        --wui-font-weight-medium: 600;
        --wui-font-weight-bold: 700;

        --wui-letter-spacing-large: -0.8px;
        --wui-letter-spacing-paragraph: -0.64px;
        --wui-letter-spacing-small: -0.56px;
        --wui-letter-spacing-tiny: -0.48px;
        --wui-letter-spacing-micro: -0.2px;

        --wui-spacing-0: 0px;
        --wui-spacing-4xs: 2px;
        --wui-spacing-3xs: 4px;
        --wui-spacing-xxs: 6px;
        --wui-spacing-2xs: 7px;
        --wui-spacing-xs: 8px;
        --wui-spacing-1xs: 10px;
        --wui-spacing-s: 12px;
        --wui-spacing-m: 14px;
        --wui-spacing-l: 16px;
        --wui-spacing-2l: 18px;
        --wui-spacing-xl: 20px;
        --wui-spacing-xxl: 24px;
        --wui-spacing-2xl: 32px;
        --wui-spacing-3xl: 40px;
        --wui-spacing-4xl: 90px;

        --wui-icon-box-size-xxs: 14px;
        --wui-icon-box-size-xs: 20px;
        --wui-icon-box-size-sm: 24px;
        --wui-icon-box-size-md: 32px;
        --wui-icon-box-size-lg: 40px;
        --wui-icon-box-size-xl: 64px;

        --wui-icon-size-inherit: inherit;
        --wui-icon-size-xxs: 10px;
        --wui-icon-size-xs: 12px;
        --wui-icon-size-sm: 14px;
        --wui-icon-size-md: 16px;
        --wui-icon-size-mdl: 18px;
        --wui-icon-size-lg: 20px;
        --wui-icon-size-xl: 24px;

        --wui-wallet-image-size-inherit: inherit;
        --wui-wallet-image-size-sm: 40px;
        --wui-wallet-image-size-md: 56px;
        --wui-wallet-image-size-lg: 80px;

        --wui-box-size-md: 100px;
        --wui-box-size-lg: 120px;

        --wui-ease-out-power-2: cubic-bezier(0, 0, 0.22, 1);
        --wui-ease-out-power-1: cubic-bezier(0, 0, 0.55, 1);

        --wui-ease-in-power-3: cubic-bezier(0.66, 0, 1, 1);
        --wui-ease-in-power-2: cubic-bezier(0.45, 0, 1, 1);
        --wui-ease-in-power-1: cubic-bezier(0.3, 0, 1, 1);

        --wui-ease-inout-power-1: cubic-bezier(0.45, 0, 0.55, 1);

        --wui-duration-lg: 200ms;
        --wui-duration-md: 125ms;
        --wui-duration-sm: 75ms;

        --wui-path-network: path(
          'M43.4605 10.7248L28.0485 1.61089C25.5438 0.129705 22.4562 0.129705 19.9515 1.61088L4.53951 10.7248C2.03626 12.2051 0.5 14.9365 0.5 17.886V36.1139C0.5 39.0635 2.03626 41.7949 4.53951 43.2752L19.9515 52.3891C22.4562 53.8703 25.5438 53.8703 28.0485 52.3891L43.4605 43.2752C45.9637 41.7949 47.5 39.0635 47.5 36.114V17.8861C47.5 14.9365 45.9637 12.2051 43.4605 10.7248Z'
        );

        --wui-path-network-lg: path(
          'M78.3244 18.926L50.1808 2.45078C45.7376 -0.150261 40.2624 -0.150262 35.8192 2.45078L7.6756 18.926C3.23322 21.5266 0.5 26.3301 0.5 31.5248V64.4752C0.5 69.6699 3.23322 74.4734 7.6756 77.074L35.8192 93.5492C40.2624 96.1503 45.7376 96.1503 50.1808 93.5492L78.3244 77.074C82.7668 74.4734 85.5 69.6699 85.5 64.4752V31.5248C85.5 26.3301 82.7668 21.5266 78.3244 18.926Z'
        );

        --wui-color-inherit: inherit;

        --wui-color-inverse-100: #fff;
        --wui-color-inverse-000: #000;

        --wui-cover: rgba(0, 0, 0, 0.3);

        --wui-color-modal-bg: var(--wui-color-modal-bg-base);

        --wui-color-blue-100: var(--wui-color-blue-base-100);

        --wui-color-accent-100: var(--wui-color-accent-base-100);
        --wui-color-accent-090: var(--wui-color-accent-base-090);
        --wui-color-accent-080: var(--wui-color-accent-base-080);

        --wui-accent-glass-090: var(--wui-accent-glass-base-090);
        --wui-accent-glass-080: var(--wui-accent-glass-base-080);
        --wui-accent-glass-020: var(--wui-accent-glass-base-020);
        --wui-accent-glass-015: var(--wui-accent-glass-base-015);
        --wui-accent-glass-010: var(--wui-accent-glass-base-010);
        --wui-accent-glass-005: var(--wui-accent-glass-base-005);
        --wui-accent-glass-002: var(--wui-accent-glass-base-002);

        --wui-color-fg-100: var(--wui-color-fg-base-100);
        --wui-color-fg-125: var(--wui-color-fg-base-125);
        --wui-color-fg-150: var(--wui-color-fg-base-150);
        --wui-color-fg-175: var(--wui-color-fg-base-175);
        --wui-color-fg-200: var(--wui-color-fg-base-200);
        --wui-color-fg-225: var(--wui-color-fg-base-225);
        --wui-color-fg-250: var(--wui-color-fg-base-250);
        --wui-color-fg-275: var(--wui-color-fg-base-275);
        --wui-color-fg-300: var(--wui-color-fg-base-300);

        --wui-color-bg-100: var(--wui-color-bg-base-100);
        --wui-color-bg-125: var(--wui-color-bg-base-125);
        --wui-color-bg-150: var(--wui-color-bg-base-150);
        --wui-color-bg-175: var(--wui-color-bg-base-175);
        --wui-color-bg-200: var(--wui-color-bg-base-200);
        --wui-color-bg-225: var(--wui-color-bg-base-225);
        --wui-color-bg-250: var(--wui-color-bg-base-250);
        --wui-color-bg-275: var(--wui-color-bg-base-275);
        --wui-color-bg-300: var(--wui-color-bg-base-300);

        --wui-color-success-100: var(--wui-color-success-base-100);
        --wui-color-error-100: var(--wui-color-error-base-100);

        --wui-icon-box-bg-error-100: var(--wui-icon-box-bg-error-base-100);
        --wui-icon-box-bg-blue-100: var(--wui-icon-box-bg-blue-base-100);
        --wui-icon-box-bg-success-100: var(--wui-icon-box-bg-success-base-100);
        --wui-icon-box-bg-inverse-100: var(--wui-icon-box-bg-inverse-base-100);

        --wui-all-wallets-bg-100: var(--wui-all-wallets-bg-base-100);

        --wui-avatar-border: var(--wui-avatar-border-base);

        --wui-thumbnail-border: var(--wui-thumbnail-border-base);

        --wui-box-shadow-blue: rgba(71, 161, 255, 0.16);
      }

      @supports (background: color-mix(in srgb, white 50%, black)) {
        :root {
          --wui-color-modal-bg: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-modal-bg-base)
          );

          --wui-box-shadow-blue: color-mix(in srgb, var(--wui-color-accent-100) 16%, transparent);

          --wui-color-accent-090: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 90%,
            var(--w3m-default)
          );
          --wui-color-accent-080: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 80%,
            var(--w3m-default)
          );

          --wui-color-accent-090: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 90%,
            transparent
          );
          --wui-color-accent-080: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 80%,
            transparent
          );

          --wui-accent-glass-090: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 90%,
            transparent
          );
          --wui-accent-glass-080: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 80%,
            transparent
          );
          --wui-accent-glass-020: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 20%,
            transparent
          );
          --wui-accent-glass-015: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 15%,
            transparent
          );
          --wui-accent-glass-010: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 10%,
            transparent
          );
          --wui-accent-glass-005: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 5%,
            transparent
          );
          --wui-color-accent-002: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 2%,
            transparent
          );

          --wui-color-fg-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-100)
          );
          --wui-color-fg-125: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-125)
          );
          --wui-color-fg-150: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-150)
          );
          --wui-color-fg-175: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-175)
          );
          --wui-color-fg-200: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-200)
          );
          --wui-color-fg-225: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-225)
          );
          --wui-color-fg-250: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-250)
          );
          --wui-color-fg-275: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-275)
          );
          --wui-color-fg-300: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-300)
          );

          --wui-color-bg-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-100)
          );
          --wui-color-bg-125: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-125)
          );
          --wui-color-bg-150: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-150)
          );
          --wui-color-bg-175: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-175)
          );
          --wui-color-bg-200: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-200)
          );
          --wui-color-bg-225: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-225)
          );
          --wui-color-bg-250: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-250)
          );
          --wui-color-bg-275: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-275)
          );
          --wui-color-bg-300: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-300)
          );

          --wui-color-success-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-success-base-100)
          );
          --wui-color-error-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-error-base-100)
          );

          --wui-icon-box-bg-error-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-icon-box-bg-error-base-100)
          );
          --wui-icon-box-bg-accent-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-icon-box-bg-blue-base-100)
          );
          --wui-icon-box-bg-success-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-icon-box-bg-success-base-100)
          );
          --wui-icon-box-bg-inverse-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-icon-box-bg-inverse-base-100)
          );

          --wui-all-wallets-bg-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-all-wallets-bg-base-100)
          );

          --wui-avatar-border: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-avatar-border-base)
          );

          --wui-thumbnail-border: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-thumbnail-border-base)
          );
        }
      }
    `,
    light: ze`
      :root {
        --w3m-color-mix: ${uo((t == null ? void 0 : t["--w3m-color-mix"]) || "#fff")};
        --w3m-accent: ${uo((t == null ? void 0 : t["--w3m-accent"]) || "#47a1ff")};
        --w3m-default: #fff;

        --wui-color-modal-bg-base: #191a1a;

        --wui-color-blue-base-100: #47a1ff;

        --wui-color-accent-base-100: var(--w3m-accent);
        --wui-color-accent-base-090: #59aaff;
        --wui-color-accent-base-080: #6cb4ff;

        --wui-accent-glass-base-090: rgba(71, 161, 255, 0.9);
        --wui-accent-glass-base-080: rgba(71, 161, 255, 0.8);
        --wui-accent-glass-base-020: rgba(71, 161, 255, 0.2);
        --wui-accent-glass-base-015: rgba(71, 161, 255, 0.15);
        --wui-accent-glass-base-010: rgba(71, 161, 255, 0.1);
        --wui-accent-glass-base-005: rgba(71, 161, 255, 0.05);
        --wui-accent-glass-base-002: rgba(71, 161, 255, 0.02);

        --wui-color-fg-base-100: #e4e7e7;
        --wui-color-fg-base-125: #d0d5d5;
        --wui-color-fg-base-150: #a8b1b1;
        --wui-color-fg-base-175: #a8b0b0;
        --wui-color-fg-base-200: #949e9e;
        --wui-color-fg-base-225: #868f8f;
        --wui-color-fg-base-250: #788080;
        --wui-color-fg-base-275: #788181;
        --wui-color-fg-base-300: #6e7777;

        --wui-color-bg-base-100: #141414;
        --wui-color-bg-base-125: #191a1a;
        --wui-color-bg-base-150: #1e1f1f;
        --wui-color-bg-base-175: #222525;
        --wui-color-bg-base-200: #272a2a;
        --wui-color-bg-base-225: #2c3030;
        --wui-color-bg-base-250: #313535;
        --wui-color-bg-base-275: #363b3b;
        --wui-color-bg-base-300: #3b4040;

        --wui-color-success-base-100: #26d962;
        --wui-color-error-base-100: #f25a67;

        --wui-icon-box-bg-error-base-100: #3c2426;
        --wui-icon-box-bg-blue-base-100: #20303f;
        --wui-icon-box-bg-success-base-100: #1f3a28;
        --wui-icon-box-bg-inverse-base-100: #243240;

        --wui-all-wallets-bg-base-100: #222b35;

        --wui-avatar-border-base: #252525;

        --wui-thumbnail-border-base: #252525;

        --wui-gray-glass-001: rgba(255, 255, 255, 0.01);
        --wui-gray-glass-002: rgba(255, 255, 255, 0.02);
        --wui-gray-glass-005: rgba(255, 255, 255, 0.05);
        --wui-gray-glass-010: rgba(255, 255, 255, 0.1);
        --wui-gray-glass-015: rgba(255, 255, 255, 0.15);
        --wui-gray-glass-020: rgba(255, 255, 255, 0.2);
        --wui-gray-glass-025: rgba(255, 255, 255, 0.25);
        --wui-gray-glass-030: rgba(255, 255, 255, 0.3);
        --wui-gray-glass-060: rgba(255, 255, 255, 0.6);
        --wui-gray-glass-080: rgba(255, 255, 255, 0.8);
      }
    `,
    dark: ze`
      :root {
        --w3m-color-mix: ${uo((t == null ? void 0 : t["--w3m-color-mix"]) || "#000")};
        --w3m-accent: ${uo((t == null ? void 0 : t["--w3m-accent"]) || "#3396ff")};
        --w3m-default: #000;

        --wui-color-modal-bg-base: #fff;

        --wui-color-blue-base-100: #3396ff;

        --wui-color-accent-base-100: var(--w3m-accent);
        --wui-color-accent-base-090: #2d7dd2;
        --wui-color-accent-base-080: #2978cc;

        --wui-accent-glass-base-090: rgba(51, 150, 255, 0.9);
        --wui-accent-glass-base-080: rgba(51, 150, 255, 0.8);
        --wui-accent-glass-base-020: rgba(51, 150, 255, 0.2);
        --wui-accent-glass-base-015: rgba(51, 150, 255, 0.15);
        --wui-accent-glass-base-010: rgba(51, 150, 255, 0.1);
        --wui-accent-glass-base-005: rgba(51, 150, 255, 0.05);
        --wui-accent-glass-base-002: rgba(51, 150, 255, 0.02);

        --wui-color-fg-base-100: #141414;
        --wui-color-fg-base-125: #2d3131;
        --wui-color-fg-base-150: #474d4d;
        --wui-color-fg-base-175: #636d6d;
        --wui-color-fg-base-200: #798686;
        --wui-color-fg-base-225: #828f8f;
        --wui-color-fg-base-250: #8b9797;
        --wui-color-fg-base-275: #95a0a0;
        --wui-color-fg-base-300: #9ea9a9;

        --wui-color-bg-base-100: #ffffff;
        --wui-color-bg-base-125: #f5fafa;
        --wui-color-bg-base-150: #f3f8f8;
        --wui-color-bg-base-175: #eef4f4;
        --wui-color-bg-base-200: #eaf1f1;
        --wui-color-bg-base-225: #e5eded;
        --wui-color-bg-base-250: #e1e9e9;
        --wui-color-bg-base-275: #dce7e7;
        --wui-color-bg-base-300: #d8e3e3;

        --wui-color-success-base-100: #26b562;
        --wui-color-error-base-100: #f05142;

        --wui-icon-box-bg-error-base-100: #f4dfdd;
        --wui-icon-box-bg-blue-base-100: #d9ecfb;
        --wui-icon-box-bg-success-base-100: #daf0e4;
        --wui-icon-box-bg-inverse-base-100: #dcecfc;

        --wui-all-wallets-bg-base-100: #e8f1fa;

        --wui-avatar-border-base: #f3f4f4;

        --wui-thumbnail-border-base: #eaefef;

        --wui-gray-glass-001: rgba(0, 0, 0, 0.01);
        --wui-gray-glass-002: rgba(0, 0, 0, 0.02);
        --wui-gray-glass-005: rgba(0, 0, 0, 0.05);
        --wui-gray-glass-010: rgba(0, 0, 0, 0.1);
        --wui-gray-glass-015: rgba(0, 0, 0, 0.15);
        --wui-gray-glass-020: rgba(0, 0, 0, 0.2);
        --wui-gray-glass-025: rgba(0, 0, 0, 0.25);
        --wui-gray-glass-030: rgba(0, 0, 0, 0.3);
        --wui-gray-glass-060: rgba(0, 0, 0, 0.6);
        --wui-gray-glass-080: rgba(0, 0, 0, 0.8);
      }
    `
  };
}
const Rt = ze`
  *,
  *::after,
  *::before,
  :host {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-style: normal;
    text-rendering: optimizeSpeed;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: transparent;
    font-family: var(--wui-font-family);
    backface-visibility: hidden;
  }
`, pr = ze`
  button,
  a {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    transition: all var(--wui-ease-out-power-1) var(--wui-duration-lg);
    outline: none;
    border: 1px solid transparent;
    column-gap: var(--wui-spacing-3xs);
    background-color: transparent;
    text-decoration: none;
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled {
      background-color: var(--wui-gray-glass-005);
    }

    button:active:enabled {
      transition: all var(--wui-ease-out-power-2) var(--wui-duration-sm);
      background-color: var(--wui-gray-glass-010);
    }

    button[data-variant='fill']:hover:enabled {
      background-color: var(--wui-color-accent-090);
    }

    button[data-variant='accentBg']:hover:enabled {
      background: var(--wui-accent-glass-015);
    }

    button[data-variant='accentBg']:active:enabled {
      background: var(--wui-accent-glass-020);
    }
  }

  button:disabled {
    cursor: not-allowed;
    background-color: var(--wui-gray-glass-005);
  }

  button[data-variant='shade']:disabled,
  button[data-variant='accent']:disabled,
  button[data-variant='accentBg']:disabled {
    background-color: var(--wui-gray-glass-010);
    color: var(--wui-gray-glass-015);
    filter: grayscale(1);
  }

  button:disabled > wui-wallet-image,
  button:disabled > wui-all-wallets-image,
  button:disabled > wui-network-image,
  button:disabled > wui-image,
  button:disabled > wui-icon-box,
  button:disabled > wui-transaction-visual,
  button:disabled > wui-logo {
    filter: grayscale(1);
  }

  button:focus-visible,
  a:focus-visible {
    border: 1px solid var(--wui-color-accent-100);
    background-color: var(--wui-gray-glass-005);
    -webkit-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    -moz-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
  }

  button[data-variant='fill']:focus-visible {
    background-color: var(--wui-color-accent-090);
  }

  button[data-variant='fill'] {
    color: var(--wui-color-inverse-100);
    background-color: var(--wui-color-accent-100);
  }

  button[data-variant='fill']:disabled {
    color: var(--wui-gray-glass-015);
    background-color: var(--wui-gray-glass-015);
  }

  button[data-variant='fill']:disabled > wui-icon {
    color: var(--wui-gray-glass-015);
  }

  button[data-variant='shade'] {
    color: var(--wui-color-fg-200);
  }

  button[data-variant='accent'],
  button[data-variant='accentBg'] {
    color: var(--wui-color-accent-100);
  }

  button[data-variant='accentBg'] {
    background: var(--wui-accent-glass-010);
    border: 1px solid var(--wui-accent-glass-010);
  }

  button[data-variant='fullWidth'] {
    width: 100%;
    border-radius: var(--wui-border-radius-xs);
    height: 56px;
    border: none;
    background-color: var(--wui-gray-glass-002);
    color: var(--wui-color-fg-200);
    gap: var(--wui-spacing-xs);
  }

  button:active:enabled {
    background-color: var(--wui-gray-glass-010);
  }

  button[data-variant='fill']:active:enabled {
    background-color: var(--wui-color-accent-080);
    border: 1px solid var(--wui-gray-glass-010);
  }

  input {
    border: none;
    outline: none;
    appearance: none;
  }
`, sS = ze`
  .wui-color-inherit {
    color: var(--wui-color-inherit);
  }

  .wui-color-accent-100 {
    color: var(--wui-color-accent-100);
  }

  .wui-color-error-100 {
    color: var(--wui-color-error-100);
  }

  .wui-color-success-100 {
    color: var(--wui-color-success-100);
  }

  .wui-color-inverse-100 {
    color: var(--wui-color-inverse-100);
  }

  .wui-color-inverse-000 {
    color: var(--wui-color-inverse-000);
  }

  .wui-color-fg-100 {
    color: var(--wui-color-fg-100);
  }

  .wui-color-fg-200 {
    color: var(--wui-color-fg-200);
  }

  .wui-color-fg-300 {
    color: var(--wui-color-fg-300);
  }

  .wui-bg-color-inherit {
    background-color: var(--wui-color-inherit);
  }

  .wui-bg-color-blue-100 {
    background-color: var(--wui-color-accent-100);
  }

  .wui-bg-color-error-100 {
    background-color: var(--wui-color-error-100);
  }

  .wui-bg-color-success-100 {
    background-color: var(--wui-color-success-100);
  }

  .wui-bg-color-inverse-100 {
    background-color: var(--wui-color-inverse-100);
  }

  .wui-bg-color-inverse-000 {
    background-color: var(--wui-color-inverse-000);
  }

  .wui-bg-color-fg-100 {
    background-color: var(--wui-color-fg-100);
  }

  .wui-bg-color-fg-200 {
    background-color: var(--wui-color-fg-200);
  }

  .wui-bg-color-fg-300 {
    background-color: var(--wui-color-fg-300);
  }
`;
function sse(t, e) {
  const { kind: n, elements: r } = e;
  return {
    kind: n,
    elements: r,
    finisher(i) {
      customElements.get(t) || customElements.define(t, i);
    }
  };
}
function lse(t, e) {
  return customElements.get(t) || customElements.define(t, e), e;
}
function Ze(t) {
  return function(n) {
    return typeof n == "function" ? lse(t, n) : sse(t, n);
  };
}
const cse = ze`
  :host {
    display: block;
    border-radius: clamp(0px, var(--wui-border-radius-l), 44px);
    border: 1px solid var(--wui-gray-glass-005);
    background-color: var(--wui-color-modal-bg);
    overflow: hidden;
  }
`;
var dse = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let tb = class extends be {
  render() {
    return _`<slot></slot>`;
  }
};
tb.styles = [Rt, cse];
tb = dse([
  Ze("wui-card")
], tb);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const use = { attribute: !0, type: String, converter: rV, reflect: !1, hasChanged: oS }, hse = (t = use, e, n) => {
  const { kind: r, metadata: i } = n;
  let a = globalThis.litPropertyMetadata.get(i);
  if (a === void 0 && globalThis.litPropertyMetadata.set(i, a = /* @__PURE__ */ new Map()), a.set(n.name, t), r === "accessor") {
    const { name: o } = n;
    return { set(s) {
      const l = e.get.call(this);
      e.set.call(this, s), this.requestUpdate(o, l, t);
    }, init(s) {
      return s !== void 0 && this.C(o, void 0, t), s;
    } };
  }
  if (r === "setter") {
    const { name: o } = n;
    return function(s) {
      const l = this[o];
      e.call(this, s), this.requestUpdate(o, l, t);
    };
  }
  throw Error("Unsupported decorator location: " + r);
};
function te(t) {
  return (e, n) => typeof n == "object" ? hse(t, e, n) : ((r, i, a) => {
    const o = i.hasOwnProperty(a);
    return i.constructor.createProperty(a, o ? { ...r, wrapped: !0 } : r), o ? Object.getOwnPropertyDescriptor(i, a) : void 0;
  })(t, e, n);
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function Ke(t) {
  return te({ ...t, state: !0, attribute: !1 });
}
const Nse = ze`
  :host {
    display: flex;
    aspect-ratio: 1 / 1;
    color: var(--local-color);
    width: var(--local-width);
  }

  svg {
    width: inherit;
    height: inherit;
    object-fit: contain;
    object-position: center;
  }
`, Mse = ke`<svg fill="none" viewBox="0 0 24 24">
  <path
    style="fill: var(--wui-color-accent-100);"
    d="M10.2 6.6a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0ZM21 6.6a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0ZM10.2 17.4a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0ZM21 17.4a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0Z"
  />
</svg>`, pse = ke`
<svg width="36" height="36">
  <path
    d="M28.724 0H7.271A7.269 7.269 0 0 0 0 7.272v21.46A7.268 7.268 0 0 0 7.271 36H28.73A7.272 7.272 0 0 0 36 28.728V7.272A7.275 7.275 0 0 0 28.724 0Z"
    fill="url(#a)"
  />
  <path
    d="m17.845 8.271.729-1.26a1.64 1.64 0 1 1 2.843 1.638l-7.023 12.159h5.08c1.646 0 2.569 1.935 1.853 3.276H6.434a1.632 1.632 0 0 1-1.638-1.638c0-.909.73-1.638 1.638-1.638h4.176l5.345-9.265-1.67-2.898a1.642 1.642 0 0 1 2.844-1.638l.716 1.264Zm-6.317 17.5-1.575 2.732a1.64 1.64 0 1 1-2.844-1.638l1.17-2.025c1.323-.41 2.398-.095 3.249.931Zm13.56-4.954h4.262c.909 0 1.638.729 1.638 1.638 0 .909-.73 1.638-1.638 1.638h-2.367l1.597 2.772c.45.788.185 1.782-.602 2.241a1.642 1.642 0 0 1-2.241-.603c-2.69-4.666-4.711-8.159-6.052-10.485-1.372-2.367-.391-4.743.576-5.549 1.075 1.846 2.682 4.631 4.828 8.348Z"
    fill="#fff"
  />
  <defs>
    <linearGradient id="a" x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">
      <stop stop-color="#18BFFB" />
      <stop offset="1" stop-color="#2072F3" />
    </linearGradient>
  </defs>
</svg>`, mse = ke`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#000" />
      <g clip-path="url(#c)">
        <path
          fill="#fff"
          d="M28.77 23.3c-.69 1.99-2.75 5.52-4.87 5.56-1.4.03-1.86-.84-3.46-.84-1.61 0-2.12.81-3.45.86-2.25.1-5.72-5.1-5.72-9.62 0-4.15 2.9-6.2 5.42-6.25 1.36-.02 2.64.92 3.47.92.83 0 2.38-1.13 4.02-.97.68.03 2.6.28 3.84 2.08-3.27 2.14-2.76 6.61.75 8.25ZM24.2 7.88c-2.47.1-4.49 2.69-4.2 4.84 2.28.17 4.47-2.39 4.2-4.84Z"
        />
      </g>
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>
  </defs>
</svg>`, Tse = ke`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M7 1.99a1 1 0 0 1 1 1v7.58l2.46-2.46a1 1 0 0 1 1.41 1.42L7.7 13.69a1 1 0 0 1-1.41 0L2.12 9.53A1 1 0 0 1 3.54 8.1L6 10.57V3a1 1 0 0 1 1-1Z"
    clip-rule="evenodd"
  />
</svg>`, fse = ke`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M13 7.99a1 1 0 0 1-1 1H4.4l2.46 2.46a1 1 0 1 1-1.41 1.41L1.29 8.7a1 1 0 0 1 0-1.41L5.46 3.1a1 1 0 0 1 1.41 1.42L4.41 6.99H12a1 1 0 0 1 1 1Z"
    clip-rule="evenodd"
  />
</svg>`, Vse = ke`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M1 7.99a1 1 0 0 1 1-1h7.58L7.12 4.53A1 1 0 1 1 8.54 3.1l4.16 4.17a1 1 0 0 1 0 1.41l-4.16 4.17a1 1 0 1 1-1.42-1.41l2.46-2.46H2a1 1 0 0 1-1-1Z"
    clip-rule="evenodd"
  />
</svg>`, Use = ke`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M7 13.99a1 1 0 0 1-1-1V5.4L3.54 7.86a1 1 0 0 1-1.42-1.41L6.3 2.28a1 1 0 0 1 1.41 0l4.17 4.17a1 1 0 1 1-1.41 1.41L8 5.4v7.59a1 1 0 0 1-1 1Z"
    clip-rule="evenodd"
  />
</svg>`, Rse = ke`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M4 6.4a1 1 0 0 1-.46.89 6.98 6.98 0 0 0 .38 6.18A7 7 0 0 0 16.46 7.3a1 1 0 0 1-.47-.92 7 7 0 0 0-12 .03Zm-2.02-.5a9 9 0 1 1 16.03 8.2A9 9 0 0 1 1.98 5.9Z"
    clip-rule="evenodd"
  />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M6.03 8.63c-1.46-.3-2.72-.75-3.6-1.35l-.02-.01-.14-.11a1 1 0 0 1 1.2-1.6l.1.08c.6.4 1.52.74 2.69 1 .16-.99.39-1.88.67-2.65.3-.79.68-1.5 1.15-2.02A2.58 2.58 0 0 1 9.99 1c.8 0 1.45.44 1.92.97.47.52.84 1.23 1.14 2.02.29.77.52 1.66.68 2.64a8 8 0 0 0 2.7-1l.26-.18h.48a1 1 0 0 1 .12 2c-.86.51-2.01.91-3.34 1.18a22.24 22.24 0 0 1-.03 3.19c1.45.29 2.7.73 3.58 1.31a1 1 0 0 1-1.1 1.68c-.6-.4-1.56-.76-2.75-1-.15.8-.36 1.55-.6 2.2-.3.79-.67 1.5-1.14 2.02-.47.53-1.12.97-1.92.97-.8 0-1.45-.44-1.91-.97a6.51 6.51 0 0 1-1.15-2.02c-.24-.65-.44-1.4-.6-2.2-1.18.24-2.13.6-2.73.99a1 1 0 1 1-1.1-1.67c.88-.58 2.12-1.03 3.57-1.31a22.03 22.03 0 0 1-.04-3.2Zm2.2-1.7c.15-.86.34-1.61.58-2.24.24-.65.51-1.12.76-1.4.25-.28.4-.29.42-.29.03 0 .17.01.42.3.25.27.52.74.77 1.4.23.62.43 1.37.57 2.22a19.96 19.96 0 0 1-3.52 0Zm-.18 4.6a20.1 20.1 0 0 1-.03-2.62 21.95 21.95 0 0 0 3.94 0 20.4 20.4 0 0 1-.03 2.63 21.97 21.97 0 0 0-3.88 0Zm.27 2c.13.66.3 1.26.49 1.78.24.65.51 1.12.76 1.4.25.28.4.29.42.29.03 0 .17-.01.42-.3.25-.27.52-.74.77-1.4.19-.5.36-1.1.49-1.78a20.03 20.03 0 0 0-3.35 0Z"
    clip-rule="evenodd"
  />
</svg>`, gse = ke`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M12.04 2.65c.47.3.6.91.3 1.38l-5.78 9a1 1 0 0 1-1.61.1L1.73 9.27A1 1 0 1 1 3.27 8L5.6 10.8l5.05-7.85a1 1 0 0 1 1.38-.3Z"
    clip-rule="evenodd"
  />
</svg>`, yse = ke`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M1.46 4.96a1 1 0 0 1 1.41 0L8 10.09l5.13-5.13a1 1 0 1 1 1.41 1.41l-5.83 5.84a1 1 0 0 1-1.42 0L1.46 6.37a1 1 0 0 1 0-1.41Z"
    clip-rule="evenodd"
  />
</svg>`, Zse = ke`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M11.04 1.46a1 1 0 0 1 0 1.41L5.91 8l5.13 5.13a1 1 0 1 1-1.41 1.41L3.79 8.71a1 1 0 0 1 0-1.42l5.84-5.83a1 1 0 0 1 1.41 0Z"
    clip-rule="evenodd"
  />
</svg>`, bse = ke`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M4.96 14.54a1 1 0 0 1 0-1.41L10.09 8 4.96 2.87a1 1 0 0 1 1.41-1.41l5.84 5.83a1 1 0 0 1 0 1.42l-5.84 5.83a1 1 0 0 1-1.41 0Z"
    clip-rule="evenodd"
  />
</svg>`, Ese = ke`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M14.54 11.04a1 1 0 0 1-1.41 0L8 5.92l-5.13 5.12a1 1 0 1 1-1.41-1.41l5.83-5.84a1 1 0 0 1 1.42 0l5.83 5.84a1 1 0 0 1 0 1.41Z"
    clip-rule="evenodd"
  />
</svg>`, Sse = ke`<svg width="36" height="36" fill="none">
  <path
    fill="#fff"
    fill-opacity=".05"
    d="M0 14.94c0-5.55 0-8.326 1.182-10.4a9 9 0 0 1 3.359-3.358C6.614 0 9.389 0 14.94 0h6.12c5.55 0 8.326 0 10.4 1.182a9 9 0 0 1 3.358 3.359C36 6.614 36 9.389 36 14.94v6.12c0 5.55 0 8.326-1.182 10.4a9 9 0 0 1-3.359 3.358C29.386 36 26.611 36 21.06 36h-6.12c-5.55 0-8.326 0-10.4-1.182a9 9 0 0 1-3.358-3.359C0 29.386 0 26.611 0 21.06v-6.12Z"
  />
  <path
    stroke="#fff"
    stroke-opacity=".05"
    d="M14.94.5h6.12c2.785 0 4.84 0 6.46.146 1.612.144 2.743.43 3.691.97a8.5 8.5 0 0 1 3.172 3.173c.541.948.826 2.08.971 3.692.145 1.62.146 3.675.146 6.459v6.12c0 2.785 0 4.84-.146 6.46-.145 1.612-.43 2.743-.97 3.691a8.5 8.5 0 0 1-3.173 3.172c-.948.541-2.08.826-3.692.971-1.62.145-3.674.146-6.459.146h-6.12c-2.784 0-4.84 0-6.46-.146-1.612-.145-2.743-.43-3.691-.97a8.5 8.5 0 0 1-3.172-3.173c-.541-.948-.827-2.08-.971-3.692C.5 25.9.5 23.845.5 21.06v-6.12c0-2.784 0-4.84.146-6.46.144-1.612.43-2.743.97-3.691A8.5 8.5 0 0 1 4.79 1.617C5.737 1.076 6.869.79 8.48.646 10.1.5 12.156.5 14.94.5Z"
  />
  <path
    fill="url(#a)"
    d="M17.998 10.8h12.469a14.397 14.397 0 0 0-24.938.001l6.234 10.798.006-.001a7.19 7.19 0 0 1 6.23-10.799Z"
  />
  <path
    fill="url(#b)"
    d="m24.237 21.598-6.234 10.798A14.397 14.397 0 0 0 30.47 10.798H18.002l-.002.006a7.191 7.191 0 0 1 6.237 10.794Z"
  />
  <path
    fill="url(#c)"
    d="M11.765 21.601 5.531 10.803A14.396 14.396 0 0 0 18.001 32.4l6.235-10.798-.004-.004a7.19 7.19 0 0 1-12.466.004Z"
  />
  <path fill="#fff" d="M18 25.2a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4Z" />
  <path fill="#1A73E8" d="M18 23.7a5.7 5.7 0 1 0 0-11.4 5.7 5.7 0 0 0 0 11.4Z" />
  <defs>
    <linearGradient
      id="a"
      x1="6.294"
      x2="41.1"
      y1="5.995"
      y2="5.995"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#D93025" />
      <stop offset="1" stop-color="#EA4335" />
    </linearGradient>
    <linearGradient
      id="b"
      x1="20.953"
      x2="37.194"
      y1="32.143"
      y2="2.701"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#FCC934" />
      <stop offset="1" stop-color="#FBBC04" />
    </linearGradient>
    <linearGradient
      id="c"
      x1="25.873"
      x2="9.632"
      y1="31.2"
      y2="1.759"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#1E8E3E" />
      <stop offset="1" stop-color="#34A853" />
    </linearGradient>
  </defs>
</svg>`, xse = ke`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M7 2.99a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm-7 5a7 7 0 1 1 14 0 7 7 0 0 1-14 0Zm7-4a1 1 0 0 1 1 1v2.58l1.85 1.85a1 1 0 0 1-1.41 1.42L6.29 8.69A1 1 0 0 1 6 8v-3a1 1 0 0 1 1-1Z"
    clip-rule="evenodd"
  />
</svg>`, Wse = ke`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M2.54 2.54a1 1 0 0 1 1.42 0L8 6.6l4.04-4.05a1 1 0 1 1 1.42 1.42L9.4 8l4.05 4.04a1 1 0 0 1-1.42 1.42L8 9.4l-4.04 4.05a1 1 0 0 1-1.42-1.42L6.6 8 2.54 3.96a1 1 0 0 1 0-1.42Z"
    clip-rule="evenodd"
  />
</svg>`, jse = ke`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M10 3a7 7 0 0 0-6.85 8.44l8.29-8.3C10.97 3.06 10.49 3 10 3Zm3.49.93-9.56 9.56c.32.55.71 1.06 1.16 1.5L15 5.1a7.03 7.03 0 0 0-1.5-1.16Zm2.7 2.8-9.46 9.46a7 7 0 0 0 9.46-9.46ZM1.99 5.9A9 9 0 1 1 18 14.09 9 9 0 0 1 1.98 5.91Z"
    clip-rule="evenodd"
  />
</svg>`, Dse = ke`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2ZM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm10.66-2.65a1 1 0 0 1 .23 1.06L9.83 9.24a1 1 0 0 1-.59.58l-2.83 1.06A1 1 0 0 1 5.13 9.6l1.06-2.82a1 1 0 0 1 .58-.59L9.6 5.12a1 1 0 0 1 1.06.23ZM7.9 7.89l-.13.35.35-.13.12-.35-.34.13Z"
    clip-rule="evenodd"
  />
</svg>`, zse = ke`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M9.5 0h1.67c.68 0 1.26 0 1.73.04.5.05.97.14 1.42.4.52.3.95.72 1.24 1.24.26.45.35.92.4 1.42.04.47.04 1.05.04 1.73V6.5c0 .69 0 1.26-.04 1.74-.05.5-.14.97-.4 1.41-.3.52-.72.95-1.24 1.25-.45.25-.92.35-1.42.4-.43.03-.95.03-1.57.03 0 .62 0 1.14-.04 1.57-.04.5-.14.97-.4 1.42-.29.52-.72.95-1.24 1.24-.44.26-.92.35-1.41.4-.48.04-1.05.04-1.74.04H4.83c-.68 0-1.26 0-1.73-.04-.5-.05-.97-.14-1.42-.4-.52-.3-.95-.72-1.24-1.24a3.39 3.39 0 0 1-.4-1.42A20.9 20.9 0 0 1 0 11.17V9.5c0-.69 0-1.26.04-1.74.05-.5.14-.97.4-1.41.3-.52.72-.95 1.24-1.25.45-.25.92-.35 1.42-.4.43-.03.95-.03 1.57-.03 0-.62 0-1.14.04-1.57.04-.5.14-.97.4-1.42.29-.52.72-.95 1.24-1.24.44-.26.92-.35 1.41-.4A20.9 20.9 0 0 1 9.5 0ZM4.67 6.67c-.63 0-1.06 0-1.4.03-.35.03-.5.09-.6.14-.2.12-.38.3-.5.5-.05.1-.1.24-.14.6C2 8.32 2 8.8 2 9.54v1.59c0 .73 0 1.22.03 1.6.04.35.1.5.15.6.11.2.29.38.5.5.09.05.24.1.6.14.37.03.86.03 1.6.03h1.58c.74 0 1.22 0 1.6-.03.36-.04.5-.1.6-.15.2-.11.38-.29.5-.5.05-.09.1-.24.14-.6.03-.33.03-.76.03-1.39-.6 0-1.13 0-1.57-.04-.5-.04-.97-.14-1.41-.4-.52-.29-.95-.72-1.25-1.24a3.39 3.39 0 0 1-.4-1.41c-.03-.44-.03-.96-.03-1.57Zm3.27-4.64c-.36.04-.5.1-.6.15-.2.11-.38.29-.5.5-.05.09-.1.24-.14.6-.03.37-.03.86-.03 1.6v1.58c0 .74 0 1.22.03 1.6.03.36.09.5.14.6.12.2.3.38.5.5.1.05.24.1.6.14.38.03.86.03 1.6.03h1.59c.73 0 1.22 0 1.6-.03.35-.03.5-.09.6-.14.2-.12.38-.3.5-.5.05-.1.1-.24.14-.6.03-.38.03-.86.03-1.6V4.87c0-.73 0-1.22-.03-1.6a1.46 1.46 0 0 0-.15-.6c-.11-.2-.29-.38-.5-.5-.09-.05-.24-.1-.6-.14-.37-.03-.86-.03-1.6-.03H9.55c-.74 0-1.22 0-1.6.03Z"
    clip-rule="evenodd"
  />
</svg>`, kse = ke` <svg fill="none" viewBox="0 0 13 4">
  <path fill="currentColor" d="M.5 0h12L8.9 3.13a3.76 3.76 0 0 1-4.8 0L.5 0Z" />
</svg>`, wse = ke`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M13.66 2H6.34c-1.07 0-1.96 0-2.68.08-.74.08-1.42.25-2.01.68a4 4 0 0 0-.89.89c-.43.6-.6 1.27-.68 2.01C0 6.38 0 7.26 0 8.34v.89c0 1.07 0 1.96.08 2.68.08.74.25 1.42.68 2.01a4 4 0 0 0 .89.89c.6.43 1.27.6 2.01.68a27 27 0 0 0 2.68.08h7.32a27 27 0 0 0 2.68-.08 4.03 4.03 0 0 0 2.01-.68 4 4 0 0 0 .89-.89c.43-.6.6-1.27.68-2.01.08-.72.08-1.6.08-2.68v-.89c0-1.07 0-1.96-.08-2.68a4.04 4.04 0 0 0-.68-2.01 4 4 0 0 0-.89-.89c-.6-.43-1.27-.6-2.01-.68C15.62 2 14.74 2 13.66 2ZM2.82 4.38c.2-.14.48-.25 1.06-.31C4.48 4 5.25 4 6.4 4h7.2c1.15 0 1.93 0 2.52.07.58.06.86.17 1.06.31a2 2 0 0 1 .44.44c.14.2.25.48.31 1.06.07.6.07 1.37.07 2.52v.77c0 1.15 0 1.93-.07 2.52-.06.58-.17.86-.31 1.06a2 2 0 0 1-.44.44c-.2.14-.48.25-1.06.32-.6.06-1.37.06-2.52.06H6.4c-1.15 0-1.93 0-2.52-.06-.58-.07-.86-.18-1.06-.32a2 2 0 0 1-.44-.44c-.14-.2-.25-.48-.31-1.06C2 11.1 2 10.32 2 9.17V8.4c0-1.15 0-1.93.07-2.52.06-.58.17-.86.31-1.06a2 2 0 0 1 .44-.44Z"
    clip-rule="evenodd"
  />
  <path fill="currentColor" d="M6.14 17.57a1 1 0 1 0 0 2h7.72a1 1 0 1 0 0-2H6.14Z" />
</svg>`, Fse = ke`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M6.07 1h.57a1 1 0 0 1 0 2h-.52c-.98 0-1.64 0-2.14.06-.48.05-.7.14-.84.24-.13.1-.25.22-.34.35-.1.14-.2.35-.25.83-.05.5-.05 1.16-.05 2.15v2.74c0 .99 0 1.65.05 2.15.05.48.14.7.25.83.1.14.2.25.34.35.14.1.36.2.84.25.5.05 1.16.05 2.14.05h.52a1 1 0 0 1 0 2h-.57c-.92 0-1.69 0-2.3-.07a3.6 3.6 0 0 1-1.8-.61c-.3-.22-.57-.49-.8-.8a3.6 3.6 0 0 1-.6-1.79C.5 11.11.5 10.35.5 9.43V6.58c0-.92 0-1.7.06-2.31a3.6 3.6 0 0 1 .62-1.8c.22-.3.48-.57.79-.79a3.6 3.6 0 0 1 1.8-.61C4.37 1 5.14 1 6.06 1ZM9.5 3a1 1 0 0 1 1.42 0l4.28 4.3a1 1 0 0 1 0 1.4L10.93 13a1 1 0 0 1-1.42-1.42L12.1 9H6.8a1 1 0 1 1 0-2h5.3L9.51 4.42a1 1 0 0 1 0-1.41Z"
    clip-rule="evenodd"
  />
</svg>`, vse = ke`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#5865F2" />
      <path
        fill="#fff"
        fill-rule="evenodd"
        d="M25.71 28.15C30.25 28 32 25.02 32 25.02c0-6.61-2.96-11.98-2.96-11.98-2.96-2.22-5.77-2.15-5.77-2.15l-.29.32c3.5 1.07 5.12 2.61 5.12 2.61a16.75 16.75 0 0 0-10.34-1.93l-.35.04a15.43 15.43 0 0 0-5.88 1.9s1.71-1.63 5.4-2.7l-.2-.24s-2.81-.07-5.77 2.15c0 0-2.96 5.37-2.96 11.98 0 0 1.73 2.98 6.27 3.13l1.37-1.7c-2.6-.79-3.6-2.43-3.6-2.43l.58.35.09.06.08.04.02.01.08.05a17.25 17.25 0 0 0 4.52 1.58 14.4 14.4 0 0 0 8.3-.86c.72-.27 1.52-.66 2.37-1.21 0 0-1.03 1.68-3.72 2.44.61.78 1.35 1.67 1.35 1.67Zm-9.55-9.6c-1.17 0-2.1 1.03-2.1 2.28 0 1.25.95 2.28 2.1 2.28 1.17 0 2.1-1.03 2.1-2.28.01-1.25-.93-2.28-2.1-2.28Zm7.5 0c-1.17 0-2.1 1.03-2.1 2.28 0 1.25.95 2.28 2.1 2.28 1.17 0 2.1-1.03 2.1-2.28 0-1.25-.93-2.28-2.1-2.28Z"
        clip-rule="evenodd"
      />
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
  </defs>
</svg>`, Ise = ke`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    d="M4.25 7a.63.63 0 0 0-.63.63v3.97c0 .28-.2.51-.47.54l-.75.07a.93.93 0 0 1-.9-.47A7.51 7.51 0 0 1 5.54.92a7.5 7.5 0 0 1 9.54 4.62c.12.35.06.72-.16 1-.74.97-1.68 1.78-2.6 2.44V4.44a.64.64 0 0 0-.63-.64h-1.06c-.35 0-.63.3-.63.64v5.5c0 .23-.12.42-.32.5l-.52.23V6.05c0-.36-.3-.64-.64-.64H7.45c-.35 0-.64.3-.64.64v4.97c0 .25-.17.46-.4.52a5.8 5.8 0 0 0-.45.11v-4c0-.36-.3-.65-.64-.65H4.25ZM14.07 12.4A7.49 7.49 0 0 1 3.6 14.08c4.09-.58 9.14-2.5 11.87-6.6v.03a7.56 7.56 0 0 1-1.41 4.91Z"
  />
</svg>`, Ose = ke`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M6.71 2.99a.57.57 0 0 0-.57.57 1 1 0 0 1-1 1c-.58 0-.96 0-1.24.03-.27.03-.37.07-.42.1a.97.97 0 0 0-.36.35c-.04.08-.09.21-.11.67a2.57 2.57 0 0 1 0 5.13c.02.45.07.6.11.66.09.15.21.28.36.36.07.04.21.1.67.12a2.57 2.57 0 0 1 5.12 0c.46-.03.6-.08.67-.12a.97.97 0 0 0 .36-.36c.03-.04.07-.14.1-.41.02-.29.03-.66.03-1.24a1 1 0 0 1 1-1 .57.57 0 0 0 0-1.15 1 1 0 0 1-1-1c0-.58 0-.95-.03-1.24a1.04 1.04 0 0 0-.1-.42.97.97 0 0 0-.36-.36 1.04 1.04 0 0 0-.42-.1c-.28-.02-.65-.02-1.24-.02a1 1 0 0 1-1-1 .57.57 0 0 0-.57-.57ZM5.15 13.98a1 1 0 0 0 .99-1v-.78a.57.57 0 0 1 1.14 0v.78a1 1 0 0 0 .99 1H8.36a66.26 66.26 0 0 0 .73 0 3.78 3.78 0 0 0 1.84-.38c.46-.26.85-.64 1.1-1.1.23-.4.32-.8.36-1.22.02-.2.03-.4.03-.63a2.57 2.57 0 0 0 0-4.75c0-.23-.01-.44-.03-.63a2.96 2.96 0 0 0-.35-1.22 2.97 2.97 0 0 0-1.1-1.1c-.4-.22-.8-.31-1.22-.35a8.7 8.7 0 0 0-.64-.04 2.57 2.57 0 0 0-4.74 0c-.23 0-.44.02-.63.04-.42.04-.83.13-1.22.35-.46.26-.84.64-1.1 1.1-.33.57-.37 1.2-.39 1.84a21.39 21.39 0 0 0 0 .72v.1a1 1 0 0 0 1 .99h.78a.57.57 0 0 1 0 1.15h-.77a1 1 0 0 0-1 .98v.1a63.87 63.87 0 0 0 0 .73c0 .64.05 1.27.38 1.83.26.47.64.85 1.1 1.11.56.32 1.2.37 1.84.38a20.93 20.93 0 0 0 .72 0h.1Z"
    clip-rule="evenodd"
  />
</svg>`, Yse = ke`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M3.74 3.99a1 1 0 0 1 1-1H11a1 1 0 0 1 1 1v6.26a1 1 0 0 1-2 0V6.4l-6.3 6.3a1 1 0 0 1-1.4-1.42l6.29-6.3H4.74a1 1 0 0 1-1-1Z"
    clip-rule="evenodd"
  />
</svg>`, Qse = ke`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#1877F2" />
      <g clip-path="url(#c)">
        <path
          fill="#fff"
          d="M26 12.38h-2.89c-.92 0-1.61.38-1.61 1.34v1.66H26l-.36 4.5H21.5v12H17v-12h-3v-4.5h3V12.5c0-3.03 1.6-4.62 5.2-4.62H26v4.5Z"
        />
      </g>
    </g>
    <path
      fill="#1877F2"
      d="M40 20a20 20 0 1 0-23.13 19.76V25.78H11.8V20h5.07v-4.4c0-5.02 3-7.79 7.56-7.79 2.19 0 4.48.4 4.48.4v4.91h-2.53c-2.48 0-3.25 1.55-3.25 3.13V20h5.54l-.88 5.78h-4.66v13.98A20 20 0 0 0 40 20Z"
    />
    <path
      fill="#fff"
      d="m27.79 25.78.88-5.78h-5.55v-3.75c0-1.58.78-3.13 3.26-3.13h2.53V8.2s-2.3-.39-4.48-.39c-4.57 0-7.55 2.77-7.55 7.78V20H11.8v5.78h5.07v13.98a20.15 20.15 0 0 0 6.25 0V25.78h4.67Z"
    />
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>
  </defs>
</svg>`, Gse = ke`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M0 3a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1Zm2.63 5.25a1 1 0 0 1 1-1h8.75a1 1 0 1 1 0 2H3.63a1 1 0 0 1-1-1Zm2.62 5.25a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2h-3.5a1 1 0 0 1-1-1Z"
    clip-rule="evenodd"
  />
</svg>`, Cse = ke`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#1B1F23" />
      <g clip-path="url(#c)">
        <path
          fill="#fff"
          d="M8 19.89a12 12 0 1 1 15.8 11.38c-.6.12-.8-.26-.8-.57v-3.3c0-1.12-.4-1.85-.82-2.22 2.67-.3 5.48-1.31 5.48-5.92 0-1.31-.47-2.38-1.24-3.22.13-.3.54-1.52-.12-3.18 0 0-1-.32-3.3 1.23a11.54 11.54 0 0 0-6 0c-2.3-1.55-3.3-1.23-3.3-1.23a4.32 4.32 0 0 0-.12 3.18 4.64 4.64 0 0 0-1.24 3.22c0 4.6 2.8 5.63 5.47 5.93-.34.3-.65.83-.76 1.6-.69.31-2.42.84-3.5-1 0 0-.63-1.15-1.83-1.23 0 0-1.18-.02-.09.73 0 0 .8.37 1.34 1.76 0 0 .7 2.14 4.03 1.41v2.24c0 .31-.2.68-.8.57A12 12 0 0 1 8 19.9Z"
        />
      </g>
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>
  </defs>
</svg>`, Lse = ke`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#fff" fill-opacity=".05" />
      <g clip-path="url(#c)">
        <path
          fill="#4285F4"
          d="M20 17.7v4.65h6.46a5.53 5.53 0 0 1-2.41 3.61l3.9 3.02c2.26-2.09 3.57-5.17 3.57-8.82 0-.85-.08-1.67-.22-2.46H20Z"
        />
        <path
          fill="#34A853"
          d="m13.27 22.17-.87.67-3.11 2.42A12 12 0 0 0 20 31.9c3.24 0 5.96-1.07 7.94-2.9l-3.9-3.03A7.15 7.15 0 0 1 20 27.12a7.16 7.16 0 0 1-6.72-4.94v-.01Z"
        />
        <path
          fill="#FBBC05"
          d="M9.29 14.5a11.85 11.85 0 0 0 0 10.76l3.99-3.1a7.19 7.19 0 0 1 0-4.55l-4-3.1Z"
        />
        <path
          fill="#EA4335"
          d="M20 12.66c1.77 0 3.34.61 4.6 1.8l3.43-3.44A11.51 11.51 0 0 0 20 7.89c-4.7 0-8.74 2.69-10.71 6.62l3.99 3.1A7.16 7.16 0 0 1 20 12.66Z"
        />
      </g>
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>
  </defs>
</svg>`, Jse = ke`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    d="M8.51 5.66a.83.83 0 0 0-.57-.2.83.83 0 0 0-.52.28.8.8 0 0 0-.25.52 1 1 0 0 1-2 0c0-.75.34-1.43.81-1.91a2.75 2.75 0 0 1 4.78 1.92c0 1.24-.8 1.86-1.25 2.2l-.04.03c-.47.36-.5.43-.5.65a1 1 0 1 1-2 0c0-1.25.8-1.86 1.24-2.2l.04-.04c.47-.36.5-.43.5-.65 0-.3-.1-.49-.24-.6ZM9.12 11.87a1.13 1.13 0 1 1-2.25 0 1.13 1.13 0 0 1 2.25 0Z"
  />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6a6 6 0 1 0 0 12A6 6 0 0 0 8 2Z"
    clip-rule="evenodd"
  />
</svg>`, Bse = ke`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    d="M6 10.49a1 1 0 1 0 2 0v-2a1 1 0 0 0-2 0v2ZM7 4.49a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
  />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M7 14.99a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm5-7a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"
    clip-rule="evenodd"
  />
</svg>`, Ase = ke`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M4.83 1.34h6.34c.68 0 1.26 0 1.73.04.5.05.97.15 1.42.4.52.3.95.72 1.24 1.24.26.45.35.92.4 1.42.04.47.04 1.05.04 1.73v3.71c0 .69 0 1.26-.04 1.74-.05.5-.14.97-.4 1.41-.3.52-.72.95-1.24 1.25-.45.25-.92.35-1.42.4-.47.03-1.05.03-1.73.03H4.83c-.68 0-1.26 0-1.73-.04-.5-.04-.97-.14-1.42-.4-.52-.29-.95-.72-1.24-1.24a3.39 3.39 0 0 1-.4-1.41A20.9 20.9 0 0 1 0 9.88v-3.7c0-.7 0-1.27.04-1.74.05-.5.14-.97.4-1.42.3-.52.72-.95 1.24-1.24.45-.25.92-.35 1.42-.4.47-.04 1.05-.04 1.73-.04ZM3.28 3.38c-.36.03-.51.08-.6.14-.21.11-.39.29-.5.5a.8.8 0 0 0-.08.19l5.16 3.44c.45.3 1.03.3 1.48 0L13.9 4.2a.79.79 0 0 0-.08-.2c-.11-.2-.29-.38-.5-.5-.09-.05-.24-.1-.6-.13-.37-.04-.86-.04-1.6-.04H4.88c-.73 0-1.22 0-1.6.04ZM14 6.54 9.85 9.31a3.33 3.33 0 0 1-3.7 0L2 6.54v3.3c0 .74 0 1.22.03 1.6.04.36.1.5.15.6.11.2.29.38.5.5.09.05.24.1.6.14.37.03.86.03 1.6.03h6.25c.73 0 1.22 0 1.6-.03.35-.03.5-.09.6-.14.2-.12.38-.3.5-.5.05-.1.1-.24.14-.6.03-.38.03-.86.03-1.6v-3.3Z"
    clip-rule="evenodd"
  />
</svg>`, Hse = ke`<svg fill="none" viewBox="0 0 20 20">
  <path fill="currentColor" d="M10.81 5.81a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M3 4.75A4.75 4.75 0 0 1 7.75 0h4.5A4.75 4.75 0 0 1 17 4.75v10.5A4.75 4.75 0 0 1 12.25 20h-4.5A4.75 4.75 0 0 1 3 15.25V4.75ZM7.75 2A2.75 2.75 0 0 0 5 4.75v10.5A2.75 2.75 0 0 0 7.75 18h4.5A2.75 2.75 0 0 0 15 15.25V4.75A2.75 2.75 0 0 0 12.25 2h-4.5Z"
    clip-rule="evenodd"
  />
</svg>`, Xse = ke`<svg fill="none" viewBox="0 0 22 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M16.32 13.62a3.14 3.14 0 1 1-.99 1.72l-1.6-.93a3.83 3.83 0 0 1-3.71 1 3.66 3.66 0 0 1-1.74-1l-1.6.94a3.14 3.14 0 1 1-1-1.73l1.6-.94a3.7 3.7 0 0 1 0-2 3.81 3.81 0 0 1 1.8-2.33c.29-.17.6-.3.92-.38V6.1a3.14 3.14 0 1 1 2 0l-.01.02v1.85H12a3.82 3.82 0 0 1 2.33 1.8 3.7 3.7 0 0 1 .39 2.91l1.6.93ZM2.6 16.54a1.14 1.14 0 0 0 1.98-1.14 1.14 1.14 0 0 0-1.98 1.14ZM11 2.01a1.14 1.14 0 1 0 0 2.28 1.14 1.14 0 0 0 0-2.28Zm1.68 10.45c.08-.19.14-.38.16-.58v-.05l.02-.13v-.13a1.92 1.92 0 0 0-.24-.8l-.11-.15a1.89 1.89 0 0 0-.74-.6 1.86 1.86 0 0 0-.77-.17h-.19a1.97 1.97 0 0 0-.89.34 1.98 1.98 0 0 0-.61.74 1.99 1.99 0 0 0-.16.9v.05a1.87 1.87 0 0 0 .24.74l.1.15c.12.16.26.3.42.42l.16.1.13.07.04.02a1.84 1.84 0 0 0 .76.17h.17a2 2 0 0 0 .91-.35 1.78 1.78 0 0 0 .52-.58l.03-.05a.84.84 0 0 0 .05-.11Zm5.15 4.5a1.14 1.14 0 0 0 1.14-1.97 1.13 1.13 0 0 0-1.55.41c-.32.55-.13 1.25.41 1.56Z"
    clip-rule="evenodd"
  />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M4.63 9.43a1.5 1.5 0 1 0 1.5-2.6 1.5 1.5 0 0 0-1.5 2.6Zm.32-1.55a.5.5 0 0 1 .68-.19.5.5 0 0 1 .18.68.5.5 0 0 1-.68.19.5.5 0 0 1-.18-.68ZM17.94 8.88a1.5 1.5 0 1 1-2.6-1.5 1.5 1.5 0 1 1 2.6 1.5ZM16.9 7.69a.5.5 0 0 0-.68.19.5.5 0 0 0 .18.68.5.5 0 0 0 .68-.19.5.5 0 0 0-.18-.68ZM9.75 17.75a1.5 1.5 0 1 1 2.6 1.5 1.5 1.5 0 1 1-2.6-1.5Zm1.05 1.18a.5.5 0 0 0 .68-.18.5.5 0 0 0-.18-.68.5.5 0 0 0-.68.18.5.5 0 0 0 .18.68Z"
    clip-rule="evenodd"
  />
</svg>`, _se = ke`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M9.13 1h1.71c1.46 0 2.63 0 3.56.1.97.1 1.8.33 2.53.85a5 5 0 0 1 1.1 1.11c.53.73.75 1.56.86 2.53.1.93.1 2.1.1 3.55v1.72c0 1.45 0 2.62-.1 3.55-.1.97-.33 1.8-.86 2.53a5 5 0 0 1-1.1 1.1c-.73.53-1.56.75-2.53.86-.93.1-2.1.1-3.55.1H9.13c-1.45 0-2.62 0-3.56-.1-.96-.1-1.8-.33-2.52-.85a5 5 0 0 1-1.1-1.11 5.05 5.05 0 0 1-.86-2.53c-.1-.93-.1-2.1-.1-3.55V9.14c0-1.45 0-2.62.1-3.55.1-.97.33-1.8.85-2.53a5 5 0 0 1 1.1-1.1 5.05 5.05 0 0 1 2.53-.86C6.51 1 7.67 1 9.13 1ZM5.79 3.09a3.1 3.1 0 0 0-1.57.48 3 3 0 0 0-.66.67c-.24.32-.4.77-.48 1.56-.1.82-.1 1.88-.1 3.4v1.6c0 1.15 0 2.04.05 2.76l.41-.42c.5-.5.93-.92 1.32-1.24.41-.33.86-.6 1.43-.7a3 3 0 0 1 .94 0c.35.06.66.2.95.37a17.11 17.11 0 0 0 .8.45c.1-.08.2-.2.41-.4l.04-.03a27 27 0 0 1 1.95-1.84 4.03 4.03 0 0 1 1.91-.94 4 4 0 0 1 1.25 0c.73.11 1.33.46 1.91.94l.64.55V9.2c0-1.52 0-2.58-.1-3.4a3.1 3.1 0 0 0-.48-1.56 3 3 0 0 0-.66-.67 3.1 3.1 0 0 0-1.56-.48C13.37 3 12.3 3 10.79 3h-1.6c-1.52 0-2.59 0-3.4.09Zm11.18 10-.04-.05a26.24 26.24 0 0 0-1.83-1.74c-.45-.36-.73-.48-.97-.52a2 2 0 0 0-.63 0c-.24.04-.51.16-.97.52-.46.38-1.01.93-1.83 1.74l-.02.02c-.17.18-.34.34-.49.47a2.04 2.04 0 0 1-1.08.5 1.97 1.97 0 0 1-1.25-.27l-.79-.46-.02-.02a.65.65 0 0 0-.24-.1 1 1 0 0 0-.31 0c-.08.02-.21.06-.49.28-.3.24-.65.59-1.2 1.14l-.56.56-.65.66a3 3 0 0 0 .62.6c.33.24.77.4 1.57.49.81.09 1.88.09 3.4.09h1.6c1.52 0 2.58 0 3.4-.09a3.1 3.1 0 0 0 1.56-.48 3 3 0 0 0 .66-.67c.24-.32.4-.77.49-1.56l.07-1.12Zm-8.02-1.03ZM4.99 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z"
    clip-rule="evenodd"
  />
</svg>`, Pse = ke`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M8 0a1 1 0 0 1 1 1v5.38a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1ZM5.26 2.6a1 1 0 0 1-.28 1.39 5.46 5.46 0 1 0 6.04 0 1 1 0 1 1 1.1-1.67 7.46 7.46 0 1 1-8.25 0 1 1 0 0 1 1.4.28Z"
    clip-rule="evenodd"
  />
</svg>`, Kse = ke` <svg
  width="36"
  height="36"
  fill="none"
>
  <path
    d="M0 8a8 8 0 0 1 8-8h20a8 8 0 0 1 8 8v20a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z"
    fill="#fff"
    fill-opacity=".05"
  />
  <path
    d="m18.262 17.513-8.944 9.49v.01a2.417 2.417 0 0 0 3.56 1.452l.026-.017 10.061-5.803-4.703-5.132Z"
    fill="#EA4335"
  />
  <path
    d="m27.307 15.9-.008-.008-4.342-2.52-4.896 4.36 4.913 4.912 4.325-2.494a2.42 2.42 0 0 0 .008-4.25Z"
    fill="#FBBC04"
  />
  <path
    d="M9.318 8.997c-.05.202-.084.403-.084.622V26.39c0 .218.025.42.084.621l9.246-9.247-9.246-8.768Z"
    fill="#4285F4"
  />
  <path
    d="m18.33 18 4.627-4.628-10.053-5.828a2.427 2.427 0 0 0-3.586 1.444L18.329 18Z"
    fill="#34A853"
  />
  <path
    d="M8 .5h20A7.5 7.5 0 0 1 35.5 8v20a7.5 7.5 0 0 1-7.5 7.5H8A7.5 7.5 0 0 1 .5 28V8A7.5 7.5 0 0 1 8 .5Z"
    stroke="#fff"
    stroke-opacity=".05"
  />
</svg>`, $se = ke`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    d="M3 6a3 3 0 0 1 3-3h1a1 1 0 1 0 0-2H6a5 5 0 0 0-5 5v1a1 1 0 0 0 2 0V6ZM13 1a1 1 0 1 0 0 2h1a3 3 0 0 1 3 3v1a1 1 0 1 0 2 0V6a5 5 0 0 0-5-5h-1ZM3 13a1 1 0 1 0-2 0v1a5 5 0 0 0 5 5h1a1 1 0 1 0 0-2H6a3 3 0 0 1-3-3v-1ZM19 13a1 1 0 1 0-2 0v1a3 3 0 0 1-3 3h-1a1 1 0 1 0 0 2h1.01a5 5 0 0 0 5-5v-1ZM5.3 6.36c-.04.2-.04.43-.04.89s0 .7.05.89c.14.52.54.92 1.06 1.06.19.05.42.05.89.05.46 0 .7 0 .88-.05A1.5 1.5 0 0 0 9.2 8.14c.06-.2.06-.43.06-.89s0-.7-.06-.89A1.5 1.5 0 0 0 8.14 5.3c-.19-.05-.42-.05-.88-.05-.47 0-.7 0-.9.05a1.5 1.5 0 0 0-1.05 1.06ZM10.8 6.36c-.04.2-.04.43-.04.89s0 .7.05.89c.14.52.54.92 1.06 1.06.19.05.42.05.89.05.46 0 .7 0 .88-.05a1.5 1.5 0 0 0 1.06-1.06c.06-.2.06-.43.06-.89s0-.7-.06-.89a1.5 1.5 0 0 0-1.06-1.06c-.19-.05-.42-.05-.88-.05-.47 0-.7 0-.9.05a1.5 1.5 0 0 0-1.05 1.06ZM5.26 12.75c0-.46 0-.7.05-.89a1.5 1.5 0 0 1 1.06-1.06c.19-.05.42-.05.89-.05.46 0 .7 0 .88.05.52.14.93.54 1.06 1.06.06.2.06.43.06.89s0 .7-.06.89a1.5 1.5 0 0 1-1.06 1.06c-.19.05-.42.05-.88.05-.47 0-.7 0-.9-.05a1.5 1.5 0 0 1-1.05-1.06c-.05-.2-.05-.43-.05-.89ZM10.8 11.86c-.04.2-.04.43-.04.89s0 .7.05.89c.14.52.54.92 1.06 1.06.19.05.42.05.89.05.46 0 .7 0 .88-.05a1.5 1.5 0 0 0 1.06-1.06c.06-.2.06-.43.06-.89s0-.7-.06-.89a1.5 1.5 0 0 0-1.06-1.06c-.19-.05-.42-.05-.88-.05-.47 0-.7 0-.9.05a1.5 1.5 0 0 0-1.05 1.06Z"
  />
</svg>`, qse = ke`<svg fill="none" viewBox="0 0 14 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M3.94 1.04a1 1 0 0 1 .7 1.23l-.48 1.68a5.85 5.85 0 0 1 8.53 4.32 5.86 5.86 0 0 1-11.4 2.56 1 1 0 0 1 1.9-.57 3.86 3.86 0 1 0 1.83-4.5l1.87.53a1 1 0 0 1-.55 1.92l-4.1-1.15a1 1 0 0 1-.69-1.23l1.16-4.1a1 1 0 0 1 1.23-.7Z"
    clip-rule="evenodd"
  />
</svg>`, ele = ke`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M9.36 4.21a5.14 5.14 0 1 0 0 10.29 5.14 5.14 0 0 0 0-10.29ZM1.64 9.36a7.71 7.71 0 1 1 14 4.47l2.52 2.5a1.29 1.29 0 1 1-1.82 1.83l-2.51-2.51A7.71 7.71 0 0 1 1.65 9.36Z"
    clip-rule="evenodd"
  />
</svg>`, tle = ke`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M6.76.3a1 1 0 0 1 0 1.4L4.07 4.4h9a1 1 0 1 1 0 2h-9l2.69 2.68a1 1 0 1 1-1.42 1.42L.95 6.09a1 1 0 0 1 0-1.4l4.4-4.4a1 1 0 0 1 1.4 0Zm6.49 9.21a1 1 0 0 1 1.41 0l4.39 4.4a1 1 0 0 1 0 1.4l-4.39 4.4a1 1 0 0 1-1.41-1.42l2.68-2.68h-9a1 1 0 0 1 0-2h9l-2.68-2.68a1 1 0 0 1 0-1.42Z"
    clip-rule="evenodd"
  />
</svg>`, nle = ke`<svg width="10" height="10" viewBox="0 0 10 10">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M3.77986 0.566631C4.0589 0.845577 4.0589 1.29784 3.77986 1.57678L3.08261 2.2738H6.34184C6.73647 2.2738 7.05637 2.5936 7.05637 2.98808C7.05637 3.38257 6.73647 3.70237 6.34184 3.70237H3.08261L3.77986 4.39938C4.0589 4.67833 4.0589 5.13059 3.77986 5.40954C3.50082 5.68848 3.04841 5.68848 2.76937 5.40954L0.852346 3.49316C0.573306 3.21421 0.573306 2.76195 0.852346 2.48301L2.76937 0.566631C3.04841 0.287685 3.50082 0.287685 3.77986 0.566631ZM6.22 4.59102C6.49904 4.31208 6.95145 4.31208 7.23049 4.59102L9.14751 6.5074C9.42655 6.78634 9.42655 7.23861 9.14751 7.51755L7.23049 9.43393C6.95145 9.71287 6.49904 9.71287 6.22 9.43393C5.94096 9.15498 5.94096 8.70272 6.22 8.42377L6.91725 7.72676L3.65802 7.72676C3.26339 7.72676 2.94349 7.40696 2.94349 7.01247C2.94349 6.61798 3.26339 6.29819 3.65802 6.29819L6.91725 6.29819L6.22 5.60117C5.94096 5.32223 5.94096 4.86997 6.22 4.59102Z"
    clip-rule="evenodd"
  />
</svg>`, rle = ke`<svg fill="none" viewBox="0 0 14 14">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M3.48 2.18a1 1 0 0 1 1.41 0l2.68 2.68a1 1 0 1 1-1.41 1.42l-.98-.98v4.56a1 1 0 0 1-2 0V5.3l-.97.98A1 1 0 0 1 .79 4.86l2.69-2.68Zm6.34 2.93a1 1 0 0 1 1 1v4.56l.97-.98a1 1 0 1 1 1.42 1.42l-2.69 2.68a1 1 0 0 1-1.41 0l-2.68-2.68a1 1 0 0 1 1.41-1.42l.98.98V6.1a1 1 0 0 1 1-1Z"
    clip-rule="evenodd"
  />
</svg>`, ile = ke`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#5865F2" />
      <path
        fill="#fff"
        fill-rule="evenodd"
        d="M25.71 28.15C30.25 28 32 25.02 32 25.02c0-6.61-2.96-11.98-2.96-11.98-2.96-2.22-5.77-2.15-5.77-2.15l-.29.32c3.5 1.07 5.12 2.61 5.12 2.61a16.75 16.75 0 0 0-10.34-1.93l-.35.04a15.43 15.43 0 0 0-5.88 1.9s1.71-1.63 5.4-2.7l-.2-.24s-2.81-.07-5.77 2.15c0 0-2.96 5.37-2.96 11.98 0 0 1.73 2.98 6.27 3.13l1.37-1.7c-2.6-.79-3.6-2.43-3.6-2.43l.58.35.09.06.08.04.02.01.08.05a17.25 17.25 0 0 0 4.52 1.58 14.4 14.4 0 0 0 8.3-.86c.72-.27 1.52-.66 2.37-1.21 0 0-1.03 1.68-3.72 2.44.61.78 1.35 1.67 1.35 1.67Zm-9.55-9.6c-1.17 0-2.1 1.03-2.1 2.28 0 1.25.95 2.28 2.1 2.28 1.17 0 2.1-1.03 2.1-2.28.01-1.25-.93-2.28-2.1-2.28Zm7.5 0c-1.17 0-2.1 1.03-2.1 2.28 0 1.25.95 2.28 2.1 2.28 1.17 0 2.1-1.03 2.1-2.28 0-1.25-.93-2.28-2.1-2.28Z"
        clip-rule="evenodd"
      />
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
  </defs>
</svg> `, ale = ke`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#5A3E85" />
      <g clip-path="url(#c)">
        <path
          fill="#fff"
          d="M18.22 25.7 20 23.91h3.34l2.1-2.1v-6.68H15.4v8.78h2.82v1.77Zm3.87-8.16h1.25v3.66H22.1v-3.66Zm-3.34 0H20v3.66h-1.25v-3.66ZM20 7.9a12 12 0 1 0 0 24 12 12 0 0 0 0-24Zm6.69 14.56-3.66 3.66h-2.72l-1.77 1.78h-1.88V26.1H13.3v-9.82l.94-2.4H26.7v8.56Z"
        />
      </g>
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>
  </defs>
</svg>`, ole = ke`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#1D9BF0" />
      <path
        fill="#fff"
        d="M30 13.81c-.74.33-1.53.55-2.36.65.85-.51 1.5-1.32 1.8-2.27-.79.47-1.66.8-2.6 1a4.1 4.1 0 0 0-7 3.73c-3.4-.17-6.42-1.8-8.45-4.28a4.1 4.1 0 0 0 1.27 5.47c-.67-.02-1.3-.2-1.86-.5a4.1 4.1 0 0 0 3.3 4.07c-.58.15-1.21.19-1.86.07a4.1 4.1 0 0 0 3.83 2.85A8.25 8.25 0 0 1 10 26.3a11.62 11.62 0 0 0 6.29 1.84c7.62 0 11.92-6.44 11.66-12.2.8-.59 1.5-1.3 2.05-2.13Z"
      />
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
  </defs>
</svg>`, sle = ke`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    d="m14.36 4.74.01.42c0 4.34-3.3 9.34-9.34 9.34A9.3 9.3 0 0 1 0 13.03a6.6 6.6 0 0 0 4.86-1.36 3.29 3.29 0 0 1-3.07-2.28c.5.1 1 .07 1.48-.06A3.28 3.28 0 0 1 .64 6.11v-.04c.46.26.97.4 1.49.41A3.29 3.29 0 0 1 1.11 2.1a9.32 9.32 0 0 0 6.77 3.43 3.28 3.28 0 0 1 5.6-3 6.59 6.59 0 0 0 2.08-.8 3.3 3.3 0 0 1-1.45 1.82A6.53 6.53 0 0 0 16 3.04c-.44.66-1 1.23-1.64 1.7Z"
  />
</svg>`, lle = ke`<svg fill="none" viewBox="0 0 28 28">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M18.1 4.76c-.42-.73-1.33-1.01-2.09-.66l-1.42.66c-.37.18-.8.18-1.18 0l-1.4-.65a1.63 1.63 0 0 0-2.1.66l-.84 1.45c-.2.34-.53.59-.92.67l-1.7.35c-.83.17-1.39.94-1.3 1.78l.19 1.56c.04.39-.08.78-.33 1.07l-1.12 1.3c-.52.6-.52 1.5 0 2.11L5 16.38c.25.3.37.68.33 1.06l-.18 1.57c-.1.83.46 1.6 1.28 1.78l1.7.35c.4.08.73.32.93.66l.84 1.43a1.63 1.63 0 0 0 2.09.66l1.41-.66c.37-.17.8-.17 1.18 0l1.43.67c.76.35 1.66.07 2.08-.65l.86-1.45c.2-.34.54-.58.92-.66l1.68-.35A1.63 1.63 0 0 0 22.84 19l-.18-1.57a1.4 1.4 0 0 1 .33-1.06l1.12-1.32c.52-.6.52-1.5 0-2.11l-1.12-1.3a1.4 1.4 0 0 1-.33-1.07l.18-1.57c.1-.83-.46-1.6-1.28-1.77l-1.68-.35a1.4 1.4 0 0 1-.92-.66l-.86-1.47Zm-3.27-3.2a4.43 4.43 0 0 1 5.69 1.78l.54.93 1.07.22a4.43 4.43 0 0 1 3.5 4.84l-.11.96.7.83a4.43 4.43 0 0 1 .02 5.76l-.72.85.1.96a4.43 4.43 0 0 1-3.5 4.84l-1.06.22-.54.92a4.43 4.43 0 0 1-5.68 1.77l-.84-.4-.82.39a4.43 4.43 0 0 1-5.7-1.79l-.51-.89-1.09-.22a4.43 4.43 0 0 1-3.5-4.84l.1-.96-.72-.85a4.43 4.43 0 0 1 .01-5.76l.71-.83-.1-.95a4.43 4.43 0 0 1 3.5-4.84l1.08-.23.53-.9a4.43 4.43 0 0 1 5.7-1.8l.81.38.83-.39ZM18.2 9.4c.65.42.84 1.28.42 1.93l-4.4 6.87a1.4 1.4 0 0 1-2.26.14L9.5 15.39a1.4 1.4 0 0 1 2.15-1.8l1.23 1.48 3.38-5.26a1.4 1.4 0 0 1 1.93-.42Z"
    clip-rule="evenodd"
  />
</svg>`, cle = ke`
  <svg fill="none" viewBox="0 0 48 44">
    <path
      style="fill: var(--wui-color-bg-300);"
      d="M4.56 8.64c-1.23 1.68-1.23 4.08-1.23 8.88v8.96c0 4.8 0 7.2 1.23 8.88.39.55.87 1.02 1.41 1.42C7.65 38 10.05 38 14.85 38h14.3c4.8 0 7.2 0 8.88-1.22a6.4 6.4 0 0 0 1.41-1.42c.83-1.14 1.1-2.6 1.19-4.92a6.4 6.4 0 0 0 5.16-4.65c.21-.81.21-1.8.21-3.79 0-1.98 0-2.98-.22-3.79a6.4 6.4 0 0 0-5.15-4.65c-.1-2.32-.36-3.78-1.19-4.92a6.4 6.4 0 0 0-1.41-1.42C36.35 6 33.95 6 29.15 6h-14.3c-4.8 0-7.2 0-8.88 1.22a6.4 6.4 0 0 0-1.41 1.42Z"
    />
    <path
      style="fill: var(--wui-color-fg-200);"
      fill-rule="evenodd"
      d="M2.27 11.33a6.4 6.4 0 0 1 6.4-6.4h26.66a6.4 6.4 0 0 1 6.4 6.4v1.7a6.4 6.4 0 0 1 5.34 6.3v5.34a6.4 6.4 0 0 1-5.34 6.3v1.7a6.4 6.4 0 0 1-6.4 6.4H8.67a6.4 6.4 0 0 1-6.4-6.4V11.33ZM39.6 31.07h-6.93a9.07 9.07 0 1 1 0-18.14h6.93v-1.6a4.27 4.27 0 0 0-4.27-4.26H8.67a4.27 4.27 0 0 0-4.27 4.26v21.34a4.27 4.27 0 0 0 4.27 4.26h26.66a4.27 4.27 0 0 0 4.27-4.26v-1.6Zm-6.93-16a6.93 6.93 0 0 0 0 13.86h8a4.27 4.27 0 0 0 4.26-4.26v-5.34a4.27 4.27 0 0 0-4.26-4.26h-8Z"
      clip-rule="evenodd"
    />
  </svg>
`, dle = ke`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M0 5.5c0-1.8 1.46-3.25 3.25-3.25H14.5c1.8 0 3.25 1.46 3.25 3.25v.28A3.25 3.25 0 0 1 20 8.88v2.24c0 1.45-.94 2.68-2.25 3.1v.28c0 1.8-1.46 3.25-3.25 3.25H3.25A3.25 3.25 0 0 1 0 14.5v-9Zm15.75 8.88h-2.38a4.38 4.38 0 0 1 0-8.76h2.38V5.5c0-.69-.56-1.25-1.25-1.25H3.25C2.56 4.25 2 4.81 2 5.5v9c0 .69.56 1.25 1.25 1.25H14.5c.69 0 1.25-.56 1.25-1.25v-.13Zm-2.38-6.76a2.37 2.37 0 1 0 0 4.75h3.38c.69 0 1.25-.55 1.25-1.24V8.87c0-.69-.56-1.24-1.25-1.24h-3.38Z"
    clip-rule="evenodd"
  />
</svg>`, ule = ke`<svg fill="none" viewBox="0 0 96 67">
  <path
    fill="currentColor"
    d="M25.32 18.8a32.56 32.56 0 0 1 45.36 0l1.5 1.47c.63.62.63 1.61 0 2.22l-5.15 5.05c-.31.3-.82.3-1.14 0l-2.07-2.03a22.71 22.71 0 0 0-31.64 0l-2.22 2.18c-.31.3-.82.3-1.14 0l-5.15-5.05a1.55 1.55 0 0 1 0-2.22l1.65-1.62Zm56.02 10.44 4.59 4.5c.63.6.63 1.6 0 2.21l-20.7 20.26c-.62.61-1.63.61-2.26 0L48.28 41.83a.4.4 0 0 0-.56 0L33.03 56.21c-.63.61-1.64.61-2.27 0L10.07 35.95a1.55 1.55 0 0 1 0-2.22l4.59-4.5a1.63 1.63 0 0 1 2.27 0L31.6 43.63a.4.4 0 0 0 .57 0l14.69-14.38a1.63 1.63 0 0 1 2.26 0l14.69 14.38a.4.4 0 0 0 .57 0l14.68-14.38a1.63 1.63 0 0 1 2.27 0Z"
  />
  <path
    stroke="#000"
    stroke-opacity=".1"
    d="M25.67 19.15a32.06 32.06 0 0 1 44.66 0l1.5 1.48c.43.42.43 1.09 0 1.5l-5.15 5.05a.31.31 0 0 1-.44 0l-2.07-2.03a23.21 23.21 0 0 0-32.34 0l-2.22 2.18a.31.31 0 0 1-.44 0l-5.15-5.05a1.05 1.05 0 0 1 0-1.5l1.65-1.63ZM81 29.6l4.6 4.5c.42.41.42 1.09 0 1.5l-20.7 20.26c-.43.43-1.14.43-1.57 0L48.63 41.47a.9.9 0 0 0-1.26 0L32.68 55.85c-.43.43-1.14.43-1.57 0L10.42 35.6a1.05 1.05 0 0 1 0-1.5l4.59-4.5a1.13 1.13 0 0 1 1.57 0l14.68 14.38a.9.9 0 0 0 1.27 0l-.35-.35.35.35L47.22 29.6a1.13 1.13 0 0 1 1.56 0l14.7 14.38a.9.9 0 0 0 1.26 0L79.42 29.6a1.13 1.13 0 0 1 1.57 0Z"
  />
</svg>`, hle = ke`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    d="M11 6.67a1 1 0 1 0-2 0v2.66a1 1 0 0 0 2 0V6.67ZM10 14.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
  />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-7 9a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z"
    clip-rule="evenodd"
  />
</svg>`;
var uU = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
const Nle = {
  allWallets: Mse,
  appStore: pse,
  chromeStore: Sse,
  apple: mse,
  arrowBottom: Tse,
  arrowLeft: fse,
  arrowRight: Vse,
  arrowTop: Use,
  browser: Rse,
  checkmark: gse,
  chevronBottom: yse,
  chevronLeft: Zse,
  chevronRight: bse,
  chevronTop: Ese,
  clock: xse,
  close: Wse,
  compass: Dse,
  coinPlaceholder: jse,
  copy: zse,
  cursor: kse,
  desktop: wse,
  disconnect: Fse,
  discord: vse,
  etherscan: Ise,
  extension: Ose,
  externalLink: Yse,
  facebook: Qse,
  filters: Gse,
  github: Cse,
  google: Lse,
  helpCircle: Jse,
  infoCircle: Bse,
  mail: Ase,
  mobile: Hse,
  networkPlaceholder: Xse,
  nftPlaceholder: _se,
  off: Pse,
  playStore: Kse,
  qrCode: $se,
  refresh: qse,
  search: ele,
  swapHorizontal: tle,
  swapHorizontalBold: nle,
  swapVertical: rle,
  telegram: ile,
  twitch: ale,
  twitter: ole,
  twitterIcon: sle,
  verify: lle,
  wallet: dle,
  walletConnect: ule,
  walletPlaceholder: cle,
  warningCircle: hle
};
let oh = class extends be {
  constructor() {
    super(...arguments), this.size = "md", this.name = "copy", this.color = "fg-300";
  }
  render() {
    return this.style.cssText = `
      --local-color: ${`var(--wui-color-${this.color});`}
      --local-width: ${`var(--wui-icon-size-${this.size});`}
    `, _`${Nle[this.name]}`;
  }
};
oh.styles = [Rt, sS, Nse];
uU([
  te()
], oh.prototype, "size", void 0);
uU([
  te()
], oh.prototype, "name", void 0);
uU([
  te()
], oh.prototype, "color", void 0);
oh = uU([
  Ze("wui-icon")
], oh);
const Mle = ze`
  :host {
    display: block;
    width: 100%;
    height: 100%;
  }

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    border-radius: inherit;
  }
`;
var lS = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let NM = class extends be {
  constructor() {
    super(...arguments), this.src = "./path/to/image.jpg", this.alt = "Image";
  }
  render() {
    return _`<img src=${this.src} alt=${this.alt} />`;
  }
};
NM.styles = [Rt, sS, Mle];
lS([
  te()
], NM.prototype, "src", void 0);
lS([
  te()
], NM.prototype, "alt", void 0);
NM = lS([
  Ze("wui-image")
], NM);
const ple = ze`
  :host {
    display: block;
    width: var(--wui-box-size-lg);
    height: var(--wui-box-size-lg);
  }

  svg {
    width: var(--wui-box-size-lg);
    height: var(--wui-box-size-lg);
    fill: none;
    stroke: transparent;
    stroke-linecap: round;
    transition: all var(--wui-ease-in-power-3) var(--wui-duration-lg);
  }

  use {
    stroke: var(--wui-color-accent-100);
    stroke-width: 2px;
    stroke-dasharray: 54, 118;
    stroke-dashoffset: 172;
    animation: dash 1s linear infinite;
  }

  @keyframes dash {
    to {
      stroke-dashoffset: 0px;
    }
  }
`;
var mle = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let nb = class extends be {
  render() {
    return _`
      <svg viewBox="0 0 54 59">
        <path
          id="wui-loader-path"
          d="M17.22 5.295c3.877-2.277 5.737-3.363 7.72-3.726a11.44 11.44 0 0 1 4.12 0c1.983.363 3.844 1.45 7.72 3.726l6.065 3.562c3.876 2.276 5.731 3.372 7.032 4.938a11.896 11.896 0 0 1 2.06 3.63c.683 1.928.688 4.11.688 8.663v7.124c0 4.553-.005 6.735-.688 8.664a11.896 11.896 0 0 1-2.06 3.63c-1.3 1.565-3.156 2.66-7.032 4.937l-6.065 3.563c-3.877 2.276-5.737 3.362-7.72 3.725a11.46 11.46 0 0 1-4.12 0c-1.983-.363-3.844-1.449-7.72-3.726l-6.065-3.562c-3.876-2.276-5.731-3.372-7.032-4.938a11.885 11.885 0 0 1-2.06-3.63c-.682-1.928-.688-4.11-.688-8.663v-7.124c0-4.553.006-6.735.688-8.664a11.885 11.885 0 0 1 2.06-3.63c1.3-1.565 3.156-2.66 7.032-4.937l6.065-3.562Z"
        />
        <use xlink:href="#wui-loader-path"></use>
      </svg>
    `;
  }
};
nb.styles = [Rt, ple];
nb = mle([
  Ze("wui-loading-hexagon")
], nb);
const Tle = ze`
  :host {
    display: flex;
  }

  :host([data-size='sm']) > svg {
    width: 12px;
    height: 12px;
  }

  :host([data-size='md']) > svg {
    width: 16px;
    height: 16px;
  }

  :host([data-size='lg']) > svg {
    width: 24px;
    height: 24px;
  }

  :host([data-size='xl']) > svg {
    width: 32px;
    height: 32px;
  }

  svg {
    animation: rotate 2s linear infinite;
    transition: all var(--wui-ease-in-power-3) var(--wui-duration-lg);
  }

  circle {
    fill: none;
    stroke: var(--local-color);
    stroke-width: 4px;
    stroke-dasharray: 1, 124;
    stroke-dashoffset: 0;
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  :host([data-size='md']) > svg > circle {
    stroke-width: 6px;
  }

  :host([data-size='sm']) > svg > circle {
    stroke-width: 8px;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 124;
      stroke-dashoffset: 0;
    }

    50% {
      stroke-dasharray: 90, 124;
      stroke-dashoffset: -35;
    }

    100% {
      stroke-dashoffset: -125;
    }
  }
`;
var cS = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let MM = class extends be {
  constructor() {
    super(...arguments), this.color = "accent-100", this.size = "lg";
  }
  render() {
    return this.style.cssText = `--local-color: var(--wui-color-${this.color});`, this.dataset.size = this.size, _`<svg viewBox="25 25 50 50">
      <circle r="20" cy="50" cx="50"></circle>
    </svg>`;
  }
};
MM.styles = [Rt, Tle];
cS([
  te()
], MM.prototype, "color", void 0);
cS([
  te()
], MM.prototype, "size", void 0);
MM = cS([
  Ze("wui-loading-spinner")
], MM);
const fle = ze`
  :host {
    display: block;
    width: var(--wui-box-size-md);
    height: var(--wui-box-size-md);
  }

  svg {
    width: var(--wui-box-size-md);
    height: var(--wui-box-size-md);
    transition: all var(--wui-ease-in-power-3) var(--wui-duration-lg);
  }

  rect {
    fill: none;
    stroke: var(--wui-color-accent-100);
    stroke-width: 4px;
    stroke-linecap: round;
    animation: dash 1s linear infinite;
  }

  @keyframes dash {
    to {
      stroke-dashoffset: 0px;
    }
  }
`;
var nQ = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let aV = class extends be {
  constructor() {
    super(...arguments), this.radius = 36;
  }
  render() {
    return this.svgLoaderTemplate();
  }
  svgLoaderTemplate() {
    const e = this.radius > 50 ? 50 : this.radius, r = 36 - e, i = 116 + r, a = 245 + r, o = 360 + r * 1.75;
    return _`
      <svg viewBox="0 0 110 110" width="110" height="110">
        <rect
          x="2"
          y="2"
          width="106"
          height="106"
          rx=${e}
          stroke-dasharray="${i} ${a}"
          stroke-dashoffset=${o}
        />
      </svg>
    `;
  }
};
aV.styles = [Rt, fle];
nQ([
  te({ type: Number })
], aV.prototype, "radius", void 0);
aV = nQ([
  Ze("wui-loading-thumbnail")
], aV);
const Vle = ze`
  :host {
    display: block;
    box-shadow: inset 0 0 0 1px var(--wui-gray-glass-005);
    background: linear-gradient(
      120deg,
      var(--wui-color-bg-200) 5%,
      var(--wui-color-bg-200) 48%,
      var(--wui-color-bg-300) 55%,
      var(--wui-color-bg-300) 60%,
      var(--wui-color-bg-300) calc(60% + 10px),
      var(--wui-color-bg-200) calc(60% + 12px),
      var(--wui-color-bg-200) 100%
    );
    background-size: 250%;
    animation: shimmer 3s linear infinite reverse;
  }

  @keyframes shimmer {
    from {
      background-position: -250% 0;
    }
    to {
      background-position: 250% 0;
    }
  }
`;
var hU = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let sh = class extends be {
  constructor() {
    super(...arguments), this.width = "", this.height = "", this.borderRadius = "m";
  }
  render() {
    return this.style.cssText = `
      width: ${this.width};
      height: ${this.height};
      border-radius: ${`clamp(0px,var(--wui-border-radius-${this.borderRadius}), 40px)`};
    `, _`<slot></slot>`;
  }
};
sh.styles = [Vle];
hU([
  te()
], sh.prototype, "width", void 0);
hU([
  te()
], sh.prototype, "height", void 0);
hU([
  te()
], sh.prototype, "borderRadius", void 0);
sh = hU([
  Ze("wui-shimmer")
], sh);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const rQ = { ATTRIBUTE: 1, CHILD: 2, PROPERTY: 3, BOOLEAN_ATTRIBUTE: 4, EVENT: 5, ELEMENT: 6 }, iQ = (t) => (...e) => ({ _$litDirective$: t, values: e });
let aQ = class {
  constructor(e) {
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AT(e, n, r) {
    this._$Ct = e, this._$AM = n, this._$Ci = r;
  }
  _$AS(e, n) {
    return this.update(e, n);
  }
  update(e, n) {
    return this.render(...n);
  }
};
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Ule = iQ(class extends aQ {
  constructor(t) {
    var e;
    if (super(t), t.type !== rQ.ATTRIBUTE || t.name !== "class" || ((e = t.strings) == null ? void 0 : e.length) > 2)
      throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
  }
  render(t) {
    return " " + Object.keys(t).filter((e) => t[e]).join(" ") + " ";
  }
  update(t, [e]) {
    var r, i;
    if (this.it === void 0) {
      this.it = /* @__PURE__ */ new Set(), t.strings !== void 0 && (this.st = new Set(t.strings.join(" ").split(/\s/).filter((a) => a !== "")));
      for (const a in e)
        e[a] && !((r = this.st) != null && r.has(a)) && this.it.add(a);
      return this.render(e);
    }
    const n = t.element.classList;
    for (const a of this.it)
      a in e || (n.remove(a), this.it.delete(a));
    for (const a in e) {
      const o = !!e[a];
      o === this.it.has(a) || (i = this.st) != null && i.has(a) || (o ? (n.add(a), this.it.add(a)) : (n.remove(a), this.it.delete(a)));
    }
    return Od;
  }
}), Rle = ze`
  :host {
    display: flex !important;
  }

  slot {
    display: inline-block;
    font-style: normal;
    font-family: var(--wui-font-family);
    font-feature-settings:
      'tnum' on,
      'lnum' on,
      'case' on;
    line-height: 130%;
    font-weight: var(--wui-font-weight-regular);
    overflow: inherit;
    text-overflow: inherit;
    text-align: var(--local-align);
    color: var(--local-color);
  }

  .wui-font-large-500,
  .wui-font-large-600,
  .wui-font-large-700 {
    font-size: var(--wui-font-size-large);
    letter-spacing: var(--wui-letter-spacing-large);
  }

  .wui-font-paragraph-500,
  .wui-font-paragraph-600,
  .wui-font-paragraph-700 {
    font-size: var(--wui-font-size-paragraph);
    letter-spacing: var(--wui-letter-spacing-paragraph);
  }

  .wui-font-small-400,
  .wui-font-small-500,
  .wui-font-small-600 {
    font-size: var(--wui-font-size-small);
    letter-spacing: var(--wui-letter-spacing-small);
  }

  .wui-font-tiny-500,
  .wui-font-tiny-600 {
    font-size: var(--wui-font-size-tiny);
    letter-spacing: var(--wui-letter-spacing-tiny);
  }

  .wui-font-micro-700,
  .wui-font-micro-600 {
    font-size: var(--wui-font-size-micro);
    letter-spacing: var(--wui-letter-spacing-micro);
    text-transform: uppercase;
  }

  .wui-font-small-400,
  .wui-font-paragraph-400 {
    font-weight: var(--wui-font-weight-light);
  }

  .wui-font-large-700,
  .wui-font-paragraph-700,
  .wui-font-micro-700 {
    font-weight: var(--wui-font-weight-bold);
  }

  .wui-font-large-600,
  .wui-font-paragraph-600,
  .wui-font-small-600,
  .wui-font-tiny-600,
  .wui-font-micro-600 {
    font-weight: var(--wui-font-weight-medium);
  }
`;
var NU = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let lh = class extends be {
  constructor() {
    super(...arguments), this.variant = "paragraph-500", this.color = "fg-300", this.align = "left";
  }
  render() {
    const e = {
      [`wui-font-${this.variant}`]: !0,
      [`wui-color-${this.color}`]: !0
    };
    return this.style.cssText = `
      --local-align: ${this.align};
      --local-color: var(--wui-color-${this.color});
    `, _`<slot class=${Ule(e)}></slot>`;
  }
};
lh.styles = [Rt, Rle];
NU([
  te()
], lh.prototype, "variant", void 0);
NU([
  te()
], lh.prototype, "color", void 0);
NU([
  te()
], lh.prototype, "align", void 0);
lh = NU([
  Ze("wui-text")
], lh);
const gle = ke`<svg fill="none" viewBox="0 0 60 60">
  <rect width="60" height="60" fill="#1DC956" rx="30" />
  <circle cx="30" cy="30" r="3" fill="#fff" />
  <path
    fill="#2BEE6C"
    stroke="#fff"
    stroke-width="2"
    d="m45.32 17.9-.88-.42.88.42.02-.05c.1-.2.21-.44.26-.7l-.82-.15.82.16a2 2 0 0 0-.24-1.4c-.13-.23-.32-.42-.47-.57a8.42 8.42 0 0 1-.04-.04l-.04-.04a2.9 2.9 0 0 0-.56-.47l-.51.86.5-.86a2 2 0 0 0-1.4-.24c-.26.05-.5.16-.69.26l-.05.02-15.05 7.25-.1.05c-1.14.55-1.85.89-2.46 1.37a7 7 0 0 0-1.13 1.14c-.5.6-.83 1.32-1.38 2.45l-.05.11-7.25 15.05-.02.05c-.1.2-.21.43-.26.69a2 2 0 0 0 .24 1.4l.85-.5-.85.5c.13.23.32.42.47.57l.04.04.04.04c.15.15.34.34.56.47a2 2 0 0 0 1.41.24l-.2-.98.2.98c.25-.05.5-.17.69-.26l.05-.02-.42-.87.42.87 15.05-7.25.1-.05c1.14-.55 1.85-.89 2.46-1.38a7 7 0 0 0 1.13-1.13 12.87 12.87 0 0 0 1.43-2.56l7.25-15.05Z"
  />
  <path
    fill="#1DC956"
    d="M33.38 32.72 30.7 29.3 15.86 44.14l.2.2a1 1 0 0 0 1.14.2l15.1-7.27a3 3 0 0 0 1.08-4.55Z"
  />
  <path
    fill="#86F999"
    d="m26.62 27.28 2.67 3.43 14.85-14.85-.2-.2a1 1 0 0 0-1.14-.2l-15.1 7.27a3 3 0 0 0-1.08 4.55Z"
  />
  <circle cx="30" cy="30" r="3" fill="#fff" transform="rotate(45 30 30)" />
  <rect width="59" height="59" x=".5" y=".5" stroke="#062B2B" stroke-opacity=".1" rx="29.5" />
</svg> `, yle = ke`<svg viewBox="0 0 60 60" fill="none">
  <g clip-path="url(#clip0_7734_50402)">
    <path
      d="M0 24.9C0 15.6485 0 11.0228 1.97053 7.56812C3.3015 5.23468 5.23468 3.3015 7.56812 1.97053C11.0228 0 15.6485 0 24.9 0H35.1C44.3514 0 48.9772 0 52.4319 1.97053C54.7653 3.3015 56.6985 5.23468 58.0295 7.56812C60 11.0228 60 15.6485 60 24.9V35.1C60 44.3514 60 48.9772 58.0295 52.4319C56.6985 54.7653 54.7653 56.6985 52.4319 58.0295C48.9772 60 44.3514 60 35.1 60H24.9C15.6485 60 11.0228 60 7.56812 58.0295C5.23468 56.6985 3.3015 54.7653 1.97053 52.4319C0 48.9772 0 44.3514 0 35.1V24.9Z"
      fill="#EB8B47"
    />
    <path
      d="M0.5 24.9C0.5 20.2652 0.50047 16.8221 0.744315 14.105C0.987552 11.3946 1.46987 9.45504 2.40484 7.81585C3.69145 5.56019 5.56019 3.69145 7.81585 2.40484C9.45504 1.46987 11.3946 0.987552 14.105 0.744315C16.8221 0.50047 20.2652 0.5 24.9 0.5H35.1C39.7348 0.5 43.1779 0.50047 45.895 0.744315C48.6054 0.987552 50.545 1.46987 52.1841 2.40484C54.4398 3.69145 56.3086 5.56019 57.5952 7.81585C58.5301 9.45504 59.0124 11.3946 59.2557 14.105C59.4995 16.8221 59.5 20.2652 59.5 24.9V35.1C59.5 39.7348 59.4995 43.1779 59.2557 45.895C59.0124 48.6054 58.5301 50.545 57.5952 52.1841C56.3086 54.4398 54.4398 56.3086 52.1841 57.5952C50.545 58.5301 48.6054 59.0124 45.895 59.2557C43.1779 59.4995 39.7348 59.5 35.1 59.5H24.9C20.2652 59.5 16.8221 59.4995 14.105 59.2557C11.3946 59.0124 9.45504 58.5301 7.81585 57.5952C5.56019 56.3086 3.69145 54.4398 2.40484 52.1841C1.46987 50.545 0.987552 48.6054 0.744315 45.895C0.50047 43.1779 0.5 39.7348 0.5 35.1V24.9Z"
      stroke="#062B2B"
      stroke-opacity="0.1"
    />
    <path
      d="M19 52C24.5228 52 29 47.5228 29 42C29 36.4772 24.5228 32 19 32C13.4772 32 9 36.4772 9 42C9 47.5228 13.4772 52 19 52Z"
      fill="#FF974C"
      stroke="white"
      stroke-width="2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M42.8437 8.3264C42.4507 7.70891 41.5493 7.70891 41.1564 8.32641L28.978 27.4638C28.5544 28.1295 29.0326 29.0007 29.8217 29.0007H54.1783C54.9674 29.0007 55.4456 28.1295 55.022 27.4638L42.8437 8.3264Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M42.3348 11.6456C42.659 11.7608 42.9061 12.1492 43.4005 12.926L50.7332 24.4488C51.2952 25.332 51.5763 25.7737 51.5254 26.1382C51.4915 26.3808 51.3698 26.6026 51.1833 26.7614C50.9031 27 50.3796 27 49.3327 27H34.6673C33.6204 27 33.0969 27 32.8167 26.7614C32.6302 26.6026 32.5085 26.3808 32.4746 26.1382C32.4237 25.7737 32.7048 25.332 33.2669 24.4488L40.5995 12.926C41.0939 12.1492 41.341 11.7608 41.6652 11.6456C41.8818 11.5687 42.1182 11.5687 42.3348 11.6456ZM35.0001 26.999C38.8661 26.999 42.0001 23.865 42.0001 19.999C42.0001 23.865 45.1341 26.999 49.0001 26.999H35.0001Z"
      fill="#FF974C"
    />
    <path
      d="M10.1061 9.35712C9.9973 9.67775 9.99867 10.0388 9.99978 10.3323C9.99989 10.3611 10 10.3893 10 10.4167V25.5833C10 25.6107 9.99989 25.6389 9.99978 25.6677C9.99867 25.9612 9.9973 26.3222 10.1061 26.6429C10.306 27.2317 10.7683 27.694 11.3571 27.8939C11.6777 28.0027 12.0388 28.0013 12.3323 28.0002C12.3611 28.0001 12.3893 28 12.4167 28H19C24.5228 28 29 23.5228 29 18C29 12.4772 24.5228 8 19 8H12.4167C12.3893 8 12.3611 7.99989 12.3323 7.99978C12.0388 7.99867 11.6778 7.9973 11.3571 8.10614C10.7683 8.306 10.306 8.76834 10.1061 9.35712Z"
      fill="#FF974C"
      stroke="white"
      stroke-width="2"
    />
    <circle cx="19" cy="18" r="4" fill="#EB8B47" stroke="white" stroke-width="2" />
    <circle cx="19" cy="42" r="4" fill="#EB8B47" stroke="white" stroke-width="2" />
  </g>
  <defs>
    <clipPath id="clip0_7734_50402">
      <rect width="60" height="60" fill="white" />
    </clipPath>
  </defs>
</svg> `, Zle = ke`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <path
      fill="#1DC956"
      d="M0 25.01c0-9.25 0-13.88 1.97-17.33a15 15 0 0 1 5.6-5.6C11.02.11 15.65.11 24.9.11h10.2c9.25 0 13.88 0 17.33 1.97a15 15 0 0 1 5.6 5.6C60 11.13 60 15.76 60 25v10.2c0 9.25 0 13.88-1.97 17.33a15 15 0 0 1-5.6 5.6c-3.45 1.97-8.08 1.97-17.33 1.97H24.9c-9.25 0-13.88 0-17.33-1.97a15 15 0 0 1-5.6-5.6C0 49.1 0 44.46 0 35.21v-10.2Z"
    />
    <path
      fill="#2BEE6C"
      d="M16.1 60c-3.82-.18-6.4-.64-8.53-1.86a15 15 0 0 1-5.6-5.6C.55 50.06.16 46.97.04 41.98L4.2 40.6a4 4 0 0 0 2.48-2.39l4.65-12.4a2 2 0 0 1 2.5-1.2l2.53.84a2 2 0 0 0 2.43-1l2.96-5.94a2 2 0 0 1 3.7.32l3.78 12.58a2 2 0 0 0 3.03 1.09l3.34-2.23a2 2 0 0 0 .65-.7l5.3-9.72a2 2 0 0 1 1.42-1.01l4.14-.69a2 2 0 0 1 1.6.44l3.9 3.24a2 2 0 0 0 2.7-.12l4.62-4.63c.08 2.2.08 4.8.08 7.93v10.2c0 9.25 0 13.88-1.97 17.33a15 15 0 0 1-5.6 5.6c-2.13 1.22-4.7 1.68-8.54 1.86H16.11Z"
    />
    <path
      fill="#fff"
      d="m.07 43.03-.05-2.1 3.85-1.28a3 3 0 0 0 1.86-1.79l4.66-12.4a3 3 0 0 1 3.75-1.8l2.53.84a1 1 0 0 0 1.21-.5l2.97-5.94a3 3 0 0 1 5.56.48l3.77 12.58a1 1 0 0 0 1.51.55l3.34-2.23a1 1 0 0 0 .33-.35l5.3-9.71a3 3 0 0 1 2.14-1.53l4.13-.69a3 3 0 0 1 2.41.66l3.9 3.24a1 1 0 0 0 1.34-.06l5.28-5.28c.05.85.08 1.75.1 2.73L56 22.41a3 3 0 0 1-4.04.19l-3.9-3.25a1 1 0 0 0-.8-.21l-4.13.69a1 1 0 0 0-.72.5l-5.3 9.72a3 3 0 0 1-.97 1.05l-3.34 2.23a3 3 0 0 1-4.53-1.63l-3.78-12.58a1 1 0 0 0-1.85-.16l-2.97 5.94a3 3 0 0 1-3.63 1.5l-2.53-.84a1 1 0 0 0-1.25.6l-4.65 12.4a5 5 0 0 1-3.1 3L.07 43.02Z"
    />
    <path
      fill="#fff"
      fill-rule="evenodd"
      d="M49.5 19a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"
      clip-rule="evenodd"
    />
    <path fill="#fff" d="M45 .28v59.66l-2 .1V.19c.7.02 1.37.05 2 .1Z" />
    <path fill="#2BEE6C" d="M47.5 19a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" />
    <path
      stroke="#fff"
      stroke-opacity=".1"
      d="M.5 25.01c0-4.63 0-8.08.24-10.8.25-2.7.73-4.64 1.66-6.28a14.5 14.5 0 0 1 5.42-5.41C9.46 1.58 11.39 1.1 14.1.85A133 133 0 0 1 24.9.61h10.2c4.63 0 8.08 0 10.8.24 2.7.25 4.65.73 6.28 1.67a14.5 14.5 0 0 1 5.42 5.4c.93 1.65 1.41 3.58 1.66 6.3.24 2.71.24 6.16.24 10.79v10.2c0 4.64 0 8.08-.24 10.8-.25 2.7-.73 4.65-1.66 6.28a14.5 14.5 0 0 1-5.42 5.42c-1.63.93-3.57 1.41-6.28 1.66-2.72.24-6.17.24-10.8.24H24.9c-4.63 0-8.08 0-10.8-.24-2.7-.25-4.64-.73-6.28-1.66a14.5 14.5 0 0 1-5.42-5.42C1.47 50.66 1 48.72.74 46.01A133 133 0 0 1 .5 35.2v-10.2Z"
    />
  </g>
  <defs>
    <clipPath id="a"><path fill="#fff" d="M0 0h60v60H0z" /></clipPath>
  </defs>
</svg>`, ble = ke`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <rect width="60" height="60" fill="#C653C6" rx="30" />
    <path
      fill="#E87DE8"
      d="M57.98.01v19.5a4.09 4.09 0 0 0-2.63 2.29L50.7 34.2a2 2 0 0 1-2.5 1.2l-2.53-.84a2 2 0 0 0-2.42 1l-2.97 5.94a2 2 0 0 1-3.7-.32L32.8 28.6a2 2 0 0 0-3.02-1.09l-3.35 2.23a2 2 0 0 0-.64.7l-5.3 9.72a2 2 0 0 1-1.43 1.01l-4.13.69a2 2 0 0 1-1.61-.44l-3.9-3.24a2 2 0 0 0-2.69.12L2.1 42.93.02 43V.01h57.96Z"
    />
    <path
      fill="#fff"
      d="m61.95 16.94.05 2.1-3.85 1.28a3 3 0 0 0-1.86 1.79l-4.65 12.4a3 3 0 0 1-3.76 1.8l-2.53-.84a1 1 0 0 0-1.2.5l-2.98 5.94a3 3 0 0 1-5.55-.48l-3.78-12.58a1 1 0 0 0-1.5-.55l-3.35 2.23a1 1 0 0 0-.32.35l-5.3 9.72a3 3 0 0 1-2.14 1.52l-4.14.69a3 3 0 0 1-2.41-.66l-3.9-3.24a1 1 0 0 0-1.34.06l-5.28 5.28c-.05-.84-.08-1.75-.1-2.73l3.97-3.96a3 3 0 0 1 4.04-.19l3.89 3.25a1 1 0 0 0 .8.21l4.14-.68a1 1 0 0 0 .71-.51l5.3-9.71a3 3 0 0 1 .97-1.06l3.34-2.23a3 3 0 0 1 4.54 1.63l3.77 12.58a1 1 0 0 0 1.86.16l2.96-5.93a3 3 0 0 1 3.64-1.5l2.52.83a1 1 0 0 0 1.25-.6l4.66-12.4a5 5 0 0 1 3.1-2.99l4.43-1.48Z"
    />
    <path
      fill="#fff"
      fill-rule="evenodd"
      d="M35.5 27a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"
      clip-rule="evenodd"
    />
    <path fill="#fff" d="M31 0v60h-2V0h2Z" />
    <path fill="#E87DE8" d="M33.5 27a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" />
  </g>
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="29.5" />
  <defs>
    <clipPath id="a"><rect width="60" height="60" fill="#fff" rx="30" /></clipPath>
  </defs>
</svg> `, Ele = ke`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <rect width="60" height="60" fill="#987DE8" rx="30" />
    <path
      fill="#fff"
      fill-rule="evenodd"
      d="m15.48 28.37 11.97-19.3a3 3 0 0 1 5.1 0l11.97 19.3a6 6 0 0 1 .9 3.14v.03a6 6 0 0 1-1.16 3.56L33.23 50.2a4 4 0 0 1-6.46 0L15.73 35.1a6 6 0 0 1-1.15-3.54v-.03a6 6 0 0 1 .9-3.16Z"
      clip-rule="evenodd"
    />
    <path
      fill="#643CDD"
      d="M30.84 10.11a1 1 0 0 0-.84-.46V24.5l12.6 5.53a2 2 0 0 0-.28-1.4L30.84 10.11Z"
    />
    <path
      fill="#BDADEB"
      d="M30 9.65a1 1 0 0 0-.85.46L17.66 28.64a2 2 0 0 0-.26 1.39L30 24.5V9.65Z"
    />
    <path
      fill="#643CDD"
      d="M30 50.54a1 1 0 0 0 .8-.4l11.24-15.38c.3-.44-.2-1-.66-.73l-9.89 5.68a3 3 0 0 1-1.5.4v10.43Z"
    />
    <path
      fill="#BDADEB"
      d="m17.97 34.76 11.22 15.37c.2.28.5.41.8.41V40.11a3 3 0 0 1-1.49-.4l-9.88-5.68c-.47-.27-.97.3-.65.73Z"
    />
    <path
      fill="#401AB3"
      d="M42.6 30.03 30 24.5v13.14a3 3 0 0 0 1.5-.4l10.14-5.83a2 2 0 0 0 .95-1.38Z"
    />
    <path
      fill="#7C5AE2"
      d="M30 37.64V24.46l-12.6 5.57a2 2 0 0 0 .97 1.39l10.13 5.82a3 3 0 0 0 1.5.4Z"
    />
  </g>
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="29.5" />
  <defs>
    <clipPath id="a"><rect width="60" height="60" fill="#fff" rx="30" /></clipPath>
  </defs>
</svg> `, Sle = ke`<svg fill="none" viewBox="0 0 60 60">
  <rect width="60" height="60" fill="#1DC956" rx="3" />
  <path
    fill="#1FAD7E"
    stroke="#fff"
    stroke-width="2"
    d="m30.49 29.13-.49-.27-.49.27-12.77 7.1-.05.02c-.86.48-1.58.88-2.1 1.24-.54.37-1.04.81-1.28 1.45a3 3 0 0 0 0 2.12c.24.63.74 1.08 1.27 1.45.53.36 1.25.76 2.11 1.24l.05.03 6.33 3.51.17.1c2.33 1.3 3.72 2.06 5.22 2.32a9 9 0 0 0 3.08 0c1.5-.26 2.9-1.03 5.22-2.32l.18-.1 6.32-3.51.05-.03a26.9 26.9 0 0 0 2.1-1.24 3.21 3.21 0 0 0 1.28-1.45l-.94-.35.94.35a3 3 0 0 0 0-2.12l-.94.35.94-.35a3.21 3.21 0 0 0-1.27-1.45c-.53-.36-1.25-.76-2.11-1.24l-.05-.03-12.77-7.1Z"
  />
  <path
    fill="#2BEE6C"
    stroke="#fff"
    stroke-width="2"
    d="m30.49 19.13-.49-.27-.49.27-12.77 7.1-.05.02c-.86.48-1.58.88-2.1 1.24-.54.37-1.04.81-1.28 1.45a3 3 0 0 0 0 2.12c.24.63.74 1.08 1.27 1.45.53.36 1.25.76 2.11 1.24l.05.03 6.33 3.51.17.1c2.33 1.3 3.72 2.06 5.22 2.32a9 9 0 0 0 3.08 0c1.5-.26 2.9-1.03 5.22-2.32l.18-.1 6.32-3.51.05-.03a26.9 26.9 0 0 0 2.1-1.24 3.21 3.21 0 0 0 1.28-1.45l-.94-.35.94.35a3 3 0 0 0 0-2.12l-.94.35.94-.35a3.21 3.21 0 0 0-1.27-1.45c-.53-.36-1.25-.76-2.11-1.24l-.05-.03-12.77-7.1Z"
  />
  <path
    fill="#86F999"
    stroke="#fff"
    stroke-width="2"
    d="m46.69 21.06-.94-.35.94.35a3 3 0 0 0 0-2.12l-.94.35.94-.35a3.21 3.21 0 0 0-1.27-1.45c-.53-.36-1.25-.76-2.11-1.24l-.05-.03-6.32-3.51-.18-.1c-2.33-1.3-3.72-2.06-5.22-2.33a9 9 0 0 0-3.08 0c-1.5.27-2.9 1.04-5.22 2.33l-.17.1-6.33 3.51-.05.03c-.86.48-1.58.88-2.1 1.24-.54.37-1.04.81-1.28 1.45a3 3 0 0 0 0 2.12c.24.63.74 1.08 1.27 1.45.53.36 1.25.76 2.11 1.24l.05.03 6.33 3.51.17.1c2.33 1.3 3.72 2.06 5.22 2.32a9 9 0 0 0 3.08 0c1.5-.26 2.9-1.03 5.22-2.32l.18-.1 6.32-3.51.05-.03a26.9 26.9 0 0 0 2.1-1.24 3.21 3.21 0 0 0 1.28-1.45Z"
  />
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="2.5" />
</svg>`, xle = ke`<svg fill="none" viewBox="0 0 60 60">
  <rect width="60" height="60" fill="#C653C6" rx="3" />
  <path
    fill="#fff"
    d="M20.03 15.22C20 15.6 20 16.07 20 17v2.8c0 1.14 0 1.7-.2 2.12-.15.31-.3.5-.58.71-.37.28-1.06.42-2.43.7-.59.12-1.11.29-1.6.51a9 9 0 0 0-4.35 4.36C10 30 10 32.34 10 37c0 4.66 0 7 .84 8.8a9 9 0 0 0 4.36 4.36C17 51 19.34 51 24 51h12c4.66 0 7 0 8.8-.84a9 9 0 0 0 4.36-4.36C50 44 50 41.66 50 37c0-4.66 0-7-.84-8.8a9 9 0 0 0-4.36-4.36c-.48-.22-1-.39-1.6-.5-1.36-.29-2.05-.43-2.42-.7-.27-.22-.43-.4-.58-.72-.2-.42-.2-.98-.2-2.11V17c0-.93 0-1.4-.03-1.78a9 9 0 0 0-8.19-8.19C31.4 7 30.93 7 30 7s-1.4 0-1.78.03a9 9 0 0 0-8.19 8.19Z"
  />
  <path
    fill="#E87DE8"
    d="M22 17c0-.93 0-1.4.04-1.78a7 7 0 0 1 6.18-6.18C28.6 9 29.07 9 30 9s1.4 0 1.78.04a7 7 0 0 1 6.18 6.18c.04.39.04.85.04 1.78v4.5a1.5 1.5 0 0 1-3 0V17c0-.93 0-1.4-.08-1.78a4 4 0 0 0-3.14-3.14C31.39 12 30.93 12 30 12s-1.4 0-1.78.08a4 4 0 0 0-3.14 3.14c-.08.39-.08.85-.08 1.78v4.5a1.5 1.5 0 0 1-3 0V17Z"
  />
  <path
    fill="#E87DE8"
    fill-rule="evenodd"
    d="M12 36.62c0-4.32 0-6.48.92-8.09a7 7 0 0 1 2.61-2.61C17.14 25 19.3 25 23.62 25h6.86c.46 0 .7 0 .9.02 2.73.22 4.37 2.43 4.62 4.98.27-2.7 2.11-5 5.02-5A6.98 6.98 0 0 1 48 31.98v5.4c0 4.32 0 6.48-.92 8.09a7 7 0 0 1-2.61 2.61c-1.61.92-3.77.92-8.09.92h-5.86c-.46 0-.7 0-.9-.02-2.73-.22-4.37-2.43-4.62-4.98-.26 2.58-1.94 4.82-4.71 4.99l-.7.01c-.55 0-.82 0-1.05-.02a7 7 0 0 1-6.52-6.52c-.02-.23-.02-.5-.02-1.05v-4.79Zm21.24-.27a4 4 0 1 0-6.48 0 31.28 31.28 0 0 1 1.57 2.23c.17.4.17.81.17 1.24V42.5a1.5 1.5 0 0 0 3 0V39.82c0-.43 0-.85.17-1.24.09-.2.58-.87 1.57-2.23Z"
    clip-rule="evenodd"
  />
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="2.5" />
</svg>`, Wle = ke`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <path
      fill="#EB8B47"
      d="M0 24.9c0-9.25 0-13.88 1.97-17.33a15 15 0 0 1 5.6-5.6C11.02 0 15.65 0 24.9 0h10.2c9.25 0 13.88 0 17.33 1.97a15 15 0 0 1 5.6 5.6C60 11.02 60 15.65 60 24.9v10.2c0 9.25 0 13.88-1.97 17.33a15 15 0 0 1-5.6 5.6C48.98 60 44.35 60 35.1 60H24.9c-9.25 0-13.88 0-17.33-1.97a15 15 0 0 1-5.6-5.6C0 48.98 0 44.35 0 35.1V24.9Z"
    />
    <path
      stroke="#062B2B"
      stroke-opacity=".1"
      d="M.5 24.9c0-4.64 0-8.08.24-10.8.25-2.7.73-4.65 1.66-6.28A14.5 14.5 0 0 1 7.82 2.4C9.46 1.47 11.39 1 14.1.74A133 133 0 0 1 24.9.5h10.2c4.63 0 8.08 0 10.8.24 2.7.25 4.65.73 6.28 1.66a14.5 14.5 0 0 1 5.42 5.42c.93 1.63 1.41 3.57 1.66 6.28.24 2.72.24 6.16.24 10.8v10.2c0 4.63 0 8.08-.24 10.8-.25 2.7-.73 4.64-1.66 6.28a14.5 14.5 0 0 1-5.42 5.41c-1.63.94-3.57 1.42-6.28 1.67-2.72.24-6.17.24-10.8.24H24.9c-4.63 0-8.08 0-10.8-.24-2.7-.25-4.64-.73-6.28-1.67a14.5 14.5 0 0 1-5.42-5.4C1.47 50.53 1 48.6.74 45.88A133 133 0 0 1 .5 35.1V24.9Z"
    />
    <path
      fill="#FF974C"
      stroke="#fff"
      stroke-width="2"
      d="M39.2 29.2a13 13 0 1 0-18.4 0l1.3 1.28a12.82 12.82 0 0 1 2.1 2.39 6 6 0 0 1 .6 1.47c.2.76.2 1.56.2 3.17v11.24c0 1.08 0 1.61.13 2.12a4 4 0 0 0 .41.98c.26.45.64.83 1.4 1.6l.3.29c.65.65.98.98 1.36 1.09.26.07.54.07.8 0 .38-.11.7-.44 1.36-1.1l3.48-3.47c.65-.65.98-.98 1.09-1.36a1.5 1.5 0 0 0 0-.8c-.1-.38-.44-.7-1.1-1.36l-.47-.48c-.65-.65-.98-.98-1.09-1.36a1.5 1.5 0 0 1 0-.8c.1-.38.44-.7 1.1-1.36l.47-.48c.65-.65.98-.98 1.09-1.36a1.5 1.5 0 0 0 0-.8c-.1-.38-.44-.7-1.1-1.36l-.48-.5c-.65-.64-.98-.97-1.08-1.35a1.5 1.5 0 0 1 0-.79c.1-.38.42-.7 1.06-1.36l5.46-5.55Z"
    />
    <circle cx="30" cy="17" r="4" fill="#EB8B47" stroke="#fff" stroke-width="2" />
  </g>
  <defs>
    <clipPath id="a"><path fill="#fff" d="M0 0h60v60H0z" /></clipPath>
  </defs>
</svg> `, jle = ke`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <rect width="60" height="60" fill="#00ACE6" rx="30" />
    <circle cx="64" cy="39" r="50" fill="#1AC6FF" stroke="#fff" stroke-width="2" />
    <circle cx="78" cy="30" r="50" fill="#4DD2FF" stroke="#fff" stroke-width="2" />
    <circle cx="72" cy="15" r="35" fill="#80DFFF" stroke="#fff" stroke-width="2" />
    <circle cx="34" cy="-17" r="45" stroke="#fff" stroke-width="2" />
    <circle cx="34" cy="-5" r="50" stroke="#fff" stroke-width="2" />
    <circle cx="30" cy="45" r="4" fill="#4DD2FF" stroke="#fff" stroke-width="2" />
    <circle cx="39.5" cy="27.5" r="4" fill="#80DFFF" stroke="#fff" stroke-width="2" />
    <circle cx="16" cy="24" r="4" fill="#19C6FF" stroke="#fff" stroke-width="2" />
  </g>
  <rect width="59" height="59" x=".5" y=".5" stroke="#062B2B" stroke-opacity=".1" rx="29.5" />
  <defs>
    <clipPath id="a"><rect width="60" height="60" fill="#fff" rx="30" /></clipPath>
  </defs>
</svg>`, Dle = ke`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <rect width="60" height="60" fill="#C653C6" rx="3" />
    <path
      fill="#E87DE8"
      stroke="#fff"
      stroke-width="2"
      d="M52.1 47.34c0-4.24-1.44-9.55-5.9-12.4a2.86 2.86 0 0 0-1.6-3.89v-.82c0-1.19-.52-2.26-1.35-3a4.74 4.74 0 0 0-2.4-6.26v-5.5a11.31 11.31 0 1 0-22.63 0v2.15a3.34 3.34 0 0 0-1.18 5.05 4.74 4.74 0 0 0-.68 6.44A5.22 5.22 0 0 0 14 35.92c-3.06 4.13-6.1 8.3-6.1 15.64 0 2.67.37 4.86.74 6.39a20.3 20.3 0 0 0 .73 2.39l.02.04v.01l.92-.39-.92.4.26.6h38.26l.3-.49-.87-.51.86.5.02-.01.03-.07a16.32 16.32 0 0 0 .57-1.05c.36-.72.85-1.74 1.33-2.96a25.51 25.51 0 0 0 1.94-9.07Z"
    />
    <path
      fill="#fff"
      fill-rule="evenodd"
      d="M26.5 29.5c-3-.5-5.5-3-5.5-7v-7c0-.47 0-.7.03-.9a3 3 0 0 1 2.58-2.57c.2-.03.42-.03.89-.03 2 0 2.5-2.5 2.5-2.5s0 2.5 2.5 2.5c1.4 0 2.1 0 2.65.23a3 3 0 0 1 1.62 1.62c.23.55.23 1.25.23 2.65v6c0 4-3 7-6.5 7 1.35.23 4 0 6.5-2v9.53C34 38.5 31.5 40 28 40s-6-1.5-6-2.97L24 34l2.5 1.5v-6ZM26 47h4.5c2.5 0 3 4 3 5.5h-3l-1-1.5H26v-4Zm-6.25 5.5H24V57h-8c0-1 1-4.5 3.75-4.5Z"
      clip-rule="evenodd"
    />
  </g>
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="2.5" />
  <defs>
    <clipPath id="a"><rect width="60" height="60" fill="#fff" rx="3" /></clipPath>
  </defs>
</svg> `, zle = ke`<svg fill="none" viewBox="0 0 60 60">
  <rect width="60" height="60" fill="#794CFF" rx="3" />
  <path
    fill="#987DE8"
    stroke="#fff"
    stroke-width="2"
    d="M33 22.5v-1H16v5H8.5V36H13v-5h3v7.5h17V31h1v7.5h17v-17H34v5h-1v-4Z"
  />
  <path fill="#fff" d="M37.5 25h10v10h-10z" />
  <path fill="#4019B2" d="M42.5 25h5v10h-5z" />
  <path fill="#fff" d="M19.5 25h10v10h-10z" />
  <path fill="#4019B2" d="M24.5 25h5v10h-5z" />
  <path fill="#fff" d="M12 30.5h4V37h-4v-6.5Z" />
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="2.5" />
</svg>`, kle = ke`<svg
  viewBox="0 0 60 60"
  fill="none"
>
  <g clip-path="url(#1)">
    <rect width="60" height="60" rx="30" fill="#00ACE6" />
    <path
      d="M59 73C59 89.0163 46.0163 102 30 102C13.9837 102 1 89.0163 1 73C1 56.9837 12 44 30 44C48 44 59 56.9837 59 73Z"
      fill="#1AC6FF"
      stroke="white"
      stroke-width="2"
    />
    <path
      d="M18.6904 19.9015C19.6264 15.3286 23.3466 11.8445 27.9708 11.2096C29.3231 11.024 30.6751 11.0238 32.0289 11.2096C36.6532 11.8445 40.3733 15.3286 41.3094 19.9015C41.4868 20.7681 41.6309 21.6509 41.7492 22.5271C41.8811 23.5041 41.8811 24.4944 41.7492 25.4715C41.6309 26.3476 41.4868 27.2304 41.3094 28.097C40.3733 32.6699 36.6532 36.154 32.0289 36.7889C30.6772 36.9744 29.3216 36.9743 27.9708 36.7889C23.3466 36.154 19.6264 32.6699 18.6904 28.097C18.513 27.2304 18.3689 26.3476 18.2506 25.4715C18.1186 24.4944 18.1186 23.5041 18.2506 22.5271C18.3689 21.6509 18.513 20.7681 18.6904 19.9015Z"
      fill="#1AC6FF"
      stroke="white"
      stroke-width="2"
    />
    <circle cx="24.5" cy="23.5" r="1.5" fill="white" />
    <circle cx="35.5" cy="23.5" r="1.5" fill="white" />
    <path
      d="M31 20L28 28H32"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
  <rect x="0.5" y="0.5" width="59" height="59" rx="29.5" stroke="white" stroke-opacity="0.1" />
  <defs>
    <clipPath id="1">
      <rect width="60" height="60" rx="30" fill="white" />
    </clipPath>
  </defs>
</svg> `, wle = ke`<svg viewBox="0 0 60 60" fill="none">
  <g clip-path="url(#1)">
    <path
      d="M0 24.9C0 15.6485 0 11.0228 1.97053 7.56812C3.3015 5.23468 5.23468 3.3015 7.56812 1.97053C11.0228 0 15.6485 0 24.9 0H35.1C44.3514 0 48.9772 0 52.4319 1.97053C54.7653 3.3015 56.6985 5.23468 58.0295 7.56812C60 11.0228 60 15.6485 60 24.9V35.1C60 44.3514 60 48.9772 58.0295 52.4319C56.6985 54.7653 54.7653 56.6985 52.4319 58.0295C48.9772 60 44.3514 60 35.1 60H24.9C15.6485 60 11.0228 60 7.56812 58.0295C5.23468 56.6985 3.3015 54.7653 1.97053 52.4319C0 48.9772 0 44.3514 0 35.1V24.9Z"
      fill="#794CFF"
    />
    <path
      d="M0.5 24.9C0.5 20.2652 0.50047 16.8221 0.744315 14.105C0.987552 11.3946 1.46987 9.45504 2.40484 7.81585C3.69145 5.56019 5.56019 3.69145 7.81585 2.40484C9.45504 1.46987 11.3946 0.987552 14.105 0.744315C16.8221 0.50047 20.2652 0.5 24.9 0.5H35.1C39.7348 0.5 43.1779 0.50047 45.895 0.744315C48.6054 0.987552 50.545 1.46987 52.1841 2.40484C54.4398 3.69145 56.3086 5.56019 57.5952 7.81585C58.5301 9.45504 59.0124 11.3946 59.2557 14.105C59.4995 16.8221 59.5 20.2652 59.5 24.9V35.1C59.5 39.7348 59.4995 43.1779 59.2557 45.895C59.0124 48.6054 58.5301 50.545 57.5952 52.1841C56.3086 54.4398 54.4398 56.3086 52.1841 57.5952C50.545 58.5301 48.6054 59.0124 45.895 59.2557C43.1779 59.4995 39.7348 59.5 35.1 59.5H24.9C20.2652 59.5 16.8221 59.4995 14.105 59.2557C11.3946 59.0124 9.45504 58.5301 7.81585 57.5952C5.56019 56.3086 3.69145 54.4398 2.40484 52.1841C1.46987 50.545 0.987552 48.6054 0.744315 45.895C0.50047 43.1779 0.5 39.7348 0.5 35.1V24.9Z"
      stroke="#062B2B"
      stroke-opacity="0.1"
    />
    <path
      d="M35.1403 31.5016C35.1193 30.9637 35.388 30.4558 35.8446 30.1707C36.1207 29.9982 36.4761 29.8473 36.7921 29.7685C37.3143 29.6382 37.8664 29.7977 38.2386 30.1864C38.8507 30.8257 39.3004 31.6836 39.8033 32.408C40.2796 33.0942 41.4695 33.2512 41.9687 32.5047C42.4839 31.7341 42.9405 30.8229 43.572 30.1399C43.9375 29.7447 44.4866 29.5756 45.0111 29.6967C45.3283 29.7701 45.6863 29.9147 45.9655 30.0823C46.4269 30.3595 46.7045 30.8626 46.6928 31.4008C46.6731 32.3083 46.3764 33.2571 46.2158 34.1473C46.061 35.0048 46.9045 35.8337 47.7592 35.664C48.6464 35.4878 49.5899 35.1747 50.497 35.1391C51.0348 35.1181 51.5427 35.3868 51.8279 35.8433C52.0004 36.1195 52.1513 36.4749 52.2301 36.7908C52.3604 37.3131 52.2009 37.8651 51.8121 38.2374C51.1729 38.8495 50.3151 39.2991 49.5908 39.8019C48.9046 40.2782 48.7473 41.4683 49.4939 41.9675C50.2644 42.4827 51.1757 42.9393 51.8587 43.5708C52.2539 43.9362 52.423 44.4854 52.3018 45.0099C52.2285 45.3271 52.0839 45.6851 51.9162 45.9642C51.6391 46.4257 51.1359 46.7032 50.5978 46.6916C49.6903 46.6719 48.7417 46.3753 47.8516 46.2146C46.9939 46.0598 46.1648 46.9035 46.3346 47.7583C46.5108 48.6454 46.8239 49.5888 46.8594 50.4958C46.8805 51.0336 46.6117 51.5415 46.1552 51.8267C45.879 51.9992 45.5236 52.15 45.2077 52.2289C44.6854 52.3592 44.1334 52.1997 43.7611 51.8109C43.1491 51.1718 42.6996 50.314 42.1968 49.5897C41.7203 48.9034 40.5301 48.7463 40.0309 49.493C39.5157 50.2634 39.0592 51.1746 38.4278 51.8574C38.0623 52.2527 37.5132 52.4218 36.9887 52.3006C36.6715 52.2273 36.3135 52.0826 36.0343 51.915C35.5729 51.6379 35.2953 51.1347 35.307 50.5966C35.3267 49.6891 35.6233 48.7405 35.7839 47.8505C35.9388 46.9928 35.0951 46.1636 34.2402 46.3334C33.3531 46.5096 32.4098 46.8227 31.5028 46.8582C30.9649 46.8793 30.457 46.6105 30.1719 46.154C29.9994 45.8778 29.8485 45.5224 29.7697 45.2065C29.6394 44.6842 29.7989 44.1322 30.1877 43.7599C30.8269 43.1479 31.6847 42.6982 32.4091 42.1954C33.0954 41.7189 33.2522 40.5289 32.5056 40.0297C31.7351 39.5145 30.824 39.058 30.1411 38.4265C29.7459 38.0611 29.5768 37.5119 29.698 36.9875C29.7713 36.6702 29.9159 36.3122 30.0836 36.0331C30.3607 35.5717 30.8638 35.2941 31.402 35.3058C32.3095 35.3255 33.2583 35.6221 34.1485 35.7828C35.006 35.9376 35.8349 35.094 35.6652 34.2393C35.489 33.3521 35.1759 32.4087 35.1403 31.5016Z"
      fill="#906EF7"
      stroke="white"
      stroke-width="2"
    />
    <path
      d="M20.7706 8.22357C20.9036 7.51411 21.5231 7 22.2449 7H23.7551C24.4769 7 25.0964 7.51411 25.2294 8.22357C25.5051 9.69403 25.4829 11.6321 27.1202 12.2606C27.3092 12.3331 27.4958 12.4105 27.6798 12.4926C29.2818 13.2072 30.6374 11.8199 31.8721 10.9752C32.4678 10.5676 33.2694 10.6421 33.7798 11.1525L34.8477 12.2204C35.3581 12.7308 35.4326 13.5323 35.025 14.128C34.1802 15.3627 32.7931 16.7183 33.5077 18.3202C33.5898 18.5043 33.6672 18.6909 33.7398 18.88C34.3683 20.5171 36.3061 20.4949 37.7764 20.7706C38.4859 20.9036 39 21.5231 39 22.2449V23.7551C39 24.4769 38.4859 25.0964 37.7764 25.2294C36.3061 25.5051 34.3685 25.483 33.7401 27.1201C33.6675 27.3093 33.59 27.4961 33.5079 27.6803C32.7934 29.282 34.1803 30.6374 35.025 31.8719C35.4326 32.4677 35.3581 33.2692 34.8477 33.7796L33.7798 34.8475C33.2694 35.3579 32.4678 35.4324 31.8721 35.0248C30.6376 34.1801 29.2823 32.7934 27.6806 33.508C27.4962 33.5903 27.3093 33.6678 27.12 33.7405C25.483 34.3688 25.5051 36.3062 25.2294 37.7764C25.0964 38.4859 24.4769 39 23.7551 39H22.2449C21.5231 39 20.9036 38.4859 20.7706 37.7764C20.4949 36.3062 20.517 34.3688 18.88 33.7405C18.6908 33.6678 18.5039 33.5903 18.3196 33.5081C16.7179 32.7936 15.3625 34.1804 14.1279 35.0251C13.5322 35.4327 12.7307 35.3582 12.2203 34.8478L11.1524 33.7799C10.642 33.2695 10.5675 32.4679 10.9751 31.8722C11.8198 30.6376 13.2067 29.2822 12.4922 27.6804C12.41 27.4962 12.3325 27.3093 12.2599 27.1201C11.6315 25.483 9.69392 25.5051 8.22357 25.2294C7.51411 25.0964 7 24.4769 7 23.7551V22.2449C7 21.5231 7.51411 20.9036 8.22357 20.7706C9.69394 20.4949 11.6317 20.5171 12.2602 18.88C12.3328 18.6909 12.4103 18.5042 12.4924 18.3201C13.207 16.7181 11.8198 15.3625 10.975 14.1278C10.5674 13.5321 10.6419 12.7305 11.1523 12.2201L12.2202 11.1522C12.7306 10.6418 13.5322 10.5673 14.1279 10.9749C15.3626 11.8197 16.7184 13.2071 18.3204 12.4925C18.5044 12.4105 18.6909 12.3331 18.8799 12.2606C20.5171 11.6321 20.4949 9.69403 20.7706 8.22357Z"
      fill="#906EF7"
      stroke="white"
      stroke-width="2"
    />
    <circle cx="23" cy="23" r="6" fill="#794CFF" stroke="white" stroke-width="2" />
    <circle cx="41" cy="41" r="4" fill="#794CFF" stroke="white" stroke-width="2" />
  </g>
  <defs>
    <clipPath id="1">
      <rect width="60" height="60" fill="white" />
    </clipPath>
  </defs>
</svg> `, Fle = ze`
  :host {
    display: block;
    width: 55px;
    height: 55px;
  }
`;
var oQ = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
const vle = {
  browser: gle,
  dao: yle,
  defi: Zle,
  defiAlt: ble,
  eth: Ele,
  layers: Sle,
  lock: xle,
  login: Wle,
  network: jle,
  nft: Dle,
  noun: zle,
  profile: kle,
  system: wle
};
let oV = class extends be {
  constructor() {
    super(...arguments), this.name = "browser";
  }
  render() {
    return _`${vle[this.name]}`;
  }
};
oV.styles = [Rt, Fle];
oQ([
  te()
], oV.prototype, "name", void 0);
oV = oQ([
  Ze("wui-visual")
], oV);
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Ft = (t) => t ?? ar, yn = {
  getSpacingStyles(t, e) {
    if (Array.isArray(t))
      return t[e] ? `var(--wui-spacing-${t[e]})` : void 0;
    if (typeof t == "string")
      return `var(--wui-spacing-${t})`;
  },
  getFormattedDate(t) {
    return new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric" }).format(t);
  },
  getHostName(t) {
    return new URL(t).hostname;
  },
  getTruncateString({ string: t, charsStart: e, charsEnd: n, truncate: r }) {
    return t.length <= e + n ? t : r === "end" ? `${t.substring(0, e)}...` : r === "start" ? `...${t.substring(t.length - n)}` : `${t.substring(0, Math.floor(e))}...${t.substring(t.length - Math.floor(n))}`;
  },
  generateAvatarColors(t) {
    const n = t.toLowerCase().replace(/^0x/iu, "").substring(0, 6), r = this.hexToRgb(n), i = [];
    for (let a = 0; a < 5; a += 1) {
      const o = this.tintColor(r, 0.15 * a);
      i.push(`rgb(${o[0]}, ${o[1]}, ${o[2]})`);
    }
    return `
    --local-color-1: ${i[0]};
    --local-color-2: ${i[1]};
    --local-color-3: ${i[2]};
    --local-color-4: ${i[3]};
    --local-color-5: ${i[4]};
   `;
  },
  hexToRgb(t) {
    const e = parseInt(t, 16), n = e >> 16 & 255, r = e >> 8 & 255, i = e & 255;
    return [n, r, i];
  },
  tintColor(t, e) {
    const [n, r, i] = t, a = Math.round(n + (255 - n) * e), o = Math.round(r + (255 - r) * e), s = Math.round(i + (255 - i) * e);
    return [a, o, s];
  },
  isNumber(t) {
    return {
      number: /^[0-9]+$/u
    }.number.test(t);
  },
  getColorTheme(t) {
    return t || (typeof window < "u" && window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : "dark");
  }
}, Ile = ze`
  :host {
    display: flex;
    width: inherit;
    height: inherit;
  }
`;
var sa = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let Ti = class extends be {
  render() {
    return this.style.cssText = `
      flex-direction: ${this.flexDirection};
      flex-wrap: ${this.flexWrap};
      flex-basis: ${this.flexBasis};
      flex-grow: ${this.flexGrow};
      flex-shrink: ${this.flexShrink};
      align-items: ${this.alignItems};
      justify-content: ${this.justifyContent};
      column-gap: ${this.columnGap && `var(--wui-spacing-${this.columnGap})`};
      row-gap: ${this.rowGap && `var(--wui-spacing-${this.rowGap})`};
      gap: ${this.gap && `var(--wui-spacing-${this.gap})`};
      padding-top: ${this.padding && yn.getSpacingStyles(this.padding, 0)};
      padding-right: ${this.padding && yn.getSpacingStyles(this.padding, 1)};
      padding-bottom: ${this.padding && yn.getSpacingStyles(this.padding, 2)};
      padding-left: ${this.padding && yn.getSpacingStyles(this.padding, 3)};
      margin-top: ${this.margin && yn.getSpacingStyles(this.margin, 0)};
      margin-right: ${this.margin && yn.getSpacingStyles(this.margin, 1)};
      margin-bottom: ${this.margin && yn.getSpacingStyles(this.margin, 2)};
      margin-left: ${this.margin && yn.getSpacingStyles(this.margin, 3)};
    `, _`<slot></slot>`;
  }
};
Ti.styles = [Rt, Ile];
sa([
  te()
], Ti.prototype, "flexDirection", void 0);
sa([
  te()
], Ti.prototype, "flexWrap", void 0);
sa([
  te()
], Ti.prototype, "flexBasis", void 0);
sa([
  te()
], Ti.prototype, "flexGrow", void 0);
sa([
  te()
], Ti.prototype, "flexShrink", void 0);
sa([
  te()
], Ti.prototype, "alignItems", void 0);
sa([
  te()
], Ti.prototype, "justifyContent", void 0);
sa([
  te()
], Ti.prototype, "columnGap", void 0);
sa([
  te()
], Ti.prototype, "rowGap", void 0);
sa([
  te()
], Ti.prototype, "gap", void 0);
sa([
  te()
], Ti.prototype, "padding", void 0);
sa([
  te()
], Ti.prototype, "margin", void 0);
Ti = sa([
  Ze("wui-flex")
], Ti);
const Ole = ze`
  :host {
    display: block;
    width: 64px;
    height: 64px;
    border-radius: var(--wui-border-radius-3xl);
    box-shadow: 0 0 0 8px var(--wui-gray-glass-005);
    overflow: hidden;
    position: relative;
  }

  :host([data-variant='generated']) {
    --mixed-local-color-1: var(--local-color-1);
    --mixed-local-color-2: var(--local-color-2);
    --mixed-local-color-3: var(--local-color-3);
    --mixed-local-color-4: var(--local-color-4);
    --mixed-local-color-5: var(--local-color-5);
  }

  @supports (background: color-mix(in srgb, white 50%, black)) {
    :host([data-variant='generated']) {
      --mixed-local-color-1: color-mix(
        in srgb,
        var(--w3m-color-mix) var(--w3m-color-mix-strength),
        var(--local-color-1)
      );
      --mixed-local-color-2: color-mix(
        in srgb,
        var(--w3m-color-mix) var(--w3m-color-mix-strength),
        var(--local-color-2)
      );
      --mixed-local-color-3: color-mix(
        in srgb,
        var(--w3m-color-mix) var(--w3m-color-mix-strength),
        var(--local-color-3)
      );
      --mixed-local-color-4: color-mix(
        in srgb,
        var(--w3m-color-mix) var(--w3m-color-mix-strength),
        var(--local-color-4)
      );
      --mixed-local-color-5: color-mix(
        in srgb,
        var(--w3m-color-mix) var(--w3m-color-mix-strength),
        var(--local-color-5)
      );
    }
  }

  :host([data-variant='generated']) {
    box-shadow: 0 0 0 8px var(--wui-gray-glass-005);
    background: radial-gradient(
      75.29% 75.29% at 64.96% 24.36%,
      #fff 0.52%,
      var(--mixed-local-color-5) 31.25%,
      var(--mixed-local-color-3) 51.56%,
      var(--mixed-local-color-2) 65.63%,
      var(--mixed-local-color-1) 82.29%,
      var(--mixed-local-color-4) 100%
    );
  }

  :host([data-variant='default']) {
    box-shadow: 0 0 0 8px var(--wui-gray-glass-005);
    background: radial-gradient(
      75.29% 75.29% at 64.96% 24.36%,
      #fff 0.52%,
      #f5ccfc 31.25%,
      #dba4f5 51.56%,
      #9a8ee8 65.63%,
      #6493da 82.29%,
      #6ebdea 100%
    );
  }
`;
var MU = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let ch = class extends be {
  constructor() {
    super(...arguments), this.imageSrc = void 0, this.alt = void 0, this.address = void 0;
  }
  render() {
    return _`${this.visualTemplate()}`;
  }
  visualTemplate() {
    if (this.imageSrc)
      return this.dataset.variant = "image", _`<wui-image src=${this.imageSrc} alt=${this.alt ?? "avatar"}></wui-image>`;
    if (this.address) {
      this.dataset.variant = "generated";
      const e = yn.generateAvatarColors(this.address);
      return this.style.cssText = e, null;
    }
    return this.dataset.variant = "default", null;
  }
};
ch.styles = [Rt, Ole];
MU([
  te()
], ch.prototype, "imageSrc", void 0);
MU([
  te()
], ch.prototype, "alt", void 0);
MU([
  te()
], ch.prototype, "address", void 0);
ch = MU([
  Ze("wui-avatar")
], ch);
const Yle = ze`
  :host {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    background-color: var(--wui-gray-glass-020);
    border-radius: var(--local-border-radius);
    box-shadow: 0 0 0 1px var(--local-border);
    width: var(--local-size);
    height: var(--local-size);
    min-height: var(--local-size);
    min-width: var(--local-size);
  }

  @supports (background: color-mix(in srgb, white 50%, black)) {
    :host {
      background-color: color-mix(in srgb, var(--local-bg-value) var(--local-bg-mix), transparent);
    }
  }
`;
var _s = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let Ka = class extends be {
  constructor() {
    super(...arguments), this.size = "md", this.backgroundColor = "accent-100", this.iconColor = "accent-100", this.background = "transparent", this.border = !1, this.borderColor = "wui-color-bg-125", this.icon = "copy";
  }
  render() {
    const e = this.iconSize || this.size, n = this.size === "lg", r = this.size === "xl", i = n ? "12%" : "16%", a = n ? "xxs" : r ? "s" : "3xl", o = this.background === "gray", s = this.background === "opaque", l = this.backgroundColor === "accent-100" && s || this.backgroundColor === "success-100" && s || this.backgroundColor === "error-100" && s || this.backgroundColor === "inverse-100" && s;
    let c = `var(--wui-color-${this.backgroundColor})`;
    return l ? c = `var(--wui-icon-box-bg-${this.backgroundColor})` : o && (c = `var(--wui-gray-${this.backgroundColor})`), this.style.cssText = `
       --local-bg-value: ${c};
       --local-bg-mix: ${l || o ? "100%" : i};
       --local-border-radius: var(--wui-border-radius-${a});
       --local-size: var(--wui-icon-box-size-${this.size});
       --local-border: ${this.borderColor === "wui-color-bg-125" ? "2px" : "1px"} solid ${this.border ? `var(--${this.borderColor})` : "transparent"}
   `, _` <wui-icon color=${this.iconColor} size=${e} name=${this.icon}></wui-icon> `;
  }
};
Ka.styles = [Rt, pr, Yle];
_s([
  te()
], Ka.prototype, "size", void 0);
_s([
  te()
], Ka.prototype, "backgroundColor", void 0);
_s([
  te()
], Ka.prototype, "iconColor", void 0);
_s([
  te()
], Ka.prototype, "iconSize", void 0);
_s([
  te()
], Ka.prototype, "background", void 0);
_s([
  te({ type: Boolean })
], Ka.prototype, "border", void 0);
_s([
  te()
], Ka.prototype, "borderColor", void 0);
_s([
  te()
], Ka.prototype, "icon", void 0);
Ka = _s([
  Ze("wui-icon-box")
], Ka);
const Qle = ze`
  :host {
    display: block;
  }

  button {
    border-radius: var(--wui-border-radius-3xl);
    background: var(--wui-gray-glass-002);
    display: flex;
    gap: var(--wui-spacing-xs);
    padding: var(--wui-spacing-3xs) var(--wui-spacing-xs) var(--wui-spacing-3xs)
      var(--wui-spacing-xs);
    border: 1px solid var(--wui-gray-glass-005);
  }

  button:disabled {
    background: var(--wui-gray-glass-015);
  }

  button:disabled > wui-text {
    color: var(--wui-gray-glass-015);
  }

  button:disabled > wui-flex > wui-text {
    color: var(--wui-gray-glass-015);
  }

  button:disabled > wui-image,
  button:disabled > wui-icon-box,
  button:disabled > wui-flex > wui-avatar {
    filter: grayscale(1);
  }

  button:has(wui-image) {
    padding: var(--wui-spacing-3xs) var(--wui-spacing-3xs) var(--wui-spacing-3xs)
      var(--wui-spacing-xs);
  }

  wui-text {
    color: var(--wui-color-fg-100);
  }

  wui-flex > wui-text {
    color: var(--wui-color-fg-200);
    transition: all var(--wui-ease-out-power-1) var(--wui-duration-lg);
  }

  wui-image,
  wui-icon-box {
    border-radius: var(--wui-border-radius-3xl);
    width: 24px;
    height: 24px;
    box-shadow: 0 0 0 2px var(--wui-gray-glass-005);
  }

  wui-flex {
    border-radius: var(--wui-border-radius-3xl);
    border: 1px solid var(--wui-gray-glass-005);
    background: var(--wui-gray-glass-005);
    padding: 4px var(--wui-spacing-m) 4px var(--wui-spacing-xxs);
  }

  wui-flex.local-no-balance {
    border-radius: 0px;
    border: none;
    background: transparent;
  }

  wui-avatar {
    width: 20px;
    height: 20px;
    box-shadow: 0 0 0 2px var(--wui-accent-glass-010);
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled > wui-flex > wui-text {
      color: var(--wui-color-fg-175);
    }

    button:active:enabled > wui-flex > wui-text {
      color: var(--wui-color-fg-175);
    }
  }
`;
var du = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let Fs = class extends be {
  constructor() {
    super(...arguments), this.networkSrc = void 0, this.avatarSrc = void 0, this.balance = void 0, this.disabled = !1, this.isProfileName = !1, this.address = "";
  }
  render() {
    return _`
      <button ?disabled=${this.disabled}>
        ${this.balanceTemplate()}
        <wui-flex
          gap="xxs"
          alignItems="center"
          class=${Ft(this.balance ? void 0 : "local-no-balance")}
        >
          <wui-avatar
            .imageSrc=${this.avatarSrc}
            alt=${this.address}
            address=${this.address}
          ></wui-avatar>
          <wui-text variant="paragraph-600" color="inherit">
            ${yn.getTruncateString({
      string: this.address,
      charsStart: this.isProfileName ? 18 : 4,
      charsEnd: this.isProfileName ? 0 : 6,
      truncate: this.isProfileName ? "end" : "middle"
    })}
          </wui-text>
        </wui-flex>
      </button>
    `;
  }
  balanceTemplate() {
    if (this.balance) {
      const e = this.networkSrc ? _`<wui-image src=${this.networkSrc}></wui-image>` : _`
            <wui-icon-box
              size="sm"
              iconColor="fg-200"
              backgroundColor="fg-300"
              icon="networkPlaceholder"
            ></wui-icon-box>
          `;
      return _`
        ${e}
        <wui-text variant="paragraph-600" color="inherit"> ${this.balance} </wui-text>
      `;
    }
    return null;
  }
};
Fs.styles = [Rt, pr, Qle];
du([
  te()
], Fs.prototype, "networkSrc", void 0);
du([
  te()
], Fs.prototype, "avatarSrc", void 0);
du([
  te()
], Fs.prototype, "balance", void 0);
du([
  te({ type: Boolean })
], Fs.prototype, "disabled", void 0);
du([
  te({ type: Boolean })
], Fs.prototype, "isProfileName", void 0);
du([
  te()
], Fs.prototype, "address", void 0);
Fs = du([
  Ze("wui-account-button")
], Fs);
const Gle = ze`
  :host {
    position: relative;
    background-color: var(--wui-gray-glass-002);
    display: flex;
    justify-content: center;
    align-items: center;
    width: var(--local-size);
    height: var(--local-size);
    border-radius: inherit;
    border-radius: var(--local-border-radius);
  }

  :host > wui-flex {
    overflow: hidden;
    border-radius: inherit;
    border-radius: var(--local-border-radius);
  }

  :host::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: inherit;
    border: 1px solid var(--wui-gray-glass-010);
    pointer-events: none;
  }

  :host([name='Extension'])::after {
    border: 1px solid var(--wui-accent-glass-010);
  }

  :host([data-wallet-icon='allWallets']) {
    background-color: var(--wui-all-wallets-bg-100);
  }

  :host([data-wallet-icon='allWallets'])::after {
    border: 1px solid var(--wui-accent-glass-010);
  }

  wui-icon[data-parent-size='inherit'] {
    width: 75%;
    height: 75%;
    align-items: center;
  }

  wui-icon[data-parent-size='sm'] {
    width: 18px;
    height: 18px;
  }

  wui-icon[data-parent-size='md'] {
    width: 24px;
    height: 24px;
  }

  wui-icon[data-parent-size='lg'] {
    width: 42px;
    height: 42px;
  }

  wui-icon[data-parent-size='full'] {
    width: 100%;
    height: 100%;
  }

  :host > wui-icon-box {
    position: absolute;
    overflow: hidden;
    right: -1px;
    bottom: -2px;
    z-index: 1;
    border: 2px solid var(--wui-color-bg-base-150, #1e1f1f);
    padding: 1px;
  }
`;
var uu = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let vs = class extends be {
  constructor() {
    super(...arguments), this.size = "md", this.name = "", this.installed = !1, this.badgeSize = "xs";
  }
  render() {
    let e = "xxs";
    return this.size === "lg" ? e = "m" : this.size === "md" ? e = "xs" : e = "xxs", this.style.cssText = `
       --local-border-radius: var(--wui-border-radius-${e});
       --local-size: var(--wui-wallet-image-size-${this.size});
   `, this.walletIcon && (this.dataset.walletIcon = this.walletIcon), _`
      <wui-flex justifyContent="center" alignItems="center"> ${this.templateVisual()} </wui-flex>
      ${this.templateInstalledBadge()}
    `;
  }
  templateVisual() {
    return this.imageSrc ? _`<wui-image src=${this.imageSrc} alt=${this.name}></wui-image>` : this.walletIcon ? _`<wui-icon
        data-parent-size="md"
        size="md"
        color="inherit"
        name=${this.walletIcon}
      ></wui-icon>` : _`<wui-icon
      data-parent-size=${this.size}
      size="inherit"
      color="inherit"
      name="walletPlaceholder"
    ></wui-icon>`;
  }
  templateInstalledBadge() {
    return this.installed ? _`
        <wui-icon-box
          size=${this.badgeSize}
          iconSize=${this.badgeSize}
          iconcolor="success-100"
          backgroundcolor="success-100"
          icon="checkmark"
          background="opaque"
        ></wui-icon-box>
      ` : null;
  }
};
vs.styles = [Rt, Gle];
uu([
  te()
], vs.prototype, "size", void 0);
uu([
  te()
], vs.prototype, "name", void 0);
uu([
  te()
], vs.prototype, "imageSrc", void 0);
uu([
  te()
], vs.prototype, "walletIcon", void 0);
uu([
  te({ type: Boolean })
], vs.prototype, "installed", void 0);
uu([
  te()
], vs.prototype, "badgeSize", void 0);
vs = uu([
  Ze("wui-wallet-image")
], vs);
const Cle = ze`
  :host {
    position: relative;
    border-radius: var(--wui-border-radius-xxs);
    width: 40px;
    height: 40px;
    overflow: hidden;
    background: var(--wui-gray-glass-002);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--wui-spacing-4xs);
    padding: 3.75px !important;
  }

  :host::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: inherit;
    border: 1px solid var(--wui-gray-glass-010);
    pointer-events: none;
  }

  :host > wui-wallet-image {
    width: 14px;
    height: 14px;
    border-radius: var(--wui-border-radius-5xs);
  }

  :host > wui-flex {
    padding: 2px;
    position: fixed;
    overflow: hidden;
    left: 34px;
    bottom: 8px;
    background: var(--dark-background-150, #1e1f1f);
    border-radius: 50%;
    z-index: 2;
    display: flex;
  }
`;
var sQ = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
const fg = 4;
let sV = class extends be {
  constructor() {
    super(...arguments), this.walletImages = [];
  }
  render() {
    const e = this.walletImages.length < fg;
    return _`${this.walletImages.slice(0, fg).map(({ src: n, walletName: r }) => _`
            <wui-wallet-image
              size="inherit"
              imageSrc=${n}
              name=${Ft(r)}
            ></wui-wallet-image>
          `)}
      ${e ? [...Array(fg - this.walletImages.length)].map(() => _` <wui-wallet-image size="inherit" name=""></wui-wallet-image>`) : null}
      <wui-flex>
        <wui-icon-box
          size="xxs"
          iconSize="xxs"
          iconcolor="success-100"
          backgroundcolor="success-100"
          icon="checkmark"
          background="opaque"
        ></wui-icon-box>
      </wui-flex>`;
  }
};
sV.styles = [Rt, Cle];
sQ([
  te({ type: Array })
], sV.prototype, "walletImages", void 0);
sV = sQ([
  Ze("wui-all-wallets-image")
], sV);
const Lle = ze`
  :host {
    width: var(--local-width);
    position: relative;
  }

  button {
    border: 1px solid var(--wui-gray-glass-010);
    border-radius: var(--wui-border-radius-m);
    width: var(--local-width);
  }

  button:disabled {
    border: 1px solid var(--wui-gray-glass-010);
  }

  button[data-size='sm'] {
    padding: var(--wui-spacing-xxs) var(--wui-spacing-s);
  }

  button[data-size='sm'][data-icon-left='true'] {
    padding: var(--wui-spacing-xxs) var(--wui-spacing-s) var(--wui-spacing-xxs)
      var(--wui-spacing-xs);
  }

  button[data-size='sm'][data-icon-right='true'] {
    padding: var(--wui-spacing-xxs) var(--wui-spacing-xs) var(--wui-spacing-xxs)
      var(--wui-spacing-s);
  }

  ::slotted(*) {
    transition: opacity 200ms ease-in-out;
    opacity: var(--local-opacity-100);
  }

  button > wui-text {
    transition: opacity 200ms ease-in-out;
    opacity: var(--local-opacity-100);
  }

  button[data-size='md'] {
    padding: 8.2px var(--wui-spacing-l) 9px var(--wui-spacing-l);
  }

  button[data-size='md'][data-icon-left='true'] {
    padding: 8.2px var(--wui-spacing-l) 9px var(--wui-spacing-s);
  }

  button[data-size='md'][data-icon-right='true'] {
    padding: 8.2px var(--wui-spacing-s) 9px var(--wui-spacing-l);
  }

  wui-loading-spinner {
    position: absolute;
    left: 50%;
    top: 50%;
    transition: all 200ms ease-in-out;
    transform: translate(-50%, -50%);
    opacity: var(--local-opacity-000);
  }
`;
var bc = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let wo = class extends be {
  constructor() {
    super(...arguments), this.size = "md", this.disabled = !1, this.fullWidth = !1, this.loading = !1, this.variant = "fill", this.hasIconLeft = !1, this.hasIconRight = !1;
  }
  render() {
    this.style.cssText = `
    --local-width: ${this.fullWidth ? "100%" : "auto"};
    --local-opacity-100: ${this.loading ? 0 : 1};
    --local-opacity-000: ${this.loading ? 1 : 0};`;
    const e = this.size === "md" ? "paragraph-600" : "small-600";
    return _`
      <button
        data-variant=${this.variant}
        data-icon-left=${this.hasIconLeft}
        data-icon-right=${this.hasIconRight}
        data-size=${this.size}
        ?disabled=${this.disabled || this.loading}
        ontouchstart
      >
        ${this.loadingTemplate()}
        <slot name="iconLeft" @slotchange=${() => this.handleSlotLeftChange()}></slot>
        <wui-text variant=${e} color="inherit">
          <slot></slot>
        </wui-text>
        <slot name="iconRight" @slotchange=${() => this.handleSlotRightChange()}></slot>
      </button>
    `;
  }
  handleSlotLeftChange() {
    this.hasIconLeft = !0;
  }
  handleSlotRightChange() {
    this.hasIconRight = !0;
  }
  loadingTemplate() {
    return this.loading ? _`<wui-loading-spinner color="fg-300"></wui-loading-spinner>` : _``;
  }
};
wo.styles = [Rt, pr, Lle];
bc([
  te()
], wo.prototype, "size", void 0);
bc([
  te({ type: Boolean })
], wo.prototype, "disabled", void 0);
bc([
  te({ type: Boolean })
], wo.prototype, "fullWidth", void 0);
bc([
  te({ type: Boolean })
], wo.prototype, "loading", void 0);
bc([
  te()
], wo.prototype, "variant", void 0);
bc([
  te({ type: Boolean })
], wo.prototype, "hasIconLeft", void 0);
bc([
  te({ type: Boolean })
], wo.prototype, "hasIconRight", void 0);
wo = bc([
  Ze("wui-button")
], wo);
const lQ = ke`<svg  viewBox="0 0 48 54" fill="none">
  <path
    d="M43.4605 10.7248L28.0485 1.61089C25.5438 0.129705 22.4562 0.129705 19.9515 1.61088L4.53951 10.7248C2.03626 12.2051 0.5 14.9365 0.5 17.886V36.1139C0.5 39.0635 2.03626 41.7949 4.53951 43.2752L19.9515 52.3891C22.4562 53.8703 25.5438 53.8703 28.0485 52.3891L43.4605 43.2752C45.9637 41.7949 47.5 39.0635 47.5 36.114V17.8861C47.5 14.9365 45.9637 12.2051 43.4605 10.7248Z"
  />
</svg>`, Jle = ze`
  :host {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 76px;
    row-gap: var(--wui-spacing-xs);
    padding: var(--wui-spacing-xs) 10px;
    background-color: var(--wui-gray-glass-002);
    border-radius: clamp(0px, var(--wui-border-radius-xs), 20px);
    position: relative;
  }

  wui-shimmer[data-type='network'] {
    border: none;
    -webkit-clip-path: var(--wui-path-network);
    clip-path: var(--wui-path-network);
  }

  svg {
    position: absolute;
    width: 48px;
    height: 54px;
    z-index: 1;
  }

  svg > path {
    stroke: var(--wui-gray-glass-010);
    stroke-width: 1px;
  }
`;
var cQ = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let lV = class extends be {
  constructor() {
    super(...arguments), this.type = "wallet";
  }
  render() {
    return _`
      ${this.shimmerTemplate()}
      <wui-shimmer width="56px" height="20px" borderRadius="xs"></wui-shimmer>
    `;
  }
  shimmerTemplate() {
    return this.type === "network" ? _` <wui-shimmer
          data-type=${this.type}
          width="48px"
          height="54px"
          borderRadius="xs"
        ></wui-shimmer>
        ${lQ}` : _`<wui-shimmer width="56px" height="56px" borderRadius="xs"></wui-shimmer>`;
  }
};
lV.styles = [Rt, pr, Jle];
cQ([
  te()
], lV.prototype, "type", void 0);
lV = cQ([
  Ze("wui-card-select-loader")
], lV);
const Ble = ke`<svg width="86" height="96" fill="none">
  <path
    d="M78.3244 18.926L50.1808 2.45078C45.7376 -0.150261 40.2624 -0.150262 35.8192 2.45078L7.6756 18.926C3.23322 21.5266 0.5 26.3301 0.5 31.5248V64.4752C0.5 69.6699 3.23322 74.4734 7.6756 77.074L35.8192 93.5492C40.2624 96.1503 45.7376 96.1503 50.1808 93.5492L78.3244 77.074C82.7668 74.4734 85.5 69.6699 85.5 64.4752V31.5248C85.5 26.3301 82.7668 21.5266 78.3244 18.926Z"
  />
</svg>`, Ale = ze`
  :host {
    position: relative;
    border-radius: inherit;
    display: flex;
    justify-content: center;
    align-items: center;
    width: var(--local-width);
    height: var(--local-height);
  }

  svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    fill: var(--wui-gray-glass-002);
  }

  svg > path {
    stroke: var(--local-stroke);
    transition: stroke var(--wui-ease-out-power-1) var(--wui-duration-lg);
  }

  wui-image {
    width: 100%;
    height: 100%;
    -webkit-clip-path: var(--local-path);
    clip-path: var(--local-path);
    background: var(--wui-gray-glass-002);
  }

  wui-icon {
    transform: translateY(-5%);
    width: var(--local-icon-size);
    height: var(--local-icon-size);
  }
`;
var $p = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let Yd = class extends be {
  constructor() {
    super(...arguments), this.size = "md", this.name = "uknown", this.selected = !1;
  }
  render() {
    const e = this.size === "lg";
    return this.style.cssText = `
      --local-stroke: ${this.selected ? "var(--wui-color-accent-100)" : "var(--wui-gray-glass-010)"};
      --local-path: ${e ? "var(--wui-path-network-lg)" : "var(--wui-path-network)"};
      --local-width: ${e ? "86px" : "48px"};
      --local-height: ${e ? "96px" : "54px"};
      --local-icon-size: ${e ? "42px" : "24px"};
    `, _`${this.templateVisual()} ${e ? Ble : lQ}`;
  }
  templateVisual() {
    return this.imageSrc ? _`<wui-image src=${this.imageSrc} alt=${this.name}></wui-image>` : _`<wui-icon size="inherit" color="fg-200" name="networkPlaceholder"></wui-icon>`;
  }
};
Yd.styles = [Rt, Ale];
$p([
  te()
], Yd.prototype, "size", void 0);
$p([
  te()
], Yd.prototype, "name", void 0);
$p([
  te()
], Yd.prototype, "imageSrc", void 0);
$p([
  te({ type: Boolean })
], Yd.prototype, "selected", void 0);
Yd = $p([
  Ze("wui-network-image")
], Yd);
const Hle = ze`
  button {
    flex-direction: column;
    width: 76px;
    row-gap: var(--wui-spacing-xs);
    padding: var(--wui-spacing-xs) var(--wui-spacing-0);
    background-color: var(--wui-gray-glass-002);
    border-radius: clamp(0px, var(--wui-border-radius-xs), 20px);
  }

  button > wui-text {
    color: var(--wui-color-fg-100);
    max-width: 64px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    justify-content: center;
  }

  button:disabled > wui-text {
    color: var(--wui-gray-glass-015);
  }

  [data-selected='true'] {
    background-color: var(--wui-accent-glass-020);
  }

  @media (hover: hover) and (pointer: fine) {
    [data-selected='true']:hover:enabled {
      background-color: var(--wui-accent-glass-015);
    }
  }

  [data-selected='true']:active:enabled {
    background-color: var(--wui-accent-glass-010);
  }
`;
var hu = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let Is = class extends be {
  constructor() {
    super(...arguments), this.name = "Unknown", this.type = "wallet", this.imageSrc = void 0, this.disabled = !1, this.selected = !1, this.installed = !1;
  }
  render() {
    return _`
      <button data-selected=${Ft(this.selected)} ?disabled=${this.disabled} ontouchstart>
        ${this.imageTemplate()}
        <wui-text variant="tiny-500" color=${this.selected ? "accent-100" : "inherit"}>
          ${this.name}
        </wui-text>
      </button>
    `;
  }
  imageTemplate() {
    return this.type === "network" ? _`
        <wui-network-image
          .selected=${this.selected}
          imageSrc=${Ft(this.imageSrc)}
          name=${this.name}
        >
        </wui-network-image>
      ` : _`
      <wui-wallet-image
        size="md"
        imageSrc=${Ft(this.imageSrc)}
        name=${this.name}
        .installed=${this.installed}
        badgeSize="sm"
      >
      </wui-wallet-image>
    `;
  }
};
Is.styles = [Rt, pr, Hle];
hu([
  te()
], Is.prototype, "name", void 0);
hu([
  te()
], Is.prototype, "type", void 0);
hu([
  te()
], Is.prototype, "imageSrc", void 0);
hu([
  te({ type: Boolean })
], Is.prototype, "disabled", void 0);
hu([
  te({ type: Boolean })
], Is.prototype, "selected", void 0);
hu([
  te({ type: Boolean })
], Is.prototype, "installed", void 0);
Is = hu([
  Ze("wui-card-select")
], Is);
const Xle = ze`
  a {
    border: 1px solid var(--wui-gray-glass-010);
    border-radius: var(--wui-border-radius-3xl);
  }

  wui-image {
    border-radius: var(--wui-border-radius-3xl);
    overflow: hidden;
  }

  a.disabled > wui-icon,
  a.disabled > wui-image {
    filter: grayscale(1);
  }

  a[data-variant='fill'] {
    color: var(--wui-color-inverse-100);
    background-color: var(--wui-color-accent-100);
  }

  a[data-variant='shade'] {
    background-color: transparent;
    background-color: var(--wui-gray-glass-010);
    color: var(--wui-color-fg-200);
  }

  a[data-variant='transparent'] {
    column-gap: var(--wui-spacing-xxs);
    background-color: transparent;
    padding: 7px var(--wui-spacing-s) 7px 10px;
    color: var(--wui-color-fg-150);
  }

  a[data-variant='transparent']:has(wui-text:first-child) {
    padding: 7px var(--wui-spacing-s);
  }

  a[data-variant='fill'],
  a[data-variant='shade'] {
    column-gap: var(--wui-spacing-xs);
    padding: var(--wui-spacing-xxs) var(--wui-spacing-m) var(--wui-spacing-xxs)
      var(--wui-spacing-xs);
  }

  a[data-variant='fill']:has(wui-text:first-child),
  a[data-variant='shade']:has(wui-text:first-child) {
    padding: 9px var(--wui-spacing-m) 9px var(--wui-spacing-m);
  }

  a[data-variant='fill'] > wui-image,
  a[data-variant='shade'] > wui-image {
    width: 24px;
    height: 24px;
  }

  a[data-variant='fill'] > wui-image {
    border: 1px solid var(--wui-color-accent-090);
  }

  a[data-variant='shade'] > wui-image {
    border: 1px solid var(--wui-gray-glass-010);
  }

  a[data-variant='fill'] > wui-icon,
  a[data-variant='shade'] > wui-icon {
    width: 14px;
    height: 14px;
  }

  a[data-variant='transparent'] > wui-image {
    width: 14px;
    height: 14px;
  }

  a[data-variant='transparent'] > wui-icon {
    width: 12px;
    height: 12px;
  }

  a[data-variant='fill']:focus-visible {
    background-color: var(--wui-color-accent-090);
  }

  a[data-variant='shade']:focus-visible {
    background-color: var(--wui-gray-glass-015);
  }

  a[data-variant='transparent']:focus-visible {
    background-color: var(--wui-gray-glass-005);
  }

  a.disabled {
    color: var(--wui-gray-glass-015);
    background-color: var(--wui-gray-glass-015);
    pointer-events: none;
  }

  @media (hover: hover) and (pointer: fine) {
    a[data-variant='fill']:hover {
      background-color: var(--wui-color-accent-090);
    }

    a[data-variant='shade']:hover {
      background-color: var(--wui-gray-glass-015);
    }

    a[data-variant='transparent']:hover {
      background-color: var(--wui-gray-glass-005);
    }
  }

  a[data-variant='fill']:active {
    background-color: var(--wui-color-accent-080);
  }

  a[data-variant='shade']:active {
    background-color: var(--wui-gray-glass-020);
  }

  a[data-variant='transparent']:active {
    background-color: var(--wui-gray-glass-010);
  }
`;
var oN = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let ic = class extends be {
  constructor() {
    super(...arguments), this.variant = "fill", this.imageSrc = void 0, this.disabled = !1, this.icon = "externalLink", this.href = "";
  }
  render() {
    const e = this.variant === "transparent" ? "small-600" : "paragraph-600";
    return _`
      <a
        rel="noreferrer"
        target="_blank"
        href=${this.href}
        class=${this.disabled ? "disabled" : ""}
        data-variant=${this.variant}
      >
        ${this.imageTemplate()}
        <wui-text variant=${e} color="inherit">
          ${yn.getHostName(this.href)}
        </wui-text>
        <wui-icon name=${this.icon} color="inherit" size="inherit"></wui-icon>
      </a>
    `;
  }
  imageTemplate() {
    return this.imageSrc ? _`<wui-image src=${this.imageSrc}></wui-image>` : null;
  }
};
ic.styles = [Rt, pr, Xle];
oN([
  te()
], ic.prototype, "variant", void 0);
oN([
  te()
], ic.prototype, "imageSrc", void 0);
oN([
  te({ type: Boolean })
], ic.prototype, "disabled", void 0);
oN([
  te()
], ic.prototype, "icon", void 0);
oN([
  te()
], ic.prototype, "href", void 0);
ic = oN([
  Ze("wui-chip")
], ic);
const _le = ze`
  :host {
    position: relative;
    display: block;
  }

  button {
    background: var(--wui-color-accent-100);
    border: 1px solid var(--wui-gray-glass-010);
    border-radius: var(--wui-border-radius-m);
    gap: var(--wui-spacing-xs);
  }

  button.loading {
    background: var(--wui-gray-glass-010);
    border: 1px solid var(--wui-gray-glass-010);
    pointer-events: none;
  }

  button:disabled {
    background-color: var(--wui-gray-glass-015);
    border: 1px solid var(--wui-gray-glass-010);
  }

  button:disabled > wui-text {
    color: var(--wui-gray-glass-015);
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled {
      background-color: var(--wui-color-accent-090);
    }

    button:active:enabled {
      background-color: var(--wui-color-accent-080);
    }
  }

  button:focus-visible {
    border: 1px solid var(--wui-gray-glass-010);
    background-color: var(--wui-color-accent-090);
    -webkit-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    -moz-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
  }

  button[data-size='sm'] {
    padding: 6.75px 10px 7.25px;
  }

  ::slotted(*) {
    transition: opacity 200ms ease-in-out;
    opacity: var(--local-opacity-100);
  }

  button > wui-text {
    transition: opacity 200ms ease-in-out;
    opacity: var(--local-opacity-100);
    color: var(--wui-color-inverse-100);
  }

  button[data-size='md'] {
    padding: 9px var(--wui-spacing-l) 9px var(--wui-spacing-l);
  }

  button[data-size='md'] + wui-text {
    padding-left: var(--wui-spacing-3xs);
  }

  wui-loading-spinner {
    width: 14px;
    height: 14px;
  }

  wui-loading-spinner::slotted(svg) {
    width: 10px !important;
    height: 10px !important;
  }

  button[data-size='sm'] > wui-loading-spinner {
    width: 12px;
    height: 12px;
  }
`;
var dS = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let pM = class extends be {
  constructor() {
    super(...arguments), this.size = "md", this.loading = !1;
  }
  render() {
    const e = this.size === "md" ? "paragraph-600" : "small-600";
    return _`
      <button data-size=${this.size} ?disabled=${this.loading} ontouchstart>
        ${this.loadingTemplate()}
        <wui-text variant=${e} color=${this.loading ? "accent-100" : "inherit"}>
          <slot></slot>
        </wui-text>
      </button>
    `;
  }
  loadingTemplate() {
    return this.loading ? _`<wui-loading-spinner size=${this.size} color="accent-100"></wui-loading-spinner>` : null;
  }
};
pM.styles = [Rt, pr, _le];
dS([
  te()
], pM.prototype, "size", void 0);
dS([
  te({ type: Boolean })
], pM.prototype, "loading", void 0);
pM = dS([
  Ze("wui-connect-button")
], pM);
const Ple = ze`
  wui-flex {
    width: 100%;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
  }
`;
var pU = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let dh = class extends be {
  constructor() {
    super(...arguments), this.disabled = !1, this.label = "", this.buttonLabel = "";
  }
  render() {
    return _`
      <wui-flex
        justifyContent="space-between"
        alignItems="center"
        .padding=${["1xs", "2l", "1xs", "2l"]}
      >
        <wui-text variant="paragraph-500" color="fg-200">${this.label}</wui-text>
        <wui-button size="sm" variant="accent">
          ${this.buttonLabel}
          <wui-icon size="xs" color="inherit" slot="iconRight" name="chevronRight"></wui-icon>
        </wui-button>
      </wui-flex>
    `;
  }
};
dh.styles = [Rt, pr, Ple];
pU([
  te({ type: Boolean })
], dh.prototype, "disabled", void 0);
pU([
  te()
], dh.prototype, "label", void 0);
pU([
  te()
], dh.prototype, "buttonLabel", void 0);
dh = pU([
  Ze("wui-cta-button")
], dh);
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Kle = (t) => t.strings === void 0;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const s1 = (t, e) => {
  var r;
  const n = t._$AN;
  if (n === void 0)
    return !1;
  for (const i of n)
    (r = i._$AO) == null || r.call(i, e, !1), s1(i, e);
  return !0;
}, cV = (t) => {
  let e, n;
  do {
    if ((e = t._$AM) === void 0)
      break;
    n = e._$AN, n.delete(t), t = e;
  } while ((n == null ? void 0 : n.size) === 0);
}, dQ = (t) => {
  for (let e; e = t._$AM; t = e) {
    let n = e._$AN;
    if (n === void 0)
      e._$AN = n = /* @__PURE__ */ new Set();
    else if (n.has(t))
      break;
    n.add(t), ece(e);
  }
};
function $le(t) {
  this._$AN !== void 0 ? (cV(this), this._$AM = t, dQ(this)) : this._$AM = t;
}
function qle(t, e = !1, n = 0) {
  const r = this._$AH, i = this._$AN;
  if (i !== void 0 && i.size !== 0)
    if (e)
      if (Array.isArray(r))
        for (let a = n; a < r.length; a++)
          s1(r[a], !1), cV(r[a]);
      else
        r != null && (s1(r, !1), cV(r));
    else
      s1(this, t);
}
const ece = (t) => {
  t.type == rQ.CHILD && (t._$AP ?? (t._$AP = qle), t._$AQ ?? (t._$AQ = $le));
};
class tce extends aQ {
  constructor() {
    super(...arguments), this._$AN = void 0;
  }
  _$AT(e, n, r) {
    super._$AT(e, n, r), dQ(this), this.isConnected = e._$AU;
  }
  _$AO(e, n = !0) {
    var r, i;
    e !== this.isConnected && (this.isConnected = e, e ? (r = this.reconnected) == null || r.call(this) : (i = this.disconnected) == null || i.call(this)), n && (s1(this, e), cV(this));
  }
  setValue(e) {
    if (Kle(this._$Ct))
      this._$Ct._$AI(e, this);
    else {
      const n = [...this._$Ct._$AH];
      n[this._$Ci] = e, this._$Ct._$AI(n, this, 0);
    }
  }
  disconnected() {
  }
  reconnected() {
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const uS = () => new nce();
class nce {
}
const Vg = /* @__PURE__ */ new WeakMap(), hS = iQ(class extends tce {
  render(t) {
    return ar;
  }
  update(t, [e]) {
    var r;
    const n = e !== this.G;
    return n && this.G !== void 0 && this.ot(void 0), (n || this.rt !== this.lt) && (this.G = e, this.ct = (r = t.options) == null ? void 0 : r.host, this.ot(this.lt = t.element)), ar;
  }
  ot(t) {
    if (typeof this.G == "function") {
      const e = this.ct ?? globalThis;
      let n = Vg.get(e);
      n === void 0 && (n = /* @__PURE__ */ new WeakMap(), Vg.set(e, n)), n.get(this.G) !== void 0 && this.G.call(this.ct, void 0), n.set(this.G, t), t !== void 0 && this.G.call(this.ct, t);
    } else
      this.G.value = t;
  }
  get rt() {
    var t, e;
    return typeof this.G == "function" ? (t = Vg.get(this.ct ?? globalThis)) == null ? void 0 : t.get(this.G) : (e = this.G) == null ? void 0 : e.value;
  }
  disconnected() {
    this.rt === this.lt && this.ot(void 0);
  }
  reconnected() {
    this.ot(this.lt);
  }
}), rce = ze`
  :host {
    position: relative;
    width: 100%;
    display: inline-block;
    color: var(--wui-color-fg-275);
  }

  input {
    width: 100%;
    border-radius: var(--wui-border-radius-xs);
    border: 1px solid var(--wui-gray-glass-005);
    background: var(--wui-gray-glass-005);
    font-size: var(--wui-font-size-paragraph);
    font-weight: var(--wui-font-weight-light);
    letter-spacing: var(--wui-letter-spacing-paragraph);
    color: var(--wui-color-fg-100);
    transition: all var(--wui-ease-inout-power-1) var(--wui-duration-lg);
    caret-color: var(--wui-color-accent-100);
  }

  input:disabled {
    cursor: not-allowed;
    border: 1px solid var(--wui-gray-glass-010);
    background: var(--wui-gray-glass-015);
  }

  input:disabled::placeholder,
  input:disabled + wui-icon {
    color: var(--wui-color-fg-300);
  }

  input::placeholder {
    color: var(--wui-color-fg-275);
  }

  input:focus:enabled {
    transition: all var(--wui-ease-out-power-2) var(--wui-duration-sm);
    background-color: var(--wui-gray-glass-010);
    border: 1px solid var(--wui-color-accent-100);
    -webkit-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    -moz-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
  }

  input:hover:enabled {
    background-color: var(--wui-gray-glass-010);
  }

  wui-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }

  .wui-size-sm {
    padding: 9px var(--wui-spacing-m) 10px var(--wui-spacing-s);
  }

  wui-icon + .wui-size-sm {
    padding: 9px var(--wui-spacing-m) 10px 36px;
  }

  wui-icon[data-input='sm'] {
    left: var(--wui-spacing-s);
  }

  .wui-size-md {
    padding: 15px var(--wui-spacing-m) var(--wui-spacing-l) var(--wui-spacing-m);
  }

  wui-icon + .wui-size-md {
    padding: 15px var(--wui-spacing-m) var(--wui-spacing-l) var(--wui-spacing-3xl);
  }

  wui-icon[data-input='md'] {
    left: var(--wui-spacing-l);
  }

  input:placeholder-shown ~ ::slotted(wui-input-element),
  input:placeholder-shown ~ ::slotted(wui-icon) {
    opacity: 0;
    pointer-events: none;
  }

  ::slotted(wui-input-element),
  ::slotted(wui-icon) {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    transition: all var(--wui-ease-in-power-2) var(--wui-duration-md);
  }

  ::slotted(wui-input-element) {
    right: var(--wui-spacing-m);
  }

  ::slotted(wui-icon) {
    right: 0px;
  }
`;
var Nu = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let Os = class extends be {
  constructor() {
    super(...arguments), this.inputElementRef = uS(), this.size = "md", this.disabled = !1, this.placeholder = "", this.type = "text";
  }
  render() {
    const e = `wui-size-${this.size}`;
    return _` ${this.templateIcon()}
      <input
        ${hS(this.inputElementRef)}
        class=${e}
        type=${this.type}
        enterkeyhint=${Ft(this.enterKeyHint)}
        ?disabled=${this.disabled}
        placeholder=${this.placeholder}
        @input=${this.dispatchInputChangeEvent.bind(this)}
      />
      <slot></slot>`;
  }
  templateIcon() {
    return this.icon ? _`<wui-icon
        data-input=${this.size}
        size="md"
        color="inherit"
        name=${this.icon}
      ></wui-icon>` : null;
  }
  dispatchInputChangeEvent() {
    var e;
    this.dispatchEvent(new CustomEvent("inputChange", {
      detail: (e = this.inputElementRef.value) == null ? void 0 : e.value,
      bubbles: !0,
      composed: !0
    }));
  }
};
Os.styles = [Rt, pr, rce];
Nu([
  te()
], Os.prototype, "size", void 0);
Nu([
  te()
], Os.prototype, "icon", void 0);
Nu([
  te({ type: Boolean })
], Os.prototype, "disabled", void 0);
Nu([
  te()
], Os.prototype, "placeholder", void 0);
Nu([
  te()
], Os.prototype, "type", void 0);
Nu([
  te()
], Os.prototype, "keyHint", void 0);
Os = Nu([
  Ze("wui-input-text")
], Os);
const ice = ze`
  :host {
    position: relative;
    display: inline-block;
  }

  wui-text {
    margin: var(--wui-spacing-xxs) var(--wui-spacing-m) var(--wui-spacing-0) var(--wui-spacing-m);
  }
`;
var NS = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let mM = class extends be {
  constructor() {
    super(...arguments), this.disabled = !1;
  }
  render() {
    return _`
      <wui-input-text
        placeholder="Email"
        icon="mail"
        size="md"
        .disabled=${this.disabled}
      ></wui-input-text>
      ${this.templateError()}
    `;
  }
  templateError() {
    return this.errorMessage ? _`<wui-text variant="tiny-500" color="error-100">${this.errorMessage}</wui-text>` : null;
  }
};
mM.styles = [Rt, ice];
NS([
  te()
], mM.prototype, "errorMessage", void 0);
NS([
  te({ type: Boolean })
], mM.prototype, "disabled", void 0);
mM = NS([
  Ze("wui-email-input")
], mM);
const ace = ze`
  button {
    border-radius: var(--wui-border-radius-xxs);
    color: var(--wui-color-fg-100);
    padding: var(--wui-spacing-2xs);
  }

  @media (max-width: 700px) {
    button {
      padding: var(--wui-spacing-s);
    }
  }

  button > wui-icon {
    pointer-events: none;
  }

  button:disabled > wui-icon {
    color: var(--wui-color-bg-300) !important;
  }

  button:disabled {
    background-color: transparent;
  }
`;
var qp = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let Qd = class extends be {
  constructor() {
    super(...arguments), this.size = "md", this.disabled = !1, this.icon = "copy", this.iconColor = "inherit";
  }
  render() {
    return _`
      <button ?disabled=${this.disabled} ontouchstart>
        <wui-icon color=${this.iconColor} size=${this.size} name=${this.icon}></wui-icon>
      </button>
    `;
  }
};
Qd.styles = [Rt, pr, sS, ace];
qp([
  te()
], Qd.prototype, "size", void 0);
qp([
  te({ type: Boolean })
], Qd.prototype, "disabled", void 0);
qp([
  te()
], Qd.prototype, "icon", void 0);
qp([
  te()
], Qd.prototype, "iconColor", void 0);
Qd = qp([
  Ze("wui-icon-link")
], Qd);
const oce = ze`
  button {
    background-color: var(--wui-color-fg-300);
    border-radius: var(--wui-border-radius-4xs);
    width: 16px;
    height: 16px;
  }

  button:disabled {
    background-color: var(--wui-color-bg-300);
  }

  wui-icon {
    color: var(--wui-color-bg-200) !important;
  }

  button:focus-visible {
    background-color: var(--wui-color-fg-250);
    border: 1px solid var(--wui-color-accent-100);
  }

  button:active:enabled {
    background-color: var(--wui-color-fg-225);
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled {
      background-color: var(--wui-color-fg-250);
    }
  }
`;
var uQ = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let dV = class extends be {
  constructor() {
    super(...arguments), this.icon = "copy";
  }
  render() {
    return _`
      <button>
        <wui-icon color="inherit" size="xxs" name=${this.icon}></wui-icon>
      </button>
    `;
  }
};
dV.styles = [Rt, pr, oce];
uQ([
  te()
], dV.prototype, "icon", void 0);
dV = uQ([
  Ze("wui-input-element")
], dV);
const sce = ze`
  :host {
    position: relative;
    display: inline-block;
  }

  input {
    width: 50px;
    height: 50px;
    background: var(--wui-gray-glass-005);
    border-radius: var(--wui-border-radius-xs);
    border: 1px solid var(--wui-gray-glass-005);
    font-family: var(--wui-font-family);
    font-size: var(--wui-font-size-large);
    font-weight: var(--wui-font-weight-regular);
    letter-spacing: var(--wui-letter-spacing-large);
    text-align: center;
    color: var(--wui-color-fg-100);
    caret-color: var(--wui-color-accent-100);
    transition: all var(--wui-ease-inout-power-1) var(--wui-duration-lg);
    box-sizing: border-box;
    -webkit-appearance: none;
    -moz-appearance: textfield;
    padding: 0px;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }

  input:disabled {
    cursor: not-allowed;
    border: 1px solid var(--wui-gray-glass-010);
    background: var(--wui-gray-glass-015);
  }

  input:focus:enabled {
    transition: all var(--wui-ease-out-power-2) var(--wui-duration-sm);
    background-color: var(--wui-gray-glass-010);
    border: 1px solid var(--wui-color-accent-100);
    -webkit-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    -moz-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
  }

  input:hover:enabled {
    background-color: var(--wui-gray-glass-010);
  }
`;
var hQ = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let uV = class extends be {
  constructor() {
    super(...arguments), this.disabled = !1;
  }
  render() {
    return _`<input
      type="number"
      maxlength="1"
      inputmode="numeric"
      autofocus
      ?disabled=${this.disabled}
    /> `;
  }
};
uV.styles = [Rt, pr, sce];
hQ([
  te({ type: Boolean })
], uV.prototype, "disabled", void 0);
uV = hQ([
  Ze("wui-input-numeric")
], uV);
const lce = ze`
  button {
    padding: var(--wui-spacing-4xs) var(--wui-spacing-xxs);
    border-radius: var(--wui-border-radius-3xs);
    background-color: transparent;
    color: var(--wui-color-accent-100);
  }

  button:disabled {
    background-color: transparent;
    color: var(--wui-gray-glass-015);
  }
`;
var MS = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let TM = class extends be {
  constructor() {
    super(...arguments), this.disabled = !1, this.color = "inherit";
  }
  render() {
    return _`
      <button ?disabled=${this.disabled} ontouchstart>
        <slot name="iconLeft"></slot>
        <wui-text variant="small-600" color=${this.color}>
          <slot></slot>
        </wui-text>
        <slot name="iconRight"></slot>
      </button>
    `;
  }
};
TM.styles = [Rt, pr, lce];
MS([
  te({ type: Boolean })
], TM.prototype, "disabled", void 0);
MS([
  te()
], TM.prototype, "color", void 0);
TM = MS([
  Ze("wui-link")
], TM);
const cce = ze`
  button {
    column-gap: var(--wui-spacing-s);
    padding: 11px 18px 11px var(--wui-spacing-s);
    width: 100%;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-250);
  }

  button[data-iconvariant='square'],
  button[data-iconvariant='square-blue'] {
    padding: 6px 18px 6px 9px;
  }

  button > wui-flex {
    flex: 1;
  }

  button > wui-image {
    width: 32px;
    height: 32px;
    box-shadow: 0 0 0 2px var(--wui-gray-glass-005);
    border-radius: var(--wui-border-radius-3xl);
  }

  button > wui-icon {
    width: 36px;
    height: 36px;
  }

  button > wui-icon-box[data-variant='blue'] {
    box-shadow: 0 0 0 2px var(--wui-accent-glass-005);
  }

  button > wui-icon-box[data-variant='overlay'] {
    box-shadow: 0 0 0 2px var(--wui-gray-glass-005);
  }

  button > wui-icon-box[data-variant='square-blue'] {
    border-radius: var(--wui-border-radius-3xs);
    position: relative;
    border: none;
    width: 36px;
    height: 36px;
  }

  button > wui-icon-box[data-variant='square-blue']::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: inherit;
    border: 1px solid var(--wui-accent-glass-010);
    pointer-events: none;
  }

  button > wui-icon:last-child {
    width: 14px;
    height: 14px;
  }

  button:disabled {
    background-color: var(--wui-gray-glass-015);
    color: var(--wui-gray-glass-015);
  }

  button[data-loading='true'] > wui-icon {
    transition: opacity 200ms ease-in-out;
    opacity: 0;
  }

  wui-loading-spinner {
    position: absolute;
    right: 18px;
    top: 50%;
    transform: translateY(-50%);
  }
`;
var Jo = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let xa = class extends be {
  constructor() {
    super(...arguments), this.variant = "icon", this.disabled = !1, this.imageSrc = void 0, this.alt = void 0, this.chevron = !1, this.loading = !1;
  }
  render() {
    return _`
      <button
        ?disabled=${this.loading ? !0 : !!this.disabled}
        data-loading=${this.loading}
        data-iconvariant=${Ft(this.iconVariant)}
        ontouchstart
      >
        ${this.loadingTemplate()} ${this.visualTemplate()}
        <wui-flex gap="3xs">
          <slot></slot>
        </wui-flex>
        ${this.chevronTemplate()}
      </button>
    `;
  }
  visualTemplate() {
    if (this.variant === "image" && this.imageSrc)
      return _`<wui-image src=${this.imageSrc} alt=${this.alt ?? "list item"}></wui-image>`;
    if (this.iconVariant === "square" && this.icon && this.variant === "icon")
      return _`<wui-icon name=${this.icon}></wui-icon>`;
    if (this.variant === "icon" && this.icon && this.iconVariant) {
      const e = ["blue", "square-blue"].includes(this.iconVariant) ? "accent-100" : "fg-200", n = this.iconVariant === "square-blue" ? "mdl" : "md", r = this.iconSize ? this.iconSize : n;
      return _`
        <wui-icon-box
          data-variant=${this.iconVariant}
          icon=${this.icon}
          iconSize=${r}
          background="transparent"
          iconColor=${e}
          backgroundColor=${e}
          size=${n}
        ></wui-icon-box>
      `;
    }
    return null;
  }
  loadingTemplate() {
    return this.loading ? _`<wui-loading-spinner color="fg-300"></wui-loading-spinner>` : _``;
  }
  chevronTemplate() {
    return this.chevron ? _`<wui-icon size="inherit" color="fg-200" name="chevronRight"></wui-icon>` : null;
  }
};
xa.styles = [Rt, pr, cce];
Jo([
  te()
], xa.prototype, "icon", void 0);
Jo([
  te()
], xa.prototype, "iconSize", void 0);
Jo([
  te()
], xa.prototype, "variant", void 0);
Jo([
  te()
], xa.prototype, "iconVariant", void 0);
Jo([
  te({ type: Boolean })
], xa.prototype, "disabled", void 0);
Jo([
  te()
], xa.prototype, "imageSrc", void 0);
Jo([
  te()
], xa.prototype, "alt", void 0);
Jo([
  te({ type: Boolean })
], xa.prototype, "chevron", void 0);
Jo([
  te({ type: Boolean })
], xa.prototype, "loading", void 0);
xa = Jo([
  Ze("wui-list-item")
], xa);
var rb;
(function(t) {
  t.approve = "approved", t.bought = "bought", t.borrow = "borrowed", t.burn = "burnt", t.cancel = "canceled", t.claim = "claimed", t.deploy = "deployed", t.deposit = "deposited", t.execute = "executed", t.mint = "minted", t.receive = "received", t.repay = "repaid", t.send = "sent", t.sell = "sold", t.stake = "staked", t.trade = "swapped", t.unstake = "unstaked", t.withdraw = "withdrawn";
})(rb || (rb = {}));
const dce = ze`
  :host > wui-flex {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 40px;
    height: 40px;
    box-shadow: inset 0 0 0 1px var(--wui-gray-glass-005);
    background-color: var(--wui-gray-glass-005);
  }

  :host > wui-flex wui-image {
    display: block;
    z-index: -1;
  }

  :host > wui-flex,
  :host > wui-flex wui-image,
  .swap-images-container,
  .swap-images-container.nft,
  wui-image.nft {
    border-top-left-radius: var(--local-left-border-radius);
    border-top-right-radius: var(--local-right-border-radius);
    border-bottom-left-radius: var(--local-left-border-radius);
    border-bottom-right-radius: var(--local-right-border-radius);
  }

  wui-icon {
    width: 20px;
    height: 20px;
  }

  wui-icon-box {
    position: absolute;
    right: 0;
    bottom: 0;
    transform: translate(20%, 20%);
  }

  .swap-images-container {
    position: relative;
    width: 40px;
    height: 40px;
    overflow: hidden;
  }

  .swap-images-container wui-image:first-child {
    position: absolute;
    width: 40px;
    height: 40px;
    top: 0;
    left: 0%;
    clip-path: inset(0px calc(50% + 2px) 0px 0%);
  }

  .swap-images-container wui-image:last-child {
    clip-path: inset(0px 0px 0px calc(50% + 2px));
  }
`;
var Mu = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let Ys = class extends be {
  constructor() {
    super(...arguments), this.images = [], this.secondImage = {
      type: void 0,
      url: ""
    };
  }
  render() {
    const [e, n] = this.images, r = (e == null ? void 0 : e.type) === "NFT", i = n != null && n.url ? n.type === "NFT" : r, a = r ? "var(--wui-border-radius-xxs)" : "var(--wui-border-radius-s)", o = i ? "var(--wui-border-radius-xxs)" : "var(--wui-border-radius-s)";
    return this.style.cssText = `
    --local-left-border-radius: ${a};
    --local-right-border-radius: ${o};
    `, _`<wui-flex> ${this.templateVisual()} ${this.templateIcon()} </wui-flex>`;
  }
  templateVisual() {
    const [e, n] = this.images, r = e == null ? void 0 : e.type;
    return this.images.length === 2 && (e != null && e.url || n != null && n.url) ? _`<div class="swap-images-container">
        ${e != null && e.url ? _`<wui-image src=${e.url} alt="Transaction image"></wui-image>` : null}
        ${n != null && n.url ? _`<wui-image src=${n.url} alt="Transaction image"></wui-image>` : null}
      </div>` : e != null && e.url ? _`<wui-image src=${e.url} alt="Transaction image"></wui-image>` : r === "NFT" ? _`<wui-icon size="inherit" color="fg-200" name="nftPlaceholder"></wui-icon>` : _`<wui-icon size="inherit" color="fg-200" name="coinPlaceholder"></wui-icon>`;
  }
  templateIcon() {
    let e = "accent-100", n;
    return n = this.getIcon(), this.status && (e = this.getStatusColor()), n ? _`
      <wui-icon-box
        size="xxs"
        iconColor=${e}
        backgroundColor=${e}
        background="opaque"
        icon=${n}
        ?border=${!0}
        borderColor="wui-color-bg-125"
      ></wui-icon-box>
    ` : null;
  }
  getDirectionIcon() {
    switch (this.direction) {
      case "in":
        return "arrowBottom";
      case "out":
        return "arrowTop";
      default:
        return;
    }
  }
  getIcon() {
    return this.onlyDirectionIcon ? this.getDirectionIcon() : this.type === "trade" ? "swapHorizontalBold" : this.type === "approve" ? "checkmark" : this.type === "cancel" ? "close" : this.getDirectionIcon();
  }
  getStatusColor() {
    switch (this.status) {
      case "confirmed":
        return "success-100";
      case "failed":
        return "error-100";
      case "pending":
        return "inverse-100";
      default:
        return "accent-100";
    }
  }
};
Ys.styles = [dce];
Mu([
  te()
], Ys.prototype, "type", void 0);
Mu([
  te()
], Ys.prototype, "status", void 0);
Mu([
  te()
], Ys.prototype, "direction", void 0);
Mu([
  te({ type: Boolean })
], Ys.prototype, "onlyDirectionIcon", void 0);
Mu([
  te({ type: Array })
], Ys.prototype, "images", void 0);
Mu([
  te({ type: Object })
], Ys.prototype, "secondImage", void 0);
Ys = Mu([
  Ze("wui-transaction-visual")
], Ys);
const uce = ze`
  :host > wui-flex:first-child {
    align-items: center;
    column-gap: var(--wui-spacing-s);
    padding: 6.5px var(--wui-spacing-l) 6.5px var(--wui-spacing-xs);
    width: 100%;
  }

  :host > wui-flex:first-child wui-text:nth-child(1) {
    text-transform: capitalize;
  }

  wui-transaction-visual {
    width: 40px;
    height: 40px;
  }

  wui-flex {
    flex: 1;
  }

  :host wui-flex wui-flex {
    overflow: hidden;
  }

  :host .description-container wui-text span {
    word-break: break-all;
  }

  :host .description-container wui-text {
    overflow: hidden;
  }

  :host .description-separator-icon {
    margin: 0px 6px;
  }

  :host wui-text > span {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
`;
var Ec = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let Fo = class extends be {
  constructor() {
    super(...arguments), this.type = "approve", this.onlyDirectionIcon = !1, this.images = [];
  }
  render() {
    return _`
      <wui-flex>
        <wui-transaction-visual
          .status=${this.status}
          direction=${Ft(this.direction)}
          type=${this.type}
          onlyDirectionIcon=${Ft(this.onlyDirectionIcon)}
          .images=${this.images}
        ></wui-transaction-visual>
        <wui-flex flexDirection="column" gap="3xs">
          <wui-text variant="paragraph-600" color="fg-100">
            ${rb[this.type]}
          </wui-text>
          <wui-flex class="description-container">
            ${this.templateDescription()} ${this.templateSecondDescription()}
          </wui-flex>
        </wui-flex>
        <wui-text variant="micro-700" color="fg-300"><span>${this.date}</span></wui-text>
      </wui-flex>
    `;
  }
  templateDescription() {
    var n;
    const e = (n = this.descriptions) == null ? void 0 : n[0];
    return e ? _`
          <wui-text variant="small-500" color="fg-200">
            <span>${e}</span>
          </wui-text>
        ` : null;
  }
  templateSecondDescription() {
    var n;
    const e = (n = this.descriptions) == null ? void 0 : n[1];
    return e ? _`
          <wui-icon class="description-separator-icon" size="xxs" name="arrowRight"></wui-icon>
          <wui-text variant="small-400" color="fg-200">
            <span>${e}</span>
          </wui-text>
        ` : null;
  }
};
Fo.styles = [Rt, uce];
Ec([
  te()
], Fo.prototype, "type", void 0);
Ec([
  te({ type: Array })
], Fo.prototype, "descriptions", void 0);
Ec([
  te()
], Fo.prototype, "date", void 0);
Ec([
  te({ type: Boolean })
], Fo.prototype, "onlyDirectionIcon", void 0);
Ec([
  te()
], Fo.prototype, "status", void 0);
Ec([
  te()
], Fo.prototype, "direction", void 0);
Ec([
  te({ type: Array })
], Fo.prototype, "images", void 0);
Fo = Ec([
  Ze("wui-transaction-list-item")
], Fo);
const hce = ze`
  :host > wui-flex:first-child {
    column-gap: var(--wui-spacing-s);
    padding: 7px var(--wui-spacing-l) 7px var(--wui-spacing-xs);
    width: 100%;
  }

  wui-flex {
    display: flex;
    flex: 1;
  }
`;
var Nce = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let ib = class extends be {
  render() {
    return _`
      <wui-flex alignItems="center">
        <wui-shimmer width="40px" height="40px"></wui-shimmer>
        <wui-flex flexDirection="column" gap="2xs">
          <wui-shimmer width="72px" height="16px" borderRadius="4xs"></wui-shimmer>
          <wui-shimmer width="148px" height="14px" borderRadius="4xs"></wui-shimmer>
        </wui-flex>
        <wui-shimmer width="24px" height="12px" borderRadius="5xs"></wui-shimmer>
      </wui-flex>
    `;
  }
};
ib.styles = [Rt, hce];
ib = Nce([
  Ze("wui-transaction-list-item-loader")
], ib);
const Mce = ze`
  :host {
    display: block;
    padding: 3.5px 5px !important;
    border-radius: var(--wui-border-radius-5xs);
  }

  :host([data-variant='main']) {
    background-color: var(--wui-accent-glass-015);
    color: var(--wui-color-accent-100);
  }

  :host([data-variant='shade']) {
    background-color: var(--wui-gray-glass-010);
    color: var(--wui-color-fg-200);
  }

  :host([data-variant='success']) {
    background-color: var(--wui-icon-box-bg-success-100);
    color: var(--wui-color-success-100);
  }

  :host([data-variant='error']) {
    background-color: var(--wui-icon-box-bg-error-100);
    color: var(--wui-color-error-100);
  }
`;
var NQ = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let hV = class extends be {
  constructor() {
    super(...arguments), this.variant = "main";
  }
  render() {
    return this.dataset.variant = this.variant, _`
      <wui-text data-variant=${this.variant} variant="micro-700" color="inherit">
        <slot></slot>
      </wui-text>
    `;
  }
};
hV.styles = [Rt, Mce];
NQ([
  te()
], hV.prototype, "variant", void 0);
hV = NQ([
  Ze("wui-tag")
], hV);
const pce = ze`
  button {
    column-gap: var(--wui-spacing-s);
    padding: 7px var(--wui-spacing-l) 7px var(--wui-spacing-xs);
    width: 100%;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-100);
  }

  button > wui-text:nth-child(2) {
    display: flex;
    flex: 1;
  }

  wui-icon {
    color: var(--wui-color-fg-200) !important;
  }

  button:disabled {
    background-color: var(--wui-gray-glass-015);
    color: var(--wui-gray-glass-015);
  }

  button:disabled > wui-tag {
    background-color: var(--wui-gray-glass-010);
    color: var(--wui-color-fg-300);
  }
`;
var to = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let na = class extends be {
  constructor() {
    super(...arguments), this.walletImages = [], this.imageSrc = "", this.name = "", this.installed = !1, this.disabled = !1, this.showAllWallets = !1;
  }
  render() {
    return _`
      <button ?disabled=${this.disabled} ontouchstart>
        ${this.templateAllWallets()} ${this.templateWalletImage()}
        <wui-text variant="paragraph-500" color="inherit">${this.name}</wui-text>
        ${this.templateStatus()}
      </button>
    `;
  }
  templateAllWallets() {
    return this.showAllWallets && this.imageSrc ? _` <wui-all-wallets-image .imageeSrc=${this.imageSrc}> </wui-all-wallets-image> ` : this.showAllWallets && this.walletIcon ? _` <wui-wallet-image .walletIcon=${this.walletIcon} size="sm"> </wui-wallet-image> ` : null;
  }
  templateWalletImage() {
    return !this.showAllWallets && this.imageSrc ? _`<wui-wallet-image
        size="sm"
        imageSrc=${this.imageSrc}
        name=${this.name}
        .installed=${this.installed}
      ></wui-wallet-image>` : !this.showAllWallets && !this.imageSrc ? _`<wui-wallet-image size="sm" name=${this.name}></wui-wallet-image>` : null;
  }
  templateStatus() {
    return this.tagLabel && this.tagVariant ? _`<wui-tag variant=${this.tagVariant}>${this.tagLabel}</wui-tag>` : this.icon ? _`<wui-icon color="inherit" size="sm" name=${this.icon}></wui-icon>` : null;
  }
};
na.styles = [Rt, pr, pce];
to([
  te({ type: Array })
], na.prototype, "walletImages", void 0);
to([
  te()
], na.prototype, "imageSrc", void 0);
to([
  te()
], na.prototype, "name", void 0);
to([
  te()
], na.prototype, "tagLabel", void 0);
to([
  te()
], na.prototype, "tagVariant", void 0);
to([
  te()
], na.prototype, "icon", void 0);
to([
  te()
], na.prototype, "walletIcon", void 0);
to([
  te({ type: Boolean })
], na.prototype, "installed", void 0);
to([
  te({ type: Boolean })
], na.prototype, "disabled", void 0);
to([
  te({ type: Boolean })
], na.prototype, "showAllWallets", void 0);
na = to([
  Ze("wui-list-wallet")
], na);
const mce = ze`
  :host {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: var(--wui-border-radius-3xl);
    border: 1px solid var(--wui-gray-glass-010);
    overflow: hidden;
  }

  wui-icon {
    width: 100%;
    height: 100%;
  }
`;
var MQ = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let NV = class extends be {
  constructor() {
    super(...arguments), this.logo = "google";
  }
  render() {
    return _`<wui-icon color="inherit" size="inherit" name=${this.logo}></wui-icon> `;
  }
};
NV.styles = [Rt, mce];
MQ([
  te()
], NV.prototype, "logo", void 0);
NV = MQ([
  Ze("wui-logo")
], NV);
const Tce = ze`
  :host {
    display: block;
  }

  button {
    width: 50px;
    height: 50px;
    background: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
  }
`;
var pS = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let fM = class extends be {
  constructor() {
    super(...arguments), this.logo = "google", this.disabled = !1;
  }
  render() {
    return _`
      <button ?disabled=${this.disabled} ontouchstart>
        <wui-logo logo=${this.logo}></wui-logo>
      </button>
    `;
  }
};
fM.styles = [Rt, pr, Tce];
pS([
  te()
], fM.prototype, "logo", void 0);
pS([
  te({ type: Boolean })
], fM.prototype, "disabled", void 0);
fM = pS([
  Ze("wui-logo-select")
], fM);
const fce = ze`
  :host {
    display: block;
  }

  button {
    border-radius: var(--wui-border-radius-3xl);
    display: flex;
    gap: var(--wui-spacing-xs);
    padding: var(--wui-spacing-2xs) var(--wui-spacing-s) var(--wui-spacing-2xs)
      var(--wui-spacing-xs);
    border: 1px solid var(--wui-gray-glass-010);
    background-color: var(--wui-gray-glass-005);
    color: var(--wui-color-fg-100);
  }

  button:disabled {
    border: 1px solid var(--wui-gray-glass-005);
    background-color: var(--wui-gray-glass-015);
    color: var(--wui-gray-glass-015);
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled {
      background-color: var(--wui-gray-glass-010);
    }

    button:active:enabled {
      background-color: var(--wui-gray-glass-015);
    }
  }

  wui-image,
  wui-icon-box {
    border-radius: var(--wui-border-radius-3xl);
    width: 24px;
    height: 24px;
    box-shadow: 0 0 0 2px var(--wui-gray-glass-005);
  }
`;
var mS = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let VM = class extends be {
  constructor() {
    super(...arguments), this.imageSrc = void 0, this.disabled = !1;
  }
  render() {
    return _`
      <button ?disabled=${this.disabled}>
        ${this.visualTemplate()}
        <wui-text variant="paragraph-600" color="inherit">
          <slot></slot>
        </wui-text>
      </button>
    `;
  }
  visualTemplate() {
    return this.imageSrc ? _`<wui-image src=${this.imageSrc}></wui-image>` : _`
      <wui-icon-box
        size="sm"
        iconColor="inverse-100"
        backgroundColor="fg-100"
        icon="networkPlaceholder"
      ></wui-icon-box>
    `;
  }
};
VM.styles = [Rt, pr, fce];
mS([
  te()
], VM.prototype, "imageSrc", void 0);
mS([
  te({ type: Boolean })
], VM.prototype, "disabled", void 0);
VM = mS([
  Ze("wui-network-button")
], VM);
const Vce = ze`
  :host {
    position: relative;
    display: block;
  }
`;
var pQ = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let MV = class extends be {
  constructor() {
    super(...arguments), this.length = 6, this.numerics = [], this.valueArr = Array.from({ length: this.length }).map(() => ""), this.handleKeyDown = (e, n) => {
      const r = e.target, i = this.getInputElement(r), a = ["ArrowLeft", "ArrowRight", "Shift", "Delete"];
      if (!i)
        return;
      a.includes(e.key) && e.preventDefault();
      const o = i.selectionStart;
      switch (e.key) {
        case "ArrowLeft":
          o && i.setSelectionRange(o + 1, o + 1), this.focusInputField("prev", n);
          break;
        case "ArrowRight":
          this.focusInputField("next", n);
          break;
        case "Shift":
          this.focusInputField("next", n);
          break;
        case "Delete":
          i.value === "" ? this.focusInputField("prev", n) : (i.value = "", this.valueArr[n] = "");
          break;
        case "Backspace":
          i.value === "" ? this.focusInputField("prev", n) : (i.value = "", this.valueArr[n] = "");
          break;
      }
    }, this.focusInputField = (e, n) => {
      if (e === "next") {
        const r = n + 1, i = this.numerics[r < this.length ? r : n], a = i ? this.getInputElement(i) : void 0;
        a && a.focus();
      }
      if (e === "prev") {
        const r = n - 1, i = this.numerics[r > -1 ? r : n], a = i ? this.getInputElement(i) : void 0;
        a && a.focus();
      }
    };
  }
  firstUpdated() {
    var n;
    const e = (n = this.shadowRoot) == null ? void 0 : n.querySelectorAll("wui-input-numeric");
    e && (this.numerics = Array.from(e));
  }
  render() {
    return _`
      <wui-flex gap="xxs">
        ${Array.from({ length: this.length }).map((e, n) => _`
            <wui-input-numeric
              @input=${(r) => this.handleInput(r, n)}
              @keydown=${(r) => this.handleKeyDown(r, n)}
            >
            </wui-input-numeric>
          `)}
      </wui-flex>
    `;
  }
  handleInput(e, n) {
    const r = e.target, i = this.getInputElement(r);
    if (i) {
      const a = i.value;
      e.inputType === "insertFromPaste" ? this.handlePaste(i, a, n) : yn.isNumber(a) && e.data ? (i.value = e.data, this.valueArr[n] = e.data, this.focusInputField("next", n)) : (i.value = "", this.valueArr[n] = "");
    }
    this.dispatchInputChangeEvent();
  }
  handlePaste(e, n, r) {
    const i = n[0];
    if (i && yn.isNumber(i)) {
      e.value = i, this.valueArr[r] = i;
      const o = n.substring(1);
      if (r + 1 < this.length && o.length) {
        const s = this.numerics[r + 1], l = s ? this.getInputElement(s) : void 0;
        l && this.handlePaste(l, o, r + 1);
      } else
        this.focusInputField("next", r);
    } else
      e.value = "", this.valueArr[r] = "";
  }
  getInputElement(e) {
    var n;
    return (n = e.shadowRoot) != null && n.querySelector("input") ? e.shadowRoot.querySelector("input") : null;
  }
  dispatchInputChangeEvent() {
    const e = this.valueArr.join("");
    this.dispatchEvent(new CustomEvent("inputChange", {
      detail: e,
      bubbles: !0,
      composed: !0
    }));
  }
};
MV.styles = [Rt, Vce];
pQ([
  te({ type: Number })
], MV.prototype, "length", void 0);
MV = pQ([
  Ze("wui-otp")
], MV);
var em = {}, Uce = function() {
  return typeof Promise == "function" && Promise.prototype && Promise.prototype.then;
}, mQ = {}, la = {};
let TS;
const Rce = [
  0,
  // Not used
  26,
  44,
  70,
  100,
  134,
  172,
  196,
  242,
  292,
  346,
  404,
  466,
  532,
  581,
  655,
  733,
  815,
  901,
  991,
  1085,
  1156,
  1258,
  1364,
  1474,
  1588,
  1706,
  1828,
  1921,
  2051,
  2185,
  2323,
  2465,
  2611,
  2761,
  2876,
  3034,
  3196,
  3362,
  3532,
  3706
];
la.getSymbolSize = function(e) {
  if (!e)
    throw new Error('"version" cannot be null or undefined');
  if (e < 1 || e > 40)
    throw new Error('"version" should be in range from 1 to 40');
  return e * 4 + 17;
};
la.getSymbolTotalCodewords = function(e) {
  return Rce[e];
};
la.getBCHDigit = function(t) {
  let e = 0;
  for (; t !== 0; )
    e++, t >>>= 1;
  return e;
};
la.setToSJISFunction = function(e) {
  if (typeof e != "function")
    throw new Error('"toSJISFunc" is not a valid function.');
  TS = e;
};
la.isKanjiModeEnabled = function() {
  return typeof TS < "u";
};
la.toSJIS = function(e) {
  return TS(e);
};
var mU = {};
(function(t) {
  t.L = { bit: 1 }, t.M = { bit: 0 }, t.Q = { bit: 3 }, t.H = { bit: 2 };
  function e(n) {
    if (typeof n != "string")
      throw new Error("Param is not a string");
    switch (n.toLowerCase()) {
      case "l":
      case "low":
        return t.L;
      case "m":
      case "medium":
        return t.M;
      case "q":
      case "quartile":
        return t.Q;
      case "h":
      case "high":
        return t.H;
      default:
        throw new Error("Unknown EC Level: " + n);
    }
  }
  t.isValid = function(r) {
    return r && typeof r.bit < "u" && r.bit >= 0 && r.bit < 4;
  }, t.from = function(r, i) {
    if (t.isValid(r))
      return r;
    try {
      return e(r);
    } catch {
      return i;
    }
  };
})(mU);
function TQ() {
  this.buffer = [], this.length = 0;
}
TQ.prototype = {
  get: function(t) {
    const e = Math.floor(t / 8);
    return (this.buffer[e] >>> 7 - t % 8 & 1) === 1;
  },
  put: function(t, e) {
    for (let n = 0; n < e; n++)
      this.putBit((t >>> e - n - 1 & 1) === 1);
  },
  getLengthInBits: function() {
    return this.length;
  },
  putBit: function(t) {
    const e = Math.floor(this.length / 8);
    this.buffer.length <= e && this.buffer.push(0), t && (this.buffer[e] |= 128 >>> this.length % 8), this.length++;
  }
};
var gce = TQ;
function tm(t) {
  if (!t || t < 1)
    throw new Error("BitMatrix size must be defined and greater than 0");
  this.size = t, this.data = new Uint8Array(t * t), this.reservedBit = new Uint8Array(t * t);
}
tm.prototype.set = function(t, e, n, r) {
  const i = t * this.size + e;
  this.data[i] = n, r && (this.reservedBit[i] = !0);
};
tm.prototype.get = function(t, e) {
  return this.data[t * this.size + e];
};
tm.prototype.xor = function(t, e, n) {
  this.data[t * this.size + e] ^= n;
};
tm.prototype.isReserved = function(t, e) {
  return this.reservedBit[t * this.size + e];
};
var yce = tm, fQ = {};
(function(t) {
  const e = la.getSymbolSize;
  t.getRowColCoords = function(r) {
    if (r === 1)
      return [];
    const i = Math.floor(r / 7) + 2, a = e(r), o = a === 145 ? 26 : Math.ceil((a - 13) / (2 * i - 2)) * 2, s = [a - 7];
    for (let l = 1; l < i - 1; l++)
      s[l] = s[l - 1] - o;
    return s.push(6), s.reverse();
  }, t.getPositions = function(r) {
    const i = [], a = t.getRowColCoords(r), o = a.length;
    for (let s = 0; s < o; s++)
      for (let l = 0; l < o; l++)
        s === 0 && l === 0 || // top-left
        s === 0 && l === o - 1 || // bottom-left
        s === o - 1 && l === 0 || i.push([a[s], a[l]]);
    return i;
  };
})(fQ);
var VQ = {};
const Zce = la.getSymbolSize, l4 = 7;
VQ.getPositions = function(e) {
  const n = Zce(e);
  return [
    // top-left
    [0, 0],
    // top-right
    [n - l4, 0],
    // bottom-left
    [0, n - l4]
  ];
};
var UQ = {};
(function(t) {
  t.Patterns = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
  };
  const e = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
  };
  t.isValid = function(i) {
    return i != null && i !== "" && !isNaN(i) && i >= 0 && i <= 7;
  }, t.from = function(i) {
    return t.isValid(i) ? parseInt(i, 10) : void 0;
  }, t.getPenaltyN1 = function(i) {
    const a = i.size;
    let o = 0, s = 0, l = 0, c = null, d = null;
    for (let u = 0; u < a; u++) {
      s = l = 0, c = d = null;
      for (let h = 0; h < a; h++) {
        let N = i.get(u, h);
        N === c ? s++ : (s >= 5 && (o += e.N1 + (s - 5)), c = N, s = 1), N = i.get(h, u), N === d ? l++ : (l >= 5 && (o += e.N1 + (l - 5)), d = N, l = 1);
      }
      s >= 5 && (o += e.N1 + (s - 5)), l >= 5 && (o += e.N1 + (l - 5));
    }
    return o;
  }, t.getPenaltyN2 = function(i) {
    const a = i.size;
    let o = 0;
    for (let s = 0; s < a - 1; s++)
      for (let l = 0; l < a - 1; l++) {
        const c = i.get(s, l) + i.get(s, l + 1) + i.get(s + 1, l) + i.get(s + 1, l + 1);
        (c === 4 || c === 0) && o++;
      }
    return o * e.N2;
  }, t.getPenaltyN3 = function(i) {
    const a = i.size;
    let o = 0, s = 0, l = 0;
    for (let c = 0; c < a; c++) {
      s = l = 0;
      for (let d = 0; d < a; d++)
        s = s << 1 & 2047 | i.get(c, d), d >= 10 && (s === 1488 || s === 93) && o++, l = l << 1 & 2047 | i.get(d, c), d >= 10 && (l === 1488 || l === 93) && o++;
    }
    return o * e.N3;
  }, t.getPenaltyN4 = function(i) {
    let a = 0;
    const o = i.data.length;
    for (let l = 0; l < o; l++)
      a += i.data[l];
    return Math.abs(Math.ceil(a * 100 / o / 5) - 10) * e.N4;
  };
  function n(r, i, a) {
    switch (r) {
      case t.Patterns.PATTERN000:
        return (i + a) % 2 === 0;
      case t.Patterns.PATTERN001:
        return i % 2 === 0;
      case t.Patterns.PATTERN010:
        return a % 3 === 0;
      case t.Patterns.PATTERN011:
        return (i + a) % 3 === 0;
      case t.Patterns.PATTERN100:
        return (Math.floor(i / 2) + Math.floor(a / 3)) % 2 === 0;
      case t.Patterns.PATTERN101:
        return i * a % 2 + i * a % 3 === 0;
      case t.Patterns.PATTERN110:
        return (i * a % 2 + i * a % 3) % 2 === 0;
      case t.Patterns.PATTERN111:
        return (i * a % 3 + (i + a) % 2) % 2 === 0;
      default:
        throw new Error("bad maskPattern:" + r);
    }
  }
  t.applyMask = function(i, a) {
    const o = a.size;
    for (let s = 0; s < o; s++)
      for (let l = 0; l < o; l++)
        a.isReserved(l, s) || a.xor(l, s, n(i, l, s));
  }, t.getBestMask = function(i, a) {
    const o = Object.keys(t.Patterns).length;
    let s = 0, l = 1 / 0;
    for (let c = 0; c < o; c++) {
      a(c), t.applyMask(c, i);
      const d = t.getPenaltyN1(i) + t.getPenaltyN2(i) + t.getPenaltyN3(i) + t.getPenaltyN4(i);
      t.applyMask(c, i), d < l && (l = d, s = c);
    }
    return s;
  };
})(UQ);
var TU = {};
const vl = mU, eT = [
  // L  M  Q  H
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  1,
  2,
  2,
  4,
  1,
  2,
  4,
  4,
  2,
  4,
  4,
  4,
  2,
  4,
  6,
  5,
  2,
  4,
  6,
  6,
  2,
  5,
  8,
  8,
  4,
  5,
  8,
  8,
  4,
  5,
  8,
  11,
  4,
  8,
  10,
  11,
  4,
  9,
  12,
  16,
  4,
  9,
  16,
  16,
  6,
  10,
  12,
  18,
  6,
  10,
  17,
  16,
  6,
  11,
  16,
  19,
  6,
  13,
  18,
  21,
  7,
  14,
  21,
  25,
  8,
  16,
  20,
  25,
  8,
  17,
  23,
  25,
  9,
  17,
  23,
  34,
  9,
  18,
  25,
  30,
  10,
  20,
  27,
  32,
  12,
  21,
  29,
  35,
  12,
  23,
  34,
  37,
  12,
  25,
  34,
  40,
  13,
  26,
  35,
  42,
  14,
  28,
  38,
  45,
  15,
  29,
  40,
  48,
  16,
  31,
  43,
  51,
  17,
  33,
  45,
  54,
  18,
  35,
  48,
  57,
  19,
  37,
  51,
  60,
  19,
  38,
  53,
  63,
  20,
  40,
  56,
  66,
  21,
  43,
  59,
  70,
  22,
  45,
  62,
  74,
  24,
  47,
  65,
  77,
  25,
  49,
  68,
  81
], tT = [
  // L  M  Q  H
  7,
  10,
  13,
  17,
  10,
  16,
  22,
  28,
  15,
  26,
  36,
  44,
  20,
  36,
  52,
  64,
  26,
  48,
  72,
  88,
  36,
  64,
  96,
  112,
  40,
  72,
  108,
  130,
  48,
  88,
  132,
  156,
  60,
  110,
  160,
  192,
  72,
  130,
  192,
  224,
  80,
  150,
  224,
  264,
  96,
  176,
  260,
  308,
  104,
  198,
  288,
  352,
  120,
  216,
  320,
  384,
  132,
  240,
  360,
  432,
  144,
  280,
  408,
  480,
  168,
  308,
  448,
  532,
  180,
  338,
  504,
  588,
  196,
  364,
  546,
  650,
  224,
  416,
  600,
  700,
  224,
  442,
  644,
  750,
  252,
  476,
  690,
  816,
  270,
  504,
  750,
  900,
  300,
  560,
  810,
  960,
  312,
  588,
  870,
  1050,
  336,
  644,
  952,
  1110,
  360,
  700,
  1020,
  1200,
  390,
  728,
  1050,
  1260,
  420,
  784,
  1140,
  1350,
  450,
  812,
  1200,
  1440,
  480,
  868,
  1290,
  1530,
  510,
  924,
  1350,
  1620,
  540,
  980,
  1440,
  1710,
  570,
  1036,
  1530,
  1800,
  570,
  1064,
  1590,
  1890,
  600,
  1120,
  1680,
  1980,
  630,
  1204,
  1770,
  2100,
  660,
  1260,
  1860,
  2220,
  720,
  1316,
  1950,
  2310,
  750,
  1372,
  2040,
  2430
];
TU.getBlocksCount = function(e, n) {
  switch (n) {
    case vl.L:
      return eT[(e - 1) * 4 + 0];
    case vl.M:
      return eT[(e - 1) * 4 + 1];
    case vl.Q:
      return eT[(e - 1) * 4 + 2];
    case vl.H:
      return eT[(e - 1) * 4 + 3];
    default:
      return;
  }
};
TU.getTotalCodewordsCount = function(e, n) {
  switch (n) {
    case vl.L:
      return tT[(e - 1) * 4 + 0];
    case vl.M:
      return tT[(e - 1) * 4 + 1];
    case vl.Q:
      return tT[(e - 1) * 4 + 2];
    case vl.H:
      return tT[(e - 1) * 4 + 3];
    default:
      return;
  }
};
var RQ = {}, fU = {};
const l1 = new Uint8Array(512), pV = new Uint8Array(256);
(function() {
  let e = 1;
  for (let n = 0; n < 255; n++)
    l1[n] = e, pV[e] = n, e <<= 1, e & 256 && (e ^= 285);
  for (let n = 255; n < 512; n++)
    l1[n] = l1[n - 255];
})();
fU.log = function(e) {
  if (e < 1)
    throw new Error("log(" + e + ")");
  return pV[e];
};
fU.exp = function(e) {
  return l1[e];
};
fU.mul = function(e, n) {
  return e === 0 || n === 0 ? 0 : l1[pV[e] + pV[n]];
};
(function(t) {
  const e = fU;
  t.mul = function(r, i) {
    const a = new Uint8Array(r.length + i.length - 1);
    for (let o = 0; o < r.length; o++)
      for (let s = 0; s < i.length; s++)
        a[o + s] ^= e.mul(r[o], i[s]);
    return a;
  }, t.mod = function(r, i) {
    let a = new Uint8Array(r);
    for (; a.length - i.length >= 0; ) {
      const o = a[0];
      for (let l = 0; l < i.length; l++)
        a[l] ^= e.mul(i[l], o);
      let s = 0;
      for (; s < a.length && a[s] === 0; )
        s++;
      a = a.slice(s);
    }
    return a;
  }, t.generateECPolynomial = function(r) {
    let i = new Uint8Array([1]);
    for (let a = 0; a < r; a++)
      i = t.mul(i, new Uint8Array([1, e.exp(a)]));
    return i;
  };
})(RQ);
const gQ = RQ;
function fS(t) {
  this.genPoly = void 0, this.degree = t, this.degree && this.initialize(this.degree);
}
fS.prototype.initialize = function(e) {
  this.degree = e, this.genPoly = gQ.generateECPolynomial(this.degree);
};
fS.prototype.encode = function(e) {
  if (!this.genPoly)
    throw new Error("Encoder not initialized");
  const n = new Uint8Array(e.length + this.degree);
  n.set(e);
  const r = gQ.mod(n, this.genPoly), i = this.degree - r.length;
  if (i > 0) {
    const a = new Uint8Array(this.degree);
    return a.set(r, i), a;
  }
  return r;
};
var bce = fS, yQ = {}, Sc = {}, VS = {};
VS.isValid = function(e) {
  return !isNaN(e) && e >= 1 && e <= 40;
};
var Bo = {};
const ZQ = "[0-9]+", Ece = "[A-Z $%*+\\-./:]+";
let UM = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
UM = UM.replace(/u/g, "\\u");
const Sce = "(?:(?![A-Z0-9 $%*+\\-./:]|" + UM + `)(?:.|[\r
]))+`;
Bo.KANJI = new RegExp(UM, "g");
Bo.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
Bo.BYTE = new RegExp(Sce, "g");
Bo.NUMERIC = new RegExp(ZQ, "g");
Bo.ALPHANUMERIC = new RegExp(Ece, "g");
const xce = new RegExp("^" + UM + "$"), Wce = new RegExp("^" + ZQ + "$"), jce = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
Bo.testKanji = function(e) {
  return xce.test(e);
};
Bo.testNumeric = function(e) {
  return Wce.test(e);
};
Bo.testAlphanumeric = function(e) {
  return jce.test(e);
};
(function(t) {
  const e = VS, n = Bo;
  t.NUMERIC = {
    id: "Numeric",
    bit: 1,
    ccBits: [10, 12, 14]
  }, t.ALPHANUMERIC = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [9, 11, 13]
  }, t.BYTE = {
    id: "Byte",
    bit: 4,
    ccBits: [8, 16, 16]
  }, t.KANJI = {
    id: "Kanji",
    bit: 8,
    ccBits: [8, 10, 12]
  }, t.MIXED = {
    bit: -1
  }, t.getCharCountIndicator = function(a, o) {
    if (!a.ccBits)
      throw new Error("Invalid mode: " + a);
    if (!e.isValid(o))
      throw new Error("Invalid version: " + o);
    return o >= 1 && o < 10 ? a.ccBits[0] : o < 27 ? a.ccBits[1] : a.ccBits[2];
  }, t.getBestModeForData = function(a) {
    return n.testNumeric(a) ? t.NUMERIC : n.testAlphanumeric(a) ? t.ALPHANUMERIC : n.testKanji(a) ? t.KANJI : t.BYTE;
  }, t.toString = function(a) {
    if (a && a.id)
      return a.id;
    throw new Error("Invalid mode");
  }, t.isValid = function(a) {
    return a && a.bit && a.ccBits;
  };
  function r(i) {
    if (typeof i != "string")
      throw new Error("Param is not a string");
    switch (i.toLowerCase()) {
      case "numeric":
        return t.NUMERIC;
      case "alphanumeric":
        return t.ALPHANUMERIC;
      case "kanji":
        return t.KANJI;
      case "byte":
        return t.BYTE;
      default:
        throw new Error("Unknown mode: " + i);
    }
  }
  t.from = function(a, o) {
    if (t.isValid(a))
      return a;
    try {
      return r(a);
    } catch {
      return o;
    }
  };
})(Sc);
(function(t) {
  const e = la, n = TU, r = mU, i = Sc, a = VS, o = 7973, s = e.getBCHDigit(o);
  function l(h, N, M) {
    for (let p = 1; p <= 40; p++)
      if (N <= t.getCapacity(p, M, h))
        return p;
  }
  function c(h, N) {
    return i.getCharCountIndicator(h, N) + 4;
  }
  function d(h, N) {
    let M = 0;
    return h.forEach(function(p) {
      const m = c(p.mode, N);
      M += m + p.getBitsLength();
    }), M;
  }
  function u(h, N) {
    for (let M = 1; M <= 40; M++)
      if (d(h, M) <= t.getCapacity(M, N, i.MIXED))
        return M;
  }
  t.from = function(N, M) {
    return a.isValid(N) ? parseInt(N, 10) : M;
  }, t.getCapacity = function(N, M, p) {
    if (!a.isValid(N))
      throw new Error("Invalid QR Code version");
    typeof p > "u" && (p = i.BYTE);
    const m = e.getSymbolTotalCodewords(N), R = n.getTotalCodewordsCount(N, M), V = (m - R) * 8;
    if (p === i.MIXED)
      return V;
    const U = V - c(p, N);
    switch (p) {
      case i.NUMERIC:
        return Math.floor(U / 10 * 3);
      case i.ALPHANUMERIC:
        return Math.floor(U / 11 * 2);
      case i.KANJI:
        return Math.floor(U / 13);
      case i.BYTE:
      default:
        return Math.floor(U / 8);
    }
  }, t.getBestVersionForData = function(N, M) {
    let p;
    const m = r.from(M, r.M);
    if (Array.isArray(N)) {
      if (N.length > 1)
        return u(N, m);
      if (N.length === 0)
        return 1;
      p = N[0];
    } else
      p = N;
    return l(p.mode, p.getLength(), m);
  }, t.getEncodedBits = function(N) {
    if (!a.isValid(N) || N < 7)
      throw new Error("Invalid QR Code version");
    let M = N << 12;
    for (; e.getBCHDigit(M) - s >= 0; )
      M ^= o << e.getBCHDigit(M) - s;
    return N << 12 | M;
  };
})(yQ);
var bQ = {};
const ab = la, EQ = 1335, Dce = 21522, c4 = ab.getBCHDigit(EQ);
bQ.getEncodedBits = function(e, n) {
  const r = e.bit << 3 | n;
  let i = r << 10;
  for (; ab.getBCHDigit(i) - c4 >= 0; )
    i ^= EQ << ab.getBCHDigit(i) - c4;
  return (r << 10 | i) ^ Dce;
};
var SQ = {};
const zce = Sc;
function uh(t) {
  this.mode = zce.NUMERIC, this.data = t.toString();
}
uh.getBitsLength = function(e) {
  return 10 * Math.floor(e / 3) + (e % 3 ? e % 3 * 3 + 1 : 0);
};
uh.prototype.getLength = function() {
  return this.data.length;
};
uh.prototype.getBitsLength = function() {
  return uh.getBitsLength(this.data.length);
};
uh.prototype.write = function(e) {
  let n, r, i;
  for (n = 0; n + 3 <= this.data.length; n += 3)
    r = this.data.substr(n, 3), i = parseInt(r, 10), e.put(i, 10);
  const a = this.data.length - n;
  a > 0 && (r = this.data.substr(n), i = parseInt(r, 10), e.put(i, a * 3 + 1));
};
var kce = uh;
const wce = Sc, Ug = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  " ",
  "$",
  "%",
  "*",
  "+",
  "-",
  ".",
  "/",
  ":"
];
function hh(t) {
  this.mode = wce.ALPHANUMERIC, this.data = t;
}
hh.getBitsLength = function(e) {
  return 11 * Math.floor(e / 2) + 6 * (e % 2);
};
hh.prototype.getLength = function() {
  return this.data.length;
};
hh.prototype.getBitsLength = function() {
  return hh.getBitsLength(this.data.length);
};
hh.prototype.write = function(e) {
  let n;
  for (n = 0; n + 2 <= this.data.length; n += 2) {
    let r = Ug.indexOf(this.data[n]) * 45;
    r += Ug.indexOf(this.data[n + 1]), e.put(r, 11);
  }
  this.data.length % 2 && e.put(Ug.indexOf(this.data[n]), 6);
};
var Fce = hh, vce = function(e) {
  for (var n = [], r = e.length, i = 0; i < r; i++) {
    var a = e.charCodeAt(i);
    if (a >= 55296 && a <= 56319 && r > i + 1) {
      var o = e.charCodeAt(i + 1);
      o >= 56320 && o <= 57343 && (a = (a - 55296) * 1024 + o - 56320 + 65536, i += 1);
    }
    if (a < 128) {
      n.push(a);
      continue;
    }
    if (a < 2048) {
      n.push(a >> 6 | 192), n.push(a & 63 | 128);
      continue;
    }
    if (a < 55296 || a >= 57344 && a < 65536) {
      n.push(a >> 12 | 224), n.push(a >> 6 & 63 | 128), n.push(a & 63 | 128);
      continue;
    }
    if (a >= 65536 && a <= 1114111) {
      n.push(a >> 18 | 240), n.push(a >> 12 & 63 | 128), n.push(a >> 6 & 63 | 128), n.push(a & 63 | 128);
      continue;
    }
    n.push(239, 191, 189);
  }
  return new Uint8Array(n).buffer;
};
const Ice = vce, Oce = Sc;
function Nh(t) {
  this.mode = Oce.BYTE, typeof t == "string" && (t = Ice(t)), this.data = new Uint8Array(t);
}
Nh.getBitsLength = function(e) {
  return e * 8;
};
Nh.prototype.getLength = function() {
  return this.data.length;
};
Nh.prototype.getBitsLength = function() {
  return Nh.getBitsLength(this.data.length);
};
Nh.prototype.write = function(t) {
  for (let e = 0, n = this.data.length; e < n; e++)
    t.put(this.data[e], 8);
};
var Yce = Nh;
const Qce = Sc, Gce = la;
function Mh(t) {
  this.mode = Qce.KANJI, this.data = t;
}
Mh.getBitsLength = function(e) {
  return e * 13;
};
Mh.prototype.getLength = function() {
  return this.data.length;
};
Mh.prototype.getBitsLength = function() {
  return Mh.getBitsLength(this.data.length);
};
Mh.prototype.write = function(t) {
  let e;
  for (e = 0; e < this.data.length; e++) {
    let n = Gce.toSJIS(this.data[e]);
    if (n >= 33088 && n <= 40956)
      n -= 33088;
    else if (n >= 57408 && n <= 60351)
      n -= 49472;
    else
      throw new Error(
        "Invalid SJIS character: " + this.data[e] + `
Make sure your charset is UTF-8`
      );
    n = (n >>> 8 & 255) * 192 + (n & 255), t.put(n, 13);
  }
};
var Cce = Mh, xQ = { exports: {} };
(function(t) {
  var e = {
    single_source_shortest_paths: function(n, r, i) {
      var a = {}, o = {};
      o[r] = 0;
      var s = e.PriorityQueue.make();
      s.push(r, 0);
      for (var l, c, d, u, h, N, M, p, m; !s.empty(); ) {
        l = s.pop(), c = l.value, u = l.cost, h = n[c] || {};
        for (d in h)
          h.hasOwnProperty(d) && (N = h[d], M = u + N, p = o[d], m = typeof o[d] > "u", (m || p > M) && (o[d] = M, s.push(d, M), a[d] = c));
      }
      if (typeof i < "u" && typeof o[i] > "u") {
        var R = ["Could not find a path from ", r, " to ", i, "."].join("");
        throw new Error(R);
      }
      return a;
    },
    extract_shortest_path_from_predecessor_list: function(n, r) {
      for (var i = [], a = r; a; )
        i.push(a), n[a], a = n[a];
      return i.reverse(), i;
    },
    find_path: function(n, r, i) {
      var a = e.single_source_shortest_paths(n, r, i);
      return e.extract_shortest_path_from_predecessor_list(
        a,
        i
      );
    },
    /**
     * A very naive priority queue implementation.
     */
    PriorityQueue: {
      make: function(n) {
        var r = e.PriorityQueue, i = {}, a;
        n = n || {};
        for (a in r)
          r.hasOwnProperty(a) && (i[a] = r[a]);
        return i.queue = [], i.sorter = n.sorter || r.default_sorter, i;
      },
      default_sorter: function(n, r) {
        return n.cost - r.cost;
      },
      /**
       * Add a new item to the queue and ensure the highest priority element
       * is at the front of the queue.
       */
      push: function(n, r) {
        var i = { value: n, cost: r };
        this.queue.push(i), this.queue.sort(this.sorter);
      },
      /**
       * Return the highest priority element in the queue.
       */
      pop: function() {
        return this.queue.shift();
      },
      empty: function() {
        return this.queue.length === 0;
      }
    }
  };
  t.exports = e;
})(xQ);
var Lce = xQ.exports;
(function(t) {
  const e = Sc, n = kce, r = Fce, i = Yce, a = Cce, o = Bo, s = la, l = Lce;
  function c(R) {
    return unescape(encodeURIComponent(R)).length;
  }
  function d(R, V, U) {
    const g = [];
    let y;
    for (; (y = R.exec(U)) !== null; )
      g.push({
        data: y[0],
        index: y.index,
        mode: V,
        length: y[0].length
      });
    return g;
  }
  function u(R) {
    const V = d(o.NUMERIC, e.NUMERIC, R), U = d(o.ALPHANUMERIC, e.ALPHANUMERIC, R);
    let g, y;
    return s.isKanjiModeEnabled() ? (g = d(o.BYTE, e.BYTE, R), y = d(o.KANJI, e.KANJI, R)) : (g = d(o.BYTE_KANJI, e.BYTE, R), y = []), V.concat(U, g, y).sort(function(f, D) {
      return f.index - D.index;
    }).map(function(f) {
      return {
        data: f.data,
        mode: f.mode,
        length: f.length
      };
    });
  }
  function h(R, V) {
    switch (V) {
      case e.NUMERIC:
        return n.getBitsLength(R);
      case e.ALPHANUMERIC:
        return r.getBitsLength(R);
      case e.KANJI:
        return a.getBitsLength(R);
      case e.BYTE:
        return i.getBitsLength(R);
    }
  }
  function N(R) {
    return R.reduce(function(V, U) {
      const g = V.length - 1 >= 0 ? V[V.length - 1] : null;
      return g && g.mode === U.mode ? (V[V.length - 1].data += U.data, V) : (V.push(U), V);
    }, []);
  }
  function M(R) {
    const V = [];
    for (let U = 0; U < R.length; U++) {
      const g = R[U];
      switch (g.mode) {
        case e.NUMERIC:
          V.push([
            g,
            { data: g.data, mode: e.ALPHANUMERIC, length: g.length },
            { data: g.data, mode: e.BYTE, length: g.length }
          ]);
          break;
        case e.ALPHANUMERIC:
          V.push([
            g,
            { data: g.data, mode: e.BYTE, length: g.length }
          ]);
          break;
        case e.KANJI:
          V.push([
            g,
            { data: g.data, mode: e.BYTE, length: c(g.data) }
          ]);
          break;
        case e.BYTE:
          V.push([
            { data: g.data, mode: e.BYTE, length: c(g.data) }
          ]);
      }
    }
    return V;
  }
  function p(R, V) {
    const U = {}, g = { start: {} };
    let y = ["start"];
    for (let x = 0; x < R.length; x++) {
      const f = R[x], D = [];
      for (let Y = 0; Y < f.length; Y++) {
        const Q = f[Y], G = "" + x + Y;
        D.push(G), U[G] = { node: Q, lastCount: 0 }, g[G] = {};
        for (let ne = 0; ne < y.length; ne++) {
          const O = y[ne];
          U[O] && U[O].node.mode === Q.mode ? (g[O][G] = h(U[O].lastCount + Q.length, Q.mode) - h(U[O].lastCount, Q.mode), U[O].lastCount += Q.length) : (U[O] && (U[O].lastCount = Q.length), g[O][G] = h(Q.length, Q.mode) + 4 + e.getCharCountIndicator(Q.mode, V));
        }
      }
      y = D;
    }
    for (let x = 0; x < y.length; x++)
      g[y[x]].end = 0;
    return { map: g, table: U };
  }
  function m(R, V) {
    let U;
    const g = e.getBestModeForData(R);
    if (U = e.from(V, g), U !== e.BYTE && U.bit < g.bit)
      throw new Error('"' + R + '" cannot be encoded with mode ' + e.toString(U) + `.
 Suggested mode is: ` + e.toString(g));
    switch (U === e.KANJI && !s.isKanjiModeEnabled() && (U = e.BYTE), U) {
      case e.NUMERIC:
        return new n(R);
      case e.ALPHANUMERIC:
        return new r(R);
      case e.KANJI:
        return new a(R);
      case e.BYTE:
        return new i(R);
    }
  }
  t.fromArray = function(V) {
    return V.reduce(function(U, g) {
      return typeof g == "string" ? U.push(m(g, null)) : g.data && U.push(m(g.data, g.mode)), U;
    }, []);
  }, t.fromString = function(V, U) {
    const g = u(V, s.isKanjiModeEnabled()), y = M(g), x = p(y, U), f = l.find_path(x.map, "start", "end"), D = [];
    for (let Y = 1; Y < f.length - 1; Y++)
      D.push(x.table[f[Y]].node);
    return t.fromArray(N(D));
  }, t.rawSplit = function(V) {
    return t.fromArray(
      u(V, s.isKanjiModeEnabled())
    );
  };
})(SQ);
const VU = la, Rg = mU, Jce = gce, Bce = yce, Ace = fQ, Hce = VQ, ob = UQ, sb = TU, Xce = bce, mV = yQ, _ce = bQ, Pce = Sc, gg = SQ;
function Kce(t, e) {
  const n = t.size, r = Hce.getPositions(e);
  for (let i = 0; i < r.length; i++) {
    const a = r[i][0], o = r[i][1];
    for (let s = -1; s <= 7; s++)
      if (!(a + s <= -1 || n <= a + s))
        for (let l = -1; l <= 7; l++)
          o + l <= -1 || n <= o + l || (s >= 0 && s <= 6 && (l === 0 || l === 6) || l >= 0 && l <= 6 && (s === 0 || s === 6) || s >= 2 && s <= 4 && l >= 2 && l <= 4 ? t.set(a + s, o + l, !0, !0) : t.set(a + s, o + l, !1, !0));
  }
}
function $ce(t) {
  const e = t.size;
  for (let n = 8; n < e - 8; n++) {
    const r = n % 2 === 0;
    t.set(n, 6, r, !0), t.set(6, n, r, !0);
  }
}
function qce(t, e) {
  const n = Ace.getPositions(e);
  for (let r = 0; r < n.length; r++) {
    const i = n[r][0], a = n[r][1];
    for (let o = -2; o <= 2; o++)
      for (let s = -2; s <= 2; s++)
        o === -2 || o === 2 || s === -2 || s === 2 || o === 0 && s === 0 ? t.set(i + o, a + s, !0, !0) : t.set(i + o, a + s, !1, !0);
  }
}
function ede(t, e) {
  const n = t.size, r = mV.getEncodedBits(e);
  let i, a, o;
  for (let s = 0; s < 18; s++)
    i = Math.floor(s / 3), a = s % 3 + n - 8 - 3, o = (r >> s & 1) === 1, t.set(i, a, o, !0), t.set(a, i, o, !0);
}
function yg(t, e, n) {
  const r = t.size, i = _ce.getEncodedBits(e, n);
  let a, o;
  for (a = 0; a < 15; a++)
    o = (i >> a & 1) === 1, a < 6 ? t.set(a, 8, o, !0) : a < 8 ? t.set(a + 1, 8, o, !0) : t.set(r - 15 + a, 8, o, !0), a < 8 ? t.set(8, r - a - 1, o, !0) : a < 9 ? t.set(8, 15 - a - 1 + 1, o, !0) : t.set(8, 15 - a - 1, o, !0);
  t.set(r - 8, 8, 1, !0);
}
function tde(t, e) {
  const n = t.size;
  let r = -1, i = n - 1, a = 7, o = 0;
  for (let s = n - 1; s > 0; s -= 2)
    for (s === 6 && s--; ; ) {
      for (let l = 0; l < 2; l++)
        if (!t.isReserved(i, s - l)) {
          let c = !1;
          o < e.length && (c = (e[o] >>> a & 1) === 1), t.set(i, s - l, c), a--, a === -1 && (o++, a = 7);
        }
      if (i += r, i < 0 || n <= i) {
        i -= r, r = -r;
        break;
      }
    }
}
function nde(t, e, n) {
  const r = new Jce();
  n.forEach(function(l) {
    r.put(l.mode.bit, 4), r.put(l.getLength(), Pce.getCharCountIndicator(l.mode, t)), l.write(r);
  });
  const i = VU.getSymbolTotalCodewords(t), a = sb.getTotalCodewordsCount(t, e), o = (i - a) * 8;
  for (r.getLengthInBits() + 4 <= o && r.put(0, 4); r.getLengthInBits() % 8 !== 0; )
    r.putBit(0);
  const s = (o - r.getLengthInBits()) / 8;
  for (let l = 0; l < s; l++)
    r.put(l % 2 ? 17 : 236, 8);
  return rde(r, t, e);
}
function rde(t, e, n) {
  const r = VU.getSymbolTotalCodewords(e), i = sb.getTotalCodewordsCount(e, n), a = r - i, o = sb.getBlocksCount(e, n), s = r % o, l = o - s, c = Math.floor(r / o), d = Math.floor(a / o), u = d + 1, h = c - d, N = new Xce(h);
  let M = 0;
  const p = new Array(o), m = new Array(o);
  let R = 0;
  const V = new Uint8Array(t.buffer);
  for (let f = 0; f < o; f++) {
    const D = f < l ? d : u;
    p[f] = V.slice(M, M + D), m[f] = N.encode(p[f]), M += D, R = Math.max(R, D);
  }
  const U = new Uint8Array(r);
  let g = 0, y, x;
  for (y = 0; y < R; y++)
    for (x = 0; x < o; x++)
      y < p[x].length && (U[g++] = p[x][y]);
  for (y = 0; y < h; y++)
    for (x = 0; x < o; x++)
      U[g++] = m[x][y];
  return U;
}
function ide(t, e, n, r) {
  let i;
  if (Array.isArray(t))
    i = gg.fromArray(t);
  else if (typeof t == "string") {
    let c = e;
    if (!c) {
      const d = gg.rawSplit(t);
      c = mV.getBestVersionForData(d, n);
    }
    i = gg.fromString(t, c || 40);
  } else
    throw new Error("Invalid data");
  const a = mV.getBestVersionForData(i, n);
  if (!a)
    throw new Error("The amount of data is too big to be stored in a QR Code");
  if (!e)
    e = a;
  else if (e < a)
    throw new Error(
      `
The chosen QR Code version cannot contain this amount of data.
Minimum version required to store current data is: ` + a + `.
`
    );
  const o = nde(e, n, i), s = VU.getSymbolSize(e), l = new Bce(s);
  return Kce(l, e), $ce(l), qce(l, e), yg(l, n, 0), e >= 7 && ede(l, e), tde(l, o), isNaN(r) && (r = ob.getBestMask(
    l,
    yg.bind(null, l, n)
  )), ob.applyMask(r, l), yg(l, n, r), {
    modules: l,
    version: e,
    errorCorrectionLevel: n,
    maskPattern: r,
    segments: i
  };
}
mQ.create = function(e, n) {
  if (typeof e > "u" || e === "")
    throw new Error("No input text");
  let r = Rg.M, i, a;
  return typeof n < "u" && (r = Rg.from(n.errorCorrectionLevel, Rg.M), i = mV.from(n.version), a = ob.from(n.maskPattern), n.toSJISFunc && VU.setToSJISFunction(n.toSJISFunc)), ide(e, i, r, a);
};
var WQ = {}, US = {};
(function(t) {
  function e(n) {
    if (typeof n == "number" && (n = n.toString()), typeof n != "string")
      throw new Error("Color should be defined as hex string");
    let r = n.slice().replace("#", "").split("");
    if (r.length < 3 || r.length === 5 || r.length > 8)
      throw new Error("Invalid hex color: " + n);
    (r.length === 3 || r.length === 4) && (r = Array.prototype.concat.apply([], r.map(function(a) {
      return [a, a];
    }))), r.length === 6 && r.push("F", "F");
    const i = parseInt(r.join(""), 16);
    return {
      r: i >> 24 & 255,
      g: i >> 16 & 255,
      b: i >> 8 & 255,
      a: i & 255,
      hex: "#" + r.slice(0, 6).join("")
    };
  }
  t.getOptions = function(r) {
    r || (r = {}), r.color || (r.color = {});
    const i = typeof r.margin > "u" || r.margin === null || r.margin < 0 ? 4 : r.margin, a = r.width && r.width >= 21 ? r.width : void 0, o = r.scale || 4;
    return {
      width: a,
      scale: a ? 4 : o,
      margin: i,
      color: {
        dark: e(r.color.dark || "#000000ff"),
        light: e(r.color.light || "#ffffffff")
      },
      type: r.type,
      rendererOpts: r.rendererOpts || {}
    };
  }, t.getScale = function(r, i) {
    return i.width && i.width >= r + i.margin * 2 ? i.width / (r + i.margin * 2) : i.scale;
  }, t.getImageWidth = function(r, i) {
    const a = t.getScale(r, i);
    return Math.floor((r + i.margin * 2) * a);
  }, t.qrToImageData = function(r, i, a) {
    const o = i.modules.size, s = i.modules.data, l = t.getScale(o, a), c = Math.floor((o + a.margin * 2) * l), d = a.margin * l, u = [a.color.light, a.color.dark];
    for (let h = 0; h < c; h++)
      for (let N = 0; N < c; N++) {
        let M = (h * c + N) * 4, p = a.color.light;
        if (h >= d && N >= d && h < c - d && N < c - d) {
          const m = Math.floor((h - d) / l), R = Math.floor((N - d) / l);
          p = u[s[m * o + R] ? 1 : 0];
        }
        r[M++] = p.r, r[M++] = p.g, r[M++] = p.b, r[M] = p.a;
      }
  };
})(US);
(function(t) {
  const e = US;
  function n(i, a, o) {
    i.clearRect(0, 0, a.width, a.height), a.style || (a.style = {}), a.height = o, a.width = o, a.style.height = o + "px", a.style.width = o + "px";
  }
  function r() {
    try {
      return document.createElement("canvas");
    } catch {
      throw new Error("You need to specify a canvas element");
    }
  }
  t.render = function(a, o, s) {
    let l = s, c = o;
    typeof l > "u" && (!o || !o.getContext) && (l = o, o = void 0), o || (c = r()), l = e.getOptions(l);
    const d = e.getImageWidth(a.modules.size, l), u = c.getContext("2d"), h = u.createImageData(d, d);
    return e.qrToImageData(h.data, a, l), n(u, c, d), u.putImageData(h, 0, 0), c;
  }, t.renderToDataURL = function(a, o, s) {
    let l = s;
    typeof l > "u" && (!o || !o.getContext) && (l = o, o = void 0), l || (l = {});
    const c = t.render(a, o, l), d = l.type || "image/png", u = l.rendererOpts || {};
    return c.toDataURL(d, u.quality);
  };
})(WQ);
var jQ = {};
const ade = US;
function d4(t, e) {
  const n = t.a / 255, r = e + '="' + t.hex + '"';
  return n < 1 ? r + " " + e + '-opacity="' + n.toFixed(2).slice(1) + '"' : r;
}
function Zg(t, e, n) {
  let r = t + e;
  return typeof n < "u" && (r += " " + n), r;
}
function ode(t, e, n) {
  let r = "", i = 0, a = !1, o = 0;
  for (let s = 0; s < t.length; s++) {
    const l = Math.floor(s % e), c = Math.floor(s / e);
    !l && !a && (a = !0), t[s] ? (o++, s > 0 && l > 0 && t[s - 1] || (r += a ? Zg("M", l + n, 0.5 + c + n) : Zg("m", i, 0), i = 0, a = !1), l + 1 < e && t[s + 1] || (r += Zg("h", o), o = 0)) : i++;
  }
  return r;
}
jQ.render = function(e, n, r) {
  const i = ade.getOptions(n), a = e.modules.size, o = e.modules.data, s = a + i.margin * 2, l = i.color.light.a ? "<path " + d4(i.color.light, "fill") + ' d="M0 0h' + s + "v" + s + 'H0z"/>' : "", c = "<path " + d4(i.color.dark, "stroke") + ' d="' + ode(o, a, i.margin) + '"/>', d = 'viewBox="0 0 ' + s + " " + s + '"', h = '<svg xmlns="http://www.w3.org/2000/svg" ' + (i.width ? 'width="' + i.width + '" height="' + i.width + '" ' : "") + d + ' shape-rendering="crispEdges">' + l + c + `</svg>
`;
  return typeof r == "function" && r(null, h), h;
};
const sde = Uce, lb = mQ, DQ = WQ, lde = jQ;
function RS(t, e, n, r, i) {
  const a = [].slice.call(arguments, 1), o = a.length, s = typeof a[o - 1] == "function";
  if (!s && !sde())
    throw new Error("Callback required as last argument");
  if (s) {
    if (o < 2)
      throw new Error("Too few arguments provided");
    o === 2 ? (i = n, n = e, e = r = void 0) : o === 3 && (e.getContext && typeof i > "u" ? (i = r, r = void 0) : (i = r, r = n, n = e, e = void 0));
  } else {
    if (o < 1)
      throw new Error("Too few arguments provided");
    return o === 1 ? (n = e, e = r = void 0) : o === 2 && !e.getContext && (r = n, n = e, e = void 0), new Promise(function(l, c) {
      try {
        const d = lb.create(n, r);
        l(t(d, e, r));
      } catch (d) {
        c(d);
      }
    });
  }
  try {
    const l = lb.create(n, r);
    i(null, t(l, e, r));
  } catch (l) {
    i(l);
  }
}
em.create = lb.create;
em.toCanvas = RS.bind(null, DQ.render);
em.toDataURL = RS.bind(null, DQ.renderToDataURL);
em.toString = RS.bind(null, function(t, e, n) {
  return lde.render(t, n);
});
const cde = 0.1, u4 = 2.5, ts = 7;
function bg(t, e, n) {
  return t === e ? !1 : (t - e < 0 ? e - t : t - e) <= n + cde;
}
function dde(t, e) {
  const n = Array.prototype.slice.call(em.create(t, { errorCorrectionLevel: e }).modules.data, 0), r = Math.sqrt(n.length);
  return n.reduce((i, a, o) => (o % r === 0 ? i.push([a]) : i[i.length - 1].push(a)) && i, []);
}
const ude = {
  generate(t, e, n) {
    const r = "#141414", i = "transparent", o = [], s = dde(t, "Q"), l = e / s.length, c = [
      { x: 0, y: 0 },
      { x: 1, y: 0 },
      { x: 0, y: 1 }
    ];
    c.forEach(({ x: p, y: m }) => {
      const R = (s.length - ts) * l * p, V = (s.length - ts) * l * m, U = 0.45;
      for (let g = 0; g < c.length; g += 1) {
        const y = l * (ts - g * 2);
        o.push(ke`
            <rect
              fill=${g === 2 ? r : i}
              width=${g === 0 ? y - 5 : y}
              rx= ${g === 0 ? (y - 5) * U : y * U}
              ry= ${g === 0 ? (y - 5) * U : y * U}
              stroke=${r}
              stroke-width=${g === 0 ? 5 : 0}
              height=${g === 0 ? y - 5 : y}
              x= ${g === 0 ? V + l * g + 5 / 2 : V + l * g}
              y= ${g === 0 ? R + l * g + 5 / 2 : R + l * g}
            />
          `);
      }
    });
    const d = Math.floor((n + 25) / l), u = s.length / 2 - d / 2, h = s.length / 2 + d / 2 - 1, N = [];
    s.forEach((p, m) => {
      p.forEach((R, V) => {
        if (s[m][V] && !(m < ts && V < ts || m > s.length - (ts + 1) && V < ts || m < ts && V > s.length - (ts + 1)) && !(m > u && m < h && V > u && V < h)) {
          const U = m * l + l / 2, g = V * l + l / 2;
          N.push([U, g]);
        }
      });
    });
    const M = {};
    return N.forEach(([p, m]) => {
      var R;
      M[p] ? (R = M[p]) == null || R.push(m) : M[p] = [m];
    }), Object.entries(M).map(([p, m]) => {
      const R = m.filter((V) => m.every((U) => !bg(V, U, l)));
      return [Number(p), R];
    }).forEach(([p, m]) => {
      m.forEach((R) => {
        o.push(ke`<circle cx=${p} cy=${R} fill=${r} r=${l / u4} />`);
      });
    }), Object.entries(M).filter(([p, m]) => m.length > 1).map(([p, m]) => {
      const R = m.filter((V) => m.some((U) => bg(V, U, l)));
      return [Number(p), R];
    }).map(([p, m]) => {
      m.sort((V, U) => V < U ? -1 : 1);
      const R = [];
      for (const V of m) {
        const U = R.find((g) => g.some((y) => bg(V, y, l)));
        U ? U.push(V) : R.push([V]);
      }
      return [p, R.map((V) => [V[0], V[V.length - 1]])];
    }).forEach(([p, m]) => {
      m.forEach(([R, V]) => {
        o.push(ke`
              <line
                x1=${p}
                x2=${p}
                y1=${R}
                y2=${V}
                stroke=${r}
                stroke-width=${l / (u4 / 2)}
                stroke-linecap="round"
              />
            `);
      });
    }), o;
  }
}, hde = ze`
  :host {
    position: relative;
    user-select: none;
    display: block;
    overflow: hidden;
    aspect-ratio: 1 / 1;
    width: var(--local-size);
  }

  :host([data-theme='dark']) {
    border-radius: clamp(0px, var(--wui-border-radius-l), 40px);
    background-color: var(--wui-color-inverse-100);
    padding: var(--wui-spacing-l);
  }

  :host([data-theme='light']) {
    box-shadow: 0 0 0 1px var(--wui-color-bg-125);
    background-color: var(--wui-color-bg-125);
  }

  svg:first-child,
  wui-image,
  wui-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
  }

  wui-image {
    width: 25%;
    height: 25%;
    border-radius: var(--wui-border-radius-xs);
  }

  wui-icon {
    width: 100%;
    height: 100%;
    color: #3396ff !important;
    transform: translateY(-50%) translateX(-50%) scale(0.25);
  }
`;
var sN = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let ac = class extends be {
  constructor() {
    super(...arguments), this.uri = "", this.size = 0, this.theme = "dark", this.imageSrc = void 0, this.alt = void 0;
  }
  render() {
    return this.dataset.theme = this.theme, this.style.cssText = `--local-size: ${this.size}px`, _`${this.templateVisual()} ${this.templateSvg()}`;
  }
  templateSvg() {
    const e = this.theme === "light" ? this.size : this.size - 32;
    return ke`
      <svg height=${e} width=${e}>
        ${ude.generate(this.uri, e, e / 4)}
      </svg>
    `;
  }
  templateVisual() {
    return this.imageSrc ? _`<wui-image src=${this.imageSrc} alt=${this.alt ?? "logo"}></wui-image>` : _`<wui-icon size="inherit" color="inherit" name="walletConnect"></wui-icon>`;
  }
};
ac.styles = [Rt, hde];
sN([
  te()
], ac.prototype, "uri", void 0);
sN([
  te({ type: Number })
], ac.prototype, "size", void 0);
sN([
  te()
], ac.prototype, "theme", void 0);
sN([
  te()
], ac.prototype, "imageSrc", void 0);
sN([
  te()
], ac.prototype, "alt", void 0);
ac = sN([
  Ze("wui-qr-code")
], ac);
const Nde = ze`
  :host {
    position: relative;
    display: inline-block;
    width: 100%;
  }
`;
var Mde = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let cb = class extends be {
  constructor() {
    super(...arguments), this.inputComponentRef = uS();
  }
  render() {
    return _`
      <wui-input-text
        ${hS(this.inputComponentRef)}
        placeholder="Search wallet"
        icon="search"
        type="search"
        enterKeyHint="search"
        size="sm"
      >
        <wui-input-element @click=${this.clearValue} icon="close"></wui-input-element>
      </wui-input-text>
    `;
  }
  clearValue() {
    const e = this.inputComponentRef.value, n = e == null ? void 0 : e.inputElementRef.value;
    n && (n.value = "", n.focus(), n.dispatchEvent(new Event("input")));
  }
};
cb.styles = [Rt, Nde];
cb = Mde([
  Ze("wui-search-bar")
], cb);
const pde = ze`
  :host {
    display: flex;
    column-gap: var(--wui-spacing-xs);
    align-items: center;
    padding: 7px var(--wui-spacing-l) 7px var(--wui-spacing-xs);
    border-radius: var(--wui-border-radius-3xl);
    border: 1px solid var(--wui-gray-glass-005);
    background-color: var(--wui-color-bg-175);
    box-shadow:
      0px 14px 64px -4px rgba(0, 0, 0, 0.15),
      0px 8px 22px -6px rgba(0, 0, 0, 0.15);
  }
`;
var nm = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let Gd = class extends be {
  constructor() {
    super(...arguments), this.backgroundColor = "accent-100", this.iconColor = "accent-100", this.icon = "checkmark", this.message = "";
  }
  render() {
    return _`
      <wui-icon-box
        size="xs"
        iconColor=${this.iconColor}
        backgroundColor=${this.backgroundColor}
        icon=${this.icon}
      ></wui-icon-box>
      <wui-text variant="paragraph-500" color="fg-100">${this.message}</wui-text>
    `;
  }
};
Gd.styles = [Rt, pde];
nm([
  te()
], Gd.prototype, "backgroundColor", void 0);
nm([
  te()
], Gd.prototype, "iconColor", void 0);
nm([
  te()
], Gd.prototype, "icon", void 0);
nm([
  te()
], Gd.prototype, "message", void 0);
Gd = nm([
  Ze("wui-snackbar")
], Gd);
const mde = ze`
  :host {
    display: inline-flex;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-3xl);
    padding: var(--wui-spacing-3xs);
    position: relative;
    height: 36px;
    overflow: hidden;
  }

  :host::before {
    content: '';
    position: absolute;
    pointer-events: none;
    top: 4px;
    left: 4px;
    display: block;
    width: var(--local-tab-width);
    height: 28px;
    border-radius: var(--wui-border-radius-3xl);
    background-color: var(--wui-gray-glass-002);
    box-shadow: inset 0 0 0 1px var(--wui-gray-glass-002);
    transform: translateX(calc(var(--local-tab) * var(--local-tab-width)));
    transition: transform var(--wui-ease-out-power-2) var(--wui-duration-lg);
  }

  :host([data-type='flex'])::before {
    left: 3px;
    transform: translateX(calc((var(--local-tab) * 34px) + (var(--local-tab) * 4px)));
  }

  :host([data-type='flex']) {
    display: flex;
    padding: 0px 0px 0px 12px;
    gap: 4px;
  }

  :host([data-type='flex']) > button > wui-text {
    position: absolute;
    left: 18px;
    opacity: 0;
  }

  button[data-active='true'] > wui-icon,
  button[data-active='true'] > wui-text {
    color: var(--wui-color-fg-100);
  }

  button[data-active='false'] > wui-icon,
  button[data-active='false'] > wui-text {
    color: var(--wui-color-fg-200);
  }

  button[data-active='true']:disabled,
  button[data-active='false']:disabled {
    background-color: transparent;
    opacity: 0.5;
    cursor: not-allowed;
  }

  button[data-active='true']:disabled > wui-text {
    color: var(--wui-color-fg-200);
  }

  button[data-active='false']:disabled > wui-text {
    color: var(--wui-color-fg-300);
  }

  button > wui-icon,
  button > wui-text {
    pointer-events: none;
    transition: all var(--wui-ease-out-power-2) var(--wui-duration-lg);
  }

  button {
    width: var(--local-tab-width);
  }

  :host([data-type='flex']) > button {
    width: 34px;
    position: relative;
    display: flex;
    justify-content: flex-start;
  }

  button:hover:enabled,
  button:active:enabled {
    background-color: transparent !important;
  }

  button:hover:enabled > wui-icon,
  button:active:enabled > wui-icon {
    color: var(--wui-color-fg-125);
  }

  button:hover:enabled > wui-text,
  button:active:enabled > wui-text {
    color: var(--wui-color-fg-125);
  }

  button {
    border-radius: var(--wui-border-radius-3xl);
  }
`;
var xc = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let vo = class extends be {
  constructor() {
    super(...arguments), this.tabs = [], this.onTabChange = () => null, this.buttons = [], this.disabled = !1, this.activeTab = 0, this.localTabWidth = "100px", this.isDense = !1;
  }
  render() {
    return this.isDense = this.tabs.length > 3, this.style.cssText = `
      --local-tab: ${this.activeTab};
      --local-tab-width: ${this.localTabWidth};
    `, this.dataset.type = this.isDense ? "flex" : "block", this.tabs.map((e, n) => {
      const r = n === this.activeTab;
      return _`
        <button
          ?disabled=${this.disabled}
          @click=${() => this.onTabClick(n)}
          data-active=${r}
        >
          <wui-icon size="xs" color="inherit" name=${e.icon}></wui-icon>
          <wui-text variant="small-600" color="inherit"> ${e.label} </wui-text>
        </button>
      `;
    });
  }
  firstUpdated() {
    this.shadowRoot && this.isDense && (this.buttons = [...this.shadowRoot.querySelectorAll("button")], setTimeout(() => {
      this.animateTabs(0, !0);
    }, 0));
  }
  onTabClick(e) {
    this.buttons && this.animateTabs(e, !1), this.activeTab = e, this.onTabChange(e);
  }
  animateTabs(e, n) {
    const r = this.buttons[this.activeTab], i = this.buttons[e], a = r == null ? void 0 : r.querySelector("wui-text"), o = i == null ? void 0 : i.querySelector("wui-text"), s = i == null ? void 0 : i.getBoundingClientRect(), l = o == null ? void 0 : o.getBoundingClientRect();
    r && a && !n && e !== this.activeTab && (a.animate([{ opacity: 0 }], {
      duration: 50,
      easing: "ease",
      fill: "forwards"
    }), r.animate([{ width: "34px" }], {
      duration: 500,
      easing: "ease",
      fill: "forwards"
    })), i && s && l && o && (e !== this.activeTab || n) && (this.localTabWidth = `${Math.round(s.width + l.width) + 6}px`, i.animate([{ width: `${s.width + l.width}px` }], {
      duration: n ? 0 : 500,
      fill: "forwards",
      easing: "ease"
    }), o.animate([{ opacity: 1 }], {
      duration: n ? 0 : 125,
      delay: n ? 0 : 200,
      fill: "forwards",
      easing: "ease"
    }));
  }
};
vo.styles = [Rt, pr, mde];
xc([
  te({ type: Array })
], vo.prototype, "tabs", void 0);
xc([
  te()
], vo.prototype, "onTabChange", void 0);
xc([
  te({ type: Array })
], vo.prototype, "buttons", void 0);
xc([
  te({ type: Boolean })
], vo.prototype, "disabled", void 0);
xc([
  Ke()
], vo.prototype, "activeTab", void 0);
xc([
  Ke()
], vo.prototype, "localTabWidth", void 0);
xc([
  Ke()
], vo.prototype, "isDense", void 0);
vo = xc([
  Ze("wui-tabs")
], vo);
const Tde = ze`
  :host {
    display: block;
    padding: 9px var(--wui-spacing-s) 10px var(--wui-spacing-s);
    border-radius: var(--wui-border-radius-xxs);
    background-color: var(--wui-color-fg-100);
    color: var(--wui-color-bg-100);
    position: relative;
  }

  wui-icon {
    position: absolute;
    width: 12px !important;
    height: 4px !important;
  }

  wui-icon[data-placement='top'] {
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 95%);
  }

  wui-icon[data-placement='bottom'] {
    top: 0;
    left: 50%;
    transform: translate(-50%, -95%) rotate(180deg);
  }

  wui-icon[data-placement='right'] {
    top: 50%;
    left: 0;
    transform: translate(-65%, -50%) rotate(90deg);
  }

  wui-icon[data-placement='left'] {
    top: 50%;
    right: 0%;
    transform: translate(65%, -50%) rotate(270deg);
  }
`;
var gS = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let RM = class extends be {
  constructor() {
    super(...arguments), this.placement = "top", this.message = "";
  }
  render() {
    return _`<wui-icon
        data-placement=${this.placement}
        color="fg-100"
        size="inherit"
        name="cursor"
      ></wui-icon>
      <wui-text color="inherit" variant="small-500">${this.message}</wui-text>`;
  }
};
RM.styles = [Rt, pr, Tde];
gS([
  te()
], RM.prototype, "placement", void 0);
gS([
  te()
], RM.prototype, "message", void 0);
RM = gS([
  Ze("wui-tooltip")
], RM);
const fde = ze`
  :host {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 64px;
    height: 64px;
    box-shadow: 0 0 0 8px var(--wui-thumbnail-border);
    border-radius: var(--local-border-radius);
    overflow: hidden;
  }

  wui-icon {
    width: 32px;
    height: 32px;
  }
`;
var UU = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let ph = class extends be {
  render() {
    return this.style.cssText = `--local-border-radius: ${this.borderRadiusFull ? "1000px" : "20px"};`, _`${this.templateVisual()}`;
  }
  templateVisual() {
    return this.imageSrc ? _`<wui-image src=${this.imageSrc} alt=${this.alt ?? ""}></wui-image>` : _`<wui-icon
      data-parent-size="md"
      size="inherit"
      color="inherit"
      name="walletPlaceholder"
    ></wui-icon>`;
  }
};
ph.styles = [Rt, fde];
UU([
  te()
], ph.prototype, "imageSrc", void 0);
UU([
  te()
], ph.prototype, "alt", void 0);
UU([
  te({ type: Boolean })
], ph.prototype, "borderRadiusFull", void 0);
ph = UU([
  Ze("wui-visual-thumbnail")
], ph);
const Vde = ze`
  :host {
    display: block;
  }

  button {
    width: 100%;
    display: block;
    padding-top: var(--wui-spacing-l);
    padding-bottom: var(--wui-spacing-l);
    padding-left: var(--wui-spacing-s);
    padding-right: var(--wui-spacing-2l);
    border-radius: var(--wui-border-radius-s);
    background-color: var(--wui-accent-glass-015);
  }

  button:hover {
    background-color: var(--wui-accent-glass-010) !important;
  }

  button:active {
    background-color: var(--wui-accent-glass-020) !important;
  }
`;
var RU = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let mh = class extends be {
  constructor() {
    super(...arguments), this.label = "", this.description = "", this.icon = "wallet";
  }
  render() {
    return _`
      <button>
        <wui-flex gap="m" alignItems="center" justifyContent="space-between">
          <wui-icon-box
            size="lg"
            iconcolor="accent-100"
            backgroundcolor="accent-100"
            icon=${this.icon}
            background="transparent"
          ></wui-icon-box>

          <wui-flex flexDirection="column" gap="3xs">
            <wui-text variant="paragraph-500" color="fg-100">${this.label}</wui-text>
            <wui-text variant="small-400" color="fg-200">${this.description}</wui-text>
          </wui-flex>

          <wui-icon size="md" color="fg-200" name="chevronRight"></wui-icon>
        </wui-flex>
      </button>
    `;
  }
};
mh.styles = [Rt, pr, Vde];
RU([
  te()
], mh.prototype, "label", void 0);
RU([
  te()
], mh.prototype, "description", void 0);
RU([
  te()
], mh.prototype, "icon", void 0);
mh = RU([
  Ze("wui-notice-card")
], mh);
const Ude = ze`
  :host {
    display: grid;
    width: inherit;
    height: inherit;
  }
`;
var ka = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let Fi = class extends be {
  render() {
    return this.style.cssText = `
      grid-template-rows: ${this.gridTemplateRows};
      grid-template-columns: ${this.gridTemplateColumns};
      justify-items: ${this.justifyItems};
      align-items: ${this.alignItems};
      justify-content: ${this.justifyContent};
      align-content: ${this.alignContent};
      column-gap: ${this.columnGap && `var(--wui-spacing-${this.columnGap})`};
      row-gap: ${this.rowGap && `var(--wui-spacing-${this.rowGap})`};
      gap: ${this.gap && `var(--wui-spacing-${this.gap})`};
      padding-top: ${this.padding && yn.getSpacingStyles(this.padding, 0)};
      padding-right: ${this.padding && yn.getSpacingStyles(this.padding, 1)};
      padding-bottom: ${this.padding && yn.getSpacingStyles(this.padding, 2)};
      padding-left: ${this.padding && yn.getSpacingStyles(this.padding, 3)};
      margin-top: ${this.margin && yn.getSpacingStyles(this.margin, 0)};
      margin-right: ${this.margin && yn.getSpacingStyles(this.margin, 1)};
      margin-bottom: ${this.margin && yn.getSpacingStyles(this.margin, 2)};
      margin-left: ${this.margin && yn.getSpacingStyles(this.margin, 3)};
    `, _`<slot></slot>`;
  }
};
Fi.styles = [Rt, Ude];
ka([
  te()
], Fi.prototype, "gridTemplateRows", void 0);
ka([
  te()
], Fi.prototype, "gridTemplateColumns", void 0);
ka([
  te()
], Fi.prototype, "justifyItems", void 0);
ka([
  te()
], Fi.prototype, "alignItems", void 0);
ka([
  te()
], Fi.prototype, "justifyContent", void 0);
ka([
  te()
], Fi.prototype, "alignContent", void 0);
ka([
  te()
], Fi.prototype, "columnGap", void 0);
ka([
  te()
], Fi.prototype, "rowGap", void 0);
ka([
  te()
], Fi.prototype, "gap", void 0);
ka([
  te()
], Fi.prototype, "padding", void 0);
ka([
  te()
], Fi.prototype, "margin", void 0);
Fi = ka([
  Ze("wui-grid")
], Fi);
const Rde = ze`
  :host {
    position: relative;
    display: flex;
    width: 100%;
    height: 1px;
    background-color: var(--wui-gray-glass-005);
    justify-content: center;
    align-items: center;
  }

  :host > wui-text {
    position: absolute;
    padding: 0px 10px;
    background-color: var(--wui-color-modal-bg);
  }
`;
var zQ = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let TV = class extends be {
  constructor() {
    super(...arguments), this.text = "";
  }
  render() {
    return _`${this.template()}`;
  }
  template() {
    return this.text ? _`<wui-text variant="small-500" color="fg-200">${this.text}</wui-text>` : null;
  }
};
TV.styles = [Rt, Rde];
zQ([
  te()
], TV.prototype, "text", void 0);
TV = zQ([
  Ze("wui-separator")
], TV);
var kQ = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })(ya, function() {
    var n = 1e3, r = 6e4, i = 36e5, a = "millisecond", o = "second", s = "minute", l = "hour", c = "day", d = "week", u = "month", h = "quarter", N = "year", M = "date", p = "Invalid Date", m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, R = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, V = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(T) {
      var Z = ["th", "st", "nd", "rd"], z = T % 100;
      return "[" + T + (Z[(z - 20) % 10] || Z[z] || Z[0]) + "]";
    } }, U = function(T, Z, z) {
      var j = String(T);
      return !j || j.length >= Z ? T : "" + Array(Z + 1 - j.length).join(z) + T;
    }, g = { s: U, z: function(T) {
      var Z = -T.utcOffset(), z = Math.abs(Z), j = Math.floor(z / 60), w = z % 60;
      return (Z <= 0 ? "+" : "-") + U(j, 2, "0") + ":" + U(w, 2, "0");
    }, m: function T(Z, z) {
      if (Z.date() < z.date())
        return -T(z, Z);
      var j = 12 * (z.year() - Z.year()) + (z.month() - Z.month()), w = Z.clone().add(j, u), C = z - w < 0, J = Z.clone().add(j + (C ? -1 : 1), u);
      return +(-(j + (z - w) / (C ? w - J : J - w)) || 0);
    }, a: function(T) {
      return T < 0 ? Math.ceil(T) || 0 : Math.floor(T);
    }, p: function(T) {
      return { M: u, y: N, w: d, d: c, D: M, h: l, m: s, s: o, ms: a, Q: h }[T] || String(T || "").toLowerCase().replace(/s$/, "");
    }, u: function(T) {
      return T === void 0;
    } }, y = "en", x = {};
    x[y] = V;
    var f = "$isDayjsObject", D = function(T) {
      return T instanceof ne || !(!T || !T[f]);
    }, Y = function T(Z, z, j) {
      var w;
      if (!Z)
        return y;
      if (typeof Z == "string") {
        var C = Z.toLowerCase();
        x[C] && (w = C), z && (x[C] = z, w = C);
        var J = Z.split("-");
        if (!w && J.length > 1)
          return T(J[0]);
      } else {
        var I = Z.name;
        x[I] = Z, w = I;
      }
      return !j && w && (y = w), w || !j && y;
    }, Q = function(T, Z) {
      if (D(T))
        return T.clone();
      var z = typeof Z == "object" ? Z : {};
      return z.date = T, z.args = arguments, new ne(z);
    }, G = g;
    G.l = Y, G.i = D, G.w = function(T, Z) {
      return Q(T, { locale: Z.$L, utc: Z.$u, x: Z.$x, $offset: Z.$offset });
    };
    var ne = function() {
      function T(z) {
        this.$L = Y(z.locale, null, !0), this.parse(z), this.$x = this.$x || z.x || {}, this[f] = !0;
      }
      var Z = T.prototype;
      return Z.parse = function(z) {
        this.$d = function(j) {
          var w = j.date, C = j.utc;
          if (w === null)
            return /* @__PURE__ */ new Date(NaN);
          if (G.u(w))
            return /* @__PURE__ */ new Date();
          if (w instanceof Date)
            return new Date(w);
          if (typeof w == "string" && !/Z$/i.test(w)) {
            var J = w.match(m);
            if (J) {
              var I = J[2] - 1 || 0, b = (J[7] || "0").substring(0, 3);
              return C ? new Date(Date.UTC(J[1], I, J[3] || 1, J[4] || 0, J[5] || 0, J[6] || 0, b)) : new Date(J[1], I, J[3] || 1, J[4] || 0, J[5] || 0, J[6] || 0, b);
            }
          }
          return new Date(w);
        }(z), this.init();
      }, Z.init = function() {
        var z = this.$d;
        this.$y = z.getFullYear(), this.$M = z.getMonth(), this.$D = z.getDate(), this.$W = z.getDay(), this.$H = z.getHours(), this.$m = z.getMinutes(), this.$s = z.getSeconds(), this.$ms = z.getMilliseconds();
      }, Z.$utils = function() {
        return G;
      }, Z.isValid = function() {
        return this.$d.toString() !== p;
      }, Z.isSame = function(z, j) {
        var w = Q(z);
        return this.startOf(j) <= w && w <= this.endOf(j);
      }, Z.isAfter = function(z, j) {
        return Q(z) < this.startOf(j);
      }, Z.isBefore = function(z, j) {
        return this.endOf(j) < Q(z);
      }, Z.$g = function(z, j, w) {
        return G.u(z) ? this[j] : this.set(w, z);
      }, Z.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, Z.valueOf = function() {
        return this.$d.getTime();
      }, Z.startOf = function(z, j) {
        var w = this, C = !!G.u(j) || j, J = G.p(z), I = function(Me, je) {
          var Se = G.w(w.$u ? Date.UTC(w.$y, je, Me) : new Date(w.$y, je, Me), w);
          return C ? Se : Se.endOf(c);
        }, b = function(Me, je) {
          return G.w(w.toDate()[Me].apply(w.toDate("s"), (C ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(je)), w);
        }, k = this.$W, ae = this.$M, oe = this.$D, le = "set" + (this.$u ? "UTC" : "");
        switch (J) {
          case N:
            return C ? I(1, 0) : I(31, 11);
          case u:
            return C ? I(1, ae) : I(0, ae + 1);
          case d:
            var fe = this.$locale().weekStart || 0, de = (k < fe ? k + 7 : k) - fe;
            return I(C ? oe - de : oe + (6 - de), ae);
          case c:
          case M:
            return b(le + "Hours", 0);
          case l:
            return b(le + "Minutes", 1);
          case s:
            return b(le + "Seconds", 2);
          case o:
            return b(le + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, Z.endOf = function(z) {
        return this.startOf(z, !1);
      }, Z.$set = function(z, j) {
        var w, C = G.p(z), J = "set" + (this.$u ? "UTC" : ""), I = (w = {}, w[c] = J + "Date", w[M] = J + "Date", w[u] = J + "Month", w[N] = J + "FullYear", w[l] = J + "Hours", w[s] = J + "Minutes", w[o] = J + "Seconds", w[a] = J + "Milliseconds", w)[C], b = C === c ? this.$D + (j - this.$W) : j;
        if (C === u || C === N) {
          var k = this.clone().set(M, 1);
          k.$d[I](b), k.init(), this.$d = k.set(M, Math.min(this.$D, k.daysInMonth())).$d;
        } else
          I && this.$d[I](b);
        return this.init(), this;
      }, Z.set = function(z, j) {
        return this.clone().$set(z, j);
      }, Z.get = function(z) {
        return this[G.p(z)]();
      }, Z.add = function(z, j) {
        var w, C = this;
        z = Number(z);
        var J = G.p(j), I = function(ae) {
          var oe = Q(C);
          return G.w(oe.date(oe.date() + Math.round(ae * z)), C);
        };
        if (J === u)
          return this.set(u, this.$M + z);
        if (J === N)
          return this.set(N, this.$y + z);
        if (J === c)
          return I(1);
        if (J === d)
          return I(7);
        var b = (w = {}, w[s] = r, w[l] = i, w[o] = n, w)[J] || 1, k = this.$d.getTime() + z * b;
        return G.w(k, this);
      }, Z.subtract = function(z, j) {
        return this.add(-1 * z, j);
      }, Z.format = function(z) {
        var j = this, w = this.$locale();
        if (!this.isValid())
          return w.invalidDate || p;
        var C = z || "YYYY-MM-DDTHH:mm:ssZ", J = G.z(this), I = this.$H, b = this.$m, k = this.$M, ae = w.weekdays, oe = w.months, le = w.meridiem, fe = function(je, Se, se, Ce) {
          return je && (je[Se] || je(j, C)) || se[Se].slice(0, Ce);
        }, de = function(je) {
          return G.s(I % 12 || 12, je, "0");
        }, Me = le || function(je, Se, se) {
          var Ce = je < 12 ? "AM" : "PM";
          return se ? Ce.toLowerCase() : Ce;
        };
        return C.replace(R, function(je, Se) {
          return Se || function(se) {
            switch (se) {
              case "YY":
                return String(j.$y).slice(-2);
              case "YYYY":
                return G.s(j.$y, 4, "0");
              case "M":
                return k + 1;
              case "MM":
                return G.s(k + 1, 2, "0");
              case "MMM":
                return fe(w.monthsShort, k, oe, 3);
              case "MMMM":
                return fe(oe, k);
              case "D":
                return j.$D;
              case "DD":
                return G.s(j.$D, 2, "0");
              case "d":
                return String(j.$W);
              case "dd":
                return fe(w.weekdaysMin, j.$W, ae, 2);
              case "ddd":
                return fe(w.weekdaysShort, j.$W, ae, 3);
              case "dddd":
                return ae[j.$W];
              case "H":
                return String(I);
              case "HH":
                return G.s(I, 2, "0");
              case "h":
                return de(1);
              case "hh":
                return de(2);
              case "a":
                return Me(I, b, !0);
              case "A":
                return Me(I, b, !1);
              case "m":
                return String(b);
              case "mm":
                return G.s(b, 2, "0");
              case "s":
                return String(j.$s);
              case "ss":
                return G.s(j.$s, 2, "0");
              case "SSS":
                return G.s(j.$ms, 3, "0");
              case "Z":
                return J;
            }
            return null;
          }(je) || J.replace(":", "");
        });
      }, Z.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, Z.diff = function(z, j, w) {
        var C, J = this, I = G.p(j), b = Q(z), k = (b.utcOffset() - this.utcOffset()) * r, ae = this - b, oe = function() {
          return G.m(J, b);
        };
        switch (I) {
          case N:
            C = oe() / 12;
            break;
          case u:
            C = oe();
            break;
          case h:
            C = oe() / 3;
            break;
          case d:
            C = (ae - k) / 6048e5;
            break;
          case c:
            C = (ae - k) / 864e5;
            break;
          case l:
            C = ae / i;
            break;
          case s:
            C = ae / r;
            break;
          case o:
            C = ae / n;
            break;
          default:
            C = ae;
        }
        return w ? C : G.a(C);
      }, Z.daysInMonth = function() {
        return this.endOf(u).$D;
      }, Z.$locale = function() {
        return x[this.$L];
      }, Z.locale = function(z, j) {
        if (!z)
          return this.$L;
        var w = this.clone(), C = Y(z, j, !0);
        return C && (w.$L = C), w;
      }, Z.clone = function() {
        return G.w(this.$d, this);
      }, Z.toDate = function() {
        return new Date(this.valueOf());
      }, Z.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, Z.toISOString = function() {
        return this.$d.toISOString();
      }, Z.toString = function() {
        return this.$d.toUTCString();
      }, T;
    }(), O = ne.prototype;
    return Q.prototype = O, [["$ms", a], ["$s", o], ["$m", s], ["$H", l], ["$W", c], ["$M", u], ["$y", N], ["$D", M]].forEach(function(T) {
      O[T[1]] = function(Z) {
        return this.$g(Z, T[0], T[1]);
      };
    }), Q.extend = function(T, Z) {
      return T.$i || (T(Z, ne, Q), T.$i = !0), Q;
    }, Q.locale = Y, Q.isDayjs = D, Q.unix = function(T) {
      return Q(1e3 * T);
    }, Q.en = x[y], Q.Ls = x, Q.p = {}, Q;
  });
})(kQ);
var gde = kQ.exports;
const gM = /* @__PURE__ */ fc(gde);
var wQ = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })(ya, function() {
    return function(n, r, i) {
      i.updateLocale = function(a, o) {
        var s = i.Ls[a];
        if (s)
          return (o ? Object.keys(o) : []).forEach(function(l) {
            s[l] = o[l];
          }), s;
      };
    };
  });
})(wQ);
var yde = wQ.exports;
const Zde = /* @__PURE__ */ fc(yde);
var FQ = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })(ya, function() {
    return function(n, r, i) {
      n = n || {};
      var a = r.prototype, o = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
      function s(c, d, u, h) {
        return a.fromToBase(c, d, u, h);
      }
      i.en.relativeTime = o, a.fromToBase = function(c, d, u, h, N) {
        for (var M, p, m, R = u.$locale().relativeTime || o, V = n.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], U = V.length, g = 0; g < U; g += 1) {
          var y = V[g];
          y.d && (M = h ? i(c).diff(u, y.d, !0) : u.diff(c, y.d, !0));
          var x = (n.rounding || Math.round)(Math.abs(M));
          if (m = M > 0, x <= y.r || !y.r) {
            x <= 1 && g > 0 && (y = V[g - 1]);
            var f = R[y.l];
            N && (x = N("" + x)), p = typeof f == "string" ? f.replace("%d", x) : f(x, d, y.l, m);
            break;
          }
        }
        if (d)
          return p;
        var D = m ? R.future : R.past;
        return typeof D == "function" ? D(p) : D.replace("%s", p);
      }, a.to = function(c, d) {
        return s(c, d, this, !0);
      }, a.from = function(c, d) {
        return s(c, d, this);
      };
      var l = function(c) {
        return c.$u ? i.utc() : i();
      };
      a.toNow = function(c) {
        return this.to(l(this), c);
      }, a.fromNow = function(c) {
        return this.from(l(this), c);
      };
    };
  });
})(FQ);
var bde = FQ.exports;
const Ede = /* @__PURE__ */ fc(bde);
gM.extend(Ede);
gM.extend(Zde);
gM.updateLocale("en", {
  relativeTime: {
    future: "in %s",
    past: "%s ago",
    s: "%s sec",
    m: "1 min",
    mm: "%d min",
    h: "1 hr",
    hh: "%d hrs",
    d: "1 d",
    dd: "%d d",
    M: "1 mo",
    MM: "%d mo",
    y: "1 yr",
    yy: "%d yr"
  }
});
const vQ = {
  getYear(t = (/* @__PURE__ */ new Date()).toISOString()) {
    return gM(t).year();
  },
  getRelativeDateFromNow(t) {
    return gM(t).fromNow(!0);
  }
}, Sde = 3, xde = ["receive", "deposit", "borrow", "claim"], Wde = ["withdraw", "repay", "burn"], Ku = {
  getTransactionGroupTitle(t) {
    const e = vQ.getYear();
    return t === e ? "This Year" : t;
  },
  getTransactionImages(t) {
    const [e, n] = t, r = !!e && (t == null ? void 0 : t.every((o) => !!o.nft_info)), i = (t == null ? void 0 : t.length) > 1;
    return (t == null ? void 0 : t.length) === 2 && !r ? [this.getTransactionImage(e), this.getTransactionImage(n)] : i ? t.map((o) => this.getTransactionImage(o)) : [this.getTransactionImage(e)];
  },
  getTransactionImage(t) {
    return {
      type: Ku.getTransactionTransferTokenType(t),
      url: Ku.getTransactionImageURL(t)
    };
  },
  getTransactionImageURL(t) {
    var i, a, o, s, l;
    let e = null;
    const n = !!(t != null && t.nft_info), r = !!(t != null && t.fungible_info);
    return t && n ? e = (o = (a = (i = t == null ? void 0 : t.nft_info) == null ? void 0 : i.content) == null ? void 0 : a.preview) == null ? void 0 : o.url : t && r && (e = (l = (s = t == null ? void 0 : t.fungible_info) == null ? void 0 : s.icon) == null ? void 0 : l.url), e;
  },
  getTransactionTransferTokenType(t) {
    return t != null && t.fungible_info ? "FUNGIBLE" : t != null && t.nft_info ? "NFT" : null;
  },
  getTransactionDescriptions(t) {
    var u, h, N;
    const e = (u = t.metadata) == null ? void 0 : u.operationType, n = t.transfers, r = ((h = t.transfers) == null ? void 0 : h.length) > 0, i = ((N = t.transfers) == null ? void 0 : N.length) > 1, a = r && (n == null ? void 0 : n.every((M) => !!M.fungible_info)), [o, s] = n;
    let l = this.getTransferDescription(o), c = this.getTransferDescription(s);
    if (!r)
      return (e === "send" || e === "receive") && a ? (l = yn.getTruncateString({
        string: t.metadata.sentFrom,
        charsStart: 4,
        charsEnd: 6,
        truncate: "middle"
      }), c = yn.getTruncateString({
        string: t.metadata.sentTo,
        charsStart: 4,
        charsEnd: 6,
        truncate: "middle"
      }), [l, c]) : [t.metadata.status];
    if (i)
      return n.map((M) => this.getTransferDescription(M));
    let d = "";
    return xde.includes(e) ? d = "+" : Wde.includes(e) && (d = "-"), l = d.concat(l), [l];
  },
  getTransferDescription(t) {
    var n;
    let e = "";
    return t && (t != null && t.nft_info ? e = ((n = t == null ? void 0 : t.nft_info) == null ? void 0 : n.name) || "-" : t != null && t.fungible_info && (e = this.getFungibleTransferDescription(t) || "-")), e;
  },
  getFungibleTransferDescription(t) {
    var r;
    return t ? [this.getQuantityFixedValue(t == null ? void 0 : t.quantity.numeric), (r = t == null ? void 0 : t.fungible_info) == null ? void 0 : r.symbol].join(" ").trim() : null;
  },
  getQuantityFixedValue(t) {
    return t ? parseFloat(t).toFixed(Sde) : null;
  }
};
var Ps = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let Io = class extends be {
  constructor() {
    super(), this.unsubscribe = [], this.disabled = !1, this.balance = "show", this.address = en.state.address, this.balanceVal = en.state.balance, this.balanceSymbol = en.state.balanceSymbol, this.profileName = en.state.profileName, this.profileImage = en.state.profileImage, this.network = er.state.caipNetwork, this.unsubscribe.push(en.subscribe((e) => {
      e.isConnected ? (this.address = e.address, this.balanceVal = e.balance, this.profileName = e.profileName, this.profileImage = e.profileImage, this.balanceSymbol = e.balanceSymbol) : (this.address = "", this.balanceVal = "", this.profileName = "", this.profileImage = "", this.balanceSymbol = "");
    }), er.subscribeKey("caipNetwork", (e) => this.network = e));
  }
  disconnectedCallback() {
    this.unsubscribe.forEach((e) => e());
  }
  render() {
    const e = qn.getNetworkImage(this.network), n = this.balance === "show";
    return _`
      <wui-account-button
        .disabled=${!!this.disabled}
        address=${Ft(this.profileName ?? this.address)}
        ?isProfileName=${!!this.profileName}
        networkSrc=${Ft(e)}
        avatarSrc=${Ft(this.profileImage)}
        balance=${n ? st.formatBalance(this.balanceVal, this.balanceSymbol) : ""}
        @click=${this.onClick.bind(this)}
      >
      </wui-account-button>
    `;
  }
  onClick() {
    bn.open();
  }
};
Ps([
  te({ type: Boolean })
], Io.prototype, "disabled", void 0);
Ps([
  te()
], Io.prototype, "balance", void 0);
Ps([
  Ke()
], Io.prototype, "address", void 0);
Ps([
  Ke()
], Io.prototype, "balanceVal", void 0);
Ps([
  Ke()
], Io.prototype, "balanceSymbol", void 0);
Ps([
  Ke()
], Io.prototype, "profileName", void 0);
Ps([
  Ke()
], Io.prototype, "profileImage", void 0);
Ps([
  Ke()
], Io.prototype, "network", void 0);
Io = Ps([
  Ze("w3m-account-button")
], Io);
var pu = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let oc = class extends be {
  constructor() {
    super(), this.unsubscribe = [], this.disabled = !1, this.balance = void 0, this.size = void 0, this.label = void 0, this.loadingLabel = void 0, this.isAccount = en.state.isConnected, this.unsubscribe.push(en.subscribeKey("isConnected", (e) => {
      this.isAccount = e;
    }));
  }
  disconnectedCallback() {
    this.unsubscribe.forEach((e) => e());
  }
  render() {
    return this.isAccount ? _`
          <w3m-account-button
            .disabled=${!!this.disabled}
            balance=${Ft(this.balance)}
          >
          </w3m-account-button>
        ` : _`
          <w3m-connect-button
            size=${Ft(this.size)}
            label=${Ft(this.label)}
            loadingLabel=${Ft(this.loadingLabel)}
          ></w3m-connect-button>
        `;
  }
};
pu([
  te({ type: Boolean })
], oc.prototype, "disabled", void 0);
pu([
  te()
], oc.prototype, "balance", void 0);
pu([
  te()
], oc.prototype, "size", void 0);
pu([
  te()
], oc.prototype, "label", void 0);
pu([
  te()
], oc.prototype, "loadingLabel", void 0);
pu([
  Ke()
], oc.prototype, "isAccount", void 0);
oc = pu([
  Ze("w3m-button")
], oc);
var lN = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let Cd = class extends be {
  constructor() {
    super(), this.unsubscribe = [], this.size = "md", this.label = "Connect Wallet", this.loadingLabel = "Connecting...", this.open = bn.state.open, this.loading = bn.state.loading, this.unsubscribe.push(bn.subscribe((e) => {
      this.open = e.open, this.loading = e.loading;
    }));
  }
  disconnectedCallback() {
    this.unsubscribe.forEach((e) => e());
  }
  render() {
    const e = this.loading || this.open;
    return _`
      <wui-connect-button
        size=${Ft(this.size)}
        .loading=${e}
        @click=${this.onClick.bind(this)}
      >
        ${e ? this.loadingLabel : this.label}
      </wui-connect-button>
    `;
  }
  onClick() {
    this.open ? bn.close() : bn.open();
  }
};
lN([
  te()
], Cd.prototype, "size", void 0);
lN([
  te()
], Cd.prototype, "label", void 0);
lN([
  te()
], Cd.prototype, "loadingLabel", void 0);
lN([
  Ke()
], Cd.prototype, "open", void 0);
lN([
  Ke()
], Cd.prototype, "loading", void 0);
Cd = lN([
  Ze("w3m-connect-button")
], Cd);
const jde = ze`
  :host {
    z-index: var(--w3m-z-index);
    display: block;
    backface-visibility: hidden;
    will-change: opacity;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    opacity: 0;
    background-color: var(--wui-cover);
  }

  @keyframes zoom-in {
    0% {
      transform: scale(0.95) translateY(0);
    }
    100% {
      transform: scale(1) translateY(0);
    }
  }

  @keyframes slide-in {
    0% {
      transform: scale(1) translateY(50px);
    }
    100% {
      transform: scale(1) translateY(0);
    }
  }

  wui-card {
    max-width: 360px;
    width: 100%;
    position: relative;
    animation-delay: 0.3s;
    animation-duration: 0.2s;
    animation-name: zoom-in;
    animation-fill-mode: backwards;
    animation-timing-function: var(--wui-ease-out-power-2);
    outline: none;
  }

  wui-flex {
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  @media (max-height: 700px) and (min-width: 431px) {
    wui-flex {
      align-items: flex-start;
    }

    wui-card {
      margin: var(--wui-spacing-xxl) 0px;
    }
  }

  @media (max-width: 430px) {
    wui-flex {
      align-items: flex-end;
    }

    wui-card {
      max-width: 100%;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      border-bottom: none;
      animation-name: slide-in;
    }
  }
`;
var gU = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
const h4 = "scroll-lock";
let Ld = class extends be {
  constructor() {
    super(), this.unsubscribe = [], this.abortController = void 0, this.open = bn.state.open, this.caipAddress = en.state.address, this.isSiweEnabled = ir.state.isSiweEnabled, this.initializeTheming(), Gt.prefetch(), this.unsubscribe.push(bn.subscribeKey("open", (e) => e ? this.onOpen() : this.onClose()), ir.subscribeKey("isSiweEnabled", (e) => {
      this.isSiweEnabled = e;
    }), en.subscribe((e) => this.onNewAccountState(e))), _t.sendEvent({ type: "track", event: "MODAL_LOADED" });
  }
  disconnectedCallback() {
    this.unsubscribe.forEach((e) => e()), this.onRemoveKeyboardListener();
  }
  render() {
    return this.open ? _`
          <wui-flex @click=${this.onOverlayClick.bind(this)}>
            <wui-card role="alertdialog" aria-modal="true" tabindex="0">
              <w3m-header></w3m-header>
              <w3m-router></w3m-router>
              <w3m-snackbar></w3m-snackbar>
            </wui-card>
          </wui-flex>
        ` : null;
  }
  async onOverlayClick(e) {
    e.target === e.currentTarget && await this.handleClose();
  }
  async handleClose() {
    this.isSiweEnabled && ir.state.status !== "success" && await Ht.disconnect(), bn.close();
  }
  initializeTheming() {
    const { themeVariables: e, themeMode: n } = pa.state, r = yn.getColorTheme(n);
    ase(e, r);
  }
  async onClose() {
    this.onScrollUnlock(), await this.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 200,
      easing: "ease",
      fill: "forwards"
    }).finished, Vr.hide(), this.open = !1, this.onRemoveKeyboardListener();
  }
  async onOpen() {
    this.onScrollLock(), this.open = !0, await this.animate([{ opacity: 0 }, { opacity: 1 }], {
      duration: 200,
      easing: "ease",
      fill: "forwards",
      delay: 300
    }).finished, this.onAddKeyboardListener();
  }
  onScrollLock() {
    const e = document.createElement("style");
    e.dataset.w3m = h4, e.textContent = `
      html, body {
        touch-action: none;
        overflow: hidden;
        overscroll-behavior: contain;
      }
      w3m-modal {
        pointer-events: auto;
      }
    `, document.head.appendChild(e);
  }
  onScrollUnlock() {
    const e = document.head.querySelector(`style[data-w3m="${h4}"]`);
    e && e.remove();
  }
  onAddKeyboardListener() {
    var n;
    this.abortController = new AbortController();
    const e = (n = this.shadowRoot) == null ? void 0 : n.querySelector("wui-card");
    e == null || e.focus(), window.addEventListener("keydown", (r) => {
      if (r.key === "Escape")
        this.handleClose();
      else if (r.key === "Tab") {
        const { tagName: i } = r.target;
        i && !i.includes("W3M-") && !i.includes("WUI-") && (e == null || e.focus());
      }
    }, this.abortController);
  }
  onRemoveKeyboardListener() {
    var e;
    (e = this.abortController) == null || e.abort(), this.abortController = void 0;
  }
  async onNewAccountState(e) {
    const { isConnected: n, caipAddress: r } = e;
    if (this.isSiweEnabled) {
      n && !this.caipAddress && (this.caipAddress = r), n && r && this.caipAddress !== r && (await ir.signOut(), this.onSiweNavigation(), this.caipAddress = r);
      try {
        const i = await ir.getSession();
        i && !n ? await ir.signOut() : n && !i && this.onSiweNavigation();
      } catch {
        n && this.onSiweNavigation();
      }
    }
  }
  onSiweNavigation() {
    this.open ? tt.push("ConnectingSiwe") : bn.open({
      view: "ConnectingSiwe"
    });
  }
};
Ld.styles = jde;
gU([
  Ke()
], Ld.prototype, "open", void 0);
gU([
  Ke()
], Ld.prototype, "caipAddress", void 0);
gU([
  Ke()
], Ld.prototype, "isSiweEnabled", void 0);
Ld = gU([
  Ze("w3m-modal")
], Ld);
const Dde = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get W3mModal() {
    return Ld;
  }
}, Symbol.toStringTag, { value: "Module" }));
var rm = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let Th = class extends be {
  constructor() {
    super(), this.unsubscribe = [], this.disabled = !1, this.network = er.state.caipNetwork, this.connected = en.state.isConnected, this.loading = bn.state.loading, this.unsubscribe.push(er.subscribeKey("caipNetwork", (e) => this.network = e), en.subscribeKey("isConnected", (e) => this.connected = e), bn.subscribeKey("loading", (e) => this.loading = e));
  }
  disconnectedCallback() {
    this.unsubscribe.forEach((e) => e());
  }
  render() {
    var e;
    return _`
      <wui-network-button
        .disabled=${!!(this.disabled || this.loading)}
        imageSrc=${Ft(qn.getNetworkImage(this.network))}
        @click=${this.onClick.bind(this)}
      >
        ${((e = this.network) == null ? void 0 : e.name) ?? (this.connected ? "Unknown Network" : "Select Network")}
      </wui-network-button>
    `;
  }
  onClick() {
    bn.open({ view: "Networks" });
  }
};
rm([
  te({ type: Boolean })
], Th.prototype, "disabled", void 0);
rm([
  Ke()
], Th.prototype, "network", void 0);
rm([
  Ke()
], Th.prototype, "connected", void 0);
rm([
  Ke()
], Th.prototype, "loading", void 0);
Th = rm([
  Ze("w3m-network-button")
], Th);
const zde = ze`
  :host {
    display: block;
    will-change: transform, opacity;
  }
`;
var IQ = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let fV = class extends be {
  constructor() {
    super(), this.resizeObserver = void 0, this.prevHeight = "0px", this.prevHistoryLength = 1, this.unsubscribe = [], this.view = tt.state.view, this.unsubscribe.push(tt.subscribeKey("view", (e) => this.onViewChange(e)));
  }
  firstUpdated() {
    this.resizeObserver = new ResizeObserver(async ([e]) => {
      const n = `${e == null ? void 0 : e.contentRect.height}px`;
      this.prevHeight !== "0px" && (await this.animate([{ height: this.prevHeight }, { height: n }], {
        duration: 150,
        easing: "ease",
        fill: "forwards"
      }).finished, this.style.height = "auto"), this.prevHeight = n;
    }), this.resizeObserver.observe(this.getWrapper());
  }
  disconnectedCallback() {
    var e;
    (e = this.resizeObserver) == null || e.unobserve(this.getWrapper()), this.unsubscribe.forEach((n) => n());
  }
  render() {
    return _`<div>${this.viewTemplate()}</div>`;
  }
  viewTemplate() {
    switch (this.view) {
      case "Connect":
        return _`<w3m-connect-view></w3m-connect-view>`;
      case "ConnectingWalletConnect":
        return _`<w3m-connecting-wc-view></w3m-connecting-wc-view>`;
      case "ConnectingExternal":
        return _`<w3m-connecting-external-view></w3m-connecting-external-view>`;
      case "ConnectingSiwe":
        return _`<w3m-connecting-siwe-view></w3m-connecting-siwe-view>`;
      case "AllWallets":
        return _`<w3m-all-wallets-view></w3m-all-wallets-view>`;
      case "Networks":
        return _`<w3m-networks-view></w3m-networks-view>`;
      case "SwitchNetwork":
        return _`<w3m-network-switch-view></w3m-network-switch-view>`;
      case "Account":
        return _`<w3m-account-view></w3m-account-view>`;
      case "WhatIsAWallet":
        return _`<w3m-what-is-a-wallet-view></w3m-what-is-a-wallet-view>`;
      case "WhatIsANetwork":
        return _`<w3m-what-is-a-network-view></w3m-what-is-a-network-view>`;
      case "GetWallet":
        return _`<w3m-get-wallet-view></w3m-get-wallet-view>`;
      case "Downloads":
        return _`<w3m-downloads-view></w3m-downloads-view>`;
      case "EmailVerifyOtp":
        return _`<w3m-email-verify-otp-view></w3m-email-verify-otp-view>`;
      case "EmailVerifyDevice":
        return _`<w3m-email-verify-device-view></w3m-email-verify-device-view>`;
      case "ApproveTransaction":
        return _`<w3m-approve-transaction-view></w3m-approve-transaction-view>`;
      case "Transactions":
        return _`<w3m-transactions-view></w3m-transactions-view>`;
      case "UpgradeWallet":
        return _`<w3m-upgrade-wallet-view></w3m-upgrade-wallet-view>`;
      default:
        return _`<w3m-connect-view></w3m-connect-view>`;
    }
  }
  async onViewChange(e) {
    const { history: n } = tt.state;
    let r = -10, i = 10;
    n.length < this.prevHistoryLength && (r = 10, i = -10), this.prevHistoryLength = n.length, await this.animate([
      { opacity: 1, transform: "translateX(0px)" },
      { opacity: 0, transform: `translateX(${r}px)` }
    ], { duration: 150, easing: "ease", fill: "forwards" }).finished, this.view = e, await this.animate([
      { opacity: 0, transform: `translateX(${i}px)` },
      { opacity: 1, transform: "translateX(0px)" }
    ], { duration: 150, easing: "ease", fill: "forwards", delay: 50 }).finished;
  }
  getWrapper() {
    var e;
    return (e = this.shadowRoot) == null ? void 0 : e.querySelector("div");
  }
};
fV.styles = zde;
IQ([
  Ke()
], fV.prototype, "view", void 0);
fV = IQ([
  Ze("w3m-router")
], fV);
const kde = ze`
  wui-flex {
    width: 100%;
  }

  :host > wui-flex:first-child {
    transform: translateY(calc(var(--wui-spacing-xxs) * -1));
  }

  wui-icon-link {
    margin-right: calc(var(--wui-icon-box-size-md) * -1);
  }

  wui-notice-card {
    margin-bottom: var(--wui-spacing-3xs);
  }
`;
var Wc = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let Oo = class extends be {
  constructor() {
    super(), this.usubscribe = [], this.connectors = or.state.connectors, this.address = en.state.address, this.profileImage = en.state.profileImage, this.profileName = en.state.profileName, this.balance = en.state.balance, this.balanceSymbol = en.state.balanceSymbol, this.network = er.state.caipNetwork, this.disconecting = !1, this.usubscribe.push(en.subscribe((e) => {
      e.address ? (this.address = e.address, this.profileImage = e.profileImage, this.profileName = e.profileName, this.balance = e.balance, this.balanceSymbol = e.balanceSymbol) : bn.close();
    }), er.subscribeKey("caipNetwork", (e) => {
      e != null && e.id && (this.network = e);
    }));
  }
  disconnectedCallback() {
    this.usubscribe.forEach((e) => e());
  }
  render() {
    var n;
    if (!this.address)
      throw new Error("w3m-account-view: No account provided");
    const e = qn.getNetworkImage(this.network);
    return _`
      <wui-flex
        flexDirection="column"
        .padding=${["0", "s", "m", "s"]}
        alignItems="center"
        gap="l"
      >
        <wui-avatar
          alt=${this.address}
          address=${this.address}
          imageSrc=${Ft(this.profileImage === null ? void 0 : this.profileImage)}
        ></wui-avatar>

        <wui-flex flexDirection="column" alignItems="center">
          <wui-flex gap="3xs" alignItems="center" justifyContent="center">
            <wui-text variant="large-600" color="fg-100">
              ${this.profileName ? yn.getTruncateString({
      string: this.profileName,
      charsStart: 20,
      charsEnd: 0,
      truncate: "end"
    }) : yn.getTruncateString({
      string: this.address,
      charsStart: 4,
      charsEnd: 6,
      truncate: "middle"
    })}
            </wui-text>
            <wui-icon-link
              size="md"
              icon="copy"
              iconColor="fg-200"
              @click=${this.onCopyAddress}
            ></wui-icon-link>
          </wui-flex>
          <wui-flex gap="s" flexDirection="column" alignItems="center">
            <wui-text variant="paragraph-500" color="fg-200">
              ${st.formatBalance(this.balance, this.balanceSymbol)}
            </wui-text>

            ${this.explorerBtnTemplate()}
          </wui-flex>
        </wui-flex>
      </wui-flex>

      <wui-flex flexDirection="column" gap="xs" .padding=${["0", "s", "s", "s"]}>
        ${this.emailCardTemplate()}

        <wui-list-item
          .variant=${e ? "image" : "icon"}
          iconVariant="overlay"
          icon="networkPlaceholder"
          imageSrc=${Ft(e)}
          ?chevron=${this.isAllowedNetworkSwitch()}
          @click=${this.onNetworks.bind(this)}
        >
          <wui-text variant="paragraph-500" color="fg-100">
            ${((n = this.network) == null ? void 0 : n.name) ?? "Unknown"}
          </wui-text>
        </wui-list-item>
        <wui-list-item
          iconVariant="blue"
          icon="swapHorizontalBold"
          iconSize="sm"
          ?chevron=${!0}
          @click=${this.onTransactions.bind(this)}
        >
          <wui-text variant="paragraph-500" color="fg-100">Activity</wui-text>
        </wui-list-item>
        <wui-list-item
          variant="icon"
          iconVariant="overlay"
          icon="disconnect"
          ?chevron=${!1}
          .loading=${this.disconecting}
          @click=${this.onDisconnect.bind(this)}
        >
          <wui-text variant="paragraph-500" color="fg-200">Disconnect</wui-text>
        </wui-list-item>
      </wui-flex>
    `;
  }
  emailCardTemplate() {
    const e = Si.getConnectedConnector();
    return !this.connectors.find((r) => r.type === "EMAIL") || e !== "EMAIL" ? null : _`
      <wui-notice-card
        @click=${this.onGoToUpgradeView.bind(this)}
        label="Upgrade your wallet"
        description="Transition to a non-custodial wallet"
        icon="wallet"
      ></wui-notice-card>
    `;
  }
  explorerBtnTemplate() {
    const { addressExplorerUrl: e } = en.state;
    return e ? _`
      <wui-button size="sm" variant="shade" @click=${this.onExplorer.bind(this)}>
        <wui-icon size="sm" color="inherit" slot="iconLeft" name="compass"></wui-icon>
        Block Explorer
        <wui-icon size="sm" color="inherit" slot="iconRight" name="externalLink"></wui-icon>
      </wui-button>
    ` : null;
  }
  isAllowedNetworkSwitch() {
    const { requestedCaipNetworks: e } = er.state, n = e ? e.length > 1 : !1, r = e == null ? void 0 : e.find(({ id: i }) => {
      var a;
      return i === ((a = this.network) == null ? void 0 : a.id);
    });
    return n || !r;
  }
  onCopyAddress() {
    try {
      this.address && (st.copyToClopboard(this.address), Vr.showSuccess("Address copied"));
    } catch {
      Vr.showError("Failed to copy");
    }
  }
  onNetworks() {
    this.isAllowedNetworkSwitch() && tt.push("Networks");
  }
  onTransactions() {
    _t.sendEvent({ type: "track", event: "CLICK_TRANSACTIONS" }), tt.push("Transactions");
  }
  async onDisconnect() {
    try {
      this.disconecting = !0, await Ht.disconnect(), _t.sendEvent({ type: "track", event: "DISCONNECT_SUCCESS" }), bn.close();
    } catch {
      _t.sendEvent({ type: "track", event: "DISCONNECT_ERROR" }), Vr.showError("Failed to disconnect");
    } finally {
      this.disconecting = !1;
    }
  }
  onExplorer() {
    const { addressExplorerUrl: e } = en.state;
    e && st.openHref(e, "_blank");
  }
  onGoToUpgradeView() {
    tt.push("UpgradeWallet");
  }
};
Oo.styles = kde;
Wc([
  Ke()
], Oo.prototype, "address", void 0);
Wc([
  Ke()
], Oo.prototype, "profileImage", void 0);
Wc([
  Ke()
], Oo.prototype, "profileName", void 0);
Wc([
  Ke()
], Oo.prototype, "balance", void 0);
Wc([
  Ke()
], Oo.prototype, "balanceSymbol", void 0);
Wc([
  Ke()
], Oo.prototype, "network", void 0);
Wc([
  Ke()
], Oo.prototype, "disconecting", void 0);
Oo = Wc([
  Ze("w3m-account-view")
], Oo);
var OQ = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let db = class extends be {
  constructor() {
    super(...arguments), this.search = "", this.onDebouncedSearch = st.debounce((e) => {
      this.search = e;
    });
  }
  render() {
    const e = this.search.length >= 2;
    return _`
      <wui-flex padding="s" gap="s">
        <wui-search-bar @inputChange=${this.onInputChange.bind(this)}></wui-search-bar>
        ${this.qrButtonTemplate()}
      </wui-flex>
      ${e ? _`<w3m-all-wallets-search query=${this.search}></w3m-all-wallets-search>` : _`<w3m-all-wallets-list></w3m-all-wallets-list>`}
    `;
  }
  onInputChange(e) {
    this.onDebouncedSearch(e.detail);
  }
  qrButtonTemplate() {
    return st.isMobile() ? _`
        <wui-icon-box
          size="lg"
          iconSize="xl"
          iconColor="accent-100"
          backgroundColor="accent-100"
          icon="qrCode"
          background="transparent"
          border
          borderColor="wui-accent-glass-010"
          @click=${this.onWalletConnectQr.bind(this)}
        ></wui-icon-box>
      ` : null;
  }
  onWalletConnectQr() {
    tt.push("ConnectingWalletConnect");
  }
};
OQ([
  Ke()
], db.prototype, "search", void 0);
db = OQ([
  Ze("w3m-all-wallets-view")
], db);
const wde = ze`
  wui-flex {
    max-height: clamp(360px, 540px, 80vh);
    overflow: scroll;
    scrollbar-width: none;
  }

  wui-flex::-webkit-scrollbar {
    display: none;
  }
`;
var YQ = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let VV = class extends be {
  constructor() {
    super(), this.unsubscribe = [], this.connectors = or.state.connectors, this.unsubscribe.push(or.subscribeKey("connectors", (e) => this.connectors = e));
  }
  disconnectedCallback() {
    this.unsubscribe.forEach((e) => e());
  }
  render() {
    return _`
      <wui-flex flexDirection="column" padding="s" gap="xs">
        <w3m-email-login-widget></w3m-email-login-widget>

        ${this.walletConnectConnectorTemplate()} ${this.recentTemplate()}
        ${this.announcedTemplate()} ${this.injectedTemplate()} ${this.featuredTemplate()}
        ${this.customTemplate()} ${this.recommendedTemplate()} ${this.connectorsTemplate()}
        ${this.allWalletsTemplate()}
      </wui-flex>
      <w3m-legal-footer></w3m-legal-footer>
    `;
  }
  walletConnectConnectorTemplate() {
    if (st.isMobile())
      return null;
    const e = this.connectors.find((n) => n.type === "WALLET_CONNECT");
    return e ? _`
      <wui-list-wallet
        imageSrc=${Ft(qn.getConnectorImage(e))}
        name=${e.name ?? "Unknown"}
        @click=${() => this.onConnector(e)}
        tagLabel="qr code"
        tagVariant="main"
      >
      </wui-list-wallet>
    ` : null;
  }
  customTemplate() {
    const { customWallets: e } = dn.state;
    return e != null && e.length ? this.filterOutDuplicateWallets(e).map((r) => _`
        <wui-list-wallet
          imageSrc=${Ft(qn.getWalletImage(r))}
          name=${r.name ?? "Unknown"}
          @click=${() => this.onConnectWallet(r)}
        >
        </wui-list-wallet>
      `) : null;
  }
  featuredTemplate() {
    if (!this.connectors.find((i) => i.type === "WALLET_CONNECT"))
      return null;
    const { featured: n } = Gt.state;
    return n.length ? this.filterOutDuplicateWallets(n).map((i) => _`
        <wui-list-wallet
          imageSrc=${Ft(qn.getWalletImage(i))}
          name=${i.name ?? "Unknown"}
          @click=${() => this.onConnectWallet(i)}
        >
        </wui-list-wallet>
      `) : null;
  }
  recentTemplate() {
    return Si.getRecentWallets().map((n) => _`
        <wui-list-wallet
          imageSrc=${Ft(qn.getWalletImage(n))}
          name=${n.name ?? "Unknown"}
          @click=${() => this.onConnectWallet(n)}
          tagLabel="recent"
          tagVariant="shade"
        >
        </wui-list-wallet>
      `);
  }
  announcedTemplate() {
    return this.connectors.map((e) => e.type !== "ANNOUNCED" ? null : _`
        <wui-list-wallet
          imageSrc=${Ft(qn.getConnectorImage(e))}
          name=${e.name ?? "Unknown"}
          @click=${() => this.onConnector(e)}
          tagVariant="success"
          installed=${!0}
        >
        </wui-list-wallet>
      `);
  }
  injectedTemplate() {
    const e = this.connectors.find((n) => n.type === "ANNOUNCED");
    return this.connectors.map((n) => n.type !== "INJECTED" || !Ht.checkInstalled() ? null : _`
        <wui-list-wallet
          imageSrc=${Ft(qn.getConnectorImage(n))}
          installed=${!!e}
          name=${n.name ?? "Unknown"}
          @click=${() => this.onConnector(n)}
        >
        </wui-list-wallet>
      `);
  }
  connectorsTemplate() {
    return this.connectors.map((e) => ["WALLET_CONNECT", "INJECTED", "ANNOUNCED", "EMAIL"].includes(e.type) ? null : _`
        <wui-list-wallet
          imageSrc=${Ft(qn.getConnectorImage(e))}
          name=${e.name ?? "Unknown"}
          @click=${() => this.onConnector(e)}
        >
        </wui-list-wallet>
      `);
  }
  allWalletsTemplate() {
    if (!this.connectors.find((s) => s.type === "WALLET_CONNECT"))
      return null;
    const n = Gt.state.count, r = Gt.state.featured.length, i = n + r, a = i < 10 ? i : Math.floor(i / 10) * 10, o = a < i ? `${a}+` : `${a}`;
    return _`
      <wui-list-wallet
        name="All Wallets"
        walletIcon="allWallets"
        showAllWallets
        @click=${this.onAllWallets.bind(this)}
        tagLabel=${o}
        tagVariant="shade"
      ></wui-list-wallet>
    `;
  }
  recommendedTemplate() {
    if (!this.connectors.find((u) => u.type === "WALLET_CONNECT"))
      return null;
    const { recommended: n } = Gt.state, { customWallets: r, featuredWalletIds: i } = dn.state, { connectors: a } = or.state, o = Si.getRecentWallets(), s = a.filter((u) => u.type === "ANNOUNCED");
    if (i || r || !n.length)
      return null;
    const l = s.length + o.length, c = Math.max(0, 2 - l);
    return this.filterOutDuplicateWallets(n).slice(0, c).map((u) => _`
        <wui-list-wallet
          imageSrc=${Ft(qn.getWalletImage(u))}
          name=${(u == null ? void 0 : u.name) ?? "Unknown"}
          @click=${() => this.onConnectWallet(u)}
        >
        </wui-list-wallet>
      `);
  }
  onConnector(e) {
    e.type === "WALLET_CONNECT" ? st.isMobile() ? tt.push("AllWallets") : tt.push("ConnectingWalletConnect") : tt.push("ConnectingExternal", { connector: e });
  }
  filterOutDuplicateWallets(e) {
    const { connectors: n } = or.state, i = Si.getRecentWallets().map((s) => s.id), a = n.map((s) => {
      var l;
      return (l = s.info) == null ? void 0 : l.rdns;
    }).filter(Boolean);
    return e.filter((s) => !i.includes(s.id) && !a.includes(s.rdns ?? void 0));
  }
  onAllWallets() {
    _t.sendEvent({ type: "track", event: "CLICK_ALL_WALLETS" }), tt.push("AllWallets");
  }
  onConnectWallet(e) {
    tt.push("ConnectingWalletConnect", { wallet: e });
  }
};
VV.styles = wde;
YQ([
  Ke()
], VV.prototype, "connectors", void 0);
VV = YQ([
  Ze("w3m-connect-view")
], VV);
const Fde = ze`
  @keyframes shake {
    0% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(3px);
    }
    50% {
      transform: translateX(-3px);
    }
    75% {
      transform: translateX(3px);
    }
    100% {
      transform: translateX(0);
    }
  }

  wui-flex:first-child:not(:only-child) {
    position: relative;
  }

  wui-loading-thumbnail {
    position: absolute;
  }

  wui-icon-box {
    position: absolute;
    right: calc(var(--wui-spacing-3xs) * -1);
    bottom: calc(var(--wui-spacing-3xs) * -1);
    opacity: 0;
    transform: scale(0.5);
    transition: all var(--wui-ease-out-power-2) var(--wui-duration-lg);
  }

  wui-text[align='center'] {
    width: 100%;
    padding: 0px var(--wui-spacing-l);
  }

  [data-error='true'] wui-icon-box {
    opacity: 1;
    transform: scale(1);
  }

  [data-error='true'] > wui-flex:first-child {
    animation: shake 250ms cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  }

  [data-retry='false'] wui-link {
    display: none;
  }

  [data-retry='true'] wui-link {
    display: block;
    opacity: 1;
  }
`;
var mu = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
class Gi extends be {
  constructor() {
    var e, n, r, i;
    super(), this.wallet = (e = tt.state.data) == null ? void 0 : e.wallet, this.connector = (n = tt.state.data) == null ? void 0 : n.connector, this.timeout = void 0, this.secondaryBtnLabel = "Try again", this.secondaryBtnIcon = "refresh", this.secondaryLabel = "Accept connection request in the wallet", this.onConnect = void 0, this.onRender = void 0, this.onAutoConnect = void 0, this.isWalletConnect = !0, this.unsubscribe = [], this.imageSrc = qn.getWalletImage(this.wallet) ?? qn.getConnectorImage(this.connector), this.name = ((r = this.wallet) == null ? void 0 : r.name) ?? ((i = this.connector) == null ? void 0 : i.name) ?? "Wallet", this.isRetrying = !1, this.uri = Ht.state.wcUri, this.error = Ht.state.wcError, this.ready = !1, this.showRetry = !1, this.buffering = !1, this.isMobile = !1, this.onRetry = void 0, this.unsubscribe.push(Ht.subscribeKey("wcUri", (a) => {
      var o;
      this.uri = a, this.isRetrying && this.onRetry && (this.isRetrying = !1, (o = this.onConnect) == null || o.call(this));
    }), Ht.subscribeKey("wcError", (a) => this.error = a), Ht.subscribeKey("buffering", (a) => this.buffering = a));
  }
  firstUpdated() {
    var e;
    (e = this.onAutoConnect) == null || e.call(this), this.showRetry = !this.onAutoConnect;
  }
  disconnectedCallback() {
    this.unsubscribe.forEach((e) => e()), clearTimeout(this.timeout);
  }
  render() {
    var r;
    (r = this.onRender) == null || r.call(this), this.onShowRetry();
    const e = this.error ? "Connection can be declined if a previous request is still active" : this.secondaryLabel;
    let n = `Continue in ${this.name}`;
    return this.buffering && (n = "Connecting..."), this.error && (n = "Connection declined"), _`
      <wui-flex
        data-error=${Ft(this.error)}
        data-retry=${this.showRetry}
        flexDirection="column"
        alignItems="center"
        .padding=${["3xl", "xl", "xl", "xl"]}
        gap="xl"
      >
        <wui-flex justifyContent="center" alignItems="center">
          <wui-wallet-image size="lg" imageSrc=${Ft(this.imageSrc)}></wui-wallet-image>

          ${this.error ? null : this.loaderTemplate()}

          <wui-icon-box
            backgroundColor="error-100"
            background="opaque"
            iconColor="error-100"
            icon="close"
            size="sm"
            border
            borderColor="wui-color-bg-125"
          ></wui-icon-box>
        </wui-flex>

        <wui-flex flexDirection="column" alignItems="center" gap="xs">
          <wui-text variant="paragraph-500" color=${this.error ? "error-100" : "fg-100"}>
            ${n}
          </wui-text>
          <wui-text align="center" variant="small-500" color="fg-200">${e}</wui-text>
        </wui-flex>

        <wui-button
          variant="accent"
          ?disabled=${!this.error && this.buffering}
          @click=${this.onTryAgain.bind(this)}
        >
          <wui-icon color="inherit" slot="iconLeft" name=${this.secondaryBtnIcon}></wui-icon>
          ${this.secondaryBtnLabel}
        </wui-button>
      </wui-flex>

      ${this.isWalletConnect ? _`
            <wui-flex .padding=${["0", "xl", "xl", "xl"]} justifyContent="center">
              <wui-link @click=${this.onCopyUri} color="fg-200">
                <wui-icon size="xs" color="fg-200" slot="iconLeft" name="copy"></wui-icon>
                Copy link
              </wui-link>
            </wui-flex>
          ` : null}

      <w3m-mobile-download-links .wallet=${this.wallet}></w3m-mobile-download-links>
    `;
  }
  onShowRetry() {
    var e;
    this.error && !this.showRetry && (this.showRetry = !0, ((e = this.shadowRoot) == null ? void 0 : e.querySelector("wui-button")).animate([{ opacity: 0 }, { opacity: 1 }], {
      fill: "forwards",
      easing: "ease"
    }));
  }
  onTryAgain() {
    var e, n;
    this.buffering || (Ht.setWcError(!1), this.onRetry ? (this.isRetrying = !0, (e = this.onRetry) == null || e.call(this)) : (n = this.onConnect) == null || n.call(this));
  }
  loaderTemplate() {
    const e = pa.state.themeVariables["--w3m-border-radius-master"], n = e ? parseInt(e.replace("px", ""), 10) : 4;
    return _`<wui-loading-thumbnail radius=${n * 9}></wui-loading-thumbnail>`;
  }
  onCopyUri() {
    try {
      this.uri && (st.copyToClopboard(this.uri), Vr.showSuccess("Link copied"));
    } catch {
      Vr.showError("Failed to copy");
    }
  }
}
Gi.styles = Fde;
mu([
  Ke()
], Gi.prototype, "uri", void 0);
mu([
  Ke()
], Gi.prototype, "error", void 0);
mu([
  Ke()
], Gi.prototype, "ready", void 0);
mu([
  Ke()
], Gi.prototype, "showRetry", void 0);
mu([
  Ke()
], Gi.prototype, "buffering", void 0);
mu([
  te({ type: Boolean })
], Gi.prototype, "isMobile", void 0);
mu([
  te()
], Gi.prototype, "onRetry", void 0);
var vde = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
const Ide = {
  INJECTED: "browser",
  ANNOUNCED: "browser"
};
let N4 = class extends Gi {
  constructor() {
    if (super(), !this.connector)
      throw new Error("w3m-connecting-view: No connector provided");
    _t.sendEvent({
      type: "track",
      event: "SELECT_WALLET",
      properties: {
        name: this.connector.name ?? "Unknown",
        platform: Ide[this.connector.type] ?? "external"
      }
    }), this.onConnect = this.onConnectProxy.bind(this), this.onAutoConnect = this.onConnectProxy.bind(this), this.isWalletConnect = !1;
  }
  async onConnectProxy() {
    try {
      this.error = !1, this.connector && (this.connector.imageUrl && Si.setConnectedWalletImageUrl(this.connector.imageUrl), await Ht.connectExternal(this.connector), ir.state.isSiweEnabled ? tt.push("ConnectingSiwe") : bn.close(), _t.sendEvent({
        type: "track",
        event: "CONNECT_SUCCESS",
        properties: { method: "external" }
      }));
    } catch (e) {
      _t.sendEvent({
        type: "track",
        event: "CONNECT_ERROR",
        properties: { message: (e == null ? void 0 : e.message) ?? "Unknown" }
      }), this.error = !0;
    }
  }
};
N4 = vde([
  Ze("w3m-connecting-external-view")
], N4);
var QQ = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let ub = class extends be {
  constructor() {
    var e;
    super(...arguments), this.dappName = (e = dn.state.metadata) == null ? void 0 : e.name, this.isSigning = !1;
  }
  render() {
    return _`
      <wui-flex justifyContent="center" .padding=${["2xl", "0", "xxl", "0"]}>
        <w3m-connecting-siwe></w3m-connecting-siwe>
      </wui-flex>
      <wui-flex
        .padding=${["0", "4xl", "l", "4xl"]}
        gap="s"
        justifyContent="space-between"
      >
        <wui-text variant="paragraph-500" align="center" color="fg-100"
          >${this.dappName ?? "Dapp"} needs to connect to your wallet</wui-text
        >
      </wui-flex>
      <wui-flex
        .padding=${["0", "3xl", "l", "3xl"]}
        gap="s"
        justifyContent="space-between"
      >
        <wui-text variant="small-400" align="center" color="fg-200"
          >Sign this message to prove you own this wallet and proceed. Canceling will disconnect
          you.</wui-text
        >
      </wui-flex>
      <wui-flex .padding=${["l", "xl", "xl", "xl"]} gap="s" justifyContent="space-between">
        <wui-button size="md" ?fullwidth=${!0} variant="shade" @click=${this.onCancel.bind(this)}>
          Cancel
        </wui-button>
        <wui-button
          size="md"
          ?fullwidth=${!0}
          variant="fill"
          @click=${this.onSign.bind(this)}
          ?loading=${this.isSigning}
        >
          ${this.isSigning ? "Signing..." : "Sign"}
        </wui-button>
      </wui-flex>
    `;
  }
  async onSign() {
    this.isSigning = !0, _t.sendEvent({
      event: "CLICK_SIGN_SIWE_MESSAGE",
      type: "track"
    });
    try {
      ir.setStatus("loading");
      const e = await ir.signIn();
      return ir.setStatus("success"), _t.sendEvent({
        event: "SIWE_AUTH_SUCCESS",
        type: "track"
      }), e;
    } catch {
      return Vr.showError("Signature declined"), ir.setStatus("error"), _t.sendEvent({
        event: "SIWE_AUTH_ERROR",
        type: "track"
      });
    } finally {
      this.isSigning = !1;
    }
  }
  async onCancel() {
    const { isConnected: e } = en.state;
    e ? (await Ht.disconnect(), bn.close()) : tt.push("Connect"), _t.sendEvent({
      event: "CLICK_CANCEL_SIWE",
      type: "track"
    });
  }
};
QQ([
  Ke()
], ub.prototype, "isSigning", void 0);
ub = QQ([
  Ze("w3m-connecting-siwe-view")
], ub);
var yS = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let UV = class extends be {
  constructor() {
    var e;
    super(), this.interval = void 0, this.lastRetry = Date.now(), this.wallet = (e = tt.state.data) == null ? void 0 : e.wallet, this.platform = void 0, this.platforms = [], this.initializeConnection(), this.interval = setInterval(this.initializeConnection.bind(this), od.TEN_SEC_MS);
  }
  disconnectedCallback() {
    clearTimeout(this.interval);
  }
  render() {
    return this.wallet ? (this.determinePlatforms(), _`
      ${this.headerTemplate()}
      <div>${this.platformTemplate()}</div>
    `) : _`<w3m-connecting-wc-qrcode></w3m-connecting-wc-qrcode>`;
  }
  async initializeConnection(e = !1) {
    try {
      const { wcPairingExpiry: n } = Ht.state;
      if (e || st.isPairingExpired(n)) {
        if (Ht.connectWalletConnect(), this.wallet) {
          const r = qn.getWalletImage(this.wallet);
          r && Si.setConnectedWalletImageUrl(r);
        } else {
          const i = or.state.connectors.find((o) => o.type === "WALLET_CONNECT"), a = qn.getConnectorImage(i);
          a && Si.setConnectedWalletImageUrl(a);
        }
        await Ht.state.wcPromise, this.finalizeConnection(), ir.state.isSiweEnabled ? tt.push("ConnectingSiwe") : bn.close();
      }
    } catch (n) {
      _t.sendEvent({
        type: "track",
        event: "CONNECT_ERROR",
        properties: { message: (n == null ? void 0 : n.message) ?? "Unknown" }
      }), Ht.setWcError(!0), st.isAllowedRetry(this.lastRetry) && (Vr.showError("Declined"), this.lastRetry = Date.now(), this.initializeConnection(!0));
    }
  }
  finalizeConnection() {
    const { wcLinking: e, recentWallet: n } = Ht.state;
    e && Si.setWalletConnectDeepLink(e), n && Si.setWeb3ModalRecent(n), _t.sendEvent({
      type: "track",
      event: "CONNECT_SUCCESS",
      properties: {
        method: e ? "mobile" : "qrcode"
      }
    });
  }
  determinePlatforms() {
    if (!this.wallet)
      throw new Error("w3m-connecting-wc-view:determinePlatforms No wallet");
    if (this.platform)
      return;
    const { mobile_link: e, desktop_link: n, webapp_link: r, injected: i, rdns: a } = this.wallet, o = i == null ? void 0 : i.map(({ injected_id: M }) => M).filter(Boolean), s = a ? [a] : o ?? [], l = s.length, c = e, d = r, u = Ht.checkInstalled(s), h = l && u, N = n && !st.isMobile();
    h && this.platforms.push("browser"), c && this.platforms.push(st.isMobile() ? "mobile" : "qrcode"), d && this.platforms.push("web"), N && this.platforms.push("desktop"), !h && l && this.platforms.push("unsupported"), this.platform = this.platforms[0];
  }
  platformTemplate() {
    switch (this.platform) {
      case "browser":
        return _`<w3m-connecting-wc-browser></w3m-connecting-wc-browser>`;
      case "desktop":
        return _`
          <w3m-connecting-wc-desktop .onRetry=${() => this.initializeConnection(!0)}>
          </w3m-connecting-wc-desktop>
        `;
      case "web":
        return _`
          <w3m-connecting-wc-web .onRetry=${() => this.initializeConnection(!0)}>
          </w3m-connecting-wc-web>
        `;
      case "mobile":
        return _`
          <w3m-connecting-wc-mobile isMobile .onRetry=${() => this.initializeConnection(!0)}>
          </w3m-connecting-wc-mobile>
        `;
      case "qrcode":
        return _`<w3m-connecting-wc-qrcode></w3m-connecting-wc-qrcode>`;
      default:
        return _`<w3m-connecting-wc-unsupported></w3m-connecting-wc-unsupported>`;
    }
  }
  headerTemplate() {
    return this.platforms.length > 1 ? _`
      <w3m-connecting-header
        .platforms=${this.platforms}
        .onSelectPlatfrom=${this.onSelectPlatform.bind(this)}
      >
      </w3m-connecting-header>
    ` : null;
  }
  async onSelectPlatform(e) {
    var r;
    const n = (r = this.shadowRoot) == null ? void 0 : r.querySelector("div");
    n && (await n.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 200,
      fill: "forwards",
      easing: "ease"
    }).finished, this.platform = e, n.animate([{ opacity: 0 }, { opacity: 1 }], {
      duration: 200,
      fill: "forwards",
      easing: "ease"
    }));
  }
};
yS([
  Ke()
], UV.prototype, "platform", void 0);
yS([
  Ke()
], UV.prototype, "platforms", void 0);
UV = yS([
  Ze("w3m-connecting-wc-view")
], UV);
var Ode = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let M4 = class extends be {
  constructor() {
    var e;
    super(...arguments), this.wallet = (e = tt.state.data) == null ? void 0 : e.wallet;
  }
  render() {
    if (!this.wallet)
      throw new Error("w3m-downloads-view");
    return _`
      <wui-flex gap="xs" flexDirection="column" .padding=${["s", "s", "l", "s"]}>
        ${this.chromeTemplate()} ${this.iosTemplate()} ${this.androidTemplate()}
        ${this.homepageTemplate()}
      </wui-flex>
    `;
  }
  chromeTemplate() {
    var e;
    return (e = this.wallet) != null && e.chrome_store ? _`<wui-list-item
      variant="icon"
      icon="chromeStore"
      iconVariant="square"
      @click=${this.onChromeStore.bind(this)}
      chevron
    >
      <wui-text variant="paragraph-500" color="fg-100">Chrome Extension</wui-text>
    </wui-list-item>` : null;
  }
  iosTemplate() {
    var e;
    return (e = this.wallet) != null && e.app_store ? _`<wui-list-item
      variant="icon"
      icon="appStore"
      iconVariant="square"
      @click=${this.onAppStore.bind(this)}
      chevron
    >
      <wui-text variant="paragraph-500" color="fg-100">iOS App</wui-text>
    </wui-list-item>` : null;
  }
  androidTemplate() {
    var e;
    return (e = this.wallet) != null && e.play_store ? _`<wui-list-item
      variant="icon"
      icon="playStore"
      iconVariant="square"
      @click=${this.onPlayStore.bind(this)}
      chevron
    >
      <wui-text variant="paragraph-500" color="fg-100">Android App</wui-text>
    </wui-list-item>` : null;
  }
  homepageTemplate() {
    var e;
    return (e = this.wallet) != null && e.homepage ? _`
      <wui-list-item
        variant="icon"
        icon="browser"
        iconVariant="square-blue"
        @click=${this.onHomePage.bind(this)}
        chevron
      >
        <wui-text variant="paragraph-500" color="fg-100">Website</wui-text>
      </wui-list-item>
    ` : null;
  }
  onChromeStore() {
    var e;
    (e = this.wallet) != null && e.chrome_store && st.openHref(this.wallet.chrome_store, "_blank");
  }
  onAppStore() {
    var e;
    (e = this.wallet) != null && e.app_store && st.openHref(this.wallet.app_store, "_blank");
  }
  onPlayStore() {
    var e;
    (e = this.wallet) != null && e.play_store && st.openHref(this.wallet.play_store, "_blank");
  }
  onHomePage() {
    var e;
    (e = this.wallet) != null && e.homepage && st.openHref(this.wallet.homepage, "_blank");
  }
};
M4 = Ode([
  Ze("w3m-downloads-view")
], M4);
var Yde = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
const Qde = "https://walletconnect.com/explorer";
let p4 = class extends be {
  render() {
    return _`
      <wui-flex flexDirection="column" padding="s" gap="xs">
        ${this.recommendedWalletsTemplate()}
        <wui-list-wallet
          name="Explore all"
          showAllWallets
          walletIcon="allWallets"
          icon="externalLink"
          @click=${() => {
      st.openHref("https://walletconnect.com/explorer?type=wallet", "_blank");
    }}
        ></wui-list-wallet>
      </wui-flex>
    `;
  }
  recommendedWalletsTemplate() {
    const { recommended: e, featured: n } = Gt.state, { customWallets: r } = dn.state;
    return [...n, ...r ?? [], ...e].slice(0, 4).map((a) => _`
        <wui-list-wallet
          name=${a.name ?? "Unknown"}
          tagVariant="main"
          imageSrc=${Ft(qn.getWalletImage(a))}
          @click=${() => {
      st.openHref(a.homepage ?? Qde, "_blank");
    }}
        ></wui-list-wallet>
      `);
  }
};
p4 = Yde([
  Ze("w3m-get-wallet-view")
], p4);
const Gde = ze`
  @keyframes shake {
    0% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(3px);
    }
    50% {
      transform: translateX(-3px);
    }
    75% {
      transform: translateX(3px);
    }
    100% {
      transform: translateX(0);
    }
  }

  wui-flex:first-child:not(:only-child) {
    position: relative;
  }

  wui-loading-hexagon {
    position: absolute;
  }

  wui-icon-box {
    position: absolute;
    right: 4px;
    bottom: 0;
    opacity: 0;
    transform: scale(0.5);
    z-index: 1;
    transition: all var(--wui-ease-out-power-2) var(--wui-duration-lg);
  }

  wui-button {
    display: none;
  }

  [data-error='true'] wui-icon-box {
    opacity: 1;
    transform: scale(1);
  }

  [data-error='true'] > wui-flex:first-child {
    animation: shake 250ms cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  }

  wui-button[data-retry='true'] {
    display: block;
    opacity: 1;
  }
`;
var ZS = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let yM = class extends be {
  constructor() {
    var e;
    super(), this.network = (e = tt.state.data) == null ? void 0 : e.network, this.unsubscribe = [], this.showRetry = !1, this.error = !1;
  }
  disconnectedCallback() {
    this.unsubscribe.forEach((e) => e());
  }
  firstUpdated() {
    this.onSwitchNetwork();
  }
  render() {
    if (!this.network)
      throw new Error("w3m-network-switch-view: No network provided");
    this.onShowRetry();
    const e = this.error ? "Switch declined" : "Approve in wallet", n = this.error ? "Switch can be declined if chain is not supported by a wallet or previous request is still active" : "Accept connection request in your wallet";
    return _`
      <wui-flex
        data-error=${this.error}
        flexDirection="column"
        alignItems="center"
        .padding=${["3xl", "xl", "3xl", "xl"]}
        gap="xl"
      >
        <wui-flex justifyContent="center" alignItems="center">
          <wui-network-image
            size="lg"
            imageSrc=${Ft(qn.getNetworkImage(this.network))}
          ></wui-network-image>

          ${this.error ? null : _`<wui-loading-hexagon></wui-loading-hexagon>`}

          <wui-icon-box
            backgroundColor="error-100"
            background="opaque"
            iconColor="error-100"
            icon="close"
            size="sm"
            ?border=${!0}
            borderColor="wui-color-bg-125"
          ></wui-icon-box>
        </wui-flex>

        <wui-flex flexDirection="column" alignItems="center" gap="xs">
          <wui-text align="center" variant="paragraph-500" color="fg-100">${e}</wui-text>
          <wui-text align="center" variant="small-500" color="fg-200">${n}</wui-text>
        </wui-flex>

        <wui-button
          data-retry=${this.showRetry}
          variant="fill"
          .disabled=${!this.error}
          @click=${this.onSwitchNetwork.bind(this)}
        >
          <wui-icon color="inherit" slot="iconLeft" name="refresh"></wui-icon>
          Try again
        </wui-button>
      </wui-flex>
    `;
  }
  onShowRetry() {
    var e;
    this.error && !this.showRetry && (this.showRetry = !0, ((e = this.shadowRoot) == null ? void 0 : e.querySelector("wui-button")).animate([{ opacity: 0 }, { opacity: 1 }], {
      fill: "forwards",
      easing: "ease"
    }));
  }
  async onSwitchNetwork() {
    try {
      this.error = !1, this.network && (await er.switchActiveNetwork(this.network), ir.state.isSiweEnabled || HY.navigateAfterNetworkSwitch());
    } catch {
      this.error = !0;
    }
  }
};
yM.styles = Gde;
ZS([
  Ke()
], yM.prototype, "showRetry", void 0);
ZS([
  Ke()
], yM.prototype, "error", void 0);
yM = ZS([
  Ze("w3m-network-switch-view")
], yM);
var GQ = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let hb = class extends be {
  constructor() {
    super(), this.unsubscribe = [], this.caipNetwork = er.state.caipNetwork, this.unsubscribe.push(er.subscribeKey("caipNetwork", (e) => this.caipNetwork = e));
  }
  disconnectedCallback() {
    this.unsubscribe.forEach((e) => e());
  }
  render() {
    return _`
      <wui-grid padding="s" gridTemplateColumns="repeat(4, 1fr)" rowGap="l" columnGap="xs">
        ${this.networksTemplate()}
      </wui-grid>

      <wui-separator></wui-separator>

      <wui-flex padding="s" flexDirection="column" gap="m" alignItems="center">
        <wui-text variant="small-400" color="fg-300" align="center">
          Your connected wallet may not support some of the networks available for this dApp
        </wui-text>
        <wui-link @click=${this.onNetworkHelp.bind(this)}>
          <wui-icon size="xs" color="accent-100" slot="iconLeft" name="helpCircle"></wui-icon>
          What is a network
        </wui-link>
      </wui-flex>
    `;
  }
  onNetworkHelp() {
    _t.sendEvent({ type: "track", event: "CLICK_NETWORK_HELP" }), tt.push("WhatIsANetwork");
  }
  networksTemplate() {
    const { approvedCaipNetworkIds: e, requestedCaipNetworks: n, supportsAllNetworks: r } = er.state, i = e, a = n, o = {};
    return a && i && (i.forEach((s, l) => {
      o[s] = l;
    }), a.sort((s, l) => {
      const c = o[s.id], d = o[l.id];
      return c !== void 0 && d !== void 0 ? c - d : c !== void 0 ? -1 : d !== void 0 ? 1 : 0;
    })), a == null ? void 0 : a.map((s) => {
      var l;
      return _`
        <wui-card-select
          .selected=${((l = this.caipNetwork) == null ? void 0 : l.id) === s.id}
          imageSrc=${Ft(qn.getNetworkImage(s))}
          type="network"
          name=${s.name ?? s.id}
          @click=${() => this.onSwitchNetwork(s)}
          .disabled=${!r && !(i != null && i.includes(s.id))}
        ></wui-card-select>
      `;
    });
  }
  async onSwitchNetwork(e) {
    const { isConnected: n } = en.state, { approvedCaipNetworkIds: r, supportsAllNetworks: i, caipNetwork: a } = er.state, { data: o } = tt.state;
    n && (a == null ? void 0 : a.id) !== e.id ? r != null && r.includes(e.id) ? (await er.switchActiveNetwork(e), HY.navigateAfterNetworkSwitch()) : i && tt.push("SwitchNetwork", { ...o, network: e }) : n || (er.setCaipNetwork(e), tt.push("Connect"));
  }
};
GQ([
  Ke()
], hb.prototype, "caipNetwork", void 0);
hb = GQ([
  Ze("w3m-networks-view")
], hb);
const Cde = ze`
  :host > wui-flex:first-child {
    height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
  }
`;
var Tu = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
const nT = "last-transaction", Lde = 7;
let Qs = class extends be {
  constructor() {
    super(), this.unsubscribe = [], this.paginationObserver = void 0, this.address = en.state.address, this.transactions = Oa.state.transactions, this.transactionsByYear = Oa.state.transactionsByYear, this.loading = Oa.state.loading, this.empty = Oa.state.empty, this.next = Oa.state.next, this.unsubscribe.push(en.subscribe((e) => {
      e.isConnected && this.address !== e.address && (this.address = e.address, Oa.resetTransactions(), Oa.fetchTransactions(e.address));
    }), Oa.subscribe((e) => {
      this.transactions = e.transactions, this.transactionsByYear = e.transactionsByYear, this.loading = e.loading, this.empty = e.empty, this.next = e.next;
    }));
  }
  firstUpdated() {
    this.transactions.length === 0 && Oa.fetchTransactions(this.address), this.createPaginationObserver();
  }
  updated() {
    this.setPaginationObserver();
  }
  disconnectedCallback() {
    this.unsubscribe.forEach((e) => e());
  }
  render() {
    return _`
      <wui-flex flexDirection="column" padding="s" gap="s">
        ${this.empty ? null : this.templateTransactionsByYear()}
        ${this.loading ? this.templateLoading() : null}
        ${!this.loading && this.empty ? this.templateEmpty() : null}
      </wui-flex>
    `;
  }
  templateTransactionsByYear() {
    const e = Object.keys(this.transactionsByYear).sort().reverse();
    return e.map((n, r) => {
      const i = r === e.length - 1, a = parseInt(n, 10), o = Ku.getTransactionGroupTitle(a), s = this.transactionsByYear[a];
      return s ? _`
        <wui-flex flexDirection="column" gap="s">
          <wui-flex
            alignItems="center"
            flexDirection="row"
            .padding=${["xs", "s", "s", "s"]}
          >
            <wui-text variant="paragraph-500" color="fg-200">${o}</wui-text>
          </wui-flex>
          <wui-flex flexDirection="column" gap="xs">
            ${this.templateTransactions(s, i)}
          </wui-flex>
        </wui-flex>
      ` : null;
    });
  }
  templateRenderTransaction(e, n) {
    const { date: r, descriptions: i, direction: a, isAllNFT: o, images: s, status: l, transfers: c, type: d } = this.getTransactionListItemProps(e), u = (c == null ? void 0 : c.length) > 1;
    return (c == null ? void 0 : c.length) === 2 && !o ? _`
        <wui-transaction-list-item
          date=${r}
          .direction=${a}
          id=${n && this.next ? nT : ""}
          status=${l}
          type=${d}
          .images=${s}
          .descriptions=${i}
        ></wui-transaction-list-item>
      ` : u ? c.map((N, M) => {
      const p = Ku.getTransferDescription(N), m = n && M === c.length - 1;
      return _` <wui-transaction-list-item
          date=${r}
          direction=${N.direction}
          id=${m && this.next ? nT : ""}
          status=${l}
          type=${d}
          .onlyDirectionIcon=${!0}
          .images=${[s == null ? void 0 : s[M]]}
          .descriptions=${[p]}
        ></wui-transaction-list-item>`;
    }) : _`
      <wui-transaction-list-item
        date=${r}
        .direction=${a}
        id=${n && this.next ? nT : ""}
        status=${l}
        type=${d}
        .images=${s}
        .descriptions=${i}
      ></wui-transaction-list-item>
    `;
  }
  templateTransactions(e, n) {
    return e.map((r, i) => {
      const a = n && i === e.length - 1;
      return _`${this.templateRenderTransaction(r, a)}`;
    });
  }
  templateEmpty() {
    return _`
      <wui-flex
        flexGrow="1"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        .padding=${["3xl", "xl", "3xl", "xl"]}
        gap="xl"
      >
        <wui-icon-box
          backgroundColor="glass-005"
          background="gray"
          iconColor="fg-200"
          icon="wallet"
          size="lg"
          ?border=${!0}
          borderColor="wui-color-bg-125"
        ></wui-icon-box>
        <wui-flex flexDirection="column" alignItems="center" gap="xs">
          <wui-text align="center" variant="paragraph-500" color="fg-100"
            >No Transactions yet</wui-text
          >
          <wui-text align="center" variant="small-500" color="fg-200"
            >Start trading on dApps <br />
            to grow your wallet!</wui-text
          >
        </wui-flex>
      </wui-flex>
    `;
  }
  templateLoading() {
    return Array(Lde).fill(_` <wui-transaction-list-item-loader></wui-transaction-list-item-loader> `).map((e) => e);
  }
  createPaginationObserver() {
    const { projectId: e } = dn.state;
    this.paginationObserver = new IntersectionObserver(([n]) => {
      n != null && n.isIntersecting && !this.loading && (Oa.fetchTransactions(this.address), _t.sendEvent({
        type: "track",
        event: "LOAD_MORE_TRANSACTIONS",
        properties: {
          address: this.address,
          projectId: e,
          cursor: this.next
        }
      }));
    }, {}), this.setPaginationObserver();
  }
  setPaginationObserver() {
    var n, r, i;
    (n = this.paginationObserver) == null || n.disconnect();
    const e = (r = this.shadowRoot) == null ? void 0 : r.querySelector(`#${nT}`);
    e && ((i = this.paginationObserver) == null || i.observe(e));
  }
  getTransactionListItemProps(e) {
    var l, c, d, u, h;
    const n = vQ.getRelativeDateFromNow((l = e == null ? void 0 : e.metadata) == null ? void 0 : l.minedAt), r = Ku.getTransactionDescriptions(e), i = e == null ? void 0 : e.transfers, a = (c = e == null ? void 0 : e.transfers) == null ? void 0 : c[0], o = !!a && ((d = e == null ? void 0 : e.transfers) == null ? void 0 : d.every((N) => !!N.nft_info)), s = Ku.getTransactionImages(i);
    return {
      date: n,
      direction: a == null ? void 0 : a.direction,
      descriptions: r,
      isAllNFT: o,
      images: s,
      status: (u = e.metadata) == null ? void 0 : u.status,
      transfers: i,
      type: (h = e.metadata) == null ? void 0 : h.operationType
    };
  }
};
Qs.styles = Cde;
Tu([
  Ke()
], Qs.prototype, "address", void 0);
Tu([
  Ke()
], Qs.prototype, "transactions", void 0);
Tu([
  Ke()
], Qs.prototype, "transactionsByYear", void 0);
Tu([
  Ke()
], Qs.prototype, "loading", void 0);
Tu([
  Ke()
], Qs.prototype, "empty", void 0);
Tu([
  Ke()
], Qs.prototype, "next", void 0);
Qs = Tu([
  Ze("w3m-transactions-view")
], Qs);
var Jde = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
const Bde = [
  {
    images: ["network", "layers", "system"],
    title: "The system’s nuts and bolts",
    text: "A network is what brings the blockchain to life, as this technical infrastructure allows apps to access the ledger and smart contract services."
  },
  {
    images: ["noun", "defiAlt", "dao"],
    title: "Designed for different uses",
    text: "Each network is designed differently, and may therefore suit certain apps and experiences."
  }
];
let m4 = class extends be {
  render() {
    return _`
      <wui-flex
        flexDirection="column"
        .padding=${["xxl", "xl", "xl", "xl"]}
        alignItems="center"
        gap="xl"
      >
        <w3m-help-widget .data=${Bde}></w3m-help-widget>
        <wui-button
          variant="fill"
          size="sm"
          @click=${() => {
      st.openHref("https://ethereum.org/en/developers/docs/networks/", "_blank");
    }}
        >
          Learn more
          <wui-icon color="inherit" slot="iconRight" name="externalLink"></wui-icon>
        </wui-button>
      </wui-flex>
    `;
  }
};
m4 = Jde([
  Ze("w3m-what-is-a-network-view")
], m4);
var Ade = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
const Hde = [
  {
    images: ["login", "profile", "lock"],
    title: "One login for all of web3",
    text: "Log in to any app by connecting your wallet. Say goodbye to countless passwords!"
  },
  {
    images: ["defi", "nft", "eth"],
    title: "A home for your digital assets",
    text: "A wallet lets you store, send and receive digital assets like cryptocurrencies and NFTs."
  },
  {
    images: ["browser", "noun", "dao"],
    title: "Your gateway to a new web",
    text: "With your wallet, you can explore and interact with DeFi, NFTs, DAOs, and much more."
  }
];
let T4 = class extends be {
  render() {
    return _`
      <wui-flex
        flexDirection="column"
        .padding=${["xxl", "xl", "xl", "xl"]}
        alignItems="center"
        gap="xl"
      >
        <w3m-help-widget .data=${Hde}></w3m-help-widget>
        <wui-button variant="fill" size="sm" @click=${this.onGetWallet.bind(this)}>
          <wui-icon color="inherit" slot="iconLeft" name="wallet"></wui-icon>
          Get a wallet
        </wui-button>
      </wui-flex>
    `;
  }
  onGetWallet() {
    _t.sendEvent({ type: "track", event: "CLICK_GET_WALLET" }), tt.push("GetWallet");
  }
};
T4 = Ade([
  Ze("w3m-what-is-a-wallet-view")
], T4);
const Xde = ze`
  wui-loading-spinner {
    margin: 9px auto;
  }
`;
var CQ = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
const _de = 6;
let RV = class extends be {
  constructor() {
    var e;
    super(...arguments), this.email = (e = tt.state.data) == null ? void 0 : e.email, this.emailConnector = or.getEmailConnector(), this.loading = !1;
  }
  render() {
    if (!this.email)
      throw new Error("w3m-email-verify-otp-view: No email provided");
    return _`
      <wui-flex
        flexDirection="column"
        alignItems="center"
        .padding=${["l", "0", "l", "0"]}
        gap="l"
      >
        <wui-flex flexDirection="column" alignItems="center">
          <wui-text variant="paragraph-400" color="fg-100"> Enter the code we sent to </wui-text>
          <wui-text variant="paragraph-500" color="fg-100">${this.email}</wui-text>
        </wui-flex>

        <wui-text variant="small-400" color="fg-200">The code expires in 10 minutes</wui-text>

        ${this.loading ? _`<wui-loading-spinner size="xl" color="accent-100"></wui-loading-spinner>` : _`<wui-otp
              dissabled
              length="6"
              @inputChange=${this.onOtpInputChange.bind(this)}
            ></wui-otp>`}

        <wui-flex alignItems="center">
          <wui-text variant="small-400" color="fg-200">Didn't receive it?</wui-text>
          <wui-link @click=${this.onResendCode.bind(this)}>Resend code</wui-link>
        </wui-flex>
      </wui-flex>
    `;
  }
  async onOtpInputChange(e) {
    try {
      if (!this.loading) {
        const n = e.detail;
        this.emailConnector && n.length === _de && (this.loading = !0, await this.emailConnector.provider.connectOtp({ otp: n }), await Ht.connectExternal(this.emailConnector), bn.close(), _t.sendEvent({
          type: "track",
          event: "CONNECT_SUCCESS",
          properties: { method: "email" }
        }));
      }
    } catch (n) {
      Vr.showError(n), this.loading = !1;
    }
  }
  async onResendCode() {
    try {
      if (!this.loading) {
        const e = or.getEmailConnector();
        if (!e || !this.email)
          throw new Error("w3m-email-login-widget: Unable to resend email");
        this.loading = !0, await e.provider.connectEmail({ email: this.email }), Vr.showSuccess("New Email sent");
      }
    } catch (e) {
      Vr.showError(e);
    } finally {
      this.loading = !1;
    }
  }
};
RV.styles = Xde;
CQ([
  Ke()
], RV.prototype, "loading", void 0);
RV = CQ([
  Ze("w3m-email-verify-otp-view")
], RV);
const Pde = ze`
  wui-icon-box {
    height: 64px;
    width: 64px;
  }

  #w3m-resend-section {
    height: 56px;
  }
`;
var LQ = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let gV = class extends be {
  constructor() {
    var e;
    super(), this.email = (e = tt.state.data) == null ? void 0 : e.email, this.emailConnector = or.getEmailConnector(), this.loading = !1, this.listenForDeviceApproval();
  }
  render() {
    if (!this.email)
      throw new Error("w3m-email-verify-device-view: No email provided");
    if (!this.emailConnector)
      throw new Error("w3m-email-verify-device-view: No email provided");
    return _`
      <wui-flex
        flexDirection="column"
        alignItems="center"
        .padding=${["0", "3xl", "xxl", "3xl"]}
      >
        <wui-flex justifyContent="center" .padding=${["0", "0", "xxl", "0"]}>
          <wui-icon-box
            size="xl"
            iconcolor="accent-100"
            backgroundcolor="accent-100"
            icon="verify"
            background="opaque"
          ></wui-icon-box>
        </wui-flex>
        <wui-text variant="large-600" color="fg-100">Register this device to continue</wui-text>
        <wui-flex
          flexDirection="column"
          alignItems="center"
          .padding=${["s", "0", "0", "0"]}
        >
          <wui-text variant="paragraph-400" color="fg-200">Check the instructions sent to</wui-text>
          <wui-text variant="paragraph-600" color="fg-100">${this.email}</wui-text>
        </wui-flex>

        <wui-flex alignItems="center" id="w3m-resend-section">
          ${this.loading ? _`<wui-loading-spinner size="xl" color="accent-100"></wui-loading-spinner>` : _` <wui-link @click=${this.onResendCode.bind(this)}>Resend email</wui-link>`}
        </wui-flex>

        <wui-flex alignItems="center">
          <wui-text variant="paragraph-400" color="fg-200" align="center">
            This is a quick one-time approval that will keep your account secure
          </wui-text>
        </wui-flex>
      </wui-flex>
    `;
  }
  async listenForDeviceApproval() {
    this.emailConnector && (await this.emailConnector.provider.connectDevice(), tt.replace("EmailVerifyOtp", { email: this.email }));
  }
  async onResendCode() {
    try {
      if (!this.loading) {
        const e = or.getEmailConnector();
        if (!e || !this.email)
          throw new Error("w3m-email-login-widget: Unable to resend email");
        this.loading = !0, await e.provider.connectEmail({ email: this.email }), Vr.showSuccess("New Email sent");
      }
    } catch (e) {
      Vr.showError(e);
    } finally {
      this.loading = !1;
    }
  }
};
gV.styles = Pde;
LQ([
  Ke()
], gV.prototype, "loading", void 0);
gV = LQ([
  Ze("w3m-email-verify-device-view")
], gV);
const Kde = ze`
  div {
    width: 100%;
    height: 400px;
  }

  [data-ready='false'] {
    transform: scale(1.05);
  }

  @media (max-width: 430px) {
    [data-ready='false'] {
      transform: translateY(-50px);
    }
  }
`;
var JQ = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let yV = class extends be {
  constructor() {
    super(), this.bodyObserver = void 0, this.unsubscribe = [], this.iframe = document.getElementById("w3m-iframe"), this.ready = !1, this.unsubscribe.push(bn.subscribeKey("open", (e) => {
      e || this.onHideIframe();
    }));
  }
  disconnectedCallback() {
    var e;
    this.unsubscribe.forEach((n) => n()), (e = this.bodyObserver) == null || e.unobserve(window.document.body);
  }
  firstUpdated() {
    this.iframe.style.display = "block";
    const r = this.renderRoot.querySelector("div");
    this.bodyObserver = new ResizeObserver(() => {
      const a = (r == null ? void 0 : r.getBoundingClientRect()) ?? { left: 0, top: 0, width: 0, height: 0 };
      this.iframe.style.width = `${a.width - 24}px`, this.iframe.style.height = `${a.height - 10}px`, this.iframe.style.left = `${a.left + 24 / 2}px`, this.iframe.style.top = `${a.top + 10 / 2}px`, this.ready = !0;
    }), this.bodyObserver.observe(window.document.body);
  }
  render() {
    return this.ready && this.onShowIframe(), _`<div data-ready=${this.ready}></div>`;
  }
  onShowIframe() {
    const e = window.innerWidth <= 430;
    this.iframe.animate([
      { opacity: 0, transform: e ? "translateY(50px)" : "scale(.95)" },
      { opacity: 1, transform: e ? "translateY(0)" : "scale(1)" }
    ], { duration: 200, easing: "ease", fill: "forwards", delay: 300 });
  }
  async onHideIframe() {
    await this.iframe.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 200,
      easing: "ease",
      fill: "forwards"
    }).finished, this.iframe.style.display = "none";
  }
};
yV.styles = Kde;
JQ([
  Ke()
], yV.prototype, "ready", void 0);
yV = JQ([
  Ze("w3m-approve-transaction-view")
], yV);
var $de = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let f4 = class extends be {
  render() {
    return _`
      <wui-flex flexDirection="column" alignItems="center" gap="xl" padding="xl">
        <wui-text variant="paragraph-400" color="fg-100">Follow the instructions on</wui-text>
        <wui-chip
          icon="externalLink"
          variant="fill"
          href=${od.SECURE_SITE_DASHBOARD}
          imageSrc=${od.SECURE_SITE_FAVICON}
        >
        </wui-chip>
        <wui-text variant="small-400" color="fg-200">
          You will have to reconnect for security reasons
        </wui-text>
      </wui-flex>
    `;
  }
};
f4 = $de([
  Ze("w3m-upgrade-wallet-view")
], f4);
const qde = ze`
  wui-grid {
    max-height: clamp(360px, 400px, 80vh);
    overflow: scroll;
    scrollbar-width: none;
    grid-auto-rows: min-content;
    grid-template-columns: repeat(auto-fill, 76px);
  }

  @media (max-width: 435px) {
    wui-grid {
      grid-template-columns: repeat(auto-fill, 77px);
    }
  }

  wui-grid[data-scroll='false'] {
    overflow: hidden;
  }

  wui-grid::-webkit-scrollbar {
    display: none;
  }

  wui-loading-spinner {
    padding-top: var(--wui-spacing-l);
    padding-bottom: var(--wui-spacing-l);
    justify-content: center;
    grid-column: 1 / span 4;
  }
`;
function BQ(t) {
  const { connectors: e } = or.state, n = e.filter((a) => a.type === "ANNOUNCED").reduce((a, o) => {
    var s;
    return (s = o.info) != null && s.rdns && (a[o.info.rdns] = !0), a;
  }, {});
  return t.map((a) => ({
    ...a,
    installed: !!a.rdns && !!n[a.rdns ?? ""]
  })).sort((a, o) => Number(o.installed) - Number(a.installed));
}
var im = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
const V4 = "local-paginator";
let Jd = class extends be {
  constructor() {
    super(), this.unsubscribe = [], this.paginationObserver = void 0, this.initial = !Gt.state.wallets.length, this.wallets = Gt.state.wallets, this.recommended = Gt.state.recommended, this.featured = Gt.state.featured, this.unsubscribe.push(Gt.subscribeKey("wallets", (e) => this.wallets = e), Gt.subscribeKey("recommended", (e) => this.recommended = e), Gt.subscribeKey("featured", (e) => this.featured = e));
  }
  firstUpdated() {
    this.initialFetch(), this.createPaginationObserver();
  }
  disconnectedCallback() {
    var e;
    this.unsubscribe.forEach((n) => n()), (e = this.paginationObserver) == null || e.disconnect();
  }
  render() {
    return _`
      <wui-grid
        data-scroll=${!this.initial}
        .padding=${["0", "s", "s", "s"]}
        columnGap="xxs"
        rowGap="l"
        justifyContent="space-between"
      >
        ${this.initial ? this.shimmerTemplate(16) : this.walletsTemplate()}
        ${this.paginationLoaderTemplate()}
      </wui-grid>
    `;
  }
  async initialFetch() {
    var n;
    const e = (n = this.shadowRoot) == null ? void 0 : n.querySelector("wui-grid");
    this.initial && e && (await Gt.fetchWallets({ page: 1 }), await e.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 200,
      fill: "forwards",
      easing: "ease"
    }).finished, this.initial = !1, e.animate([{ opacity: 0 }, { opacity: 1 }], {
      duration: 200,
      fill: "forwards",
      easing: "ease"
    }));
  }
  shimmerTemplate(e, n) {
    return [...Array(e)].map(() => _`
        <wui-card-select-loader type="wallet" id=${Ft(n)}></wui-card-select-loader>
      `);
  }
  walletsTemplate() {
    const e = [...this.featured, ...this.recommended, ...this.wallets];
    return BQ(e).map((r) => _`
        <wui-card-select
          imageSrc=${Ft(qn.getWalletImage(r))}
          type="wallet"
          name=${r.name}
          @click=${() => this.onConnectWallet(r)}
          .installed=${r.installed}
        ></wui-card-select>
      `);
  }
  paginationLoaderTemplate() {
    const { wallets: e, recommended: n, featured: r, count: i } = Gt.state, a = window.innerWidth < 352 ? 3 : 4, o = e.length + n.length;
    let l = Math.ceil(o / a) * a - o + a;
    return l -= e.length ? r.length % a : 0, i === 0 && r.length > 0 ? null : i === 0 || [...r, ...e, ...n].length < i ? this.shimmerTemplate(l, V4) : null;
  }
  createPaginationObserver() {
    var n;
    const e = (n = this.shadowRoot) == null ? void 0 : n.querySelector(`#${V4}`);
    e && (this.paginationObserver = new IntersectionObserver(([r]) => {
      if (r != null && r.isIntersecting && !this.initial) {
        const { page: i, count: a, wallets: o } = Gt.state;
        o.length < a && Gt.fetchWallets({ page: i + 1 });
      }
    }), this.paginationObserver.observe(e));
  }
  onConnectWallet(e) {
    const { connectors: n } = or.state, r = n.find(({ explorerId: i }) => i === e.id);
    r ? tt.push("ConnectingExternal", { connector: r }) : tt.push("ConnectingWalletConnect", { wallet: e });
  }
};
Jd.styles = qde;
im([
  Ke()
], Jd.prototype, "initial", void 0);
im([
  Ke()
], Jd.prototype, "wallets", void 0);
im([
  Ke()
], Jd.prototype, "recommended", void 0);
im([
  Ke()
], Jd.prototype, "featured", void 0);
Jd = im([
  Ze("w3m-all-wallets-list")
], Jd);
const eue = ze`
  wui-grid,
  wui-loading-spinner,
  wui-flex {
    height: 360px;
  }

  wui-grid {
    overflow: scroll;
    scrollbar-width: none;
    grid-auto-rows: min-content;
  }

  wui-grid[data-scroll='false'] {
    overflow: hidden;
  }

  wui-grid::-webkit-scrollbar {
    display: none;
  }

  wui-loading-spinner {
    justify-content: center;
    align-items: center;
  }
`;
var bS = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let ZM = class extends be {
  constructor() {
    super(...arguments), this.prevQuery = "", this.loading = !0, this.query = "";
  }
  render() {
    return this.onSearch(), this.loading ? _`<wui-loading-spinner color="accent-100"></wui-loading-spinner>` : this.walletsTemplate();
  }
  async onSearch() {
    this.query !== this.prevQuery && (this.prevQuery = this.query, this.loading = !0, await Gt.searchWallet({ search: this.query }), this.loading = !1);
  }
  walletsTemplate() {
    const { search: e } = Gt.state, n = BQ(e);
    return e.length ? _`
      <wui-grid
        .padding=${["0", "s", "s", "s"]}
        gridTemplateColumns="repeat(4, 1fr)"
        rowGap="l"
        columnGap="xs"
      >
        ${n.map((r) => _`
            <wui-card-select
              imageSrc=${Ft(qn.getWalletImage(r))}
              type="wallet"
              name=${r.name}
              @click=${() => this.onConnectWallet(r)}
              .installed=${r.installed}
            ></wui-card-select>
          `)}
      </wui-grid>
    ` : _`
        <wui-flex justifyContent="center" alignItems="center" gap="s" flexDirection="column">
          <wui-icon-box
            size="lg"
            iconColor="fg-200"
            backgroundColor="fg-300"
            icon="wallet"
            background="transparent"
          ></wui-icon-box>
          <wui-text color="fg-200" variant="paragraph-500">No Wallet found</wui-text>
        </wui-flex>
      `;
  }
  onConnectWallet(e) {
    const { connectors: n } = or.state, r = n.find(({ explorerId: i }) => i === e.id);
    r ? tt.push("ConnectingExternal", { connector: r }) : tt.push("ConnectingWalletConnect", { wallet: e });
  }
};
ZM.styles = eue;
bS([
  Ke()
], ZM.prototype, "loading", void 0);
bS([
  te()
], ZM.prototype, "query", void 0);
ZM = bS([
  Ze("w3m-all-wallets-search")
], ZM);
var yU = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let bM = class extends be {
  constructor() {
    super(), this.platformTabs = [], this.unsubscribe = [], this.platforms = [], this.onSelectPlatfrom = void 0, this.buffering = !1, this.unsubscribe.push(Ht.subscribeKey("buffering", (e) => this.buffering = e));
  }
  disconnectCallback() {
    this.unsubscribe.forEach((e) => e());
  }
  render() {
    const e = this.generateTabs();
    return _`
      <wui-flex justifyContent="center" .padding=${["l", "0", "0", "0"]}>
        <wui-tabs
          ?disabled=${this.buffering}
          .tabs=${e}
          .onTabChange=${this.onTabChange.bind(this)}
        ></wui-tabs>
      </wui-flex>
    `;
  }
  generateTabs() {
    const e = this.platforms.map((n) => n === "browser" ? { label: "Browser", icon: "extension", platform: "browser" } : n === "mobile" ? { label: "Mobile", icon: "mobile", platform: "mobile" } : n === "qrcode" ? { label: "Mobile", icon: "mobile", platform: "qrcode" } : n === "web" ? { label: "Webapp", icon: "browser", platform: "web" } : n === "desktop" ? { label: "Desktop", icon: "desktop", platform: "desktop" } : { label: "Browser", icon: "extension", platform: "unsupported" });
    return this.platformTabs = e.map(({ platform: n }) => n), e;
  }
  onTabChange(e) {
    var r;
    const n = this.platformTabs[e];
    n && ((r = this.onSelectPlatfrom) == null || r.call(this, n));
  }
};
yU([
  te({ type: Array })
], bM.prototype, "platforms", void 0);
yU([
  te()
], bM.prototype, "onSelectPlatfrom", void 0);
yU([
  Ke()
], bM.prototype, "buffering", void 0);
bM = yU([
  Ze("w3m-connecting-header")
], bM);
var tue = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let U4 = class extends Gi {
  constructor() {
    if (super(), !this.wallet)
      throw new Error("w3m-connecting-wc-browser: No wallet provided");
    this.onConnect = this.onConnectProxy.bind(this), this.onAutoConnect = this.onConnectProxy.bind(this), _t.sendEvent({
      type: "track",
      event: "SELECT_WALLET",
      properties: { name: this.wallet.name, platform: "browser" }
    });
  }
  async onConnectProxy() {
    try {
      this.error = !1;
      const { connectors: e } = or.state, n = e.find((i) => {
        var a, o;
        return i.type === "ANNOUNCED" && ((a = i.info) == null ? void 0 : a.rdns) === ((o = this.wallet) == null ? void 0 : o.rdns);
      }), r = e.find((i) => i.type === "INJECTED");
      n ? await Ht.connectExternal(n) : r && await Ht.connectExternal(r), bn.close(), _t.sendEvent({
        type: "track",
        event: "CONNECT_SUCCESS",
        properties: { method: "browser" }
      });
    } catch (e) {
      _t.sendEvent({
        type: "track",
        event: "CONNECT_ERROR",
        properties: { message: (e == null ? void 0 : e.message) ?? "Unknown" }
      }), this.error = !0;
    }
  }
};
U4 = tue([
  Ze("w3m-connecting-wc-browser")
], U4);
var nue = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let R4 = class extends Gi {
  constructor() {
    if (super(), !this.wallet)
      throw new Error("w3m-connecting-wc-desktop: No wallet provided");
    this.onConnect = this.onConnectProxy.bind(this), this.onRender = this.onRenderProxy.bind(this), _t.sendEvent({
      type: "track",
      event: "SELECT_WALLET",
      properties: { name: this.wallet.name, platform: "desktop" }
    });
  }
  onRenderProxy() {
    !this.ready && this.uri && (this.ready = !0, this.timeout = setTimeout(() => {
      var e;
      (e = this.onConnect) == null || e.call(this);
    }, 200));
  }
  onConnectProxy() {
    var e;
    if ((e = this.wallet) != null && e.desktop_link && this.uri)
      try {
        this.error = !1;
        const { desktop_link: n, name: r } = this.wallet, { redirect: i, href: a } = st.formatNativeUrl(n, this.uri);
        Ht.setWcLinking({ name: r, href: a }), Ht.setRecentWallet(this.wallet), st.openHref(i, "_self");
      } catch {
        this.error = !0;
      }
  }
};
R4 = nue([
  Ze("w3m-connecting-wc-desktop")
], R4);
var rue = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let g4 = class extends Gi {
  constructor() {
    if (super(), !this.wallet)
      throw new Error("w3m-connecting-wc-mobile: No wallet provided");
    this.onConnect = this.onConnectProxy.bind(this), this.onRender = this.onRenderProxy.bind(this), document.addEventListener("visibilitychange", this.onBuffering.bind(this)), _t.sendEvent({
      type: "track",
      event: "SELECT_WALLET",
      properties: { name: this.wallet.name, platform: "mobile" }
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("visibilitychange", this.onBuffering.bind(this));
  }
  onRenderProxy() {
    var e;
    !this.ready && this.uri && (this.ready = !0, (e = this.onConnect) == null || e.call(this));
  }
  onConnectProxy() {
    var e;
    if ((e = this.wallet) != null && e.mobile_link && this.uri)
      try {
        this.error = !1;
        const { mobile_link: n, name: r } = this.wallet, { redirect: i, href: a } = st.formatNativeUrl(n, this.uri);
        Ht.setWcLinking({ name: r, href: a }), Ht.setRecentWallet(this.wallet), st.openHref(i, "_self");
      } catch {
        this.error = !0;
      }
  }
  onBuffering() {
    const e = st.isIos();
    (document == null ? void 0 : document.visibilityState) === "visible" && !this.error && e && (Ht.setBuffering(!0), setTimeout(() => {
      Ht.setBuffering(!1);
    }, 5e3));
  }
};
g4 = rue([
  Ze("w3m-connecting-wc-mobile")
], g4);
const iue = ze`
  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  wui-shimmer {
    width: 100%;
    aspect-ratio: 1 / 1;
    border-radius: clamp(0px, var(--wui-border-radius-l), 40px) !important;
  }

  wui-qr-code {
    opacity: 0;
    animation-duration: 200ms;
    animation-timing-function: ease;
    animation-name: fadein;
    animation-fill-mode: forwards;
  }
`;
var aue = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let Nb = class extends Gi {
  constructor() {
    var e;
    super(), this.forceUpdate = () => {
      this.requestUpdate();
    }, window.addEventListener("resize", this.forceUpdate), _t.sendEvent({
      type: "track",
      event: "SELECT_WALLET",
      properties: { name: ((e = this.wallet) == null ? void 0 : e.name) ?? "WalletConnect", platform: "qrcode" }
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback(), window.removeEventListener("resize", this.forceUpdate);
  }
  render() {
    return this.onRenderProxy(), _`
      <wui-flex padding="xl" flexDirection="column" gap="xl" alignItems="center">
        <wui-shimmer borderRadius="l" width="100%"> ${this.qrCodeTemplate()} </wui-shimmer>

        <wui-text variant="paragraph-500" color="fg-100">
          Scan this QR Code with your phone
        </wui-text>
        ${this.copyTemplate()}
      </wui-flex>

      <w3m-mobile-download-links .wallet=${this.wallet}></w3m-mobile-download-links>
    `;
  }
  onRenderProxy() {
    !this.ready && this.uri && (this.timeout = setTimeout(() => {
      this.ready = !0;
    }, 200));
  }
  qrCodeTemplate() {
    if (!this.uri || !this.ready)
      return null;
    const e = this.getBoundingClientRect().width - 40, n = this.wallet ? this.wallet.name : void 0;
    return Ht.setWcLinking(void 0), Ht.setRecentWallet(this.wallet), _` <wui-qr-code
      size=${e}
      theme=${pa.state.themeMode}
      uri=${this.uri}
      imageSrc=${Ft(qn.getWalletImage(this.wallet))}
      alt=${Ft(n)}
    ></wui-qr-code>`;
  }
  copyTemplate() {
    const e = !this.uri || !this.ready;
    return _`<wui-link .disabled=${e} @click=${this.onCopyUri} color="fg-200">
      <wui-icon size="xs" color="fg-200" slot="iconLeft" name="copy"></wui-icon>
      Copy link
    </wui-link>`;
  }
};
Nb.styles = iue;
Nb = aue([
  Ze("w3m-connecting-wc-qrcode")
], Nb);
const oue = ze`
  :host {
    display: flex;
    justify-content: center;
    gap: var(--wui-spacing-2xl);
  }

  wui-visual-thumbnail:nth-child(1) {
    z-index: 1;
  }
`;
var sue = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let Mb = class extends be {
  constructor() {
    var e;
    super(...arguments), this.dappImageUrl = (e = dn.state.metadata) == null ? void 0 : e.icons, this.walletImageUrl = Si.getConnectedWalletImageUrl();
  }
  firstUpdated() {
    var n;
    const e = (n = this.shadowRoot) == null ? void 0 : n.querySelectorAll("wui-visual-thumbnail");
    e != null && e[0] && this.createAnimation(e[0], "translate(18px)"), e != null && e[1] && this.createAnimation(e[1], "translate(-18px)");
  }
  render() {
    var e;
    return _`
      <wui-visual-thumbnail
        ?borderRadiusFull=${!0}
        .imageSrc=${(e = this.dappImageUrl) == null ? void 0 : e[0]}
      ></wui-visual-thumbnail>
      <wui-visual-thumbnail .imageSrc=${this.walletImageUrl}></wui-visual-thumbnail>
    `;
  }
  createAnimation(e, n) {
    e.animate([{ transform: "translateX(0px)" }, { transform: n }], {
      duration: 1600,
      easing: "cubic-bezier(0.56, 0, 0.48, 1)",
      direction: "alternate",
      iterations: 1 / 0
    });
  }
};
Mb.styles = oue;
Mb = sue([
  Ze("w3m-connecting-siwe")
], Mb);
var lue = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let y4 = class extends be {
  constructor() {
    var e;
    if (super(), this.wallet = (e = tt.state.data) == null ? void 0 : e.wallet, !this.wallet)
      throw new Error("w3m-connecting-wc-unsupported: No wallet provided");
    _t.sendEvent({
      type: "track",
      event: "SELECT_WALLET",
      properties: { name: this.wallet.name, platform: "browser" }
    });
  }
  render() {
    return _`
      <wui-flex
        flexDirection="column"
        alignItems="center"
        .padding=${["3xl", "xl", "xl", "xl"]}
        gap="xl"
      >
        <wui-wallet-image
          size="lg"
          imageSrc=${Ft(qn.getWalletImage(this.wallet))}
        ></wui-wallet-image>

        <wui-text variant="paragraph-500" color="fg-100">Not Detected</wui-text>
      </wui-flex>

      <w3m-mobile-download-links .wallet=${this.wallet}></w3m-mobile-download-links>
    `;
  }
};
y4 = lue([
  Ze("w3m-connecting-wc-unsupported")
], y4);
var cue = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let Z4 = class extends Gi {
  constructor() {
    if (super(), !this.wallet)
      throw new Error("w3m-connecting-wc-web: No wallet provided");
    this.onConnect = this.onConnectProxy.bind(this), this.secondaryBtnLabel = "Open", this.secondaryLabel = "Open and continue in a new browser tab", this.secondaryBtnIcon = "externalLink", _t.sendEvent({
      type: "track",
      event: "SELECT_WALLET",
      properties: { name: this.wallet.name, platform: "web" }
    });
  }
  onConnectProxy() {
    var e;
    if ((e = this.wallet) != null && e.webapp_link && this.uri)
      try {
        this.error = !1;
        const { webapp_link: n, name: r } = this.wallet, { redirect: i, href: a } = st.formatUniversalUrl(n, this.uri);
        Ht.setWcLinking({ name: r, href: a }), Ht.setRecentWallet(this.wallet), st.openHref(i, "_blank");
      } catch {
        this.error = !0;
      }
  }
};
Z4 = cue([
  Ze("w3m-connecting-wc-web")
], Z4);
const due = ze`
  wui-icon-link[data-hidden='true'] {
    opacity: 0 !important;
    pointer-events: none;
  }
`;
var ZU = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
function b4() {
  var i, a, o, s, l, c;
  const t = (a = (i = tt.state.data) == null ? void 0 : i.connector) == null ? void 0 : a.name, e = (s = (o = tt.state.data) == null ? void 0 : o.wallet) == null ? void 0 : s.name, n = (c = (l = tt.state.data) == null ? void 0 : l.network) == null ? void 0 : c.name, r = e ?? t;
  return {
    Connect: "Connect Wallet",
    Account: void 0,
    ConnectingExternal: r ?? "Connect Wallet",
    ConnectingWalletConnect: r ?? "WalletConnect",
    ConnectingSiwe: "Sign In",
    Networks: "Choose Network",
    SwitchNetwork: n ?? "Switch Network",
    AllWallets: "All Wallets",
    WhatIsANetwork: "What is a network?",
    WhatIsAWallet: "What is a wallet?",
    GetWallet: "Get a wallet",
    Downloads: r ? `Get ${r}` : "Downloads",
    EmailVerifyOtp: "Confirm Email",
    EmailVerifyDevice: "",
    ApproveTransaction: "Approve Transaction",
    Transactions: "Activity",
    UpgradeWallet: "Upgrade your Wallet"
  };
}
let fh = class extends be {
  constructor() {
    super(), this.unsubscribe = [], this.heading = b4()[tt.state.view], this.buffering = !1, this.showBack = !1, this.unsubscribe.push(tt.subscribeKey("view", (e) => {
      this.onViewChange(e), this.onHistoryChange();
    }), Ht.subscribeKey("buffering", (e) => this.buffering = e));
  }
  disconnectCallback() {
    this.unsubscribe.forEach((e) => e());
  }
  render() {
    return _`
      <wui-flex .padding=${this.getPadding()} justifyContent="space-between" alignItems="center">
        ${this.dynamicButtonTemplate()} ${this.titleTemplate()}
        <wui-icon-link
          ?disabled=${this.buffering}
          icon="close"
          @click=${this.onClose.bind(this)}
        ></wui-icon-link>
      </wui-flex>
      ${this.separatorTemplate()}
    `;
  }
  onWalletHelp() {
    _t.sendEvent({ type: "track", event: "CLICK_WALLET_HELP" }), tt.push("WhatIsAWallet");
  }
  async onClose() {
    ir.state.isSiweEnabled && ir.state.status !== "success" && await Ht.disconnect(), bn.close();
  }
  titleTemplate() {
    return _`<wui-text variant="paragraph-700" color="fg-100">${this.heading}</wui-text>`;
  }
  dynamicButtonTemplate() {
    const { view: e } = tt.state, n = e === "Connect", r = e === "ApproveTransaction";
    return this.showBack && !r ? _`<wui-icon-link
        id="dynamic"
        icon="chevronLeft"
        ?disabled=${this.buffering}
        @click=${this.onGoBack.bind(this)}
      ></wui-icon-link>` : _`<wui-icon-link
      data-hidden=${!n}
      id="dynamic"
      icon="helpCircle"
      @click=${this.onWalletHelp.bind(this)}
    ></wui-icon-link>`;
  }
  separatorTemplate() {
    return !this.heading || tt.state.view === "EmailVerifyDevice" ? null : _`<wui-separator></wui-separator>`;
  }
  getPadding() {
    return this.heading ? ["l", "2l", "l", "2l"] : ["l", "2l", "0", "2l"];
  }
  async onViewChange(e) {
    var r;
    const n = (r = this.shadowRoot) == null ? void 0 : r.querySelector("wui-text");
    if (n) {
      const i = b4()[e];
      await n.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 200,
        fill: "forwards",
        easing: "ease"
      }).finished, this.heading = i, n.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 200,
        fill: "forwards",
        easing: "ease"
      });
    }
  }
  async onHistoryChange() {
    var r;
    const { history: e } = tt.state, n = (r = this.shadowRoot) == null ? void 0 : r.querySelector("#dynamic");
    e.length > 1 && !this.showBack && n ? (await n.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 200,
      fill: "forwards",
      easing: "ease"
    }).finished, this.showBack = !0, n.animate([{ opacity: 0 }, { opacity: 1 }], {
      duration: 200,
      fill: "forwards",
      easing: "ease"
    })) : e.length <= 1 && this.showBack && n && (await n.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 200,
      fill: "forwards",
      easing: "ease"
    }).finished, this.showBack = !1, n.animate([{ opacity: 0 }, { opacity: 1 }], {
      duration: 200,
      fill: "forwards",
      easing: "ease"
    }));
  }
  onGoBack() {
    tt.state.view === "ConnectingSiwe" ? tt.push("Connect") : tt.goBack();
  }
};
fh.styles = [due];
ZU([
  Ke()
], fh.prototype, "heading", void 0);
ZU([
  Ke()
], fh.prototype, "buffering", void 0);
ZU([
  Ke()
], fh.prototype, "showBack", void 0);
fh = ZU([
  Ze("w3m-header")
], fh);
var AQ = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let pb = class extends be {
  constructor() {
    super(...arguments), this.data = [];
  }
  render() {
    return _`
      <wui-flex flexDirection="column" alignItems="center" gap="l">
        ${this.data.map((e) => _`
            <wui-flex flexDirection="column" alignItems="center" gap="xl">
              <wui-flex flexDirection="row" justifyContent="center" gap="1xs">
                ${e.images.map((n) => _`<wui-visual name=${n}></wui-visual>`)}
              </wui-flex>
            </wui-flex>
            <wui-flex flexDirection="column" alignItems="center" gap="xxs">
              <wui-text variant="paragraph-500" color="fg-100" align="center">
                ${e.title}
              </wui-text>
              <wui-text variant="small-500" color="fg-200" align="center">${e.text}</wui-text>
            </wui-flex>
          `)}
      </wui-flex>
    `;
  }
};
AQ([
  te({ type: Array })
], pb.prototype, "data", void 0);
pb = AQ([
  Ze("w3m-help-widget")
], pb);
const uue = ze`
  wui-flex {
    background-color: var(--wui-gray-glass-005);
  }

  a {
    text-decoration: none;
    color: var(--wui-color-fg-175);
    font-weight: 500;
  }
`;
var hue = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let mb = class extends be {
  render() {
    const { termsConditionsUrl: e, privacyPolicyUrl: n } = dn.state;
    return !e && !n ? null : _`
      <wui-flex .padding=${["m", "s", "s", "s"]} justifyContent="center">
        <wui-text color="fg-250" variant="small-400" align="center">
          By connecting your wallet, you agree to our <br />
          ${this.termsTemplate()} ${this.andTemplate()} ${this.privacyTemplate()}
        </wui-text>
      </wui-flex>
    `;
  }
  andTemplate() {
    const { termsConditionsUrl: e, privacyPolicyUrl: n } = dn.state;
    return e && n ? "and" : "";
  }
  termsTemplate() {
    const { termsConditionsUrl: e } = dn.state;
    return e ? _`<a href=${e}>Terms of Service</a>` : null;
  }
  privacyTemplate() {
    const { privacyPolicyUrl: e } = dn.state;
    return e ? _`<a href=${e}>Privacy Policy</a>` : null;
  }
};
mb.styles = [uue];
mb = hue([
  Ze("w3m-legal-footer")
], mb);
const Nue = ze`
  :host {
    display: block;
    padding: 0 var(--wui-spacing-xl) var(--wui-spacing-xl);
  }
`;
var HQ = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let ZV = class extends be {
  constructor() {
    super(...arguments), this.wallet = void 0;
  }
  render() {
    if (!this.wallet)
      return this.style.display = "none", null;
    const { name: e, app_store: n, play_store: r, chrome_store: i, homepage: a } = this.wallet, o = st.isMobile(), s = st.isIos(), l = st.isAndroid(), c = [n, r, a, i].filter(Boolean).length > 1, d = yn.getTruncateString({
      string: e,
      charsStart: 12,
      charsEnd: 0,
      truncate: "end"
    });
    return c && !o ? _`
        <wui-cta-button
          label=${`Don't have ${d}?`}
          buttonLabel="Get"
          @click=${() => tt.push("Downloads", { wallet: this.wallet })}
        ></wui-cta-button>
      ` : !c && a ? _`
        <wui-cta-button
          label=${`Don't have ${d}?`}
          buttonLabel="Get"
          @click=${this.onHomePage.bind(this)}
        ></wui-cta-button>
      ` : n && s ? _`
        <wui-cta-button
          label=${`Don't have ${d}?`}
          buttonLabel="Get"
          @click=${this.onAppStore.bind(this)}
        ></wui-cta-button>
      ` : r && l ? _`
        <wui-cta-button
          label=${`Don't have ${d}?`}
          buttonLabel="Get"
          @click=${this.onPlayStore.bind(this)}
        ></wui-cta-button>
      ` : (this.style.display = "none", null);
  }
  onAppStore() {
    var e;
    (e = this.wallet) != null && e.app_store && st.openHref(this.wallet.app_store, "_blank");
  }
  onPlayStore() {
    var e;
    (e = this.wallet) != null && e.play_store && st.openHref(this.wallet.play_store, "_blank");
  }
  onHomePage() {
    var e;
    (e = this.wallet) != null && e.homepage && st.openHref(this.wallet.homepage, "_blank");
  }
};
ZV.styles = [Nue];
HQ([
  te({ type: Object })
], ZV.prototype, "wallet", void 0);
ZV = HQ([
  Ze("w3m-mobile-download-links")
], ZV);
const Mue = ze`
  :host {
    display: block;
    position: absolute;
    opacity: 0;
    pointer-events: none;
    top: 11px;
    left: 50%;
    width: max-content;
  }
`;
var XQ = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
const pue = {
  success: {
    backgroundColor: "success-100",
    iconColor: "success-100",
    icon: "checkmark"
  },
  error: {
    backgroundColor: "error-100",
    iconColor: "error-100",
    icon: "close"
  }
};
let bV = class extends be {
  constructor() {
    super(), this.unsubscribe = [], this.timeout = void 0, this.open = Vr.state.open, this.unsubscribe.push(Vr.subscribeKey("open", (e) => {
      this.open = e, this.onOpen();
    }));
  }
  disconnectedCallback() {
    clearTimeout(this.timeout), this.unsubscribe.forEach((e) => e());
  }
  render() {
    const { message: e, variant: n } = Vr.state, r = pue[n];
    return _`
      <wui-snackbar
        message=${e}
        backgroundColor=${r.backgroundColor}
        iconColor=${r.iconColor}
        icon=${r.icon}
      ></wui-snackbar>
    `;
  }
  onOpen() {
    clearTimeout(this.timeout), this.open ? (this.animate([
      { opacity: 0, transform: "translateX(-50%) scale(0.85)" },
      { opacity: 1, transform: "translateX(-50%) scale(1)" }
    ], {
      duration: 150,
      fill: "forwards",
      easing: "ease"
    }), this.timeout = setTimeout(() => Vr.hide(), 2500)) : this.animate([
      { opacity: 1, transform: "translateX(-50%) scale(1)" },
      { opacity: 0, transform: "translateX(-50%) scale(0.85)" }
    ], {
      duration: 150,
      fill: "forwards",
      easing: "ease"
    });
  }
};
bV.styles = Mue;
XQ([
  Ke()
], bV.prototype, "open", void 0);
bV = XQ([
  Ze("w3m-snackbar")
], bV);
const mue = ze`
  :host {
    padding: var(--wui-spacing-3xs) 0;
  }

  wui-separator {
    margin: var(--wui-spacing-s) calc(var(--wui-spacing-s) * -1);
    width: calc(100% + var(--wui-spacing-s) * 2);
  }

  wui-email-input {
    width: 100%;
  }

  form {
    width: 100%;
    display: block;
    position: relative;
    margin-bottom: var(--wui-spacing-m);
  }

  wui-icon-link,
  wui-loading-spinner {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  wui-icon-link {
    right: var(--wui-spacing-xs);
  }

  wui-loading-spinner {
    right: var(--wui-spacing-m);
  }
`;
var bU = globalThis && globalThis.__decorate || function(t, e, n, r) {
  var i = arguments.length, a = i < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(t, e, n, r);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, n, a) : o(e, n)) || a);
  return i > 3 && a && Object.defineProperty(e, n, a), a;
};
let Vh = class extends be {
  constructor() {
    super(), this.unsubscribe = [], this.formRef = uS(), this.connectors = or.state.connectors, this.email = "", this.loading = !1, this.unsubscribe.push(or.subscribeKey("connectors", (e) => this.connectors = e));
  }
  disconnectedCallback() {
    this.unsubscribe.forEach((e) => e());
  }
  firstUpdated() {
    var e;
    (e = this.formRef.value) == null || e.addEventListener("keydown", (n) => {
      n.key === "Enter" && this.onSubmitEmail(n);
    });
  }
  render() {
    const e = this.connectors.length > 1, n = this.connectors.find((i) => i.type === "EMAIL"), r = !this.loading && this.email.length > 3;
    return n ? _`
      <form ${hS(this.formRef)} @submit=${this.onSubmitEmail.bind(this)}>
        <wui-email-input
          .disabled=${this.loading}
          @inputChange=${this.onEmailInputChange.bind(this)}
        >
        </wui-email-input>

        ${r && e ? _`
              <wui-icon-link
                size="sm"
                icon="chevronRight"
                iconcolor="accent-100"
                @click=${this.onSubmitEmail.bind(this)}
              >
              </wui-icon-link>
            ` : null}
        ${this.loading && e ? _`<wui-loading-spinner size="md" color="accent-100"></wui-loading-spinner>` : null}

        <input type="submit" hidden />
      </form>

      ${e ? _`<wui-separator text="or"></wui-separator>` : _`<wui-button
            size="md"
            variant="fill"
            fullWidth
            @click=${this.onSubmitEmail.bind(this)}
            .disabled=${!r}
            .loading=${this.loading}
          >
            Continue
          </wui-button>`}
    ` : null;
  }
  onEmailInputChange(e) {
    this.email = e.detail;
  }
  async onSubmitEmail(e) {
    try {
      if (this.loading)
        return;
      this.loading = !0, e.preventDefault();
      const n = or.getEmailConnector();
      if (!n)
        throw new Error("w3m-email-login-widget: Email connector not found");
      const { action: r } = await n.provider.connectEmail({ email: this.email });
      r === "VERIFY_OTP" ? tt.push("EmailVerifyOtp", { email: this.email }) : r === "VERIFY_DEVICE" && tt.push("EmailVerifyDevice", { email: this.email });
    } catch (n) {
      Vr.showError(n);
    } finally {
      this.loading = !1;
    }
  }
};
Vh.styles = mue;
bU([
  Ke()
], Vh.prototype, "connectors", void 0);
bU([
  Ke()
], Vh.prototype, "email", void 0);
bU([
  Ke()
], Vh.prototype, "loading", void 0);
Vh = bU([
  Ze("w3m-email-login-widget")
], Vh);
let E4 = !1;
class Tue {
  constructor(e) {
    this.initPromise = void 0, this.setIsConnected = (n) => {
      en.setIsConnected(n);
    }, this.setCaipAddress = (n) => {
      en.setCaipAddress(n);
    }, this.setBalance = (n, r) => {
      en.setBalance(n, r);
    }, this.setProfileName = (n) => {
      en.setProfileName(n);
    }, this.setProfileImage = (n) => {
      en.setProfileImage(n);
    }, this.resetAccount = () => {
      en.resetAccount();
    }, this.setCaipNetwork = (n) => {
      er.setCaipNetwork(n);
    }, this.getCaipNetwork = () => er.state.caipNetwork, this.setRequestedCaipNetworks = (n) => {
      er.setRequestedCaipNetworks(n);
    }, this.getApprovedCaipNetworksData = () => er.getApprovedCaipNetworksData(), this.resetNetwork = () => {
      er.resetNetwork();
    }, this.setConnectors = (n) => {
      or.setConnectors(n);
    }, this.addConnector = (n) => {
      or.addConnector(n);
    }, this.getConnectors = () => or.getConnectors(), this.resetWcConnection = () => {
      Ht.resetWcConnection();
    }, this.fetchIdentity = (n) => AY.fetchIdentity(n), this.setAddressExplorerUrl = (n) => {
      en.setAddressExplorerUrl(n);
    }, this.setSIWENonce = (n) => {
      ir.setNonce(n);
    }, this.setSIWESession = (n) => {
      ir.setSession(n);
    }, this.setSIWEStatus = (n) => {
      ir.setStatus(n);
    }, this.setSIWEMessage = (n) => {
      ir.setMessage(n);
    }, this.initControllers(e), this.initOrContinue();
  }
  async open(e) {
    await this.initOrContinue(), bn.open(e);
  }
  async close() {
    await this.initOrContinue(), bn.close();
  }
  setLoading(e) {
    bn.setLoading(e);
  }
  getThemeMode() {
    return pa.state.themeMode;
  }
  getThemeVariables() {
    return pa.state.themeVariables;
  }
  setThemeMode(e) {
    pa.setThemeMode(e), tQ(pa.state.themeMode);
  }
  setThemeVariables(e) {
    pa.setThemeVariables(e), ose(pa.state.themeVariables);
  }
  subscribeTheme(e) {
    return pa.subscribe(e);
  }
  getState() {
    return { ...ih.state };
  }
  subscribeState(e) {
    return ih.subscribe(e);
  }
  getEvent() {
    return { ..._t.state };
  }
  subscribeEvents(e) {
    return _t.subscribe(e);
  }
  subscribeSIWEState(e) {
    return ir.subscribe(e);
  }
  initControllers(e) {
    if (er.setClient(e.networkControllerClient), er.setDefaultCaipNetwork(e.defaultChain), dn.setProjectId(e.projectId), dn.setIncludeWalletIds(e.includeWalletIds), dn.setExcludeWalletIds(e.excludeWalletIds), dn.setFeaturedWalletIds(e.featuredWalletIds), dn.setTokens(e.tokens), dn.setTermsConditionsUrl(e.termsConditionsUrl), dn.setPrivacyPolicyUrl(e.privacyPolicyUrl), dn.setCustomWallets(e.customWallets), dn.setEnableAnalytics(e.enableAnalytics), dn.setSdkVersion(e._sdkVersion), Ht.setClient(e.connectionControllerClient), e.siweControllerClient) {
      const n = e.siweControllerClient;
      ir.setSIWEClient(n);
    }
    e.metadata && dn.setMetadata(e.metadata), e.themeMode && pa.setThemeMode(e.themeMode), e.themeVariables && pa.setThemeVariables(e.themeVariables);
  }
  async initOrContinue() {
    return !this.initPromise && !E4 && st.isClient() && (E4 = !0, this.initPromise = new Promise(async (e) => {
      await Promise.all([import("./index-6160210e.js"), Promise.resolve().then(() => Dde)]);
      const n = document.createElement("w3m-modal");
      document.body.insertAdjacentElement("beforeend", n), e();
    })), this.initPromise;
  }
}
const Ut = {
  WALLET_CONNECT_CONNECTOR_ID: "walletConnect",
  INJECTED_CONNECTOR_ID: "injected",
  COINBASE_CONNECTOR_ID: "coinbaseWallet",
  SAFE_CONNECTOR_ID: "safe",
  LEDGER_CONNECTOR_ID: "ledger",
  EIP6963_CONNECTOR_ID: "eip6963",
  EMAIL_CONNECTOR_ID: "w3mEmail",
  EIP155: "eip155",
  ADD_CHAIN_METHOD: "wallet_addEthereumChain",
  EIP6963_ANNOUNCE_EVENT: "eip6963:announceProvider",
  EIP6963_REQUEST_EVENT: "eip6963:requestProvider",
  VERSION: "3.5.1"
}, ss = {
  ConnectorExplorerIds: {
    [Ut.COINBASE_CONNECTOR_ID]: "fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa",
    [Ut.SAFE_CONNECTOR_ID]: "225affb176778569276e484e1b92637ad061b01e13a048b35a9d280c3b58970f",
    [Ut.LEDGER_CONNECTOR_ID]: "19177a98252e07ddfc9af2083ba8e07ef627cb6103467ffebb3f8f4205fd7927"
  },
  EIP155NetworkImageIds: {
    1: "692ed6ba-e569-459a-556a-776476829e00",
    42161: "600a9a04-c1b9-42ca-6785-9b4b6ff85200",
    43114: "30c46e53-e989-45fb-4549-be3bd4eb3b00",
    56: "93564157-2e8e-4ce7-81df-b264dbee9b00",
    250: "06b26297-fe0c-4733-5d6b-ffa5498aac00",
    10: "ab9c186a-c52f-464b-2906-ca59d760a400",
    137: "41d04d42-da3b-4453-8506-668cc0727900",
    100: "02b53f6a-e3d4-479e-1cb4-21178987d100",
    9001: "f926ff41-260d-4028-635e-91913fc28e00",
    324: "b310f07f-4ef7-49f3-7073-2a0a39685800",
    314: "5a73b3dd-af74-424e-cae0-0de859ee9400",
    4689: "34e68754-e536-40da-c153-6ef2e7188a00",
    1088: "3897a66d-40b9-4833-162f-a2c90531c900",
    1284: "161038da-44ae-4ec7-1208-0ea569454b00",
    1285: "f1d73bb6-5450-4e18-38f7-fb6484264a00",
    7777777: "845c60df-d429-4991-e687-91ae45791600",
    42220: "ab781bbc-ccc6-418d-d32d-789b15da1f00",
    8453: "7289c336-3981-4081-c5f4-efc26ac64a00",
    1313161554: "3ff73439-a619-4894-9262-4470c773a100"
  },
  ConnectorImageIds: {
    [Ut.COINBASE_CONNECTOR_ID]: "0c2840c3-5b04-4c44-9661-fbd4b49e1800",
    [Ut.SAFE_CONNECTOR_ID]: "461db637-8616-43ce-035a-d89b8a1d5800",
    [Ut.LEDGER_CONNECTOR_ID]: "54a1aa77-d202-4f8d-0fb2-5d2bb6db0300",
    [Ut.WALLET_CONNECT_CONNECTOR_ID]: "ef1a1fcf-7fe8-4d69-bd6d-fda1345b4400",
    [Ut.INJECTED_CONNECTOR_ID]: "07ba87ed-43aa-4adf-4540-9e6a2b9cae00"
  },
  ConnectorNamesMap: {
    [Ut.INJECTED_CONNECTOR_ID]: "Browser Wallet",
    [Ut.WALLET_CONNECT_CONNECTOR_ID]: "WalletConnect",
    [Ut.COINBASE_CONNECTOR_ID]: "Coinbase",
    [Ut.LEDGER_CONNECTOR_ID]: "Ledger",
    [Ut.SAFE_CONNECTOR_ID]: "Safe"
  },
  ConnectorTypesMap: {
    [Ut.INJECTED_CONNECTOR_ID]: "INJECTED",
    [Ut.WALLET_CONNECT_CONNECTOR_ID]: "WALLET_CONNECT",
    [Ut.EIP6963_CONNECTOR_ID]: "ANNOUNCED",
    [Ut.EMAIL_CONNECTOR_ID]: "EMAIL"
  },
  WalletConnectRpcChainIds: [
    1,
    5,
    11155111,
    10,
    420,
    42161,
    421613,
    137,
    80001,
    42220,
    1313161554,
    1313161555,
    56,
    97,
    43114,
    43113,
    100,
    8453,
    84531,
    7777777,
    999,
    324,
    280
  ]
}, Iu = {
  caipNetworkIdToNumber(t) {
    return t ? Number(t.split(":")[1]) : void 0;
  },
  getCaipTokens(t) {
    if (!t)
      return;
    const e = {};
    return Object.entries(t).forEach(([n, r]) => {
      e[`${Ut.EIP155}:${n}`] = r;
    }), e;
  }
};
function fue(t) {
  if (t)
    return {
      id: `${Ut.EIP155}:${t.id}`,
      name: t.name,
      imageId: ss.EIP155NetworkImageIds[t.id]
    };
}
const Vue = "wagmi.wallet";
class Uue extends Tue {
  constructor(e) {
    const { wagmiConfig: n, siweConfig: r, chains: i, defaultChain: a, tokens: o, _sdkVersion: s, ...l } = e;
    if (!n)
      throw new Error("web3modal:constructor - wagmiConfig is undefined");
    if (!l.projectId)
      throw new Error("web3modal:constructor - projectId is undefined");
    const c = {
      switchCaipNetwork: async (u) => {
        const h = Iu.caipNetworkIdToNumber(u == null ? void 0 : u.id);
        h && await TO({ chainId: h });
      },
      async getApprovedCaipNetworksData() {
        var h, N, M, p;
        const u = localStorage.getItem(Vue);
        if (u != null && u.includes(Ut.EMAIL_CONNECTOR_ID))
          return {
            supportsAllNetworks: !1,
            approvedCaipNetworkIds: ss.WalletConnectRpcChainIds.map((m) => `${Ut.EIP155}:${m}`)
          };
        if (u != null && u.includes(Ut.WALLET_CONNECT_CONNECTOR_ID)) {
          const m = n.connectors.find((y) => y.id === Ut.WALLET_CONNECT_CONNECTOR_ID);
          if (!m)
            throw new Error("networkControllerClient:getApprovedCaipNetworks - connector is undefined");
          const V = (N = (h = (await m.getProvider()).signer) == null ? void 0 : h.session) == null ? void 0 : N.namespaces, U = (M = V == null ? void 0 : V[Ut.EIP155]) == null ? void 0 : M.methods, g = (p = V == null ? void 0 : V[Ut.EIP155]) == null ? void 0 : p.chains;
          return {
            supportsAllNetworks: U == null ? void 0 : U.includes(Ut.ADD_CHAIN_METHOD),
            approvedCaipNetworkIds: g
          };
        }
        return { approvedCaipNetworkIds: void 0, supportsAllNetworks: !0 };
      }
    }, d = {
      connectWalletConnect: async (u) => {
        var M;
        const h = n.connectors.find((p) => p.id === Ut.WALLET_CONNECT_CONNECTOR_ID);
        if (!h)
          throw new Error("connectionControllerClient:getWalletConnectUri - connector is undefined");
        h.on("message", (p) => {
          p.type === "display_uri" && (u(p.data), h.removeAllListeners());
        });
        const N = Iu.caipNetworkIdToNumber((M = this.getCaipNetwork()) == null ? void 0 : M.id);
        await yZ({ connector: h, chainId: N });
      },
      connectExternal: async ({ id: u, provider: h, info: N }) => {
        var m, R;
        const M = n.connectors.find((V) => V.id === u);
        if (!M)
          throw new Error("connectionControllerClient:connectExternal - connector is undefined");
        h && N && M.id === Ut.EIP6963_CONNECTOR_ID && ((m = M.setEip6963Wallet) == null || m.call(M, { provider: h, info: N }));
        const p = Iu.caipNetworkIdToNumber((R = this.getCaipNetwork()) == null ? void 0 : R.id);
        await yZ({ connector: M, chainId: p });
      },
      checkInstalled: (u) => {
        const h = this.getConnectors().filter((M) => M.type === "ANNOUNCED"), N = this.getConnectors().find((M) => M.type === "INJECTED");
        return u ? h.length && u.some((p) => h.some((m) => {
          var R;
          return ((R = m.info) == null ? void 0 : R.rdns) === p;
        })) ? !0 : N && window != null && window.ethereum ? u.some((M) => {
          var p;
          return !!((p = window.ethereum) != null && p[String(M)]);
        }) : !1 : !!window.ethereum;
      },
      disconnect: async () => {
        var u;
        await MO(), (u = r == null ? void 0 : r.options) != null && u.signOutOnDisconnect && await r.signOut();
      },
      signMessage: async (u) => qq({ message: u })
    };
    super({
      networkControllerClient: c,
      connectionControllerClient: d,
      siweControllerClient: r,
      defaultChain: fue(a),
      tokens: Iu.getCaipTokens(o),
      _sdkVersion: s ?? `html-wagmi-${Ut.VERSION}`,
      ...l
    }), this.hasSyncedConnectedAccount = !1, this.options = void 0, this.options = e, this.syncRequestedNetworks(i), this.syncConnectors(n), this.syncEmailConnector(n), this.listenEIP6963Connector(n), this.listenEmailConnector(n), fO(() => this.syncAccount()), VO(() => this.syncNetwork());
  }
  getState() {
    const e = super.getState();
    return {
      ...e,
      selectedNetworkId: Iu.caipNetworkIdToNumber(e.selectedNetworkId)
    };
  }
  subscribeState(e) {
    return super.subscribeState((n) => e({
      ...n,
      selectedNetworkId: Iu.caipNetworkIdToNumber(n.selectedNetworkId)
    }));
  }
  syncRequestedNetworks(e) {
    const n = e == null ? void 0 : e.map((r) => {
      var i, a;
      return {
        id: `${Ut.EIP155}:${r.id}`,
        name: r.name,
        imageId: ss.EIP155NetworkImageIds[r.id],
        imageUrl: (a = (i = this.options) == null ? void 0 : i.chainImages) == null ? void 0 : a[r.id]
      };
    });
    this.setRequestedCaipNetworks(n ?? []);
  }
  async syncAccount() {
    const { address: e, isConnected: n } = Yf(), { chain: r } = rM();
    if (this.resetAccount(), n && e && r) {
      const i = `${Ut.EIP155}:${r.id}:${e}`;
      this.setIsConnected(n), this.setCaipAddress(i), await Promise.all([
        this.syncProfile(e, r),
        this.syncBalance(e, r),
        this.getApprovedCaipNetworksData()
      ]), this.hasSyncedConnectedAccount = !0;
    } else
      !n && this.hasSyncedConnectedAccount && (this.resetWcConnection(), this.resetNetwork());
  }
  async syncNetwork() {
    var i, a, o, s;
    const { address: e, isConnected: n } = Yf(), { chain: r } = rM();
    if (r) {
      const l = String(r.id), c = `${Ut.EIP155}:${l}`;
      if (this.setCaipNetwork({
        id: c,
        name: r.name,
        imageId: ss.EIP155NetworkImageIds[r.id],
        imageUrl: (a = (i = this.options) == null ? void 0 : i.chainImages) == null ? void 0 : a[r.id]
      }), n && e) {
        const d = `${Ut.EIP155}:${r.id}:${e}`;
        if (this.setCaipAddress(d), (s = (o = r.blockExplorers) == null ? void 0 : o.default) != null && s.url) {
          const u = `${r.blockExplorers.default.url}/address/${e}`;
          this.setAddressExplorerUrl(u);
        } else
          this.setAddressExplorerUrl(void 0);
        this.hasSyncedConnectedAccount && (await this.syncProfile(e, r), await this.syncBalance(e, r));
      }
    }
  }
  async syncProfile(e, n) {
    if (n.id !== uI.id) {
      this.setProfileName(null), this.setProfileImage(null);
      return;
    }
    try {
      const { name: r, avatar: i } = await this.fetchIdentity({
        caipChainId: `${Ut.EIP155}:${n.id}`,
        address: e
      });
      this.setProfileName(r), this.setProfileImage(i);
    } catch {
      const r = await nee({ address: e, chainId: n.id });
      if (r) {
        this.setProfileName(r);
        const i = await tee({ name: r, chainId: n.id });
        i && this.setProfileImage(i);
      }
    }
  }
  async syncBalance(e, n) {
    var i, a, o;
    const r = await $q({
      address: e,
      chainId: n.id,
      token: (o = (a = (i = this.options) == null ? void 0 : i.tokens) == null ? void 0 : a[n.id]) == null ? void 0 : o.address
    });
    this.setBalance(r.formatted, r.symbol);
  }
  syncConnectors(e) {
    const n = [];
    e.connectors.forEach(({ id: r, name: i }) => {
      var a, o;
      [Ut.EIP6963_CONNECTOR_ID, Ut.EMAIL_CONNECTOR_ID].includes(r) || n.push({
        id: r,
        explorerId: ss.ConnectorExplorerIds[r],
        imageId: ss.ConnectorImageIds[r],
        imageUrl: (o = (a = this.options) == null ? void 0 : a.connectorImages) == null ? void 0 : o[r],
        name: ss.ConnectorNamesMap[r] ?? i,
        type: ss.ConnectorTypesMap[r] ?? "EXTERNAL"
      });
    }), this.setConnectors(n);
  }
  async syncEmailConnector(e) {
    const n = e.connectors.find(({ id: r }) => r === "w3mEmail");
    if (n) {
      const r = await n.getProvider();
      this.addConnector({
        id: Ut.EMAIL_CONNECTOR_ID,
        type: "EMAIL",
        name: "Email",
        provider: r
      });
    }
  }
  eip6963EventHandler(e, n) {
    var r, i;
    if (n.detail) {
      const { info: a, provider: o } = n.detail;
      this.getConnectors().find((c) => c.name === a.name) || (this.addConnector({
        id: Ut.EIP6963_CONNECTOR_ID,
        type: "ANNOUNCED",
        imageUrl: a.icon ?? ((i = (r = this.options) == null ? void 0 : r.connectorImages) == null ? void 0 : i[Ut.EIP6963_CONNECTOR_ID]),
        name: a.name,
        provider: o,
        info: a
      }), e.isAuthorized({ info: a, provider: o }));
    }
  }
  listenEIP6963Connector(e) {
    const n = e.connectors.find((r) => r.id === Ut.EIP6963_CONNECTOR_ID);
    if (typeof window < "u" && n) {
      const r = this.eip6963EventHandler.bind(this, n);
      window.addEventListener(Ut.EIP6963_ANNOUNCE_EVENT, r), window.dispatchEvent(new Event(Ut.EIP6963_REQUEST_EVENT));
    }
  }
  async listenEmailConnector(e) {
    const n = e.connectors.find((r) => r.id === Ut.EMAIL_CONNECTOR_ID);
    if (typeof window < "u" && n) {
      super.setLoading(!0);
      const r = await n.getProvider(), i = r.getLoginEmailUsed();
      super.setLoading(i), r.onRpcRequest(() => {
        super.open({ view: "ApproveTransaction" });
      }), r.onRpcResponse(() => {
        super.close();
      }), r.onIsConnected(() => {
        super.setLoading(!1);
      });
    }
  }
}
globalThis && globalThis.__classPrivateFieldSet;
globalThis && globalThis.__classPrivateFieldGet;
var _Q = {}, EU = {};
EU.byteLength = yue;
EU.toByteArray = bue;
EU.fromByteArray = xue;
var go = [], ma = [], Rue = typeof Uint8Array < "u" ? Uint8Array : Array, Eg = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var Ou = 0, gue = Eg.length; Ou < gue; ++Ou)
  go[Ou] = Eg[Ou], ma[Eg.charCodeAt(Ou)] = Ou;
ma["-".charCodeAt(0)] = 62;
ma["_".charCodeAt(0)] = 63;
function PQ(t) {
  var e = t.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var n = t.indexOf("=");
  n === -1 && (n = e);
  var r = n === e ? 0 : 4 - n % 4;
  return [n, r];
}
function yue(t) {
  var e = PQ(t), n = e[0], r = e[1];
  return (n + r) * 3 / 4 - r;
}
function Zue(t, e, n) {
  return (e + n) * 3 / 4 - n;
}
function bue(t) {
  var e, n = PQ(t), r = n[0], i = n[1], a = new Rue(Zue(t, r, i)), o = 0, s = i > 0 ? r - 4 : r, l;
  for (l = 0; l < s; l += 4)
    e = ma[t.charCodeAt(l)] << 18 | ma[t.charCodeAt(l + 1)] << 12 | ma[t.charCodeAt(l + 2)] << 6 | ma[t.charCodeAt(l + 3)], a[o++] = e >> 16 & 255, a[o++] = e >> 8 & 255, a[o++] = e & 255;
  return i === 2 && (e = ma[t.charCodeAt(l)] << 2 | ma[t.charCodeAt(l + 1)] >> 4, a[o++] = e & 255), i === 1 && (e = ma[t.charCodeAt(l)] << 10 | ma[t.charCodeAt(l + 1)] << 4 | ma[t.charCodeAt(l + 2)] >> 2, a[o++] = e >> 8 & 255, a[o++] = e & 255), a;
}
function Eue(t) {
  return go[t >> 18 & 63] + go[t >> 12 & 63] + go[t >> 6 & 63] + go[t & 63];
}
function Sue(t, e, n) {
  for (var r, i = [], a = e; a < n; a += 3)
    r = (t[a] << 16 & 16711680) + (t[a + 1] << 8 & 65280) + (t[a + 2] & 255), i.push(Eue(r));
  return i.join("");
}
function xue(t) {
  for (var e, n = t.length, r = n % 3, i = [], a = 16383, o = 0, s = n - r; o < s; o += a)
    i.push(Sue(t, o, o + a > s ? s : o + a));
  return r === 1 ? (e = t[n - 1], i.push(
    go[e >> 2] + go[e << 4 & 63] + "=="
  )) : r === 2 && (e = (t[n - 2] << 8) + t[n - 1], i.push(
    go[e >> 10] + go[e >> 4 & 63] + go[e << 2 & 63] + "="
  )), i.join("");
}
var ES = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
ES.read = function(t, e, n, r, i) {
  var a, o, s = i * 8 - r - 1, l = (1 << s) - 1, c = l >> 1, d = -7, u = n ? i - 1 : 0, h = n ? -1 : 1, N = t[e + u];
  for (u += h, a = N & (1 << -d) - 1, N >>= -d, d += s; d > 0; a = a * 256 + t[e + u], u += h, d -= 8)
    ;
  for (o = a & (1 << -d) - 1, a >>= -d, d += r; d > 0; o = o * 256 + t[e + u], u += h, d -= 8)
    ;
  if (a === 0)
    a = 1 - c;
  else {
    if (a === l)
      return o ? NaN : (N ? -1 : 1) * (1 / 0);
    o = o + Math.pow(2, r), a = a - c;
  }
  return (N ? -1 : 1) * o * Math.pow(2, a - r);
};
ES.write = function(t, e, n, r, i, a) {
  var o, s, l, c = a * 8 - i - 1, d = (1 << c) - 1, u = d >> 1, h = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, N = r ? 0 : a - 1, M = r ? 1 : -1, p = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, o = d) : (o = Math.floor(Math.log(e) / Math.LN2), e * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), o + u >= 1 ? e += h / l : e += h * Math.pow(2, 1 - u), e * l >= 2 && (o++, l /= 2), o + u >= d ? (s = 0, o = d) : o + u >= 1 ? (s = (e * l - 1) * Math.pow(2, i), o = o + u) : (s = e * Math.pow(2, u - 1) * Math.pow(2, i), o = 0)); i >= 8; t[n + N] = s & 255, N += M, s /= 256, i -= 8)
    ;
  for (o = o << i | s, c += i; c > 0; t[n + N] = o & 255, N += M, o /= 256, c -= 8)
    ;
  t[n + N - M] |= p * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(t) {
  const e = EU, n = ES, r = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  t.Buffer = s, t.SlowBuffer = V, t.INSPECT_MAX_BYTES = 50;
  const i = 2147483647;
  t.kMaxLength = i, s.TYPED_ARRAY_SUPPORT = a(), !s.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function a() {
    try {
      const v = new Uint8Array(1), S = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(S, Uint8Array.prototype), Object.setPrototypeOf(v, S), v.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(s.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (s.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(s.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (s.isBuffer(this))
        return this.byteOffset;
    }
  });
  function o(v) {
    if (v > i)
      throw new RangeError('The value "' + v + '" is invalid for option "size"');
    const S = new Uint8Array(v);
    return Object.setPrototypeOf(S, s.prototype), S;
  }
  function s(v, S, W) {
    if (typeof v == "number") {
      if (typeof S == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return u(v);
    }
    return l(v, S, W);
  }
  s.poolSize = 8192;
  function l(v, S, W) {
    if (typeof v == "string")
      return h(v, S);
    if (ArrayBuffer.isView(v))
      return M(v);
    if (v == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof v
      );
    if (ft(v, ArrayBuffer) || v && ft(v.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (ft(v, SharedArrayBuffer) || v && ft(v.buffer, SharedArrayBuffer)))
      return p(v, S, W);
    if (typeof v == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const L = v.valueOf && v.valueOf();
    if (L != null && L !== v)
      return s.from(L, S, W);
    const P = m(v);
    if (P)
      return P;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof v[Symbol.toPrimitive] == "function")
      return s.from(v[Symbol.toPrimitive]("string"), S, W);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof v
    );
  }
  s.from = function(v, S, W) {
    return l(v, S, W);
  }, Object.setPrototypeOf(s.prototype, Uint8Array.prototype), Object.setPrototypeOf(s, Uint8Array);
  function c(v) {
    if (typeof v != "number")
      throw new TypeError('"size" argument must be of type number');
    if (v < 0)
      throw new RangeError('The value "' + v + '" is invalid for option "size"');
  }
  function d(v, S, W) {
    return c(v), v <= 0 ? o(v) : S !== void 0 ? typeof W == "string" ? o(v).fill(S, W) : o(v).fill(S) : o(v);
  }
  s.alloc = function(v, S, W) {
    return d(v, S, W);
  };
  function u(v) {
    return c(v), o(v < 0 ? 0 : R(v) | 0);
  }
  s.allocUnsafe = function(v) {
    return u(v);
  }, s.allocUnsafeSlow = function(v) {
    return u(v);
  };
  function h(v, S) {
    if ((typeof S != "string" || S === "") && (S = "utf8"), !s.isEncoding(S))
      throw new TypeError("Unknown encoding: " + S);
    const W = U(v, S) | 0;
    let L = o(W);
    const P = L.write(v, S);
    return P !== W && (L = L.slice(0, P)), L;
  }
  function N(v) {
    const S = v.length < 0 ? 0 : R(v.length) | 0, W = o(S);
    for (let L = 0; L < S; L += 1)
      W[L] = v[L] & 255;
    return W;
  }
  function M(v) {
    if (ft(v, Uint8Array)) {
      const S = new Uint8Array(v);
      return p(S.buffer, S.byteOffset, S.byteLength);
    }
    return N(v);
  }
  function p(v, S, W) {
    if (S < 0 || v.byteLength < S)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (v.byteLength < S + (W || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let L;
    return S === void 0 && W === void 0 ? L = new Uint8Array(v) : W === void 0 ? L = new Uint8Array(v, S) : L = new Uint8Array(v, S, W), Object.setPrototypeOf(L, s.prototype), L;
  }
  function m(v) {
    if (s.isBuffer(v)) {
      const S = R(v.length) | 0, W = o(S);
      return W.length === 0 || v.copy(W, 0, 0, S), W;
    }
    if (v.length !== void 0)
      return typeof v.length != "number" || Le(v.length) ? o(0) : N(v);
    if (v.type === "Buffer" && Array.isArray(v.data))
      return N(v.data);
  }
  function R(v) {
    if (v >= i)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
    return v | 0;
  }
  function V(v) {
    return +v != v && (v = 0), s.alloc(+v);
  }
  s.isBuffer = function(S) {
    return S != null && S._isBuffer === !0 && S !== s.prototype;
  }, s.compare = function(S, W) {
    if (ft(S, Uint8Array) && (S = s.from(S, S.offset, S.byteLength)), ft(W, Uint8Array) && (W = s.from(W, W.offset, W.byteLength)), !s.isBuffer(S) || !s.isBuffer(W))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (S === W)
      return 0;
    let L = S.length, P = W.length;
    for (let q = 0, ie = Math.min(L, P); q < ie; ++q)
      if (S[q] !== W[q]) {
        L = S[q], P = W[q];
        break;
      }
    return L < P ? -1 : P < L ? 1 : 0;
  }, s.isEncoding = function(S) {
    switch (String(S).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, s.concat = function(S, W) {
    if (!Array.isArray(S))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (S.length === 0)
      return s.alloc(0);
    let L;
    if (W === void 0)
      for (W = 0, L = 0; L < S.length; ++L)
        W += S[L].length;
    const P = s.allocUnsafe(W);
    let q = 0;
    for (L = 0; L < S.length; ++L) {
      let ie = S[L];
      if (ft(ie, Uint8Array))
        q + ie.length > P.length ? (s.isBuffer(ie) || (ie = s.from(ie)), ie.copy(P, q)) : Uint8Array.prototype.set.call(
          P,
          ie,
          q
        );
      else if (s.isBuffer(ie))
        ie.copy(P, q);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      q += ie.length;
    }
    return P;
  };
  function U(v, S) {
    if (s.isBuffer(v))
      return v.length;
    if (ArrayBuffer.isView(v) || ft(v, ArrayBuffer))
      return v.byteLength;
    if (typeof v != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof v
      );
    const W = v.length, L = arguments.length > 2 && arguments[2] === !0;
    if (!L && W === 0)
      return 0;
    let P = !1;
    for (; ; )
      switch (S) {
        case "ascii":
        case "latin1":
        case "binary":
          return W;
        case "utf8":
        case "utf-8":
          return Zt(v).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return W * 2;
        case "hex":
          return W >>> 1;
        case "base64":
          return Oe(v).length;
        default:
          if (P)
            return L ? -1 : Zt(v).length;
          S = ("" + S).toLowerCase(), P = !0;
      }
  }
  s.byteLength = U;
  function g(v, S, W) {
    let L = !1;
    if ((S === void 0 || S < 0) && (S = 0), S > this.length || ((W === void 0 || W > this.length) && (W = this.length), W <= 0) || (W >>>= 0, S >>>= 0, W <= S))
      return "";
    for (v || (v = "utf8"); ; )
      switch (v) {
        case "hex":
          return C(this, S, W);
        case "utf8":
        case "utf-8":
          return T(this, S, W);
        case "ascii":
          return j(this, S, W);
        case "latin1":
        case "binary":
          return w(this, S, W);
        case "base64":
          return O(this, S, W);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return J(this, S, W);
        default:
          if (L)
            throw new TypeError("Unknown encoding: " + v);
          v = (v + "").toLowerCase(), L = !0;
      }
  }
  s.prototype._isBuffer = !0;
  function y(v, S, W) {
    const L = v[S];
    v[S] = v[W], v[W] = L;
  }
  s.prototype.swap16 = function() {
    const S = this.length;
    if (S % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let W = 0; W < S; W += 2)
      y(this, W, W + 1);
    return this;
  }, s.prototype.swap32 = function() {
    const S = this.length;
    if (S % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let W = 0; W < S; W += 4)
      y(this, W, W + 3), y(this, W + 1, W + 2);
    return this;
  }, s.prototype.swap64 = function() {
    const S = this.length;
    if (S % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let W = 0; W < S; W += 8)
      y(this, W, W + 7), y(this, W + 1, W + 6), y(this, W + 2, W + 5), y(this, W + 3, W + 4);
    return this;
  }, s.prototype.toString = function() {
    const S = this.length;
    return S === 0 ? "" : arguments.length === 0 ? T(this, 0, S) : g.apply(this, arguments);
  }, s.prototype.toLocaleString = s.prototype.toString, s.prototype.equals = function(S) {
    if (!s.isBuffer(S))
      throw new TypeError("Argument must be a Buffer");
    return this === S ? !0 : s.compare(this, S) === 0;
  }, s.prototype.inspect = function() {
    let S = "";
    const W = t.INSPECT_MAX_BYTES;
    return S = this.toString("hex", 0, W).replace(/(.{2})/g, "$1 ").trim(), this.length > W && (S += " ... "), "<Buffer " + S + ">";
  }, r && (s.prototype[r] = s.prototype.inspect), s.prototype.compare = function(S, W, L, P, q) {
    if (ft(S, Uint8Array) && (S = s.from(S, S.offset, S.byteLength)), !s.isBuffer(S))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof S
      );
    if (W === void 0 && (W = 0), L === void 0 && (L = S ? S.length : 0), P === void 0 && (P = 0), q === void 0 && (q = this.length), W < 0 || L > S.length || P < 0 || q > this.length)
      throw new RangeError("out of range index");
    if (P >= q && W >= L)
      return 0;
    if (P >= q)
      return -1;
    if (W >= L)
      return 1;
    if (W >>>= 0, L >>>= 0, P >>>= 0, q >>>= 0, this === S)
      return 0;
    let ie = q - P, Be = L - W;
    const Je = Math.min(ie, Be), He = this.slice(P, q), Qt = S.slice(W, L);
    for (let it = 0; it < Je; ++it)
      if (He[it] !== Qt[it]) {
        ie = He[it], Be = Qt[it];
        break;
      }
    return ie < Be ? -1 : Be < ie ? 1 : 0;
  };
  function x(v, S, W, L, P) {
    if (v.length === 0)
      return -1;
    if (typeof W == "string" ? (L = W, W = 0) : W > 2147483647 ? W = 2147483647 : W < -2147483648 && (W = -2147483648), W = +W, Le(W) && (W = P ? 0 : v.length - 1), W < 0 && (W = v.length + W), W >= v.length) {
      if (P)
        return -1;
      W = v.length - 1;
    } else if (W < 0)
      if (P)
        W = 0;
      else
        return -1;
    if (typeof S == "string" && (S = s.from(S, L)), s.isBuffer(S))
      return S.length === 0 ? -1 : f(v, S, W, L, P);
    if (typeof S == "number")
      return S = S & 255, typeof Uint8Array.prototype.indexOf == "function" ? P ? Uint8Array.prototype.indexOf.call(v, S, W) : Uint8Array.prototype.lastIndexOf.call(v, S, W) : f(v, [S], W, L, P);
    throw new TypeError("val must be string, number or Buffer");
  }
  function f(v, S, W, L, P) {
    let q = 1, ie = v.length, Be = S.length;
    if (L !== void 0 && (L = String(L).toLowerCase(), L === "ucs2" || L === "ucs-2" || L === "utf16le" || L === "utf-16le")) {
      if (v.length < 2 || S.length < 2)
        return -1;
      q = 2, ie /= 2, Be /= 2, W /= 2;
    }
    function Je(Qt, it) {
      return q === 1 ? Qt[it] : Qt.readUInt16BE(it * q);
    }
    let He;
    if (P) {
      let Qt = -1;
      for (He = W; He < ie; He++)
        if (Je(v, He) === Je(S, Qt === -1 ? 0 : He - Qt)) {
          if (Qt === -1 && (Qt = He), He - Qt + 1 === Be)
            return Qt * q;
        } else
          Qt !== -1 && (He -= He - Qt), Qt = -1;
    } else
      for (W + Be > ie && (W = ie - Be), He = W; He >= 0; He--) {
        let Qt = !0;
        for (let it = 0; it < Be; it++)
          if (Je(v, He + it) !== Je(S, it)) {
            Qt = !1;
            break;
          }
        if (Qt)
          return He;
      }
    return -1;
  }
  s.prototype.includes = function(S, W, L) {
    return this.indexOf(S, W, L) !== -1;
  }, s.prototype.indexOf = function(S, W, L) {
    return x(this, S, W, L, !0);
  }, s.prototype.lastIndexOf = function(S, W, L) {
    return x(this, S, W, L, !1);
  };
  function D(v, S, W, L) {
    W = Number(W) || 0;
    const P = v.length - W;
    L ? (L = Number(L), L > P && (L = P)) : L = P;
    const q = S.length;
    L > q / 2 && (L = q / 2);
    let ie;
    for (ie = 0; ie < L; ++ie) {
      const Be = parseInt(S.substr(ie * 2, 2), 16);
      if (Le(Be))
        return ie;
      v[W + ie] = Be;
    }
    return ie;
  }
  function Y(v, S, W, L) {
    return Xe(Zt(S, v.length - W), v, W, L);
  }
  function Q(v, S, W, L) {
    return Xe(kt(S), v, W, L);
  }
  function G(v, S, W, L) {
    return Xe(Oe(S), v, W, L);
  }
  function ne(v, S, W, L) {
    return Xe(Pn(S, v.length - W), v, W, L);
  }
  s.prototype.write = function(S, W, L, P) {
    if (W === void 0)
      P = "utf8", L = this.length, W = 0;
    else if (L === void 0 && typeof W == "string")
      P = W, L = this.length, W = 0;
    else if (isFinite(W))
      W = W >>> 0, isFinite(L) ? (L = L >>> 0, P === void 0 && (P = "utf8")) : (P = L, L = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const q = this.length - W;
    if ((L === void 0 || L > q) && (L = q), S.length > 0 && (L < 0 || W < 0) || W > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    P || (P = "utf8");
    let ie = !1;
    for (; ; )
      switch (P) {
        case "hex":
          return D(this, S, W, L);
        case "utf8":
        case "utf-8":
          return Y(this, S, W, L);
        case "ascii":
        case "latin1":
        case "binary":
          return Q(this, S, W, L);
        case "base64":
          return G(this, S, W, L);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return ne(this, S, W, L);
        default:
          if (ie)
            throw new TypeError("Unknown encoding: " + P);
          P = ("" + P).toLowerCase(), ie = !0;
      }
  }, s.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function O(v, S, W) {
    return S === 0 && W === v.length ? e.fromByteArray(v) : e.fromByteArray(v.slice(S, W));
  }
  function T(v, S, W) {
    W = Math.min(v.length, W);
    const L = [];
    let P = S;
    for (; P < W; ) {
      const q = v[P];
      let ie = null, Be = q > 239 ? 4 : q > 223 ? 3 : q > 191 ? 2 : 1;
      if (P + Be <= W) {
        let Je, He, Qt, it;
        switch (Be) {
          case 1:
            q < 128 && (ie = q);
            break;
          case 2:
            Je = v[P + 1], (Je & 192) === 128 && (it = (q & 31) << 6 | Je & 63, it > 127 && (ie = it));
            break;
          case 3:
            Je = v[P + 1], He = v[P + 2], (Je & 192) === 128 && (He & 192) === 128 && (it = (q & 15) << 12 | (Je & 63) << 6 | He & 63, it > 2047 && (it < 55296 || it > 57343) && (ie = it));
            break;
          case 4:
            Je = v[P + 1], He = v[P + 2], Qt = v[P + 3], (Je & 192) === 128 && (He & 192) === 128 && (Qt & 192) === 128 && (it = (q & 15) << 18 | (Je & 63) << 12 | (He & 63) << 6 | Qt & 63, it > 65535 && it < 1114112 && (ie = it));
        }
      }
      ie === null ? (ie = 65533, Be = 1) : ie > 65535 && (ie -= 65536, L.push(ie >>> 10 & 1023 | 55296), ie = 56320 | ie & 1023), L.push(ie), P += Be;
    }
    return z(L);
  }
  const Z = 4096;
  function z(v) {
    const S = v.length;
    if (S <= Z)
      return String.fromCharCode.apply(String, v);
    let W = "", L = 0;
    for (; L < S; )
      W += String.fromCharCode.apply(
        String,
        v.slice(L, L += Z)
      );
    return W;
  }
  function j(v, S, W) {
    let L = "";
    W = Math.min(v.length, W);
    for (let P = S; P < W; ++P)
      L += String.fromCharCode(v[P] & 127);
    return L;
  }
  function w(v, S, W) {
    let L = "";
    W = Math.min(v.length, W);
    for (let P = S; P < W; ++P)
      L += String.fromCharCode(v[P]);
    return L;
  }
  function C(v, S, W) {
    const L = v.length;
    (!S || S < 0) && (S = 0), (!W || W < 0 || W > L) && (W = L);
    let P = "";
    for (let q = S; q < W; ++q)
      P += dt[v[q]];
    return P;
  }
  function J(v, S, W) {
    const L = v.slice(S, W);
    let P = "";
    for (let q = 0; q < L.length - 1; q += 2)
      P += String.fromCharCode(L[q] + L[q + 1] * 256);
    return P;
  }
  s.prototype.slice = function(S, W) {
    const L = this.length;
    S = ~~S, W = W === void 0 ? L : ~~W, S < 0 ? (S += L, S < 0 && (S = 0)) : S > L && (S = L), W < 0 ? (W += L, W < 0 && (W = 0)) : W > L && (W = L), W < S && (W = S);
    const P = this.subarray(S, W);
    return Object.setPrototypeOf(P, s.prototype), P;
  };
  function I(v, S, W) {
    if (v % 1 !== 0 || v < 0)
      throw new RangeError("offset is not uint");
    if (v + S > W)
      throw new RangeError("Trying to access beyond buffer length");
  }
  s.prototype.readUintLE = s.prototype.readUIntLE = function(S, W, L) {
    S = S >>> 0, W = W >>> 0, L || I(S, W, this.length);
    let P = this[S], q = 1, ie = 0;
    for (; ++ie < W && (q *= 256); )
      P += this[S + ie] * q;
    return P;
  }, s.prototype.readUintBE = s.prototype.readUIntBE = function(S, W, L) {
    S = S >>> 0, W = W >>> 0, L || I(S, W, this.length);
    let P = this[S + --W], q = 1;
    for (; W > 0 && (q *= 256); )
      P += this[S + --W] * q;
    return P;
  }, s.prototype.readUint8 = s.prototype.readUInt8 = function(S, W) {
    return S = S >>> 0, W || I(S, 1, this.length), this[S];
  }, s.prototype.readUint16LE = s.prototype.readUInt16LE = function(S, W) {
    return S = S >>> 0, W || I(S, 2, this.length), this[S] | this[S + 1] << 8;
  }, s.prototype.readUint16BE = s.prototype.readUInt16BE = function(S, W) {
    return S = S >>> 0, W || I(S, 2, this.length), this[S] << 8 | this[S + 1];
  }, s.prototype.readUint32LE = s.prototype.readUInt32LE = function(S, W) {
    return S = S >>> 0, W || I(S, 4, this.length), (this[S] | this[S + 1] << 8 | this[S + 2] << 16) + this[S + 3] * 16777216;
  }, s.prototype.readUint32BE = s.prototype.readUInt32BE = function(S, W) {
    return S = S >>> 0, W || I(S, 4, this.length), this[S] * 16777216 + (this[S + 1] << 16 | this[S + 2] << 8 | this[S + 3]);
  }, s.prototype.readBigUInt64LE = Dt(function(S) {
    S = S >>> 0, Ce(S, "offset");
    const W = this[S], L = this[S + 7];
    (W === void 0 || L === void 0) && et(S, this.length - 8);
    const P = W + this[++S] * 2 ** 8 + this[++S] * 2 ** 16 + this[++S] * 2 ** 24, q = this[++S] + this[++S] * 2 ** 8 + this[++S] * 2 ** 16 + L * 2 ** 24;
    return BigInt(P) + (BigInt(q) << BigInt(32));
  }), s.prototype.readBigUInt64BE = Dt(function(S) {
    S = S >>> 0, Ce(S, "offset");
    const W = this[S], L = this[S + 7];
    (W === void 0 || L === void 0) && et(S, this.length - 8);
    const P = W * 2 ** 24 + this[++S] * 2 ** 16 + this[++S] * 2 ** 8 + this[++S], q = this[++S] * 2 ** 24 + this[++S] * 2 ** 16 + this[++S] * 2 ** 8 + L;
    return (BigInt(P) << BigInt(32)) + BigInt(q);
  }), s.prototype.readIntLE = function(S, W, L) {
    S = S >>> 0, W = W >>> 0, L || I(S, W, this.length);
    let P = this[S], q = 1, ie = 0;
    for (; ++ie < W && (q *= 256); )
      P += this[S + ie] * q;
    return q *= 128, P >= q && (P -= Math.pow(2, 8 * W)), P;
  }, s.prototype.readIntBE = function(S, W, L) {
    S = S >>> 0, W = W >>> 0, L || I(S, W, this.length);
    let P = W, q = 1, ie = this[S + --P];
    for (; P > 0 && (q *= 256); )
      ie += this[S + --P] * q;
    return q *= 128, ie >= q && (ie -= Math.pow(2, 8 * W)), ie;
  }, s.prototype.readInt8 = function(S, W) {
    return S = S >>> 0, W || I(S, 1, this.length), this[S] & 128 ? (255 - this[S] + 1) * -1 : this[S];
  }, s.prototype.readInt16LE = function(S, W) {
    S = S >>> 0, W || I(S, 2, this.length);
    const L = this[S] | this[S + 1] << 8;
    return L & 32768 ? L | 4294901760 : L;
  }, s.prototype.readInt16BE = function(S, W) {
    S = S >>> 0, W || I(S, 2, this.length);
    const L = this[S + 1] | this[S] << 8;
    return L & 32768 ? L | 4294901760 : L;
  }, s.prototype.readInt32LE = function(S, W) {
    return S = S >>> 0, W || I(S, 4, this.length), this[S] | this[S + 1] << 8 | this[S + 2] << 16 | this[S + 3] << 24;
  }, s.prototype.readInt32BE = function(S, W) {
    return S = S >>> 0, W || I(S, 4, this.length), this[S] << 24 | this[S + 1] << 16 | this[S + 2] << 8 | this[S + 3];
  }, s.prototype.readBigInt64LE = Dt(function(S) {
    S = S >>> 0, Ce(S, "offset");
    const W = this[S], L = this[S + 7];
    (W === void 0 || L === void 0) && et(S, this.length - 8);
    const P = this[S + 4] + this[S + 5] * 2 ** 8 + this[S + 6] * 2 ** 16 + (L << 24);
    return (BigInt(P) << BigInt(32)) + BigInt(W + this[++S] * 2 ** 8 + this[++S] * 2 ** 16 + this[++S] * 2 ** 24);
  }), s.prototype.readBigInt64BE = Dt(function(S) {
    S = S >>> 0, Ce(S, "offset");
    const W = this[S], L = this[S + 7];
    (W === void 0 || L === void 0) && et(S, this.length - 8);
    const P = (W << 24) + // Overflow
    this[++S] * 2 ** 16 + this[++S] * 2 ** 8 + this[++S];
    return (BigInt(P) << BigInt(32)) + BigInt(this[++S] * 2 ** 24 + this[++S] * 2 ** 16 + this[++S] * 2 ** 8 + L);
  }), s.prototype.readFloatLE = function(S, W) {
    return S = S >>> 0, W || I(S, 4, this.length), n.read(this, S, !0, 23, 4);
  }, s.prototype.readFloatBE = function(S, W) {
    return S = S >>> 0, W || I(S, 4, this.length), n.read(this, S, !1, 23, 4);
  }, s.prototype.readDoubleLE = function(S, W) {
    return S = S >>> 0, W || I(S, 8, this.length), n.read(this, S, !0, 52, 8);
  }, s.prototype.readDoubleBE = function(S, W) {
    return S = S >>> 0, W || I(S, 8, this.length), n.read(this, S, !1, 52, 8);
  };
  function b(v, S, W, L, P, q) {
    if (!s.isBuffer(v))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (S > P || S < q)
      throw new RangeError('"value" argument is out of bounds');
    if (W + L > v.length)
      throw new RangeError("Index out of range");
  }
  s.prototype.writeUintLE = s.prototype.writeUIntLE = function(S, W, L, P) {
    if (S = +S, W = W >>> 0, L = L >>> 0, !P) {
      const Be = Math.pow(2, 8 * L) - 1;
      b(this, S, W, L, Be, 0);
    }
    let q = 1, ie = 0;
    for (this[W] = S & 255; ++ie < L && (q *= 256); )
      this[W + ie] = S / q & 255;
    return W + L;
  }, s.prototype.writeUintBE = s.prototype.writeUIntBE = function(S, W, L, P) {
    if (S = +S, W = W >>> 0, L = L >>> 0, !P) {
      const Be = Math.pow(2, 8 * L) - 1;
      b(this, S, W, L, Be, 0);
    }
    let q = L - 1, ie = 1;
    for (this[W + q] = S & 255; --q >= 0 && (ie *= 256); )
      this[W + q] = S / ie & 255;
    return W + L;
  }, s.prototype.writeUint8 = s.prototype.writeUInt8 = function(S, W, L) {
    return S = +S, W = W >>> 0, L || b(this, S, W, 1, 255, 0), this[W] = S & 255, W + 1;
  }, s.prototype.writeUint16LE = s.prototype.writeUInt16LE = function(S, W, L) {
    return S = +S, W = W >>> 0, L || b(this, S, W, 2, 65535, 0), this[W] = S & 255, this[W + 1] = S >>> 8, W + 2;
  }, s.prototype.writeUint16BE = s.prototype.writeUInt16BE = function(S, W, L) {
    return S = +S, W = W >>> 0, L || b(this, S, W, 2, 65535, 0), this[W] = S >>> 8, this[W + 1] = S & 255, W + 2;
  }, s.prototype.writeUint32LE = s.prototype.writeUInt32LE = function(S, W, L) {
    return S = +S, W = W >>> 0, L || b(this, S, W, 4, 4294967295, 0), this[W + 3] = S >>> 24, this[W + 2] = S >>> 16, this[W + 1] = S >>> 8, this[W] = S & 255, W + 4;
  }, s.prototype.writeUint32BE = s.prototype.writeUInt32BE = function(S, W, L) {
    return S = +S, W = W >>> 0, L || b(this, S, W, 4, 4294967295, 0), this[W] = S >>> 24, this[W + 1] = S >>> 16, this[W + 2] = S >>> 8, this[W + 3] = S & 255, W + 4;
  };
  function k(v, S, W, L, P) {
    se(S, L, P, v, W, 7);
    let q = Number(S & BigInt(4294967295));
    v[W++] = q, q = q >> 8, v[W++] = q, q = q >> 8, v[W++] = q, q = q >> 8, v[W++] = q;
    let ie = Number(S >> BigInt(32) & BigInt(4294967295));
    return v[W++] = ie, ie = ie >> 8, v[W++] = ie, ie = ie >> 8, v[W++] = ie, ie = ie >> 8, v[W++] = ie, W;
  }
  function ae(v, S, W, L, P) {
    se(S, L, P, v, W, 7);
    let q = Number(S & BigInt(4294967295));
    v[W + 7] = q, q = q >> 8, v[W + 6] = q, q = q >> 8, v[W + 5] = q, q = q >> 8, v[W + 4] = q;
    let ie = Number(S >> BigInt(32) & BigInt(4294967295));
    return v[W + 3] = ie, ie = ie >> 8, v[W + 2] = ie, ie = ie >> 8, v[W + 1] = ie, ie = ie >> 8, v[W] = ie, W + 8;
  }
  s.prototype.writeBigUInt64LE = Dt(function(S, W = 0) {
    return k(this, S, W, BigInt(0), BigInt("0xffffffffffffffff"));
  }), s.prototype.writeBigUInt64BE = Dt(function(S, W = 0) {
    return ae(this, S, W, BigInt(0), BigInt("0xffffffffffffffff"));
  }), s.prototype.writeIntLE = function(S, W, L, P) {
    if (S = +S, W = W >>> 0, !P) {
      const Je = Math.pow(2, 8 * L - 1);
      b(this, S, W, L, Je - 1, -Je);
    }
    let q = 0, ie = 1, Be = 0;
    for (this[W] = S & 255; ++q < L && (ie *= 256); )
      S < 0 && Be === 0 && this[W + q - 1] !== 0 && (Be = 1), this[W + q] = (S / ie >> 0) - Be & 255;
    return W + L;
  }, s.prototype.writeIntBE = function(S, W, L, P) {
    if (S = +S, W = W >>> 0, !P) {
      const Je = Math.pow(2, 8 * L - 1);
      b(this, S, W, L, Je - 1, -Je);
    }
    let q = L - 1, ie = 1, Be = 0;
    for (this[W + q] = S & 255; --q >= 0 && (ie *= 256); )
      S < 0 && Be === 0 && this[W + q + 1] !== 0 && (Be = 1), this[W + q] = (S / ie >> 0) - Be & 255;
    return W + L;
  }, s.prototype.writeInt8 = function(S, W, L) {
    return S = +S, W = W >>> 0, L || b(this, S, W, 1, 127, -128), S < 0 && (S = 255 + S + 1), this[W] = S & 255, W + 1;
  }, s.prototype.writeInt16LE = function(S, W, L) {
    return S = +S, W = W >>> 0, L || b(this, S, W, 2, 32767, -32768), this[W] = S & 255, this[W + 1] = S >>> 8, W + 2;
  }, s.prototype.writeInt16BE = function(S, W, L) {
    return S = +S, W = W >>> 0, L || b(this, S, W, 2, 32767, -32768), this[W] = S >>> 8, this[W + 1] = S & 255, W + 2;
  }, s.prototype.writeInt32LE = function(S, W, L) {
    return S = +S, W = W >>> 0, L || b(this, S, W, 4, 2147483647, -2147483648), this[W] = S & 255, this[W + 1] = S >>> 8, this[W + 2] = S >>> 16, this[W + 3] = S >>> 24, W + 4;
  }, s.prototype.writeInt32BE = function(S, W, L) {
    return S = +S, W = W >>> 0, L || b(this, S, W, 4, 2147483647, -2147483648), S < 0 && (S = 4294967295 + S + 1), this[W] = S >>> 24, this[W + 1] = S >>> 16, this[W + 2] = S >>> 8, this[W + 3] = S & 255, W + 4;
  }, s.prototype.writeBigInt64LE = Dt(function(S, W = 0) {
    return k(this, S, W, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), s.prototype.writeBigInt64BE = Dt(function(S, W = 0) {
    return ae(this, S, W, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function oe(v, S, W, L, P, q) {
    if (W + L > v.length)
      throw new RangeError("Index out of range");
    if (W < 0)
      throw new RangeError("Index out of range");
  }
  function le(v, S, W, L, P) {
    return S = +S, W = W >>> 0, P || oe(v, S, W, 4), n.write(v, S, W, L, 23, 4), W + 4;
  }
  s.prototype.writeFloatLE = function(S, W, L) {
    return le(this, S, W, !0, L);
  }, s.prototype.writeFloatBE = function(S, W, L) {
    return le(this, S, W, !1, L);
  };
  function fe(v, S, W, L, P) {
    return S = +S, W = W >>> 0, P || oe(v, S, W, 8), n.write(v, S, W, L, 52, 8), W + 8;
  }
  s.prototype.writeDoubleLE = function(S, W, L) {
    return fe(this, S, W, !0, L);
  }, s.prototype.writeDoubleBE = function(S, W, L) {
    return fe(this, S, W, !1, L);
  }, s.prototype.copy = function(S, W, L, P) {
    if (!s.isBuffer(S))
      throw new TypeError("argument should be a Buffer");
    if (L || (L = 0), !P && P !== 0 && (P = this.length), W >= S.length && (W = S.length), W || (W = 0), P > 0 && P < L && (P = L), P === L || S.length === 0 || this.length === 0)
      return 0;
    if (W < 0)
      throw new RangeError("targetStart out of bounds");
    if (L < 0 || L >= this.length)
      throw new RangeError("Index out of range");
    if (P < 0)
      throw new RangeError("sourceEnd out of bounds");
    P > this.length && (P = this.length), S.length - W < P - L && (P = S.length - W + L);
    const q = P - L;
    return this === S && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(W, L, P) : Uint8Array.prototype.set.call(
      S,
      this.subarray(L, P),
      W
    ), q;
  }, s.prototype.fill = function(S, W, L, P) {
    if (typeof S == "string") {
      if (typeof W == "string" ? (P = W, W = 0, L = this.length) : typeof L == "string" && (P = L, L = this.length), P !== void 0 && typeof P != "string")
        throw new TypeError("encoding must be a string");
      if (typeof P == "string" && !s.isEncoding(P))
        throw new TypeError("Unknown encoding: " + P);
      if (S.length === 1) {
        const ie = S.charCodeAt(0);
        (P === "utf8" && ie < 128 || P === "latin1") && (S = ie);
      }
    } else
      typeof S == "number" ? S = S & 255 : typeof S == "boolean" && (S = Number(S));
    if (W < 0 || this.length < W || this.length < L)
      throw new RangeError("Out of range index");
    if (L <= W)
      return this;
    W = W >>> 0, L = L === void 0 ? this.length : L >>> 0, S || (S = 0);
    let q;
    if (typeof S == "number")
      for (q = W; q < L; ++q)
        this[q] = S;
    else {
      const ie = s.isBuffer(S) ? S : s.from(S, P), Be = ie.length;
      if (Be === 0)
        throw new TypeError('The value "' + S + '" is invalid for argument "value"');
      for (q = 0; q < L - W; ++q)
        this[q + W] = ie[q % Be];
    }
    return this;
  };
  const de = {};
  function Me(v, S, W) {
    de[v] = class extends W {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: S.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${v}]`, this.stack, delete this.name;
      }
      get code() {
        return v;
      }
      set code(P) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: P,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${v}]: ${this.message}`;
      }
    };
  }
  Me(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(v) {
      return v ? `${v} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), Me(
    "ERR_INVALID_ARG_TYPE",
    function(v, S) {
      return `The "${v}" argument must be of type number. Received type ${typeof S}`;
    },
    TypeError
  ), Me(
    "ERR_OUT_OF_RANGE",
    function(v, S, W) {
      let L = `The value of "${v}" is out of range.`, P = W;
      return Number.isInteger(W) && Math.abs(W) > 2 ** 32 ? P = je(String(W)) : typeof W == "bigint" && (P = String(W), (W > BigInt(2) ** BigInt(32) || W < -(BigInt(2) ** BigInt(32))) && (P = je(P)), P += "n"), L += ` It must be ${S}. Received ${P}`, L;
    },
    RangeError
  );
  function je(v) {
    let S = "", W = v.length;
    const L = v[0] === "-" ? 1 : 0;
    for (; W >= L + 4; W -= 3)
      S = `_${v.slice(W - 3, W)}${S}`;
    return `${v.slice(0, W)}${S}`;
  }
  function Se(v, S, W) {
    Ce(S, "offset"), (v[S] === void 0 || v[S + W] === void 0) && et(S, v.length - (W + 1));
  }
  function se(v, S, W, L, P, q) {
    if (v > W || v < S) {
      const ie = typeof S == "bigint" ? "n" : "";
      let Be;
      throw q > 3 ? S === 0 || S === BigInt(0) ? Be = `>= 0${ie} and < 2${ie} ** ${(q + 1) * 8}${ie}` : Be = `>= -(2${ie} ** ${(q + 1) * 8 - 1}${ie}) and < 2 ** ${(q + 1) * 8 - 1}${ie}` : Be = `>= ${S}${ie} and <= ${W}${ie}`, new de.ERR_OUT_OF_RANGE("value", Be, v);
    }
    Se(L, P, q);
  }
  function Ce(v, S) {
    if (typeof v != "number")
      throw new de.ERR_INVALID_ARG_TYPE(S, "number", v);
  }
  function et(v, S, W) {
    throw Math.floor(v) !== v ? (Ce(v, W), new de.ERR_OUT_OF_RANGE(W || "offset", "an integer", v)) : S < 0 ? new de.ERR_BUFFER_OUT_OF_BOUNDS() : new de.ERR_OUT_OF_RANGE(
      W || "offset",
      `>= ${W ? 1 : 0} and <= ${S}`,
      v
    );
  }
  const at = /[^+/0-9A-Za-z-_]/g;
  function Rn(v) {
    if (v = v.split("=")[0], v = v.trim().replace(at, ""), v.length < 2)
      return "";
    for (; v.length % 4 !== 0; )
      v = v + "=";
    return v;
  }
  function Zt(v, S) {
    S = S || 1 / 0;
    let W;
    const L = v.length;
    let P = null;
    const q = [];
    for (let ie = 0; ie < L; ++ie) {
      if (W = v.charCodeAt(ie), W > 55295 && W < 57344) {
        if (!P) {
          if (W > 56319) {
            (S -= 3) > -1 && q.push(239, 191, 189);
            continue;
          } else if (ie + 1 === L) {
            (S -= 3) > -1 && q.push(239, 191, 189);
            continue;
          }
          P = W;
          continue;
        }
        if (W < 56320) {
          (S -= 3) > -1 && q.push(239, 191, 189), P = W;
          continue;
        }
        W = (P - 55296 << 10 | W - 56320) + 65536;
      } else
        P && (S -= 3) > -1 && q.push(239, 191, 189);
      if (P = null, W < 128) {
        if ((S -= 1) < 0)
          break;
        q.push(W);
      } else if (W < 2048) {
        if ((S -= 2) < 0)
          break;
        q.push(
          W >> 6 | 192,
          W & 63 | 128
        );
      } else if (W < 65536) {
        if ((S -= 3) < 0)
          break;
        q.push(
          W >> 12 | 224,
          W >> 6 & 63 | 128,
          W & 63 | 128
        );
      } else if (W < 1114112) {
        if ((S -= 4) < 0)
          break;
        q.push(
          W >> 18 | 240,
          W >> 12 & 63 | 128,
          W >> 6 & 63 | 128,
          W & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return q;
  }
  function kt(v) {
    const S = [];
    for (let W = 0; W < v.length; ++W)
      S.push(v.charCodeAt(W) & 255);
    return S;
  }
  function Pn(v, S) {
    let W, L, P;
    const q = [];
    for (let ie = 0; ie < v.length && !((S -= 2) < 0); ++ie)
      W = v.charCodeAt(ie), L = W >> 8, P = W % 256, q.push(P), q.push(L);
    return q;
  }
  function Oe(v) {
    return e.toByteArray(Rn(v));
  }
  function Xe(v, S, W, L) {
    let P;
    for (P = 0; P < L && !(P + W >= S.length || P >= v.length); ++P)
      S[P + W] = v[P];
    return P;
  }
  function ft(v, S) {
    return v instanceof S || v != null && v.constructor != null && v.constructor.name != null && v.constructor.name === S.name;
  }
  function Le(v) {
    return v !== v;
  }
  const dt = function() {
    const v = "0123456789abcdef", S = new Array(256);
    for (let W = 0; W < 16; ++W) {
      const L = W * 16;
      for (let P = 0; P < 16; ++P)
        S[L + P] = v[W] + v[P];
    }
    return S;
  }();
  function Dt(v) {
    return typeof BigInt > "u" ? ut : v;
  }
  function ut() {
    throw new Error("BigInt not supported");
  }
})(_Q);
var hw;
typeof window < "u" && (window.Buffer || (window.Buffer = _Q.Buffer), window.global || (window.global = window), window.process || (window.process = {}), (hw = window.process) != null && hw.env || (window.process = { env: {} }));
const Wue = {
  SECURE_SITE_SDK: "https://secure.web3modal.com/sdk",
  APP_EVENT_KEY: "@w3m-app/",
  FRAME_EVENT_KEY: "@w3m-frame/",
  RPC_METHOD_KEY: "RPC_",
  STORAGE_KEY: "@w3m-storage/",
  SESSION_TOKEN_KEY: "SESSION_TOKEN_KEY",
  EMAIL_LOGIN_USED_KEY: "EMAIL_LOGIN_USED_KEY",
  LAST_EMAIL_LOGIN_TIME: "LAST_EMAIL_LOGIN_TIME",
  APP_SWITCH_NETWORK: "@w3m-app/SWITCH_NETWORK",
  APP_CONNECT_EMAIL: "@w3m-app/CONNECT_EMAIL",
  APP_CONNECT_DEVICE: "@w3m-app/CONNECT_DEVICE",
  APP_CONNECT_OTP: "@w3m-app/CONNECT_OTP",
  APP_GET_USER: "@w3m-app/GET_USER",
  APP_SIGN_OUT: "@w3m-app/SIGN_OUT",
  APP_IS_CONNECTED: "@w3m-app/IS_CONNECTED",
  APP_GET_CHAIN_ID: "@w3m-app/GET_CHAIN_ID",
  APP_RPC_REQUEST: "@w3m-app/RPC_REQUEST",
  FRAME_SWITCH_NETWORK_ERROR: "@w3m-frame/SWITCH_NETWORK_ERROR",
  FRAME_SWITCH_NETWORK_SUCCESS: "@w3m-frame/SWITCH_NETWORK_SUCCESS",
  FRAME_CONNECT_EMAIL_ERROR: "@w3m-frame/CONNECT_EMAIL_ERROR",
  FRAME_CONNECT_EMAIL_SUCCESS: "@w3m-frame/CONNECT_EMAIL_SUCCESS",
  FRAME_CONNECT_DEVICE_ERROR: "@w3m-frame/CONNECT_DEVICE_ERROR",
  FRAME_CONNECT_DEVICE_SUCCESS: "@w3m-frame/CONNECT_DEVICE_SUCCESS",
  FRAME_CONNECT_OTP_SUCCESS: "@w3m-frame/CONNECT_OTP_SUCCESS",
  FRAME_CONNECT_OTP_ERROR: "@w3m-frame/CONNECT_OTP_ERROR",
  FRAME_GET_USER_SUCCESS: "@w3m-frame/GET_USER_SUCCESS",
  FRAME_GET_USER_ERROR: "@w3m-frame/GET_USER_ERROR",
  FRAME_SIGN_OUT_SUCCESS: "@w3m-frame/SIGN_OUT_SUCCESS",
  FRAME_SIGN_OUT_ERROR: "@w3m-frame/SIGN_OUT_ERROR",
  FRAME_IS_CONNECTED_SUCCESS: "@w3m-frame/IS_CONNECTED_SUCCESS",
  FRAME_IS_CONNECTED_ERROR: "@w3m-frame/IS_CONNECTED_ERROR",
  FRAME_GET_CHAIN_ID_SUCCESS: "@w3m-frame/GET_CHAIN_ID_SUCCESS",
  FRAME_GET_CHAIN_ID_ERROR: "@w3m-frame/GET_CHAIN_ID_ERROR",
  FRAME_RPC_REQUEST_SUCCESS: "@w3m-frame/RPC_REQUEST_SUCCESS",
  FRAME_RPC_REQUEST_ERROR: "@w3m-frame/RPC_REQUEST_ERROR",
  FRAME_SESSION_UPDATE: "@w3m-frame/SESSION_UPDATE"
};
var tn;
(function(t) {
  t.assertEqual = (i) => i;
  function e(i) {
  }
  t.assertIs = e;
  function n(i) {
    throw new Error();
  }
  t.assertNever = n, t.arrayToEnum = (i) => {
    const a = {};
    for (const o of i)
      a[o] = o;
    return a;
  }, t.getValidEnumValues = (i) => {
    const a = t.objectKeys(i).filter((s) => typeof i[i[s]] != "number"), o = {};
    for (const s of a)
      o[s] = i[s];
    return t.objectValues(o);
  }, t.objectValues = (i) => t.objectKeys(i).map(function(a) {
    return i[a];
  }), t.objectKeys = typeof Object.keys == "function" ? (i) => Object.keys(i) : (i) => {
    const a = [];
    for (const o in i)
      Object.prototype.hasOwnProperty.call(i, o) && a.push(o);
    return a;
  }, t.find = (i, a) => {
    for (const o of i)
      if (a(o))
        return o;
  }, t.isInteger = typeof Number.isInteger == "function" ? (i) => Number.isInteger(i) : (i) => typeof i == "number" && isFinite(i) && Math.floor(i) === i;
  function r(i, a = " | ") {
    return i.map((o) => typeof o == "string" ? `'${o}'` : o).join(a);
  }
  t.joinValues = r, t.jsonStringifyReplacer = (i, a) => typeof a == "bigint" ? a.toString() : a;
})(tn || (tn = {}));
var Tb;
(function(t) {
  t.mergeShapes = (e, n) => ({
    ...e,
    ...n
    // second overwrites first
  });
})(Tb || (Tb = {}));
const Ie = tn.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), yl = (t) => {
  switch (typeof t) {
    case "undefined":
      return Ie.undefined;
    case "string":
      return Ie.string;
    case "number":
      return isNaN(t) ? Ie.nan : Ie.number;
    case "boolean":
      return Ie.boolean;
    case "function":
      return Ie.function;
    case "bigint":
      return Ie.bigint;
    case "symbol":
      return Ie.symbol;
    case "object":
      return Array.isArray(t) ? Ie.array : t === null ? Ie.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? Ie.promise : typeof Map < "u" && t instanceof Map ? Ie.map : typeof Set < "u" && t instanceof Set ? Ie.set : typeof Date < "u" && t instanceof Date ? Ie.date : Ie.object;
    default:
      return Ie.unknown;
  }
}, Re = tn.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), jue = (t) => JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
class Aa extends Error {
  constructor(e) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = e;
  }
  get errors() {
    return this.issues;
  }
  format(e) {
    const n = e || function(a) {
      return a.message;
    }, r = { _errors: [] }, i = (a) => {
      for (const o of a.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(i);
        else if (o.code === "invalid_return_type")
          i(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          i(o.argumentsError);
        else if (o.path.length === 0)
          r._errors.push(n(o));
        else {
          let s = r, l = 0;
          for (; l < o.path.length; ) {
            const c = o.path[l];
            l === o.path.length - 1 ? (s[c] = s[c] || { _errors: [] }, s[c]._errors.push(n(o))) : s[c] = s[c] || { _errors: [] }, s = s[c], l++;
          }
        }
    };
    return i(this), r;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, tn.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (n) => n.message) {
    const n = {}, r = [];
    for (const i of this.issues)
      i.path.length > 0 ? (n[i.path[0]] = n[i.path[0]] || [], n[i.path[0]].push(e(i))) : r.push(e(i));
    return { formErrors: r, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
Aa.create = (t) => new Aa(t);
const EM = (t, e) => {
  let n;
  switch (t.code) {
    case Re.invalid_type:
      t.received === Ie.undefined ? n = "Required" : n = `Expected ${t.expected}, received ${t.received}`;
      break;
    case Re.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(t.expected, tn.jsonStringifyReplacer)}`;
      break;
    case Re.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${tn.joinValues(t.keys, ", ")}`;
      break;
    case Re.invalid_union:
      n = "Invalid input";
      break;
    case Re.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${tn.joinValues(t.options)}`;
      break;
    case Re.invalid_enum_value:
      n = `Invalid enum value. Expected ${tn.joinValues(t.options)}, received '${t.received}'`;
      break;
    case Re.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case Re.invalid_return_type:
      n = "Invalid function return type";
      break;
    case Re.invalid_date:
      n = "Invalid date";
      break;
    case Re.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (n = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? n = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? n = `Invalid input: must end with "${t.validation.endsWith}"` : tn.assertNever(t.validation) : t.validation !== "regex" ? n = `Invalid ${t.validation}` : n = "Invalid";
      break;
    case Re.too_small:
      t.type === "array" ? n = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? n = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? n = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : n = "Invalid input";
      break;
    case Re.too_big:
      t.type === "array" ? n = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? n = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? n = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? n = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : n = "Invalid input";
      break;
    case Re.custom:
      n = "Invalid input";
      break;
    case Re.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case Re.not_multiple_of:
      n = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case Re.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = e.defaultError, tn.assertNever(t);
  }
  return { message: n };
};
let KQ = EM;
function Due(t) {
  KQ = t;
}
function EV() {
  return KQ;
}
const SV = (t) => {
  const { data: e, path: n, errorMaps: r, issueData: i } = t, a = [...n, ...i.path || []], o = {
    ...i,
    path: a
  };
  let s = "";
  const l = r.filter((c) => !!c).slice().reverse();
  for (const c of l)
    s = c(o, { data: e, defaultError: s }).message;
  return {
    ...i,
    path: a,
    message: i.message || s
  };
}, zue = [];
function Qe(t, e) {
  const n = SV({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      t.schemaErrorMap,
      EV(),
      EM
      // then global default map
    ].filter((r) => !!r)
  });
  t.common.issues.push(n);
}
class ii {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, n) {
    const r = [];
    for (const i of n) {
      if (i.status === "aborted")
        return yt;
      i.status === "dirty" && e.dirty(), r.push(i.value);
    }
    return { status: e.value, value: r };
  }
  static async mergeObjectAsync(e, n) {
    const r = [];
    for (const i of n)
      r.push({
        key: await i.key,
        value: await i.value
      });
    return ii.mergeObjectSync(e, r);
  }
  static mergeObjectSync(e, n) {
    const r = {};
    for (const i of n) {
      const { key: a, value: o } = i;
      if (a.status === "aborted" || o.status === "aborted")
        return yt;
      a.status === "dirty" && e.dirty(), o.status === "dirty" && e.dirty(), a.value !== "__proto__" && (typeof o.value < "u" || i.alwaysSet) && (r[a.value] = o.value);
    }
    return { status: e.value, value: r };
  }
}
const yt = Object.freeze({
  status: "aborted"
}), $Q = (t) => ({ status: "dirty", value: t }), fi = (t) => ({ status: "valid", value: t }), fb = (t) => t.status === "aborted", Vb = (t) => t.status === "dirty", SM = (t) => t.status === "valid", xV = (t) => typeof Promise < "u" && t instanceof Promise;
var ot;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(ot || (ot = {}));
class Yo {
  constructor(e, n, r, i) {
    this._cachedPath = [], this.parent = e, this.data = n, this._path = r, this._key = i;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const S4 = (t, e) => {
  if (SM(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const n = new Aa(t.common.issues);
      return this._error = n, this._error;
    }
  };
};
function xt(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: n, required_error: r, description: i } = t;
  if (e && (n || r))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: i } : { errorMap: (o, s) => o.code !== "invalid_type" ? { message: s.defaultError } : typeof s.data > "u" ? { message: r ?? s.defaultError } : { message: n ?? s.defaultError }, description: i };
}
class zt {
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return yl(e.data);
  }
  _getOrReturnCtx(e, n) {
    return n || {
      common: e.parent.common,
      data: e.data,
      parsedType: yl(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new ii(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: yl(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const n = this._parse(e);
    if (xV(n))
      throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(e) {
    const n = this._parse(e);
    return Promise.resolve(n);
  }
  parse(e, n) {
    const r = this.safeParse(e, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  safeParse(e, n) {
    var r;
    const i = {
      common: {
        issues: [],
        async: (r = n == null ? void 0 : n.async) !== null && r !== void 0 ? r : !1,
        contextualErrorMap: n == null ? void 0 : n.errorMap
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: yl(e)
    }, a = this._parseSync({ data: e, path: i.path, parent: i });
    return S4(i, a);
  }
  async parseAsync(e, n) {
    const r = await this.safeParseAsync(e, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  async safeParseAsync(e, n) {
    const r = {
      common: {
        issues: [],
        contextualErrorMap: n == null ? void 0 : n.errorMap,
        async: !0
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: yl(e)
    }, i = this._parse({ data: e, path: r.path, parent: r }), a = await (xV(i) ? i : Promise.resolve(i));
    return S4(r, a);
  }
  refine(e, n) {
    const r = (i) => typeof n == "string" || typeof n > "u" ? { message: n } : typeof n == "function" ? n(i) : n;
    return this._refinement((i, a) => {
      const o = e(i), s = () => a.addIssue({
        code: Re.custom,
        ...r(i)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((l) => l ? !0 : (s(), !1)) : o ? !0 : (s(), !1);
    });
  }
  refinement(e, n) {
    return this._refinement((r, i) => e(r) ? !0 : (i.addIssue(typeof n == "function" ? n(r, i) : n), !1));
  }
  _refinement(e) {
    return new $a({
      schema: this,
      typeName: pt.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  optional() {
    return Ss.create(this, this._def);
  }
  nullable() {
    return Hd.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return Ha.create(this, this._def);
  }
  promise() {
    return Rh.create(this, this._def);
  }
  or(e) {
    return DM.create([this, e], this._def);
  }
  and(e) {
    return zM.create(this, e, this._def);
  }
  transform(e) {
    return new $a({
      ...xt(this._def),
      schema: this,
      typeName: pt.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const n = typeof e == "function" ? e : () => e;
    return new IM({
      ...xt(this._def),
      innerType: this,
      defaultValue: n,
      typeName: pt.ZodDefault
    });
  }
  brand() {
    return new eG({
      typeName: pt.ZodBranded,
      type: this,
      ...xt(this._def)
    });
  }
  catch(e) {
    const n = typeof e == "function" ? e : () => e;
    return new zV({
      ...xt(this._def),
      innerType: this,
      catchValue: n,
      typeName: pt.ZodCatch
    });
  }
  describe(e) {
    const n = this.constructor;
    return new n({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return am.create(this, e);
  }
  readonly() {
    return wV.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const kue = /^c[^\s-]{8,}$/i, wue = /^[a-z][a-z0-9]*$/, Fue = /^[0-9A-HJKMNP-TV-Z]{26}$/, vue = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Iue = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, Oue = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Sg;
const Yue = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/, Que = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, Gue = (t) => t.precision ? t.offset ? new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${t.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`) : new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${t.precision}}Z$`) : t.precision === 0 ? t.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$") : t.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
function Cue(t, e) {
  return !!((e === "v4" || !e) && Yue.test(t) || (e === "v6" || !e) && Que.test(t));
}
class Ja extends zt {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== Ie.string) {
      const a = this._getOrReturnCtx(e);
      return Qe(
        a,
        {
          code: Re.invalid_type,
          expected: Ie.string,
          received: a.parsedType
        }
        //
      ), yt;
    }
    const r = new ii();
    let i;
    for (const a of this._def.checks)
      if (a.kind === "min")
        e.data.length < a.value && (i = this._getOrReturnCtx(e, i), Qe(i, {
          code: Re.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), r.dirty());
      else if (a.kind === "max")
        e.data.length > a.value && (i = this._getOrReturnCtx(e, i), Qe(i, {
          code: Re.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), r.dirty());
      else if (a.kind === "length") {
        const o = e.data.length > a.value, s = e.data.length < a.value;
        (o || s) && (i = this._getOrReturnCtx(e, i), o ? Qe(i, {
          code: Re.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }) : s && Qe(i, {
          code: Re.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }), r.dirty());
      } else if (a.kind === "email")
        Iue.test(e.data) || (i = this._getOrReturnCtx(e, i), Qe(i, {
          validation: "email",
          code: Re.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "emoji")
        Sg || (Sg = new RegExp(Oue, "u")), Sg.test(e.data) || (i = this._getOrReturnCtx(e, i), Qe(i, {
          validation: "emoji",
          code: Re.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "uuid")
        vue.test(e.data) || (i = this._getOrReturnCtx(e, i), Qe(i, {
          validation: "uuid",
          code: Re.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "cuid")
        kue.test(e.data) || (i = this._getOrReturnCtx(e, i), Qe(i, {
          validation: "cuid",
          code: Re.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "cuid2")
        wue.test(e.data) || (i = this._getOrReturnCtx(e, i), Qe(i, {
          validation: "cuid2",
          code: Re.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "ulid")
        Fue.test(e.data) || (i = this._getOrReturnCtx(e, i), Qe(i, {
          validation: "ulid",
          code: Re.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "url")
        try {
          new URL(e.data);
        } catch {
          i = this._getOrReturnCtx(e, i), Qe(i, {
            validation: "url",
            code: Re.invalid_string,
            message: a.message
          }), r.dirty();
        }
      else
        a.kind === "regex" ? (a.regex.lastIndex = 0, a.regex.test(e.data) || (i = this._getOrReturnCtx(e, i), Qe(i, {
          validation: "regex",
          code: Re.invalid_string,
          message: a.message
        }), r.dirty())) : a.kind === "trim" ? e.data = e.data.trim() : a.kind === "includes" ? e.data.includes(a.value, a.position) || (i = this._getOrReturnCtx(e, i), Qe(i, {
          code: Re.invalid_string,
          validation: { includes: a.value, position: a.position },
          message: a.message
        }), r.dirty()) : a.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : a.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : a.kind === "startsWith" ? e.data.startsWith(a.value) || (i = this._getOrReturnCtx(e, i), Qe(i, {
          code: Re.invalid_string,
          validation: { startsWith: a.value },
          message: a.message
        }), r.dirty()) : a.kind === "endsWith" ? e.data.endsWith(a.value) || (i = this._getOrReturnCtx(e, i), Qe(i, {
          code: Re.invalid_string,
          validation: { endsWith: a.value },
          message: a.message
        }), r.dirty()) : a.kind === "datetime" ? Gue(a).test(e.data) || (i = this._getOrReturnCtx(e, i), Qe(i, {
          code: Re.invalid_string,
          validation: "datetime",
          message: a.message
        }), r.dirty()) : a.kind === "ip" ? Cue(e.data, a.version) || (i = this._getOrReturnCtx(e, i), Qe(i, {
          validation: "ip",
          code: Re.invalid_string,
          message: a.message
        }), r.dirty()) : tn.assertNever(a);
    return { status: r.value, value: e.data };
  }
  _regex(e, n, r) {
    return this.refinement((i) => e.test(i), {
      validation: n,
      code: Re.invalid_string,
      ...ot.errToObj(r)
    });
  }
  _addCheck(e) {
    return new Ja({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...ot.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...ot.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...ot.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...ot.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...ot.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...ot.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...ot.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...ot.errToObj(e) });
  }
  datetime(e) {
    var n;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (n = e == null ? void 0 : e.offset) !== null && n !== void 0 ? n : !1,
      ...ot.errToObj(e == null ? void 0 : e.message)
    });
  }
  regex(e, n) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...ot.errToObj(n)
    });
  }
  includes(e, n) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: n == null ? void 0 : n.position,
      ...ot.errToObj(n == null ? void 0 : n.message)
    });
  }
  startsWith(e, n) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...ot.errToObj(n)
    });
  }
  endsWith(e, n) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...ot.errToObj(n)
    });
  }
  min(e, n) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...ot.errToObj(n)
    });
  }
  max(e, n) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...ot.errToObj(n)
    });
  }
  length(e, n) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...ot.errToObj(n)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(e) {
    return this.min(1, ot.errToObj(e));
  }
  trim() {
    return new Ja({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Ja({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Ja({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get minLength() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
Ja.create = (t) => {
  var e;
  return new Ja({
    checks: [],
    typeName: pt.ZodString,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...xt(t)
  });
};
function Lue(t, e) {
  const n = (t.toString().split(".")[1] || "").length, r = (e.toString().split(".")[1] || "").length, i = n > r ? n : r, a = parseInt(t.toFixed(i).replace(".", "")), o = parseInt(e.toFixed(i).replace(".", ""));
  return a % o / Math.pow(10, i);
}
class sc extends zt {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== Ie.number) {
      const a = this._getOrReturnCtx(e);
      return Qe(a, {
        code: Re.invalid_type,
        expected: Ie.number,
        received: a.parsedType
      }), yt;
    }
    let r;
    const i = new ii();
    for (const a of this._def.checks)
      a.kind === "int" ? tn.isInteger(e.data) || (r = this._getOrReturnCtx(e, r), Qe(r, {
        code: Re.invalid_type,
        expected: "integer",
        received: "float",
        message: a.message
      }), i.dirty()) : a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (r = this._getOrReturnCtx(e, r), Qe(r, {
        code: Re.too_small,
        minimum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), i.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (r = this._getOrReturnCtx(e, r), Qe(r, {
        code: Re.too_big,
        maximum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), i.dirty()) : a.kind === "multipleOf" ? Lue(e.data, a.value) !== 0 && (r = this._getOrReturnCtx(e, r), Qe(r, {
        code: Re.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), i.dirty()) : a.kind === "finite" ? Number.isFinite(e.data) || (r = this._getOrReturnCtx(e, r), Qe(r, {
        code: Re.not_finite,
        message: a.message
      }), i.dirty()) : tn.assertNever(a);
    return { status: i.value, value: e.data };
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, ot.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, ot.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, ot.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, ot.toString(n));
  }
  setLimit(e, n, r, i) {
    return new sc({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: n,
          inclusive: r,
          message: ot.toString(i)
        }
      ]
    });
  }
  _addCheck(e) {
    return new sc({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: ot.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: ot.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: ot.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: ot.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: ot.toString(e)
    });
  }
  multipleOf(e, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: ot.toString(n)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: ot.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: ot.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: ot.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && tn.isInteger(e.value));
  }
  get isFinite() {
    let e = null, n = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf")
        return !0;
      r.kind === "min" ? (n === null || r.value > n) && (n = r.value) : r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    }
    return Number.isFinite(n) && Number.isFinite(e);
  }
}
sc.create = (t) => new sc({
  checks: [],
  typeName: pt.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...xt(t)
});
class lc extends zt {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = BigInt(e.data)), this._getType(e) !== Ie.bigint) {
      const a = this._getOrReturnCtx(e);
      return Qe(a, {
        code: Re.invalid_type,
        expected: Ie.bigint,
        received: a.parsedType
      }), yt;
    }
    let r;
    const i = new ii();
    for (const a of this._def.checks)
      a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (r = this._getOrReturnCtx(e, r), Qe(r, {
        code: Re.too_small,
        type: "bigint",
        minimum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), i.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (r = this._getOrReturnCtx(e, r), Qe(r, {
        code: Re.too_big,
        type: "bigint",
        maximum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), i.dirty()) : a.kind === "multipleOf" ? e.data % a.value !== BigInt(0) && (r = this._getOrReturnCtx(e, r), Qe(r, {
        code: Re.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), i.dirty()) : tn.assertNever(a);
    return { status: i.value, value: e.data };
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, ot.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, ot.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, ot.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, ot.toString(n));
  }
  setLimit(e, n, r, i) {
    return new lc({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: n,
          inclusive: r,
          message: ot.toString(i)
        }
      ]
    });
  }
  _addCheck(e) {
    return new lc({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: ot.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: ot.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: ot.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: ot.toString(e)
    });
  }
  multipleOf(e, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: ot.toString(n)
    });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
lc.create = (t) => {
  var e;
  return new lc({
    checks: [],
    typeName: pt.ZodBigInt,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...xt(t)
  });
};
class xM extends zt {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== Ie.boolean) {
      const r = this._getOrReturnCtx(e);
      return Qe(r, {
        code: Re.invalid_type,
        expected: Ie.boolean,
        received: r.parsedType
      }), yt;
    }
    return fi(e.data);
  }
}
xM.create = (t) => new xM({
  typeName: pt.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...xt(t)
});
class Bd extends zt {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== Ie.date) {
      const a = this._getOrReturnCtx(e);
      return Qe(a, {
        code: Re.invalid_type,
        expected: Ie.date,
        received: a.parsedType
      }), yt;
    }
    if (isNaN(e.data.getTime())) {
      const a = this._getOrReturnCtx(e);
      return Qe(a, {
        code: Re.invalid_date
      }), yt;
    }
    const r = new ii();
    let i;
    for (const a of this._def.checks)
      a.kind === "min" ? e.data.getTime() < a.value && (i = this._getOrReturnCtx(e, i), Qe(i, {
        code: Re.too_small,
        message: a.message,
        inclusive: !0,
        exact: !1,
        minimum: a.value,
        type: "date"
      }), r.dirty()) : a.kind === "max" ? e.data.getTime() > a.value && (i = this._getOrReturnCtx(e, i), Qe(i, {
        code: Re.too_big,
        message: a.message,
        inclusive: !0,
        exact: !1,
        maximum: a.value,
        type: "date"
      }), r.dirty()) : tn.assertNever(a);
    return {
      status: r.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new Bd({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, n) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: ot.toString(n)
    });
  }
  max(e, n) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: ot.toString(n)
    });
  }
  get minDate() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
}
Bd.create = (t) => new Bd({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: pt.ZodDate,
  ...xt(t)
});
class WV extends zt {
  _parse(e) {
    if (this._getType(e) !== Ie.symbol) {
      const r = this._getOrReturnCtx(e);
      return Qe(r, {
        code: Re.invalid_type,
        expected: Ie.symbol,
        received: r.parsedType
      }), yt;
    }
    return fi(e.data);
  }
}
WV.create = (t) => new WV({
  typeName: pt.ZodSymbol,
  ...xt(t)
});
class WM extends zt {
  _parse(e) {
    if (this._getType(e) !== Ie.undefined) {
      const r = this._getOrReturnCtx(e);
      return Qe(r, {
        code: Re.invalid_type,
        expected: Ie.undefined,
        received: r.parsedType
      }), yt;
    }
    return fi(e.data);
  }
}
WM.create = (t) => new WM({
  typeName: pt.ZodUndefined,
  ...xt(t)
});
class jM extends zt {
  _parse(e) {
    if (this._getType(e) !== Ie.null) {
      const r = this._getOrReturnCtx(e);
      return Qe(r, {
        code: Re.invalid_type,
        expected: Ie.null,
        received: r.parsedType
      }), yt;
    }
    return fi(e.data);
  }
}
jM.create = (t) => new jM({
  typeName: pt.ZodNull,
  ...xt(t)
});
class Uh extends zt {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return fi(e.data);
  }
}
Uh.create = (t) => new Uh({
  typeName: pt.ZodAny,
  ...xt(t)
});
class Ed extends zt {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return fi(e.data);
  }
}
Ed.create = (t) => new Ed({
  typeName: pt.ZodUnknown,
  ...xt(t)
});
class Gs extends zt {
  _parse(e) {
    const n = this._getOrReturnCtx(e);
    return Qe(n, {
      code: Re.invalid_type,
      expected: Ie.never,
      received: n.parsedType
    }), yt;
  }
}
Gs.create = (t) => new Gs({
  typeName: pt.ZodNever,
  ...xt(t)
});
class jV extends zt {
  _parse(e) {
    if (this._getType(e) !== Ie.undefined) {
      const r = this._getOrReturnCtx(e);
      return Qe(r, {
        code: Re.invalid_type,
        expected: Ie.void,
        received: r.parsedType
      }), yt;
    }
    return fi(e.data);
  }
}
jV.create = (t) => new jV({
  typeName: pt.ZodVoid,
  ...xt(t)
});
class Ha extends zt {
  _parse(e) {
    const { ctx: n, status: r } = this._processInputParams(e), i = this._def;
    if (n.parsedType !== Ie.array)
      return Qe(n, {
        code: Re.invalid_type,
        expected: Ie.array,
        received: n.parsedType
      }), yt;
    if (i.exactLength !== null) {
      const o = n.data.length > i.exactLength.value, s = n.data.length < i.exactLength.value;
      (o || s) && (Qe(n, {
        code: o ? Re.too_big : Re.too_small,
        minimum: s ? i.exactLength.value : void 0,
        maximum: o ? i.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: i.exactLength.message
      }), r.dirty());
    }
    if (i.minLength !== null && n.data.length < i.minLength.value && (Qe(n, {
      code: Re.too_small,
      minimum: i.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.minLength.message
    }), r.dirty()), i.maxLength !== null && n.data.length > i.maxLength.value && (Qe(n, {
      code: Re.too_big,
      maximum: i.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.maxLength.message
    }), r.dirty()), n.common.async)
      return Promise.all([...n.data].map((o, s) => i.type._parseAsync(new Yo(n, o, n.path, s)))).then((o) => ii.mergeArray(r, o));
    const a = [...n.data].map((o, s) => i.type._parseSync(new Yo(n, o, n.path, s)));
    return ii.mergeArray(r, a);
  }
  get element() {
    return this._def.type;
  }
  min(e, n) {
    return new Ha({
      ...this._def,
      minLength: { value: e, message: ot.toString(n) }
    });
  }
  max(e, n) {
    return new Ha({
      ...this._def,
      maxLength: { value: e, message: ot.toString(n) }
    });
  }
  length(e, n) {
    return new Ha({
      ...this._def,
      exactLength: { value: e, message: ot.toString(n) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
Ha.create = (t, e) => new Ha({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: pt.ZodArray,
  ...xt(e)
});
function Hu(t) {
  if (t instanceof Hn) {
    const e = {};
    for (const n in t.shape) {
      const r = t.shape[n];
      e[n] = Ss.create(Hu(r));
    }
    return new Hn({
      ...t._def,
      shape: () => e
    });
  } else
    return t instanceof Ha ? new Ha({
      ...t._def,
      type: Hu(t.element)
    }) : t instanceof Ss ? Ss.create(Hu(t.unwrap())) : t instanceof Hd ? Hd.create(Hu(t.unwrap())) : t instanceof Qo ? Qo.create(t.items.map((e) => Hu(e))) : t;
}
class Hn extends zt {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), n = tn.objectKeys(e);
    return this._cached = { shape: e, keys: n };
  }
  _parse(e) {
    if (this._getType(e) !== Ie.object) {
      const c = this._getOrReturnCtx(e);
      return Qe(c, {
        code: Re.invalid_type,
        expected: Ie.object,
        received: c.parsedType
      }), yt;
    }
    const { status: r, ctx: i } = this._processInputParams(e), { shape: a, keys: o } = this._getCached(), s = [];
    if (!(this._def.catchall instanceof Gs && this._def.unknownKeys === "strip"))
      for (const c in i.data)
        o.includes(c) || s.push(c);
    const l = [];
    for (const c of o) {
      const d = a[c], u = i.data[c];
      l.push({
        key: { status: "valid", value: c },
        value: d._parse(new Yo(i, u, i.path, c)),
        alwaysSet: c in i.data
      });
    }
    if (this._def.catchall instanceof Gs) {
      const c = this._def.unknownKeys;
      if (c === "passthrough")
        for (const d of s)
          l.push({
            key: { status: "valid", value: d },
            value: { status: "valid", value: i.data[d] }
          });
      else if (c === "strict")
        s.length > 0 && (Qe(i, {
          code: Re.unrecognized_keys,
          keys: s
        }), r.dirty());
      else if (c !== "strip")
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const c = this._def.catchall;
      for (const d of s) {
        const u = i.data[d];
        l.push({
          key: { status: "valid", value: d },
          value: c._parse(
            new Yo(i, u, i.path, d)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: d in i.data
        });
      }
    }
    return i.common.async ? Promise.resolve().then(async () => {
      const c = [];
      for (const d of l) {
        const u = await d.key;
        c.push({
          key: u,
          value: await d.value,
          alwaysSet: d.alwaysSet
        });
      }
      return c;
    }).then((c) => ii.mergeObjectSync(r, c)) : ii.mergeObjectSync(r, l);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return ot.errToObj, new Hn({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (n, r) => {
          var i, a, o, s;
          const l = (o = (a = (i = this._def).errorMap) === null || a === void 0 ? void 0 : a.call(i, n, r).message) !== null && o !== void 0 ? o : r.defaultError;
          return n.code === "unrecognized_keys" ? {
            message: (s = ot.errToObj(e).message) !== null && s !== void 0 ? s : l
          } : {
            message: l
          };
        }
      } : {}
    });
  }
  strip() {
    return new Hn({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new Hn({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new Hn({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new Hn({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: pt.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, n) {
    return this.augment({ [e]: n });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new Hn({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const n = {};
    return tn.objectKeys(e).forEach((r) => {
      e[r] && this.shape[r] && (n[r] = this.shape[r]);
    }), new Hn({
      ...this._def,
      shape: () => n
    });
  }
  omit(e) {
    const n = {};
    return tn.objectKeys(this.shape).forEach((r) => {
      e[r] || (n[r] = this.shape[r]);
    }), new Hn({
      ...this._def,
      shape: () => n
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return Hu(this);
  }
  partial(e) {
    const n = {};
    return tn.objectKeys(this.shape).forEach((r) => {
      const i = this.shape[r];
      e && !e[r] ? n[r] = i : n[r] = i.optional();
    }), new Hn({
      ...this._def,
      shape: () => n
    });
  }
  required(e) {
    const n = {};
    return tn.objectKeys(this.shape).forEach((r) => {
      if (e && !e[r])
        n[r] = this.shape[r];
      else {
        let a = this.shape[r];
        for (; a instanceof Ss; )
          a = a._def.innerType;
        n[r] = a;
      }
    }), new Hn({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return qQ(tn.objectKeys(this.shape));
  }
}
Hn.create = (t, e) => new Hn({
  shape: () => t,
  unknownKeys: "strip",
  catchall: Gs.create(),
  typeName: pt.ZodObject,
  ...xt(e)
});
Hn.strictCreate = (t, e) => new Hn({
  shape: () => t,
  unknownKeys: "strict",
  catchall: Gs.create(),
  typeName: pt.ZodObject,
  ...xt(e)
});
Hn.lazycreate = (t, e) => new Hn({
  shape: t,
  unknownKeys: "strip",
  catchall: Gs.create(),
  typeName: pt.ZodObject,
  ...xt(e)
});
class DM extends zt {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = this._def.options;
    function i(a) {
      for (const s of a)
        if (s.result.status === "valid")
          return s.result;
      for (const s of a)
        if (s.result.status === "dirty")
          return n.common.issues.push(...s.ctx.common.issues), s.result;
      const o = a.map((s) => new Aa(s.ctx.common.issues));
      return Qe(n, {
        code: Re.invalid_union,
        unionErrors: o
      }), yt;
    }
    if (n.common.async)
      return Promise.all(r.map(async (a) => {
        const o = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await a._parseAsync({
            data: n.data,
            path: n.path,
            parent: o
          }),
          ctx: o
        };
      })).then(i);
    {
      let a;
      const o = [];
      for (const l of r) {
        const c = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        }, d = l._parseSync({
          data: n.data,
          path: n.path,
          parent: c
        });
        if (d.status === "valid")
          return d;
        d.status === "dirty" && !a && (a = { result: d, ctx: c }), c.common.issues.length && o.push(c.common.issues);
      }
      if (a)
        return n.common.issues.push(...a.ctx.common.issues), a.result;
      const s = o.map((l) => new Aa(l));
      return Qe(n, {
        code: Re.invalid_union,
        unionErrors: s
      }), yt;
    }
  }
  get options() {
    return this._def.options;
  }
}
DM.create = (t, e) => new DM({
  options: t,
  typeName: pt.ZodUnion,
  ...xt(e)
});
const XT = (t) => t instanceof wM ? XT(t.schema) : t instanceof $a ? XT(t.innerType()) : t instanceof FM ? [t.value] : t instanceof cc ? t.options : t instanceof vM ? Object.keys(t.enum) : t instanceof IM ? XT(t._def.innerType) : t instanceof WM ? [void 0] : t instanceof jM ? [null] : null;
class SU extends zt {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== Ie.object)
      return Qe(n, {
        code: Re.invalid_type,
        expected: Ie.object,
        received: n.parsedType
      }), yt;
    const r = this.discriminator, i = n.data[r], a = this.optionsMap.get(i);
    return a ? n.common.async ? a._parseAsync({
      data: n.data,
      path: n.path,
      parent: n
    }) : a._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }) : (Qe(n, {
      code: Re.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [r]
    }), yt);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, n, r) {
    const i = /* @__PURE__ */ new Map();
    for (const a of n) {
      const o = XT(a.shape[e]);
      if (!o)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const s of o) {
        if (i.has(s))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(s)}`);
        i.set(s, a);
      }
    }
    return new SU({
      typeName: pt.ZodDiscriminatedUnion,
      discriminator: e,
      options: n,
      optionsMap: i,
      ...xt(r)
    });
  }
}
function Ub(t, e) {
  const n = yl(t), r = yl(e);
  if (t === e)
    return { valid: !0, data: t };
  if (n === Ie.object && r === Ie.object) {
    const i = tn.objectKeys(e), a = tn.objectKeys(t).filter((s) => i.indexOf(s) !== -1), o = { ...t, ...e };
    for (const s of a) {
      const l = Ub(t[s], e[s]);
      if (!l.valid)
        return { valid: !1 };
      o[s] = l.data;
    }
    return { valid: !0, data: o };
  } else if (n === Ie.array && r === Ie.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const i = [];
    for (let a = 0; a < t.length; a++) {
      const o = t[a], s = e[a], l = Ub(o, s);
      if (!l.valid)
        return { valid: !1 };
      i.push(l.data);
    }
    return { valid: !0, data: i };
  } else
    return n === Ie.date && r === Ie.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class zM extends zt {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e), i = (a, o) => {
      if (fb(a) || fb(o))
        return yt;
      const s = Ub(a.value, o.value);
      return s.valid ? ((Vb(a) || Vb(o)) && n.dirty(), { status: n.value, value: s.data }) : (Qe(r, {
        code: Re.invalid_intersection_types
      }), yt);
    };
    return r.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      }),
      this._def.right._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      })
    ]).then(([a, o]) => i(a, o)) : i(this._def.left._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }), this._def.right._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }));
  }
}
zM.create = (t, e, n) => new zM({
  left: t,
  right: e,
  typeName: pt.ZodIntersection,
  ...xt(n)
});
class Qo extends zt {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== Ie.array)
      return Qe(r, {
        code: Re.invalid_type,
        expected: Ie.array,
        received: r.parsedType
      }), yt;
    if (r.data.length < this._def.items.length)
      return Qe(r, {
        code: Re.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), yt;
    !this._def.rest && r.data.length > this._def.items.length && (Qe(r, {
      code: Re.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const a = [...r.data].map((o, s) => {
      const l = this._def.items[s] || this._def.rest;
      return l ? l._parse(new Yo(r, o, r.path, s)) : null;
    }).filter((o) => !!o);
    return r.common.async ? Promise.all(a).then((o) => ii.mergeArray(n, o)) : ii.mergeArray(n, a);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new Qo({
      ...this._def,
      rest: e
    });
  }
}
Qo.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Qo({
    items: t,
    typeName: pt.ZodTuple,
    rest: null,
    ...xt(e)
  });
};
class kM extends zt {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== Ie.object)
      return Qe(r, {
        code: Re.invalid_type,
        expected: Ie.object,
        received: r.parsedType
      }), yt;
    const i = [], a = this._def.keyType, o = this._def.valueType;
    for (const s in r.data)
      i.push({
        key: a._parse(new Yo(r, s, r.path, s)),
        value: o._parse(new Yo(r, r.data[s], r.path, s))
      });
    return r.common.async ? ii.mergeObjectAsync(n, i) : ii.mergeObjectSync(n, i);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, n, r) {
    return n instanceof zt ? new kM({
      keyType: e,
      valueType: n,
      typeName: pt.ZodRecord,
      ...xt(r)
    }) : new kM({
      keyType: Ja.create(),
      valueType: e,
      typeName: pt.ZodRecord,
      ...xt(n)
    });
  }
}
class DV extends zt {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== Ie.map)
      return Qe(r, {
        code: Re.invalid_type,
        expected: Ie.map,
        received: r.parsedType
      }), yt;
    const i = this._def.keyType, a = this._def.valueType, o = [...r.data.entries()].map(([s, l], c) => ({
      key: i._parse(new Yo(r, s, r.path, [c, "key"])),
      value: a._parse(new Yo(r, l, r.path, [c, "value"]))
    }));
    if (r.common.async) {
      const s = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of o) {
          const c = await l.key, d = await l.value;
          if (c.status === "aborted" || d.status === "aborted")
            return yt;
          (c.status === "dirty" || d.status === "dirty") && n.dirty(), s.set(c.value, d.value);
        }
        return { status: n.value, value: s };
      });
    } else {
      const s = /* @__PURE__ */ new Map();
      for (const l of o) {
        const c = l.key, d = l.value;
        if (c.status === "aborted" || d.status === "aborted")
          return yt;
        (c.status === "dirty" || d.status === "dirty") && n.dirty(), s.set(c.value, d.value);
      }
      return { status: n.value, value: s };
    }
  }
}
DV.create = (t, e, n) => new DV({
  valueType: e,
  keyType: t,
  typeName: pt.ZodMap,
  ...xt(n)
});
class Ad extends zt {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== Ie.set)
      return Qe(r, {
        code: Re.invalid_type,
        expected: Ie.set,
        received: r.parsedType
      }), yt;
    const i = this._def;
    i.minSize !== null && r.data.size < i.minSize.value && (Qe(r, {
      code: Re.too_small,
      minimum: i.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.minSize.message
    }), n.dirty()), i.maxSize !== null && r.data.size > i.maxSize.value && (Qe(r, {
      code: Re.too_big,
      maximum: i.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.maxSize.message
    }), n.dirty());
    const a = this._def.valueType;
    function o(l) {
      const c = /* @__PURE__ */ new Set();
      for (const d of l) {
        if (d.status === "aborted")
          return yt;
        d.status === "dirty" && n.dirty(), c.add(d.value);
      }
      return { status: n.value, value: c };
    }
    const s = [...r.data.values()].map((l, c) => a._parse(new Yo(r, l, r.path, c)));
    return r.common.async ? Promise.all(s).then((l) => o(l)) : o(s);
  }
  min(e, n) {
    return new Ad({
      ...this._def,
      minSize: { value: e, message: ot.toString(n) }
    });
  }
  max(e, n) {
    return new Ad({
      ...this._def,
      maxSize: { value: e, message: ot.toString(n) }
    });
  }
  size(e, n) {
    return this.min(e, n).max(e, n);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
Ad.create = (t, e) => new Ad({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: pt.ZodSet,
  ...xt(e)
});
class m0 extends zt {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== Ie.function)
      return Qe(n, {
        code: Re.invalid_type,
        expected: Ie.function,
        received: n.parsedType
      }), yt;
    function r(s, l) {
      return SV({
        data: s,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          EV(),
          EM
        ].filter((c) => !!c),
        issueData: {
          code: Re.invalid_arguments,
          argumentsError: l
        }
      });
    }
    function i(s, l) {
      return SV({
        data: s,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          EV(),
          EM
        ].filter((c) => !!c),
        issueData: {
          code: Re.invalid_return_type,
          returnTypeError: l
        }
      });
    }
    const a = { errorMap: n.common.contextualErrorMap }, o = n.data;
    if (this._def.returns instanceof Rh) {
      const s = this;
      return fi(async function(...l) {
        const c = new Aa([]), d = await s._def.args.parseAsync(l, a).catch((N) => {
          throw c.addIssue(r(l, N)), c;
        }), u = await Reflect.apply(o, this, d);
        return await s._def.returns._def.type.parseAsync(u, a).catch((N) => {
          throw c.addIssue(i(u, N)), c;
        });
      });
    } else {
      const s = this;
      return fi(function(...l) {
        const c = s._def.args.safeParse(l, a);
        if (!c.success)
          throw new Aa([r(l, c.error)]);
        const d = Reflect.apply(o, this, c.data), u = s._def.returns.safeParse(d, a);
        if (!u.success)
          throw new Aa([i(d, u.error)]);
        return u.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new m0({
      ...this._def,
      args: Qo.create(e).rest(Ed.create())
    });
  }
  returns(e) {
    return new m0({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, n, r) {
    return new m0({
      args: e || Qo.create([]).rest(Ed.create()),
      returns: n || Ed.create(),
      typeName: pt.ZodFunction,
      ...xt(r)
    });
  }
}
class wM extends zt {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
wM.create = (t, e) => new wM({
  getter: t,
  typeName: pt.ZodLazy,
  ...xt(e)
});
class FM extends zt {
  _parse(e) {
    if (e.data !== this._def.value) {
      const n = this._getOrReturnCtx(e);
      return Qe(n, {
        received: n.data,
        code: Re.invalid_literal,
        expected: this._def.value
      }), yt;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
FM.create = (t, e) => new FM({
  value: t,
  typeName: pt.ZodLiteral,
  ...xt(e)
});
function qQ(t, e) {
  return new cc({
    values: t,
    typeName: pt.ZodEnum,
    ...xt(e)
  });
}
class cc extends zt {
  _parse(e) {
    if (typeof e.data != "string") {
      const n = this._getOrReturnCtx(e), r = this._def.values;
      return Qe(n, {
        expected: tn.joinValues(r),
        received: n.parsedType,
        code: Re.invalid_type
      }), yt;
    }
    if (this._def.values.indexOf(e.data) === -1) {
      const n = this._getOrReturnCtx(e), r = this._def.values;
      return Qe(n, {
        received: n.data,
        code: Re.invalid_enum_value,
        options: r
      }), yt;
    }
    return fi(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  get Values() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  get Enum() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  extract(e) {
    return cc.create(e);
  }
  exclude(e) {
    return cc.create(this.options.filter((n) => !e.includes(n)));
  }
}
cc.create = qQ;
class vM extends zt {
  _parse(e) {
    const n = tn.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(e);
    if (r.parsedType !== Ie.string && r.parsedType !== Ie.number) {
      const i = tn.objectValues(n);
      return Qe(r, {
        expected: tn.joinValues(i),
        received: r.parsedType,
        code: Re.invalid_type
      }), yt;
    }
    if (n.indexOf(e.data) === -1) {
      const i = tn.objectValues(n);
      return Qe(r, {
        received: r.data,
        code: Re.invalid_enum_value,
        options: i
      }), yt;
    }
    return fi(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
vM.create = (t, e) => new vM({
  values: t,
  typeName: pt.ZodNativeEnum,
  ...xt(e)
});
class Rh extends zt {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== Ie.promise && n.common.async === !1)
      return Qe(n, {
        code: Re.invalid_type,
        expected: Ie.promise,
        received: n.parsedType
      }), yt;
    const r = n.parsedType === Ie.promise ? n.data : Promise.resolve(n.data);
    return fi(r.then((i) => this._def.type.parseAsync(i, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
}
Rh.create = (t, e) => new Rh({
  type: t,
  typeName: pt.ZodPromise,
  ...xt(e)
});
class $a extends zt {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === pt.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e), i = this._def.effect || null, a = {
      addIssue: (o) => {
        Qe(r, o), o.fatal ? n.abort() : n.dirty();
      },
      get path() {
        return r.path;
      }
    };
    if (a.addIssue = a.addIssue.bind(a), i.type === "preprocess") {
      const o = i.transform(r.data, a);
      return r.common.issues.length ? {
        status: "dirty",
        value: r.data
      } : r.common.async ? Promise.resolve(o).then((s) => this._def.schema._parseAsync({
        data: s,
        path: r.path,
        parent: r
      })) : this._def.schema._parseSync({
        data: o,
        path: r.path,
        parent: r
      });
    }
    if (i.type === "refinement") {
      const o = (s) => {
        const l = i.refinement(s, a);
        if (r.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return s;
      };
      if (r.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return s.status === "aborted" ? yt : (s.status === "dirty" && n.dirty(), o(s.value), { status: n.value, value: s.value });
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((s) => s.status === "aborted" ? yt : (s.status === "dirty" && n.dirty(), o(s.value).then(() => ({ status: n.value, value: s.value }))));
    }
    if (i.type === "transform")
      if (r.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        if (!SM(o))
          return o;
        const s = i.transform(o.value, a);
        if (s instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: s };
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((o) => SM(o) ? Promise.resolve(i.transform(o.value, a)).then((s) => ({ status: n.value, value: s })) : o);
    tn.assertNever(i);
  }
}
$a.create = (t, e, n) => new $a({
  schema: t,
  typeName: pt.ZodEffects,
  effect: e,
  ...xt(n)
});
$a.createWithPreprocess = (t, e, n) => new $a({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: pt.ZodEffects,
  ...xt(n)
});
class Ss extends zt {
  _parse(e) {
    return this._getType(e) === Ie.undefined ? fi(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ss.create = (t, e) => new Ss({
  innerType: t,
  typeName: pt.ZodOptional,
  ...xt(e)
});
class Hd extends zt {
  _parse(e) {
    return this._getType(e) === Ie.null ? fi(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Hd.create = (t, e) => new Hd({
  innerType: t,
  typeName: pt.ZodNullable,
  ...xt(e)
});
class IM extends zt {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    let r = n.data;
    return n.parsedType === Ie.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
IM.create = (t, e) => new IM({
  innerType: t,
  typeName: pt.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...xt(e)
});
class zV extends zt {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = {
      ...n,
      common: {
        ...n.common,
        issues: []
      }
    }, i = this._def.innerType._parse({
      data: r.data,
      path: r.path,
      parent: {
        ...r
      }
    });
    return xV(i) ? i.then((a) => ({
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new Aa(r.common.issues);
        },
        input: r.data
      })
    })) : {
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new Aa(r.common.issues);
        },
        input: r.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
zV.create = (t, e) => new zV({
  innerType: t,
  typeName: pt.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...xt(e)
});
class kV extends zt {
  _parse(e) {
    if (this._getType(e) !== Ie.nan) {
      const r = this._getOrReturnCtx(e);
      return Qe(r, {
        code: Re.invalid_type,
        expected: Ie.nan,
        received: r.parsedType
      }), yt;
    }
    return { status: "valid", value: e.data };
  }
}
kV.create = (t) => new kV({
  typeName: pt.ZodNaN,
  ...xt(t)
});
const Jue = Symbol("zod_brand");
class eG extends zt {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = n.data;
    return this._def.type._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class am extends zt {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.common.async)
      return (async () => {
        const a = await this._def.in._parseAsync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return a.status === "aborted" ? yt : a.status === "dirty" ? (n.dirty(), $Q(a.value)) : this._def.out._parseAsync({
          data: a.value,
          path: r.path,
          parent: r
        });
      })();
    {
      const i = this._def.in._parseSync({
        data: r.data,
        path: r.path,
        parent: r
      });
      return i.status === "aborted" ? yt : i.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: i.value
      }) : this._def.out._parseSync({
        data: i.value,
        path: r.path,
        parent: r
      });
    }
  }
  static create(e, n) {
    return new am({
      in: e,
      out: n,
      typeName: pt.ZodPipeline
    });
  }
}
class wV extends zt {
  _parse(e) {
    const n = this._def.innerType._parse(e);
    return SM(n) && (n.value = Object.freeze(n.value)), n;
  }
}
wV.create = (t, e) => new wV({
  innerType: t,
  typeName: pt.ZodReadonly,
  ...xt(e)
});
const tG = (t, e = {}, n) => t ? Uh.create().superRefine((r, i) => {
  var a, o;
  if (!t(r)) {
    const s = typeof e == "function" ? e(r) : typeof e == "string" ? { message: e } : e, l = (o = (a = s.fatal) !== null && a !== void 0 ? a : n) !== null && o !== void 0 ? o : !0, c = typeof s == "string" ? { message: s } : s;
    i.addIssue({ code: "custom", ...c, fatal: l });
  }
}) : Uh.create(), Bue = {
  object: Hn.lazycreate
};
var pt;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(pt || (pt = {}));
const Aue = (t, e = {
  message: `Input not instance of ${t.name}`
}) => tG((n) => n instanceof t, e), nG = Ja.create, rG = sc.create, Hue = kV.create, Xue = lc.create, iG = xM.create, _ue = Bd.create, Pue = WV.create, Kue = WM.create, $ue = jM.create, que = Uh.create, e0e = Ed.create, t0e = Gs.create, n0e = jV.create, r0e = Ha.create, i0e = Hn.create, a0e = Hn.strictCreate, o0e = DM.create, s0e = SU.create, l0e = zM.create, c0e = Qo.create, d0e = kM.create, u0e = DV.create, h0e = Ad.create, N0e = m0.create, M0e = wM.create, p0e = FM.create, m0e = cc.create, T0e = vM.create, f0e = Rh.create, x4 = $a.create, V0e = Ss.create, U0e = Hd.create, R0e = $a.createWithPreprocess, g0e = am.create, y0e = () => nG().optional(), Z0e = () => rG().optional(), b0e = () => iG().optional(), E0e = {
  string: (t) => Ja.create({ ...t, coerce: !0 }),
  number: (t) => sc.create({ ...t, coerce: !0 }),
  boolean: (t) => xM.create({
    ...t,
    coerce: !0
  }),
  bigint: (t) => lc.create({ ...t, coerce: !0 }),
  date: (t) => Bd.create({ ...t, coerce: !0 })
}, S0e = yt;
var We = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: EM,
  setErrorMap: Due,
  getErrorMap: EV,
  makeIssue: SV,
  EMPTY_PATH: zue,
  addIssueToContext: Qe,
  ParseStatus: ii,
  INVALID: yt,
  DIRTY: $Q,
  OK: fi,
  isAborted: fb,
  isDirty: Vb,
  isValid: SM,
  isAsync: xV,
  get util() {
    return tn;
  },
  get objectUtil() {
    return Tb;
  },
  ZodParsedType: Ie,
  getParsedType: yl,
  ZodType: zt,
  ZodString: Ja,
  ZodNumber: sc,
  ZodBigInt: lc,
  ZodBoolean: xM,
  ZodDate: Bd,
  ZodSymbol: WV,
  ZodUndefined: WM,
  ZodNull: jM,
  ZodAny: Uh,
  ZodUnknown: Ed,
  ZodNever: Gs,
  ZodVoid: jV,
  ZodArray: Ha,
  ZodObject: Hn,
  ZodUnion: DM,
  ZodDiscriminatedUnion: SU,
  ZodIntersection: zM,
  ZodTuple: Qo,
  ZodRecord: kM,
  ZodMap: DV,
  ZodSet: Ad,
  ZodFunction: m0,
  ZodLazy: wM,
  ZodLiteral: FM,
  ZodEnum: cc,
  ZodNativeEnum: vM,
  ZodPromise: Rh,
  ZodEffects: $a,
  ZodTransformer: $a,
  ZodOptional: Ss,
  ZodNullable: Hd,
  ZodDefault: IM,
  ZodCatch: zV,
  ZodNaN: kV,
  BRAND: Jue,
  ZodBranded: eG,
  ZodPipeline: am,
  ZodReadonly: wV,
  custom: tG,
  Schema: zt,
  ZodSchema: zt,
  late: Bue,
  get ZodFirstPartyTypeKind() {
    return pt;
  },
  coerce: E0e,
  any: que,
  array: r0e,
  bigint: Xue,
  boolean: iG,
  date: _ue,
  discriminatedUnion: s0e,
  effect: x4,
  enum: m0e,
  function: N0e,
  instanceof: Aue,
  intersection: l0e,
  lazy: M0e,
  literal: p0e,
  map: u0e,
  nan: Hue,
  nativeEnum: T0e,
  never: t0e,
  null: $ue,
  nullable: U0e,
  number: rG,
  object: i0e,
  oboolean: b0e,
  onumber: Z0e,
  optional: V0e,
  ostring: y0e,
  pipeline: g0e,
  preprocess: R0e,
  promise: f0e,
  record: d0e,
  set: h0e,
  strictObject: a0e,
  string: nG,
  symbol: Pue,
  transformer: x4,
  tuple: c0e,
  undefined: Kue,
  union: o0e,
  unknown: e0e,
  void: n0e,
  NEVER: S0e,
  ZodIssueCode: Re,
  quotelessJson: jue,
  ZodError: Aa
});
const ns = We.object({ message: We.string() });
function Vn(t) {
  return We.literal(Wue[t]);
}
const x0e = We.object({ chainId: We.number() }), W0e = We.object({ email: We.string().email() }), j0e = We.object({ otp: We.string() }), D0e = We.object({ chainId: We.optional(We.number()) }), z0e = We.object({
  action: We.enum(["VERIFY_DEVICE", "VERIFY_OTP"])
}), k0e = We.object({
  address: We.string(),
  chainId: We.number()
}), w0e = We.object({ isConnected: We.boolean() }), F0e = We.object({ chainId: We.number() }), v0e = We.string(), I0e = We.object({
  method: We.literal("personal_sign"),
  params: We.array(We.any())
}), O0e = We.object({
  method: We.literal("eth_sendTransaction"),
  params: We.array(We.any())
}), Y0e = We.object({
  method: We.literal("eth_accounts")
}), Q0e = We.object({
  method: We.literal("eth_getBalance"),
  params: We.array(We.any())
}), G0e = We.object({
  method: We.literal("eth_estimateGas"),
  params: We.array(We.any())
}), C0e = We.object({
  method: We.literal("eth_gasPrice")
}), L0e = We.object({
  method: We.literal("eth_signTypedData_v4"),
  params: We.array(We.any())
}), W4 = We.object({
  token: We.string()
});
We.object({ type: Vn("APP_SWITCH_NETWORK"), payload: x0e }).or(We.object({ type: Vn("APP_CONNECT_EMAIL"), payload: W0e })).or(We.object({ type: Vn("APP_CONNECT_DEVICE") })).or(We.object({ type: Vn("APP_CONNECT_OTP"), payload: j0e })).or(We.object({ type: Vn("APP_GET_USER"), payload: We.optional(D0e) })).or(We.object({ type: Vn("APP_SIGN_OUT") })).or(We.object({ type: Vn("APP_IS_CONNECTED"), payload: We.optional(W4) })).or(We.object({ type: Vn("APP_GET_CHAIN_ID") })).or(We.object({
  type: Vn("APP_RPC_REQUEST"),
  payload: I0e.or(O0e).or(Y0e).or(Q0e).or(G0e).or(C0e).or(L0e)
})), We.object({ type: Vn("FRAME_SWITCH_NETWORK_ERROR"), payload: ns }).or(We.object({ type: Vn("FRAME_SWITCH_NETWORK_SUCCESS") })).or(We.object({ type: Vn("FRAME_CONNECT_EMAIL_ERROR"), payload: ns })).or(We.object({ type: Vn("FRAME_CONNECT_EMAIL_SUCCESS"), payload: z0e })).or(We.object({ type: Vn("FRAME_CONNECT_OTP_ERROR"), payload: ns })).or(We.object({ type: Vn("FRAME_CONNECT_OTP_SUCCESS") })).or(We.object({ type: Vn("FRAME_CONNECT_DEVICE_ERROR"), payload: ns })).or(We.object({ type: Vn("FRAME_CONNECT_DEVICE_SUCCESS") })).or(We.object({ type: Vn("FRAME_GET_USER_ERROR"), payload: ns })).or(We.object({ type: Vn("FRAME_GET_USER_SUCCESS"), payload: k0e })).or(We.object({ type: Vn("FRAME_SIGN_OUT_ERROR"), payload: ns })).or(We.object({ type: Vn("FRAME_SIGN_OUT_SUCCESS") })).or(We.object({ type: Vn("FRAME_IS_CONNECTED_ERROR"), payload: ns })).or(We.object({ type: Vn("FRAME_IS_CONNECTED_SUCCESS"), payload: w0e })).or(We.object({ type: Vn("FRAME_GET_CHAIN_ID_ERROR"), payload: ns })).or(We.object({ type: Vn("FRAME_GET_CHAIN_ID_SUCCESS"), payload: F0e })).or(We.object({ type: Vn("FRAME_RPC_REQUEST_ERROR"), payload: ns })).or(We.object({ type: Vn("FRAME_RPC_REQUEST_SUCCESS"), payload: v0e })).or(We.object({ type: Vn("FRAME_SESSION_UPDATE"), payload: W4 }));
const J0e = st.getBlockchainApiUrl();
function B0e({ projectId: t }) {
  return function(n) {
    if (!ss.WalletConnectRpcChainIds.includes(n.id))
      return null;
    const r = `${J0e}/v1/?chainId=${Ut.EIP155}:${n.id}&projectId=${t}`;
    return {
      chain: {
        ...n,
        rpcUrls: {
          ...n.rpcUrls,
          default: { http: [r] }
        }
      },
      rpcUrls: {
        http: [r]
      }
    };
  };
}
let rT;
function A0e(t) {
  return rT || (rT = new Uue({
    ...t,
    _sdkVersion: `react-wagmi-${Ut.VERSION}`
  }), Woe(rT)), rT;
}
const H0e = (t, e, n) => {
  const r = n ? t.filter((l) => !n.map(
    (d) => parseInt(d)
  ).includes(l.id)) : t, { chains: i, publicClient: a } = wq(r, [
    B0e({ projectId: e }),
    xoe()
  ]), o = {
    name: "@xyfinance/widget",
    description: "@xyfinance/widget Web3Modal",
    url: "https://xy.finance",
    icons: ["https://avatars.githubusercontent.com/u/37784886"]
  }, s = lee({
    autoConnect: !0,
    storage: D3({ key: "xy", storage: window.localStorage }),
    connectors: [
      new jre({
        chains: i
      }),
      new Noe({
        chains: i,
        options: {
          projectId: e,
          // There is a bug in web3modal v3, so taht we need to disable QR code modal in web3modal v2 ( wagmi ).
          showQrModal: !1,
          metadata: o
        }
      }),
      new Soe({
        chains: i,
        options: {
          appName: o.name
        }
      }),
      new moe({
        chains: i
      }),
      new foe({
        chains: i
      }),
      new Uoe({
        chains: i
      }),
      new goe({
        chains: i
      }),
      new Zoe({
        chains: i
      }),
      new Eoe({
        chains: i
      })
    ],
    publicClient: a
  });
  return A0e({
    wagmiConfig: s,
    projectId: e,
    chains: i,
    // https://walletconnect.com/explorer
    excludeWalletIds: [
      // MetaMask
      "c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96",
      // Safe
      "225affb176778569276e484e1b92637ad061b01e13a048b35a9d280c3b58970f",
      // Trust
      "4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0"
    ]
  }), s;
}, X0e = {
  defaultOptions: {
    queries: {
      enabled: !0,
      staleTime: 36e5,
      refetchInterval: !1,
      retry: 3
    }
  }
}, gh = (t) => {
  window.open(t, "_blank", "noopener noreferrer");
}, aG = Wt(yI);
function _0e({
  children: t,
  theme: e
}) {
  const n = IE(
    e || {},
    yI
  );
  return /* @__PURE__ */ E.jsx(aG.Provider, { value: n, children: t });
}
function P0e(t) {
  if (t.sheet)
    return t.sheet;
  for (var e = 0; e < document.styleSheets.length; e++)
    if (document.styleSheets[e].ownerNode === t)
      return document.styleSheets[e];
}
function K0e(t) {
  var e = document.createElement("style");
  return e.setAttribute("data-emotion", t.key), t.nonce !== void 0 && e.setAttribute("nonce", t.nonce), e.appendChild(document.createTextNode("")), e.setAttribute("data-s", ""), e;
}
var $0e = /* @__PURE__ */ function() {
  function t(n) {
    var r = this;
    this._insertTag = function(i) {
      var a;
      r.tags.length === 0 ? r.insertionPoint ? a = r.insertionPoint.nextSibling : r.prepend ? a = r.container.firstChild : a = r.before : a = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(i, a), r.tags.push(i);
    }, this.isSpeedy = n.speedy === void 0 ? ue.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var e = t.prototype;
  return e.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, e.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(K0e(this));
    var i = this.tags[this.tags.length - 1];
    if (ue.env.NODE_ENV !== "production") {
      var a = r.charCodeAt(0) === 64 && r.charCodeAt(1) === 105;
      a && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + r + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !a;
    }
    if (this.isSpeedy) {
      var o = P0e(i);
      try {
        o.insertRule(r, o.cssRules.length);
      } catch (s) {
        ue.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(r) && console.error('There was a problem inserting the following rule: "' + r + '"', s);
      }
    } else
      i.appendChild(document.createTextNode(r));
    this.ctr++;
  }, e.flush = function() {
    this.tags.forEach(function(r) {
      return r.parentNode && r.parentNode.removeChild(r);
    }), this.tags = [], this.ctr = 0, ue.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, t;
}(), _r = "-ms-", FV = "-moz-", rn = "-webkit-", SS = "comm", xS = "rule", WS = "decl", q0e = "@import", oG = "@keyframes", ehe = "@layer", the = Math.abs, xU = String.fromCharCode, nhe = Object.assign;
function rhe(t, e) {
  return Or(t, 0) ^ 45 ? (((e << 2 ^ Or(t, 0)) << 2 ^ Or(t, 1)) << 2 ^ Or(t, 2)) << 2 ^ Or(t, 3) : 0;
}
function sG(t) {
  return t.trim();
}
function ihe(t, e) {
  return (t = e.exec(t)) ? t[0] : t;
}
function an(t, e, n) {
  return t.replace(e, n);
}
function Rb(t, e) {
  return t.indexOf(e);
}
function Or(t, e) {
  return t.charCodeAt(e) | 0;
}
function OM(t, e, n) {
  return t.slice(e, n);
}
function Uo(t) {
  return t.length;
}
function jS(t) {
  return t.length;
}
function iT(t, e) {
  return e.push(t), t;
}
function ahe(t, e) {
  return t.map(e).join("");
}
var WU = 1, yh = 1, lG = 0, Ii = 0, hr = 0, cN = "";
function jU(t, e, n, r, i, a, o) {
  return { value: t, root: e, parent: n, type: r, props: i, children: a, line: WU, column: yh, length: o, return: "" };
}
function WN(t, e) {
  return nhe(jU("", null, null, "", null, null, 0), t, { length: -t.length }, e);
}
function ohe() {
  return hr;
}
function she() {
  return hr = Ii > 0 ? Or(cN, --Ii) : 0, yh--, hr === 10 && (yh = 1, WU--), hr;
}
function Pi() {
  return hr = Ii < lG ? Or(cN, Ii++) : 0, yh++, hr === 10 && (yh = 1, WU++), hr;
}
function So() {
  return Or(cN, Ii);
}
function _T() {
  return Ii;
}
function om(t, e) {
  return OM(cN, t, e);
}
function YM(t) {
  switch (t) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function cG(t) {
  return WU = yh = 1, lG = Uo(cN = t), Ii = 0, [];
}
function dG(t) {
  return cN = "", t;
}
function PT(t) {
  return sG(om(Ii - 1, gb(t === 91 ? t + 2 : t === 40 ? t + 1 : t)));
}
function lhe(t) {
  for (; (hr = So()) && hr < 33; )
    Pi();
  return YM(t) > 2 || YM(hr) > 3 ? "" : " ";
}
function che(t, e) {
  for (; --e && Pi() && !(hr < 48 || hr > 102 || hr > 57 && hr < 65 || hr > 70 && hr < 97); )
    ;
  return om(t, _T() + (e < 6 && So() == 32 && Pi() == 32));
}
function gb(t) {
  for (; Pi(); )
    switch (hr) {
      case t:
        return Ii;
      case 34:
      case 39:
        t !== 34 && t !== 39 && gb(hr);
        break;
      case 40:
        t === 41 && gb(t);
        break;
      case 92:
        Pi();
        break;
    }
  return Ii;
}
function dhe(t, e) {
  for (; Pi() && t + hr !== 47 + 10; )
    if (t + hr === 42 + 42 && So() === 47)
      break;
  return "/*" + om(e, Ii - 1) + "*" + xU(t === 47 ? t : Pi());
}
function uhe(t) {
  for (; !YM(So()); )
    Pi();
  return om(t, Ii);
}
function hhe(t) {
  return dG(KT("", null, null, null, [""], t = cG(t), 0, [0], t));
}
function KT(t, e, n, r, i, a, o, s, l) {
  for (var c = 0, d = 0, u = o, h = 0, N = 0, M = 0, p = 1, m = 1, R = 1, V = 0, U = "", g = i, y = a, x = r, f = U; m; )
    switch (M = V, V = Pi()) {
      case 40:
        if (M != 108 && Or(f, u - 1) == 58) {
          Rb(f += an(PT(V), "&", "&\f"), "&\f") != -1 && (R = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        f += PT(V);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        f += lhe(M);
        break;
      case 92:
        f += che(_T() - 1, 7);
        continue;
      case 47:
        switch (So()) {
          case 42:
          case 47:
            iT(Nhe(dhe(Pi(), _T()), e, n), l);
            break;
          default:
            f += "/";
        }
        break;
      case 123 * p:
        s[c++] = Uo(f) * R;
      case 125 * p:
      case 59:
      case 0:
        switch (V) {
          case 0:
          case 125:
            m = 0;
          case 59 + d:
            R == -1 && (f = an(f, /\f/g, "")), N > 0 && Uo(f) - u && iT(N > 32 ? D4(f + ";", r, n, u - 1) : D4(an(f, " ", "") + ";", r, n, u - 2), l);
            break;
          case 59:
            f += ";";
          default:
            if (iT(x = j4(f, e, n, c, d, i, s, U, g = [], y = [], u), a), V === 123)
              if (d === 0)
                KT(f, e, x, x, g, a, u, s, y);
              else
                switch (h === 99 && Or(f, 3) === 110 ? 100 : h) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    KT(t, x, x, r && iT(j4(t, x, x, 0, 0, i, s, U, i, g = [], u), y), i, y, u, s, r ? g : y);
                    break;
                  default:
                    KT(f, x, x, x, [""], y, 0, s, y);
                }
        }
        c = d = N = 0, p = R = 1, U = f = "", u = o;
        break;
      case 58:
        u = 1 + Uo(f), N = M;
      default:
        if (p < 1) {
          if (V == 123)
            --p;
          else if (V == 125 && p++ == 0 && she() == 125)
            continue;
        }
        switch (f += xU(V), V * p) {
          case 38:
            R = d > 0 ? 1 : (f += "\f", -1);
            break;
          case 44:
            s[c++] = (Uo(f) - 1) * R, R = 1;
            break;
          case 64:
            So() === 45 && (f += PT(Pi())), h = So(), d = u = Uo(U = f += uhe(_T())), V++;
            break;
          case 45:
            M === 45 && Uo(f) == 2 && (p = 0);
        }
    }
  return a;
}
function j4(t, e, n, r, i, a, o, s, l, c, d) {
  for (var u = i - 1, h = i === 0 ? a : [""], N = jS(h), M = 0, p = 0, m = 0; M < r; ++M)
    for (var R = 0, V = OM(t, u + 1, u = the(p = o[M])), U = t; R < N; ++R)
      (U = sG(p > 0 ? h[R] + " " + V : an(V, /&\f/g, h[R]))) && (l[m++] = U);
  return jU(t, e, n, i === 0 ? xS : s, l, c, d);
}
function Nhe(t, e, n) {
  return jU(t, e, n, SS, xU(ohe()), OM(t, 2, -2), 0);
}
function D4(t, e, n, r) {
  return jU(t, e, n, WS, OM(t, 0, r), OM(t, r + 1, -1), r);
}
function T0(t, e) {
  for (var n = "", r = jS(t), i = 0; i < r; i++)
    n += e(t[i], i, t, e) || "";
  return n;
}
function Mhe(t, e, n, r) {
  switch (t.type) {
    case ehe:
      if (t.children.length)
        break;
    case q0e:
    case WS:
      return t.return = t.return || t.value;
    case SS:
      return "";
    case oG:
      return t.return = t.value + "{" + T0(t.children, r) + "}";
    case xS:
      t.value = t.props.join(",");
  }
  return Uo(n = T0(t.children, r)) ? t.return = t.value + "{" + n + "}" : "";
}
function phe(t) {
  var e = jS(t);
  return function(n, r, i, a) {
    for (var o = "", s = 0; s < e; s++)
      o += t[s](n, r, i, a) || "";
    return o;
  };
}
function mhe(t) {
  return function(e) {
    e.root || (e = e.return) && t(e);
  };
}
var z4 = function(e) {
  var n = /* @__PURE__ */ new WeakMap();
  return function(r) {
    if (n.has(r))
      return n.get(r);
    var i = e(r);
    return n.set(r, i), i;
  };
};
function uG(t) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return e[n] === void 0 && (e[n] = t(n)), e[n];
  };
}
var The = function(e, n, r) {
  for (var i = 0, a = 0; i = a, a = So(), i === 38 && a === 12 && (n[r] = 1), !YM(a); )
    Pi();
  return om(e, Ii);
}, fhe = function(e, n) {
  var r = -1, i = 44;
  do
    switch (YM(i)) {
      case 0:
        i === 38 && So() === 12 && (n[r] = 1), e[r] += The(Ii - 1, n, r);
        break;
      case 2:
        e[r] += PT(i);
        break;
      case 4:
        if (i === 44) {
          e[++r] = So() === 58 ? "&\f" : "", n[r] = e[r].length;
          break;
        }
      default:
        e[r] += xU(i);
    }
  while (i = Pi());
  return e;
}, Vhe = function(e, n) {
  return dG(fhe(cG(e), n));
}, k4 = /* @__PURE__ */ new WeakMap(), Uhe = function(e) {
  if (!(e.type !== "rule" || !e.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  e.length < 1)) {
    for (var n = e.value, r = e.parent, i = e.column === r.column && e.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r)
        return;
    if (!(e.props.length === 1 && n.charCodeAt(0) !== 58 && !k4.get(r)) && !i) {
      k4.set(e, !0);
      for (var a = [], o = Vhe(n, a), s = r.props, l = 0, c = 0; l < o.length; l++)
        for (var d = 0; d < s.length; d++, c++)
          e.props[c] = a[l] ? o[l].replace(/&\f/g, s[d]) : s[d] + " " + o[l];
    }
  }
}, Rhe = function(e) {
  if (e.type === "decl") {
    var n = e.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (e.return = "", e.value = "");
  }
}, ghe = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", yhe = function(e) {
  return e.type === "comm" && e.children.indexOf(ghe) > -1;
}, Zhe = function(e) {
  return function(n, r, i) {
    if (!(n.type !== "rule" || e.compat)) {
      var a = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (a) {
        for (var o = !!n.parent, s = o ? n.parent.children : (
          // global rule at the root level
          i
        ), l = s.length - 1; l >= 0; l--) {
          var c = s[l];
          if (c.line < n.line)
            break;
          if (c.column < n.column) {
            if (yhe(c))
              return;
            break;
          }
        }
        a.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, hG = function(e) {
  return e.type.charCodeAt(1) === 105 && e.type.charCodeAt(0) === 64;
}, bhe = function(e, n) {
  for (var r = e - 1; r >= 0; r--)
    if (!hG(n[r]))
      return !0;
  return !1;
}, w4 = function(e) {
  e.type = "", e.value = "", e.return = "", e.children = "", e.props = "";
}, Ehe = function(e, n, r) {
  hG(e) && (e.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), w4(e)) : bhe(n, r) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), w4(e)));
};
function NG(t, e) {
  switch (rhe(t, e)) {
    case 5103:
      return rn + "print-" + t + t;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return rn + t + t;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return rn + t + FV + t + _r + t + t;
    case 6828:
    case 4268:
      return rn + t + _r + t + t;
    case 6165:
      return rn + t + _r + "flex-" + t + t;
    case 5187:
      return rn + t + an(t, /(\w+).+(:[^]+)/, rn + "box-$1$2" + _r + "flex-$1$2") + t;
    case 5443:
      return rn + t + _r + "flex-item-" + an(t, /flex-|-self/, "") + t;
    case 4675:
      return rn + t + _r + "flex-line-pack" + an(t, /align-content|flex-|-self/, "") + t;
    case 5548:
      return rn + t + _r + an(t, "shrink", "negative") + t;
    case 5292:
      return rn + t + _r + an(t, "basis", "preferred-size") + t;
    case 6060:
      return rn + "box-" + an(t, "-grow", "") + rn + t + _r + an(t, "grow", "positive") + t;
    case 4554:
      return rn + an(t, /([^-])(transform)/g, "$1" + rn + "$2") + t;
    case 6187:
      return an(an(an(t, /(zoom-|grab)/, rn + "$1"), /(image-set)/, rn + "$1"), t, "") + t;
    case 5495:
    case 3959:
      return an(t, /(image-set\([^]*)/, rn + "$1$`$1");
    case 4968:
      return an(an(t, /(.+:)(flex-)?(.*)/, rn + "box-pack:$3" + _r + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + rn + t + t;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return an(t, /(.+)-inline(.+)/, rn + "$1$2") + t;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Uo(t) - 1 - e > 6)
        switch (Or(t, e + 1)) {
          case 109:
            if (Or(t, e + 4) !== 45)
              break;
          case 102:
            return an(t, /(.+:)(.+)-([^]+)/, "$1" + rn + "$2-$3$1" + FV + (Or(t, e + 3) == 108 ? "$3" : "$2-$3")) + t;
          case 115:
            return ~Rb(t, "stretch") ? NG(an(t, "stretch", "fill-available"), e) + t : t;
        }
      break;
    case 4949:
      if (Or(t, e + 1) !== 115)
        break;
    case 6444:
      switch (Or(t, Uo(t) - 3 - (~Rb(t, "!important") && 10))) {
        case 107:
          return an(t, ":", ":" + rn) + t;
        case 101:
          return an(t, /(.+:)([^;!]+)(;|!.+)?/, "$1" + rn + (Or(t, 14) === 45 ? "inline-" : "") + "box$3$1" + rn + "$2$3$1" + _r + "$2box$3") + t;
      }
      break;
    case 5936:
      switch (Or(t, e + 11)) {
        case 114:
          return rn + t + _r + an(t, /[svh]\w+-[tblr]{2}/, "tb") + t;
        case 108:
          return rn + t + _r + an(t, /[svh]\w+-[tblr]{2}/, "tb-rl") + t;
        case 45:
          return rn + t + _r + an(t, /[svh]\w+-[tblr]{2}/, "lr") + t;
      }
      return rn + t + _r + t + t;
  }
  return t;
}
var She = function(e, n, r, i) {
  if (e.length > -1 && !e.return)
    switch (e.type) {
      case WS:
        e.return = NG(e.value, e.length);
        break;
      case oG:
        return T0([WN(e, {
          value: an(e.value, "@", "@" + rn)
        })], i);
      case xS:
        if (e.length)
          return ahe(e.props, function(a) {
            switch (ihe(a, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return T0([WN(e, {
                  props: [an(a, /:(read-\w+)/, ":" + FV + "$1")]
                })], i);
              case "::placeholder":
                return T0([WN(e, {
                  props: [an(a, /:(plac\w+)/, ":" + rn + "input-$1")]
                }), WN(e, {
                  props: [an(a, /:(plac\w+)/, ":" + FV + "$1")]
                }), WN(e, {
                  props: [an(a, /:(plac\w+)/, _r + "input-$1")]
                })], i);
            }
            return "";
          });
    }
}, xhe = [She], Whe = function(e) {
  var n = e.key;
  if (ue.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(p) {
      var m = p.getAttribute("data-emotion");
      m.indexOf(" ") !== -1 && (document.head.appendChild(p), p.setAttribute("data-s", ""));
    });
  }
  var i = e.stylisPlugins || xhe;
  if (ue.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var a = {}, o, s = [];
  o = e.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(p) {
      for (var m = p.getAttribute("data-emotion").split(" "), R = 1; R < m.length; R++)
        a[m[R]] = !0;
      s.push(p);
    }
  );
  var l, c = [Uhe, Rhe];
  ue.env.NODE_ENV !== "production" && c.push(Zhe({
    get compat() {
      return M.compat;
    }
  }), Ehe);
  {
    var d, u = [Mhe, ue.env.NODE_ENV !== "production" ? function(p) {
      p.root || (p.return ? d.insert(p.return) : p.value && p.type !== SS && d.insert(p.value + "{}"));
    } : mhe(function(p) {
      d.insert(p);
    })], h = phe(c.concat(i, u)), N = function(m) {
      return T0(hhe(m), h);
    };
    l = function(m, R, V, U) {
      d = V, ue.env.NODE_ENV !== "production" && R.map !== void 0 && (d = {
        insert: function(y) {
          V.insert(y + R.map);
        }
      }), N(m ? m + "{" + R.styles + "}" : R.styles), U && (M.inserted[R.name] = !0);
    };
  }
  var M = {
    key: n,
    sheet: new $0e({
      key: n,
      container: o,
      nonce: e.nonce,
      speedy: e.speedy,
      prepend: e.prepend,
      insertionPoint: e.insertionPoint
    }),
    nonce: e.nonce,
    inserted: a,
    registered: {},
    insert: l
  };
  return M.sheet.hydrate(s), M;
};
function vV() {
  return vV = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, vV.apply(this, arguments);
}
var yb = { exports: {} }, ln = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var F4;
function jhe() {
  if (F4)
    return ln;
  F4 = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, a = t ? Symbol.for("react.profiler") : 60114, o = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, u = t ? Symbol.for("react.suspense") : 60113, h = t ? Symbol.for("react.suspense_list") : 60120, N = t ? Symbol.for("react.memo") : 60115, M = t ? Symbol.for("react.lazy") : 60116, p = t ? Symbol.for("react.block") : 60121, m = t ? Symbol.for("react.fundamental") : 60117, R = t ? Symbol.for("react.responder") : 60118, V = t ? Symbol.for("react.scope") : 60119;
  function U(y) {
    if (typeof y == "object" && y !== null) {
      var x = y.$$typeof;
      switch (x) {
        case e:
          switch (y = y.type, y) {
            case l:
            case c:
            case r:
            case a:
            case i:
            case u:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case s:
                case d:
                case M:
                case N:
                case o:
                  return y;
                default:
                  return x;
              }
          }
        case n:
          return x;
      }
    }
  }
  function g(y) {
    return U(y) === c;
  }
  return ln.AsyncMode = l, ln.ConcurrentMode = c, ln.ContextConsumer = s, ln.ContextProvider = o, ln.Element = e, ln.ForwardRef = d, ln.Fragment = r, ln.Lazy = M, ln.Memo = N, ln.Portal = n, ln.Profiler = a, ln.StrictMode = i, ln.Suspense = u, ln.isAsyncMode = function(y) {
    return g(y) || U(y) === l;
  }, ln.isConcurrentMode = g, ln.isContextConsumer = function(y) {
    return U(y) === s;
  }, ln.isContextProvider = function(y) {
    return U(y) === o;
  }, ln.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === e;
  }, ln.isForwardRef = function(y) {
    return U(y) === d;
  }, ln.isFragment = function(y) {
    return U(y) === r;
  }, ln.isLazy = function(y) {
    return U(y) === M;
  }, ln.isMemo = function(y) {
    return U(y) === N;
  }, ln.isPortal = function(y) {
    return U(y) === n;
  }, ln.isProfiler = function(y) {
    return U(y) === a;
  }, ln.isStrictMode = function(y) {
    return U(y) === i;
  }, ln.isSuspense = function(y) {
    return U(y) === u;
  }, ln.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === r || y === c || y === a || y === i || y === u || y === h || typeof y == "object" && y !== null && (y.$$typeof === M || y.$$typeof === N || y.$$typeof === o || y.$$typeof === s || y.$$typeof === d || y.$$typeof === m || y.$$typeof === R || y.$$typeof === V || y.$$typeof === p);
  }, ln.typeOf = U, ln;
}
var cn = {}, v4;
function Dhe() {
  return v4 || (v4 = 1, ue.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, a = t ? Symbol.for("react.profiler") : 60114, o = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, u = t ? Symbol.for("react.suspense") : 60113, h = t ? Symbol.for("react.suspense_list") : 60120, N = t ? Symbol.for("react.memo") : 60115, M = t ? Symbol.for("react.lazy") : 60116, p = t ? Symbol.for("react.block") : 60121, m = t ? Symbol.for("react.fundamental") : 60117, R = t ? Symbol.for("react.responder") : 60118, V = t ? Symbol.for("react.scope") : 60119;
    function U(se) {
      return typeof se == "string" || typeof se == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      se === r || se === c || se === a || se === i || se === u || se === h || typeof se == "object" && se !== null && (se.$$typeof === M || se.$$typeof === N || se.$$typeof === o || se.$$typeof === s || se.$$typeof === d || se.$$typeof === m || se.$$typeof === R || se.$$typeof === V || se.$$typeof === p);
    }
    function g(se) {
      if (typeof se == "object" && se !== null) {
        var Ce = se.$$typeof;
        switch (Ce) {
          case e:
            var et = se.type;
            switch (et) {
              case l:
              case c:
              case r:
              case a:
              case i:
              case u:
                return et;
              default:
                var at = et && et.$$typeof;
                switch (at) {
                  case s:
                  case d:
                  case M:
                  case N:
                  case o:
                    return at;
                  default:
                    return Ce;
                }
            }
          case n:
            return Ce;
        }
      }
    }
    var y = l, x = c, f = s, D = o, Y = e, Q = d, G = r, ne = M, O = N, T = n, Z = a, z = i, j = u, w = !1;
    function C(se) {
      return w || (w = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), J(se) || g(se) === l;
    }
    function J(se) {
      return g(se) === c;
    }
    function I(se) {
      return g(se) === s;
    }
    function b(se) {
      return g(se) === o;
    }
    function k(se) {
      return typeof se == "object" && se !== null && se.$$typeof === e;
    }
    function ae(se) {
      return g(se) === d;
    }
    function oe(se) {
      return g(se) === r;
    }
    function le(se) {
      return g(se) === M;
    }
    function fe(se) {
      return g(se) === N;
    }
    function de(se) {
      return g(se) === n;
    }
    function Me(se) {
      return g(se) === a;
    }
    function je(se) {
      return g(se) === i;
    }
    function Se(se) {
      return g(se) === u;
    }
    cn.AsyncMode = y, cn.ConcurrentMode = x, cn.ContextConsumer = f, cn.ContextProvider = D, cn.Element = Y, cn.ForwardRef = Q, cn.Fragment = G, cn.Lazy = ne, cn.Memo = O, cn.Portal = T, cn.Profiler = Z, cn.StrictMode = z, cn.Suspense = j, cn.isAsyncMode = C, cn.isConcurrentMode = J, cn.isContextConsumer = I, cn.isContextProvider = b, cn.isElement = k, cn.isForwardRef = ae, cn.isFragment = oe, cn.isLazy = le, cn.isMemo = fe, cn.isPortal = de, cn.isProfiler = Me, cn.isStrictMode = je, cn.isSuspense = Se, cn.isValidElementType = U, cn.typeOf = g;
  }()), cn;
}
ue.env.NODE_ENV === "production" ? yb.exports = jhe() : yb.exports = Dhe();
var zhe = yb.exports, MG = zhe, khe = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, whe = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, pG = {};
pG[MG.ForwardRef] = khe;
pG[MG.Memo] = whe;
var Fhe = !0;
function DS(t, e, n) {
  var r = "";
  return n.split(" ").forEach(function(i) {
    t[i] !== void 0 ? e.push(t[i] + ";") : r += i + " ";
  }), r;
}
var DU = function(e, n, r) {
  var i = e.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (r === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Fhe === !1) && e.registered[i] === void 0 && (e.registered[i] = n.styles);
}, zU = function(e, n, r) {
  DU(e, n, r);
  var i = e.key + "-" + n.name;
  if (e.inserted[n.name] === void 0) {
    var a = n;
    do
      e.insert(n === a ? "." + i : "", a, e.sheet, !0), a = a.next;
    while (a !== void 0);
  }
};
function vhe(t) {
  for (var e = 0, n, r = 0, i = t.length; i >= 4; ++r, i -= 4)
    n = t.charCodeAt(r) & 255 | (t.charCodeAt(++r) & 255) << 8 | (t.charCodeAt(++r) & 255) << 16 | (t.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, e = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      e ^= (t.charCodeAt(r + 2) & 255) << 16;
    case 2:
      e ^= (t.charCodeAt(r + 1) & 255) << 8;
    case 1:
      e ^= t.charCodeAt(r) & 255, e = /* Math.imul(h, m): */
      (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
  }
  return e ^= e >>> 13, e = /* Math.imul(h, m): */
  (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16), ((e ^ e >>> 15) >>> 0).toString(36);
}
var Ihe = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, I4 = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Ohe = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", Yhe = /[A-Z]|^ms/g, mG = /_EMO_([^_]+?)_([^]*?)_EMO_/g, zS = function(e) {
  return e.charCodeAt(1) === 45;
}, O4 = function(e) {
  return e != null && typeof e != "boolean";
}, xg = /* @__PURE__ */ uG(function(t) {
  return zS(t) ? t : t.replace(Yhe, "-$&").toLowerCase();
}), IV = function(e, n) {
  switch (e) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(mG, function(r, i, a) {
          return Ga = {
            name: i,
            styles: a,
            next: Ga
          }, i;
        });
  }
  return Ihe[e] !== 1 && !zS(e) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (ue.env.NODE_ENV !== "production") {
  var Qhe = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, Ghe = ["normal", "none", "initial", "inherit", "unset"], Che = IV, Lhe = /^-ms-/, Jhe = /-(.)/g, Y4 = {};
  IV = function(e, n) {
    if (e === "content" && (typeof n != "string" || Ghe.indexOf(n) === -1 && !Qhe.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var r = Che(e, n);
    return r !== "" && !zS(e) && e.indexOf("-") !== -1 && Y4[e] === void 0 && (Y4[e] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + e.replace(Lhe, "ms-").replace(Jhe, function(i, a) {
      return a.toUpperCase();
    }) + "?")), r;
  };
}
var TG = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function QM(t, e, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (ue.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(TG);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return Ga = {
          name: n.name,
          styles: n.styles,
          next: Ga
        }, n.name;
      if (n.styles !== void 0) {
        var r = n.next;
        if (r !== void 0)
          for (; r !== void 0; )
            Ga = {
              name: r.name,
              styles: r.styles,
              next: Ga
            }, r = r.next;
        var i = n.styles + ";";
        return ue.env.NODE_ENV !== "production" && n.map !== void 0 && (i += n.map), i;
      }
      return Bhe(t, e, n);
    }
    case "function": {
      if (t !== void 0) {
        var a = Ga, o = n(t);
        return Ga = a, QM(t, e, o);
      } else
        ue.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (ue.env.NODE_ENV !== "production") {
        var s = [], l = n.replace(mG, function(d, u, h) {
          var N = "animation" + s.length;
          return s.push("const " + N + " = keyframes`" + h.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + N + "}";
        });
        s.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(s, ["`" + l + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + l + "`"));
      }
      break;
  }
  if (e == null)
    return n;
  var c = e[n];
  return c !== void 0 ? c : n;
}
function Bhe(t, e, n) {
  var r = "";
  if (Array.isArray(n))
    for (var i = 0; i < n.length; i++)
      r += QM(t, e, n[i]) + ";";
  else
    for (var a in n) {
      var o = n[a];
      if (typeof o != "object")
        e != null && e[o] !== void 0 ? r += a + "{" + e[o] + "}" : O4(o) && (r += xg(a) + ":" + IV(a, o) + ";");
      else {
        if (a === "NO_COMPONENT_SELECTOR" && ue.env.NODE_ENV !== "production")
          throw new Error(TG);
        if (Array.isArray(o) && typeof o[0] == "string" && (e == null || e[o[0]] === void 0))
          for (var s = 0; s < o.length; s++)
            O4(o[s]) && (r += xg(a) + ":" + IV(a, o[s]) + ";");
        else {
          var l = QM(t, e, o);
          switch (a) {
            case "animation":
            case "animationName": {
              r += xg(a) + ":" + l + ";";
              break;
            }
            default:
              ue.env.NODE_ENV !== "production" && a === "undefined" && console.error(Ohe), r += a + "{" + l + "}";
          }
        }
      }
    }
  return r;
}
var Q4 = /label:\s*([^\s;\n{]+)\s*(;|$)/g, fG;
ue.env.NODE_ENV !== "production" && (fG = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var Ga, Zh = function(e, n, r) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var i = !0, a = "";
  Ga = void 0;
  var o = e[0];
  o == null || o.raw === void 0 ? (i = !1, a += QM(r, n, o)) : (ue.env.NODE_ENV !== "production" && o[0] === void 0 && console.error(I4), a += o[0]);
  for (var s = 1; s < e.length; s++)
    a += QM(r, n, e[s]), i && (ue.env.NODE_ENV !== "production" && o[s] === void 0 && console.error(I4), a += o[s]);
  var l;
  ue.env.NODE_ENV !== "production" && (a = a.replace(fG, function(h) {
    return l = h, "";
  })), Q4.lastIndex = 0;
  for (var c = "", d; (d = Q4.exec(a)) !== null; )
    c += "-" + // $FlowFixMe we know it's not null
    d[1];
  var u = vhe(a) + c;
  return ue.env.NODE_ENV !== "production" ? {
    name: u,
    styles: a,
    map: l,
    next: Ga,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: u,
    styles: a,
    next: Ga
  };
}, Ahe = function(e) {
  return e();
}, VG = H["useInsertionEffect"] ? H["useInsertionEffect"] : !1, kS = VG || Ahe, G4 = VG || H.useLayoutEffect, Hhe = {}.hasOwnProperty, wS = /* @__PURE__ */ Wt(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ Whe({
    key: "css"
  }) : null
);
ue.env.NODE_ENV !== "production" && (wS.displayName = "EmotionCacheContext");
wS.Provider;
var kU = function(e) {
  return /* @__PURE__ */ Ge(function(n, r) {
    var i = lt(wS);
    return e(n, i, r);
  });
}, dc = /* @__PURE__ */ Wt({});
ue.env.NODE_ENV !== "production" && (dc.displayName = "EmotionThemeContext");
var Xhe = function(e, n) {
  if (typeof n == "function") {
    var r = n(e);
    if (ue.env.NODE_ENV !== "production" && (r == null || typeof r != "object" || Array.isArray(r)))
      throw new Error("[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!");
    return r;
  }
  if (ue.env.NODE_ENV !== "production" && (n == null || typeof n != "object" || Array.isArray(n)))
    throw new Error("[ThemeProvider] Please make your theme prop a plain object");
  return vV({}, e, n);
}, _he = /* @__PURE__ */ z4(function(t) {
  return z4(function(e) {
    return Xhe(t, e);
  });
}), Phe = function(e) {
  var n = lt(dc);
  return e.theme !== n && (n = _he(n)(e.theme)), /* @__PURE__ */ ye(dc.Provider, {
    value: n
  }, e.children);
}, C4 = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", L4 = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", Khe = function(e) {
  var n = e.cache, r = e.serialized, i = e.isStringTag;
  return DU(n, r, i), kS(function() {
    return zU(n, r, i);
  }), null;
}, $he = /* @__PURE__ */ kU(function(t, e, n) {
  var r = t.css;
  typeof r == "string" && e.registered[r] !== void 0 && (r = e.registered[r]);
  var i = t[C4], a = [r], o = "";
  typeof t.className == "string" ? o = DS(e.registered, a, t.className) : t.className != null && (o = t.className + " ");
  var s = Zh(a, void 0, lt(dc));
  if (ue.env.NODE_ENV !== "production" && s.name.indexOf("-") === -1) {
    var l = t[L4];
    l && (s = Zh([s, "label:" + l + ";"]));
  }
  o += e.key + "-" + s.name;
  var c = {};
  for (var d in t)
    Hhe.call(t, d) && d !== "css" && d !== C4 && (ue.env.NODE_ENV === "production" || d !== L4) && (c[d] = t[d]);
  return c.ref = n, c.className = o, /* @__PURE__ */ ye(tu, null, /* @__PURE__ */ ye(Khe, {
    cache: e,
    serialized: s,
    isStringTag: typeof i == "string"
  }), /* @__PURE__ */ ye(i, c));
});
ue.env.NODE_ENV !== "production" && ($he.displayName = "EmotionCssPropInternal");
var qhe = {
  name: "@emotion/react",
  version: "11.10.6",
  main: "dist/emotion-react.cjs.js",
  module: "dist/emotion-react.esm.js",
  browser: {
    "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  },
  exports: {
    ".": {
      module: {
        worker: "./dist/emotion-react.worker.esm.js",
        browser: "./dist/emotion-react.browser.esm.js",
        default: "./dist/emotion-react.esm.js"
      },
      default: "./dist/emotion-react.cjs.js"
    },
    "./jsx-runtime": {
      module: {
        worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
        browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
        default: "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
      },
      default: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
    },
    "./_isolated-hnrs": {
      module: {
        worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
        browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
        default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
      },
      default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
    },
    "./jsx-dev-runtime": {
      module: {
        worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
        browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
        default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
      },
      default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
    },
    "./package.json": "./package.json",
    "./types/css-prop": "./types/css-prop.d.ts",
    "./macro": "./macro.js"
  },
  types: "types/index.d.ts",
  files: [
    "src",
    "dist",
    "jsx-runtime",
    "jsx-dev-runtime",
    "_isolated-hnrs",
    "types/*.d.ts",
    "macro.js",
    "macro.d.ts",
    "macro.js.flow"
  ],
  sideEffects: !1,
  author: "Emotion Contributors",
  license: "MIT",
  scripts: {
    "test:typescript": "dtslint types"
  },
  dependencies: {
    "@babel/runtime": "^7.18.3",
    "@emotion/babel-plugin": "^11.10.6",
    "@emotion/cache": "^11.10.5",
    "@emotion/serialize": "^1.1.1",
    "@emotion/use-insertion-effect-with-fallbacks": "^1.0.0",
    "@emotion/utils": "^1.2.0",
    "@emotion/weak-memoize": "^0.3.0",
    "hoist-non-react-statics": "^3.3.1"
  },
  peerDependencies: {
    react: ">=16.8.0"
  },
  peerDependenciesMeta: {
    "@types/react": {
      optional: !0
    }
  },
  devDependencies: {
    "@definitelytyped/dtslint": "0.0.112",
    "@emotion/css": "11.10.6",
    "@emotion/css-prettifier": "1.1.1",
    "@emotion/server": "11.10.0",
    "@emotion/styled": "11.10.6",
    "html-tag-names": "^1.1.2",
    react: "16.14.0",
    "svg-tag-names": "^1.1.1",
    typescript: "^4.5.5"
  },
  repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
  publishConfig: {
    access: "public"
  },
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct: {
    entrypoints: [
      "./index.js",
      "./jsx-runtime.js",
      "./jsx-dev-runtime.js",
      "./_isolated-hnrs.js"
    ],
    umdName: "emotionReact",
    exports: {
      envConditions: [
        "browser",
        "worker"
      ],
      extra: {
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": "./macro.js"
      }
    }
  }
}, J4 = !1, sm = /* @__PURE__ */ kU(function(t, e) {
  ue.env.NODE_ENV !== "production" && !J4 && // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  (t.className || t.css) && (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), J4 = !0);
  var n = t.styles, r = Zh([n], void 0, lt(dc)), i = Ve();
  return G4(function() {
    var a = e.key + "-global", o = new e.sheet.constructor({
      key: a,
      nonce: e.sheet.nonce,
      container: e.sheet.container,
      speedy: e.sheet.isSpeedy
    }), s = !1, l = document.querySelector('style[data-emotion="' + a + " " + r.name + '"]');
    return e.sheet.tags.length && (o.before = e.sheet.tags[0]), l !== null && (s = !0, l.setAttribute("data-emotion", a), o.hydrate([l])), i.current = [o, s], function() {
      o.flush();
    };
  }, [e]), G4(function() {
    var a = i.current, o = a[0], s = a[1];
    if (s) {
      a[1] = !1;
      return;
    }
    if (r.next !== void 0 && zU(e, r.next, !0), o.tags.length) {
      var l = o.tags[o.tags.length - 1].nextElementSibling;
      o.before = l, o.flush();
    }
    e.insert("", r, o, !1);
  }, [e, r.name]), null;
});
ue.env.NODE_ENV !== "production" && (sm.displayName = "EmotionGlobal");
function eNe() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return Zh(e);
}
var wU = function() {
  var e = eNe.apply(void 0, arguments), n = "animation-" + e.name;
  return {
    name: n,
    styles: "@keyframes " + n + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}, tNe = function t(e) {
  for (var n = e.length, r = 0, i = ""; r < n; r++) {
    var a = e[r];
    if (a != null) {
      var o = void 0;
      switch (typeof a) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(a))
            o = t(a);
          else {
            ue.env.NODE_ENV !== "production" && a.styles !== void 0 && a.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), o = "";
            for (var s in a)
              a[s] && s && (o && (o += " "), o += s);
          }
          break;
        }
        default:
          o = a;
      }
      o && (i && (i += " "), i += o);
    }
  }
  return i;
};
function nNe(t, e, n) {
  var r = [], i = DS(t, r, n);
  return r.length < 2 ? n : i + e(r);
}
var rNe = function(e) {
  var n = e.cache, r = e.serializedArr;
  return kS(function() {
    for (var i = 0; i < r.length; i++)
      zU(n, r[i], !1);
  }), null;
}, iNe = /* @__PURE__ */ kU(function(t, e) {
  var n = !1, r = [], i = function() {
    if (n && ue.env.NODE_ENV !== "production")
      throw new Error("css can only be used during render");
    for (var c = arguments.length, d = new Array(c), u = 0; u < c; u++)
      d[u] = arguments[u];
    var h = Zh(d, e.registered);
    return r.push(h), DU(e, h, !1), e.key + "-" + h.name;
  }, a = function() {
    if (n && ue.env.NODE_ENV !== "production")
      throw new Error("cx can only be used during render");
    for (var c = arguments.length, d = new Array(c), u = 0; u < c; u++)
      d[u] = arguments[u];
    return nNe(e.registered, i, tNe(d));
  }, o = {
    css: i,
    cx: a,
    theme: lt(dc)
  }, s = t.children(o);
  return n = !0, /* @__PURE__ */ ye(tu, null, /* @__PURE__ */ ye(rNe, {
    cache: e,
    serializedArr: r
  }), s);
});
ue.env.NODE_ENV !== "production" && (iNe.displayName = "EmotionClassNames");
if (ue.env.NODE_ENV !== "production") {
  var B4 = !0, aNe = typeof jest < "u" || typeof vi < "u";
  if (B4 && !aNe) {
    var A4 = (
      // $FlowIgnore
      typeof globalThis < "u" ? globalThis : B4 ? window : $i
    ), H4 = "__EMOTION_REACT_" + qhe.version.split(".")[0] + "__";
    A4[H4] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), A4[H4] = !0;
  }
}
var UG = String.raw, RG = UG`
  :root,
  :host {
    --chakra-vh: 100vh;
  }

  @supports (height: -webkit-fill-available) {
    :root,
    :host {
      --chakra-vh: -webkit-fill-available;
    }
  }

  @supports (height: -moz-fill-available) {
    :root,
    :host {
      --chakra-vh: -moz-fill-available;
    }
  }

  @supports (height: 100dvh) {
    :root,
    :host {
      --chakra-vh: 100dvh;
    }
  }
`, oNe = () => /* @__PURE__ */ E.jsx(sm, { styles: RG }), sNe = ({ scope: t = "" }) => /* @__PURE__ */ E.jsx(
  sm,
  {
    styles: UG`
      html {
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        font-family: system-ui, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        touch-action: manipulation;
      }

      body {
        position: relative;
        min-height: 100%;
        margin: 0;
        font-feature-settings: "kern";
      }

      ${t} :where(*, *::before, *::after) {
        border-width: 0;
        border-style: solid;
        box-sizing: border-box;
        word-wrap: break-word;
      }

      main {
        display: block;
      }

      ${t} hr {
        border-top-width: 1px;
        box-sizing: content-box;
        height: 0;
        overflow: visible;
      }

      ${t} :where(pre, code, kbd,samp) {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        font-size: 1em;
      }

      ${t} a {
        background-color: transparent;
        color: inherit;
        text-decoration: inherit;
      }

      ${t} abbr[title] {
        border-bottom: none;
        text-decoration: underline;
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
      }

      ${t} :where(b, strong) {
        font-weight: bold;
      }

      ${t} small {
        font-size: 80%;
      }

      ${t} :where(sub,sup) {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }

      ${t} sub {
        bottom: -0.25em;
      }

      ${t} sup {
        top: -0.5em;
      }

      ${t} img {
        border-style: none;
      }

      ${t} :where(button, input, optgroup, select, textarea) {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
      }

      ${t} :where(button, input) {
        overflow: visible;
      }

      ${t} :where(button, select) {
        text-transform: none;
      }

      ${t} :where(
          button::-moz-focus-inner,
          [type="button"]::-moz-focus-inner,
          [type="reset"]::-moz-focus-inner,
          [type="submit"]::-moz-focus-inner
        ) {
        border-style: none;
        padding: 0;
      }

      ${t} fieldset {
        padding: 0.35em 0.75em 0.625em;
      }

      ${t} legend {
        box-sizing: border-box;
        color: inherit;
        display: table;
        max-width: 100%;
        padding: 0;
        white-space: normal;
      }

      ${t} progress {
        vertical-align: baseline;
      }

      ${t} textarea {
        overflow: auto;
      }

      ${t} :where([type="checkbox"], [type="radio"]) {
        box-sizing: border-box;
        padding: 0;
      }

      ${t} input[type="number"]::-webkit-inner-spin-button,
      ${t} input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
      }

      ${t} input[type="number"] {
        -moz-appearance: textfield;
      }

      ${t} input[type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
      }

      ${t} input[type="search"]::-webkit-search-decoration {
        -webkit-appearance: none !important;
      }

      ${t} ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
      }

      ${t} details {
        display: block;
      }

      ${t} summary {
        display: list-item;
      }

      template {
        display: none;
      }

      [hidden] {
        display: none !important;
      }

      ${t} :where(
          blockquote,
          dl,
          dd,
          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          hr,
          figure,
          p,
          pre
        ) {
        margin: 0;
      }

      ${t} button {
        background: transparent;
        padding: 0;
      }

      ${t} fieldset {
        margin: 0;
        padding: 0;
      }

      ${t} :where(ol, ul) {
        margin: 0;
        padding: 0;
      }

      ${t} textarea {
        resize: vertical;
      }

      ${t} :where(button, [role="button"]) {
        cursor: pointer;
      }

      ${t} button::-moz-focus-inner {
        border: 0 !important;
      }

      ${t} table {
        border-collapse: collapse;
      }

      ${t} :where(h1, h2, h3, h4, h5, h6) {
        font-size: inherit;
        font-weight: inherit;
      }

      ${t} :where(button, input, optgroup, select, textarea) {
        padding: 0;
        line-height: inherit;
        color: inherit;
      }

      ${t} :where(img, svg, video, canvas, audio, iframe, embed, object) {
        display: block;
      }

      ${t} :where(img, video) {
        max-width: 100%;
        height: auto;
      }

      [data-js-focus-visible]
        :focus:not([data-focus-visible-added]):not(
          [data-focus-visible-disabled]
        ) {
        outline: none;
        box-shadow: none;
      }

      ${t} select::-ms-expand {
        display: none;
      }

      ${RG}
    `
  }
);
function lNe(t, e) {
  return `${t} returned \`undefined\`. Seems you forgot to wrap component within ${e}`;
}
function Ks(t = {}) {
  const {
    name: e,
    strict: n = !0,
    hookName: r = "useContext",
    providerName: i = "Provider",
    errorMessage: a,
    defaultValue: o
  } = t, s = Wt(o);
  s.displayName = e;
  function l() {
    var c;
    const d = lt(s);
    if (!d && n) {
      const u = new Error(
        a ?? lNe(r, i)
      );
      throw u.name = "ContextError", (c = Error.captureStackTrace) == null || c.call(Error, u, l), u;
    }
    return d;
  }
  return [s.Provider, l, s];
}
var [cNe, dNe] = Ks({
  strict: !1,
  name: "PortalManagerContext"
});
function gG(t) {
  const { children: e, zIndex: n } = t;
  return /* @__PURE__ */ E.jsx(cNe, { value: { zIndex: n }, children: e });
}
gG.displayName = "PortalManager";
var GM = globalThis != null && globalThis.document ? xp : Ee, [yG, uNe] = Ks({
  strict: !1,
  name: "PortalContext"
}), FS = "chakra-portal", hNe = ".chakra-portal", NNe = (t) => /* @__PURE__ */ E.jsx(
  "div",
  {
    className: "chakra-portal-zIndex",
    style: {
      position: "absolute",
      zIndex: t.zIndex,
      top: 0,
      left: 0,
      right: 0
      // NB: Don't add `bottom: 0`, it makes the entire app unusable
      // @see https://github.com/chakra-ui/chakra-ui/issues/3201
    },
    children: t.children
  }
), MNe = (t) => {
  const { appendToParentPortal: e, children: n } = t, [r, i] = nt(null), a = Ve(null), [, o] = nt({});
  Ee(() => o({}), []);
  const s = uNe(), l = dNe();
  GM(() => {
    if (!r)
      return;
    const d = r.ownerDocument, u = e ? s ?? d.body : d.body;
    if (!u)
      return;
    a.current = d.createElement("div"), a.current.className = FS, u.appendChild(a.current), o({});
    const h = a.current;
    return () => {
      u.contains(h) && u.removeChild(h);
    };
  }, [r]);
  const c = l != null && l.zIndex ? /* @__PURE__ */ E.jsx(NNe, { zIndex: l == null ? void 0 : l.zIndex, children: n }) : n;
  return a.current ? EE(
    /* @__PURE__ */ E.jsx(yG, { value: a.current, children: c }),
    a.current
  ) : /* @__PURE__ */ E.jsx(
    "span",
    {
      ref: (d) => {
        d && i(d);
      }
    }
  );
}, pNe = (t) => {
  const { children: e, containerRef: n, appendToParentPortal: r } = t, i = n.current, a = i ?? (typeof window < "u" ? document.body : void 0), o = vt(() => {
    const l = i == null ? void 0 : i.ownerDocument.createElement("div");
    return l && (l.className = FS), l;
  }, [i]), [, s] = nt({});
  return GM(() => s({}), []), GM(() => {
    if (!(!o || !a))
      return a.appendChild(o), () => {
        a.removeChild(o);
      };
  }, [o, a]), a && o ? EE(
    /* @__PURE__ */ E.jsx(yG, { value: r ? o : null, children: e }),
    o
  ) : null;
};
function lm(t) {
  const e = {
    appendToParentPortal: !0,
    ...t
  }, { containerRef: n, ...r } = e;
  return n ? /* @__PURE__ */ E.jsx(pNe, { containerRef: n, ...r }) : /* @__PURE__ */ E.jsx(MNe, { ...r });
}
lm.className = FS;
lm.selector = hNe;
lm.displayName = "Portal";
function FU() {
  const t = lt(
    dc
  );
  if (!t)
    throw Error(
      "useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`"
    );
  return t;
}
var vS = Wt({});
vS.displayName = "ColorModeContext";
function IS() {
  const t = lt(vS);
  if (t === void 0)
    throw new Error("useColorMode must be used within a ColorModeProvider");
  return t;
}
var aT = {
  light: "chakra-ui-light",
  dark: "chakra-ui-dark"
};
function mNe(t = {}) {
  const { preventTransition: e = !0 } = t, n = {
    setDataset: (r) => {
      const i = e ? n.preventTransition() : void 0;
      document.documentElement.dataset.theme = r, document.documentElement.style.colorScheme = r, i == null || i();
    },
    setClassName(r) {
      document.body.classList.add(r ? aT.dark : aT.light), document.body.classList.remove(r ? aT.light : aT.dark);
    },
    query() {
      return window.matchMedia("(prefers-color-scheme: dark)");
    },
    getSystemTheme(r) {
      var i;
      return ((i = n.query().matches) != null ? i : r === "dark") ? "dark" : "light";
    },
    addListener(r) {
      const i = n.query(), a = (o) => {
        r(o.matches ? "dark" : "light");
      };
      return typeof i.addListener == "function" ? i.addListener(a) : i.addEventListener("change", a), () => {
        typeof i.removeListener == "function" ? i.removeListener(a) : i.removeEventListener("change", a);
      };
    },
    preventTransition() {
      const r = document.createElement("style");
      return r.appendChild(
        document.createTextNode(
          "*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}"
        )
      ), document.head.appendChild(r), () => {
        window.getComputedStyle(document.body), requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            document.head.removeChild(r);
          });
        });
      };
    }
  };
  return n;
}
var TNe = "chakra-ui-color-mode";
function fNe(t) {
  return {
    ssr: !1,
    type: "localStorage",
    get(e) {
      if (!(globalThis != null && globalThis.document))
        return e;
      let n;
      try {
        n = localStorage.getItem(t) || e;
      } catch {
      }
      return n || e;
    },
    set(e) {
      try {
        localStorage.setItem(t, e);
      } catch {
      }
    }
  };
}
var VNe = fNe(TNe), X4 = () => {
};
function _4(t, e) {
  return t.type === "cookie" && t.ssr ? t.get(e) : e;
}
function ZG(t) {
  const {
    value: e,
    children: n,
    options: {
      useSystemColorMode: r,
      initialColorMode: i,
      disableTransitionOnChange: a
    } = {},
    colorModeManager: o = VNe
  } = t, s = i === "dark" ? "dark" : "light", [l, c] = nt(
    () => _4(o, s)
  ), [d, u] = nt(
    () => _4(o)
  ), { getSystemTheme: h, setClassName: N, setDataset: M, addListener: p } = vt(
    () => mNe({ preventTransition: a }),
    [a]
  ), m = i === "system" && !l ? d : l, R = De(
    (g) => {
      const y = g === "system" ? h() : g;
      c(y), N(y === "dark"), M(y), o.set(y);
    },
    [o, h, N, M]
  );
  GM(() => {
    i === "system" && u(h());
  }, []), Ee(() => {
    const g = o.get();
    if (g) {
      R(g);
      return;
    }
    if (i === "system") {
      R("system");
      return;
    }
    R(s);
  }, [o, s, i, R]);
  const V = De(() => {
    R(m === "dark" ? "light" : "dark");
  }, [m, R]);
  Ee(() => {
    if (r)
      return p(R);
  }, [r, p, R]);
  const U = vt(
    () => ({
      colorMode: e ?? m,
      toggleColorMode: e ? X4 : V,
      setColorMode: e ? X4 : R,
      forced: e !== void 0
    }),
    [m, V, R, e]
  );
  return /* @__PURE__ */ E.jsx(vS.Provider, { value: U, children: n });
}
ZG.displayName = "ColorModeProvider";
function UNe() {
  const t = IS(), e = FU();
  return { ...t, theme: e };
}
function RNe(t, e, n) {
  var r, i;
  if (e == null)
    return e;
  const a = (o) => {
    var s, l;
    return (l = (s = t.__breakpoints) == null ? void 0 : s.asArray) == null ? void 0 : l[o];
  };
  return (i = (r = a(e)) != null ? r : a(n)) != null ? i : n;
}
function gNe(t, e, n) {
  var r, i;
  if (e == null)
    return e;
  const a = (o) => {
    var s, l;
    return (l = (s = t.__cssMap) == null ? void 0 : s[o]) == null ? void 0 : l.value;
  };
  return (i = (r = a(e)) != null ? r : a(n)) != null ? i : n;
}
function yNe(t, e, n) {
  const r = FU();
  return ZNe(t, e, n)(r);
}
function ZNe(t, e, n) {
  const r = Array.isArray(e) ? e : [e], i = Array.isArray(n) ? n : [n];
  return (a) => {
    const o = i.filter(Boolean), s = r.map((l, c) => {
      var d, u;
      if (t === "breakpoints")
        return RNe(a, l, (d = o[c]) != null ? d : l);
      const h = `${t}.${l}`;
      return gNe(a, h, (u = o[c]) != null ? u : l);
    });
    return Array.isArray(e) ? s : s[0];
  };
}
var gr = (...t) => t.filter(Boolean).join(" ");
function Ea(t) {
  const e = typeof t;
  return t != null && (e === "object" || e === "function") && !Array.isArray(t);
}
function Ts(t, ...e) {
  return bNe(t) ? t(...e) : t;
}
var bNe = (t) => typeof t == "function", OV = (t) => t ? "" : void 0;
function Zl(...t) {
  return function(n) {
    t.some((r) => (r == null || r(n), n == null ? void 0 : n.defaultPrevented));
  };
}
function ENe(...t) {
  return function(n) {
    t.forEach((r) => {
      r == null || r(n);
    });
  };
}
var YV = { exports: {} };
YV.exports;
(function(t, e) {
  var n = 200, r = "__lodash_hash_undefined__", i = 800, a = 16, o = 9007199254740991, s = "[object Arguments]", l = "[object Array]", c = "[object AsyncFunction]", d = "[object Boolean]", u = "[object Date]", h = "[object Error]", N = "[object Function]", M = "[object GeneratorFunction]", p = "[object Map]", m = "[object Number]", R = "[object Null]", V = "[object Object]", U = "[object Proxy]", g = "[object RegExp]", y = "[object Set]", x = "[object String]", f = "[object Undefined]", D = "[object WeakMap]", Y = "[object ArrayBuffer]", Q = "[object DataView]", G = "[object Float32Array]", ne = "[object Float64Array]", O = "[object Int8Array]", T = "[object Int16Array]", Z = "[object Int32Array]", z = "[object Uint8Array]", j = "[object Uint8ClampedArray]", w = "[object Uint16Array]", C = "[object Uint32Array]", J = /[\\^$.*+?()[\]{}|]/g, I = /^\[object .+?Constructor\]$/, b = /^(?:0|[1-9]\d*)$/, k = {};
  k[G] = k[ne] = k[O] = k[T] = k[Z] = k[z] = k[j] = k[w] = k[C] = !0, k[s] = k[l] = k[Y] = k[d] = k[Q] = k[u] = k[h] = k[N] = k[p] = k[m] = k[V] = k[g] = k[y] = k[x] = k[D] = !1;
  var ae = typeof ya == "object" && ya && ya.Object === Object && ya, oe = typeof self == "object" && self && self.Object === Object && self, le = ae || oe || Function("return this")(), fe = e && !e.nodeType && e, de = fe && !0 && t && !t.nodeType && t, Me = de && de.exports === fe, je = Me && ae.process, Se = function() {
    try {
      var B = de && de.require && de.require("util").types;
      return B || je && je.binding && je.binding("util");
    } catch {
    }
  }(), se = Se && Se.isTypedArray;
  function Ce(B, $, F) {
    switch (F.length) {
      case 0:
        return B.call($);
      case 1:
        return B.call($, F[0]);
      case 2:
        return B.call($, F[0], F[1]);
      case 3:
        return B.call($, F[0], F[1], F[2]);
    }
    return B.apply($, F);
  }
  function et(B, $) {
    for (var F = -1, A = Array(B); ++F < B; )
      A[F] = $(F);
    return A;
  }
  function at(B) {
    return function($) {
      return B($);
    };
  }
  function Rn(B, $) {
    return B == null ? void 0 : B[$];
  }
  function Zt(B, $) {
    return function(F) {
      return B($(F));
    };
  }
  var kt = Array.prototype, Pn = Function.prototype, Oe = Object.prototype, Xe = le["__core-js_shared__"], ft = Pn.toString, Le = Oe.hasOwnProperty, dt = function() {
    var B = /[^.]+$/.exec(Xe && Xe.keys && Xe.keys.IE_PROTO || "");
    return B ? "Symbol(src)_1." + B : "";
  }(), Dt = Oe.toString, ut = ft.call(Object), v = RegExp(
    "^" + ft.call(Le).replace(J, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), S = Me ? le.Buffer : void 0, W = le.Symbol, L = le.Uint8Array, P = S ? S.allocUnsafe : void 0, q = Zt(Object.getPrototypeOf, Object), ie = Object.create, Be = Oe.propertyIsEnumerable, Je = kt.splice, He = W ? W.toStringTag : void 0, Qt = function() {
    try {
      var B = nl(Object, "defineProperty");
      return B({}, "", {}), B;
    } catch {
    }
  }(), it = S ? S.isBuffer : void 0, sn = Math.max, Ao = Date.now, Pt = nl(le, "Map"), Ct = nl(Object, "create"), no = function() {
    function B() {
    }
    return function($) {
      if (!ao($))
        return {};
      if (ie)
        return ie($);
      B.prototype = $;
      var F = new B();
      return B.prototype = void 0, F;
    };
  }();
  function wt(B) {
    var $ = -1, F = B == null ? 0 : B.length;
    for (this.clear(); ++$ < F; ) {
      var A = B[$];
      this.set(A[0], A[1]);
    }
  }
  function xn() {
    this.__data__ = Ct ? Ct(null) : {}, this.size = 0;
  }
  function Ho(B) {
    var $ = this.has(B) && delete this.__data__[B];
    return this.size -= $ ? 1 : 0, $;
  }
  function Wn(B) {
    var $ = this.__data__;
    if (Ct) {
      var F = $[B];
      return F === r ? void 0 : F;
    }
    return Le.call($, B) ? $[B] : void 0;
  }
  function gn(B) {
    var $ = this.__data__;
    return Ct ? $[B] !== void 0 : Le.call($, B);
  }
  function Xo(B, $) {
    var F = this.__data__;
    return this.size += this.has(B) ? 0 : 1, F[B] = Ct && $ === void 0 ? r : $, this;
  }
  wt.prototype.clear = xn, wt.prototype.delete = Ho, wt.prototype.get = Wn, wt.prototype.has = gn, wt.prototype.set = Xo;
  function bt(B) {
    var $ = -1, F = B == null ? 0 : B.length;
    for (this.clear(); ++$ < F; ) {
      var A = B[$];
      this.set(A[0], A[1]);
    }
  }
  function jn() {
    this.__data__ = [], this.size = 0;
  }
  function _o(B) {
    var $ = this.__data__, F = An($, B);
    if (F < 0)
      return !1;
    var A = $.length - 1;
    return F == A ? $.pop() : Je.call($, F, 1), --this.size, !0;
  }
  function Dn(B) {
    var $ = this.__data__, F = An($, B);
    return F < 0 ? void 0 : $[F][1];
  }
  function zn(B) {
    return An(this.__data__, B) > -1;
  }
  function el(B, $) {
    var F = this.__data__, A = An(F, B);
    return A < 0 ? (++this.size, F.push([B, $])) : F[A][1] = $, this;
  }
  bt.prototype.clear = jn, bt.prototype.delete = _o, bt.prototype.get = Dn, bt.prototype.has = zn, bt.prototype.set = el;
  function Lt(B) {
    var $ = -1, F = B == null ? 0 : B.length;
    for (this.clear(); ++$ < F; ) {
      var A = B[$];
      this.set(A[0], A[1]);
    }
  }
  function X() {
    this.size = 0, this.__data__ = {
      hash: new wt(),
      map: new (Pt || bt)(),
      string: new wt()
    };
  }
  function he(B) {
    var $ = Yc(this, B).delete(B);
    return this.size -= $ ? 1 : 0, $;
  }
  function pe(B) {
    return Yc(this, B).get(B);
  }
  function we(B) {
    return Yc(this, B).has(B);
  }
  function It(B, $) {
    var F = Yc(this, B), A = F.size;
    return F.set(B, $), this.size += F.size == A ? 0 : 1, this;
  }
  Lt.prototype.clear = X, Lt.prototype.delete = he, Lt.prototype.get = pe, Lt.prototype.has = we, Lt.prototype.set = It;
  function _e(B) {
    var $ = this.__data__ = new bt(B);
    this.size = $.size;
  }
  function qe() {
    this.__data__ = new bt(), this.size = 0;
  }
  function gt(B) {
    var $ = this.__data__, F = $.delete(B);
    return this.size = $.size, F;
  }
  function Bn(B) {
    return this.__data__.get(B);
  }
  function Mn(B) {
    return this.__data__.has(B);
  }
  function fn(B, $) {
    var F = this.__data__;
    if (F instanceof bt) {
      var A = F.__data__;
      if (!Pt || A.length < n - 1)
        return A.push([B, $]), this.size = ++F.size, this;
      F = this.__data__ = new Lt(A);
    }
    return F.set(B, $), this.size = F.size, this;
  }
  _e.prototype.clear = qe, _e.prototype.delete = gt, _e.prototype.get = Bn, _e.prototype.has = Mn, _e.prototype.set = fn;
  function lr(B, $) {
    var F = Qc(B), A = !F && rl(B), re = !F && !A && km(B), me = !F && !A && !re && wm(B), $e = F || A || re || me, Ye = $e ? et(B.length, String) : [], ht = Ye.length;
    for (var mt in B)
      ($ || Le.call(B, mt)) && !($e && // Safari 9 has enumerable `arguments.length` in strict mode.
      (mt == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      re && (mt == "offset" || mt == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      me && (mt == "buffer" || mt == "byteLength" || mt == "byteOffset") || // Skip index properties.
      Wm(mt, ht))) && Ye.push(mt);
    return Ye;
  }
  function Zr(B, $, F) {
    (F !== void 0 && !bu(B[$], F) || F === void 0 && !($ in B)) && wa(B, $, F);
  }
  function ro(B, $, F) {
    var A = B[$];
    (!(Le.call(B, $) && bu(A, F)) || F === void 0 && !($ in B)) && wa(B, $, F);
  }
  function An(B, $) {
    for (var F = B.length; F--; )
      if (bu(B[F][0], $))
        return F;
    return -1;
  }
  function wa(B, $, F) {
    $ == "__proto__" && Qt ? Qt(B, $, {
      configurable: !0,
      enumerable: !0,
      value: F,
      writable: !0
    }) : B[$] = F;
  }
  var kc = NR();
  function Ci(B) {
    return B == null ? B === void 0 ? f : R : He && He in Object(B) ? NN(B) : TR(B);
  }
  function Po(B) {
    return ai(B) && Ci(B) == s;
  }
  function wc(B) {
    if (!ao(B) || mR(B))
      return !1;
    var $ = Eu(B) ? v : I;
    return $.test(UR(B));
  }
  function Fc(B) {
    return ai(B) && Su(B.length) && !!k[Ci(B)];
  }
  function vc(B) {
    if (!ao(B))
      return zm(B);
    var $ = Dm(B), F = [];
    for (var A in B)
      A == "constructor" && ($ || !Le.call(B, A)) || F.push(A);
    return F;
  }
  function io(B, $, F, A, re) {
    B !== $ && kc($, function(me, $e) {
      if (re || (re = new _e()), ao(me))
        Ic(B, $, $e, F, io, A, re);
      else {
        var Ye = A ? A(MN(B, $e), me, $e + "", B, $, re) : void 0;
        Ye === void 0 && (Ye = me), Zr(B, $e, Ye);
      }
    }, vm);
  }
  function Ic(B, $, F, A, re, me, $e) {
    var Ye = MN(B, F), ht = MN($, F), mt = $e.get(ht);
    if (mt) {
      Zr(B, F, mt);
      return;
    }
    var Ot = me ? me(Ye, ht, F + "", B, $, $e) : void 0, br = Ot === void 0;
    if (br) {
      var kr = Qc(ht), Ko = !kr && km(ht), xu = !kr && !Ko && wm(ht);
      Ot = ht, kr || Ko || xu ? Qc(Ye) ? Ot = Ye : mN(Ye) ? Ot = dR(Ye) : Ko ? (br = !1, Ot = sR(ht, !0)) : xu ? (br = !1, Ot = cR(ht, !0)) : Ot = [] : Cc(ht) || rl(ht) ? (Ot = Ye, rl(Ye) ? Ot = Fm(Ye) : (!ao(Ye) || Eu(Ye)) && (Ot = MR(ht))) : br = !1;
    }
    br && ($e.set(ht, Ot), re(Ot, ht, A, me, $e), $e.delete(ht)), Zr(B, F, Ot);
  }
  function tl(B, $) {
    return pN(fR(B, $, Om), B + "");
  }
  var Oc = Qt ? function(B, $) {
    return Qt(B, "toString", {
      configurable: !0,
      enumerable: !1,
      value: Im($),
      writable: !0
    });
  } : Om;
  function sR(B, $) {
    if ($)
      return B.slice();
    var F = B.length, A = P ? P(F) : new B.constructor(F);
    return B.copy(A), A;
  }
  function lR(B) {
    var $ = new B.constructor(B.byteLength);
    return new L($).set(new L(B)), $;
  }
  function cR(B, $) {
    var F = $ ? lR(B.buffer) : B.buffer;
    return new B.constructor(F, B.byteOffset, B.length);
  }
  function dR(B, $) {
    var F = -1, A = B.length;
    for ($ || ($ = Array(A)); ++F < A; )
      $[F] = B[F];
    return $;
  }
  function uR(B, $, F, A) {
    var re = !F;
    F || (F = {});
    for (var me = -1, $e = $.length; ++me < $e; ) {
      var Ye = $[me], ht = A ? A(F[Ye], B[Ye], Ye, F, B) : void 0;
      ht === void 0 && (ht = B[Ye]), re ? wa(F, Ye, ht) : ro(F, Ye, ht);
    }
    return F;
  }
  function hR(B) {
    return tl(function($, F) {
      var A = -1, re = F.length, me = re > 1 ? F[re - 1] : void 0, $e = re > 2 ? F[2] : void 0;
      for (me = B.length > 3 && typeof me == "function" ? (re--, me) : void 0, $e && jm(F[0], F[1], $e) && (me = re < 3 ? void 0 : me, re = 1), $ = Object($); ++A < re; ) {
        var Ye = F[A];
        Ye && B($, Ye, A, me);
      }
      return $;
    });
  }
  function NR(B) {
    return function($, F, A) {
      for (var re = -1, me = Object($), $e = A($), Ye = $e.length; Ye--; ) {
        var ht = $e[B ? Ye : ++re];
        if (F(me[ht], ht, me) === !1)
          break;
      }
      return $;
    };
  }
  function Yc(B, $) {
    var F = B.__data__;
    return pR($) ? F[typeof $ == "string" ? "string" : "hash"] : F.map;
  }
  function nl(B, $) {
    var F = Rn(B, $);
    return wc(F) ? F : void 0;
  }
  function NN(B) {
    var $ = Le.call(B, He), F = B[He];
    try {
      B[He] = void 0;
      var A = !0;
    } catch {
    }
    var re = Dt.call(B);
    return A && ($ ? B[He] = F : delete B[He]), re;
  }
  function MR(B) {
    return typeof B.constructor == "function" && !Dm(B) ? no(q(B)) : {};
  }
  function Wm(B, $) {
    var F = typeof B;
    return $ = $ ?? o, !!$ && (F == "number" || F != "symbol" && b.test(B)) && B > -1 && B % 1 == 0 && B < $;
  }
  function jm(B, $, F) {
    if (!ao(F))
      return !1;
    var A = typeof $;
    return (A == "number" ? Gc(F) && Wm($, F.length) : A == "string" && $ in F) ? bu(F[$], B) : !1;
  }
  function pR(B) {
    var $ = typeof B;
    return $ == "string" || $ == "number" || $ == "symbol" || $ == "boolean" ? B !== "__proto__" : B === null;
  }
  function mR(B) {
    return !!dt && dt in B;
  }
  function Dm(B) {
    var $ = B && B.constructor, F = typeof $ == "function" && $.prototype || Oe;
    return B === F;
  }
  function zm(B) {
    var $ = [];
    if (B != null)
      for (var F in Object(B))
        $.push(F);
    return $;
  }
  function TR(B) {
    return Dt.call(B);
  }
  function fR(B, $, F) {
    return $ = sn($ === void 0 ? B.length - 1 : $, 0), function() {
      for (var A = arguments, re = -1, me = sn(A.length - $, 0), $e = Array(me); ++re < me; )
        $e[re] = A[$ + re];
      re = -1;
      for (var Ye = Array($ + 1); ++re < $; )
        Ye[re] = A[re];
      return Ye[$] = F($e), Ce(B, this, Ye);
    };
  }
  function MN(B, $) {
    if (!($ === "constructor" && typeof B[$] == "function") && $ != "__proto__")
      return B[$];
  }
  var pN = VR(Oc);
  function VR(B) {
    var $ = 0, F = 0;
    return function() {
      var A = Ao(), re = a - (A - F);
      if (F = A, re > 0) {
        if (++$ >= i)
          return arguments[0];
      } else
        $ = 0;
      return B.apply(void 0, arguments);
    };
  }
  function UR(B) {
    if (B != null) {
      try {
        return ft.call(B);
      } catch {
      }
      try {
        return B + "";
      } catch {
      }
    }
    return "";
  }
  function bu(B, $) {
    return B === $ || B !== B && $ !== $;
  }
  var rl = Po(function() {
    return arguments;
  }()) ? Po : function(B) {
    return ai(B) && Le.call(B, "callee") && !Be.call(B, "callee");
  }, Qc = Array.isArray;
  function Gc(B) {
    return B != null && Su(B.length) && !Eu(B);
  }
  function mN(B) {
    return ai(B) && Gc(B);
  }
  var km = it || gR;
  function Eu(B) {
    if (!ao(B))
      return !1;
    var $ = Ci(B);
    return $ == N || $ == M || $ == c || $ == U;
  }
  function Su(B) {
    return typeof B == "number" && B > -1 && B % 1 == 0 && B <= o;
  }
  function ao(B) {
    var $ = typeof B;
    return B != null && ($ == "object" || $ == "function");
  }
  function ai(B) {
    return B != null && typeof B == "object";
  }
  function Cc(B) {
    if (!ai(B) || Ci(B) != V)
      return !1;
    var $ = q(B);
    if ($ === null)
      return !0;
    var F = Le.call($, "constructor") && $.constructor;
    return typeof F == "function" && F instanceof F && ft.call(F) == ut;
  }
  var wm = se ? at(se) : Fc;
  function Fm(B) {
    return uR(B, vm(B));
  }
  function vm(B) {
    return Gc(B) ? lr(B, !0) : vc(B);
  }
  var RR = hR(function(B, $, F, A) {
    io(B, $, F, A);
  });
  function Im(B) {
    return function() {
      return B;
    };
  }
  function Om(B) {
    return B;
  }
  function gR() {
    return !1;
  }
  t.exports = RR;
})(YV, YV.exports);
var SNe = YV.exports;
const Za = /* @__PURE__ */ fc(SNe);
var xNe = (t) => /!(important)?$/.test(t), P4 = (t) => typeof t == "string" ? t.replace(/!(important)?$/, "").trim() : t, WNe = (t, e) => (n) => {
  const r = String(e), i = xNe(r), a = P4(r), o = t ? `${t}.${a}` : a;
  let s = Ea(n.__cssMap) && o in n.__cssMap ? n.__cssMap[o].varRef : e;
  return s = P4(s), i ? `${s} !important` : s;
};
function OS(t) {
  const { scale: e, transform: n, compose: r } = t;
  return (a, o) => {
    var s;
    const l = WNe(e, a)(o);
    let c = (s = n == null ? void 0 : n(l, o)) != null ? s : l;
    return r && (c = r(c, o)), c;
  };
}
var oT = (...t) => (e) => t.reduce((n, r) => r(n), e);
function ua(t, e) {
  return (n) => {
    const r = { property: n, scale: t };
    return r.transform = OS({
      scale: t,
      transform: e
    }), r;
  };
}
var jNe = ({ rtl: t, ltr: e }) => (n) => n.direction === "rtl" ? t : e;
function DNe(t) {
  const { property: e, scale: n, transform: r } = t;
  return {
    scale: n,
    property: jNe(e),
    transform: n ? OS({
      scale: n,
      compose: r
    }) : r
  };
}
var bG = [
  "rotate(var(--chakra-rotate, 0))",
  "scaleX(var(--chakra-scale-x, 1))",
  "scaleY(var(--chakra-scale-y, 1))",
  "skewX(var(--chakra-skew-x, 0))",
  "skewY(var(--chakra-skew-y, 0))"
];
function zNe() {
  return [
    "translateX(var(--chakra-translate-x, 0))",
    "translateY(var(--chakra-translate-y, 0))",
    ...bG
  ].join(" ");
}
function kNe() {
  return [
    "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
    ...bG
  ].join(" ");
}
var wNe = {
  "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
  filter: [
    "var(--chakra-blur)",
    "var(--chakra-brightness)",
    "var(--chakra-contrast)",
    "var(--chakra-grayscale)",
    "var(--chakra-hue-rotate)",
    "var(--chakra-invert)",
    "var(--chakra-saturate)",
    "var(--chakra-sepia)",
    "var(--chakra-drop-shadow)"
  ].join(" ")
}, FNe = {
  backdropFilter: [
    "var(--chakra-backdrop-blur)",
    "var(--chakra-backdrop-brightness)",
    "var(--chakra-backdrop-contrast)",
    "var(--chakra-backdrop-grayscale)",
    "var(--chakra-backdrop-hue-rotate)",
    "var(--chakra-backdrop-invert)",
    "var(--chakra-backdrop-opacity)",
    "var(--chakra-backdrop-saturate)",
    "var(--chakra-backdrop-sepia)"
  ].join(" "),
  "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function vNe(t) {
  return {
    "--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
    "--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
    "--chakra-ring-width": t,
    boxShadow: [
      "var(--chakra-ring-offset-shadow)",
      "var(--chakra-ring-shadow)",
      "var(--chakra-shadow, 0 0 #0000)"
    ].join(", ")
  };
}
var INe = {
  "row-reverse": {
    space: "--chakra-space-x-reverse",
    divide: "--chakra-divide-x-reverse"
  },
  "column-reverse": {
    space: "--chakra-space-y-reverse",
    divide: "--chakra-divide-y-reverse"
  }
}, Zb = {
  "to-t": "to top",
  "to-tr": "to top right",
  "to-r": "to right",
  "to-br": "to bottom right",
  "to-b": "to bottom",
  "to-bl": "to bottom left",
  "to-l": "to left",
  "to-tl": "to top left"
}, ONe = new Set(Object.values(Zb)), bb = /* @__PURE__ */ new Set([
  "none",
  "-moz-initial",
  "inherit",
  "initial",
  "revert",
  "unset"
]), YNe = (t) => t.trim();
function QNe(t, e) {
  if (t == null || bb.has(t))
    return t;
  if (!(Eb(t) || bb.has(t)))
    return `url('${t}')`;
  const i = /(^[a-z-A-Z]+)\((.*)\)/g.exec(t), a = i == null ? void 0 : i[1], o = i == null ? void 0 : i[2];
  if (!a || !o)
    return t;
  const s = a.includes("-gradient") ? a : `${a}-gradient`, [l, ...c] = o.split(",").map(YNe).filter(Boolean);
  if ((c == null ? void 0 : c.length) === 0)
    return t;
  const d = l in Zb ? Zb[l] : l;
  c.unshift(d);
  const u = c.map((h) => {
    if (ONe.has(h))
      return h;
    const N = h.indexOf(" "), [M, p] = N !== -1 ? [h.substr(0, N), h.substr(N + 1)] : [h], m = Eb(p) ? p : p && p.split(" "), R = `colors.${M}`, V = R in e.__cssMap ? e.__cssMap[R].varRef : M;
    return m ? [
      V,
      ...Array.isArray(m) ? m : [m]
    ].join(" ") : V;
  });
  return `${s}(${u.join(", ")})`;
}
var Eb = (t) => typeof t == "string" && t.includes("(") && t.includes(")"), GNe = (t, e) => QNe(t, e ?? {});
function CNe(t) {
  return /^var\(--.+\)$/.test(t);
}
var LNe = (t) => {
  const e = parseFloat(t.toString()), n = t.toString().replace(String(e), "");
  return { unitless: !n, value: e, unit: n };
}, lo = (t) => (e) => `${t}(${e})`, $t = {
  filter(t) {
    return t !== "auto" ? t : wNe;
  },
  backdropFilter(t) {
    return t !== "auto" ? t : FNe;
  },
  ring(t) {
    return vNe($t.px(t));
  },
  bgClip(t) {
    return t === "text" ? { color: "transparent", backgroundClip: "text" } : { backgroundClip: t };
  },
  transform(t) {
    return t === "auto" ? zNe() : t === "auto-gpu" ? kNe() : t;
  },
  vh(t) {
    return t === "$100vh" ? "var(--chakra-vh)" : t;
  },
  px(t) {
    if (t == null)
      return t;
    const { unitless: e } = LNe(t);
    return e || typeof t == "number" ? `${t}px` : t;
  },
  fraction(t) {
    return typeof t != "number" || t > 1 ? t : `${t * 100}%`;
  },
  float(t, e) {
    const n = { left: "right", right: "left" };
    return e.direction === "rtl" ? n[t] : t;
  },
  degree(t) {
    if (CNe(t) || t == null)
      return t;
    const e = typeof t == "string" && !t.endsWith("deg");
    return typeof t == "number" || e ? `${t}deg` : t;
  },
  gradient: GNe,
  blur: lo("blur"),
  opacity: lo("opacity"),
  brightness: lo("brightness"),
  contrast: lo("contrast"),
  dropShadow: lo("drop-shadow"),
  grayscale: lo("grayscale"),
  hueRotate: lo("hue-rotate"),
  invert: lo("invert"),
  saturate: lo("saturate"),
  sepia: lo("sepia"),
  bgImage(t) {
    return t == null || Eb(t) || bb.has(t) ? t : `url(${t})`;
  },
  outline(t) {
    const e = String(t) === "0" || String(t) === "none";
    return t !== null && e ? { outline: "2px solid transparent", outlineOffset: "2px" } : { outline: t };
  },
  flexDirection(t) {
    var e;
    const { space: n, divide: r } = (e = INe[t]) != null ? e : {}, i = { flexDirection: t };
    return n && (i[n] = 1), r && (i[r] = 1), i;
  }
}, ee = {
  borderWidths: ua("borderWidths"),
  borderStyles: ua("borderStyles"),
  colors: ua("colors"),
  borders: ua("borders"),
  gradients: ua("gradients", $t.gradient),
  radii: ua("radii", $t.px),
  space: ua("space", oT($t.vh, $t.px)),
  spaceT: ua("space", oT($t.vh, $t.px)),
  degreeT(t) {
    return { property: t, transform: $t.degree };
  },
  prop(t, e, n) {
    return {
      property: t,
      scale: e,
      ...e && {
        transform: OS({ scale: e, transform: n })
      }
    };
  },
  propT(t, e) {
    return { property: t, transform: e };
  },
  sizes: ua("sizes", oT($t.vh, $t.px)),
  sizesT: ua("sizes", oT($t.vh, $t.fraction)),
  shadows: ua("shadows"),
  logical: DNe,
  blur: ua("blur", $t.blur)
}, $T = {
  background: ee.colors("background"),
  backgroundColor: ee.colors("backgroundColor"),
  backgroundImage: ee.gradients("backgroundImage"),
  backgroundSize: !0,
  backgroundPosition: !0,
  backgroundRepeat: !0,
  backgroundAttachment: !0,
  backgroundClip: { transform: $t.bgClip },
  bgSize: ee.prop("backgroundSize"),
  bgPosition: ee.prop("backgroundPosition"),
  bg: ee.colors("background"),
  bgColor: ee.colors("backgroundColor"),
  bgPos: ee.prop("backgroundPosition"),
  bgRepeat: ee.prop("backgroundRepeat"),
  bgAttachment: ee.prop("backgroundAttachment"),
  bgGradient: ee.gradients("backgroundImage"),
  bgClip: { transform: $t.bgClip }
};
Object.assign($T, {
  bgImage: $T.backgroundImage,
  bgImg: $T.backgroundImage
});
var nn = {
  border: ee.borders("border"),
  borderWidth: ee.borderWidths("borderWidth"),
  borderStyle: ee.borderStyles("borderStyle"),
  borderColor: ee.colors("borderColor"),
  borderRadius: ee.radii("borderRadius"),
  borderTop: ee.borders("borderTop"),
  borderBlockStart: ee.borders("borderBlockStart"),
  borderTopLeftRadius: ee.radii("borderTopLeftRadius"),
  borderStartStartRadius: ee.logical({
    scale: "radii",
    property: {
      ltr: "borderTopLeftRadius",
      rtl: "borderTopRightRadius"
    }
  }),
  borderEndStartRadius: ee.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomLeftRadius",
      rtl: "borderBottomRightRadius"
    }
  }),
  borderTopRightRadius: ee.radii("borderTopRightRadius"),
  borderStartEndRadius: ee.logical({
    scale: "radii",
    property: {
      ltr: "borderTopRightRadius",
      rtl: "borderTopLeftRadius"
    }
  }),
  borderEndEndRadius: ee.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomRightRadius",
      rtl: "borderBottomLeftRadius"
    }
  }),
  borderRight: ee.borders("borderRight"),
  borderInlineEnd: ee.borders("borderInlineEnd"),
  borderBottom: ee.borders("borderBottom"),
  borderBlockEnd: ee.borders("borderBlockEnd"),
  borderBottomLeftRadius: ee.radii("borderBottomLeftRadius"),
  borderBottomRightRadius: ee.radii("borderBottomRightRadius"),
  borderLeft: ee.borders("borderLeft"),
  borderInlineStart: {
    property: "borderInlineStart",
    scale: "borders"
  },
  borderInlineStartRadius: ee.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
      rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
    }
  }),
  borderInlineEndRadius: ee.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
      rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
    }
  }),
  borderX: ee.borders(["borderLeft", "borderRight"]),
  borderInline: ee.borders("borderInline"),
  borderY: ee.borders(["borderTop", "borderBottom"]),
  borderBlock: ee.borders("borderBlock"),
  borderTopWidth: ee.borderWidths("borderTopWidth"),
  borderBlockStartWidth: ee.borderWidths("borderBlockStartWidth"),
  borderTopColor: ee.colors("borderTopColor"),
  borderBlockStartColor: ee.colors("borderBlockStartColor"),
  borderTopStyle: ee.borderStyles("borderTopStyle"),
  borderBlockStartStyle: ee.borderStyles("borderBlockStartStyle"),
  borderBottomWidth: ee.borderWidths("borderBottomWidth"),
  borderBlockEndWidth: ee.borderWidths("borderBlockEndWidth"),
  borderBottomColor: ee.colors("borderBottomColor"),
  borderBlockEndColor: ee.colors("borderBlockEndColor"),
  borderBottomStyle: ee.borderStyles("borderBottomStyle"),
  borderBlockEndStyle: ee.borderStyles("borderBlockEndStyle"),
  borderLeftWidth: ee.borderWidths("borderLeftWidth"),
  borderInlineStartWidth: ee.borderWidths("borderInlineStartWidth"),
  borderLeftColor: ee.colors("borderLeftColor"),
  borderInlineStartColor: ee.colors("borderInlineStartColor"),
  borderLeftStyle: ee.borderStyles("borderLeftStyle"),
  borderInlineStartStyle: ee.borderStyles("borderInlineStartStyle"),
  borderRightWidth: ee.borderWidths("borderRightWidth"),
  borderInlineEndWidth: ee.borderWidths("borderInlineEndWidth"),
  borderRightColor: ee.colors("borderRightColor"),
  borderInlineEndColor: ee.colors("borderInlineEndColor"),
  borderRightStyle: ee.borderStyles("borderRightStyle"),
  borderInlineEndStyle: ee.borderStyles("borderInlineEndStyle"),
  borderTopRadius: ee.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
  borderBottomRadius: ee.radii([
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ]),
  borderLeftRadius: ee.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
  borderRightRadius: ee.radii([
    "borderTopRightRadius",
    "borderBottomRightRadius"
  ])
};
Object.assign(nn, {
  rounded: nn.borderRadius,
  roundedTop: nn.borderTopRadius,
  roundedTopLeft: nn.borderTopLeftRadius,
  roundedTopRight: nn.borderTopRightRadius,
  roundedTopStart: nn.borderStartStartRadius,
  roundedTopEnd: nn.borderStartEndRadius,
  roundedBottom: nn.borderBottomRadius,
  roundedBottomLeft: nn.borderBottomLeftRadius,
  roundedBottomRight: nn.borderBottomRightRadius,
  roundedBottomStart: nn.borderEndStartRadius,
  roundedBottomEnd: nn.borderEndEndRadius,
  roundedLeft: nn.borderLeftRadius,
  roundedRight: nn.borderRightRadius,
  roundedStart: nn.borderInlineStartRadius,
  roundedEnd: nn.borderInlineEndRadius,
  borderStart: nn.borderInlineStart,
  borderEnd: nn.borderInlineEnd,
  borderTopStartRadius: nn.borderStartStartRadius,
  borderTopEndRadius: nn.borderStartEndRadius,
  borderBottomStartRadius: nn.borderEndStartRadius,
  borderBottomEndRadius: nn.borderEndEndRadius,
  borderStartRadius: nn.borderInlineStartRadius,
  borderEndRadius: nn.borderInlineEndRadius,
  borderStartWidth: nn.borderInlineStartWidth,
  borderEndWidth: nn.borderInlineEndWidth,
  borderStartColor: nn.borderInlineStartColor,
  borderEndColor: nn.borderInlineEndColor,
  borderStartStyle: nn.borderInlineStartStyle,
  borderEndStyle: nn.borderInlineEndStyle
});
var JNe = {
  color: ee.colors("color"),
  textColor: ee.colors("color"),
  fill: ee.colors("fill"),
  stroke: ee.colors("stroke")
}, Sb = {
  boxShadow: ee.shadows("boxShadow"),
  mixBlendMode: !0,
  blendMode: ee.prop("mixBlendMode"),
  backgroundBlendMode: !0,
  bgBlendMode: ee.prop("backgroundBlendMode"),
  opacity: !0
};
Object.assign(Sb, {
  shadow: Sb.boxShadow
});
var BNe = {
  filter: { transform: $t.filter },
  blur: ee.blur("--chakra-blur"),
  brightness: ee.propT("--chakra-brightness", $t.brightness),
  contrast: ee.propT("--chakra-contrast", $t.contrast),
  hueRotate: ee.degreeT("--chakra-hue-rotate"),
  invert: ee.propT("--chakra-invert", $t.invert),
  saturate: ee.propT("--chakra-saturate", $t.saturate),
  dropShadow: ee.propT("--chakra-drop-shadow", $t.dropShadow),
  backdropFilter: { transform: $t.backdropFilter },
  backdropBlur: ee.blur("--chakra-backdrop-blur"),
  backdropBrightness: ee.propT(
    "--chakra-backdrop-brightness",
    $t.brightness
  ),
  backdropContrast: ee.propT("--chakra-backdrop-contrast", $t.contrast),
  backdropHueRotate: ee.degreeT("--chakra-backdrop-hue-rotate"),
  backdropInvert: ee.propT("--chakra-backdrop-invert", $t.invert),
  backdropSaturate: ee.propT("--chakra-backdrop-saturate", $t.saturate)
}, QV = {
  alignItems: !0,
  alignContent: !0,
  justifyItems: !0,
  justifyContent: !0,
  flexWrap: !0,
  flexDirection: { transform: $t.flexDirection },
  flex: !0,
  flexFlow: !0,
  flexGrow: !0,
  flexShrink: !0,
  flexBasis: ee.sizes("flexBasis"),
  justifySelf: !0,
  alignSelf: !0,
  order: !0,
  placeItems: !0,
  placeContent: !0,
  placeSelf: !0,
  gap: ee.space("gap"),
  rowGap: ee.space("rowGap"),
  columnGap: ee.space("columnGap")
};
Object.assign(QV, {
  flexDir: QV.flexDirection
});
var EG = {
  gridGap: ee.space("gridGap"),
  gridColumnGap: ee.space("gridColumnGap"),
  gridRowGap: ee.space("gridRowGap"),
  gridColumn: !0,
  gridRow: !0,
  gridAutoFlow: !0,
  gridAutoColumns: !0,
  gridColumnStart: !0,
  gridColumnEnd: !0,
  gridRowStart: !0,
  gridRowEnd: !0,
  gridAutoRows: !0,
  gridTemplate: !0,
  gridTemplateColumns: !0,
  gridTemplateRows: !0,
  gridTemplateAreas: !0,
  gridArea: !0
}, ANe = {
  appearance: !0,
  cursor: !0,
  resize: !0,
  userSelect: !0,
  pointerEvents: !0,
  outline: { transform: $t.outline },
  outlineOffset: !0,
  outlineColor: ee.colors("outlineColor")
}, Na = {
  width: ee.sizesT("width"),
  inlineSize: ee.sizesT("inlineSize"),
  height: ee.sizes("height"),
  blockSize: ee.sizes("blockSize"),
  boxSize: ee.sizes(["width", "height"]),
  minWidth: ee.sizes("minWidth"),
  minInlineSize: ee.sizes("minInlineSize"),
  minHeight: ee.sizes("minHeight"),
  minBlockSize: ee.sizes("minBlockSize"),
  maxWidth: ee.sizes("maxWidth"),
  maxInlineSize: ee.sizes("maxInlineSize"),
  maxHeight: ee.sizes("maxHeight"),
  maxBlockSize: ee.sizes("maxBlockSize"),
  overflow: !0,
  overflowX: !0,
  overflowY: !0,
  overscrollBehavior: !0,
  overscrollBehaviorX: !0,
  overscrollBehaviorY: !0,
  display: !0,
  aspectRatio: !0,
  hideFrom: {
    scale: "breakpoints",
    transform: (t, e) => {
      var n, r, i;
      return { [`@media screen and (min-width: ${(i = (r = (n = e.__breakpoints) == null ? void 0 : n.get(t)) == null ? void 0 : r.minW) != null ? i : t})`]: { display: "none" } };
    }
  },
  hideBelow: {
    scale: "breakpoints",
    transform: (t, e) => {
      var n, r, i;
      return { [`@media screen and (max-width: ${(i = (r = (n = e.__breakpoints) == null ? void 0 : n.get(t)) == null ? void 0 : r._minW) != null ? i : t})`]: { display: "none" } };
    }
  },
  verticalAlign: !0,
  boxSizing: !0,
  boxDecorationBreak: !0,
  float: ee.propT("float", $t.float),
  objectFit: !0,
  objectPosition: !0,
  visibility: !0,
  isolation: !0
};
Object.assign(Na, {
  w: Na.width,
  h: Na.height,
  minW: Na.minWidth,
  maxW: Na.maxWidth,
  minH: Na.minHeight,
  maxH: Na.maxHeight,
  overscroll: Na.overscrollBehavior,
  overscrollX: Na.overscrollBehaviorX,
  overscrollY: Na.overscrollBehaviorY
});
var HNe = {
  listStyleType: !0,
  listStylePosition: !0,
  listStylePos: ee.prop("listStylePosition"),
  listStyleImage: !0,
  listStyleImg: ee.prop("listStyleImage")
};
function XNe(t, e, n, r) {
  const i = typeof e == "string" ? e.split(".") : [e];
  for (r = 0; r < i.length && t; r += 1)
    t = t[i[r]];
  return t === void 0 ? n : t;
}
var _Ne = (t) => {
  const e = /* @__PURE__ */ new WeakMap();
  return (r, i, a, o) => {
    if (typeof r > "u")
      return t(r, i, a);
    e.has(r) || e.set(r, /* @__PURE__ */ new Map());
    const s = e.get(r);
    if (s.has(i))
      return s.get(i);
    const l = t(r, i, a, o);
    return s.set(i, l), l;
  };
}, PNe = _Ne(XNe), KNe = {
  border: "0px",
  clip: "rect(0, 0, 0, 0)",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
}, $Ne = {
  position: "static",
  width: "auto",
  height: "auto",
  clip: "auto",
  padding: "0",
  margin: "0",
  overflow: "visible",
  whiteSpace: "normal"
}, Wg = (t, e, n) => {
  const r = {}, i = PNe(t, e, {});
  for (const a in i)
    a in n && n[a] != null || (r[a] = i[a]);
  return r;
}, qNe = {
  srOnly: {
    transform(t) {
      return t === !0 ? KNe : t === "focusable" ? $Ne : {};
    }
  },
  layerStyle: {
    processResult: !0,
    transform: (t, e, n) => Wg(e, `layerStyles.${t}`, n)
  },
  textStyle: {
    processResult: !0,
    transform: (t, e, n) => Wg(e, `textStyles.${t}`, n)
  },
  apply: {
    processResult: !0,
    transform: (t, e, n) => Wg(e, t, n)
  }
}, c1 = {
  position: !0,
  pos: ee.prop("position"),
  zIndex: ee.prop("zIndex", "zIndices"),
  inset: ee.spaceT("inset"),
  insetX: ee.spaceT(["left", "right"]),
  insetInline: ee.spaceT("insetInline"),
  insetY: ee.spaceT(["top", "bottom"]),
  insetBlock: ee.spaceT("insetBlock"),
  top: ee.spaceT("top"),
  insetBlockStart: ee.spaceT("insetBlockStart"),
  bottom: ee.spaceT("bottom"),
  insetBlockEnd: ee.spaceT("insetBlockEnd"),
  left: ee.spaceT("left"),
  insetInlineStart: ee.logical({
    scale: "space",
    property: { ltr: "left", rtl: "right" }
  }),
  right: ee.spaceT("right"),
  insetInlineEnd: ee.logical({
    scale: "space",
    property: { ltr: "right", rtl: "left" }
  })
};
Object.assign(c1, {
  insetStart: c1.insetInlineStart,
  insetEnd: c1.insetInlineEnd
});
var e1e = {
  ring: { transform: $t.ring },
  ringColor: ee.colors("--chakra-ring-color"),
  ringOffset: ee.prop("--chakra-ring-offset-width"),
  ringOffsetColor: ee.colors("--chakra-ring-offset-color"),
  ringInset: ee.prop("--chakra-ring-inset")
}, vn = {
  margin: ee.spaceT("margin"),
  marginTop: ee.spaceT("marginTop"),
  marginBlockStart: ee.spaceT("marginBlockStart"),
  marginRight: ee.spaceT("marginRight"),
  marginInlineEnd: ee.spaceT("marginInlineEnd"),
  marginBottom: ee.spaceT("marginBottom"),
  marginBlockEnd: ee.spaceT("marginBlockEnd"),
  marginLeft: ee.spaceT("marginLeft"),
  marginInlineStart: ee.spaceT("marginInlineStart"),
  marginX: ee.spaceT(["marginInlineStart", "marginInlineEnd"]),
  marginInline: ee.spaceT("marginInline"),
  marginY: ee.spaceT(["marginTop", "marginBottom"]),
  marginBlock: ee.spaceT("marginBlock"),
  padding: ee.space("padding"),
  paddingTop: ee.space("paddingTop"),
  paddingBlockStart: ee.space("paddingBlockStart"),
  paddingRight: ee.space("paddingRight"),
  paddingBottom: ee.space("paddingBottom"),
  paddingBlockEnd: ee.space("paddingBlockEnd"),
  paddingLeft: ee.space("paddingLeft"),
  paddingInlineStart: ee.space("paddingInlineStart"),
  paddingInlineEnd: ee.space("paddingInlineEnd"),
  paddingX: ee.space(["paddingInlineStart", "paddingInlineEnd"]),
  paddingInline: ee.space("paddingInline"),
  paddingY: ee.space(["paddingTop", "paddingBottom"]),
  paddingBlock: ee.space("paddingBlock")
};
Object.assign(vn, {
  m: vn.margin,
  mt: vn.marginTop,
  mr: vn.marginRight,
  me: vn.marginInlineEnd,
  marginEnd: vn.marginInlineEnd,
  mb: vn.marginBottom,
  ml: vn.marginLeft,
  ms: vn.marginInlineStart,
  marginStart: vn.marginInlineStart,
  mx: vn.marginX,
  my: vn.marginY,
  p: vn.padding,
  pt: vn.paddingTop,
  py: vn.paddingY,
  px: vn.paddingX,
  pb: vn.paddingBottom,
  pl: vn.paddingLeft,
  ps: vn.paddingInlineStart,
  paddingStart: vn.paddingInlineStart,
  pr: vn.paddingRight,
  pe: vn.paddingInlineEnd,
  paddingEnd: vn.paddingInlineEnd
});
var t1e = {
  textDecorationColor: ee.colors("textDecorationColor"),
  textDecoration: !0,
  textDecor: { property: "textDecoration" },
  textDecorationLine: !0,
  textDecorationStyle: !0,
  textDecorationThickness: !0,
  textUnderlineOffset: !0,
  textShadow: ee.shadows("textShadow")
}, n1e = {
  clipPath: !0,
  transform: ee.propT("transform", $t.transform),
  transformOrigin: !0,
  translateX: ee.spaceT("--chakra-translate-x"),
  translateY: ee.spaceT("--chakra-translate-y"),
  skewX: ee.degreeT("--chakra-skew-x"),
  skewY: ee.degreeT("--chakra-skew-y"),
  scaleX: ee.prop("--chakra-scale-x"),
  scaleY: ee.prop("--chakra-scale-y"),
  scale: ee.prop(["--chakra-scale-x", "--chakra-scale-y"]),
  rotate: ee.degreeT("--chakra-rotate")
}, r1e = {
  transition: !0,
  transitionDelay: !0,
  animation: !0,
  willChange: !0,
  transitionDuration: ee.prop("transitionDuration", "transition.duration"),
  transitionProperty: ee.prop("transitionProperty", "transition.property"),
  transitionTimingFunction: ee.prop(
    "transitionTimingFunction",
    "transition.easing"
  )
}, i1e = {
  fontFamily: ee.prop("fontFamily", "fonts"),
  fontSize: ee.prop("fontSize", "fontSizes", $t.px),
  fontWeight: ee.prop("fontWeight", "fontWeights"),
  lineHeight: ee.prop("lineHeight", "lineHeights"),
  letterSpacing: ee.prop("letterSpacing", "letterSpacings"),
  textAlign: !0,
  fontStyle: !0,
  textIndent: !0,
  wordBreak: !0,
  overflowWrap: !0,
  textOverflow: !0,
  textTransform: !0,
  whiteSpace: !0,
  isTruncated: {
    transform(t) {
      if (t === !0)
        return {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        };
    }
  },
  noOfLines: {
    static: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: "var(--chakra-line-clamp)"
    },
    property: "--chakra-line-clamp"
  }
}, a1e = {
  scrollBehavior: !0,
  scrollSnapAlign: !0,
  scrollSnapStop: !0,
  scrollSnapType: !0,
  scrollMargin: ee.spaceT("scrollMargin"),
  scrollMarginTop: ee.spaceT("scrollMarginTop"),
  scrollMarginBottom: ee.spaceT("scrollMarginBottom"),
  scrollMarginLeft: ee.spaceT("scrollMarginLeft"),
  scrollMarginRight: ee.spaceT("scrollMarginRight"),
  scrollMarginX: ee.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
  scrollMarginY: ee.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
  scrollPadding: ee.spaceT("scrollPadding"),
  scrollPaddingTop: ee.spaceT("scrollPaddingTop"),
  scrollPaddingBottom: ee.spaceT("scrollPaddingBottom"),
  scrollPaddingLeft: ee.spaceT("scrollPaddingLeft"),
  scrollPaddingRight: ee.spaceT("scrollPaddingRight"),
  scrollPaddingX: ee.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
  scrollPaddingY: ee.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
};
function SG(t) {
  return Ea(t) && t.reference ? t.reference : String(t);
}
var vU = (t, ...e) => e.map(SG).join(` ${t} `).replace(/calc/g, ""), K4 = (...t) => `calc(${vU("+", ...t)})`, $4 = (...t) => `calc(${vU("-", ...t)})`, xb = (...t) => `calc(${vU("*", ...t)})`, q4 = (...t) => `calc(${vU("/", ...t)})`, ez = (t) => {
  const e = SG(t);
  return e != null && !Number.isNaN(parseFloat(e)) ? String(e).startsWith("-") ? String(e).slice(1) : `-${e}` : xb(e, -1);
}, qc = Object.assign(
  (t) => ({
    add: (...e) => qc(K4(t, ...e)),
    subtract: (...e) => qc($4(t, ...e)),
    multiply: (...e) => qc(xb(t, ...e)),
    divide: (...e) => qc(q4(t, ...e)),
    negate: () => qc(ez(t)),
    toString: () => t.toString()
  }),
  {
    add: K4,
    subtract: $4,
    multiply: xb,
    divide: q4,
    negate: ez
  }
);
function o1e(t, e = "-") {
  return t.replace(/\s+/g, e);
}
function s1e(t) {
  const e = o1e(t.toString());
  return c1e(l1e(e));
}
function l1e(t) {
  return t.includes("\\.") ? t : !Number.isInteger(parseFloat(t.toString())) ? t.replace(".", "\\.") : t;
}
function c1e(t) {
  return t.replace(/[!-,/:-@[-^`{-~]/g, "\\$&");
}
function d1e(t, e = "") {
  return [e, t].filter(Boolean).join("-");
}
function u1e(t, e) {
  return `var(${t}${e ? `, ${e}` : ""})`;
}
function h1e(t, e = "") {
  return s1e(`--${d1e(t, e)}`);
}
function rt(t, e, n) {
  const r = h1e(t, n);
  return {
    variable: r,
    reference: u1e(r, e)
  };
}
function N1e(t, e) {
  const n = {};
  for (const r of e) {
    if (Array.isArray(r)) {
      const [i, a] = r;
      n[i] = rt(`${t}-${i}`, a);
      continue;
    }
    n[r] = rt(`${t}-${r}`);
  }
  return n;
}
function M1e(t) {
  const e = t == null ? 0 : t.length;
  return e ? t[e - 1] : void 0;
}
function p1e(t) {
  const e = parseFloat(t.toString()), n = t.toString().replace(String(e), "");
  return { unitless: !n, value: e, unit: n };
}
function Wb(t) {
  if (t == null)
    return t;
  const { unitless: e } = p1e(t);
  return e || typeof t == "number" ? `${t}px` : t;
}
var xG = (t, e) => parseInt(t[1], 10) > parseInt(e[1], 10) ? 1 : -1, YS = (t) => Object.fromEntries(Object.entries(t).sort(xG));
function tz(t) {
  const e = YS(t);
  return Object.assign(Object.values(e), e);
}
function m1e(t) {
  const e = Object.keys(YS(t));
  return new Set(e);
}
function nz(t) {
  var e;
  if (!t)
    return t;
  t = (e = Wb(t)) != null ? e : t;
  const n = -0.02;
  return typeof t == "number" ? `${t + n}` : t.replace(/(\d+\.?\d*)/u, (r) => `${parseFloat(r) + n}`);
}
function JN(t, e) {
  const n = ["@media screen"];
  return t && n.push("and", `(min-width: ${Wb(t)})`), e && n.push("and", `(max-width: ${Wb(e)})`), n.join(" ");
}
function T1e(t) {
  var e;
  if (!t)
    return null;
  t.base = (e = t.base) != null ? e : "0px";
  const n = tz(t), r = Object.entries(t).sort(xG).map(([o, s], l, c) => {
    var d;
    let [, u] = (d = c[l + 1]) != null ? d : [];
    return u = parseFloat(u) > 0 ? nz(u) : void 0, {
      _minW: nz(s),
      breakpoint: o,
      minW: s,
      maxW: u,
      maxWQuery: JN(null, u),
      minWQuery: JN(s),
      minMaxQuery: JN(s, u)
    };
  }), i = m1e(t), a = Array.from(i.values());
  return {
    keys: i,
    normalized: n,
    isResponsive(o) {
      const s = Object.keys(o);
      return s.length > 0 && s.every((l) => i.has(l));
    },
    asObject: YS(t),
    asArray: tz(t),
    details: r,
    get(o) {
      return r.find((s) => s.breakpoint === o);
    },
    media: [
      null,
      ...n.map((o) => JN(o)).slice(1)
    ],
    toArrayValue(o) {
      if (!Ea(o))
        throw new Error("toArrayValue: value must be an object");
      const s = a.map((l) => {
        var c;
        return (c = o[l]) != null ? c : null;
      });
      for (; M1e(s) === null; )
        s.pop();
      return s;
    },
    toObjectValue(o) {
      if (!Array.isArray(o))
        throw new Error("toObjectValue: value must be an array");
      return o.reduce((s, l, c) => {
        const d = a[c];
        return d != null && l != null && (s[d] = l), s;
      }, {});
    }
  };
}
var wr = {
  hover: (t, e) => `${t}:hover ${e}, ${t}[data-hover] ${e}`,
  focus: (t, e) => `${t}:focus ${e}, ${t}[data-focus] ${e}`,
  focusVisible: (t, e) => `${t}:focus-visible ${e}`,
  focusWithin: (t, e) => `${t}:focus-within ${e}`,
  active: (t, e) => `${t}:active ${e}, ${t}[data-active] ${e}`,
  disabled: (t, e) => `${t}:disabled ${e}, ${t}[data-disabled] ${e}`,
  invalid: (t, e) => `${t}:invalid ${e}, ${t}[data-invalid] ${e}`,
  checked: (t, e) => `${t}:checked ${e}, ${t}[data-checked] ${e}`,
  indeterminate: (t, e) => `${t}:indeterminate ${e}, ${t}[aria-checked=mixed] ${e}, ${t}[data-indeterminate] ${e}`,
  readOnly: (t, e) => `${t}:read-only ${e}, ${t}[readonly] ${e}, ${t}[data-read-only] ${e}`,
  expanded: (t, e) => `${t}:read-only ${e}, ${t}[aria-expanded=true] ${e}, ${t}[data-expanded] ${e}`,
  placeholderShown: (t, e) => `${t}:placeholder-shown ${e}`
}, sl = (t) => WG((e) => t(e, "&"), "[role=group]", "[data-group]", ".group"), rs = (t) => WG((e) => t(e, "~ &"), "[data-peer]", ".peer"), WG = (t, ...e) => e.map(t).join(", "), IU = {
  _hover: "&:hover, &[data-hover]",
  _active: "&:active, &[data-active]",
  _focus: "&:focus, &[data-focus]",
  _highlighted: "&[data-highlighted]",
  _focusWithin: "&:focus-within",
  _focusVisible: "&:focus-visible, &[data-focus-visible]",
  _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
  _before: "&::before",
  _after: "&::after",
  _empty: "&:empty",
  _expanded: "&[aria-expanded=true], &[data-expanded]",
  _checked: "&[aria-checked=true], &[data-checked]",
  _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
  _pressed: "&[aria-pressed=true], &[data-pressed]",
  _invalid: "&[aria-invalid=true], &[data-invalid]",
  _valid: "&[data-valid], &[data-state=valid]",
  _loading: "&[data-loading], &[aria-busy=true]",
  _selected: "&[aria-selected=true], &[data-selected]",
  _hidden: "&[hidden], &[data-hidden]",
  _autofill: "&:-webkit-autofill",
  _even: "&:nth-of-type(even)",
  _odd: "&:nth-of-type(odd)",
  _first: "&:first-of-type",
  _firstLetter: "&::first-letter",
  _last: "&:last-of-type",
  _notFirst: "&:not(:first-of-type)",
  _notLast: "&:not(:last-of-type)",
  _visited: "&:visited",
  _activeLink: "&[aria-current=page]",
  _activeStep: "&[aria-current=step]",
  _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
  _groupHover: sl(wr.hover),
  _peerHover: rs(wr.hover),
  _groupFocus: sl(wr.focus),
  _peerFocus: rs(wr.focus),
  _groupFocusVisible: sl(wr.focusVisible),
  _peerFocusVisible: rs(wr.focusVisible),
  _groupActive: sl(wr.active),
  _peerActive: rs(wr.active),
  _groupDisabled: sl(wr.disabled),
  _peerDisabled: rs(wr.disabled),
  _groupInvalid: sl(wr.invalid),
  _peerInvalid: rs(wr.invalid),
  _groupChecked: sl(wr.checked),
  _peerChecked: rs(wr.checked),
  _groupFocusWithin: sl(wr.focusWithin),
  _peerFocusWithin: rs(wr.focusWithin),
  _peerPlaceholderShown: rs(wr.placeholderShown),
  _placeholder: "&::placeholder",
  _placeholderShown: "&:placeholder-shown",
  _fullScreen: "&:fullscreen",
  _selection: "&::selection",
  _rtl: "[dir=rtl] &, &[dir=rtl]",
  _ltr: "[dir=ltr] &, &[dir=ltr]",
  _mediaDark: "@media (prefers-color-scheme: dark)",
  _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
  _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
  _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
  _horizontal: "&[data-orientation=horizontal]",
  _vertical: "&[data-orientation=vertical]"
}, jG = Object.keys(
  IU
);
function rz(t, e) {
  return rt(String(t).replace(/\./g, "-"), void 0, e);
}
function f1e(t, e) {
  let n = {};
  const r = {};
  for (const [i, a] of Object.entries(t)) {
    const { isSemantic: o, value: s } = a, { variable: l, reference: c } = rz(i, e == null ? void 0 : e.cssVarPrefix);
    if (!o) {
      if (i.startsWith("space")) {
        const h = i.split("."), [N, ...M] = h, p = `${N}.-${M.join(".")}`, m = qc.negate(s), R = qc.negate(c);
        r[p] = {
          value: m,
          var: l,
          varRef: R
        };
      }
      n[l] = s, r[i] = {
        value: s,
        var: l,
        varRef: c
      };
      continue;
    }
    const d = (h) => {
      const M = [String(i).split(".")[0], h].join(".");
      if (!t[M])
        return h;
      const { reference: m } = rz(M, e == null ? void 0 : e.cssVarPrefix);
      return m;
    }, u = Ea(s) ? s : { default: s };
    n = Za(
      n,
      Object.entries(u).reduce(
        (h, [N, M]) => {
          var p, m;
          if (!M)
            return h;
          const R = d(`${M}`);
          if (N === "default")
            return h[l] = R, h;
          const V = (m = (p = IU) == null ? void 0 : p[N]) != null ? m : N;
          return h[V] = { [l]: R }, h;
        },
        {}
      )
    ), r[i] = {
      value: c,
      var: l,
      varRef: c
    };
  }
  return {
    cssVars: n,
    cssMap: r
  };
}
function V1e(t, e = []) {
  const n = Object.assign({}, t);
  for (const r of e)
    r in n && delete n[r];
  return n;
}
function U1e(t, e) {
  const n = {};
  for (const r of e)
    r in t && (n[r] = t[r]);
  return n;
}
function R1e(t) {
  return typeof t == "object" && t != null && !Array.isArray(t);
}
function iz(t, e, n = {}) {
  const { stop: r, getKey: i } = n;
  function a(o, s = []) {
    var l;
    if (R1e(o) || Array.isArray(o)) {
      const c = {};
      for (const [d, u] of Object.entries(o)) {
        const h = (l = i == null ? void 0 : i(d)) != null ? l : d, N = [...s, h];
        if (r != null && r(o, N))
          return e(o, s);
        c[h] = a(u, N);
      }
      return c;
    }
    return e(o, s);
  }
  return a(t);
}
var g1e = [
  "colors",
  "borders",
  "borderWidths",
  "borderStyles",
  "fonts",
  "fontSizes",
  "fontWeights",
  "gradients",
  "letterSpacings",
  "lineHeights",
  "radii",
  "space",
  "shadows",
  "sizes",
  "zIndices",
  "transition",
  "blur",
  "breakpoints"
];
function y1e(t) {
  return U1e(t, g1e);
}
function Z1e(t) {
  return t.semanticTokens;
}
function b1e(t) {
  const { __cssMap: e, __cssVars: n, __breakpoints: r, ...i } = t;
  return i;
}
var E1e = (t) => jG.includes(t) || t === "default";
function S1e({
  tokens: t,
  semanticTokens: e
}) {
  const n = {};
  return iz(t, (r, i) => {
    r != null && (n[i.join(".")] = { isSemantic: !1, value: r });
  }), iz(
    e,
    (r, i) => {
      r != null && (n[i.join(".")] = { isSemantic: !0, value: r });
    },
    {
      stop: (r) => Object.keys(r).every(E1e)
    }
  ), n;
}
function x1e(t) {
  var e;
  const n = b1e(t), r = y1e(n), i = Z1e(n), a = S1e({ tokens: r, semanticTokens: i }), o = (e = n.config) == null ? void 0 : e.cssVarPrefix, {
    cssMap: s,
    cssVars: l
  } = f1e(a, { cssVarPrefix: o });
  return Object.assign(n, {
    __cssVars: { ...{
      "--chakra-ring-inset": "var(--chakra-empty,/*!*/ /*!*/)",
      "--chakra-ring-offset-width": "0px",
      "--chakra-ring-offset-color": "#fff",
      "--chakra-ring-color": "rgba(66, 153, 225, 0.6)",
      "--chakra-ring-offset-shadow": "0 0 #0000",
      "--chakra-ring-shadow": "0 0 #0000",
      "--chakra-space-x-reverse": "0",
      "--chakra-space-y-reverse": "0"
    }, ...l },
    __cssMap: s,
    __breakpoints: T1e(n.breakpoints)
  }), n;
}
var QS = Za(
  {},
  $T,
  nn,
  JNe,
  QV,
  Na,
  BNe,
  e1e,
  ANe,
  EG,
  qNe,
  c1,
  Sb,
  vn,
  a1e,
  i1e,
  t1e,
  n1e,
  HNe,
  r1e
);
Object.assign({}, vn, Na, QV, EG, c1);
var W1e = [...Object.keys(QS), ...jG], j1e = { ...QS, ...IU }, D1e = (t) => t in j1e, z1e = (t) => (e) => {
  if (!e.__breakpoints)
    return t;
  const { isResponsive: n, toArrayValue: r, media: i } = e.__breakpoints, a = {};
  for (const o in t) {
    let s = Ts(t[o], e);
    if (s == null)
      continue;
    if (s = Ea(s) && n(s) ? r(s) : s, !Array.isArray(s)) {
      a[o] = s;
      continue;
    }
    const l = s.slice(0, i.length).length;
    for (let c = 0; c < l; c += 1) {
      const d = i == null ? void 0 : i[c];
      if (!d) {
        a[o] = s[c];
        continue;
      }
      a[d] = a[d] || {}, s[c] != null && (a[d][o] = s[c]);
    }
  }
  return a;
};
function k1e(t) {
  const e = [];
  let n = "", r = !1;
  for (let i = 0; i < t.length; i++) {
    const a = t[i];
    a === "(" ? (r = !0, n += a) : a === ")" ? (r = !1, n += a) : a === "," && !r ? (e.push(n), n = "") : n += a;
  }
  return n = n.trim(), n && e.push(n), e;
}
function w1e(t) {
  return /^var\(--.+\)$/.test(t);
}
var F1e = (t, e) => t.startsWith("--") && typeof e == "string" && !w1e(e), v1e = (t, e) => {
  var n, r;
  if (e == null)
    return e;
  const i = (l) => {
    var c, d;
    return (d = (c = t.__cssMap) == null ? void 0 : c[l]) == null ? void 0 : d.varRef;
  }, a = (l) => {
    var c;
    return (c = i(l)) != null ? c : l;
  }, [o, s] = k1e(e);
  return e = (r = (n = i(o)) != null ? n : a(s)) != null ? r : a(e), e;
};
function I1e(t) {
  const { configs: e = {}, pseudos: n = {}, theme: r } = t, i = (a, o = !1) => {
    var s, l, c;
    const d = Ts(a, r), u = z1e(d)(r);
    let h = {};
    for (let N in u) {
      const M = u[N];
      let p = Ts(M, r);
      N in n && (N = n[N]), F1e(N, p) && (p = v1e(r, p));
      let m = e[N];
      if (m === !0 && (m = { property: N }), Ea(p)) {
        h[N] = (s = h[N]) != null ? s : {}, h[N] = Za(
          {},
          h[N],
          i(p, !0)
        );
        continue;
      }
      let R = (c = (l = m == null ? void 0 : m.transform) == null ? void 0 : l.call(m, p, r, d)) != null ? c : p;
      R = m != null && m.processResult ? i(R, !0) : R;
      const V = Ts(m == null ? void 0 : m.property, r);
      if (!o && (m != null && m.static)) {
        const U = Ts(m.static, r);
        h = Za({}, h, U);
      }
      if (V && Array.isArray(V)) {
        for (const U of V)
          h[U] = R;
        continue;
      }
      if (V) {
        V === "&" && Ea(R) ? h = Za({}, h, R) : h[V] = R;
        continue;
      }
      if (Ea(R)) {
        h = Za({}, h, R);
        continue;
      }
      h[N] = R;
    }
    return h;
  };
  return i;
}
var DG = (t) => (e) => I1e({
  theme: e,
  pseudos: IU,
  configs: QS
})(t);
function Sn(t) {
  return {
    definePartsStyle(e) {
      return e;
    },
    defineMultiStyleConfig(e) {
      return { parts: t, ...e };
    }
  };
}
function O1e(t, e) {
  if (Array.isArray(t))
    return t;
  if (Ea(t))
    return e(t);
  if (t != null)
    return [t];
}
function Y1e(t, e) {
  for (let n = e + 1; n < t.length; n++)
    if (t[n] != null)
      return n;
  return -1;
}
function Q1e(t) {
  const e = t.__breakpoints;
  return function(r, i, a, o) {
    var s, l;
    if (!e)
      return;
    const c = {}, d = O1e(a, e.toArrayValue);
    if (!d)
      return c;
    const u = d.length, h = u === 1, N = !!r.parts;
    for (let M = 0; M < u; M++) {
      const p = e.details[M], m = e.details[Y1e(d, M)], R = JN(p.minW, m == null ? void 0 : m._minW), V = Ts((s = r[i]) == null ? void 0 : s[d[M]], o);
      if (V) {
        if (N) {
          (l = r.parts) == null || l.forEach((U) => {
            Za(c, {
              [U]: h ? V[U] : { [R]: V[U] }
            });
          });
          continue;
        }
        if (!N) {
          h ? Za(c, V) : c[R] = V;
          continue;
        }
        c[R] = V;
      }
    }
    return c;
  };
}
function G1e(t) {
  return (e) => {
    var n;
    const { variant: r, size: i, theme: a } = e, o = Q1e(a);
    return Za(
      {},
      Ts((n = t.baseStyle) != null ? n : {}, e),
      o(t, "sizes", i, e),
      o(t, "variants", r, e)
    );
  };
}
function C1e(t, e, n) {
  var r, i, a;
  return (a = (i = (r = t.__cssMap) == null ? void 0 : r[`${e}.${n}`]) == null ? void 0 : i.varRef) != null ? a : n;
}
function $s(t) {
  return V1e(t, ["styleConfig", "size", "variant", "colorScheme"]);
}
var L1e = [
  "borders",
  "breakpoints",
  "colors",
  "components",
  "config",
  "direction",
  "fonts",
  "fontSizes",
  "fontWeights",
  "letterSpacings",
  "lineHeights",
  "radii",
  "shadows",
  "sizes",
  "space",
  "styles",
  "transition",
  "zIndices"
];
function J1e(t) {
  return Ea(t) ? L1e.every(
    (e) => Object.prototype.hasOwnProperty.call(t, e)
  ) : !1;
}
var B1e = {
  common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
  colors: "background-color, border-color, color, fill, stroke",
  dimensions: "width, height",
  position: "left, right, top, bottom",
  background: "background-color, background-image, background-position"
}, A1e = {
  "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
  "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
  "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
}, H1e = {
  "ultra-fast": "50ms",
  faster: "100ms",
  fast: "150ms",
  normal: "200ms",
  slow: "300ms",
  slower: "400ms",
  "ultra-slow": "500ms"
}, X1e = {
  property: B1e,
  easing: A1e,
  duration: H1e
}, _1e = X1e, P1e = {
  hide: -1,
  auto: "auto",
  base: 0,
  docked: 10,
  dropdown: 1e3,
  sticky: 1100,
  banner: 1200,
  overlay: 1300,
  modal: 1400,
  popover: 1500,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800
}, K1e = P1e, $1e = {
  none: 0,
  "1px": "1px solid",
  "2px": "2px solid",
  "4px": "4px solid",
  "8px": "8px solid"
}, q1e = $1e, eMe = {
  base: "0em",
  sm: "30em",
  md: "48em",
  lg: "62em",
  xl: "80em",
  "2xl": "96em"
}, tMe = eMe, nMe = {
  transparent: "transparent",
  current: "currentColor",
  black: "#000000",
  white: "#FFFFFF",
  whiteAlpha: {
    50: "rgba(255, 255, 255, 0.04)",
    100: "rgba(255, 255, 255, 0.06)",
    200: "rgba(255, 255, 255, 0.08)",
    300: "rgba(255, 255, 255, 0.16)",
    400: "rgba(255, 255, 255, 0.24)",
    500: "rgba(255, 255, 255, 0.36)",
    600: "rgba(255, 255, 255, 0.48)",
    700: "rgba(255, 255, 255, 0.64)",
    800: "rgba(255, 255, 255, 0.80)",
    900: "rgba(255, 255, 255, 0.92)"
  },
  blackAlpha: {
    50: "rgba(0, 0, 0, 0.04)",
    100: "rgba(0, 0, 0, 0.06)",
    200: "rgba(0, 0, 0, 0.08)",
    300: "rgba(0, 0, 0, 0.16)",
    400: "rgba(0, 0, 0, 0.24)",
    500: "rgba(0, 0, 0, 0.36)",
    600: "rgba(0, 0, 0, 0.48)",
    700: "rgba(0, 0, 0, 0.64)",
    800: "rgba(0, 0, 0, 0.80)",
    900: "rgba(0, 0, 0, 0.92)"
  },
  gray: {
    50: "#F7FAFC",
    100: "#EDF2F7",
    200: "#E2E8F0",
    300: "#CBD5E0",
    400: "#A0AEC0",
    500: "#718096",
    600: "#4A5568",
    700: "#2D3748",
    800: "#1A202C",
    900: "#171923"
  },
  red: {
    50: "#FFF5F5",
    100: "#FED7D7",
    200: "#FEB2B2",
    300: "#FC8181",
    400: "#F56565",
    500: "#E53E3E",
    600: "#C53030",
    700: "#9B2C2C",
    800: "#822727",
    900: "#63171B"
  },
  orange: {
    50: "#FFFAF0",
    100: "#FEEBC8",
    200: "#FBD38D",
    300: "#F6AD55",
    400: "#ED8936",
    500: "#DD6B20",
    600: "#C05621",
    700: "#9C4221",
    800: "#7B341E",
    900: "#652B19"
  },
  yellow: {
    50: "#FFFFF0",
    100: "#FEFCBF",
    200: "#FAF089",
    300: "#F6E05E",
    400: "#ECC94B",
    500: "#D69E2E",
    600: "#B7791F",
    700: "#975A16",
    800: "#744210",
    900: "#5F370E"
  },
  green: {
    50: "#F0FFF4",
    100: "#C6F6D5",
    200: "#9AE6B4",
    300: "#68D391",
    400: "#48BB78",
    500: "#38A169",
    600: "#2F855A",
    700: "#276749",
    800: "#22543D",
    900: "#1C4532"
  },
  teal: {
    50: "#E6FFFA",
    100: "#B2F5EA",
    200: "#81E6D9",
    300: "#4FD1C5",
    400: "#38B2AC",
    500: "#319795",
    600: "#2C7A7B",
    700: "#285E61",
    800: "#234E52",
    900: "#1D4044"
  },
  blue: {
    50: "#ebf8ff",
    100: "#bee3f8",
    200: "#90cdf4",
    300: "#63b3ed",
    400: "#4299e1",
    500: "#3182ce",
    600: "#2b6cb0",
    700: "#2c5282",
    800: "#2a4365",
    900: "#1A365D"
  },
  cyan: {
    50: "#EDFDFD",
    100: "#C4F1F9",
    200: "#9DECF9",
    300: "#76E4F7",
    400: "#0BC5EA",
    500: "#00B5D8",
    600: "#00A3C4",
    700: "#0987A0",
    800: "#086F83",
    900: "#065666"
  },
  purple: {
    50: "#FAF5FF",
    100: "#E9D8FD",
    200: "#D6BCFA",
    300: "#B794F4",
    400: "#9F7AEA",
    500: "#805AD5",
    600: "#6B46C1",
    700: "#553C9A",
    800: "#44337A",
    900: "#322659"
  },
  pink: {
    50: "#FFF5F7",
    100: "#FED7E2",
    200: "#FBB6CE",
    300: "#F687B3",
    400: "#ED64A6",
    500: "#D53F8C",
    600: "#B83280",
    700: "#97266D",
    800: "#702459",
    900: "#521B41"
  },
  linkedin: {
    50: "#E8F4F9",
    100: "#CFEDFB",
    200: "#9BDAF3",
    300: "#68C7EC",
    400: "#34B3E4",
    500: "#00A0DC",
    600: "#008CC9",
    700: "#0077B5",
    800: "#005E93",
    900: "#004471"
  },
  facebook: {
    50: "#E8F4F9",
    100: "#D9DEE9",
    200: "#B7C2DA",
    300: "#6482C0",
    400: "#4267B2",
    500: "#385898",
    600: "#314E89",
    700: "#29487D",
    800: "#223B67",
    900: "#1E355B"
  },
  messenger: {
    50: "#D0E6FF",
    100: "#B9DAFF",
    200: "#A2CDFF",
    300: "#7AB8FF",
    400: "#2E90FF",
    500: "#0078FF",
    600: "#0063D1",
    700: "#0052AC",
    800: "#003C7E",
    900: "#002C5C"
  },
  whatsapp: {
    50: "#dffeec",
    100: "#b9f5d0",
    200: "#90edb3",
    300: "#65e495",
    400: "#3cdd78",
    500: "#22c35e",
    600: "#179848",
    700: "#0c6c33",
    800: "#01421c",
    900: "#001803"
  },
  twitter: {
    50: "#E5F4FD",
    100: "#C8E9FB",
    200: "#A8DCFA",
    300: "#83CDF7",
    400: "#57BBF5",
    500: "#1DA1F2",
    600: "#1A94DA",
    700: "#1681BF",
    800: "#136B9E",
    900: "#0D4D71"
  },
  telegram: {
    50: "#E3F2F9",
    100: "#C5E4F3",
    200: "#A2D4EC",
    300: "#7AC1E4",
    400: "#47A9DA",
    500: "#0088CC",
    600: "#007AB8",
    700: "#006BA1",
    800: "#005885",
    900: "#003F5E"
  }
}, rMe = nMe, iMe = {
  none: "0",
  sm: "0.125rem",
  base: "0.25rem",
  md: "0.375rem",
  lg: "0.5rem",
  xl: "0.75rem",
  "2xl": "1rem",
  "3xl": "1.5rem",
  full: "9999px"
}, aMe = iMe, oMe = {
  xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
  sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
  base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
  outline: "0 0 0 3px rgba(66, 153, 225, 0.6)",
  inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
  none: "none",
  "dark-lg": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px"
}, sMe = oMe, lMe = {
  none: 0,
  sm: "4px",
  base: "8px",
  md: "12px",
  lg: "16px",
  xl: "24px",
  "2xl": "40px",
  "3xl": "64px"
}, cMe = lMe, dMe = {
  letterSpacings: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em"
  },
  lineHeights: {
    normal: "normal",
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: "2",
    3: ".75rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem"
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  fonts: {
    heading: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    body: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    mono: 'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace'
  },
  fontSizes: {
    "3xs": "0.45rem",
    "2xs": "0.625rem",
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "3.75rem",
    "7xl": "4.5rem",
    "8xl": "6rem",
    "9xl": "8rem"
  }
}, zG = dMe, kG = {
  px: "1px",
  0.5: "0.125rem",
  1: "0.25rem",
  1.5: "0.375rem",
  2: "0.5rem",
  2.5: "0.625rem",
  3: "0.75rem",
  3.5: "0.875rem",
  4: "1rem",
  5: "1.25rem",
  6: "1.5rem",
  7: "1.75rem",
  8: "2rem",
  9: "2.25rem",
  10: "2.5rem",
  12: "3rem",
  14: "3.5rem",
  16: "4rem",
  20: "5rem",
  24: "6rem",
  28: "7rem",
  32: "8rem",
  36: "9rem",
  40: "10rem",
  44: "11rem",
  48: "12rem",
  52: "13rem",
  56: "14rem",
  60: "15rem",
  64: "16rem",
  72: "18rem",
  80: "20rem",
  96: "24rem"
}, uMe = {
  max: "max-content",
  min: "min-content",
  full: "100%",
  "3xs": "14rem",
  "2xs": "16rem",
  xs: "20rem",
  sm: "24rem",
  md: "28rem",
  lg: "32rem",
  xl: "36rem",
  "2xl": "42rem",
  "3xl": "48rem",
  "4xl": "56rem",
  "5xl": "64rem",
  "6xl": "72rem",
  "7xl": "80rem",
  "8xl": "90rem",
  prose: "60ch"
}, hMe = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px"
}, NMe = {
  ...kG,
  ...uMe,
  container: hMe
}, wG = NMe, MMe = {
  breakpoints: tMe,
  zIndices: K1e,
  radii: aMe,
  blur: cMe,
  colors: rMe,
  ...zG,
  sizes: wG,
  shadows: sMe,
  space: kG,
  borders: q1e,
  transition: _1e
}, { defineMultiStyleConfig: pMe, definePartsStyle: BN } = Sn([
  "stepper",
  "step",
  "title",
  "description",
  "indicator",
  "separator",
  "icon",
  "number"
]), hs = rt("stepper-indicator-size"), $u = rt("stepper-icon-size"), qu = rt("stepper-title-font-size"), AN = rt("stepper-description-font-size"), jN = rt("stepper-accent-color"), mMe = BN(({ colorScheme: t }) => ({
  stepper: {
    display: "flex",
    justifyContent: "space-between",
    gap: "4",
    "&[data-orientation=vertical]": {
      flexDirection: "column",
      alignItems: "flex-start"
    },
    "&[data-orientation=horizontal]": {
      flexDirection: "row",
      alignItems: "center"
    },
    [jN.variable]: `colors.${t}.500`,
    _dark: {
      [jN.variable]: `colors.${t}.200`
    }
  },
  title: {
    fontSize: qu.reference,
    fontWeight: "medium"
  },
  description: {
    fontSize: AN.reference,
    color: "chakra-subtle-text"
  },
  number: {
    fontSize: qu.reference
  },
  step: {
    flexShrink: 0,
    position: "relative",
    display: "flex",
    gap: "2",
    "&[data-orientation=horizontal]": {
      alignItems: "center"
    },
    flex: "1",
    "&:last-of-type:not([data-stretch])": {
      flex: "initial"
    }
  },
  icon: {
    flexShrink: 0,
    width: $u.reference,
    height: $u.reference
  },
  indicator: {
    flexShrink: 0,
    borderRadius: "full",
    width: hs.reference,
    height: hs.reference,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&[data-status=active]": {
      borderWidth: "2px",
      borderColor: jN.reference
    },
    "&[data-status=complete]": {
      bg: jN.reference,
      color: "chakra-inverse-text"
    },
    "&[data-status=incomplete]": {
      borderWidth: "2px"
    }
  },
  separator: {
    bg: "chakra-border-color",
    flex: "1",
    "&[data-status=complete]": {
      bg: jN.reference
    },
    "&[data-orientation=horizontal]": {
      width: "100%",
      height: "2px",
      marginStart: "2"
    },
    "&[data-orientation=vertical]": {
      width: "2px",
      position: "absolute",
      height: "100%",
      maxHeight: `calc(100% - ${hs.reference} - 8px)`,
      top: `calc(${hs.reference} + 4px)`,
      insetStart: `calc(${hs.reference} / 2 - 1px)`
    }
  }
})), TMe = pMe({
  baseStyle: mMe,
  sizes: {
    xs: BN({
      stepper: {
        [hs.variable]: "sizes.4",
        [$u.variable]: "sizes.3",
        [qu.variable]: "fontSizes.xs",
        [AN.variable]: "fontSizes.xs"
      }
    }),
    sm: BN({
      stepper: {
        [hs.variable]: "sizes.6",
        [$u.variable]: "sizes.4",
        [qu.variable]: "fontSizes.sm",
        [AN.variable]: "fontSizes.xs"
      }
    }),
    md: BN({
      stepper: {
        [hs.variable]: "sizes.8",
        [$u.variable]: "sizes.5",
        [qu.variable]: "fontSizes.md",
        [AN.variable]: "fontSizes.sm"
      }
    }),
    lg: BN({
      stepper: {
        [hs.variable]: "sizes.10",
        [$u.variable]: "sizes.6",
        [qu.variable]: "fontSizes.lg",
        [AN.variable]: "fontSizes.md"
      }
    })
  },
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
});
function hn(t, e = {}) {
  let n = !1;
  function r() {
    if (!n) {
      n = !0;
      return;
    }
    throw new Error(
      "[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?"
    );
  }
  function i(...d) {
    r();
    for (const u of d)
      e[u] = l(u);
    return hn(t, e);
  }
  function a(...d) {
    for (const u of d)
      u in e || (e[u] = l(u));
    return hn(t, e);
  }
  function o() {
    return Object.fromEntries(
      Object.entries(e).map(([u, h]) => [u, h.selector])
    );
  }
  function s() {
    return Object.fromEntries(
      Object.entries(e).map(([u, h]) => [u, h.className])
    );
  }
  function l(d) {
    const N = `chakra-${(["container", "root"].includes(d ?? "") ? [t] : [t, d]).filter(Boolean).join("__")}`;
    return {
      className: N,
      selector: `.${N}`,
      toString: () => d
    };
  }
  return {
    parts: i,
    toPart: l,
    extend: a,
    selectors: o,
    classnames: s,
    get keys() {
      return Object.keys(e);
    },
    __type: {}
  };
}
var fMe = hn("accordion").parts("root", "container", "button", "panel").extend("icon"), VMe = hn("alert").parts("title", "description", "container").extend("icon", "spinner"), UMe = hn("avatar").parts("label", "badge", "container").extend("excessLabel", "group"), RMe = hn("breadcrumb").parts("link", "item", "container").extend("separator");
hn("button").parts();
var gMe = hn("checkbox").parts("control", "icon", "container").extend("label");
hn("progress").parts("track", "filledTrack").extend("label");
var yMe = hn("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer"), ZMe = hn("editable").parts(
  "preview",
  "input",
  "textarea"
), bMe = hn("form").parts(
  "container",
  "requiredIndicator",
  "helperText"
), EMe = hn("formError").parts("text", "icon"), SMe = hn("input").parts(
  "addon",
  "field",
  "element",
  "group"
), xMe = hn("list").parts("container", "item", "icon"), WMe = hn("menu").parts("button", "list", "item").extend("groupTitle", "icon", "command", "divider"), jMe = hn("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer"), DMe = hn("numberinput").parts(
  "root",
  "field",
  "stepperGroup",
  "stepper"
);
hn("pininput").parts("field");
var zMe = hn("popover").parts("content", "header", "body", "footer").extend("popper", "arrow", "closeButton"), kMe = hn("progress").parts(
  "label",
  "filledTrack",
  "track"
), wMe = hn("radio").parts(
  "container",
  "control",
  "label"
), FMe = hn("select").parts("field", "icon"), vMe = hn("slider").parts(
  "container",
  "track",
  "thumb",
  "filledTrack",
  "mark"
), IMe = hn("stat").parts(
  "container",
  "label",
  "helpText",
  "number",
  "icon"
), OMe = hn("switch").parts(
  "container",
  "track",
  "thumb"
), YMe = hn("table").parts(
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
  "tfoot",
  "caption"
), QMe = hn("tabs").parts(
  "root",
  "tab",
  "tablist",
  "tabpanel",
  "tabpanels",
  "indicator"
), GMe = hn("tag").parts(
  "container",
  "label",
  "closeButton"
), CMe = hn("card").parts(
  "container",
  "header",
  "body",
  "footer"
);
function ld(t, e, n) {
  return Math.min(Math.max(t, n), e);
}
class LMe extends Error {
  constructor(e) {
    super(`Failed to parse color: "${e}"`);
  }
}
var HN = LMe;
function GS(t) {
  if (typeof t != "string")
    throw new HN(t);
  if (t.trim().toLowerCase() === "transparent")
    return [0, 0, 0, 0];
  let e = t.trim();
  e = KMe.test(t) ? AMe(t) : t;
  const n = HMe.exec(e);
  if (n) {
    const o = Array.from(n).slice(1);
    return [...o.slice(0, 3).map((s) => parseInt(CM(s, 2), 16)), parseInt(CM(o[3] || "f", 2), 16) / 255];
  }
  const r = XMe.exec(e);
  if (r) {
    const o = Array.from(r).slice(1);
    return [...o.slice(0, 3).map((s) => parseInt(s, 16)), parseInt(o[3] || "ff", 16) / 255];
  }
  const i = _Me.exec(e);
  if (i) {
    const o = Array.from(i).slice(1);
    return [...o.slice(0, 3).map((s) => parseInt(s, 10)), parseFloat(o[3] || "1")];
  }
  const a = PMe.exec(e);
  if (a) {
    const [o, s, l, c] = Array.from(a).slice(1).map(parseFloat);
    if (ld(0, 100, s) !== s)
      throw new HN(t);
    if (ld(0, 100, l) !== l)
      throw new HN(t);
    return [...$Me(o, s, l), Number.isNaN(c) ? 1 : c];
  }
  throw new HN(t);
}
function JMe(t) {
  let e = 5381, n = t.length;
  for (; n; )
    e = e * 33 ^ t.charCodeAt(--n);
  return (e >>> 0) % 2341;
}
const az = (t) => parseInt(t.replace(/_/g, ""), 36), BMe = "1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm".split(" ").reduce((t, e) => {
  const n = az(e.substring(0, 3)), r = az(e.substring(3)).toString(16);
  let i = "";
  for (let a = 0; a < 6 - r.length; a++)
    i += "0";
  return t[n] = `${i}${r}`, t;
}, {});
function AMe(t) {
  const e = t.toLowerCase().trim(), n = BMe[JMe(e)];
  if (!n)
    throw new HN(t);
  return `#${n}`;
}
const CM = (t, e) => Array.from(Array(e)).map(() => t).join(""), HMe = new RegExp(`^#${CM("([a-f0-9])", 3)}([a-f0-9])?$`, "i"), XMe = new RegExp(`^#${CM("([a-f0-9]{2})", 3)}([a-f0-9]{2})?$`, "i"), _Me = new RegExp(`^rgba?\\(\\s*(\\d+)\\s*${CM(",\\s*(\\d+)\\s*", 2)}(?:,\\s*([\\d.]+))?\\s*\\)$`, "i"), PMe = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i, KMe = /^[a-z]+$/i, oz = (t) => Math.round(t * 255), $Me = (t, e, n) => {
  let r = n / 100;
  if (e === 0)
    return [r, r, r].map(oz);
  const i = (t % 360 + 360) % 360 / 60, a = (1 - Math.abs(2 * r - 1)) * (e / 100), o = a * (1 - Math.abs(i % 2 - 1));
  let s = 0, l = 0, c = 0;
  i >= 0 && i < 1 ? (s = a, l = o) : i >= 1 && i < 2 ? (s = o, l = a) : i >= 2 && i < 3 ? (l = a, c = o) : i >= 3 && i < 4 ? (l = o, c = a) : i >= 4 && i < 5 ? (s = o, c = a) : i >= 5 && i < 6 && (s = a, c = o);
  const d = r - a / 2, u = s + d, h = l + d, N = c + d;
  return [u, h, N].map(oz);
};
function qMe(t, e, n, r) {
  return `rgba(${ld(0, 255, t).toFixed()}, ${ld(0, 255, e).toFixed()}, ${ld(0, 255, n).toFixed()}, ${parseFloat(ld(0, 1, r).toFixed(3))})`;
}
function epe(t, e) {
  const [n, r, i, a] = GS(t);
  return qMe(n, r, i, a - e);
}
function tpe(t) {
  const [e, n, r, i] = GS(t);
  let a = (o) => {
    const s = ld(0, 255, o).toString(16);
    return s.length === 1 ? `0${s}` : s;
  };
  return `#${a(e)}${a(n)}${a(r)}${i < 1 ? a(Math.round(i * 255)) : ""}`;
}
function npe(t, e, n, r, i) {
  for (e = e.split ? e.split(".") : e, r = 0; r < e.length; r++)
    t = t ? t[e[r]] : i;
  return t === i ? n : t;
}
var rpe = (t) => Object.keys(t).length === 0, hi = (t, e, n) => {
  const r = npe(t, `colors.${e}`, e);
  try {
    return tpe(r), r;
  } catch {
    return n ?? "#000000";
  }
}, ipe = (t) => {
  const [e, n, r] = GS(t);
  return (e * 299 + n * 587 + r * 114) / 1e3;
}, ape = (t) => (e) => {
  const n = hi(e, t);
  return ipe(n) < 128 ? "dark" : "light";
}, ope = (t) => (e) => ape(t)(e) === "dark", bh = (t, e) => (n) => {
  const r = hi(n, t);
  return epe(r, 1 - e);
};
function sz(t = "1rem", e = "rgba(255, 255, 255, 0.15)") {
  return {
    backgroundImage: `linear-gradient(
    45deg,
    ${e} 25%,
    transparent 25%,
    transparent 50%,
    ${e} 50%,
    ${e} 75%,
    transparent 75%,
    transparent
  )`,
    backgroundSize: `${t} ${t}`
  };
}
var spe = () => `#${Math.floor(Math.random() * 16777215).toString(16).padEnd(6, "0")}`;
function lpe(t) {
  const e = spe();
  return !t || rpe(t) ? e : t.string && t.colors ? dpe(t.string, t.colors) : t.string && !t.colors ? cpe(t.string) : t.colors && !t.string ? upe(t.colors) : e;
}
function cpe(t) {
  let e = 0;
  if (t.length === 0)
    return e.toString();
  for (let r = 0; r < t.length; r += 1)
    e = t.charCodeAt(r) + ((e << 5) - e), e = e & e;
  let n = "#";
  for (let r = 0; r < 3; r += 1) {
    const i = e >> r * 8 & 255;
    n += `00${i.toString(16)}`.substr(-2);
  }
  return n;
}
function dpe(t, e) {
  let n = 0;
  if (t.length === 0)
    return e[0];
  for (let r = 0; r < t.length; r += 1)
    n = t.charCodeAt(r) + ((n << 5) - n), n = n & n;
  return n = (n % e.length + e.length) % e.length, e[n];
}
function upe(t) {
  return t[Math.floor(Math.random() * t.length)];
}
function ct(t, e) {
  return (n) => n.colorMode === "dark" ? e : t;
}
function CS(t) {
  const { orientation: e, vertical: n, horizontal: r } = t;
  return e ? e === "vertical" ? n : r : {};
}
function FG(t) {
  return Ea(t) && t.reference ? t.reference : String(t);
}
var OU = (t, ...e) => e.map(FG).join(` ${t} `).replace(/calc/g, ""), lz = (...t) => `calc(${OU("+", ...t)})`, cz = (...t) => `calc(${OU("-", ...t)})`, jb = (...t) => `calc(${OU("*", ...t)})`, dz = (...t) => `calc(${OU("/", ...t)})`, uz = (t) => {
  const e = FG(t);
  return e != null && !Number.isNaN(parseFloat(e)) ? String(e).startsWith("-") ? String(e).slice(1) : `-${e}` : jb(e, -1);
}, Ns = Object.assign(
  (t) => ({
    add: (...e) => Ns(lz(t, ...e)),
    subtract: (...e) => Ns(cz(t, ...e)),
    multiply: (...e) => Ns(jb(t, ...e)),
    divide: (...e) => Ns(dz(t, ...e)),
    negate: () => Ns(uz(t)),
    toString: () => t.toString()
  }),
  {
    add: lz,
    subtract: cz,
    multiply: jb,
    divide: dz,
    negate: uz
  }
);
function hpe(t) {
  return !Number.isInteger(parseFloat(t.toString()));
}
function Npe(t, e = "-") {
  return t.replace(/\s+/g, e);
}
function vG(t) {
  const e = Npe(t.toString());
  return e.includes("\\.") ? t : hpe(t) ? e.replace(".", "\\.") : t;
}
function Mpe(t, e = "") {
  return [e, vG(t)].filter(Boolean).join("-");
}
function ppe(t, e) {
  return `var(${vG(t)}${e ? `, ${e}` : ""})`;
}
function mpe(t, e = "") {
  return `--${Mpe(t, e)}`;
}
function yr(t, e) {
  const n = mpe(t, e == null ? void 0 : e.prefix);
  return {
    variable: n,
    reference: ppe(n, Tpe(e == null ? void 0 : e.fallback))
  };
}
function Tpe(t) {
  return typeof t == "string" ? t : t == null ? void 0 : t.reference;
}
var { defineMultiStyleConfig: fpe, definePartsStyle: qT } = Sn(OMe.keys), d1 = yr("switch-track-width"), Sd = yr("switch-track-height"), jg = yr("switch-track-diff"), Vpe = Ns.subtract(d1, Sd), Db = yr("switch-thumb-x"), DN = yr("switch-bg"), Upe = (t) => {
  const { colorScheme: e } = t;
  return {
    borderRadius: "full",
    p: "0.5",
    width: [d1.reference],
    height: [Sd.reference],
    transitionProperty: "common",
    transitionDuration: "fast",
    [DN.variable]: "colors.gray.300",
    _dark: {
      [DN.variable]: "colors.whiteAlpha.400"
    },
    _focusVisible: {
      boxShadow: "outline"
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    },
    _checked: {
      [DN.variable]: `colors.${e}.500`,
      _dark: {
        [DN.variable]: `colors.${e}.200`
      }
    },
    bg: DN.reference
  };
}, Rpe = {
  bg: "white",
  transitionProperty: "transform",
  transitionDuration: "normal",
  borderRadius: "inherit",
  width: [Sd.reference],
  height: [Sd.reference],
  _checked: {
    transform: `translateX(${Db.reference})`
  }
}, gpe = qT((t) => ({
  container: {
    [jg.variable]: Vpe,
    [Db.variable]: jg.reference,
    _rtl: {
      [Db.variable]: Ns(jg).negate().toString()
    }
  },
  track: Upe(t),
  thumb: Rpe
})), ype = {
  sm: qT({
    container: {
      [d1.variable]: "1.375rem",
      [Sd.variable]: "sizes.3"
    }
  }),
  md: qT({
    container: {
      [d1.variable]: "1.875rem",
      [Sd.variable]: "sizes.4"
    }
  }),
  lg: qT({
    container: {
      [d1.variable]: "2.875rem",
      [Sd.variable]: "sizes.6"
    }
  })
}, Zpe = fpe({
  baseStyle: gpe,
  sizes: ype,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: bpe, definePartsStyle: f0 } = Sn(YMe.keys), Epe = f0({
  table: {
    fontVariantNumeric: "lining-nums tabular-nums",
    borderCollapse: "collapse",
    width: "full"
  },
  th: {
    fontFamily: "heading",
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: "wider",
    textAlign: "start"
  },
  td: {
    textAlign: "start"
  },
  caption: {
    mt: 4,
    fontFamily: "heading",
    textAlign: "center",
    fontWeight: "medium"
  }
}), GV = {
  "&[data-is-numeric=true]": {
    textAlign: "end"
  }
}, Spe = f0((t) => {
  const { colorScheme: e } = t;
  return {
    th: {
      color: ct("gray.600", "gray.400")(t),
      borderBottom: "1px",
      borderColor: ct(`${e}.100`, `${e}.700`)(t),
      ...GV
    },
    td: {
      borderBottom: "1px",
      borderColor: ct(`${e}.100`, `${e}.700`)(t),
      ...GV
    },
    caption: {
      color: ct("gray.600", "gray.100")(t)
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: { borderBottomWidth: 0 }
        }
      }
    }
  };
}), xpe = f0((t) => {
  const { colorScheme: e } = t;
  return {
    th: {
      color: ct("gray.600", "gray.400")(t),
      borderBottom: "1px",
      borderColor: ct(`${e}.100`, `${e}.700`)(t),
      ...GV
    },
    td: {
      borderBottom: "1px",
      borderColor: ct(`${e}.100`, `${e}.700`)(t),
      ...GV
    },
    caption: {
      color: ct("gray.600", "gray.100")(t)
    },
    tbody: {
      tr: {
        "&:nth-of-type(odd)": {
          "th, td": {
            borderBottomWidth: "1px",
            borderColor: ct(`${e}.100`, `${e}.700`)(t)
          },
          td: {
            background: ct(`${e}.100`, `${e}.700`)(t)
          }
        }
      }
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: { borderBottomWidth: 0 }
        }
      }
    }
  };
}), Wpe = {
  simple: Spe,
  striped: xpe,
  unstyled: {}
}, jpe = {
  sm: f0({
    th: {
      px: "4",
      py: "1",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "4",
      py: "2",
      fontSize: "sm",
      lineHeight: "4"
    },
    caption: {
      px: "4",
      py: "2",
      fontSize: "xs"
    }
  }),
  md: f0({
    th: {
      px: "6",
      py: "3",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "6",
      py: "4",
      lineHeight: "5"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "sm"
    }
  }),
  lg: f0({
    th: {
      px: "8",
      py: "4",
      lineHeight: "5",
      fontSize: "sm"
    },
    td: {
      px: "8",
      py: "5",
      lineHeight: "6"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "md"
    }
  })
}, Dpe = bpe({
  baseStyle: Epe,
  variants: Wpe,
  sizes: jpe,
  defaultProps: {
    variant: "simple",
    size: "md",
    colorScheme: "gray"
  }
}), bi = rt("tabs-color"), Ca = rt("tabs-bg"), sT = rt("tabs-border-color"), { defineMultiStyleConfig: zpe, definePartsStyle: xo } = Sn(QMe.keys), kpe = (t) => {
  const { orientation: e } = t;
  return {
    display: e === "vertical" ? "flex" : "block"
  };
}, wpe = (t) => {
  const { isFitted: e } = t;
  return {
    flex: e ? 1 : void 0,
    transitionProperty: "common",
    transitionDuration: "normal",
    _focusVisible: {
      zIndex: 1,
      boxShadow: "outline"
    },
    _disabled: {
      cursor: "not-allowed",
      opacity: 0.4
    }
  };
}, Fpe = (t) => {
  const { align: e = "start", orientation: n } = t;
  return {
    justifyContent: {
      end: "flex-end",
      center: "center",
      start: "flex-start"
    }[e],
    flexDirection: n === "vertical" ? "column" : "row"
  };
}, vpe = {
  p: 4
}, Ipe = xo((t) => ({
  root: kpe(t),
  tab: wpe(t),
  tablist: Fpe(t),
  tabpanel: vpe
})), Ope = {
  sm: xo({
    tab: {
      py: 1,
      px: 4,
      fontSize: "sm"
    }
  }),
  md: xo({
    tab: {
      fontSize: "md",
      py: 2,
      px: 4
    }
  }),
  lg: xo({
    tab: {
      fontSize: "lg",
      py: 3,
      px: 4
    }
  })
}, Ype = xo((t) => {
  const { colorScheme: e, orientation: n } = t, r = n === "vertical", i = r ? "borderStart" : "borderBottom", a = r ? "marginStart" : "marginBottom";
  return {
    tablist: {
      [i]: "2px solid",
      borderColor: "inherit"
    },
    tab: {
      [i]: "2px solid",
      borderColor: "transparent",
      [a]: "-2px",
      _selected: {
        [bi.variable]: `colors.${e}.600`,
        _dark: {
          [bi.variable]: `colors.${e}.300`
        },
        borderColor: "currentColor"
      },
      _active: {
        [Ca.variable]: "colors.gray.200",
        _dark: {
          [Ca.variable]: "colors.whiteAlpha.300"
        }
      },
      _disabled: {
        _active: { bg: "none" }
      },
      color: bi.reference,
      bg: Ca.reference
    }
  };
}), Qpe = xo((t) => {
  const { colorScheme: e } = t;
  return {
    tab: {
      borderTopRadius: "md",
      border: "1px solid",
      borderColor: "transparent",
      mb: "-1px",
      [sT.variable]: "transparent",
      _selected: {
        [bi.variable]: `colors.${e}.600`,
        [sT.variable]: "colors.white",
        _dark: {
          [bi.variable]: `colors.${e}.300`,
          [sT.variable]: "colors.gray.800"
        },
        borderColor: "inherit",
        borderBottomColor: sT.reference
      },
      color: bi.reference
    },
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
}), Gpe = xo((t) => {
  const { colorScheme: e } = t;
  return {
    tab: {
      border: "1px solid",
      borderColor: "inherit",
      [Ca.variable]: "colors.gray.50",
      _dark: {
        [Ca.variable]: "colors.whiteAlpha.50"
      },
      mb: "-1px",
      _notLast: {
        marginEnd: "-1px"
      },
      _selected: {
        [Ca.variable]: "colors.white",
        [bi.variable]: `colors.${e}.600`,
        _dark: {
          [Ca.variable]: "colors.gray.800",
          [bi.variable]: `colors.${e}.300`
        },
        borderColor: "inherit",
        borderTopColor: "currentColor",
        borderBottomColor: "transparent"
      },
      color: bi.reference,
      bg: Ca.reference
    },
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
}), Cpe = xo((t) => {
  const { colorScheme: e, theme: n } = t;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      color: "gray.600",
      _selected: {
        color: hi(n, `${e}.700`),
        bg: hi(n, `${e}.100`)
      }
    }
  };
}), Lpe = xo((t) => {
  const { colorScheme: e } = t;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      [bi.variable]: "colors.gray.600",
      _dark: {
        [bi.variable]: "inherit"
      },
      _selected: {
        [bi.variable]: "colors.white",
        [Ca.variable]: `colors.${e}.600`,
        _dark: {
          [bi.variable]: "colors.gray.800",
          [Ca.variable]: `colors.${e}.300`
        }
      },
      color: bi.reference,
      bg: Ca.reference
    }
  };
}), Jpe = xo({}), Bpe = {
  line: Ype,
  enclosed: Qpe,
  "enclosed-colored": Gpe,
  "soft-rounded": Cpe,
  "solid-rounded": Lpe,
  unstyled: Jpe
}, Ape = zpe({
  baseStyle: Ipe,
  sizes: Ope,
  variants: Bpe,
  defaultProps: {
    size: "md",
    variant: "line",
    colorScheme: "blue"
  }
}), sr = N1e("badge", ["bg", "color", "shadow"]), Hpe = {
  px: 1,
  textTransform: "uppercase",
  fontSize: "xs",
  borderRadius: "sm",
  fontWeight: "bold",
  bg: sr.bg.reference,
  color: sr.color.reference,
  boxShadow: sr.shadow.reference
}, Xpe = (t) => {
  const { colorScheme: e, theme: n } = t, r = bh(`${e}.500`, 0.6)(n);
  return {
    [sr.bg.variable]: `colors.${e}.500`,
    [sr.color.variable]: "colors.white",
    _dark: {
      [sr.bg.variable]: r,
      [sr.color.variable]: "colors.whiteAlpha.800"
    }
  };
}, _pe = (t) => {
  const { colorScheme: e, theme: n } = t, r = bh(`${e}.200`, 0.16)(n);
  return {
    [sr.bg.variable]: `colors.${e}.100`,
    [sr.color.variable]: `colors.${e}.800`,
    _dark: {
      [sr.bg.variable]: r,
      [sr.color.variable]: `colors.${e}.200`
    }
  };
}, Ppe = (t) => {
  const { colorScheme: e, theme: n } = t, r = bh(`${e}.200`, 0.8)(n);
  return {
    [sr.color.variable]: `colors.${e}.500`,
    _dark: {
      [sr.color.variable]: r
    },
    [sr.shadow.variable]: `inset 0 0 0px 1px ${sr.color.reference}`
  };
}, Kpe = {
  solid: Xpe,
  subtle: _pe,
  outline: Ppe
}, u1 = {
  baseStyle: Hpe,
  variants: Kpe,
  defaultProps: {
    variant: "subtle",
    colorScheme: "gray"
  }
}, { defineMultiStyleConfig: $pe, definePartsStyle: xd } = Sn(GMe.keys), hz = rt("tag-bg"), Nz = rt("tag-color"), Dg = rt("tag-shadow"), ef = rt("tag-min-height"), tf = rt("tag-min-width"), nf = rt("tag-font-size"), rf = rt("tag-padding-inline"), qpe = {
  fontWeight: "medium",
  lineHeight: 1.2,
  outline: 0,
  [Nz.variable]: sr.color.reference,
  [hz.variable]: sr.bg.reference,
  [Dg.variable]: sr.shadow.reference,
  color: Nz.reference,
  bg: hz.reference,
  boxShadow: Dg.reference,
  borderRadius: "md",
  minH: ef.reference,
  minW: tf.reference,
  fontSize: nf.reference,
  px: rf.reference,
  _focusVisible: {
    [Dg.variable]: "shadows.outline"
  }
}, eme = {
  lineHeight: 1.2,
  overflow: "visible"
}, tme = {
  fontSize: "lg",
  w: "5",
  h: "5",
  transitionProperty: "common",
  transitionDuration: "normal",
  borderRadius: "full",
  marginStart: "1.5",
  marginEnd: "-1",
  opacity: 0.5,
  _disabled: {
    opacity: 0.4
  },
  _focusVisible: {
    boxShadow: "outline",
    bg: "rgba(0, 0, 0, 0.14)"
  },
  _hover: {
    opacity: 0.8
  },
  _active: {
    opacity: 1
  }
}, nme = xd({
  container: qpe,
  label: eme,
  closeButton: tme
}), rme = {
  sm: xd({
    container: {
      [ef.variable]: "sizes.5",
      [tf.variable]: "sizes.5",
      [nf.variable]: "fontSizes.xs",
      [rf.variable]: "space.2"
    },
    closeButton: {
      marginEnd: "-2px",
      marginStart: "0.35rem"
    }
  }),
  md: xd({
    container: {
      [ef.variable]: "sizes.6",
      [tf.variable]: "sizes.6",
      [nf.variable]: "fontSizes.sm",
      [rf.variable]: "space.2"
    }
  }),
  lg: xd({
    container: {
      [ef.variable]: "sizes.8",
      [tf.variable]: "sizes.8",
      [nf.variable]: "fontSizes.md",
      [rf.variable]: "space.3"
    }
  })
}, ime = {
  subtle: xd((t) => {
    var e;
    return {
      container: (e = u1.variants) == null ? void 0 : e.subtle(t)
    };
  }),
  solid: xd((t) => {
    var e;
    return {
      container: (e = u1.variants) == null ? void 0 : e.solid(t)
    };
  }),
  outline: xd((t) => {
    var e;
    return {
      container: (e = u1.variants) == null ? void 0 : e.outline(t)
    };
  })
}, ame = $pe({
  variants: ime,
  baseStyle: nme,
  sizes: rme,
  defaultProps: {
    size: "md",
    variant: "subtle",
    colorScheme: "gray"
  }
}), { definePartsStyle: fs, defineMultiStyleConfig: ome } = Sn(SMe.keys), e0 = rt("input-height"), t0 = rt("input-font-size"), n0 = rt("input-padding"), r0 = rt("input-border-radius"), sme = fs({
  addon: {
    height: e0.reference,
    fontSize: t0.reference,
    px: n0.reference,
    borderRadius: r0.reference
  },
  field: {
    width: "100%",
    height: e0.reference,
    fontSize: t0.reference,
    px: n0.reference,
    borderRadius: r0.reference,
    minWidth: 0,
    outline: 0,
    position: "relative",
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal",
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    }
  }
}), ll = {
  lg: {
    [t0.variable]: "fontSizes.lg",
    [n0.variable]: "space.4",
    [r0.variable]: "radii.md",
    [e0.variable]: "sizes.12"
  },
  md: {
    [t0.variable]: "fontSizes.md",
    [n0.variable]: "space.4",
    [r0.variable]: "radii.md",
    [e0.variable]: "sizes.10"
  },
  sm: {
    [t0.variable]: "fontSizes.sm",
    [n0.variable]: "space.3",
    [r0.variable]: "radii.sm",
    [e0.variable]: "sizes.8"
  },
  xs: {
    [t0.variable]: "fontSizes.xs",
    [n0.variable]: "space.2",
    [r0.variable]: "radii.sm",
    [e0.variable]: "sizes.6"
  }
}, lme = {
  lg: fs({
    field: ll.lg,
    group: ll.lg
  }),
  md: fs({
    field: ll.md,
    group: ll.md
  }),
  sm: fs({
    field: ll.sm,
    group: ll.sm
  }),
  xs: fs({
    field: ll.xs,
    group: ll.xs
  })
};
function LS(t) {
  const { focusBorderColor: e, errorBorderColor: n } = t;
  return {
    focusBorderColor: e || ct("blue.500", "blue.300")(t),
    errorBorderColor: n || ct("red.500", "red.300")(t)
  };
}
var cme = fs((t) => {
  const { theme: e } = t, { focusBorderColor: n, errorBorderColor: r } = LS(t);
  return {
    field: {
      border: "1px solid",
      borderColor: "inherit",
      bg: "inherit",
      _hover: {
        borderColor: ct("gray.300", "whiteAlpha.400")(t)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: hi(e, r),
        boxShadow: `0 0 0 1px ${hi(e, r)}`
      },
      _focusVisible: {
        zIndex: 1,
        borderColor: hi(e, n),
        boxShadow: `0 0 0 1px ${hi(e, n)}`
      }
    },
    addon: {
      border: "1px solid",
      borderColor: ct("inherit", "whiteAlpha.50")(t),
      bg: ct("gray.100", "whiteAlpha.300")(t)
    }
  };
}), dme = fs((t) => {
  const { theme: e } = t, { focusBorderColor: n, errorBorderColor: r } = LS(t);
  return {
    field: {
      border: "2px solid",
      borderColor: "transparent",
      bg: ct("gray.100", "whiteAlpha.50")(t),
      _hover: {
        bg: ct("gray.200", "whiteAlpha.100")(t)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: hi(e, r)
      },
      _focusVisible: {
        bg: "transparent",
        borderColor: hi(e, n)
      }
    },
    addon: {
      border: "2px solid",
      borderColor: "transparent",
      bg: ct("gray.100", "whiteAlpha.50")(t)
    }
  };
}), ume = fs((t) => {
  const { theme: e } = t, { focusBorderColor: n, errorBorderColor: r } = LS(t);
  return {
    field: {
      borderBottom: "1px solid",
      borderColor: "inherit",
      borderRadius: "0",
      px: "0",
      bg: "transparent",
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: hi(e, r),
        boxShadow: `0px 1px 0px 0px ${hi(e, r)}`
      },
      _focusVisible: {
        borderColor: hi(e, n),
        boxShadow: `0px 1px 0px 0px ${hi(e, n)}`
      }
    },
    addon: {
      borderBottom: "2px solid",
      borderColor: "inherit",
      borderRadius: "0",
      px: "0",
      bg: "transparent"
    }
  };
}), hme = fs({
  field: {
    bg: "transparent",
    px: "0",
    height: "auto"
  },
  addon: {
    bg: "transparent",
    px: "0",
    height: "auto"
  }
}), Nme = {
  outline: cme,
  filled: dme,
  flushed: ume,
  unstyled: hme
}, on = ome({
  baseStyle: sme,
  sizes: lme,
  variants: Nme,
  defaultProps: {
    size: "md",
    variant: "outline"
  }
}), Mz, Mme = {
  ...(Mz = on.baseStyle) == null ? void 0 : Mz.field,
  paddingY: "2",
  minHeight: "20",
  lineHeight: "short",
  verticalAlign: "top"
}, pz, mz, pme = {
  outline: (t) => {
    var e, n;
    return (n = (e = on.variants) == null ? void 0 : e.outline(t).field) != null ? n : {};
  },
  flushed: (t) => {
    var e, n;
    return (n = (e = on.variants) == null ? void 0 : e.flushed(t).field) != null ? n : {};
  },
  filled: (t) => {
    var e, n;
    return (n = (e = on.variants) == null ? void 0 : e.filled(t).field) != null ? n : {};
  },
  unstyled: (mz = (pz = on.variants) == null ? void 0 : pz.unstyled.field) != null ? mz : {}
}, Tz, fz, Vz, Uz, Rz, gz, yz, Zz, mme = {
  xs: (fz = (Tz = on.sizes) == null ? void 0 : Tz.xs.field) != null ? fz : {},
  sm: (Uz = (Vz = on.sizes) == null ? void 0 : Vz.sm.field) != null ? Uz : {},
  md: (gz = (Rz = on.sizes) == null ? void 0 : Rz.md.field) != null ? gz : {},
  lg: (Zz = (yz = on.sizes) == null ? void 0 : yz.lg.field) != null ? Zz : {}
}, Tme = {
  baseStyle: Mme,
  sizes: mme,
  variants: pme,
  defaultProps: {
    size: "md",
    variant: "outline"
  }
}, lT = yr("tooltip-bg"), zg = yr("tooltip-fg"), fme = yr("popper-arrow-bg"), Vme = {
  bg: lT.reference,
  color: zg.reference,
  [lT.variable]: "colors.gray.700",
  [zg.variable]: "colors.whiteAlpha.900",
  _dark: {
    [lT.variable]: "colors.gray.300",
    [zg.variable]: "colors.gray.900"
  },
  [fme.variable]: lT.reference,
  px: "2",
  py: "0.5",
  borderRadius: "sm",
  fontWeight: "medium",
  fontSize: "sm",
  boxShadow: "md",
  maxW: "xs",
  zIndex: "tooltip"
}, Ume = {
  baseStyle: Vme
}, { defineMultiStyleConfig: Rme, definePartsStyle: XN } = Sn(kMe.keys), gme = (t) => {
  const { colorScheme: e, theme: n, isIndeterminate: r, hasStripe: i } = t, a = ct(
    sz(),
    sz("1rem", "rgba(0,0,0,0.1)")
  )(t), o = ct(`${e}.500`, `${e}.200`)(t), s = `linear-gradient(
    to right,
    transparent 0%,
    ${hi(n, o)} 50%,
    transparent 100%
  )`;
  return {
    ...!r && i && a,
    ...r ? { bgImage: s } : { bgColor: o }
  };
}, yme = {
  lineHeight: "1",
  fontSize: "0.25em",
  fontWeight: "bold",
  color: "white"
}, Zme = (t) => ({
  bg: ct("gray.100", "whiteAlpha.300")(t)
}), bme = (t) => ({
  transitionProperty: "common",
  transitionDuration: "slow",
  ...gme(t)
}), Eme = XN((t) => ({
  label: yme,
  filledTrack: bme(t),
  track: Zme(t)
})), Sme = {
  xs: XN({
    track: { h: "1" }
  }),
  sm: XN({
    track: { h: "2" }
  }),
  md: XN({
    track: { h: "3" }
  }),
  lg: XN({
    track: { h: "4" }
  })
}, xme = Rme({
  sizes: Sme,
  baseStyle: Eme,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), Wme = (t) => typeof t == "function";
function pi(t, ...e) {
  return Wme(t) ? t(...e) : t;
}
var { definePartsStyle: af, defineMultiStyleConfig: jme } = Sn(gMe.keys), h1 = rt("checkbox-size"), Dme = (t) => {
  const { colorScheme: e } = t;
  return {
    w: h1.reference,
    h: h1.reference,
    transitionProperty: "box-shadow",
    transitionDuration: "normal",
    border: "2px solid",
    borderRadius: "sm",
    borderColor: "inherit",
    color: "white",
    _checked: {
      bg: ct(`${e}.500`, `${e}.200`)(t),
      borderColor: ct(`${e}.500`, `${e}.200`)(t),
      color: ct("white", "gray.900")(t),
      _hover: {
        bg: ct(`${e}.600`, `${e}.300`)(t),
        borderColor: ct(`${e}.600`, `${e}.300`)(t)
      },
      _disabled: {
        borderColor: ct("gray.200", "transparent")(t),
        bg: ct("gray.200", "whiteAlpha.300")(t),
        color: ct("gray.500", "whiteAlpha.500")(t)
      }
    },
    _indeterminate: {
      bg: ct(`${e}.500`, `${e}.200`)(t),
      borderColor: ct(`${e}.500`, `${e}.200`)(t),
      color: ct("white", "gray.900")(t)
    },
    _disabled: {
      bg: ct("gray.100", "whiteAlpha.100")(t),
      borderColor: ct("gray.100", "transparent")(t)
    },
    _focusVisible: {
      boxShadow: "outline"
    },
    _invalid: {
      borderColor: ct("red.500", "red.300")(t)
    }
  };
}, zme = {
  _disabled: { cursor: "not-allowed" }
}, kme = {
  userSelect: "none",
  _disabled: { opacity: 0.4 }
}, wme = {
  transitionProperty: "transform",
  transitionDuration: "normal"
}, Fme = af((t) => ({
  icon: wme,
  container: zme,
  control: pi(Dme, t),
  label: kme
})), vme = {
  sm: af({
    control: { [h1.variable]: "sizes.3" },
    label: { fontSize: "sm" },
    icon: { fontSize: "3xs" }
  }),
  md: af({
    control: { [h1.variable]: "sizes.4" },
    label: { fontSize: "md" },
    icon: { fontSize: "2xs" }
  }),
  lg: af({
    control: { [h1.variable]: "sizes.5" },
    label: { fontSize: "lg" },
    icon: { fontSize: "2xs" }
  })
}, CV = jme({
  baseStyle: Fme,
  sizes: vme,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: Ime, definePartsStyle: of } = Sn(wMe.keys), Ome = (t) => {
  var e;
  const n = (e = pi(CV.baseStyle, t)) == null ? void 0 : e.control;
  return {
    ...n,
    borderRadius: "full",
    _checked: {
      ...n == null ? void 0 : n._checked,
      _before: {
        content: '""',
        display: "inline-block",
        pos: "relative",
        w: "50%",
        h: "50%",
        borderRadius: "50%",
        bg: "currentColor"
      }
    }
  };
}, Yme = of((t) => {
  var e, n, r, i;
  return {
    label: (n = (e = CV).baseStyle) == null ? void 0 : n.call(e, t).label,
    container: (i = (r = CV).baseStyle) == null ? void 0 : i.call(r, t).container,
    control: Ome(t)
  };
}), Qme = {
  md: of({
    control: { w: "4", h: "4" },
    label: { fontSize: "md" }
  }),
  lg: of({
    control: { w: "5", h: "5" },
    label: { fontSize: "lg" }
  }),
  sm: of({
    control: { width: "3", height: "3" },
    label: { fontSize: "sm" }
  })
}, Gme = Ime({
  baseStyle: Yme,
  sizes: Qme,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: Cme, definePartsStyle: Lme } = Sn(FMe.keys), cT = rt("select-bg"), bz, Jme = {
  ...(bz = on.baseStyle) == null ? void 0 : bz.field,
  appearance: "none",
  paddingBottom: "1px",
  lineHeight: "normal",
  bg: cT.reference,
  [cT.variable]: "colors.white",
  _dark: {
    [cT.variable]: "colors.gray.700"
  },
  "> option, > optgroup": {
    bg: cT.reference
  }
}, Bme = {
  width: "6",
  height: "100%",
  insetEnd: "2",
  position: "relative",
  color: "currentColor",
  fontSize: "xl",
  _disabled: {
    opacity: 0.5
  }
}, Ame = Lme({
  field: Jme,
  icon: Bme
}), dT = {
  paddingInlineEnd: "8"
}, Ez, Sz, xz, Wz, jz, Dz, zz, kz, Hme = {
  lg: {
    ...(Ez = on.sizes) == null ? void 0 : Ez.lg,
    field: {
      ...(Sz = on.sizes) == null ? void 0 : Sz.lg.field,
      ...dT
    }
  },
  md: {
    ...(xz = on.sizes) == null ? void 0 : xz.md,
    field: {
      ...(Wz = on.sizes) == null ? void 0 : Wz.md.field,
      ...dT
    }
  },
  sm: {
    ...(jz = on.sizes) == null ? void 0 : jz.sm,
    field: {
      ...(Dz = on.sizes) == null ? void 0 : Dz.sm.field,
      ...dT
    }
  },
  xs: {
    ...(zz = on.sizes) == null ? void 0 : zz.xs,
    field: {
      ...(kz = on.sizes) == null ? void 0 : kz.xs.field,
      ...dT
    },
    icon: {
      insetEnd: "1"
    }
  }
}, Xme = Cme({
  baseStyle: Ame,
  sizes: Hme,
  variants: on.variants,
  defaultProps: on.defaultProps
}), kg = rt("skeleton-start-color"), wg = rt("skeleton-end-color"), _me = {
  [kg.variable]: "colors.gray.100",
  [wg.variable]: "colors.gray.400",
  _dark: {
    [kg.variable]: "colors.gray.800",
    [wg.variable]: "colors.gray.600"
  },
  background: kg.reference,
  borderColor: wg.reference,
  opacity: 0.7,
  borderRadius: "sm"
}, Pme = {
  baseStyle: _me
}, Fg = rt("skip-link-bg"), Kme = {
  borderRadius: "md",
  fontWeight: "semibold",
  _focusVisible: {
    boxShadow: "outline",
    padding: "4",
    position: "fixed",
    top: "6",
    insetStart: "6",
    [Fg.variable]: "colors.white",
    _dark: {
      [Fg.variable]: "colors.gray.700"
    },
    bg: Fg.reference
  }
}, $me = {
  baseStyle: Kme
}, { defineMultiStyleConfig: qme, definePartsStyle: YU } = Sn(vMe.keys), LM = rt("slider-thumb-size"), JM = rt("slider-track-size"), bl = rt("slider-bg"), eTe = (t) => {
  const { orientation: e } = t;
  return {
    display: "inline-block",
    position: "relative",
    cursor: "pointer",
    _disabled: {
      opacity: 0.6,
      cursor: "default",
      pointerEvents: "none"
    },
    ...CS({
      orientation: e,
      vertical: { h: "100%" },
      horizontal: { w: "100%" }
    })
  };
}, tTe = (t) => ({
  ...CS({
    orientation: t.orientation,
    horizontal: { h: JM.reference },
    vertical: { w: JM.reference }
  }),
  overflow: "hidden",
  borderRadius: "sm",
  [bl.variable]: "colors.gray.200",
  _dark: {
    [bl.variable]: "colors.whiteAlpha.200"
  },
  _disabled: {
    [bl.variable]: "colors.gray.300",
    _dark: {
      [bl.variable]: "colors.whiteAlpha.300"
    }
  },
  bg: bl.reference
}), nTe = (t) => {
  const { orientation: e } = t;
  return {
    ...CS({
      orientation: e,
      vertical: {
        left: "50%",
        transform: "translateX(-50%)",
        _active: {
          transform: "translateX(-50%) scale(1.15)"
        }
      },
      horizontal: {
        top: "50%",
        transform: "translateY(-50%)",
        _active: {
          transform: "translateY(-50%) scale(1.15)"
        }
      }
    }),
    w: LM.reference,
    h: LM.reference,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    outline: 0,
    zIndex: 1,
    borderRadius: "full",
    bg: "white",
    boxShadow: "base",
    border: "1px solid",
    borderColor: "transparent",
    transitionProperty: "transform",
    transitionDuration: "normal",
    _focusVisible: {
      boxShadow: "outline"
    },
    _disabled: {
      bg: "gray.300"
    }
  };
}, rTe = (t) => {
  const { colorScheme: e } = t;
  return {
    width: "inherit",
    height: "inherit",
    [bl.variable]: `colors.${e}.500`,
    _dark: {
      [bl.variable]: `colors.${e}.200`
    },
    bg: bl.reference
  };
}, iTe = YU((t) => ({
  container: eTe(t),
  track: tTe(t),
  thumb: nTe(t),
  filledTrack: rTe(t)
})), aTe = YU({
  container: {
    [LM.variable]: "sizes.4",
    [JM.variable]: "sizes.1"
  }
}), oTe = YU({
  container: {
    [LM.variable]: "sizes.3.5",
    [JM.variable]: "sizes.1"
  }
}), sTe = YU({
  container: {
    [LM.variable]: "sizes.2.5",
    [JM.variable]: "sizes.0.5"
  }
}), lTe = {
  lg: aTe,
  md: oTe,
  sm: sTe
}, cTe = qme({
  baseStyle: iTe,
  sizes: lTe,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), ed = yr("spinner-size"), dTe = {
  width: [ed.reference],
  height: [ed.reference]
}, uTe = {
  xs: {
    [ed.variable]: "sizes.3"
  },
  sm: {
    [ed.variable]: "sizes.4"
  },
  md: {
    [ed.variable]: "sizes.6"
  },
  lg: {
    [ed.variable]: "sizes.8"
  },
  xl: {
    [ed.variable]: "sizes.12"
  }
}, hTe = {
  baseStyle: dTe,
  sizes: uTe,
  defaultProps: {
    size: "md"
  }
}, { defineMultiStyleConfig: NTe, definePartsStyle: IG } = Sn(IMe.keys), MTe = {
  fontWeight: "medium"
}, pTe = {
  opacity: 0.8,
  marginBottom: "2"
}, mTe = {
  verticalAlign: "baseline",
  fontWeight: "semibold"
}, TTe = {
  marginEnd: 1,
  w: "3.5",
  h: "3.5",
  verticalAlign: "middle"
}, fTe = IG({
  container: {},
  label: MTe,
  helpText: pTe,
  number: mTe,
  icon: TTe
}), VTe = {
  md: IG({
    label: { fontSize: "sm" },
    helpText: { fontSize: "sm" },
    number: { fontSize: "2xl" }
  })
}, UTe = NTe({
  baseStyle: fTe,
  sizes: VTe,
  defaultProps: {
    size: "md"
  }
}), vg = rt("kbd-bg"), RTe = {
  [vg.variable]: "colors.gray.100",
  _dark: {
    [vg.variable]: "colors.whiteAlpha.100"
  },
  bg: vg.reference,
  borderRadius: "md",
  borderWidth: "1px",
  borderBottomWidth: "3px",
  fontSize: "0.8em",
  fontWeight: "bold",
  lineHeight: "normal",
  px: "0.4em",
  whiteSpace: "nowrap"
}, gTe = {
  baseStyle: RTe
}, yTe = {
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  cursor: "pointer",
  textDecoration: "none",
  outline: "none",
  color: "inherit",
  _hover: {
    textDecoration: "underline"
  },
  _focusVisible: {
    boxShadow: "outline"
  }
}, ZTe = {
  baseStyle: yTe
}, { defineMultiStyleConfig: bTe, definePartsStyle: ETe } = Sn(xMe.keys), STe = {
  marginEnd: "2",
  display: "inline",
  verticalAlign: "text-bottom"
}, xTe = ETe({
  icon: STe
}), WTe = bTe({
  baseStyle: xTe
}), { defineMultiStyleConfig: jTe, definePartsStyle: DTe } = Sn(WMe.keys), po = rt("menu-bg"), Ig = rt("menu-shadow"), zTe = {
  [po.variable]: "#fff",
  [Ig.variable]: "shadows.sm",
  _dark: {
    [po.variable]: "colors.gray.700",
    [Ig.variable]: "shadows.dark-lg"
  },
  color: "inherit",
  minW: "3xs",
  py: "2",
  zIndex: 1,
  borderRadius: "md",
  borderWidth: "1px",
  bg: po.reference,
  boxShadow: Ig.reference
}, kTe = {
  py: "1.5",
  px: "3",
  transitionProperty: "background",
  transitionDuration: "ultra-fast",
  transitionTimingFunction: "ease-in",
  _focus: {
    [po.variable]: "colors.gray.100",
    _dark: {
      [po.variable]: "colors.whiteAlpha.100"
    }
  },
  _active: {
    [po.variable]: "colors.gray.200",
    _dark: {
      [po.variable]: "colors.whiteAlpha.200"
    }
  },
  _expanded: {
    [po.variable]: "colors.gray.100",
    _dark: {
      [po.variable]: "colors.whiteAlpha.100"
    }
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  },
  bg: po.reference
}, wTe = {
  mx: 4,
  my: 2,
  fontWeight: "semibold",
  fontSize: "sm"
}, FTe = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0
}, vTe = {
  opacity: 0.6
}, ITe = {
  border: 0,
  borderBottom: "1px solid",
  borderColor: "inherit",
  my: "2",
  opacity: 0.6
}, OTe = {
  transitionProperty: "common",
  transitionDuration: "normal"
}, YTe = DTe({
  button: OTe,
  list: zTe,
  item: kTe,
  groupTitle: wTe,
  icon: FTe,
  command: vTe,
  divider: ITe
}), QTe = jTe({
  baseStyle: YTe
}), { defineMultiStyleConfig: GTe, definePartsStyle: zb } = Sn(jMe.keys), Og = rt("modal-bg"), Yg = rt("modal-shadow"), CTe = {
  bg: "blackAlpha.600",
  zIndex: "modal"
}, LTe = (t) => {
  const { isCentered: e, scrollBehavior: n } = t;
  return {
    display: "flex",
    zIndex: "modal",
    justifyContent: "center",
    alignItems: e ? "center" : "flex-start",
    overflow: n === "inside" ? "hidden" : "auto",
    overscrollBehaviorY: "none"
  };
}, JTe = (t) => {
  const { isCentered: e, scrollBehavior: n } = t;
  return {
    borderRadius: "md",
    color: "inherit",
    my: e ? "auto" : "16",
    mx: e ? "auto" : void 0,
    zIndex: "modal",
    maxH: n === "inside" ? "calc(100% - 7.5rem)" : void 0,
    [Og.variable]: "colors.white",
    [Yg.variable]: "shadows.lg",
    _dark: {
      [Og.variable]: "colors.gray.700",
      [Yg.variable]: "shadows.dark-lg"
    },
    bg: Og.reference,
    boxShadow: Yg.reference
  };
}, BTe = {
  px: "6",
  py: "4",
  fontSize: "xl",
  fontWeight: "semibold"
}, ATe = {
  position: "absolute",
  top: "2",
  insetEnd: "3"
}, HTe = (t) => {
  const { scrollBehavior: e } = t;
  return {
    px: "6",
    py: "2",
    flex: "1",
    overflow: e === "inside" ? "auto" : void 0
  };
}, XTe = {
  px: "6",
  py: "4"
}, _Te = zb((t) => ({
  overlay: CTe,
  dialogContainer: pi(LTe, t),
  dialog: pi(JTe, t),
  header: BTe,
  closeButton: ATe,
  body: pi(HTe, t),
  footer: XTe
}));
function va(t) {
  return zb(t === "full" ? {
    dialog: {
      maxW: "100vw",
      minH: "$100vh",
      my: "0",
      borderRadius: "0"
    }
  } : {
    dialog: { maxW: t }
  });
}
var PTe = {
  xs: va("xs"),
  sm: va("sm"),
  md: va("md"),
  lg: va("lg"),
  xl: va("xl"),
  "2xl": va("2xl"),
  "3xl": va("3xl"),
  "4xl": va("4xl"),
  "5xl": va("5xl"),
  "6xl": va("6xl"),
  full: va("full")
}, KTe = GTe({
  baseStyle: _Te,
  sizes: PTe,
  defaultProps: { size: "md" }
}), { defineMultiStyleConfig: $Te, definePartsStyle: OG } = Sn(DMe.keys), JS = yr("number-input-stepper-width"), YG = yr("number-input-input-padding"), qTe = Ns(JS).add("0.5rem").toString(), Qg = yr("number-input-bg"), Gg = yr("number-input-color"), Cg = yr("number-input-border-color"), efe = {
  [JS.variable]: "sizes.6",
  [YG.variable]: qTe
}, tfe = (t) => {
  var e, n;
  return (n = (e = pi(on.baseStyle, t)) == null ? void 0 : e.field) != null ? n : {};
}, nfe = {
  width: JS.reference
}, rfe = {
  borderStart: "1px solid",
  borderStartColor: Cg.reference,
  color: Gg.reference,
  bg: Qg.reference,
  [Gg.variable]: "colors.chakra-body-text",
  [Cg.variable]: "colors.chakra-border-color",
  _dark: {
    [Gg.variable]: "colors.whiteAlpha.800",
    [Cg.variable]: "colors.whiteAlpha.300"
  },
  _active: {
    [Qg.variable]: "colors.gray.200",
    _dark: {
      [Qg.variable]: "colors.whiteAlpha.300"
    }
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  }
}, ife = OG((t) => {
  var e;
  return {
    root: efe,
    field: (e = pi(tfe, t)) != null ? e : {},
    stepperGroup: nfe,
    stepper: rfe
  };
});
function uT(t) {
  var e, n, r;
  const i = (e = on.sizes) == null ? void 0 : e[t], a = {
    lg: "md",
    md: "md",
    sm: "sm",
    xs: "sm"
  }, o = (r = (n = i.field) == null ? void 0 : n.fontSize) != null ? r : "md", s = zG.fontSizes[o];
  return OG({
    field: {
      ...i.field,
      paddingInlineEnd: YG.reference,
      verticalAlign: "top"
    },
    stepper: {
      fontSize: Ns(s).multiply(0.75).toString(),
      _first: {
        borderTopEndRadius: a[t]
      },
      _last: {
        borderBottomEndRadius: a[t],
        mt: "-1px",
        borderTopWidth: 1
      }
    }
  });
}
var afe = {
  xs: uT("xs"),
  sm: uT("sm"),
  md: uT("md"),
  lg: uT("lg")
}, ofe = $Te({
  baseStyle: ife,
  sizes: afe,
  variants: on.variants,
  defaultProps: on.defaultProps
}), wz, sfe = {
  ...(wz = on.baseStyle) == null ? void 0 : wz.field,
  textAlign: "center"
}, lfe = {
  lg: {
    fontSize: "lg",
    w: 12,
    h: 12,
    borderRadius: "md"
  },
  md: {
    fontSize: "md",
    w: 10,
    h: 10,
    borderRadius: "md"
  },
  sm: {
    fontSize: "sm",
    w: 8,
    h: 8,
    borderRadius: "sm"
  },
  xs: {
    fontSize: "xs",
    w: 6,
    h: 6,
    borderRadius: "sm"
  }
}, Fz, vz, cfe = {
  outline: (t) => {
    var e, n, r;
    return (r = (n = pi((e = on.variants) == null ? void 0 : e.outline, t)) == null ? void 0 : n.field) != null ? r : {};
  },
  flushed: (t) => {
    var e, n, r;
    return (r = (n = pi((e = on.variants) == null ? void 0 : e.flushed, t)) == null ? void 0 : n.field) != null ? r : {};
  },
  filled: (t) => {
    var e, n, r;
    return (r = (n = pi((e = on.variants) == null ? void 0 : e.filled, t)) == null ? void 0 : n.field) != null ? r : {};
  },
  unstyled: (vz = (Fz = on.variants) == null ? void 0 : Fz.unstyled.field) != null ? vz : {}
}, dfe = {
  baseStyle: sfe,
  sizes: lfe,
  variants: cfe,
  defaultProps: on.defaultProps
}, { defineMultiStyleConfig: ufe, definePartsStyle: hfe } = Sn(zMe.keys), hT = yr("popper-bg"), Nfe = yr("popper-arrow-bg"), Iz = yr("popper-arrow-shadow-color"), Mfe = { zIndex: 10 }, pfe = {
  [hT.variable]: "colors.white",
  bg: hT.reference,
  [Nfe.variable]: hT.reference,
  [Iz.variable]: "colors.gray.200",
  _dark: {
    [hT.variable]: "colors.gray.700",
    [Iz.variable]: "colors.whiteAlpha.300"
  },
  width: "xs",
  border: "1px solid",
  borderColor: "inherit",
  borderRadius: "md",
  boxShadow: "sm",
  zIndex: "inherit",
  _focusVisible: {
    outline: 0,
    boxShadow: "outline"
  }
}, mfe = {
  px: 3,
  py: 2,
  borderBottomWidth: "1px"
}, Tfe = {
  px: 3,
  py: 2
}, ffe = {
  px: 3,
  py: 2,
  borderTopWidth: "1px"
}, Vfe = {
  position: "absolute",
  borderRadius: "md",
  top: 1,
  insetEnd: 2,
  padding: 2
}, Ufe = hfe({
  popper: Mfe,
  content: pfe,
  header: mfe,
  body: Tfe,
  footer: ffe,
  closeButton: Vfe
}), Rfe = ufe({
  baseStyle: Ufe
}), { definePartsStyle: kb, defineMultiStyleConfig: gfe } = Sn(yMe.keys), Lg = rt("drawer-bg"), Jg = rt("drawer-box-shadow");
function Yu(t) {
  return kb(t === "full" ? {
    dialog: { maxW: "100vw", h: "100vh" }
  } : {
    dialog: { maxW: t }
  });
}
var yfe = {
  bg: "blackAlpha.600",
  zIndex: "overlay"
}, Zfe = {
  display: "flex",
  zIndex: "modal",
  justifyContent: "center"
}, bfe = (t) => {
  const { isFullHeight: e } = t;
  return {
    ...e && { height: "100vh" },
    zIndex: "modal",
    maxH: "100vh",
    color: "inherit",
    [Lg.variable]: "colors.white",
    [Jg.variable]: "shadows.lg",
    _dark: {
      [Lg.variable]: "colors.gray.700",
      [Jg.variable]: "shadows.dark-lg"
    },
    bg: Lg.reference,
    boxShadow: Jg.reference
  };
}, Efe = {
  px: "6",
  py: "4",
  fontSize: "xl",
  fontWeight: "semibold"
}, Sfe = {
  position: "absolute",
  top: "2",
  insetEnd: "3"
}, xfe = {
  px: "6",
  py: "2",
  flex: "1",
  overflow: "auto"
}, Wfe = {
  px: "6",
  py: "4"
}, jfe = kb((t) => ({
  overlay: yfe,
  dialogContainer: Zfe,
  dialog: pi(bfe, t),
  header: Efe,
  closeButton: Sfe,
  body: xfe,
  footer: Wfe
})), Dfe = {
  xs: Yu("xs"),
  sm: Yu("md"),
  md: Yu("lg"),
  lg: Yu("2xl"),
  xl: Yu("4xl"),
  full: Yu("full")
}, zfe = gfe({
  baseStyle: jfe,
  sizes: Dfe,
  defaultProps: {
    size: "xs"
  }
}), { definePartsStyle: kfe, defineMultiStyleConfig: wfe } = Sn(ZMe.keys), Ffe = {
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal"
}, vfe = {
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal",
  width: "full",
  _focusVisible: { boxShadow: "outline" },
  _placeholder: { opacity: 0.6 }
}, Ife = {
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal",
  width: "full",
  _focusVisible: { boxShadow: "outline" },
  _placeholder: { opacity: 0.6 }
}, Ofe = kfe({
  preview: Ffe,
  input: vfe,
  textarea: Ife
}), Yfe = wfe({
  baseStyle: Ofe
}), { definePartsStyle: Qfe, defineMultiStyleConfig: Gfe } = Sn(bMe.keys), V0 = rt("form-control-color"), Cfe = {
  marginStart: "1",
  [V0.variable]: "colors.red.500",
  _dark: {
    [V0.variable]: "colors.red.300"
  },
  color: V0.reference
}, Lfe = {
  mt: "2",
  [V0.variable]: "colors.gray.600",
  _dark: {
    [V0.variable]: "colors.whiteAlpha.600"
  },
  color: V0.reference,
  lineHeight: "normal",
  fontSize: "sm"
}, Jfe = Qfe({
  container: {
    width: "100%",
    position: "relative"
  },
  requiredIndicator: Cfe,
  helperText: Lfe
}), Bfe = Gfe({
  baseStyle: Jfe
}), { definePartsStyle: Afe, defineMultiStyleConfig: Hfe } = Sn(EMe.keys), U0 = rt("form-error-color"), Xfe = {
  [U0.variable]: "colors.red.500",
  _dark: {
    [U0.variable]: "colors.red.300"
  },
  color: U0.reference,
  mt: "2",
  fontSize: "sm",
  lineHeight: "normal"
}, _fe = {
  marginEnd: "0.5em",
  [U0.variable]: "colors.red.500",
  _dark: {
    [U0.variable]: "colors.red.300"
  },
  color: U0.reference
}, Pfe = Afe({
  text: Xfe,
  icon: _fe
}), Kfe = Hfe({
  baseStyle: Pfe
}), $fe = {
  fontSize: "md",
  marginEnd: "3",
  mb: "2",
  fontWeight: "medium",
  transitionProperty: "common",
  transitionDuration: "normal",
  opacity: 1,
  _disabled: {
    opacity: 0.4
  }
}, qfe = {
  baseStyle: $fe
}, eVe = {
  fontFamily: "heading",
  fontWeight: "bold"
}, tVe = {
  "4xl": {
    fontSize: ["6xl", null, "7xl"],
    lineHeight: 1
  },
  "3xl": {
    fontSize: ["5xl", null, "6xl"],
    lineHeight: 1
  },
  "2xl": {
    fontSize: ["4xl", null, "5xl"],
    lineHeight: [1.2, null, 1]
  },
  xl: {
    fontSize: ["3xl", null, "4xl"],
    lineHeight: [1.33, null, 1.2]
  },
  lg: {
    fontSize: ["2xl", null, "3xl"],
    lineHeight: [1.33, null, 1.2]
  },
  md: {
    fontSize: "xl",
    lineHeight: 1.2
  },
  sm: {
    fontSize: "md",
    lineHeight: 1.2
  },
  xs: {
    fontSize: "sm",
    lineHeight: 1.2
  }
}, nVe = {
  baseStyle: eVe,
  sizes: tVe,
  defaultProps: {
    size: "xl"
  }
}, { defineMultiStyleConfig: rVe, definePartsStyle: iVe } = Sn(RMe.keys), Bg = rt("breadcrumb-link-decor"), aVe = {
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  outline: "none",
  color: "inherit",
  textDecoration: Bg.reference,
  [Bg.variable]: "none",
  "&:not([aria-current=page])": {
    cursor: "pointer",
    _hover: {
      [Bg.variable]: "underline"
    },
    _focusVisible: {
      boxShadow: "outline"
    }
  }
}, oVe = iVe({
  link: aVe
}), sVe = rVe({
  baseStyle: oVe
}), lVe = {
  lineHeight: "1.2",
  borderRadius: "md",
  fontWeight: "semibold",
  transitionProperty: "common",
  transitionDuration: "normal",
  _focusVisible: {
    boxShadow: "outline"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none"
  },
  _hover: {
    _disabled: {
      bg: "initial"
    }
  }
}, QG = (t) => {
  const { colorScheme: e, theme: n } = t;
  if (e === "gray")
    return {
      color: ct("gray.800", "whiteAlpha.900")(t),
      _hover: {
        bg: ct("gray.100", "whiteAlpha.200")(t)
      },
      _active: { bg: ct("gray.200", "whiteAlpha.300")(t) }
    };
  const r = bh(`${e}.200`, 0.12)(n), i = bh(`${e}.200`, 0.24)(n);
  return {
    color: ct(`${e}.600`, `${e}.200`)(t),
    bg: "transparent",
    _hover: {
      bg: ct(`${e}.50`, r)(t)
    },
    _active: {
      bg: ct(`${e}.100`, i)(t)
    }
  };
}, cVe = (t) => {
  const { colorScheme: e } = t, n = ct("gray.200", "whiteAlpha.300")(t);
  return {
    border: "1px solid",
    borderColor: e === "gray" ? n : "currentColor",
    ".chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)": { marginEnd: "-1px" },
    ".chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)": { marginBottom: "-1px" },
    ...pi(QG, t)
  };
}, dVe = {
  yellow: {
    bg: "yellow.400",
    color: "black",
    hoverBg: "yellow.500",
    activeBg: "yellow.600"
  },
  cyan: {
    bg: "cyan.400",
    color: "black",
    hoverBg: "cyan.500",
    activeBg: "cyan.600"
  }
}, uVe = (t) => {
  var e;
  const { colorScheme: n } = t;
  if (n === "gray") {
    const l = ct("gray.100", "whiteAlpha.200")(t);
    return {
      bg: l,
      color: ct("gray.800", "whiteAlpha.900")(t),
      _hover: {
        bg: ct("gray.200", "whiteAlpha.300")(t),
        _disabled: {
          bg: l
        }
      },
      _active: { bg: ct("gray.300", "whiteAlpha.400")(t) }
    };
  }
  const {
    bg: r = `${n}.500`,
    color: i = "white",
    hoverBg: a = `${n}.600`,
    activeBg: o = `${n}.700`
  } = (e = dVe[n]) != null ? e : {}, s = ct(r, `${n}.200`)(t);
  return {
    bg: s,
    color: ct(i, "gray.800")(t),
    _hover: {
      bg: ct(a, `${n}.300`)(t),
      _disabled: {
        bg: s
      }
    },
    _active: { bg: ct(o, `${n}.400`)(t) }
  };
}, hVe = (t) => {
  const { colorScheme: e } = t;
  return {
    padding: 0,
    height: "auto",
    lineHeight: "normal",
    verticalAlign: "baseline",
    color: ct(`${e}.500`, `${e}.200`)(t),
    _hover: {
      textDecoration: "underline",
      _disabled: {
        textDecoration: "none"
      }
    },
    _active: {
      color: ct(`${e}.700`, `${e}.500`)(t)
    }
  };
}, NVe = {
  bg: "none",
  color: "inherit",
  display: "inline",
  lineHeight: "inherit",
  m: "0",
  p: "0"
}, MVe = {
  ghost: QG,
  outline: cVe,
  solid: uVe,
  link: hVe,
  unstyled: NVe
}, pVe = {
  lg: {
    h: "12",
    minW: "12",
    fontSize: "lg",
    px: "6"
  },
  md: {
    h: "10",
    minW: "10",
    fontSize: "md",
    px: "4"
  },
  sm: {
    h: "8",
    minW: "8",
    fontSize: "sm",
    px: "3"
  },
  xs: {
    h: "6",
    minW: "6",
    fontSize: "xs",
    px: "2"
  }
}, mVe = {
  baseStyle: lVe,
  variants: MVe,
  sizes: pVe,
  defaultProps: {
    variant: "solid",
    size: "md",
    colorScheme: "gray"
  }
}, { definePartsStyle: Wd, defineMultiStyleConfig: TVe } = Sn(CMe.keys), LV = rt("card-bg"), xs = rt("card-padding"), GG = rt("card-shadow"), sf = rt("card-radius"), CG = rt("card-border-width", "0"), LG = rt("card-border-color"), fVe = Wd({
  container: {
    [LV.variable]: "colors.chakra-body-bg",
    backgroundColor: LV.reference,
    boxShadow: GG.reference,
    borderRadius: sf.reference,
    color: "chakra-body-text",
    borderWidth: CG.reference,
    borderColor: LG.reference
  },
  body: {
    padding: xs.reference,
    flex: "1 1 0%"
  },
  header: {
    padding: xs.reference
  },
  footer: {
    padding: xs.reference
  }
}), VVe = {
  sm: Wd({
    container: {
      [sf.variable]: "radii.base",
      [xs.variable]: "space.3"
    }
  }),
  md: Wd({
    container: {
      [sf.variable]: "radii.md",
      [xs.variable]: "space.5"
    }
  }),
  lg: Wd({
    container: {
      [sf.variable]: "radii.xl",
      [xs.variable]: "space.7"
    }
  })
}, UVe = {
  elevated: Wd({
    container: {
      [GG.variable]: "shadows.base",
      _dark: {
        [LV.variable]: "colors.gray.700"
      }
    }
  }),
  outline: Wd({
    container: {
      [CG.variable]: "1px",
      [LG.variable]: "colors.chakra-border-color"
    }
  }),
  filled: Wd({
    container: {
      [LV.variable]: "colors.chakra-subtle-bg"
    }
  }),
  unstyled: {
    body: {
      [xs.variable]: 0
    },
    header: {
      [xs.variable]: 0
    },
    footer: {
      [xs.variable]: 0
    }
  }
}, RVe = TVe({
  baseStyle: fVe,
  variants: UVe,
  sizes: VVe,
  defaultProps: {
    variant: "elevated",
    size: "md"
  }
}), N1 = yr("close-button-size"), zN = yr("close-button-bg"), gVe = {
  w: [N1.reference],
  h: [N1.reference],
  borderRadius: "md",
  transitionProperty: "common",
  transitionDuration: "normal",
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none"
  },
  _hover: {
    [zN.variable]: "colors.blackAlpha.100",
    _dark: {
      [zN.variable]: "colors.whiteAlpha.100"
    }
  },
  _active: {
    [zN.variable]: "colors.blackAlpha.200",
    _dark: {
      [zN.variable]: "colors.whiteAlpha.200"
    }
  },
  _focusVisible: {
    boxShadow: "outline"
  },
  bg: zN.reference
}, yVe = {
  lg: {
    [N1.variable]: "sizes.10",
    fontSize: "md"
  },
  md: {
    [N1.variable]: "sizes.8",
    fontSize: "xs"
  },
  sm: {
    [N1.variable]: "sizes.6",
    fontSize: "2xs"
  }
}, ZVe = {
  baseStyle: gVe,
  sizes: yVe,
  defaultProps: {
    size: "md"
  }
}, { variants: bVe, defaultProps: EVe } = u1, SVe = {
  fontFamily: "mono",
  fontSize: "sm",
  px: "0.2em",
  borderRadius: "sm",
  bg: sr.bg.reference,
  color: sr.color.reference,
  boxShadow: sr.shadow.reference
}, xVe = {
  baseStyle: SVe,
  variants: bVe,
  defaultProps: EVe
}, WVe = {
  w: "100%",
  mx: "auto",
  maxW: "prose",
  px: "4"
}, jVe = {
  baseStyle: WVe
}, DVe = {
  opacity: 0.6,
  borderColor: "inherit"
}, zVe = {
  borderStyle: "solid"
}, kVe = {
  borderStyle: "dashed"
}, wVe = {
  solid: zVe,
  dashed: kVe
}, FVe = {
  baseStyle: DVe,
  variants: wVe,
  defaultProps: {
    variant: "solid"
  }
}, { definePartsStyle: vVe, defineMultiStyleConfig: IVe } = Sn(fMe.keys), OVe = {
  borderTopWidth: "1px",
  borderColor: "inherit",
  _last: {
    borderBottomWidth: "1px"
  }
}, YVe = {
  transitionProperty: "common",
  transitionDuration: "normal",
  fontSize: "md",
  _focusVisible: {
    boxShadow: "outline"
  },
  _hover: {
    bg: "blackAlpha.50"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  },
  px: "4",
  py: "2"
}, QVe = {
  pt: "2",
  px: "4",
  pb: "5"
}, GVe = {
  fontSize: "1.25em"
}, CVe = vVe({
  container: OVe,
  button: YVe,
  panel: QVe,
  icon: GVe
}), LVe = IVe({ baseStyle: CVe }), { definePartsStyle: cm, defineMultiStyleConfig: JVe } = Sn(VMe.keys), Ki = rt("alert-fg"), Cs = rt("alert-bg"), BVe = cm({
  container: {
    bg: Cs.reference,
    px: "4",
    py: "3"
  },
  title: {
    fontWeight: "bold",
    lineHeight: "6",
    marginEnd: "2"
  },
  description: {
    lineHeight: "6"
  },
  icon: {
    color: Ki.reference,
    flexShrink: 0,
    marginEnd: "3",
    w: "5",
    h: "6"
  },
  spinner: {
    color: Ki.reference,
    flexShrink: 0,
    marginEnd: "3",
    w: "5",
    h: "5"
  }
});
function BS(t) {
  const { theme: e, colorScheme: n } = t, r = bh(`${n}.200`, 0.16)(e);
  return {
    light: `colors.${n}.100`,
    dark: r
  };
}
var AVe = cm((t) => {
  const { colorScheme: e } = t, n = BS(t);
  return {
    container: {
      [Ki.variable]: `colors.${e}.500`,
      [Cs.variable]: n.light,
      _dark: {
        [Ki.variable]: `colors.${e}.200`,
        [Cs.variable]: n.dark
      }
    }
  };
}), HVe = cm((t) => {
  const { colorScheme: e } = t, n = BS(t);
  return {
    container: {
      [Ki.variable]: `colors.${e}.500`,
      [Cs.variable]: n.light,
      _dark: {
        [Ki.variable]: `colors.${e}.200`,
        [Cs.variable]: n.dark
      },
      paddingStart: "3",
      borderStartWidth: "4px",
      borderStartColor: Ki.reference
    }
  };
}), XVe = cm((t) => {
  const { colorScheme: e } = t, n = BS(t);
  return {
    container: {
      [Ki.variable]: `colors.${e}.500`,
      [Cs.variable]: n.light,
      _dark: {
        [Ki.variable]: `colors.${e}.200`,
        [Cs.variable]: n.dark
      },
      pt: "2",
      borderTopWidth: "4px",
      borderTopColor: Ki.reference
    }
  };
}), _Ve = cm((t) => {
  const { colorScheme: e } = t;
  return {
    container: {
      [Ki.variable]: "colors.white",
      [Cs.variable]: `colors.${e}.500`,
      _dark: {
        [Ki.variable]: "colors.gray.900",
        [Cs.variable]: `colors.${e}.200`
      },
      color: Ki.reference
    }
  };
}), PVe = {
  subtle: AVe,
  "left-accent": HVe,
  "top-accent": XVe,
  solid: _Ve
}, KVe = JVe({
  baseStyle: BVe,
  variants: PVe,
  defaultProps: {
    variant: "subtle",
    colorScheme: "blue"
  }
}), { definePartsStyle: JG, defineMultiStyleConfig: $Ve } = Sn(UMe.keys), R0 = rt("avatar-border-color"), M1 = rt("avatar-bg"), BM = rt("avatar-font-size"), Eh = rt("avatar-size"), qVe = {
  borderRadius: "full",
  border: "0.2em solid",
  borderColor: R0.reference,
  [R0.variable]: "white",
  _dark: {
    [R0.variable]: "colors.gray.800"
  }
}, e2e = {
  bg: M1.reference,
  fontSize: BM.reference,
  width: Eh.reference,
  height: Eh.reference,
  lineHeight: "1",
  [M1.variable]: "colors.gray.200",
  _dark: {
    [M1.variable]: "colors.whiteAlpha.400"
  }
}, t2e = (t) => {
  const { name: e, theme: n } = t, r = e ? lpe({ string: e }) : "colors.gray.400", i = ope(r)(n);
  let a = "white";
  return i || (a = "gray.800"), {
    bg: M1.reference,
    fontSize: BM.reference,
    color: a,
    borderColor: R0.reference,
    verticalAlign: "top",
    width: Eh.reference,
    height: Eh.reference,
    "&:not([data-loaded])": {
      [M1.variable]: r
    },
    [R0.variable]: "colors.white",
    _dark: {
      [R0.variable]: "colors.gray.800"
    }
  };
}, n2e = {
  fontSize: BM.reference,
  lineHeight: "1"
}, r2e = JG((t) => ({
  badge: pi(qVe, t),
  excessLabel: pi(e2e, t),
  container: pi(t2e, t),
  label: n2e
}));
function cl(t) {
  const e = t !== "100%" ? wG[t] : void 0;
  return JG({
    container: {
      [Eh.variable]: e ?? t,
      [BM.variable]: `calc(${e ?? t} / 2.5)`
    },
    excessLabel: {
      [Eh.variable]: e ?? t,
      [BM.variable]: `calc(${e ?? t} / 2.5)`
    }
  });
}
var i2e = {
  "2xs": cl(4),
  xs: cl(6),
  sm: cl(8),
  md: cl(12),
  lg: cl(16),
  xl: cl(24),
  "2xl": cl(32),
  full: cl("100%")
}, a2e = $Ve({
  baseStyle: r2e,
  sizes: i2e,
  defaultProps: {
    size: "md"
  }
}), o2e = {
  Accordion: LVe,
  Alert: KVe,
  Avatar: a2e,
  Badge: u1,
  Breadcrumb: sVe,
  Button: mVe,
  Checkbox: CV,
  CloseButton: ZVe,
  Code: xVe,
  Container: jVe,
  Divider: FVe,
  Drawer: zfe,
  Editable: Yfe,
  Form: Bfe,
  FormError: Kfe,
  FormLabel: qfe,
  Heading: nVe,
  Input: on,
  Kbd: gTe,
  Link: ZTe,
  List: WTe,
  Menu: QTe,
  Modal: KTe,
  NumberInput: ofe,
  PinInput: dfe,
  Popover: Rfe,
  Progress: xme,
  Radio: Gme,
  Select: Xme,
  Skeleton: Pme,
  SkipLink: $me,
  Slider: cTe,
  Spinner: hTe,
  Stat: UTe,
  Switch: Zpe,
  Table: Dpe,
  Tabs: Ape,
  Tag: ame,
  Textarea: Tme,
  Tooltip: Ume,
  Card: RVe,
  Stepper: TMe
}, s2e = {
  colors: {
    "chakra-body-text": { _light: "gray.800", _dark: "whiteAlpha.900" },
    "chakra-body-bg": { _light: "white", _dark: "gray.800" },
    "chakra-border-color": { _light: "gray.200", _dark: "whiteAlpha.300" },
    "chakra-inverse-text": { _light: "white", _dark: "gray.800" },
    "chakra-subtle-bg": { _light: "gray.100", _dark: "gray.700" },
    "chakra-subtle-text": { _light: "gray.600", _dark: "gray.400" },
    "chakra-placeholder-color": { _light: "gray.500", _dark: "whiteAlpha.400" }
  }
}, l2e = {
  global: {
    body: {
      fontFamily: "body",
      color: "chakra-body-text",
      bg: "chakra-body-bg",
      transitionProperty: "background-color",
      transitionDuration: "normal",
      lineHeight: "base"
    },
    "*::placeholder": {
      color: "chakra-placeholder-color"
    },
    "*, *::before, &::after": {
      borderColor: "chakra-border-color"
    }
  }
}, c2e = "ltr", d2e = {
  useSystemColorMode: !1,
  initialColorMode: "light",
  cssVarPrefix: "chakra"
}, BG = {
  semanticTokens: s2e,
  direction: c2e,
  ...MMe,
  components: o2e,
  styles: l2e,
  config: d2e
};
function _N(t) {
  return typeof t == "function";
}
function u2e(...t) {
  return (e) => t.reduce((n, r) => r(n), e);
}
var h2e = (t) => function(...n) {
  let r = [...n], i = n[n.length - 1];
  return J1e(i) && // this ensures backward compatibility
  // previously only `extendTheme(override, activeTheme?)` was allowed
  r.length > 1 ? r = r.slice(0, r.length - 1) : i = t, u2e(
    ...r.map(
      (a) => (o) => _N(a) ? a(o) : M2e(o, a)
    )
  )(i);
}, N2e = h2e(BG);
function M2e(...t) {
  return Za({}, ...t, AG);
}
function AG(t, e, n, r) {
  if ((_N(t) || _N(e)) && Object.prototype.hasOwnProperty.call(r, n))
    return (...i) => {
      const a = _N(t) ? t(...i) : t, o = _N(e) ? e(...i) : e;
      return Za({}, a, o, AG);
    };
}
function p2e(t, e) {
  const n = {};
  return Object.keys(t).forEach((r) => {
    e.includes(r) || (n[r] = t[r]);
  }), n;
}
function m2e(t, e, n, r) {
  const i = typeof e == "string" ? e.split(".") : [e];
  for (r = 0; r < i.length && t; r += 1)
    t = t[i[r]];
  return t === void 0 ? n : t;
}
var T2e = (t) => {
  const e = /* @__PURE__ */ new WeakMap();
  return (r, i, a, o) => {
    if (typeof r > "u")
      return t(r, i, a);
    e.has(r) || e.set(r, /* @__PURE__ */ new Map());
    const s = e.get(r);
    if (s.has(i))
      return s.get(i);
    const l = t(r, i, a, o);
    return s.set(i, l), l;
  };
}, HG = T2e(m2e);
function XG(t, e) {
  const n = {};
  return Object.keys(t).forEach((r) => {
    const i = t[r];
    e(i, r, t) && (n[r] = i);
  }), n;
}
var _G = (t) => XG(t, (e) => e != null);
function f2e(t) {
  return typeof t == "function";
}
ue.env.NODE_ENV;
ue.env.NODE_ENV;
function PG(t, ...e) {
  return f2e(t) ? t(...e) : t;
}
var V2e = typeof Element < "u", U2e = typeof Map == "function", R2e = typeof Set == "function", g2e = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function lf(t, e) {
  if (t === e)
    return !0;
  if (t && e && typeof t == "object" && typeof e == "object") {
    if (t.constructor !== e.constructor)
      return !1;
    var n, r, i;
    if (Array.isArray(t)) {
      if (n = t.length, n != e.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!lf(t[r], e[r]))
          return !1;
      return !0;
    }
    var a;
    if (U2e && t instanceof Map && e instanceof Map) {
      if (t.size !== e.size)
        return !1;
      for (a = t.entries(); !(r = a.next()).done; )
        if (!e.has(r.value[0]))
          return !1;
      for (a = t.entries(); !(r = a.next()).done; )
        if (!lf(r.value[1], e.get(r.value[0])))
          return !1;
      return !0;
    }
    if (R2e && t instanceof Set && e instanceof Set) {
      if (t.size !== e.size)
        return !1;
      for (a = t.entries(); !(r = a.next()).done; )
        if (!e.has(r.value[0]))
          return !1;
      return !0;
    }
    if (g2e && ArrayBuffer.isView(t) && ArrayBuffer.isView(e)) {
      if (n = t.length, n != e.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (t[r] !== e[r])
          return !1;
      return !0;
    }
    if (t.constructor === RegExp)
      return t.source === e.source && t.flags === e.flags;
    if (t.valueOf !== Object.prototype.valueOf && typeof t.valueOf == "function" && typeof e.valueOf == "function")
      return t.valueOf() === e.valueOf();
    if (t.toString !== Object.prototype.toString && typeof t.toString == "function" && typeof e.toString == "function")
      return t.toString() === e.toString();
    if (i = Object.keys(t), n = i.length, n !== Object.keys(e).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(e, i[r]))
        return !1;
    if (V2e && t instanceof Element)
      return !1;
    for (r = n; r-- !== 0; )
      if (!((i[r] === "_owner" || i[r] === "__v" || i[r] === "__o") && t.$$typeof) && !lf(t[i[r]], e[i[r]]))
        return !1;
    return !0;
  }
  return t !== t && e !== e;
}
var y2e = function(e, n) {
  try {
    return lf(e, n);
  } catch (r) {
    if ((r.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw r;
  }
};
const Z2e = /* @__PURE__ */ fc(y2e);
function KG(t, e = {}) {
  var n;
  const { styleConfig: r, ...i } = e, { theme: a, colorMode: o } = UNe(), s = t ? HG(a, `components.${t}`) : void 0, l = r || s, c = Za(
    { theme: a, colorMode: o },
    (n = l == null ? void 0 : l.defaultProps) != null ? n : {},
    _G(p2e(i, ["children"]))
  ), d = Ve({});
  if (l) {
    const h = G1e(l)(c);
    Z2e(d.current, h) || (d.current = h);
  }
  return d.current;
}
function jc(t, e = {}) {
  return KG(t, e);
}
function $G(t, e = {}) {
  return KG(t, e);
}
var b2e = /* @__PURE__ */ new Set([
  ...W1e,
  "textStyle",
  "layerStyle",
  "apply",
  "noOfLines",
  "focusBorderColor",
  "errorBorderColor",
  "as",
  "__css",
  "css",
  "sx"
]), E2e = /* @__PURE__ */ new Set([
  "htmlWidth",
  "htmlHeight",
  "htmlSize",
  "htmlTranslate"
]);
function S2e(t) {
  return E2e.has(t) || !b2e.has(t);
}
function x2e(t, ...e) {
  if (t == null)
    throw new TypeError("Cannot convert undefined or null to object");
  const n = { ...t };
  for (const r of e)
    if (r != null)
      for (const i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (i in n && delete n[i], n[i] = r[i]);
  return n;
}
function W2e(t) {
  const e = Object.assign({}, t);
  for (let n in e)
    e[n] === void 0 && delete e[n];
  return e;
}
var j2e = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, D2e = /* @__PURE__ */ uG(
  function(t) {
    return j2e.test(t) || t.charCodeAt(0) === 111 && t.charCodeAt(1) === 110 && t.charCodeAt(2) < 91;
  }
  /* Z+1 */
), z2e = D2e, k2e = function(e) {
  return e !== "theme";
}, Oz = function(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96 ? z2e : k2e;
}, Yz = function(e, n, r) {
  var i;
  if (n) {
    var a = n.shouldForwardProp;
    i = e.__emotion_forwardProp && a ? function(o) {
      return e.__emotion_forwardProp(o) && a(o);
    } : a;
  }
  return typeof i != "function" && r && (i = e.__emotion_forwardProp), i;
}, Qz = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, w2e = function(e) {
  var n = e.cache, r = e.serialized, i = e.isStringTag;
  return DU(n, r, i), kS(function() {
    return zU(n, r, i);
  }), null;
}, F2e = function t(e, n) {
  if (ue.env.NODE_ENV !== "production" && e === void 0)
    throw new Error(`You are trying to create a styled element with an undefined component.
You may have forgotten to import it.`);
  var r = e.__emotion_real === e, i = r && e.__emotion_base || e, a, o;
  n !== void 0 && (a = n.label, o = n.target);
  var s = Yz(e, n, r), l = s || Oz(i), c = !l("as");
  return function() {
    var d = arguments, u = r && e.__emotion_styles !== void 0 ? e.__emotion_styles.slice(0) : [];
    if (a !== void 0 && u.push("label:" + a + ";"), d[0] == null || d[0].raw === void 0)
      u.push.apply(u, d);
    else {
      ue.env.NODE_ENV !== "production" && d[0][0] === void 0 && console.error(Qz), u.push(d[0][0]);
      for (var h = d.length, N = 1; N < h; N++)
        ue.env.NODE_ENV !== "production" && d[0][N] === void 0 && console.error(Qz), u.push(d[N], d[0][N]);
    }
    var M = kU(function(p, m, R) {
      var V = c && p.as || i, U = "", g = [], y = p;
      if (p.theme == null) {
        y = {};
        for (var x in p)
          y[x] = p[x];
        y.theme = lt(dc);
      }
      typeof p.className == "string" ? U = DS(m.registered, g, p.className) : p.className != null && (U = p.className + " ");
      var f = Zh(u.concat(g), m.registered, y);
      U += m.key + "-" + f.name, o !== void 0 && (U += " " + o);
      var D = c && s === void 0 ? Oz(V) : l, Y = {};
      for (var Q in p)
        c && Q === "as" || // $FlowFixMe
        D(Q) && (Y[Q] = p[Q]);
      return Y.className = U, Y.ref = R, /* @__PURE__ */ ye(tu, null, /* @__PURE__ */ ye(w2e, {
        cache: m,
        serialized: f,
        isStringTag: typeof V == "string"
      }), /* @__PURE__ */ ye(V, Y));
    });
    return M.displayName = a !== void 0 ? a : "Styled(" + (typeof i == "string" ? i : i.displayName || i.name || "Component") + ")", M.defaultProps = e.defaultProps, M.__emotion_real = M, M.__emotion_base = i, M.__emotion_styles = u, M.__emotion_forwardProp = s, Object.defineProperty(M, "toString", {
      value: function() {
        return o === void 0 && ue.env.NODE_ENV !== "production" ? "NO_COMPONENT_SELECTOR" : "." + o;
      }
    }), M.withComponent = function(p, m) {
      return t(p, vV({}, n, m, {
        shouldForwardProp: Yz(M, m, !0)
      })).apply(void 0, u);
    }, M;
  };
}, v2e = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], JV = F2e.bind();
v2e.forEach(function(t) {
  JV[t] = JV(t);
});
var Gz, I2e = (Gz = JV.default) != null ? Gz : JV, O2e = ({ baseStyle: t }) => (e) => {
  const { theme: n, css: r, __css: i, sx: a, ...o } = e, s = XG(o, (u, h) => D1e(h)), l = PG(t, e), c = x2e(
    {},
    i,
    l,
    _G(s),
    a
  ), d = DG(c)(e.theme);
  return r ? [d, r] : d;
};
function Ag(t, e) {
  const { baseStyle: n, ...r } = e ?? {};
  r.shouldForwardProp || (r.shouldForwardProp = S2e);
  const i = O2e({ baseStyle: n }), a = I2e(
    t,
    r
  )(i);
  return rr.forwardRef(function(l, c) {
    const { colorMode: d, forced: u } = IS();
    return rr.createElement(a, {
      ref: c,
      "data-theme": u ? d : void 0,
      ...l
    });
  });
}
function Y2e() {
  const t = /* @__PURE__ */ new Map();
  return new Proxy(Ag, {
    /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */
    apply(e, n, r) {
      return Ag(...r);
    },
    /**
     * @example
     * <chakra.div />
     */
    get(e, n) {
      return t.has(n) || t.set(n, Ag(n)), t.get(n);
    }
  });
}
var Te = Y2e();
function On(t) {
  return Ge(t);
}
function Q2e(t = {}) {
  const {
    strict: e = !0,
    errorMessage: n = "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider",
    name: r
  } = t, i = Wt(void 0);
  i.displayName = r;
  function a() {
    var o;
    const s = lt(i);
    if (!s && e) {
      const l = new Error(n);
      throw l.name = "ContextError", (o = Error.captureStackTrace) == null || o.call(Error, l, a), l;
    }
    return s;
  }
  return [
    i.Provider,
    a,
    i
  ];
}
function G2e(t) {
  const { cssVarsRoot: e, theme: n, children: r } = t, i = vt(() => x1e(n), [n]);
  return /* @__PURE__ */ E.jsxs(Phe, { theme: i, children: [
    /* @__PURE__ */ E.jsx(C2e, { root: e }),
    r
  ] });
}
function C2e({ root: t = ":host, :root" }) {
  const e = [t, "[data-theme]"].join(",");
  return /* @__PURE__ */ E.jsx(sm, { styles: (n) => ({ [e]: n.__cssVars }) });
}
Q2e({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
});
function L2e() {
  const { colorMode: t } = IS();
  return /* @__PURE__ */ E.jsx(
    sm,
    {
      styles: (e) => {
        const n = HG(e, "styles.global"), r = PG(n, { theme: e, colorMode: t });
        return r ? DG(r)(e) : void 0;
      }
    }
  );
}
var qG = Wt({
  getDocument() {
    return document;
  },
  getWindow() {
    return window;
  }
});
qG.displayName = "EnvironmentContext";
function eC(t) {
  const { children: e, environment: n, disabled: r } = t, i = Ve(null), a = vt(() => n || {
    getDocument: () => {
      var s, l;
      return (l = (s = i.current) == null ? void 0 : s.ownerDocument) != null ? l : document;
    },
    getWindow: () => {
      var s, l;
      return (l = (s = i.current) == null ? void 0 : s.ownerDocument.defaultView) != null ? l : window;
    }
  }, [n]), o = !r || !n;
  return /* @__PURE__ */ E.jsxs(qG.Provider, { value: a, children: [
    e,
    o && /* @__PURE__ */ E.jsx("span", { id: "__chakra_env", hidden: !0, ref: i })
  ] });
}
eC.displayName = "EnvironmentProvider";
var J2e = (t) => {
  const {
    children: e,
    colorModeManager: n,
    portalZIndex: r,
    resetScope: i,
    resetCSS: a = !0,
    theme: o = {},
    environment: s,
    cssVarsRoot: l,
    disableEnvironment: c,
    disableGlobalStyle: d
  } = t, u = /* @__PURE__ */ E.jsx(
    eC,
    {
      environment: s,
      disabled: c,
      children: e
    }
  );
  return /* @__PURE__ */ E.jsx(G2e, { theme: o, cssVarsRoot: l, children: /* @__PURE__ */ E.jsxs(
    ZG,
    {
      colorModeManager: n,
      options: o.config,
      children: [
        a ? /* @__PURE__ */ E.jsx(sNe, { scope: i }) : /* @__PURE__ */ E.jsx(oNe, {}),
        !d && /* @__PURE__ */ E.jsx(L2e, {}),
        r ? /* @__PURE__ */ E.jsx(gG, { zIndex: r, children: u }) : u
      ]
    }
  ) });
}, B2e = (t, e) => t.find((n) => n.id === e);
function Cz(t, e) {
  const n = tC(t, e), r = n ? t[n].findIndex((i) => i.id === e) : -1;
  return {
    position: n,
    index: r
  };
}
function tC(t, e) {
  for (const [n, r] of Object.entries(t))
    if (B2e(r, e))
      return n;
}
function A2e(t) {
  const e = t.includes("right"), n = t.includes("left");
  let r = "center";
  return e && (r = "flex-end"), n && (r = "flex-start"), {
    display: "flex",
    flexDirection: "column",
    alignItems: r
  };
}
function H2e(t) {
  const n = t === "top" || t === "bottom" ? "0 auto" : void 0, r = t.includes("top") ? "env(safe-area-inset-top, 0px)" : void 0, i = t.includes("bottom") ? "env(safe-area-inset-bottom, 0px)" : void 0, a = t.includes("left") ? void 0 : "env(safe-area-inset-right, 0px)", o = t.includes("right") ? void 0 : "env(safe-area-inset-left, 0px)";
  return {
    position: "fixed",
    zIndex: "var(--toast-z-index, 5500)",
    pointerEvents: "none",
    display: "flex",
    flexDirection: "column",
    margin: n,
    top: r,
    bottom: i,
    right: a,
    left: o
  };
}
function AM(t, e = []) {
  const n = Ve(t);
  return Ee(() => {
    n.current = t;
  }), De((...r) => {
    var i;
    return (i = n.current) == null ? void 0 : i.call(n, ...r);
  }, e);
}
function X2e(t, e) {
  const n = AM(t);
  Ee(() => {
    if (e == null)
      return;
    let r = null;
    return r = window.setTimeout(() => {
      n();
    }, e), () => {
      r && window.clearTimeout(r);
    };
  }, [e, n]);
}
function HM(t, e) {
  const n = Ve(!1), r = Ve(!1);
  Ee(() => {
    if (n.current && r.current)
      return t();
    r.current = !0;
  }, e), Ee(() => (n.current = !0, () => {
    n.current = !1;
  }), []);
}
const nC = Wt({
  transformPagePoint: (t) => t,
  isStatic: !1,
  reducedMotion: "never"
}), QU = Wt({}), dm = Wt(null), GU = typeof document < "u", BV = GU ? xp : Ee, rC = Wt({ strict: !1 });
function _2e(t, e, n, r) {
  const { visualElement: i } = lt(QU), a = lt(rC), o = lt(dm), s = lt(nC).reducedMotion, l = Ve();
  r = r || a.renderer, !l.current && r && (l.current = r(t, {
    visualState: e,
    parent: i,
    props: n,
    presenceContext: o,
    blockInitialAnimation: o ? o.initial === !1 : !1,
    reducedMotionConfig: s
  }));
  const c = l.current;
  return Nw(() => {
    c && c.update(n, o);
  }), BV(() => {
    c && c.render();
  }), Ee(() => {
    c && c.updateFeatures();
  }), (window.HandoffAppearAnimations ? BV : Ee)(() => {
    c && c.animationState && c.animationState.animateChanges();
  }), c;
}
function i0(t) {
  return typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "current");
}
function P2e(t, e, n) {
  return De(
    (r) => {
      r && t.mount && t.mount(r), e && (r ? e.mount(r) : e.unmount()), n && (typeof n == "function" ? n(r) : i0(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [e]
  );
}
function XM(t) {
  return typeof t == "string" || Array.isArray(t);
}
function CU(t) {
  return typeof t == "object" && typeof t.start == "function";
}
const AS = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], HS = ["initial", ...AS];
function LU(t) {
  return CU(t.animate) || HS.some((e) => XM(t[e]));
}
function iC(t) {
  return !!(LU(t) || t.variants);
}
function K2e(t, e) {
  if (LU(t)) {
    const { initial: n, animate: r } = t;
    return {
      initial: n === !1 || XM(n) ? n : void 0,
      animate: XM(r) ? r : void 0
    };
  }
  return t.inherit !== !1 ? e : {};
}
function $2e(t) {
  const { initial: e, animate: n } = K2e(t, lt(QU));
  return vt(() => ({ initial: e, animate: n }), [Lz(e), Lz(n)]);
}
function Lz(t) {
  return Array.isArray(t) ? t.join(" ") : t;
}
const Jz = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, _M = {};
for (const t in Jz)
  _M[t] = {
    isEnabled: (e) => Jz[t].some((n) => !!e[n])
  };
function q2e(t) {
  for (const e in t)
    _M[e] = {
      ..._M[e],
      ...t[e]
    };
}
function XS(t) {
  const e = Ve(null);
  return e.current === null && (e.current = t()), e.current;
}
const p1 = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
let eUe = 1;
function tUe() {
  return XS(() => {
    if (p1.hasEverUpdated)
      return eUe++;
  });
}
const _S = Wt({}), aC = Wt({}), nUe = Symbol.for("motionComponentSymbol");
function rUe({ preloadedFeatures: t, createVisualElement: e, useRender: n, useVisualState: r, Component: i }) {
  t && q2e(t);
  function a(s, l) {
    let c;
    const d = {
      ...lt(nC),
      ...s,
      layoutId: iUe(s)
    }, { isStatic: u } = d, h = $2e(s), N = u ? void 0 : tUe(), M = r(s, u);
    if (!u && GU) {
      h.visualElement = _2e(i, M, d, e);
      const p = lt(aC), m = lt(rC).strict;
      h.visualElement && (c = h.visualElement.loadFeatures(
        // Note: Pass the full new combined props to correctly re-render dynamic feature components.
        d,
        m,
        t,
        N,
        p
      ));
    }
    return H.createElement(
      QU.Provider,
      { value: h },
      c && h.visualElement ? H.createElement(c, { visualElement: h.visualElement, ...d }) : null,
      n(i, s, N, P2e(M, h.visualElement, l), M, u, h.visualElement)
    );
  }
  const o = Ge(a);
  return o[nUe] = i, o;
}
function iUe({ layoutId: t }) {
  const e = lt(_S).id;
  return e && t !== void 0 ? e + "-" + t : t;
}
function aUe(t) {
  function e(r, i = {}) {
    return rUe(t(r, i));
  }
  if (typeof Proxy > "u")
    return e;
  const n = /* @__PURE__ */ new Map();
  return new Proxy(e, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (r, i) => (n.has(i) || n.set(i, e(i)), n.get(i))
  });
}
const oUe = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function PS(t) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof t != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    t.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(oUe.indexOf(t) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(t))
    )
  );
}
const AV = {};
function sUe(t) {
  Object.assign(AV, t);
}
const JU = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], fu = new Set(JU);
function oC(t, { layout: e, layoutId: n }) {
  return fu.has(t) || t.startsWith("origin") || (e || n !== void 0) && (!!AV[t] || t === "opacity");
}
const Oi = (t) => !!(t && t.getVelocity), lUe = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, cUe = JU.length;
function dUe(t, { enableHardwareAcceleration: e = !0, allowTransformNone: n = !0 }, r, i) {
  let a = "";
  for (let o = 0; o < cUe; o++) {
    const s = JU[o];
    if (t[s] !== void 0) {
      const l = lUe[s] || s;
      a += `${l}(${t[s]}) `;
    }
  }
  return e && !t.z && (a += "translateZ(0)"), a = a.trim(), i ? a = i(t, r ? "" : a) : n && r && (a = "none"), a;
}
const sC = (t) => (e) => typeof e == "string" && e.startsWith(t), lC = sC("--"), wb = sC("var(--"), uUe = (t, e) => e && typeof t == "number" ? e.transform(t) : t, Xd = (t, e, n) => Math.min(Math.max(n, t), e), Vu = {
  test: (t) => typeof t == "number",
  parse: parseFloat,
  transform: (t) => t
}, m1 = {
  ...Vu,
  transform: (t) => Xd(0, 1, t)
}, NT = {
  ...Vu,
  default: 1
}, T1 = (t) => Math.round(t * 1e5) / 1e5, PM = /(-)?([\d]*\.?[\d])+/g, Fb = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi, hUe = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function um(t) {
  return typeof t == "string";
}
const hm = (t) => ({
  test: (e) => um(e) && e.endsWith(t) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${t}`
}), ml = hm("deg"), Wo = hm("%"), Nt = hm("px"), NUe = hm("vh"), MUe = hm("vw"), Bz = {
  ...Wo,
  parse: (t) => Wo.parse(t) / 100,
  transform: (t) => Wo.transform(t * 100)
}, Az = {
  ...Vu,
  transform: Math.round
}, cC = {
  // Border props
  borderWidth: Nt,
  borderTopWidth: Nt,
  borderRightWidth: Nt,
  borderBottomWidth: Nt,
  borderLeftWidth: Nt,
  borderRadius: Nt,
  radius: Nt,
  borderTopLeftRadius: Nt,
  borderTopRightRadius: Nt,
  borderBottomRightRadius: Nt,
  borderBottomLeftRadius: Nt,
  // Positioning props
  width: Nt,
  maxWidth: Nt,
  height: Nt,
  maxHeight: Nt,
  size: Nt,
  top: Nt,
  right: Nt,
  bottom: Nt,
  left: Nt,
  // Spacing props
  padding: Nt,
  paddingTop: Nt,
  paddingRight: Nt,
  paddingBottom: Nt,
  paddingLeft: Nt,
  margin: Nt,
  marginTop: Nt,
  marginRight: Nt,
  marginBottom: Nt,
  marginLeft: Nt,
  // Transform props
  rotate: ml,
  rotateX: ml,
  rotateY: ml,
  rotateZ: ml,
  scale: NT,
  scaleX: NT,
  scaleY: NT,
  scaleZ: NT,
  skew: ml,
  skewX: ml,
  skewY: ml,
  distance: Nt,
  translateX: Nt,
  translateY: Nt,
  translateZ: Nt,
  x: Nt,
  y: Nt,
  z: Nt,
  perspective: Nt,
  transformPerspective: Nt,
  opacity: m1,
  originX: Bz,
  originY: Bz,
  originZ: Nt,
  // Misc
  zIndex: Az,
  // SVG
  fillOpacity: m1,
  strokeOpacity: m1,
  numOctaves: Az
};
function KS(t, e, n, r) {
  const { style: i, vars: a, transform: o, transformOrigin: s } = t;
  let l = !1, c = !1, d = !0;
  for (const u in e) {
    const h = e[u];
    if (lC(u)) {
      a[u] = h;
      continue;
    }
    const N = cC[u], M = uUe(h, N);
    if (fu.has(u)) {
      if (l = !0, o[u] = M, !d)
        continue;
      h !== (N.default || 0) && (d = !1);
    } else
      u.startsWith("origin") ? (c = !0, s[u] = M) : i[u] = M;
  }
  if (e.transform || (l || r ? i.transform = dUe(t.transform, n, d, r) : i.transform && (i.transform = "none")), c) {
    const { originX: u = "50%", originY: h = "50%", originZ: N = 0 } = s;
    i.transformOrigin = `${u} ${h} ${N}`;
  }
}
const $S = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function dC(t, e, n) {
  for (const r in e)
    !Oi(e[r]) && !oC(r, n) && (t[r] = e[r]);
}
function pUe({ transformTemplate: t }, e, n) {
  return vt(() => {
    const r = $S();
    return KS(r, e, { enableHardwareAcceleration: !n }, t), Object.assign({}, r.vars, r.style);
  }, [e]);
}
function mUe(t, e, n) {
  const r = t.style || {}, i = {};
  return dC(i, r, t), Object.assign(i, pUe(t, e, n)), t.transformValues ? t.transformValues(i) : i;
}
function TUe(t, e, n) {
  const r = {}, i = mUe(t, e, n);
  return t.drag && t.dragListener !== !1 && (r.draggable = !1, i.userSelect = i.WebkitUserSelect = i.WebkitTouchCallout = "none", i.touchAction = t.drag === !0 ? "none" : `pan-${t.drag === "x" ? "y" : "x"}`), t.tabIndex === void 0 && (t.onTap || t.onTapStart || t.whileTap) && (r.tabIndex = 0), r.style = i, r;
}
const fUe = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "onLayoutAnimationStart",
  "onLayoutAnimationComplete",
  "onLayoutMeasure",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "ignoreStrict",
  "viewport"
]);
function HV(t) {
  return t.startsWith("while") || t.startsWith("drag") && t !== "draggable" || t.startsWith("layout") || t.startsWith("onTap") || t.startsWith("onPan") || fUe.has(t);
}
let uC = (t) => !HV(t);
function VUe(t) {
  t && (uC = (e) => e.startsWith("on") ? !HV(e) : t(e));
}
try {
  VUe(require("@emotion/is-prop-valid").default);
} catch {
}
function UUe(t, e, n) {
  const r = {};
  for (const i in t)
    i === "values" && typeof t.values == "object" || (uC(i) || n === !0 && HV(i) || !e && !HV(i) || // If trying to use native HTML drag events, forward drag listeners
    t.draggable && i.startsWith("onDrag")) && (r[i] = t[i]);
  return r;
}
function Hz(t, e, n) {
  return typeof t == "string" ? t : Nt.transform(e + n * t);
}
function RUe(t, e, n) {
  const r = Hz(e, t.x, t.width), i = Hz(n, t.y, t.height);
  return `${r} ${i}`;
}
const gUe = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, yUe = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function ZUe(t, e, n = 1, r = 0, i = !0) {
  t.pathLength = 1;
  const a = i ? gUe : yUe;
  t[a.offset] = Nt.transform(-r);
  const o = Nt.transform(e), s = Nt.transform(n);
  t[a.array] = `${o} ${s}`;
}
function qS(t, {
  attrX: e,
  attrY: n,
  originX: r,
  originY: i,
  pathLength: a,
  pathSpacing: o = 1,
  pathOffset: s = 0,
  // This is object creation, which we try to avoid per-frame.
  ...l
}, c, d, u) {
  if (KS(t, l, c, u), d) {
    t.style.viewBox && (t.attrs.viewBox = t.style.viewBox);
    return;
  }
  t.attrs = t.style, t.style = {};
  const { attrs: h, style: N, dimensions: M } = t;
  h.transform && (M && (N.transform = h.transform), delete h.transform), M && (r !== void 0 || i !== void 0 || N.transform) && (N.transformOrigin = RUe(M, r !== void 0 ? r : 0.5, i !== void 0 ? i : 0.5)), e !== void 0 && (h.x = e), n !== void 0 && (h.y = n), a !== void 0 && ZUe(h, a, o, s, !1);
}
const hC = () => ({
  ...$S(),
  attrs: {}
}), ex = (t) => typeof t == "string" && t.toLowerCase() === "svg";
function bUe(t, e, n, r) {
  const i = vt(() => {
    const a = hC();
    return qS(a, e, { enableHardwareAcceleration: !1 }, ex(r), t.transformTemplate), {
      ...a.attrs,
      style: { ...a.style }
    };
  }, [e]);
  if (t.style) {
    const a = {};
    dC(a, t.style, t), i.style = { ...a, ...i.style };
  }
  return i;
}
function EUe(t = !1) {
  return (n, r, i, a, { latestValues: o }, s) => {
    const c = (PS(n) ? bUe : TUe)(r, o, s, n), u = {
      ...UUe(r, typeof n == "string", t),
      ...c,
      ref: a
    }, { children: h } = r, N = vt(() => Oi(h) ? h.get() : h, [h]);
    return i && (u["data-projection-id"] = i), ye(n, {
      ...u,
      children: N
    });
  };
}
const tx = (t) => t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
function NC(t, { style: e, vars: n }, r, i) {
  Object.assign(t.style, e, i && i.getProjectionStyles(r));
  for (const a in n)
    t.style.setProperty(a, n[a]);
}
const MC = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function pC(t, e, n, r) {
  NC(t, e, void 0, r);
  for (const i in e.attrs)
    t.setAttribute(MC.has(i) ? i : tx(i), e.attrs[i]);
}
function nx(t, e) {
  const { style: n } = t, r = {};
  for (const i in n)
    (Oi(n[i]) || e.style && Oi(e.style[i]) || oC(i, t)) && (r[i] = n[i]);
  return r;
}
function mC(t, e) {
  const n = nx(t, e);
  for (const r in t)
    if (Oi(t[r]) || Oi(e[r])) {
      const i = r === "x" || r === "y" ? "attr" + r.toUpperCase() : r;
      n[i] = t[r];
    }
  return n;
}
function rx(t, e, n, r = {}, i = {}) {
  return typeof e == "function" && (e = e(n !== void 0 ? n : t.custom, r, i)), typeof e == "string" && (e = t.variants && t.variants[e]), typeof e == "function" && (e = e(n !== void 0 ? n : t.custom, r, i)), e;
}
const XV = (t) => Array.isArray(t), SUe = (t) => !!(t && typeof t == "object" && t.mix && t.toValue), xUe = (t) => XV(t) ? t[t.length - 1] || 0 : t;
function cf(t) {
  const e = Oi(t) ? t.get() : t;
  return SUe(e) ? e.toValue() : e;
}
function WUe({ scrapeMotionValuesFromProps: t, createRenderState: e, onMount: n }, r, i, a) {
  const o = {
    latestValues: jUe(r, i, a, t),
    renderState: e()
  };
  return n && (o.mount = (s) => n(r, s, o)), o;
}
const TC = (t) => (e, n) => {
  const r = lt(QU), i = lt(dm), a = () => WUe(t, e, r, i);
  return n ? a() : XS(a);
};
function jUe(t, e, n, r) {
  const i = {}, a = r(t, {});
  for (const h in a)
    i[h] = cf(a[h]);
  let { initial: o, animate: s } = t;
  const l = LU(t), c = iC(t);
  e && c && !l && t.inherit !== !1 && (o === void 0 && (o = e.initial), s === void 0 && (s = e.animate));
  let d = n ? n.initial === !1 : !1;
  d = d || o === !1;
  const u = d ? s : o;
  return u && typeof u != "boolean" && !CU(u) && (Array.isArray(u) ? u : [u]).forEach((N) => {
    const M = rx(t, N);
    if (!M)
      return;
    const { transitionEnd: p, transition: m, ...R } = M;
    for (const V in R) {
      let U = R[V];
      if (Array.isArray(U)) {
        const g = d ? U.length - 1 : 0;
        U = U[g];
      }
      U !== null && (i[V] = U);
    }
    for (const V in p)
      i[V] = p[V];
  }), i;
}
const DUe = {
  useVisualState: TC({
    scrapeMotionValuesFromProps: mC,
    createRenderState: hC,
    onMount: (t, e, { renderState: n, latestValues: r }) => {
      try {
        n.dimensions = typeof e.getBBox == "function" ? e.getBBox() : e.getBoundingClientRect();
      } catch {
        n.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      qS(n, r, { enableHardwareAcceleration: !1 }, ex(e.tagName), t.transformTemplate), pC(e, n);
    }
  })
}, zUe = {
  useVisualState: TC({
    scrapeMotionValuesFromProps: nx,
    createRenderState: $S
  })
};
function kUe(t, { forwardMotionProps: e = !1 }, n, r) {
  return {
    ...PS(t) ? DUe : zUe,
    preloadedFeatures: n,
    useRender: EUe(e),
    createVisualElement: r,
    Component: t
  };
}
function Vs(t, e, n, r = { passive: !0 }) {
  return t.addEventListener(e, n, r), () => t.removeEventListener(e, n);
}
const fC = (t) => t.pointerType === "mouse" ? typeof t.button != "number" || t.button <= 0 : t.isPrimary !== !1;
function BU(t, e = "page") {
  return {
    point: {
      x: t[e + "X"],
      y: t[e + "Y"]
    }
  };
}
const wUe = (t) => (e) => fC(e) && t(e, BU(e));
function Ws(t, e, n, r) {
  return Vs(t, e, wUe(n), r);
}
const FUe = (t, e) => (n) => e(t(n)), Ll = (...t) => t.reduce(FUe);
function VC(t) {
  let e = null;
  return () => {
    const n = () => {
      e = null;
    };
    return e === null ? (e = t, n) : !1;
  };
}
const Xz = VC("dragHorizontal"), _z = VC("dragVertical");
function UC(t) {
  let e = !1;
  if (t === "y")
    e = _z();
  else if (t === "x")
    e = Xz();
  else {
    const n = Xz(), r = _z();
    n && r ? e = () => {
      n(), r();
    } : (n && n(), r && r());
  }
  return e;
}
function RC() {
  const t = UC(!0);
  return t ? (t(), !1) : !0;
}
class Dc {
  constructor(e) {
    this.isMounted = !1, this.node = e;
  }
  update() {
  }
}
function vUe(t) {
  let e = [], n = [], r = 0, i = !1, a = !1;
  const o = /* @__PURE__ */ new WeakSet(), s = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (l, c = !1, d = !1) => {
      const u = d && i, h = u ? e : n;
      return c && o.add(l), h.indexOf(l) === -1 && (h.push(l), u && i && (r = e.length)), l;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (l) => {
      const c = n.indexOf(l);
      c !== -1 && n.splice(c, 1), o.delete(l);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (l) => {
      if (i) {
        a = !0;
        return;
      }
      if (i = !0, [e, n] = [n, e], n.length = 0, r = e.length, r)
        for (let c = 0; c < r; c++) {
          const d = e[c];
          d(l), o.has(d) && (s.schedule(d), t());
        }
      i = !1, a && (a = !1, s.process(l));
    }
  };
  return s;
}
const qr = {
  delta: 0,
  timestamp: 0,
  isProcessing: !1
}, IUe = 40;
let vb = !0, KM = !1;
const Nm = [
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], AU = Nm.reduce((t, e) => (t[e] = vUe(() => KM = !0), t), {}), Ln = Nm.reduce((t, e) => {
  const n = AU[e];
  return t[e] = (r, i = !1, a = !1) => (KM || YUe(), n.schedule(r, i, a)), t;
}, {}), uc = Nm.reduce((t, e) => (t[e] = AU[e].cancel, t), {}), Hg = Nm.reduce((t, e) => (t[e] = () => AU[e].process(qr), t), {}), OUe = (t) => AU[t].process(qr), gC = (t) => {
  KM = !1, qr.delta = vb ? 1e3 / 60 : Math.max(Math.min(t - qr.timestamp, IUe), 1), qr.timestamp = t, qr.isProcessing = !0, Nm.forEach(OUe), qr.isProcessing = !1, KM && (vb = !1, requestAnimationFrame(gC));
}, YUe = () => {
  KM = !0, vb = !0, qr.isProcessing || requestAnimationFrame(gC);
};
function Pz(t, e) {
  const n = "pointer" + (e ? "enter" : "leave"), r = "onHover" + (e ? "Start" : "End"), i = (a, o) => {
    if (a.type === "touch" || RC())
      return;
    const s = t.getProps();
    t.animationState && s.whileHover && t.animationState.setActive("whileHover", e), s[r] && Ln.update(() => s[r](a, o));
  };
  return Ws(t.current, n, i, {
    passive: !t.getProps()[r]
  });
}
class QUe extends Dc {
  mount() {
    this.unmount = Ll(Pz(this.node, !0), Pz(this.node, !1));
  }
  unmount() {
  }
}
class GUe extends Dc {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let e = !1;
    try {
      e = this.node.current.matches(":focus-visible");
    } catch {
      e = !0;
    }
    !e || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = Ll(Vs(this.node.current, "focus", () => this.onFocus()), Vs(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const yC = (t, e) => e ? t === e ? !0 : yC(t, e.parentElement) : !1, Gr = (t) => t;
function Xg(t, e) {
  if (!e)
    return;
  const n = new PointerEvent("pointer" + t);
  e(n, BU(n));
}
class CUe extends Dc {
  constructor() {
    super(...arguments), this.removeStartListeners = Gr, this.removeEndListeners = Gr, this.removeAccessibleListeners = Gr, this.startPointerPress = (e, n) => {
      if (this.removeEndListeners(), this.isPressing)
        return;
      const r = this.node.getProps(), a = Ws(window, "pointerup", (s, l) => {
        if (!this.checkPressEnd())
          return;
        const { onTap: c, onTapCancel: d } = this.node.getProps();
        Ln.update(() => {
          yC(this.node.current, s.target) ? c && c(s, l) : d && d(s, l);
        });
      }, { passive: !(r.onTap || r.onPointerUp) }), o = Ws(window, "pointercancel", (s, l) => this.cancelPress(s, l), { passive: !(r.onTapCancel || r.onPointerCancel) });
      this.removeEndListeners = Ll(a, o), this.startPress(e, n);
    }, this.startAccessiblePress = () => {
      const e = (a) => {
        if (a.key !== "Enter" || this.isPressing)
          return;
        const o = (s) => {
          s.key !== "Enter" || !this.checkPressEnd() || Xg("up", (l, c) => {
            const { onTap: d } = this.node.getProps();
            d && Ln.update(() => d(l, c));
          });
        };
        this.removeEndListeners(), this.removeEndListeners = Vs(this.node.current, "keyup", o), Xg("down", (s, l) => {
          this.startPress(s, l);
        });
      }, n = Vs(this.node.current, "keydown", e), r = () => {
        this.isPressing && Xg("cancel", (a, o) => this.cancelPress(a, o));
      }, i = Vs(this.node.current, "blur", r);
      this.removeAccessibleListeners = Ll(n, i);
    };
  }
  startPress(e, n) {
    this.isPressing = !0;
    const { onTapStart: r, whileTap: i } = this.node.getProps();
    i && this.node.animationState && this.node.animationState.setActive("whileTap", !0), r && Ln.update(() => r(e, n));
  }
  checkPressEnd() {
    return this.removeEndListeners(), this.isPressing = !1, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !RC();
  }
  cancelPress(e, n) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel: r } = this.node.getProps();
    r && Ln.update(() => r(e, n));
  }
  mount() {
    const e = this.node.getProps(), n = Ws(this.node.current, "pointerdown", this.startPointerPress, { passive: !(e.onTapStart || e.onPointerStart) }), r = Vs(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = Ll(n, r);
  }
  unmount() {
    this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
  }
}
const Ib = /* @__PURE__ */ new WeakMap(), _g = /* @__PURE__ */ new WeakMap(), LUe = (t) => {
  const e = Ib.get(t.target);
  e && e(t);
}, JUe = (t) => {
  t.forEach(LUe);
};
function BUe({ root: t, ...e }) {
  const n = t || document;
  _g.has(n) || _g.set(n, {});
  const r = _g.get(n), i = JSON.stringify(e);
  return r[i] || (r[i] = new IntersectionObserver(JUe, { root: t, ...e })), r[i];
}
function AUe(t, e, n) {
  const r = BUe(e);
  return Ib.set(t, n), r.observe(t), () => {
    Ib.delete(t), r.unobserve(t);
  };
}
const HUe = {
  some: 0,
  all: 1
};
class XUe extends Dc {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: e = {} } = this.node.getProps(), { root: n, margin: r, amount: i = "some", once: a } = e, o = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof i == "number" ? i : HUe[i]
    }, s = (l) => {
      const { isIntersecting: c } = l;
      if (this.isInView === c || (this.isInView = c, a && !c && this.hasEnteredView))
        return;
      c && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", c);
      const { onViewportEnter: d, onViewportLeave: u } = this.node.getProps(), h = c ? d : u;
      h && h(l);
    };
    return AUe(this.node.current, o, s);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: e, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(_Ue(e, n)) && this.startObserver();
  }
  unmount() {
  }
}
function _Ue({ viewport: t = {} }, { viewport: e = {} } = {}) {
  return (n) => t[n] !== e[n];
}
const PUe = {
  inView: {
    Feature: XUe
  },
  tap: {
    Feature: CUe
  },
  focus: {
    Feature: GUe
  },
  hover: {
    Feature: QUe
  }
};
function ZC(t, e) {
  if (!Array.isArray(e))
    return !1;
  const n = e.length;
  if (n !== t.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function KUe(t) {
  const e = {};
  return t.values.forEach((n, r) => e[r] = n.get()), e;
}
function $Ue(t) {
  const e = {};
  return t.values.forEach((n, r) => e[r] = n.getVelocity()), e;
}
function HU(t, e, n) {
  const r = t.getProps();
  return rx(r, e, n !== void 0 ? n : r.custom, KUe(t), $Ue(t));
}
const qUe = "framerAppearId", eRe = "data-" + tx(qUe);
let Mm = Gr, Wa = Gr;
ue.env.NODE_ENV !== "production" && (Mm = (t, e) => {
  !t && typeof console < "u" && console.warn(e);
}, Wa = (t, e) => {
  if (!t)
    throw new Error(e);
});
const Jl = (t) => t * 1e3, _d = (t) => t / 1e3, tRe = {
  current: !1
};
function nRe(t) {
  return !t || // Default easing
  Array.isArray(t) || // Bezier curve
  typeof t == "string" && bC[t];
}
const PN = ([t, e, n, r]) => `cubic-bezier(${t}, ${e}, ${n}, ${r})`, bC = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: PN([0, 0.65, 0.55, 1]),
  circOut: PN([0.55, 0, 1, 0.45]),
  backIn: PN([0.31, 0.01, 0.66, -0.59]),
  backOut: PN([0.33, 1.53, 0.69, 0.99])
};
function rRe(t) {
  if (t)
    return Array.isArray(t) ? PN(t) : bC[t];
}
function iRe(t, e, n, { delay: r = 0, duration: i, repeat: a = 0, repeatType: o = "loop", ease: s, times: l } = {}) {
  const c = { [e]: n };
  return l && (c.offset = l), t.animate(c, {
    delay: r,
    duration: i,
    easing: rRe(s),
    fill: "both",
    iterations: a + 1,
    direction: o === "reverse" ? "alternate" : "normal"
  });
}
const Kz = {
  waapi: () => Object.hasOwnProperty.call(Element.prototype, "animate")
}, Pg = {}, EC = {};
for (const t in Kz)
  EC[t] = () => (Pg[t] === void 0 && (Pg[t] = Kz[t]()), Pg[t]);
function aRe(t, { repeat: e, repeatType: n = "loop" }) {
  const r = e && n !== "loop" && e % 2 === 1 ? 0 : t.length - 1;
  return t[r];
}
const SC = (t, e, n) => (((1 - 3 * n + 3 * e) * t + (3 * n - 6 * e)) * t + 3 * e) * t, oRe = 1e-7, sRe = 12;
function lRe(t, e, n, r, i) {
  let a, o, s = 0;
  do
    o = e + (n - e) / 2, a = SC(o, r, i) - t, a > 0 ? n = o : e = o;
  while (Math.abs(a) > oRe && ++s < sRe);
  return o;
}
function pm(t, e, n, r) {
  if (t === e && n === r)
    return Gr;
  const i = (a) => lRe(a, 0, 1, t, n);
  return (a) => a === 0 || a === 1 ? a : SC(i(a), e, r);
}
const cRe = pm(0.42, 0, 1, 1), dRe = pm(0, 0, 0.58, 1), xC = pm(0.42, 0, 0.58, 1), ix = (t, e) => (n) => !!(um(n) && hUe.test(n) && n.startsWith(t) || e && Object.prototype.hasOwnProperty.call(n, e)), WC = (t, e, n) => (r) => {
  if (!um(r))
    return r;
  const [i, a, o, s] = r.match(PM);
  return {
    [t]: parseFloat(i),
    [e]: parseFloat(a),
    [n]: parseFloat(o),
    alpha: s !== void 0 ? parseFloat(s) : 1
  };
}, uRe = (t) => Xd(0, 255, t), Kg = {
  ...Vu,
  transform: (t) => Math.round(uRe(t))
}, cd = {
  test: ix("rgb", "red"),
  parse: WC("red", "green", "blue"),
  transform: ({ red: t, green: e, blue: n, alpha: r = 1 }) => "rgba(" + Kg.transform(t) + ", " + Kg.transform(e) + ", " + Kg.transform(n) + ", " + T1(m1.transform(r)) + ")"
};
function hRe(t) {
  let e = "", n = "", r = "", i = "";
  return t.length > 5 ? (e = t.substring(1, 3), n = t.substring(3, 5), r = t.substring(5, 7), i = t.substring(7, 9)) : (e = t.substring(1, 2), n = t.substring(2, 3), r = t.substring(3, 4), i = t.substring(4, 5), e += e, n += n, r += r, i += i), {
    red: parseInt(e, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const Ob = {
  test: ix("#"),
  parse: hRe,
  transform: cd.transform
}, a0 = {
  test: ix("hsl", "hue"),
  parse: WC("hue", "saturation", "lightness"),
  transform: ({ hue: t, saturation: e, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(t) + ", " + Wo.transform(T1(e)) + ", " + Wo.transform(T1(n)) + ", " + T1(m1.transform(r)) + ")"
}, si = {
  test: (t) => cd.test(t) || Ob.test(t) || a0.test(t),
  parse: (t) => cd.test(t) ? cd.parse(t) : a0.test(t) ? a0.parse(t) : Ob.parse(t),
  transform: (t) => um(t) ? t : t.hasOwnProperty("red") ? cd.transform(t) : a0.transform(t)
}, _n = (t, e, n) => -n * t + n * e + t;
function $g(t, e, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + (e - t) * 6 * n : n < 1 / 2 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
}
function NRe({ hue: t, saturation: e, lightness: n, alpha: r }) {
  t /= 360, e /= 100, n /= 100;
  let i = 0, a = 0, o = 0;
  if (!e)
    i = a = o = n;
  else {
    const s = n < 0.5 ? n * (1 + e) : n + e - n * e, l = 2 * n - s;
    i = $g(l, s, t + 1 / 3), a = $g(l, s, t), o = $g(l, s, t - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(a * 255),
    blue: Math.round(o * 255),
    alpha: r
  };
}
const qg = (t, e, n) => {
  const r = t * t;
  return Math.sqrt(Math.max(0, n * (e * e - r) + r));
}, MRe = [Ob, cd, a0], pRe = (t) => MRe.find((e) => e.test(t));
function $z(t) {
  const e = pRe(t);
  Wa(!!e, `'${t}' is not an animatable color. Use the equivalent color code instead.`);
  let n = e.parse(t);
  return e === a0 && (n = NRe(n)), n;
}
const jC = (t, e) => {
  const n = $z(t), r = $z(e), i = { ...n };
  return (a) => (i.red = qg(n.red, r.red, a), i.green = qg(n.green, r.green, a), i.blue = qg(n.blue, r.blue, a), i.alpha = _n(n.alpha, r.alpha, a), cd.transform(i));
}, DC = "${c}", zC = "${n}";
function mRe(t) {
  var e, n;
  return isNaN(t) && um(t) && (((e = t.match(PM)) === null || e === void 0 ? void 0 : e.length) || 0) + (((n = t.match(Fb)) === null || n === void 0 ? void 0 : n.length) || 0) > 0;
}
function _V(t) {
  typeof t == "number" && (t = `${t}`);
  const e = [];
  let n = 0, r = 0;
  const i = t.match(Fb);
  i && (n = i.length, t = t.replace(Fb, DC), e.push(...i.map(si.parse)));
  const a = t.match(PM);
  return a && (r = a.length, t = t.replace(PM, zC), e.push(...a.map(Vu.parse))), { values: e, numColors: n, numNumbers: r, tokenised: t };
}
function kC(t) {
  return _V(t).values;
}
function wC(t) {
  const { values: e, numColors: n, tokenised: r } = _V(t), i = e.length;
  return (a) => {
    let o = r;
    for (let s = 0; s < i; s++)
      o = o.replace(s < n ? DC : zC, s < n ? si.transform(a[s]) : T1(a[s]));
    return o;
  };
}
const TRe = (t) => typeof t == "number" ? 0 : t;
function fRe(t) {
  const e = kC(t);
  return wC(t)(e.map(TRe));
}
const hc = { test: mRe, parse: kC, createTransformer: wC, getAnimatableNone: fRe };
function FC(t, e) {
  return typeof t == "number" ? (n) => _n(t, e, n) : si.test(t) ? jC(t, e) : IC(t, e);
}
const vC = (t, e) => {
  const n = [...t], r = n.length, i = t.map((a, o) => FC(a, e[o]));
  return (a) => {
    for (let o = 0; o < r; o++)
      n[o] = i[o](a);
    return n;
  };
}, VRe = (t, e) => {
  const n = { ...t, ...e }, r = {};
  for (const i in n)
    t[i] !== void 0 && e[i] !== void 0 && (r[i] = FC(t[i], e[i]));
  return (i) => {
    for (const a in r)
      n[a] = r[a](i);
    return n;
  };
}, IC = (t, e) => {
  const n = hc.createTransformer(e), r = _V(t), i = _V(e);
  return r.numColors === i.numColors && r.numNumbers >= i.numNumbers ? Ll(vC(r.values, i.values), n) : (Mm(!0, `Complex values '${t}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), (o) => `${o > 0 ? e : t}`);
}, $M = (t, e, n) => {
  const r = e - t;
  return r === 0 ? 1 : (n - t) / r;
}, qz = (t, e) => (n) => _n(t, e, n);
function URe(t) {
  return typeof t == "number" ? qz : typeof t == "string" ? si.test(t) ? jC : IC : Array.isArray(t) ? vC : typeof t == "object" ? VRe : qz;
}
function RRe(t, e, n) {
  const r = [], i = n || URe(t[0]), a = t.length - 1;
  for (let o = 0; o < a; o++) {
    let s = i(t[o], t[o + 1]);
    if (e) {
      const l = Array.isArray(e) ? e[o] : e;
      s = Ll(l, s);
    }
    r.push(s);
  }
  return r;
}
function OC(t, e, { clamp: n = !0, ease: r, mixer: i } = {}) {
  const a = t.length;
  if (Wa(a === e.length, "Both input and output ranges must be the same length"), Wa(!r || !Array.isArray(r) || r.length === a - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values."), a === 1)
    return () => e[0];
  t[0] > t[a - 1] && (t = [...t].reverse(), e = [...e].reverse());
  const o = RRe(e, r, i), s = o.length, l = (c) => {
    let d = 0;
    if (s > 1)
      for (; d < t.length - 2 && !(c < t[d + 1]); d++)
        ;
    const u = $M(t[d], t[d + 1], c);
    return o[d](u);
  };
  return n ? (c) => l(Xd(t[0], t[a - 1], c)) : l;
}
function gRe(t, e) {
  const n = t[t.length - 1];
  for (let r = 1; r <= e; r++) {
    const i = $M(0, e, r);
    t.push(_n(n, 1, i));
  }
}
function yRe(t) {
  const e = [0];
  return gRe(e, t.length - 1), e;
}
function ZRe(t, e) {
  return t.map((n) => n * e);
}
const YC = (t) => (e) => e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2, QC = (t) => (e) => 1 - t(1 - e), GC = (t) => 1 - Math.sin(Math.acos(t)), ax = QC(GC), bRe = YC(ax), CC = pm(0.33, 1.53, 0.69, 0.99), ox = QC(CC), ERe = YC(ox), SRe = (t) => (t *= 2) < 1 ? 0.5 * ox(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1))), e5 = {
  linear: Gr,
  easeIn: cRe,
  easeInOut: xC,
  easeOut: dRe,
  circIn: GC,
  circInOut: bRe,
  circOut: ax,
  backIn: ox,
  backInOut: ERe,
  backOut: CC,
  anticipate: SRe
}, t5 = (t) => {
  if (Array.isArray(t)) {
    Wa(t.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [e, n, r, i] = t;
    return pm(e, n, r, i);
  } else if (typeof t == "string")
    return Wa(e5[t] !== void 0, `Invalid easing type '${t}'`), e5[t];
  return t;
}, xRe = (t) => Array.isArray(t) && typeof t[0] != "number";
function WRe(t, e) {
  return t.map(() => e || xC).splice(0, t.length - 1);
}
function PV({ duration: t = 300, keyframes: e, times: n, ease: r = "easeInOut" }) {
  const i = xRe(r) ? r.map(t5) : t5(r), a = {
    done: !1,
    value: e[0]
  }, o = ZRe(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === e.length ? n : yRe(e),
    t
  ), s = OC(o, e, {
    ease: Array.isArray(i) ? i : WRe(e, i)
  });
  return {
    calculatedDuration: t,
    next: (l) => (a.value = s(l), a.done = l >= t, a)
  };
}
function LC(t, e) {
  return e ? t * (1e3 / e) : 0;
}
const jRe = 5;
function JC(t, e, n) {
  const r = Math.max(e - jRe, 0);
  return LC(n - t(r), e - r);
}
const ey = 1e-3, DRe = 0.01, n5 = 10, zRe = 0.05, kRe = 1;
function wRe({ duration: t = 800, bounce: e = 0.25, velocity: n = 0, mass: r = 1 }) {
  let i, a;
  Mm(t <= Jl(n5), "Spring duration must be 10 seconds or less");
  let o = 1 - e;
  o = Xd(zRe, kRe, o), t = Xd(DRe, n5, _d(t)), o < 1 ? (i = (c) => {
    const d = c * o, u = d * t, h = d - n, N = Yb(c, o), M = Math.exp(-u);
    return ey - h / N * M;
  }, a = (c) => {
    const u = c * o * t, h = u * n + n, N = Math.pow(o, 2) * Math.pow(c, 2) * t, M = Math.exp(-u), p = Yb(Math.pow(c, 2), o);
    return (-i(c) + ey > 0 ? -1 : 1) * ((h - N) * M) / p;
  }) : (i = (c) => {
    const d = Math.exp(-c * t), u = (c - n) * t + 1;
    return -ey + d * u;
  }, a = (c) => {
    const d = Math.exp(-c * t), u = (n - c) * (t * t);
    return d * u;
  });
  const s = 5 / t, l = vRe(i, a, s);
  if (t = Jl(t), isNaN(l))
    return {
      stiffness: 100,
      damping: 10,
      duration: t
    };
  {
    const c = Math.pow(l, 2) * r;
    return {
      stiffness: c,
      damping: o * 2 * Math.sqrt(r * c),
      duration: t
    };
  }
}
const FRe = 12;
function vRe(t, e, n) {
  let r = n;
  for (let i = 1; i < FRe; i++)
    r = r - t(r) / e(r);
  return r;
}
function Yb(t, e) {
  return t * Math.sqrt(1 - e * e);
}
const IRe = ["duration", "bounce"], ORe = ["stiffness", "damping", "mass"];
function r5(t, e) {
  return e.some((n) => t[n] !== void 0);
}
function YRe(t) {
  let e = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: !1,
    ...t
  };
  if (!r5(t, ORe) && r5(t, IRe)) {
    const n = wRe(t);
    e = {
      ...e,
      ...n,
      velocity: 0,
      mass: 1
    }, e.isResolvedFromDuration = !0;
  }
  return e;
}
function BC({ keyframes: t, restDelta: e, restSpeed: n, ...r }) {
  const i = t[0], a = t[t.length - 1], o = { done: !1, value: i }, { stiffness: s, damping: l, mass: c, velocity: d, duration: u, isResolvedFromDuration: h } = YRe(r), N = d ? -_d(d) : 0, M = l / (2 * Math.sqrt(s * c)), p = a - i, m = _d(Math.sqrt(s / c)), R = Math.abs(p) < 5;
  n || (n = R ? 0.01 : 2), e || (e = R ? 5e-3 : 0.5);
  let V;
  if (M < 1) {
    const U = Yb(m, M);
    V = (g) => {
      const y = Math.exp(-M * m * g);
      return a - y * ((N + M * m * p) / U * Math.sin(U * g) + p * Math.cos(U * g));
    };
  } else if (M === 1)
    V = (U) => a - Math.exp(-m * U) * (p + (N + m * p) * U);
  else {
    const U = m * Math.sqrt(M * M - 1);
    V = (g) => {
      const y = Math.exp(-M * m * g), x = Math.min(U * g, 300);
      return a - y * ((N + M * m * p) * Math.sinh(x) + U * p * Math.cosh(x)) / U;
    };
  }
  return {
    calculatedDuration: h && u || null,
    next: (U) => {
      const g = V(U);
      if (h)
        o.done = U >= u;
      else {
        let y = N;
        U !== 0 && (M < 1 ? y = JC(V, U, g) : y = 0);
        const x = Math.abs(y) <= n, f = Math.abs(a - g) <= e;
        o.done = x && f;
      }
      return o.value = o.done ? a : g, o;
    }
  };
}
function i5({ keyframes: t, velocity: e = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: i = 10, bounceStiffness: a = 500, modifyTarget: o, min: s, max: l, restDelta: c = 0.5, restSpeed: d }) {
  const u = t[0], h = {
    done: !1,
    value: u
  }, N = (D) => s !== void 0 && D < s || l !== void 0 && D > l, M = (D) => s === void 0 ? l : l === void 0 || Math.abs(s - D) < Math.abs(l - D) ? s : l;
  let p = n * e;
  const m = u + p, R = o === void 0 ? m : o(m);
  R !== m && (p = R - u);
  const V = (D) => -p * Math.exp(-D / r), U = (D) => R + V(D), g = (D) => {
    const Y = V(D), Q = U(D);
    h.done = Math.abs(Y) <= c, h.value = h.done ? R : Q;
  };
  let y, x;
  const f = (D) => {
    N(h.value) && (y = D, x = BC({
      keyframes: [h.value, M(h.value)],
      velocity: JC(U, D, h.value),
      damping: i,
      stiffness: a,
      restDelta: c,
      restSpeed: d
    }));
  };
  return f(0), {
    calculatedDuration: null,
    next: (D) => {
      let Y = !1;
      return !x && y === void 0 && (Y = !0, g(D), f(D)), y !== void 0 && D > y ? x.next(D - y) : (!Y && g(D), h);
    }
  };
}
const QRe = (t) => {
  const e = ({ timestamp: n }) => t(n);
  return {
    start: () => Ln.update(e, !0),
    stop: () => uc.update(e),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => qr.isProcessing ? qr.timestamp : performance.now()
  };
}, GRe = {
  decay: i5,
  inertia: i5,
  tween: PV,
  keyframes: PV,
  spring: BC
}, CRe = 2e4;
function LRe(t) {
  let e = 0;
  const n = 50;
  let r = t.next(e);
  for (; !r.done && e < CRe; )
    e += n, r = t.next(e);
  return e;
}
function KV({ autoplay: t = !0, delay: e = 0, driver: n = QRe, keyframes: r, type: i = "keyframes", repeat: a = 0, repeatDelay: o = 0, repeatType: s = "loop", onPlay: l, onStop: c, onComplete: d, onUpdate: u, ...h }) {
  let N = 1, M = !1, p, m;
  const R = () => {
    p && p(), m = new Promise((I) => {
      p = I;
    });
  };
  R();
  let V;
  const U = GRe[i] || PV;
  let g;
  U !== PV && typeof r[0] != "number" && (g = OC([0, 100], r, {
    clamp: !1
  }), r = [0, 100]);
  const y = U({ ...h, keyframes: r });
  let x;
  s === "mirror" && (x = U({
    ...h,
    keyframes: [...r].reverse(),
    velocity: -(h.velocity || 0)
  }));
  let f = "idle", D = null, Y = null, Q = null;
  y.calculatedDuration === null && a && (y.calculatedDuration = LRe(y));
  const { calculatedDuration: G } = y;
  let ne = 1 / 0, O = 1 / 0;
  G !== null && (ne = G + o, O = ne * (a + 1) - o);
  let T = 0;
  const Z = (I) => {
    if (Y === null)
      return;
    D !== null ? T = D : T = (I - Y) * N, T = Math.max(T - e, 0), f === "finished" && D === null && (T = O);
    let b = T, k = y;
    if (a) {
      const fe = T / ne;
      let de = Math.floor(fe), Me = fe % 1;
      !Me && fe >= 1 && (Me = 1), Me === 1 && de--, de = Math.min(de, a + 1);
      const je = !!(de % 2);
      je && (s === "reverse" ? (Me = 1 - Me, o && (Me -= o / ne)) : s === "mirror" && (k = x));
      let Se = Xd(0, 1, Me);
      T > O && (Se = s === "reverse" && je ? 1 : 0), b = Se * ne;
    }
    const ae = k.next(b);
    g && (ae.value = g(ae.value));
    let { done: oe } = ae;
    G !== null && (oe = T >= O);
    const le = D === null && (f === "finished" || f === "running" && oe || N < 0 && T <= 0);
    return u && u(ae.value), le && w(), ae;
  }, z = () => {
    V && V.stop(), V = void 0;
  }, j = () => {
    f = "idle", z(), R(), Y = Q = null;
  }, w = () => {
    f = "finished", d && d(), z(), R();
  }, C = () => {
    if (M)
      return;
    V || (V = n(Z));
    const I = V.now();
    l && l(), f = "running", D !== null ? Y = I - D : Y || (Y = I), Q = Y, D = null, V.start();
  };
  t && C();
  const J = {
    then(I, b) {
      return m.then(I, b);
    },
    get time() {
      return _d(T);
    },
    set time(I) {
      I = Jl(I), T = I, D !== null || !V || N === 0 ? D = I : Y = V.now() - I / N;
    },
    get speed() {
      return N;
    },
    set speed(I) {
      I === N || !V || (N = I, J.time = _d(T));
    },
    get state() {
      return f;
    },
    play: C,
    pause: () => {
      f = "paused", D = T;
    },
    stop: () => {
      M = !0, f !== "idle" && (f = "idle", c && c(), j());
    },
    cancel: () => {
      Q !== null && Z(Q), j();
    },
    complete: () => {
      f = "finished";
    },
    sample: (I) => (Y = 0, Z(I))
  };
  return J;
}
const JRe = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform",
  "backgroundColor"
]), MT = 10, BRe = 2e4, ARe = (t, e) => e.type === "spring" || t === "backgroundColor" || !nRe(e.ease);
function HRe(t, e, { onUpdate: n, onComplete: r, ...i }) {
  if (!(EC.waapi() && JRe.has(e) && !i.repeatDelay && i.repeatType !== "mirror" && i.damping !== 0 && i.type !== "inertia"))
    return !1;
  let o = !1, s, l;
  const c = () => {
    l = new Promise((p) => {
      s = p;
    });
  };
  c();
  let { keyframes: d, duration: u = 300, ease: h } = i;
  if (ARe(e, i)) {
    const p = KV({
      ...i,
      repeat: 0,
      delay: 0
    });
    let m = { done: !1, value: d[0] };
    const R = [];
    let V = 0;
    for (; !m.done && V < BRe; )
      m = p.sample(V), R.push(m.value), V += MT;
    d = R, u = V - MT, h = "linear";
  }
  const N = iRe(t.owner.current, e, d, {
    ...i,
    duration: u,
    /**
     * This function is currently not called if ease is provided
     * as a function so the cast is safe.
     *
     * However it would be possible for a future refinement to port
     * in easing pregeneration from Motion One for browsers that
     * support the upcoming `linear()` easing function.
     */
    ease: h
  }), M = () => {
    Ln.update(() => N.cancel()), s(), c();
  };
  return N.onfinish = () => {
    t.set(aRe(d, i)), r && r(), M();
  }, {
    then(p, m) {
      return l.then(p, m);
    },
    get time() {
      return _d(N.currentTime || 0);
    },
    set time(p) {
      N.currentTime = Jl(p);
    },
    get speed() {
      return N.playbackRate;
    },
    set speed(p) {
      N.playbackRate = p;
    },
    play: () => {
      o || N.play();
    },
    pause: () => N.pause(),
    stop: () => {
      if (o = !0, N.playState === "idle")
        return;
      const { currentTime: p } = N;
      if (p) {
        const m = KV({
          ...i,
          autoplay: !1
        });
        t.setWithVelocity(m.sample(p - MT).value, m.sample(p).value, MT);
      }
      M();
    },
    complete: () => N.finish(),
    cancel: M
  };
}
function XRe({ keyframes: t, delay: e, onUpdate: n, onComplete: r }) {
  const i = () => (n && n(t[t.length - 1]), r && r(), {
    time: 0,
    speed: 1,
    play: Gr,
    pause: Gr,
    stop: Gr,
    then: (a) => (a(), Promise.resolve()),
    cancel: Gr,
    complete: Gr
  });
  return e ? KV({
    keyframes: [0, 1],
    duration: e,
    onComplete: i
  }) : i();
}
const _Re = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, PRe = (t) => ({
  type: "spring",
  stiffness: 550,
  damping: t === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), KRe = {
  type: "keyframes",
  duration: 0.8
}, $Re = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, qRe = (t, { keyframes: e }) => e.length > 2 ? KRe : fu.has(t) ? t.startsWith("scale") ? PRe(e[1]) : _Re : $Re, Qb = (t, e) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
hc.test(e) && // And it contains numbers and/or colors
!e.startsWith("url(")), ege = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function tge(t) {
  const [e, n] = t.slice(0, -1).split("(");
  if (e === "drop-shadow")
    return t;
  const [r] = n.match(PM) || [];
  if (!r)
    return t;
  const i = n.replace(r, "");
  let a = ege.has(e) ? 1 : 0;
  return r !== n && (a *= 100), e + "(" + a + i + ")";
}
const nge = /([a-z-]*)\(.*?\)/g, Gb = {
  ...hc,
  getAnimatableNone: (t) => {
    const e = t.match(nge);
    return e ? e.map(tge).join(" ") : t;
  }
}, rge = {
  ...cC,
  // Color props
  color: si,
  backgroundColor: si,
  outlineColor: si,
  fill: si,
  stroke: si,
  // Border props
  borderColor: si,
  borderTopColor: si,
  borderRightColor: si,
  borderBottomColor: si,
  borderLeftColor: si,
  filter: Gb,
  WebkitFilter: Gb
}, sx = (t) => rge[t];
function lx(t, e) {
  let n = sx(t);
  return n !== Gb && (n = hc), n.getAnimatableNone ? n.getAnimatableNone(e) : void 0;
}
function ige({ when: t, delay: e, delayChildren: n, staggerChildren: r, staggerDirection: i, repeat: a, repeatType: o, repeatDelay: s, from: l, elapsed: c, ...d }) {
  return !!Object.keys(d).length;
}
function a5(t) {
  return t === 0 || typeof t == "string" && parseFloat(t) === 0 && t.indexOf(" ") === -1;
}
function o5(t) {
  return typeof t == "number" ? 0 : lx("", t);
}
function AC(t, e) {
  return t[e] || t.default || t;
}
function age(t, e, n, r) {
  const i = Qb(e, n);
  let a = r.from !== void 0 ? r.from : t.get();
  return a === "none" && i && typeof n == "string" ? a = lx(e, n) : a5(a) && typeof n == "string" ? a = o5(n) : !Array.isArray(n) && a5(n) && typeof a == "string" && (n = o5(a)), Array.isArray(n) ? (n[0] === null && (n[0] = a), n) : [a, n];
}
const cx = (t, e, n, r = {}) => (i) => {
  const a = AC(r, t) || {}, o = a.delay || r.delay || 0;
  let { elapsed: s = 0 } = r;
  s = s - Jl(o);
  const l = age(e, t, n, a), c = l[0], d = l[l.length - 1], u = Qb(t, c), h = Qb(t, d);
  Mm(u === h, `You are trying to animate ${t} from "${c}" to "${d}". ${c} is not an animatable value - to enable this animation set ${c} to a value animatable to ${d} via the \`style\` property.`);
  let N = {
    keyframes: l,
    velocity: e.getVelocity(),
    ease: "easeOut",
    ...a,
    delay: -s,
    onUpdate: (M) => {
      e.set(M), a.onUpdate && a.onUpdate(M);
    },
    onComplete: () => {
      i(), a.onComplete && a.onComplete();
    }
  };
  if (!u || !h || tRe.current || a.type === !1)
    return XRe(N);
  if (ige(a) || (N = {
    ...N,
    ...qRe(t, N)
  }), N.duration && (N.duration = Jl(N.duration)), N.repeatDelay && (N.repeatDelay = Jl(N.repeatDelay)), e.owner && e.owner.current instanceof HTMLElement && !e.owner.getProps().onUpdate) {
    const M = HRe(e, t, N);
    if (M)
      return M;
  }
  return KV(N);
};
function $V(t) {
  return !!(Oi(t) && t.add);
}
const oge = (t) => /^\-?\d*\.?\d+$/.test(t), sge = (t) => /^0[^.\s]+$/.test(t);
function dx(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function ux(t, e) {
  const n = t.indexOf(e);
  n > -1 && t.splice(n, 1);
}
class hx {
  constructor() {
    this.subscriptions = [];
  }
  add(e) {
    return dx(this.subscriptions, e), () => ux(this.subscriptions, e);
  }
  notify(e, n, r) {
    const i = this.subscriptions.length;
    if (i)
      if (i === 1)
        this.subscriptions[0](e, n, r);
      else
        for (let a = 0; a < i; a++) {
          const o = this.subscriptions[a];
          o && o(e, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const s5 = /* @__PURE__ */ new Set();
function Nx(t, e, n) {
  t || s5.has(e) || (console.warn(e), n && console.warn(n), s5.add(e));
}
const lge = (t) => !isNaN(parseFloat(t));
class cge {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(e, n = {}) {
    this.version = "10.8.4", this.timeDelta = 0, this.lastUpdated = 0, this.canTrackVelocity = !1, this.events = {}, this.updateAndNotify = (r, i = !0) => {
      this.prev = this.current, this.current = r;
      const { delta: a, timestamp: o } = qr;
      this.lastUpdated !== o && (this.timeDelta = a, this.lastUpdated = o, Ln.postRender(this.scheduleVelocityCheck)), this.prev !== this.current && this.events.change && this.events.change.notify(this.current), this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()), i && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.scheduleVelocityCheck = () => Ln.postRender(this.velocityCheck), this.velocityCheck = ({ timestamp: r }) => {
      r !== this.lastUpdated && (this.prev = this.current, this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()));
    }, this.hasAnimated = !1, this.prev = this.current = e, this.canTrackVelocity = lge(this.current), this.owner = n.owner;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(e) {
    return ue.env.NODE_ENV !== "production" && Nx(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", e);
  }
  on(e, n) {
    this.events[e] || (this.events[e] = new hx());
    const r = this.events[e].add(n);
    return e === "change" ? () => {
      r(), Ln.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const e in this.events)
      this.events[e].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(e, n) {
    this.passiveEffect = e, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(e, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(e, n) : this.passiveEffect(e, this.updateAndNotify);
  }
  setWithVelocity(e, n, r) {
    this.set(n), this.prev = e, this.timeDelta = r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(e) {
    this.updateAndNotify(e), this.prev = e, this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    return this.canTrackVelocity ? (
      // These casts could be avoided if parseFloat would be typed better
      LC(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
    ) : 0;
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(e) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = e(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Sh(t, e) {
  return new cge(t, e);
}
const HC = (t) => (e) => e.test(t), dge = {
  test: (t) => t === "auto",
  parse: (t) => t
}, XC = [Vu, Nt, Wo, ml, MUe, NUe, dge], kN = (t) => XC.find(HC(t)), uge = [...XC, si, hc], hge = (t) => uge.find(HC(t));
function Nge(t, e, n) {
  t.hasValue(e) ? t.getValue(e).set(n) : t.addValue(e, Sh(n));
}
function Mge(t, e) {
  const n = HU(t, e);
  let { transitionEnd: r = {}, transition: i = {}, ...a } = n ? t.makeTargetAnimatable(n, !1) : {};
  a = { ...a, ...r };
  for (const o in a) {
    const s = xUe(a[o]);
    Nge(t, o, s);
  }
}
function pge(t, e, n) {
  var r, i;
  const a = Object.keys(e).filter((s) => !t.hasValue(s)), o = a.length;
  if (o)
    for (let s = 0; s < o; s++) {
      const l = a[s], c = e[l];
      let d = null;
      Array.isArray(c) && (d = c[0]), d === null && (d = (i = (r = n[l]) !== null && r !== void 0 ? r : t.readValue(l)) !== null && i !== void 0 ? i : e[l]), d != null && (typeof d == "string" && (oge(d) || sge(d)) ? d = parseFloat(d) : !hge(d) && hc.test(c) && (d = lx(l, c)), t.addValue(l, Sh(d, { owner: t })), n[l] === void 0 && (n[l] = d), d !== null && t.setBaseTarget(l, d));
    }
}
function mge(t, e) {
  return e ? (e[t] || e.default || e).from : void 0;
}
function Tge(t, e, n) {
  const r = {};
  for (const i in t) {
    const a = mge(i, e);
    if (a !== void 0)
      r[i] = a;
    else {
      const o = n.getValue(i);
      o && (r[i] = o.get());
    }
  }
  return r;
}
function fge({ protectedKeys: t, needsAnimating: e }, n) {
  const r = t.hasOwnProperty(n) && e[n] !== !0;
  return e[n] = !1, r;
}
function _C(t, e, { delay: n = 0, transitionOverride: r, type: i } = {}) {
  let { transition: a = t.getDefaultTransition(), transitionEnd: o, ...s } = t.makeTargetAnimatable(e);
  const l = t.getValue("willChange");
  r && (a = r);
  const c = [], d = i && t.animationState && t.animationState.getState()[i];
  for (const u in s) {
    const h = t.getValue(u), N = s[u];
    if (!h || N === void 0 || d && fge(d, u))
      continue;
    const M = { delay: n, elapsed: 0, ...a };
    if (window.HandoffAppearAnimations && !h.hasAnimated) {
      const m = t.getProps()[eRe];
      m && (M.elapsed = window.HandoffAppearAnimations(m, u, h, Ln));
    }
    h.start(cx(u, h, N, t.shouldReduceMotion && fu.has(u) ? { type: !1 } : M));
    const p = h.animation;
    $V(l) && (l.add(u), p.then(() => l.remove(u))), c.push(p);
  }
  return o && Promise.all(c).then(() => {
    o && Mge(t, o);
  }), c;
}
function Cb(t, e, n = {}) {
  const r = HU(t, e, n.custom);
  let { transition: i = t.getDefaultTransition() || {} } = r || {};
  n.transitionOverride && (i = n.transitionOverride);
  const a = r ? () => Promise.all(_C(t, r, n)) : () => Promise.resolve(), o = t.variantChildren && t.variantChildren.size ? (l = 0) => {
    const { delayChildren: c = 0, staggerChildren: d, staggerDirection: u } = i;
    return Vge(t, e, c + l, d, u, n);
  } : () => Promise.resolve(), { when: s } = i;
  if (s) {
    const [l, c] = s === "beforeChildren" ? [a, o] : [o, a];
    return l().then(() => c());
  } else
    return Promise.all([a(), o(n.delay)]);
}
function Vge(t, e, n = 0, r = 0, i = 1, a) {
  const o = [], s = (t.variantChildren.size - 1) * r, l = i === 1 ? (c = 0) => c * r : (c = 0) => s - c * r;
  return Array.from(t.variantChildren).sort(Uge).forEach((c, d) => {
    c.notify("AnimationStart", e), o.push(Cb(c, e, {
      ...a,
      delay: n + l(d)
    }).then(() => c.notify("AnimationComplete", e)));
  }), Promise.all(o);
}
function Uge(t, e) {
  return t.sortNodePosition(e);
}
function Rge(t, e, n = {}) {
  t.notify("AnimationStart", e);
  let r;
  if (Array.isArray(e)) {
    const i = e.map((a) => Cb(t, a, n));
    r = Promise.all(i);
  } else if (typeof e == "string")
    r = Cb(t, e, n);
  else {
    const i = typeof e == "function" ? HU(t, e, n.custom) : e;
    r = Promise.all(_C(t, i, n));
  }
  return r.then(() => t.notify("AnimationComplete", e));
}
const gge = [...AS].reverse(), yge = AS.length;
function Zge(t) {
  return (e) => Promise.all(e.map(({ animation: n, options: r }) => Rge(t, n, r)));
}
function bge(t) {
  let e = Zge(t);
  const n = Sge();
  let r = !0;
  const i = (l, c) => {
    const d = HU(t, c);
    if (d) {
      const { transition: u, transitionEnd: h, ...N } = d;
      l = { ...l, ...N, ...h };
    }
    return l;
  };
  function a(l) {
    e = l(t);
  }
  function o(l, c) {
    const d = t.getProps(), u = t.getVariantContext(!0) || {}, h = [], N = /* @__PURE__ */ new Set();
    let M = {}, p = 1 / 0;
    for (let R = 0; R < yge; R++) {
      const V = gge[R], U = n[V], g = d[V] !== void 0 ? d[V] : u[V], y = XM(g), x = V === c ? U.isActive : null;
      x === !1 && (p = R);
      let f = g === u[V] && g !== d[V] && y;
      if (f && r && t.manuallyAnimateOnMount && (f = !1), U.protectedKeys = { ...M }, // If it isn't active and hasn't *just* been set as inactive
      !U.isActive && x === null || // If we didn't and don't have any defined prop for this animation type
      !g && !U.prevProp || // Or if the prop doesn't define an animation
      CU(g) || typeof g == "boolean")
        continue;
      const D = Ege(U.prevProp, g);
      let Y = D || // If we're making this variant active, we want to always make it active
      V === c && U.isActive && !f && y || // If we removed a higher-priority variant (i is in reverse order)
      R > p && y;
      const Q = Array.isArray(g) ? g : [g];
      let G = Q.reduce(i, {});
      x === !1 && (G = {});
      const { prevResolvedValues: ne = {} } = U, O = {
        ...ne,
        ...G
      }, T = (Z) => {
        Y = !0, N.delete(Z), U.needsAnimating[Z] = !0;
      };
      for (const Z in O) {
        const z = G[Z], j = ne[Z];
        M.hasOwnProperty(Z) || (z !== j ? XV(z) && XV(j) ? !ZC(z, j) || D ? T(Z) : U.protectedKeys[Z] = !0 : z !== void 0 ? T(Z) : N.add(Z) : z !== void 0 && N.has(Z) ? T(Z) : U.protectedKeys[Z] = !0);
      }
      U.prevProp = g, U.prevResolvedValues = G, U.isActive && (M = { ...M, ...G }), r && t.blockInitialAnimation && (Y = !1), Y && !f && h.push(...Q.map((Z) => ({
        animation: Z,
        options: { type: V, ...l }
      })));
    }
    if (N.size) {
      const R = {};
      N.forEach((V) => {
        const U = t.getBaseTarget(V);
        U !== void 0 && (R[V] = U);
      }), h.push({ animation: R });
    }
    let m = !!h.length;
    return r && d.initial === !1 && !t.manuallyAnimateOnMount && (m = !1), r = !1, m ? e(h) : Promise.resolve();
  }
  function s(l, c, d) {
    var u;
    if (n[l].isActive === c)
      return Promise.resolve();
    (u = t.variantChildren) === null || u === void 0 || u.forEach((N) => {
      var M;
      return (M = N.animationState) === null || M === void 0 ? void 0 : M.setActive(l, c);
    }), n[l].isActive = c;
    const h = o(d, l);
    for (const N in n)
      n[N].protectedKeys = {};
    return h;
  }
  return {
    animateChanges: o,
    setActive: s,
    setAnimateFunction: a,
    getState: () => n
  };
}
function Ege(t, e) {
  return typeof e == "string" ? e !== t : Array.isArray(e) ? !ZC(e, t) : !1;
}
function Xc(t = !1) {
  return {
    isActive: t,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function Sge() {
  return {
    animate: Xc(!0),
    whileInView: Xc(),
    whileHover: Xc(),
    whileTap: Xc(),
    whileDrag: Xc(),
    whileFocus: Xc(),
    exit: Xc()
  };
}
class xge extends Dc {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(e) {
    super(e), e.animationState || (e.animationState = bge(e));
  }
  updateAnimationControlsSubscription() {
    const { animate: e } = this.node.getProps();
    this.unmount(), CU(e) && (this.unmount = e.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: e } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    e !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
  }
}
let Wge = 0;
class jge extends Dc {
  constructor() {
    super(...arguments), this.id = Wge++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: e, onExitComplete: n, custom: r } = this.node.presenceContext, { isPresent: i } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || e === i)
      return;
    const a = this.node.animationState.setActive("exit", !e, { custom: r ?? this.node.getProps().custom });
    n && !e && a.then(() => n(this.id));
  }
  mount() {
    const { register: e } = this.node.presenceContext || {};
    e && (this.unmount = e(this.id));
  }
  unmount() {
  }
}
const Dge = {
  animation: {
    Feature: xge
  },
  exit: {
    Feature: jge
  }
}, l5 = (t, e) => Math.abs(t - e);
function zge(t, e) {
  const n = l5(t.x, e.x), r = l5(t.y, e.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
class PC {
  constructor(e, n, { transformPagePoint: r } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const c = ny(this.lastMoveEventInfo, this.history), d = this.startEvent !== null, u = zge(c.offset, { x: 0, y: 0 }) >= 3;
      if (!d && !u)
        return;
      const { point: h } = c, { timestamp: N } = qr;
      this.history.push({ ...h, timestamp: N });
      const { onStart: M, onMove: p } = this.handlers;
      d || (M && M(this.lastMoveEvent, c), this.startEvent = this.lastMoveEvent), p && p(this.lastMoveEvent, c);
    }, this.handlePointerMove = (c, d) => {
      this.lastMoveEvent = c, this.lastMoveEventInfo = ty(d, this.transformPagePoint), Ln.update(this.updatePoint, !0);
    }, this.handlePointerUp = (c, d) => {
      if (this.end(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const { onEnd: u, onSessionEnd: h } = this.handlers, N = ny(c.type === "pointercancel" ? this.lastMoveEventInfo : ty(d, this.transformPagePoint), this.history);
      this.startEvent && u && u(c, N), h && h(c, N);
    }, !fC(e))
      return;
    this.handlers = n, this.transformPagePoint = r;
    const i = BU(e), a = ty(i, this.transformPagePoint), { point: o } = a, { timestamp: s } = qr;
    this.history = [{ ...o, timestamp: s }];
    const { onSessionStart: l } = n;
    l && l(e, ny(a, this.history)), this.removeListeners = Ll(Ws(window, "pointermove", this.handlePointerMove), Ws(window, "pointerup", this.handlePointerUp), Ws(window, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(e) {
    this.handlers = e;
  }
  end() {
    this.removeListeners && this.removeListeners(), uc.update(this.updatePoint);
  }
}
function ty(t, e) {
  return e ? { point: e(t.point) } : t;
}
function c5(t, e) {
  return { x: t.x - e.x, y: t.y - e.y };
}
function ny({ point: t }, e) {
  return {
    point: t,
    delta: c5(t, KC(e)),
    offset: c5(t, kge(e)),
    velocity: wge(e, 0.1)
  };
}
function kge(t) {
  return t[0];
}
function KC(t) {
  return t[t.length - 1];
}
function wge(t, e) {
  if (t.length < 2)
    return { x: 0, y: 0 };
  let n = t.length - 1, r = null;
  const i = KC(t);
  for (; n >= 0 && (r = t[n], !(i.timestamp - r.timestamp > Jl(e))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  const a = _d(i.timestamp - r.timestamp);
  if (a === 0)
    return { x: 0, y: 0 };
  const o = {
    x: (i.x - r.x) / a,
    y: (i.y - r.y) / a
  };
  return o.x === 1 / 0 && (o.x = 0), o.y === 1 / 0 && (o.y = 0), o;
}
function ra(t) {
  return t.max - t.min;
}
function Lb(t, e = 0, n = 0.01) {
  return Math.abs(t - e) <= n;
}
function d5(t, e, n, r = 0.5) {
  t.origin = r, t.originPoint = _n(e.min, e.max, t.origin), t.scale = ra(n) / ra(e), (Lb(t.scale, 1, 1e-4) || isNaN(t.scale)) && (t.scale = 1), t.translate = _n(n.min, n.max, t.origin) - t.originPoint, (Lb(t.translate) || isNaN(t.translate)) && (t.translate = 0);
}
function f1(t, e, n, r) {
  d5(t.x, e.x, n.x, r ? r.originX : void 0), d5(t.y, e.y, n.y, r ? r.originY : void 0);
}
function u5(t, e, n) {
  t.min = n.min + e.min, t.max = t.min + ra(e);
}
function Fge(t, e, n) {
  u5(t.x, e.x, n.x), u5(t.y, e.y, n.y);
}
function h5(t, e, n) {
  t.min = e.min - n.min, t.max = t.min + ra(e);
}
function V1(t, e, n) {
  h5(t.x, e.x, n.x), h5(t.y, e.y, n.y);
}
function vge(t, { min: e, max: n }, r) {
  return e !== void 0 && t < e ? t = r ? _n(e, t, r.min) : Math.max(t, e) : n !== void 0 && t > n && (t = r ? _n(n, t, r.max) : Math.min(t, n)), t;
}
function N5(t, e, n) {
  return {
    min: e !== void 0 ? t.min + e : void 0,
    max: n !== void 0 ? t.max + n - (t.max - t.min) : void 0
  };
}
function Ige(t, { top: e, left: n, bottom: r, right: i }) {
  return {
    x: N5(t.x, n, i),
    y: N5(t.y, e, r)
  };
}
function M5(t, e) {
  let n = e.min - t.min, r = e.max - t.max;
  return e.max - e.min < t.max - t.min && ([n, r] = [r, n]), { min: n, max: r };
}
function Oge(t, e) {
  return {
    x: M5(t.x, e.x),
    y: M5(t.y, e.y)
  };
}
function Yge(t, e) {
  let n = 0.5;
  const r = ra(t), i = ra(e);
  return i > r ? n = $M(e.min, e.max - r, t.min) : r > i && (n = $M(t.min, t.max - i, e.min)), Xd(0, 1, n);
}
function Qge(t, e) {
  const n = {};
  return e.min !== void 0 && (n.min = e.min - t.min), e.max !== void 0 && (n.max = e.max - t.min), n;
}
const Jb = 0.35;
function Gge(t = Jb) {
  return t === !1 ? t = 0 : t === !0 && (t = Jb), {
    x: p5(t, "left", "right"),
    y: p5(t, "top", "bottom")
  };
}
function p5(t, e, n) {
  return {
    min: m5(t, e),
    max: m5(t, n)
  };
}
function m5(t, e) {
  return typeof t == "number" ? t : t[e] || 0;
}
const T5 = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), U1 = () => ({
  x: T5(),
  y: T5()
}), f5 = () => ({ min: 0, max: 0 }), ur = () => ({
  x: f5(),
  y: f5()
});
function ho(t) {
  return [t("x"), t("y")];
}
function $C({ top: t, left: e, right: n, bottom: r }) {
  return {
    x: { min: e, max: n },
    y: { min: t, max: r }
  };
}
function Cge({ x: t, y: e }) {
  return { top: e.min, right: t.max, bottom: e.max, left: t.min };
}
function Lge(t, e) {
  if (!e)
    return t;
  const n = e({ x: t.left, y: t.top }), r = e({ x: t.right, y: t.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function ry(t) {
  return t === void 0 || t === 1;
}
function Bb({ scale: t, scaleX: e, scaleY: n }) {
  return !ry(t) || !ry(e) || !ry(n);
}
function Kc(t) {
  return Bb(t) || qC(t) || t.z || t.rotate || t.rotateX || t.rotateY;
}
function qC(t) {
  return V5(t.x) || V5(t.y);
}
function V5(t) {
  return t && t !== "0%";
}
function qV(t, e, n) {
  const r = t - n, i = e * r;
  return n + i;
}
function U5(t, e, n, r, i) {
  return i !== void 0 && (t = qV(t, i, r)), qV(t, n, r) + e;
}
function Ab(t, e = 0, n = 1, r, i) {
  t.min = U5(t.min, e, n, r, i), t.max = U5(t.max, e, n, r, i);
}
function e9(t, { x: e, y: n }) {
  Ab(t.x, e.translate, e.scale, e.originPoint), Ab(t.y, n.translate, n.scale, n.originPoint);
}
function Jge(t, e, n, r = !1) {
  const i = n.length;
  if (!i)
    return;
  e.x = e.y = 1;
  let a, o;
  for (let s = 0; s < i; s++) {
    a = n[s], o = a.projectionDelta;
    const l = a.instance;
    l && l.style && l.style.display === "contents" || (r && a.options.layoutScroll && a.scroll && a !== a.root && o0(t, {
      x: -a.scroll.offset.x,
      y: -a.scroll.offset.y
    }), o && (e.x *= o.x.scale, e.y *= o.y.scale, e9(t, o)), r && Kc(a.latestValues) && o0(t, a.latestValues));
  }
  e.x = R5(e.x), e.y = R5(e.y);
}
function R5(t) {
  return Number.isInteger(t) || t > 1.0000000000001 || t < 0.999999999999 ? t : 1;
}
function Vl(t, e) {
  t.min = t.min + e, t.max = t.max + e;
}
function g5(t, e, [n, r, i]) {
  const a = e[i] !== void 0 ? e[i] : 0.5, o = _n(t.min, t.max, a);
  Ab(t, e[n], e[r], o, e.scale);
}
const Bge = ["x", "scaleX", "originX"], Age = ["y", "scaleY", "originY"];
function o0(t, e) {
  g5(t.x, e, Bge), g5(t.y, e, Age);
}
function t9(t, e) {
  return $C(Lge(t.getBoundingClientRect(), e));
}
function Hge(t, e, n) {
  const r = t9(t, n), { scroll: i } = e;
  return i && (Vl(r.x, i.offset.x), Vl(r.y, i.offset.y)), r;
}
const Xge = /* @__PURE__ */ new WeakMap();
class _ge {
  constructor(e) {
    this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = ur(), this.visualElement = e;
  }
  start(e, { snapToCursor: n = !1 } = {}) {
    const { presenceContext: r } = this.visualElement;
    if (r && r.isPresent === !1)
      return;
    const i = (l) => {
      this.stopAnimation(), n && this.snapToCursor(BU(l, "page").point);
    }, a = (l, c) => {
      const { drag: d, dragPropagation: u, onDragStart: h } = this.getProps();
      if (d && !u && (this.openGlobalLock && this.openGlobalLock(), this.openGlobalLock = UC(d), !this.openGlobalLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), ho((M) => {
        let p = this.getAxisMotionValue(M).get() || 0;
        if (Wo.test(p)) {
          const { projection: m } = this.visualElement;
          if (m && m.layout) {
            const R = m.layout.layoutBox[M];
            R && (p = ra(R) * (parseFloat(p) / 100));
          }
        }
        this.originPoint[M] = p;
      }), h && Ln.update(() => h(l, c));
      const { animationState: N } = this.visualElement;
      N && N.setActive("whileDrag", !0);
    }, o = (l, c) => {
      const { dragPropagation: d, dragDirectionLock: u, onDirectionLock: h, onDrag: N } = this.getProps();
      if (!d && !this.openGlobalLock)
        return;
      const { offset: M } = c;
      if (u && this.currentDirection === null) {
        this.currentDirection = Pge(M), this.currentDirection !== null && h && h(this.currentDirection);
        return;
      }
      this.updateAxis("x", c.point, M), this.updateAxis("y", c.point, M), this.visualElement.render(), N && N(l, c);
    }, s = (l, c) => this.stop(l, c);
    this.panSession = new PC(e, {
      onSessionStart: i,
      onStart: a,
      onMove: o,
      onSessionEnd: s
    }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
  }
  stop(e, n) {
    const r = this.isDragging;
    if (this.cancel(), !r)
      return;
    const { velocity: i } = n;
    this.startAnimation(i);
    const { onDragEnd: a } = this.getProps();
    a && Ln.update(() => a(e, n));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: e, animationState: n } = this.visualElement;
    e && (e.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: r } = this.getProps();
    !r && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(e, n, r) {
    const { drag: i } = this.getProps();
    if (!r || !pT(e, i, this.currentDirection))
      return;
    const a = this.getAxisMotionValue(e);
    let o = this.originPoint[e] + r[e];
    this.constraints && this.constraints[e] && (o = vge(o, this.constraints[e], this.elastic[e])), a.set(o);
  }
  resolveConstraints() {
    const { dragConstraints: e, dragElastic: n } = this.getProps(), { layout: r } = this.visualElement.projection || {}, i = this.constraints;
    e && i0(e) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : e && r ? this.constraints = Ige(r.layoutBox, e) : this.constraints = !1, this.elastic = Gge(n), i !== this.constraints && r && this.constraints && !this.hasMutatedConstraints && ho((a) => {
      this.getAxisMotionValue(a) && (this.constraints[a] = Qge(r.layoutBox[a], this.constraints[a]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: e, onMeasureDragConstraints: n } = this.getProps();
    if (!e || !i0(e))
      return !1;
    const r = e.current;
    Wa(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: i } = this.visualElement;
    if (!i || !i.layout)
      return !1;
    const a = Hge(r, i.root, this.visualElement.getTransformPagePoint());
    let o = Oge(i.layout.layoutBox, a);
    if (n) {
      const s = n(Cge(o));
      this.hasMutatedConstraints = !!s, s && (o = $C(s));
    }
    return o;
  }
  startAnimation(e) {
    const { drag: n, dragMomentum: r, dragElastic: i, dragTransition: a, dragSnapToOrigin: o, onDragTransitionEnd: s } = this.getProps(), l = this.constraints || {}, c = ho((d) => {
      if (!pT(d, n, this.currentDirection))
        return;
      let u = l && l[d] || {};
      o && (u = { min: 0, max: 0 });
      const h = i ? 200 : 1e6, N = i ? 40 : 1e7, M = {
        type: "inertia",
        velocity: r ? e[d] : 0,
        bounceStiffness: h,
        bounceDamping: N,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...a,
        ...u
      };
      return this.startAxisValueAnimation(d, M);
    });
    return Promise.all(c).then(s);
  }
  startAxisValueAnimation(e, n) {
    const r = this.getAxisMotionValue(e);
    return r.start(cx(e, r, 0, n));
  }
  stopAnimation() {
    ho((e) => this.getAxisMotionValue(e).stop());
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(e) {
    const n = "_drag" + e.toUpperCase(), r = this.visualElement.getProps(), i = r[n];
    return i || this.visualElement.getValue(e, (r.initial ? r.initial[e] : void 0) || 0);
  }
  snapToCursor(e) {
    ho((n) => {
      const { drag: r } = this.getProps();
      if (!pT(n, r, this.currentDirection))
        return;
      const { projection: i } = this.visualElement, a = this.getAxisMotionValue(n);
      if (i && i.layout) {
        const { min: o, max: s } = i.layout.layoutBox[n];
        a.set(e[n] - _n(o, s, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: e, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!i0(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const i = { x: 0, y: 0 };
    ho((o) => {
      const s = this.getAxisMotionValue(o);
      if (s) {
        const l = s.get();
        i[o] = Yge({ min: l, max: l }, this.constraints[o]);
      }
    });
    const { transformTemplate: a } = this.visualElement.getProps();
    this.visualElement.current.style.transform = a ? a({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), ho((o) => {
      if (!pT(o, e, null))
        return;
      const s = this.getAxisMotionValue(o), { min: l, max: c } = this.constraints[o];
      s.set(_n(l, c, i[o]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    Xge.set(this.visualElement, this);
    const e = this.visualElement.current, n = Ws(e, "pointerdown", (l) => {
      const { drag: c, dragListener: d = !0 } = this.getProps();
      c && d && this.start(l);
    }), r = () => {
      const { dragConstraints: l } = this.getProps();
      i0(l) && (this.constraints = this.resolveRefConstraints());
    }, { projection: i } = this.visualElement, a = i.addEventListener("measure", r);
    i && !i.layout && (i.root && i.root.updateScroll(), i.updateLayout()), r();
    const o = Vs(window, "resize", () => this.scalePositionWithinConstraints()), s = i.addEventListener("didUpdate", ({ delta: l, hasLayoutChanged: c }) => {
      this.isDragging && c && (ho((d) => {
        const u = this.getAxisMotionValue(d);
        u && (this.originPoint[d] += l[d].translate, u.set(u.get() + l[d].translate));
      }), this.visualElement.render());
    });
    return () => {
      o(), n(), a(), s && s();
    };
  }
  getProps() {
    const e = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: i = !1, dragConstraints: a = !1, dragElastic: o = Jb, dragMomentum: s = !0 } = e;
    return {
      ...e,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: i,
      dragConstraints: a,
      dragElastic: o,
      dragMomentum: s
    };
  }
}
function pT(t, e, n) {
  return (e === !0 || e === t) && (n === null || n === t);
}
function Pge(t, e = 10) {
  let n = null;
  return Math.abs(t.y) > e ? n = "y" : Math.abs(t.x) > e && (n = "x"), n;
}
class Kge extends Dc {
  constructor(e) {
    super(e), this.removeGroupControls = Gr, this.removeListeners = Gr, this.controls = new _ge(e);
  }
  mount() {
    const { dragControls: e } = this.node.getProps();
    e && (this.removeGroupControls = e.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Gr;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const y5 = (t) => (e, n) => {
  t && Ln.update(() => t(e, n));
};
class $ge extends Dc {
  constructor() {
    super(...arguments), this.removePointerDownListener = Gr;
  }
  onPointerDown(e) {
    this.session = new PC(e, this.createPanHandlers(), { transformPagePoint: this.node.getTransformPagePoint() });
  }
  createPanHandlers() {
    const { onPanSessionStart: e, onPanStart: n, onPan: r, onPanEnd: i } = this.node.getProps();
    return {
      onSessionStart: y5(e),
      onStart: y5(n),
      onMove: r,
      onEnd: (a, o) => {
        delete this.session, i && Ln.update(() => i(a, o));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Ws(this.node.current, "pointerdown", (e) => this.onPointerDown(e));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
function qge() {
  const t = lt(dm);
  if (t === null)
    return [!0, null];
  const { isPresent: e, onExitComplete: n, register: r } = t, i = nu();
  return Ee(() => r(i), []), !e && n ? [!1, () => n && n(i)] : [!0];
}
function eye() {
  return tye(lt(dm));
}
function tye(t) {
  return t === null ? !0 : t.isPresent;
}
function Z5(t, e) {
  return e.max === e.min ? 0 : t / (e.max - e.min) * 100;
}
const wN = {
  correct: (t, e) => {
    if (!e.target)
      return t;
    if (typeof t == "string")
      if (Nt.test(t))
        t = parseFloat(t);
      else
        return t;
    const n = Z5(t, e.target.x), r = Z5(t, e.target.y);
    return `${n}% ${r}%`;
  }
}, n9 = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function nye(t) {
  const e = n9.exec(t);
  if (!e)
    return [,];
  const [, n, r] = e;
  return [n, r];
}
const rye = 4;
function Hb(t, e, n = 1) {
  Wa(n <= rye, `Max CSS variable fallback depth detected in property "${t}". This may indicate a circular fallback dependency.`);
  const [r, i] = nye(t);
  if (!r)
    return;
  const a = window.getComputedStyle(e).getPropertyValue(r);
  return a ? a.trim() : wb(i) ? Hb(i, e, n + 1) : i;
}
function iye(t, { ...e }, n) {
  const r = t.current;
  if (!(r instanceof Element))
    return { target: e, transitionEnd: n };
  n && (n = { ...n }), t.values.forEach((i) => {
    const a = i.get();
    if (!wb(a))
      return;
    const o = Hb(a, r);
    o && i.set(o);
  });
  for (const i in e) {
    const a = e[i];
    if (!wb(a))
      continue;
    const o = Hb(a, r);
    o && (e[i] = o, n || (n = {}), n[i] === void 0 && (n[i] = a));
  }
  return { target: e, transitionEnd: n };
}
const b5 = "_$css", aye = {
  correct: (t, { treeScale: e, projectionDelta: n }) => {
    const r = t, i = t.includes("var("), a = [];
    i && (t = t.replace(n9, (N) => (a.push(N), b5)));
    const o = hc.parse(t);
    if (o.length > 5)
      return r;
    const s = hc.createTransformer(t), l = typeof o[0] != "number" ? 1 : 0, c = n.x.scale * e.x, d = n.y.scale * e.y;
    o[0 + l] /= c, o[1 + l] /= d;
    const u = _n(c, d, 0.5);
    typeof o[2 + l] == "number" && (o[2 + l] /= u), typeof o[3 + l] == "number" && (o[3 + l] /= u);
    let h = s(o);
    if (i) {
      let N = 0;
      h = h.replace(b5, () => {
        const M = a[N];
        return N++, M;
      });
    }
    return h;
  }
};
class oye extends rr.Component {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: e, layoutGroup: n, switchLayoutGroup: r, layoutId: i } = this.props, { projection: a } = e;
    sUe(sye), a && (n.group && n.group.add(a), r && r.register && i && r.register(a), a.root.didUpdate(), a.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), a.setOptions({
      ...a.options,
      onExitComplete: () => this.safeToRemove()
    })), p1.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(e) {
    const { layoutDependency: n, visualElement: r, drag: i, isPresent: a } = this.props, o = r.projection;
    return o && (o.isPresent = a, i || e.layoutDependency !== n || n === void 0 ? o.willUpdate() : this.safeToRemove(), e.isPresent !== a && (a ? o.promote() : o.relegate() || Ln.postRender(() => {
      const s = o.getStack();
      (!s || !s.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: e } = this.props.visualElement;
    e && (e.root.didUpdate(), !e.currentAnimation && e.isLead() && this.safeToRemove());
  }
  componentWillUnmount() {
    const { visualElement: e, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: i } = e;
    i && (i.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(i), r && r.deregister && r.deregister(i));
  }
  safeToRemove() {
    const { safeToRemove: e } = this.props;
    e && e();
  }
  render() {
    return null;
  }
}
function r9(t) {
  const [e, n] = qge(), r = lt(_S);
  return rr.createElement(oye, { ...t, layoutGroup: r, switchLayoutGroup: lt(aC), isPresent: e, safeToRemove: n });
}
const sye = {
  borderRadius: {
    ...wN,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: wN,
  borderTopRightRadius: wN,
  borderBottomLeftRadius: wN,
  borderBottomRightRadius: wN,
  boxShadow: aye
}, i9 = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], lye = i9.length, E5 = (t) => typeof t == "string" ? parseFloat(t) : t, S5 = (t) => typeof t == "number" || Nt.test(t);
function cye(t, e, n, r, i, a) {
  i ? (t.opacity = _n(
    0,
    // TODO Reinstate this if only child
    n.opacity !== void 0 ? n.opacity : 1,
    dye(r)
  ), t.opacityExit = _n(e.opacity !== void 0 ? e.opacity : 1, 0, uye(r))) : a && (t.opacity = _n(e.opacity !== void 0 ? e.opacity : 1, n.opacity !== void 0 ? n.opacity : 1, r));
  for (let o = 0; o < lye; o++) {
    const s = `border${i9[o]}Radius`;
    let l = x5(e, s), c = x5(n, s);
    if (l === void 0 && c === void 0)
      continue;
    l || (l = 0), c || (c = 0), l === 0 || c === 0 || S5(l) === S5(c) ? (t[s] = Math.max(_n(E5(l), E5(c), r), 0), (Wo.test(c) || Wo.test(l)) && (t[s] += "%")) : t[s] = c;
  }
  (e.rotate || n.rotate) && (t.rotate = _n(e.rotate || 0, n.rotate || 0, r));
}
function x5(t, e) {
  return t[e] !== void 0 ? t[e] : t.borderRadius;
}
const dye = a9(0, 0.5, ax), uye = a9(0.5, 0.95, Gr);
function a9(t, e, n) {
  return (r) => r < t ? 0 : r > e ? 1 : n($M(t, e, r));
}
function W5(t, e) {
  t.min = e.min, t.max = e.max;
}
function ha(t, e) {
  W5(t.x, e.x), W5(t.y, e.y);
}
function j5(t, e, n, r, i) {
  return t -= e, t = qV(t, 1 / n, r), i !== void 0 && (t = qV(t, 1 / i, r)), t;
}
function hye(t, e = 0, n = 1, r = 0.5, i, a = t, o = t) {
  if (Wo.test(e) && (e = parseFloat(e), e = _n(o.min, o.max, e / 100) - o.min), typeof e != "number")
    return;
  let s = _n(a.min, a.max, r);
  t === a && (s -= e), t.min = j5(t.min, e, n, s, i), t.max = j5(t.max, e, n, s, i);
}
function D5(t, e, [n, r, i], a, o) {
  hye(t, e[n], e[r], e[i], e.scale, a, o);
}
const Nye = ["x", "scaleX", "originX"], Mye = ["y", "scaleY", "originY"];
function z5(t, e, n, r) {
  D5(t.x, e, Nye, n ? n.x : void 0, r ? r.x : void 0), D5(t.y, e, Mye, n ? n.y : void 0, r ? r.y : void 0);
}
function k5(t) {
  return t.translate === 0 && t.scale === 1;
}
function o9(t) {
  return k5(t.x) && k5(t.y);
}
function Xb(t, e) {
  return t.x.min === e.x.min && t.x.max === e.x.max && t.y.min === e.y.min && t.y.max === e.y.max;
}
function w5(t) {
  return ra(t.x) / ra(t.y);
}
class pye {
  constructor() {
    this.members = [];
  }
  add(e) {
    dx(this.members, e), e.scheduleRender();
  }
  remove(e) {
    if (ux(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(e) {
    const n = this.members.findIndex((i) => e === i);
    if (n === 0)
      return !1;
    let r;
    for (let i = n; i >= 0; i--) {
      const a = this.members[i];
      if (a.isPresent !== !1) {
        r = a;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(e, n) {
    const r = this.lead;
    if (e !== r && (this.prevLead = r, this.lead = e, e.show(), r)) {
      r.instance && r.scheduleRender(), e.scheduleRender(), e.resumeFrom = r, n && (e.resumeFrom.preserveOpacity = !0), r.snapshot && (e.snapshot = r.snapshot, e.snapshot.latestValues = r.animationValues || r.latestValues), e.root && e.root.isUpdating && (e.isLayoutDirty = !0);
      const { crossfade: i } = e.options;
      i === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((e) => {
      const { options: n, resumingFrom: r } = e;
      n.onExitComplete && n.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((e) => {
      e.instance && e.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function F5(t, e, n) {
  let r = "";
  const i = t.x.translate / e.x, a = t.y.translate / e.y;
  if ((i || a) && (r = `translate3d(${i}px, ${a}px, 0) `), (e.x !== 1 || e.y !== 1) && (r += `scale(${1 / e.x}, ${1 / e.y}) `), n) {
    const { rotate: l, rotateX: c, rotateY: d } = n;
    l && (r += `rotate(${l}deg) `), c && (r += `rotateX(${c}deg) `), d && (r += `rotateY(${d}deg) `);
  }
  const o = t.x.scale * e.x, s = t.y.scale * e.y;
  return (o !== 1 || s !== 1) && (r += `scale(${o}, ${s})`), r || "none";
}
const mye = (t, e) => t.depth - e.depth;
class Tye {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(e) {
    dx(this.children, e), this.isDirty = !0;
  }
  remove(e) {
    ux(this.children, e), this.isDirty = !0;
  }
  forEach(e) {
    this.isDirty && this.children.sort(mye), this.isDirty = !1, this.children.forEach(e);
  }
}
function fye(t, e) {
  const n = performance.now(), r = ({ timestamp: i }) => {
    const a = i - n;
    a >= e && (uc.read(r), t(a - e));
  };
  return Ln.read(r, !0), () => uc.read(r);
}
function Vye(t) {
  window.MotionDebug && window.MotionDebug.record(t);
}
function Uye(t) {
  return t instanceof SVGElement && t.tagName !== "svg";
}
function Rye(t, e, n) {
  const r = Oi(t) ? t : Sh(t);
  return r.start(cx("", r, e, n)), r.animation;
}
const v5 = ["", "X", "Y", "Z"], I5 = 1e3;
let gye = 0;
const $c = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
};
function s9({ attachResizeListener: t, defaultParent: e, measureScroll: n, checkIsScrollRoot: r, resetTransform: i }) {
  return class {
    constructor(o, s = {}, l = e == null ? void 0 : e()) {
      this.id = gye++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.potentialNodes = /* @__PURE__ */ new Map(), this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        $c.totalNodes = $c.resolvedTargetDeltas = $c.recalculatedProjection = 0, this.nodes.forEach(bye), this.nodes.forEach(Wye), this.nodes.forEach(jye), this.nodes.forEach(Eye), Vye($c);
      }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.elementId = o, this.latestValues = s, this.root = l ? l.root || l : this, this.path = l ? [...l.path, l] : [], this.parent = l, this.depth = l ? l.depth + 1 : 0, o && this.root.registerPotentialNode(o, this);
      for (let c = 0; c < this.path.length; c++)
        this.path[c].shouldResetTransform = !0;
      this.root === this && (this.nodes = new Tye());
    }
    addEventListener(o, s) {
      return this.eventHandlers.has(o) || this.eventHandlers.set(o, new hx()), this.eventHandlers.get(o).add(s);
    }
    notifyListeners(o, ...s) {
      const l = this.eventHandlers.get(o);
      l && l.notify(...s);
    }
    hasListeners(o) {
      return this.eventHandlers.has(o);
    }
    registerPotentialNode(o, s) {
      this.potentialNodes.set(o, s);
    }
    /**
     * Lifecycles
     */
    mount(o, s = !1) {
      if (this.instance)
        return;
      this.isSVG = Uye(o), this.instance = o;
      const { layoutId: l, layout: c, visualElement: d } = this.options;
      if (d && !d.current && d.mount(o), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.elementId && this.root.potentialNodes.delete(this.elementId), s && (c || l) && (this.isLayoutDirty = !0), t) {
        let u;
        const h = () => this.root.updateBlockedByResize = !1;
        t(o, () => {
          this.root.updateBlockedByResize = !0, u && u(), u = fye(h, 250), p1.hasAnimatedSinceResize && (p1.hasAnimatedSinceResize = !1, this.nodes.forEach(Y5));
        });
      }
      l && this.root.registerSharedNode(l, this), this.options.animate !== !1 && d && (l || c) && this.addEventListener("didUpdate", ({ delta: u, hasLayoutChanged: h, hasRelativeTargetChanged: N, layout: M }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const p = this.options.transition || d.getDefaultTransition() || Fye, { onLayoutAnimationStart: m, onLayoutAnimationComplete: R } = d.getProps(), V = !this.targetLayout || !Xb(this.targetLayout, M) || N, U = !h && N;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || U || h && (V || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(u, U);
          const g = {
            ...AC(p, "layout"),
            onPlay: m,
            onComplete: R
          };
          (d.shouldReduceMotion || this.options.layoutRoot) && (g.delay = 0, g.type = !1), this.startAnimation(g);
        } else
          !h && this.animationProgress === 0 && Y5(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = M;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const o = this.getStack();
      o && o.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, uc.preRender(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(Dye), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: o } = this.options;
      return o && o.getProps().transformTemplate;
    }
    willUpdate(o = !0) {
      if (this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (!this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let d = 0; d < this.path.length; d++) {
        const u = this.path[d];
        u.shouldResetTransform = !0, u.updateScroll("snapshot"), u.options.layoutRoot && u.willUpdate(!1);
      }
      const { layoutId: s, layout: l } = this.options;
      if (s === void 0 && !l)
        return;
      const c = this.getTransformTemplate();
      this.prevTransformTemplateValue = c ? c(this.latestValues, "") : void 0, this.updateSnapshot(), o && this.notifyListeners("willUpdate");
    }
    // Note: Currently only running on root node
    didUpdate() {
      if (this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(O5);
        return;
      }
      this.isUpdating && (this.isUpdating = !1, this.potentialNodes.size && (this.potentialNodes.forEach(vye), this.potentialNodes.clear()), this.nodes.forEach(xye), this.nodes.forEach(yye), this.nodes.forEach(Zye), this.clearAllSnapshots(), Hg.update(), Hg.preRender(), Hg.render());
    }
    clearAllSnapshots() {
      this.nodes.forEach(Sye), this.sharedNodes.forEach(zye);
    }
    scheduleUpdateProjection() {
      Ln.preRender(this.updateProjection, !1, !0);
    }
    scheduleCheckAfterUnmount() {
      Ln.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let l = 0; l < this.path.length; l++)
          this.path[l].updateScroll();
      const o = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = ur(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: s } = this.options;
      s && s.notify("LayoutMeasure", this.layout.layoutBox, o ? o.layoutBox : void 0);
    }
    updateScroll(o = "measure") {
      let s = !!(this.options.layoutScroll && this.instance);
      this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === o && (s = !1), s && (this.scroll = {
        animationId: this.root.animationId,
        phase: o,
        isRoot: r(this.instance),
        offset: n(this.instance)
      });
    }
    resetTransform() {
      if (!i)
        return;
      const o = this.isLayoutDirty || this.shouldResetTransform, s = this.projectionDelta && !o9(this.projectionDelta), l = this.getTransformTemplate(), c = l ? l(this.latestValues, "") : void 0, d = c !== this.prevTransformTemplateValue;
      o && (s || Kc(this.latestValues) || d) && (i(this.instance, c), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(o = !0) {
      const s = this.measurePageBox();
      let l = this.removeElementScroll(s);
      return o && (l = this.removeTransform(l)), Iye(l), {
        animationId: this.root.animationId,
        measuredBox: s,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement: o } = this.options;
      if (!o)
        return ur();
      const s = o.measureViewportBox(), { scroll: l } = this.root;
      return l && (Vl(s.x, l.offset.x), Vl(s.y, l.offset.y)), s;
    }
    removeElementScroll(o) {
      const s = ur();
      ha(s, o);
      for (let l = 0; l < this.path.length; l++) {
        const c = this.path[l], { scroll: d, options: u } = c;
        if (c !== this.root && d && u.layoutScroll) {
          if (d.isRoot) {
            ha(s, o);
            const { scroll: h } = this.root;
            h && (Vl(s.x, -h.offset.x), Vl(s.y, -h.offset.y));
          }
          Vl(s.x, d.offset.x), Vl(s.y, d.offset.y);
        }
      }
      return s;
    }
    applyTransform(o, s = !1) {
      const l = ur();
      ha(l, o);
      for (let c = 0; c < this.path.length; c++) {
        const d = this.path[c];
        !s && d.options.layoutScroll && d.scroll && d !== d.root && o0(l, {
          x: -d.scroll.offset.x,
          y: -d.scroll.offset.y
        }), Kc(d.latestValues) && o0(l, d.latestValues);
      }
      return Kc(this.latestValues) && o0(l, this.latestValues), l;
    }
    removeTransform(o) {
      const s = ur();
      ha(s, o);
      for (let l = 0; l < this.path.length; l++) {
        const c = this.path[l];
        if (!c.instance || !Kc(c.latestValues))
          continue;
        Bb(c.latestValues) && c.updateSnapshot();
        const d = ur(), u = c.measurePageBox();
        ha(d, u), z5(s, c.latestValues, c.snapshot ? c.snapshot.layoutBox : void 0, d);
      }
      return Kc(this.latestValues) && z5(s, this.latestValues), s;
    }
    setTargetDelta(o) {
      this.targetDelta = o, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(o) {
      this.options = {
        ...this.options,
        ...o,
        crossfade: o.crossfade !== void 0 ? o.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    resolveTargetDelta(o = !1) {
      var s;
      const l = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = l.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = l.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = l.isSharedProjectionDirty);
      const c = !!this.resumingFrom || this !== l;
      if (!(o || c && this.isSharedProjectionDirty || this.isProjectionDirty || !((s = this.parent) === null || s === void 0) && s.isProjectionDirty || this.attemptToResolveRelativeTarget))
        return;
      const { layout: u, layoutId: h } = this.options;
      if (!(!this.layout || !(u || h))) {
        if (this.resolvedRelativeTargetAt = qr.timestamp, !this.targetDelta && !this.relativeTarget) {
          const N = this.getClosestProjectingParent();
          N && N.layout ? (this.relativeParent = N, this.relativeTarget = ur(), this.relativeTargetOrigin = ur(), V1(this.relativeTargetOrigin, this.layout.layoutBox, N.layout.layoutBox), ha(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = ur(), this.targetWithTransforms = ur()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.relativeParent.resolvedRelativeTargetAt !== qr.timestamp && this.relativeParent.resolveTargetDelta(!0), Fge(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : ha(this.target, this.layout.layoutBox), e9(this.target, this.targetDelta)) : ha(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const N = this.getClosestProjectingParent();
            N && !!N.resumingFrom == !!this.resumingFrom && !N.options.layoutScroll && N.target ? (this.relativeParent = N, this.relativeTarget = ur(), this.relativeTargetOrigin = ur(), V1(this.relativeTargetOrigin, this.target, N.target), ha(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          $c.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Bb(this.parent.latestValues) || qC(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var o;
      const s = this.getLead(), l = !!this.resumingFrom || this !== s;
      let c = !0;
      if ((this.isProjectionDirty || !((o = this.parent) === null || o === void 0) && o.isProjectionDirty) && (c = !1), l && (this.isSharedProjectionDirty || this.isTransformDirty) && (c = !1), this.resolvedRelativeTargetAt === qr.timestamp && (c = !1), c)
        return;
      const { layout: d, layoutId: u } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(d || u))
        return;
      ha(this.layoutCorrected, this.layout.layoutBox), Jge(this.layoutCorrected, this.treeScale, this.path, l);
      const { target: h } = s;
      if (!h)
        return;
      this.projectionDelta || (this.projectionDelta = U1(), this.projectionDeltaWithTransform = U1());
      const N = this.treeScale.x, M = this.treeScale.y, p = this.projectionTransform;
      f1(this.projectionDelta, this.layoutCorrected, h, this.latestValues), this.projectionTransform = F5(this.projectionDelta, this.treeScale), (this.projectionTransform !== p || this.treeScale.x !== N || this.treeScale.y !== M) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", h)), $c.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(o = !0) {
      if (this.options.scheduleRender && this.options.scheduleRender(), o) {
        const s = this.getStack();
        s && s.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    setAnimationOrigin(o, s = !1) {
      const l = this.snapshot, c = l ? l.latestValues : {}, d = { ...this.latestValues }, u = U1();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !s;
      const h = ur(), N = l ? l.source : void 0, M = this.layout ? this.layout.source : void 0, p = N !== M, m = this.getStack(), R = !m || m.members.length <= 1, V = !!(p && !R && this.options.crossfade === !0 && !this.path.some(wye));
      this.animationProgress = 0;
      let U;
      this.mixTargetDelta = (g) => {
        const y = g / 1e3;
        Q5(u.x, o.x, y), Q5(u.y, o.y, y), this.setTargetDelta(u), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (V1(h, this.layout.layoutBox, this.relativeParent.layout.layoutBox), kye(this.relativeTarget, this.relativeTargetOrigin, h, y), U && Xb(this.relativeTarget, U) && (this.isProjectionDirty = !1), U || (U = ur()), ha(U, this.relativeTarget)), p && (this.animationValues = d, cye(d, c, this.latestValues, y, V, R)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = y;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(o) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (uc.update(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = Ln.update(() => {
        p1.hasAnimatedSinceResize = !0, this.currentAnimation = Rye(0, I5, {
          ...o,
          // keyframes: [0, animationTarget],÷
          onUpdate: (s) => {
            this.mixTargetDelta(s), o.onUpdate && o.onUpdate(s);
          },
          onComplete: () => {
            o.onComplete && o.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const o = this.getStack();
      o && o.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(I5), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const o = this.getLead();
      let { targetWithTransforms: s, target: l, layout: c, latestValues: d } = o;
      if (!(!s || !l || !c)) {
        if (this !== o && this.layout && c && l9(this.options.animationType, this.layout.layoutBox, c.layoutBox)) {
          l = this.target || ur();
          const u = ra(this.layout.layoutBox.x);
          l.x.min = o.target.x.min, l.x.max = l.x.min + u;
          const h = ra(this.layout.layoutBox.y);
          l.y.min = o.target.y.min, l.y.max = l.y.min + h;
        }
        ha(s, l), o0(s, d), f1(this.projectionDeltaWithTransform, this.layoutCorrected, s, d);
      }
    }
    registerSharedNode(o, s) {
      this.sharedNodes.has(o) || this.sharedNodes.set(o, new pye()), this.sharedNodes.get(o).add(s);
      const c = s.options.initialPromotionConfig;
      s.promote({
        transition: c ? c.transition : void 0,
        preserveFollowOpacity: c && c.shouldPreserveFollowOpacity ? c.shouldPreserveFollowOpacity(s) : void 0
      });
    }
    isLead() {
      const o = this.getStack();
      return o ? o.lead === this : !0;
    }
    getLead() {
      var o;
      const { layoutId: s } = this.options;
      return s ? ((o = this.getStack()) === null || o === void 0 ? void 0 : o.lead) || this : this;
    }
    getPrevLead() {
      var o;
      const { layoutId: s } = this.options;
      return s ? (o = this.getStack()) === null || o === void 0 ? void 0 : o.prevLead : void 0;
    }
    getStack() {
      const { layoutId: o } = this.options;
      if (o)
        return this.root.sharedNodes.get(o);
    }
    promote({ needsReset: o, transition: s, preserveFollowOpacity: l } = {}) {
      const c = this.getStack();
      c && c.promote(this, l), o && (this.projectionDelta = void 0, this.needsReset = !0), s && this.setOptions({ transition: s });
    }
    relegate() {
      const o = this.getStack();
      return o ? o.relegate(this) : !1;
    }
    resetRotation() {
      const { visualElement: o } = this.options;
      if (!o)
        return;
      let s = !1;
      const { latestValues: l } = o;
      if ((l.rotate || l.rotateX || l.rotateY || l.rotateZ) && (s = !0), !s)
        return;
      const c = {};
      for (let d = 0; d < v5.length; d++) {
        const u = "rotate" + v5[d];
        l[u] && (c[u] = l[u], o.setStaticValue(u, 0));
      }
      o.render();
      for (const d in c)
        o.setStaticValue(d, c[d]);
      o.scheduleRender();
    }
    getProjectionStyles(o = {}) {
      var s, l;
      const c = {};
      if (!this.instance || this.isSVG)
        return c;
      if (this.isVisible)
        c.visibility = "";
      else
        return { visibility: "hidden" };
      const d = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, c.opacity = "", c.pointerEvents = cf(o.pointerEvents) || "", c.transform = d ? d(this.latestValues, "") : "none", c;
      const u = this.getLead();
      if (!this.projectionDelta || !this.layout || !u.target) {
        const p = {};
        return this.options.layoutId && (p.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, p.pointerEvents = cf(o.pointerEvents) || ""), this.hasProjected && !Kc(this.latestValues) && (p.transform = d ? d({}, "") : "none", this.hasProjected = !1), p;
      }
      const h = u.animationValues || u.latestValues;
      this.applyTransformsToTarget(), c.transform = F5(this.projectionDeltaWithTransform, this.treeScale, h), d && (c.transform = d(h, c.transform));
      const { x: N, y: M } = this.projectionDelta;
      c.transformOrigin = `${N.origin * 100}% ${M.origin * 100}% 0`, u.animationValues ? c.opacity = u === this ? (l = (s = h.opacity) !== null && s !== void 0 ? s : this.latestValues.opacity) !== null && l !== void 0 ? l : 1 : this.preserveOpacity ? this.latestValues.opacity : h.opacityExit : c.opacity = u === this ? h.opacity !== void 0 ? h.opacity : "" : h.opacityExit !== void 0 ? h.opacityExit : 0;
      for (const p in AV) {
        if (h[p] === void 0)
          continue;
        const { correct: m, applyTo: R } = AV[p], V = c.transform === "none" ? h[p] : m(h[p], u);
        if (R) {
          const U = R.length;
          for (let g = 0; g < U; g++)
            c[R[g]] = V;
        } else
          c[p] = V;
      }
      return this.options.layoutId && (c.pointerEvents = u === this ? cf(o.pointerEvents) || "" : "none"), c;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((o) => {
        var s;
        return (s = o.currentAnimation) === null || s === void 0 ? void 0 : s.stop();
      }), this.root.nodes.forEach(O5), this.root.sharedNodes.clear();
    }
  };
}
function yye(t) {
  t.updateLayout();
}
function Zye(t) {
  var e;
  const n = ((e = t.resumeFrom) === null || e === void 0 ? void 0 : e.snapshot) || t.snapshot;
  if (t.isLead() && t.layout && n && t.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: i } = t.layout, { animationType: a } = t.options, o = n.source !== t.layout.source;
    a === "size" ? ho((u) => {
      const h = o ? n.measuredBox[u] : n.layoutBox[u], N = ra(h);
      h.min = r[u].min, h.max = h.min + N;
    }) : l9(a, n.layoutBox, r) && ho((u) => {
      const h = o ? n.measuredBox[u] : n.layoutBox[u], N = ra(r[u]);
      h.max = h.min + N;
    });
    const s = U1();
    f1(s, r, n.layoutBox);
    const l = U1();
    o ? f1(l, t.applyTransform(i, !0), n.measuredBox) : f1(l, r, n.layoutBox);
    const c = !o9(s);
    let d = !1;
    if (!t.resumeFrom) {
      const u = t.getClosestProjectingParent();
      if (u && !u.resumeFrom) {
        const { snapshot: h, layout: N } = u;
        if (h && N) {
          const M = ur();
          V1(M, n.layoutBox, h.layoutBox);
          const p = ur();
          V1(p, r, N.layoutBox), Xb(M, p) || (d = !0), u.options.layoutRoot && (t.relativeTarget = p, t.relativeTargetOrigin = M, t.relativeParent = u);
        }
      }
    }
    t.notifyListeners("didUpdate", {
      layout: r,
      snapshot: n,
      delta: l,
      layoutDelta: s,
      hasLayoutChanged: c,
      hasRelativeTargetChanged: d
    });
  } else if (t.isLead()) {
    const { onExitComplete: r } = t.options;
    r && r();
  }
  t.options.transition = void 0;
}
function bye(t) {
  $c.totalNodes++, t.parent && (t.isProjecting() || (t.isProjectionDirty = t.parent.isProjectionDirty), t.isSharedProjectionDirty || (t.isSharedProjectionDirty = !!(t.isProjectionDirty || t.parent.isProjectionDirty || t.parent.isSharedProjectionDirty)), t.isTransformDirty || (t.isTransformDirty = t.parent.isTransformDirty));
}
function Eye(t) {
  t.isProjectionDirty = t.isSharedProjectionDirty = t.isTransformDirty = !1;
}
function Sye(t) {
  t.clearSnapshot();
}
function O5(t) {
  t.clearMeasurements();
}
function xye(t) {
  const { visualElement: e } = t.options;
  e && e.getProps().onBeforeLayoutMeasure && e.notify("BeforeLayoutMeasure"), t.resetTransform();
}
function Y5(t) {
  t.finishAnimation(), t.targetDelta = t.relativeTarget = t.target = void 0;
}
function Wye(t) {
  t.resolveTargetDelta();
}
function jye(t) {
  t.calcProjection();
}
function Dye(t) {
  t.resetRotation();
}
function zye(t) {
  t.removeLeadSnapshot();
}
function Q5(t, e, n) {
  t.translate = _n(e.translate, 0, n), t.scale = _n(e.scale, 1, n), t.origin = e.origin, t.originPoint = e.originPoint;
}
function G5(t, e, n, r) {
  t.min = _n(e.min, n.min, r), t.max = _n(e.max, n.max, r);
}
function kye(t, e, n, r) {
  G5(t.x, e.x, n.x, r), G5(t.y, e.y, n.y, r);
}
function wye(t) {
  return t.animationValues && t.animationValues.opacityExit !== void 0;
}
const Fye = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
function vye(t, e) {
  let n = t.root;
  for (let a = t.path.length - 1; a >= 0; a--)
    if (t.path[a].instance) {
      n = t.path[a];
      break;
    }
  const i = (n && n !== t.root ? n.instance : document).querySelector(`[data-projection-id="${e}"]`);
  i && t.mount(i, !0);
}
function C5(t) {
  t.min = Math.round(t.min), t.max = Math.round(t.max);
}
function Iye(t) {
  C5(t.x), C5(t.y);
}
function l9(t, e, n) {
  return t === "position" || t === "preserve-aspect" && !Lb(w5(e), w5(n), 0.2);
}
const Oye = s9({
  attachResizeListener: (t, e) => Vs(t, "resize", e),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), iy = {
  current: void 0
}, c9 = s9({
  measureScroll: (t) => ({
    x: t.scrollLeft,
    y: t.scrollTop
  }),
  defaultParent: () => {
    if (!iy.current) {
      const t = new Oye(0, {});
      t.mount(window), t.setOptions({ layoutScroll: !0 }), iy.current = t;
    }
    return iy.current;
  },
  resetTransform: (t, e) => {
    t.style.transform = e !== void 0 ? e : "none";
  },
  checkIsScrollRoot: (t) => window.getComputedStyle(t).position === "fixed"
}), Yye = {
  pan: {
    Feature: $ge
  },
  drag: {
    Feature: Kge,
    ProjectionNode: c9,
    MeasureLayout: r9
  }
}, Qye = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y"
]), d9 = (t) => Qye.has(t), Gye = (t) => Object.keys(t).some(d9), mT = (t) => t === Vu || t === Nt, L5 = (t, e) => parseFloat(t.split(", ")[e]), J5 = (t, e) => (n, { transform: r }) => {
  if (r === "none" || !r)
    return 0;
  const i = r.match(/^matrix3d\((.+)\)$/);
  if (i)
    return L5(i[1], e);
  {
    const a = r.match(/^matrix\((.+)\)$/);
    return a ? L5(a[1], t) : 0;
  }
}, Cye = /* @__PURE__ */ new Set(["x", "y", "z"]), Lye = JU.filter((t) => !Cye.has(t));
function Jye(t) {
  const e = [];
  return Lye.forEach((n) => {
    const r = t.getValue(n);
    r !== void 0 && (e.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), e.length && t.render(), e;
}
const B5 = {
  // Dimensions
  width: ({ x: t }, { paddingLeft: e = "0", paddingRight: n = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(n),
  height: ({ y: t }, { paddingTop: e = "0", paddingBottom: n = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(n),
  top: (t, { top: e }) => parseFloat(e),
  left: (t, { left: e }) => parseFloat(e),
  bottom: ({ y: t }, { top: e }) => parseFloat(e) + (t.max - t.min),
  right: ({ x: t }, { left: e }) => parseFloat(e) + (t.max - t.min),
  // Transform
  x: J5(4, 13),
  y: J5(5, 14)
}, Bye = (t, e, n) => {
  const r = e.measureViewportBox(), i = e.current, a = getComputedStyle(i), { display: o } = a, s = {};
  o === "none" && e.setStaticValue("display", t.display || "block"), n.forEach((c) => {
    s[c] = B5[c](r, a);
  }), e.render();
  const l = e.measureViewportBox();
  return n.forEach((c) => {
    const d = e.getValue(c);
    d && d.jump(s[c]), t[c] = B5[c](l, a);
  }), t;
}, Aye = (t, e, n = {}, r = {}) => {
  e = { ...e }, r = { ...r };
  const i = Object.keys(e).filter(d9);
  let a = [], o = !1;
  const s = [];
  if (i.forEach((l) => {
    const c = t.getValue(l);
    if (!t.hasValue(l))
      return;
    let d = n[l], u = kN(d);
    const h = e[l];
    let N;
    if (XV(h)) {
      const M = h.length, p = h[0] === null ? 1 : 0;
      d = h[p], u = kN(d);
      for (let m = p; m < M; m++)
        N ? Wa(kN(h[m]) === N, "All keyframes must be of the same type") : (N = kN(h[m]), Wa(N === u || mT(u) && mT(N), "Keyframes must be of the same dimension as the current value"));
    } else
      N = kN(h);
    if (u !== N)
      if (mT(u) && mT(N)) {
        const M = c.get();
        typeof M == "string" && c.set(parseFloat(M)), typeof h == "string" ? e[l] = parseFloat(h) : Array.isArray(h) && N === Nt && (e[l] = h.map(parseFloat));
      } else
        u != null && u.transform && (N != null && N.transform) && (d === 0 || h === 0) ? d === 0 ? c.set(N.transform(d)) : e[l] = u.transform(h) : (o || (a = Jye(t), o = !0), s.push(l), r[l] = r[l] !== void 0 ? r[l] : e[l], c.jump(h));
  }), s.length) {
    const l = s.indexOf("height") >= 0 ? window.pageYOffset : null, c = Bye(e, t, s);
    return a.length && a.forEach(([d, u]) => {
      t.getValue(d).set(u);
    }), t.render(), GU && l !== null && window.scrollTo({ top: l }), { target: c, transitionEnd: r };
  } else
    return { target: e, transitionEnd: r };
};
function Hye(t, e, n, r) {
  return Gye(e) ? Aye(t, e, n, r) : { target: e, transitionEnd: r };
}
const Xye = (t, e, n, r) => {
  const i = iye(t, e, r);
  return e = i.target, r = i.transitionEnd, Hye(t, e, n, r);
}, _b = { current: null }, u9 = { current: !1 };
function _ye() {
  if (u9.current = !0, !!GU)
    if (window.matchMedia) {
      const t = window.matchMedia("(prefers-reduced-motion)"), e = () => _b.current = t.matches;
      t.addListener(e), e();
    } else
      _b.current = !1;
}
function Pye(t, e, n) {
  const { willChange: r } = e;
  for (const i in e) {
    const a = e[i], o = n[i];
    if (Oi(a))
      t.addValue(i, a), $V(r) && r.add(i), ue.env.NODE_ENV === "development" && Nx(a.version === "10.8.4", `Attempting to mix Framer Motion versions ${a.version} with 10.8.4 may not work as expected.`);
    else if (Oi(o))
      t.addValue(i, Sh(a, { owner: t })), $V(r) && r.remove(i);
    else if (o !== a)
      if (t.hasValue(i)) {
        const s = t.getValue(i);
        !s.hasAnimated && s.set(a);
      } else {
        const s = t.getStaticValue(i);
        t.addValue(i, Sh(s !== void 0 ? s : a, { owner: t }));
      }
  }
  for (const i in n)
    e[i] === void 0 && t.removeValue(i);
  return e;
}
const A5 = /* @__PURE__ */ new WeakMap(), h9 = Object.keys(_M), Kye = h9.length, H5 = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
], $ye = HS.length;
class qye {
  constructor({ parent: e, props: n, presenceContext: r, reducedMotionConfig: i, visualState: a }, o = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.scheduleRender = () => Ln.render(this.render, !1, !0);
    const { latestValues: s, renderState: l } = a;
    this.latestValues = s, this.baseTarget = { ...s }, this.initialValues = n.initial ? { ...s } : {}, this.renderState = l, this.parent = e, this.props = n, this.presenceContext = r, this.depth = e ? e.depth + 1 : 0, this.reducedMotionConfig = i, this.options = o, this.isControllingVariants = LU(n), this.isVariantNode = iC(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(e && e.current);
    const { willChange: c, ...d } = this.scrapeMotionValuesFromProps(n, {});
    for (const u in d) {
      const h = d[u];
      s[u] !== void 0 && Oi(h) && (h.set(s[u], !1), $V(c) && c.add(u));
    }
  }
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(e, n) {
    return {};
  }
  mount(e) {
    this.current = e, A5.set(e, this), this.projection && this.projection.mount(e), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, r) => this.bindToMotionValue(r, n)), u9.current || _ye(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : _b.current, ue.env.NODE_ENV !== "production" && Nx(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    A5.delete(this.current), this.projection && this.projection.unmount(), uc.update(this.notifyUpdate), uc.render(this.render), this.valueSubscriptions.forEach((e) => e()), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const e in this.events)
      this.events[e].clear();
    for (const e in this.features)
      this.features[e].unmount();
    this.current = null;
  }
  bindToMotionValue(e, n) {
    const r = fu.has(e), i = n.on("change", (o) => {
      this.latestValues[e] = o, this.props.onUpdate && Ln.update(this.notifyUpdate, !1, !0), r && this.projection && (this.projection.isTransformDirty = !0);
    }), a = n.on("renderRequest", this.scheduleRender);
    this.valueSubscriptions.set(e, () => {
      i(), a();
    });
  }
  sortNodePosition(e) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== e.type ? 0 : this.sortInstanceNodePosition(this.current, e.current);
  }
  loadFeatures({ children: e, ...n }, r, i, a, o) {
    let s, l;
    if (ue.env.NODE_ENV !== "production" && i && r) {
      const c = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
      n.ignoreStrict ? Mm(!1, c) : Wa(!1, c);
    }
    for (let c = 0; c < Kye; c++) {
      const d = h9[c], { isEnabled: u, Feature: h, ProjectionNode: N, MeasureLayout: M } = _M[d];
      N && (s = N), u(n) && (!this.features[d] && h && (this.features[d] = new h(this)), M && (l = M));
    }
    if (!this.projection && s) {
      this.projection = new s(a, this.latestValues, this.parent && this.parent.projection);
      const { layoutId: c, layout: d, drag: u, dragConstraints: h, layoutScroll: N, layoutRoot: M } = n;
      this.projection.setOptions({
        layoutId: c,
        layout: d,
        alwaysMeasureLayout: !!u || h && i0(h),
        visualElement: this,
        scheduleRender: () => this.scheduleRender(),
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */
        animationType: typeof d == "string" ? d : "both",
        initialPromotionConfig: o,
        layoutScroll: N,
        layoutRoot: M
      });
    }
    return l;
  }
  updateFeatures() {
    for (const e in this.features) {
      const n = this.features[e];
      n.isMounted ? n.update(this.props, this.prevProps) : (n.mount(), n.isMounted = !0);
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.options, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : ur();
  }
  getStaticValue(e) {
    return this.latestValues[e];
  }
  setStaticValue(e, n) {
    this.latestValues[e] = n;
  }
  /**
   * Make a target animatable by Popmotion. For instance, if we're
   * trying to animate width from 100px to 100vw we need to measure 100vw
   * in pixels to determine what we really need to animate to. This is also
   * pluggable to support Framer's custom value types like Color,
   * and CSS variables.
   */
  makeTargetAnimatable(e, n = !0) {
    return this.makeTargetAnimatableFromInstance(e, this.props, n);
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(e, n) {
    (e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = e, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < H5.length; r++) {
      const i = H5[r];
      this.propEventSubscriptions[i] && (this.propEventSubscriptions[i](), delete this.propEventSubscriptions[i]);
      const a = e["on" + i];
      a && (this.propEventSubscriptions[i] = this.on(i, a));
    }
    this.prevMotionValues = Pye(this, this.scrapeMotionValuesFromProps(e, this.prevProps), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(e) {
    return this.props.variants ? this.props.variants[e] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  getVariantContext(e = !1) {
    if (e)
      return this.parent ? this.parent.getVariantContext() : void 0;
    if (!this.isControllingVariants) {
      const r = this.parent ? this.parent.getVariantContext() || {} : {};
      return this.props.initial !== void 0 && (r.initial = this.props.initial), r;
    }
    const n = {};
    for (let r = 0; r < $ye; r++) {
      const i = HS[r], a = this.props[i];
      (XM(a) || a === !1) && (n[i] = a);
    }
    return n;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(e) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(e), () => n.variantChildren.delete(e);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(e, n) {
    n !== this.values.get(e) && (this.removeValue(e), this.bindToMotionValue(e, n)), this.values.set(e, n), this.latestValues[e] = n.get();
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(e) {
    this.values.delete(e);
    const n = this.valueSubscriptions.get(e);
    n && (n(), this.valueSubscriptions.delete(e)), delete this.latestValues[e], this.removeValueFromRenderState(e, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(e) {
    return this.values.has(e);
  }
  getValue(e, n) {
    if (this.props.values && this.props.values[e])
      return this.props.values[e];
    let r = this.values.get(e);
    return r === void 0 && n !== void 0 && (r = Sh(n, { owner: this }), this.addValue(e, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(e) {
    return this.latestValues[e] !== void 0 || !this.current ? this.latestValues[e] : this.readValueFromInstance(this.current, e, this.options);
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(e, n) {
    this.baseTarget[e] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(e) {
    var n;
    const { initial: r } = this.props, i = typeof r == "string" || typeof r == "object" ? (n = rx(this.props, r)) === null || n === void 0 ? void 0 : n[e] : void 0;
    if (r && i !== void 0)
      return i;
    const a = this.getBaseTargetFromProps(this.props, e);
    return a !== void 0 && !Oi(a) ? a : this.initialValues[e] !== void 0 && i === void 0 ? void 0 : this.baseTarget[e];
  }
  on(e, n) {
    return this.events[e] || (this.events[e] = new hx()), this.events[e].add(n);
  }
  notify(e, ...n) {
    this.events[e] && this.events[e].notify(...n);
  }
}
class N9 extends qye {
  sortInstanceNodePosition(e, n) {
    return e.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(e, n) {
    return e.style ? e.style[n] : void 0;
  }
  removeValueFromRenderState(e, { vars: n, style: r }) {
    delete n[e], delete r[e];
  }
  makeTargetAnimatableFromInstance({ transition: e, transitionEnd: n, ...r }, { transformValues: i }, a) {
    let o = Tge(r, e || {}, this);
    if (i && (n && (n = i(n)), r && (r = i(r)), o && (o = i(o))), a) {
      pge(this, r, o);
      const s = Xye(this, r, o, n);
      n = s.transitionEnd, r = s.target;
    }
    return {
      transition: e,
      transitionEnd: n,
      ...r
    };
  }
}
function eZe(t) {
  return window.getComputedStyle(t);
}
class tZe extends N9 {
  readValueFromInstance(e, n) {
    if (fu.has(n)) {
      const r = sx(n);
      return r && r.default || 0;
    } else {
      const r = eZe(e), i = (lC(n) ? r.getPropertyValue(n) : r[n]) || 0;
      return typeof i == "string" ? i.trim() : i;
    }
  }
  measureInstanceViewportBox(e, { transformPagePoint: n }) {
    return t9(e, n);
  }
  build(e, n, r, i) {
    KS(e, n, r, i.transformTemplate);
  }
  scrapeMotionValuesFromProps(e, n) {
    return nx(e, n);
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: e } = this.props;
    Oi(e) && (this.childSubscription = e.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
  renderInstance(e, n, r, i) {
    NC(e, n, r, i);
  }
}
class nZe extends N9 {
  constructor() {
    super(...arguments), this.isSVGTag = !1;
  }
  getBaseTargetFromProps(e, n) {
    return e[n];
  }
  readValueFromInstance(e, n) {
    if (fu.has(n)) {
      const r = sx(n);
      return r && r.default || 0;
    }
    return n = MC.has(n) ? n : tx(n), e.getAttribute(n);
  }
  measureInstanceViewportBox() {
    return ur();
  }
  scrapeMotionValuesFromProps(e, n) {
    return mC(e, n);
  }
  build(e, n, r, i) {
    qS(e, n, r, this.isSVGTag, i.transformTemplate);
  }
  renderInstance(e, n, r, i) {
    pC(e, n, r, i);
  }
  mount(e) {
    this.isSVGTag = ex(e.tagName), super.mount(e);
  }
}
const rZe = (t, e) => PS(t) ? new nZe(e, { enableHardwareAcceleration: !1 }) : new tZe(e, { enableHardwareAcceleration: !0 }), iZe = {
  layout: {
    ProjectionNode: c9,
    MeasureLayout: r9
  }
}, aZe = {
  ...Dge,
  ...PUe,
  ...Yye,
  ...iZe
}, Mx = /* @__PURE__ */ aUe((t, e) => kUe(t, e, aZe, rZe));
function M9() {
  const t = Ve(!1);
  return BV(() => (t.current = !0, () => {
    t.current = !1;
  }), []), t;
}
function oZe() {
  const t = M9(), [e, n] = nt(0), r = De(() => {
    t.current && n(e + 1);
  }, [e]);
  return [De(() => Ln.postRender(r), [r]), e];
}
class sZe extends H.Component {
  getSnapshotBeforeUpdate(e) {
    const n = this.props.childRef.current;
    if (n && e.isPresent && !this.props.isPresent) {
      const r = this.props.sizeRef.current;
      r.height = n.offsetHeight || 0, r.width = n.offsetWidth || 0, r.top = n.offsetTop, r.left = n.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function lZe({ children: t, isPresent: e }) {
  const n = nu(), r = Ve(null), i = Ve({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  });
  return Nw(() => {
    const { width: a, height: o, top: s, left: l } = i.current;
    if (e || !r.current || !a || !o)
      return;
    r.current.dataset.motionPopId = n;
    const c = document.createElement("style");
    return document.head.appendChild(c), c.sheet && c.sheet.insertRule(`
          [data-motion-pop-id="${n}"] {
            position: absolute !important;
            width: ${a}px !important;
            height: ${o}px !important;
            top: ${s}px !important;
            left: ${l}px !important;
          }
        `), () => {
      document.head.removeChild(c);
    };
  }, [e]), H.createElement(sZe, { isPresent: e, childRef: r, sizeRef: i }, H.cloneElement(t, { ref: r }));
}
const ay = ({ children: t, initial: e, isPresent: n, onExitComplete: r, custom: i, presenceAffectsLayout: a, mode: o }) => {
  const s = XS(cZe), l = nu(), c = vt(
    () => ({
      id: l,
      initial: e,
      isPresent: n,
      custom: i,
      onExitComplete: (d) => {
        s.set(d, !0);
        for (const u of s.values())
          if (!u)
            return;
        r && r();
      },
      register: (d) => (s.set(d, !1), () => s.delete(d))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    a ? void 0 : [n]
  );
  return vt(() => {
    s.forEach((d, u) => s.set(u, !1));
  }, [n]), H.useEffect(() => {
    !n && !s.size && r && r();
  }, [n]), o === "popLayout" && (t = H.createElement(lZe, { isPresent: n }, t)), H.createElement(dm.Provider, { value: c }, t);
};
function cZe() {
  return /* @__PURE__ */ new Map();
}
function dZe(t) {
  return Ee(() => () => t(), []);
}
const Xu = (t) => t.key || "";
function uZe(t, e) {
  t.forEach((n) => {
    const r = Xu(n);
    e.set(r, n);
  });
}
function hZe(t) {
  const e = [];
  return Zo.forEach(t, (n) => {
    _l(n) && e.push(n);
  }), e;
}
const p9 = ({ children: t, custom: e, initial: n = !0, onExitComplete: r, exitBeforeEnter: i, presenceAffectsLayout: a = !0, mode: o = "sync" }) => {
  Wa(!i, "Replace exitBeforeEnter with mode='wait'");
  let [s] = oZe();
  const l = lt(_S).forceRender;
  l && (s = l);
  const c = M9(), d = hZe(t);
  let u = d;
  const h = /* @__PURE__ */ new Set(), N = Ve(u), M = Ve(/* @__PURE__ */ new Map()).current, p = Ve(!0);
  if (BV(() => {
    p.current = !1, uZe(d, M), N.current = u;
  }), dZe(() => {
    p.current = !0, M.clear(), h.clear();
  }), p.current)
    return H.createElement(H.Fragment, null, u.map((U) => H.createElement(ay, { key: Xu(U), isPresent: !0, initial: n ? void 0 : !1, presenceAffectsLayout: a, mode: o }, U)));
  u = [...u];
  const m = N.current.map(Xu), R = d.map(Xu), V = m.length;
  for (let U = 0; U < V; U++) {
    const g = m[U];
    R.indexOf(g) === -1 && h.add(g);
  }
  return o === "wait" && h.size && (u = []), h.forEach((U) => {
    if (R.indexOf(U) !== -1)
      return;
    const g = M.get(U);
    if (!g)
      return;
    const y = m.indexOf(U), x = () => {
      M.delete(U), h.delete(U);
      const f = N.current.findIndex((D) => D.key === U);
      if (N.current.splice(f, 1), !h.size) {
        if (N.current = d, c.current === !1)
          return;
        s(), r && r();
      }
    };
    u.splice(y, 0, H.createElement(ay, { key: Xu(g), isPresent: !1, onExitComplete: x, custom: e, presenceAffectsLayout: a, mode: o }, g));
  }), u = u.map((U) => {
    const g = U.key;
    return h.has(g) ? U : H.createElement(ay, { key: Xu(U), isPresent: !0, presenceAffectsLayout: a, mode: o }, U);
  }), ue.env.NODE_ENV !== "production" && o === "wait" && u.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`), H.createElement(H.Fragment, null, h.size ? u : u.map((U) => Tc(U)));
};
var NZe = {
  initial: (t) => {
    const { position: e } = t, n = ["top", "bottom"].includes(e) ? "y" : "x";
    let r = ["top-right", "bottom-right"].includes(e) ? 1 : -1;
    return e === "bottom" && (r = 1), {
      opacity: 0,
      [n]: r * 24
    };
  },
  animate: {
    opacity: 1,
    y: 0,
    x: 0,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: [0.4, 0, 0.2, 1]
    }
  },
  exit: {
    opacity: 0,
    scale: 0.85,
    transition: {
      duration: 0.2,
      ease: [0.4, 0, 1, 1]
    }
  }
}, m9 = ZJ((t) => {
  const {
    id: e,
    message: n,
    onCloseComplete: r,
    onRequestRemove: i,
    requestClose: a = !1,
    position: o = "bottom",
    duration: s = 5e3,
    containerStyle: l,
    motionVariants: c = NZe,
    toastSpacing: d = "0.5rem"
  } = t, [u, h] = nt(s), N = eye();
  HM(() => {
    N || r == null || r();
  }, [N]), HM(() => {
    h(s);
  }, [s]);
  const M = () => h(null), p = () => h(s), m = () => {
    N && i();
  };
  Ee(() => {
    N && a && i();
  }, [N, a, i]), X2e(m, u);
  const R = vt(
    () => ({
      pointerEvents: "auto",
      maxWidth: 560,
      minWidth: 300,
      margin: d,
      ...l
    }),
    [l, d]
  ), V = vt(() => A2e(o), [o]);
  return /* @__PURE__ */ E.jsx(
    Mx.div,
    {
      layout: !0,
      className: "chakra-toast",
      variants: c,
      initial: "initial",
      animate: "animate",
      exit: "exit",
      onHoverStart: M,
      onHoverEnd: p,
      custom: { position: o },
      style: V,
      children: /* @__PURE__ */ E.jsx(
        Te.div,
        {
          role: "status",
          "aria-atomic": "true",
          className: "chakra-toast__inner",
          __css: R,
          children: Ts(n, { id: e, onClose: m })
        }
      )
    }
  );
});
m9.displayName = "ToastComponent";
var X5 = {
  path: /* @__PURE__ */ E.jsxs("g", { stroke: "currentColor", strokeWidth: "1.5", children: [
    /* @__PURE__ */ E.jsx(
      "path",
      {
        strokeLinecap: "round",
        fill: "none",
        d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
      }
    ),
    /* @__PURE__ */ E.jsx(
      "path",
      {
        fill: "currentColor",
        strokeLinecap: "round",
        d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
      }
    ),
    /* @__PURE__ */ E.jsx("circle", { fill: "none", strokeMiterlimit: "10", cx: "12", cy: "12", r: "11.25" })
  ] }),
  viewBox: "0 0 24 24"
}, mm = On((t, e) => {
  const {
    as: n,
    viewBox: r,
    color: i = "currentColor",
    focusable: a = !1,
    children: o,
    className: s,
    __css: l,
    ...c
  } = t, d = gr("chakra-icon", s), u = jc("Icon", t), h = {
    w: "1em",
    h: "1em",
    display: "inline-block",
    lineHeight: "1em",
    flexShrink: 0,
    color: i,
    ...l,
    ...u
  }, N = {
    ref: e,
    focusable: a,
    className: d,
    __css: h
  }, M = r ?? X5.viewBox;
  if (n && typeof n != "string")
    return /* @__PURE__ */ E.jsx(Te.svg, { as: n, ...N, ...c });
  const p = o ?? X5.path;
  return /* @__PURE__ */ E.jsx(Te.svg, { verticalAlign: "middle", viewBox: M, ...N, ...c, children: p });
});
mm.displayName = "Icon";
function MZe(t) {
  return /* @__PURE__ */ E.jsx(mm, { viewBox: "0 0 24 24", ...t, children: /* @__PURE__ */ E.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
    }
  ) });
}
function pZe(t) {
  return /* @__PURE__ */ E.jsx(mm, { viewBox: "0 0 24 24", ...t, children: /* @__PURE__ */ E.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
    }
  ) });
}
function _5(t) {
  return /* @__PURE__ */ E.jsx(mm, { viewBox: "0 0 24 24", ...t, children: /* @__PURE__ */ E.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
    }
  ) });
}
var mZe = wU({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
}), px = On((t, e) => {
  const n = jc("Spinner", t), {
    label: r = "Loading...",
    thickness: i = "2px",
    speed: a = "0.45s",
    emptyColor: o = "transparent",
    className: s,
    ...l
  } = $s(t), c = gr("chakra-spinner", s), d = {
    display: "inline-block",
    borderColor: "currentColor",
    borderStyle: "solid",
    borderRadius: "99999px",
    borderWidth: i,
    borderBottomColor: o,
    borderLeftColor: o,
    animation: `${mZe} ${a} linear infinite`,
    ...n
  };
  return /* @__PURE__ */ E.jsx(
    Te.div,
    {
      ref: e,
      __css: d,
      className: c,
      ...l,
      children: r && /* @__PURE__ */ E.jsx(Te.span, { srOnly: !0, children: r })
    }
  );
});
px.displayName = "Spinner";
var [TZe, mx] = Ks({
  name: "AlertContext",
  hookName: "useAlertContext",
  providerName: "<Alert />"
}), [fZe, Tx] = Ks({
  name: "AlertStylesContext",
  hookName: "useAlertStyles",
  providerName: "<Alert />"
}), T9 = {
  info: { icon: pZe, colorScheme: "blue" },
  warning: { icon: _5, colorScheme: "orange" },
  success: { icon: MZe, colorScheme: "green" },
  error: { icon: _5, colorScheme: "red" },
  loading: { icon: px, colorScheme: "blue" }
};
function VZe(t) {
  return T9[t].colorScheme;
}
function UZe(t) {
  return T9[t].icon;
}
var f9 = On(
  function(e, n) {
    const r = Tx(), { status: i } = mx(), a = {
      display: "inline",
      ...r.description
    };
    return /* @__PURE__ */ E.jsx(
      Te.div,
      {
        ref: n,
        "data-status": i,
        ...e,
        className: gr("chakra-alert__desc", e.className),
        __css: a
      }
    );
  }
);
f9.displayName = "AlertDescription";
function V9(t) {
  const { status: e } = mx(), n = UZe(e), r = Tx(), i = e === "loading" ? r.spinner : r.icon;
  return /* @__PURE__ */ E.jsx(
    Te.span,
    {
      display: "inherit",
      "data-status": e,
      ...t,
      className: gr("chakra-alert__icon", t.className),
      __css: i,
      children: t.children || /* @__PURE__ */ E.jsx(n, { h: "100%", w: "100%" })
    }
  );
}
V9.displayName = "AlertIcon";
var U9 = On(
  function(e, n) {
    const r = Tx(), { status: i } = mx();
    return /* @__PURE__ */ E.jsx(
      Te.div,
      {
        ref: n,
        "data-status": i,
        ...e,
        className: gr("chakra-alert__title", e.className),
        __css: r.title
      }
    );
  }
);
U9.displayName = "AlertTitle";
var R9 = On(function(e, n) {
  var r;
  const { status: i = "info", addRole: a = !0, ...o } = $s(e), s = (r = e.colorScheme) != null ? r : VZe(i), l = $G("Alert", { ...e, colorScheme: s }), c = {
    width: "100%",
    display: "flex",
    alignItems: "center",
    position: "relative",
    overflow: "hidden",
    ...l.container
  };
  return /* @__PURE__ */ E.jsx(TZe, { value: { status: i }, children: /* @__PURE__ */ E.jsx(fZe, { value: l, children: /* @__PURE__ */ E.jsx(
    Te.div,
    {
      "data-status": i,
      role: a ? "alert" : void 0,
      ref: n,
      ...o,
      className: gr("chakra-alert", e.className),
      __css: c
    }
  ) }) });
});
R9.displayName = "Alert";
function RZe(t) {
  return /* @__PURE__ */ E.jsx(mm, { focusable: "false", "aria-hidden": !0, ...t, children: /* @__PURE__ */ E.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
    }
  ) });
}
var g9 = On(
  function(e, n) {
    const r = jc("CloseButton", e), { children: i, isDisabled: a, __css: o, ...s } = $s(e), l = {
      outline: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0
    };
    return /* @__PURE__ */ E.jsx(
      Te.button,
      {
        type: "button",
        "aria-label": "Close",
        ref: n,
        disabled: a,
        __css: {
          ...l,
          ...r,
          ...o
        },
        ...s,
        children: i || /* @__PURE__ */ E.jsx(RZe, { width: "1em", height: "1em" })
      }
    );
  }
);
g9.displayName = "CloseButton";
var gZe = {
  top: [],
  "top-left": [],
  "top-right": [],
  "bottom-left": [],
  bottom: [],
  "bottom-right": []
}, R1 = yZe(gZe);
function yZe(t) {
  let e = t;
  const n = /* @__PURE__ */ new Set(), r = (i) => {
    e = i(e), n.forEach((a) => a());
  };
  return {
    getState: () => e,
    subscribe: (i) => (n.add(i), () => {
      r(() => t), n.delete(i);
    }),
    /**
     * Delete a toast record at its position
     */
    removeToast: (i, a) => {
      r((o) => ({
        ...o,
        // id may be string or number
        // eslint-disable-next-line eqeqeq
        [a]: o[a].filter((s) => s.id != i)
      }));
    },
    notify: (i, a) => {
      const o = ZZe(i, a), { position: s, id: l } = o;
      return r((c) => {
        var d, u;
        const N = s.includes("top") ? [o, ...(d = c[s]) != null ? d : []] : [...(u = c[s]) != null ? u : [], o];
        return {
          ...c,
          [s]: N
        };
      }), l;
    },
    update: (i, a) => {
      i && r((o) => {
        const s = { ...o }, { position: l, index: c } = Cz(s, i);
        return l && c !== -1 && (s[l][c] = {
          ...s[l][c],
          ...a,
          message: EZe(a)
        }), s;
      });
    },
    closeAll: ({ positions: i } = {}) => {
      r((a) => (i ?? [
        "bottom",
        "bottom-right",
        "bottom-left",
        "top",
        "top-left",
        "top-right"
      ]).reduce(
        (l, c) => (l[c] = a[c].map((d) => ({
          ...d,
          requestClose: !0
        })), l),
        { ...a }
      ));
    },
    close: (i) => {
      r((a) => {
        const o = tC(a, i);
        return o ? {
          ...a,
          [o]: a[o].map((s) => s.id == i ? {
            ...s,
            requestClose: !0
          } : s)
        } : a;
      });
    },
    isActive: (i) => !!Cz(R1.getState(), i).position
  };
}
var P5 = 0;
function ZZe(t, e = {}) {
  var n, r;
  P5 += 1;
  const i = (n = e.id) != null ? n : P5, a = (r = e.position) != null ? r : "bottom";
  return {
    id: i,
    message: t,
    position: a,
    duration: e.duration,
    onCloseComplete: e.onCloseComplete,
    onRequestRemove: () => R1.removeToast(String(i), a),
    status: e.status,
    requestClose: !1,
    containerStyle: e.containerStyle
  };
}
var bZe = (t) => {
  const {
    status: e,
    variant: n = "solid",
    id: r,
    title: i,
    isClosable: a,
    onClose: o,
    description: s,
    colorScheme: l,
    icon: c
  } = t, d = r ? {
    root: `toast-${r}`,
    title: `toast-${r}-title`,
    description: `toast-${r}-description`
  } : void 0;
  return /* @__PURE__ */ E.jsxs(
    R9,
    {
      addRole: !1,
      status: e,
      variant: n,
      id: d == null ? void 0 : d.root,
      alignItems: "start",
      borderRadius: "md",
      boxShadow: "lg",
      paddingEnd: 8,
      textAlign: "start",
      width: "auto",
      colorScheme: l,
      children: [
        /* @__PURE__ */ E.jsx(V9, { children: c }),
        /* @__PURE__ */ E.jsxs(Te.div, { flex: "1", maxWidth: "100%", children: [
          i && /* @__PURE__ */ E.jsx(U9, { id: d == null ? void 0 : d.title, children: i }),
          s && /* @__PURE__ */ E.jsx(f9, { id: d == null ? void 0 : d.description, display: "block", children: s })
        ] }),
        a && /* @__PURE__ */ E.jsx(
          g9,
          {
            size: "sm",
            onClick: o,
            position: "absolute",
            insetEnd: 1,
            top: 1
          }
        )
      ]
    }
  );
};
function EZe(t = {}) {
  const { render: e, toastComponent: n = bZe } = t;
  return (i) => typeof e == "function" ? e({ ...i, ...t }) : /* @__PURE__ */ E.jsx(n, { ...i, ...t });
}
var [SZe, wve] = Ks({
  name: "ToastOptionsContext",
  strict: !1
}), xZe = (t) => {
  const e = bJ(
    R1.subscribe,
    R1.getState,
    R1.getState
  ), {
    motionVariants: n,
    component: r = m9,
    portalProps: i
  } = t, o = Object.keys(e).map((s) => {
    const l = e[s];
    return /* @__PURE__ */ E.jsx(
      "div",
      {
        role: "region",
        "aria-live": "polite",
        "aria-label": "Notifications",
        id: `chakra-toast-manager-${s}`,
        style: H2e(s),
        children: /* @__PURE__ */ E.jsx(p9, { initial: !1, children: l.map((c) => /* @__PURE__ */ E.jsx(
          r,
          {
            motionVariants: n,
            ...c
          },
          c.id
        )) })
      },
      s
    );
  });
  return /* @__PURE__ */ E.jsx(lm, { ...i, children: o });
}, WZe = (t) => function({
  children: n,
  theme: r = t,
  toastOptions: i,
  ...a
}) {
  return /* @__PURE__ */ E.jsxs(J2e, { theme: r, ...a, children: [
    /* @__PURE__ */ E.jsx(SZe, { value: i == null ? void 0 : i.defaultOptions, children: n }),
    /* @__PURE__ */ E.jsx(xZe, { ...i })
  ] });
}, jZe = WZe(BG), DZe = Object.defineProperty, zZe = (t, e, n) => e in t ? DZe(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, Kn = (t, e, n) => (zZe(t, typeof e != "symbol" ? e + "" : e, n), n);
function K5(t) {
  return t.sort((e, n) => {
    const r = e.compareDocumentPosition(n);
    if (r & Node.DOCUMENT_POSITION_FOLLOWING || r & Node.DOCUMENT_POSITION_CONTAINED_BY)
      return -1;
    if (r & Node.DOCUMENT_POSITION_PRECEDING || r & Node.DOCUMENT_POSITION_CONTAINS)
      return 1;
    if (r & Node.DOCUMENT_POSITION_DISCONNECTED || r & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC)
      throw Error("Cannot sort the given nodes.");
    return 0;
  });
}
var kZe = (t) => typeof t == "object" && "nodeType" in t && t.nodeType === Node.ELEMENT_NODE;
function $5(t, e, n) {
  let r = t + 1;
  return n && r >= e && (r = 0), r;
}
function q5(t, e, n) {
  let r = t - 1;
  return n && r < 0 && (r = e), r;
}
var Pb = typeof window < "u" ? xp : Ee, e2 = (t) => t, wZe = class {
  constructor() {
    Kn(this, "descendants", /* @__PURE__ */ new Map()), Kn(this, "register", (t) => {
      if (t != null)
        return kZe(t) ? this.registerNode(t) : (e) => {
          this.registerNode(e, t);
        };
    }), Kn(this, "unregister", (t) => {
      this.descendants.delete(t);
      const e = K5(Array.from(this.descendants.keys()));
      this.assignIndex(e);
    }), Kn(this, "destroy", () => {
      this.descendants.clear();
    }), Kn(this, "assignIndex", (t) => {
      this.descendants.forEach((e) => {
        const n = t.indexOf(e.node);
        e.index = n, e.node.dataset.index = e.index.toString();
      });
    }), Kn(this, "count", () => this.descendants.size), Kn(this, "enabledCount", () => this.enabledValues().length), Kn(this, "values", () => Array.from(this.descendants.values()).sort((e, n) => e.index - n.index)), Kn(this, "enabledValues", () => this.values().filter((t) => !t.disabled)), Kn(this, "item", (t) => {
      if (this.count() !== 0)
        return this.values()[t];
    }), Kn(this, "enabledItem", (t) => {
      if (this.enabledCount() !== 0)
        return this.enabledValues()[t];
    }), Kn(this, "first", () => this.item(0)), Kn(this, "firstEnabled", () => this.enabledItem(0)), Kn(this, "last", () => this.item(this.descendants.size - 1)), Kn(this, "lastEnabled", () => {
      const t = this.enabledValues().length - 1;
      return this.enabledItem(t);
    }), Kn(this, "indexOf", (t) => {
      var e, n;
      return t && (n = (e = this.descendants.get(t)) == null ? void 0 : e.index) != null ? n : -1;
    }), Kn(this, "enabledIndexOf", (t) => t == null ? -1 : this.enabledValues().findIndex((e) => e.node.isSameNode(t))), Kn(this, "next", (t, e = !0) => {
      const n = $5(t, this.count(), e);
      return this.item(n);
    }), Kn(this, "nextEnabled", (t, e = !0) => {
      const n = this.item(t);
      if (!n)
        return;
      const r = this.enabledIndexOf(n.node), i = $5(
        r,
        this.enabledCount(),
        e
      );
      return this.enabledItem(i);
    }), Kn(this, "prev", (t, e = !0) => {
      const n = q5(t, this.count() - 1, e);
      return this.item(n);
    }), Kn(this, "prevEnabled", (t, e = !0) => {
      const n = this.item(t);
      if (!n)
        return;
      const r = this.enabledIndexOf(n.node), i = q5(
        r,
        this.enabledCount() - 1,
        e
      );
      return this.enabledItem(i);
    }), Kn(this, "registerNode", (t, e) => {
      if (!t || this.descendants.has(t))
        return;
      const n = Array.from(this.descendants.keys()).concat(t), r = K5(n);
      e != null && e.disabled && (e.disabled = !!e.disabled);
      const i = { node: t, index: -1, ...e };
      this.descendants.set(t, i), this.assignIndex(r);
    });
  }
};
function FZe(t, e) {
  if (t != null) {
    if (typeof t == "function") {
      t(e);
      return;
    }
    try {
      t.current = e;
    } catch {
      throw new Error(`Cannot assign value '${e}' to ref '${t}'`);
    }
  }
}
function Ls(...t) {
  return (e) => {
    t.forEach((n) => {
      FZe(n, e);
    });
  };
}
function vZe(...t) {
  return vt(() => Ls(...t), t);
}
function IZe() {
  const t = Ve(new wZe());
  return Pb(() => () => t.current.destroy()), t.current;
}
var [OZe, y9] = Ks({
  name: "DescendantsProvider",
  errorMessage: "useDescendantsContext must be used within DescendantsProvider"
});
function YZe(t) {
  const e = y9(), [n, r] = nt(-1), i = Ve(null);
  Pb(() => () => {
    i.current && e.unregister(i.current);
  }, []), Pb(() => {
    if (!i.current)
      return;
    const o = Number(i.current.dataset.index);
    n != o && !Number.isNaN(o) && r(o);
  });
  const a = e2(t ? e.register(t) : e.register);
  return {
    descendants: e,
    index: n,
    enabledIndex: e.enabledIndexOf(i.current),
    register: Ls(a, i)
  };
}
function QZe() {
  return [
    e2(OZe),
    () => e2(y9()),
    () => IZe(),
    (i) => YZe(i)
  ];
}
var Kb = On(function(e, n) {
  const { htmlWidth: r, htmlHeight: i, alt: a, ...o } = e;
  return /* @__PURE__ */ E.jsx("img", { width: r, height: i, ref: n, alt: a, ...o });
});
Kb.displayName = "NativeImage";
function GZe(t) {
  const {
    loading: e,
    src: n,
    srcSet: r,
    onLoad: i,
    onError: a,
    crossOrigin: o,
    sizes: s,
    ignoreFallback: l
  } = t, [c, d] = nt("pending");
  Ee(() => {
    d(n ? "loading" : "pending");
  }, [n]);
  const u = Ve(), h = De(() => {
    if (!n)
      return;
    N();
    const M = new Image();
    M.src = n, o && (M.crossOrigin = o), r && (M.srcset = r), s && (M.sizes = s), e && (M.loading = e), M.onload = (p) => {
      N(), d("loaded"), i == null || i(p);
    }, M.onerror = (p) => {
      N(), d("failed"), a == null || a(p);
    }, u.current = M;
  }, [n, o, r, s, i, a, e]), N = () => {
    u.current && (u.current.onload = null, u.current.onerror = null, u.current = null);
  };
  return GM(() => {
    if (!l)
      return c === "loading" && h(), () => {
        N();
      };
  }, [c, h, l]), l ? "loaded" : c;
}
var CZe = (t, e) => t !== "loaded" && e === "beforeLoadOrError" || t === "failed" && e === "onError";
function LZe(t, e = []) {
  const n = Object.assign({}, t);
  for (const r of e)
    r in n && delete n[r];
  return n;
}
var Z9 = On(function(e, n) {
  const {
    fallbackSrc: r,
    fallback: i,
    src: a,
    srcSet: o,
    align: s,
    fit: l,
    loading: c,
    ignoreFallback: d,
    crossOrigin: u,
    fallbackStrategy: h = "beforeLoadOrError",
    referrerPolicy: N,
    ...M
  } = e, p = r !== void 0 || i !== void 0, m = c != null || // use can opt out of fallback image
  d || // if the user doesn't provide any kind of fallback we should ignore it
  !p, R = GZe({
    ...e,
    crossOrigin: u,
    ignoreFallback: m
  }), V = CZe(R, h), U = {
    ref: n,
    objectFit: l,
    objectPosition: s,
    ...m ? M : LZe(M, ["onError", "onLoad"])
  };
  return V ? i || /* @__PURE__ */ E.jsx(
    Te.img,
    {
      as: Kb,
      className: "chakra-image__placeholder",
      src: r,
      ...U
    }
  ) : /* @__PURE__ */ E.jsx(
    Te.img,
    {
      as: Kb,
      src: a,
      srcSet: o,
      crossOrigin: u,
      loading: c,
      referrerPolicy: N,
      className: "chakra-image",
      ...U
    }
  );
});
Z9.displayName = "Image";
function JZe(t) {
  return Zo.toArray(t).filter(
    (e) => _l(e)
  );
}
var [Fve, BZe] = Ks({
  strict: !1,
  name: "ButtonGroupContext"
});
function AZe(t) {
  const [e, n] = nt(!t);
  return { ref: De((a) => {
    a && n(a.tagName === "BUTTON");
  }, []), type: e ? "button" : void 0 };
}
function $b(t) {
  const { children: e, className: n, ...r } = t, i = _l(e) ? Tc(e, {
    "aria-hidden": !0,
    focusable: !1
  }) : e, a = gr("chakra-button__icon", n);
  return /* @__PURE__ */ E.jsx(
    Te.span,
    {
      display: "inline-flex",
      alignSelf: "center",
      flexShrink: 0,
      ...r,
      className: a,
      children: i
    }
  );
}
$b.displayName = "ButtonIcon";
function qb(t) {
  const {
    label: e,
    placement: n,
    spacing: r = "0.5rem",
    children: i = /* @__PURE__ */ E.jsx(px, { color: "currentColor", width: "1em", height: "1em" }),
    className: a,
    __css: o,
    ...s
  } = t, l = gr("chakra-button__spinner", a), c = n === "start" ? "marginEnd" : "marginStart", d = vt(
    () => ({
      display: "flex",
      alignItems: "center",
      position: e ? "relative" : "absolute",
      [c]: e ? r : 0,
      fontSize: "1em",
      lineHeight: "normal",
      ...o
    }),
    [o, e, c, r]
  );
  return /* @__PURE__ */ E.jsx(Te.div, { className: l, ...s, __css: d, children: i });
}
qb.displayName = "ButtonSpinner";
var Uu = On((t, e) => {
  const n = BZe(), r = jc("Button", { ...n, ...t }), {
    isDisabled: i = n == null ? void 0 : n.isDisabled,
    isLoading: a,
    isActive: o,
    children: s,
    leftIcon: l,
    rightIcon: c,
    loadingText: d,
    iconSpacing: u = "0.5rem",
    type: h,
    spinner: N,
    spinnerPlacement: M = "start",
    className: p,
    as: m,
    ...R
  } = $s(t), V = vt(() => {
    const x = { ...r == null ? void 0 : r._focus, zIndex: 1 };
    return {
      display: "inline-flex",
      appearance: "none",
      alignItems: "center",
      justifyContent: "center",
      userSelect: "none",
      position: "relative",
      whiteSpace: "nowrap",
      verticalAlign: "middle",
      outline: "none",
      ...r,
      ...!!n && { _focus: x }
    };
  }, [r, n]), { ref: U, type: g } = AZe(m), y = { rightIcon: c, leftIcon: l, iconSpacing: u, children: s };
  return /* @__PURE__ */ E.jsxs(
    Te.button,
    {
      ref: vZe(e, U),
      as: m,
      type: h ?? g,
      "data-active": OV(o),
      "data-loading": OV(a),
      __css: V,
      className: gr("chakra-button", p),
      ...R,
      disabled: i || a,
      children: [
        a && M === "start" && /* @__PURE__ */ E.jsx(
          qb,
          {
            className: "chakra-button__spinner--start",
            label: d,
            placement: "start",
            spacing: u,
            children: N
          }
        ),
        a ? d || /* @__PURE__ */ E.jsx(Te.span, { opacity: 0, children: /* @__PURE__ */ E.jsx(ek, { ...y }) }) : /* @__PURE__ */ E.jsx(ek, { ...y }),
        a && M === "end" && /* @__PURE__ */ E.jsx(
          qb,
          {
            className: "chakra-button__spinner--end",
            label: d,
            placement: "end",
            spacing: u,
            children: N
          }
        )
      ]
    }
  );
});
Uu.displayName = "Button";
function ek(t) {
  const { leftIcon: e, rightIcon: n, children: r, iconSpacing: i } = t;
  return /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
    e && /* @__PURE__ */ E.jsx($b, { marginEnd: i, children: e }),
    r,
    n && /* @__PURE__ */ E.jsx($b, { marginStart: i, children: n })
  ] });
}
function df(t, e, n, r) {
  const i = AM(n);
  return Ee(() => {
    const a = typeof t == "function" ? t() : t ?? document;
    if (!(!n || !a))
      return a.addEventListener(e, i, r), () => {
        a.removeEventListener(e, i, r);
      };
  }, [e, t, r, i, n]), () => {
    const a = typeof t == "function" ? t() : t ?? document;
    a == null || a.removeEventListener(e, i, r);
  };
}
function b9(t) {
  return t != null && typeof t == "object" && "nodeType" in t && t.nodeType === Node.ELEMENT_NODE;
}
function fx(t) {
  var e;
  if (!b9(t))
    return !1;
  const n = (e = t.ownerDocument.defaultView) != null ? e : window;
  return t instanceof n.HTMLElement;
}
function HZe(t) {
  var e, n;
  return (n = (e = E9(t)) == null ? void 0 : e.defaultView) != null ? n : window;
}
function E9(t) {
  return b9(t) ? t.ownerDocument : document;
}
function XZe(t) {
  return E9(t).activeElement;
}
function _Ze(t) {
  const e = t.ownerDocument.defaultView || window, { overflow: n, overflowX: r, overflowY: i } = e.getComputedStyle(t);
  return /auto|scroll|overlay|hidden/.test(n + i + r);
}
function PZe(t) {
  return t.localName === "html" ? t : t.assignedSlot || t.parentElement || t.ownerDocument.documentElement;
}
function S9(t) {
  return ["html", "body", "#document"].includes(t.localName) ? t.ownerDocument.body : fx(t) && _Ze(t) ? t : S9(PZe(t));
}
var x9 = (t) => t.hasAttribute("tabindex"), KZe = (t) => x9(t) && t.tabIndex === -1;
function $Ze(t) {
  return !!t.getAttribute("disabled") || !!t.getAttribute("aria-disabled");
}
function W9(t) {
  return t.parentElement && W9(t.parentElement) ? !0 : t.hidden;
}
function qZe(t) {
  const e = t.getAttribute("contenteditable");
  return e !== "false" && e != null;
}
function ebe(t) {
  if (!fx(t) || W9(t) || $Ze(t))
    return !1;
  const { localName: e } = t;
  if (["input", "select", "textarea", "button"].indexOf(e) >= 0)
    return !0;
  const r = {
    a: () => t.hasAttribute("href"),
    audio: () => t.hasAttribute("controls"),
    video: () => t.hasAttribute("controls")
  };
  return e in r ? r[e]() : qZe(t) ? !0 : x9(t);
}
function tbe(t) {
  return t ? fx(t) && ebe(t) && !KZe(t) : !1;
}
function nbe(t, e) {
  return Array.isArray(t) ? t.map((n) => n === null ? null : e(n)) : Ea(t) ? Object.keys(t).reduce((n, r) => (n[r] = e(t[r]), n), {}) : t != null ? e(t) : null;
}
var Mt = On(function(e, n) {
  const r = jc("Text", e), { className: i, align: a, decoration: o, casing: s, ...l } = $s(e), c = W2e({
    textAlign: e.align,
    textDecoration: e.decoration,
    textTransform: e.casing
  });
  return /* @__PURE__ */ E.jsx(
    Te.p,
    {
      ref: n,
      className: gr("chakra-text", e.className),
      ...c,
      ...l,
      __css: r
    }
  );
});
Mt.displayName = "Text";
var j9 = (t) => /* @__PURE__ */ E.jsx(
  Te.div,
  {
    className: "chakra-stack__item",
    ...t,
    __css: {
      display: "inline-block",
      flex: "0 0 auto",
      minWidth: 0,
      ...t.__css
    }
  }
);
j9.displayName = "StackItem";
function rbe(t) {
  const { spacing: e, direction: n } = t, r = {
    column: {
      my: e,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    "column-reverse": {
      my: e,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    row: {
      mx: e,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    },
    "row-reverse": {
      mx: e,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    }
  };
  return {
    "&": nbe(
      n,
      (i) => r[i]
    )
  };
}
var Ae = On((t, e) => {
  const {
    isInline: n,
    direction: r,
    align: i,
    justify: a,
    spacing: o = "0.5rem",
    wrap: s,
    children: l,
    divider: c,
    className: d,
    shouldWrapChildren: u,
    ...h
  } = t, N = n ? "row" : r ?? "column", M = vt(
    () => rbe({ spacing: o, direction: N }),
    [o, N]
  ), p = !!c, m = !u && !p, R = vt(() => {
    const U = JZe(l);
    return m ? U : U.map((g, y) => {
      const x = typeof g.key < "u" ? g.key : y, f = y + 1 === U.length, Y = u ? /* @__PURE__ */ E.jsx(j9, { children: g }, x) : g;
      if (!p)
        return Y;
      const Q = Tc(
        c,
        {
          __css: M
        }
      ), G = f ? null : Q;
      return /* @__PURE__ */ E.jsxs(tu, { children: [
        Y,
        G
      ] }, x);
    });
  }, [
    c,
    M,
    p,
    m,
    u,
    l
  ]), V = gr("chakra-stack", d);
  return /* @__PURE__ */ E.jsx(
    Te.div,
    {
      ref: e,
      display: "flex",
      alignItems: i,
      justifyContent: a,
      flexDirection: N,
      flexWrap: s,
      gap: p ? void 0 : o,
      className: V,
      ...h,
      children: R
    }
  );
});
Ae.displayName = "Stack";
var Vx = On((t, e) => /* @__PURE__ */ E.jsx(Ae, { align: "center", ...t, direction: "column", ref: e }));
Vx.displayName = "VStack";
var qM = On((t, e) => /* @__PURE__ */ E.jsx(Ae, { align: "center", ...t, direction: "row", ref: e }));
qM.displayName = "HStack";
var xh = On(function(e, n) {
  const r = jc("Heading", e), { className: i, ...a } = $s(e);
  return /* @__PURE__ */ E.jsx(
    Te.h2,
    {
      ref: n,
      className: gr("chakra-heading", e.className),
      ...a,
      __css: r
    }
  );
});
xh.displayName = "Heading";
var Mr = Te("div");
Mr.displayName = "Box";
var D9 = On(function(e, n) {
  const { size: r, centerContent: i = !0, ...a } = e, o = i ? { display: "flex", alignItems: "center", justifyContent: "center" } : {};
  return /* @__PURE__ */ E.jsx(
    Mr,
    {
      ref: n,
      boxSize: r,
      __css: {
        ...o,
        flexShrink: 0,
        flexGrow: 0
      },
      ...a
    }
  );
});
D9.displayName = "Square";
var ibe = On(function(e, n) {
  const { size: r, ...i } = e;
  return /* @__PURE__ */ E.jsx(D9, { size: r, ref: n, borderRadius: "9999px", ...i });
});
ibe.displayName = "Circle";
var Jr = On(function(e, n) {
  const { direction: r, align: i, justify: a, wrap: o, basis: s, grow: l, shrink: c, ...d } = e, u = {
    display: "flex",
    flexDirection: r,
    alignItems: i,
    justifyContent: a,
    flexWrap: o,
    flexBasis: s,
    flexGrow: l,
    flexShrink: c
  };
  return /* @__PURE__ */ E.jsx(Te.div, { ref: n, __css: u, ...d });
});
Jr.displayName = "Flex";
function abe(t) {
  const { key: e } = t;
  return e.length === 1 || e.length > 1 && /[^a-zA-Z0-9]/.test(e);
}
function obe(t = {}) {
  const { timeout: e = 300, preventDefault: n = () => !0 } = t, [r, i] = nt([]), a = Ve(), o = () => {
    a.current && (clearTimeout(a.current), a.current = null);
  }, s = () => {
    o(), a.current = setTimeout(() => {
      i([]), a.current = null;
    }, e);
  };
  Ee(() => o, []);
  function l(c) {
    return (d) => {
      if (d.key === "Backspace") {
        const u = [...r];
        u.pop(), i(u);
        return;
      }
      if (abe(d)) {
        const u = r.concat(d.key);
        n(d) && (d.preventDefault(), d.stopPropagation()), i(u), c(u.join("")), s();
      }
    };
  }
  return l;
}
function sbe(t, e, n, r) {
  if (e == null)
    return r;
  if (!r)
    return t.find(
      (o) => n(o).toLowerCase().startsWith(e.toLowerCase())
    );
  const i = t.filter(
    (a) => n(a).toLowerCase().startsWith(e.toLowerCase())
  );
  if (i.length > 0) {
    let a;
    return i.includes(r) ? (a = i.indexOf(r) + 1, a === i.length && (a = 0), i[a]) : (a = t.indexOf(i[0]), t[a]);
  }
  return r;
}
function lbe() {
  const t = Ve(/* @__PURE__ */ new Map()), e = t.current, n = De((i, a, o, s) => {
    t.current.set(o, { type: a, el: i, options: s }), i.addEventListener(a, o, s);
  }, []), r = De(
    (i, a, o, s) => {
      i.removeEventListener(a, o, s), t.current.delete(o);
    },
    []
  );
  return Ee(
    () => () => {
      e.forEach((i, a) => {
        r(i.el, i.type, a, i.options);
      });
    },
    [r, e]
  ), { add: n, remove: r };
}
function oy(t) {
  const e = t.target, { tagName: n, isContentEditable: r } = e;
  return n !== "INPUT" && n !== "TEXTAREA" && r !== !0;
}
function cbe(t = {}) {
  const {
    ref: e,
    isDisabled: n,
    isFocusable: r,
    clickOnEnter: i = !0,
    clickOnSpace: a = !0,
    onMouseDown: o,
    onMouseUp: s,
    onClick: l,
    onKeyDown: c,
    onKeyUp: d,
    tabIndex: u,
    onMouseOver: h,
    onMouseLeave: N,
    ...M
  } = t, [p, m] = nt(!0), [R, V] = nt(!1), U = lbe(), g = (j) => {
    j && j.tagName !== "BUTTON" && m(!1);
  }, y = p ? u : u || 0, x = n && !r, f = De(
    (j) => {
      if (n) {
        j.stopPropagation(), j.preventDefault();
        return;
      }
      j.currentTarget.focus(), l == null || l(j);
    },
    [n, l]
  ), D = De(
    (j) => {
      R && oy(j) && (j.preventDefault(), j.stopPropagation(), V(!1), U.remove(document, "keyup", D, !1));
    },
    [R, U]
  ), Y = De(
    (j) => {
      if (c == null || c(j), n || j.defaultPrevented || j.metaKey || !oy(j.nativeEvent) || p)
        return;
      const w = i && j.key === "Enter";
      a && j.key === " " && (j.preventDefault(), V(!0)), w && (j.preventDefault(), j.currentTarget.click()), U.add(document, "keyup", D, !1);
    },
    [
      n,
      p,
      c,
      i,
      a,
      U,
      D
    ]
  ), Q = De(
    (j) => {
      if (d == null || d(j), n || j.defaultPrevented || j.metaKey || !oy(j.nativeEvent) || p)
        return;
      a && j.key === " " && (j.preventDefault(), V(!1), j.currentTarget.click());
    },
    [a, p, n, d]
  ), G = De(
    (j) => {
      j.button === 0 && (V(!1), U.remove(document, "mouseup", G, !1));
    },
    [U]
  ), ne = De(
    (j) => {
      if (j.button !== 0)
        return;
      if (n) {
        j.stopPropagation(), j.preventDefault();
        return;
      }
      p || V(!0), j.currentTarget.focus({ preventScroll: !0 }), U.add(document, "mouseup", G, !1), o == null || o(j);
    },
    [n, p, o, U, G]
  ), O = De(
    (j) => {
      j.button === 0 && (p || V(!1), s == null || s(j));
    },
    [s, p]
  ), T = De(
    (j) => {
      if (n) {
        j.preventDefault();
        return;
      }
      h == null || h(j);
    },
    [n, h]
  ), Z = De(
    (j) => {
      R && (j.preventDefault(), V(!1)), N == null || N(j);
    },
    [R, N]
  ), z = Ls(e, g);
  return p ? {
    ...M,
    ref: z,
    type: "button",
    "aria-disabled": x ? void 0 : n,
    disabled: x,
    onClick: f,
    onMouseDown: o,
    onMouseUp: s,
    onKeyUp: d,
    onKeyDown: c,
    onMouseOver: h,
    onMouseLeave: N
  } : {
    ...M,
    ref: z,
    role: "button",
    "data-active": OV(R),
    "aria-disabled": n ? "true" : void 0,
    tabIndex: x ? void 0 : y,
    onClick: f,
    onMouseDown: ne,
    onMouseUp: O,
    onKeyUp: Q,
    onKeyDown: Y,
    onMouseOver: T,
    onMouseLeave: Z
  };
}
function dbe(t) {
  const e = t.current;
  if (!e)
    return !1;
  const n = XZe(e);
  return !n || e.contains(n) ? !1 : !!tbe(n);
}
function ube(t, e) {
  const { shouldFocus: n, visible: r, focusRef: i } = e, a = n && !r;
  HM(() => {
    if (!a || dbe(t))
      return;
    const o = (i == null ? void 0 : i.current) || t.current;
    let s;
    if (o)
      return s = requestAnimationFrame(() => {
        o.focus({ preventScroll: !0 });
      }), () => {
        cancelAnimationFrame(s);
      };
  }, [a, t, i]);
}
var Qu = (t, e) => ({
  var: t,
  varRef: e ? `var(${t}, ${e})` : `var(${t})`
}), Qr = {
  arrowShadowColor: Qu("--popper-arrow-shadow-color"),
  arrowSize: Qu("--popper-arrow-size", "8px"),
  arrowSizeHalf: Qu("--popper-arrow-size-half"),
  arrowBg: Qu("--popper-arrow-bg"),
  transformOrigin: Qu("--popper-transform-origin"),
  arrowOffset: Qu("--popper-arrow-offset")
};
function hbe(t) {
  if (t.includes("top"))
    return "1px 1px 0px 0 var(--popper-arrow-shadow-color)";
  if (t.includes("bottom"))
    return "-1px -1px 0px 0 var(--popper-arrow-shadow-color)";
  if (t.includes("right"))
    return "-1px 1px 0px 0 var(--popper-arrow-shadow-color)";
  if (t.includes("left"))
    return "1px -1px 0px 0 var(--popper-arrow-shadow-color)";
}
var Nbe = {
  top: "bottom center",
  "top-start": "bottom left",
  "top-end": "bottom right",
  bottom: "top center",
  "bottom-start": "top left",
  "bottom-end": "top right",
  left: "right center",
  "left-start": "right top",
  "left-end": "right bottom",
  right: "left center",
  "right-start": "left top",
  "right-end": "left bottom"
}, Mbe = (t) => Nbe[t], tk = {
  scroll: !0,
  resize: !0
};
function pbe(t) {
  let e;
  return typeof t == "object" ? e = {
    enabled: !0,
    options: { ...tk, ...t }
  } : e = {
    enabled: t,
    options: tk
  }, e;
}
var mbe = {
  name: "matchWidth",
  enabled: !0,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: ({ state: t }) => {
    t.styles.popper.width = `${t.rects.reference.width}px`;
  },
  effect: ({ state: t }) => () => {
    const e = t.elements.reference;
    t.elements.popper.style.width = `${e.offsetWidth}px`;
  }
}, Tbe = {
  name: "transformOrigin",
  enabled: !0,
  phase: "write",
  fn: ({ state: t }) => {
    nk(t);
  },
  effect: ({ state: t }) => () => {
    nk(t);
  }
}, nk = (t) => {
  t.elements.popper.style.setProperty(
    Qr.transformOrigin.var,
    Mbe(t.placement)
  );
}, fbe = {
  name: "positionArrow",
  enabled: !0,
  phase: "afterWrite",
  fn: ({ state: t }) => {
    Vbe(t);
  }
}, Vbe = (t) => {
  var e;
  if (!t.placement)
    return;
  const n = Ube(t.placement);
  if ((e = t.elements) != null && e.arrow && n) {
    Object.assign(t.elements.arrow.style, {
      [n.property]: n.value,
      width: Qr.arrowSize.varRef,
      height: Qr.arrowSize.varRef,
      zIndex: -1
    });
    const r = {
      [Qr.arrowSizeHalf.var]: `calc(${Qr.arrowSize.varRef} / 2 - 1px)`,
      [Qr.arrowOffset.var]: `calc(${Qr.arrowSizeHalf.varRef} * -1)`
    };
    for (const i in r)
      t.elements.arrow.style.setProperty(i, r[i]);
  }
}, Ube = (t) => {
  if (t.startsWith("top"))
    return { property: "bottom", value: Qr.arrowOffset.varRef };
  if (t.startsWith("bottom"))
    return { property: "top", value: Qr.arrowOffset.varRef };
  if (t.startsWith("left"))
    return { property: "right", value: Qr.arrowOffset.varRef };
  if (t.startsWith("right"))
    return { property: "left", value: Qr.arrowOffset.varRef };
}, Rbe = {
  name: "innerArrow",
  enabled: !0,
  phase: "main",
  requires: ["arrow"],
  fn: ({ state: t }) => {
    rk(t);
  },
  effect: ({ state: t }) => () => {
    rk(t);
  }
}, rk = (t) => {
  if (!t.elements.arrow)
    return;
  const e = t.elements.arrow.querySelector(
    "[data-popper-arrow-inner]"
  );
  if (!e)
    return;
  const n = hbe(t.placement);
  n && e.style.setProperty("--popper-arrow-default-shadow", n), Object.assign(e.style, {
    transform: "rotate(45deg)",
    background: Qr.arrowBg.varRef,
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    position: "absolute",
    zIndex: "inherit",
    boxShadow: "var(--popper-arrow-shadow, var(--popper-arrow-default-shadow))"
  });
}, gbe = {
  "start-start": { ltr: "left-start", rtl: "right-start" },
  "start-end": { ltr: "left-end", rtl: "right-end" },
  "end-start": { ltr: "right-start", rtl: "left-start" },
  "end-end": { ltr: "right-end", rtl: "left-end" },
  start: { ltr: "left", rtl: "right" },
  end: { ltr: "right", rtl: "left" }
}, ybe = {
  "auto-start": "auto-end",
  "auto-end": "auto-start",
  "top-start": "top-end",
  "top-end": "top-start",
  "bottom-start": "bottom-end",
  "bottom-end": "bottom-start"
};
function Zbe(t, e = "ltr") {
  var n, r;
  const i = ((n = gbe[t]) == null ? void 0 : n[e]) || t;
  return e === "ltr" ? i : (r = ybe[t]) != null ? r : i;
}
var Wi = "top", ja = "bottom", Da = "right", ji = "left", Ux = "auto", Tm = [Wi, ja, Da, ji], Wh = "start", ep = "end", bbe = "clippingParents", z9 = "viewport", FN = "popper", Ebe = "reference", ik = /* @__PURE__ */ Tm.reduce(function(t, e) {
  return t.concat([e + "-" + Wh, e + "-" + ep]);
}, []), k9 = /* @__PURE__ */ [].concat(Tm, [Ux]).reduce(function(t, e) {
  return t.concat([e, e + "-" + Wh, e + "-" + ep]);
}, []), Sbe = "beforeRead", xbe = "read", Wbe = "afterRead", jbe = "beforeMain", Dbe = "main", zbe = "afterMain", kbe = "beforeWrite", wbe = "write", Fbe = "afterWrite", vbe = [Sbe, xbe, Wbe, jbe, Dbe, zbe, kbe, wbe, Fbe];
function Go(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function ia(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function Pd(t) {
  var e = ia(t).Element;
  return t instanceof e || t instanceof Element;
}
function Sa(t) {
  var e = ia(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function Rx(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = ia(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function Ibe(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(n) {
    var r = e.styles[n] || {}, i = e.attributes[n] || {}, a = e.elements[n];
    !Sa(a) || !Go(a) || (Object.assign(a.style, r), Object.keys(i).forEach(function(o) {
      var s = i[o];
      s === !1 ? a.removeAttribute(o) : a.setAttribute(o, s === !0 ? "" : s);
    }));
  });
}
function Obe(t) {
  var e = t.state, n = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, n.popper), e.styles = n, e.elements.arrow && Object.assign(e.elements.arrow.style, n.arrow), function() {
    Object.keys(e.elements).forEach(function(r) {
      var i = e.elements[r], a = e.attributes[r] || {}, o = Object.keys(e.styles.hasOwnProperty(r) ? e.styles[r] : n[r]), s = o.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !Sa(i) || !Go(i) || (Object.assign(i.style, s), Object.keys(a).forEach(function(l) {
        i.removeAttribute(l);
      }));
    });
  };
}
const Ybe = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Ibe,
  effect: Obe,
  requires: ["computeStyles"]
};
function jo(t) {
  return t.split("-")[0];
}
var jd = Math.max, t2 = Math.min, jh = Math.round;
function eE() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function w9() {
  return !/^((?!chrome|android).)*safari/i.test(eE());
}
function Dh(t, e, n) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  var r = t.getBoundingClientRect(), i = 1, a = 1;
  e && Sa(t) && (i = t.offsetWidth > 0 && jh(r.width) / t.offsetWidth || 1, a = t.offsetHeight > 0 && jh(r.height) / t.offsetHeight || 1);
  var o = Pd(t) ? ia(t) : window, s = o.visualViewport, l = !w9() && n, c = (r.left + (l && s ? s.offsetLeft : 0)) / i, d = (r.top + (l && s ? s.offsetTop : 0)) / a, u = r.width / i, h = r.height / a;
  return {
    width: u,
    height: h,
    top: d,
    right: c + u,
    bottom: d + h,
    left: c,
    x: c,
    y: d
  };
}
function gx(t) {
  var e = Dh(t), n = t.offsetWidth, r = t.offsetHeight;
  return Math.abs(e.width - n) <= 1 && (n = e.width), Math.abs(e.height - r) <= 1 && (r = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: n,
    height: r
  };
}
function F9(t, e) {
  var n = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (n && Rx(n)) {
    var r = e;
    do {
      if (r && t.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Js(t) {
  return ia(t).getComputedStyle(t);
}
function Qbe(t) {
  return ["table", "td", "th"].indexOf(Go(t)) >= 0;
}
function zc(t) {
  return ((Pd(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function XU(t) {
  return Go(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (Rx(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    zc(t)
  );
}
function ak(t) {
  return !Sa(t) || // https://github.com/popperjs/popper-core/issues/837
  Js(t).position === "fixed" ? null : t.offsetParent;
}
function Gbe(t) {
  var e = /firefox/i.test(eE()), n = /Trident/i.test(eE());
  if (n && Sa(t)) {
    var r = Js(t);
    if (r.position === "fixed")
      return null;
  }
  var i = XU(t);
  for (Rx(i) && (i = i.host); Sa(i) && ["html", "body"].indexOf(Go(i)) < 0; ) {
    var a = Js(i);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || e && a.willChange === "filter" || e && a.filter && a.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function fm(t) {
  for (var e = ia(t), n = ak(t); n && Qbe(n) && Js(n).position === "static"; )
    n = ak(n);
  return n && (Go(n) === "html" || Go(n) === "body" && Js(n).position === "static") ? e : n || Gbe(t) || e;
}
function yx(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function g1(t, e, n) {
  return jd(t, t2(e, n));
}
function Cbe(t, e, n) {
  var r = g1(t, e, n);
  return r > n ? n : r;
}
function v9() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function I9(t) {
  return Object.assign({}, v9(), t);
}
function O9(t, e) {
  return e.reduce(function(n, r) {
    return n[r] = t, n;
  }, {});
}
var Lbe = function(e, n) {
  return e = typeof e == "function" ? e(Object.assign({}, n.rects, {
    placement: n.placement
  })) : e, I9(typeof e != "number" ? e : O9(e, Tm));
};
function Jbe(t) {
  var e, n = t.state, r = t.name, i = t.options, a = n.elements.arrow, o = n.modifiersData.popperOffsets, s = jo(n.placement), l = yx(s), c = [ji, Da].indexOf(s) >= 0, d = c ? "height" : "width";
  if (!(!a || !o)) {
    var u = Lbe(i.padding, n), h = gx(a), N = l === "y" ? Wi : ji, M = l === "y" ? ja : Da, p = n.rects.reference[d] + n.rects.reference[l] - o[l] - n.rects.popper[d], m = o[l] - n.rects.reference[l], R = fm(a), V = R ? l === "y" ? R.clientHeight || 0 : R.clientWidth || 0 : 0, U = p / 2 - m / 2, g = u[N], y = V - h[d] - u[M], x = V / 2 - h[d] / 2 + U, f = g1(g, x, y), D = l;
    n.modifiersData[r] = (e = {}, e[D] = f, e.centerOffset = f - x, e);
  }
}
function Bbe(t) {
  var e = t.state, n = t.options, r = n.element, i = r === void 0 ? "[data-popper-arrow]" : r;
  i != null && (typeof i == "string" && (i = e.elements.popper.querySelector(i), !i) || F9(e.elements.popper, i) && (e.elements.arrow = i));
}
const Abe = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Jbe,
  effect: Bbe,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function zh(t) {
  return t.split("-")[1];
}
var Hbe = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Xbe(t, e) {
  var n = t.x, r = t.y, i = e.devicePixelRatio || 1;
  return {
    x: jh(n * i) / i || 0,
    y: jh(r * i) / i || 0
  };
}
function ok(t) {
  var e, n = t.popper, r = t.popperRect, i = t.placement, a = t.variation, o = t.offsets, s = t.position, l = t.gpuAcceleration, c = t.adaptive, d = t.roundOffsets, u = t.isFixed, h = o.x, N = h === void 0 ? 0 : h, M = o.y, p = M === void 0 ? 0 : M, m = typeof d == "function" ? d({
    x: N,
    y: p
  }) : {
    x: N,
    y: p
  };
  N = m.x, p = m.y;
  var R = o.hasOwnProperty("x"), V = o.hasOwnProperty("y"), U = ji, g = Wi, y = window;
  if (c) {
    var x = fm(n), f = "clientHeight", D = "clientWidth";
    if (x === ia(n) && (x = zc(n), Js(x).position !== "static" && s === "absolute" && (f = "scrollHeight", D = "scrollWidth")), x = x, i === Wi || (i === ji || i === Da) && a === ep) {
      g = ja;
      var Y = u && x === y && y.visualViewport ? y.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        x[f]
      );
      p -= Y - r.height, p *= l ? 1 : -1;
    }
    if (i === ji || (i === Wi || i === ja) && a === ep) {
      U = Da;
      var Q = u && x === y && y.visualViewport ? y.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        x[D]
      );
      N -= Q - r.width, N *= l ? 1 : -1;
    }
  }
  var G = Object.assign({
    position: s
  }, c && Hbe), ne = d === !0 ? Xbe({
    x: N,
    y: p
  }, ia(n)) : {
    x: N,
    y: p
  };
  if (N = ne.x, p = ne.y, l) {
    var O;
    return Object.assign({}, G, (O = {}, O[g] = V ? "0" : "", O[U] = R ? "0" : "", O.transform = (y.devicePixelRatio || 1) <= 1 ? "translate(" + N + "px, " + p + "px)" : "translate3d(" + N + "px, " + p + "px, 0)", O));
  }
  return Object.assign({}, G, (e = {}, e[g] = V ? p + "px" : "", e[U] = R ? N + "px" : "", e.transform = "", e));
}
function _be(t) {
  var e = t.state, n = t.options, r = n.gpuAcceleration, i = r === void 0 ? !0 : r, a = n.adaptive, o = a === void 0 ? !0 : a, s = n.roundOffsets, l = s === void 0 ? !0 : s, c = {
    placement: jo(e.placement),
    variation: zh(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: i,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, ok(Object.assign({}, c, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: o,
    roundOffsets: l
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, ok(Object.assign({}, c, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const Pbe = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: _be,
  data: {}
};
var TT = {
  passive: !0
};
function Kbe(t) {
  var e = t.state, n = t.instance, r = t.options, i = r.scroll, a = i === void 0 ? !0 : i, o = r.resize, s = o === void 0 ? !0 : o, l = ia(e.elements.popper), c = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return a && c.forEach(function(d) {
    d.addEventListener("scroll", n.update, TT);
  }), s && l.addEventListener("resize", n.update, TT), function() {
    a && c.forEach(function(d) {
      d.removeEventListener("scroll", n.update, TT);
    }), s && l.removeEventListener("resize", n.update, TT);
  };
}
const $be = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Kbe,
  data: {}
};
var qbe = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function uf(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return qbe[e];
  });
}
var eEe = {
  start: "end",
  end: "start"
};
function sk(t) {
  return t.replace(/start|end/g, function(e) {
    return eEe[e];
  });
}
function Zx(t) {
  var e = ia(t), n = e.pageXOffset, r = e.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function bx(t) {
  return Dh(zc(t)).left + Zx(t).scrollLeft;
}
function tEe(t, e) {
  var n = ia(t), r = zc(t), i = n.visualViewport, a = r.clientWidth, o = r.clientHeight, s = 0, l = 0;
  if (i) {
    a = i.width, o = i.height;
    var c = w9();
    (c || !c && e === "fixed") && (s = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: a,
    height: o,
    x: s + bx(t),
    y: l
  };
}
function nEe(t) {
  var e, n = zc(t), r = Zx(t), i = (e = t.ownerDocument) == null ? void 0 : e.body, a = jd(n.scrollWidth, n.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), o = jd(n.scrollHeight, n.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), s = -r.scrollLeft + bx(t), l = -r.scrollTop;
  return Js(i || n).direction === "rtl" && (s += jd(n.clientWidth, i ? i.clientWidth : 0) - a), {
    width: a,
    height: o,
    x: s,
    y: l
  };
}
function Ex(t) {
  var e = Js(t), n = e.overflow, r = e.overflowX, i = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + i + r);
}
function Y9(t) {
  return ["html", "body", "#document"].indexOf(Go(t)) >= 0 ? t.ownerDocument.body : Sa(t) && Ex(t) ? t : Y9(XU(t));
}
function y1(t, e) {
  var n;
  e === void 0 && (e = []);
  var r = Y9(t), i = r === ((n = t.ownerDocument) == null ? void 0 : n.body), a = ia(r), o = i ? [a].concat(a.visualViewport || [], Ex(r) ? r : []) : r, s = e.concat(o);
  return i ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(y1(XU(o)))
  );
}
function tE(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function rEe(t, e) {
  var n = Dh(t, !1, e === "fixed");
  return n.top = n.top + t.clientTop, n.left = n.left + t.clientLeft, n.bottom = n.top + t.clientHeight, n.right = n.left + t.clientWidth, n.width = t.clientWidth, n.height = t.clientHeight, n.x = n.left, n.y = n.top, n;
}
function lk(t, e, n) {
  return e === z9 ? tE(tEe(t, n)) : Pd(e) ? rEe(e, n) : tE(nEe(zc(t)));
}
function iEe(t) {
  var e = y1(XU(t)), n = ["absolute", "fixed"].indexOf(Js(t).position) >= 0, r = n && Sa(t) ? fm(t) : t;
  return Pd(r) ? e.filter(function(i) {
    return Pd(i) && F9(i, r) && Go(i) !== "body";
  }) : [];
}
function aEe(t, e, n, r) {
  var i = e === "clippingParents" ? iEe(t) : [].concat(e), a = [].concat(i, [n]), o = a[0], s = a.reduce(function(l, c) {
    var d = lk(t, c, r);
    return l.top = jd(d.top, l.top), l.right = t2(d.right, l.right), l.bottom = t2(d.bottom, l.bottom), l.left = jd(d.left, l.left), l;
  }, lk(t, o, r));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function Q9(t) {
  var e = t.reference, n = t.element, r = t.placement, i = r ? jo(r) : null, a = r ? zh(r) : null, o = e.x + e.width / 2 - n.width / 2, s = e.y + e.height / 2 - n.height / 2, l;
  switch (i) {
    case Wi:
      l = {
        x: o,
        y: e.y - n.height
      };
      break;
    case ja:
      l = {
        x: o,
        y: e.y + e.height
      };
      break;
    case Da:
      l = {
        x: e.x + e.width,
        y: s
      };
      break;
    case ji:
      l = {
        x: e.x - n.width,
        y: s
      };
      break;
    default:
      l = {
        x: e.x,
        y: e.y
      };
  }
  var c = i ? yx(i) : null;
  if (c != null) {
    var d = c === "y" ? "height" : "width";
    switch (a) {
      case Wh:
        l[c] = l[c] - (e[d] / 2 - n[d] / 2);
        break;
      case ep:
        l[c] = l[c] + (e[d] / 2 - n[d] / 2);
        break;
    }
  }
  return l;
}
function tp(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, i = r === void 0 ? t.placement : r, a = n.strategy, o = a === void 0 ? t.strategy : a, s = n.boundary, l = s === void 0 ? bbe : s, c = n.rootBoundary, d = c === void 0 ? z9 : c, u = n.elementContext, h = u === void 0 ? FN : u, N = n.altBoundary, M = N === void 0 ? !1 : N, p = n.padding, m = p === void 0 ? 0 : p, R = I9(typeof m != "number" ? m : O9(m, Tm)), V = h === FN ? Ebe : FN, U = t.rects.popper, g = t.elements[M ? V : h], y = aEe(Pd(g) ? g : g.contextElement || zc(t.elements.popper), l, d, o), x = Dh(t.elements.reference), f = Q9({
    reference: x,
    element: U,
    strategy: "absolute",
    placement: i
  }), D = tE(Object.assign({}, U, f)), Y = h === FN ? D : x, Q = {
    top: y.top - Y.top + R.top,
    bottom: Y.bottom - y.bottom + R.bottom,
    left: y.left - Y.left + R.left,
    right: Y.right - y.right + R.right
  }, G = t.modifiersData.offset;
  if (h === FN && G) {
    var ne = G[i];
    Object.keys(Q).forEach(function(O) {
      var T = [Da, ja].indexOf(O) >= 0 ? 1 : -1, Z = [Wi, ja].indexOf(O) >= 0 ? "y" : "x";
      Q[O] += ne[Z] * T;
    });
  }
  return Q;
}
function oEe(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, i = n.boundary, a = n.rootBoundary, o = n.padding, s = n.flipVariations, l = n.allowedAutoPlacements, c = l === void 0 ? k9 : l, d = zh(r), u = d ? s ? ik : ik.filter(function(M) {
    return zh(M) === d;
  }) : Tm, h = u.filter(function(M) {
    return c.indexOf(M) >= 0;
  });
  h.length === 0 && (h = u);
  var N = h.reduce(function(M, p) {
    return M[p] = tp(t, {
      placement: p,
      boundary: i,
      rootBoundary: a,
      padding: o
    })[jo(p)], M;
  }, {});
  return Object.keys(N).sort(function(M, p) {
    return N[M] - N[p];
  });
}
function sEe(t) {
  if (jo(t) === Ux)
    return [];
  var e = uf(t);
  return [sk(t), e, sk(e)];
}
function lEe(t) {
  var e = t.state, n = t.options, r = t.name;
  if (!e.modifiersData[r]._skip) {
    for (var i = n.mainAxis, a = i === void 0 ? !0 : i, o = n.altAxis, s = o === void 0 ? !0 : o, l = n.fallbackPlacements, c = n.padding, d = n.boundary, u = n.rootBoundary, h = n.altBoundary, N = n.flipVariations, M = N === void 0 ? !0 : N, p = n.allowedAutoPlacements, m = e.options.placement, R = jo(m), V = R === m, U = l || (V || !M ? [uf(m)] : sEe(m)), g = [m].concat(U).reduce(function(ae, oe) {
      return ae.concat(jo(oe) === Ux ? oEe(e, {
        placement: oe,
        boundary: d,
        rootBoundary: u,
        padding: c,
        flipVariations: M,
        allowedAutoPlacements: p
      }) : oe);
    }, []), y = e.rects.reference, x = e.rects.popper, f = /* @__PURE__ */ new Map(), D = !0, Y = g[0], Q = 0; Q < g.length; Q++) {
      var G = g[Q], ne = jo(G), O = zh(G) === Wh, T = [Wi, ja].indexOf(ne) >= 0, Z = T ? "width" : "height", z = tp(e, {
        placement: G,
        boundary: d,
        rootBoundary: u,
        altBoundary: h,
        padding: c
      }), j = T ? O ? Da : ji : O ? ja : Wi;
      y[Z] > x[Z] && (j = uf(j));
      var w = uf(j), C = [];
      if (a && C.push(z[ne] <= 0), s && C.push(z[j] <= 0, z[w] <= 0), C.every(function(ae) {
        return ae;
      })) {
        Y = G, D = !1;
        break;
      }
      f.set(G, C);
    }
    if (D)
      for (var J = M ? 3 : 1, I = function(oe) {
        var le = g.find(function(fe) {
          var de = f.get(fe);
          if (de)
            return de.slice(0, oe).every(function(Me) {
              return Me;
            });
        });
        if (le)
          return Y = le, "break";
      }, b = J; b > 0; b--) {
        var k = I(b);
        if (k === "break")
          break;
      }
    e.placement !== Y && (e.modifiersData[r]._skip = !0, e.placement = Y, e.reset = !0);
  }
}
const cEe = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: lEe,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function ck(t, e, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - n.y,
    right: t.right - e.width + n.x,
    bottom: t.bottom - e.height + n.y,
    left: t.left - e.width - n.x
  };
}
function dk(t) {
  return [Wi, Da, ja, ji].some(function(e) {
    return t[e] >= 0;
  });
}
function dEe(t) {
  var e = t.state, n = t.name, r = e.rects.reference, i = e.rects.popper, a = e.modifiersData.preventOverflow, o = tp(e, {
    elementContext: "reference"
  }), s = tp(e, {
    altBoundary: !0
  }), l = ck(o, r), c = ck(s, i, a), d = dk(l), u = dk(c);
  e.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: c,
    isReferenceHidden: d,
    hasPopperEscaped: u
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": u
  });
}
const uEe = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: dEe
};
function hEe(t, e, n) {
  var r = jo(t), i = [ji, Wi].indexOf(r) >= 0 ? -1 : 1, a = typeof n == "function" ? n(Object.assign({}, e, {
    placement: t
  })) : n, o = a[0], s = a[1];
  return o = o || 0, s = (s || 0) * i, [ji, Da].indexOf(r) >= 0 ? {
    x: s,
    y: o
  } : {
    x: o,
    y: s
  };
}
function NEe(t) {
  var e = t.state, n = t.options, r = t.name, i = n.offset, a = i === void 0 ? [0, 0] : i, o = k9.reduce(function(d, u) {
    return d[u] = hEe(u, e.rects, a), d;
  }, {}), s = o[e.placement], l = s.x, c = s.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += c), e.modifiersData[r] = o;
}
const MEe = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: NEe
};
function pEe(t) {
  var e = t.state, n = t.name;
  e.modifiersData[n] = Q9({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const mEe = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: pEe,
  data: {}
};
function TEe(t) {
  return t === "x" ? "y" : "x";
}
function fEe(t) {
  var e = t.state, n = t.options, r = t.name, i = n.mainAxis, a = i === void 0 ? !0 : i, o = n.altAxis, s = o === void 0 ? !1 : o, l = n.boundary, c = n.rootBoundary, d = n.altBoundary, u = n.padding, h = n.tether, N = h === void 0 ? !0 : h, M = n.tetherOffset, p = M === void 0 ? 0 : M, m = tp(e, {
    boundary: l,
    rootBoundary: c,
    padding: u,
    altBoundary: d
  }), R = jo(e.placement), V = zh(e.placement), U = !V, g = yx(R), y = TEe(g), x = e.modifiersData.popperOffsets, f = e.rects.reference, D = e.rects.popper, Y = typeof p == "function" ? p(Object.assign({}, e.rects, {
    placement: e.placement
  })) : p, Q = typeof Y == "number" ? {
    mainAxis: Y,
    altAxis: Y
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, Y), G = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, ne = {
    x: 0,
    y: 0
  };
  if (x) {
    if (a) {
      var O, T = g === "y" ? Wi : ji, Z = g === "y" ? ja : Da, z = g === "y" ? "height" : "width", j = x[g], w = j + m[T], C = j - m[Z], J = N ? -D[z] / 2 : 0, I = V === Wh ? f[z] : D[z], b = V === Wh ? -D[z] : -f[z], k = e.elements.arrow, ae = N && k ? gx(k) : {
        width: 0,
        height: 0
      }, oe = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : v9(), le = oe[T], fe = oe[Z], de = g1(0, f[z], ae[z]), Me = U ? f[z] / 2 - J - de - le - Q.mainAxis : I - de - le - Q.mainAxis, je = U ? -f[z] / 2 + J + de + fe + Q.mainAxis : b + de + fe + Q.mainAxis, Se = e.elements.arrow && fm(e.elements.arrow), se = Se ? g === "y" ? Se.clientTop || 0 : Se.clientLeft || 0 : 0, Ce = (O = G == null ? void 0 : G[g]) != null ? O : 0, et = j + Me - Ce - se, at = j + je - Ce, Rn = g1(N ? t2(w, et) : w, j, N ? jd(C, at) : C);
      x[g] = Rn, ne[g] = Rn - j;
    }
    if (s) {
      var Zt, kt = g === "x" ? Wi : ji, Pn = g === "x" ? ja : Da, Oe = x[y], Xe = y === "y" ? "height" : "width", ft = Oe + m[kt], Le = Oe - m[Pn], dt = [Wi, ji].indexOf(R) !== -1, Dt = (Zt = G == null ? void 0 : G[y]) != null ? Zt : 0, ut = dt ? ft : Oe - f[Xe] - D[Xe] - Dt + Q.altAxis, v = dt ? Oe + f[Xe] + D[Xe] - Dt - Q.altAxis : Le, S = N && dt ? Cbe(ut, Oe, v) : g1(N ? ut : ft, Oe, N ? v : Le);
      x[y] = S, ne[y] = S - Oe;
    }
    e.modifiersData[r] = ne;
  }
}
const VEe = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: fEe,
  requiresIfExists: ["offset"]
};
function UEe(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function REe(t) {
  return t === ia(t) || !Sa(t) ? Zx(t) : UEe(t);
}
function gEe(t) {
  var e = t.getBoundingClientRect(), n = jh(e.width) / t.offsetWidth || 1, r = jh(e.height) / t.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function yEe(t, e, n) {
  n === void 0 && (n = !1);
  var r = Sa(e), i = Sa(e) && gEe(e), a = zc(e), o = Dh(t, i, n), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((Go(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Ex(a)) && (s = REe(e)), Sa(e) ? (l = Dh(e, !0), l.x += e.clientLeft, l.y += e.clientTop) : a && (l.x = bx(a))), {
    x: o.left + s.scrollLeft - l.x,
    y: o.top + s.scrollTop - l.y,
    width: o.width,
    height: o.height
  };
}
function ZEe(t) {
  var e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  t.forEach(function(a) {
    e.set(a.name, a);
  });
  function i(a) {
    n.add(a.name);
    var o = [].concat(a.requires || [], a.requiresIfExists || []);
    o.forEach(function(s) {
      if (!n.has(s)) {
        var l = e.get(s);
        l && i(l);
      }
    }), r.push(a);
  }
  return t.forEach(function(a) {
    n.has(a.name) || i(a);
  }), r;
}
function bEe(t) {
  var e = ZEe(t);
  return vbe.reduce(function(n, r) {
    return n.concat(e.filter(function(i) {
      return i.phase === r;
    }));
  }, []);
}
function EEe(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(n) {
      Promise.resolve().then(function() {
        e = void 0, n(t());
      });
    })), e;
  };
}
function SEe(t) {
  var e = t.reduce(function(n, r) {
    var i = n[r.name];
    return n[r.name] = i ? Object.assign({}, i, r, {
      options: Object.assign({}, i.options, r.options),
      data: Object.assign({}, i.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(e).map(function(n) {
    return e[n];
  });
}
var uk = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function hk() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return !e.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function xEe(t) {
  t === void 0 && (t = {});
  var e = t, n = e.defaultModifiers, r = n === void 0 ? [] : n, i = e.defaultOptions, a = i === void 0 ? uk : i;
  return function(s, l, c) {
    c === void 0 && (c = a);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, uk, a),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, u = [], h = !1, N = {
      state: d,
      setOptions: function(R) {
        var V = typeof R == "function" ? R(d.options) : R;
        p(), d.options = Object.assign({}, a, d.options, V), d.scrollParents = {
          reference: Pd(s) ? y1(s) : s.contextElement ? y1(s.contextElement) : [],
          popper: y1(l)
        };
        var U = bEe(SEe([].concat(r, d.options.modifiers)));
        return d.orderedModifiers = U.filter(function(g) {
          return g.enabled;
        }), M(), N.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!h) {
          var R = d.elements, V = R.reference, U = R.popper;
          if (hk(V, U)) {
            d.rects = {
              reference: yEe(V, fm(U), d.options.strategy === "fixed"),
              popper: gx(U)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(Q) {
              return d.modifiersData[Q.name] = Object.assign({}, Q.data);
            });
            for (var g = 0; g < d.orderedModifiers.length; g++) {
              if (d.reset === !0) {
                d.reset = !1, g = -1;
                continue;
              }
              var y = d.orderedModifiers[g], x = y.fn, f = y.options, D = f === void 0 ? {} : f, Y = y.name;
              typeof x == "function" && (d = x({
                state: d,
                options: D,
                name: Y,
                instance: N
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: EEe(function() {
        return new Promise(function(m) {
          N.forceUpdate(), m(d);
        });
      }),
      destroy: function() {
        p(), h = !0;
      }
    };
    if (!hk(s, l))
      return N;
    N.setOptions(c).then(function(m) {
      !h && c.onFirstUpdate && c.onFirstUpdate(m);
    });
    function M() {
      d.orderedModifiers.forEach(function(m) {
        var R = m.name, V = m.options, U = V === void 0 ? {} : V, g = m.effect;
        if (typeof g == "function") {
          var y = g({
            state: d,
            name: R,
            instance: N,
            options: U
          }), x = function() {
          };
          u.push(y || x);
        }
      });
    }
    function p() {
      u.forEach(function(m) {
        return m();
      }), u = [];
    }
    return N;
  };
}
var WEe = [$be, mEe, Pbe, Ybe, MEe, cEe, VEe, Abe, uEe], jEe = /* @__PURE__ */ xEe({
  defaultModifiers: WEe
});
function G9(t = {}) {
  const {
    enabled: e = !0,
    modifiers: n,
    placement: r = "bottom",
    strategy: i = "absolute",
    arrowPadding: a = 8,
    eventListeners: o = !0,
    offset: s,
    gutter: l = 8,
    flip: c = !0,
    boundary: d = "clippingParents",
    preventOverflow: u = !0,
    matchWidth: h,
    direction: N = "ltr"
  } = t, M = Ve(null), p = Ve(null), m = Ve(null), R = Zbe(r, N), V = Ve(() => {
  }), U = De(() => {
    var Q;
    !e || !M.current || !p.current || ((Q = V.current) == null || Q.call(V), m.current = jEe(M.current, p.current, {
      placement: R,
      modifiers: [
        Rbe,
        fbe,
        Tbe,
        {
          ...mbe,
          enabled: !!h
        },
        {
          name: "eventListeners",
          ...pbe(o)
        },
        {
          name: "arrow",
          options: { padding: a }
        },
        {
          name: "offset",
          options: {
            offset: s ?? [0, l]
          }
        },
        {
          name: "flip",
          enabled: !!c,
          options: { padding: 8 }
        },
        {
          name: "preventOverflow",
          enabled: !!u,
          options: { boundary: d }
        },
        // allow users override internal modifiers
        ...n ?? []
      ],
      strategy: i
    }), m.current.forceUpdate(), V.current = m.current.destroy);
  }, [
    R,
    e,
    n,
    h,
    o,
    a,
    s,
    l,
    c,
    u,
    d,
    i
  ]);
  Ee(() => () => {
    var Q;
    !M.current && !p.current && ((Q = m.current) == null || Q.destroy(), m.current = null);
  }, []);
  const g = De(
    (Q) => {
      M.current = Q, U();
    },
    [U]
  ), y = De(
    (Q = {}, G = null) => ({
      ...Q,
      ref: Ls(g, G)
    }),
    [g]
  ), x = De(
    (Q) => {
      p.current = Q, U();
    },
    [U]
  ), f = De(
    (Q = {}, G = null) => ({
      ...Q,
      ref: Ls(x, G),
      style: {
        ...Q.style,
        position: i,
        minWidth: h ? void 0 : "max-content",
        inset: "0 auto auto 0"
      }
    }),
    [i, x, h]
  ), D = De((Q = {}, G = null) => {
    const { size: ne, shadowColor: O, bg: T, style: Z, ...z } = Q;
    return {
      ...z,
      ref: G,
      "data-popper-arrow": "",
      style: DEe(Q)
    };
  }, []), Y = De(
    (Q = {}, G = null) => ({
      ...Q,
      ref: G,
      "data-popper-arrow-inner": ""
    }),
    []
  );
  return {
    update() {
      var Q;
      (Q = m.current) == null || Q.update();
    },
    forceUpdate() {
      var Q;
      (Q = m.current) == null || Q.forceUpdate();
    },
    transformOrigin: Qr.transformOrigin.varRef,
    referenceRef: g,
    popperRef: x,
    getPopperProps: f,
    getArrowProps: D,
    getArrowInnerProps: Y,
    getReferenceProps: y
  };
}
function DEe(t) {
  const { size: e, shadowColor: n, bg: r, style: i } = t, a = { ...i, position: "absolute" };
  return e && (a["--popper-arrow-size"] = e), n && (a["--popper-arrow-shadow-color"] = n), r && (a["--popper-arrow-bg"] = r), a;
}
function C9(t = {}) {
  const {
    onClose: e,
    onOpen: n,
    isOpen: r,
    id: i
  } = t, a = AM(n), o = AM(e), [s, l] = nt(t.defaultIsOpen || !1), c = r !== void 0 ? r : s, d = r !== void 0, u = nu(), h = i ?? `disclosure-${u}`, N = De(() => {
    d || l(!1), o == null || o();
  }, [d, o]), M = De(() => {
    d || l(!0), a == null || a();
  }, [d, a]), p = De(() => {
    c ? N() : M();
  }, [c, M, N]);
  function m(V = {}) {
    return {
      ...V,
      "aria-expanded": c,
      "aria-controls": h,
      onClick(U) {
        var g;
        (g = V.onClick) == null || g.call(V, U), p();
      }
    };
  }
  function R(V = {}) {
    return {
      ...V,
      hidden: !c,
      id: h
    };
  }
  return {
    isOpen: c,
    onOpen: M,
    onClose: N,
    onToggle: p,
    isControlled: d,
    getButtonProps: m,
    getDisclosureProps: R
  };
}
function zEe(t) {
  const { ref: e, handler: n, enabled: r = !0 } = t, i = AM(n), o = Ve({
    isPointerDown: !1,
    ignoreEmulatedMouseEvents: !1
  }).current;
  Ee(() => {
    if (!r)
      return;
    const s = (u) => {
      sy(u, e) && (o.isPointerDown = !0);
    }, l = (u) => {
      if (o.ignoreEmulatedMouseEvents) {
        o.ignoreEmulatedMouseEvents = !1;
        return;
      }
      o.isPointerDown && n && sy(u, e) && (o.isPointerDown = !1, i(u));
    }, c = (u) => {
      o.ignoreEmulatedMouseEvents = !0, n && o.isPointerDown && sy(u, e) && (o.isPointerDown = !1, i(u));
    }, d = L9(e.current);
    return d.addEventListener("mousedown", s, !0), d.addEventListener("mouseup", l, !0), d.addEventListener("touchstart", s, !0), d.addEventListener("touchend", c, !0), () => {
      d.removeEventListener("mousedown", s, !0), d.removeEventListener("mouseup", l, !0), d.removeEventListener("touchstart", s, !0), d.removeEventListener("touchend", c, !0);
    };
  }, [n, e, i, o, r]);
}
function sy(t, e) {
  var n;
  const r = t.target;
  return r && !L9(r).contains(r) ? !1 : !((n = e.current) != null && n.contains(r));
}
function L9(t) {
  var e;
  return (e = t == null ? void 0 : t.ownerDocument) != null ? e : document;
}
function kEe(t) {
  const { isOpen: e, ref: n } = t, [r, i] = nt(e), [a, o] = nt(!1);
  return Ee(() => {
    a || (i(e), o(!0));
  }, [e, a, r]), df(
    () => n.current,
    "animationend",
    () => {
      i(e);
    }
  ), {
    present: !(e ? !1 : !r),
    onComplete() {
      var l;
      const c = HZe(n.current), d = new c.CustomEvent("animationend", { bubbles: !0 });
      (l = n.current) == null || l.dispatchEvent(d);
    }
  };
}
function wEe(t) {
  const { wasSelected: e, enabled: n, isSelected: r, mode: i = "unmount" } = t;
  return !!(!n || r || i === "keepMounted" && e);
}
var [
  FEe,
  vEe,
  IEe,
  OEe
] = QZe(), [YEe, Vm] = Ks({
  strict: !1,
  name: "MenuContext"
});
function QEe(t, ...e) {
  const n = nu(), r = t || n;
  return vt(() => e.map((i) => `${i}-${r}`), [r, e]);
}
function J9(t) {
  var e;
  return (e = t == null ? void 0 : t.ownerDocument) != null ? e : document;
}
function Nk(t) {
  return J9(t).activeElement === t;
}
function GEe(t = {}) {
  const {
    id: e,
    closeOnSelect: n = !0,
    closeOnBlur: r = !0,
    initialFocusRef: i,
    autoSelect: a = !0,
    isLazy: o,
    isOpen: s,
    defaultIsOpen: l,
    onClose: c,
    onOpen: d,
    placement: u = "bottom-start",
    lazyBehavior: h = "unmount",
    direction: N,
    computePositionOnMount: M = !1,
    ...p
  } = t, m = Ve(null), R = Ve(null), V = IEe(), U = De(() => {
    requestAnimationFrame(() => {
      var k;
      (k = m.current) == null || k.focus({ preventScroll: !1 });
    });
  }, []), g = De(() => {
    const k = setTimeout(() => {
      var ae;
      if (i)
        (ae = i.current) == null || ae.focus();
      else {
        const oe = V.firstEnabled();
        oe && O(oe.index);
      }
    });
    w.current.add(k);
  }, [V, i]), y = De(() => {
    const k = setTimeout(() => {
      const ae = V.lastEnabled();
      ae && O(ae.index);
    });
    w.current.add(k);
  }, [V]), x = De(() => {
    d == null || d(), a ? g() : U();
  }, [a, g, U, d]), { isOpen: f, onOpen: D, onClose: Y, onToggle: Q } = C9({
    isOpen: s,
    defaultIsOpen: l,
    onClose: c,
    onOpen: x
  });
  zEe({
    enabled: f && r,
    ref: m,
    handler: (k) => {
      var ae;
      (ae = R.current) != null && ae.contains(k.target) || Y();
    }
  });
  const G = G9({
    ...p,
    enabled: f || M,
    placement: u,
    direction: N
  }), [ne, O] = nt(-1);
  HM(() => {
    f || O(-1);
  }, [f]), ube(m, {
    focusRef: R,
    visible: f,
    shouldFocus: !0
  });
  const T = kEe({ isOpen: f, ref: m }), [Z, z] = QEe(e, "menu-button", "menu-list"), j = De(() => {
    D(), U();
  }, [D, U]), w = Ve(/* @__PURE__ */ new Set([]));
  XEe(() => {
    w.current.forEach((k) => clearTimeout(k)), w.current.clear();
  });
  const C = De(() => {
    D(), g();
  }, [g, D]), J = De(() => {
    D(), y();
  }, [D, y]), I = De(() => {
    var k, ae;
    const oe = J9(m.current), le = (k = m.current) == null ? void 0 : k.contains(oe.activeElement);
    if (!(f && !le))
      return;
    const de = (ae = V.item(ne)) == null ? void 0 : ae.node;
    de == null || de.focus();
  }, [f, ne, V]), b = Ve(null);
  return {
    openAndFocusMenu: j,
    openAndFocusFirstItem: C,
    openAndFocusLastItem: J,
    onTransitionEnd: I,
    unstable__animationState: T,
    descendants: V,
    popper: G,
    buttonId: Z,
    menuId: z,
    forceUpdate: G.forceUpdate,
    orientation: "vertical",
    isOpen: f,
    onToggle: Q,
    onOpen: D,
    onClose: Y,
    menuRef: m,
    buttonRef: R,
    focusedIndex: ne,
    closeOnSelect: n,
    closeOnBlur: r,
    autoSelect: a,
    setFocusedIndex: O,
    isLazy: o,
    lazyBehavior: h,
    initialFocusRef: i,
    rafId: b
  };
}
function CEe(t = {}, e = null) {
  const n = Vm(), { onToggle: r, popper: i, openAndFocusFirstItem: a, openAndFocusLastItem: o } = n, s = De(
    (l) => {
      const c = l.key, u = {
        Enter: a,
        ArrowDown: a,
        ArrowUp: o
      }[c];
      u && (l.preventDefault(), l.stopPropagation(), u(l));
    },
    [a, o]
  );
  return {
    ...t,
    ref: Ls(n.buttonRef, e, i.referenceRef),
    id: n.buttonId,
    "data-active": OV(n.isOpen),
    "aria-expanded": n.isOpen,
    "aria-haspopup": "menu",
    "aria-controls": n.menuId,
    onClick: Zl(t.onClick, r),
    onKeyDown: Zl(t.onKeyDown, s)
  };
}
function nE(t) {
  var e;
  return AEe(t) && !!((e = t == null ? void 0 : t.getAttribute("role")) != null && e.startsWith("menuitem"));
}
function LEe(t = {}, e = null) {
  const n = Vm();
  if (!n)
    throw new Error(
      "useMenuContext: context is undefined. Seems you forgot to wrap component within <Menu>"
    );
  const {
    focusedIndex: r,
    setFocusedIndex: i,
    menuRef: a,
    isOpen: o,
    onClose: s,
    menuId: l,
    isLazy: c,
    lazyBehavior: d,
    unstable__animationState: u
  } = n, h = vEe(), N = obe({
    preventDefault: (R) => R.key !== " " && nE(R.target)
  }), M = De(
    (R) => {
      if (!R.currentTarget.contains(R.target))
        return;
      const V = R.key, g = {
        Tab: (x) => x.preventDefault(),
        Escape: s,
        ArrowDown: () => {
          const x = h.nextEnabled(r);
          x && i(x.index);
        },
        ArrowUp: () => {
          const x = h.prevEnabled(r);
          x && i(x.index);
        }
      }[V];
      if (g) {
        R.preventDefault(), g(R);
        return;
      }
      const y = N((x) => {
        const f = sbe(
          h.values(),
          x,
          (D) => {
            var Y, Q;
            return (Q = (Y = D == null ? void 0 : D.node) == null ? void 0 : Y.textContent) != null ? Q : "";
          },
          h.item(r)
        );
        if (f) {
          const D = h.indexOf(f.node);
          i(D);
        }
      });
      nE(R.target) && y(R);
    },
    [
      h,
      r,
      N,
      s,
      i
    ]
  ), p = Ve(!1);
  o && (p.current = !0);
  const m = wEe({
    wasSelected: p.current,
    enabled: c,
    mode: d,
    isSelected: u.present
  });
  return {
    ...t,
    ref: Ls(a, e),
    children: m ? t.children : null,
    tabIndex: -1,
    role: "menu",
    id: l,
    style: {
      ...t.style,
      transformOrigin: "var(--popper-transform-origin)"
    },
    "aria-orientation": "vertical",
    onKeyDown: Zl(t.onKeyDown, M)
  };
}
function JEe(t = {}) {
  const { popper: e, isOpen: n } = Vm();
  return e.getPopperProps({
    ...t,
    style: {
      visibility: n ? "visible" : "hidden",
      ...t.style
    }
  });
}
function BEe(t = {}, e = null) {
  const {
    onMouseEnter: n,
    onMouseMove: r,
    onMouseLeave: i,
    onClick: a,
    onFocus: o,
    isDisabled: s,
    isFocusable: l,
    closeOnSelect: c,
    type: d,
    ...u
  } = t, h = Vm(), {
    setFocusedIndex: N,
    focusedIndex: M,
    closeOnSelect: p,
    onClose: m,
    menuRef: R,
    isOpen: V,
    menuId: U,
    rafId: g
  } = h, y = Ve(null), x = `${U}-menuitem-${nu()}`, { index: f, register: D } = OEe({
    disabled: s && !l
  }), Y = De(
    (j) => {
      n == null || n(j), !s && N(f);
    },
    [N, f, s, n]
  ), Q = De(
    (j) => {
      r == null || r(j), y.current && !Nk(y.current) && Y(j);
    },
    [Y, r]
  ), G = De(
    (j) => {
      i == null || i(j), !s && N(-1);
    },
    [N, s, i]
  ), ne = De(
    (j) => {
      a == null || a(j), nE(j.currentTarget) && (c ?? p) && m();
    },
    [m, a, p, c]
  ), O = De(
    (j) => {
      o == null || o(j), N(f);
    },
    [N, o, f]
  ), T = f === M, Z = s && !l;
  HM(() => {
    V && (T && !Z && y.current ? (g.current && cancelAnimationFrame(g.current), g.current = requestAnimationFrame(() => {
      var j;
      (j = y.current) == null || j.focus(), g.current = null;
    })) : R.current && !Nk(R.current) && R.current.focus({ preventScroll: !0 }));
  }, [T, Z, R, V]);
  const z = cbe({
    onClick: ne,
    onFocus: O,
    onMouseEnter: Y,
    onMouseMove: Q,
    onMouseLeave: G,
    ref: Ls(D, y, e),
    isDisabled: s,
    isFocusable: l
  });
  return {
    ...u,
    ...z,
    type: d ?? z.type,
    id: x,
    role: "menuitem",
    tabIndex: T ? 0 : -1
  };
}
function AEe(t) {
  var e;
  if (!HEe(t))
    return !1;
  const n = (e = t.ownerDocument.defaultView) != null ? e : window;
  return t instanceof n.HTMLElement;
}
function HEe(t) {
  return t != null && typeof t == "object" && "nodeType" in t && t.nodeType === Node.ELEMENT_NODE;
}
function XEe(t, e = []) {
  return Ee(
    () => () => t(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e
  );
}
var [_Ee, dN] = Ks({
  name: "MenuStylesContext",
  errorMessage: `useMenuStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Menu />" `
}), B9 = (t) => {
  const { children: e } = t, n = $G("Menu", t), r = $s(t), { direction: i } = FU(), { descendants: a, ...o } = GEe({ ...r, direction: i }), s = vt(() => o, [o]), { isOpen: l, onClose: c, forceUpdate: d } = s;
  return /* @__PURE__ */ E.jsx(FEe, { value: a, children: /* @__PURE__ */ E.jsx(YEe, { value: s, children: /* @__PURE__ */ E.jsx(_Ee, { value: n, children: Ts(e, { isOpen: l, onClose: c, forceUpdate: d }) }) }) });
};
B9.displayName = "Menu";
var A9 = On(
  (t, e) => {
    const n = dN();
    return /* @__PURE__ */ E.jsx(
      Te.span,
      {
        ref: e,
        ...t,
        __css: n.command,
        className: "chakra-menu__command"
      }
    );
  }
);
A9.displayName = "MenuCommand";
var PEe = On(
  (t, e) => {
    const { type: n, ...r } = t, i = dN(), a = r.as || n ? n ?? void 0 : "button", o = vt(
      () => ({
        textDecoration: "none",
        color: "inherit",
        userSelect: "none",
        display: "flex",
        width: "100%",
        alignItems: "center",
        textAlign: "start",
        flex: "0 0 auto",
        outline: 0,
        ...i.item
      }),
      [i.item]
    );
    return /* @__PURE__ */ E.jsx(Te.button, { ref: e, type: a, ...r, __css: o });
  }
), H9 = (t) => {
  const { className: e, children: n, ...r } = t, i = dN(), a = Zo.only(n), o = _l(a) ? Tc(a, {
    focusable: "false",
    "aria-hidden": !0,
    className: gr("chakra-menu__icon", a.props.className)
  }) : null, s = gr("chakra-menu__icon-wrapper", e);
  return /* @__PURE__ */ E.jsx(Te.span, { className: s, ...r, __css: i.icon, children: o });
};
H9.displayName = "MenuIcon";
var rE = On((t, e) => {
  const {
    icon: n,
    iconSpacing: r = "0.75rem",
    command: i,
    commandSpacing: a = "0.75rem",
    children: o,
    ...s
  } = t, l = BEe(s, e), d = n || i ? /* @__PURE__ */ E.jsx("span", { style: { pointerEvents: "none", flex: 1 }, children: o }) : o;
  return /* @__PURE__ */ E.jsxs(
    PEe,
    {
      ...l,
      className: gr("chakra-menu__menuitem", l.className),
      children: [
        n && /* @__PURE__ */ E.jsx(H9, { fontSize: "0.8em", marginEnd: r, children: n }),
        d,
        i && /* @__PURE__ */ E.jsx(A9, { marginStart: a, children: i })
      ]
    }
  );
});
rE.displayName = "MenuItem";
var KEe = {
  enter: {
    visibility: "visible",
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.2,
      ease: [0.4, 0, 0.2, 1]
    }
  },
  exit: {
    transitionEnd: {
      visibility: "hidden"
    },
    opacity: 0,
    scale: 0.8,
    transition: {
      duration: 0.1,
      easings: "easeOut"
    }
  }
}, $Ee = Te(Mx.div), X9 = On(function(e, n) {
  var r, i;
  const { rootProps: a, motionProps: o, ...s } = e, {
    isOpen: l,
    onTransitionEnd: c,
    unstable__animationState: d
  } = Vm(), u = LEe(s, n), h = JEe(a), N = dN();
  return /* @__PURE__ */ E.jsx(
    Te.div,
    {
      ...h,
      __css: { zIndex: (i = e.zIndex) != null ? i : (r = N.list) == null ? void 0 : r.zIndex },
      children: /* @__PURE__ */ E.jsx(
        $Ee,
        {
          variants: KEe,
          initial: !1,
          animate: l ? "enter" : "exit",
          __css: { outline: 0, ...N.list },
          ...o,
          className: gr("chakra-menu__menu-list", u.className),
          ...u,
          onUpdate: c,
          onAnimationComplete: ENe(
            d.onComplete,
            u.onAnimationComplete
          )
        }
      )
    }
  );
});
X9.displayName = "MenuList";
var qEe = On((t, e) => {
  const n = dN();
  return /* @__PURE__ */ E.jsx(
    Te.button,
    {
      ref: e,
      ...t,
      __css: {
        display: "inline-flex",
        appearance: "none",
        alignItems: "center",
        outline: 0,
        ...n.button
      }
    }
  );
}), _9 = On(
  (t, e) => {
    const { children: n, as: r, ...i } = t, a = CEe(i, e), o = r || qEe;
    return /* @__PURE__ */ E.jsx(
      o,
      {
        ...a,
        className: gr("chakra-menu__menu-button", t.className),
        children: /* @__PURE__ */ E.jsx(
          Te.span,
          {
            __css: { pointerEvents: "none", flex: "1 1 auto", minW: 0 },
            children: t.children
          }
        )
      }
    );
  }
);
_9.displayName = "MenuButton";
var hf = (t) => {
  const { className: e, ...n } = t, r = dN();
  return /* @__PURE__ */ E.jsx(
    Te.hr,
    {
      "aria-orientation": "horizontal",
      className: gr("chakra-menu__divider", e),
      ...n,
      __css: r.divider
    }
  );
};
hf.displayName = "MenuDivider";
function e3e() {
  const t = Ve(!0);
  return Ee(() => {
    t.current = !1;
  }, []), t.current;
}
function t3e(t) {
  const e = Ve();
  return Ee(() => {
    e.current = t;
  }, [t]), e.current;
}
var n3e = Te("div", {
  baseStyle: {
    boxShadow: "none",
    backgroundClip: "padding-box",
    cursor: "default",
    color: "transparent",
    pointerEvents: "none",
    userSelect: "none",
    "&::before, &::after, *": {
      visibility: "hidden"
    }
  }
}), iE = rt("skeleton-start-color"), aE = rt("skeleton-end-color"), r3e = wU({
  from: { opacity: 0 },
  to: { opacity: 1 }
}), i3e = wU({
  from: {
    borderColor: iE.reference,
    background: iE.reference
  },
  to: {
    borderColor: aE.reference,
    background: aE.reference
  }
}), np = On((t, e) => {
  const n = {
    ...t,
    fadeDuration: typeof t.fadeDuration == "number" ? t.fadeDuration : 0.4,
    speed: typeof t.speed == "number" ? t.speed : 0.8
  }, r = jc("Skeleton", n), i = e3e(), {
    startColor: a = "",
    endColor: o = "",
    isLoaded: s,
    fadeDuration: l,
    speed: c,
    className: d,
    fitContent: u,
    ...h
  } = $s(n), [N, M] = yNe("colors", [
    a,
    o
  ]), p = t3e(s), m = gr("chakra-skeleton", d), R = {
    ...N && { [iE.variable]: N },
    ...M && { [aE.variable]: M }
  };
  if (s) {
    const V = i || p ? "none" : `${r3e} ${l}s`;
    return /* @__PURE__ */ E.jsx(
      Te.div,
      {
        ref: e,
        className: m,
        __css: { animation: V },
        ...h
      }
    );
  }
  return /* @__PURE__ */ E.jsx(
    n3e,
    {
      ref: e,
      className: m,
      ...h,
      __css: {
        width: u ? "fit-content" : void 0,
        ...r,
        ...R,
        _dark: { ...r._dark, ...R },
        animation: `${c}s linear infinite alternate ${i3e}`
      }
    }
  );
});
np.displayName = "Skeleton";
var a3e = {
  exit: {
    scale: 0.85,
    opacity: 0,
    transition: {
      opacity: { duration: 0.15, easings: "easeInOut" },
      scale: { duration: 0.2, easings: "easeInOut" }
    }
  },
  enter: {
    scale: 1,
    opacity: 1,
    transition: {
      opacity: { easings: "easeOut", duration: 0.2 },
      scale: { duration: 0.2, ease: [0.175, 0.885, 0.4, 1.1] }
    }
  }
}, oE = (t) => {
  var e;
  return ((e = t.current) == null ? void 0 : e.ownerDocument) || document;
}, Nf = (t) => {
  var e, n;
  return ((n = (e = t.current) == null ? void 0 : e.ownerDocument) == null ? void 0 : n.defaultView) || window;
};
function o3e(t = {}) {
  const {
    openDelay: e = 0,
    closeDelay: n = 0,
    closeOnClick: r = !0,
    closeOnMouseDown: i,
    closeOnScroll: a,
    closeOnPointerDown: o = i,
    closeOnEsc: s = !0,
    onOpen: l,
    onClose: c,
    placement: d,
    id: u,
    isOpen: h,
    defaultIsOpen: N,
    arrowSize: M = 10,
    arrowShadowColor: p,
    arrowPadding: m,
    modifiers: R,
    isDisabled: V,
    gutter: U,
    offset: g,
    direction: y,
    ...x
  } = t, { isOpen: f, onOpen: D, onClose: Y } = C9({
    isOpen: h,
    defaultIsOpen: N,
    onOpen: l,
    onClose: c
  }), { referenceRef: Q, getPopperProps: G, getArrowInnerProps: ne, getArrowProps: O } = G9({
    enabled: f,
    placement: d,
    arrowPadding: m,
    modifiers: R,
    gutter: U,
    offset: g,
    direction: y
  }), T = nu(), z = `tooltip-${u ?? T}`, j = Ve(null), w = Ve(), C = De(() => {
    w.current && (clearTimeout(w.current), w.current = void 0);
  }, []), J = Ve(), I = De(() => {
    J.current && (clearTimeout(J.current), J.current = void 0);
  }, []), b = De(() => {
    I(), Y();
  }, [Y, I]), k = s3e(j, b), ae = De(() => {
    if (!V && !w.current) {
      f && k();
      const se = Nf(j);
      w.current = se.setTimeout(D, e);
    }
  }, [k, V, f, D, e]), oe = De(() => {
    C();
    const se = Nf(j);
    J.current = se.setTimeout(b, n);
  }, [n, b, C]), le = De(() => {
    f && r && oe();
  }, [r, oe, f]), fe = De(() => {
    f && o && oe();
  }, [o, oe, f]), de = De(
    (se) => {
      f && se.key === "Escape" && oe();
    },
    [f, oe]
  );
  df(
    () => oE(j),
    "keydown",
    s ? de : void 0
  ), df(
    () => {
      const se = j.current;
      if (!se)
        return null;
      const Ce = S9(se);
      return Ce.localName === "body" ? Nf(j) : Ce;
    },
    "scroll",
    () => {
      f && a && b();
    },
    { passive: !0, capture: !0 }
  ), Ee(() => {
    V && (C(), f && Y());
  }, [V, f, Y, C]), Ee(() => () => {
    C(), I();
  }, [C, I]), df(() => j.current, "pointerleave", oe);
  const Me = De(
    (se = {}, Ce = null) => ({
      ...se,
      ref: Ls(j, Ce, Q),
      onPointerEnter: Zl(se.onPointerEnter, (at) => {
        at.pointerType !== "touch" && ae();
      }),
      onClick: Zl(se.onClick, le),
      onPointerDown: Zl(se.onPointerDown, fe),
      onFocus: Zl(se.onFocus, ae),
      onBlur: Zl(se.onBlur, oe),
      "aria-describedby": f ? z : void 0
    }),
    [
      ae,
      oe,
      fe,
      f,
      z,
      le,
      Q
    ]
  ), je = De(
    (se = {}, Ce = null) => G(
      {
        ...se,
        style: {
          ...se.style,
          [Qr.arrowSize.var]: M ? `${M}px` : void 0,
          [Qr.arrowShadowColor.var]: p
        }
      },
      Ce
    ),
    [G, M, p]
  ), Se = De(
    (se = {}, Ce = null) => {
      const et = {
        ...se.style,
        position: "relative",
        transformOrigin: Qr.transformOrigin.varRef
      };
      return {
        ref: Ce,
        ...x,
        ...se,
        id: z,
        role: "tooltip",
        style: et
      };
    },
    [x, z]
  );
  return {
    isOpen: f,
    show: ae,
    hide: oe,
    getTriggerProps: Me,
    getTooltipProps: Se,
    getTooltipPositionerProps: je,
    getArrowProps: O,
    getArrowInnerProps: ne
  };
}
var ly = "chakra-ui:close-tooltip";
function s3e(t, e) {
  return Ee(() => {
    const n = oE(t);
    return n.addEventListener(ly, e), () => n.removeEventListener(ly, e);
  }, [e, t]), () => {
    const n = oE(t), r = Nf(t);
    n.dispatchEvent(new r.CustomEvent(ly));
  };
}
function l3e(t, e = []) {
  const n = Object.assign({}, t);
  for (const r of e)
    r in n && delete n[r];
  return n;
}
function c3e(t, e) {
  const n = {};
  for (const r of e)
    r in t && (n[r] = t[r]);
  return n;
}
var d3e = Te(Mx.div), Um = On((t, e) => {
  var n, r;
  const i = jc("Tooltip", t), a = $s(t), o = FU(), {
    children: s,
    label: l,
    shouldWrapChildren: c,
    "aria-label": d,
    hasArrow: u,
    bg: h,
    portalProps: N,
    background: M,
    backgroundColor: p,
    bgColor: m,
    motionProps: R,
    ...V
  } = a, U = (r = (n = M ?? p) != null ? n : h) != null ? r : m;
  if (U) {
    i.bg = U;
    const G = C1e(o, "colors", U);
    i[Qr.arrowBg.var] = G;
  }
  const g = o3e({ ...V, direction: o.direction }), y = typeof s == "string" || c;
  let x;
  if (y)
    x = /* @__PURE__ */ E.jsx(
      Te.span,
      {
        display: "inline-block",
        tabIndex: 0,
        ...g.getTriggerProps(),
        children: s
      }
    );
  else {
    const G = Zo.only(s);
    x = Tc(
      G,
      g.getTriggerProps(G.props, G.ref)
    );
  }
  const f = !!d, D = g.getTooltipProps({}, e), Y = f ? l3e(D, ["role", "id"]) : D, Q = c3e(D, ["role", "id"]);
  return l ? /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
    x,
    /* @__PURE__ */ E.jsx(p9, { children: g.isOpen && /* @__PURE__ */ E.jsx(lm, { ...N, children: /* @__PURE__ */ E.jsx(
      Te.div,
      {
        ...g.getTooltipPositionerProps(),
        __css: {
          zIndex: i.zIndex,
          pointerEvents: "none"
        },
        children: /* @__PURE__ */ E.jsxs(
          d3e,
          {
            variants: a3e,
            initial: "exit",
            animate: "enter",
            exit: "exit",
            ...R,
            ...Y,
            __css: i,
            children: [
              l,
              f && /* @__PURE__ */ E.jsx(Te.span, { srOnly: !0, ...Q, children: d }),
              u && /* @__PURE__ */ E.jsx(
                Te.div,
                {
                  "data-popper-arrow": !0,
                  className: "chakra-tooltip__arrow-wrapper",
                  children: /* @__PURE__ */ E.jsx(
                    Te.div,
                    {
                      "data-popper-arrow-inner": !0,
                      className: "chakra-tooltip__arrow",
                      __css: { bg: i.bg }
                    }
                  )
                }
              )
            ]
          }
        )
      }
    ) }) })
  ] }) : /* @__PURE__ */ E.jsx(E.Fragment, { children: s });
});
Um.displayName = "Tooltip";
function Nn(t, e = {}) {
  let n = !1;
  function r() {
    if (!n) {
      n = !0;
      return;
    }
    throw new Error(
      "[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?"
    );
  }
  function i(...d) {
    r();
    for (const u of d)
      e[u] = l(u);
    return Nn(t, e);
  }
  function a(...d) {
    for (const u of d)
      u in e || (e[u] = l(u));
    return Nn(t, e);
  }
  function o() {
    return Object.fromEntries(
      Object.entries(e).map(([u, h]) => [u, h.selector])
    );
  }
  function s() {
    return Object.fromEntries(
      Object.entries(e).map(([u, h]) => [u, h.className])
    );
  }
  function l(d) {
    const N = `chakra-${(["container", "root"].includes(d ?? "") ? [t] : [t, d]).filter(Boolean).join("__")}`;
    return {
      className: N,
      selector: `.${N}`,
      toString: () => d
    };
  }
  return {
    parts: i,
    toPart: l,
    extend: a,
    selectors: o,
    classnames: s,
    get keys() {
      return Object.keys(e);
    },
    __type: {}
  };
}
Nn("accordion").parts("root", "container", "button", "panel").extend("icon");
Nn("alert").parts("title", "description", "container").extend("icon", "spinner");
Nn("avatar").parts("label", "badge", "container").extend("excessLabel", "group");
Nn("breadcrumb").parts("link", "item", "container").extend("separator");
Nn("button").parts();
Nn("checkbox").parts("control", "icon", "container").extend("label");
Nn("progress").parts("track", "filledTrack").extend("label");
Nn("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
Nn("editable").parts(
  "preview",
  "input",
  "textarea"
);
Nn("form").parts(
  "container",
  "requiredIndicator",
  "helperText"
);
Nn("formError").parts("text", "icon");
Nn("input").parts(
  "addon",
  "field",
  "element",
  "group"
);
Nn("list").parts("container", "item", "icon");
var u3e = Nn("menu").parts("button", "list", "item").extend("groupTitle", "icon", "command", "divider");
Nn("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
Nn("numberinput").parts(
  "root",
  "field",
  "stepperGroup",
  "stepper"
);
Nn("pininput").parts("field");
Nn("popover").parts("content", "header", "body", "footer").extend("popper", "arrow", "closeButton");
Nn("progress").parts(
  "label",
  "filledTrack",
  "track"
);
Nn("radio").parts(
  "container",
  "control",
  "label"
);
Nn("select").parts("field", "icon");
Nn("slider").parts(
  "container",
  "track",
  "thumb",
  "filledTrack",
  "mark"
);
Nn("stat").parts(
  "container",
  "label",
  "helpText",
  "number",
  "icon"
);
Nn("switch").parts(
  "container",
  "track",
  "thumb"
);
Nn("table").parts(
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
  "tfoot",
  "caption"
);
Nn("tabs").parts(
  "root",
  "tab",
  "tablist",
  "tabpanel",
  "tabpanels",
  "indicator"
);
Nn("tag").parts(
  "container",
  "label",
  "closeButton"
);
Nn("card").parts(
  "container",
  "header",
  "body",
  "footer"
);
const { definePartsStyle: Z1, defineMultiStyleConfig: h3e } = Sn(u3e.keys), N3e = Z1({
  // define the part you're going to style
  button: {
    // this will style the MenuButton component
    fontWeight: "medium",
    bg: "teal.500",
    color: "gray.200",
    _hover: {
      bg: "teal.600",
      color: "white"
    }
  },
  list: {
    // this will style the MenuList component
    py: "10px",
    borderRadius: "10px",
    borderWidth: "0.5px",
    borderColor: "border.default",
    bgColor: "surface.0",
    boxShadow: "xs",
    zIndex: "10",
    minWidth: 0,
    width: "200px"
  },
  item: {
    // this will style the MenuItem and MenuItemOption components
    color: "text.secondary",
    bgColor: "surface.0",
    cursor: "pointer",
    _hover: {
      color: "text.primary",
      bgColor: "surface.3"
    },
    _focus: {
      bgColor: "surface.3"
    },
    py: "12px",
    width: "full"
  },
  groupTitle: {
    // this will style the text defined by the title prop
    // in the MenuGroup and MenuOptionGroup components
    textTransform: "uppercase",
    color: "white",
    textAlign: "center",
    letterSpacing: "wider"
  },
  command: {
    // this will style the text defined by the command
    // prop in the MenuItem and MenuItemOption components
    opacity: "0.8",
    fontFamily: "mono",
    fontSize: "sm",
    letterSpacing: "tighter",
    pl: "4"
  },
  divider: {
    // this will style the MenuDivider component
    my: "0",
    borderColor: "border.default",
    borderBottom: "1px solid"
  }
}), fT = {
  fontSize: "16px",
  fontWeight: "normal",
  lineHeight: "20px",
  py: "12px",
  px: "12px"
}, M3e = {
  // apply custom styles to parts
  sm: Z1({
    button: fT,
    item: fT,
    groupTitle: fT,
    command: fT
  })
}, p3e = {
  danger: Z1({
    item: {
      color: "red"
    }
  }),
  roundLeft: Z1({
    button: {
      borderLeftRadius: "full",
      pl: "6"
    }
  }),
  roundRight: Z1({
    button: {
      borderRightRadius: "full",
      pr: "6"
    }
  })
}, m3e = h3e({
  baseStyle: N3e,
  sizes: M3e,
  variants: p3e,
  defaultProps: {
    // define which size is applied by default
    size: "sm"
  }
}), _U = 1.85, sE = {
  background: {
    default: "rgba(14, 14, 14, 1)",
    mask: "rgba(20, 23, 26, 0.8)"
  },
  surface: {
    0: "rgba(20, 23, 26, 1)",
    1: "rgba(27, 31, 34, 1)",
    2: "rgba(31, 36, 40, 1)",
    3: "rgba(36, 41, 46, 1)",
    4: "rgba(40, 46, 51, 1)",
    success: "rgba(57, 194, 36, 1)",
    alert: "rgba(241, 108, 19, 1)",
    critical: "rgba(182, 47, 47, 1)"
  },
  text: {
    primary: "rgba(255, 255, 255, 1)",
    secondary: "rgba(198, 204, 210, 1)",
    tertiary: "rgba(141, 152, 165, 1)",
    disable: "rgba(56, 64, 71, 1)",
    placeholder: "rgba(45, 51, 57, 1)",
    success: "rgba(57, 194, 36, 1)",
    alert: "rgba(241, 108, 19, 1)",
    critical: {
      default: "rgba(182, 47, 47, 1)",
      hover: "rgba(208, 73, 73, 1)",
      disable: "rgba(61, 16, 16, 1)"
    }
  },
  button: {
    primary: {
      text: {
        enable: "rgba(255, 255, 255, 1)",
        hover: "rgba(255, 255, 255, 1)",
        disable: "rgba(255, 255, 255, 0.4)"
      }
    },
    secondary: {
      background: {
        hover: "rgba(255, 255, 255, 1)"
      },
      border: {
        enable: "rgba(198, 204, 210, 1)",
        disable: "rgba(56, 64, 71, 1)"
      },
      text: {
        enable: "rgba(255, 255, 255, 1)",
        hover: "rgba(20, 23, 26, 1)",
        disable: "rgba(56, 64, 71, 1)"
      }
    },
    grey: {
      background: {
        enable: "rgba(27, 31, 34, 1)",
        hover: "rgba(36, 41, 46, 1)",
        disable: "rgba(27, 31, 34, 1)"
      },
      text: {
        enable: "rgba(198, 204, 210, 1)",
        hover: "rgba(198, 204, 210, 1)",
        disable: "rgba(56, 64, 71, 1)"
      }
    }
  },
  border: {
    default: "rgba(45, 51, 57, 1)",
    hover: "rgba(67, 76, 86, 1)",
    critical: "rgba(182, 47, 47, 1)"
  },
  contract: {
    lightBackgroundText: {
      enable: "rgba(20, 23, 26, 1)",
      hover: "rgba(20, 23, 26, 1)",
      disable: "rgba(20, 23, 26, 0.4)"
    },
    darkBackgroundText: {
      enable: "rgba(255, 255, 255, 1)",
      hover: "rgba(255, 255, 255, 1)",
      disable: "rgba(255, 255, 255, 0.4)"
    }
  }
}, T3e = {
  background: {
    default: "rgba(250, 250, 250, 1)",
    mask: "rgba(255, 255, 255, 0.8)"
  },
  surface: {
    0: "rgba(255, 255, 255, 1)",
    1: "rgba(246, 247, 248, 1)",
    2: "rgba(235, 237, 239, 1)",
    3: "rgba(226, 229, 233, 1)",
    4: "rgba(221, 224, 228, 1)",
    success: "rgba(57, 194, 36, 1)",
    alert: "rgba(241, 108, 19, 1)",
    critical: "rgba(182, 47, 47, 1)"
  },
  text: {
    primary: "rgba(20, 23, 26, 1)",
    secondary: "rgba(45, 51, 57, 1)",
    tertiary: "rgba(67, 76, 86, 1)",
    disable: "rgba(184, 191, 199, 1)",
    placeholder: "rgba(198, 204, 210, 1)",
    success: "rgba(57, 194, 36, 1)",
    alert: "rgba(241, 108, 19, 1)",
    critical: {
      default: "rgba(182, 47, 47, 1)",
      hover: "rgba(208, 73, 73, 1)",
      disable: "rgba(61, 16, 16, 1)"
    }
  },
  button: {
    primary: {
      text: {
        enable: "rgba(255, 255, 255, 1)",
        hover: "rgba(255, 255, 255, 1)",
        disable: "rgba(255, 255, 255, 0.4)"
      }
    },
    secondary: {
      background: {
        hover: "rgba(20, 23, 26, 1)"
      },
      border: {
        enable: "rgba(45, 51, 57, 1)",
        disable: "rgba(184, 191, 199, 1)"
      },
      text: {
        enable: "rgba(20, 23, 26, 1)",
        hover: "rgba(255, 255, 255, 1)",
        disable: "rgba(184, 191, 199, 1)"
      }
    },
    grey: {
      background: {
        enable: "rgba(246, 247, 248, 1)",
        hover: "rgba(226, 229, 233, 1)",
        disable: "rgba(246, 247, 248, 1)"
      },
      text: {
        enable: "rgba(45, 51, 57, 1)",
        hover: "rgba(45, 51, 57, 1)",
        disable: "rgba(184, 191, 199, 1)"
      }
    }
  },
  border: {
    default: "rgba(191, 191, 191, 1)",
    hover: "rgba(115, 115, 115, 1)",
    critical: "rgba(182, 47, 47, 1)"
  },
  contract: {
    lightBackgroundText: {
      enable: "rgba(20, 23, 26, 1)",
      hover: "rgba(20, 23, 26, 1)",
      disable: "rgba(20, 23, 26, 0.4)"
    },
    darkBackgroundText: {
      enable: "rgba(255, 255, 255, 1)",
      hover: "rgba(255, 255, 255, 1)",
      disable: "rgba(255, 255, 255, 0.4)"
    }
  }
}, f3e = {
  cursor: "pointer",
  fontWeight: "semibold",
  color: "white",
  bgColor: "black",
  _hover: {
    bgColor: "blue"
  },
  _disabled: {
    bgColor: "red",
    opacity: 1
  }
}, V3e = {
  // Naming "sm" will conflict with the "sm" in Chakra offical theme
  _sm: {
    px: "12px",
    py: "8px",
    fontSize: "16px",
    lineHeight: "20px",
    borderRadius: "inner"
  },
  md: {
    px: "16px",
    py: "10px",
    fontSize: "18px",
    lineHeight: "22px",
    borderRadius: "inner"
  },
  lg: {
    px: "16px",
    py: "12px",
    fontSize: "20px",
    lineHeight: "24px",
    borderRadius: "inner"
  },
  xl: {
    px: "24px",
    py: "16px",
    fontSize: "24px",
    lineHeight: "30px",
    borderRadius: "button"
  }
}, U3e = (t) => {
  const { theme: e } = t, { lightBackgroundText: n, darkBackgroundText: r } = e.colors.contract, { enable: i, hover: a, disable: o } = e.colors.button.primary.background, s = i.from, l = a.from, c = o.from, d = i.to, u = a.to, h = o.to, N = Pe.readability(i.from, n.enable) > _U;
  return {
    color: N ? r.enable : n.enable,
    background: `linear-gradient(90deg, ${s} 0%, ${d} 100%)`,
    _hover: {
      color: N ? r.hover : n.hover,
      background: `linear-gradient(90deg, ${l} 0%, ${u} 100%)`
    },
    _disabled: {
      color: `${N ? r.disable : n.disable} !important`,
      background: `linear-gradient(90deg, ${c} 0%, ${h} 100%) !important`
    }
  };
}, R3e = (t) => {
  const { theme: e } = t, { lightBackgroundText: n, darkBackgroundText: r } = e.colors.contract, i = e.colors.primary, a = Pe.readability(i, "white") > _U;
  return {
    color: a ? r.enable : n.enable,
    bgColor: "text.interaction.default",
    _hover: {
      color: a ? r.hover : n.hover,
      bgColor: "text.interaction.hover"
    },
    _disabled: {
      color: `${a ? r.disable : n.disable} !important`,
      bgColor: "text.interaction.disable !important"
    }
  };
}, g3e = {
  outline: "1px solid",
  outlineColor: "button.secondary.border.enable",
  color: "button.secondary.text.enable",
  bgColor: "transparent",
  _hover: {
    color: "button.secondary.text.hover",
    bgColor: "button.secondary.background.hover",
    outlineColor: void 0
  },
  _disabled: {
    color: "button.secondary.text.disable !important",
    outlineColor: "button.secondary.border.disable !important",
    bgColor: "transparent !important"
  }
}, y3e = {
  color: "button.grey.text.enable",
  bgColor: "button.grey.background.enable",
  _hover: {
    color: "button.grey.text.hover",
    bgColor: "button.grey.background.hover"
  },
  _disabled: {
    color: "button.grey.text.disable !important",
    bgColor: "button.grey.background.disable !important"
  }
}, Z3e = {
  baseStyle: f3e,
  sizes: V3e,
  variants: {
    gradient: U3e,
    filled: R3e,
    neutral: g3e,
    grey: y3e
  },
  defaultProps: {
    variant: "gradient",
    size: "_sm"
  }
}, b3e = rt("popper-arrow-bg"), E3e = {
  bgColor: sE.surface[3],
  fontWeight: "normal",
  [b3e.variable]: sE.surface[3]
}, S3e = {
  md: {
    fontSize: "12px",
    lineHeight: "16px"
  },
  lg: {
    fontSize: "14px",
    lineHeight: "18px"
  }
}, x3e = {}, W3e = {
  baseStyle: E3e,
  sizes: S3e,
  variants: {
    solid: x3e
  },
  defaultProps: {
    variant: "solid",
    size: "md"
  }
}, P9 = wU({
  from: {
    transform: "rotate(0deg)"
  },
  to: {
    transform: "rotate(360deg)"
  }
}), j3e = (t) => {
  const e = {
    global: () => ({
      body: {
        fontFamily: "",
        color: "",
        bg: "",
        lineHeight: ""
      },
      "*::placeholder": {
        color: ""
      },
      "*, *::before, &::after": {
        borderColor: "",
        wordWrap: ""
      }
    })
  }, r = t.mode === "dark" ? sE : T3e, i = t.colors.primary, a = t.colors.gradient[0], o = t.colors.gradient[1], s = {
    ...r,
    primary: i,
    surface: {
      ...r.surface,
      highlight: i
    },
    text: {
      ...r.text,
      interaction: {
        default: i
      }
    },
    button: {
      ...r.button,
      primary: {
        ...r.button.primary,
        background: {
          enable: {
            from: a,
            to: o
          }
        }
      }
    },
    border: {
      ...r.border,
      active: i
    }
  }, l = {
    ...s,
    surface: {
      ...s.surface,
      active: Lc(i, 0.2)
    },
    text: {
      ...s.text,
      interaction: {
        ...s.text.interaction,
        hover: Lc(i, 0.8),
        disable: Lc(i, 0.4)
      }
    },
    button: {
      ...s.button,
      primary: {
        ...s.button.primary,
        background: {
          ...s.button.primary.background,
          hover: {
            from: Lc(a, 0.8),
            to: Lc(o, 0.8)
          },
          disable: {
            from: Lc(a, 0.4),
            to: Lc(o, 0.4)
          }
        }
      }
    },
    border: {
      ...s.border,
      active: i
    }
  }, c = {
    fonts: {
      body: t.fontFamily,
      heading: t.fontFamily,
      mono: t.fontFamily
    },
    fontSizes: {
      xs: "10px",
      sm: "12px",
      md: "16px",
      lg: "18px",
      xl: "24px",
      "2xl": "40px"
    },
    fontWeights: {
      hairline: 100,
      thin: 200,
      light: 300,
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      extrabold: 800,
      black: 900
    },
    lineHeights: {
      sm: "16px",
      md: "20px",
      "2md": "22px",
      lg: "24px",
      xl: "30px"
    },
    letterSpacings: {
      tighter: "-0.05em",
      tight: "-0.025em",
      normal: "0",
      wide: "0.025em",
      wider: "0.05em",
      widest: "0.1em"
    }
  }, d = {
    sm: "480px"
  }, u = {
    space: {
      xs: "8px",
      "2xs": "10px",
      sm: "12px",
      md: "16px",
      lg: "20px",
      xl: "24px",
      "3xl": "40px"
    }
  }, h = {
    sizes: {
      ...u.space,
      max: "max-content",
      min: "min-content",
      full: "100%",
      "3xs": "14rem",
      "2xs": "16rem",
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem",
      "8xl": "90rem",
      container: {
        sm: "480px",
        md: "768px",
        lg: "1024px",
        xl: "1280px"
      }
    }
  }, N = {
    radii: {
      base: "4px",
      inner: t.borderRadius.inner,
      container: t.borderRadius.container,
      button: t.borderRadius.button,
      full: "9999px"
    }
  };
  return N2e({
    styles: e,
    colors: l,
    ...c,
    breakpoints: d,
    ...u,
    sizes: h,
    ...N,
    zIndices: {
      zIndices: {
        hide: -1,
        auto: "auto",
        base: 0,
        docked: 10,
        dropdown: 1e3,
        sticky: 1100,
        banner: 1200,
        overlay: 1300,
        modal: 1400,
        popover: 1500,
        skipLink: 1600,
        toast: 1700,
        tooltip: 1800
      }
    },
    shadows: {
      xs: "3px 5px 8px 0 rgba(0,0,0,0.2)",
      sm: "3px 5px 12px 0 rgba(0,0,0,0.16)"
    },
    components: {
      Menu: m3e,
      Button: Z3e,
      Tooltip: W3e
    }
  });
};
function ca() {
  const { mode: t, fontFamily: e, borderRadius: n, colors: r, components: i } = lt(aG);
  return {
    mode: t,
    isDarkMode: t === "dark",
    fontFamily: e,
    borderRadius: n,
    colors: r,
    components: i
  };
}
function K9() {
  const { swapError: t, approveError: e } = lt(TL), n = [t, e], { chain: r } = lu(), { inputToken: i } = Br(), a = !i.isFakeToken && i.chainId !== String(r == null ? void 0 : r.id);
  return {
    swapError: t,
    approveError: e,
    errors: n,
    isNeedToSwitchNetwork: a
  };
}
function D3e() {
  return lt(fL);
}
/**
 * @remix-run/router v1.13.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function n2() {
  return n2 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, n2.apply(this, arguments);
}
var Il;
(function(t) {
  t.Pop = "POP", t.Push = "PUSH", t.Replace = "REPLACE";
})(Il || (Il = {}));
function z3e(t) {
  t === void 0 && (t = {});
  let {
    initialEntries: e = ["/"],
    initialIndex: n,
    v5Compat: r = !1
  } = t, i;
  i = e.map((N, M) => d(N, typeof N == "string" ? null : N.state, M === 0 ? "default" : void 0));
  let a = l(n ?? i.length - 1), o = Il.Pop, s = null;
  function l(N) {
    return Math.min(Math.max(N, 0), i.length - 1);
  }
  function c() {
    return i[a];
  }
  function d(N, M, p) {
    M === void 0 && (M = null);
    let m = w3e(i ? c().pathname : "/", N, M, p);
    return Co(m.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(N)), m;
  }
  function u(N) {
    return typeof N == "string" ? N : F3e(N);
  }
  return {
    get index() {
      return a;
    },
    get action() {
      return o;
    },
    get location() {
      return c();
    },
    createHref: u,
    createURL(N) {
      return new URL(u(N), "http://localhost");
    },
    encodeLocation(N) {
      let M = typeof N == "string" ? Ru(N) : N;
      return {
        pathname: M.pathname || "",
        search: M.search || "",
        hash: M.hash || ""
      };
    },
    push(N, M) {
      o = Il.Push;
      let p = d(N, M);
      a += 1, i.splice(a, i.length, p), r && s && s({
        action: o,
        location: p,
        delta: 1
      });
    },
    replace(N, M) {
      o = Il.Replace;
      let p = d(N, M);
      i[a] = p, r && s && s({
        action: o,
        location: p,
        delta: 0
      });
    },
    go(N) {
      o = Il.Pop;
      let M = l(a + N), p = i[M];
      a = M, s && s({
        action: o,
        location: p,
        delta: N
      });
    },
    listen(N) {
      return s = N, () => {
        s = null;
      };
    }
  };
}
function In(t, e) {
  if (t === !1 || t === null || typeof t > "u")
    throw new Error(e);
}
function Co(t, e) {
  if (!t) {
    typeof console < "u" && console.warn(e);
    try {
      throw new Error(e);
    } catch {
    }
  }
}
function k3e() {
  return Math.random().toString(36).substr(2, 8);
}
function w3e(t, e, n, r) {
  return n === void 0 && (n = null), n2({
    pathname: typeof t == "string" ? t : t.pathname,
    search: "",
    hash: ""
  }, typeof e == "string" ? Ru(e) : e, {
    state: n,
    // TODO: This could be cleaned up.  push/replace should probably just take
    // full Locations now and avoid the need to run through this flow at all
    // But that's a pretty big refactor to the current test suite so going to
    // keep as is for the time being and just let any incoming keys take precedence
    key: e && e.key || r || k3e()
  });
}
function F3e(t) {
  let {
    pathname: e = "/",
    search: n = "",
    hash: r = ""
  } = t;
  return n && n !== "?" && (e += n.charAt(0) === "?" ? n : "?" + n), r && r !== "#" && (e += r.charAt(0) === "#" ? r : "#" + r), e;
}
function Ru(t) {
  let e = {};
  if (t) {
    let n = t.indexOf("#");
    n >= 0 && (e.hash = t.substr(n), t = t.substr(0, n));
    let r = t.indexOf("?");
    r >= 0 && (e.search = t.substr(r), t = t.substr(0, r)), t && (e.pathname = t);
  }
  return e;
}
var Mk;
(function(t) {
  t.data = "data", t.deferred = "deferred", t.redirect = "redirect", t.error = "error";
})(Mk || (Mk = {}));
function v3e(t, e, n) {
  n === void 0 && (n = "/");
  let r = typeof e == "string" ? Ru(e) : e, i = eL(r.pathname || "/", n);
  if (i == null)
    return null;
  let a = $9(t);
  I3e(a);
  let o = null;
  for (let s = 0; o == null && s < a.length; ++s)
    o = A3e(
      a[s],
      // Incoming pathnames are generally encoded from either window.location
      // or from router.navigate, but we want to match against the unencoded
      // paths in the route definitions.  Memory router locations won't be
      // encoded here but there also shouldn't be anything to decode so this
      // should be a safe operation.  This avoids needing matchRoutes to be
      // history-aware.
      _3e(i)
    );
  return o;
}
function $9(t, e, n, r) {
  e === void 0 && (e = []), n === void 0 && (n = []), r === void 0 && (r = "");
  let i = (a, o, s) => {
    let l = {
      relativePath: s === void 0 ? a.path || "" : s,
      caseSensitive: a.caseSensitive === !0,
      childrenIndex: o,
      route: a
    };
    l.relativePath.startsWith("/") && (In(l.relativePath.startsWith(r), 'Absolute route path "' + l.relativePath + '" nested under path ' + ('"' + r + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes."), l.relativePath = l.relativePath.slice(r.length));
    let c = Dd([r, l.relativePath]), d = n.concat(l);
    a.children && a.children.length > 0 && (In(
      // Our types know better, but runtime JS may not!
      // @ts-expect-error
      a.index !== !0,
      "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + c + '".')
    ), $9(a.children, e, d, c)), !(a.path == null && !a.index) && e.push({
      path: c,
      score: J3e(c, a.index),
      routesMeta: d
    });
  };
  return t.forEach((a, o) => {
    var s;
    if (a.path === "" || !((s = a.path) != null && s.includes("?")))
      i(a, o);
    else
      for (let l of q9(a.path))
        i(a, o, l);
  }), e;
}
function q9(t) {
  let e = t.split("/");
  if (e.length === 0)
    return [];
  let [n, ...r] = e, i = n.endsWith("?"), a = n.replace(/\?$/, "");
  if (r.length === 0)
    return i ? [a, ""] : [a];
  let o = q9(r.join("/")), s = [];
  return s.push(...o.map((l) => l === "" ? a : [a, l].join("/"))), i && s.push(...o), s.map((l) => t.startsWith("/") && l === "" ? "/" : l);
}
function I3e(t) {
  t.sort((e, n) => e.score !== n.score ? n.score - e.score : B3e(e.routesMeta.map((r) => r.childrenIndex), n.routesMeta.map((r) => r.childrenIndex)));
}
const O3e = /^:\w+$/, Y3e = 3, Q3e = 2, G3e = 1, C3e = 10, L3e = -2, pk = (t) => t === "*";
function J3e(t, e) {
  let n = t.split("/"), r = n.length;
  return n.some(pk) && (r += L3e), e && (r += Q3e), n.filter((i) => !pk(i)).reduce((i, a) => i + (O3e.test(a) ? Y3e : a === "" ? G3e : C3e), r);
}
function B3e(t, e) {
  return t.length === e.length && t.slice(0, -1).every((r, i) => r === e[i]) ? (
    // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    t[t.length - 1] - e[e.length - 1]
  ) : (
    // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0
  );
}
function A3e(t, e) {
  let {
    routesMeta: n
  } = t, r = {}, i = "/", a = [];
  for (let o = 0; o < n.length; ++o) {
    let s = n[o], l = o === n.length - 1, c = i === "/" ? e : e.slice(i.length) || "/", d = H3e({
      path: s.relativePath,
      caseSensitive: s.caseSensitive,
      end: l
    }, c);
    if (!d)
      return null;
    Object.assign(r, d.params);
    let u = s.route;
    a.push({
      // TODO: Can this as be avoided?
      params: r,
      pathname: Dd([i, d.pathname]),
      pathnameBase: nSe(Dd([i, d.pathnameBase])),
      route: u
    }), d.pathnameBase !== "/" && (i = Dd([i, d.pathnameBase]));
  }
  return a;
}
function H3e(t, e) {
  typeof t == "string" && (t = {
    path: t,
    caseSensitive: !1,
    end: !0
  });
  let [n, r] = X3e(t.path, t.caseSensitive, t.end), i = e.match(n);
  if (!i)
    return null;
  let a = i[0], o = a.replace(/(.)\/+$/, "$1"), s = i.slice(1);
  return {
    params: r.reduce((c, d, u) => {
      let {
        paramName: h,
        isOptional: N
      } = d;
      if (h === "*") {
        let p = s[u] || "";
        o = a.slice(0, a.length - p.length).replace(/(.)\/+$/, "$1");
      }
      const M = s[u];
      return N && !M ? c[h] = void 0 : c[h] = P3e(M || "", h), c;
    }, {}),
    pathname: a,
    pathnameBase: o,
    pattern: t
  };
}
function X3e(t, e, n) {
  e === void 0 && (e = !1), n === void 0 && (n = !0), Co(t === "*" || !t.endsWith("*") || t.endsWith("/*"), 'Route path "' + t + '" will be treated as if it were ' + ('"' + t.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + t.replace(/\*$/, "/*") + '".'));
  let r = [], i = "^" + t.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:(\w+)(\?)?/g, (o, s, l) => (r.push({
    paramName: s,
    isOptional: l != null
  }), l ? "/?([^\\/]+)?" : "/([^\\/]+)"));
  return t.endsWith("*") ? (r.push({
    paramName: "*"
  }), i += t === "*" || t === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$") : n ? i += "\\/*$" : t !== "" && t !== "/" && (i += "(?:(?=\\/|$))"), [new RegExp(i, e ? void 0 : "i"), r];
}
function _3e(t) {
  try {
    return decodeURI(t);
  } catch (e) {
    return Co(!1, 'The URL path "' + t + '" could not be decoded because it is is a malformed URL segment. This is probably due to a bad percent ' + ("encoding (" + e + ").")), t;
  }
}
function P3e(t, e) {
  try {
    return decodeURIComponent(t);
  } catch (n) {
    return Co(!1, 'The value for the URL param "' + e + '" will not be decoded because' + (' the string "' + t + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + n + ").")), t;
  }
}
function eL(t, e) {
  if (e === "/")
    return t;
  if (!t.toLowerCase().startsWith(e.toLowerCase()))
    return null;
  let n = e.endsWith("/") ? e.length - 1 : e.length, r = t.charAt(n);
  return r && r !== "/" ? null : t.slice(n) || "/";
}
function K3e(t, e) {
  e === void 0 && (e = "/");
  let {
    pathname: n,
    search: r = "",
    hash: i = ""
  } = typeof t == "string" ? Ru(t) : t;
  return {
    pathname: n ? n.startsWith("/") ? n : $3e(n, e) : e,
    search: rSe(r),
    hash: iSe(i)
  };
}
function $3e(t, e) {
  let n = e.replace(/\/+$/, "").split("/");
  return t.split("/").forEach((i) => {
    i === ".." ? n.length > 1 && n.pop() : i !== "." && n.push(i);
  }), n.length > 1 ? n.join("/") : "/";
}
function cy(t, e, n, r) {
  return "Cannot include a '" + t + "' character in a manually specified " + ("`to." + e + "` field [" + JSON.stringify(r) + "].  Please separate it out to the ") + ("`to." + n + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
function q3e(t) {
  return t.filter((e, n) => n === 0 || e.route.path && e.route.path.length > 0);
}
function eSe(t) {
  return q3e(t).map((e, n) => n === t.length - 1 ? e.pathname : e.pathnameBase);
}
function tSe(t, e, n, r) {
  r === void 0 && (r = !1);
  let i;
  typeof t == "string" ? i = Ru(t) : (i = n2({}, t), In(!i.pathname || !i.pathname.includes("?"), cy("?", "pathname", "search", i)), In(!i.pathname || !i.pathname.includes("#"), cy("#", "pathname", "hash", i)), In(!i.search || !i.search.includes("#"), cy("#", "search", "hash", i)));
  let a = t === "" || i.pathname === "", o = a ? "/" : i.pathname, s;
  if (o == null)
    s = n;
  else if (r) {
    let u = e[e.length - 1].replace(/^\//, "").split("/");
    if (o.startsWith("..")) {
      let h = o.split("/");
      for (; h[0] === ".."; )
        h.shift(), u.pop();
      i.pathname = h.join("/");
    }
    s = "/" + u.join("/");
  } else {
    let u = e.length - 1;
    if (o.startsWith("..")) {
      let h = o.split("/");
      for (; h[0] === ".."; )
        h.shift(), u -= 1;
      i.pathname = h.join("/");
    }
    s = u >= 0 ? e[u] : "/";
  }
  let l = K3e(i, s), c = o && o !== "/" && o.endsWith("/"), d = (a || o === ".") && n.endsWith("/");
  return !l.pathname.endsWith("/") && (c || d) && (l.pathname += "/"), l;
}
const Dd = (t) => t.join("/").replace(/\/\/+/g, "/"), nSe = (t) => t.replace(/\/+$/, "").replace(/^\/*/, "/"), rSe = (t) => !t || t === "?" ? "" : t.startsWith("?") ? t : "?" + t, iSe = (t) => !t || t === "#" ? "" : t.startsWith("#") ? t : "#" + t;
function aSe(t) {
  return t != null && typeof t.status == "number" && typeof t.statusText == "string" && typeof t.internal == "boolean" && "data" in t;
}
const tL = ["post", "put", "patch", "delete"];
new Set(tL);
const oSe = ["get", ...tL];
new Set(oSe);
function r2() {
  return r2 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, r2.apply(this, arguments);
}
const PU = /* @__PURE__ */ H.createContext(null);
ue.env.NODE_ENV !== "production" && (PU.displayName = "DataRouter");
const nL = /* @__PURE__ */ H.createContext(null);
ue.env.NODE_ENV !== "production" && (nL.displayName = "DataRouterState");
const sSe = /* @__PURE__ */ H.createContext(null);
ue.env.NODE_ENV !== "production" && (sSe.displayName = "Await");
const Rm = /* @__PURE__ */ H.createContext(null);
ue.env.NODE_ENV !== "production" && (Rm.displayName = "Navigation");
const gm = /* @__PURE__ */ H.createContext(null);
ue.env.NODE_ENV !== "production" && (gm.displayName = "Location");
const gu = /* @__PURE__ */ H.createContext({
  outlet: null,
  matches: [],
  isDataRoute: !1
});
ue.env.NODE_ENV !== "production" && (gu.displayName = "Route");
const Sx = /* @__PURE__ */ H.createContext(null);
ue.env.NODE_ENV !== "production" && (Sx.displayName = "RouteError");
function KU() {
  return H.useContext(gm) != null;
}
function $U() {
  return KU() || (ue.env.NODE_ENV !== "production" ? In(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component."
  ) : In(!1)), H.useContext(gm).location;
}
const rL = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function iL(t) {
  H.useContext(Rm).static || H.useLayoutEffect(t);
}
function aL() {
  let {
    isDataRoute: t
  } = H.useContext(gu);
  return t ? USe() : lSe();
}
function lSe() {
  KU() || (ue.env.NODE_ENV !== "production" ? In(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component."
  ) : In(!1));
  let t = H.useContext(PU), {
    basename: e,
    navigator: n
  } = H.useContext(Rm), {
    matches: r
  } = H.useContext(gu), {
    pathname: i
  } = $U(), a = JSON.stringify(eSe(r)), o = H.useRef(!1);
  return iL(() => {
    o.current = !0;
  }), H.useCallback(function(l, c) {
    if (c === void 0 && (c = {}), ue.env.NODE_ENV !== "production" && Co(o.current, rL), !o.current)
      return;
    if (typeof l == "number") {
      n.go(l);
      return;
    }
    let d = tSe(l, JSON.parse(a), i, c.relative === "path");
    t == null && e !== "/" && (d.pathname = d.pathname === "/" ? e : Dd([e, d.pathname])), (c.replace ? n.replace : n.push)(d, c.state, c);
  }, [e, n, a, i, t]);
}
function cSe(t, e) {
  return dSe(t, e);
}
function dSe(t, e, n) {
  KU() || (ue.env.NODE_ENV !== "production" ? In(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component."
  ) : In(!1));
  let {
    navigator: r
  } = H.useContext(Rm), {
    matches: i
  } = H.useContext(gu), a = i[i.length - 1], o = a ? a.params : {}, s = a ? a.pathname : "/", l = a ? a.pathnameBase : "/", c = a && a.route;
  if (ue.env.NODE_ENV !== "production") {
    let R = c && c.path || "";
    RSe(s, !c || R.endsWith("*"), "You rendered descendant <Routes> (or called `useRoutes()`) at " + ('"' + s + '" (under <Route path="' + R + '">) but the ') + `parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

` + ('Please change the parent <Route path="' + R + '"> to <Route ') + ('path="' + (R === "/" ? "*" : R + "/*") + '">.'));
  }
  let d = $U(), u;
  if (e) {
    var h;
    let R = typeof e == "string" ? Ru(e) : e;
    l === "/" || (h = R.pathname) != null && h.startsWith(l) || (ue.env.NODE_ENV !== "production" ? In(!1, "When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was " + ('matched by all parent routes. The current pathname base is "' + l + '" ') + ('but pathname "' + R.pathname + '" was given in the `location` prop.')) : In(!1)), u = R;
  } else
    u = d;
  let N = u.pathname || "/", M = l === "/" ? N : N.slice(l.length) || "/", p = v3e(t, {
    pathname: M
  });
  ue.env.NODE_ENV !== "production" && (ue.env.NODE_ENV !== "production" && Co(c || p != null, 'No routes matched location "' + u.pathname + u.search + u.hash + '" '), ue.env.NODE_ENV !== "production" && Co(p == null || p[p.length - 1].route.element !== void 0 || p[p.length - 1].route.Component !== void 0, 'Matched leaf route at location "' + u.pathname + u.search + u.hash + '" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.'));
  let m = pSe(p && p.map((R) => Object.assign({}, R, {
    params: Object.assign({}, o, R.params),
    pathname: Dd([
      l,
      // Re-encode pathnames that were decoded inside matchRoutes
      r.encodeLocation ? r.encodeLocation(R.pathname).pathname : R.pathname
    ]),
    pathnameBase: R.pathnameBase === "/" ? l : Dd([
      l,
      // Re-encode pathnames that were decoded inside matchRoutes
      r.encodeLocation ? r.encodeLocation(R.pathnameBase).pathname : R.pathnameBase
    ])
  })), i, n);
  return e && m ? /* @__PURE__ */ H.createElement(gm.Provider, {
    value: {
      location: r2({
        pathname: "/",
        search: "",
        hash: "",
        state: null,
        key: "default"
      }, u),
      navigationType: Il.Pop
    }
  }, m) : m;
}
function uSe() {
  let t = VSe(), e = aSe(t) ? t.status + " " + t.statusText : t instanceof Error ? t.message : JSON.stringify(t), n = t instanceof Error ? t.stack : null, r = "rgba(200,200,200, 0.5)", i = {
    padding: "0.5rem",
    backgroundColor: r
  }, a = {
    padding: "2px 4px",
    backgroundColor: r
  }, o = null;
  return ue.env.NODE_ENV !== "production" && (console.error("Error handled by React Router default ErrorBoundary:", t), o = /* @__PURE__ */ H.createElement(H.Fragment, null, /* @__PURE__ */ H.createElement("p", null, "💿 Hey developer 👋"), /* @__PURE__ */ H.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ H.createElement("code", {
    style: a
  }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ H.createElement("code", {
    style: a
  }, "errorElement"), " prop on your route."))), /* @__PURE__ */ H.createElement(H.Fragment, null, /* @__PURE__ */ H.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ H.createElement("h3", {
    style: {
      fontStyle: "italic"
    }
  }, e), n ? /* @__PURE__ */ H.createElement("pre", {
    style: i
  }, n) : null, o);
}
const hSe = /* @__PURE__ */ H.createElement(uSe, null);
class NSe extends H.Component {
  constructor(e) {
    super(e), this.state = {
      location: e.location,
      revalidation: e.revalidation,
      error: e.error
    };
  }
  static getDerivedStateFromError(e) {
    return {
      error: e
    };
  }
  static getDerivedStateFromProps(e, n) {
    return n.location !== e.location || n.revalidation !== "idle" && e.revalidation === "idle" ? {
      error: e.error,
      location: e.location,
      revalidation: e.revalidation
    } : {
      error: e.error || n.error,
      location: n.location,
      revalidation: e.revalidation || n.revalidation
    };
  }
  componentDidCatch(e, n) {
    console.error("React Router caught the following error during render", e, n);
  }
  render() {
    return this.state.error ? /* @__PURE__ */ H.createElement(gu.Provider, {
      value: this.props.routeContext
    }, /* @__PURE__ */ H.createElement(Sx.Provider, {
      value: this.state.error,
      children: this.props.component
    })) : this.props.children;
  }
}
function MSe(t) {
  let {
    routeContext: e,
    match: n,
    children: r
  } = t, i = H.useContext(PU);
  return i && i.static && i.staticContext && (n.route.errorElement || n.route.ErrorBoundary) && (i.staticContext._deepestRenderedBoundaryId = n.route.id), /* @__PURE__ */ H.createElement(gu.Provider, {
    value: e
  }, r);
}
function pSe(t, e, n) {
  var r;
  if (e === void 0 && (e = []), n === void 0 && (n = null), t == null) {
    var i;
    if ((i = n) != null && i.errors)
      t = n.matches;
    else
      return null;
  }
  let a = t, o = (r = n) == null ? void 0 : r.errors;
  if (o != null) {
    let s = a.findIndex((l) => l.route.id && (o == null ? void 0 : o[l.route.id]));
    s >= 0 || (ue.env.NODE_ENV !== "production" ? In(!1, "Could not find a matching route for errors on route IDs: " + Object.keys(o).join(",")) : In(!1)), a = a.slice(0, Math.min(a.length, s + 1));
  }
  return a.reduceRight((s, l, c) => {
    let d = l.route.id ? o == null ? void 0 : o[l.route.id] : null, u = null;
    n && (u = l.route.errorElement || hSe);
    let h = e.concat(a.slice(0, c + 1)), N = () => {
      let M;
      return d ? M = u : l.route.Component ? M = /* @__PURE__ */ H.createElement(l.route.Component, null) : l.route.element ? M = l.route.element : M = s, /* @__PURE__ */ H.createElement(MSe, {
        match: l,
        routeContext: {
          outlet: s,
          matches: h,
          isDataRoute: n != null
        },
        children: M
      });
    };
    return n && (l.route.ErrorBoundary || l.route.errorElement || c === 0) ? /* @__PURE__ */ H.createElement(NSe, {
      location: n.location,
      revalidation: n.revalidation,
      component: u,
      error: d,
      children: N(),
      routeContext: {
        outlet: null,
        matches: h,
        isDataRoute: !0
      }
    }) : N();
  }, null);
}
var oL = /* @__PURE__ */ function(t) {
  return t.UseBlocker = "useBlocker", t.UseRevalidator = "useRevalidator", t.UseNavigateStable = "useNavigate", t;
}(oL || {}), i2 = /* @__PURE__ */ function(t) {
  return t.UseBlocker = "useBlocker", t.UseLoaderData = "useLoaderData", t.UseActionData = "useActionData", t.UseRouteError = "useRouteError", t.UseNavigation = "useNavigation", t.UseRouteLoaderData = "useRouteLoaderData", t.UseMatches = "useMatches", t.UseRevalidator = "useRevalidator", t.UseNavigateStable = "useNavigate", t.UseRouteId = "useRouteId", t;
}(i2 || {});
function xx(t) {
  return t + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function mSe(t) {
  let e = H.useContext(PU);
  return e || (ue.env.NODE_ENV !== "production" ? In(!1, xx(t)) : In(!1)), e;
}
function TSe(t) {
  let e = H.useContext(nL);
  return e || (ue.env.NODE_ENV !== "production" ? In(!1, xx(t)) : In(!1)), e;
}
function fSe(t) {
  let e = H.useContext(gu);
  return e || (ue.env.NODE_ENV !== "production" ? In(!1, xx(t)) : In(!1)), e;
}
function sL(t) {
  let e = fSe(t), n = e.matches[e.matches.length - 1];
  return n.route.id || (ue.env.NODE_ENV !== "production" ? In(!1, t + ' can only be used on routes that contain a unique "id"') : In(!1)), n.route.id;
}
function VSe() {
  var t;
  let e = H.useContext(Sx), n = TSe(i2.UseRouteError), r = sL(i2.UseRouteError);
  return e || ((t = n.errors) == null ? void 0 : t[r]);
}
function USe() {
  let {
    router: t
  } = mSe(oL.UseNavigateStable), e = sL(i2.UseNavigateStable), n = H.useRef(!1);
  return iL(() => {
    n.current = !0;
  }), H.useCallback(function(i, a) {
    a === void 0 && (a = {}), ue.env.NODE_ENV !== "production" && Co(n.current, rL), n.current && (typeof i == "number" ? t.navigate(i) : t.navigate(i, r2({
      fromRouteId: e
    }, a)));
  }, [t, e]);
}
const mk = {};
function RSe(t, e, n) {
  !e && !mk[t] && (mk[t] = !0, ue.env.NODE_ENV !== "production" && Co(!1, n));
}
const gSe = "startTransition", Tk = H[gSe];
function ySe(t) {
  let {
    basename: e,
    children: n,
    initialEntries: r,
    initialIndex: i,
    future: a
  } = t, o = H.useRef();
  o.current == null && (o.current = z3e({
    initialEntries: r,
    initialIndex: i,
    v5Compat: !0
  }));
  let s = o.current, [l, c] = H.useState({
    action: s.action,
    location: s.location
  }), {
    v7_startTransition: d
  } = a || {}, u = H.useCallback((h) => {
    d && Tk ? Tk(() => c(h)) : c(h);
  }, [c, d]);
  return H.useLayoutEffect(() => s.listen(u), [s, u]), /* @__PURE__ */ H.createElement(ZSe, {
    basename: e,
    children: n,
    location: l.location,
    navigationType: l.action,
    navigator: s
  });
}
function ZSe(t) {
  let {
    basename: e = "/",
    children: n = null,
    location: r,
    navigationType: i = Il.Pop,
    navigator: a,
    static: o = !1
  } = t;
  KU() && (ue.env.NODE_ENV !== "production" ? In(!1, "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.") : In(!1));
  let s = e.replace(/^\/*/, "/"), l = H.useMemo(() => ({
    basename: s,
    navigator: a,
    static: o
  }), [s, a, o]);
  typeof r == "string" && (r = Ru(r));
  let {
    pathname: c = "/",
    search: d = "",
    hash: u = "",
    state: h = null,
    key: N = "default"
  } = r, M = H.useMemo(() => {
    let p = eL(c, s);
    return p == null ? null : {
      location: {
        pathname: p,
        search: d,
        hash: u,
        state: h,
        key: N
      },
      navigationType: i
    };
  }, [s, c, d, u, h, N, i]);
  return ue.env.NODE_ENV !== "production" && Co(M != null, '<Router basename="' + s + '"> is not able to match the URL ' + ('"' + c + d + u + '" because it does not start with the ') + "basename, so the <Router> won't render anything."), M == null ? null : /* @__PURE__ */ H.createElement(Rm.Provider, {
    value: l
  }, /* @__PURE__ */ H.createElement(gm.Provider, {
    children: n,
    value: M
  }));
}
new Promise(() => {
});
function qs() {
  const t = aL();
  return { navigateBack: De(() => {
    t(-1);
  }, [t]), navigate: t };
}
const lL = Wt({
  transactions: []
}), cL = Wt(() => {
});
function bSe({ children: t }) {
  const e = localStorage.getItem("xy-transactions"), n = (() => {
    if (e)
      try {
        return JSON.parse(e);
      } catch (a) {
        console.error("STORAGE_TRANSACTIONS_ERROR", a);
      }
    return [];
  })(), [r, i] = yc(ESe, {
    transactions: n
  });
  return Ee(() => {
    const { transactions: a } = r;
    localStorage.setItem("xy-transactions", JSON.stringify(a));
  }, [r]), /* @__PURE__ */ E.jsx(lL.Provider, { value: r, children: /* @__PURE__ */ E.jsx(cL.Provider, { value: i, children: t }) });
}
function ESe(t, e) {
  const { type: n, payload: r } = e;
  switch (n) {
    case "SET_TRANSACTIONS":
      t.transactions = r;
      return;
    case "ADD_TRANSACTION":
      t.transactions = [...t.transactions, r];
      return;
    case "SET_TRANSACTION_RECEIPT":
      const { id: i, receiptUpdatedAt: a, receiptStatus: o } = r, s = t.transactions.findIndex(
        (h) => h.id === i
      );
      t.transactions[s].receiptStatus = o, t.transactions[s].receiptUpdatedAt = a;
      return;
    case "SET_CROSS_CHAIN_SWAP_TRANSACTION_TX":
      const { id: l, destinationChainHash: c } = r, d = t.transactions.findIndex(
        (h) => h.id === l
      ), u = t.transactions[d];
      u.destinationChainHash = c;
      return;
  }
}
function qU() {
  const { transactions: t } = lt(lL), { address: e } = Ui(), n = [...t].sort((h, N) => N.createdAt - h.createdAt).filter((h) => h.msgSender === e), r = n.filter(
    (h) => h.receiptUpdatedAt === null
  ), i = n.filter(
    (h) => h.type === "swap"
  ), a = n.filter(
    (h) => h.type === "approve"
  ), o = i.filter(
    (h) => !h.isCrossChain
  ), s = i.filter(
    (h) => h.isCrossChain
  ), l = o.filter(
    (h) => !h.receiptUpdatedAt
  ), c = s.filter((h) => {
    var N, M;
    return ((N = h.receipt) == null ? void 0 : N.status) === 0 || h.receiptStatus === 0 || h.receiptStatus === "reverted" ? !1 : ((M = h.receipt) == null ? void 0 : M.status) === 1 || h.receiptStatus === 1 || h.receiptStatus === "success" ? !h.destinationChainHash : !0;
  }), d = i[0] ? i[0] : null, u = l.length !== 0 || c.length !== 0;
  return {
    transactions: n,
    processingTransactions: r,
    swapTransactions: i,
    processingSingleChainSwapTransactinos: l,
    crossChainSwapTransactinos: s,
    processingCrossChainSwapTransactinos: c,
    approveTransactions: a,
    latestSwapTransaction: d,
    isSwapTransactionProcessing: u
  };
}
function Wx() {
  return lt(cL);
}
function SSe() {
  const { iframeUrl: t } = lt(oJ);
  return {
    iframeUrl: t
  };
}
function yu() {
  const {
    data: t,
    dataUpdatedAt: e,
    isLoading: n,
    isError: r,
    isFetching: i,
    isStale: a,
    refetch: o,
    error: s
  } = lt(sJ), l = t == null ? void 0 : t.route, c = !!(t && t.success), d = t == null ? void 0 : t.error_code, u = t == null ? void 0 : t.error_msg, h = d ? EI.getErrorMessageDisplayFromErrorCode(d) : null, N = l ? qi(
    BigInt(l.dst_quote_token_amount),
    l.dst_quote_token.decimals
  ) : null, M = l ? l.src_chain_id === l.dst_chain_id : !1, p = l ? l.src_chain_id !== l.dst_chain_id : !1, m = h ? new Error(h) : null, R = [s, m], V = d === Bt.Build_Tx_Rate_Limit, U = (() => {
    if (!l)
      return !1;
    const { src_quote_token_usd_value: g, dst_quote_token_usd_value: y } = l;
    if (!g || !y)
      return !1;
    const x = Number(g), f = Number(y);
    return x >= 1e4 ? f <= x * 0.05 : x >= 3e3 ? f <= x * 0.1 : x >= 1e3 ? f <= x * 0.2 : x >= 100 ? f <= x * 0.3 : f <= x * 0.5;
  })();
  return {
    data: t,
    dataUpdatedAt: e,
    isLoading: n,
    isError: r,
    isFetching: i,
    isStale: a,
    refetch: o,
    error: s,
    route: l,
    isSuccess: c,
    errorCode: d,
    errorMessage: u,
    errors: R,
    isSingleChain: M,
    isCrossChain: p,
    formatedSelectedRouteTokenNumber: N,
    isPriceImpact: U,
    isRateLimitError: V
  };
}
function jx() {
  const { isNewBuildTx: t, isUserAcceptNewBuildTx: e, isUserProceedPriceImpact: n } = lt(pL);
  return {
    isNewBuildTx: t,
    isUserAcceptNewBuildTx: e,
    isUserProceedPriceImpact: n
  };
}
function dL() {
  return lt(mL);
}
const uL = {
  contract: {
    lightSecondaryButtonBorder: {
      enable: "rgba(45, 51, 57, 1)",
      disable: "rgba(184, 191, 199, 0.4)"
    },
    darkSecondaryButtonBorder: {
      enable: "rgba(198, 204, 210, 1)",
      disable: "rgba(56, 64, 71, 0.4)"
    },
    lightBackgroundText: {
      enable: "rgba(20, 23, 26, 1)",
      hover: "rgba(20, 23, 26, 1)",
      disable: "rgba(20, 23, 26, 0.4)"
    },
    darkBackgroundText: {
      enable: "rgba(255, 255, 255, 1)",
      hover: "rgba(255, 255, 255, 1)",
      disable: "rgba(255, 255, 255, 0.4)"
    }
  }
}, hL = {
  contract: {
    lightSecondaryButtonBorder: {
      enable: "rgba(45, 51, 57, 1)",
      disable: "rgba(184, 191, 199, 0.4)"
    },
    darkSecondaryButtonBorder: {
      enable: "rgba(198, 204, 210, 1)",
      disable: "rgba(56, 64, 71, 0.4)"
    },
    lightBackgroundText: {
      enable: "rgba(20, 23, 26, 1)",
      hover: "rgba(20, 23, 26, 1)",
      disable: "rgba(20, 23, 26, 0.4)"
    },
    darkBackgroundText: {
      enable: "rgba(255, 255, 255, 1)",
      hover: "rgba(255, 255, 255, 1)",
      disable: "rgba(255, 255, 255, 0.4)"
    }
  }
}, NL = () => {
  const { colors: { primary: t }, isDarkMode: e } = ca(), n = e ? uL : hL, { lightBackgroundText: r, darkBackgroundText: i } = n.contract;
  return Pe.readability(t, "white") > _U ? i.enable : r.enable;
}, xSe = () => {
  const { colors: { primary: t }, isDarkMode: e } = ca(), n = e ? uL : hL, { lightSecondaryButtonBorder: r, darkSecondaryButtonBorder: i } = n.contract;
  return Pe.readability(t, "white") > _U ? i.enable : r.enable;
};
function WSe({ children: t }) {
  const e = ca(), n = j3e(e);
  return /* @__PURE__ */ E.jsx(E.Fragment, { children: /* @__PURE__ */ E.jsx(jZe, { theme: n, children: t }) });
}
const ML = {
  isNewBuildTx: !1,
  isUserAcceptNewBuildTx: !1,
  isUserProceedPriceImpact: !1
}, pL = Wt(ML), mL = Wt(
  () => {
  }
);
function jSe(t, e) {
  const { type: n, payload: r } = e;
  switch (n) {
    case "SET_IS_NEW_BUILD_TX":
      t.isNewBuildTx = r;
      break;
    case "SET_IS_USER_ACCEPT_NEW_BUILD_TX":
      t.isUserAcceptNewBuildTx = r;
      break;
    case "SET_IS_USER_PROCEED_PRICE_IMPACT":
      t.isUserProceedPriceImpact = r;
      break;
  }
}
function DSe({ children: t }) {
  const [e, n] = yc(jSe, {
    ...ML
  });
  return /* @__PURE__ */ E.jsx(pL.Provider, { value: e, children: /* @__PURE__ */ E.jsx(mL.Provider, { value: n, children: t }) });
}
const TL = Wt({
  approveError: null,
  swapError: null
}), fL = Wt(() => {
});
function zSe({ children: t }) {
  const [e, n] = yc(kSe, {
    approveError: null,
    swapError: null
  }), { dataUpdatedAt: r } = aa();
  return Ee(() => {
    n({ type: "RESET_ERROR" });
  }, [r]), /* @__PURE__ */ E.jsx(TL.Provider, { value: e, children: /* @__PURE__ */ E.jsx(fL.Provider, { value: n, children: t }) });
}
function kSe(t, e) {
  const { type: n, payload: r } = e;
  switch (n) {
    case "RESET_ERROR":
      t.approveError = null, t.swapError = null;
      return;
    case "SET_APPROVE_ERROR":
      t.approveError = r;
      return;
    case "SET_SWAP_ERROR":
      t.swapError = r;
      return;
  }
}
const wSe = Wt({
  connectError: null
}), FSe = Wt(() => {
});
function vSe({ children: t }) {
  const [e, n] = yc(ISe, {
    connectError: null
  });
  return /* @__PURE__ */ E.jsx(wSe.Provider, { value: e, children: /* @__PURE__ */ E.jsx(FSe.Provider, { value: n, children: t }) });
}
function ISe(t, e) {
  const { type: n, payload: r } = e;
  switch (n) {
    case "SET_CONNECT_ERROR":
      t.connectError = r;
      return;
  }
}
function OSe({ children: t }) {
  return /* @__PURE__ */ E.jsx(ySe, { children: t });
}
const {
  DEV: YSe,
  VITE_API_BASE_URL: QSe,
  VITE_TOKEN_LIST_URL: GSe,
  VITE_PLAT: CSe,
  VITE_ROUTER_API_URL: LSe,
  VITE_NEST_API_URL: JSe
} = { VITE_PLAT: "PRODUCTION", VITE_API_BASE_URL: "https://api.xy.finance", VITE_TOKEN_LIST_URL: "https://token-list-v2.xy.finance", VITE_ROUTER_API_URL: "https://router-api.xy.finance/xy_router", VITE_NEST_API_URL: "https://prod-nest-xy-finance-jlurmtcgjq-de.a.run.app", BASE_URL: "/", MODE: "prod", DEV: !1, PROD: !0, SSR: !1 }, El = {
  DEV: YSe,
  PLAT: CSe,
  TOKEN_LIST_URL: GSe,
  API_BASE_URL: QSe,
  ROUTER_API_URL: LSe,
  NEST_API_URL: JSe
}, VL = Object.prototype.toString;
function UL(t) {
  switch (VL.call(t)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
      return !0;
    default:
      return Mc(t, Error);
  }
}
function uN(t, e) {
  return VL.call(t) === `[object ${e}]`;
}
function RL(t) {
  return uN(t, "ErrorEvent");
}
function fk(t) {
  return uN(t, "DOMError");
}
function BSe(t) {
  return uN(t, "DOMException");
}
function Nc(t) {
  return uN(t, "String");
}
function gL(t) {
  return t === null || typeof t != "object" && typeof t != "function";
}
function kh(t) {
  return uN(t, "Object");
}
function Dx(t) {
  return typeof Event < "u" && Mc(t, Event);
}
function ASe(t) {
  return typeof Element < "u" && Mc(t, Element);
}
function HSe(t) {
  return uN(t, "RegExp");
}
function zx(t) {
  return !!(t && t.then && typeof t.then == "function");
}
function XSe(t) {
  return kh(t) && "nativeEvent" in t && "preventDefault" in t && "stopPropagation" in t;
}
function yL(t) {
  return typeof t == "number" && t !== t;
}
function Mc(t, e) {
  try {
    return t instanceof e;
  } catch {
    return !1;
  }
}
function VT(t) {
  return t && t.Math == Math ? t : void 0;
}
const Cr = typeof globalThis == "object" && VT(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && VT(window) || typeof self == "object" && VT(self) || typeof $i == "object" && VT($i) || function() {
  return this;
}() || {};
function ym() {
  return Cr;
}
function kx(t, e, n) {
  const r = n || Cr, i = r.__SENTRY__ = r.__SENTRY__ || {};
  return i[t] || (i[t] = e());
}
const Mf = ym(), _Se = 80;
function wh(t, e = {}) {
  try {
    let n = t;
    const r = 5, i = [];
    let a = 0, o = 0;
    const s = " > ", l = s.length;
    let c;
    const d = Array.isArray(e) ? e : e.keyAttrs, u = !Array.isArray(e) && e.maxStringLength || _Se;
    for (; n && a++ < r && (c = PSe(n, d), !(c === "html" || a > 1 && o + i.length * l + c.length >= u)); )
      i.push(c), o += c.length, n = n.parentNode;
    return i.reverse().join(s);
  } catch {
    return "<unknown>";
  }
}
function PSe(t, e) {
  const n = t, r = [];
  let i, a, o, s, l;
  if (!n || !n.tagName)
    return "";
  r.push(n.tagName.toLowerCase());
  const c = e && e.length ? e.filter((u) => n.getAttribute(u)).map((u) => [u, n.getAttribute(u)]) : null;
  if (c && c.length)
    c.forEach((u) => {
      r.push(`[${u[0]}="${u[1]}"]`);
    });
  else if (n.id && r.push(`#${n.id}`), i = n.className, i && Nc(i))
    for (a = i.split(/\s+/), l = 0; l < a.length; l++)
      r.push(`.${a[l]}`);
  const d = ["aria-label", "type", "name", "title", "alt"];
  for (l = 0; l < d.length; l++)
    o = d[l], s = n.getAttribute(o), s && r.push(`[${o}="${s}"]`);
  return r.join("");
}
function KSe() {
  try {
    return Mf.document.location.href;
  } catch {
    return "";
  }
}
function $Se(t) {
  return Mf.document && Mf.document.querySelector ? Mf.document.querySelector(t) : null;
}
class $r extends Error {
  /** Display name of this error instance. */
  constructor(e, n = "warn") {
    super(e), this.message = e, this.name = new.target.prototype.constructor.name, Object.setPrototypeOf(this, new.target.prototype), this.logLevel = n;
  }
}
const qSe = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function exe(t) {
  return t === "http" || t === "https";
}
function eR(t, e = !1) {
  const { host: n, path: r, pass: i, port: a, projectId: o, protocol: s, publicKey: l } = t;
  return `${s}://${l}${e && i ? `:${i}` : ""}@${n}${a ? `:${a}` : ""}/${r && `${r}/`}${o}`;
}
function txe(t) {
  const e = qSe.exec(t);
  if (!e)
    throw new $r(`Invalid Sentry Dsn: ${t}`);
  const [n, r, i = "", a, o = "", s] = e.slice(1);
  let l = "", c = s;
  const d = c.split("/");
  if (d.length > 1 && (l = d.slice(0, -1).join("/"), c = d.pop()), c) {
    const u = c.match(/^\d+/);
    u && (c = u[0]);
  }
  return ZL({ host: a, pass: i, path: l, projectId: c, port: o, protocol: n, publicKey: r });
}
function ZL(t) {
  return {
    protocol: t.protocol,
    publicKey: t.publicKey || "",
    pass: t.pass || "",
    host: t.host,
    port: t.port || "",
    path: t.path || "",
    projectId: t.projectId
  };
}
function nxe(t) {
  if (!(typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__))
    return;
  const { port: e, projectId: n, protocol: r } = t;
  if (["protocol", "publicKey", "host", "projectId"].forEach((a) => {
    if (!t[a])
      throw new $r(`Invalid Sentry Dsn: ${a} missing`);
  }), !n.match(/^\d+$/))
    throw new $r(`Invalid Sentry Dsn: Invalid projectId ${n}`);
  if (!exe(r))
    throw new $r(`Invalid Sentry Dsn: Invalid protocol ${r}`);
  if (e && isNaN(parseInt(e, 10)))
    throw new $r(`Invalid Sentry Dsn: Invalid port ${e}`);
  return !0;
}
function rxe(t) {
  const e = typeof t == "string" ? txe(t) : ZL(t);
  return nxe(e), e;
}
const ixe = "Sentry Logger ", rp = ["debug", "info", "warn", "error", "log", "assert", "trace"];
function bL(t) {
  if (!("console" in Cr))
    return t();
  const e = Cr.console, n = {};
  rp.forEach((r) => {
    const i = e[r] && e[r].__sentry_original__;
    r in e && i && (n[r] = e[r], e[r] = i);
  });
  try {
    return t();
  } finally {
    Object.keys(n).forEach((r) => {
      e[r] = n[r];
    });
  }
}
function Vk() {
  let t = !1;
  const e = {
    enable: () => {
      t = !0;
    },
    disable: () => {
      t = !1;
    }
  };
  return typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__ ? rp.forEach((n) => {
    e[n] = (...r) => {
      t && bL(() => {
        Cr.console[n](`${ixe}[${n}]:`, ...r);
      });
    };
  }) : rp.forEach((n) => {
    e[n] = () => {
    };
  }), e;
}
let ge;
typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__ ? ge = kx("logger", Vk) : ge = Vk();
function b1(t, e = 0) {
  return typeof t != "string" || e === 0 || t.length <= e ? t : `${t.slice(0, e)}...`;
}
function a2(t, e) {
  if (!Array.isArray(t))
    return "";
  const n = [];
  for (let r = 0; r < t.length; r++) {
    const i = t[r];
    try {
      n.push(String(i));
    } catch {
      n.push("[value cannot be serialized]");
    }
  }
  return n.join(e);
}
function axe(t, e, n = !1) {
  return Nc(t) ? HSe(e) ? e.test(t) : Nc(e) ? n ? t === e : t.includes(e) : !1 : !1;
}
function Zm(t, e = [], n = !1) {
  return e.some((r) => axe(t, r, n));
}
function jr(t, e, n) {
  if (!(e in t))
    return;
  const r = t[e], i = n(r);
  if (typeof i == "function")
    try {
      EL(i, r);
    } catch {
    }
  t[e] = i;
}
function wx(t, e, n) {
  Object.defineProperty(t, e, {
    // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
    value: n,
    writable: !0,
    configurable: !0
  });
}
function EL(t, e) {
  const n = e.prototype || {};
  t.prototype = e.prototype = n, wx(t, "__sentry_original__", e);
}
function Fx(t) {
  return t.__sentry_original__;
}
function oxe(t) {
  return Object.keys(t).map((e) => `${encodeURIComponent(e)}=${encodeURIComponent(t[e])}`).join("&");
}
function SL(t) {
  if (UL(t))
    return {
      message: t.message,
      name: t.name,
      stack: t.stack,
      ...Rk(t)
    };
  if (Dx(t)) {
    const e = {
      type: t.type,
      target: Uk(t.target),
      currentTarget: Uk(t.currentTarget),
      ...Rk(t)
    };
    return typeof CustomEvent < "u" && Mc(t, CustomEvent) && (e.detail = t.detail), e;
  } else
    return t;
}
function Uk(t) {
  try {
    return ASe(t) ? wh(t) : Object.prototype.toString.call(t);
  } catch {
    return "<unknown>";
  }
}
function Rk(t) {
  if (typeof t == "object" && t !== null) {
    const e = {};
    for (const n in t)
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    return e;
  } else
    return {};
}
function sxe(t, e = 40) {
  const n = Object.keys(SL(t));
  if (n.sort(), !n.length)
    return "[object has no keys]";
  if (n[0].length >= e)
    return b1(n[0], e);
  for (let r = n.length; r > 0; r--) {
    const i = n.slice(0, r).join(", ");
    if (!(i.length > e))
      return r === n.length ? i : b1(i, e);
  }
  return "";
}
function Bl(t) {
  return lE(t, /* @__PURE__ */ new Map());
}
function lE(t, e) {
  if (kh(t)) {
    const n = e.get(t);
    if (n !== void 0)
      return n;
    const r = {};
    e.set(t, r);
    for (const i of Object.keys(t))
      typeof t[i] < "u" && (r[i] = lE(t[i], e));
    return r;
  }
  if (Array.isArray(t)) {
    const n = e.get(t);
    if (n !== void 0)
      return n;
    const r = [];
    return e.set(t, r), t.forEach((i) => {
      r.push(lE(i, e));
    }), r;
  }
  return t;
}
const xL = 50, gk = /\(error: (.*)\)/;
function WL(...t) {
  const e = t.sort((n, r) => n[0] - r[0]).map((n) => n[1]);
  return (n, r = 0) => {
    const i = [], a = n.split(`
`);
    for (let o = r; o < a.length; o++) {
      const s = a[o];
      if (s.length > 1024)
        continue;
      const l = gk.test(s) ? s.replace(gk, "$1") : s;
      for (const c of e) {
        const d = c(l);
        if (d) {
          i.push(d);
          break;
        }
      }
      if (i.length >= xL)
        break;
    }
    return cxe(i);
  };
}
function lxe(t) {
  return Array.isArray(t) ? WL(...t) : t;
}
function cxe(t) {
  if (!t.length)
    return [];
  const e = t.slice(0, xL), n = e[e.length - 1].function;
  n && /sentryWrapped/.test(n) && e.pop(), e.reverse();
  const r = e[e.length - 1].function;
  return r && /captureMessage|captureException/.test(r) && e.pop(), e.map((i) => ({
    ...i,
    filename: i.filename || e[e.length - 1].filename,
    function: i.function || "?"
  }));
}
const dy = "<anonymous>";
function pc(t) {
  try {
    return !t || typeof t != "function" ? dy : t.name || dy;
  } catch {
    return dy;
  }
}
const cE = ym();
function jL() {
  if (!("fetch" in cE))
    return !1;
  try {
    return new Headers(), new Request("http://www.example.com"), new Response(), !0;
  } catch {
    return !1;
  }
}
function dE(t) {
  return t && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(t.toString());
}
function dxe() {
  if (!jL())
    return !1;
  if (dE(cE.fetch))
    return !0;
  let t = !1;
  const e = cE.document;
  if (e && typeof e.createElement == "function")
    try {
      const n = e.createElement("iframe");
      n.hidden = !0, e.head.appendChild(n), n.contentWindow && n.contentWindow.fetch && (t = dE(n.contentWindow.fetch)), e.head.removeChild(n);
    } catch (n) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", n);
    }
  return t;
}
const UT = ym();
function uxe() {
  const t = UT.chrome, e = t && t.app && t.app.runtime, n = "history" in UT && !!UT.history.pushState && !!UT.history.replaceState;
  return !e && n;
}
const Cn = ym(), E1 = {}, yk = {};
function hxe(t) {
  if (!yk[t])
    switch (yk[t] = !0, t) {
      case "console":
        Nxe();
        break;
      case "dom":
        Rxe();
        break;
      case "xhr":
        mxe();
        break;
      case "fetch":
        Mxe();
        break;
      case "history":
        Txe();
        break;
      case "error":
        gxe();
        break;
      case "unhandledrejection":
        yxe();
        break;
      default:
        (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn("unknown instrumentation type:", t);
        return;
    }
}
function _i(t, e) {
  E1[t] = E1[t] || [], E1[t].push(e), hxe(t);
}
function Xa(t, e) {
  if (!(!t || !E1[t]))
    for (const n of E1[t] || [])
      try {
        n(e);
      } catch (r) {
        (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.error(
          `Error while triggering instrumentation handler.
Type: ${t}
Name: ${pc(n)}
Error:`,
          r
        );
      }
}
function Nxe() {
  "console" in Cn && rp.forEach(function(t) {
    t in Cn.console && jr(Cn.console, t, function(e) {
      return function(...n) {
        Xa("console", { args: n, level: t }), e && e.apply(Cn.console, n);
      };
    });
  });
}
function Mxe() {
  dxe() && jr(Cn, "fetch", function(t) {
    return function(...e) {
      const { method: n, url: r } = pxe(e), i = {
        args: e,
        fetchData: {
          method: n,
          url: r
        },
        startTimestamp: Date.now()
      };
      return Xa("fetch", {
        ...i
      }), t.apply(Cn, e).then(
        (a) => (Xa("fetch", {
          ...i,
          endTimestamp: Date.now(),
          response: a
        }), a),
        (a) => {
          throw Xa("fetch", {
            ...i,
            endTimestamp: Date.now(),
            error: a
          }), a;
        }
      );
    };
  });
}
function uE(t, e) {
  return !!t && typeof t == "object" && !!t[e];
}
function Zk(t) {
  return typeof t == "string" ? t : t ? uE(t, "url") ? t.url : t.toString ? t.toString() : "" : "";
}
function pxe(t) {
  if (t.length === 0)
    return { method: "GET", url: "" };
  if (t.length === 2) {
    const [n, r] = t;
    return {
      url: Zk(n),
      method: uE(r, "method") ? String(r.method).toUpperCase() : "GET"
    };
  }
  const e = t[0];
  return {
    url: Zk(e),
    method: uE(e, "method") ? String(e.method).toUpperCase() : "GET"
  };
}
function mxe() {
  if (!("XMLHttpRequest" in Cn))
    return;
  const t = XMLHttpRequest.prototype;
  jr(t, "open", function(e) {
    return function(...n) {
      const r = n[1], i = this.__sentry_xhr__ = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        method: Nc(n[0]) ? n[0].toUpperCase() : n[0],
        url: n[1],
        request_headers: {}
      };
      Nc(r) && i.method === "POST" && r.match(/sentry_key/) && (this.__sentry_own_request__ = !0);
      const a = () => {
        const o = this.__sentry_xhr__;
        if (o && this.readyState === 4) {
          try {
            o.status_code = this.status;
          } catch {
          }
          Xa("xhr", {
            args: n,
            endTimestamp: Date.now(),
            startTimestamp: Date.now(),
            xhr: this
          });
        }
      };
      return "onreadystatechange" in this && typeof this.onreadystatechange == "function" ? jr(this, "onreadystatechange", function(o) {
        return function(...s) {
          return a(), o.apply(this, s);
        };
      }) : this.addEventListener("readystatechange", a), jr(this, "setRequestHeader", function(o) {
        return function(...s) {
          const [l, c] = s, d = this.__sentry_xhr__;
          return d && (d.request_headers[l] = c), o.apply(this, s);
        };
      }), e.apply(this, n);
    };
  }), jr(t, "send", function(e) {
    return function(...n) {
      return this.__sentry_xhr__ && n[0] !== void 0 && (this.__sentry_xhr__.body = n[0]), Xa("xhr", {
        args: n,
        startTimestamp: Date.now(),
        xhr: this
      }), e.apply(this, n);
    };
  });
}
let RT;
function Txe() {
  if (!uxe())
    return;
  const t = Cn.onpopstate;
  Cn.onpopstate = function(...n) {
    const r = Cn.location.href, i = RT;
    if (RT = r, Xa("history", {
      from: i,
      to: r
    }), t)
      try {
        return t.apply(this, n);
      } catch {
      }
  };
  function e(n) {
    return function(...r) {
      const i = r.length > 2 ? r[2] : void 0;
      if (i) {
        const a = RT, o = String(i);
        RT = o, Xa("history", {
          from: a,
          to: o
        });
      }
      return n.apply(this, r);
    };
  }
  jr(Cn.history, "pushState", e), jr(Cn.history, "replaceState", e);
}
const fxe = 1e3;
let gT, yT;
function Vxe(t, e) {
  if (!t || t.type !== e.type)
    return !0;
  try {
    if (t.target !== e.target)
      return !0;
  } catch {
  }
  return !1;
}
function Uxe(t) {
  if (t.type !== "keypress")
    return !1;
  try {
    const e = t.target;
    if (!e || !e.tagName)
      return !0;
    if (e.tagName === "INPUT" || e.tagName === "TEXTAREA" || e.isContentEditable)
      return !1;
  } catch {
  }
  return !0;
}
function bk(t, e = !1) {
  return (n) => {
    if (!n || yT === n || Uxe(n))
      return;
    const r = n.type === "keypress" ? "input" : n.type;
    gT === void 0 ? (t({
      event: n,
      name: r,
      global: e
    }), yT = n) : Vxe(yT, n) && (t({
      event: n,
      name: r,
      global: e
    }), yT = n), clearTimeout(gT), gT = Cn.setTimeout(() => {
      gT = void 0;
    }, fxe);
  };
}
function Rxe() {
  if (!("document" in Cn))
    return;
  const t = Xa.bind(null, "dom"), e = bk(t, !0);
  Cn.document.addEventListener("click", e, !1), Cn.document.addEventListener("keypress", e, !1), ["EventTarget", "Node"].forEach((n) => {
    const r = Cn[n] && Cn[n].prototype;
    !r || !r.hasOwnProperty || !r.hasOwnProperty("addEventListener") || (jr(r, "addEventListener", function(i) {
      return function(a, o, s) {
        if (a === "click" || a == "keypress")
          try {
            const l = this, c = l.__sentry_instrumentation_handlers__ = l.__sentry_instrumentation_handlers__ || {}, d = c[a] = c[a] || { refCount: 0 };
            if (!d.handler) {
              const u = bk(t);
              d.handler = u, i.call(this, a, u, s);
            }
            d.refCount++;
          } catch {
          }
        return i.call(this, a, o, s);
      };
    }), jr(
      r,
      "removeEventListener",
      function(i) {
        return function(a, o, s) {
          if (a === "click" || a == "keypress")
            try {
              const l = this, c = l.__sentry_instrumentation_handlers__ || {}, d = c[a];
              d && (d.refCount--, d.refCount <= 0 && (i.call(this, a, d.handler, s), d.handler = void 0, delete c[a]), Object.keys(c).length === 0 && delete l.__sentry_instrumentation_handlers__);
            } catch {
            }
          return i.call(this, a, o, s);
        };
      }
    ));
  });
}
let ZT = null;
function gxe() {
  ZT = Cn.onerror, Cn.onerror = function(t, e, n, r, i) {
    return Xa("error", {
      column: r,
      error: i,
      line: n,
      msg: t,
      url: e
    }), ZT && !ZT.__SENTRY_LOADER__ ? ZT.apply(this, arguments) : !1;
  }, Cn.onerror.__SENTRY_INSTRUMENTED__ = !0;
}
let bT = null;
function yxe() {
  bT = Cn.onunhandledrejection, Cn.onunhandledrejection = function(t) {
    return Xa("unhandledrejection", t), bT && !bT.__SENTRY_LOADER__ ? bT.apply(this, arguments) : !0;
  }, Cn.onunhandledrejection.__SENTRY_INSTRUMENTED__ = !0;
}
function Zxe() {
  const t = typeof WeakSet == "function", e = t ? /* @__PURE__ */ new WeakSet() : [];
  function n(i) {
    if (t)
      return e.has(i) ? !0 : (e.add(i), !1);
    for (let a = 0; a < e.length; a++)
      if (e[a] === i)
        return !0;
    return e.push(i), !1;
  }
  function r(i) {
    if (t)
      e.delete(i);
    else
      for (let a = 0; a < e.length; a++)
        if (e[a] === i) {
          e.splice(a, 1);
          break;
        }
  }
  return [n, r];
}
function Al() {
  const t = Cr, e = t.crypto || t.msCrypto;
  if (e && e.randomUUID)
    return e.randomUUID().replace(/-/g, "");
  const n = e && e.getRandomValues ? () => e.getRandomValues(new Uint8Array(1))[0] : () => Math.random() * 16;
  return ([1e7] + 1e3 + 4e3 + 8e3 + 1e11).replace(
    /[018]/g,
    (r) => (
      // eslint-disable-next-line no-bitwise
      (r ^ (n() & 15) >> r / 4).toString(16)
    )
  );
}
function DL(t) {
  return t.exception && t.exception.values ? t.exception.values[0] : void 0;
}
function Sl(t) {
  const { message: e, event_id: n } = t;
  if (e)
    return e;
  const r = DL(t);
  return r ? r.type && r.value ? `${r.type}: ${r.value}` : r.type || r.value || n || "<unknown>" : n || "<unknown>";
}
function hE(t, e, n) {
  const r = t.exception = t.exception || {}, i = r.values = r.values || [], a = i[0] = i[0] || {};
  a.value || (a.value = e || ""), a.type || (a.type = n || "Error");
}
function ip(t, e) {
  const n = DL(t);
  if (!n)
    return;
  const r = { type: "generic", handled: !0 }, i = n.mechanism;
  if (n.mechanism = { ...r, ...i, ...e }, e && "data" in e) {
    const a = { ...i && i.data, ...e.data };
    n.mechanism.data = a;
  }
}
function Ek(t) {
  if (t && t.__sentry_captured__)
    return !0;
  try {
    wx(t, "__sentry_captured__", !0);
  } catch {
  }
  return !1;
}
function zL(t) {
  return Array.isArray(t) ? t : [t];
}
function bxe() {
  return typeof __SENTRY_BROWSER_BUNDLE__ < "u" && !!__SENTRY_BROWSER_BUNDLE__;
}
function Exe() {
  return "npm";
}
function kL() {
  return !bxe() && Object.prototype.toString.call(typeof ue < "u" ? ue : 0) === "[object process]";
}
function Sxe(t, e) {
  return t.require(e);
}
function Ul(t, e = 1 / 0, n = 1 / 0) {
  try {
    return NE("", t, e, n);
  } catch (r) {
    return { ERROR: `**non-serializable** (${r})` };
  }
}
function wL(t, e = 3, n = 100 * 1024) {
  const r = Ul(t, e);
  return Dxe(r) > n ? wL(t, e - 1, n) : r;
}
function NE(t, e, n = 1 / 0, r = 1 / 0, i = Zxe()) {
  const [a, o] = i;
  if (e === null || ["number", "boolean", "string"].includes(typeof e) && !yL(e))
    return e;
  const s = xxe(t, e);
  if (!s.startsWith("[object "))
    return s;
  if (e.__sentry_skip_normalization__)
    return e;
  let l = n;
  if (typeof e.__sentry_override_normalization_depth__ == "number" && (l = e.__sentry_override_normalization_depth__), l === 0)
    return s.replace("object ", "");
  if (a(e))
    return "[Circular ~]";
  const c = e;
  if (c && typeof c.toJSON == "function")
    try {
      const N = c.toJSON();
      return NE("", N, l - 1, r, i);
    } catch {
    }
  const d = Array.isArray(e) ? [] : {};
  let u = 0;
  const h = SL(e);
  for (const N in h) {
    if (!Object.prototype.hasOwnProperty.call(h, N))
      continue;
    if (u >= r) {
      d[N] = "[MaxProperties ~]";
      break;
    }
    const M = h[N];
    d[N] = NE(N, M, l - 1, r, i), u++;
  }
  return o(e), d;
}
function xxe(t, e) {
  try {
    return t === "domain" && e && typeof e == "object" && e._events ? "[Domain]" : t === "domainEmitter" ? "[DomainEmitter]" : typeof $i < "u" && e === $i ? "[Global]" : typeof window < "u" && e === window ? "[Window]" : typeof document < "u" && e === document ? "[Document]" : XSe(e) ? "[SyntheticEvent]" : typeof e == "number" && e !== e ? "[NaN]" : e === void 0 ? "[undefined]" : typeof e == "function" ? `[Function: ${pc(e)}]` : typeof e == "symbol" ? `[${String(e)}]` : typeof e == "bigint" ? `[BigInt: ${String(e)}]` : `[object ${Wxe(e)}]`;
  } catch (n) {
    return `**non-serializable** (${n})`;
  }
}
function Wxe(t) {
  const e = Object.getPrototypeOf(t);
  return e ? e.constructor.name : "null prototype";
}
function jxe(t) {
  return ~-encodeURI(t).split(/%..|./).length;
}
function Dxe(t) {
  return jxe(JSON.stringify(t));
}
var ls;
(function(t) {
  t[t.PENDING = 0] = "PENDING";
  const n = 1;
  t[t.RESOLVED = n] = "RESOLVED";
  const r = 2;
  t[t.REJECTED = r] = "REJECTED";
})(ls || (ls = {}));
function Kd(t) {
  return new li((e) => {
    e(t);
  });
}
function o2(t) {
  return new li((e, n) => {
    n(t);
  });
}
class li {
  __init() {
    this._state = ls.PENDING;
  }
  __init2() {
    this._handlers = [];
  }
  constructor(e) {
    li.prototype.__init.call(this), li.prototype.__init2.call(this), li.prototype.__init3.call(this), li.prototype.__init4.call(this), li.prototype.__init5.call(this), li.prototype.__init6.call(this);
    try {
      e(this._resolve, this._reject);
    } catch (n) {
      this._reject(n);
    }
  }
  /** JSDoc */
  then(e, n) {
    return new li((r, i) => {
      this._handlers.push([
        !1,
        (a) => {
          if (!e)
            r(a);
          else
            try {
              r(e(a));
            } catch (o) {
              i(o);
            }
        },
        (a) => {
          if (!n)
            i(a);
          else
            try {
              r(n(a));
            } catch (o) {
              i(o);
            }
        }
      ]), this._executeHandlers();
    });
  }
  /** JSDoc */
  catch(e) {
    return this.then((n) => n, e);
  }
  /** JSDoc */
  finally(e) {
    return new li((n, r) => {
      let i, a;
      return this.then(
        (o) => {
          a = !1, i = o, e && e();
        },
        (o) => {
          a = !0, i = o, e && e();
        }
      ).then(() => {
        if (a) {
          r(i);
          return;
        }
        n(i);
      });
    });
  }
  /** JSDoc */
  __init3() {
    this._resolve = (e) => {
      this._setResult(ls.RESOLVED, e);
    };
  }
  /** JSDoc */
  __init4() {
    this._reject = (e) => {
      this._setResult(ls.REJECTED, e);
    };
  }
  /** JSDoc */
  __init5() {
    this._setResult = (e, n) => {
      if (this._state === ls.PENDING) {
        if (zx(n)) {
          n.then(this._resolve, this._reject);
          return;
        }
        this._state = e, this._value = n, this._executeHandlers();
      }
    };
  }
  /** JSDoc */
  __init6() {
    this._executeHandlers = () => {
      if (this._state === ls.PENDING)
        return;
      const e = this._handlers.slice();
      this._handlers = [], e.forEach((n) => {
        n[0] || (this._state === ls.RESOLVED && n[1](this._value), this._state === ls.REJECTED && n[2](this._value), n[0] = !0);
      });
    };
  }
}
function zxe(t) {
  const e = [];
  function n() {
    return t === void 0 || e.length < t;
  }
  function r(o) {
    return e.splice(e.indexOf(o), 1)[0];
  }
  function i(o) {
    if (!n())
      return o2(new $r("Not adding Promise because buffer limit was reached."));
    const s = o();
    return e.indexOf(s) === -1 && e.push(s), s.then(() => r(s)).then(
      null,
      () => r(s).then(null, () => {
      })
    ), s;
  }
  function a(o) {
    return new li((s, l) => {
      let c = e.length;
      if (!c)
        return s(!0);
      const d = setTimeout(() => {
        o && o > 0 && s(!1);
      }, o);
      e.forEach((u) => {
        Kd(u).then(() => {
          --c || (clearTimeout(d), s(!0));
        }, l);
      });
    });
  }
  return {
    $: e,
    add: i,
    drain: a
  };
}
function uy(t) {
  if (!t)
    return {};
  const e = t.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!e)
    return {};
  const n = e[6] || "", r = e[8] || "";
  return {
    host: e[4],
    path: e[5],
    protocol: e[2],
    search: n,
    hash: r,
    relative: e[5] + n + r
    // everything minus origin
  };
}
const kxe = ["fatal", "error", "warning", "log", "info", "debug"];
function FL(t) {
  return t === "warn" ? "warning" : kxe.includes(t) ? t : "log";
}
const vL = ym(), ME = {
  nowSeconds: () => Date.now() / 1e3
};
function wxe() {
  const { performance: t } = vL;
  if (!t || !t.now)
    return;
  const e = Date.now() - t.now();
  return {
    now: () => t.now(),
    timeOrigin: e
  };
}
function Fxe() {
  try {
    return Sxe(module, "perf_hooks").performance;
  } catch {
    return;
  }
}
const hy = kL() ? Fxe() : wxe(), Sk = hy === void 0 ? ME : {
  nowSeconds: () => (hy.timeOrigin + hy.now()) / 1e3
}, tR = ME.nowSeconds.bind(ME), vx = Sk.nowSeconds.bind(Sk), ap = vx, $d = (() => {
  const { performance: t } = vL;
  if (!t || !t.now)
    return;
  const e = 3600 * 1e3, n = t.now(), r = Date.now(), i = t.timeOrigin ? Math.abs(t.timeOrigin + n - r) : e, a = i < e, o = t.timing && t.timing.navigationStart, l = typeof o == "number" ? Math.abs(o + n - r) : e, c = l < e;
  return a || c ? i <= l ? t.timeOrigin : o : r;
})(), vxe = new RegExp(
  "^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$"
  // whitespace
);
function Ixe(t) {
  const e = t.match(vxe);
  if (!t || !e)
    return;
  let n;
  return e[3] === "1" ? n = !0 : e[3] === "0" && (n = !1), {
    traceId: e[1],
    parentSampled: n,
    parentSpanId: e[2]
  };
}
function bm(t, e = []) {
  return [t, e];
}
function Oxe(t, e) {
  const [n, r] = t;
  return [n, [...r, e]];
}
function xk(t, e) {
  const n = t[1];
  for (const r of n) {
    const i = r[0].type;
    if (e(r, i))
      return !0;
  }
  return !1;
}
function pE(t, e) {
  return (e || new TextEncoder()).encode(t);
}
function Yxe(t, e) {
  const [n, r] = t;
  let i = JSON.stringify(n);
  function a(o) {
    typeof i == "string" ? i = typeof o == "string" ? i + o : [pE(i, e), o] : i.push(typeof o == "string" ? pE(o, e) : o);
  }
  for (const o of r) {
    const [s, l] = o;
    if (a(`
${JSON.stringify(s)}
`), typeof l == "string" || l instanceof Uint8Array)
      a(l);
    else {
      let c;
      try {
        c = JSON.stringify(l);
      } catch {
        c = JSON.stringify(Ul(l));
      }
      a(c);
    }
  }
  return typeof i == "string" ? i : Qxe(i);
}
function Qxe(t) {
  const e = t.reduce((i, a) => i + a.length, 0), n = new Uint8Array(e);
  let r = 0;
  for (const i of t)
    n.set(i, r), r += i.length;
  return n;
}
function Gxe(t, e) {
  const n = typeof t.data == "string" ? pE(t.data, e) : t.data;
  return [
    Bl({
      type: "attachment",
      length: n.length,
      filename: t.filename,
      content_type: t.contentType,
      attachment_type: t.attachmentType
    }),
    n
  ];
}
const Cxe = {
  session: "session",
  sessions: "session",
  attachment: "attachment",
  transaction: "transaction",
  event: "error",
  client_report: "internal",
  user_report: "default",
  profile: "profile",
  replay_event: "replay",
  replay_recording: "replay"
};
function Wk(t) {
  return Cxe[t];
}
function IL(t) {
  if (!t || !t.sdk)
    return;
  const { name: e, version: n } = t.sdk;
  return { name: e, version: n };
}
function Lxe(t, e, n, r) {
  const i = t.sdkProcessingMetadata && t.sdkProcessingMetadata.dynamicSamplingContext;
  return {
    event_id: t.event_id,
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...e && { sdk: e },
    ...!!n && { dsn: eR(r) },
    ...t.type === "transaction" && i && {
      trace: Bl({ ...i })
    }
  };
}
function Jxe(t, e, n) {
  const r = [
    { type: "client_report" },
    {
      timestamp: n || tR(),
      discarded_events: t
    }
  ];
  return bm(e ? { dsn: e } : {}, [r]);
}
const Bxe = 60 * 1e3;
function Axe(t, e = Date.now()) {
  const n = parseInt(`${t}`, 10);
  if (!isNaN(n))
    return n * 1e3;
  const r = Date.parse(`${t}`);
  return isNaN(r) ? Bxe : r - e;
}
function Hxe(t, e) {
  return t[e] || t.all || 0;
}
function Xxe(t, e, n = Date.now()) {
  return Hxe(t, e) > n;
}
function _xe(t, { statusCode: e, headers: n }, r = Date.now()) {
  const i = {
    ...t
  }, a = n && n["x-sentry-rate-limits"], o = n && n["retry-after"];
  if (a)
    for (const s of a.trim().split(",")) {
      const [l, c] = s.split(":", 2), d = parseInt(l, 10), u = (isNaN(d) ? 60 : d) * 1e3;
      if (!c)
        i.all = r + u;
      else
        for (const h of c.split(";"))
          i[h] = r + u;
    }
  else
    o ? i.all = r + Axe(o, r) : e === 429 && (i.all = r + 60 * 1e3);
  return i;
}
const mE = "baggage", OL = "sentry-", Pxe = /^sentry-/, Kxe = 8192;
function $xe(t) {
  if (!Nc(t) && !Array.isArray(t))
    return;
  let e = {};
  if (Array.isArray(t))
    e = t.reduce((r, i) => {
      const a = jk(i);
      return {
        ...r,
        ...a
      };
    }, {});
  else {
    if (!t)
      return;
    e = jk(t);
  }
  const n = Object.entries(e).reduce((r, [i, a]) => {
    if (i.match(Pxe)) {
      const o = i.slice(OL.length);
      r[o] = a;
    }
    return r;
  }, {});
  if (Object.keys(n).length > 0)
    return n;
}
function YL(t) {
  const e = Object.entries(t).reduce(
    (n, [r, i]) => (i && (n[`${OL}${r}`] = i), n),
    {}
  );
  return qxe(e);
}
function jk(t) {
  return t.split(",").map((e) => e.split("=").map((n) => decodeURIComponent(n.trim()))).reduce((e, [n, r]) => (e[n] = r, e), {});
}
function qxe(t) {
  if (Object.keys(t).length !== 0)
    return Object.entries(t).reduce((e, [n, r], i) => {
      const a = `${encodeURIComponent(n)}=${encodeURIComponent(r)}`, o = i === 0 ? a : `${e},${a}`;
      return o.length > Kxe ? ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn(
        `Not adding key: ${n} with val: ${r} to baggage header due to exceeding baggage size limits.`
      ), e) : o;
    }, "");
}
const Ix = "production";
function eWe(t) {
  const e = vx(), n = {
    sid: Al(),
    init: !0,
    timestamp: e,
    started: e,
    duration: 0,
    status: "ok",
    errors: 0,
    ignoreDuration: !1,
    toJSON: () => nWe(n)
  };
  return t && Fh(n, t), n;
}
function Fh(t, e = {}) {
  if (e.user && (!t.ipAddress && e.user.ip_address && (t.ipAddress = e.user.ip_address), !t.did && !e.did && (t.did = e.user.id || e.user.email || e.user.username)), t.timestamp = e.timestamp || vx(), e.ignoreDuration && (t.ignoreDuration = e.ignoreDuration), e.sid && (t.sid = e.sid.length === 32 ? e.sid : Al()), e.init !== void 0 && (t.init = e.init), !t.did && e.did && (t.did = `${e.did}`), typeof e.started == "number" && (t.started = e.started), t.ignoreDuration)
    t.duration = void 0;
  else if (typeof e.duration == "number")
    t.duration = e.duration;
  else {
    const n = t.timestamp - t.started;
    t.duration = n >= 0 ? n : 0;
  }
  e.release && (t.release = e.release), e.environment && (t.environment = e.environment), !t.ipAddress && e.ipAddress && (t.ipAddress = e.ipAddress), !t.userAgent && e.userAgent && (t.userAgent = e.userAgent), typeof e.errors == "number" && (t.errors = e.errors), e.status && (t.status = e.status);
}
function tWe(t, e) {
  let n = {};
  e ? n = { status: e } : t.status === "ok" && (n = { status: "exited" }), Fh(t, n);
}
function nWe(t) {
  return Bl({
    sid: `${t.sid}`,
    init: t.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(t.started * 1e3).toISOString(),
    timestamp: new Date(t.timestamp * 1e3).toISOString(),
    status: t.status,
    errors: t.errors,
    did: typeof t.did == "number" || typeof t.did == "string" ? `${t.did}` : void 0,
    duration: t.duration,
    attrs: {
      release: t.release,
      environment: t.environment,
      ip_address: t.ipAddress,
      user_agent: t.userAgent
    }
  });
}
const rWe = 100;
class Hl {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called after {@link applyToEvent}. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  // eslint-disable-next-line deprecation/deprecation
  /** Transaction Name */
  /** Span */
  /** Session */
  /** Request Mode Session Status */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {};
  }
  /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */
  static clone(e) {
    const n = new Hl();
    return e && (n._breadcrumbs = [...e._breadcrumbs], n._tags = { ...e._tags }, n._extra = { ...e._extra }, n._contexts = { ...e._contexts }, n._user = e._user, n._level = e._level, n._span = e._span, n._session = e._session, n._transactionName = e._transactionName, n._fingerprint = e._fingerprint, n._eventProcessors = [...e._eventProcessors], n._requestSession = e._requestSession, n._attachments = [...e._attachments], n._sdkProcessingMetadata = { ...e._sdkProcessingMetadata }), n;
  }
  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
  addScopeListener(e) {
    this._scopeListeners.push(e);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(e) {
    return this._eventProcessors.push(e), this;
  }
  /**
   * @inheritDoc
   */
  setUser(e) {
    return this._user = e || {}, this._session && Fh(this._session, { user: e }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(e) {
    return this._requestSession = e, this;
  }
  /**
   * @inheritDoc
   */
  setTags(e) {
    return this._tags = {
      ...this._tags,
      ...e
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(e, n) {
    return this._tags = { ...this._tags, [e]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(e) {
    return this._extra = {
      ...this._extra,
      ...e
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(e, n) {
    return this._extra = { ...this._extra, [e]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(e) {
    return this._fingerprint = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(e) {
    return this._level = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(e) {
    return this._transactionName = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(e, n) {
    return n === null ? delete this._contexts[e] : this._contexts[e] = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSpan(e) {
    return this._span = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSpan() {
    return this._span;
  }
  /**
   * @inheritDoc
   */
  getTransaction() {
    const e = this.getSpan();
    return e && e.transaction;
  }
  /**
   * @inheritDoc
   */
  setSession(e) {
    return e ? this._session = e : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(e) {
    if (!e)
      return this;
    if (typeof e == "function") {
      const n = e(this);
      return n instanceof Hl ? n : this;
    }
    return e instanceof Hl ? (this._tags = { ...this._tags, ...e._tags }, this._extra = { ...this._extra, ...e._extra }, this._contexts = { ...this._contexts, ...e._contexts }, e._user && Object.keys(e._user).length && (this._user = e._user), e._level && (this._level = e._level), e._fingerprint && (this._fingerprint = e._fingerprint), e._requestSession && (this._requestSession = e._requestSession)) : kh(e) && (e = e, this._tags = { ...this._tags, ...e.tags }, this._extra = { ...this._extra, ...e.extra }, this._contexts = { ...this._contexts, ...e.contexts }, e.user && (this._user = e.user), e.level && (this._level = e.level), e.fingerprint && (this._fingerprint = e.fingerprint), e.requestSession && (this._requestSession = e.requestSession)), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._span = void 0, this._session = void 0, this._notifyScopeListeners(), this._attachments = [], this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(e, n) {
    const r = typeof n == "number" ? n : rWe;
    if (r <= 0)
      return this;
    const i = {
      timestamp: tR(),
      ...e
    };
    return this._breadcrumbs = [...this._breadcrumbs, i].slice(-r), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(e) {
    return this._attachments.push(e), this;
  }
  /**
   * @inheritDoc
   */
  getAttachments() {
    return this._attachments;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */
  applyToEvent(e, n = {}) {
    if (this._extra && Object.keys(this._extra).length && (e.extra = { ...this._extra, ...e.extra }), this._tags && Object.keys(this._tags).length && (e.tags = { ...this._tags, ...e.tags }), this._user && Object.keys(this._user).length && (e.user = { ...this._user, ...e.user }), this._contexts && Object.keys(this._contexts).length && (e.contexts = { ...this._contexts, ...e.contexts }), this._level && (e.level = this._level), this._transactionName && (e.transaction = this._transactionName), this._span) {
      e.contexts = { trace: this._span.getTraceContext(), ...e.contexts };
      const r = this._span.transaction && this._span.transaction.name;
      r && (e.tags = { transaction: r, ...e.tags });
    }
    return this._applyFingerprint(e), e.breadcrumbs = [...e.breadcrumbs || [], ...this._breadcrumbs], e.breadcrumbs = e.breadcrumbs.length > 0 ? e.breadcrumbs : void 0, e.sdkProcessingMetadata = { ...e.sdkProcessingMetadata, ...this._sdkProcessingMetadata }, this._notifyEventProcessors([...QL(), ...this._eventProcessors], e, n);
  }
  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
  setSDKProcessingMetadata(e) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...e }, this;
  }
  /**
   * This will be called after {@link applyToEvent} is finished.
   */
  _notifyEventProcessors(e, n, r, i = 0) {
    return new li((a, o) => {
      const s = e[i];
      if (n === null || typeof s != "function")
        a(n);
      else {
        const l = s({ ...n }, r);
        (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && s.id && l === null && ge.log(`Event processor "${s.id}" dropped event`), zx(l) ? l.then((c) => this._notifyEventProcessors(e, c, r, i + 1).then(a)).then(null, o) : this._notifyEventProcessors(e, l, r, i + 1).then(a).then(null, o);
      }
    });
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((e) => {
      e(this);
    }), this._notifyingListeners = !1);
  }
  /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */
  _applyFingerprint(e) {
    e.fingerprint = e.fingerprint ? zL(e.fingerprint) : [], this._fingerprint && (e.fingerprint = e.fingerprint.concat(this._fingerprint)), e.fingerprint && !e.fingerprint.length && delete e.fingerprint;
  }
}
function QL() {
  return kx("globalEventProcessors", () => []);
}
function Ox(t) {
  QL().push(t);
}
const Yx = 4, iWe = 100;
class Qx {
  /** Is a {@link Layer}[] containing the client and scope */
  /** Contains the last event id of a captured event.  */
  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */
  constructor(e, n = new Hl(), r = Yx) {
    this._version = r, this._stack = [{ scope: n }], e && this.bindClient(e);
  }
  /**
   * @inheritDoc
   */
  isOlderThan(e) {
    return this._version < e;
  }
  /**
   * @inheritDoc
   */
  bindClient(e) {
    const n = this.getStackTop();
    n.client = e, e && e.setupIntegrations && e.setupIntegrations();
  }
  /**
   * @inheritDoc
   */
  pushScope() {
    const e = Hl.clone(this.getScope());
    return this.getStack().push({
      client: this.getClient(),
      scope: e
    }), e;
  }
  /**
   * @inheritDoc
   */
  popScope() {
    return this.getStack().length <= 1 ? !1 : !!this.getStack().pop();
  }
  /**
   * @inheritDoc
   */
  withScope(e) {
    const n = this.pushScope();
    try {
      e(n);
    } finally {
      this.popScope();
    }
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this.getStackTop().client;
  }
  /** Returns the scope of the top stack. */
  getScope() {
    return this.getStackTop().scope;
  }
  /** Returns the scope stack for domains or the process. */
  getStack() {
    return this._stack;
  }
  /** Returns the topmost scope layer in the order domain > local > process. */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * @inheritDoc
   */
  captureException(e, n) {
    const r = this._lastEventId = n && n.event_id ? n.event_id : Al(), i = new Error("Sentry syntheticException");
    return this._withClient((a, o) => {
      a.captureException(
        e,
        {
          originalException: e,
          syntheticException: i,
          ...n,
          event_id: r
        },
        o
      );
    }), r;
  }
  /**
   * @inheritDoc
   */
  captureMessage(e, n, r) {
    const i = this._lastEventId = r && r.event_id ? r.event_id : Al(), a = new Error(e);
    return this._withClient((o, s) => {
      o.captureMessage(
        e,
        n,
        {
          originalException: e,
          syntheticException: a,
          ...r,
          event_id: i
        },
        s
      );
    }), i;
  }
  /**
   * @inheritDoc
   */
  captureEvent(e, n) {
    const r = n && n.event_id ? n.event_id : Al();
    return e.type || (this._lastEventId = r), this._withClient((i, a) => {
      i.captureEvent(e, { ...n, event_id: r }, a);
    }), r;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(e, n) {
    const { scope: r, client: i } = this.getStackTop();
    if (!i)
      return;
    const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = iWe } = i.getOptions && i.getOptions() || {};
    if (o <= 0)
      return;
    const l = { timestamp: tR(), ...e }, c = a ? bL(() => a(l, n)) : l;
    c !== null && (i.emit && i.emit("beforeAddBreadcrumb", c, n), r.addBreadcrumb(c, o));
  }
  /**
   * @inheritDoc
   */
  setUser(e) {
    this.getScope().setUser(e);
  }
  /**
   * @inheritDoc
   */
  setTags(e) {
    this.getScope().setTags(e);
  }
  /**
   * @inheritDoc
   */
  setExtras(e) {
    this.getScope().setExtras(e);
  }
  /**
   * @inheritDoc
   */
  setTag(e, n) {
    this.getScope().setTag(e, n);
  }
  /**
   * @inheritDoc
   */
  setExtra(e, n) {
    this.getScope().setExtra(e, n);
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setContext(e, n) {
    this.getScope().setContext(e, n);
  }
  /**
   * @inheritDoc
   */
  configureScope(e) {
    const { scope: n, client: r } = this.getStackTop();
    r && e(n);
  }
  /**
   * @inheritDoc
   */
  run(e) {
    const n = Dk(this);
    try {
      e(this);
    } finally {
      Dk(n);
    }
  }
  /**
   * @inheritDoc
   */
  getIntegration(e) {
    const n = this.getClient();
    if (!n)
      return null;
    try {
      return n.getIntegration(e);
    } catch {
      return (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn(`Cannot retrieve integration ${e.id} from the current Hub`), null;
    }
  }
  /**
   * @inheritDoc
   */
  startTransaction(e, n) {
    return this._callExtensionMethod("startTransaction", e, n);
  }
  /**
   * @inheritDoc
   */
  traceHeaders() {
    return this._callExtensionMethod("traceHeaders");
  }
  /**
   * @inheritDoc
   */
  captureSession(e = !1) {
    if (e)
      return this.endSession();
    this._sendSessionUpdate();
  }
  /**
   * @inheritDoc
   */
  endSession() {
    const n = this.getStackTop().scope, r = n.getSession();
    r && tWe(r), this._sendSessionUpdate(), n.setSession();
  }
  /**
   * @inheritDoc
   */
  startSession(e) {
    const { scope: n, client: r } = this.getStackTop(), { release: i, environment: a = Ix } = r && r.getOptions() || {}, { userAgent: o } = Cr.navigator || {}, s = eWe({
      release: i,
      environment: a,
      user: n.getUser(),
      ...o && { userAgent: o },
      ...e
    }), l = n.getSession && n.getSession();
    return l && l.status === "ok" && Fh(l, { status: "exited" }), this.endSession(), n.setSession(s), s;
  }
  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */
  shouldSendDefaultPii() {
    const e = this.getClient(), n = e && e.getOptions();
    return !!(n && n.sendDefaultPii);
  }
  /**
   * Sends the current Session on the scope
   */
  _sendSessionUpdate() {
    const { scope: e, client: n } = this.getStackTop(), r = e.getSession();
    r && n && n.captureSession && n.captureSession(r);
  }
  /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */
  _withClient(e) {
    const { scope: n, client: r } = this.getStackTop();
    r && e(r, n);
  }
  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _callExtensionMethod(e, ...n) {
    const i = Em().__SENTRY__;
    if (i && i.extensions && typeof i.extensions[e] == "function")
      return i.extensions[e].apply(this, n);
    (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn(`Extension method ${e} couldn't be found, doing nothing.`);
  }
}
function Em() {
  return Cr.__SENTRY__ = Cr.__SENTRY__ || {
    extensions: {},
    hub: void 0
  }, Cr;
}
function Dk(t) {
  const e = Em(), n = xl(e);
  return Gx(e, t), n;
}
function Jn() {
  const t = Em();
  return (!GL(t) || xl(t).isOlderThan(Yx)) && Gx(t, new Qx()), kL() ? aWe(t) : xl(t);
}
function aWe(t) {
  try {
    const e = Em().__SENTRY__, n = e && e.extensions && e.extensions.domain && e.extensions.domain.active;
    if (!n)
      return xl(t);
    if (!GL(n) || xl(n).isOlderThan(Yx)) {
      const r = xl(t).getStackTop();
      Gx(n, new Qx(r.client, Hl.clone(r.scope)));
    }
    return xl(n);
  } catch {
    return xl(t);
  }
}
function GL(t) {
  return !!(t && t.__SENTRY__ && t.__SENTRY__.hub);
}
function xl(t) {
  return kx("hub", () => new Qx(), t);
}
function Gx(t, e) {
  if (!t)
    return !1;
  const n = t.__SENTRY__ = t.__SENTRY__ || {};
  return n.hub = e, !0;
}
function Cx(t) {
  if (typeof __SENTRY_TRACING__ == "boolean" && !__SENTRY_TRACING__)
    return !1;
  const e = Jn().getClient(), n = t || e && e.getOptions();
  return !!n && (n.enableTracing || "tracesSampleRate" in n || "tracesSampler" in n);
}
function Sm(t) {
  return (t || Jn()).getScope().getTransaction();
}
let zk = !1;
function oWe() {
  zk || (zk = !0, _i("error", TE), _i("unhandledrejection", TE));
}
function TE() {
  const t = Sm();
  if (t) {
    const e = "internal_error";
    (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log(`[Tracing] Transaction: ${e} -> Global error occured`), t.setStatus(e);
  }
}
TE.tag = "sentry_tracingErrorCallback";
class nR {
  __init() {
    this.spans = [];
  }
  constructor(e = 1e3) {
    nR.prototype.__init.call(this), this._maxlen = e;
  }
  /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */
  add(e) {
    this.spans.length > this._maxlen ? e.spanRecorder = void 0 : this.spans.push(e);
  }
}
class cs {
  /**
   * @inheritDoc
   */
  __init2() {
    this.traceId = Al();
  }
  /**
   * @inheritDoc
   */
  __init3() {
    this.spanId = Al().substring(16);
  }
  /**
   * @inheritDoc
   */
  /**
   * Internal keeper of the status
   */
  /**
   * @inheritDoc
   */
  /**
   * Timestamp in seconds when the span was created.
   */
  __init4() {
    this.startTimestamp = ap();
  }
  /**
   * Timestamp in seconds when the span ended.
   */
  /**
   * @inheritDoc
   */
  /**
   * @inheritDoc
   */
  /**
   * @inheritDoc
   */
  __init5() {
    this.tags = {};
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  __init6() {
    this.data = {};
  }
  /**
   * List of spans that were finalized
   */
  /**
   * @inheritDoc
   */
  /**
   * The instrumenter that created this span.
   */
  __init7() {
    this.instrumenter = "sentry";
  }
  /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */
  constructor(e) {
    if (cs.prototype.__init2.call(this), cs.prototype.__init3.call(this), cs.prototype.__init4.call(this), cs.prototype.__init5.call(this), cs.prototype.__init6.call(this), cs.prototype.__init7.call(this), !e)
      return this;
    e.traceId && (this.traceId = e.traceId), e.spanId && (this.spanId = e.spanId), e.parentSpanId && (this.parentSpanId = e.parentSpanId), "sampled" in e && (this.sampled = e.sampled), e.op && (this.op = e.op), e.description && (this.description = e.description), e.data && (this.data = e.data), e.tags && (this.tags = e.tags), e.status && (this.status = e.status), e.startTimestamp && (this.startTimestamp = e.startTimestamp), e.endTimestamp && (this.endTimestamp = e.endTimestamp), e.instrumenter && (this.instrumenter = e.instrumenter);
  }
  /**
   * @inheritDoc
   */
  startChild(e) {
    const n = new cs({
      ...e,
      parentSpanId: this.spanId,
      sampled: this.sampled,
      traceId: this.traceId
    });
    if (n.spanRecorder = this.spanRecorder, n.spanRecorder && n.spanRecorder.add(n), n.transaction = this.transaction, (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && n.transaction) {
      const r = e && e.op || "< unknown op >", i = n.transaction.name || "< unknown name >", a = n.transaction.spanId, o = `[Tracing] Starting '${r}' span on transaction '${i}' (${a}).`;
      n.transaction.metadata.spanMetadata[n.spanId] = { logMessage: o }, ge.log(o);
    }
    return n;
  }
  /**
   * @inheritDoc
   */
  setTag(e, n) {
    return this.tags = { ...this.tags, [e]: n }, this;
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  setData(e, n) {
    return this.data = { ...this.data, [e]: n }, this;
  }
  /**
   * @inheritDoc
   */
  setStatus(e) {
    return this.status = e, this;
  }
  /**
   * @inheritDoc
   */
  setHttpStatus(e) {
    this.setTag("http.status_code", String(e));
    const n = sWe(e);
    return n !== "unknown_error" && this.setStatus(n), this;
  }
  /**
   * @inheritDoc
   */
  isSuccess() {
    return this.status === "ok";
  }
  /**
   * @inheritDoc
   */
  finish(e) {
    if ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && // Don't call this for transactions
    this.transaction && this.transaction.spanId !== this.spanId) {
      const { logMessage: n } = this.transaction.metadata.spanMetadata[this.spanId];
      n && ge.log(n.replace("Starting", "Finishing"));
    }
    this.endTimestamp = typeof e == "number" ? e : ap();
  }
  /**
   * @inheritDoc
   */
  toTraceparent() {
    let e = "";
    return this.sampled !== void 0 && (e = this.sampled ? "-1" : "-0"), `${this.traceId}-${this.spanId}${e}`;
  }
  /**
   * @inheritDoc
   */
  toContext() {
    return Bl({
      data: this.data,
      description: this.description,
      endTimestamp: this.endTimestamp,
      op: this.op,
      parentSpanId: this.parentSpanId,
      sampled: this.sampled,
      spanId: this.spanId,
      startTimestamp: this.startTimestamp,
      status: this.status,
      tags: this.tags,
      traceId: this.traceId
    });
  }
  /**
   * @inheritDoc
   */
  updateWithContext(e) {
    return this.data = e.data || {}, this.description = e.description, this.endTimestamp = e.endTimestamp, this.op = e.op, this.parentSpanId = e.parentSpanId, this.sampled = e.sampled, this.spanId = e.spanId || this.spanId, this.startTimestamp = e.startTimestamp || this.startTimestamp, this.status = e.status, this.tags = e.tags || {}, this.traceId = e.traceId || this.traceId, this;
  }
  /**
   * @inheritDoc
   */
  getTraceContext() {
    return Bl({
      data: Object.keys(this.data).length > 0 ? this.data : void 0,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : void 0,
      trace_id: this.traceId
    });
  }
  /**
   * @inheritDoc
   */
  toJSON() {
    return Bl({
      data: Object.keys(this.data).length > 0 ? this.data : void 0,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      start_timestamp: this.startTimestamp,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : void 0,
      timestamp: this.endTimestamp,
      trace_id: this.traceId
    });
  }
}
function sWe(t) {
  if (t < 400 && t >= 100)
    return "ok";
  if (t >= 400 && t < 500)
    switch (t) {
      case 401:
        return "unauthenticated";
      case 403:
        return "permission_denied";
      case 404:
        return "not_found";
      case 409:
        return "already_exists";
      case 413:
        return "failed_precondition";
      case 429:
        return "resource_exhausted";
      default:
        return "invalid_argument";
    }
  if (t >= 500 && t < 600)
    switch (t) {
      case 501:
        return "unimplemented";
      case 503:
        return "unavailable";
      case 504:
        return "deadline_exceeded";
      default:
        return "internal_error";
    }
  return "unknown_error";
}
class g0 extends cs {
  /**
   * The reference to the current hub.
   */
  __init() {
    this._measurements = {};
  }
  __init2() {
    this._contexts = {};
  }
  __init3() {
    this._frozenDynamicSamplingContext = void 0;
  }
  /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */
  constructor(e, n) {
    super(e), g0.prototype.__init.call(this), g0.prototype.__init2.call(this), g0.prototype.__init3.call(this), this._hub = n || Jn(), this._name = e.name || "", this.metadata = {
      source: "custom",
      ...e.metadata,
      spanMetadata: {}
    }, this._trimEnd = e.trimEnd, this.transaction = this;
    const r = this.metadata.dynamicSamplingContext;
    r && (this._frozenDynamicSamplingContext = { ...r });
  }
  /** Getter for `name` property */
  get name() {
    return this._name;
  }
  /** Setter for `name` property, which also sets `source` as custom */
  set name(e) {
    this.setName(e);
  }
  /**
   * JSDoc
   */
  setName(e, n = "custom") {
    this._name = e, this.metadata.source = n;
  }
  /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */
  initSpanRecorder(e = 1e3) {
    this.spanRecorder || (this.spanRecorder = new nR(e)), this.spanRecorder.add(this);
  }
  /**
   * @inheritDoc
   */
  setContext(e, n) {
    n === null ? delete this._contexts[e] : this._contexts[e] = n;
  }
  /**
   * @inheritDoc
   */
  setMeasurement(e, n, r = "") {
    this._measurements[e] = { value: n, unit: r };
  }
  /**
   * @inheritDoc
   */
  setMetadata(e) {
    this.metadata = { ...this.metadata, ...e };
  }
  /**
   * @inheritDoc
   */
  finish(e) {
    if (this.endTimestamp !== void 0)
      return;
    this.name || ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn("Transaction has no name, falling back to `<unlabeled transaction>`."), this.name = "<unlabeled transaction>"), super.finish(e);
    const n = this._hub.getClient();
    if (n && n.emit && n.emit("finishTransaction", this), this.sampled !== !0) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log("[Tracing] Discarding transaction because its trace was not chosen to be sampled."), n && n.recordDroppedEvent("sample_rate", "transaction");
      return;
    }
    const r = this.spanRecorder ? this.spanRecorder.spans.filter((s) => s !== this && s.endTimestamp) : [];
    this._trimEnd && r.length > 0 && (this.endTimestamp = r.reduce((s, l) => s.endTimestamp && l.endTimestamp ? s.endTimestamp > l.endTimestamp ? s : l : s).endTimestamp);
    const i = this.metadata, a = {
      contexts: {
        ...this._contexts,
        // We don't want to override trace context
        trace: this.getTraceContext()
      },
      spans: r,
      start_timestamp: this.startTimestamp,
      tags: this.tags,
      timestamp: this.endTimestamp,
      transaction: this.name,
      type: "transaction",
      sdkProcessingMetadata: {
        ...i,
        dynamicSamplingContext: this.getDynamicSamplingContext()
      },
      ...i.source && {
        transaction_info: {
          source: i.source
        }
      }
    };
    return Object.keys(this._measurements).length > 0 && ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log(
      "[Measurements] Adding measurements to transaction",
      JSON.stringify(this._measurements, void 0, 2)
    ), a.measurements = this._measurements), (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log(`[Tracing] Finishing ${this.op} transaction: ${this.name}.`), this._hub.captureEvent(a);
  }
  /**
   * @inheritDoc
   */
  toContext() {
    const e = super.toContext();
    return Bl({
      ...e,
      name: this.name,
      trimEnd: this._trimEnd
    });
  }
  /**
   * @inheritDoc
   */
  updateWithContext(e) {
    return super.updateWithContext(e), this.name = e.name || "", this._trimEnd = e.trimEnd, this;
  }
  /**
   * @inheritdoc
   *
   * @experimental
   */
  getDynamicSamplingContext() {
    if (this._frozenDynamicSamplingContext)
      return this._frozenDynamicSamplingContext;
    const e = this._hub || Jn(), n = e && e.getClient();
    if (!n)
      return {};
    const { environment: r, release: i } = n.getOptions() || {}, { publicKey: a } = n.getDsn() || {}, o = this.metadata.sampleRate, s = o !== void 0 ? o.toString() : void 0, { segment: l } = e.getScope().getUser() || {}, c = this.metadata.source, d = c && c !== "url" ? this.name : void 0, u = Bl({
      environment: r || Ix,
      release: i,
      transaction: d,
      user_segment: l,
      public_key: a,
      trace_id: this.traceId,
      sample_rate: s
    });
    return n.emit && n.emit("createDsc", u), u;
  }
  /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */
  setHub(e) {
    this._hub = e;
  }
}
const pf = {
  idleTimeout: 1e3,
  finalTimeout: 3e4,
  heartbeatInterval: 5e3
}, lWe = "finishReason", Gu = [
  "heartbeatFailed",
  "idleTimeout",
  "documentHidden",
  "finalTimeout",
  "externalFinish",
  "cancelled"
];
class cWe extends nR {
  constructor(e, n, r, i) {
    super(i), this._pushActivity = e, this._popActivity = n, this.transactionSpanId = r;
  }
  /**
   * @inheritDoc
   */
  add(e) {
    e.spanId !== this.transactionSpanId && (e.finish = (n) => {
      e.endTimestamp = typeof n == "number" ? n : ap(), this._popActivity(e.spanId);
    }, e.endTimestamp === void 0 && this._pushActivity(e.spanId)), super.add(e);
  }
}
class Rl extends g0 {
  // Activities store a list of active spans
  __init() {
    this.activities = {};
  }
  // Track state of activities in previous heartbeat
  // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
  __init2() {
    this._heartbeatCounter = 0;
  }
  // We should not use heartbeat if we finished a transaction
  __init3() {
    this._finished = !1;
  }
  // Idle timeout was canceled and we should finish the transaction with the last span end.
  __init4() {
    this._idleTimeoutCanceledPermanently = !1;
  }
  __init5() {
    this._beforeFinishCallbacks = [];
  }
  /**
   * Timer that tracks Transaction idleTimeout
   */
  __init6() {
    this._finishReason = Gu[4];
  }
  constructor(e, n, r = pf.idleTimeout, i = pf.finalTimeout, a = pf.heartbeatInterval, o = !1) {
    super(e, n), this._idleHub = n, this._idleTimeout = r, this._finalTimeout = i, this._heartbeatInterval = a, this._onScope = o, Rl.prototype.__init.call(this), Rl.prototype.__init2.call(this), Rl.prototype.__init3.call(this), Rl.prototype.__init4.call(this), Rl.prototype.__init5.call(this), Rl.prototype.__init6.call(this), o && ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log(`Setting idle transaction on scope. Span ID: ${this.spanId}`), n.configureScope((s) => s.setSpan(this))), this._restartIdleTimeout(), setTimeout(() => {
      this._finished || (this.setStatus("deadline_exceeded"), this._finishReason = Gu[3], this.finish());
    }, this._finalTimeout);
  }
  /** {@inheritDoc} */
  finish(e = ap()) {
    if (this._finished = !0, this.activities = {}, this.op === "ui.action.click" && this.setTag(lWe, this._finishReason), this.spanRecorder) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log("[Tracing] finishing IdleTransaction", new Date(e * 1e3).toISOString(), this.op);
      for (const n of this._beforeFinishCallbacks)
        n(this, e);
      this.spanRecorder.spans = this.spanRecorder.spans.filter((n) => {
        if (n.spanId === this.spanId)
          return !0;
        n.endTimestamp || (n.endTimestamp = e, n.setStatus("cancelled"), (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log("[Tracing] cancelling span since transaction ended early", JSON.stringify(n, void 0, 2)));
        const r = n.startTimestamp < e;
        return r || (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log(
          "[Tracing] discarding Span since it happened after Transaction was finished",
          JSON.stringify(n, void 0, 2)
        ), r;
      }), (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log("[Tracing] flushing IdleTransaction");
    } else
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log("[Tracing] No active IdleTransaction");
    if (this._onScope) {
      const n = this._idleHub.getScope();
      n.getTransaction() === this && n.setSpan(void 0);
    }
    return super.finish(e);
  }
  /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */
  registerBeforeFinishCallback(e) {
    this._beforeFinishCallbacks.push(e);
  }
  /**
   * @inheritDoc
   */
  initSpanRecorder(e) {
    if (!this.spanRecorder) {
      const n = (i) => {
        this._finished || this._pushActivity(i);
      }, r = (i) => {
        this._finished || this._popActivity(i);
      };
      this.spanRecorder = new cWe(n, r, this.spanId, e), (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log("Starting heartbeat"), this._pingHeartbeat();
    }
    this.spanRecorder.add(this);
  }
  /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */
  cancelIdleTimeout(e, {
    restartOnChildSpanChange: n
  } = {
    restartOnChildSpanChange: !0
  }) {
    this._idleTimeoutCanceledPermanently = n === !1, this._idleTimeoutID && (clearTimeout(this._idleTimeoutID), this._idleTimeoutID = void 0, Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently && (this._finishReason = Gu[5], this.finish(e)));
  }
  /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */
  setFinishReason(e) {
    this._finishReason = e;
  }
  /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */
  _restartIdleTimeout(e) {
    this.cancelIdleTimeout(), this._idleTimeoutID = setTimeout(() => {
      !this._finished && Object.keys(this.activities).length === 0 && (this._finishReason = Gu[1], this.finish(e));
    }, this._idleTimeout);
  }
  /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */
  _pushActivity(e) {
    this.cancelIdleTimeout(void 0, { restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently }), (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log(`[Tracing] pushActivity: ${e}`), this.activities[e] = !0, (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log("[Tracing] new activities count", Object.keys(this.activities).length);
  }
  /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */
  _popActivity(e) {
    if (this.activities[e] && ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log(`[Tracing] popActivity ${e}`), delete this.activities[e], (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log("[Tracing] new activities count", Object.keys(this.activities).length)), Object.keys(this.activities).length === 0) {
      const n = ap();
      this._idleTimeoutCanceledPermanently ? (this._finishReason = Gu[5], this.finish(n)) : this._restartIdleTimeout(n + this._idleTimeout / 1e3);
    }
  }
  /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */
  _beat() {
    if (this._finished)
      return;
    const e = Object.keys(this.activities).join("");
    e === this._prevHeartbeatString ? this._heartbeatCounter++ : this._heartbeatCounter = 1, this._prevHeartbeatString = e, this._heartbeatCounter >= 3 ? ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log("[Tracing] Transaction finished because of no change for 3 heart beats"), this.setStatus("deadline_exceeded"), this._finishReason = Gu[0], this.finish()) : this._pingHeartbeat();
  }
  /**
   * Pings the heartbeat
   */
  _pingHeartbeat() {
    (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`), setTimeout(() => {
      this._beat();
    }, this._heartbeatInterval);
  }
}
function dWe() {
  const e = this.getScope().getSpan();
  return e ? {
    "sentry-trace": e.toTraceparent()
  } : {};
}
function CL(t, e, n) {
  if (!Cx(e))
    return t.sampled = !1, t;
  if (t.sampled !== void 0)
    return t.setMetadata({
      sampleRate: Number(t.sampled)
    }), t;
  let r;
  return typeof e.tracesSampler == "function" ? (r = e.tracesSampler(n), t.setMetadata({
    sampleRate: Number(r)
  })) : n.parentSampled !== void 0 ? r = n.parentSampled : typeof e.tracesSampleRate < "u" ? (r = e.tracesSampleRate, t.setMetadata({
    sampleRate: Number(r)
  })) : (r = 1, t.setMetadata({
    sampleRate: r
  })), uWe(r) ? r ? (t.sampled = Math.random() < r, t.sampled ? ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log(`[Tracing] starting ${t.op} transaction - ${t.name}`), t) : ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log(
    `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
      r
    )})`
  ), t)) : ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log(
    `[Tracing] Discarding transaction because ${typeof e.tracesSampler == "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`
  ), t.sampled = !1, t) : ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn("[Tracing] Discarding transaction because of invalid sample rate."), t.sampled = !1, t);
}
function uWe(t) {
  return yL(t) || !(typeof t == "number" || typeof t == "boolean") ? ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn(
    `[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
      t
    )} of type ${JSON.stringify(typeof t)}.`
  ), !1) : t < 0 || t > 1 ? ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${t}.`), !1) : !0;
}
function hWe(t, e) {
  const n = this.getClient(), r = n && n.getOptions() || {}, i = r.instrumenter || "sentry", a = t.instrumenter || "sentry";
  i !== a && ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.error(
    `A transaction was started with instrumenter=\`${a}\`, but the SDK is configured with the \`${i}\` instrumenter.
The transaction will not be sampled. Please use the ${i} instrumentation to start transactions.`
  ), t.sampled = !1);
  let o = new g0(t, this);
  return o = CL(o, r, {
    parentSampled: t.parentSampled,
    transactionContext: t,
    ...e
  }), o.sampled && o.initSpanRecorder(r._experiments && r._experiments.maxSpans), n && n.emit && n.emit("startTransaction", o), o;
}
function kk(t, e, n, r, i, a, o) {
  const s = t.getClient(), l = s && s.getOptions() || {};
  let c = new Rl(e, t, n, r, o, i);
  return c = CL(c, l, {
    parentSampled: e.parentSampled,
    transactionContext: e,
    ...a
  }), c.sampled && c.initSpanRecorder(l._experiments && l._experiments.maxSpans), s && s.emit && s.emit("startTransaction", c), c;
}
function NWe() {
  const t = Em();
  t.__SENTRY__ && (t.__SENTRY__.extensions = t.__SENTRY__.extensions || {}, t.__SENTRY__.extensions.startTransaction || (t.__SENTRY__.extensions.startTransaction = hWe), t.__SENTRY__.extensions.traceHeaders || (t.__SENTRY__.extensions.traceHeaders = dWe), oWe());
}
function MWe(t, e) {
  return Jn().captureException(t, { captureContext: e });
}
function pWe(t) {
  Jn().withScope(t);
}
const mWe = "7";
function TWe(t) {
  const e = t.protocol ? `${t.protocol}:` : "", n = t.port ? `:${t.port}` : "";
  return `${e}//${t.host}${n}${t.path ? `/${t.path}` : ""}/api/`;
}
function fWe(t) {
  return `${TWe(t)}${t.projectId}/envelope/`;
}
function VWe(t, e) {
  return oxe({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: t.publicKey,
    sentry_version: mWe,
    ...e && { sentry_client: `${e.name}/${e.version}` }
  });
}
function UWe(t, e = {}) {
  const n = typeof e == "string" ? e : e.tunnel, r = typeof e == "string" || !e._metadata ? void 0 : e._metadata.sdk;
  return n || `${fWe(t)}?${VWe(t, r)}`;
}
function RWe(t, e) {
  return e && (t.sdk = t.sdk || {}, t.sdk.name = t.sdk.name || e.name, t.sdk.version = t.sdk.version || e.version, t.sdk.integrations = [...t.sdk.integrations || [], ...e.integrations || []], t.sdk.packages = [...t.sdk.packages || [], ...e.packages || []]), t;
}
function gWe(t, e, n, r) {
  const i = IL(n), a = {
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...i && { sdk: i },
    ...!!r && { dsn: eR(e) }
  }, o = "aggregates" in t ? [{ type: "sessions" }, t] : [{ type: "session" }, t];
  return bm(a, [o]);
}
function yWe(t, e, n, r) {
  const i = IL(n), a = t.type && t.type !== "replay_event" ? t.type : "event";
  RWe(t, n && n.sdk);
  const o = Lxe(t, i, r, e);
  return delete t.sdkProcessingMetadata, bm(o, [[{ type: a }, t]]);
}
const wk = [];
function ZWe(t) {
  const e = {};
  return t.forEach((n) => {
    const { name: r } = n, i = e[r];
    i && !i.isDefaultInstance && n.isDefaultInstance || (e[r] = n);
  }), Object.keys(e).map((n) => e[n]);
}
function bWe(t) {
  const e = t.defaultIntegrations || [], n = t.integrations;
  e.forEach((o) => {
    o.isDefaultInstance = !0;
  });
  let r;
  Array.isArray(n) ? r = [...e, ...n] : typeof n == "function" ? r = zL(n(e)) : r = e;
  const i = ZWe(r), a = SWe(i, (o) => o.name === "Debug");
  if (a !== -1) {
    const [o] = i.splice(a, 1);
    i.push(o);
  }
  return i;
}
function EWe(t) {
  const e = {};
  return t.forEach((n) => {
    n && LL(n, e);
  }), e;
}
function LL(t, e) {
  e[t.name] = t, wk.indexOf(t.name) === -1 && (t.setupOnce(Ox, Jn), wk.push(t.name), (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log(`Integration installed: ${t.name}`));
}
function SWe(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]) === !0)
      return n;
  return -1;
}
function xWe(t, e, n, r) {
  const { normalizeDepth: i = 3, normalizeMaxBreadth: a = 1e3 } = t, o = {
    ...e,
    event_id: e.event_id || n.event_id || Al(),
    timestamp: e.timestamp || tR()
  }, s = n.integrations || t.integrations.map((d) => d.name);
  WWe(o, t), DWe(o, s), jWe(o, t.stackParser);
  let l = r;
  n.captureContext && (l = Hl.clone(l).update(n.captureContext));
  let c = Kd(o);
  if (l) {
    if (l.getAttachments) {
      const d = [...n.attachments || [], ...l.getAttachments()];
      d.length && (n.attachments = d);
    }
    c = l.applyToEvent(o, n);
  }
  return c.then((d) => typeof i == "number" && i > 0 ? zWe(d, i, a) : d);
}
function WWe(t, e) {
  const { environment: n, release: r, dist: i, maxValueLength: a = 250 } = e;
  "environment" in t || (t.environment = "environment" in e ? n : Ix), t.release === void 0 && r !== void 0 && (t.release = r), t.dist === void 0 && i !== void 0 && (t.dist = i), t.message && (t.message = b1(t.message, a));
  const o = t.exception && t.exception.values && t.exception.values[0];
  o && o.value && (o.value = b1(o.value, a));
  const s = t.request;
  s && s.url && (s.url = b1(s.url, a));
}
function jWe(t, e) {
  const n = Cr._sentryDebugIds;
  if (!n)
    return;
  const r = Object.keys(n).reduce((o, s) => {
    const l = e(s);
    for (let c = l.length - 1; c >= 0; c--) {
      const d = l[c];
      if (d.filename) {
        o[d.filename] = n[s];
        break;
      }
    }
    return o;
  }, {}), i = /* @__PURE__ */ new Set();
  try {
    t.exception.values.forEach((o) => {
      o.stacktrace.frames.forEach((s) => {
        s.filename && i.add(s.filename);
      });
    });
  } catch {
  }
  t.debug_meta = t.debug_meta || {}, t.debug_meta.images = t.debug_meta.images || [];
  const a = t.debug_meta.images;
  i.forEach((o) => {
    r[o] && a.push({
      type: "sourcemap",
      code_file: o,
      debug_id: r[o]
    });
  });
}
function DWe(t, e) {
  e.length > 0 && (t.sdk = t.sdk || {}, t.sdk.integrations = [...t.sdk.integrations || [], ...e]);
}
function zWe(t, e, n) {
  if (!t)
    return null;
  const r = {
    ...t,
    ...t.breadcrumbs && {
      breadcrumbs: t.breadcrumbs.map((i) => ({
        ...i,
        ...i.data && {
          data: Ul(i.data, e, n)
        }
      }))
    },
    ...t.user && {
      user: Ul(t.user, e, n)
    },
    ...t.contexts && {
      contexts: Ul(t.contexts, e, n)
    },
    ...t.extra && {
      extra: Ul(t.extra, e, n)
    }
  };
  return t.contexts && t.contexts.trace && r.contexts && (r.contexts.trace = t.contexts.trace, t.contexts.trace.data && (r.contexts.trace.data = Ul(t.contexts.trace.data, e, n))), t.spans && (r.spans = t.spans.map((i) => (i.data && (i.data = Ul(i.data, e, n)), i))), r;
}
const Fk = "Not capturing exception because it's already been captured.";
class td {
  /** Options passed to the SDK. */
  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */
  /** Array of set up integrations. */
  __init() {
    this._integrations = {};
  }
  /** Indicates whether this client's integrations have been set up. */
  __init2() {
    this._integrationsInitialized = !1;
  }
  /** Number of calls being processed */
  __init3() {
    this._numProcessing = 0;
  }
  /** Holds flushable  */
  __init4() {
    this._outcomes = {};
  }
  // eslint-disable-next-line @typescript-eslint/ban-types
  __init5() {
    this._hooks = {};
  }
  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
  constructor(e) {
    if (td.prototype.__init.call(this), td.prototype.__init2.call(this), td.prototype.__init3.call(this), td.prototype.__init4.call(this), td.prototype.__init5.call(this), this._options = e, e.dsn) {
      this._dsn = rxe(e.dsn);
      const n = UWe(this._dsn, e);
      this._transport = e.transport({
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...e.transportOptions,
        url: n
      });
    } else
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn("No DSN provided, client will not do anything.");
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  captureException(e, n, r) {
    if (Ek(e)) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log(Fk);
      return;
    }
    let i = n && n.event_id;
    return this._process(
      this.eventFromException(e, n).then((a) => this._captureEvent(a, n, r)).then((a) => {
        i = a;
      })
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(e, n, r, i) {
    let a = r && r.event_id;
    const o = gL(e) ? this.eventFromMessage(String(e), n, r) : this.eventFromException(e, r);
    return this._process(
      o.then((s) => this._captureEvent(s, r, i)).then((s) => {
        a = s;
      })
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(e, n, r) {
    if (n && n.originalException && Ek(n.originalException)) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log(Fk);
      return;
    }
    let i = n && n.event_id;
    return this._process(
      this._captureEvent(e, n, r).then((a) => {
        i = a;
      })
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureSession(e) {
    if (!this._isEnabled()) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn("SDK not enabled, will not capture session.");
      return;
    }
    typeof e.release != "string" ? (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn("Discarded session because of missing or non-string release") : (this.sendSession(e), Fh(e, { init: !1 }));
  }
  /**
   * @inheritDoc
   */
  getDsn() {
    return this._dsn;
  }
  /**
   * @inheritDoc
   */
  getOptions() {
    return this._options;
  }
  /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */
  getSdkMetadata() {
    return this._options._metadata;
  }
  /**
   * @inheritDoc
   */
  getTransport() {
    return this._transport;
  }
  /**
   * @inheritDoc
   */
  flush(e) {
    const n = this._transport;
    return n ? this._isClientDoneProcessing(e).then((r) => n.flush(e).then((i) => r && i)) : Kd(!0);
  }
  /**
   * @inheritDoc
   */
  close(e) {
    return this.flush(e).then((n) => (this.getOptions().enabled = !1, n));
  }
  /**
   * Sets up the integrations
   */
  setupIntegrations() {
    this._isEnabled() && !this._integrationsInitialized && (this._integrations = EWe(this._options.integrations), this._integrationsInitialized = !0);
  }
  /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */
  getIntegrationById(e) {
    return this._integrations[e];
  }
  /**
   * @inheritDoc
   */
  getIntegration(e) {
    try {
      return this._integrations[e.id] || null;
    } catch {
      return (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn(`Cannot retrieve integration ${e.id} from the current Client`), null;
    }
  }
  /**
   * @inheritDoc
   */
  addIntegration(e) {
    LL(e, this._integrations);
  }
  /**
   * @inheritDoc
   */
  sendEvent(e, n = {}) {
    if (this._dsn) {
      let r = yWe(e, this._dsn, this._options._metadata, this._options.tunnel);
      for (const a of n.attachments || [])
        r = Oxe(
          r,
          Gxe(
            a,
            this._options.transportOptions && this._options.transportOptions.textEncoder
          )
        );
      const i = this._sendEnvelope(r);
      i && i.then((a) => this.emit("afterSendEvent", e, a), null);
    }
  }
  /**
   * @inheritDoc
   */
  sendSession(e) {
    if (this._dsn) {
      const n = gWe(e, this._dsn, this._options._metadata, this._options.tunnel);
      this._sendEnvelope(n);
    }
  }
  /**
   * @inheritDoc
   */
  recordDroppedEvent(e, n, r) {
    if (this._options.sendClientReports) {
      const i = `${e}:${n}`;
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log(`Adding outcome: "${i}"`), this._outcomes[i] = this._outcomes[i] + 1 || 1;
    }
  }
  // Keep on() & emit() signatures in sync with types' client.ts interface
  /** @inheritdoc */
  /** @inheritdoc */
  on(e, n) {
    this._hooks[e] || (this._hooks[e] = []), this._hooks[e].push(n);
  }
  /** @inheritdoc */
  /** @inheritdoc */
  emit(e, ...n) {
    this._hooks[e] && this._hooks[e].forEach((r) => r(...n));
  }
  /** Updates existing session based on the provided event */
  _updateSessionFromEvent(e, n) {
    let r = !1, i = !1;
    const a = n.exception && n.exception.values;
    if (a) {
      i = !0;
      for (const l of a) {
        const c = l.mechanism;
        if (c && c.handled === !1) {
          r = !0;
          break;
        }
      }
    }
    const o = e.status === "ok";
    (o && e.errors === 0 || o && r) && (Fh(e, {
      ...r && { status: "crashed" },
      errors: e.errors || Number(i || r)
    }), this.captureSession(e));
  }
  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
  _isClientDoneProcessing(e) {
    return new li((n) => {
      let r = 0;
      const i = 1, a = setInterval(() => {
        this._numProcessing == 0 ? (clearInterval(a), n(!0)) : (r += i, e && r >= e && (clearInterval(a), n(!1)));
      }, i);
    });
  }
  /** Determines whether this SDK is enabled and a valid Dsn is present. */
  _isEnabled() {
    return this.getOptions().enabled !== !1 && this._dsn !== void 0;
  }
  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */
  _prepareEvent(e, n, r) {
    const i = this.getOptions(), a = Object.keys(this._integrations);
    return !n.integrations && a.length > 0 && (n.integrations = a), xWe(i, e, n, r);
  }
  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
  _captureEvent(e, n = {}, r) {
    return this._processEvent(e, n, r).then(
      (i) => i.event_id,
      (i) => {
        if (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) {
          const a = i;
          a.logLevel === "log" ? ge.log(a.message) : ge.warn(a);
        }
      }
    );
  }
  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
  _processEvent(e, n, r) {
    const i = this.getOptions(), { sampleRate: a } = i;
    if (!this._isEnabled())
      return o2(new $r("SDK not enabled, will not capture event.", "log"));
    const o = BL(e), s = JL(e), l = e.type || "error", c = `before send for type \`${l}\``;
    if (s && typeof a == "number" && Math.random() > a)
      return this.recordDroppedEvent("sample_rate", "error", e), o2(
        new $r(
          `Discarding event because it's not included in the random sample (sampling rate = ${a})`,
          "log"
        )
      );
    const d = l === "replay_event" ? "replay" : l;
    return this._prepareEvent(e, n, r).then((u) => {
      if (u === null)
        throw this.recordDroppedEvent("event_processor", d, e), new $r("An event processor returned `null`, will not send event.", "log");
      if (n.data && n.data.__sentry__ === !0)
        return u;
      const N = wWe(i, u, n);
      return kWe(N, c);
    }).then((u) => {
      if (u === null)
        throw this.recordDroppedEvent("before_send", d, e), new $r(`${c} returned \`null\`, will not send event.`, "log");
      const h = r && r.getSession();
      !o && h && this._updateSessionFromEvent(h, u);
      const N = u.transaction_info;
      if (o && N && u.transaction !== e.transaction) {
        const M = "custom";
        u.transaction_info = {
          ...N,
          source: M
        };
      }
      return this.sendEvent(u, n), u;
    }).then(null, (u) => {
      throw u instanceof $r ? u : (this.captureException(u, {
        data: {
          __sentry__: !0
        },
        originalException: u
      }), new $r(
        `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${u}`
      ));
    });
  }
  /**
   * Occupies the client with processing and event
   */
  _process(e) {
    this._numProcessing++, e.then(
      (n) => (this._numProcessing--, n),
      (n) => (this._numProcessing--, n)
    );
  }
  /**
   * @inheritdoc
   */
  _sendEnvelope(e) {
    if (this._transport && this._dsn)
      return this.emit("beforeEnvelope", e), this._transport.send(e).then(null, (n) => {
        (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.error("Error while sending event:", n);
      });
    (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.error("Transport disabled");
  }
  /**
   * Clears outcomes on this client and returns them.
   */
  _clearOutcomes() {
    const e = this._outcomes;
    return this._outcomes = {}, Object.keys(e).map((n) => {
      const [r, i] = n.split(":");
      return {
        reason: r,
        category: i,
        quantity: e[n]
      };
    });
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
}
function kWe(t, e) {
  const n = `${e} must return \`null\` or a valid event.`;
  if (zx(t))
    return t.then(
      (r) => {
        if (!kh(r) && r !== null)
          throw new $r(n);
        return r;
      },
      (r) => {
        throw new $r(`${e} rejected with ${r}`);
      }
    );
  if (!kh(t) && t !== null)
    throw new $r(n);
  return t;
}
function wWe(t, e, n) {
  const { beforeSend: r, beforeSendTransaction: i } = t;
  return JL(e) && r ? r(e, n) : BL(e) && i ? i(e, n) : e;
}
function JL(t) {
  return t.type === void 0;
}
function BL(t) {
  return t.type === "transaction";
}
function FWe(t, e) {
  e.debug === !0 && (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__ ? ge.enable() : console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle."));
  const n = Jn();
  n.getScope().update(e.initialScope);
  const i = new t(e);
  n.bindClient(i);
}
const vWe = 30;
function AL(t, e, n = zxe(
  t.bufferSize || vWe
)) {
  let r = {};
  const i = (o) => n.drain(o);
  function a(o) {
    const s = [];
    if (xk(o, (u, h) => {
      const N = Wk(h);
      if (Xxe(r, N)) {
        const M = vk(u, h);
        t.recordDroppedEvent("ratelimit_backoff", N, M);
      } else
        s.push(u);
    }), s.length === 0)
      return Kd();
    const l = bm(o[0], s), c = (u) => {
      xk(l, (h, N) => {
        const M = vk(h, N);
        t.recordDroppedEvent(u, Wk(N), M);
      });
    }, d = () => e({ body: Yxe(l, t.textEncoder) }).then(
      (u) => (u.statusCode !== void 0 && (u.statusCode < 200 || u.statusCode >= 300) && (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn(`Sentry responded with status code ${u.statusCode} to sent event.`), r = _xe(r, u), u),
      (u) => {
        throw c("network_error"), u;
      }
    );
    return n.add(d).then(
      (u) => u,
      (u) => {
        if (u instanceof $r)
          return (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.error("Skipped sending event because buffer is full."), c("queue_overflow"), Kd();
        throw u;
      }
    );
  }
  return a.__sentry__baseTransport__ = !0, {
    send: a,
    flush: i
  };
}
function vk(t, e) {
  if (!(e !== "event" && e !== "transaction"))
    return Array.isArray(t) ? t[1] : void 0;
}
const s2 = "7.47.0";
let Ik;
class op {
  constructor() {
    op.prototype.__init.call(this);
  }
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "FunctionToString";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = op.id;
  }
  /**
   * @inheritDoc
   */
  setupOnce() {
    Ik = Function.prototype.toString, Function.prototype.toString = function(...e) {
      const n = Fx(this) || this;
      return Ik.apply(n, e);
    };
  }
}
op.__initStatic();
const IWe = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
class y0 {
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "InboundFilters";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = y0.id;
  }
  constructor(e = {}) {
    this._options = e, y0.prototype.__init.call(this);
  }
  /**
   * @inheritDoc
   */
  setupOnce(e, n) {
    const r = (i) => {
      const a = n();
      if (a) {
        const o = a.getIntegration(y0);
        if (o) {
          const s = a.getClient(), l = s ? s.getOptions() : {}, c = OWe(o._options, l);
          return YWe(i, c) ? null : i;
        }
      }
      return i;
    };
    r.id = this.name, e(r);
  }
}
y0.__initStatic();
function OWe(t = {}, e = {}) {
  return {
    allowUrls: [...t.allowUrls || [], ...e.allowUrls || []],
    denyUrls: [...t.denyUrls || [], ...e.denyUrls || []],
    ignoreErrors: [
      ...t.ignoreErrors || [],
      ...e.ignoreErrors || [],
      ...IWe
    ],
    ignoreTransactions: [...t.ignoreTransactions || [], ...e.ignoreTransactions || []],
    ignoreInternal: t.ignoreInternal !== void 0 ? t.ignoreInternal : !0
  };
}
function YWe(t, e) {
  return e.ignoreInternal && BWe(t) ? ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn(`Event dropped due to being internal Sentry Error.
Event: ${Sl(t)}`), !0) : QWe(t, e.ignoreErrors) ? ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn(
    `Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${Sl(t)}`
  ), !0) : GWe(t, e.ignoreTransactions) ? ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn(
    `Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${Sl(t)}`
  ), !0) : CWe(t, e.denyUrls) ? ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn(
    `Event dropped due to being matched by \`denyUrls\` option.
Event: ${Sl(
      t
    )}.
Url: ${l2(t)}`
  ), !0) : LWe(t, e.allowUrls) ? !1 : ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn(
    `Event dropped due to not being matched by \`allowUrls\` option.
Event: ${Sl(
      t
    )}.
Url: ${l2(t)}`
  ), !0);
}
function QWe(t, e) {
  return t.type || !e || !e.length ? !1 : JWe(t).some((n) => Zm(n, e));
}
function GWe(t, e) {
  if (t.type !== "transaction" || !e || !e.length)
    return !1;
  const n = t.transaction;
  return n ? Zm(n, e) : !1;
}
function CWe(t, e) {
  if (!e || !e.length)
    return !1;
  const n = l2(t);
  return n ? Zm(n, e) : !1;
}
function LWe(t, e) {
  if (!e || !e.length)
    return !0;
  const n = l2(t);
  return n ? Zm(n, e) : !0;
}
function JWe(t) {
  if (t.message)
    return [t.message];
  if (t.exception)
    try {
      const { type: e = "", value: n = "" } = t.exception.values && t.exception.values[0] || {};
      return [`${n}`, `${e}: ${n}`];
    } catch {
      return (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.error(`Cannot extract message for event ${Sl(t)}`), [];
    }
  return [];
}
function BWe(t) {
  try {
    return t.exception.values[0].type === "SentryError";
  } catch {
  }
  return !1;
}
function AWe(t = []) {
  for (let e = t.length - 1; e >= 0; e--) {
    const n = t[e];
    if (n && n.filename !== "<anonymous>" && n.filename !== "[native code]")
      return n.filename || null;
  }
  return null;
}
function l2(t) {
  try {
    let e;
    try {
      e = t.exception.values[0].stacktrace.frames;
    } catch {
    }
    return e ? AWe(e) : null;
  } catch {
    return (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.error(`Cannot extract url for event ${Sl(t)}`), null;
  }
}
const Zn = Cr;
let fE = 0;
function HL() {
  return fE > 0;
}
function HWe() {
  fE++, setTimeout(() => {
    fE--;
  });
}
function vh(t, e = {}, n) {
  if (typeof t != "function")
    return t;
  try {
    const i = t.__sentry_wrapped__;
    if (i)
      return i;
    if (Fx(t))
      return t;
  } catch {
    return t;
  }
  const r = function() {
    const i = Array.prototype.slice.call(arguments);
    try {
      n && typeof n == "function" && n.apply(this, arguments);
      const a = i.map((o) => vh(o, e));
      return t.apply(this, a);
    } catch (a) {
      throw HWe(), pWe((o) => {
        o.addEventProcessor((s) => (e.mechanism && (hE(s, void 0, void 0), ip(s, e.mechanism)), s.extra = {
          ...s.extra,
          arguments: i
        }, s)), MWe(a);
      }), a;
    }
  };
  try {
    for (const i in t)
      Object.prototype.hasOwnProperty.call(t, i) && (r[i] = t[i]);
  } catch {
  }
  EL(r, t), wx(t, "__sentry_wrapped__", r);
  try {
    Object.getOwnPropertyDescriptor(r, "name").configurable && Object.defineProperty(r, "name", {
      get() {
        return t.name;
      }
    });
  } catch {
  }
  return r;
}
function XL(t, e) {
  const n = Lx(t, e), r = {
    type: e && e.name,
    value: KWe(e)
  };
  return n.length && (r.stacktrace = { frames: n }), r.type === void 0 && r.value === "" && (r.value = "Unrecoverable error caught"), r;
}
function XWe(t, e, n, r) {
  const a = Jn().getClient(), o = a && a.getOptions().normalizeDepth, s = {
    exception: {
      values: [
        {
          type: Dx(e) ? e.constructor.name : r ? "UnhandledRejection" : "Error",
          value: `Non-Error ${r ? "promise rejection" : "exception"} captured with keys: ${sxe(e)}`
        }
      ]
    },
    extra: {
      __serialized__: wL(e, o)
    }
  };
  if (n) {
    const l = Lx(t, n);
    l.length && (s.exception.values[0].stacktrace = { frames: l });
  }
  return s;
}
function Ny(t, e) {
  return {
    exception: {
      values: [XL(t, e)]
    }
  };
}
function Lx(t, e) {
  const n = e.stacktrace || e.stack || "", r = PWe(e);
  try {
    return t(n, r);
  } catch {
  }
  return [];
}
const _We = /Minified React error #\d+;/i;
function PWe(t) {
  if (t) {
    if (typeof t.framesToPop == "number")
      return t.framesToPop;
    if (_We.test(t.message))
      return 1;
  }
  return 0;
}
function KWe(t) {
  const e = t && t.message;
  return e ? e.error && typeof e.error.message == "string" ? e.error.message : e : "No error message";
}
function $We(t, e, n, r) {
  const i = n && n.syntheticException || void 0, a = Jx(t, e, i, r);
  return ip(a), a.level = "error", n && n.event_id && (a.event_id = n.event_id), Kd(a);
}
function qWe(t, e, n = "info", r, i) {
  const a = r && r.syntheticException || void 0, o = VE(t, e, a, i);
  return o.level = n, r && r.event_id && (o.event_id = r.event_id), Kd(o);
}
function Jx(t, e, n, r, i) {
  let a;
  if (RL(e) && e.error)
    return Ny(t, e.error);
  if (fk(e) || BSe(e)) {
    const o = e;
    if ("stack" in e)
      a = Ny(t, e);
    else {
      const s = o.name || (fk(o) ? "DOMError" : "DOMException"), l = o.message ? `${s}: ${o.message}` : s;
      a = VE(t, l, n, r), hE(a, l);
    }
    return "code" in o && (a.tags = { ...a.tags, "DOMException.code": `${o.code}` }), a;
  }
  return UL(e) ? Ny(t, e) : kh(e) || Dx(e) ? (a = XWe(t, e, n, i), ip(a, {
    synthetic: !0
  }), a) : (a = VE(t, e, n, r), hE(a, `${e}`, void 0), ip(a, {
    synthetic: !0
  }), a);
}
function VE(t, e, n, r) {
  const i = {
    message: e
  };
  if (r && n) {
    const a = Lx(t, n);
    a.length && (i.exception = {
      values: [{ value: e, stacktrace: { frames: a } }]
    });
  }
  return i;
}
const ET = 1024, _L = "Breadcrumbs";
class sp {
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = _L;
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = sp.id;
  }
  /**
   * Options of the breadcrumbs integration.
   */
  // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.
  /**
   * @inheritDoc
   */
  constructor(e) {
    sp.prototype.__init.call(this), this.options = {
      console: !0,
      dom: !0,
      fetch: !0,
      history: !0,
      sentry: !0,
      xhr: !0,
      ...e
    };
  }
  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */
  setupOnce() {
    this.options.console && _i("console", tje), this.options.dom && _i("dom", eje(this.options.dom)), this.options.xhr && _i("xhr", nje), this.options.fetch && _i("fetch", rje), this.options.history && _i("history", ije);
  }
  /**
   * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
   */
  addSentryBreadcrumb(e) {
    this.options.sentry && Jn().addBreadcrumb(
      {
        category: `sentry.${e.type === "transaction" ? "transaction" : "event"}`,
        event_id: e.event_id,
        level: e.level,
        message: Sl(e)
      },
      {
        event: e
      }
    );
  }
}
sp.__initStatic();
function eje(t) {
  function e(n) {
    let r, i = typeof t == "object" ? t.serializeAttribute : void 0, a = typeof t == "object" && typeof t.maxStringLength == "number" ? t.maxStringLength : void 0;
    a && a > ET && ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn(
      `\`dom.maxStringLength\` cannot exceed ${ET}, but a value of ${a} was configured. Sentry will use ${ET} instead.`
    ), a = ET), typeof i == "string" && (i = [i]);
    try {
      const o = n.event;
      r = aje(o) ? wh(o.target, { keyAttrs: i, maxStringLength: a }) : wh(o, { keyAttrs: i, maxStringLength: a });
    } catch {
      r = "<unknown>";
    }
    r.length !== 0 && Jn().addBreadcrumb(
      {
        category: `ui.${n.name}`,
        message: r
      },
      {
        event: n.event,
        name: n.name,
        global: n.global
      }
    );
  }
  return e;
}
function tje(t) {
  for (let n = 0; n < t.args.length; n++)
    if (t.args[n] === "ref=Ref<") {
      t.args[n + 1] = "viewRef";
      break;
    }
  const e = {
    category: "console",
    data: {
      arguments: t.args,
      logger: "console"
    },
    level: FL(t.level),
    message: a2(t.args, " ")
  };
  if (t.level === "assert")
    if (t.args[0] === !1)
      e.message = `Assertion failed: ${a2(t.args.slice(1), " ") || "console.assert"}`, e.data.arguments = t.args.slice(1);
    else
      return;
  Jn().addBreadcrumb(e, {
    input: t.args,
    level: t.level
  });
}
function nje(t) {
  const { startTimestamp: e, endTimestamp: n } = t;
  if (!e || !n || !t.xhr.__sentry_xhr__)
    return;
  const { method: r, url: i, status_code: a, body: o } = t.xhr.__sentry_xhr__, s = {
    method: r,
    url: i,
    status_code: a
  }, l = {
    xhr: t.xhr,
    input: o,
    startTimestamp: e,
    endTimestamp: n
  };
  Jn().addBreadcrumb(
    {
      category: "xhr",
      data: s,
      type: "http"
    },
    l
  );
}
function rje(t) {
  const { startTimestamp: e, endTimestamp: n } = t;
  if (n && !(t.fetchData.url.match(/sentry_key/) && t.fetchData.method === "POST"))
    if (t.error) {
      const r = t.fetchData, i = {
        data: t.error,
        input: t.args,
        startTimestamp: e,
        endTimestamp: n
      };
      Jn().addBreadcrumb(
        {
          category: "fetch",
          data: r,
          level: "error",
          type: "http"
        },
        i
      );
    } else {
      const r = {
        ...t.fetchData,
        status_code: t.response && t.response.status
      }, i = {
        input: t.args,
        response: t.response,
        startTimestamp: e,
        endTimestamp: n
      };
      Jn().addBreadcrumb(
        {
          category: "fetch",
          data: r,
          type: "http"
        },
        i
      );
    }
}
function ije(t) {
  let e = t.from, n = t.to;
  const r = uy(Zn.location.href);
  let i = uy(e);
  const a = uy(n);
  i.path || (i = r), r.protocol === a.protocol && r.host === a.host && (n = a.relative), r.protocol === i.protocol && r.host === i.host && (e = i.relative), Jn().addBreadcrumb({
    category: "navigation",
    data: {
      from: e,
      to: n
    }
  });
}
function aje(t) {
  return t && !!t.target;
}
function oje(t, {
  metadata: e,
  tunnel: n,
  dsn: r
}) {
  const i = {
    event_id: t.event_id,
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...e && e.sdk && {
      sdk: {
        name: e.sdk.name,
        version: e.sdk.version
      }
    },
    ...!!n && !!r && { dsn: eR(r) }
  }, a = sje(t);
  return bm(i, [a]);
}
function sje(t) {
  return [{
    type: "user_report"
  }, t];
}
class lje extends td {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
  constructor(e) {
    const n = Zn.SENTRY_SDK_SOURCE || Exe();
    e._metadata = e._metadata || {}, e._metadata.sdk = e._metadata.sdk || {
      name: "sentry.javascript.browser",
      packages: [
        {
          name: `${n}:@sentry/browser`,
          version: s2
        }
      ],
      version: s2
    }, super(e), e.sendClientReports && Zn.document && Zn.document.addEventListener("visibilitychange", () => {
      Zn.document.visibilityState === "hidden" && this._flushOutcomes();
    });
  }
  /**
   * @inheritDoc
   */
  eventFromException(e, n) {
    return $We(this._options.stackParser, e, n, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  eventFromMessage(e, n = "info", r) {
    return qWe(this._options.stackParser, e, n, r, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  sendEvent(e, n) {
    const r = this.getIntegrationById(_L);
    r && r.addSentryBreadcrumb && r.addSentryBreadcrumb(e), super.sendEvent(e, n);
  }
  /**
   * Sends user feedback to Sentry.
   */
  captureUserFeedback(e) {
    if (!this._isEnabled()) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn("SDK not enabled, will not capture user feedback.");
      return;
    }
    const n = oje(e, {
      metadata: this.getSdkMetadata(),
      dsn: this.getDsn(),
      tunnel: this.getOptions().tunnel
    });
    this._sendEnvelope(n);
  }
  /**
   * @inheritDoc
   */
  _prepareEvent(e, n, r) {
    return e.platform = e.platform || "javascript", super._prepareEvent(e, n, r);
  }
  /**
   * Sends client reports as an envelope.
   */
  _flushOutcomes() {
    const e = this._clearOutcomes();
    if (e.length === 0) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log("No outcomes to send");
      return;
    }
    if (!this._dsn) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log("No dsn provided, will not send outcomes");
      return;
    }
    (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log("Sending outcomes:", e);
    const n = Jxe(e, this._options.tunnel && eR(this._dsn));
    this._sendEnvelope(n);
  }
}
let KN;
function cje() {
  if (KN)
    return KN;
  if (dE(Zn.fetch))
    return KN = Zn.fetch.bind(Zn);
  const t = Zn.document;
  let e = Zn.fetch;
  if (t && typeof t.createElement == "function")
    try {
      const n = t.createElement("iframe");
      n.hidden = !0, t.head.appendChild(n);
      const r = n.contentWindow;
      r && r.fetch && (e = r.fetch), t.head.removeChild(n);
    } catch (n) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", n);
    }
  return KN = e.bind(Zn);
}
function dje() {
  KN = void 0;
}
function uje(t, e = cje()) {
  let n = 0, r = 0;
  function i(a) {
    const o = a.body.length;
    n += o, r++;
    const s = {
      body: a.body,
      method: "POST",
      referrerPolicy: "origin",
      headers: t.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: n <= 6e4 && r < 15,
      ...t.fetchOptions
    };
    try {
      return e(t.url, s).then((l) => (n -= o, r--, {
        statusCode: l.status,
        headers: {
          "x-sentry-rate-limits": l.headers.get("X-Sentry-Rate-Limits"),
          "retry-after": l.headers.get("Retry-After")
        }
      }));
    } catch (l) {
      return dje(), n -= o, r--, o2(l);
    }
  }
  return AL(t, i);
}
const hje = 4;
function Nje(t) {
  function e(n) {
    return new li((r, i) => {
      const a = new XMLHttpRequest();
      a.onerror = i, a.onreadystatechange = () => {
        a.readyState === hje && r({
          statusCode: a.status,
          headers: {
            "x-sentry-rate-limits": a.getResponseHeader("X-Sentry-Rate-Limits"),
            "retry-after": a.getResponseHeader("Retry-After")
          }
        });
      }, a.open("POST", t.url);
      for (const o in t.headers)
        Object.prototype.hasOwnProperty.call(t.headers, o) && a.setRequestHeader(o, t.headers[o]);
      a.send(n.body);
    });
  }
  return AL(t, e);
}
const rR = "?", Mje = 30, pje = 40, mje = 50;
function Bx(t, e, n, r) {
  const i = {
    filename: t,
    function: e,
    in_app: !0
    // All browser frames are considered in_app
  };
  return n !== void 0 && (i.lineno = n), r !== void 0 && (i.colno = r), i;
}
const Tje = /^\s*at (?:(.*\).*?|.*?) ?\((?:address at )?)?(?:async )?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, fje = /\((\S*)(?::(\d+))(?::(\d+))\)/, Vje = (t) => {
  const e = Tje.exec(t);
  if (e) {
    if (e[2] && e[2].indexOf("eval") === 0) {
      const a = fje.exec(e[2]);
      a && (e[2] = a[1], e[3] = a[2], e[4] = a[3]);
    }
    const [r, i] = PL(e[1] || rR, e[2]);
    return Bx(i, r, e[3] ? +e[3] : void 0, e[4] ? +e[4] : void 0);
  }
}, Uje = [Mje, Vje], Rje = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|safari-extension|safari-web-extension|capacitor)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, gje = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, yje = (t) => {
  const e = Rje.exec(t);
  if (e) {
    if (e[3] && e[3].indexOf(" > eval") > -1) {
      const a = gje.exec(e[3]);
      a && (e[1] = e[1] || "eval", e[3] = a[1], e[4] = a[2], e[5] = "");
    }
    let r = e[3], i = e[1] || rR;
    return [i, r] = PL(i, r), Bx(r, i, e[4] ? +e[4] : void 0, e[5] ? +e[5] : void 0);
  }
}, Zje = [mje, yje], bje = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i, Eje = (t) => {
  const e = bje.exec(t);
  return e ? Bx(e[2], e[1] || rR, +e[3], e[4] ? +e[4] : void 0) : void 0;
}, Sje = [pje, Eje], xje = [Uje, Zje, Sje], Wje = WL(...xje), PL = (t, e) => {
  const n = t.indexOf("safari-extension") !== -1, r = t.indexOf("safari-web-extension") !== -1;
  return n || r ? [
    t.indexOf("@") !== -1 ? t.split("@")[0] : rR,
    n ? `safari-extension:${e}` : `safari-web-extension:${e}`
  ] : [t, e];
};
class Xl {
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "GlobalHandlers";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = Xl.id;
  }
  /** JSDoc */
  /**
   * Stores references functions to installing handlers. Will set to undefined
   * after they have been run so that they are not used twice.
   */
  __init2() {
    this._installFunc = {
      onerror: jje,
      onunhandledrejection: Dje
    };
  }
  /** JSDoc */
  constructor(e) {
    Xl.prototype.__init.call(this), Xl.prototype.__init2.call(this), this._options = {
      onerror: !0,
      onunhandledrejection: !0,
      ...e
    };
  }
  /**
   * @inheritDoc
   */
  setupOnce() {
    Error.stackTraceLimit = 50;
    const e = this._options;
    for (const n in e) {
      const r = this._installFunc[n];
      r && e[n] && (wje(n), r(), this._installFunc[n] = void 0);
    }
  }
}
Xl.__initStatic();
function jje() {
  _i(
    "error",
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (t) => {
      const [e, n, r] = qL();
      if (!e.getIntegration(Xl))
        return;
      const { msg: i, url: a, line: o, column: s, error: l } = t;
      if (HL() || l && l.__sentry_own_request__)
        return;
      const c = l === void 0 && Nc(i) ? kje(i, a, o, s) : KL(
        Jx(n, l || i, void 0, r, !1),
        a,
        o,
        s
      );
      c.level = "error", $L(e, l, c, "onerror");
    }
  );
}
function Dje() {
  _i(
    "unhandledrejection",
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (t) => {
      const [e, n, r] = qL();
      if (!e.getIntegration(Xl))
        return;
      let i = t;
      try {
        "reason" in t ? i = t.reason : "detail" in t && "reason" in t.detail && (i = t.detail.reason);
      } catch {
      }
      if (HL() || i && i.__sentry_own_request__)
        return !0;
      const a = gL(i) ? zje(i) : Jx(n, i, void 0, r, !0);
      a.level = "error", $L(e, i, a, "onunhandledrejection");
    }
  );
}
function zje(t) {
  return {
    exception: {
      values: [
        {
          type: "UnhandledRejection",
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(t)}`
        }
      ]
    }
  };
}
function kje(t, e, n, r) {
  const i = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
  let a = RL(t) ? t.message : t, o = "Error";
  const s = a.match(i);
  return s && (o = s[1], a = s[2]), KL({
    exception: {
      values: [
        {
          type: o,
          value: a
        }
      ]
    }
  }, e, n, r);
}
function KL(t, e, n, r) {
  const i = t.exception = t.exception || {}, a = i.values = i.values || [], o = a[0] = a[0] || {}, s = o.stacktrace = o.stacktrace || {}, l = s.frames = s.frames || [], c = isNaN(parseInt(r, 10)) ? void 0 : r, d = isNaN(parseInt(n, 10)) ? void 0 : n, u = Nc(e) && e.length > 0 ? e : KSe();
  return l.length === 0 && l.push({
    colno: c,
    filename: u,
    function: "?",
    in_app: !0,
    lineno: d
  }), t;
}
function wje(t) {
  (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log(`Global Handler attached: ${t}`);
}
function $L(t, e, n, r) {
  ip(n, {
    handled: !1,
    type: r
  }), t.captureEvent(n, {
    originalException: e
  });
}
function qL() {
  const t = Jn(), e = t.getClient(), n = e && e.getOptions() || {
    stackParser: () => [],
    attachStacktrace: !1
  };
  return [t, n.stackParser, n.attachStacktrace];
}
const Fje = [
  "EventTarget",
  "Window",
  "Node",
  "ApplicationCache",
  "AudioTrackList",
  "ChannelMergerNode",
  "CryptoOperation",
  "EventSource",
  "FileReader",
  "HTMLUnknownElement",
  "IDBDatabase",
  "IDBRequest",
  "IDBTransaction",
  "KeyOperation",
  "MediaController",
  "MessagePort",
  "ModalWindow",
  "Notification",
  "SVGElementInstance",
  "Screen",
  "TextTrack",
  "TextTrackCue",
  "TextTrackList",
  "WebSocket",
  "WebSocketWorker",
  "Worker",
  "XMLHttpRequest",
  "XMLHttpRequestEventTarget",
  "XMLHttpRequestUpload"
];
class lp {
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "TryCatch";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = lp.id;
  }
  /** JSDoc */
  /**
   * @inheritDoc
   */
  constructor(e) {
    lp.prototype.__init.call(this), this._options = {
      XMLHttpRequest: !0,
      eventTarget: !0,
      requestAnimationFrame: !0,
      setInterval: !0,
      setTimeout: !0,
      ...e
    };
  }
  /**
   * Wrap timer functions and event targets to catch errors
   * and provide better metadata.
   */
  setupOnce() {
    this._options.setTimeout && jr(Zn, "setTimeout", Ok), this._options.setInterval && jr(Zn, "setInterval", Ok), this._options.requestAnimationFrame && jr(Zn, "requestAnimationFrame", vje), this._options.XMLHttpRequest && "XMLHttpRequest" in Zn && jr(XMLHttpRequest.prototype, "send", Ije);
    const e = this._options.eventTarget;
    e && (Array.isArray(e) ? e : Fje).forEach(Oje);
  }
}
lp.__initStatic();
function Ok(t) {
  return function(...e) {
    const n = e[0];
    return e[0] = vh(n, {
      mechanism: {
        data: { function: pc(t) },
        handled: !0,
        type: "instrument"
      }
    }), t.apply(this, e);
  };
}
function vje(t) {
  return function(e) {
    return t.apply(this, [
      vh(e, {
        mechanism: {
          data: {
            function: "requestAnimationFrame",
            handler: pc(t)
          },
          handled: !0,
          type: "instrument"
        }
      })
    ]);
  };
}
function Ije(t) {
  return function(...e) {
    const n = this;
    return ["onload", "onerror", "onprogress", "onreadystatechange"].forEach((i) => {
      i in n && typeof n[i] == "function" && jr(n, i, function(a) {
        const o = {
          mechanism: {
            data: {
              function: i,
              handler: pc(a)
            },
            handled: !0,
            type: "instrument"
          }
        }, s = Fx(a);
        return s && (o.mechanism.data.handler = pc(s)), vh(a, o);
      });
    }), t.apply(this, e);
  };
}
function Oje(t) {
  const e = Zn, n = e[t] && e[t].prototype;
  !n || !n.hasOwnProperty || !n.hasOwnProperty("addEventListener") || (jr(n, "addEventListener", function(r) {
    return function(i, a, o) {
      try {
        typeof a.handleEvent == "function" && (a.handleEvent = vh(a.handleEvent, {
          mechanism: {
            data: {
              function: "handleEvent",
              handler: pc(a),
              target: t
            },
            handled: !0,
            type: "instrument"
          }
        }));
      } catch {
      }
      return r.apply(this, [
        i,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        vh(a, {
          mechanism: {
            data: {
              function: "addEventListener",
              handler: pc(a),
              target: t
            },
            handled: !0,
            type: "instrument"
          }
        }),
        o
      ]);
    };
  }), jr(
    n,
    "removeEventListener",
    function(r) {
      return function(i, a, o) {
        const s = a;
        try {
          const l = s && s.__sentry_wrapped__;
          l && r.call(this, i, l, o);
        } catch {
        }
        return r.call(this, i, s, o);
      };
    }
  ));
}
const Yje = "cause", Qje = 5;
class Z0 {
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "LinkedErrors";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = Z0.id;
  }
  /**
   * @inheritDoc
   */
  /**
   * @inheritDoc
   */
  /**
   * @inheritDoc
   */
  constructor(e = {}) {
    Z0.prototype.__init.call(this), this._key = e.key || Yje, this._limit = e.limit || Qje;
  }
  /**
   * @inheritDoc
   */
  setupOnce() {
    const e = Jn().getClient();
    e && Ox((n, r) => {
      const i = Jn().getIntegration(Z0);
      return i ? Gje(e.getOptions().stackParser, i._key, i._limit, n, r) : n;
    });
  }
}
Z0.__initStatic();
function Gje(t, e, n, r, i) {
  if (!r.exception || !r.exception.values || !i || !Mc(i.originalException, Error))
    return r;
  const a = eJ(t, n, i.originalException, e);
  return r.exception.values = [...a, ...r.exception.values], r;
}
function eJ(t, e, n, r, i = []) {
  if (!Mc(n[r], Error) || i.length + 1 >= e)
    return i;
  const a = XL(t, n[r]);
  return eJ(t, e, n[r], r, [a, ...i]);
}
class b0 {
  constructor() {
    b0.prototype.__init.call(this);
  }
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "HttpContext";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = b0.id;
  }
  /**
   * @inheritDoc
   */
  setupOnce() {
    Ox((e) => {
      if (Jn().getIntegration(b0)) {
        if (!Zn.navigator && !Zn.location && !Zn.document)
          return e;
        const n = e.request && e.request.url || Zn.location && Zn.location.href, { referrer: r } = Zn.document || {}, { userAgent: i } = Zn.navigator || {}, a = {
          ...e.request && e.request.headers,
          ...r && { Referer: r },
          ...i && { "User-Agent": i }
        }, o = { ...e.request, ...n && { url: n }, headers: a };
        return { ...e, request: o };
      }
      return e;
    });
  }
}
b0.__initStatic();
class E0 {
  constructor() {
    E0.prototype.__init.call(this);
  }
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "Dedupe";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = E0.id;
  }
  /**
   * @inheritDoc
   */
  /**
   * @inheritDoc
   */
  setupOnce(e, n) {
    const r = (i) => {
      if (i.type)
        return i;
      const a = n().getIntegration(E0);
      if (a) {
        try {
          if (Cje(i, a._previousEvent))
            return (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn("Event dropped due to being a duplicate of previously captured event."), null;
        } catch {
          return a._previousEvent = i;
        }
        return a._previousEvent = i;
      }
      return i;
    };
    r.id = this.name, e(r);
  }
}
E0.__initStatic();
function Cje(t, e) {
  return e ? !!(Lje(t, e) || Jje(t, e)) : !1;
}
function Lje(t, e) {
  const n = t.message, r = e.message;
  return !(!n && !r || n && !r || !n && r || n !== r || !nJ(t, e) || !tJ(t, e));
}
function Jje(t, e) {
  const n = Yk(e), r = Yk(t);
  return !(!n || !r || n.type !== r.type || n.value !== r.value || !nJ(t, e) || !tJ(t, e));
}
function tJ(t, e) {
  let n = Qk(t), r = Qk(e);
  if (!n && !r)
    return !0;
  if (n && !r || !n && r || (n = n, r = r, r.length !== n.length))
    return !1;
  for (let i = 0; i < r.length; i++) {
    const a = r[i], o = n[i];
    if (a.filename !== o.filename || a.lineno !== o.lineno || a.colno !== o.colno || a.function !== o.function)
      return !1;
  }
  return !0;
}
function nJ(t, e) {
  let n = t.fingerprint, r = e.fingerprint;
  if (!n && !r)
    return !0;
  if (n && !r || !n && r)
    return !1;
  n = n, r = r;
  try {
    return n.join("") === r.join("");
  } catch {
    return !1;
  }
}
function Yk(t) {
  return t.exception && t.exception.values && t.exception.values[0];
}
function Qk(t) {
  const e = t.exception;
  if (e)
    try {
      return e.values[0].stacktrace.frames;
    } catch {
      return;
    }
}
const Bje = [
  new y0(),
  new op(),
  new lp(),
  new sp(),
  new Xl(),
  new Z0(),
  new E0(),
  new b0()
];
function Aje(t = {}) {
  t.defaultIntegrations === void 0 && (t.defaultIntegrations = Bje), t.release === void 0 && (typeof __SENTRY_RELEASE__ == "string" && (t.release = __SENTRY_RELEASE__), Zn.SENTRY_RELEASE && Zn.SENTRY_RELEASE.id && (t.release = Zn.SENTRY_RELEASE.id)), t.autoSessionTracking === void 0 && (t.autoSessionTracking = !0), t.sendClientReports === void 0 && (t.sendClientReports = !0);
  const e = {
    ...t,
    stackParser: lxe(t.stackParser || Wje),
    integrations: bWe(t),
    transport: t.transport || (jL() ? uje : Nje)
  };
  FWe(lje, e), t.autoSessionTracking && Hje();
}
function Gk(t) {
  t.startSession({ ignoreDuration: !0 }), t.captureSession();
}
function Hje() {
  if (typeof Zn.document > "u") {
    (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
    return;
  }
  const t = Jn();
  t.captureSession && (Gk(t), _i("history", ({ from: e, to: n }) => {
    e === void 0 || e === n || Gk(Jn());
  }));
}
const En = Cr;
function Xje() {
  En && En.document ? En.document.addEventListener("visibilitychange", () => {
    const t = Sm();
    if (En.document.hidden && t) {
      const e = "cancelled";
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log(
        `[Tracing] Transaction: ${e} -> since tab moved to the background, op: ${t.op}`
      ), t.status || t.setStatus(e), t.setTag("visibilitychange", "document.hidden"), t.finish();
    }
  }) : (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn("[Tracing] Could not set up background tab detection due to lack of global document");
}
const Ax = (t, e, n) => {
  let r, i;
  return (a) => {
    e.value >= 0 && (a || n) && (i = e.value - (r || 0), (i || r === void 0) && (r = e.value, e.delta = i, t(e)));
  };
}, _je = () => `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`, Pje = () => {
  const t = En.performance.timing, e = En.performance.navigation.type, n = {
    entryType: "navigation",
    startTime: 0,
    type: e == 2 ? "back_forward" : e === 1 ? "reload" : "navigate"
  };
  for (const r in t)
    r !== "navigationStart" && r !== "toJSON" && (n[r] = Math.max(t[r] - t.navigationStart, 0));
  return n;
}, rJ = () => En.__WEB_VITALS_POLYFILL__ ? En.performance && (performance.getEntriesByType && performance.getEntriesByType("navigation")[0] || Pje()) : En.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0], iJ = () => {
  const t = rJ();
  return t && t.activationStart || 0;
}, Hx = (t, e) => {
  const n = rJ();
  let r = "navigate";
  return n && (En.document.prerendering || iJ() > 0 ? r = "prerender" : r = n.type.replace(/_/g, "-")), {
    name: t,
    value: typeof e > "u" ? -1 : e,
    rating: "good",
    // Will be updated if the value changes.
    delta: 0,
    entries: [],
    id: _je(),
    navigationType: r
  };
}, xm = (t, e, n) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(t)) {
      const r = new PerformanceObserver((i) => {
        e(i.getEntries());
      });
      return r.observe(
        Object.assign(
          {
            type: t,
            buffered: !0
          },
          n || {}
        )
      ), r;
    }
  } catch {
  }
}, iR = (t, e) => {
  const n = (r) => {
    (r.type === "pagehide" || En.document.visibilityState === "hidden") && (t(r), e && (removeEventListener("visibilitychange", n, !0), removeEventListener("pagehide", n, !0)));
  };
  addEventListener("visibilitychange", n, !0), addEventListener("pagehide", n, !0);
}, Kje = (t) => {
  const e = Hx("CLS", 0);
  let n, r = 0, i = [];
  const a = (s) => {
    s.forEach((l) => {
      if (!l.hadRecentInput) {
        const c = i[0], d = i[i.length - 1];
        r && i.length !== 0 && l.startTime - d.startTime < 1e3 && l.startTime - c.startTime < 5e3 ? (r += l.value, i.push(l)) : (r = l.value, i = [l]), r > e.value && (e.value = r, e.entries = i, n && n());
      }
    });
  }, o = xm("layout-shift", a);
  if (o) {
    n = Ax(t, e);
    const s = () => {
      a(o.takeRecords()), n(!0);
    };
    return iR(s), s;
  }
};
let mf = -1;
const $je = () => En.document.visibilityState === "hidden" && !En.document.prerendering ? 0 : 1 / 0, qje = () => {
  iR(({ timeStamp: t }) => {
    mf = t;
  }, !0);
}, Xx = () => (mf < 0 && (mf = $je(), qje()), {
  get firstHiddenTime() {
    return mf;
  }
}), eDe = (t) => {
  const e = Xx(), n = Hx("FID");
  let r;
  const i = (s) => {
    s.startTime < e.firstHiddenTime && (n.value = s.processingStart - s.startTime, n.entries.push(s), r(!0));
  }, a = (s) => {
    s.forEach(i);
  }, o = xm("first-input", a);
  r = Ax(t, n), o && iR(() => {
    a(o.takeRecords()), o.disconnect();
  }, !0);
}, Ck = {}, tDe = (t) => {
  const e = Xx(), n = Hx("LCP");
  let r;
  const i = (o) => {
    const s = o[o.length - 1];
    if (s) {
      const l = Math.max(s.startTime - iJ(), 0);
      l < e.firstHiddenTime && (n.value = l, n.entries = [s], r());
    }
  }, a = xm("largest-contentful-paint", i);
  if (a) {
    r = Ax(t, n);
    const o = () => {
      Ck[n.id] || (i(a.takeRecords()), a.disconnect(), Ck[n.id] = !0, r(!0));
    };
    return ["keydown", "click"].forEach((s) => {
      addEventListener(s, o, { once: !0, capture: !0 });
    }), iR(o, !0), o;
  }
};
function My(t) {
  return typeof t == "number" && isFinite(t);
}
function Ih(t, { startTimestamp: e, ...n }) {
  return e && t.startTimestamp > e && (t.startTimestamp = e), t.startChild({
    startTimestamp: e,
    ...n
  });
}
function Tr(t) {
  return t / 1e3;
}
function aJ() {
  return En && En.addEventListener && En.performance;
}
let Lk = 0, $n = {}, No, S1;
function nDe() {
  const t = aJ();
  if (t && $d) {
    t.mark && En.performance.mark("sentry-tracing-init"), sDe();
    const e = aDe(), n = oDe();
    return () => {
      e && e(), n && n();
    };
  }
  return () => {
  };
}
function rDe() {
  xm("longtask", (e) => {
    for (const n of e) {
      const r = Sm();
      if (!r)
        return;
      const i = Tr($d + n.startTime), a = Tr(n.duration);
      r.startChild({
        description: "Main UI thread blocked",
        op: "ui.long-task",
        startTimestamp: i,
        endTimestamp: i + a
      });
    }
  });
}
function iDe() {
  xm("event", (e) => {
    for (const n of e) {
      const r = Sm();
      if (!r)
        return;
      if (n.name === "click") {
        const i = Tr($d + n.startTime), a = Tr(n.duration);
        r.startChild({
          description: wh(n.target),
          op: `ui.interaction.${n.name}`,
          startTimestamp: i,
          endTimestamp: i + a
        });
      }
    }
  }, { durationThreshold: 0 });
}
function aDe() {
  return Kje((t) => {
    const e = t.entries.pop();
    e && ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log("[Measurements] Adding CLS"), $n.cls = { value: t.value, unit: "" }, S1 = e);
  });
}
function oDe() {
  return tDe((t) => {
    const e = t.entries.pop();
    e && ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log("[Measurements] Adding LCP"), $n.lcp = { value: t.value, unit: "millisecond" }, No = e);
  });
}
function sDe() {
  eDe((t) => {
    const e = t.entries.pop();
    if (!e)
      return;
    const n = Tr($d), r = Tr(e.startTime);
    (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log("[Measurements] Adding FID"), $n.fid = { value: t.value, unit: "millisecond" }, $n["mark.fid"] = { value: n + r, unit: "second" };
  });
}
function lDe(t) {
  const e = aJ();
  if (!e || !En.performance.getEntries || !$d)
    return;
  (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log("[Tracing] Adding & adjusting spans using Performance API");
  const n = Tr($d), r = e.getEntries();
  let i, a;
  if (r.slice(Lk).forEach((o) => {
    const s = Tr(o.startTime), l = Tr(o.duration);
    if (!(t.op === "navigation" && n + s < t.startTimestamp))
      switch (o.entryType) {
        case "navigation": {
          dDe(t, o, n), i = n + Tr(o.responseStart), a = n + Tr(o.requestStart);
          break;
        }
        case "mark":
        case "paint":
        case "measure": {
          cDe(t, o, s, l, n);
          const c = Xx(), d = o.startTime < c.firstHiddenTime;
          o.name === "first-paint" && d && ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log("[Measurements] Adding FP"), $n.fp = { value: o.startTime, unit: "millisecond" }), o.name === "first-contentful-paint" && d && ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log("[Measurements] Adding FCP"), $n.fcp = { value: o.startTime, unit: "millisecond" });
          break;
        }
        case "resource": {
          const c = o.name.replace(En.location.origin, "");
          hDe(t, o, c, s, l, n);
          break;
        }
      }
  }), Lk = Math.max(r.length - 1, 0), NDe(t), t.op === "pageload") {
    typeof i == "number" && ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log("[Measurements] Adding TTFB"), $n.ttfb = {
      value: (i - t.startTimestamp) * 1e3,
      unit: "millisecond"
    }, typeof a == "number" && a <= i && ($n["ttfb.requestTime"] = {
      value: (i - a) * 1e3,
      unit: "millisecond"
    })), ["fcp", "fp", "lcp"].forEach((s) => {
      if (!$n[s] || n >= t.startTimestamp)
        return;
      const l = $n[s].value, c = n + Tr(l), d = Math.abs((c - t.startTimestamp) * 1e3), u = d - l;
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log(`[Measurements] Normalized ${s} from ${l} to ${d} (${u})`), $n[s].value = d;
    });
    const o = $n["mark.fid"];
    o && $n.fid && (Ih(t, {
      description: "first input delay",
      endTimestamp: o.value + Tr($n.fid.value),
      op: "ui.action",
      startTimestamp: o.value
    }), delete $n["mark.fid"]), "fcp" in $n || delete $n.cls, Object.keys($n).forEach((s) => {
      t.setMeasurement(
        s,
        $n[s].value,
        $n[s].unit
      );
    }), MDe(t);
  }
  No = void 0, S1 = void 0, $n = {};
}
function cDe(t, e, n, r, i) {
  const a = i + n, o = a + r;
  return Ih(t, {
    description: e.name,
    endTimestamp: o,
    op: e.entryType,
    startTimestamp: a
  }), a;
}
function dDe(t, e, n) {
  ["unloadEvent", "redirect", "domContentLoadedEvent", "loadEvent", "connect"].forEach((r) => {
    ST(t, e, r, n);
  }), ST(t, e, "secureConnection", n, "TLS/SSL", "connectEnd"), ST(t, e, "fetch", n, "cache", "domainLookupStart"), ST(t, e, "domainLookup", n, "DNS"), uDe(t, e, n);
}
function ST(t, e, n, r, i, a) {
  const o = a ? e[a] : e[`${n}End`], s = e[`${n}Start`];
  !s || !o || Ih(t, {
    op: "browser",
    description: i || n,
    startTimestamp: r + Tr(s),
    endTimestamp: r + Tr(o)
  });
}
function uDe(t, e, n) {
  Ih(t, {
    op: "browser",
    description: "request",
    startTimestamp: n + Tr(e.requestStart),
    endTimestamp: n + Tr(e.responseEnd)
  }), Ih(t, {
    op: "browser",
    description: "response",
    startTimestamp: n + Tr(e.responseStart),
    endTimestamp: n + Tr(e.responseEnd)
  });
}
function hDe(t, e, n, r, i, a) {
  if (e.initiatorType === "xmlhttprequest" || e.initiatorType === "fetch")
    return;
  const o = {};
  "transferSize" in e && (o["Transfer Size"] = e.transferSize), "encodedBodySize" in e && (o["Encoded Body Size"] = e.encodedBodySize), "decodedBodySize" in e && (o["Decoded Body Size"] = e.decodedBodySize), "renderBlockingStatus" in e && (o["resource.render_blocking_status"] = e.renderBlockingStatus);
  const s = a + r, l = s + i;
  Ih(t, {
    description: n,
    endTimestamp: l,
    op: e.initiatorType ? `resource.${e.initiatorType}` : "resource.other",
    startTimestamp: s,
    data: o
  });
}
function NDe(t) {
  const e = En.navigator;
  if (!e)
    return;
  const n = e.connection;
  n && (n.effectiveType && t.setTag("effectiveConnectionType", n.effectiveType), n.type && t.setTag("connectionType", n.type), My(n.rtt) && ($n["connection.rtt"] = { value: n.rtt, unit: "millisecond" })), My(e.deviceMemory) && t.setTag("deviceMemory", `${e.deviceMemory} GB`), My(e.hardwareConcurrency) && t.setTag("hardwareConcurrency", String(e.hardwareConcurrency));
}
function MDe(t) {
  No && ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log("[Measurements] Adding LCP Data"), No.element && t.setTag("lcp.element", wh(No.element)), No.id && t.setTag("lcp.id", No.id), No.url && t.setTag("lcp.url", No.url.trim().slice(0, 200)), t.setTag("lcp.size", No.size)), S1 && S1.sources && ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log("[Measurements] Adding CLS Data"), S1.sources.forEach(
    (e, n) => t.setTag(`cls.source.${n + 1}`, wh(e.node))
  ));
}
const UE = ["localhost", /^\//], RE = {
  traceFetch: !0,
  traceXHR: !0,
  // TODO (v8): Remove this property
  tracingOrigins: UE,
  tracePropagationTargets: UE
};
function pDe(t) {
  const { traceFetch: e, traceXHR: n, tracePropagationTargets: r, tracingOrigins: i, shouldCreateSpanForRequest: a } = {
    traceFetch: RE.traceFetch,
    traceXHR: RE.traceXHR,
    ...t
  }, o = typeof a == "function" ? a : (c) => !0, s = (c) => mDe(c, r || i), l = {};
  e && _i("fetch", (c) => {
    TDe(c, o, s, l);
  }), n && _i("xhr", (c) => {
    VDe(c, o, s, l);
  });
}
function mDe(t, e) {
  return Zm(t, e || UE);
}
function TDe(t, e, n, r) {
  if (!Cx() || !(t.fetchData && e(t.fetchData.url)))
    return;
  if (t.endTimestamp) {
    const s = t.fetchData.__span;
    if (!s)
      return;
    const l = r[s];
    l && (t.response ? l.setHttpStatus(t.response.status) : t.error && l.setStatus("internal_error"), l.finish(), delete r[s]);
    return;
  }
  const i = Jn().getScope(), a = i && i.getSpan(), o = a && a.transaction;
  if (a && o) {
    const s = a.startChild({
      data: {
        ...t.fetchData,
        type: "fetch"
      },
      description: `${t.fetchData.method} ${t.fetchData.url}`,
      op: "http.client"
    });
    t.fetchData.__span = s.spanId, r[s.spanId] = s;
    const l = t.args[0];
    t.args[1] = t.args[1] || {};
    const c = t.args[1];
    n(t.fetchData.url) && (c.headers = fDe(
      l,
      o.getDynamicSamplingContext(),
      s,
      c
    ));
  }
}
function fDe(t, e, n, r) {
  const i = YL(e), a = n.toTraceparent(), o = typeof Request < "u" && Mc(t, Request) ? t.headers : r.headers;
  if (o)
    if (typeof Headers < "u" && Mc(o, Headers)) {
      const s = new Headers(o);
      return s.append("sentry-trace", a), i && s.append(mE, i), s;
    } else if (Array.isArray(o)) {
      const s = [...o, ["sentry-trace", a]];
      return i && s.push([mE, i]), s;
    } else {
      const s = "baggage" in o ? o.baggage : void 0, l = [];
      return Array.isArray(s) ? l.push(...s) : s && l.push(s), i && l.push(i), {
        ...o,
        "sentry-trace": a,
        baggage: l.length > 0 ? l.join(",") : void 0
      };
    }
  else
    return { "sentry-trace": a, baggage: i };
}
function VDe(t, e, n, r) {
  if (!Cx() || t.xhr && t.xhr.__sentry_own_request__ || !(t.xhr && t.xhr.__sentry_xhr__ && e(t.xhr.__sentry_xhr__.url)))
    return;
  const i = t.xhr.__sentry_xhr__;
  if (t.endTimestamp) {
    const l = t.xhr.__sentry_xhr_span_id__;
    if (!l)
      return;
    const c = r[l];
    c && (c.setHttpStatus(i.status_code), c.finish(), delete r[l]);
    return;
  }
  const a = Jn().getScope(), o = a && a.getSpan(), s = o && o.transaction;
  if (o && s) {
    const l = o.startChild({
      data: {
        ...i.data,
        type: "xhr",
        method: i.method,
        url: i.url
      },
      description: `${i.method} ${i.url}`,
      op: "http.client"
    });
    if (t.xhr.__sentry_xhr_span_id__ = l.spanId, r[t.xhr.__sentry_xhr_span_id__] = l, t.xhr.setRequestHeader && n(t.xhr.__sentry_xhr__.url))
      try {
        t.xhr.setRequestHeader("sentry-trace", l.toTraceparent());
        const c = s.getDynamicSamplingContext(), d = YL(c);
        d && t.xhr.setRequestHeader(mE, d);
      } catch {
      }
  }
}
function UDe(t, e = !0, n = !0) {
  if (!En || !En.location) {
    (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn("Could not initialize routing instrumentation due to invalid location");
    return;
  }
  let r = En.location.href, i;
  e && (i = t({
    name: En.location.pathname,
    // pageload should always start at timeOrigin
    startTimestamp: $d,
    op: "pageload",
    metadata: { source: "url" }
  })), n && _i("history", ({ to: a, from: o }) => {
    if (o === void 0 && r && r.indexOf(a) !== -1) {
      r = void 0;
      return;
    }
    o !== a && (r = void 0, i && ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log(`[Tracing] Finishing current transaction with op: ${i.op}`), i.finish()), i = t({
      name: En.location.pathname,
      op: "navigation",
      metadata: { source: "url" }
    }));
  });
}
const RDe = "BrowserTracing", gDe = {
  ...pf,
  markBackgroundTransactions: !0,
  routingInstrumentation: UDe,
  startTransactionOnLocationChange: !0,
  startTransactionOnPageLoad: !0,
  enableLongTask: !0,
  _experiments: {},
  ...RE
};
class _x {
  // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
  // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
  // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
  // integrations.
  /** Browser Tracing integration options */
  /**
   * @inheritDoc
   */
  __init() {
    this.name = RDe;
  }
  constructor(e) {
    _x.prototype.__init.call(this), NWe(), this.options = {
      ...gDe,
      ...e
    }, this.options._experiments.enableLongTask !== void 0 && (this.options.enableLongTask = this.options._experiments.enableLongTask), e && !e.tracePropagationTargets && e.tracingOrigins && (this.options.tracePropagationTargets = e.tracingOrigins), this._collectWebVitals = nDe(), this.options.enableLongTask && rDe(), this.options._experiments.enableInteractions && iDe();
  }
  /**
   * @inheritDoc
   */
  setupOnce(e, n) {
    this._getCurrentHub = n;
    const {
      routingInstrumentation: r,
      startTransactionOnLocationChange: i,
      startTransactionOnPageLoad: a,
      markBackgroundTransactions: o,
      traceFetch: s,
      traceXHR: l,
      tracePropagationTargets: c,
      shouldCreateSpanForRequest: d,
      _experiments: u
    } = this.options;
    r(
      (h) => {
        const N = this._createRouteTransaction(h);
        return this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(N, h, n), N;
      },
      a,
      i
    ), o && Xje(), u.enableInteractions && this._registerInteractionListener(), pDe({
      traceFetch: s,
      traceXHR: l,
      tracePropagationTargets: c,
      shouldCreateSpanForRequest: d
    });
  }
  /** Create routing idle transaction. */
  _createRouteTransaction(e) {
    if (!this._getCurrentHub) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn(`[Tracing] Did not create ${e.op} transaction because _getCurrentHub is invalid.`);
      return;
    }
    const { beforeNavigate: n, idleTimeout: r, finalTimeout: i, heartbeatInterval: a } = this.options, o = e.op === "pageload", s = o ? Jk("sentry-trace") : null, l = o ? Jk("baggage") : null, c = s ? Ixe(s) : void 0, d = l ? $xe(l) : void 0, u = {
      ...e,
      ...c,
      metadata: {
        ...e.metadata,
        dynamicSamplingContext: c && !d ? {} : d
      },
      trimEnd: !0
    }, h = typeof n == "function" ? n(u) : u, N = h === void 0 ? { ...u, sampled: !1 } : h;
    N.metadata = N.name !== u.name ? { ...N.metadata, source: "custom" } : N.metadata, this._latestRouteName = N.name, this._latestRouteSource = N.metadata && N.metadata.source, N.sampled === !1 && (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log(`[Tracing] Will not send ${N.op} transaction because of beforeNavigate.`), (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.log(`[Tracing] Starting ${N.op} transaction on scope`);
    const M = this._getCurrentHub(), { location: p } = En, m = kk(
      M,
      N,
      r,
      i,
      !0,
      { location: p },
      // for use in the tracesSampler
      a
    );
    return m.registerBeforeFinishCallback((R) => {
      this._collectWebVitals(), lDe(R);
    }), m;
  }
  /** Start listener for interaction transactions */
  _registerInteractionListener() {
    let e;
    const n = () => {
      const { idleTimeout: r, finalTimeout: i, heartbeatInterval: a } = this.options, o = "ui.action.click", s = Sm();
      if (s && s.op && ["navigation", "pageload"].includes(s.op)) {
        (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn(
          `[Tracing] Did not create ${o} transaction because a pageload or navigation transaction is in progress.`
        );
        return;
      }
      if (e && (e.setFinishReason("interactionInterrupted"), e.finish(), e = void 0), !this._getCurrentHub) {
        (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn(`[Tracing] Did not create ${o} transaction because _getCurrentHub is invalid.`);
        return;
      }
      if (!this._latestRouteName) {
        (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && ge.warn(`[Tracing] Did not create ${o} transaction because _latestRouteName is missing.`);
        return;
      }
      const l = this._getCurrentHub(), { location: c } = En, d = {
        name: this._latestRouteName,
        op: o,
        trimEnd: !0,
        metadata: {
          source: this._latestRouteSource || "url"
        }
      };
      e = kk(
        l,
        d,
        r,
        i,
        !0,
        { location: c },
        // for use in the tracesSampler
        a
      );
    };
    ["click"].forEach((r) => {
      addEventListener(r, n, { once: !1, capture: !0 });
    });
  }
}
function Jk(t) {
  const e = $Se(`meta[name=${t}]`);
  return e ? e.getAttribute("content") : null;
}
function yDe(t) {
  t._metadata = t._metadata || {}, t._metadata.sdk = t._metadata.sdk || {
    name: "sentry.javascript.react",
    packages: [
      {
        name: "npm:@sentry/react",
        version: s2
      }
    ],
    version: s2
  }, Aje(t);
}
class dd {
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "CaptureConsole";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = dd.id;
  }
  /**
   * @inheritDoc
   */
  __init2() {
    this._levels = rp;
  }
  /**
   * @inheritDoc
   */
  constructor(e = {}) {
    dd.prototype.__init.call(this), dd.prototype.__init2.call(this), e.levels && (this._levels = e.levels);
  }
  /**
   * @inheritDoc
   */
  setupOnce(e, n) {
    "console" in Cr && this._levels.forEach((r) => {
      r in Cr.console && jr(Cr.console, r, (i) => (...a) => {
        const o = n();
        o.getIntegration(dd) && o.withScope((s) => {
          s.setLevel(FL(r)), s.setExtra("arguments", a), s.addEventProcessor((c) => (c.logger = "console", c));
          let l = a2(a, " ");
          r === "assert" ? a[0] === !1 && (l = `Assertion failed: ${a2(a.slice(1), " ") || "console.assert"}`, s.setExtra("arguments", a.slice(1)), o.captureMessage(l)) : r === "error" && a[0] instanceof Error ? o.captureException(a[0]) : o.captureMessage(l);
        }), i && i.apply(Cr.console, a);
      });
    });
  }
}
dd.__initStatic();
const Bk = async (t) => {
  El.DEV || yDe({
    enabled: t,
    dsn: JP,
    integrations: [
      new _x(),
      new dd({
        levels: ["error"]
      })
    ],
    tracesSampleRate: 1,
    environment: El.PLAT
  });
};
function ZDe({ children: t }) {
  const { enableReport: e } = Lo();
  return Ee(() => (Bk(e), () => {
    Bk(!1);
  }), []), /* @__PURE__ */ E.jsx(E.Fragment, { children: t });
}
const oJ = Wt(
  ZI
);
function bDe({
  children: t,
  internalConfig: e
}) {
  const n = IE(
    e || {},
    ZI
  );
  return /* @__PURE__ */ E.jsx(oJ.Provider, { value: n, children: t });
}
const sJ = Wt({
  dataUpdatedAt: 0,
  isLoading: !1,
  isError: !1,
  isFetching: !1,
  isStale: !1,
  error: null
});
function EDe({ children: t }) {
  const {
    data: e,
    dataUpdatedAt: n,
    isLoading: r,
    isError: i,
    isFetching: a,
    isStale: o,
    refetch: s,
    error: l
  } = SDe(), c = {
    data: e,
    dataUpdatedAt: n,
    isLoading: r,
    isError: i,
    isFetching: a,
    isStale: o,
    refetch: s,
    error: l
  };
  return /* @__PURE__ */ E.jsx(sJ.Provider, { value: c, children: t });
}
function SDe() {
  const { routerApi: t, defaultAffiliate: e } = Xp(), { referrer: n, commissionRate: r } = Lo(), { selectedRoute: i } = aa(), { receiverAddress: a } = rN(), {
    data: o,
    dataUpdatedAt: s,
    isLoading: l,
    isError: c,
    isFetching: d,
    isStale: u,
    refetch: h,
    error: N
  } = Ff({
    queryKey: ["router-build-tx"],
    queryFn: () => {
      var M, p, m, R, V;
      return GK({
        routerApi: t,
        src_chain_id: i ? i.src_chain_id : 0,
        src_quote_token_address: i ? i.src_quote_token_address : "",
        src_quote_token_amount: i ? i.src_quote_token_amount : "",
        dst_chain_id: i ? i.dst_chain_id : 0,
        dst_quote_token_address: i ? i.dst_quote_token.address : "",
        slippage: i ? i.slippage : 1,
        receiver: a,
        bridge_provider: (M = i == null ? void 0 : i.bridge_description) == null ? void 0 : M.provider,
        src_bridge_token_address: (p = i == null ? void 0 : i.bridge_description) == null ? void 0 : p.src_bridge_token_address,
        dst_bridge_token_address: (m = i == null ? void 0 : i.bridge_description) == null ? void 0 : m.dst_bridge_token_address,
        src_swap_provider: (R = i == null ? void 0 : i.src_swap_description) == null ? void 0 : R.provider,
        dst_swap_provider: (V = i == null ? void 0 : i.dst_swap_description) == null ? void 0 : V.provider,
        affiliate: n ?? e,
        commission_rate: r
      });
    },
    enabled: !1
  });
  return {
    data: o,
    dataUpdatedAt: s,
    isLoading: l,
    isError: c,
    isFetching: d,
    isStale: u,
    refetch: h,
    error: N
  };
}
function xDe({ children: t }) {
  const { processingTransactions: e, processingCrossChainSwapTransactinos: n } = qU(), r = Wx(), { routerApi: i } = Xp(), { chainDataList: a } = _3(), o = Tre();
  n1(() => {
    if (e.length === 0)
      return;
    const l = e.map((c) => nc.getInstance().viemClientMap[c.chainId].waitForTransactionReceipt({ hash: c.hash }));
    Promise.allSettled(l).then((c) => {
      c.forEach((d, u) => {
        if (d.status === "fulfilled") {
          const h = d.value;
          r({
            type: "SET_TRANSACTION_RECEIPT",
            payload: {
              id: e[u].id,
              receiptStatus: h.status,
              receiptUpdatedAt: Date.now()
            }
          });
        }
      });
    });
  }, Nj), n1(() => {
    if (n.length === 0)
      return;
    const l = n.map(
      (c) => LK({
        src_chain_id: c.chainId,
        src_tx_hash: c.hash,
        routerApi: i
      })
    );
    Promise.allSettled(l).then((c) => {
      c.forEach((d, u) => {
        if (d.status === "fulfilled") {
          const { tx: h } = d.value;
          h && r({
            type: "SET_CROSS_CHAIN_SWAP_TRANSACTION_TX",
            payload: {
              id: n[u].id,
              destinationChainHash: h
            }
          });
        }
      });
    });
  }, Nj);
  const s = () => {
    try {
      const l = a.map((c) => nc.getInstance().getFeeValue(c.chainId));
      Promise.allSettled(l).then((c) => {
        const d = [];
        c.forEach((u, h) => {
          if (u.status === "fulfilled") {
            const N = u.value, M = {
              chainId: a[h].chainId,
              feeValue: N
            };
            d.push(M);
          }
        }), o({
          type: "SET_CHAIN_DATA_LIST",
          payload: d
        });
      });
    } catch (l) {
      console.error("FETCH_CHAIN_DATA_ERROR", l);
    }
  };
  return Ee(() => {
    s();
  }, []), n1(() => {
    s();
  }, CP), /* @__PURE__ */ E.jsx(E.Fragment, { children: t });
}
function WDe({
  children: t,
  config: e,
  theme: n,
  internalConfig: r
}) {
  const i = El.PLAT === "DEVELOPMENT" ? T3 : m3, a = {
    xyApiBaseUrl: El.API_BASE_URL,
    tokenListApiBaseUrl: El.TOKEN_LIST_URL,
    routerApiBaseUrl: El.ROUTER_API_URL,
    nestApiBaseUrl: El.NEST_API_URL
  }, o = IE(
    e || {},
    gI
  ), s = H0e(
    i,
    LP,
    o.disabledChains
  ), l = new b$(X0e);
  return /* @__PURE__ */ E.jsx(
    lre,
    {
      allChains: i,
      queryClient: l,
      wagmiConfig: s,
      widgetConfig: o,
      apiUrlMap: a,
      defaultAffiliate: RI,
      children: /* @__PURE__ */ E.jsx(ZDe, { children: /* @__PURE__ */ E.jsx(OSe, { children: /* @__PURE__ */ E.jsx(_0e, { theme: n, children: /* @__PURE__ */ E.jsx(bDe, { internalConfig: r, children: /* @__PURE__ */ E.jsx(WSe, { children: /* @__PURE__ */ E.jsx(bSe, { children: /* @__PURE__ */ E.jsx(xDe, { children: /* @__PURE__ */ E.jsx(mre, { children: /* @__PURE__ */ E.jsx(EDe, { children: t }) }) }) }) }) }) }) }) })
    }
  );
}
const Oh = Ge(({ disabled: t, loading: e, icon: n, showUpdate: r, ...i }, a) => {
  const o = t || e;
  return /* @__PURE__ */ E.jsxs(
    Te.button,
    {
      ref: a,
      cursor: o ? "not-allowed" : "pointer",
      borderRadius: "inner",
      color: "button.grey.text.enable",
      bgColor: "button.grey.background.enable",
      p: "xs",
      _hover: {
        color: "button.grey.text.hover",
        bgColor: "button.grey.background.hover"
      },
      _disabled: {
        color: "button.grey.text.disable",
        bgColor: "button.grey.background.disable"
      },
      position: "relative",
      disabled: o,
      ...i,
      children: [
        /* @__PURE__ */ E.jsx(Mr, { animation: e ? `${P9} 1s linear infinite` : "", children: n }),
        r && /* @__PURE__ */ E.jsx(
          Mr,
          {
            bgColor: "text.alert",
            position: "absolute",
            top: "4px",
            right: "4px",
            height: "4px",
            width: "4px",
            borderRadius: "full"
          }
        )
      ]
    }
  );
});
function Ak({
  children: t,
  size: e = "sm",
  variant: n = "independant",
  active: r = !1,
  error: i = !1,
  ...a
}) {
  const o = (() => {
    switch (e) {
      case "sm":
        return {
          px: "8px",
          py: "8px"
        };
      case "md":
        return {
          px: "16px",
          py: "8px"
        };
    }
  })(), s = (() => {
    switch (n) {
      case "independant":
        return {
          borderRadius: "8px"
        };
      case "start":
        return {
          borderRadius: "8px 0 0 8px",
          borderRightWidth: "0.5px"
        };
      case "center":
        return {
          borderRightWidth: "0.5px",
          borderLeftWidth: "0.5px"
        };
      case "end":
        return {
          borderRadius: "0 8px 8px 0",
          borderLeftWidth: "0.5px"
        };
    }
  })(), l = r ? {
    borderColor: "text.interaction.default",
    color: "text.primary",
    borderLeftWidth: "1px",
    borderRightWidth: "1px"
  } : {
    borderColor: "border.default",
    color: "text.secondary"
  }, c = i ? {
    borderColor: "text.critical.default"
  } : {}, d = {
    fontSize: "14px",
    lineHeight: "18px",
    width: "80px",
    border: "1px"
  };
  return /* @__PURE__ */ E.jsx(
    Te.button,
    {
      ...d,
      ...o,
      ...s,
      ...l,
      ...c,
      ...a,
      children: t
    }
  );
}
const jDe = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { d: "M17.9444 8.03265L16.371 7.56162C16.2471 7.52454 16.1168 7.51171 15.9878 7.52385C15.8587 7.536 15.7334 7.57288 15.6189 7.63239C15.5044 7.69191 15.403 7.77289 15.3206 7.87071C15.2381 7.96854 15.1761 8.08129 15.1382 8.20253C15.1003 8.32377 15.0872 8.45113 15.0996 8.57733C15.112 8.70353 15.1497 8.82611 15.2106 8.93805C15.2714 9.05 15.3543 9.14913 15.4543 9.22978C15.5543 9.31043 15.6696 9.37103 15.7936 9.4081L19.5691 10.5374C19.6932 10.5745 19.8235 10.5873 19.9526 10.5751C20.0817 10.5629 20.2071 10.526 20.3216 10.4664C20.4361 10.4067 20.5375 10.3256 20.6199 10.2277C20.7023 10.1298 20.7642 10.0169 20.802 9.89554L21.9568 6.20354C21.9948 6.0823 22.0079 5.95494 21.9955 5.82874C21.983 5.70254 21.9453 5.57996 21.8845 5.46801C21.7616 5.24193 21.5518 5.07284 21.3014 4.99797C21.051 4.92309 20.7805 4.94855 20.5493 5.06874C20.4348 5.12825 20.3334 5.20924 20.2509 5.30706C20.1685 5.40488 20.1065 5.51764 20.0686 5.63888L19.6343 7.02978C17.2574 3.44974 12.5422 1.91019 8.35609 3.58776C7.1042 4.08955 5.97997 4.85351 5.06249 5.8259C4.14502 6.79829 3.45661 7.95547 3.04569 9.21602C3.00357 9.33745 2.98661 9.46587 2.9958 9.59378C3.005 9.72169 3.04016 9.84653 3.09925 9.961C3.15833 10.0755 3.24014 10.1773 3.33991 10.2605C3.43968 10.3437 3.5554 10.4066 3.68032 10.4456C3.80524 10.4846 3.93685 10.4989 4.06747 10.4876C4.19808 10.4763 4.32509 10.4396 4.44106 10.3798C4.55703 10.3199 4.65965 10.2381 4.74292 10.1391C4.82619 10.04 4.88845 9.92572 4.92605 9.80288C5.34306 8.52238 6.12192 7.38332 7.17272 6.51724C8.22351 5.65115 9.50338 5.09335 10.8645 4.90825C12.2257 4.72314 13.6127 4.91828 14.8652 5.47113C16.1178 6.02398 17.1859 6.912 17.9444 8.03265ZM5.7769 15.9427L7.52894 16.3703C7.6558 16.4043 7.78833 16.4132 7.91876 16.3964C8.04918 16.3796 8.17485 16.3375 8.2884 16.2726C8.40194 16.2076 8.50106 16.1211 8.57994 16.0182C8.65881 15.9152 8.71584 15.7979 8.74768 15.6731C8.77953 15.5483 8.78554 15.4185 8.76536 15.2914C8.74518 15.1643 8.69923 15.0424 8.63019 14.9329C8.56115 14.8234 8.47043 14.7285 8.36336 14.6538C8.25628 14.579 8.13501 14.526 8.00667 14.4978L4.4108 13.6204C4.22344 13.5332 4.0127 13.5062 3.80869 13.5431C3.61213 13.5684 3.42791 13.651 3.28002 13.7801C3.13213 13.9093 3.02743 14.0789 2.97956 14.2671L2.02408 18.0122C1.96748 18.2581 2.01155 18.516 2.14685 18.7306C2.28216 18.9452 2.49797 19.0996 2.74813 19.1606C2.99829 19.2216 3.26295 19.1845 3.48549 19.0572C3.70803 18.9299 3.8708 18.7225 3.93899 18.4793L4.26472 17.2033C5.2151 18.5407 6.51674 19.6027 8.03254 20.2774C9.54833 20.9521 11.2221 21.2145 12.8777 21.0371C14.5332 20.8596 16.1091 20.2488 17.4394 19.269C18.7698 18.2892 19.8052 16.9767 20.4368 15.4697L20.6934 14.8578C20.7926 14.6209 20.7915 14.3551 20.6904 14.119C20.5892 13.8828 20.3963 13.6957 20.154 13.5986C19.9117 13.5016 19.6399 13.5027 19.3984 13.6016C19.157 13.7005 18.9656 13.8892 18.8663 14.1261L18.6097 14.7371C18.1066 15.9377 17.2777 16.9811 16.2125 17.7548C15.1474 18.5284 13.8864 19.003 12.5656 19.1271C11.2449 19.2513 9.91453 19.0204 8.71814 18.4594C7.52175 17.8984 6.50476 17.0275 5.7769 15.9427Z", fill: "currentColor" })), lJ = Ge(jDe), DDe = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { d: "M21.5443 14.2167C21.4458 14.0197 21.3473 13.8227 21.1502 13.6256L19.968 12.7389C19.8695 12.6404 19.7709 12.5419 19.6724 12.4433C19.5739 12.3448 19.5739 12.1478 19.5739 12.0493C19.5739 11.8522 19.5739 11.7537 19.6724 11.6552C19.7709 11.5567 19.8695 11.3596 19.968 11.3596L21.1502 10.4729C21.3473 10.3744 21.4458 10.1773 21.5443 9.88177C21.6429 9.68473 21.6429 9.38916 21.5443 9.19212C21.0517 7.71429 20.2635 6.4335 19.2783 5.25123C19.0813 5.05419 18.8842 4.95566 18.6872 4.95566C18.4901 4.95566 18.1946 4.95566 17.9975 5.05419L16.6182 5.64532C16.3227 5.84236 15.8301 5.74384 15.633 5.44828C15.436 5.25123 15.3374 5.05419 15.3374 4.85714L15.1404 3.37931C15.1404 3.18227 15.0419 2.8867 14.8448 2.68966C14.6478 2.49261 14.4507 2.39409 14.2537 2.29557C13.564 2.09852 12.7759 2 11.9877 2C11.1995 2 10.5099 2.09852 9.72168 2.29557C9.52463 2.19704 9.32759 2.29557 9.13055 2.49261C8.9335 2.68966 8.83498 2.8867 8.83498 3.18227L8.63793 4.6601C8.63793 4.85714 8.53941 5.15271 8.34237 5.25123C8.14532 5.44828 7.94828 5.5468 7.75124 5.5468C7.65271 5.5468 7.45567 5.5468 7.35715 5.44828L5.97784 4.85714C5.78079 4.75862 5.48523 4.75862 5.28818 4.75862C4.99261 4.85714 4.79557 4.95566 4.69705 5.05419C3.71183 6.13793 2.92365 7.51724 2.43104 8.99507C2.33252 9.19212 2.33252 9.48768 2.43104 9.68473C2.43104 9.98029 2.62808 10.1773 2.82513 10.2759L4.00739 11.1626C4.20444 11.2611 4.30296 11.4581 4.40148 11.7537C4.5 12.0493 4.40148 12.2463 4.30296 12.4433C4.20444 12.5419 4.10592 12.7389 4.00739 12.7389L2.82513 13.6256C2.62808 13.7241 2.52956 13.9212 2.43104 14.2167C2.33252 14.4138 2.33252 14.7094 2.43104 14.9064C2.92365 16.3842 3.71183 17.665 4.69705 18.8473C4.89409 19.0443 5.09114 19.1429 5.28818 19.1429C5.48523 19.1429 5.78079 19.1429 5.97784 19.0443L7.35715 18.4532C7.65271 18.3547 8.14532 18.3547 8.34237 18.6502C8.53941 18.8473 8.63793 19.0443 8.63793 19.2414L8.83498 20.7192C8.83498 20.9163 8.9335 21.2118 9.13055 21.3103C9.32759 21.5074 9.52463 21.6059 9.72168 21.7044C10.5099 21.9015 11.1995 22 11.9877 22C12.7759 22 13.4655 21.9015 14.2537 21.7044C14.4507 21.6059 14.6478 21.5074 14.8448 21.3103C15.0419 21.1133 15.1404 20.9163 15.1404 20.7192L15.3374 19.2414C15.3374 19.0443 15.436 18.8473 15.633 18.6502C15.8301 18.4532 16.0271 18.4532 16.2241 18.3547C16.3227 18.3547 16.5197 18.3547 16.6182 18.4532L17.9975 19.0443C18.0961 19.1429 18.2931 19.1429 18.4902 19.1429C18.6872 19.1429 18.7857 19.1429 18.9828 19.0443C19.0813 18.9458 19.2783 18.8473 19.3769 18.7488C20.3621 17.665 21.1502 16.2857 21.6429 14.8079C21.6429 14.7094 21.6429 14.4138 21.5443 14.2167ZM5.78079 13.133C5.97784 12.7389 6.07636 12.3448 6.07636 11.9507C6.07636 11.5567 5.97784 11.1626 5.78079 10.7685C5.58375 10.3744 5.28818 10.0788 4.99261 9.88177L4.00739 9.19212C4.40148 8.2069 4.89409 7.3202 5.58375 6.4335L6.66749 6.92611C7.06158 7.02463 7.35715 7.12315 7.75124 7.12315C8.34237 7.12315 9.03202 6.92611 9.42611 6.4335C9.91872 6.03941 10.2143 5.44828 10.3128 4.75862L10.4113 3.57635C10.9039 3.57635 11.4951 3.57635 11.9877 3.47783C12.4803 3.47783 13.0714 3.57635 13.564 3.67488L13.6626 4.85714C13.7611 5.44828 14.0567 6.03941 14.5493 6.53202C15.0419 6.92611 15.633 7.22167 16.2241 7.22167C16.6182 7.22167 16.9138 7.12315 17.3079 7.02463L18.3916 6.53202C19.0813 7.3202 19.5739 8.2069 19.968 9.29064L18.9828 9.9803C18.6872 10.1773 18.3916 10.5714 18.1946 10.867C17.9975 11.1626 17.899 11.5567 17.899 11.9507C17.899 12.3448 17.9975 12.7389 18.1946 13.133C18.3916 13.5271 18.6872 13.8227 18.9828 14.0197L19.968 14.7094C19.5739 15.6946 19.0813 16.5813 18.3916 17.468L17.3079 16.9754C16.9138 16.7783 16.5197 16.7783 16.1256 16.7783C15.7315 16.7783 15.3374 16.8768 14.9434 17.0739C14.5493 17.2709 14.2537 17.5665 14.0567 17.8621C13.8596 18.1576 13.6626 18.5517 13.6626 18.9458L13.564 20.1281C12.4803 20.3251 11.4951 20.3251 10.4113 20.1281L10.3128 18.9458C10.2143 18.3547 9.91872 17.7635 9.42611 17.2709C8.9335 16.8768 8.34237 16.5813 7.75124 16.5813C7.35715 16.5813 7.06158 16.6798 6.76601 16.7783L5.68227 17.2709C4.99261 16.4828 4.5 15.5961 4.10592 14.5123L5.09114 13.8227C5.28818 13.8227 5.58375 13.4286 5.78079 13.133Z", fill: "currentColor" }), /* @__PURE__ */ H.createElement("path", { d: "M11.9877 15.8916C13.0714 15.8916 13.9581 15.4975 14.7463 14.7094C15.5345 13.9212 15.9286 13.0345 15.9286 11.9507C15.9286 10.867 15.5345 9.98029 14.7463 9.19212C13.9581 8.50246 13.0714 8.00985 11.9877 8.00985C10.9039 8.00985 10.0172 8.50246 9.22907 9.19212C8.53941 9.98029 8.0468 10.867 8.0468 11.9507C8.0468 13.0345 8.44089 13.9212 9.22907 14.7094C10.0172 15.399 10.9039 15.8916 11.9877 15.8916ZM11.9877 9.68473C12.5788 9.68473 13.17 9.88177 13.564 10.3744C13.9581 10.7685 14.2537 11.3596 14.2537 11.9507C14.2537 12.5419 14.0567 13.133 13.564 13.5271C13.0714 13.9212 12.5788 14.2167 11.9877 14.2167C11.3966 14.2167 10.8054 14.0197 10.4113 13.5271C10.0172 13.133 9.72168 12.5419 9.72168 11.9507C9.72168 11.3596 9.91872 10.7685 10.4113 10.3744C10.8054 9.88177 11.3966 9.68473 11.9877 9.68473Z", fill: "currentColor" })), zDe = Ge(DDe), kDe = zDe, wDe = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.9286 14.421C14.5584 14.421 13.4286 15.5466 13.4286 16.9586C13.4286 18.3707 14.5584 19.4962 15.9286 19.4962C17.2987 19.4962 18.4286 18.3707 18.4286 16.9586C18.4286 15.5466 17.2987 14.421 15.9286 14.421ZM12 16.9586C12 14.7829 13.7483 13 15.9286 13C18.1088 13 19.8571 14.7829 19.8571 16.9586C19.8571 17.6376 19.6869 18.2782 19.3864 18.8384L21.7362 20.7381C22.0423 20.9855 22.0888 21.433 21.84 21.7376C21.5912 22.0421 21.1413 22.0883 20.8352 21.8408L18.4992 19.9524C17.8117 20.5528 16.9143 20.9173 15.9286 20.9173C13.7483 20.9173 12 19.1343 12 16.9586Z", fill: "currentColor" }), /* @__PURE__ */ H.createElement("path", { d: "M4.93671 2C3.31481 2 2 3.36671 2 5.05263V18.9474C2 20.6333 3.31481 22 4.93671 22H11.0127C11.516 22 11.9241 21.5759 11.9241 21.0526C11.9241 20.5294 11.516 20.1053 11.0127 20.1053H4.93671C4.32151 20.1053 3.82278 19.5869 3.82278 18.9474V5.05263C3.82278 4.41314 4.32151 3.89474 4.93671 3.89474H15.0633C15.6785 3.89474 16.1772 4.41314 16.1772 5.05263V9.26316C16.1772 9.78638 16.5853 10.2105 17.0886 10.2105C17.592 10.2105 18 9.78638 18 9.26316V5.05263C18 3.36671 16.6852 2 15.0633 2H4.93671Z", fill: "currentColor" }), /* @__PURE__ */ H.createElement("path", { d: "M6.4557 6.42104C5.95235 6.42104 5.5443 6.84519 5.5443 7.36841C5.5443 7.89163 5.95235 8.31578 6.4557 8.31578H13.5443C14.0477 8.31578 14.4557 7.89163 14.4557 7.36841C14.4557 6.84519 14.0477 6.42104 13.5443 6.42104H6.4557Z", fill: "currentColor" }), /* @__PURE__ */ H.createElement("path", { d: "M6.4557 10.4211C5.95235 10.4211 5.5443 10.8452 5.5443 11.3684C5.5443 11.8916 5.95235 12.3158 6.4557 12.3158H10.5063C11.0097 12.3158 11.4177 11.8916 11.4177 11.3684C11.4177 10.8452 11.0097 10.4211 10.5063 10.4211H6.4557Z", fill: "currentColor" })), FDe = Ge(wDe), vDe = FDe, IDe = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { d: "M7.21852 15.6568C7.2203 15.6775 7.22326 15.6984 7.22745 15.7193L8.01603 21.1068C8.1199 21.6262 8.57592 22 9.10556 22H14.8649C15.3945 22 15.8505 21.6262 15.9544 21.1068L16.7726 15.6569C16.7768 15.636 16.7797 15.6151 16.7815 15.5944C16.3107 15.9095 15.8036 16.1745 15.2678 16.3819L14.6827 20.6667H9.28774L8.73218 16.4443C8.19638 16.2369 7.68929 15.9719 7.21852 15.6568Z", fill: "currentColor" }), /* @__PURE__ */ H.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.2585 16.8421C17.9265 15.6095 19.7778 12.9098 19.7778 9.77777C19.7778 5.48223 16.2955 2 12 2C7.70446 2 4.22223 5.48223 4.22223 9.77777C4.22223 12.9092 6.07281 15.6084 8.73999 16.8414L8.72809 16.7548H15.2719L15.2585 16.8421ZM15.188 15.3797H8.81199C6.86689 14.2704 5.55556 12.1772 5.55556 9.77777C5.55556 6.21861 8.44083 3.33333 12 3.33333C15.5592 3.33333 18.4444 6.21861 18.4444 9.77777C18.4444 12.1772 17.1331 14.2704 15.188 15.3797Z", fill: "currentColor" }), /* @__PURE__ */ H.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.2 9.22222C8.2 8.83869 8.50536 8.52777 8.88889 8.52777H15.1111C15.4946 8.52777 15.8111 8.83869 15.8111 9.22222C15.8111 9.60575 15.4946 9.91666 15.1111 9.91666H8.88889C8.50536 9.91666 8.2 9.60575 8.2 9.22222Z", fill: "currentColor" }), /* @__PURE__ */ H.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 8.52777C12.3835 8.52777 12.6944 8.83869 12.6944 9.22222V15.3333C12.6944 15.7169 12.3835 16.0278 12 16.0278C11.6165 16.0278 11.3056 15.7169 11.3056 15.3333V9.22222C11.3056 8.83869 11.6165 8.52777 12 8.52777Z", fill: "currentColor" })), ODe = Ge(IDe), YDe = ODe, QDe = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { d: "M13.6667 8.03674C13.6667 8.95722 12.9205 9.70341 12 9.70341C11.0795 9.70341 10.3333 8.95722 10.3333 8.03674C10.3333 7.11627 11.0795 6.37007 12 6.37007C12.9205 6.37007 13.6667 7.11627 13.6667 8.03674Z", fill: "currentColor" }), /* @__PURE__ */ H.createElement("path", { d: "M10.75 12.0915C10.75 11.4012 11.3097 10.8415 12 10.8415C12.6904 10.8415 13.25 11.4012 13.25 12.0915V16.9542C13.25 17.6445 12.6904 18.2042 12 18.2042C11.3097 18.2042 10.75 17.6445 10.75 16.9542V12.0915Z", fill: "currentColor" }), /* @__PURE__ */ H.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 20.125C16.4873 20.125 20.125 16.4873 20.125 12C20.125 7.51269 16.4873 3.875 12 3.875C7.51269 3.875 3.875 7.51269 3.875 12C3.875 16.4873 7.51269 20.125 12 20.125ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", fill: "currentColor" })), GDe = Ge(QDe), CDe = GDe, LDe = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { d: "M19.1308 8.27029C19.755 8.8958 19.7568 9.90918 19.1361 10.5369L13.3148 15.9181L13.3086 15.9244L13.3043 15.9285C13.3 15.9327 13.293 15.9396 13.2833 15.9486C13.264 15.9668 13.2344 15.994 13.196 16.0271C13.1189 16.0936 13.0085 16.1823 12.8766 16.2704C12.6004 16.4548 12.2836 16.6002 12.0003 16.6002C11.6726 16.6002 11.3539 16.4508 11.0968 16.2737C10.9719 16.1876 10.8705 16.1011 10.8009 16.0366C10.7663 16.0045 10.7401 15.9783 10.7232 15.9611C10.7149 15.9524 10.7088 15.9461 10.7054 15.9423L10.7019 15.9385L10.6899 15.9251L4.86444 10.537C4.24377 9.90922 4.24555 8.89581 4.86978 8.27028C5.49533 7.64343 6.50907 7.64357 7.13462 8.27042L12.0003 12.8513L16.857 8.27911L16.8658 8.27029C17.4913 7.64343 18.5052 7.64343 19.1308 8.27029Z", fill: "currentColor" })), JDe = Ge(LDe), BDe = JDe, ADe = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { d: "M16.6106 11.3477L12.9576 7.75342C12.7749 7.57078 12.5923 7.47945 12.4096 7.47945C12.227 7.47945 11.953 7.57078 11.8617 7.75342C11.4964 8.11872 11.4964 8.57534 11.8617 8.94064L14.1448 11.2237H7.93476C7.47814 11.2237 7.11284 11.589 7.11284 12.0457C7.11284 12.5023 7.47814 12.8676 7.93476 12.8676H14.0535L11.7704 15.1507C11.4051 15.516 11.4051 15.9726 11.7704 16.3379C11.953 16.5205 12.1357 16.6119 12.3183 16.6119C12.501 16.6119 12.7749 16.5205 12.8663 16.3379L16.6106 12.6592C16.6106 12.6592 16.948 12.3368 16.948 11.9801C16.948 11.6555 16.6106 11.3477 16.6106 11.3477Z", fill: "currentColor" }), /* @__PURE__ */ H.createElement("path", { d: "M17.0672 2H7.02152C4.19046 2 1.99868 4.28311 1.99868 7.02283V16.9772C1.99868 19.8082 4.28179 22 7.02152 22H16.9759C19.8069 22 21.9987 19.7169 21.9987 16.9772V7.02283C22.09 4.28311 19.8069 2 17.0672 2ZM19.9896 17.0685C19.9896 18.7123 18.711 20.0822 17.0672 20.0822H7.02152C5.37768 20.0822 4.00782 18.7123 4.00782 17.0685V7.02283C4.00782 5.379 5.37768 4.00913 7.02152 4.00913H16.9759C18.6197 4.00913 19.9896 5.379 19.9896 7.02283V17.0685Z", fill: "currentColor" })), HDe = Ge(ADe), XDe = HDe, _De = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { d: "M20.6132 13.4282L6.73201 13.4282L11.5862 18.2824C11.8291 18.5449 11.9613 18.8911 11.955 19.2488C11.9486 19.6081 11.8031 19.9509 11.549 20.205C11.2949 20.4591 10.9521 20.6047 10.5928 20.611C10.2351 20.6173 9.88884 20.4851 9.62635 20.2422L2.40558 13.0214C2.14588 12.7614 2 12.4089 2 12.0414C2 11.6739 2.14588 11.3214 2.40558 11.0614L9.63015 3.83707L9.63689 3.82983C9.76386 3.69357 9.91696 3.58428 10.0871 3.50849C10.2572 3.43269 10.4408 3.39193 10.6271 3.38864C10.8133 3.38536 10.9982 3.41961 11.1709 3.48936C11.3436 3.55911 11.5005 3.66293 11.6322 3.79462C11.7638 3.92631 11.8677 4.08318 11.9374 4.25587C12.0072 4.42855 12.0414 4.61351 12.0381 4.79973C12.0348 4.98594 11.9941 5.16958 11.9183 5.33969C11.8425 5.50981 11.7331 5.66279 11.5968 5.78975L6.73201 10.6546L20.6132 10.6546C20.981 10.6546 21.3337 10.8007 21.5938 11.0608C21.8539 11.3209 22 11.6736 22 12.0414C22 12.4092 21.8539 12.762 21.5938 13.022C21.3337 13.2821 20.981 13.4282 20.6132 13.4282Z", fill: "currentColor" })), PDe = Ge(_De), KDe = PDe, $De = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { d: "M13.4284 3.38683L13.4284 17.268L18.2826 12.4138C18.5451 12.1709 18.8913 12.0387 19.249 12.045C19.6083 12.0514 19.9511 12.1969 20.2052 12.451C20.4593 12.7051 20.6048 13.0479 20.6112 13.4072C20.6175 13.7649 20.4853 14.1112 20.2424 14.3736L13.0216 21.5944C12.7616 21.8541 12.4091 22 12.0416 22C11.6741 22 11.3216 21.8541 11.0616 21.5944L3.83725 14.3699L3.83001 14.3631C3.69375 14.2361 3.58447 14.083 3.50867 13.9129C3.43287 13.7428 3.39211 13.5592 3.38883 13.3729C3.38554 13.1867 3.41979 13.0018 3.48954 12.8291C3.5593 12.6564 3.66311 12.4995 3.7948 12.3678C3.9265 12.2362 4.08336 12.1323 4.25605 12.0626C4.42873 11.9928 4.6137 11.9586 4.79991 11.9619C4.98612 11.9652 5.16976 12.0059 5.33988 12.0817C5.50999 12.1575 5.66297 12.2669 5.78994 12.4032L10.6548 17.268L10.6548 3.38683C10.6548 3.01902 10.8009 2.66627 11.061 2.40619C11.321 2.14611 11.6738 2 12.0416 2C12.4094 2 12.7621 2.14611 13.0222 2.40619C13.2823 2.66627 13.4284 3.01902 13.4284 3.38683Z", fill: "currentColor" })), qDe = Ge($De), e4e = qDe, t4e = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { d: "M3.38683 13.4285L17.268 13.4285L12.4138 18.2827C12.1709 18.5451 12.0387 18.8914 12.045 19.2491C12.0514 19.6084 12.1969 19.9512 12.451 20.2053C12.7051 20.4594 13.0479 20.6049 13.4072 20.6112C13.7649 20.6176 14.1112 20.4854 14.3736 20.2425L21.5944 13.0217C21.8541 12.7617 22 12.4092 22 12.0417C22 11.6741 21.8541 11.3217 21.5944 11.0616L14.3699 3.83731L14.3631 3.83007C14.2361 3.69382 14.083 3.58453 13.9129 3.50873C13.7428 3.43293 13.5592 3.39217 13.3729 3.38889C13.1867 3.3856 13.0018 3.41986 12.8291 3.48961C12.6564 3.55936 12.4995 3.66317 12.3678 3.79487C12.2362 3.92656 12.1323 4.08342 12.0626 4.25611C11.9928 4.42879 11.9586 4.61376 11.9619 4.79997C11.9652 4.98618 12.0059 5.16982 12.0817 5.33994C12.1575 5.51006 12.2669 5.66304 12.4032 5.79L17.268 10.6548L3.38683 10.6548C3.01902 10.6548 2.66628 10.8009 2.40619 11.061C2.14611 11.3211 2 11.6738 2 12.0417C2 12.4095 2.14611 12.7622 2.40619 13.0223C2.66628 13.2824 3.01902 13.4285 3.38683 13.4285Z", fill: "currentColor" })), n4e = Ge(t4e), r4e = n4e, i4e = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.1587 18.3205C12.0164 18.3205 13.7292 17.6997 15.1008 16.6543L20.1244 21.6779C20.5538 22.1074 21.25 22.1074 21.6794 21.6779C22.1088 21.2485 22.1088 20.5523 21.6794 20.1229L16.6554 15.0989C17.6992 13.7278 18.319 12.0164 18.319 10.1602C18.319 5.65346 14.6655 2 10.1587 2C5.65196 2 1.9985 5.65346 1.9985 10.1602C1.9985 14.667 5.65196 18.3205 10.1587 18.3205ZM16.1199 10.1602C16.1199 13.4525 13.451 16.1213 10.1587 16.1213C6.8665 16.1213 4.19762 13.4525 4.19762 10.1602C4.19762 6.86799 6.8665 4.19911 10.1587 4.19911C13.451 4.19911 16.1199 6.86799 16.1199 10.1602ZM10.1587 18.1419C11.9717 18.1419 13.6436 17.5374 14.9837 16.5189C15.0311 16.4829 15.0781 16.4463 15.1247 16.4092C13.7618 17.4938 12.0359 18.1419 10.1587 18.1419ZM16.4104 15.1229C16.4474 15.0763 16.484 15.0293 16.52 14.9818C16.7424 14.6888 16.9451 14.38 17.126 14.0572C16.9158 14.4322 16.6762 14.7885 16.4104 15.1229C16.4104 15.1229 16.4104 15.1229 16.4104 15.1229ZM16.2984 10.1602C16.2984 10.1602 16.2984 10.1602 16.2984 10.1602V10.1602Z", fill: "currentColor" })), a4e = Ge(i4e), o4e = a4e, s4e = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { d: "M10.2297 14.1914L18.0851 6.30256C18.6838 5.7268 19.6486 5.72769 20.2465 6.30468C20.8486 6.88579 20.8512 7.83102 20.2539 8.41519L20.2514 8.41772L10.9888 17.697C10.6794 17.9946 10.2561 18.1493 9.82471 18.1262C9.39763 18.1034 8.99765 17.9081 8.72367 17.5844L3.64403 11.8428L3.63827 11.836C3.10402 11.1895 3.21588 10.2463 3.88061 9.73309C4.53494 9.22794 5.48654 9.32393 6.01938 9.95183L9.79331 14.1795C9.84833 14.2411 9.92634 14.2774 10.0089 14.2796C10.0915 14.2819 10.1714 14.25 10.2297 14.1914Z", fill: "currentColor" })), l4e = Ge(s4e), c4e = l4e, d4e = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { d: "M4.125 13.1427C3.88087 13.1424 3.64329 13.2243 3.44821 13.376C3.25312 13.5276 3.11113 13.7408 3.04371 13.9832C2.97629 14.2257 2.9871 14.4842 3.07452 14.7197C3.16194 14.9553 3.3212 15.155 3.52823 15.2887L6.5492 18.4101C6.65362 18.5179 6.77757 18.6034 6.91397 18.6617C7.05037 18.7201 7.19656 18.7501 7.34418 18.75C7.4918 18.7499 7.63796 18.7198 7.77432 18.6614C7.91069 18.603 8.03458 18.5174 8.13892 18.4095C8.24327 18.3016 8.32603 18.1736 8.38247 18.0326C8.43891 17.8917 8.46794 17.7406 8.46788 17.5881C8.46783 17.4356 8.4387 17.2846 8.38216 17.1437C8.32562 17.0028 8.24278 16.8747 8.13836 16.7669L6.8785 15.4663H15.3638C15.6618 15.4663 15.9477 15.344 16.1585 15.1262C16.3692 14.9084 16.4876 14.6131 16.4876 14.3051C16.4876 13.9971 16.3692 13.7017 16.1585 13.4839C15.9477 13.2662 15.6618 13.1438 15.3638 13.1438L4.125 13.1427Z", fill: "currentColor" }), /* @__PURE__ */ H.createElement("path", { d: "M19.875 10.8573C20.1191 10.8576 20.3567 10.7757 20.5518 10.624C20.7469 10.4724 20.8889 10.2592 20.9563 10.0168C21.0237 9.77434 21.0129 9.5158 20.9255 9.28028C20.8381 9.04475 20.6788 8.84504 20.4718 8.71134L17.4508 5.5899C17.2399 5.37216 16.954 5.24989 16.6558 5.25C16.3577 5.25011 16.0718 5.37258 15.8611 5.59048C15.6503 5.80838 15.532 6.10385 15.5321 6.4119C15.5322 6.71994 15.6508 7.01533 15.8616 7.23307L17.1215 8.53367H8.63625C8.33818 8.53367 8.05232 8.65602 7.84155 8.87379C7.63078 9.09157 7.51237 9.38694 7.51237 9.69492C7.51237 10.0029 7.63078 10.2983 7.84155 10.5161C8.05232 10.7338 8.33818 10.8562 8.63625 10.8562L19.875 10.8573Z", fill: "currentColor" })), u4e = Ge(d4e), h4e = u4e, N4e = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.5 16.825C3.73858 16.825 1.5 14.5864 1.5 11.825V6.82495C1.5 4.06353 3.73858 1.82495 6.5 1.82495H11.5C14.2614 1.82495 16.5 4.06353 16.5 6.82495C19.2614 6.82495 21.5 9.06353 21.5 11.825V16.825C21.5 19.5864 19.2614 21.825 16.5 21.825H11.5C8.73858 21.825 6.5 19.5864 6.5 16.825ZM3.375 11.825C3.375 13.5508 4.77411 14.95 6.5 14.95V11.825C6.5 9.06353 8.73858 6.82495 11.5 6.82495H14.625C14.625 5.09906 13.2259 3.69995 11.5 3.69995H6.5C4.77411 3.69995 3.375 5.09906 3.375 6.82495V11.825ZM11.5 8.69995H16.5C18.2259 8.69995 19.625 10.0991 19.625 11.825V16.825C19.625 18.5508 18.2259 19.95 16.5 19.95H11.5C9.77411 19.95 8.375 18.5508 8.375 16.825V11.825C8.375 10.0991 9.77411 8.69995 11.5 8.69995Z", fill: "currentColor" })), M4e = Ge(N4e), p4e = M4e, m4e = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { d: "M22 15.9734C22 15.3342 21.4545 14.7863 20.8182 14.7863C20.1818 14.7863 19.6364 15.3342 19.6364 15.9734V16.7952C19.6364 18.3475 18.3636 19.6259 16.8182 19.6259H7.09091C5.54545 19.6259 4.27273 18.3475 4.27273 16.7952V7.02481C4.27273 5.47251 5.54545 4.19414 7.09091 4.19414H11C11.6364 4.19414 12.0909 3.64627 12.0909 3.09839C12.0909 2.45921 11.5455 2.00265 11 2.00265H7.09091C4.27273 1.91134 2 4.19414 2 7.02481V16.8865C2 19.7172 4.27273 22 7.09091 22H16.9091C19.7273 22 22 19.7172 22 16.8865V15.9734Z", fill: "currentColor" }), /* @__PURE__ */ H.createElement("path", { d: "M11.4545 10.0381C11.6364 10.2207 11.9091 10.312 12.1818 10.312H18.0909L16 12.4122C15.6364 12.7775 15.6364 13.4167 16 13.7819C16.1818 13.9645 16.4545 14.0558 16.7273 14.0558C17 14.0558 17.2727 13.9645 17.4545 13.7819L21.0909 10.0381C21.3149 9.79875 21.4841 9.66065 21.4841 9.3431C21.4841 9.05591 21.2727 8.85106 21.0909 8.66843L17.2727 4.92463C16.9091 4.55939 16.2727 4.55939 15.9091 4.92463C15.5455 5.28988 15.5455 5.92907 15.9091 6.29432L18 8.3945H12.0909C11.8182 8.3945 11.5455 8.48581 11.3636 8.66843C11.1818 8.85106 11.0909 9.12499 11.0909 9.39893C11.1818 9.67286 11.2727 9.85549 11.4545 10.0381Z", fill: "currentColor" })), T4e = Ge(m4e), f4e = T4e, V4e = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { d: "M22 14.1472C22 13.508 21.4545 12.9601 20.8182 12.9601C20.1818 12.9601 19.6364 13.508 19.6364 14.1472V16.7952C19.6364 18.3475 18.3636 19.6259 16.8182 19.6259H7.09091C5.54545 19.6259 4.27273 18.3475 4.27273 16.7952V7.02481C4.27273 5.47251 5.54545 4.19414 7.09091 4.19414H11C11.6364 4.19414 12.0909 3.64627 12.0909 3.09839C12.0909 2.45921 11.5455 2.00265 11 2.00265H7.09091C4.27273 1.91134 2 4.19414 2 7.02481V16.8865C2 19.7172 4.27273 22 7.09091 22H16.9091C19.7273 22 22 19.7172 22 16.8865V14.1472Z", fill: "currentColor" }), /* @__PURE__ */ H.createElement("path", { d: "M14.7114 10.2778C14.9841 10.2778 15.1818 10.1294 15.3636 9.9468L19.5455 5.74644V8.75974C19.5455 9.30762 20 9.76418 20.5455 9.76418C20.8182 9.76418 21.0909 9.67286 21.2727 9.49024C21.4545 9.30762 21.5455 9.03368 21.5455 8.75974V3.37233C21.5455 2.91577 21.5455 2.73314 21.3636 2.55052C21.1818 2.3679 20.8182 2.3679 20.6364 2.3679H15.2727C14.7273 2.3679 14.2727 2.82446 14.2727 3.37233C14.2727 3.9202 14.7273 4.37676 15.2727 4.37676H18.2727L14.0909 8.57712C13.9091 8.75974 13.7142 8.92085 13.7011 9.23131C13.6891 9.51569 13.7932 9.7486 13.9905 9.9468C14.1878 10.145 14.5296 10.2778 14.7114 10.2778Z", fill: "currentColor" })), U4e = Ge(V4e), R4e = U4e, g4e = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { d: "M22 12C22 12.1725 21.9956 12.344 21.987 12.5144L22 12Z", fill: "currentColor" }), /* @__PURE__ */ H.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.987 12.5144C21.7193 17.7982 17.3503 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 21.9999 6.47722 22 12M20.125 12C20.125 16.4873 16.4873 20.125 12 20.125C7.51269 20.125 3.875 16.4873 3.875 12C3.875 7.51269 7.51269 3.875 12 3.875C16.4873 3.875 20.125 7.51269 20.125 12Z", fill: "currentColor" }), /* @__PURE__ */ H.createElement("path", { d: "M12 6.23906C11.3863 6.23906 10.8889 6.73652 10.8889 7.35017V12.9057C10.8889 13.5194 11.3863 14.0168 12 14.0168C12.6136 14.0168 13.1111 13.5194 13.1111 12.9057V7.35017C13.1111 6.73652 12.6136 6.23906 12 6.23906Z", fill: "currentColor" }), /* @__PURE__ */ H.createElement("path", { d: "M12 15.4502C11.3863 15.4502 10.8889 15.9477 10.8889 16.5614C10.8889 17.175 11.3863 17.6725 12 17.6725C12.6136 17.6725 13.1111 17.175 13.1111 16.5614C13.1111 15.9477 12.6136 15.4502 12 15.4502Z", fill: "currentColor" })), cJ = Ge(g4e), y4e = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { d: "M17.5602 6.43978C18.1465 7.02614 18.1465 7.97683 17.5602 8.5632L14.1234 12L17.5602 15.4368C18.1466 16.0231 18.1466 16.9738 17.5602 17.5602C16.9739 18.1465 16.0232 18.1465 15.4368 17.5602L12 14.1234L8.5632 17.5602C7.97683 18.1465 7.02614 18.1465 6.43978 17.5602C5.85341 16.9738 5.85341 16.0231 6.43978 15.4368L9.87657 12L6.43982 8.5632C5.85345 7.97683 5.85345 7.02614 6.43982 6.43978C7.02619 5.85341 7.97688 5.85341 8.56325 6.43978L12 9.87653L15.4368 6.43978C16.0231 5.85341 16.9738 5.85341 17.5602 6.43978Z", fill: "currentColor" })), Z4e = Ge(y4e), b4e = Z4e, E4e = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 20.1372C16.4941 20.1372 20.1373 16.4941 20.1373 12C20.1373 7.50591 16.4941 3.86274 12 3.86274C7.50594 3.86274 3.86277 7.50591 3.86277 12C3.86277 16.4941 7.50594 20.1372 12 20.1372Z", fill: "currentColor" }), /* @__PURE__ */ H.createElement("path", { d: "M16.2581 9.32175C16.6066 9.67067 16.6082 10.2354 16.2628 10.5863L11.9109 15.3863C11.7308 15.5648 11.4837 15.6587 11.2306 15.6446C10.9802 15.6308 10.7474 15.5126 10.5882 15.3191C10.5839 15.3139 10.5794 15.3089 10.5745 15.3041L8.27483 13.0343C7.96561 12.6473 8.02837 12.0824 8.41495 11.7728C8.79702 11.4667 9.35247 11.5244 9.66391 11.8994C9.6701 11.9069 9.67684 11.9139 9.68407 11.9203L11.1987 13.2743C11.2375 13.309 11.2885 13.3268 11.3404 13.3239C11.3923 13.321 11.441 13.2975 11.4756 13.2587L14.9938 9.3178C15.3441 8.97099 15.9092 8.97238 16.2581 9.32175Z", fill: "currentColor" })), S4e = Ge(E4e), x4e = S4e, W4e = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 100 100", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { d: "M50 19.7578V19.762C50.1174 19.7607 50.235 19.76 50.3527 19.76C67.2485 19.76 80.9454 33.4568 80.9454 50.3527C80.9454 67.2486 67.2485 80.9454 50.3527 80.9454C33.4568 80.9454 19.76 67.2486 19.76 50.3527C19.76 50.193 19.7578 50.0361 19.7578 49.8789C19.7578 48.2896 18.47 47.0011 16.881 47H16.8789C15.2889 47 14 48.2889 14 49.8789C14 49.9013 14 49.8398 14 49.8789C14 69.7612 30.1178 86 50 86C69.8823 86 86 69.8823 86 50C86 30.1177 69.8823 14 50 14C48.41 14 47.1211 15.2889 47.1211 16.8789C47.1211 18.4689 48.41 19.7578 50 19.7578Z", fill: "currentColor" })), j4e = Ge(W4e), D4e = j4e, z4e = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { d: "M10.4592 9.98822C10.6757 9.98822 10.8833 10.0742 11.0364 10.2273C11.1895 10.3804 11.2755 10.588 11.2755 10.8045V16.927C11.2755 17.1435 11.1895 17.3511 11.0364 17.5042C10.8833 17.6573 10.6757 17.7433 10.4592 17.7433C10.2427 17.7433 10.035 17.6573 9.88195 17.5042C9.72886 17.3511 9.64286 17.1435 9.64286 16.927V10.8045C9.64286 10.588 9.72886 10.3804 9.88195 10.2273C10.035 10.0742 10.2427 9.98822 10.4592 9.98822Z", fill: "currentColor" }), /* @__PURE__ */ H.createElement("path", { d: "M14.5408 9.98822C14.7573 9.98822 14.965 10.0742 15.118 10.2273C15.2711 10.3804 15.3571 10.588 15.3571 10.8045V16.927C15.3571 17.1435 15.2711 17.3511 15.118 17.5042C14.965 17.6573 14.7573 17.7433 14.5408 17.7433C14.3243 17.7433 14.1167 17.6573 13.9636 17.5042C13.8105 17.3511 13.7245 17.1435 13.7245 16.927V10.8045C13.7245 10.588 13.8105 10.3804 13.9636 10.2273C14.1167 10.0742 14.3243 9.98822 14.5408 9.98822Z", fill: "currentColor" }), /* @__PURE__ */ H.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.398 3.66169V5.90658H21.6837C21.9002 5.90658 22.1078 5.99259 22.2609 6.14568C22.414 6.29877 22.5 6.50641 22.5 6.72291C22.5 6.93941 22.414 7.14705 22.2609 7.30014C22.1078 7.45323 21.9002 7.53924 21.6837 7.53924H20.4028L19.5046 20.1186C19.4716 20.582 19.2643 21.0157 18.9243 21.3323C18.5843 21.6489 18.137 21.825 17.6725 21.825H7.32653C6.86196 21.825 6.41465 21.6489 6.07469 21.3323C5.73472 21.0157 5.52737 20.582 5.49438 20.1186L4.59822 7.53924H3.31633C3.09982 7.53924 2.89219 7.45323 2.7391 7.30014C2.58601 7.14705 2.5 6.93941 2.5 6.72291C2.5 6.50641 2.58601 6.29877 2.7391 6.14568C2.89219 5.99259 3.09982 5.90658 3.31633 5.90658H7.60204V3.66169C7.60204 3.17455 7.79555 2.70737 8.14001 2.36292C8.48446 2.01846 8.95164 1.82495 9.43878 1.82495H15.5612C16.0484 1.82495 16.5155 2.01846 16.86 2.36292C17.2044 2.70737 17.398 3.17455 17.398 3.66169ZM9.23469 3.4576V5.90658H15.7653V3.4576H9.23469ZM18.7671 7.53924H6.23389L7.13753 20.1923H17.8635L18.7671 7.53924Z", fill: "currentColor" })), k4e = Ge(z4e), w4e = k4e, F4e = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { d: "M7.86327 19.5058C8.5217 20.1628 9.58842 20.1647 10.2492 19.5114L15.9136 13.3837L15.9202 13.3772L15.9246 13.3727C15.929 13.3682 15.9362 13.3607 15.9457 13.3506C15.9649 13.3302 15.9935 13.2991 16.0283 13.2587C16.0983 13.1775 16.1917 13.0613 16.2844 12.9224C16.4786 12.6317 16.6316 12.2983 16.6316 12.0001C16.6316 11.6551 16.4744 11.3196 16.2879 11.049C16.1973 10.9175 16.1062 10.8108 16.0383 10.7375C16.0045 10.7011 15.977 10.6735 15.9588 10.6558C15.9497 10.6469 15.943 10.6406 15.9391 10.6369L15.9351 10.6333L15.921 10.6207L10.2492 4.48861C9.58846 3.83527 8.52172 3.83714 7.86327 4.49422C7.20343 5.1527 7.20357 6.21979 7.86342 6.87827L12.6854 12.0001L7.87256 17.1123L7.86327 17.1216C7.20343 17.7801 7.20343 18.8473 7.86327 19.5058Z", fill: "currentColor" })), v4e = Ge(F4e), I4e = v4e, O4e = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { d: "M16.1367 19.5058C15.4783 20.1628 14.4116 20.1647 13.7508 19.5114L8.08642 13.3837L8.07982 13.3772L8.07541 13.3727C8.071 13.3682 8.06382 13.3607 8.05426 13.3506C8.0351 13.3302 8.00654 13.2991 7.97172 13.2587C7.90169 13.1775 7.80834 13.0613 7.71559 12.9224C7.52143 12.6317 7.36838 12.2983 7.36838 12.0001C7.36838 11.6551 7.52565 11.3196 7.71213 11.049C7.80275 10.9175 7.89378 10.8108 7.9617 10.7375C7.99546 10.7011 8.02299 10.6735 8.04118 10.6558C8.05026 10.6469 8.05697 10.6406 8.06091 10.6369L8.06491 10.6333L8.07898 10.6207L13.7508 4.48861C14.4115 3.83527 15.4783 3.83714 16.1367 4.49422C16.7966 5.1527 16.7964 6.21979 16.1366 6.87827L11.3146 12.0001L16.1274 17.1123L16.1367 17.1216C16.7966 17.7801 16.7966 18.8473 16.1367 19.5058Z", fill: "currentColor" })), Y4e = Ge(O4e), Q4e = Y4e, G4e = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.2954 6.70459C17.8539 7.26304 17.8539 8.16846 17.2954 8.7269L14.0223 12L17.2955 15.2731C17.8539 15.8316 17.8539 16.737 17.2955 17.2955C16.737 17.8539 15.8316 17.8539 15.2731 17.2955L12 14.0223L8.72686 17.2955C8.16841 17.8539 7.26299 17.8539 6.70455 17.2955C6.1461 16.737 6.1461 15.8316 6.70455 15.2731L9.97769 12L6.70459 8.7269C6.14614 8.16846 6.14615 7.26304 6.70459 6.70459C7.26304 6.14615 8.16846 6.14615 8.7269 6.70459L12 9.97769L15.2731 6.70459C15.8315 6.14615 16.737 6.14615 17.2954 6.70459Z", fill: "currentColor" })), C4e = Ge(G4e), L4e = C4e, J4e = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { d: "M10.6667 12.1516L8.75753 14.0608C8.34748 14.4709 8.34748 15.1357 8.75753 15.5458C9.16759 15.9558 9.83241 15.9558 10.2425 15.5458L12.1517 13.6365L14.0608 15.5457C14.4709 15.9558 15.1357 15.9558 15.5458 15.5457C15.9558 15.1357 15.9558 14.4708 15.5458 14.0608L13.6366 12.1516L15.5458 10.2425C15.9558 9.83241 15.9558 9.16758 15.5458 8.75753C15.1357 8.34748 14.4709 8.34748 14.0608 8.75753L12.1517 10.6667L10.2425 8.75749C9.83241 8.34744 9.16759 8.34744 8.75753 8.75749C8.34748 9.16754 8.34748 9.83236 8.75753 10.2424L10.6667 12.1516Z", fill: "currentColor" }), /* @__PURE__ */ H.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20.125C16.4873 20.125 20.125 16.4873 20.125 12C20.125 7.51269 16.4873 3.875 12 3.875C7.51269 3.875 3.875 7.51269 3.875 12C3.875 16.4873 7.51269 20.125 12 20.125Z", fill: "currentColor" })), B4e = Ge(J4e), A4e = B4e, H4e = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 20.1372C16.4941 20.1372 20.1373 16.4941 20.1373 12C20.1373 7.50591 16.4941 3.86274 12 3.86274C7.50594 3.86274 3.86277 7.50591 3.86277 12C3.86277 16.4941 7.50594 20.1372 12 20.1372Z", fill: "currentColor" })), X4e = Ge(H4e), _4e = X4e, P4e = (t, e) => /* @__PURE__ */ H.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: e, ...t }, /* @__PURE__ */ H.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", fill: "currentColor" }), /* @__PURE__ */ H.createElement("path", { d: "M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z", fill: "currentColor" })), K4e = Ge(P4e), $4e = K4e, q4e = Te(KDe), eze = Te(e4e), tze = Te(b4e), dJ = Te(cJ), nze = Te(YDe), Px = Te(CDe), uJ = Te(h4e), Kx = Te(BDe), hJ = Te(c4e), rze = Te(L4e), ize = Te(o4e), NJ = Te(r4e), c2 = Te(R4e), aze = Te(D4e), d2 = Te(A4e), u2 = Te(x4e), oze = Te(_4e), sze = Te($4e), lze = Te(f4e), cze = Te(p4e), dze = Te(kDe), uze = Te(XDe), hze = Te(lJ), Nze = Te(vDe), Mze = Te(Q4e), pze = Te(I4e), mze = Te(w4e);
function Tze() {
  const { navigate: t } = qs();
  return /* @__PURE__ */ E.jsx(
    Uu,
    {
      onClick: () => t("/connection"),
      variant: "grey",
      rightIcon: /* @__PURE__ */ E.jsx(uze, {}),
      children: "Connect"
    }
  );
}
const fze = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTQiIGN5PSIxNCIgcj0iMTQiIGZpbGw9IndoaXRlIi8+CjxwYXRoIG9wYWNpdHk9IjAuNDUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTQuMDk2IDExLjEzNjFMMTQuMDY0OSAxMS4xMjA2TDcuNDA0NTQgMTQuMTk0VjE0LjIwOTVMMTQuMDk2IDE4LjEyMTFMMjAuODE4NSAxNC4yMDk1TDE0LjA5NiAxMS4xMzYxWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggb3BhY2l0eT0iMC42NCIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC4wOTU3IDI0Ljg4OTJMMjAuNDQ1NiAxNS44Mzk4TDE0LjA5NTcgMTkuNTM0MVYyNC44ODkyWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggb3BhY2l0eT0iMC4yMDI1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTcuNzMwNzEgMTUuODM5OEwxNC4wOTYxIDI0Ljg4OTJWMTkuNTM0MUw3LjczMDcxIDE1LjgzOThaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBvcGFjaXR5PSIwLjQ1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTcuNDA0NDQgMTQuMTk0MUw3LjM4ODkyIDE0LjIwOTZMMTQuMDk1OSAxOC4xMjEyVjExLjEzNjNWMy4xMTEzM0w3LjQwNDQ0IDE0LjE5NDFaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBvcGFjaXR5PSIwLjgiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTQuMDk1NyAzLjExMTMzVjExLjEzNjNWMTguMTIxMkwyMC44MTgyIDE0LjIwOTZMMTQuMDk1NyAzLjExMTMzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==", Vze = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0IDI4QzIxLjczMiAyOCAyOCAyMS43MzIgMjggMTRDMjggNi4yNjgwMSAyMS43MzIgMCAxNCAwQzYuMjY4MDEgMCAwIDYuMjY4MDEgMCAxNEMwIDIxLjczMiA2LjI2ODAxIDI4IDE0IDI4WiIgZmlsbD0iI0YwQjkwQiIvPgo8cGF0aCBkPSJNOS4wMTI3MSA3LjU1NTY0TDEzLjk0NDIgNC42ODUwNkwxOC44NzU3IDcuNTU1NjRMMTcuMDYyNyA4LjYxNjExTDEzLjk0NDIgNi44MDZMMTAuODI1OCA4LjYxNjExTDkuMDEyNzEgNy41NTU2NFpNMTguODc1NyAxMS4xNzU5TDE3LjA2MjcgMTAuMTE1NEwxMy45NDQyIDExLjkyNTVMMTAuODI1OCAxMC4xMTU0TDkuMDEyNzEgMTEuMTc1OVYxMy4yOTY4TDEyLjEzMTIgMTUuMTA2OVYxOC43MjcxTDEzLjk0NDIgMTkuNzg3NkwxNS43NTczIDE4LjcyNzFWMTUuMTA2OUwxOC44NzU3IDEzLjI5NjhWMTEuMTc1OVpNMTguODc1NyAxNi45MTdWMTQuNzk2MUwxNy4wNjI3IDE1Ljg1NjZWMTcuOTc3NUwxOC44NzU3IDE2LjkxN1pNMjAuMTYzIDE3LjY2NjZMMTcuMDQ0NiAxOS40NzY4VjIxLjU5NzdMMjEuOTc2MSAxOC43MjcxVjEyLjk4NkwyMC4xNjMgMTQuMDQ2NVYxNy42NjY2Wk0xOC4zNSA5LjM2NTc2TDIwLjE2MyAxMC40MjYyVjEyLjU0NzJMMjEuOTc2MSAxMS40ODY3VjkuMzY1NzZMMjAuMTYzIDguMzA1MjhMMTguMzUgOS4zNjU3NlpNMTIuMTMxMiAyMC4yNDQ3VjIyLjM2NTZMMTMuOTQ0MiAyMy40MjYxTDE1Ljc1NzMgMjIuMzY1NlYyMC4yNDQ3TDEzLjk0NDIgMjEuMzA1MkwxMi4xMzEyIDIwLjI0NDdaTTkuMDEyNzEgMTYuOTE3TDEwLjgyNTggMTcuOTc3NVYxNS44NTY2TDkuMDEyNzEgMTQuNzk2MVYxNi45MTdaTTEyLjEzMTIgOS4zNjU3NkwxMy45NDQyIDEwLjQyNjJMMTUuNzU3MyA5LjM2NTc2TDEzLjk0NDIgOC4zMDUyOEwxMi4xMzEyIDkuMzY1NzZaTTcuNzI1NDEgMTAuNDI2Mkw5LjUzODQ3IDkuMzY1NzZMNy43MjU0MSA4LjMwNTI4TDUuOTEyMzUgOS4zNjU3NlYxMS40ODY3TDcuNzI1NDEgMTIuNTQ3MlYxMC40MjYyWk03LjcyNTQxIDE0LjA0NjVMNS45MTIzNSAxMi45ODZWMTguNzI3MUwxMC44NDM5IDIxLjU5NzdWMTkuNDc2OEw3LjcyNTQxIDE3LjY2NjZWMTQuMDQ2NVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=", Uze = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4IDM2QzI3Ljk0MTEgMzYgMzYgMjcuOTQxMSAzNiAxOEMzNiA4LjA1ODg3IDI3Ljk0MTEgMCAxOCAwQzguMDU4ODcgMCAwIDguMDU4ODcgMCAxOEMwIDI3Ljk0MTEgOC4wNTg4NyAzNiAxOCAzNloiIGZpbGw9IiNGNUYwRkQiLz4KPHBhdGggZD0iTTIzLjIwMzcgMjEuODg4TDI4LjI5NzIgMTguOTQ4MUMyOC41NjkxIDE4Ljc5MzcgMjguNzMwOCAxOC40OTk3IDI4LjczMDggMTguMTkxVjEyLjMxMTFDMjguNzMwOCAxMi4wMDI0IDI4LjU2MTggMTEuNzA4NCAyOC4yOTcyIDExLjU1NEwyMy4yMDM3IDguNjE0MDVDMjIuOTMxNyA4LjQ1OTcgMjIuNjAxIDguNDU5NyAyMi4zMjkgOC42MTQwNUwxNy4yMzU1IDExLjU1NEMxNi45NjM2IDExLjcwODQgMTYuODAxOSAxMi4wMDI0IDE2LjgwMTkgMTIuMzExMVYyMi44MjE1TDEzLjIyOTggMjQuODc5NUw5LjY1Nzc1IDIyLjgyMTVWMTguNjk4MkwxMy4yMjk4IDE2LjYzMjhMMTUuNTg5MSAxNy45OTI2VjE1LjIyOUwxMy42NzA4IDE0LjExOTJDMTMuNTM4NSAxNC4wNDU3IDEzLjM4NDIgMTQuMDAxNiAxMy4yMzcyIDE0LjAwMTZDMTMuMDkwMiAxNC4wMDE2IDEyLjkzNTggMTQuMDQ1NyAxMi44MDM1IDE0LjExOTJMNy43MTAwMSAxNy4wNTkxQzcuNDM4MDcgMTcuMjEzNSA3LjI3NjM3IDE3LjUwNzUgNy4yNzYzNyAxNy44MTYyVjIzLjY5NjFDNy4yNzYzNyAyNC4wMDQ4IDcuNDQ1NDIgMjQuMjk4OCA3LjcxMDAxIDI0LjQ1MzJMMTIuODAzNSAyNy4zOTMxQzEzLjA3NTUgMjcuNTQ3NSAxMy40MDYyIDI3LjU0NzUgMTMuNjc4MiAyNy4zOTMxTDE4Ljc3MTcgMjQuNDUzMkMxOS4wNDM2IDI0LjI5ODggMTkuMjA1MyAyNC4wMDQ4IDE5LjIwNTMgMjMuNjk2MVYxMy4xODU3TDE5LjI3MTUgMTMuMTQ5TDIyLjc3NzQgMTEuMTIwNEwyNi4zNDk1IDEzLjE4NTdWMTcuMzA5TDIyLjc3NzQgMTkuMzY3TDIwLjQyNTQgMTguMDA3M1YyMC43NzA5TDIyLjM0MzcgMjEuODczM0MyMi42MDEgMjIuMDQyNCAyMi45MzkxIDIyLjA0MjQgMjMuMjAzNyAyMS44ODhaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfMTUxMl81NTAxKSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzE1MTJfNTUwMSIgeDE9IjkuMDkxOCIgeTE9IjI0LjUwMTciIHgyPSIyNy41NDYiIHkyPSIxMS4wNDU0IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiNBNzI2QzEiLz4KPHN0b3Agb2Zmc2V0PSIwLjg4IiBzdG9wLWNvbG9yPSIjODAzQkRGIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzdCM0ZFNCIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=", Rze = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4IDM2QzI3Ljk0MTEgMzYgMzYgMjcuOTQxMSAzNiAxOEMzNiA4LjA1ODg3IDI3Ljk0MTEgMCAxOCAwQzguMDU4ODcgMCAwIDguMDU4ODcgMCAxOEMwIDI3Ljk0MTEgOC4wNTg4NyAzNiAxOCAzNloiIGZpbGw9IiMxM0I1RUMiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOS4zNSAxNC41MTI1TDIzLjQgMTIuMTVWMTYuODc1TDE5LjM1IDE0LjUxMjVaTTIzLjQgMjQuNjM3NUwxOCAyNy43ODc1TDEyLjYgMjQuNjM3NVYxOS4xMjVMMTggMjIuMjc1TDIzLjQgMTkuMTI1VjI0LjYzNzVaTTEyLjYgMTIuMTVMMTYuNjUgMTQuNTEyNUwxMi42IDE2Ljg3NVYxMi4xNVpNMTguNjc1IDE1LjYzNzVMMjIuNzI1IDE4TDE4LjY3NSAyMC4zNjI1VjE1LjYzNzVaTTE3LjMyNSAyMC4zNjI1TDEzLjI3NSAxOEwxNy4zMjUgMTUuNjM3NVYyMC4zNjI1Wk0yMi43MjUgMTEuMDI1TDE4IDEzLjcyNUwxMy4yNzUgMTEuMDI1TDE4IDguMjEyNUwyMi43MjUgMTEuMDI1Wk0xMS4yNSAxMC41NzVWMjUuMzEyNUwxOCAyOS4xMzc1TDI0Ljc1IDI1LjMxMjVWMTAuNTc1TDE4IDYuNzVMMTEuMjUgMTAuNTc1WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==", gze = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTgiIGN5PSIxOCIgcj0iMTgiIGZpbGw9IiMwNTEyMjEiLz4KPHBhdGggZD0iTTE4LjAwNCA2TDcuNjA5MTMgMTIuMDAyVjI0LjAwMkwxOC4wMDQgMzBMMjguMzkwOSAyNC4wMDJWMTIuMDAyTDE4LjAwNCA2Wk0yNS4zMTM1IDIyLjIyMzlMMTguMDA0IDI2LjQ0MzhMMTAuNjkwNiAyMi4yMjM5VjEzLjc3NjFMMTguMDA0IDkuNTU2MTVMMjUuMzEzNSAxMy43NzYxVjIyLjIyMzlaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMjIuODUxNSAyMC40MDc2TDE4IDIzLjIwNzVMMTMuMTQ0NSAyMC40MDc2VjE0LjgwMzlMMTggMTJMMjIuODUxNSAxNC44MDM5TDIwLjgzMjEgMTUuOTcwNUwxOCAxNC4zMzMyTDE1LjE2OCAxNS45NzA1VjE5LjIzN0wxOCAyMC44NzQzTDIwLjgzMjEgMTkuMjM3TDIyLjg1MTUgMjAuNDA3NloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=", yze = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE2MTNfNTIzNikiPgo8cGF0aCBkPSJNNy41MjQ0MSAxNi44OTYxQzcuMTg2NDggMTcuNDM2OCA3LjU2OTQ2IDE4LjExMjYgOC4yMDAyNSAxOC4xMTI2SDE3LjMyNDJDMTcuNjE3IDE4LjExMjYgMTcuODE5OCAxOC40NTA2IDE3LjYzOTUgMTguNjk4NEw4LjY5NTg3IDMzLjAwMzhDOC42MDU3NiAzMy4xNjE0IDguNDAzIDMzLjIwNjUgOC4yNDUzMSAzMy4wOTM5QzMuMjg5MTEgMjkuODk0OSAwIDI0LjMwNzkgMCAxNy45Nzc1QzAgOC4yMjI3OCA3Ljc0OTY5IDAuMjkyODY2IDE3LjQxNDMgMEMxNy42NjIxIDAgMTcuODE5OCAwLjI3MDMzOCAxNy42ODQ2IDAuNDczMDkxTDcuNTI0NDEgMTYuODk2MVpNMjguMDkyNiAzLjA4NjM2QzI3LjkzNDkgMi45OTYyNSAyNy43MzIyIDMuMDQxMyAyNy42NDIxIDMuMTc2NDdMMTguODMzNSAxNy4zMDE2QzE4LjY3NTggMTcuNTQ5NCAxOC44NTYxIDE3Ljg4NzQgMTkuMTQ4OSAxNy44ODc0SDI4LjI3MjhDMjguOTAzNiAxNy44ODc0IDI5LjI4NjYgMTguNTg1NyAyOC45NDg3IDE5LjEwMzlMMTguNjMwOCAzNS41OTQ1QzE4LjUxODEgMzUuNzc0NyAxOC42NTMzIDM1Ljk3NzUgMTguODU2MSAzNS45Nzc1QzI4LjQwOCAzNS41MjY5IDM2IDI3LjY2NDYgMzYgMThDMzYgMTEuODA0OCAzMi44Njg2IDYuMzMwNDEgMjguMDkyNiAzLjA4NjM2WiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzE2MTNfNTIzNikiLz4KPC9nPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzE2MTNfNTIzNiIgeDE9IjE1LjU0NzUiIHkxPSI3LjQzNDM4IiB4Mj0iMjEuODcxMSIgeTI9IjM0LjYwMjMiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agb2Zmc2V0PSIwLjE3OTkiIHN0b3AtY29sb3I9IiMwMEZGRDUiLz4KPHN0b3Agb2Zmc2V0PSIwLjIzMjQiIHN0b3AtY29sb3I9IiMwMEY4RDUiLz4KPHN0b3Agb2Zmc2V0PSIwLjMwOTgiIHN0b3AtY29sb3I9IiMwMEU0RDUiLz4KPHN0b3Agb2Zmc2V0PSIwLjQwMjYiIHN0b3AtY29sb3I9IiMwMEMzRDUiLz4KPHN0b3Agb2Zmc2V0PSIwLjUwNzMiIHN0b3AtY29sb3I9IiMwMDk2RDUiLz4KPHN0b3Agb2Zmc2V0PSIwLjYyMiIgc3RvcC1jb2xvcj0iIzAwNUNENSIvPgo8c3RvcCBvZmZzZXQ9IjAuNzQzMiIgc3RvcC1jb2xvcj0iIzAwMTZENSIvPgo8c3RvcCBvZmZzZXQ9IjAuNzc5NiIgc3RvcC1jb2xvcj0iIzAwMDBENSIvPgo8L2xpbmVhckdyYWRpZW50Pgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzE2MTNfNTIzNiI+CjxyZWN0IHdpZHRoPSIzNiIgaGVpZ2h0PSIzNiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K", Zze = "data:image/svg+xml;base64,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", bze = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTgiIGN5PSIxOCIgcj0iMTgiIGZpbGw9IiMxODFDMjUiLz4KPHBhdGggZD0iTTI5Ljk4MyAxNi42NzE0TDI5LjMwMzEgMTUuNTMyNkwyNS41ODA3IDkuMjc3NjRIMjUuNTYzN0wyNS40NDQ4IDkuMDU2NjdIMjQuMDg1TDE4Ljc5ODkgMTguMzU0MUwyNC4xNyAyNy42MDA2SDI1LjUyOTdMMjUuNTYzNyAyNy41NDk2TDMwIDE5Ljk1MTlIMjcuMjYzNUwyNC45MDA5IDI0LjE1MDJMMjEuNTM1NCAxOC4zMzcxTDI0LjgzMjkgMTIuNTI0MUwyNy4yMjk1IDE2LjY1NDRMMjkuOTgzIDE2LjY3MTRaIiBmaWxsPSIjNDFFNkFGIi8+CjxwYXRoIGQ9Ik05LjI5NzQ1IDE1LjE1ODZMMTEuNzc5IDEwLjkyNjNMMTAuOTQ2MiA5LjU4MzU3TDEwLjM2ODMgOC42MzE3M0w2LjExODk4IDE2LjEyNzVMNiAxNi4zMzE0TDYuNjc5ODkgMTcuNTIxMkgxNy4zNzExTDIyLjc1OTIgOC4yOTE3OEwyMi4wMTEzIDdMMTQuNTMyNiA3LjAxN0gxNC40MTM2TDEzLjIyMzggN0wxNC40ODE2IDkuMzc5NkwxOS4zNzY4IDkuMzYyNjFMMTYuMDExMyAxNS4xNTg2SDkuMjk3NDVaIiBmaWxsPSIjNDFFNkFGIi8+CjxwYXRoIGQ9Ik0xNC41ODM2IDEwLjI2MzRDMTQuMzk2NiAxMC4yNjM0IDE0LjE5MjYgMTAuMjk3NCAxMy45ODg3IDEwLjM2NTRDMTMuNzY3NyAxMC40MzM0IDEzLjU0NjcgMTAuNTM1NCAxMy4zNDI4IDEwLjY1NDRDMTIuNzY0OSAxMS4wMTEzIDEyLjM1NjkgMTEuNTIxMiAxMi4yODkgMTEuOTk3MkMxMi4yNTUgMTIuMjE4MSAxMi4zMDYgMTIuNDA1MSAxMi40MjQ5IDEyLjU0MTFDMTIuNDQxOSAxMi41NzUxIDEyLjQ3NTkgMTIuNTkyMSAxMi40OTI5IDEyLjYyNjFDMTIuNTA5OSAxMi42NDMgMTIuNTI2OSAxMi42NDMgMTIuNTQzOSAxMi42NkMxMi41NjA5IDEyLjY3NyAxMi41NjA5IDEyLjY3NyAxMi41Nzc5IDEyLjY5NEMxMi42MTE5IDEyLjcxMSAxMi42Mjg5IDEyLjcyOCAxMi42NjI5IDEyLjc0NUMxMy4wMTk4IDEyLjkxNSAxMy41ODA3IDEyLjg4MSAxNC4xMjQ2IDEyLjYyNjFMMTQuMTQxNiAxMi42MDkxQzE0LjE5MjYgMTIuNTkyMSAxNC4yNDM2IDEyLjU1ODEgMTQuMjk0NiAxMi41NDExQzE0LjM0NTYgMTIuNTI0MSAxNC4zNzk2IDEyLjQ5MDEgMTQuNDMwNiAxMi40NTYxQzE0LjQ4MTYgMTIuNDIyMSAxNC41MzI2IDEyLjM4ODEgMTQuNTgzNiAxMi4zNTQxQzE0LjYzNDYgMTIuMzIwMSAxNC42Njg2IDEyLjI4NjEgMTQuNzE5NiAxMi4yNTIxTDE0Ljc1MzUgMTIuMjM1MUMxNC43ODc1IDEyLjIwMTEgMTQuODIxNSAxMi4xODQxIDE0Ljg1NTUgMTIuMTUwMUMxNC44NzI1IDEyLjEzMzEgMTQuODcyNSAxMi4xMzMxIDE0Ljg4OTUgMTIuMTE2MUMxNC45MjM1IDEyLjA5OTEgMTQuOTQwNSAxMi4wNjUxIDE0Ljk1NzUgMTIuMDQ4MUMxNC45NzQ1IDEyLjAzMTIgMTQuOTkxNSAxMi4wMTQyIDE1LjAwODUgMTEuOTgwMkMxNS4wMjU1IDExLjk0NjIgMTUuMDU5NSAxMS45MjkyIDE1LjA3NjUgMTEuODk1MkMxNS4wOTM1IDExLjg3ODIgMTUuMDkzNSAxMS44NzgyIDE1LjExMDUgMTEuODYxMkMxNS4xMjc1IDExLjgyNzIgMTUuMTYxNSAxMS44MTAyIDE1LjE3ODUgMTEuNzc2MkwxNS4yMTI1IDExLjc0MjJDMTUuMjI5NSAxMS43MDgyIDE1LjI0NjUgMTEuNjkxMiAxNS4yNjM1IDExLjY1NzJDMTUuMjYzNSAxMS42NTcyIDE1LjI2MzUgMTEuNjU3MiAxNS4yNjM1IDExLjY0MDJMMTUuMjgwNSAxMS42MDYyQzE1LjMxNDUgMTEuNTcyMiAxNS4zMzE0IDExLjUyMTIgMTUuMzQ4NCAxMS40ODcyQzE1LjM2NTQgMTEuNDUzMiAxNS4zODI0IDExLjQwMjMgMTUuMzk5NCAxMS4zNjgzTDE1LjQxNjQgMTEuMzUxM0MxNS40MTY0IDExLjMzNDMgMTUuNDMzNCAxMS4zMTczIDE1LjQzMzQgMTEuMzE3M0MxNS40MzM0IDExLjMwMDMgMTUuNDMzNCAxMS4zMDAzIDE1LjQ1MDQgMTEuMjgzM0MxNS40NTA0IDExLjI0OTMgMTUuNDY3NCAxMS4yMzIzIDE1LjQ2NzQgMTEuMTk4M0MxNS40Njc0IDExLjE2NDMgMTUuNDg0NCAxMS4xNjQzIDE1LjQ4NDQgMTEuMTQ3M0MxNS40ODQ0IDExLjEzMDMgMTUuNDg0NCAxMS4xMTMzIDE1LjQ4NDQgMTEuMTEzM0MxNS40ODQ0IDExLjA3OTMgMTUuNDg0NCAxMS4wNjIzIDE1LjQ4NDQgMTEuMDQ1M1YxMS4wMTEzQzE1LjQ4NDQgMTAuOTc3MyAxNS40ODQ0IDEwLjk2MDMgMTUuNDg0NCAxMC45MjYzQzE1LjQ4NDQgMTAuOTA5MyAxNS40ODQ0IDEwLjkwOTMgMTUuNDg0NCAxMC44OTIzQzE1LjQ4NDQgMTAuODc1MyAxNS40ODQ0IDEwLjg1ODMgMTUuNDg0NCAxMC44NTgzQzE1LjQ4NDQgMTAuODQxNCAxNS40ODQ0IDEwLjg0MTQgMTUuNDg0NCAxMC44MjQ0VjEwLjgwNzRDMTUuNDg0NCAxMC43NzM0IDE1LjQ2NzQgMTAuNzU2NCAxNS40NTA0IDEwLjcyMjRDMTUuNDMzNCAxMC42ODg0IDE1LjQxNjQgMTAuNjcxNCAxNS4zOTk0IDEwLjYzNzRDMTUuMjgwNSAxMC4zODI0IDE0Ljk1NzUgMTAuMjYzNCAxNC41ODM2IDEwLjI2MzRaIiBmaWxsPSIjNDFFNkFGIi8+CjxwYXRoIGQ9Ik0xNS44MjQ0IDExLjUwNDJDMTUuODI0NCAxMS41MzgyIDE1LjgwNzQgMTEuNTU1MiAxNS43OTA0IDExLjU4OTJDMTUuNzkwNCAxMS42MDYyIDE1Ljc5MDQgMTEuNjA2MiAxNS43NzM0IDExLjYyMzJDMTUuNzU2NCAxMS42NzQyIDE1LjczOTQgMTEuNzA4MiAxNS43MDU0IDExLjc1OTJDMTUuNTE4NCAxMi4xMTYxIDE1LjIxMjUgMTIuNDU2MSAxNC44Mzg1IDEyLjcyOEMxNC43ODc1IDEyLjc2MiAxNC43MzY1IDEyLjc5NiAxNC42ODU1IDEyLjgzQzE0LjYzNDYgMTIuODY0IDE0LjU4MzYgMTIuODk4IDE0LjUzMjYgMTIuOTE1SDE0LjUxNTZDMTQuNDk4NiAxMi45MzIgMTQuNDgxNiAxMi45MzIgMTQuNDY0NiAxMi45NDlDMTQuNDMwNiAxMi45NjYgMTQuNDEzNiAxMi45ODMgMTQuMzc5NiAxM0gxNC4zNjI2QzE0LjM0NTYgMTMgMTQuMzI4NiAxMy4wMTcgMTQuMzExNiAxMy4wMTdDMTQuMjc3NiAxMy4wMzQgMTQuMjQzNiAxMy4wNTEgMTQuMjA5NiAxMy4wNTFMMTQuMTc1NiAxMy4wNjhDMTQuMTc1NiAxMy4wNjggMTQuMTc1NiAxMy4wNjggMTQuMTU4NiAxMy4wNjhDMTQuMTQxNiAxMy4wNjggMTQuMTI0NiAxMy4wODUgMTQuMTA3NiAxMy4wODVDMTQuMDczNyAxMy4xMDIgMTQuMDM5NyAxMy4xMDIgMTQuMDA1NyAxMy4xMTlMMTMuOTcxNyAxMy4xMzZIMTMuOTU0N0MxMy45MjA3IDEzLjE1MyAxMy44ODY3IDEzLjE1MyAxMy44NTI3IDEzLjE3QzEzLjgzNTcgMTMuMTcgMTMuODE4NyAxMy4xODcgMTMuNzg0NyAxMy4xODdIMTMuNzY3N0MxMy43MzM3IDEzLjE4NyAxMy42OTk3IDEzLjIwMzkgMTMuNjgyNyAxMy4yMDM5QzEzLjY2NTcgMTMuMjAzOSAxMy42MzE3IDEzLjIwMzkgMTMuNjE0NyAxMy4yMjA5SDEzLjU5NzdDMTMuNTgwNyAxMy4yMjA5IDEzLjU2MzcgMTMuMjIwOSAxMy41NDY3IDEzLjIzNzlDMTMuNTI5NyAxMy4yMzc5IDEzLjUxMjcgMTMuMjM3OSAxMy40OTU3IDEzLjIzNzlDMTMuNDQ0OCAxMy4yMzc5IDEzLjM3NjggMTMuMjU0OSAxMy4zMjU4IDEzLjI1NDlIMTMuMzA4OEMxMy4yNTc4IDEzLjI1NDkgMTMuMjA2OCAxMy4yNTQ5IDEzLjE1NTggMTMuMjU0OUMxMy4xMzg4IDEzLjI1NDkgMTMuMTIxOCAxMy4yNTQ5IDEzLjEyMTggMTMuMjU0OUgxMy4xMDQ4QzEzLjA3MDggMTMuMjU0OSAxMy4wMzY4IDEzLjI1NDkgMTMuMDAyOCAxMy4yMzc5QzEyLjk4NTggMTMuMjM3OSAxMi45Njg4IDEzLjIzNzkgMTIuOTUxOCAxMy4yMjA5QzEyLjkxNzggMTMuMjIwOSAxMi44ODM5IDEzLjIwMzkgMTIuODQ5OSAxMy4yMDM5QzEyLjgzMjkgMTMuMjAzOSAxMi44MTU5IDEzLjE4NyAxMi43OTg5IDEzLjE4N0wxMy43MzM3IDE0LjY5OTdMMTUuNzM5NCAxNC42ODI3TDE2Ljc3NjIgMTIuODQ3TDE1Ljg0MTQgMTEuMzE3M0MxNS44NDE0IDExLjMzNDMgMTUuODQxNCAxMS4zNTEzIDE1LjgyNDQgMTEuMzY4M0MxNS44MjQ0IDExLjM4NTMgMTUuODI0NCAxMS4zODUzIDE1LjgyNDQgMTEuNDAyMkMxNS44MjQ0IDExLjQxOTIgMTUuODA3NCAxMS40MzYyIDE1LjgwNzQgMTEuNDcwMkMxNS44MjQ0IDExLjQ4NzIgMTUuODI0NCAxMS41MDQyIDE1LjgyNDQgMTEuNTA0MloiIGZpbGw9IiM0MUU2QUYiLz4KPHBhdGggZD0iTTI2LjQ4MTYgMTcuMDI4M0MyNi41ODM1IDE3LjE4MTMgMjYuNjUxNSAxNy4zNjgzIDI2LjcwMjUgMTcuNTg5MkMyNi43NTM1IDE3LjgxMDIgMjYuNzg3NSAxOC4wNDgxIDI2Ljc4NzUgMTguMjg2MUMyNi43ODc1IDE4Ljk2NiAyNi41NjY1IDE5LjU3NzkgMjYuMTkyNiAxOS44ODM4QzI2LjAyMjYgMjAuMDE5OCAyNS44MzU3IDIwLjA4NzggMjUuNjQ4NyAyMC4wNTM4QzI1LjYxNDcgMjAuMDUzOCAyNS41ODA3IDIwLjAzNjggMjUuNTQ2NyAyMC4wMzY4QzI1LjUyOTcgMjAuMDM2OCAyNS41MTI3IDIwLjAxOTggMjUuNDk1NyAyMC4wMTk4QzI1LjQ3ODcgMjAuMDE5OCAyNS40NjE3IDIwLjAwMjggMjUuNDQ0NyAyMC4wMDI4QzI1LjQxMDcgMTkuOTg1OCAyNS4zNzY3IDE5Ljk2ODggMjUuMzU5OCAxOS45NTE4QzI1LjAxOTggMTkuNzMwOSAyNC43NjQ4IDE5LjIzNzkgMjQuNjk2OSAxOC42NDNWMTguNjI2QzI0LjY5NjkgMTguNTc1MSAyNC42Nzk5IDE4LjUyNDEgMjQuNjc5OSAxOC40NTYxQzI0LjY3OTkgMTguNDA1MSAyNC42Nzk5IDE4LjM1NDEgMjQuNjc5OSAxOC4zMDMxQzI0LjY3OTkgMTguMjM1MSAyNC42Nzk5IDE4LjE4NDEgMjQuNjc5OSAxOC4xMTYxQzI0LjY3OTkgMTguMDY1MSAyNC42Nzk5IDE4LjAxNDIgMjQuNjk2OSAxNy45NjMyVjE3LjkyOTJDMjQuNjk2OSAxNy44OTUyIDI0LjcxMzkgMTcuODQ0MiAyNC43MTM5IDE3LjgxMDJDMjQuNzEzOSAxNy43OTMyIDI0LjcxMzkgMTcuNzc2MiAyNC43MTM5IDE3Ljc1OTJDMjQuNzEzOSAxNy43MjUyIDI0LjczMDkgMTcuNjkxMiAyNC43MzA5IDE3LjY1NzJDMjQuNzMwOSAxNy42MjMyIDI0Ljc0NzkgMTcuNjA2MiAyNC43NDc5IDE3LjU3MjJDMjQuNzY0OSAxNy41MzgyIDI0Ljc2NDkgMTcuNTA0MiAyNC43ODE4IDE3LjQ3MDJDMjQuNzgxOCAxNy40NTMyIDI0Ljc5ODggMTcuNDM2MiAyNC43OTg4IDE3LjQxOTJDMjQuODE1OCAxNy4zODUzIDI0LjgxNTggMTcuMzUxMyAyNC44MzI4IDE3LjMxNzNMMjQuODQ5OCAxNy4yNjYzQzI0Ljg2NjggMTcuMjMyMyAyNC44ODM4IDE3LjIxNTMgMjQuODgzOCAxNy4xODEzQzI0Ljg4MzggMTcuMTgxMyAyNC44ODM4IDE3LjE4MTMgMjQuODgzOCAxNy4xNjQzTDI0LjkwMDggMTcuMTMwM0MyNC45MTc4IDE3LjA3OTMgMjQuOTUxOCAxNy4wNDUzIDI0Ljk2ODggMTcuMDExM0MyNC45ODU4IDE2Ljk3NzMgMjUuMDE5OCAxNi45NDMzIDI1LjAzNjggMTYuOTA5M0wyNS4wNTM4IDE2Ljg5MjNDMjUuMDcwOCAxNi44NzUzIDI1LjA3MDggMTYuODc1MyAyNS4wODc4IDE2Ljg1ODNDMjUuMTA0OCAxNi44NDEzIDI1LjEwNDggMTYuODQxMyAyNS4xMDQ4IDE2LjgyNDNDMjUuMTIxOCAxNi44MDc0IDI1LjEzODggMTYuNzkwNCAyNS4xNTU4IDE2Ljc3MzRDMjUuMTcyOCAxNi43NTY0IDI1LjE4OTggMTYuNzM5NCAyNS4xODk4IDE2LjczOTRDMjUuMjA2OCAxNi43MjI0IDI1LjIwNjggMTYuNzIyNCAyNS4yMjM4IDE2LjcwNTRDMjUuMjQwOCAxNi42ODg0IDI1LjI1NzggMTYuNjcxNCAyNS4yNzQ4IDE2LjY1NDRMMjUuMzA4OCAxNi42Mzc0QzI1LjMyNTggMTYuNjIwNCAyNS4zNTk4IDE2LjYwMzQgMjUuMzc2NyAxNi41ODY0QzI1LjM5MzcgMTYuNTg2NCAyNS4zOTM3IDE2LjU4NjQgMjUuNDEwNyAxNi41Njk0QzI1LjQyNzcgMTYuNTY5NCAyNS40NDQ3IDE2LjU1MjQgMjUuNDQ0NyAxNi41NTI0QzI1LjQ0NDcgMTYuNTUyNCAyNS40NjE3IDE2LjU1MjQgMjUuNDYxNyAxNi41MzU0SDI1LjQ3ODdDMjUuNTEyNyAxNi41MzU0IDI1LjUyOTcgMTYuNTE4NCAyNS41NjM3IDE2LjUxODRDMjUuNTk3NyAxNi41MTg0IDI1LjYzMTcgMTYuNTE4NCAyNS42NjU3IDE2LjUxODRDMjYuMDIyNiAxNi41MDE0IDI2LjI3NzYgMTYuNzA1NCAyNi40ODE2IDE3LjAyODNaIiBmaWxsPSIjNDFFNkFGIi8+CjxwYXRoIGQ9Ik0yNC43NjQ5IDE2LjYyMDRDMjQuNzQ3OSAxNi42Mzc0IDI0LjczMDkgMTYuNjcxNCAyNC43MTM5IDE2LjY4ODRDMjQuNzEzOSAxNi43MDU0IDI0LjY5NjkgMTYuNzA1NCAyNC42OTY5IDE2LjcyMjRDMjQuNjYyOSAxNi43NTY0IDI0LjY0NTkgMTYuODA3MyAyNC42MTE5IDE2Ljg0MTNDMjQuMzkwOSAxNy4xODEzIDI0LjI3MiAxNy42MjMyIDI0LjIzOCAxOC4wODIxQzI0LjIzOCAxOC4xNTAxIDI0LjIzOCAxOC4yMDExIDI0LjIzOCAxOC4yNjkxQzI0LjIzOCAxOC4zMjAxIDI0LjIzOCAxOC4zODgxIDI0LjIzOCAxOC40MzkxVjE4LjQ1NjFDMjQuMjM4IDE4LjQ3MzEgMjQuMjM4IDE4LjUwNzEgMjQuMjM4IDE4LjUyNDFDMjQuMjM4IDE4LjU1ODEgMjQuMjM4IDE4LjU5MiAyNC4yNTUgMTguNjI2VjE4LjY0M0MyNC4yNTUgMTguNjYgMjQuMjU1IDE4LjY3NyAyNC4yNTUgMTguNjk0QzI0LjI1NSAxOC43MjggMjQuMjcyIDE4Ljc2MiAyNC4yNzIgMTguNzk2VjE4LjgzQzI0LjI3MiAxOC44MyAyNC4yNzIgMTguODMgMjQuMjcyIDE4Ljg0N0MyNC4yNzIgMTguODY0IDI0LjI3MiAxOC44ODEgMjQuMjg5IDE4Ljg5OEMyNC4yODkgMTguOTMyIDI0LjMwNiAxOC45NjYgMjQuMzA2IDE5TDI0LjMyMyAxOS4wMzRWMTkuMDUxQzI0LjMyMyAxOS4wODUgMjQuMzQgMTkuMTE5IDI0LjM1NyAxOS4xNTNDMjQuMzU3IDE5LjE3IDI0LjM3MzkgMTkuMTg2OSAyNC4zNzM5IDE5LjIwMzlWMTkuMjIwOUMyNC4zOTA5IDE5LjI1NDkgMjQuMzkwOSAxOS4yNzE5IDI0LjQwNzkgMTkuMzA1OUMyNC40MDc5IDE5LjMyMjkgMjQuNDI0OSAxOS4zMzk5IDI0LjQ0MTkgMTkuMzczOVYxOS4zOTA5QzI0LjQ0MTkgMTkuNDA3OSAyNC40NTg5IDE5LjQyNDkgMjQuNDU4OSAxOS40NDE5QzI0LjQ3NTkgMTkuNDU4OSAyNC40NzU5IDE5LjQ3NTkgMjQuNDc1OSAxOS40NzU5QzI0LjQ5MjkgMTkuNTI2OSAyNC41MjY5IDE5LjU3NzkgMjQuNTYwOSAxOS42Mjg5TDI0LjU3NzkgMTkuNjQ1OUMyNC42MTE5IDE5LjY5NjkgMjQuNjI4OSAxOS43MzA5IDI0LjY2MjkgMTkuNzY0OUMyNC42NjI5IDE5Ljc4MTggMjQuNjc5OSAxOS43ODE4IDI0LjY3OTkgMTkuNzk4OEwyNC42OTY5IDE5LjgxNThDMjQuNzEzOSAxOS44NDk4IDI0Ljc0NzkgMTkuODY2OCAyNC43NjQ5IDE5LjkwMDhDMjQuNzgxOSAxOS45MTc4IDI0Ljc4MTkgMTkuOTM0OCAyNC43OTg5IDE5LjkzNDhDMjQuODMyOSAxOS45Njg4IDI0Ljg0OTkgMTkuOTg1OCAyNC44NjY5IDIwLjAxOThDMjQuODgzOSAyMC4wMzY4IDI0LjkwMDkgMjAuMDM2OCAyNC45MDA5IDIwLjA1MzhIMjMuMTE2MkwyMi4wNzkzIDE4LjMzNzFMMjMuMDk5MiAxNi41MDE0SDI0Ljg4MzlDMjQuODY2OSAxNi41MTg0IDI0Ljg2NjkgMTYuNTE4NCAyNC44NDk5IDE2LjUzNTRMMjQuODMyOSAxNi41NTI0QzI0LjgxNTkgMTYuNTY5NCAyNC43OTg5IDE2LjU4NjQgMjQuNzY0OSAxNi42MjA0WiIgZmlsbD0iIzQxRTZBRiIvPgo8cGF0aCBkPSJNMTQuNTgzNiAyNi4zOTM4QzE0LjM5NjYgMjYuMzkzOCAxNC4xOTI2IDI2LjM1OTggMTMuOTg4NyAyNi4yOTE4QzEzLjc2NzcgMjYuMjIzOCAxMy41NDY3IDI2LjEyMTggMTMuMzQyOCAyNi4wMDI4QzEyLjc2NDkgMjUuNjQ1OSAxMi4zNTY5IDI1LjEzNiAxMi4yODkgMjQuNjYwMUMxMi4yNTUgMjQuNDM5MSAxMi4zMDYgMjQuMjUyMSAxMi40MjQ5IDI0LjExNjFDMTIuNDQxOSAyNC4wODIyIDEyLjQ3NTkgMjQuMDY1MiAxMi40OTI5IDI0LjAzMTJDMTIuNTA5OSAyNC4wMTQyIDEyLjUyNjkgMjQuMDE0MiAxMi41NDM5IDIzLjk5NzJDMTIuNTYwOSAyMy45ODAyIDEyLjU2MDkgMjMuOTgwMiAxMi41Nzc5IDIzLjk2MzJDMTIuNjExOSAyMy45NDYyIDEyLjYyODkgMjMuOTI5MiAxMi42NjI5IDIzLjkxMjJDMTMuMDE5OCAyMy43NDIyIDEzLjU4MDcgMjMuNzc2MiAxNC4xMjQ2IDI0LjAzMTJMMTQuMTQxNiAyNC4wNDgyQzE0LjE5MjYgMjQuMDY1MiAxNC4yNDM2IDI0LjA5OTEgMTQuMjk0NiAyNC4xMTYxQzE0LjM0NTYgMjQuMTMzMSAxNC4zNzk2IDI0LjE2NzEgMTQuNDMwNiAyNC4yMDExQzE0LjQ4MTYgMjQuMjM1MSAxNC41MzI2IDI0LjI2OTEgMTQuNTgzNiAyNC4zMDMxQzE0LjYzNDYgMjQuMzM3MSAxNC42Njg2IDI0LjM3MTEgMTQuNzE5NiAyNC40MDUxTDE0Ljc1MzUgMjQuNDIyMUMxNC43ODc1IDI0LjQ1NjEgMTQuODIxNSAyNC40NzMxIDE0Ljg1NTUgMjQuNTA3MUMxNC44NzI1IDI0LjUyNDEgMTQuODcyNSAyNC41MjQxIDE0Ljg4OTUgMjQuNTQxMUMxNC45MjM1IDI0LjU1ODEgMTQuOTQwNSAyNC41OTIxIDE0Ljk1NzUgMjQuNjA5MUMxNC45NzQ1IDI0LjYyNjEgMTQuOTkxNSAyNC42NDMxIDE1LjAwODUgMjQuNjc3MUMxNS4wMjU1IDI0LjcxMSAxNS4wNTk1IDI0LjcyOCAxNS4wNzY1IDI0Ljc2MkMxNS4wOTM1IDI0Ljc3OSAxNS4wOTM1IDI0Ljc3OSAxNS4xMTA1IDI0Ljc5NkMxNS4xMjc1IDI0LjgzIDE1LjE2MTUgMjQuODQ3IDE1LjE3ODUgMjQuODgxTDE1LjIxMjUgMjQuOTE1QzE1LjIyOTUgMjQuOTQ5IDE1LjI0NjUgMjQuOTY2IDE1LjI2MzUgMjVWMjUuMDE3TDE1LjI4MDUgMjUuMDUxQzE1LjMxNDUgMjUuMDg1IDE1LjMzMTQgMjUuMTM2IDE1LjM0ODQgMjUuMTdDMTUuMzY1NCAyNS4yMDQgMTUuMzgyNCAyNS4yNTUgMTUuMzk5NCAyNS4yODg5TDE1LjQxNjQgMjUuMzA1OUMxNS40MTY0IDI1LjMyMjkgMTUuNDMzNCAyNS4zMzk5IDE1LjQzMzQgMjUuMzM5OUMxNS40MzM0IDI1LjM1NjkgMTUuNDMzNCAyNS4zNTY5IDE1LjQ1MDQgMjUuMzczOUMxNS40NTA0IDI1LjQwNzkgMTUuNDY3NCAyNS40MjQ5IDE1LjQ2NzQgMjUuNDU4OUMxNS40Njc0IDI1LjQ5MjkgMTUuNDg0NCAyNS40OTI5IDE1LjQ4NDQgMjUuNTA5OUMxNS40ODQ0IDI1LjUyNjkgMTUuNDg0NCAyNS41NDM5IDE1LjQ4NDQgMjUuNTQzOUMxNS40ODQ0IDI1LjU3NzkgMTUuNDg0NCAyNS41OTQ5IDE1LjQ4NDQgMjUuNjExOVYyNS42NDU5QzE1LjQ4NDQgMjUuNjc5OSAxNS40ODQ0IDI1LjY5NjkgMTUuNDg0NCAyNS43MzA5QzE1LjQ4NDQgMjUuNzQ3OSAxNS40ODQ0IDI1Ljc0NzkgMTUuNDg0NCAyNS43NjQ5QzE1LjQ4NDQgMjUuNzgxOSAxNS40ODQ0IDI1Ljc5ODkgMTUuNDg0NCAyNS43OTg5QzE1LjQ4NDQgMjUuODE1OSAxNS40ODQ0IDI1LjgxNTkgMTUuNDg0NCAyNS44MzI5VjI1Ljg0OTlDMTUuNDg0NCAyNS44ODM5IDE1LjQ2NzQgMjUuOTAwOCAxNS40NTA0IDI1LjkzNDhDMTUuNDMzNCAyNS45Njg4IDE1LjQxNjQgMjUuOTg1OCAxNS4zOTk0IDI2LjAxOThDMTUuMjgwNSAyNi4yNzQ4IDE0Ljk1NzUgMjYuNDEwOCAxNC41ODM2IDI2LjM5MzhaIiBmaWxsPSIjNDFFNkFGIi8+CjxwYXRoIGQ9Ik0xNS44MjQ0IDI1LjE1M0MxNS44MjQ0IDI1LjExOSAxNS44MDc0IDI1LjEwMiAxNS43OTA0IDI1LjA2OEMxNS43OTA0IDI1LjA1MSAxNS43OTA0IDI1LjA1MSAxNS43NzM0IDI1LjAzNEMxNS43NTY0IDI0Ljk4MyAxNS43Mzk0IDI0Ljk0OSAxNS43MDU0IDI0Ljg5OEMxNS41MTg0IDI0LjU0MTEgMTUuMjEyNSAyNC4yMDExIDE0LjgzODUgMjMuOTI5MkMxNC43ODc1IDIzLjg5NTIgMTQuNzM2NSAyMy44NjEyIDE0LjY4NTUgMjMuODI3MkMxNC42MzQ2IDIzLjc5MzIgMTQuNTgzNiAyMy43NTkyIDE0LjUzMjYgMjMuNzQyMkgxNC41MTU2QzE0LjQ5ODYgMjMuNzI1MiAxNC40ODE2IDIzLjcyNTIgMTQuNDY0NiAyMy43MDgyQzE0LjQzMDYgMjMuNjkxMiAxNC40MTM2IDIzLjY3NDIgMTQuMzc5NiAyMy42NTcySDE0LjM2MjZDMTQuMzQ1NiAyMy42NTcyIDE0LjMyODYgMjMuNjQwMiAxNC4zMTE2IDIzLjY0MDJDMTQuMjc3NiAyMy42MjMyIDE0LjI0MzYgMjMuNjA2MiAxNC4yMDk2IDIzLjYwNjJMMTQuMTc1NiAyMy41ODkyQzE0LjE3NTYgMjMuNTg5MiAxNC4xNzU2IDIzLjU4OTIgMTQuMTU4NiAyMy41ODkyQzE0LjE0MTYgMjMuNTg5MiAxNC4xMjQ2IDIzLjU3MjIgMTQuMTA3NiAyMy41NzIyQzE0LjA3MzcgMjMuNTU1MiAxNC4wMzk3IDIzLjU1NTIgMTQuMDA1NyAyMy41MzgyTDEzLjk3MTcgMjMuNTIxMkgxMy45NTQ3QzEzLjkyMDcgMjMuNTA0MiAxMy44ODY3IDIzLjUwNDIgMTMuODUyNyAyMy40ODcyQzEzLjgzNTcgMjMuNDg3MiAxMy44MTg3IDIzLjQ3MDIgMTMuNzg0NyAyMy40NzAySDEzLjc2NzdDMTMuNzMzNyAyMy40NzAyIDEzLjY5OTcgMjMuNDUzMyAxMy42ODI3IDIzLjQ1MzNDMTMuNjY1NyAyMy40NTMzIDEzLjYzMTcgMjMuNDUzMyAxMy42MTQ3IDIzLjQzNjNIMTMuNTk3N0MxMy41ODA3IDIzLjQzNjMgMTMuNTYzNyAyMy40MzYzIDEzLjU0NjcgMjMuNDE5M0MxMy41Mjk3IDIzLjQxOTMgMTMuNTEyNyAyMy40MTkzIDEzLjQ5NTcgMjMuNDE5M0MxMy40NDQ4IDIzLjQxOTMgMTMuMzc2OCAyMy40MDIzIDEzLjMyNTggMjMuNDAyM0gxMy4zMDg4QzEzLjI1NzggMjMuNDAyMyAxMy4yMDY4IDIzLjQwMjMgMTMuMTU1OCAyMy40MDIzQzEzLjEzODggMjMuNDAyMyAxMy4xMjE4IDIzLjQwMjMgMTMuMTIxOCAyMy40MDIzSDEzLjEwNDhDMTMuMDcwOCAyMy40MDIzIDEzLjAzNjggMjMuNDAyMyAxMy4wMDI4IDIzLjQxOTNDMTIuOTg1OCAyMy40MTkzIDEyLjk2ODggMjMuNDE5MyAxMi45NTE4IDIzLjQzNjNDMTIuOTE3OCAyMy40MzYzIDEyLjg4MzkgMjMuNDUzMyAxMi44NDk5IDIzLjQ1MzNDMTIuODMyOSAyMy40NTMzIDEyLjgxNTkgMjMuNDcwMiAxMi43OTg5IDIzLjQ3MDJMMTMuNzMzNyAyMS45NTc1TDE1LjczOTQgMjEuOTc0NUwxNi43NzYyIDIzLjgxMDJMMTUuODQxNCAyNS4zMzk5QzE1Ljg0MTQgMjUuMzIyOSAxNS44NDE0IDI1LjMwNTkgMTUuODI0NCAyNS4yODg5QzE1LjgyNDQgMjUuMjcxOSAxNS44MjQ0IDI1LjI3MTkgMTUuODI0NCAyNS4yNTVDMTUuODI0NCAyNS4yMzggMTUuODA3NCAyNS4yMjEgMTUuODA3NCAyNS4xODdDMTUuODI0NCAyNS4xNyAxNS44MjQ0IDI1LjE1MyAxNS44MjQ0IDI1LjE1M1oiIGZpbGw9IiM0MUU2QUYiLz4KPHBhdGggZD0iTTE5LjM3NjggMjcuMjk0NkwxNC40ODE2IDI3LjI3NzZMMTMuNzMzNyAyOC42ODg0TDEzLjIyMzggMjkuNjU3MkwxNC41MzI2IDI5LjY0MDJWMjkuNjU3MkwyMi4wMTEzIDI5LjY3NDJMMjIuNzU5MiAyOC4zODI0TDE3LjM3MTEgMTkuMTUzTDYuNjc5ODkgMTkuMTM2TDYgMjAuMzI1OEw2LjEzNTk4IDIwLjU0NjdINi4xMTg5OEwxMC4zNjgzIDI4LjAyNTVMMTEuNzc5IDI1LjczMDlMOS4yOTc0NSAyMS41MTU2SDE2LjAxMTNMMTkuMzc2OCAyNy4yOTQ2WiIgZmlsbD0iIzQxRTZBRiIvPgo8L3N2Zz4K", Eze = "data:image/svg+xml;base64,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", Sze = "data:image/svg+xml;base64,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", xze = "data:image/svg+xml;base64,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", Wze = "data:image/svg+xml;base64,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", jze = "data:image/svg+xml;base64,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", Dze = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTgiIGN5PSIxOCIgcj0iMTgiIGZpbGw9IiMwMDAwRDgiLz4KPHBhdGggZD0iTTcuNzc4OTMgOS45NDk3MVYyNi4wNTAySDE0LjI4MTVWMTguODUxNEw5LjY4MzQ2IDE0LjQwMDVMMTQuMjgxNSA5Ljk0OTcxSDcuNzc4OTNaTTE0LjI4MTUgOS45NDk3MVYxOC44NTE0TDIxLjcxODUgMjYuMDUwMlYxNy4xNDg2TDE0LjI4MTUgOS45NDk3MVpNMjEuNzE4NiA5Ljk0OTcxVjE3LjE0ODZMMjYuMzE2NyAyMS41OTk0TDIxLjcxODYgMjYuMDUwMkgyOC4yMjExVjkuOTQ5NzFIMjEuNzE4NloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=", zze = "data:image/svg+xml;base64,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", kze = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzQ2NjBfMTQ4MzIpIj4KPHBhdGggZD0iTTE4IDM2QzI3Ljk0MTEgMzYgMzYgMjcuOTQxMSAzNiAxOEMzNiA4LjA1ODg4IDI3Ljk0MTEgMCAxOCAwQzguMDU4ODggMCAwIDguMDU4ODggMCAxOEMwIDI3Ljk0MTEgOC4wNTg4OCAzNiAxOCAzNloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjguNDQgMTcuOTEwMUwyMi40MzcgMTEuOTM0MVYxNi4zMDgxTDE2LjQ3OSAyMC42OTExSDIyLjQzN1YyMy44ODYxTDI4LjQ0IDE3LjkxMDFaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTcuMjkwMDQgMTcuOTFMMTMuMjkzIDIzLjg4NlYxOS41MzlMMTkuMjUxIDE1LjEySDEzLjI5M1YxMS45MjVMNy4yOTAwNCAxNy45MVoiIGZpbGw9IndoaXRlIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfNDY2MF8xNDgzMiI+CjxyZWN0IHdpZHRoPSIzNiIgaGVpZ2h0PSIzNiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K", wze = "data:image/svg+xml;base64,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", Fze = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTgiIGN5PSIxOCIgcj0iMTgiIGZpbGw9IiMxMjEyMTIiLz4KPHBhdGggZD0iTTIzLjI4OCAyNi4zNTY3SDEwVjEyLjM1NTVIMTMuMDQwM1YyMy42NDMySDIzLjI4OFYyNi4zNTY3WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTIzLjI4OCAxNS4wNjc1QzI0Ljc4NTggMTUuMDY3NSAyNiAxMy44NTMzIDI2IDEyLjM1NTVDMjYgMTAuODU3OCAyNC43ODU4IDkuNjQzNTUgMjMuMjg4IDkuNjQzNTVDMjEuNzkwMiA5LjY0MzU1IDIwLjU3NiAxMC44NTc4IDIwLjU3NiAxMi4zNTU1QzIwLjU3NiAxMy44NTMzIDIxLjc5MDIgMTUuMDY3NSAyMy4yODggMTUuMDY3NVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=", vze = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4IDM2QzI3Ljk0MTEgMzYgMzYgMjcuOTQxMSAzNiAxOEMzNiA4LjA1ODg3IDI3Ljk0MTEgMCAxOCAwQzguMDU4ODcgMCAwIDguMDU4ODcgMCAxOEMwIDI3Ljk0MTEgOC4wNTg4NyAzNiAxOCAzNloiIGZpbGw9IiMwMDUyRkYiLz4KPHBhdGggZD0iTTE4LjA3OTYgMzAuNTA4NUMyNS4wNTYyIDMwLjUwODUgMzAuNzExNyAyNC44NjI2IDMwLjcxMTcgMTcuODk4MkMzMC43MTE3IDEwLjkzMzggMjUuMDU2MiA1LjI4ODA5IDE4LjA3OTYgNS4yODgwOUMxMS40NjA3IDUuMjg4MDkgNi4wMzA3NCAxMC4zNjk5IDUuNDkxNDYgMTYuODM4M0gyMi4xODgzVjE4Ljk1ODJINS40OTE0NkM2LjAzMDc0IDI1LjQyNjYgMTEuNDYwNyAzMC41MDg1IDE4LjA3OTYgMzAuNTA4NVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=", Ize = "data:image/svg+xml;base64,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", Oze = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTgiIGN5PSIxOCIgcj0iMTgiIGZpbGw9IiNGRkVFREEiLz4KPHBhdGggZD0iTTI2Ljk4NTkgMjIuNTIxNlY5LjU2Mjc0QzI2Ljk2MTggOC40Nzc4MSAyNi4xMDU5IDcuNjA5ODYgMjUuMDIxIDcuNjA5ODZIMTEuNDk1NUM4LjU3ODIyIDcuNjU4MDggNi4yMjc1NCAxMC4wNDQ5IDYuMjI3NTQgMTIuOTc0MkM2LjIyNzU0IDEzLjk2MjcgNi40OTI3NCAxNC44MDY2IDYuOTAyNjEgMTUuNTU0QzcuMjQwMTQgMTYuMTY4OCA3Ljc4MjYxIDE2Ljc0NzQgOC4zMTMwMiAxNy4xOTM0QzguNDU3NjggMTcuMzE0IDguMzg1MzUgMTcuMjY1OCA4Ljg0MzQzIDE3LjU1NTFDOS40ODIzMyAxNy45NDA4IDEwLjIwNTYgMTguMTMzNyAxMC4yMDU2IDE4LjEzMzdWMjUuODg0OUMxMC4yMTc3IDI2LjI0NjYgMTAuMjY1OSAyNi42MDgyIDEwLjM1MDMgMjYuOTMzN0MxMC42NTE2IDI4LjAxODYgMTEuNDExMSAyOC44NjI1IDEyLjQzNTggMjkuMjcyM0MxMi44Njk3IDI5LjQ0MTEgMTMuMzUxOSAyOS41NjE2IDEzLjg3MDMgMjkuNTYxNkwyNC42NzE0IDI5LjU5NzhDMjYuODI5MiAyOS41OTc4IDI4LjU3NzEgMjcuODQ5OSAyOC41NzcxIDI1LjY5MjFDMjguNTc3MSAyNC4zNzgxIDI3Ljk1MDMgMjMuMjMyOSAyNi45ODU5IDIyLjUyMTZaIiBmaWxsPSIjRkZFRURBIi8+CjxwYXRoIGQ9Ik0yNy4yMzkxIDI1Ljc1MjJDMjcuMTkwOSAyNy4xMzg1IDI2LjA1NzggMjguMjQ3NSAyNC42NzE0IDI4LjI0NzVMMTcuMjMzNiAyOC4yMjM0QzE3LjgyNDMgMjcuNTM2MyAxOC4xODYgMjYuNjQ0MiAxOC4xODYgMjUuNjc5OEMxOC4xODYgMjQuMTQ4OSAxNy4yNjk4IDIzLjEwMDEgMTcuMjY5OCAyMy4xMDAxSDI0LjY3MTRDMjYuMDkzOSAyMy4xMDAxIDI3LjIzOTEgMjQuMjU3NCAyNy4yMzkxIDI1LjY3OThWMjUuNzUyMloiIGZpbGw9IiNFQkMyOEUiLz4KPHBhdGggZD0iTTkuMDAwMjMgMTYuMDcyMkM4LjE0NDM0IDE1LjI2NDUgNy41NDE2IDE0LjIxNTcgNy41NDE2IDEyLjk2MlYxMi44Mjk0QzcuNjEzOTMgMTAuNzA3OCA5LjM2MTg4IDguOTk2MDEgMTEuNDgzNSA4LjkyMzY4SDI1LjAwOUMyNS4zNTg2IDguOTM1NzQgMjUuNjQ3OSA5LjE4ODg5IDI1LjY0NzkgOS41NTA1M1YyMC45OTA1QzI1Ljk2MTMgMjEuMDUwOCAyNi4xMDYgMjEuMDg3IDI2LjQwNzQgMjEuMTk1NUMyNi42MzY0IDIxLjI3OTggMjYuOTczOSAyMS40NzI3IDI2Ljk3MzkgMjEuNDcyN1Y5LjU1MDUzQzI2Ljk0OTggOC40NjU2IDI2LjA5MzkgNy41OTc2NiAyNS4wMDkgNy41OTc2NkgxMS40ODM1QzguNTY2MjYgNy42NDU4OCA2LjIxNTU4IDEwLjAzMjcgNi4yMTU1OCAxMi45NjJDNi4yMTU1OCAxNC42NjE4IDYuOTg3MDggMTYuMTIwNCA4LjI2NDg5IDE3LjE0NTFDOC4zNDkyOCAxNy4yMTc0IDguNDMzNjYgMTcuMzAxOCA4LjY2MjcgMTcuMzAxOEM5LjA2MDUxIDE3LjMwMTggOS4zMzc3NyAxNi45ODgzIDkuMzI1NzEgMTYuNjM4OEM5LjMxMzY2IDE2LjM0OTQgOS4xOTMxMSAxNi4yNDA5IDkuMDAwMjMgMTYuMDcyMloiIGZpbGw9IiMxOTA2MDIiLz4KPHBhdGggZD0iTTI0LjY3MTUgMjEuNzYyMkgxNC4wNjMzQzEzLjM1MjEgMjEuNzYyMiAxMi43NzM0IDIyLjM1MjkgMTIuNzczNCAyMy4wNjQxVjI0LjU4M0MxMi43OTc2IDI1LjI4MjIgMTMuNDAwMyAyNS44OTcgMTQuMDk5NSAyNS44OTdIMTQuODgzVjI0LjU4M0gxNC4wOTk1VjIzLjA4ODNDMTQuMDk5NSAyMy4wODgzIDE0LjI5MjMgMjMuMDg4MyAxNC41MzM0IDIzLjA4ODNDMTUuODcxNSAyMy4wODgzIDE2Ljg2IDI0LjMyOTkgMTYuODYgMjUuNjY4QzE2Ljg2IDI2Ljg0OTMgMTUuNzg3MSAyOC4zNTYyIDEzLjk5MSAyOC4yMzU2QzEyLjM4NzcgMjguMTI3MiAxMS41MzE4IDI2LjcwNDcgMTEuNTMxOCAyNS42NjhWMTIuNzMzMkMxMS41MzE4IDEyLjE1NDYgMTEuMDYxNyAxMS42NzI0IDEwLjQ3MSAxMS42NzI0SDkuNDEwMTZWMTIuOTk4NEgxMC4xOTM3VjI1LjY2OEMxMC4xNTc2IDI4LjI0NzcgMTIuMDI2IDI5LjU0OTYgMTMuOTc4OSAyOS41NDk2TDI0LjY3MTUgMjkuNTg1OEMyNi44MjkzIDI5LjU4NTggMjguNTc3MyAyNy44Mzc4IDI4LjU3NzMgMjUuNjhDMjguNTc3MyAyMy41MjIyIDI2LjgyOTMgMjEuNzYyMiAyNC42NzE1IDIxLjc2MjJaTTI3LjIzOTIgMjUuNzUyNEMyNy4xOTEgMjcuMTM4NyAyNi4wNTc4IDI4LjI0NzcgMjQuNjcxNSAyOC4yNDc3TDE3LjIzMzcgMjguMjIzNkMxNy44MjQ0IDI3LjUzNjUgMTguMTg2IDI2LjY0NDQgMTguMTg2IDI1LjY4QzE4LjE4NiAyNC4xNDkxIDE3LjI2OTkgMjMuMTAwMyAxNy4yNjk5IDIzLjEwMDNIMjQuNjcxNUMyNi4wOTQgMjMuMTAwMyAyNy4yMzkyIDI0LjI1NzYgMjcuMjM5MiAyNS42OFYyNS43NTI0WiIgZmlsbD0iIzE5MDYwMiIvPgo8cGF0aCBkPSJNMjEuODk5IDEzLjIyNzNIMTMuODIyM1YxMS45MTMzSDIxLjg5OUMyMi4yMjQ1IDExLjkxMzMgMjIuNDc3NiAxMi4xNzg1IDIyLjQ3NzYgMTIuNDkyVjEyLjY0ODdDMjIuNDc3NiAxMi45NzQyIDIyLjIxMjQgMTMuMjI3MyAyMS44OTkgMTMuMjI3M1oiIGZpbGw9IiMxOTA2MDIiLz4KPHBhdGggZD0iTTIxLjg5OSAxOS40NTk1SDEzLjgyMjNWMTguMTQ1NUgyMS44OTlDMjIuMjI0NSAxOC4xNDU1IDIyLjQ3NzYgMTguNDEwNyAyMi40Nzc2IDE4LjcyNDFWMTguODgwOUMyMi40Nzc2IDE5LjE5NDMgMjIuMjEyNCAxOS40NTk1IDIxLjg5OSAxOS40NTk1WiIgZmlsbD0iIzE5MDYwMiIvPgo8cGF0aCBkPSJNMjMuMjk3MiAxNi4zNDk0SDEzLjgxMDFWMTUuMDM1NEgyMy4yOTcyQzIzLjYyMjcgMTUuMDM1NCAyMy44NzU4IDE1LjMwMDYgMjMuODc1OCAxNS42MTRWMTUuNzcwN0MyMy44ODc5IDE2LjA4NDIgMjMuNjIyNyAxNi4zNDk0IDIzLjI5NzIgMTYuMzQ5NFoiIGZpbGw9IiMxOTA2MDIiLz4KPC9zdmc+Cg==", Yze = "data:image/svg+xml;base64,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", Qze = "data:image/svg+xml;base64,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", Gze = "data:image/svg+xml;base64,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", Cze = "data:image/svg+xml;base64,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", Lze = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjE4ODggMTcuNjg5MkMxOS43MTIgMTEuNDM2OSAzMC4yODgxIDExLjQzNjkgMzYuODExMiAxNy42ODkyTDM3LjU5NjMgMTguNDQxNkMzNy45MjI0IDE4Ljc1NDMgMzcuOTIyNCAxOS4yNjExIDM3LjU5NjMgMTkuNTczN0wzNC45MTA3IDIyLjE0NzhDMzQuNzQ3NiAyMi4zMDQxIDM0LjQ4MzIgMjIuMzA0MSAzNC4zMjAyIDIyLjE0NzhMMzMuMjM5OCAyMS4xMTIzQzI4LjY4OTEgMTYuNzUwNiAyMS4zMTA5IDE2Ljc1MDYgMTYuNzYwMiAyMS4xMTIzTDE1LjYwMzMgMjIuMjIxMkMxNS40NDAyIDIyLjM3NzUgMTUuMTc1OCAyMi4zNzc1IDE1LjAxMjcgMjIuMjIxMkwxMi4zMjcxIDE5LjY0NzJDMTIuMDAxIDE5LjMzNDUgMTIuMDAxIDE4LjgyNzcgMTIuMzI3MSAxOC41MTUxTDEzLjE4ODggMTcuNjg5MlpNNDIuMzY1MiAyMy4wMTI2TDQ0Ljc1NTQgMjUuMzAzNUM0NS4wODE1IDI1LjYxNjEgNDUuMDgxNSAyNi4xMjI5IDQ0Ljc1NTQgMjYuNDM1NUwzMy45NzggMzYuNzY1NUMzMy42NTE4IDM3LjA3ODEgMzMuMTIzIDM3LjA3ODIgMzIuNzk2OSAzNi43NjU1QzMyLjc5NjkgMzYuNzY1NSAzMi43OTY5IDM2Ljc2NTUgMzIuNzk2OSAzNi43NjU1TDI1LjE0NzcgMjkuNDM0QzI1LjA2NjIgMjkuMzU1OSAyNC45MzQgMjkuMzU1OSAyNC44NTI0IDI5LjQzNEMyNC44NTI0IDI5LjQzNCAyNC44NTI0IDI5LjQzNCAyNC44NTI0IDI5LjQzNEwxNy4yMDM0IDM2Ljc2NTVDMTYuODc3MyAzNy4wNzgxIDE2LjM0ODUgMzcuMDc4MiAxNi4wMjIzIDM2Ljc2NTVDMTYuMDIyMyAzNi43NjU1IDE2LjAyMjMgMzYuNzY1NSAxNi4wMjIzIDM2Ljc2NTVMNS4yNDQ2MiAyNi40MzU0QzQuOTE4NDYgMjYuMTIyOCA0LjkxODQ2IDI1LjYxNiA1LjI0NDYyIDI1LjMwMzNMNy42MzQ3OCAyMy4wMTI0QzcuOTYwOTQgMjIuNjk5OCA4LjQ4OTc1IDIyLjY5OTggOC44MTU5IDIzLjAxMjRMMTYuNDY1MiAzMC4zNDRDMTYuNTQ2NyAzMC40MjIyIDE2LjY3ODkgMzAuNDIyMiAxNi43NjA0IDMwLjM0NEMxNi43NjA0IDMwLjM0NCAxNi43NjA0IDMwLjM0NCAxNi43NjA0IDMwLjM0NEwyNC40MDkzIDIzLjAxMjRDMjQuNzM1NSAyMi42OTk4IDI1LjI2NDMgMjIuNjk5OCAyNS41OTA0IDIzLjAxMjRDMjUuNTkwNCAyMy4wMTI0IDI1LjU5MDQgMjMuMDEyNCAyNS41OTA0IDIzLjAxMjRMMzMuMjM5NyAzMC4zNDRDMzMuMzIxMiAzMC40MjIyIDMzLjQ1MzQgMzAuNDIyMiAzMy41MzUgMzAuMzQ0TDQxLjE4NDEgMjMuMDEyNkM0MS41MTAzIDIyLjcgNDIuMDM5MSAyMi43IDQyLjM2NTIgMjMuMDEyNloiIGZpbGw9IiMzQjk5RkMiLz4KPC9zdmc+Cg==", Jze = "data:image/svg+xml;base64,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", Bze = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI1LjAzMDYgNDVDMzYuMDYyMiA0NC45ODM1IDQ1IDM2LjAzNTUgNDUgMjVDNDUgMTMuOTU0MyAzNi4wNDU3IDUgMjUgNUMxMy45NTQzIDUgNSAxMy45NTQzIDUgMjVDNSAzNi4wMzU1IDEzLjkzNzggNDQuOTgzNSAyNC45Njk0IDQ1SDI1LjAzMDZaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfMTU0XzQzOCkiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS4xNzMxIDI1LjAwNzZDMTEuMTczMSAzMi42NzI3IDE3LjM4NjkgMzguODg2NSAyNS4wNTIgMzguODg2NUMzMi43MTcyIDM4Ljg4NjUgMzguOTMxIDMyLjY3MjcgMzguOTMxIDI1LjAwNzZDMzguOTMxIDE3LjM0MjUgMzIuNzE3MiAxMS4xMjg3IDI1LjA1MiAxMS4xMjg3QzE3LjM4NjkgMTEuMTI4NyAxMS4xNzMxIDE3LjM0MjUgMTEuMTczMSAyNS4wMDc2Wk0yMS41MDUyIDIwLjUzNTVDMjAuOTk0MSAyMC41MzU1IDIwLjU3OTkgMjAuOTQ5NyAyMC41Nzk5IDIxLjQ2MDdWMjguNTU0NEMyMC41Nzk5IDI5LjA2NTQgMjAuOTk0MSAyOS40Nzk3IDIxLjUwNTIgMjkuNDc5N0gyOC41OTg4QzI5LjEwOTkgMjkuNDc5NyAyOS41MjQxIDI5LjA2NTQgMjkuNTI0MSAyOC41NTQ0VjIxLjQ2MDdDMjkuNTI0MSAyMC45NDk3IDI5LjEwOTkgMjAuNTM1NSAyOC41OTg4IDIwLjUzNTVIMjEuNTA1MloiIGZpbGw9IndoaXRlIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMTU0XzQzOCIgeDE9IjI1IiB5MT0iNSIgeDI9IjI1IiB5Mj0iNDUiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzJFNjZGOCIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMxMjRBREIiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K", Aze = "data:image/svg+xml;base64,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", Hze = "data:image/svg+xml;base64,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", Xze = "data:image/svg+xml;base64,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", _ze = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQ1Ljg5MDkgMTAuOTkzNUM0Ny4yNzU4IDI5LjMyODcgMzUuMjE2OSAzNy45OTQ4IDI0LjQwNjMgMzguOTE4OEMxNC4zNTU3IDM5Ljc3NzkgNC44OTUxMSAzMy43NDIxIDQuMDY1MjIgMjQuNDY4NUMzLjM4MDYyIDE2LjgwNyA4LjIyNTU4IDEzLjU0NTEgMTIuMDMyMiAxMy4yMkMxNS45NDc0IDEyLjg4NDYgMTkuMjM3NCAxNS41MjM1IDE5LjUyMjkgMTguNzE4NUMxOS43OTc4IDIxLjc5MDIgMTcuODM2NiAyMy4xODg0IDE2LjQ3MjcgMjMuMzA0OEMxNS4zOTQxIDIzLjM5NzIgMTQuMDM3MSAyMi43NTcxIDEzLjkxNDUgMjEuMzgzMUMxMy44MDk1IDIwLjIwMjIgMTQuMjY4MiAyMC4wNDEzIDE0LjE1NjEgMTguNzg2OUMxMy45NTY1IDE2LjU1MzYgMTEuOTYzOCAxNi4yOTM2IDEwLjg3MyAxNi4zODZDOS41NTI3OCAxNi40OTg5IDcuMTU3NDcgMTguMDA0OCA3LjQ5MzYgMjEuNzU2MUM3LjgzMTU3IDI1LjUzOTggMTEuNTQzNyAyOC41Mjk0IDE2LjQwOTcgMjguMTEzNkMyMS42NjA4IDI3LjY2NTIgMjUuMzE2OCAyMy42NjkzIDI1LjU5MTggMTguMDY0OEMyNS41ODkzIDE3Ljc2NzkgMjUuNjUzMiAxNy40NzQxIDI1Ljc3OTEgMTcuMjAzOUwyNS43ODA5IDE3LjE5NzJDMjUuODM3NSAxNy4wNzk3IDI1LjkwMzYgMTYuOTY3IDI1Ljk3ODcgMTYuODZDMjYuMDkwOCAxNi42OTU3IDI2LjIzNDQgMTYuNTE0NCAyNi40MiAxNi4zMTU4QzI2LjQyMTcgMTYuMzEwNyAyNi40MjE3IDE2LjMxMDcgMjYuNDI1MiAxNi4zMTA3QzI2LjU2IDE2LjE2MTcgMjYuNzIyOSAxNi4wMDA5IDI2LjkwNjggMTUuODI4MUMyOS4yMDA1IDEzLjcxMjggMzcuNDYxNiA4LjcyNDQzIDQ1LjI3NDYgMTAuMzAzOUM0NS40Mzk3IDEwLjMzODUgNDUuNTg4OSAxMC40MjQ0IDQ1LjY5OTkgMTAuNTQ4N0M0NS44MTEgMTAuNjczIDQ1Ljg3OCAxMC44MjkgNDUuODkwOSAxMC45OTM1WiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzE0Ml80ODUpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMTQyXzQ4NSIgeDE9IjQ0LjgyNTciIHkxPSIxMC44MTA4IiB4Mj0iMTguNDY1MyIgeTI9IjQ4Ljk4NzkiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzExQzREMSIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMwMDYyQUQiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K", Pze = "data:image/svg+xml;base64,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", Kze = "data:image/svg+xml;base64,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", $ze = "data:image/svg+xml;base64,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", qze = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4IDBDMjcuOTM4OCAwIDM2IDguMDYxMjQgMzYgMThWMTguMjk4NkMzNS44MzkyIDI4LjA5OTUgMjcuODQxMSAzNiAxOCAzNkgxNy44Nzk0QzEzLjkyOTIgMzUuOTc3IDEwLjI4MzMgMzQuNjczNyA3LjMyNjMyIDMyLjQ5NzZMMzAuOTcwMyA5LjE2OTM4SDIzLjczNTlMMTguMjIzOSAxNC40OTE5TDE1Ljc4OTUgMTIuMDYzMkg2LjEyMDU3TDEzLjM0MzUgMTkuMzAzNEwzLjY2MzE2IDI4Ljg4MDRMMy41OTQyNiAyOC43ODg1QzEuMzM3OCAyNS43Nzk5IDAgMjIuMDQ3OCAwIDE4VjE3LjcwMTRDMC4xNjA3NjYgNy45MDA0OCA4LjE1ODg1IDAgMTggMFpNMjMuMjQ3OCAxOS40NDY5TDE4LjM4NDcgMjQuMTY2NUwyMC44MDE5IDI2LjU2NjVIMzAuNDc2NkwyMy4yNDc4IDE5LjQ0NjlaIiBmaWxsPSJ1cmwoI3BhaW50MF9yYWRpYWxfNTkxM18xNjYwMykiLz4KPGRlZnM+CjxyYWRpYWxHcmFkaWVudCBpZD0icGFpbnQwX3JhZGlhbF81OTEzXzE2NjAzIiBjeD0iMCIgY3k9IjAiIHI9IjEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiBncmFkaWVudFRyYW5zZm9ybT0idHJhbnNsYXRlKDMzLjE0NTYgMS45NTAyMikgc2NhbGUoNDcuNTE4OSkiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMTVEOUUxIi8+CjxzdG9wIG9mZnNldD0iMC42MyIgc3RvcC1jb2xvcj0iIzBENThFRiIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMxMDBFNzUiLz4KPC9yYWRpYWxHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K", Hk = "data:image/svg+xml;base64,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", e5e = "data:image/svg+xml;base64,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", t5e = "data:image/svg+xml;base64,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", n5e = "data:image/svg+xml;base64,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", r5e = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUwIiBoZWlnaHQ9IjE1MCIgdmlld0JveD0iMCAwIDE1MCAxNTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgb3BhY2l0eT0iMC41IiBjeD0iNTciIGN5PSI3MCIgcj0iNDQiIGZpbGw9IndoaXRlIi8+CjxnIG9wYWNpdHk9IjAuNSI+CjxjaXJjbGUgY3g9IjU3IiBjeT0iNzAiIHI9IjQ0IiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfNjIwXzMxNzM0KSIvPgo8Y2lyY2xlIGN4PSI1NyIgY3k9IjcwIiByPSI0NCIgZmlsbD0idXJsKCNwYWludDFfbGluZWFyXzYyMF8zMTczNCkiLz4KPGNpcmNsZSBjeD0iNTciIGN5PSI3MCIgcj0iNDQiIGZpbGw9IiNGMUYxRjEiIGZpbGwtb3BhY2l0eT0iMC4yIi8+CjwvZz4KPHBhdGggZD0iTTEwMSA3MEMxMDEgOTQuMzAwNSA4MS4zMDAzIDExNCA1Ni45OTk4IDExNEM0My44MDgzIDExNCAzMS45NzI3IDEwOC4xOTUgMjMuOTA4MiA5OUM0Ny41IDcwIDU2Ljk5OTggNTYuNSA3OC4zMTc4IDMxLjVDOTEuODQ0NiAzOS4wMDYgMTAxIDUzLjQzMzkgMTAxIDcwWiIgZmlsbD0idXJsKCNwYWludDJfbGluZWFyXzYyMF8zMTczNCkiLz4KPHBhdGggZD0iTTEwMSA3MEMxMDEgOTQuMzAwNSA4MS4zMDAzIDExNCA1Ni45OTk4IDExNEM0My44MDgzIDExNCAzMS45NzI3IDEwOC4xOTUgMjMuOTA4MiA5OUM0Ny41IDcwIDU2Ljk5OTggNTYuNSA3OC4zMTc4IDMxLjVDOTEuODQ0NiAzOS4wMDYgMTAxIDUzLjQzMzkgMTAxIDcwWiIgZmlsbD0idXJsKCNwYWludDNfbGluZWFyXzYyMF8zMTczNCkiIGZpbGwtb3BhY2l0eT0iMC4yIi8+CjxyZWN0IHg9Ijg3LjQ1NTEiIHk9Ijg4Ljc3MzQiIHdpZHRoPSI2NS4yMjEyIiBoZWlnaHQ9IjE3LjU2MDQiIHJ4PSI4Ljc4MDE4IiB0cmFuc2Zvcm09InJvdGF0ZSg0MC43MTkyIDg3LjQ1NTEgODguNzczNCkiIGZpbGw9InVybCgjcGFpbnQ0X2xpbmVhcl82MjBfMzE3MzQpIi8+CjxyZWN0IHg9Ijg3LjQ1NTEiIHk9Ijg4Ljc3MzQiIHdpZHRoPSI2NS4yMjEyIiBoZWlnaHQ9IjE3LjU2MDQiIHJ4PSI4Ljc4MDE4IiB0cmFuc2Zvcm09InJvdGF0ZSg0MC43MTkyIDg3LjQ1NTEgODguNzczNCkiIGZpbGw9InVybCgjcGFpbnQ1X2xpbmVhcl82MjBfMzE3MzQpIiBmaWxsLW9wYWNpdHk9IjAuOCIvPgo8cmVjdCB4PSI4Ny40NTUxIiB5PSI4OC43NzM0IiB3aWR0aD0iNjUuMjIxMiIgaGVpZ2h0PSIxNy41NjA0IiByeD0iOC43ODAxOCIgdHJhbnNmb3JtPSJyb3RhdGUoNDAuNzE5MiA4Ny40NTUxIDg4Ljc3MzQpIiBmaWxsPSJ1cmwoI3BhaW50Nl9saW5lYXJfNjIwXzMxNzM0KSIgZmlsbC1vcGFjaXR5PSIwLjIiLz4KPGNpcmNsZSBjeD0iNTciIGN5PSI3MCIgcj0iMzgiIHN0cm9rZT0idXJsKCNwYWludDdfbGluZWFyXzYyMF8zMTczNCkiIHN0cm9rZS13aWR0aD0iMTIiLz4KPGNpcmNsZSBjeD0iNTciIGN5PSI3MCIgcj0iMzgiIHN0cm9rZT0idXJsKCNwYWludDhfbGluZWFyXzYyMF8zMTczNCkiIHN0cm9rZS1vcGFjaXR5PSIwLjUiIHN0cm9rZS13aWR0aD0iMTIiLz4KPGNpcmNsZSBjeD0iNTciIGN5PSI3MCIgcj0iMzgiIHN0cm9rZT0idXJsKCNwYWludDlfbGluZWFyXzYyMF8zMTczNCkiIHN0cm9rZS1vcGFjaXR5PSIwLjIiIHN0cm9rZS13aWR0aD0iMTIiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04NC4zMTY2IDI1LjY1ODNDODIuODM0NiAyNC45MTczIDgyLjIzNCAyMy4xMTUzIDgyLjk3NDkgMjEuNjMzNEw4Ny40NDcxIDEyLjY4OTFDODguMTg4IDExLjIwNzIgODkuOTkwMSAxMC42MDY1IDkxLjQ3MiAxMS4zNDc1QzkyLjk1MzkgMTIuMDg4NCA5My41NTQ2IDEzLjg5MDQgOTIuODEzNiAxNS4zNzI0TDg4LjM0MTUgMjQuMzE2N0M4Ny42MDA1IDI1Ljc5ODYgODUuNzk4NSAyNi4zOTkzIDg0LjMxNjYgMjUuNjU4M1oiIGZpbGw9IiNEMUQzRDYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMDUuNTg2IDQ4LjM4NTdDMTA1LjE2MiA0Ni43ODM5IDEwNi4xMTcgNDUuMTQyIDEwNy43MTkgNDQuNzE4NUwxMTcuMzg3IDQyLjE2MjVDMTE4Ljk4OSA0MS43MzkgMTIwLjYzMSA0Mi42OTQzIDEyMS4wNTQgNDQuMjk2MUMxMjEuNDc4IDQ1Ljg5NzkgMTIwLjUyMiA0Ny41Mzk3IDExOC45MjEgNDcuOTYzMkwxMDkuMjUzIDUwLjUxOTJDMTA3LjY1MSA1MC45NDI3IDEwNi4wMDkgNDkuOTg3NSAxMDUuNTg2IDQ4LjM4NTdaIiBmaWxsPSIjRDFEM0Q2Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTE1LjI1NSAyMS44NDMyQzExNi4yMDEgMjMuMjAzNCAxMTUuODY1IDI1LjA3MyAxMTQuNTA1IDI2LjAxOUwxMDEuMzcgMzUuMTU1QzEwMC4wMSAzNi4xMDExIDk4LjE0MDIgMzUuNzY1NCA5Ny4xOTQyIDM0LjQwNTJDOTYuMjQ4MSAzMy4wNDUgOTYuNTgzOCAzMS4xNzU0IDk3Ljk0NCAzMC4yMjkzTDExMS4wNzkgMjEuMDkzM0MxMTIuNDM5IDIwLjE0NzMgMTE0LjMwOSAyMC40ODMgMTE1LjI1NSAyMS44NDMyWiIgZmlsbD0iI0QxRDNENiIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzYyMF8zMTczNCIgeDE9IjQ3LjQ5NiIgeTE9Ii0wLjQwMDAwOCIgeDI9IjQ3LjQ5NiIgeTI9IjExNCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjREJEQkRCIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0UyRTJFMiIvPgo8L2xpbmVhckdyYWRpZW50Pgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MV9saW5lYXJfNjIwXzMxNzM0IiB4MT0iLTEyIiB5MT0iMTUuNSIgeDI9IjExNS4wODkiIHkyPSIxMjYuNDY4IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIG9mZnNldD0iMC4xNjA5MjMiIHN0b3AtY29sb3I9IiNGN0Y3RjciLz4KPHN0b3Agb2Zmc2V0PSIwLjcxMzMzIiBzdG9wLWNvbG9yPSIjQzRDNEM0Ii8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQyX2xpbmVhcl82MjBfMzE3MzQiIHgxPSI1NSIgeTE9IjQzLjUiIHgyPSI4NiIgeTI9IjEwMiIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjRThFOEU4Ii8+CjxzdG9wIG9mZnNldD0iMC45MDEwNDIiIHN0b3AtY29sb3I9IiNFMkUyRTIiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDNfbGluZWFyXzYyMF8zMTczNCIgeDE9IjQ4LjUiIHkxPSIxMDkiIHgyPSI2MiIgeTI9Ijc3IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiNFREVERUQiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSJ3aGl0ZSIgc3RvcC1vcGFjaXR5PSIwIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQ0X2xpbmVhcl82MjBfMzE3MzQiIHgxPSI0MC44NTczIiB5MT0iMTI2LjU0MSIgeDI9IjE1Ni43MDciIHkyPSIxMjAuODMiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iI0Q2RDZENiIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNFREVERUQiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDVfbGluZWFyXzYyMF8zMTczNCIgeDE9IjkxLjUwNzciIHkxPSI5OC43NzgyIiB4Mj0iMTMxLjIwNiIgeTI9Ijk4LjkxMzUiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agb2Zmc2V0PSIwLjI3MDQxNCIgc3RvcC1jb2xvcj0iI0M1QzVDNSIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNFQUVBRUEiIHN0b3Atb3BhY2l0eT0iMC42MiIvPgo8L2xpbmVhckdyYWRpZW50Pgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50Nl9saW5lYXJfNjIwXzMxNzM0IiB4MT0iMTUzLjYwMyIgeTE9Ijk4LjEwODEiIHgyPSIxMTcuNjQxIiB5Mj0iOTUuNDE2MyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjQ0FDQUNBIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0JBQkFCQSIgc3RvcC1vcGFjaXR5PSIwLjEiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDdfbGluZWFyXzYyMF8zMTczNCIgeDE9Ijk3LjUiIHkxPSIxMDYuNSIgeDI9Ii0yNiIgeTI9Ii0xNy41IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiNFN0U3RTciLz4KPHN0b3Agb2Zmc2V0PSIwLjI3MTIzMSIgc3RvcC1jb2xvcj0iI0U0RTRFNCIvPgo8c3RvcCBvZmZzZXQ9IjAuNDA3MDM4IiBzdG9wLWNvbG9yPSIjRURFREVEIi8+CjxzdG9wIG9mZnNldD0iMC41ODEyMjIiIHN0b3AtY29sb3I9IndoaXRlIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQ4X2xpbmVhcl82MjBfMzE3MzQiIHgxPSIxMjUuODkyIiB5MT0iMTU4Ljg3OCIgeDI9Ii03Ny4yMDU1IiB5Mj0iLTM2LjExNzYiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzc5Nzk3OSIvPgo8c3RvcCBvZmZzZXQ9IjAuOTc1MzMiIHN0b3AtY29sb3I9IiNFMEUwRTAiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDlfbGluZWFyXzYyMF8zMTczNCIgeDE9IjEwNiIgeTE9IjEyOCIgeDI9Ii0zMy41IiB5Mj0iMTEuNSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjQkZCRkJGIi8+CjxzdG9wIG9mZnNldD0iMC44MjAyODQiIHN0b3AtY29sb3I9IiNDN0M3QzciLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K", i5e = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUwIiBoZWlnaHQ9IjE1MCIgdmlld0JveD0iMCAwIDE1MCAxNTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik04MC45MjYyIDk2LjE3ODJIMTlDMTQuNTgxNyA5Ni4xNzgyIDExIDk5Ljc1OTkgMTEgMTA0LjE3OFYxMjYuMTk4QzExIDEzMC42MTYgMTQuNTgxNyAxMzQuMTk4IDE5IDEzNC4xOThIOTEuNzY0OUM4My41Njk1IDEyOC43NDkgNzguMTY4MiAxMTkuNDMxIDc4LjE2ODIgMTA4Ljg1MkM3OC4xNjgyIDEwNC4zMjkgNzkuMTU1NCAxMDAuMDM2IDgwLjkyNjIgOTYuMTc4MloiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8xMDM4XzMyODcyKSIvPgo8cGF0aCBkPSJNMTkgNTMuMDg4OUMxNC41ODE3IDUzLjA4ODkgMTEgNTYuNjcwNiAxMSA2MS4wODg5VjgzLjEwODdDMTEgODcuNTI2OSAxNC41ODE3IDkxLjEwODcgMTkgOTEuMTA4N0g4My44NzY2Qzg5LjM5OCA4My40MzM1IDk4LjQwNzQgNzguNDM1NSAxMDguNTg0IDc4LjQzNTVDMTEzLjYwOSA3OC40MzU1IDExOC4zNDkgNzkuNjUzOSAxMjIuNTI1IDgxLjgxMTNWNjEuMDg4OUMxMjIuNTI1IDU2LjY3MDYgMTE4Ljk0MyA1My4wODg5IDExNC41MjUgNTMuMDg4OUgxOVoiIGZpbGw9InVybCgjcGFpbnQxX2xpbmVhcl8xMDM4XzMyODcyKSIvPgo8cmVjdCB4PSIxMSIgeT0iMTAiIHdpZHRoPSIxMTEuNTI1IiBoZWlnaHQ9IjM4LjAxOTgiIHJ4PSI4IiBmaWxsPSJ1cmwoI3BhaW50Ml9saW5lYXJfMTAzOF8zMjg3MikiLz4KPGNpcmNsZSBjeD0iMjcuNDc1MyIgY3k9IjI5LjAxIiByPSI2LjMzNjYzIiBmaWxsPSJ1cmwoI3BhaW50M19saW5lYXJfMTAzOF8zMjg3MikiLz4KPGNpcmNsZSBjeD0iMjcuNDc1MyIgY3k9IjcyLjA5OTMiIHI9IjYuMzM2NjMiIGZpbGw9InVybCgjcGFpbnQ0X2xpbmVhcl8xMDM4XzMyODcyKSIvPgo8Y2lyY2xlIGN4PSIyNy40NzUzIiBjeT0iMTE1LjE4OCIgcj0iNi4zMzY2MyIgZmlsbD0idXJsKCNwYWludDVfbGluZWFyXzEwMzhfMzI4NzIpIi8+CjxwYXRoIGQ9Ik0xMDYuNDMgOTguMDc5M0MxMDYuNDMgOTYuODg5NSAxMDcuMzk0IDk1LjkyNDkgMTA4LjU4NCA5NS45MjQ5QzEwOS43NzQgOTUuOTI0OSAxMTAuNzM4IDk2Ljg4OTUgMTEwLjczOCA5OC4wNzkzVjExMS4wMDZDMTEwLjczOCAxMTIuMTk2IDEwOS43NzQgMTEzLjE2MSAxMDguNTg0IDExMy4xNjFDMTA3LjM5NCAxMTMuMTYxIDEwNi40MyAxMTIuMTk2IDEwNi40MyAxMTEuMDA2Vjk4LjA3OTNaIiBmaWxsPSJ1cmwoI3BhaW50Nl9saW5lYXJfMTAzOF8zMjg3MikiLz4KPHBhdGggZD0iTTEwOC41ODQgMTIxLjc3OEMxMDkuOTIzIDEyMS43NzggMTExLjAwOCAxMjAuNjkzIDExMS4wMDggMTE5LjM1NUMxMTEuMDA4IDExOC4wMTYgMTA5LjkyMyAxMTYuOTMxIDEwOC41ODQgMTE2LjkzMUMxMDcuMjQ2IDExNi45MzEgMTA2LjE2IDExOC4wMTYgMTA2LjE2IDExOS4zNTVDMTA2LjE2IDEyMC42OTMgMTA3LjI0NiAxMjEuNzc4IDEwOC41ODQgMTIxLjc3OFoiIGZpbGw9InVybCgjcGFpbnQ3X2xpbmVhcl8xMDM4XzMyODcyKSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEwOC41ODQgMTMwLjM5NkMxMjAuNDgzIDEzMC4zOTYgMTMwLjEyOSAxMjAuNzUgMTMwLjEyOSAxMDguODUyQzEzMC4xMjkgOTYuOTUzIDEyMC40ODMgODcuMzA3MSAxMDguNTg0IDg3LjMwNzFDOTYuNjg1NCA4Ny4zMDcxIDg3LjAzOTYgOTYuOTUzIDg3LjAzOTYgMTA4Ljg1MkM4Ny4wMzk2IDEyMC43NSA5Ni42ODU0IDEzMC4zOTYgMTA4LjU4NCAxMzAuMzk2Wk0xMDguNTg0IDEyNS41NDZDMTE3LjgwNCAxMjUuNTQ2IDEyNS4yNzggMTE4LjA3MiAxMjUuMjc4IDEwOC44NTJDMTI1LjI3OCA5OS42MzE3IDExNy44MDQgOTIuMTU3MyAxMDguNTg0IDkyLjE1NzNDOTkuMzY0MSA5Mi4xNTczIDkxLjg4OTggOTkuNjMxNyA5MS44ODk4IDEwOC44NTJDOTEuODg5OCAxMTguMDcyIDk5LjM2NDEgMTI1LjU0NiAxMDguNTg0IDEyNS41NDZaIiBmaWxsPSJ1cmwoI3BhaW50OF9saW5lYXJfMTAzOF8zMjg3MikiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl8xMDM4XzMyODcyIiB4MT0iNTQuNSIgeTE9IjkzIiB4Mj0iNTQuNSIgeTI9IjEzOSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMjUyODJDIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzE3MUIyMCIvPgo8L2xpbmVhckdyYWRpZW50Pgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MV9saW5lYXJfMTAzOF8zMjg3MiIgeDE9IjU0LjcxNzciIHkxPSI0Ny45OTk4IiB4Mj0iNTQuNzE3NyIgeTI9IjkxLjEwODciIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzI4MkQzMyIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMyMzI2MkEiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDJfbGluZWFyXzEwMzhfMzI4NzIiIHgxPSI1NC43MTc3IiB5MT0iMi41IiB4Mj0iNTQuNzE3NyIgeTI9IjQ4LjAxOTgiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzM3M0I0MiIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMyNzJEMzIiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDNfbGluZWFyXzEwMzhfMzI4NzIiIHgxPSIyNy40NzUzIiB5MT0iMjIuNjczMyIgeDI9IjI3LjQ3NTMiIHkyPSIzNS4zNDY2IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiM0QzU3NUMiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMzYzQzQxIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQ0X2xpbmVhcl8xMDM4XzMyODcyIiB4MT0iMjcuNDc1MyIgeTE9IjY1Ljc2MjciIHgyPSIyNy40NzUzIiB5Mj0iNzguNDM2IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiMzRDQ1NDkiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMkEyRDJGIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQ1X2xpbmVhcl8xMDM4XzMyODcyIiB4MT0iMjcuNDc1MyIgeTE9IjEwOC44NTIiIHgyPSIyNy40NzUzIiB5Mj0iMTIxLjUyNSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMzMzQTNFIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzI1MkEyRSIvPgo8L2xpbmVhckdyYWRpZW50Pgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50Nl9saW5lYXJfMTAzOF8zMjg3MiIgeDE9IjkyLjUiIHkxPSI4NyIgeDI9IjExNi40MDYiIHkyPSIxMzcuNjc1IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiM2NzZENzQiLz4KPHN0b3Agb2Zmc2V0PSIwLjM3ODE4MyIgc3RvcC1jb2xvcj0iIzQzNDY0QSIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMxQzIwMjQiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDdfbGluZWFyXzEwMzhfMzI4NzIiIHgxPSI5Mi41IiB5MT0iODciIHgyPSIxMTYuNDA2IiB5Mj0iMTM3LjY3NSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjNjc2RDc0Ii8+CjxzdG9wIG9mZnNldD0iMC4zNzgxODMiIHN0b3AtY29sb3I9IiM0MzQ2NEEiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMUMyMDI0Ii8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQ4X2xpbmVhcl8xMDM4XzMyODcyIiB4MT0iOTIuNSIgeTE9Ijg3IiB4Mj0iMTE2LjQwNiIgeTI9IjEzNy42NzUiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzY3NkQ3NCIvPgo8c3RvcCBvZmZzZXQ9IjAuMzc4MTgzIiBzdG9wLWNvbG9yPSIjNDM0NjRBIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzFDMjAyNCIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=", a5e = "data:image/svg+xml;base64,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", MJ = Ge(
  ({ fallbackUrl: t = Gze, ...e }, n) => {
    const r = (i) => {
      i.currentTarget.src = t;
    };
    return /* @__PURE__ */ E.jsx("img", { ref: n, onError: r, alt: "image alternative", ...e });
  }
), qd = Te(MJ);
class Tn extends bo {
  static isPreLaunch(e) {
    return XP.includes(String(e));
  }
}
Vt(Tn, "getNetworkLogoUrl", (e) => {
  switch (e = String(e), e) {
    case ve.MAINNET:
    case ve.ETH_TESTNET:
      return fze;
    case ve.BSC_MAINNET:
    case ve.BSC_TESTNET:
      return Vze;
    case ve.POLYGON_MAINNET:
    case ve.POLYGON_TESTNET:
      return Uze;
    case ve.FANTOM_MAINNET:
    case ve.FANTOM_TESTNET:
      return Rze;
    case ve.CRONOS_MAINNET:
    case ve.CRONOS_TESTNET:
      return gze;
    case ve.THUNDERCORE_MAINNET:
    case ve.THUNDERCORE_TESTNET:
      return yze;
    case ve.AVALANCHE_MAINNET:
    case ve.AVALANCHE_TESTNET:
      return Zze;
    case ve.KCC_MAINNET:
    case ve.KCC_TESTNET:
      return bze;
    case ve.ARBITRUM_MAINNET:
    case ve.ARBITRUM_TESTNET:
      return Eze;
    case ve.OPTIMISM_MAINNET:
    case ve.OPTIMISM_TESTNET:
      return Sze;
    case ve.ASTAR_MAINNET:
    case ve.ASTAR_TESTNET:
      return xze;
    case ve.MOONRIVER_MAINNET:
    case ve.MOONRIVER_TESTNET:
      return Wze;
    case ve.KLAYTN_MAINNET:
    case ve.KLAYTN_TESTNET:
      return jze;
    case ve.NUMBERS_MAINNET:
    case ve.NUMBERS_TESTNET:
      return Dze;
    case ve.WEMIX_MAINNET:
    case ve.WEMIX_TESTNET:
      return zze;
    case ve.ZKSYNC_ERA_MAINNET:
    case ve.ZKSYNC_ERA_TESTNET:
      return kze;
    case ve.POLYGON_ZKEVM_MAINNET:
    case ve.POLYGON_ZKEVM_TESTNET:
      return wze;
    case ve.LINEA_MAINNET:
    case ve.LINEA_TESTNET:
      return Fze;
    case ve.BASE_MAINNET:
    case ve.BASE_TESTNET:
      return vze;
    case ve.MANTLE_MAINNET:
    case ve.MANTLE_TESTNET:
      return Ize;
    case ve.SCROLL_MAINNET:
    case ve.SCROLL_TESTNET:
      return Oze;
    default:
      return "";
  }
}), Vt(Tn, "getWalletLogoUrl", (e) => {
  switch (e) {
    case Kr.Metamask:
      return Cze;
    case Kr.WalletConnect:
      return Lze;
    case Kr.OKXWallet:
      return Jze;
    case Kr.CoinbaseWallet:
      return Bze;
    case Kr.TrustWallet:
      return Aze;
    case Kr.ImToken:
      return _ze;
    case Kr.Bitget:
      return Hze;
    case Kr.HaloWallet:
      return Pze;
    case Kr.Brave:
      return Xze;
    default:
      return "";
  }
}), Vt(Tn, "getBridgeLogoUrl", (e, n) => {
  switch (e) {
    case ci.C_BRIDGE:
      return Kze;
    case ci.MULTICHAIN:
      return $ze;
    case ci.Y_BRIDGE:
      return qze;
    case ci.SYNAPSE:
      return e5e;
    case ci.CELER_CCTP:
      return t5e;
    case ci.XASSET_BRIDGE:
      return n || Hk;
    default:
      return Hk;
  }
});
const o5e = Ge(
  (t, e) => {
    const { address: n } = Ui(), { chain: r } = lu(), i = yd(n, 6), a = /* @__PURE__ */ E.jsx(
      qd,
      {
        w: "16px",
        src: Tn.getNetworkLogoUrl(r == null ? void 0 : r.id)
      }
    );
    return /* @__PURE__ */ E.jsx(Uu, { ref: e, leftIcon: a, variant: "grey", ...t, children: i });
  }
), s5e = (t) => {
  const e = eM.isFocused(), { borderRadius: { inner: n } } = ca(), {
    loading: r,
    disabled: i,
    startCountDown: a,
    isHideCountDownStroke: o,
    handleRefetch: s,
    duration: l
  } = t;
  return /* @__PURE__ */ E.jsxs("div", { className: "relative", children: [
    /* @__PURE__ */ E.jsx(
      "svg",
      {
        onClick: s,
        className: ni(
          "z-upstairs absolute left-0 top-0 cursor-pointer",
          i || r ? "cursor-not-allowed" : ""
        ),
        width: "36",
        height: "36",
        viewBox: "0 0 36 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ E.jsx(
          "rect",
          {
            x: "1",
            y: "1",
            width: "34",
            height: "34",
            rx: n.replace("px", "") ?? "8",
            stroke: "#C6CCD2",
            strokeLinecap: "round",
            strokeDasharray: "0, 123",
            strokeDashoffset: "92",
            className: ni(
              a && "animate-borderCountDown",
              o ? "stroke-0" : "stroke-2"
            ),
            style: {
              animationDuration: `${l}s`,
              animationPlayState: e ? "running" : "paused"
            }
          }
        )
      }
    ),
    /* @__PURE__ */ E.jsx(
      Oh,
      {
        loading: r,
        disabled: i,
        icon: /* @__PURE__ */ E.jsx(lJ, { className: "flex-shrink-0 w-[20px] h-[20px]" }),
        onClick: s
      }
    )
  ] });
}, Xk = Ge(
  ({
    className: t,
    children: e,
    disabled: n,
    loading: r,
    loadingText: i,
    primaryBg: a,
    secondaryBorder: o,
    ...s
  }, l) => {
    const c = r && i ? i : e, d = !!(r || n), u = ni([t, a && o ? "outline outline-[1px]" : ""]), { borderRadius: { button: h }, colors: { primary: N } } = ca(), M = NL(), p = xSe();
    let m = {
      borderRadius: h
    };
    return a && (m.backgroundColor = N, m.color = M), a && o && (m.outlineColor = p), /* @__PURE__ */ E.jsx(
      "button",
      {
        ref: l,
        className: u,
        disabled: d,
        style: m,
        ...s,
        children: c
      }
    );
  }
), aR = Te("input", {
  baseStyle: {
    border: "none",
    bgColor: "inherit",
    _focusVisible: {
      outline: "none"
    },
    type: "text"
  }
});
function cp({
  token: t,
  light: e,
  truncate: n = !1,
  showText: r = !1
}) {
  const { isFakeToken: i } = t, a = n ? {
    width: "80px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  } : {};
  return /* @__PURE__ */ E.jsxs(Ae, { direction: "row", alignItems: "center", spacing: "8px", children: [
    /* @__PURE__ */ E.jsxs(Mr, { position: "relative", children: [
      /* @__PURE__ */ E.jsx(
        qd,
        {
          width: "28px",
          height: "28px",
          borderRadius: "full",
          src: t.logoURI
        }
      ),
      /* @__PURE__ */ E.jsx(
        qd,
        {
          position: "absolute",
          top: "16px",
          right: "-4px",
          zIndex: "1",
          height: "16px",
          width: "16px",
          src: Tn.getNetworkLogoUrl(t.chainId)
        }
      )
    ] }),
    r && /* @__PURE__ */ E.jsxs(
      Jr,
      {
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center",
        children: [
          /* @__PURE__ */ E.jsx(Mt, { fontSize: "18px", fontWeight: "semibold", lineHeight: "22px", children: i ? "Token" : t.symbol }),
          /* @__PURE__ */ E.jsx(
            Mt,
            {
              as: "span",
              fontSize: "14px",
              lineHeight: "18px",
              textAlign: "left",
              color: e ? "text.primary" : "text.secondary",
              ...a,
              children: i ? "Network" : Tn.getNetworkName(t.chainId)
            }
          )
        ]
      }
    )
  ] });
}
function l5e({ locked: t = !1, token: e, ...n }) {
  const r = {
    borderRadius: "8px",
    display: "flex",
    height: "72px",
    minWidth: "168px",
    alignItems: "center",
    justifyContent: "space-between",
    px: "16px",
    py: "12px",
    bgColor: "surface.2",
    cursor: "pointer",
    _hover: {
      bgColor: "surface.3"
    },
    _disabled: {
      bgColor: "surface.1 !important",
      cursor: "not-allower"
    }
  };
  return /* @__PURE__ */ E.jsxs(Te.button, { ...r, disabled: t, ...n, children: [
    /* @__PURE__ */ E.jsx(cp, { truncate: !0, showText: !0, token: e }),
    !t && /* @__PURE__ */ E.jsx(Kx, { color: "text.primary" })
  ] });
}
const js = Ge(
  ({ children: t, leftIcon: e, rightIcon: n, ...r }, i) => {
    const a = {
      color: "text.interaction.default",
      _hover: {
        color: "text.interaction.hover"
      },
      _disabled: {
        color: "text.interaction.disable"
      },
      cursor: "pointer"
    };
    return /* @__PURE__ */ E.jsxs(
      Ae,
      {
        ref: i,
        direction: "row",
        alignItems: "center",
        spacing: "4px",
        ...a,
        ...r,
        children: [
          e && e,
          /* @__PURE__ */ E.jsx("span", { children: t }),
          n && n
        ]
      }
    );
  }
), pJ = /* @__PURE__ */ new Set(), Di = /* @__PURE__ */ new WeakMap(), Yh = /* @__PURE__ */ new WeakMap(), eu = /* @__PURE__ */ new WeakMap(), gE = /* @__PURE__ */ new WeakMap(), c5e = /* @__PURE__ */ new WeakMap(), Qh = /* @__PURE__ */ new WeakMap(), h2 = /* @__PURE__ */ new WeakMap(), $N = /* @__PURE__ */ new WeakSet();
let mc, $x = 0, qx = 0;
const Us = "__aa_tgt", dp = "__aa_del", N2 = "__aa_new", d5e = (t) => {
  const e = p5e(t);
  e && e.forEach((n) => m5e(n));
}, u5e = (t) => {
  t.forEach((e) => {
    e.target === mc && N5e(), Di.has(e.target) && Zu(e.target);
  });
};
function h5e(t) {
  const e = gE.get(t);
  e == null || e.disconnect();
  let n = Di.get(t), r = 0;
  const i = 5;
  n || (n = Gh(t), Di.set(t, n));
  const { offsetWidth: a, offsetHeight: o } = mc, l = [
    n.top - i,
    a - (n.left + i + n.width),
    o - (n.top + i + n.height),
    n.left - i
  ].map((d) => `${-1 * Math.floor(d)}px`).join(" "), c = new IntersectionObserver(() => {
    ++r > 1 && Zu(t);
  }, {
    root: mc,
    threshold: 1,
    rootMargin: l
  });
  c.observe(t), gE.set(t, c);
}
function Zu(t) {
  clearTimeout(h2.get(t));
  const e = oR(t), n = up(e) ? 500 : e.duration;
  h2.set(t, setTimeout(async () => {
    const r = eu.get(t);
    try {
      await (r == null ? void 0 : r.finished), Di.set(t, Gh(t)), h5e(t);
    } catch {
    }
  }, n));
}
function N5e() {
  clearTimeout(h2.get(mc)), h2.set(mc, setTimeout(() => {
    pJ.forEach((t) => VJ(t, (e) => mJ(() => Zu(e))));
  }, 100));
}
function M5e(t) {
  setTimeout(() => {
    c5e.set(t, setInterval(() => mJ(Zu.bind(null, t)), 2e3));
  }, Math.round(2e3 * Math.random()));
}
function mJ(t) {
  typeof requestIdleCallback == "function" ? requestIdleCallback(() => t()) : requestAnimationFrame(() => t());
}
let yE, s0;
typeof window < "u" && (mc = document.documentElement, yE = new MutationObserver(d5e), s0 = new ResizeObserver(u5e), window.addEventListener("scroll", () => {
  qx = window.scrollY, $x = window.scrollX;
}), s0.observe(mc));
function p5e(t) {
  return t.reduce((r, i) => [
    ...r,
    ...Array.from(i.addedNodes),
    ...Array.from(i.removedNodes)
  ], []).every((r) => r.nodeName === "#comment") ? !1 : t.reduce((r, i) => {
    if (r === !1)
      return !1;
    if (i.target instanceof Element) {
      if (py(i.target), !r.has(i.target)) {
        r.add(i.target);
        for (let a = 0; a < i.target.children.length; a++) {
          const o = i.target.children.item(a);
          if (o) {
            if (dp in o)
              return !1;
            py(i.target, o), r.add(o);
          }
        }
      }
      if (i.removedNodes.length)
        for (let a = 0; a < i.removedNodes.length; a++) {
          const o = i.removedNodes[a];
          if (dp in o)
            return !1;
          o instanceof Element && (r.add(o), py(i.target, o), Yh.set(o, [
            i.previousSibling,
            i.nextSibling
          ]));
        }
    }
    return r;
  }, /* @__PURE__ */ new Set());
}
function py(t, e) {
  !e && !(Us in t) ? Object.defineProperty(t, Us, { value: t }) : e && !(Us in e) && Object.defineProperty(e, Us, { value: t });
}
function m5e(t) {
  var e;
  const n = t.isConnected, r = Di.has(t);
  n && Yh.has(t) && Yh.delete(t), eu.has(t) && ((e = eu.get(t)) === null || e === void 0 || e.cancel()), N2 in t ? _k(t) : r && n ? f5e(t) : r && !n ? V5e(t) : _k(t);
}
function Mo(t) {
  return Number(t.replace(/[^0-9.\-]/g, ""));
}
function T5e(t) {
  let e = t.parentElement;
  for (; e; ) {
    if (e.scrollLeft || e.scrollTop)
      return { x: e.scrollLeft, y: e.scrollTop };
    e = e.parentElement;
  }
  return { x: 0, y: 0 };
}
function Gh(t) {
  const e = t.getBoundingClientRect(), { x: n, y: r } = T5e(t);
  return {
    top: e.top + r,
    left: e.left + n,
    width: e.width,
    height: e.height
  };
}
function TJ(t, e, n) {
  let r = e.width, i = e.height, a = n.width, o = n.height;
  const s = getComputedStyle(t);
  if (s.getPropertyValue("box-sizing") === "content-box") {
    const c = Mo(s.paddingTop) + Mo(s.paddingBottom) + Mo(s.borderTopWidth) + Mo(s.borderBottomWidth), d = Mo(s.paddingLeft) + Mo(s.paddingRight) + Mo(s.borderRightWidth) + Mo(s.borderLeftWidth);
    r -= d, a -= d, i -= c, o -= c;
  }
  return [r, a, i, o].map(Math.round);
}
function oR(t) {
  return Us in t && Qh.has(t[Us]) ? Qh.get(t[Us]) : { duration: 250, easing: "ease-in-out" };
}
function fJ(t) {
  if (Us in t)
    return t[Us];
}
function eW(t) {
  const e = fJ(t);
  return e ? $N.has(e) : !1;
}
function VJ(t, ...e) {
  e.forEach((n) => n(t, Qh.has(t)));
  for (let n = 0; n < t.children.length; n++) {
    const r = t.children.item(n);
    r && e.forEach((i) => i(r, Qh.has(r)));
  }
}
function tW(t) {
  return Array.isArray(t) ? t : [t];
}
function up(t) {
  return typeof t == "function";
}
function f5e(t) {
  const e = Di.get(t), n = Gh(t);
  if (!eW(t))
    return Di.set(t, n);
  let r;
  if (!e)
    return;
  const i = oR(t);
  if (typeof i != "function") {
    const a = e.left - n.left, o = e.top - n.top, [s, l, c, d] = TJ(t, e, n), u = {
      transform: `translate(${a}px, ${o}px)`
    }, h = {
      transform: "translate(0, 0)"
    };
    s !== l && (u.width = `${s}px`, h.width = `${l}px`), c !== d && (u.height = `${c}px`, h.height = `${d}px`), r = t.animate([u, h], {
      duration: i.duration,
      easing: i.easing
    });
  } else {
    const [a] = tW(i(t, "remain", e, n));
    r = new Animation(a), r.play();
  }
  eu.set(t, r), Di.set(t, n), r.addEventListener("finish", Zu.bind(null, t));
}
function _k(t) {
  N2 in t && delete t[N2];
  const e = Gh(t);
  Di.set(t, e);
  const n = oR(t);
  if (!eW(t))
    return;
  let r;
  if (typeof n != "function")
    r = t.animate([
      { transform: "scale(.98)", opacity: 0 },
      { transform: "scale(0.98)", opacity: 0, offset: 0.5 },
      { transform: "scale(1)", opacity: 1 }
    ], {
      duration: n.duration * 1.5,
      easing: "ease-in"
    });
  else {
    const [i] = tW(n(t, "add", e));
    r = new Animation(i), r.play();
  }
  eu.set(t, r), r.addEventListener("finish", Zu.bind(null, t));
}
function Pk(t, e) {
  var n;
  t.remove(), Di.delete(t), Yh.delete(t), eu.delete(t), (n = gE.get(t)) === null || n === void 0 || n.disconnect(), setTimeout(() => {
    if (dp in t && delete t[dp], Object.defineProperty(t, N2, { value: !0, configurable: !0 }), e && t instanceof HTMLElement)
      for (const r in e)
        t.style[r] = "";
  }, 0);
}
function V5e(t) {
  var e;
  if (!Yh.has(t) || !Di.has(t))
    return;
  const [n, r] = Yh.get(t);
  Object.defineProperty(t, dp, { value: !0, configurable: !0 });
  const i = window.scrollX, a = window.scrollY;
  if (r && r.parentNode && r.parentNode instanceof Element ? r.parentNode.insertBefore(t, r) : n && n.parentNode ? n.parentNode.appendChild(t) : (e = fJ(t)) === null || e === void 0 || e.appendChild(t), !eW(t))
    return Pk(t);
  const [o, s, l, c] = R5e(t), d = oR(t), u = Di.get(t);
  (i !== $x || a !== qx) && U5e(t, i, a, d);
  let h, N = {
    position: "absolute",
    top: `${o}px`,
    left: `${s}px`,
    width: `${l}px`,
    height: `${c}px`,
    margin: "0",
    pointerEvents: "none",
    transformOrigin: "center",
    zIndex: "100"
  };
  if (!up(d))
    Object.assign(t.style, N), h = t.animate([
      {
        transform: "scale(1)",
        opacity: 1
      },
      {
        transform: "scale(.98)",
        opacity: 0
      }
    ], { duration: d.duration, easing: "ease-out" });
  else {
    const [M, p] = tW(d(t, "remove", u));
    (p == null ? void 0 : p.styleReset) !== !1 && (N = (p == null ? void 0 : p.styleReset) || N, Object.assign(t.style, N)), h = new Animation(M), h.play();
  }
  eu.set(t, h), h.addEventListener("finish", Pk.bind(null, t, N));
}
function U5e(t, e, n, r) {
  const i = $x - e, a = qx - n, o = document.documentElement.style.scrollBehavior;
  if (getComputedStyle(mc).scrollBehavior === "smooth" && (document.documentElement.style.scrollBehavior = "auto"), window.scrollTo(window.scrollX + i, window.scrollY + a), !t.parentElement)
    return;
  const l = t.parentElement;
  let c = l.clientHeight, d = l.clientWidth;
  const u = performance.now();
  function h() {
    requestAnimationFrame(() => {
      if (!up(r)) {
        const N = c - l.clientHeight, M = d - l.clientWidth;
        u + r.duration > performance.now() ? (window.scrollTo({
          left: window.scrollX - M,
          top: window.scrollY - N
        }), c = l.clientHeight, d = l.clientWidth, h()) : document.documentElement.style.scrollBehavior = o;
      }
    });
  }
  h();
}
function R5e(t) {
  const e = Di.get(t), [n, , r] = TJ(t, e, Gh(t));
  let i = t.parentElement;
  for (; i && (getComputedStyle(i).position === "static" || i instanceof HTMLBodyElement); )
    i = i.parentElement;
  i || (i = document.body);
  const a = getComputedStyle(i), o = Di.get(i) || Gh(i), s = Math.round(e.top - o.top) - Mo(a.borderTopWidth), l = Math.round(e.left - o.left) - Mo(a.borderLeftWidth);
  return [s, l, n, r];
}
function g5e(t, e = {}) {
  return yE && s0 && (window.matchMedia("(prefers-reduced-motion: reduce)").matches && !up(e) && !e.disrespectUserMotionPreference || ($N.add(t), getComputedStyle(t).position === "static" && Object.assign(t.style, { position: "relative" }), VJ(t, Zu, M5e, (i) => s0 == null ? void 0 : s0.observe(i)), up(e) ? Qh.set(t, e) : Qh.set(t, { duration: 250, easing: "ease-in-out", ...e }), yE.observe(t, { childList: !0 }), pJ.add(t))), Object.freeze({
    parent: t,
    enable: () => {
      $N.add(t);
    },
    disable: () => {
      $N.delete(t);
    },
    isEnabled: () => $N.has(t)
  });
}
function Ch(t) {
  const [e, n] = nt(), r = De((a) => {
    a instanceof HTMLElement ? n(g5e(a, t)) : n(void 0);
  }, [t]), i = De((a) => {
    e && (a ? e.enable() : e.disable());
  }, [e]);
  return [r, i];
}
function y5e({ steps: t }) {
  return /* @__PURE__ */ E.jsx(Jr, { as: "ul", children: t.map((e, n) => /* @__PURE__ */ E.jsx(Z5e, { isFirst: n === 0, step: e }, e.name)) });
}
function Z5e({ step: t, isFirst: e }) {
  const { status: n, name: r, transaction: i } = t, {
    explorerUrl: a,
    receiptUpdatedAt: o,
    chainId: s,
    hash: l,
    isCrossChain: c,
    destinationChainHash: d
  } = i, u = i.outputToken.chainId, h = Tn.getExplorerUrl(u), [N] = Ch(), M = (() => {
    switch (n) {
      case "upcoming":
        return /* @__PURE__ */ E.jsx(oze, { w: "24px", h: "24px" });
      case "completed":
        return /* @__PURE__ */ E.jsx(u2, { w: "24px", h: "24px" });
      case "current":
        return /* @__PURE__ */ E.jsx(sze, { w: "24px", h: "24px" });
      case "error":
        return /* @__PURE__ */ E.jsx(d2, { w: "24px", h: "24px" });
    }
  })(), p = (() => {
    switch (n) {
      case "upcoming":
        return {
          color: "text-occupation"
        };
      case "completed":
      case "current":
      case "error":
        return {
          color: "text-default"
        };
    }
  })(), m = (() => {
    switch (n) {
      case "upcoming":
        return {
          bgColor: "bg-text-occupation"
        };
      case "completed":
      case "current":
      case "error":
        return {
          bgColor: "bg-text-default"
        };
    }
  })(), R = (() => {
    switch (n) {
      case "current":
        return /* @__PURE__ */ E.jsx(Mt, { fontSize: "12px", lineHeight: "16px", children: "Processing..." });
      case "error":
        return /* @__PURE__ */ E.jsx(Mt, { fontSize: "12px", lineHeight: "16px", children: "Failed" });
      case "upcoming":
        return null;
      case "completed":
        return o && !c ? /* @__PURE__ */ E.jsx(
          js,
          {
            fontSize: "12px",
            lineHeight: "16px",
            onClick: () => gh(
              Tn.getTxExplorerUrl(a, s, l)
            ),
            rightIcon: /* @__PURE__ */ E.jsx(c2, { h: "10px", w: "10px" }),
            children: /* @__PURE__ */ E.jsx(Mt, { as: "span", fontSize: "12px", children: yd(l) })
          }
        ) : o && c && d ? /* @__PURE__ */ E.jsx(
          js,
          {
            fontSize: "12px",
            lineHeight: "16px",
            onClick: () => gh(
              Tn.getTxExplorerUrl(
                h,
                u,
                d
              )
            ),
            rightIcon: /* @__PURE__ */ E.jsx(c2, { h: "10px", w: "10px" }),
            children: /* @__PURE__ */ E.jsx(Mt, { as: "span", fontSize: "12px", children: yd(d) })
          }
        ) : null;
    }
  })();
  return /* @__PURE__ */ E.jsxs(Jr, { w: "full", alignItems: "center", ...p, children: [
    !e && /* @__PURE__ */ E.jsx(Mr, { mx: "8px", h: "1px", w: "83px", ...m }),
    /* @__PURE__ */ E.jsxs(Mr, { position: "relative", children: [
      M,
      /* @__PURE__ */ E.jsxs(
        Ae,
        {
          position: "absolute",
          left: "-8px",
          right: "-8px",
          top: "30px",
          alignItems: "center",
          spacing: "4px",
          children: [
            /* @__PURE__ */ E.jsx(Mt, { children: r }),
            /* @__PURE__ */ E.jsx(Mr, { ref: N, children: R })
          ]
        }
      )
    ] })
  ] });
}
function ZE({
  children: t,
  leftIcon: e = /* @__PURE__ */ E.jsx(dJ, { flexShrink: 0, width: "24px", height: "24px" }),
  color: n = "text.primary",
  bgColor: r = "surface.1"
}) {
  return /* @__PURE__ */ E.jsxs(
    Ae,
    {
      color: n,
      bgColor: r,
      borderRadius: "inner",
      direction: "row",
      alignItems: "center",
      spacing: "10px",
      px: "12px",
      py: "8px",
      children: [
        e,
        t
      ]
    }
  );
}
function nW(t) {
  const {
    children: e,
    className: n,
    primaryTheme: r
  } = t;
  return /* @__PURE__ */ E.jsxs(
    Lh,
    {
      className: ni(
        "bg-surface-critical text-text-primary flex items-center space-x-[12px] rounded-[8px] px-[12px] py-[8px] text-[14px] font-normal leading-[18px]",
        n
      ),
      primaryTheme: r,
      children: [
        /* @__PURE__ */ E.jsx(cJ, { className: "flex-shrink-0 w-[24px] h-[24px]" }),
        /* @__PURE__ */ E.jsx("div", { children: e })
      ]
    }
  );
}
function hp(t) {
  return /* @__PURE__ */ E.jsx(
    aze,
    {
      animation: `${P9} 1s linear infinite`,
      ...t
    }
  );
}
function Lh({
  children: t,
  className: e,
  primaryTheme: n,
  primaryColorBorder: r,
  primaryBg: i
}) {
  const { borderRadius: { inner: a }, colors: { primary: o } } = ca(), s = NL();
  let l = {
    borderRadius: a
  };
  if (r && (l.borderColor = o), n)
    try {
      const c = Pe(o).setAlpha(0.2).toRgbString();
      l.color = o, l.backgroundColor = c;
    } catch {
    }
  else
    i && (l.backgroundColor = o, l.color = s);
  return /* @__PURE__ */ E.jsx(
    "div",
    {
      className: ni("rounded-2xl", e, [r && "border"]),
      style: l,
      children: t
    }
  );
}
function b5e({ close: t }) {
  const { address: e, connector: n } = Ui(), { isCopiedSuccess: r, copyToClipboard: i, setIsCopiedSuccess: a } = c$(), o = n ? Tn.getWalletLogoUrl(n.id) : void 0, s = () => {
    e && (i(e), a(!0), t == null || t());
  };
  return /* @__PURE__ */ E.jsxs(qM, { align: "center", spacing: "8px", children: [
    /* @__PURE__ */ E.jsx(
      Te.img,
      {
        alt: "ens avatar",
        src: o,
        width: "20px",
        height: "20px"
      }
    ),
    e && /* @__PURE__ */ E.jsx(Te.span, { fontSize: "16px", lineHeight: "20px", fontWeight: 600, children: yd(e, 6) }),
    r ? /* @__PURE__ */ E.jsx(hJ, {}) : /* @__PURE__ */ E.jsx(
      cze,
      {
        onClick: s,
        _hover: { color: "text.secondary", cursor: "pointer" }
      }
    )
  ] });
}
function E5e() {
  const { currentNativeToken: t } = Hp(), e = t ? qi(
    t.balance.toBigInt(),
    t.decimals
  ) : null;
  return /* @__PURE__ */ E.jsxs(Vx, { align: "start", className: "space-y-[8px]", children: [
    /* @__PURE__ */ E.jsx(Te.h6, { color: "text.tertiary", fontSize: "14px", lineHeight: "18px", children: "Native Token Balance" }),
    /* @__PURE__ */ E.jsxs(qM, { fontSize: "16px", lineHeight: "20px", spacing: "8px", fontWeight: 600, children: [
      /* @__PURE__ */ E.jsx(
        MJ,
        {
          width: "20px",
          height: "20px",
          src: t == null ? void 0 : t.logoURI
        }
      ),
      /* @__PURE__ */ E.jsxs(qM, { spacing: "4px", children: [
        e && /* @__PURE__ */ E.jsx(
          Te.div,
          {
            maxW: "100px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            children: /* @__PURE__ */ E.jsx("span", { children: fr(e) })
          }
        ),
        t && /* @__PURE__ */ E.jsx("span", { children: t.symbol })
      ] })
    ] })
  ] });
}
function S5e() {
  const { isConnected: t } = Ui();
  return /* @__PURE__ */ E.jsx(Jr, { as: "header", justifyContent: "flex-end", mb: "xs", children: t ? /* @__PURE__ */ E.jsx(x5e, {}) : /* @__PURE__ */ E.jsx(Tze, {}) });
}
function x5e() {
  const { address: t } = Ui(), { disconnect: e } = See(), { chain: n } = lu(), { iframeUrl: r } = SSe(), i = n == null ? void 0 : n.id, a = () => {
    if (!i || !t)
      return;
    const o = Tn.getExplorerUrl(i);
    if (!o)
      return;
    const s = Tn.getAddressExplorerUrl(
      o,
      i,
      t
    );
    window.open(s, "_blank");
  };
  return /* @__PURE__ */ E.jsxs(B9, { placement: "bottom-end", autoSelect: !1, children: [
    /* @__PURE__ */ E.jsx(_9, { as: o5e }),
    /* @__PURE__ */ E.jsxs(X9, { zIndex: 11, children: [
      /* @__PURE__ */ E.jsx(Te.div, { p: "16px", children: /* @__PURE__ */ E.jsx(b5e, {}) }),
      /* @__PURE__ */ E.jsx(hf, {}),
      /* @__PURE__ */ E.jsx(Te.div, { p: "16px", children: /* @__PURE__ */ E.jsx(E5e, {}) }),
      /* @__PURE__ */ E.jsx(hf, {}),
      /* @__PURE__ */ E.jsxs("ul", { children: [
        /* @__PURE__ */ E.jsx(
          rE,
          {
            iconSpacing: "8px",
            icon: /* @__PURE__ */ E.jsx(c2, {}),
            onClick: a,
            children: "View on explorer"
          }
        ),
        /* @__PURE__ */ E.jsx(
          rE,
          {
            iconSpacing: "8px",
            icon: /* @__PURE__ */ E.jsx(lze, {}),
            onClick: () => e(),
            color: "text.critical.default",
            _hover: {
              color: "text.critical.hover"
            },
            children: "Disconnect"
          }
        )
      ] }),
      r && /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
        /* @__PURE__ */ E.jsx(hf, {}),
        /* @__PURE__ */ E.jsxs(
          Te.div,
          {
            fontSize: "12px",
            lineHeight: "16px",
            bg: "surface.1",
            color: "text.tertiary",
            p: "16px",
            children: [
              /* @__PURE__ */ E.jsx(Te.p, { display: "inline", children: "To switch wallet accounts, visit " }),
              /* @__PURE__ */ E.jsx(
                js,
                {
                  display: "inline",
                  fontWeight: 600,
                  onClick: () => gh(YP),
                  children: "widget.xy.finance"
                }
              )
            ]
          }
        )
      ] })
    ] })
  ] });
}
let xT;
const W5e = new Uint8Array(16);
function j5e() {
  if (!xT && (xT = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !xT))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return xT(W5e);
}
const Fr = [];
for (let t = 0; t < 256; ++t)
  Fr.push((t + 256).toString(16).slice(1));
function D5e(t, e = 0) {
  return (Fr[t[e + 0]] + Fr[t[e + 1]] + Fr[t[e + 2]] + Fr[t[e + 3]] + "-" + Fr[t[e + 4]] + Fr[t[e + 5]] + "-" + Fr[t[e + 6]] + Fr[t[e + 7]] + "-" + Fr[t[e + 8]] + Fr[t[e + 9]] + "-" + Fr[t[e + 10]] + Fr[t[e + 11]] + Fr[t[e + 12]] + Fr[t[e + 13]] + Fr[t[e + 14]] + Fr[t[e + 15]]).toLowerCase();
}
const z5e = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Kk = {
  randomUUID: z5e
};
function k5e(t, e, n) {
  if (Kk.randomUUID && !e && !t)
    return Kk.randomUUID();
  t = t || {};
  const r = t.random || (t.rng || j5e)();
  if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, e) {
    n = n || 0;
    for (let i = 0; i < 16; ++i)
      e[n + i] = r[i];
    return e;
  }
  return D5e(r);
}
function w5e() {
  var I;
  const {
    data: t,
    route: e,
    isFetching: n,
    isSuccess: r,
    isPriceImpact: i,
    isRateLimitError: a
  } = yu(), { isNewBuildTx: o, isUserAcceptNewBuildTx: s, isUserProceedPriceImpact: l } = jx(), { navigate: c } = qs(), { address: d, isConnected: u } = Ui(), {
    inputToken: h,
    outputToken: N,
    isInsufficientBalance: M,
    slippage: p,
    isApproving: m,
    isSwapping: R,
    isCrossChain: V,
    isInvalidFromAmount: U,
    slippageError: g,
    isInvalidTokenPair: y
  } = Br(), { switchNetwork: x, isLoading: f } = jee(), { maybeCheckSumReceiverAddress: D, isValidReceiverAddress: Y } = rN(), Q = nN(), { chain: G } = lu(), ne = Wx(), { isNeedToSwitchNetwork: O } = K9(), T = D3e(), Z = async () => {
    if (!(!d || !G || !e || !t)) {
      Q({ type: "SET_IS_SWAPPING", payload: !0 });
      try {
        if (!t.success)
          throw t.error_msg ? new Error(t.error_msg) : new Error("Unexpected error. Can't swap.");
        if (!t.tx)
          throw new Error("tx is not exist.");
        if (!t.route)
          throw new Error("Route is not exist.");
        const { tx: b, route: k } = t, ae = await UO({
          chainId: k.src_chain_id,
          to: b.to,
          value: BigInt(b.value),
          data: b.data
        }), oe = Tn.getExplorerUrl(G.id), { hash: le } = await iee(ae), fe = k5e(), de = k.min_receive_amount ? { minimumReceived: k.min_receive_amount } : {}, Me = {
          id: fe,
          type: "swap",
          chainId: G.id,
          msgSender: d,
          hash: le,
          createdAt: Date.now(),
          inputToken: h,
          outputToken: N,
          inputTokenNumber: qi(
            BigInt(k.src_quote_token_amount),
            k.src_quote_token.decimals
          ),
          outputTokenNumber: qi(
            BigInt(k.dst_quote_token_amount),
            k.dst_quote_token.decimals
          ),
          receiptStatus: null,
          receiptUpdatedAt: null,
          slippage: p,
          explorerUrl: oe,
          isCrossChain: V,
          receiver: D,
          ...de
        };
        ne({
          type: "ADD_TRANSACTION",
          payload: Me
        }), c("/transaction-status", { state: fe });
      } catch (b) {
        console.error("HANDLE_SWAP_ERROR", b);
        const k = new Error("An error occurred in your wallet.");
        return T({ type: "SET_SWAP_ERROR", payload: k }), Promise.reject(b);
      } finally {
        Q({ type: "SET_IS_SWAPPING", payload: !1 });
      }
    }
  }, { isNeedApproved: z, refetch: j } = Wre({
    owner: d,
    spender: e == null ? void 0 : e.contract_address,
    tokenContractAddress: h.address,
    amount: e.src_quote_token_amount,
    chainId: e == null ? void 0 : e.src_chain_id
  }), w = async () => {
    if (!e || !G || h.address === zi)
      return;
    const b = e.contract_address, k = h.address, ae = BigInt(e.src_quote_token_amount);
    Q({ type: "SET_IS_APPROVING", payload: !0 });
    try {
      const { request: oe } = await pO({
        address: k,
        abi: z3,
        functionName: "approve",
        args: [b, ae]
      }), { hash: le } = await Kq(oe);
      if ((await aee({
        hash: le
      })).status === "reverted")
        throw new Error("Transaction reverted");
      await j();
    } catch (oe) {
      const le = new Error("An error occurred in your wallet.");
      throw T({ type: "SET_APPROVE_ERROR", payload: le }), console.error("HANDLE_APPROVE_ERROR"), oe;
    } finally {
      Q({ type: "SET_IS_APPROVING", payload: !1 });
    }
  }, C = (() => n ? {
    status: "ROUTER_BUILD_FETCHING",
    loading: !0,
    content: "Searching Route"
  } : u ? a ? {
    status: "RATE_LIMIT_ERROR",
    disabled: !0,
    content: "Refresh Quote Again"
  } : f ? {
    status: "SWITCHING_NETWORK",
    loading: !0,
    content: "Switching Network..."
  } : O ? {
    status: "NEED_TO_SWITCH_NETWORK",
    onClick: () => x == null ? void 0 : x(parseInt(h.chainId)),
    content: `Switch to ${Tn.getNetworkName(
      h.chainId
    )}`
  } : y ? {
    status: "INPUT_TOKEN_INVALID",
    disabled: !0,
    content: "Invalid Tokens"
  } : U ? {
    status: "INVALID_FROM_AMOUNT",
    disabled: !0,
    content: "Enter amount"
  } : M ? {
    status: "INSUFFICIENT_BALANCE",
    disabled: !0,
    content: "Insufficient Balance"
  } : m ? {
    status: "APPROVING",
    loading: !0,
    content: "Approving..."
  } : R ? {
    status: "SWAPPING",
    loading: !0,
    content: "Swapping..."
  } : o && !s ? {
    status: "NEW_BUILD_TX",
    disabled: !0,
    content: "Swap & Bridge"
  } : i && !l ? {
    status: "PRICE_IMPACT",
    disabled: !0,
    content: "Swap & Bridge"
  } : g ? {
    status: "SLIPPAGE_ERROR",
    disabled: !0,
    content: "Slippage too high"
  } : r ? Y ? z ? {
    status: "NEED_APPROVED",
    onClick: w,
    content: `Approve ${h.symbol} Token`
  } : {
    status: "SWAP",
    onClick: Z,
    content: "Swap & Bridge"
  } : {
    status: "INVALID_RECEIVER_ADDRESS",
    disabled: !0,
    content: "Receiver Invalid"
  } : {
    status: "ROUTER_BUILD_NOT_SUCCESS",
    disabled: !0,
    content: "Build Tx failed"
  } : {
    status: "NOT_CONNECTED",
    onClick: () => c("/connection"),
    content: "Connect wallet"
  })(), { components: J } = ca();
  return /* @__PURE__ */ E.jsx(
    Uu,
    {
      "data-status": C.status,
      onClick: C.onClick,
      size: "xl",
      marginTop: "auto",
      variant: (I = J == null ? void 0 : J.button) == null ? void 0 : I.variant,
      isLoading: C.loading,
      loadingText: C.loading ? C.content : void 0,
      isDisabled: C.disabled,
      children: C.content
    }
  );
}
function F5e() {
  const { address: t } = Ui(), { selectedRoute: e } = aa(), { isFetching: n, route: r } = yu(), i = r || e, { fromInput: a, inputToken: o, outputToken: s, slippage: l } = Br(), [c, d] = nt(!0), { receiverAddress: u } = rN(), h = [
    {
      id: 1,
      label: "Sender",
      content: `${t}`,
      appendItem: null
    },
    {
      id: 2,
      label: "Recipient",
      content: u,
      appendItem: null
    },
    {
      id: 3,
      label: "Exchange Rate",
      content: "-",
      appendItem: null
    },
    {
      id: 4,
      label: "Withholding Fee",
      tooltip: "Withholding Fee is used to cover the destination gas fee.",
      content: "",
      appendItem: null
    }
  ], [N, M] = dY(
    h
  );
  Ee(() => {
    i && M((m) => {
      const R = Number(
        qi(
          BigInt(i.src_quote_token_amount),
          o.decimals
        )
      ), V = Number(
        qi(
          BigInt(i.dst_quote_token_amount),
          i.dst_quote_token.decimals
        )
      ), U = fr(V / R), g = fr(R / V), y = `1 ${o.symbol} = ${U} ${s.symbol}`, x = `1 ${s.symbol} = ${g} ${o.symbol}`;
      m[2].content = c ? y : x, m[2].appendItem = /* @__PURE__ */ E.jsx(
        uJ,
        {
          color: "text.interaction.default",
          cursor: "pointer",
          _hover: {
            color: "text.interaction.hover"
          },
          onClick: () => d(!c)
        }
      ), i.withholding_fee_amount && i.withholding_fee_token.symbol && i.withholding_fee_amount !== "0" && (m[3].content = `${fr(
        i.withholding_fee_amount,
        i.withholding_fee_token.decimals
      )} ${i.withholding_fee_token.symbol}`);
    });
  }, [c, l]);
  const p = n || a === "" ? h : N;
  return /* @__PURE__ */ E.jsx(Lh, { className: "bg-surface-1 space-y-[12px] p-[12px]", children: p.map((m) => m.content && /* @__PURE__ */ E.jsxs(
    Jr,
    {
      alignItems: "center",
      justifyContent: "space-between",
      fontSize: "14px",
      lineHeight: "18px",
      children: [
        /* @__PURE__ */ E.jsxs(
          Ae,
          {
            color: "text.secondary",
            direction: "row",
            alignItems: "center",
            spacing: "4px",
            children: [
              /* @__PURE__ */ E.jsx(Mt, { as: "span", children: m.label }),
              m.tooltip && /* @__PURE__ */ E.jsx(
                Um,
                {
                  borderRadius: "inner",
                  px: "10px",
                  py: "8px",
                  hasArrow: !0,
                  label: m.tooltip,
                  placement: "top",
                  children: /* @__PURE__ */ E.jsx(
                    Px,
                    {
                      w: "16px",
                      h: "16px",
                      color: "text.secondary"
                    }
                  )
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ E.jsxs(
          Ae,
          {
            color: "text.primary",
            direction: "row",
            spacing: "4px",
            alignItems: "center",
            children: [
              /* @__PURE__ */ E.jsx(Mt, { children: m.content }),
              m.appendItem
            ]
          }
        )
      ]
    },
    m.label
  )) });
}
function v5e() {
  const { selectedRoute: t } = aa(), { isFetching: e, refetch: n, dataUpdatedAt: r, isSuccess: i } = yu(), a = dL(), o = t === null, s = async () => {
    o || (await (n == null ? void 0 : n()), i && (a({
      type: "SET_IS_NEW_BUILD_TX",
      payload: !0
    }), a({
      type: "SET_IS_USER_ACCEPT_NEW_BUILD_TX",
      payload: !1
    }), a({
      type: "SET_IS_USER_PROCEED_PRICE_IMPACT",
      payload: !1
    })));
  };
  n1(
    () => {
      s();
    },
    e ? null : Py
  );
  const l = {
    loading: !!e,
    disabled: o,
    startCountDown: !e && r !== 0,
    isHideCountDownStroke: o || r === 0 || !!e,
    handleRefetch: s,
    duration: Py / 1e3
  };
  return /* @__PURE__ */ E.jsxs("div", { className: "flex justify-between", children: [
    /* @__PURE__ */ E.jsx(hN, { title: "Confirmation" }),
    /* @__PURE__ */ E.jsx(s5e, { ...l })
  ] });
}
function I5e() {
  var r;
  const { isRateLimitError: t, errors: e } = yu(), n = ((r = e[1]) == null ? void 0 : r.message) ?? "";
  return t && n && /* @__PURE__ */ E.jsx(nW, { className: "mt-[-8px]", primaryTheme: !0, children: n });
}
function O5e() {
  const { route: t, isPriceImpact: e } = yu(), { isNewBuildTx: n, isUserAcceptNewBuildTx: r, isUserProceedPriceImpact: i } = jx(), a = dL(), { isDarkMode: o } = ca(), s = e && !i, l = !s && n && !r, c = () => {
    a({
      type: "SET_IS_USER_ACCEPT_NEW_BUILD_TX",
      payload: !0
    });
  }, d = () => {
    a({
      type: "SET_IS_USER_ACCEPT_NEW_BUILD_TX",
      payload: !0
    }), a({
      type: "SET_IS_USER_PROCEED_PRICE_IMPACT",
      payload: !0
    });
  }, u = (() => {
    if (!t)
      return "";
    const { dst_quote_token_amount: N, dst_quote_token: M, dst_chain_id: p } = t, m = Tn.getNetworkName(p), R = ws(
      BigInt(N),
      M.decimals
    );
    return `${fr(R)} ${M.symbol} on ${m}`;
  })(), h = (() => !t || !t.bridge_description || !t.bridge_description.provider ? !1 : t.bridge_description.provider === ci.SYNAPSE)();
  return !t || !(l || s || h) ? null : /* @__PURE__ */ E.jsxs("div", { className: ni("space-y-[8px] mb-[-8px]", [!o && "text-white"]), children: [
    l && /* @__PURE__ */ E.jsxs(Lh, { className: "bg-surface-highlight rounded-inner flex flex-row items-center justify-between space-x-[12px] px-[12px] py-[8px]", primaryBg: !0, children: [
      /* @__PURE__ */ E.jsxs("p", { className: "text-[14px]/[18px]", children: [
        "The quote has changed. Do you accept the new quote ",
        /* @__PURE__ */ E.jsxs("span", { className: "font-semibold", children: [
          u,
          " ?"
        ] })
      ] }),
      /* @__PURE__ */ E.jsx(
        Xk,
        {
          onClick: c,
          className: "px-[12px] py-[8px] font-semibold",
          primaryBg: !0,
          secondaryBorder: !0,
          children: "Accept"
        }
      )
    ] }),
    s && /* @__PURE__ */ E.jsxs(Lh, { className: "bg-surface-critical rounded-inner flex flex-row items-center justify-between space-x-[12px] px-[12px] py-[8px]", children: [
      /* @__PURE__ */ E.jsxs("p", { className: "text-[14px]/[18px]", children: [
        "The price has a significant impact. You will receive ",
        /* @__PURE__ */ E.jsx("span", { className: "font-semibold", children: u }),
        ". Would you like to proceed with the transaction?"
      ] }),
      /* @__PURE__ */ E.jsx(
        Xk,
        {
          onClick: d,
          className: "outline outline-[1px] outline-secondaryButton-border-grey px-[12px] py-[8px] font-semibold",
          children: "Proceed"
        }
      )
    ] }),
    h && /* @__PURE__ */ E.jsx(nW, { primaryTheme: !0, children: "This transaction will be bridged by Synapse, the actual bridge fee might slightly differ from the displayed value due to slippage." })
  ] });
}
function $k({
  header: t,
  token: e,
  value: n,
  amount: r,
  amountTextColor: i = "text-text-primary",
  loading: a = !1,
  amountStyle: o = {}
}) {
  const s = e.symbol ? e.symbol : "-", l = e.chainId ? Tn.getNetworkName(e.chainId) : "-", c = r ? qi(BigInt(r), e.decimals) : "-", d = n ? `≈ $ ${fr(n)}` : "-";
  return /* @__PURE__ */ E.jsxs("div", { className: "space-y-[4px]", children: [
    /* @__PURE__ */ E.jsx("p", { className: "text-text-secondary text-[12px]/[16px]", children: t }),
    /* @__PURE__ */ E.jsxs("div", { className: "flex items-center justify-between space-x-[24px]", children: [
      /* @__PURE__ */ E.jsxs("div", { className: "flex space-x-[12px]", children: [
        /* @__PURE__ */ E.jsx(cp, { token: e }),
        /* @__PURE__ */ E.jsxs("div", { children: [
          /* @__PURE__ */ E.jsx("p", { className: "text-text-primary text-[18px]/[22px] font-semibold", children: s }),
          /* @__PURE__ */ E.jsx("span", { className: "text-[12px]/[14px]", children: l })
        ] })
      ] }),
      /* @__PURE__ */ E.jsx("div", { className: "flex-1", children: a ? /* @__PURE__ */ E.jsxs("div", { className: "flex w-full flex-col items-end h-[48px]", children: [
        /* @__PURE__ */ E.jsx(np, { startColor: "surface.4", endColor: "text.placeholder", width: "100%", maxW: "300px", h: "24px", borderRadius: "8px" }),
        /* @__PURE__ */ E.jsx(np, { startColor: "surface.4", endColor: "text.placeholder", width: "100%", maxW: "300px", h: "16px", borderRadius: "8px" })
      ] }) : /* @__PURE__ */ E.jsxs("div", { className: "text-right", children: [
        /* @__PURE__ */ E.jsx(
          "p",
          {
            className: ni(
              "text-[20px]/[24px] font-semibold",
              i
            ),
            style: o,
            children: c
          }
        ),
        /* @__PURE__ */ E.jsx("span", { className: "text-text-tertiary text-[12px]/[16px]", children: d })
      ] }) })
    ] })
  ] });
}
const Y5e = ({ text: t = "Best Price" }) => /* @__PURE__ */ E.jsx(Lh, { className: "px-[12px] py-[4px] text-[14px]/[18px] flex items-center w-fit", primaryTheme: !0, children: t }), Q5e = ({ provider: t = "" }) => {
  const e = Tn.getBridgeLogoUrl(t), n = Tn.getBridgeName(t);
  return n && /* @__PURE__ */ E.jsxs("div", { className: "flex items-center space-x-[4px] text-[14px]/[18px]", children: [
    /* @__PURE__ */ E.jsx("span", { children: "Bridge by" }),
    /* @__PURE__ */ E.jsx("img", { src: e, className: "w-[16px] h-[16px]" }),
    /* @__PURE__ */ E.jsx("span", { children: n })
  ] });
};
function G5e() {
  var V, U;
  const { selectedRoute: t } = aa(), { route: e, isFetching: n, isPriceImpact: r } = yu(), { colors: { primary: i } } = ca(), { tokenList: a } = Hp(), { isNewBuildTx: o } = jx(), s = e || t, l = (V = s == null ? void 0 : s.bridge_description) == null ? void 0 : V.provider, c = ((U = s == null ? void 0 : s.route_type) == null ? void 0 : U.indexOf("single_chain")) > -1, d = (() => {
    if (s) {
      if (r)
        return "text-text-critical";
      if (o)
        return "text-text-interaction";
    } else
      return "text-text-primary";
    return "text-text-primary";
  })(), u = (() => s ? o ? { color: i } : {} : {})(), h = (() => s ? $y(
    {
      address: s.src_quote_token.address,
      chainId: String(s.src_quote_token.chain_id)
    },
    a
  ) || new Ei() : new Ei())(), N = s == null ? void 0 : s.src_quote_token_usd_value, M = s == null ? void 0 : s.src_quote_token_amount, p = (() => s ? $y(
    {
      address: s.dst_quote_token.address,
      chainId: String(s.dst_quote_token.chain_id)
    },
    a
  ) || new Ei() : new Ei())(), m = s == null ? void 0 : s.dst_quote_token_usd_value, R = s == null ? void 0 : s.dst_quote_token_amount;
  return /* @__PURE__ */ E.jsxs(Lh, { className: "space-y-[20px] p-[16px] bg-surface-1", primaryColorBorder: !0, children: [
    /* @__PURE__ */ E.jsxs("div", { className: "flex justify-between", children: [
      /* @__PURE__ */ E.jsx(Y5e, {}),
      !c && /* @__PURE__ */ E.jsx(Q5e, { provider: l })
    ] }),
    /* @__PURE__ */ E.jsx(
      $k,
      {
        token: h,
        value: N,
        amount: M,
        header: "From"
      }
    ),
    /* @__PURE__ */ E.jsx(
      $k,
      {
        amountTextColor: d,
        amountStyle: u,
        loading: n,
        token: p,
        value: m,
        amount: R,
        header: "To (Quote)"
      }
    )
  ] });
}
function hN({
  title: t = "Default Page",
  type: e = "back",
  navigatePath: n
}) {
  const { navigate: r, navigateBack: i } = qs(), a = () => n ? r(n) : i();
  return /* @__PURE__ */ E.jsx(
    Ae,
    {
      direction: "row",
      spacing: "16px",
      justifyContent: e === "close" ? "space-between" : void 0,
      children: e === "close" ? /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
        /* @__PURE__ */ E.jsx(xh, { fontSize: "24px", fontWeight: "semibold", lineHeight: "30px", children: t }),
        /* @__PURE__ */ E.jsx(
          Oh,
          {
            onClick: a,
            icon: /* @__PURE__ */ E.jsx(tze, {})
          }
        )
      ] }) : /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
        /* @__PURE__ */ E.jsx(
          Oh,
          {
            onClick: a,
            icon: /* @__PURE__ */ E.jsx(q4e, {})
          }
        ),
        /* @__PURE__ */ E.jsx(xh, { fontSize: "24px", fontWeight: "semibold", lineHeight: "30px", children: t })
      ] })
    }
  );
}
function C5e() {
  const { isConnected: t } = Ui(), { navigate: e } = qs(), { isFetching: n, refetch: r } = aa(), { isSwapTransactionProcessing: i } = qU(), { slippage: a, fromInput: o } = Br(), s = () => {
    r == null || r();
  }, l = [
    t ? {
      id: "History",
      onClick: () => e("/transaction-history"),
      icon: /* @__PURE__ */ E.jsx(Nze, { width: "20px", height: "20px" }),
      loading: !1,
      showUpdate: i
    } : null,
    {
      id: "Setting",
      onClick: () => e("/setting"),
      icon: /* @__PURE__ */ E.jsx(dze, { width: "20px", height: "20px" }),
      loading: !1,
      showUpdate: a !== "1"
    },
    {
      id: "Refresh",
      onClick: s,
      icon: /* @__PURE__ */ E.jsx(hze, { width: "20px", height: "20px" }),
      disabled: o === "",
      loading: n,
      showUpdate: !1
    }
  ];
  return /* @__PURE__ */ E.jsxs(Jr, { justifyContent: "space-between", children: [
    /* @__PURE__ */ E.jsx(xh, { as: "h5", fontSize: "xl", fontWeight: "semibold", lineHeight: "lg", children: "Swap & Bridge" }),
    /* @__PURE__ */ E.jsx(Ae, { direction: "row", spacing: "xs", children: l.map((c) => c && /* @__PURE__ */ E.jsx(
      Um,
      {
        borderRadius: "base",
        hasArrow: !0,
        label: c.id,
        placement: "top",
        children: /* @__PURE__ */ E.jsx(
          Oh,
          {
            loading: c.loading,
            disabled: c.disabled,
            showUpdate: c.showUpdate,
            icon: c.icon,
            onClick: c.onClick
          }
        )
      },
      c.id
    )) })
  ] });
}
function rW({
  leftIcon: t = /* @__PURE__ */ E.jsx(nze, { flexShrink: 0, width: "24px", height: "24px" }),
  bgColor: e = "surface.1",
  color: n = "text.tertiary",
  children: r
}) {
  return /* @__PURE__ */ E.jsxs(
    Ae,
    {
      color: n,
      bgColor: e,
      borderRadius: "inner",
      direction: "row",
      alignItems: "center",
      spacing: "10px",
      px: "12px",
      py: "8px",
      children: [
        t,
        r
      ]
    }
  );
}
function L5e() {
  const {
    data: t,
    isFetching: e,
    dataUpdatedAt: n,
    selectedRoute: r,
    formatedSelectedRouteTokenNumber: i
  } = aa(), { fromInput: a, inputToken: o, outputToken: s, slippage: l } = Br(), [c, d] = nt(!0), u = [
    {
      id: 1,
      label: "Exchange Rate",
      content: "-",
      appendItem: null
    },
    {
      id: 2,
      label: "Withholding Fee",
      tooltip: "Withholding Fee is used to cover the destination gas fee.",
      content: "",
      appendItem: null
    }
  ], [h, N] = dY(
    u
  );
  Ee(() => {
    !t || !r || !i || N((p) => {
      const m = Number(
        qi(
          BigInt(r.src_quote_token_amount),
          o.decimals
        )
      ), R = Number(i), V = fr(R / m), U = fr(m / R), g = `1 ${o.symbol} = ${V} ${s.symbol}`, y = `1 ${s.symbol} = ${U} ${o.symbol}`;
      p[0].content = c ? g : y, p[0].appendItem = /* @__PURE__ */ E.jsx(
        uJ,
        {
          color: "text.interaction.default",
          cursor: "pointer",
          _hover: {
            color: "text.interaction.hover"
          },
          onClick: () => d(!c)
        }
      ), r.withholding_fee_amount && r.withholding_fee_token.symbol && r.withholding_fee_amount !== "0" && (p[1].content = `${fr(
        r.withholding_fee_amount,
        r.withholding_fee_token.decimals
      )} ${r.withholding_fee_token.symbol}`);
    });
  }, [n, c, l]);
  const M = e || a === "" ? u : h;
  return /* @__PURE__ */ E.jsx(Ae, { as: "ul", spacing: "12px", children: M.map((p) => p.content && /* @__PURE__ */ E.jsxs(
    Jr,
    {
      alignItems: "center",
      justifyContent: "space-between",
      fontSize: "14px",
      lineHeight: "18px",
      children: [
        /* @__PURE__ */ E.jsxs(
          Ae,
          {
            color: "text.secondary",
            direction: "row",
            alignItems: "center",
            spacing: "4px",
            children: [
              /* @__PURE__ */ E.jsx(Mt, { as: "span", children: p.label }),
              p.tooltip && /* @__PURE__ */ E.jsx(
                Um,
                {
                  borderRadius: "inner",
                  px: "10px",
                  py: "8px",
                  hasArrow: !0,
                  label: p.tooltip,
                  placement: "top",
                  children: /* @__PURE__ */ E.jsx(
                    Px,
                    {
                      w: "16px",
                      h: "16px",
                      color: "text.secondary"
                    }
                  )
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ E.jsxs(
          Ae,
          {
            color: "text.primary",
            direction: "row",
            spacing: "4px",
            alignItems: "center",
            children: [
              /* @__PURE__ */ E.jsx(Mt, { children: p.content }),
              p.appendItem
            ]
          }
        )
      ]
    },
    p.label
  )) });
}
function J5e({ locked: t, ...e }) {
  const n = {
    bgColor: "surface.0",
    borderColor: "surface.0",
    borderWidth: "1px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: "full",
    p: "4px",
    display: "inline-block"
  }, r = t ? {
    cursor: "not-allowed",
    color: "text.interaction.disable"
  } : {
    cursor: "pointer",
    color: "text.interaction.default",
    _hover: {
      color: "text.interaction.hover"
    }
  }, i = nN(), { formatedSelectedRouteTokenNumber: a } = aa(), o = () => {
    t || i({
      type: "SWITCH_TOKENS",
      payload: a || ""
    });
  };
  return /* @__PURE__ */ E.jsx(Mr, { ...n, ...r, onClick: o, ...e, children: /* @__PURE__ */ E.jsx(eze, {}) });
}
function B5e() {
  const { disableTokenSelection: t } = Lo(), { inputToken: e } = Br(), n = nN(), r = ws(e.balance, e.decimals), i = fr(r, 6), a = t === "from" || t === "both", o = t === "to" || t === "both", s = t === "both" || t === "from" || t === "to", l = () => {
    e.balance.isZero() || n({
      type: "SET_FROM_INPUT",
      payload: r
    });
  };
  return /* @__PURE__ */ E.jsxs(Ae, { spacing: "8px", children: [
    /* @__PURE__ */ E.jsxs(Ae, { direction: "row", justifyContent: "end", spacing: "8px", children: [
      /* @__PURE__ */ E.jsxs(Mt, { color: "text.secondary", children: [
        "Balance: ",
        i
      ] }),
      /* @__PURE__ */ E.jsx(js, { onClick: l, children: "Max" })
    ] }),
    /* @__PURE__ */ E.jsxs(Mr, { position: "relative", children: [
      /* @__PURE__ */ E.jsx(A5e, { locked: a }),
      /* @__PURE__ */ E.jsx(J5e, { locked: s }),
      /* @__PURE__ */ E.jsx(H5e, { locked: o })
    ] })
  ] });
}
function A5e({ locked: t }) {
  const e = nN(), { navigate: n } = qs(), { inputToken: r, fromInput: i } = Br(), { isFetching: a, selectedRoute: o } = aa(), s = (() => a ? `≈ $ ${fr(0)}` : (o == null ? void 0 : o.src_quote_token_usd_value) === "0" ? "price unknown" : o ? `≈ $ ${fr(o.src_quote_token_usd_value, 2)}` : `≈ $ ${fr(0)}`)(), l = (d) => {
    const { value: u } = d.target;
    XK.test(u) && e({
      type: "SET_FROM_INPUT",
      payload: u
    });
  }, c = () => {
    t || n("/select-token", { state: "inputToken" });
  };
  return /* @__PURE__ */ E.jsx(
    UJ,
    {
      header: "From",
      footer: s,
      locked: t,
      onSelect: c,
      token: r,
      variant: "from",
      children: /* @__PURE__ */ E.jsx(
        aR,
        {
          onChange: l,
          value: i,
          type: "text",
          _placeholder: {
            color: "text.disable"
          },
          fontSize: "24px",
          fontWeight: "semibold",
          lineHeight: "30px",
          width: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          placeholder: "0.0"
        }
      )
    }
  );
}
function H5e({ locked: t }) {
  const { navigate: e } = qs(), { outputToken: n } = Br(), { isFetching: r, selectedRoute: i, formatedSelectedRouteTokenNumber: a } = aa(), o = (() => r ? `≈ $ ${fr(0)}` : (i == null ? void 0 : i.dst_quote_token_usd_value) === "0" ? "price unknown" : i ? `≈ $ ${fr(i.dst_quote_token_usd_value, 2)}` : `≈ $ ${fr(0)}`)(), s = () => {
    t || e("/select-token", { state: "outputToken" });
  };
  return /* @__PURE__ */ E.jsx(
    UJ,
    {
      header: "To (Quote)",
      footer: o,
      locked: t,
      onSelect: s,
      token: n,
      variant: "to",
      loading: r,
      children: /* @__PURE__ */ E.jsx(
        Mt,
        {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontSize: "24px",
          fontWeight: "semibold",
          lineHeight: "30px",
          children: a || fr(0)
        }
      )
    }
  );
}
function X5e() {
  const { receiverAddress: t, isValidReceiverAddress: e, receiverError: n } = rN(), { outputToken: r } = Br(), i = Ure(), [a, o] = nt(!e), [s, l] = nt(!1), [c] = Ch(), d = (N) => {
    i({ type: "SET_RECEIVER_ADDRESS", payload: N.target.value });
  }, u = () => {
    navigator.clipboard.readText().then((N) => {
      l(!0), i({ type: "SET_RECEIVER_ADDRESS", payload: N }), setTimeout(() => l(!1), 3e3);
    });
  }, h = () => {
    n || o(!a);
  };
  return t ? /* @__PURE__ */ E.jsxs(Ae, { spacing: "8px", ref: c, children: [
    /* @__PURE__ */ E.jsxs(Jr, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ E.jsx(Mt, { color: "text.secondary", fontSize: "14px", lineHeight: "18px", children: "Recipient Address" }),
      /* @__PURE__ */ E.jsxs(
        Ae,
        {
          as: "button",
          direction: "row",
          spacing: "4px",
          color: "text.interaction.default",
          display: "flex",
          alignItems: "center",
          fontSize: "14px",
          lineHeight: "18px",
          _hover: {
            color: "text.interaction.hover"
          },
          onClick: h,
          children: [
            /* @__PURE__ */ E.jsx(Mt, { children: "Change Recipient" }),
            /* @__PURE__ */ E.jsx(
              Kx,
              {
                w: "18px",
                h: "18px",
                transform: a ? "rotate(180deg)" : void 0
              }
            )
          ]
        }
      )
    ] }),
    a && /* @__PURE__ */ E.jsxs(Ae, { spacing: "4px", pb: "12px", children: [
      /* @__PURE__ */ E.jsx(
        Mr,
        {
          borderRadius: "inner",
          p: "16px",
          bgColor: "surface.1",
          outline: e ? void 0 : "1px solid",
          outlineColor: e ? void 0 : "text.critical.default",
          children: /* @__PURE__ */ E.jsxs(Ae, { direction: "row", alignItems: "center", spacing: "8px", children: [
            /* @__PURE__ */ E.jsx(
              aR,
              {
                w: "full",
                fontSize: "14px",
                lineHeight: "18px",
                value: t,
                onChange: d
              }
            ),
            s ? /* @__PURE__ */ E.jsx(hJ, { h: "19px", w: "19px" }) : /* @__PURE__ */ E.jsx(js, { onClick: u, children: "Paste" })
          ] })
        }
      ),
      /* @__PURE__ */ E.jsx(
        Mt,
        {
          fontSize: "12px",
          lineHeight: "16px",
          color: e ? "text.tertiary" : "text.critical.default",
          children: e ? "Verify this address. Exchange addresses are NOT allowed!" : `Please enter ${bo.getNetworkName(
            r.chainId
          )} address to receive ${r.name}`
        }
      )
    ] })
  ] }) : null;
}
function _5e() {
  const { errors: t } = K9(), { errors: e, isFetching: n } = aa(), { errors: r } = rN(), {
    errors: i,
    inputToken: a,
    sourceChainName: o,
    destinationChainName: s,
    boundStatusCode: l,
    outputToken: c
  } = Br(), { gasFeeStatusCode: d } = Sre(), { nativeTokens: u } = Hp(), h = n ? [] : [
    ...t,
    ...e,
    ...r,
    ...i
  ].filter((R) => R !== null), N = d === os.GAS_FEE_NOT_ENOUGH, M = u[a.chainId], p = N && /* @__PURE__ */ E.jsxs(Mt, { fontSize: "14px", lineHeight: "18px", children: [
    "Tip: You may not have enough gas to complete the swap. You can try to swap or add more",
    /* @__PURE__ */ E.jsxs(Mt, { as: "span", fontWeight: "semibold", children: [
      " ",
      M.symbol,
      " "
    ] }),
    "on",
    /* @__PURE__ */ E.jsxs(Mt, { as: "span", fontWeight: "semibold", children: [
      " ",
      o,
      " "
    ] }),
    "before swapping."
  ] }), m = (() => {
    if (!AP.includes(c.chainId))
      return null;
    switch (l) {
      case ps.NO_NEED_TO_CHECK_BOUND:
      case ps.LESS_THAN_FIRST_BOUND:
        return null;
      case ps.BETWEEN_OR_EQUAL_FIRST_AND_SECOND_BOUND:
        return /* @__PURE__ */ E.jsxs(Mt, { fontSize: "14px", lineHeight: "18px", children: [
          "Your transaction may be delayed for 30 minutes or longer due to network congestion on the",
          /* @__PURE__ */ E.jsxs(Mt, { fontWeight: "semibold", as: "span", children: [
            " ",
            s
          ] }),
          "."
        ] });
      case ps.GREATER_THAN_EQUAL_SECOND_BOUND:
        return /* @__PURE__ */ E.jsxs(Mt, { fontSize: "14px", lineHeight: "18px", children: [
          "Your transaction may encounter delays of an",
          /* @__PURE__ */ E.jsxs(Mt, { fontWeight: "semibold", as: "span", children: [
            " ",
            "uncertain duration",
            " "
          ] }),
          "due to network congestion on the",
          /* @__PURE__ */ E.jsxs(Mt, { fontWeight: "semibold", as: "span", children: [
            " ",
            s
          ] }),
          "."
        ] });
    }
  })();
  return /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
    h.length > 0 && /* @__PURE__ */ E.jsx(ZE, { children: /* @__PURE__ */ E.jsx(Mr, { fontSize: "14px", lineHeight: "18px", children: h[0].message }) }),
    m && /* @__PURE__ */ E.jsx(ZE, { children: m }),
    p && /* @__PURE__ */ E.jsx(rW, { children: p })
  ] });
}
function P5e() {
  var p;
  const [t, e] = nt(!1), { isFetching: n, isSuccess: r } = aa(), { navigate: i } = qs(), { isConnected: a } = Ui(), {
    isInsufficientBalance: o,
    isInvalidFromAmount: s,
    slippageError: l,
    isInvalidTokenPair: c
  } = Br(), { isValidReceiverAddress: d } = rN(), { refetch: u } = yu(), h = async () => {
    e(!0);
    try {
      await u(), i("/confirmation");
    } catch (m) {
      console.error("HANDLE_CONFIRMATION_ERROR", m);
    } finally {
      e(!1);
    }
  }, N = (() => t ? {
    status: "CONFIRMING",
    loading: !0,
    content: "Confirming"
  } : n ? {
    status: "QUOTE_FETCHING",
    loading: !0,
    content: "Searching Route ..."
  } : a ? c ? {
    status: "INPUT_TOKEN_INVALID",
    disabled: !0,
    content: "Invalid Tokens"
  } : s ? {
    status: "INVALID_FROM_AMOUNT",
    disabled: !0,
    content: "Enter amount"
  } : o ? {
    status: "INSUFFICIENT_BALANCE",
    disabled: !0,
    content: "Insufficient Balance"
  } : l ? {
    status: "SLIPPAGE_ERROR",
    disabled: !0,
    content: "Slippage too high"
  } : r ? d ? {
    status: "SWAP",
    onClick: h,
    content: "Swap & Bridge"
  } : {
    status: "INVALID_RECEIVER_ADDRESS",
    disabled: !0,
    content: "Receiver Invalid"
  } : {
    status: "QUOTE_NOT_SUCCESS",
    disabled: !0,
    content: "Quote failed"
  } : {
    status: "NOT_CONNECTED",
    onClick: () => i("connection"),
    content: "Connect wallet"
  })(), { components: M } = ca();
  return /* @__PURE__ */ E.jsx(
    Uu,
    {
      "data-status": N.status,
      onClick: N.onClick,
      size: "xl",
      variant: (p = M == null ? void 0 : M.button) == null ? void 0 : p.variant,
      isLoading: N.loading,
      loadingText: N.loading ? N.content : void 0,
      isDisabled: N.disabled,
      children: N.content
    }
  );
}
function UJ({
  header: t = "",
  footer: e = "",
  children: n,
  locked: r,
  onSelect: i,
  token: a,
  loading: o
}) {
  return /* @__PURE__ */ E.jsxs(
    Ae,
    {
      direction: "row",
      borderRadius: "inner",
      mb: "4px",
      justifyContent: "space-between",
      spacing: "4px",
      px: "16px",
      py: "12px",
      bgColor: "surface.1",
      children: [
        /* @__PURE__ */ E.jsxs(Mr, { maxW: ["120px", "220px"], children: [
          /* @__PURE__ */ E.jsx(Mt, { color: "text.secondary", fontSize: "12px", lineHeight: "16px", children: t }),
          /* @__PURE__ */ E.jsx(Mr, { position: "relative", mb: "2px", mt: "8px", children: o ? /* @__PURE__ */ E.jsx(
            np,
            {
              startColor: "surface.4",
              endColor: "text.disalbe",
              w: "220px",
              h: "30px"
            }
          ) : n }),
          o ? /* @__PURE__ */ E.jsx(
            np,
            {
              startColor: "surface.4",
              endColor: "text.disalbe",
              w: "60px",
              h: "16px"
            }
          ) : /* @__PURE__ */ E.jsx(
            Mt,
            {
              color: "text.tertiary",
              fontSize: "12px",
              lineHeight: "16px",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              children: e
            }
          )
        ] }),
        /* @__PURE__ */ E.jsx(l5e, { locked: r, onClick: i, token: a })
      ]
    }
  );
}
function K5e({ chain: t, active: e = !1, onClick: n }) {
  const r = {
    h: "84px",
    w: "72px",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "8px",
    px: "8px",
    py: "12px"
  }, i = e ? {
    bgColor: "surface.active",
    border: "1px solid",
    borderColor: "border.active",
    cursor: "not-allowed"
  } : {
    cursor: "pointer",
    bgColor: "surface.1",
    _hover: { bgColor: "surface.3" }
  };
  return /* @__PURE__ */ E.jsxs(
    Ae,
    {
      direction: "column",
      spacing: "12px",
      onClick: () => n == null ? void 0 : n(t.id),
      ...r,
      ...i,
      children: [
        /* @__PURE__ */ E.jsx(
          qd,
          {
            maxH: "32px",
            maxW: "32px",
            src: Tn.getNetworkLogoUrl(t.id)
          }
        ),
        /* @__PURE__ */ E.jsx(
          Mt,
          {
            as: "span",
            maxW: "56px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontSize: "12px",
            lineHeight: "16px",
            children: Tn.getNetworkName(t.id)
          }
        )
      ]
    }
  );
}
function $5e({ active: t = !1, onClick: e }) {
  const n = {
    h: "84px",
    w: "72px",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "8px",
    px: "8px",
    py: "12px"
  }, r = t ? {
    bgColor: "surface.active",
    border: "1px solid",
    borderColor: "border.active",
    cursor: "not-allowed"
  } : {
    cursor: "pointer",
    bgColor: "surface.1",
    _hover: { bgColor: "surface.3" }
  };
  return /* @__PURE__ */ E.jsx(
    Ae,
    {
      direction: "column",
      spacing: "12px",
      onClick: () => e(null),
      ...n,
      ...r,
      children: /* @__PURE__ */ E.jsx(
        Mt,
        {
          as: "span",
          maxW: "56px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontSize: "12px",
          lineHeight: "16px",
          children: "All"
        }
      )
    }
  );
}
function q5e({
  selectedChainId: t,
  onClickNetworkItem: e
}) {
  const [n] = Ch(), { enabledChains: r } = Lo(), i = 5, a = r.length > i, [o, s] = nt(!1), l = r.find(
    (u) => u.id === t
  ), c = (() => !l || o ? r : [
    l,
    ...r.slice(0, i).filter((u) => u.id !== t)
  ])(), d = (u) => {
    e(u), s(!1);
  };
  return /* @__PURE__ */ E.jsxs(Ae, { spacing: "24px", children: [
    /* @__PURE__ */ E.jsxs(
      Jr,
      {
        ref: n,
        as: "ul",
        flexWrap: "wrap",
        gap: "8px",
        overflow: "hidden",
        h: o ? void 0 : "84px",
        children: [
          /* @__PURE__ */ E.jsx(
            $5e,
            {
              active: t === null,
              onClick: () => {
                d(null);
              }
            }
          ),
          c.map((u) => Tn.isPreLaunch(u.id) ? null : /* @__PURE__ */ E.jsx(
            K5e,
            {
              onClick: (h) => d(h),
              active: u.id === t,
              chain: u
            },
            u.id
          ))
        ]
      }
    ),
    a && /* @__PURE__ */ E.jsxs(
      Ae,
      {
        color: "button.grey.text.enable",
        bgColor: "button.grey.background.enable",
        _hover: {
          color: "button.grey.text.hover",
          bgColor: "button.grey.background.hover"
        },
        borderRadius: "inner",
        cursor: "pointer",
        alignItems: "center",
        justifyContent: "center",
        direction: "row",
        spacing: "10px",
        px: "8px",
        py: "12px",
        onClick: () => s(!o),
        children: [
          /* @__PURE__ */ E.jsx(Mt, { fontSize: "16px", fontWeight: "semibold", lineHeight: "20px", children: o ? "Less" : "More" }),
          /* @__PURE__ */ E.jsx(
            Kx,
            {
              transform: o ? "rotate(180deg)" : void 0
            }
          )
        ]
      }
    )
  ] });
}
function RJ({ token: t, active: e, onClick: n }) {
  const r = {
    p: "12px",
    borderRadius: "8px",
    justifyContent: "space-between",
    alignItems: "center"
  }, i = e ? {
    bgColor: "surface.active",
    border: "1px solid",
    borderColor: "border.active",
    cursor: "not-allowed"
  } : {
    cursor: "pointer",
    _hover: {
      bgColor: "surface.3"
    }
  }, a = ws(t.balance, t.decimals), o = fr(a, 6);
  return /* @__PURE__ */ E.jsxs(
    Jr,
    {
      as: "ul",
      ...r,
      ...i,
      onClick: () => n == null ? void 0 : n(t),
      children: [
        /* @__PURE__ */ E.jsx(cp, { light: e, showText: !0, token: t }),
        /* @__PURE__ */ E.jsx(Mt, { as: "span", color: "text-default", fontSize: "14px", lineHeight: "18px", children: o })
      ]
    }
  );
}
function qk({
  selectedChainId: t,
  tokens: e,
  getActive: n,
  onSelectToken: r
}) {
  const i = t === null ? "All" : Tn.getNetworkName(t);
  return /* @__PURE__ */ E.jsxs(Ae, { spacing: "4px", children: [
    i && /* @__PURE__ */ E.jsxs(Mt, { fontSize: "14px", lineHeight: "18px", children: [
      "on ",
      i
    ] }),
    /* @__PURE__ */ E.jsx(Ae, { as: "ul", w: "full", spacing: "4px", children: e.map((a) => /* @__PURE__ */ E.jsx(
      RJ,
      {
        onClick: (o) => r(o),
        token: a,
        active: n(a)
      },
      `${a.chainId}-${a.address}`
    )) })
  ] });
}
function eke({
  input: t,
  onInput: e
}) {
  const [n] = Ch();
  return /* @__PURE__ */ E.jsxs(Mr, { position: "relative", children: [
    /* @__PURE__ */ E.jsx(
      aR,
      {
        _placeholder: {
          color: "text.placeholder"
        },
        color: "text.primary",
        borderRadius: "inner",
        border: "1px solid",
        borderColor: "border.default",
        w: "full",
        pb: "14px",
        pl: "16px",
        pr: "44px",
        pt: "16px",
        fontSize: "14px",
        lineHeight: "18px",
        type: "text",
        value: t,
        onChange: (r) => e(r.target.value),
        placeholder: "Token name or address"
      }
    ),
    /* @__PURE__ */ E.jsx(
      Jr,
      {
        ref: n,
        position: "absolute",
        top: "0px",
        bottom: "0px",
        right: "0px",
        cursor: "pointer",
        alignItems: "center",
        pr: "16px",
        children: t.length > 0 ? /* @__PURE__ */ E.jsx(
          rze,
          {
            color: "button.grey.background.text.enable",
            _hover: {
              color: "button.grey.background.text.hover"
            },
            h: "16px",
            w: "16px",
            cursor: "pointer",
            onClick: () => e(""),
            "aria-hidden": "true"
          }
        ) : /* @__PURE__ */ E.jsx(
          ize,
          {
            color: "text.tertiary",
            cursor: "pointer",
            "aria-hidden": "true"
          }
        )
      }
    )
  ] });
}
function tke({ onReset: t }) {
  const { isDarkMode: e } = ca(), n = e ? n5e : r5e;
  return /* @__PURE__ */ E.jsxs(Ae, { spacing: "24px", alignItems: "center", children: [
    /* @__PURE__ */ E.jsx(Te.img, { maxW: "150px", maxH: "150px", src: n, alt: "not found" }),
    /* @__PURE__ */ E.jsxs(Ae, { spacing: "12px", children: [
      /* @__PURE__ */ E.jsx(Mt, { color: "text.tertiary", children: "No results found" }),
      /* @__PURE__ */ E.jsx(Uu, { onClick: () => t(), variant: "grey", px: "40px", children: "Reset" })
    ] })
  ] });
}
function nke() {
  const { isDarkMode: t } = ca(), e = t ? i5e : a5e;
  return /* @__PURE__ */ E.jsxs(Ae, { color: "text.tertiary", spacing: "24px", alignItems: "center", children: [
    /* @__PURE__ */ E.jsx(Te.img, { maxW: "150px", maxH: "150px", src: e, alt: "RPC Error" }),
    /* @__PURE__ */ E.jsxs(
      Ae,
      {
        maxW: "300px",
        spacing: "12px",
        textAlign: "center",
        color: "text.tertiary",
        children: [
          /* @__PURE__ */ E.jsx(Mt, { fontSize: "16px", lineHeight: "20px", fontWeight: "semibold", children: "Oops!" }),
          /* @__PURE__ */ E.jsx(Mt, { fontSize: "14px", lineHeight: "18px", children: "The network is temporarily unavailable. Please try again later." })
        ]
      }
    )
  ] });
}
function rke({ tokens: t, onSelectToken: e, getActive: n }) {
  return /* @__PURE__ */ E.jsxs(Ae, { spacing: "4px", children: [
    /* @__PURE__ */ E.jsx(Mt, { fontSize: "14px", lineHeight: "18px", children: "Featured" }),
    /* @__PURE__ */ E.jsx(Ae, { as: "ul", spacing: "4px", w: "full", children: t.map((r) => /* @__PURE__ */ E.jsx(
      RJ,
      {
        onClick: (i) => e(i),
        token: r,
        active: n(r)
      },
      `${r.chainId}-${r.address}`
    )) })
  ] });
}
function ike({
  selectedChainId: t,
  tokens: e,
  onSelectToken: n,
  getActive: r
}) {
  const i = e.reduce((a, o) => {
    const s = o.chainId;
    return typeof a[s] > "u" ? a[s] = [o] : a[s].push(o), a;
  }, {});
  return t === null ? /* @__PURE__ */ E.jsx(
    qk,
    {
      selectedChainId: t,
      tokens: e,
      onSelectToken: n,
      getActive: r
    }
  ) : /* @__PURE__ */ E.jsx(Ae, { spacing: "4px", children: Object.values(i).map((a, o) => /* @__PURE__ */ E.jsx(
    qk,
    {
      selectedChainId: t,
      tokens: a,
      onSelectToken: n,
      getActive: r
    },
    Object.keys(i)[o]
  )) });
}
function ew({
  token: t,
  amount: e,
  tooltip: n
}) {
  const { isFakeToken: r } = t;
  return /* @__PURE__ */ E.jsxs(Ae, { w: "86px", spacing: "10px", justifyContent: "center", alignItems: "center", children: [
    /* @__PURE__ */ E.jsxs(Mr, { position: "relative", children: [
      /* @__PURE__ */ E.jsx(
        qd,
        {
          w: "28px",
          h: "28px",
          borderRadius: "full",
          src: t.logoURI
        }
      ),
      /* @__PURE__ */ E.jsx(
        qd,
        {
          position: "absolute",
          right: "-4px",
          top: "16px",
          zIndex: "1",
          h: "16px",
          w: "16px",
          src: Tn.getNetworkLogoUrl(t.chainId)
        }
      )
    ] }),
    /* @__PURE__ */ E.jsxs(
      Jr,
      {
        color: "text.secondary",
        flexDir: "column",
        alignItems: "center",
        justifyContent: "center",
        children: [
          /* @__PURE__ */ E.jsxs(Ae, { direction: "row", spacing: "4px", alignItems: "center", children: [
            /* @__PURE__ */ E.jsx(
              Mt,
              {
                as: "span",
                maxW: "86px",
                fontSize: "14px",
                lineHeight: "18px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                children: e
              }
            ),
            n && /* @__PURE__ */ E.jsx(
              Um,
              {
                borderRadius: "base",
                px: "10px",
                py: "8px",
                hasArrow: !0,
                label: n,
                placement: "top",
                children: /* @__PURE__ */ E.jsx(Px, { h: "12px", w: "12px" })
              }
            )
          ] }),
          /* @__PURE__ */ E.jsx(Mt, { as: "span", fontSize: "14px", lineHeight: "18px", children: r ? "Token" : t.symbol }),
          /* @__PURE__ */ E.jsxs(Mt, { as: "span", color: "text.tertiary", fontSize: "12px", lineHeight: "16px", children: [
            "on",
            " ",
            r ? "Network" : Tn.getNetworkName(t.chainId)
          ] })
        ]
      }
    )
  ] });
}
function ake({ swapTransactions: t }) {
  const e = aL(), n = (i) => {
    e("/transaction-status", { state: i });
  }, r = t.map(
    (i) => {
      const {
        id: a,
        createdAt: o,
        explorerUrl: s,
        chainId: l,
        hash: c,
        inputToken: d,
        outputToken: u,
        destinationChainHash: h,
        receipt: N,
        receiptStatus: M
      } = i, [p, m] = KK(o).split(" "), R = (g, y, x, f) => {
        g.stopPropagation(), gh(
          Tn.getTxExplorerUrl(y, String(x), f)
        );
      }, V = {
        monthDay: p,
        hourMin: m
      }, U = {
        inputToken: d,
        outputToken: u
      };
      if (i.isCrossChain) {
        const g = u.chainId, y = Tn.getExplorerUrl(g);
        return {
          id: a,
          time: V,
          txDisplay: /* @__PURE__ */ E.jsxs(E.Fragment, { children: [
            /* @__PURE__ */ E.jsxs(Ae, { direction: "row", spacing: "2px", children: [
              /* @__PURE__ */ E.jsx("span", { children: "From:" }),
              /* @__PURE__ */ E.jsx(
                js,
                {
                  fontWeight: "semibold",
                  onClick: (x) => R(x, s, l, c),
                  children: yd(c)
                }
              )
            ] }),
            h && /* @__PURE__ */ E.jsxs(Ae, { direction: "row", spacing: "2px", children: [
              /* @__PURE__ */ E.jsx("span", { children: "To:" }),
              /* @__PURE__ */ E.jsx(
                js,
                {
                  fontWeight: "semibold",
                  onClick: (x) => R(
                    x,
                    y,
                    g,
                    h
                  ),
                  children: yd(h)
                }
              )
            ] })
          ] }),
          swapPair: U,
          state: h ? /* @__PURE__ */ E.jsx(u2, { w: "full", h: "full" }) : (N == null ? void 0 : N.status) === 0 || M === 0 || M === "reverted" ? /* @__PURE__ */ E.jsx(d2, { w: "full", h: "full" }) : /* @__PURE__ */ E.jsx(hp, { w: "full", h: "full" })
        };
      }
      return {
        id: a,
        time: V,
        txDisplay: /* @__PURE__ */ E.jsx(
          js,
          {
            fontWeight: "semibold",
            onClick: (g) => R(g, s, l, c),
            children: yd(c)
          }
        ),
        swapPair: U,
        state: (N == null ? void 0 : N.status) === 1 || M === 1 || M === "success" ? /* @__PURE__ */ E.jsx(u2, { w: "full", h: "full" }) : (N == null ? void 0 : N.status) === 0 || M === 0 || M === "reverted" ? /* @__PURE__ */ E.jsx(d2, { w: "full", h: "full" }) : /* @__PURE__ */ E.jsx(hp, { w: "full", h: "full" })
      };
    }
  );
  return /* @__PURE__ */ E.jsx(Mr, { borderRadius: "inner", overflow: "auto", children: /* @__PURE__ */ E.jsxs(Te.table, { minW: "432px", children: [
    /* @__PURE__ */ E.jsx(Te.thead, { bgColor: "surface.1", children: /* @__PURE__ */ E.jsxs(
      Te.tr,
      {
        color: "text.tertiary",
        textAlign: "left",
        fontSize: "16px",
        fontWeight: "semibold",
        lineHeight: "20px",
        children: [
          /* @__PURE__ */ E.jsx(Te.th, { py: "20px", px: "16px", scope: "col", children: "Time" }),
          /* @__PURE__ */ E.jsx(Te.th, { py: "20px", px: "16px", scope: "col", children: "Tx" }),
          /* @__PURE__ */ E.jsx(Te.th, { py: "20px", px: "16px", scope: "col", children: "Swap pair" }),
          /* @__PURE__ */ E.jsx(Te.th, { py: "20px", px: "16px", scope: "col", children: "State" })
        ]
      }
    ) }),
    /* @__PURE__ */ E.jsx(Te.tbody, { children: r.map((i, a) => /* @__PURE__ */ E.jsxs(
      Te.tr,
      {
        onClick: () => n(i.id),
        cursor: "pointer",
        bgColor: a % 2 !== 0 ? "surface.2" : "surface.1",
        _hover: a % 2 !== 0 ? {
          bgColor: "surface.4"
        } : {
          bgColor: "surface.3"
        },
        children: [
          /* @__PURE__ */ E.jsx(Te.td, { py: "12px", px: "16px", children: /* @__PURE__ */ E.jsxs(Ae, { spacing: "4px", fontSize: "12px", lineHeight: "16px", children: [
            /* @__PURE__ */ E.jsx("span", { children: i.time.monthDay }),
            /* @__PURE__ */ E.jsx("span", { children: i.time.hourMin })
          ] }) }),
          /* @__PURE__ */ E.jsx(Te.td, { py: "12px", px: "16px", fontSize: "12px", lineHeight: "16px", children: i.txDisplay }),
          /* @__PURE__ */ E.jsxs(Te.td, { display: "flex", py: "12px", px: "16px", alignItems: "center", children: [
            /* @__PURE__ */ E.jsx(
              cp,
              {
                token: i.swapPair.inputToken
              }
            ),
            /* @__PURE__ */ E.jsx(NJ, { mx: "8px", h: "16px", w: "16px" }),
            /* @__PURE__ */ E.jsx(
              cp,
              {
                token: i.swapPair.outputToken
              }
            )
          ] }),
          /* @__PURE__ */ E.jsx(Te.td, { py: "12px", px: "16px", children: /* @__PURE__ */ E.jsx(
            Mr,
            {
              color: "button.grey.text.enable",
              _hover: {
                color: "button.grey.text.hover"
              },
              h: "24px",
              w: "24px",
              children: i.state
            }
          ) })
        ]
      },
      i.id
    )) })
  ] }) });
}
function oke() {
  const { isDarkMode: t } = ca();
  return /* @__PURE__ */ E.jsxs(
    qM,
    {
      onClick: () => gh(OP),
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      spacing: "4px",
      children: [
        /* @__PURE__ */ E.jsx("div", { className: "text-text-disable text-[12px]/[16px]", children: "Powered by" }),
        /* @__PURE__ */ E.jsx(Z9, { src: t ? Yze : Qze, alt: "XY-Finance logo" })
      ]
    }
  );
}
function ske() {
  const { isConnected: t } = Ui();
  return /* @__PURE__ */ E.jsxs(Ae, { direction: "column", spacing: "sm", children: [
    /* @__PURE__ */ E.jsxs(Ae, { direction: "column", spacing: "xl", children: [
      /* @__PURE__ */ E.jsx(C5e, {}),
      /* @__PURE__ */ E.jsx(B5e, {}),
      t && /* @__PURE__ */ E.jsx(X5e, {})
    ] }),
    /* @__PURE__ */ E.jsxs(Ae, { spacing: "3xl", children: [
      /* @__PURE__ */ E.jsx(L5e, {}),
      /* @__PURE__ */ E.jsxs(Ae, { spacing: "md", children: [
        /* @__PURE__ */ E.jsx(P5e, {}),
        /* @__PURE__ */ E.jsx(_5e, {})
      ] })
    ] })
  ] });
}
function lke() {
  const { address: t } = Ui(), { navigate: e } = qs(), { connect: n, connectors: r, error: i, pendingConnector: a } = Zee(), { open: o } = joe(), s = (l) => {
    l.id === "walletConnect" ? o({ view: "Connect" }) : n({ connector: l });
  };
  return Ee(() => {
    t && e("/");
  }, [t]), /* @__PURE__ */ E.jsxs(Ae, { minH: "350px", spacing: "24px", children: [
    /* @__PURE__ */ E.jsx(hN, { title: "Connect wallet" }),
    a && i && /* @__PURE__ */ E.jsxs(nW, { className: "text-white", children: [
      "Connection to ",
      a.name,
      " Failed. Please check your wallet again or install it."
    ] }),
    /* @__PURE__ */ E.jsx(Ae, { spacing: "12px", overflow: "auto", maxH: "462px", children: /* @__PURE__ */ E.jsx(Ae, { spacing: "8px", children: r.map((l) => /* @__PURE__ */ E.jsxs(
      Ae,
      {
        onClick: () => s(l),
        bgColor: "button.grey.background.enable",
        _hover: {
          bgColor: "button.grey.background.hover"
        },
        borderRadius: "inner",
        cursor: "pointer",
        alignItems: "center",
        direction: "row",
        spacing: "12px",
        py: "8px",
        px: "12px",
        children: [
          /* @__PURE__ */ E.jsx(
            qd,
            {
              src: Tn.getWalletLogoUrl(l.id)
            }
          ),
          /* @__PURE__ */ E.jsx(Mt, { fontSize: "14px", lineHeight: "18px", children: l.name })
        ]
      },
      l.id
    )) }) })
  ] });
}
function cke() {
  const { state: t } = $U(), e = t === "inputToken", { inputToken: n, outputToken: r } = Br(), i = nN(), a = parseInt(e ? n.chainId : r.chainId), o = e ? n : r, { featuredTokens: s } = Lo(), [l, c] = nt(
    a
  ), [d, u] = nt(
    o
  ), { noLPTokenList: h, rpcErrorChains: N } = Hp(), { loading: M } = sM(), { input: p } = sM(), m = gY(), R = l ? Tn.getNetworkName(l) : null, V = BP.findIndex(
    (j) => parseInt(j) === l
  ) !== -1, U = h.filter((j) => {
    if (p === "")
      return !0;
    const w = p.toLowerCase(), { symbol: C, address: J, name: I } = j;
    return C.toLowerCase().includes(w) || J.toLowerCase().includes(w) || I.toLowerCase().includes(w);
  }), g = U.filter(
    (j) => s.some(
      (w) => j.chainId === w.chainId && j.address === w.address
    )
  ), y = l ? g.filter(
    (j) => j.chainId === String(l)
  ) : g, x = U.filter(
    (j) => !s.some(
      (w) => j.chainId === w.chainId && j.address === w.address
    )
  ), f = l ? x.filter(
    (j) => j.chainId === String(l)
  ) : x, D = g.length > 0, Y = l ? y.length === 0 && f.length === 0 : U.length === 0, Q = l ? N.includes(String(l)) : !1, { navigateBack: G } = qs(), ne = (j) => {
    l !== j && c(j);
  }, O = (j) => {
    j.address === (d == null ? void 0 : d.address) && j.chainId === d.chainId || (e ? (j.address === r.address && j.chainId === r.chainId && i({ type: "SET_TO_TOKEN", payload: new Ei() }), i({ type: "SET_FROM_TOKEN", payload: j })) : (j.address === n.address && j.chainId === n.chainId && i({ type: "SET_FROM_TOKEN", payload: new Ei() }), i({ type: "SET_TO_TOKEN", payload: j })), u(j), G());
  }, T = (j) => {
    m({ type: "SET_INPUT", payload: j });
  }, Z = () => {
    m({ type: "SET_INPUT", payload: "" });
  }, z = (j) => (d == null ? void 0 : d.address) === j.address && d.chainId === j.chainId;
  return /* @__PURE__ */ E.jsxs(Ae, { direction: "column", spacing: "24px", children: [
    /* @__PURE__ */ E.jsx(hN, { title: "Select a token" }),
    /* @__PURE__ */ E.jsx(eke, { input: p, onInput: T }),
    /* @__PURE__ */ E.jsx(
      q5e,
      {
        onClickNetworkItem: ne,
        selectedChainId: l
      }
    ),
    R && V && /* @__PURE__ */ E.jsx(rW, { children: /* @__PURE__ */ E.jsxs(Mt, { fontWeight: 400, fontSize: "14px", lineHeight: "18px", children: [
      "ONLY the tokens listed below are supported on ",
      R,
      "."
    ] }) }),
    /* @__PURE__ */ E.jsx(
      Ae,
      {
        direction: "column",
        height: "326px",
        spacing: "4px",
        overflowY: "auto",
        overflowX: "hidden",
        children: Q ? /* @__PURE__ */ E.jsx(nke, {}) : M ? /* @__PURE__ */ E.jsx(hp, { w: "24px", h: "24px", color: "text.primary", mx: "auto" }) : Y ? /* @__PURE__ */ E.jsx(tke, { onReset: Z }) : /* @__PURE__ */ E.jsxs(Ae, { spacing: "4px", children: [
          D && /* @__PURE__ */ E.jsx(
            rke,
            {
              tokens: g,
              onSelectToken: O,
              getActive: z
            }
          ),
          /* @__PURE__ */ E.jsx(
            ike,
            {
              tokens: f,
              getActive: z,
              onSelectToken: O,
              selectedChainId: l
            }
          )
        ] })
      }
    )
  ] });
}
function dke() {
  return /* @__PURE__ */ E.jsx("div", { children: "BestRoutePage" });
}
function uke() {
  return /* @__PURE__ */ E.jsxs(Ae, { direction: "column", spacing: "24px", children: [
    /* @__PURE__ */ E.jsx(v5e, {}),
    /* @__PURE__ */ E.jsx(G5e, {}),
    /* @__PURE__ */ E.jsx(O5e, {}),
    /* @__PURE__ */ E.jsx("div", { className: "mb-[16px]", children: /* @__PURE__ */ E.jsx(F5e, {}) }),
    /* @__PURE__ */ E.jsx(w5e, {}),
    /* @__PURE__ */ E.jsx(I5e, {})
  ] });
}
function hke() {
  const { state: t } = $U(), { swapTransactions: e } = qU(), n = e.find((h) => h.id === t) || null, [r] = Ch(), [i] = Ch(), a = n ? [
    {
      name: "Swap",
      status: Nke(n),
      transaction: n
    }
  ] : [], o = a.reduce((h, N) => (N.status !== "completed" && (h = !1), h), !0), s = a.reduce((h, N) => (N.status !== "error" && (h = !1), h), !0), l = ((h, N) => h ? {
    icon: /* @__PURE__ */ E.jsx(
      d2,
      {
        w: "100px",
        h: "100px",
        color: "text.primary",
        mx: "auto"
      }
    ),
    content: "Failed"
  } : N ? {
    icon: /* @__PURE__ */ E.jsx(
      u2,
      {
        w: "100px",
        h: "100px",
        color: "text.primary",
        mx: "auto"
      }
    ),
    content: "Completed"
  } : {
    icon: /* @__PURE__ */ E.jsx(hp, { w: "100px", h: "100px", color: "text.primary", mx: "auto" }),
    content: "Processing"
  })(s, o), c = () => !n || !n.receiptUpdatedAt ? /* @__PURE__ */ E.jsx("p", { children: "Txid ..." }) : /* @__PURE__ */ E.jsx(
    js,
    {
      onClick: () => gh(
        Tn.getTxExplorerUrl(
          n.explorerUrl,
          n.chainId,
          n.hash
        )
      ),
      leftIcon: /* @__PURE__ */ E.jsx(c2, { h: "16px", w: "16px" }),
      children: /* @__PURE__ */ E.jsx(Mt, { as: "span", fontSize: "12px", lineHeight: "14px", fontWeight: "semibold", children: "View on explorer" })
    }
  ), d = n ? fr(
    String(
      Number(n.outputTokenNumber) * ((100 - Number(n.slippage)) / 100)
    ),
    6
  ) : "", u = n ? n.outputToken.symbol : "";
  return /* @__PURE__ */ E.jsxs(Ae, { spacing: "30px", minH: "500px", children: [
    /* @__PURE__ */ E.jsx(hN, { type: "close", title: "Transaction State", navigatePath: "/" }),
    /* @__PURE__ */ E.jsxs(Ae, { spacing: "32px", alignItems: "center", children: [
      /* @__PURE__ */ E.jsxs(
        Ae,
        {
          spacing: "12px",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          ref: i,
          children: [
            l.icon,
            /* @__PURE__ */ E.jsx(
              xh,
              {
                as: "h5",
                fontSize: "24px",
                fontWeight: "semibold",
                lineHeight: "30px",
                children: l.content
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ E.jsxs(Jr, { alignItems: "center", children: [
        /* @__PURE__ */ E.jsx(
          ew,
          {
            amount: (n == null ? void 0 : n.inputTokenNumber) ?? "",
            token: (n == null ? void 0 : n.inputToken) ?? new Ei()
          }
        ),
        /* @__PURE__ */ E.jsx(Mr, { pl: "8px", pr: "16px", children: /* @__PURE__ */ E.jsx(NJ, {}) }),
        /* @__PURE__ */ E.jsx(
          ew,
          {
            tooltip: `Estimated amount: You will receive at least ${d} ${u}`,
            amount: (n == null ? void 0 : n.outputTokenNumber) ?? "",
            token: (n == null ? void 0 : n.outputToken) ?? new Ei()
          }
        )
      ] }),
      /* @__PURE__ */ E.jsx(Mr, { ref: r, children: c() }),
      /* @__PURE__ */ E.jsx(y5e, { steps: a })
    ] })
  ] });
}
function Nke(t) {
  var e, n, r, i;
  return t.isCrossChain ? t.destinationChainHash ? "completed" : ((e = t.receipt) == null ? void 0 : e.status) === 0 || t.receiptStatus === 0 || t.receiptStatus === "reverted" ? "error" : ((n = t.receipt) == null ? void 0 : n.status) === 1 || t.receiptStatus === 1 || t.receiptStatus === "success" ? "current" : "upcoming" : ((r = t.receipt) == null ? void 0 : r.status) === 0 || t.receiptStatus === 0 || t.receiptStatus === "reverted" ? "error" : ((i = t.receipt) == null ? void 0 : i.status) === 1 || t.receiptStatus === 1 || t.receiptStatus === "success" ? "completed" : "current";
}
function Mke() {
  const { slippage: t, isSlippageWarning: e, slippageError: n, isSlippageRemind: r } = Br(), i = nN(), a = Number(t) === 1 || Number(t) === 0.5 || Number(t) === 1.5 ? "" : t, [o, s] = nt(a), l = [
    {
      id: "first",
      rate: "0.5",
      variant: "start"
    },
    {
      id: "second",
      variant: "center",
      rate: "1"
    },
    {
      id: "third",
      variant: "end",
      rate: "1.5"
    }
  ], c = pke(t, o), d = (h) => {
    const { value: N } = h.target;
    if (_K.test(N) || N === "") {
      const M = N.replace(/\.$/, "");
      s(N), i({ type: "SET_SLIPPAGE", payload: M });
    }
  }, u = (h) => {
    s(""), i({ type: "SET_SLIPPAGE", payload: h.rate });
  };
  return /* @__PURE__ */ E.jsxs(Ae, { direction: "column", spacing: "24px", children: [
    /* @__PURE__ */ E.jsx(hN, { title: "Settings" }),
    /* @__PURE__ */ E.jsxs(Ae, { direction: "column", spacing: "16px", children: [
      /* @__PURE__ */ E.jsxs(Ae, { direction: "column", spacing: "8px", children: [
        /* @__PURE__ */ E.jsx(xh, { as: "h4", fontSize: "14px", lineHeight: "18px", fontWeight: 400, children: "Slippage Tolerance" }),
        /* @__PURE__ */ E.jsx(Mt, { color: "text.tertiary", fontSize: "12px", lineHeight: "16px", children: "Your transaction will revert if the price changes by more than the below percentage. Please note: this slippage tolerance exclude AMM bridges' slippage as their slippage settings are outside of XY Finance's jurisdiction." })
      ] }),
      /* @__PURE__ */ E.jsxs(Ae, { direction: "column", spacing: "8px", children: [
        /* @__PURE__ */ E.jsxs(Jr, { justifyContent: "space-between", children: [
          /* @__PURE__ */ E.jsx(Jr, { as: "ul", children: l.map((h) => /* @__PURE__ */ E.jsxs(
            Ak,
            {
              active: c === h.id,
              variant: h.variant,
              onClick: () => u(h),
              children: [
                h.rate,
                " %"
              ]
            },
            h.id
          )) }),
          /* @__PURE__ */ E.jsxs(
            Ak,
            {
              display: "flex",
              active: c === "custom",
              size: "md",
              error: !!n,
              children: [
                /* @__PURE__ */ E.jsx(
                  aR,
                  {
                    type: "text",
                    _placeholder: { color: "text.disable" },
                    width: "100%",
                    placeholder: "0.10",
                    value: o,
                    onChange: d
                  }
                ),
                /* @__PURE__ */ E.jsx(Mt, { as: "span", color: "text.primary", children: "%" })
              ]
            }
          )
        ] }),
        n && /* @__PURE__ */ E.jsx(
          Mt,
          {
            color: "text.critical.default",
            textAlign: "right",
            fontSize: "12px",
            lineHeight: "16px",
            children: "0.01 to 49.99 is a valid range."
          }
        )
      ] })
    ] }),
    e ? /* @__PURE__ */ E.jsx(ZE, { leftIcon: /* @__PURE__ */ E.jsx(dJ, { width: "20px", height: "20px" }), children: /* @__PURE__ */ E.jsx(Mt, { fontSize: "12px", lineHeight: "16px", children: "Reminder: Your slippage is over 5%, and front-running may result." }) }) : r ? /* @__PURE__ */ E.jsx(rW, { children: /* @__PURE__ */ E.jsx(Mt, { fontSize: "12px", lineHeight: "16px", children: "Tip: You may end up receiving bridge tokens instead if the slippage is so low that the tx to the target chain fails." }) }) : null
  ] });
}
function pke(t, e) {
  if (e !== "")
    return "custom";
  switch (Number(t)) {
    case 0.5:
      return "first";
    case 1:
      return "second";
    case 1.5:
      return "third";
    default:
      return "custom";
  }
}
function mke() {
  const { swapTransactions: t } = qU(), e = Wx(), {
    currentPageData: n,
    paginationStr: r,
    nextPage: i,
    previousPage: a,
    pageSize: o,
    disabledPreviousPage: s,
    disabledNextPage: l
  } = o$({
    data: t,
    pageSize: 5
  }), c = t.length === 0;
  return /* @__PURE__ */ E.jsxs(Ae, { minH: "496px", spacing: "40px", justifyContent: "space-between", children: [
    /* @__PURE__ */ E.jsxs(Ae, { spacing: "24px", children: [
      /* @__PURE__ */ E.jsx(hN, { title: "Transaction History" }),
      /* @__PURE__ */ E.jsx(ake, { swapTransactions: n })
    ] }),
    /* @__PURE__ */ E.jsxs(Jr, { justifyContent: "space-between", children: [
      /* @__PURE__ */ E.jsx(
        Uu,
        {
          onClick: () => e({ type: "SET_TRANSACTIONS", payload: [] }),
          leftIcon: /* @__PURE__ */ E.jsx(mze, {}),
          isDisabled: c,
          variant: "grey",
          color: "text.critical.default",
          _hover: {
            color: "text.critical.hover"
          },
          children: "Clear All"
        }
      ),
      !c && /* @__PURE__ */ E.jsxs(Ae, { direction: "row", spacing: "16px", alignItems: "center", children: [
        /* @__PURE__ */ E.jsx(Mt, { fontSize: "14px", lineHeight: "18px", children: r }),
        t.length > o && /* @__PURE__ */ E.jsxs(Ae, { direction: "row", spacing: "12px", children: [
          /* @__PURE__ */ E.jsx(
            Oh,
            {
              disabled: s,
              onClick: () => a(),
              icon: /* @__PURE__ */ E.jsx(Mze, {})
            }
          ),
          /* @__PURE__ */ E.jsx(
            Oh,
            {
              disabled: l,
              onClick: () => i(),
              icon: /* @__PURE__ */ E.jsx(pze, {})
            }
          )
        ] })
      ] })
    ] })
  ] });
}
function Tke() {
  return cSe([
    {
      path: "/",
      element: /* @__PURE__ */ E.jsx(zSe, { children: /* @__PURE__ */ E.jsx(ske, {}) })
    },
    {
      path: "/transaction-history",
      element: /* @__PURE__ */ E.jsx(mke, {})
    },
    {
      path: "/transaction-status",
      element: /* @__PURE__ */ E.jsx(hke, {})
    },
    {
      path: "/select-token",
      element: /* @__PURE__ */ E.jsx(cke, {})
    },
    {
      path: "/best-route",
      element: /* @__PURE__ */ E.jsx(dke, {})
    },
    {
      path: "/confirmation",
      element: /* @__PURE__ */ E.jsx(DSe, { children: /* @__PURE__ */ E.jsx(uke, {}) })
    },
    {
      path: "/connection",
      element: /* @__PURE__ */ E.jsx(vSe, { children: /* @__PURE__ */ E.jsx(lke, {}) })
    },
    {
      path: "/setting",
      element: /* @__PURE__ */ E.jsx(Mke, {})
    },
    {
      path: "*",
      element: /* @__PURE__ */ E.jsx("h1", { children: "404 NOT FOUND" })
    }
  ]);
}
const fke = "@xyfinance/widget", Vke = "3.12.1", Uke = "XY Finance wiget.", Rke = "module", gke = "dist/index.umd.js", yke = "dist/index.es.js", Zke = "dist/index.d.ts", bke = {
  ".": {
    import: "./dist/index.es.js",
    require: "./dist/index.umd.js"
  }
}, Eke = [
  "/dist"
], Ske = {
  access: "public"
}, xke = [
  "**/*.css"
], Wke = {
  dev: "vite --mode development",
  "dev:staging": "vite --mode staging",
  "dev:internal": "vite --mode internal",
  "dev:prod": "vite --mode prod",
  "build:dev": "vite build --mode development",
  "build:staging": "vite build --mode staging",
  "build:internal": "vite build --mode internal",
  build: "vite build --mode prod",
  lint: "tsc",
  preview: "vite preview"
}, jke = {
  react: ">=18"
}, Dke = {
  "@chakra-ui/anatomy": "^2.2.1",
  "@chakra-ui/react": "^2.8.0",
  "@coinbase/wallet-sdk": "^3.7.1",
  "@emotion/is-prop-valid": "^1.2.0",
  "@emotion/react": "^11.10.6",
  "@emotion/styled": "^11.10.6",
  "@ethersproject/abstract-provider": "^5.7.0",
  "@ethersproject/address": "^5.7.0",
  "@ethersproject/bignumber": "^5.7.0",
  "@ethersproject/providers": "^5.7.2",
  "@ethersproject/units": "^5.7.0",
  "@formkit/auto-animate": "^0.8.0",
  "@sentry/integrations": "^7.47.0",
  "@sentry/react": "^7.47.0",
  "@tanstack/react-query": "^5.4.3",
  "@tanstack/react-query-devtools": "^5.4.3",
  "@uidotdev/usehooks": "^2.3.0",
  "@web3modal/wagmi": "^3.5.1",
  axios: "^1.3.3",
  ethers: "^5.7.2",
  "framer-motion": "^10.8.4",
  immer: "^9.0.19",
  localforage: "^1.10.0",
  "lodash.defaultsdeep": "^4.6.1",
  "match-sorter": "^6.3.1",
  react: "^18.2.0",
  "react-dom": "^18.2.0",
  "react-router-dom": "^6.20.0",
  "react-use": "^17.4.0",
  "sort-by": "^1.2.0",
  tinycolor2: "^1.6.0",
  "use-debounce": "^10.0.0",
  "use-immer": "^0.8.1",
  uuid: "^9.0.0",
  viem: "^1.19.11",
  "vite-plugin-svgr": "^4.1.0",
  wagmi: "^1.4.12",
  ws: "^8.13.0",
  zod: "^3.22.4"
}, zke = {
  "@esbuild-plugins/node-globals-polyfill": "^0.2.3",
  "@types/lodash.defaultsdeep": "^4.6.7",
  "@types/node": "^18.14.0",
  "@types/react": "18.2.11",
  "@types/react-dom": "18.2.4",
  "@types/tinycolor2": "^1.4.3",
  "@types/uuid": "^9.0.1",
  "@vitejs/plugin-react": "^4.1.0",
  "@xyfinance/tailwindconfig": "workspace:*",
  "@xyfinance/tsconfig": "workspace:*",
  "@xyfinance/design": "workspace:*",
  "@xyfinance/react": "workspace:*",
  "@xyfinance/ui": "workspace:*",
  autoprefixer: "10.4.14",
  postcss: "8.4.24",
  "rollup-plugin-polyfill-node": "^0.12.0",
  sass: "^1.69.7",
  tailwindcss: "3.3.2",
  typescript: "^5.2.2",
  "unplugin-auto-import": "^0.14.3",
  vite: "^4.5.0",
  "vite-plugin-dts": "^3.6.3",
  "vite-plugin-lib-inject-css": "^1.3.0"
}, kke = {
  name: fke,
  version: Vke,
  description: Uke,
  type: Rke,
  main: gke,
  module: yke,
  types: Zke,
  exports: bke,
  files: Eke,
  publishConfig: Ske,
  sideEffects: xke,
  scripts: Wke,
  peerDependencies: jke,
  dependencies: Dke,
  devDependencies: zke
}, wke = kke.version;
function Fke({
  theme: t,
  config: e,
  internalConfig: n
}) {
  const r = (t == null ? void 0 : t.mode) === "dark";
  return /* @__PURE__ */ E.jsx("div", { id: "xy-widget", className: ni(r && "dark"), children: /* @__PURE__ */ E.jsx(
    WDe,
    {
      theme: t,
      config: e,
      internalConfig: n,
      children: /* @__PURE__ */ E.jsx(vke, {})
    }
  ) });
}
function vke() {
  const { isShowLoader: t } = rU();
  return /* @__PURE__ */ E.jsx(
    Ae,
    {
      "data-version": wke,
      backgroundColor: "surface.0",
      color: "text.primary",
      borderRadius: "container",
      mx: "auto",
      minH: "556px",
      p: {
        base: "sm",
        sm: "xl"
      },
      textAlign: "left",
      fontFamily: "body",
      fontWeight: "normal",
      shadow: "sm",
      display: t ? "flex" : void 0,
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      className: "flex flex-col",
      children: t ? /* @__PURE__ */ E.jsx(Ike, {}) : /* @__PURE__ */ E.jsxs("div", { className: "flex flex-col justify-between w-full flex-auto", children: [
        /* @__PURE__ */ E.jsxs("div", { children: [
          /* @__PURE__ */ E.jsx(S5e, {}),
          /* @__PURE__ */ E.jsx(Tke, {})
        ] }),
        /* @__PURE__ */ E.jsx("div", { className: "flex justify-end mt-[16px]", children: /* @__PURE__ */ E.jsx(oke, {}) })
      ] })
    }
  );
}
function Ike() {
  return /* @__PURE__ */ E.jsxs(Vx, { color: "text.primary", alignItems: "center", spacing: "xs", children: [
    /* @__PURE__ */ E.jsx(hp, { w: "100px", h: "100px" }),
    /* @__PURE__ */ E.jsx(Mt, { fontSize: "xl", fontWeight: "semibold", lineHeight: "xl", children: "Loading..." })
  ] });
}
const vve = Fke, Ive = "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE", Ove = El.PLAT === "DEVELOPMENT" ? T3 : m3;
export {
  Rne as $,
  Os as A,
  TM as B,
  xa as C,
  Fo as D,
  ib as E,
  na as F,
  fM as G,
  NV as H,
  VM as I,
  Yd as J,
  MV as K,
  ac as L,
  cb as M,
  Gd as N,
  vo as O,
  hV as P,
  RM as Q,
  Ys as R,
  ph as S,
  Ku as T,
  yn as U,
  vs as V,
  tb as W,
  mh as X,
  Ti as Y,
  Fi as Z,
  TV as _,
  ose as a,
  Gwe as a$,
  Zi as a0,
  wi as a1,
  ine as a2,
  KO as a3,
  ywe as a4,
  wZ as a5,
  bd as a6,
  Sne as a7,
  one as a8,
  Jf as a9,
  h_ as aA,
  b_ as aB,
  E_ as aC,
  S_ as aD,
  qv as aE,
  u_ as aF,
  kT as aG,
  fc as aH,
  Ri as aI,
  Xs as aJ,
  _we as aK,
  xe as aL,
  y2 as aM,
  Mi as aN,
  Ni as aO,
  F1 as aP,
  U8 as aQ,
  k2 as aR,
  zs as aS,
  zp as aT,
  qN as aU,
  Do as aV,
  ue as aW,
  ke as aX,
  em as aY,
  Ywe as aZ,
  Qwe as a_,
  Swe as aa,
  wwe as ab,
  Fwe as ac,
  Dwe as ad,
  yne as ae,
  gwe as af,
  kZ as ag,
  Wwe as ah,
  Gf as ai,
  XO as aj,
  Zwe as ak,
  Rwe as al,
  xwe as am,
  Ewe as an,
  jwe as ao,
  Dr as ap,
  Zd as aq,
  sne as ar,
  vwe as as,
  Zne as at,
  kwe as au,
  zwe as av,
  bwe as aw,
  Iwe as ax,
  $O as ay,
  hD as az,
  oh as b,
  Cwe as b0,
  Lwe as b1,
  Jwe as b2,
  Bwe as b3,
  Awe as b4,
  Hwe as b5,
  Xwe as b6,
  Xae as b7,
  fie as b8,
  Qae as b9,
  oae as ba,
  $i as bb,
  Vie as bc,
  wY as bd,
  Owe as be,
  Dre as bf,
  Iae as bg,
  Pae as bh,
  Lae as bi,
  Ne as bj,
  Uw as bk,
  cU as bl,
  jt as bm,
  qa as bn,
  ya as bo,
  nwe as bp,
  _Q as bq,
  MI as br,
  jP as bs,
  sae as bt,
  Cke as bu,
  vve as bv,
  Ive as bw,
  Ove as bx,
  Ze as c,
  NM as d,
  nb as e,
  MM as f,
  aV as g,
  sh as h,
  ase as i,
  lh as j,
  oV as k,
  Fs as l,
  sV as m,
  ch as n,
  wo as o,
  lV as p,
  Is as q,
  ic as r,
  tQ as s,
  pM as t,
  dh as u,
  mM as v,
  Ka as w,
  Qd as x,
  dV as y,
  uV as z
};
